var xM = Object.defineProperty;
var HM = (i, l, r) => l in i ? xM(i, l, { enumerable: !0, configurable: !0, writable: !0, value: r }) : i[l] = r;
var C = (i, l, r) => (HM(i, typeof l != "symbol" ? l + "" : l, r), r);
var ln = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function YM(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
var AI = { exports: {} }, rh = { exports: {} }, nh = { exports: {} }, ih = { exports: {} }, oh = { exports: {} }, _m;
function Bh() {
  return _m || (_m = 1, function(i, l) {
    (function(r, o) {
      i.exports = o();
    })(ln, function() {
      var r = {}, o, c, T, d, h, y, b, U, Z, le, ue, be, Ke, ae, Ne, Fe, at, dr, er, Ze, Pt, wr, xn, Dl, si, Yr, Er, Dr, Ce, Ps, an, Sr, ao, nt, Fr, _o, bl, fe, Hn, Yn, Br, Xr, ai, hr, K, Re, co, Ue, Di, _t, mr, xo, bi, Ur, tr, Pi, Kr, _i, Xn, uo, $i, jr, To, k, m, D, B, V, oe, ke, $t, Wi, rc, po, ki, Xt, $s, Pl, Ws, Ho, M, v, W, H, ee, Me, He, rr, Yo, ge, Ir, Mt, ba, Xo, $l, ks, Kn, dT, Pa, Jd, ET, wi, ci, AT, ws, nc, ST, Wl, $a, ic, oc, Zd, Qd, hT, Wa, mT, IT, Eo, ka, Fi, MT, wa, gT, LT, NT, yT, lc, qd, fT, Fa, sc, kl, Ba, CT, eE, ac, Ua, vT, ui, tE, rE, nE, RT, iE, oE, lE, OT, Bi, _c, DT, sE, aE, _E, Wt, Ot, cE, uE, TE, bT, pE, Ko, PT, dE, fr, jo, Ao, wl, Va, _n, cc, Fl, Ga, xa, $T, Fs, zr, WT, cn, kT, uc, Ui, Ha, Bl, kt, Rn, Bs, Ti, Ya, wT, EE, Xa, Tc, Us, Ul, pc, dc, FT, Ec, Ac, BT, AE, zo, Ka, UT, Vs, Jr, Sc, Gs, hc, mc, So, VT, GT, SE, hE, Vl, mE, xT, Ic, Mc, ho, pi, ja, gc, Lc, jn, On, za, HT, Jt, Nc, xs, Gl, xl, x, Q, j, Ie, Ve, Et, cr, Nt, yc, IE, un, Vr, ME, Hl, Tn, gt, mt, gE, fc, zn, Cc, LE, Ja, Yl, mo, Xl, YT, Kl, vc, Rc, Za, Oc, Jo, Zo, Qa, NE, XT, Dc, Hs, jl, bc, Pc, KT, yE, pn, Ee, Lt, br, wt, di, Ys, Ae, Ft, qa, zl, Jl, Zl, Xs, Qo, jT, zT, Ks, js, JT, e_, qo, $c, R, el, t_, dn, ot, ZT, QT, r_, tl, qT, Wc, fE, CE, ep, Dn, vE, RE, OE, DE, n_, Ei, tp, rp, bE, i_, np, Jn, PE, ip, bn, op, lp, sp, ap, _p, kc, o_, l_, cp, wc, Ql, zs, up, Fc, Tp, Ai, s_, rl, En, nl, a_, __, ql, Io, Bc, Uc, Js, pp, dp, Mr, Vc, Gc, Zn, c_, es, Mo, u_, Cr, Zs, $E, WE, kE, xc, wE, Qs, Ep, FE, Ap, ts, Sp, hp, Hc, mp, Ip, Mp, gp, Yc, T_, Lp, p_, Xc, Np, yp, Oe;
      o = function(e, t, n, s) {
        if (!(e instanceof _e) && typeof e != "string" || `${e}`.trim() === "")
          throw Error('Invalid type "' + e + '". The type must be a non-empty string or a Blockly.registry.Type.');
        if (e = `${e}`.toLowerCase(), typeof t != "string" || t.trim() === "")
          throw Error('Invalid name "' + t + '". The name must be a non-empty string.');
        const u = t.toLowerCase();
        if (!n)
          throw Error("Can not register a null value");
        let A = go[e], L = Kc[e];
        if (A || (A = go[e] = /* @__PURE__ */ Object.create(null), L = Kc[e] = /* @__PURE__ */ Object.create(null)), c(e, n), !s && A[u])
          throw Error('Name "' + u + '" with type "' + e + '" already registered.');
        A[u] = n, L[u] = t;
      }, c = function(e, t) {
        switch (e) {
          case String(_e.FIELD):
            if (typeof t.fromJson != "function")
              throw Error('Type "' + e + '" must have a fromJson function');
        }
      }, T = function(e, t) {
        e = `${e}`.toLowerCase(), t = t.toLowerCase();
        const n = go[e];
        n && n[t] ? (delete go[e][t], delete Kc[e][t]) : console.warn("Unable to unregister [" + t + "][" + e + "] from the registry.");
      }, d = function(e, t, n) {
        e = `${e}`.toLowerCase(), t = t.toLowerCase();
        const s = go[e];
        if (!s || !s[t]) {
          if (t = "Unable to find [" + t + "][" + e + "] in the registry.", n)
            throw Error(t + " You must require or register a " + e + " plugin.");
          return console.warn(t), null;
        }
        return s[t];
      }, h = function(e, t) {
        return e = `${e}`.toLowerCase(), t = t.toLowerCase(), (e = go[e]) ? !!e[t] : !1;
      }, y = function(e, t, n) {
        return d(e, t, n);
      }, b = function(e, t, n) {
        return d(e, t, n);
      }, U = function(e, t, n) {
        e = `${e}`.toLowerCase();
        var s = go[e];
        if (!s) {
          if (s = `Unable to find [${e}] in the registry.`, n)
            throw Error(`${s} You must require or register a ${e} plugin.`);
          return console.warn(s), null;
        }
        if (!t)
          return s;
        e = Kc[e], n = /* @__PURE__ */ Object.create(null);
        for (const u of Object.keys(s))
          n[e[u]] = s[u];
        return n;
      }, Z = function(e, t, n) {
        return t = t.plugins[String(e)] || Vi, typeof t == "function" ? t : y(e, t, n);
      }, le = function(e) {
        return rs[e] || null;
      }, ue = function() {
        const e = [];
        for (const t in rs)
          e.push(rs[t]);
        return e;
      }, be = function(e) {
        rs[e.id] = e;
      }, Ke = function(e) {
        delete rs[e.id];
      }, ae = function() {
        return UE;
      }, Ne = function(e) {
        UE = e;
      }, Fe = function() {
        return jc;
      }, at = function(e) {
        jc = e;
      }, dr = function() {
        return rt;
      }, er = function(e) {
        rt = e;
      }, Ze = function(e) {
        for (; e.options.parentWorkspace; )
          e = e.options.parentWorkspace;
        const t = e.getParentSvg(), n = e.getCachedParentSvgSize();
        var s = t.parentElement;
        if (s instanceof HTMLElement) {
          var u = s.offsetWidth;
          s = s.offsetHeight, n.width !== u && (t.setAttribute("width", u + "px"), e.setCachedParentSvgSize(u, null)), n.height !== s && (t.setAttribute("height", s + "px"), e.setCachedParentSvgSize(null, s)), e.resize();
        }
      }, Pt = function(e, t) {
        const n = /* @__PURE__ */ Object.create(null), s = e.getDescendants(!0);
        t && (e = e.getNextBlock()) && (e = s.indexOf(e), s.splice(e, s.length - e));
        for (let u = 0, A; A = s[u]; u++)
          n[A.type] ? n[A.type]++ : n[A.type] = 1;
        return n;
      }, wr = function(e) {
        return function() {
          this.jsonInit(e);
        };
      }, xn = function(e) {
        VE.defineBlocksWithJsonArrayInternal(e);
      }, Dl = function(e) {
        r.defineBlocks$$module$build$src$core$common(r.createBlockDefinitionsFromJsonArray$$module$build$src$core$common(e));
      }, r.createBlockDefinitionsFromJsonArray$$module$build$src$core$common = function(e) {
        const t = {};
        for (let n = 0; n < e.length; n++) {
          const s = e[n];
          if (!s) {
            console.warn(`Block definition #${n} in JSON array is ${s}. Skipping`);
            continue;
          }
          const u = s.type;
          u ? t[u] = { init: wr(s) } : console.warn(`Block definition #${n} in JSON array is missing a type attribute. Skipping.`);
        }
        return t;
      }, r.defineBlocks$$module$build$src$core$common = function(e) {
        for (const t of Object.keys(e)) {
          const n = e[t];
          t in Zr && console.warn(`Block definiton "${t}" overwrites previous definition.`), Zr[t] = n;
        }
      }, si = function() {
        return "blockly-" + ($S++).toString(36);
      }, Yr = function() {
        return GE.genUid();
      }, Er = function(e) {
        Lo = e;
      }, Dr = function() {
        return Lo;
      }, Ce = function(e) {
        d_.fireInternal(e);
      }, Ps = function(e) {
        if (nt()) {
          if (!os.length)
            try {
              requestAnimationFrame(() => {
                setTimeout(an, 0);
              });
            } catch {
              setTimeout(an, 0);
            }
          os.push(e);
        }
      }, an = function() {
        var e = Sr(os, !0);
        os.length = 0;
        for (let n = 0, s; s = e[n]; n++)
          if (s.workspaceId) {
            var t = le(s.workspaceId);
            t && t.fireChangeListener(s);
          }
        e = new Set(e.map((n) => n.workspaceId));
        for (const n of e) {
          if (!n || (e = le(n), !e))
            continue;
          e = e.getUndoStack();
          let s;
          for (t = e.length; 0 < t; t--) {
            const u = e[t - 1];
            if (u.group === "")
              break;
            if (s === void 0)
              s = u.group;
            else if (u.group !== s)
              break;
          }
          s && t != e.length - 1 && (t = e.splice(t, e.length - t), t = Sr(t, !0), e.push(...t));
        }
      }, Sr = function(e, t) {
        e = e.slice(), t || e.reverse();
        const n = [], s = /* @__PURE__ */ Object.create(null);
        for (let L = 0, $; $ = e[L]; L++)
          if (!$.isNull()) {
            var u = [$.isUiEvent ? ta : $.type, $.blockId, $.workspaceId].join(" "), A = s[u];
            const q = A ? A.event : null;
            A ? $.type === r.MOVE$$module$build$src$core$events$utils && A.index === L - 1 ? (u = $, q.newParentId = u.newParentId, q.newInputName = u.newInputName, q.newCoordinate = u.newCoordinate, u.reason && (q.reason ? (u = new Set(u.reason.concat(q.reason)), q.reason = Array.from(u)) : q.reason = u.reason), A.index = L) : $.type === r.CHANGE$$module$build$src$core$events$utils && $.element === q.element && $.name === q.name ? q.newValue = $.newValue : $.type === al ? (A = $, q.viewTop = A.viewTop, q.viewLeft = A.viewLeft, q.scale = A.scale, q.oldScale = A.oldScale) : ($.type !== Gi || q.type !== Si) && (s[u] = {
              event: $,
              index: L
            }, n.push($)) : (s[u] = { event: $, index: L }, n.push($));
          }
        e = n.filter(function(L) {
          return !L.isNull();
        }), t || e.reverse();
        for (let L = 1, $; $ = e[L]; L++)
          $.type === r.CHANGE$$module$build$src$core$events$utils && $.element === "mutation" && e.unshift(e.splice(L, 1)[0]);
        return e;
      }, ao = function() {
        for (let e = 0, t; t = os[e]; e++)
          t.recordUndo = !1;
      }, r.disable$$module$build$src$core$events$utils = function() {
        ea++;
      }, r.enable$$module$build$src$core$events$utils = function() {
        ea--;
      }, nt = function() {
        return ea === 0;
      }, r.getGroup$$module$build$src$core$events$utils = function() {
        return Cp;
      }, r.setGroup$$module$build$src$core$events$utils = function(e) {
        d_.setGroupInternal(e);
      }, Fr = function(e) {
        Cp = typeof e == "boolean" ? e ? Yr() : "" : e;
      }, _o = function(e) {
        const t = [];
        e = e.getDescendants(!1);
        for (let n = 0, s; s = e[n]; n++)
          t[n] = s.id;
        return t;
      }, bl = function(e, t) {
        const n = fe(e.type);
        if (!n)
          throw Error("Unknown event type.");
        return n.fromJson(e, t);
      }, fe = function(e) {
        const t = y(_e.EVENT, e);
        if (!t)
          throw Error(`Event type ${e} not found in registry.`);
        return t;
      }, Hn = function(e) {
        if ((e.type === r.MOVE$$module$build$src$core$events$utils || e.type === r.CREATE$$module$build$src$core$events$utils) && e.workspaceId) {
          var t = le(e.workspaceId);
          if (!e.blockId)
            throw Error("Encountered a blockEvent without a proper blockId");
          if (e = t.getBlockById(e.blockId)) {
            const n = Lo;
            try {
              Lo = !1;
              const s = e.getParent();
              if (s && s.isEnabled()) {
                const u = e.getDescendants(!1);
                for (let A = 0, L; L = u[A]; A++)
                  L.setEnabled(!0);
              } else if ((e.outputConnection || e.previousConnection) && !t.isDragging())
                do
                  e.setEnabled(!1), e = e.getNextBlock();
                while (e);
            } finally {
              Lo = n;
            }
          }
        }
      }, Yn = function(e) {
        return e.saveState !== void 0 && e.loadState !== void 0;
      }, Br = function(e) {
        ({ document: E_ = E_, DOMParser: vr = vr, XMLSerializer: Sn = Sn } = e), Jc = new vr(), Zc = new Sn();
      }, r.createElement$$module$build$src$core$utils$xml = function(e) {
        return E_.createElementNS(xE, e);
      }, r.createTextNode$$module$build$src$core$utils$xml = function(e) {
        return E_.createTextNode(e);
      }, r.textToDom$$module$build$src$core$utils$xml = function(e) {
        let t = Jc.parseFromString(e, "text/xml");
        if (t && t.documentElement && !t.getElementsByTagName("parsererror").length)
          return t.documentElement;
        if ((t = Jc.parseFromString(e, "text/html")) && t.body.firstChild && t.body.firstChild.nodeName.toLowerCase() === "xml")
          return t.body.firstChild;
        throw Error(`DOMParser was unable to parse: ${e}`);
      }, Xr = function(e) {
        return ai(Zc.serializeToString(e));
      }, ai = function(e) {
        return e.replace(WS, (t) => `&#${t.charCodeAt(0)};`);
      }, hr = function(e, t, n, s) {
        e = e + " was deprecated in " + t + " and will be deleted in " + n + ".", s && (e += `
Use ` + s + " instead."), console.warn(e);
      }, K = function(e, t, n) {
        e = document.createElementNS(A_, `${e}`);
        for (const s in t)
          e.setAttribute(s, `${t[s]}`);
        return n && n.appendChild(e), e;
      }, Re = function(e, t) {
        return t = t.split(" "), t.every((n) => e.classList.contains(n)) ? !1 : (e.classList.add(...t), !0);
      }, co = function(e, t) {
        e.classList.remove(...t.split(" "));
      }, Ue = function(e, t) {
        return t = t.split(" "), t.every((n) => !e.classList.contains(n)) ? !1 : (e.classList.remove(...t), !0);
      }, Di = function(e, t) {
        return e.classList.contains(t);
      }, _t = function(e) {
        return e && e.parentNode ? e.parentNode.removeChild(e) : null;
      }, mr = function(e, t) {
        const n = t.nextSibling;
        if (t = t.parentNode, !t)
          throw Error("Reference node has no parent.");
        n ? t.insertBefore(e, n) : t.appendChild(e);
      }, xo = function(e, t) {
        return hr("Blockly.utils.dom.containsNode", "version 10", "version 11", 'Use native "contains" DOM method'), e.contains(t);
      }, bi = function(e, t) {
        e.style.transform = t, e.style["-webkit-transform"] = t;
      }, Ur = function() {
        vp++, en || (en = /* @__PURE__ */ Object.create(null));
      }, tr = function() {
        vp--, vp || (en = null);
      }, Pi = function(e) {
        const t = e.textContent + `
` + e.className.baseVal;
        let n;
        if (en && (n = en[t]))
          return n;
        try {
          n = e.getComputedTextLength();
        } catch {
          return 8 * e.textContent.length;
        }
        return en && (en[t] = n), n;
      }, Kr = function(e, t, n, s) {
        return _i(e, t + "pt", n, s);
      }, _i = function(e, t, n, s) {
        const u = e.textContent;
        e = u + `
` + e.className.baseVal;
        var A;
        return en && (A = en[e]) || (S_ || (A = document.createElement("canvas"), A.className = "blocklyComputeCanvas", document.body.appendChild(A), S_ = A.getContext("2d")), S_.font = n + " " + t + " " + s, A = u ? S_.measureText(u).width : 0, en && (en[e] = A)), A;
      }, Xn = function(e, t, n, s) {
        const u = document.createElement("span");
        u.style.font = n + " " + t + " " + s, u.textContent = e, e = document.createElement("div"), e.style.width = "1px", e.style.height = "0", t = document.createElement("div"), t.setAttribute("style", "position: fixed; top: 0; left: 0; display: flex;"), t.appendChild(u), t.appendChild(e), document.body.appendChild(t), n = { height: 0, baseline: 0 };
        try {
          t.style.alignItems = "baseline", n.baseline = e.offsetTop - u.offsetTop, t.style.alignItems = "flex-end", n.height = e.offsetTop - u.offsetTop;
        } finally {
          document.body.removeChild(t);
        }
        return n;
      }, uo = function(e, t) {
        Rp(e, t);
      }, $i = function(e) {
        Rp = e;
      }, jr = function(e, t) {
        m_.confirmInternal(e, t);
      }, To = function(e, t) {
        h_(e, t);
      }, k = function(e) {
        h_ = e;
      }, m = function(e, t, n) {
        Qc(e, t, n);
      }, D = function(e) {
        Qc = e;
      }, B = function(e) {
        return e.getVariableModel !== void 0;
      }, V = function(e) {
        return e.getProcedureDef !== void 0;
      }, oe = function(e) {
        return e.getProcedureCall !== void 0 && e.renameProcedure !== void 0;
      }, r.allUsedVarModels$$module$build$src$core$variables = function(e) {
        e = e.getAllBlocks(!1);
        const t = /* @__PURE__ */ new Set();
        for (let n = 0; n < e.length; n++) {
          const s = e[n].getVarModels();
          if (s)
            for (let u = 0; u < s.length; u++) {
              const A = s[u];
              A.getId() && t.add(A);
            }
        }
        return Array.from(t.values());
      }, r.allDeveloperVariables$$module$build$src$core$variables = function(e) {
        e = e.getAllBlocks(!1);
        const t = /* @__PURE__ */ new Set();
        for (let s = 0, u; u = e[s]; s++) {
          var n = u.getDeveloperVariables;
          if (n) {
            n = n();
            for (let A = 0; A < n.length; A++)
              t.add(n[A]);
          }
        }
        return Array.from(t.values());
      }, ke = function(e) {
        let t = [];
        const n = document.createElement("button");
        return n.setAttribute("text", "%{BKY_NEW_VARIABLE}"), n.setAttribute("callbackKey", "CREATE_VARIABLE"), e.registerButtonCallback("CREATE_VARIABLE", function(s) {
          ki(s.getTargetWorkspace());
        }), t.push(n), e = $t(e), t = t.concat(e);
      }, $t = function(e) {
        e = e.getVariablesOfType("");
        const t = [];
        if (0 < e.length) {
          var n = e[e.length - 1];
          if (Zr.variables_set) {
            var s = r.createElement$$module$build$src$core$utils$xml("block");
            s.setAttribute("type", "variables_set"), s.setAttribute("gap", Zr.math_change ? "8" : "24"), s.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(n)), t.push(s);
          }
          if (Zr.math_change && (s = r.createElement$$module$build$src$core$utils$xml("block"), s.setAttribute("type", "math_change"), s.setAttribute("gap", Zr.variables_get ? "20" : "8"), s.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(n)), n = r.textToDom$$module$build$src$core$utils$xml('<value name="DELTA"><shadow type="math_number"><field name="NUM">1</field></shadow></value>'), s.appendChild(n), t.push(s)), Zr.variables_get) {
            e.sort(ra.compareByName);
            for (let u = 0, A; A = e[u]; u++)
              n = r.createElement$$module$build$src$core$utils$xml("block"), n.setAttribute("type", "variables_get"), n.setAttribute("gap", "8"), n.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(A)), t.push(n);
          }
        }
        return t;
      }, Wi = function(e) {
        return Dp.generateUniqueNameInternal(e);
      }, rc = function(e) {
        return po(eu.charAt(0), e.getAllVariableNames());
      }, po = function(e, t) {
        if (!t.length)
          return e;
        const n = eu;
        let s = "", u = n.indexOf(e);
        for (; ; ) {
          let A = !1;
          for (let L = 0; L < t.length; L++)
            if (t[L].toLowerCase() === e) {
              A = !0;
              break;
            }
          if (!A)
            break;
          u++, u === n.length && (u = 0, s = `${Number(s) + 1}`), e = n.charAt(u) + s;
        }
        return e;
      }, ki = function(e, t, n) {
        function s(A) {
          Xt(r.Msg$$module$build$src$core$msg.NEW_VARIABLE_TITLE, A, function(L) {
            if (L) {
              var $ = Pl(L, e);
              if ($) {
                if ($.type === u)
                  var q = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS.replace("%1", $.name);
                else
                  q = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE, q = q.replace("%1", $.name).replace("%2", $.type);
                uo(q, function() {
                  s(L);
                });
              } else
                e.createVariable(L, u), t && t(L);
            } else
              t && t(null);
          });
        }
        const u = n || "";
        s("");
      }, r.renameVariable$$module$build$src$core$variables = function(e, t, n) {
        function s(u) {
          const A = r.Msg$$module$build$src$core$msg.RENAME_VARIABLE_TITLE.replace("%1", t.name);
          Xt(A, u, function(L) {
            if (L) {
              var $ = $s(L, t.type, e), q = Ws(t.name, L, e);
              if ($ || q) {
                var Le = "";
                $ ? Le = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE.replace("%1", $.name).replace(
                  "%2",
                  $.type
                ) : q && (Le = r.Msg$$module$build$src$core$msg.VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER.replace("%1", L).replace("%2", q)), uo(Le, function() {
                  s(L);
                });
              } else
                e.renameVariableById(t.getId(), L), n && n(L);
            } else
              n && n(null);
          });
        }
        s("");
      }, Xt = function(e, t, n) {
        m(e, t, function(s) {
          s && (s = s.replace(/[\s\xa0]+/g, " ").trim(), s === r.Msg$$module$build$src$core$msg.RENAME_VARIABLE || s === r.Msg$$module$build$src$core$msg.NEW_VARIABLE) && (s = null), n(s);
        });
      }, $s = function(e, t, n) {
        n = n.getVariableMap().getAllVariables(), e = e.toLowerCase();
        for (let s = 0, u; u = n[s]; s++)
          if (u.name.toLowerCase() === e && u.type !== t)
            return u;
        return null;
      }, Pl = function(e, t) {
        t = t.getVariableMap().getAllVariables(), e = e.toLowerCase();
        for (let n = 0, s; s = t[n]; n++)
          if (s.name.toLowerCase() === e)
            return s;
        return null;
      }, Ws = function(e, t, n) {
        return n.getProcedureMap().getProcedures().length ? Ho(e, t, n) : M(e, t, n);
      }, Ho = function(e, t, n) {
        e = e.toLowerCase(), t = t.toLowerCase(), n = n.getProcedureMap().getProcedures();
        for (const u of n) {
          var s = u.getParameters().filter(B).map((A) => A.getVariableModel().name);
          if (s && (n = s.some((A) => A.toLowerCase() === e), s = s.some((A) => A.toLowerCase() === t), n && s))
            return u.getName();
        }
        return null;
      }, M = function(e, t, n) {
        e = e.toLowerCase(), t = t.toLowerCase(), n = n.getAllBlocks(!1);
        for (const u of n) {
          if (!V(u))
            continue;
          n = u.getProcedureDef();
          var s = n[1];
          const A = s.some((L) => L.toLowerCase() === e);
          if (s = s.some((L) => L.toLowerCase() === t), A && s)
            return n[0];
        }
        return null;
      }, r.generateVariableFieldDom$$module$build$src$core$variables = function(e) {
        const t = r.createElement$$module$build$src$core$utils$xml("field");
        return t.setAttribute("name", "VAR"), t.setAttribute("id", e.getId()), t.setAttribute("variabletype", e.type), e = r.createTextNode$$module$build$src$core$utils$xml(e.name), t.appendChild(e), t;
      }, r.getOrCreateVariablePackage$$module$build$src$core$variables = function(e, t, n, s) {
        let u = r.getVariable$$module$build$src$core$variables(e, t, n, s);
        return u || (u = v(e, t, n, s)), u;
      }, r.getVariable$$module$build$src$core$variables = function(e, t, n, s) {
        const u = e.getPotentialVariableMap();
        let A = null;
        if (t && (A = e.getVariableById(t), !A && u && (A = u.getVariableById(t)), A))
          return A;
        if (n) {
          if (s === void 0)
            throw Error("Tried to look up a variable by name without a type");
          A = e.getVariable(n, s), !A && u && (A = u.getVariable(n, s));
        }
        return A;
      }, v = function(e, t, n, s) {
        const u = e.getPotentialVariableMap();
        return n || (n = Wi(e.isFlyout ? e.targetWorkspace : e)), u ? u.createVariable(n, s, t) : e.createVariable(n, s, t);
      }, W = function(e, t) {
        e = e.getAllVariables();
        const n = [];
        if (t.length !== e.length)
          for (let s = 0; s < e.length; s++) {
            const u = e[s];
            t.indexOf(u) === -1 && n.push(u);
          }
        return n;
      }, H = function(e, t) {
        ee(), Co = setTimeout(function() {
          t && t.handleRightClick(e);
        }, bp);
      }, ee = function() {
        Co && (clearTimeout(Co), Co = 0);
      }, Me = function() {
        na = null;
      }, He = function(e) {
        return !e.type.startsWith("pointer") || e instanceof PointerEvent && Yo(e);
      }, rr = function(e) {
        return `${e.pointerId}`;
      }, Yo = function(e) {
        const t = rr(e);
        return na ? na === t : e.type === "pointerdown" ? (na = t, !0) : !1;
      }, ge = function(e, t, n, s, u) {
        function A($) {
          (u || He($)) && (n ? s.call(n, $) : s($));
        }
        const L = [];
        if (t in Xi)
          for (let $ = 0; $ < Xi[t].length; $++) {
            const q = Xi[t][$];
            e.addEventListener(q, A, !1), L.push([e, q, A]);
          }
        else
          e.addEventListener(t, A, !1), L.push([e, t, A]);
        return L;
      }, Ir = function(e, t, n, s) {
        function u(L) {
          n ? s.call(n, L) : s(L);
        }
        const A = [];
        if (t in Xi)
          for (let L = 0; L < Xi[t].length; L++) {
            const $ = Xi[t][L];
            e.addEventListener($, u, !1), A.push([e, $, u]);
          }
        else
          e.addEventListener(t, u, !1), A.push([e, t, u]);
        return A;
      }, Mt = function(e) {
        const t = e[e.length - 1][2];
        for (; e.length; ) {
          const [n, s, u] = e.pop();
          n.removeEventListener(s, u, !1);
        }
        return t;
      }, ba = function(e) {
        if (e.target instanceof HTMLElement) {
          if (e.target.isContentEditable || e.target.getAttribute("data-is-text-input") === "true")
            return !0;
          if (e.target instanceof HTMLInputElement)
            return e = e.target, e.type === "text" || e.type === "number" || e.type === "email" || e.type === "password" || e.type === "search" || e.type === "tel" || e.type === "url";
          if (e.target instanceof HTMLTextAreaElement)
            return !0;
        }
        return !1;
      }, Xo = function(e) {
        return e.ctrlKey && Pr ? !0 : e.button === 2;
      }, $l = function(e, t, n) {
        const s = t.createSVGPoint();
        return s.x = e.clientX, s.y = e.clientY, n || (n = t.getScreenCTM().inverse()), s.matrixTransform(n);
      }, ks = function(e) {
        switch (e.deltaMode) {
          default:
            return { x: e.deltaX, y: e.deltaY };
          case 1:
            return { x: e.deltaX * iu, y: e.deltaY * iu };
          case 2:
            return { x: e.deltaX * jE, y: e.deltaY * jE };
        }
      }, Kn = function(e) {
        if (cs)
          throw Error("CSS already injected");
        ou += `
` + e;
      }, dT = function(e, t) {
        cs || (cs = !0, e && (e = t.replace(/[\\/]$/, ""), t = ou.replace(/<<<PATH>>>/g, e), ou = "", e = document.createElement("style"), e.id = "blockly-common-style", t = document.createTextNode(t), e.appendChild(t), document.head.insertBefore(e, document.head.firstChild)));
      }, Pa = function(e) {
        return zE.getSizeInternal(e);
      }, Jd = function(e) {
        if (wi(e, "display") !== "none")
          return ET(e);
        const t = e.style, n = t.display, s = t.visibility, u = t.position;
        t.visibility = "hidden", t.position = "absolute", t.display = "inline";
        const A = e.offsetWidth;
        return e = e.offsetHeight, t.display = n, t.position = u, t.visibility = s, new It(A, e);
      }, ET = function(e) {
        return new It(e.offsetWidth, e.offsetHeight);
      }, wi = function(e, t) {
        return e = window.getComputedStyle(e), e[t] || e.getPropertyValue(t);
      }, ci = function(e) {
        const t = new Te(0, 0);
        e = e.getBoundingClientRect();
        var n = document.documentElement;
        return n = new Te(window.pageXOffset || n.scrollLeft, window.pageYOffset || n.scrollTop), t.x = e.left + n.x, t.y = e.top + n.y, t;
      }, AT = function() {
        const e = document.body, t = document.documentElement;
        return new Te(e.scrollLeft || t.scrollLeft, e.scrollTop || t.scrollTop);
      }, ws = function(e) {
        const t = parseFloat(wi(e, "borderLeftWidth")), n = parseFloat(wi(e, "borderRightWidth")), s = parseFloat(wi(e, "borderTopWidth"));
        return e = parseFloat(wi(e, "borderBottomWidth")), new yt(s, e, t, n);
      }, nc = function(e, t, n) {
        e = ST(e, t, n), t.scrollLeft = e.x, t.scrollTop = e.y;
      }, ST = function(e, t, n) {
        var s = ci(e), u = ci(t), A = ws(t);
        const L = s.x - u.x - A.left;
        return s = s.y - u.y - A.top, u = ET(e), e = t.clientWidth - u.width, u = t.clientHeight - u.height, A = t.scrollLeft, t = t.scrollTop, n ? (A += L - e / 2, t += s - u / 2) : (A += Math.min(L, Math.max(L - e, 0)), t += Math.min(s, Math.max(s - u, 0))), new Te(A, t);
      }, Wl = function(e) {
        const t = new Te(0, 0);
        var n = e.x && e.getAttribute("x");
        const s = e.y && e.getAttribute("y");
        return n && (t.x = parseInt(n)), s && (t.y = parseInt(s)), (n = (n = e.getAttribute("transform")) && n.match(Wp)) && (t.x += Number(n[1]), n[3] && (t.y += Number(n[3]))), (e = e.getAttribute("style")) && -1 < e.indexOf("translate") && (e = e.match(kp)) && (t.x += Number(e[1]), e[3] && (t.y += Number(e[3]))), t;
      }, $a = function(e) {
        let t = 0, n = 0;
        for (; e; ) {
          const s = Wl(e);
          if (t += s.x, n += s.y, (" " + (e.getAttribute("class") || "") + " ").indexOf(" injectionDiv ") !== -1)
            break;
          e = e.parentNode;
        }
        return new Te(t, n);
      }, ic = function() {
        const e = AT();
        return new yt(e.y, document.documentElement.clientHeight + e.y, e.x, document.documentElement.clientWidth + e.x);
      }, oc = function() {
        const e = document.documentElement, t = window;
        return new Te(t.pageXOffset || e.scrollLeft, t.pageYOffset || e.scrollTop);
      }, Zd = function(e, t) {
        var n = t.x;
        t = t.y;
        const s = e.getInjectionDiv().getBoundingClientRect();
        return n = new Te(n - s.left, t - s.top), t = e.getOriginOffsetInPixels(), Te.difference(n, t).scale(1 / e.scale);
      }, Qd = function(e, t) {
        const n = r.createElement$$module$build$src$core$utils$xml("xml");
        var s = hT(r.allUsedVarModels$$module$build$src$core$variables(e));
        s.hasChildNodes() && n.appendChild(s), s = e.getTopComments(!0);
        for (let u = 0; u < s.length; u++)
          n.appendChild(s[u].toXmlWithXY(t));
        for (e = e.getTopBlocks(!0), s = 0; s < e.length; s++)
          n.appendChild(Wa(e[s], t));
        return n;
      }, hT = function(e) {
        const t = r.createElement$$module$build$src$core$utils$xml("variables");
        for (let n = 0; n < e.length; n++) {
          const s = e[n], u = r.createElement$$module$build$src$core$utils$xml("variable");
          u.appendChild(r.createTextNode$$module$build$src$core$utils$xml(s.name)), s.type && u.setAttribute("type", s.type), u.id = s.getId(), t.appendChild(u);
        }
        return t;
      }, Wa = function(e, t) {
        if (e.isInsertionMarker() && (e = e.getChildren(!1)[0], !e))
          return new DocumentFragment();
        let n = 0;
        if (e.workspace.RTL && (n = e.workspace.getWidth()), t = Eo(e, t), ac(t)) {
          const s = e.getRelativeToSurfaceXY();
          t.setAttribute("x", String(Math.round(e.workspace.RTL ? n - s.x : s.x))), t.setAttribute("y", String(Math.round(s.y)));
        }
        return t;
      }, mT = function(e) {
        if (e.isSerializable()) {
          const t = r.createElement$$module$build$src$core$utils$xml("field");
          return t.setAttribute("name", e.name || ""), e.toXml(t);
        }
        return null;
      }, IT = function(e, t) {
        for (let n = 0; n < e.inputList.length; n++) {
          const s = e.inputList[n];
          for (let u = 0; u < s.fieldRow.length; u++) {
            const A = mT(s.fieldRow[u]);
            A && t.appendChild(A);
          }
        }
      }, Eo = function(e, t) {
        if (e.isInsertionMarker())
          return (t = e.getChildren(!1)[0]) ? Eo(t) : new DocumentFragment();
        const n = r.createElement$$module$build$src$core$utils$xml(e.isShadow() ? "shadow" : "block");
        if (n.setAttribute("type", e.type), t || (n.id = e.id), e.mutationToDom) {
          var s = e.mutationToDom();
          s && (s.hasChildNodes() || s.hasAttributes()) && n.appendChild(s);
        }
        if (IT(e, n), s = e.getCommentText()) {
          var u = e.getIcon(Lr.COMMENT), A = u.getBubbleSize();
          u = u.bubbleIsVisible();
          var L = r.createElement$$module$build$src$core$utils$xml("comment");
          L.appendChild(r.createTextNode$$module$build$src$core$utils$xml(s)), L.setAttribute("pinned", `${u}`), L.setAttribute("h", String(A.height)), L.setAttribute("w", String(A.width)), n.appendChild(L);
        }
        for (e.data && (s = r.createElement$$module$build$src$core$utils$xml("data"), s.appendChild(r.createTextNode$$module$build$src$core$utils$xml(e.data)), n.appendChild(s)), s = 0; s < e.inputList.length; s++) {
          A = e.inputList[s];
          var $ = void 0;
          if (u = !0, A.type !== r.inputTypes$$module$build$src$core$inputs$input_types.DUMMY) {
            L = A.connection.targetBlock(), A.type === r.inputTypes$$module$build$src$core$inputs$input_types.VALUE ? $ = r.createElement$$module$build$src$core$utils$xml("value") : A.type === r.inputTypes$$module$build$src$core$inputs$input_types.STATEMENT && ($ = r.createElement$$module$build$src$core$utils$xml("statement"));
            const Le = A.connection.getShadowDom();
            !Le || L && L.isShadow() || $.appendChild(ka(
              Le,
              t
            )), L && (L = Eo(L, t), L.nodeType === hn.ELEMENT_NODE && ($.appendChild(L), u = !1)), $.setAttribute("name", A.name), u || n.appendChild($);
          }
        }
        e.inputsInline !== void 0 && e.inputsInline !== e.inputsInlineDefault && n.setAttribute("inline", String(e.inputsInline)), e.isCollapsed() && n.setAttribute("collapsed", "true"), e.isEnabled() || n.setAttribute("disabled", "true"), e.isDeletable() || e.isShadow() || n.setAttribute("deletable", "false"), e.isMovable() || e.isShadow() || n.setAttribute("movable", "false"), e.isEditable() || n.setAttribute("editable", "false"), $ = e.getNextBlock();
        let q;
        return $ && (s = Eo($, t), s.nodeType === hn.ELEMENT_NODE && (q = r.createElement$$module$build$src$core$utils$xml("next"), q.appendChild(s), n.appendChild(q))), e = e.nextConnection && e.nextConnection.getShadowDom(), !e || $ && $.isShadow() || q.appendChild(ka(e, t)), n;
      }, ka = function(e, t) {
        let n = e = e.cloneNode(!0), s;
        for (; n; )
          if (t && n.nodeName === "shadow" && n.removeAttribute("id"), n.firstChild)
            n = n.firstChild;
          else {
            for (; n && !n.nextSibling; ) {
              s = n, n = n.parentNode;
              let u;
              s.nodeType === hn.TEXT_NODE && s.data.trim() === "" && ((u = n) == null ? void 0 : u.firstChild) !== s && _t(s);
            }
            n && (s = n, n = n.nextSibling, s.nodeType === hn.TEXT_NODE && s.data.trim() === "" && _t(s));
          }
        return e;
      }, Fi = function(e) {
        return Xr(e).replace(/<(\w+)([^<]*)\/>/g, "<$1$2></$1>");
      }, MT = function(e) {
        e = Fi(e).split("<");
        let t = "";
        for (let n = 1; n < e.length; n++) {
          const s = e[n];
          s[0] === "/" && (t = t.substring(2)), e[n] = t + "<" + s, s[0] !== "/" && s.slice(-2) !== "/>" && (t += "  ");
        }
        return e = e.join(`
`), e = e.replace(/(<(\w+)\b[^>]*>[^\n]*)\n *<\/\2>/g, "$1</$2>"), e.replace(/^\n/, "");
      }, wa = function(e, t) {
        return t.setResizesEnabled(!1), t.clear(), e = r.domToWorkspace$$module$build$src$core$xml(e, t), t.setResizesEnabled(!0), e;
      }, r.domToWorkspace$$module$build$src$core$xml = function(e, t) {
        let n = 0;
        t.RTL && (n = t.getWidth());
        const s = [];
        Ur();
        const u = r.getGroup$$module$build$src$core$events$utils();
        u || r.setGroup$$module$build$src$core$events$utils(!0), t.setResizesEnabled && t.setResizesEnabled(!1);
        let A = !0;
        try {
          for (let L = 0, $; $ = e.childNodes[L]; L++) {
            const q = $.nodeName.toLowerCase(), Le = $;
            if (q === "block" || q === "shadow" && !Dr()) {
              const _r = r.domToBlock$$module$build$src$core$xml(
                Le,
                t
              );
              s.push(_r.id);
              let Bt;
              const oi = parseInt((Bt = Le.getAttribute("x")) != null ? Bt : "10", 10);
              let ju;
              const zu = parseInt((ju = Le.getAttribute("y")) != null ? ju : "10", 10);
              isNaN(oi) || isNaN(zu) || _r.moveBy(t.RTL ? n - oi : oi, zu, ["create"]), A = !1;
            } else {
              if (q === "shadow")
                throw TypeError("Shadow block cannot be a top-level block.");
              if (q === "comment")
                t.rendered ? $r.fromXmlRendered(Le, t, n) : Hi.fromXml(Le, t);
              else if (q === "variables") {
                if (A)
                  LT(
                    Le,
                    t
                  );
                else
                  throw Error("'variables' tag must exist once before block and shadow tag elements in the workspace XML, but it was found in another location.");
                A = !1;
              }
            }
          }
        } finally {
          r.setGroup$$module$build$src$core$events$utils(u), tr();
        }
        return t.setResizesEnabled && t.setResizesEnabled(!0), Ce(new (fe(is))(t)), s;
      }, gT = function(e, t) {
        if (!t.getBlocksBoundingBox)
          return r.domToWorkspace$$module$build$src$core$xml(e, t);
        var n = t.getBlocksBoundingBox();
        if (e = r.domToWorkspace$$module$build$src$core$xml(e, t), n && n.top !== n.bottom) {
          var s = n.bottom;
          n = t.RTL ? n.right : n.left;
          var u = 1 / 0;
          let A = -1 / 0, L = 1 / 0;
          for (let $ = 0; $ < e.length; $++) {
            const q = t.getBlockById(e[$]).getRelativeToSurfaceXY();
            q.y < L && (L = q.y), q.x < u && (u = q.x), q.x > A && (A = q.x);
          }
          for (s = s - L + 10, n = t.RTL ? n - A : n - u, u = 0; u < e.length; u++)
            t.getBlockById(e[u]).moveBy(
              n,
              s,
              ["create"]
            );
        }
        return e;
      }, r.domToBlock$$module$build$src$core$xml = function(e, t) {
        r.disable$$module$build$src$core$events$utils();
        var n = t.getAllVariables();
        let s;
        try {
          if (s = Ba(e, t), t.rendered) {
            const u = s, A = s.getDescendants(!1);
            u.setConnectionTracking(!1);
            for (let L = A.length - 1; 0 <= L; L--)
              A[L].initSvg();
            for (let L = A.length - 1; 0 <= L; L--)
              A[L].render(!1);
            setTimeout(function() {
              u.disposed || u.setConnectionTracking(!0);
            }, 1), u.updateDisabled(), t.resizeContents();
          } else {
            const u = s.getDescendants(!1);
            for (let A = u.length - 1; 0 <= A; A--)
              u[A].initModel();
          }
        } finally {
          r.enable$$module$build$src$core$events$utils();
        }
        if (nt()) {
          for (e = W(t, n), t = 0; t < e.length; t++)
            n = e[t], Ce(new (fe(yo))(n));
          Ce(new (fe(r.CREATE$$module$build$src$core$events$utils))(s));
        }
        return s;
      }, LT = function(e, t) {
        for (let s = 0; s < e.children.length; s++) {
          var n = e.children[s];
          const u = n.getAttribute("type"), A = n.getAttribute("id");
          if (n = n.textContent, !n)
            break;
          t.createVariable(n, u, A);
        }
      }, NT = function(e) {
        const t = { mutation: [], comment: [], data: [], field: [], input: [], next: [] };
        for (let n = 0; n < e.children.length; n++) {
          const s = e.children[n];
          if (s.nodeType !== hn.TEXT_NODE)
            switch (s.nodeName.toLowerCase()) {
              case "mutation":
                t.mutation.push(s);
                break;
              case "comment":
                t.comment.push(s);
                break;
              case "data":
                t.data.push(s);
                break;
              case "title":
              case "field":
                t.field.push(s);
                break;
              case "value":
              case "statement":
                t.input.push(s);
                break;
              case "next":
                t.next.push(s);
                break;
              default:
                console.warn("Ignoring unknown tag: " + s.nodeName);
            }
        }
        return t;
      }, yT = function(e, t) {
        let n = !1;
        for (let s = 0; s < e.length; s++) {
          const u = e[s];
          t.domToMutation && (t.domToMutation(u), t.initSvg && (n = !0));
        }
        return n;
      }, lc = function(e, t) {
        for (let s = 0; s < e.length; s++) {
          var n = e[s];
          const u = n.textContent, A = n.getAttribute("pinned") === "true";
          let L;
          const $ = parseInt((L = n.getAttribute("w")) != null ? L : "50", 10);
          let q;
          n = parseInt((q = n.getAttribute("h")) != null ? q : "50", 10), t.setCommentText(u);
          const Le = t.getIcon(Lr.COMMENT);
          isNaN($) || isNaN(n) || Le.setBubbleSize(new It($, n)), Le.setBubbleVisible(A), setTimeout(
            () => Le.setBubbleVisible(A),
            1
          );
        }
      }, qd = function(e, t) {
        for (let n = 0; n < e.length; n++)
          t.data = e[n].textContent;
      }, fT = function(e, t) {
        for (let n = 0; n < e.length; n++) {
          const s = e[n], u = s.getAttribute("name");
          u ? CT(t, u, s) : console.warn(`Ignoring unnamed field in block ${t.type}`);
        }
      }, Fa = function(e) {
        let t = null, n = null;
        for (let s = 0; s < e.childNodes.length; s++) {
          const u = e.childNodes[s];
          ac(u) && (u.nodeName.toLowerCase() === "block" ? t = u : u.nodeName.toLowerCase() === "shadow" && (n = u));
        }
        return { childBlockElement: t, childShadowElement: n };
      }, sc = function(e, t, n, s) {
        for (let A = 0; A < e.length; A++) {
          var u = e[A];
          const L = u.getAttribute("name"), $ = L ? n.getInput(L) : null;
          if (!$) {
            console.warn("Ignoring non-existent input " + L + " in block " + s);
            break;
          }
          if (u = Fa(u), u.childBlockElement) {
            if (!$.connection)
              throw TypeError("Input connection does not exist.");
            Ba(u.childBlockElement, t, $.connection, !1);
          }
          if (u.childShadowElement) {
            let q;
            (q = $.connection) == null || q.setShadowDom(u.childShadowElement);
          }
        }
      }, kl = function(e, t, n) {
        for (let s = 0; s < e.length; s++) {
          const u = Fa(e[s]);
          if (u.childBlockElement) {
            if (!n.nextConnection)
              throw TypeError("Next statement does not exist.");
            if (n.nextConnection.isConnected())
              throw TypeError("Next statement is already connected.");
            Ba(u.childBlockElement, t, n.nextConnection, !0);
          }
          u.childShadowElement && n.nextConnection && n.nextConnection.setShadowDom(u.childShadowElement);
        }
      }, Ba = function(e, t, n, s) {
        var u;
        const A = e.getAttribute("type");
        if (!A)
          throw TypeError("Block type unspecified: " + e.outerHTML);
        var L = (u = e.getAttribute("id")) != null ? u : void 0;
        u = t.newBlock(A, L), L = NT(e);
        const $ = yT(L.mutation, u);
        if (lc(L.comment, u), qd(L.data, u), n)
          if (s)
            if (u.previousConnection)
              n.connect(u.previousConnection);
            else
              throw TypeError("Next block does not have previous statement.");
          else if (u.outputConnection)
            n.connect(u.outputConnection);
          else if (u.previousConnection)
            n.connect(u.previousConnection);
          else
            throw TypeError("Child block does not have output or previous statement.");
        if (fT(L.field, u), sc(L.input, t, u, A), kl(L.next, t, u), $ && u.initSvg(), (t = e.getAttribute("inline")) && u.setInputsInline(t === "true"), (t = e.getAttribute("disabled")) && u.setEnabled(t !== "true" && t !== "disabled"), (t = e.getAttribute("deletable")) && u.setDeletable(t === "true"), (t = e.getAttribute("movable")) && u.setMovable(t === "true"), (t = e.getAttribute("editable")) && u.setEditable(t === "true"), (t = e.getAttribute("collapsed")) && u.setCollapsed(t === "true"), e.nodeName.toLowerCase() === "shadow") {
          for (e = u.getChildren(!1), t = 0; t < e.length; t++)
            if (!e[t].isShadow())
              throw TypeError("Shadow block not allowed non-shadow child.");
          if (u.getVarModels().length)
            throw TypeError("Shadow blocks cannot have variable references.");
          u.setShadow(!0);
        }
        return u;
      }, CT = function(e, t, n) {
        const s = e.getField(t);
        s ? s.fromXml(n) : console.warn("Ignoring non-existent field " + t + " in block " + e.type);
      }, eE = function(e) {
        for (let t = 0; t < e.childNodes.length; t++) {
          const n = e.childNodes[t];
          if (n.nodeName.toLowerCase() === "next") {
            e.removeChild(n);
            break;
          }
        }
      }, ac = function(e) {
        return e.nodeType === hn.ELEMENT_NODE;
      }, Ua = function(e, t) {
        o(_e.SERIALIZER, e, t);
      }, vT = function(e) {
        T(_e.SERIALIZER, e);
      }, ui = function(e, { addCoordinates: t = !1, addInputBlocks: n = !0, addNextBlocks: s = !0, doFullSerialization: u = !0 } = {}) {
        if (e.isInsertionMarker())
          return null;
        const A = { type: e.type, id: e.id };
        return t && rE(e, A), tE(e, A), nE(e, A), RT(e, A, u), iE(
          e,
          A,
          u
        ), n && oE(e, A, u), s && lE(e, A, u), A;
      }, tE = function(e, t) {
        e.isCollapsed() && (t.collapsed = !0), e.isEnabled() || (t.enabled = !1), e.isOwnDeletable() || (t.deletable = !1), e.isOwnMovable() || (t.movable = !1), e.isOwnEditable() || (t.editable = !1), e.inputsInline !== void 0 && e.inputsInline !== e.inputsInlineDefault && (t.inline = e.inputsInline), e.data && (t.data = e.data);
      }, rE = function(e, t) {
        const n = e.workspace;
        e = e.getRelativeToSurfaceXY(), t.x = Math.round(n.RTL ? n.getWidth() - e.x : e.x), t.y = Math.round(e.y);
      }, nE = function(e, t) {
        e.saveExtraState ? (e = e.saveExtraState(), e !== null && (t.extraState = e)) : e.mutationToDom && (e = e.mutationToDom(), e !== null && (t.extraState = Fi(e).replace(' xmlns="https://developers.google.com/blockly/xml"', "")));
      }, RT = function(e, t, n) {
        const s = /* @__PURE__ */ Object.create(null);
        for (const u of e.getIcons())
          Yn(u) && (e = u.saveState(n)) && (s[u.getType().toString()] = e);
        Object.keys(s).length && (t.icons = s);
      }, iE = function(e, t, n) {
        const s = /* @__PURE__ */ Object.create(null);
        for (let u = 0; u < e.inputList.length; u++) {
          const A = e.inputList[u];
          for (let L = 0; L < A.fieldRow.length; L++) {
            const $ = A.fieldRow[L];
            $.isSerializable() && (s[$.name] = $.saveState(n));
          }
        }
        Object.keys(s).length && (t.fields = s);
      }, oE = function(e, t, n) {
        const s = /* @__PURE__ */ Object.create(null);
        for (let u = 0; u < e.inputList.length; u++) {
          const A = e.inputList[u];
          if (!A.connection)
            continue;
          const L = OT(A.connection, n);
          L && (s[A.name] = L);
        }
        Object.keys(s).length && (t.inputs = s);
      }, lE = function(e, t, n) {
        e.nextConnection && (e = OT(e.nextConnection, n)) && (t.next = e);
      }, OT = function(e, t) {
        const n = e.getShadowState(!0);
        if (e = e.targetBlock(), !n && !e)
          return null;
        const s = /* @__PURE__ */ Object.create(null);
        return n && (s.shadow = n), e && !e.isShadow() && (s.block = ui(e, { doFullSerialization: t })), s;
      }, Bi = function(e, t, { recordUndo: n = !1 } = {}) {
        return _c(e, t, { recordUndo: n });
      }, _c = function(e, t, { parentConnection: n, isShadow: s = !1, recordUndo: u = !1 } = {}) {
        const A = Dr();
        Er(u), (u = r.getGroup$$module$build$src$core$events$utils()) || r.setGroup$$module$build$src$core$events$utils(!0), r.disable$$module$build$src$core$events$utils();
        const L = DT(e, t, { parentConnection: n, isShadow: s });
        return r.enable$$module$build$src$core$events$utils(), Ce(new (fe(r.CREATE$$module$build$src$core$events$utils))(L)), r.setGroup$$module$build$src$core$events$utils(u), Er(A), t.rendered && setTimeout(() => {
          L.disposed || L.setConnectionTracking(!0);
        }, 1), L;
      }, DT = function(e, t, { parentConnection: n, isShadow: s = !1 } = {}) {
        if (!e.type)
          throw new Fp(e);
        const u = t.newBlock(e.type, e.id);
        return u.setShadow(s), sE(u, e), aE(u, e), _E(u, e), Wt(
          n,
          u,
          e
        ), Ot(u, e), cE(u, e), uE(u, e), TE(u, e), pE(u, t.rendered), u;
      }, sE = function(e, t) {
        let n = t.x === void 0 ? 0 : t.x;
        t = t.y === void 0 ? 0 : t.y;
        const s = e.workspace;
        n = s.RTL ? s.getWidth() - n : n, e.moveBy(n, t);
      }, aE = function(e, t) {
        t.collapsed && e.setCollapsed(!0), t.deletable === !1 && e.setDeletable(!1), t.movable === !1 && e.setMovable(!1), t.editable === !1 && e.setEditable(!1), t.enabled === !1 && e.setEnabled(!1), t.inline !== void 0 && e.setInputsInline(t.inline), t.data !== void 0 && (e.data = t.data);
      }, _E = function(e, t) {
        t.extraState && (e.loadExtraState ? e.loadExtraState(t.extraState) : e.domToMutation && e.domToMutation(r.textToDom$$module$build$src$core$utils$xml(t.extraState)));
      }, Wt = function(e, t, n) {
        if (e) {
          if (e.getSourceBlock().isShadow() && !t.isShadow())
            throw new JE(n);
          if (e.type === r.inputTypes$$module$build$src$core$inputs$input_types.VALUE) {
            var s = t.outputConnection;
            if (!s)
              throw new In("output", t, n);
          } else if (s = t.previousConnection, !s)
            throw new In(
              "previous",
              t,
              n
            );
          if (!e.connect(s)) {
            const u = t.workspace.connectionChecker;
            throw new pl(u.getErrorMessage(u.canConnectWithReason(s, e, !1), s, e), e.type === r.inputTypes$$module$build$src$core$inputs$input_types.VALUE ? "output connection" : "previous connection", t, n);
          }
        }
      }, Ot = function(e, t) {
        if (t.icons) {
          var n = Object.keys(t.icons);
          for (const u of n) {
            n = t.icons[u];
            var s = e.getIcon(u);
            if (!s) {
              if (s = y(_e.ICON, u, !1), !s)
                throw new Bp(u, e, t);
              s = new s(e), e.addIcon(s);
            }
            Yn(s) && s.loadState(n);
          }
        }
      }, cE = function(e, t) {
        if (t.fields) {
          var n = Object.keys(t.fields);
          for (let s = 0; s < n.length; s++) {
            const u = n[s], A = t.fields[u], L = e.getField(u);
            L ? L.loadState(A) : console.warn(`Ignoring non-existant field ${u} in block ${e.type}`);
          }
        }
      }, uE = function(e, t) {
        if (t.inputs) {
          var n = Object.keys(t.inputs);
          for (let s = 0; s < n.length; s++) {
            const u = n[s], A = e.getInput(u);
            if (!A || !A.connection)
              throw new In(u, e, t);
            bT(A.connection, t.inputs[u]);
          }
        }
      }, TE = function(e, t) {
        if (t.next) {
          if (!e.nextConnection)
            throw new In("next", e, t);
          bT(e.nextConnection, t.next);
        }
      }, bT = function(e, t) {
        t.shadow && e.setShadowState(t.shadow), t.block && DT(t.block, e.getSourceBlock().workspace, { parentConnection: e });
      }, pE = function(e, t) {
        if (t) {
          e.setConnectionTracking(!1), e.initSvg(), e.render(!1);
          for (const n of e.getIcons())
            n.onLocationChange(e.getRelativeToSurfaceXY());
        } else
          e.initModel();
      }, Ko = function(e) {
        return e.bubbleIsVisible !== void 0 && e.setBubbleVisible !== void 0;
      }, PT = function(e, t) {
        if (!e || !t)
          throw Error("Cannot connect null connections.");
        e.targetConnection = t, t.targetConnection = e;
      }, dE = function(e, t) {
        let n = null;
        t = t.outputConnection;
        const s = t == null ? void 0 : t.getConnectionChecker();
        for (let u = 0, A; A = e.inputList[u]; u++) {
          const L = A.connection;
          let $;
          if (L && (($ = s) != null && $.canConnect(t, L, !1))) {
            if (n)
              return null;
            n = L;
          }
        }
        return n;
      }, fr = function(e, t) {
        let n;
        for (; n = dE(e, t); )
          if (e = n.targetBlock(), !e || e.isShadow())
            return n;
        return null;
      }, jo = function(e) {
        return e * Math.PI / 180;
      }, Ao = function(e) {
        return 180 * e / Math.PI;
      }, wl = function(e, t, n) {
        if (n < e) {
          const s = n;
          n = e, e = s;
        }
        return Math.max(e, Math.min(t, n));
      }, Va = function() {
        Tt || (Tt = document.createElement("div"), Tt.className = "blocklyDropDownDiv", (dr() || document.body).appendChild(Tt), _a = document.createElement("div"), _a.className = "blocklyDropDownContent", Tt.appendChild(_a), Es = document.createElement("div"), Es.className = "blocklyDropDownArrow", Tt.appendChild(Es), Tt.style.opacity = "0", Tt.style.transition = "transform " + Tu + "s, opacity " + Tu + "s", Tt.addEventListener("focusin", function() {
          Re(Tt, "blocklyFocused");
        }), Tt.addEventListener("focusout", function() {
          Ue(Tt, "blocklyFocused");
        }));
      }, _n = function(e) {
        N_ = e;
      }, cc = function() {
        return El;
      }, Fl = function() {
        return _a;
      }, Ga = function() {
        _a.textContent = "", _a.style.width = "";
      }, xa = function(e, t) {
        Tt.style.backgroundColor = e, Tt.style.borderColor = t;
      }, $T = function(e, t, n, s) {
        return cn(zr(t), e, n, s);
      }, Fs = function(e, t, n) {
        return oA = !0, cn(WT(e), e, t, n);
      }, zr = function(e) {
        var t = e.getSvgRoot();
        const n = e.workspace.scale, s = e.height * n;
        return e = e.width * n, t = ci(t), new yt(t.y, t.y + s, t.x, t.x + e);
      }, WT = function(e) {
        return e = e.getScaledBBox(), new yt(e.top, e.bottom, e.left, e.right);
      }, cn = function(e, t, n, s) {
        const u = e.left + (e.right - e.left) / 2, A = e.bottom;
        e = e.top, s && (e += s), s = t.getSourceBlock();
        let L = s.workspace;
        for (; L.options.parentWorkspace; )
          L = L.options.parentWorkspace;
        return _n(L.getParentSvg().parentNode), kT(t, s.RTL, u, A, u, e, n);
      }, kT = function(e, t, n, s, u, A, L) {
        return El = e, ps = L || null, Tt.style.direction = t ? "rtl" : "ltr", e = ae(), ds = e.getRenderer().getClassName(), aa = e.getTheme().getClassName(), ds && Re(
          Tt,
          ds
        ), aa && Re(Tt, aa), Ya(n, s, u, A);
      }, uc = function(e, t, n, s) {
        return e = Bl(e, n.left, n.right, s.width), { initialX: e.divX, initialY: t, finalX: e.divX, finalY: t + Mn, arrowX: e.arrowX, arrowY: -(L_ / 2 + Gp), arrowAtTop: !0, arrowVisible: !0 };
      }, Ui = function(e, t, n, s) {
        return e = Bl(e, n.left, n.right, s.width), { initialX: e.divX, initialY: t - s.height, finalX: e.divX, finalY: t - s.height - Mn, arrowX: e.arrowX, arrowY: s.height - 2 * Gp - L_ / 2, arrowAtTop: !1, arrowVisible: !0 };
      }, Ha = function(e, t, n) {
        return e = Bl(e, t.left, t.right, n.width), { initialX: e.divX, initialY: 0, finalX: e.divX, finalY: 0, arrowAtTop: null, arrowX: null, arrowY: null, arrowVisible: !1 };
      }, Bl = function(e, t, n, s) {
        return t = wl(t, e - s / 2, n - s), e = e - L_ / 2 - t, n = iA, e = wl(n, e, s - n - L_), { arrowX: e, divX: t };
      }, kt = function() {
        return !!El;
      }, Rn = function(e, t) {
        return El === e ? (t ? Ti() : Bs(), !0) : !1;
      }, Bs = function() {
        Tt.style.transform = "translate(0, 0)", Tt.style.opacity = "0", xp = setTimeout(function() {
          Ti();
        }, 1e3 * Tu), ps && (ps(), ps = null);
      }, Ti = function() {
        kt() && (xp && clearTimeout(xp), Tt.style.transform = "", Tt.style.left = "", Tt.style.top = "", Tt.style.opacity = "0", Tt.style.display = "none", Tt.style.backgroundColor = "", Tt.style.borderColor = "", ps && (ps(), ps = null), Ga(), El = null, ds && (Ue(
          Tt,
          ds
        ), ds = ""), aa && (Ue(Tt, aa), aa = ""), ae().markFocused());
      }, Ya = function(e, t, n, s) {
        e = Hp.getPositionMetrics(e, t, n, s), e.arrowVisible ? (Es.style.display = "", Es.style.transform = "translate(" + e.arrowX + "px," + e.arrowY + "px) rotate(45deg)", Es.setAttribute("class", e.arrowAtTop ? "blocklyDropDownArrow blocklyArrowTop" : "blocklyDropDownArrow blocklyArrowBottom")) : Es.style.display = "none", t = Math.floor(e.initialX), n = Math.floor(e.initialY), s = Math.floor(e.finalX);
        const u = Math.floor(e.finalY);
        return Tt.style.left = t + "px", Tt.style.top = n + "px", Tt.style.display = "block", Tt.style.opacity = "1", Tt.style.transform = "translate(" + (s - t) + "px," + (u - n) + "px)", !!e.arrowAtTop;
      }, wT = function() {
        if (El) {
          var e = El.getSourceBlock();
          e = oA ? WT(El) : zr(e);
          const t = e.left + (e.right - e.left) / 2;
          Ya(t, e.bottom, t, e.top);
        } else
          Bs();
      }, EE = function(e, t) {
        return hr("Blockly.utils.string.startsWith()", "April 2022", "April 2023", "Use built-in string.startsWith"), e.startsWith(t);
      }, Xa = function(e) {
        return e.length ? e.reduce(function(t, n) {
          return t.length < n.length ? t : n;
        }).length : 0;
      }, Tc = function(e, t) {
        if (!e.length)
          return 0;
        if (e.length === 1)
          return e[0].length;
        let n = 0;
        t = t || Xa(e);
        let s;
        for (s = 0; s < t; s++) {
          for (var u = e[0][s], A = 1; A < e.length; A++)
            if (u !== e[A][s])
              return n;
          u === " " && (n = s + 1);
        }
        for (u = 1; u < e.length; u++)
          if ((A = e[u][s]) && A !== " ")
            return n;
        return t;
      }, Us = function(e, t) {
        if (!e.length)
          return 0;
        if (e.length === 1)
          return e[0].length;
        let n = 0;
        t = t || Xa(e);
        let s;
        for (s = 0; s < t; s++) {
          for (var u = e[0].substr(-s - 1, 1), A = 1; A < e.length; A++)
            if (u !== e[A].substr(-s - 1, 1))
              return n;
          u === " " && (n = s + 1);
        }
        for (u = 1; u < e.length; u++)
          if ((A = e[u].charAt(e[u].length - s - 1)) && A !== " ")
            return n;
        return t;
      }, r.wrap$$module$build$src$core$utils$string = function(e, t) {
        e = e.split(`
`);
        for (let n = 0; n < e.length; n++)
          e[n] = Ul(e[n], t);
        return e.join(`
`);
      }, Ul = function(e, t) {
        if (e.length <= t)
          return e;
        const n = e.trim().split(/\s+/);
        for (var s = 0; s < n.length; s++)
          n[s].length > t && (t = n[s].length);
        var u = -1 / 0;
        let A, L = 1;
        do {
          s = u, A = e, e = [], u = n.length / L;
          let $ = 1;
          for (let q = 0; q < n.length - 1; q++)
            $ < (q + 1.5) / u ? ($++, e[q] = !0) : e[q] = !1;
          e = dc(n, e, t), u = pc(n, e, t), e = FT(n, e), L++;
        } while (u > s);
        return A;
      }, pc = function(e, t, n) {
        const s = [0], u = [];
        for (var A = 0; A < e.length; A++)
          s[s.length - 1] += e[A].length, t[A] === !0 ? (s.push(0), u.push(e[A].charAt(e[A].length - 1))) : t[A] === !1 && s[s.length - 1]++;
        for (e = Math.max(...s), t = 0, A = 0; A < s.length; A++)
          t -= 2 * Math.pow(Math.abs(n - s[A]), 1.5), t -= Math.pow(e - s[A], 1.5), ".?!".indexOf(u[A]) !== -1 ? t += n / 3 : ",;)]}".indexOf(u[A]) !== -1 && (t += n / 4);
        return 1 < s.length && s[s.length - 1] <= s[s.length - 2] && (t += 0.5), t;
      }, dc = function(e, t, n) {
        let s = pc(e, t, n), u;
        for (let A = 0; A < t.length - 1; A++) {
          if (t[A] === t[A + 1])
            continue;
          const L = [].concat(t);
          L[A] = !L[A], L[A + 1] = !L[A + 1];
          const $ = pc(e, L, n);
          $ > s && (s = $, u = L);
        }
        return u ? dc(e, u, n) : t;
      }, FT = function(e, t) {
        const n = [];
        for (let s = 0; s < e.length; s++)
          n.push(e[s]), t[s] !== void 0 && n.push(t[s] ? `
` : " ");
        return n.join("");
      }, r.isNumber$$module$build$src$core$utils$string = function(e) {
        return /^\s*-?\d+(\.\d+)?\s*$/.test(e);
      }, Ec = function(e) {
        pu = e;
      }, Ac = function() {
        return pu;
      }, BT = function() {
        return f_;
      }, AE = function() {
        return or;
      }, zo = function(e) {
        if (e = Ka(e)) {
          for (e = e.tooltip; typeof e == "function"; )
            e = e();
          if (typeof e != "string")
            throw Error("Tooltip function must return a string.");
          return e;
        }
        return "";
      }, Ka = function(e) {
        for (; e && e.tooltip; ) {
          if (typeof e.tooltip == "string" || typeof e.tooltip == "function")
            return e;
          e = e.tooltip;
        }
        return null;
      }, UT = function() {
        or || (or = document.createElement("div"), or.className = "blocklyTooltipDiv", (dr() || document.body).appendChild(or));
      }, Vs = function(e) {
        e.mouseOverWrapper_ = Ir(e, "pointerover", null, Sc), e.mouseOutWrapper_ = Ir(e, "pointerout", null, Gs), e.addEventListener("pointermove", hc, !1);
      }, Jr = function(e) {
        e && (Mt(e.mouseOverWrapper_), Mt(e.mouseOutWrapper_), e.removeEventListener("pointermove", hc));
      }, Sc = function(e) {
        ca || (e = Ka(e.currentTarget), ei !== e && (So(), C_ = null, ei = e), clearTimeout(sA));
      }, Gs = function(e) {
        ca || (sA = setTimeout(function() {
          C_ = ei = null, So();
        }, 1), clearTimeout(Ss), Ss = 0);
      }, hc = function(e) {
        if (ei && ei.tooltip && !ca)
          if (f_) {
            const t = Yp - e.pageX;
            e = Xp - e.pageY, Math.sqrt(t * t + e * e) > aA && So();
          } else
            C_ !== ei && (clearTimeout(Ss), Yp = e.pageX, Xp = e.pageY, Ss = setTimeout(mE, _A));
      }, mc = function() {
        C_ = ei = null, So();
      }, So = function() {
        f_ && (f_ = !1, or && (or.style.display = "none")), Ss && (clearTimeout(Ss), Ss = 0);
      }, VT = function() {
        So(), ca = !0;
      }, GT = function() {
        ca = !1;
      }, SE = function() {
        or && ei && (typeof pu == "function" ? pu(or, ei) : hE());
      }, hE = function() {
        var e = zo(ei);
        e = r.wrap$$module$build$src$core$utils$string(e, lA), e = e.split(`
`);
        for (let t = 0; t < e.length; t++) {
          const n = document.createElement("div");
          n.appendChild(document.createTextNode(e[t])), or.appendChild(n);
        }
      }, Vl = function(e) {
        const t = document.documentElement.clientWidth, n = document.documentElement.clientHeight;
        let s = Yp;
        s = e ? s - (Kp + or.offsetWidth) : s + Kp;
        let u = Xp + jp;
        return u + or.offsetHeight > n + window.scrollY && (u -= or.offsetHeight + 2 * jp), e ? s = Math.max(ua - window.scrollX, s) : s + or.offsetWidth > t + window.scrollX - 2 * ua && (s = t - or.offsetWidth - 2 * ua), { x: s, y: u };
      }, mE = function() {
        if (!ca && (C_ = ei, or)) {
          or.textContent = "", SE();
          var e = ei.RTL;
          or.style.direction = e ? "rtl" : "ltr", or.style.display = "block", f_ = !0;
          var { x: t, y: n } = Vl(e);
          or.style.left = t + "px", or.style.top = n + "px";
        }
      }, xT = function() {
        return zp;
      }, Ic = function(e) {
        zp = e;
      }, Mc = function() {
        return Jp;
      }, ho = function(e) {
        Jp = e;
      }, pi = function(e) {
        e = `${e}`.toLowerCase().trim();
        var t = cA[e];
        if (t || (t = e.substring(0, 2) === "0x" ? "#" + e.substring(2) : e, t = t[0] === "#" ? t : "#" + t, /^#[0-9a-f]{6}$/.test(t)))
          return t;
        if (/^#[0-9a-f]{3}$/.test(t))
          return ["#", t[1], t[1], t[2], t[2], t[3], t[3]].join("");
        var n = e.match(/^(?:rgb)?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
        return n && (e = Number(n[1]), t = Number(n[2]), n = Number(n[3]), 0 <= e && 256 > e && 0 <= t && 256 > t && 0 <= n && 256 > n) ? ja(
          e,
          t,
          n
        ) : null;
      }, ja = function(e, t, n) {
        return t = e << 16 | t << 8 | n, 16 > e ? "#" + (16777216 | t).toString(16).substr(1) : "#" + t.toString(16);
      }, gc = function(e) {
        return e = pi(e), e ? (e = parseInt(e.substr(1), 16), [e >> 16, e >> 8 & 255, e & 255]) : [0, 0, 0];
      }, Lc = function(e, t, n) {
        let s = 0, u = 0, A = 0;
        if (t === 0)
          A = u = s = n;
        else {
          const L = Math.floor(e / 60), $ = e / 60 - L;
          e = n * (1 - t);
          const q = n * (1 - t * $);
          switch (t = n * (1 - t * (1 - $)), L) {
            case 1:
              s = q, u = n, A = e;
              break;
            case 2:
              s = e, u = n, A = t;
              break;
            case 3:
              s = e, u = q, A = n;
              break;
            case 4:
              s = t, u = e, A = n;
              break;
            case 5:
              s = n, u = e, A = q;
              break;
            case 6:
            case 0:
              s = n, u = t, A = e;
          }
        }
        return ja(Math.floor(s), Math.floor(u), Math.floor(A));
      }, jn = function(e, t, n) {
        return e = pi(e), !e || (t = pi(t), !t) ? null : (e = gc(e), t = gc(t), ja(Math.round(t[0] + n * (e[0] - t[0])), Math.round(t[1] + n * (e[1] - t[1])), Math.round(t[2] + n * (e[2] - t[2]))));
      }, On = function(e) {
        return Lc(e, zp, 255 * Jp);
      }, za = function(e, t) {
        const n = [];
        var s = e.split("");
        s.push("");
        var u = 0;
        e = [];
        let A = null;
        for (let q = 0; q < s.length; q++) {
          var L = s[q];
          if (u === 0)
            L === "%" ? ((u = e.join("")) && n.push(u), e.length = 0, u = 1) : e.push(L);
          else if (u === 1)
            L === "%" ? (e.push(L), u = 0) : t && "0" <= L && "9" >= L ? (u = 2, A = L, (L = e.join("")) && n.push(L), e.length = 0) : L === "{" ? u = 3 : (e.push("%", L), u = 0);
          else if (u === 2)
            if ("0" <= L && "9" >= L)
              A += L;
            else {
              var $ = void 0;
              n.push(parseInt(($ = A) != null ? $ : "", 10)), q--, u = 0;
            }
          else
            u === 3 && (L === "" ? (e.splice(0, 0, "%{"), q--, u = 0) : L !== "}" ? e.push(L) : (u = e.join(""), /[A-Z]\w*/i.test(u) ? (L = u.toUpperCase(), (L = L.startsWith("BKY_") ? L.substring(4) : null) && L in r.Msg$$module$build$src$core$msg ? (u = r.Msg$$module$build$src$core$msg[L], typeof u == "string" ? Array.prototype.push.apply(n, za(u, t)) : t ? n.push(`${u}`) : n.push(u)) : n.push("%{" + u + "}")) : n.push("%{" + u + "}"), u = e.length = 0));
        }
        for ((t = e.join("")) && n.push(t), $ = [], e.length = 0, s = 0; s < n.length; s++)
          typeof n[s] == "string" ? e.push(n[s]) : ((t = e.join("")) && $.push(t), e.length = 0, $.push(n[s]));
        return (t = e.join("")) && $.push(t), e.length = 0, $;
      }, HT = function(e) {
        return za(e, !0);
      }, Jt = function(e) {
        return typeof e != "string" ? e : (e = za(e, !1), e.length ? String(e[0]) : "");
      }, Nc = function(e) {
        let t = !0;
        const n = r.Msg$$module$build$src$core$msg, s = e.match(/%{BKY_[A-Z]\w*}/gi);
        if (s)
          for (let u = 0; u < s.length; u++) {
            const A = s[u].toUpperCase();
            n[A.slice(6, -1)] === void 0 && (console.warn("No message string for " + s[u] + " in " + e), t = !1);
          }
        return t;
      }, xs = function(e) {
        const t = typeof e == "string" ? Jt(e) : e;
        var n = Number(t);
        if (!isNaN(n) && 0 <= n && 360 >= n)
          return { hue: n, hex: Lc(n, xT(), 255 * Mc()) };
        if (n = pi(t))
          return { hue: null, hex: n };
        throw n = 'Invalid colour: "' + t + '"', e !== t && (n += ' (from "' + e + '")'), Error(n);
      }, Gl = function() {
        return gn;
      }, xl = function(e) {
        gn = e;
      }, x = function() {
        gn || (gn = document.createElement("div"), gn.className = "blocklyWidgetDiv", (dr() || document.body).appendChild(gn));
      }, Q = function(e, t, n) {
        j(), Ta = e, du = n, (e = gn) && (e.style.direction = t ? "rtl" : "ltr", e.style.display = "block", t = ae(), hs = t.getRenderer().getClassName(), pa = t.getTheme().getClassName(), hs && Re(e, hs), pa && Re(e, pa));
      }, j = function() {
        if (Ie()) {
          Ta = null;
          var e = gn;
          e && (e.style.display = "none", e.style.left = "", e.style.top = "", du && du(), du = null, e.textContent = "", hs && (Ue(e, hs), hs = ""), pa && (Ue(e, pa), pa = ""), ae().markFocused());
        }
      }, Ie = function() {
        return !!Ta;
      }, Ve = function(e) {
        Ta === e && j();
      }, Et = function(e, t, n) {
        gn.style.left = e + "px", gn.style.top = t + "px", gn.style.height = n + "px";
      }, cr = function(e, t, n, s) {
        const u = yc(e, t, n);
        e = Nt(e, t, n, s), 0 > u ? Et(e, 0, n.height + u) : Et(e, u, n.height);
      }, Nt = function(e, t, n, s) {
        return s ? Math.min(Math.max(t.right - n.width, e.left), e.right - n.width) : Math.max(Math.min(t.left, e.right - n.width), e.left);
      }, yc = function(e, t, n) {
        return t.bottom + n.height >= e.bottom ? t.top - n.height : t.bottom;
      }, IE = function(e) {
        return !(e == null || !e.repositionForWindowResize);
      }, un = function() {
        IE(Ta) && Ta.repositionForWindowResize() || j();
      }, Vr = function(e, t) {
        o(_e.FIELD, e, t);
      }, ME = function(e) {
        T(_e.FIELD, e);
      }, r.fromJson$$module$build$src$core$field_registry = function(e) {
        return uA.fromJsonInternal(e);
      }, Hl = function(e) {
        const t = b(_e.FIELD, e.type);
        if (t) {
          if (typeof t.fromJson != "function")
            throw new TypeError("returned Field was not a IRegistrableField");
          return t.fromJson(e);
        }
        return console.warn("Blockly could not create a field of type " + e.type + ". The field is probably not being registered. This could be because the file is not loaded, the field does not register itself (Issue #1584), or the registration is not being reached."), null;
      }, Tn = function(e, t) {
        e.setAttribute(BS, t);
      }, gt = function(e, t, n) {
        Array.isArray(n) && (n = n.join(" ")), e.setAttribute(FS + t, `${n}`);
      }, mt = function(e) {
        let t = !1;
        const n = e.map(([L, $]) => typeof L == "string" ? [Jt(L), $] : (t = !0, [L.alt !== null ? Object.assign({}, L, { alt: Jt(L.alt) }) : Object.assign({}, L), $]));
        if (t || 2 > e.length)
          return { options: n };
        var s = n.map(([L]) => L), u = Xa(s);
        e = Tc(
          s,
          u
        );
        const A = Us(s, u);
        return !e && !A || u <= e + A ? { options: n } : (u = e ? s[0].substring(0, e - 1) : void 0, s = A ? s[0].substr(1 - A) : void 0, { options: gE(n, e, A), prefix: u, suffix: s });
      }, gE = function(e, t, n) {
        return e.map(([s, u]) => [s.substring(t, s.length - n), u]);
      }, fc = function(e) {
        if (!Array.isArray(e))
          throw TypeError("FieldDropdown options must be an array.");
        if (!e.length)
          throw TypeError("FieldDropdown options must not be an empty array.");
        let t = !1;
        for (let n = 0; n < e.length; n++) {
          const s = e[n];
          Array.isArray(s) ? typeof s[1] != "string" ? (t = !0, console.error("Invalid option[" + n + "]: Each FieldDropdown option id must be a string. Found " + s[1] + " in: ", s)) : s[0] && typeof s[0] != "string" && typeof s[0].src != "string" && (t = !0, console.error("Invalid option[" + n + "]: Each FieldDropdown option must have a string label or image description. Found" + s[0] + " in: ", s)) : (t = !0, console.error("Invalid option[" + n + "]: Each FieldDropdown option must be an array. Found: ", s));
        }
        if (t)
          throw TypeError("Found invalid FieldDropdown options.");
      }, zn = function(e, t) {
        for (const n in t)
          e[n] = t[n] !== null && typeof t[n] == "object" ? zn(e[n] || /* @__PURE__ */ Object.create(null), t[n]) : t[n];
        return e;
      }, Cc = function(e) {
        return e ? ((e instanceof Element || typeof e == "string") && (e = Rc(e), e = YT(e)), LE(e), e) : null;
      }, LE = function(e) {
        const t = e.kind;
        if (e = e.contents, t && t !== pA && t !== qp)
          throw Error("Invalid toolbox kind " + t + ". Please supply either " + pA + " or " + qp);
        if (!e)
          throw Error("Toolbox must have a contents attribute.");
      }, Ja = function(e) {
        return e ? e.contents ? e.contents : Array.isArray(e) && 0 < e.length && !e[0].nodeType ? e : Kl(e) : [];
      }, Yl = function(e) {
        return dA.hasCategoriesInternal(e);
      }, mo = function(e) {
        if (!e)
          return !1;
        const t = e.kind;
        return t ? t === qp : !!e.contents.filter(function(n) {
          return n.kind.toUpperCase() === "CATEGORY";
        }).length;
      }, Xl = function(e) {
        return e && e.contents ? !!e.contents.filter(function(t) {
          return t.kind.toUpperCase() === "CATEGORY";
        }).length : !1;
      }, YT = function(e) {
        const t = { contents: Kl(e) };
        return e instanceof Node && vc(e, t), t;
      }, Kl = function(e) {
        const t = [];
        let n = e.childNodes;
        n || (n = e);
        for (let s = 0, u; u = n[s]; s++) {
          if (!u.tagName)
            continue;
          e = {};
          const A = u.tagName.toUpperCase();
          e.kind = A, A === "BLOCK" ? e.blockxml = u : u.childNodes && 0 < u.childNodes.length && (e.contents = Kl(u)), vc(u, e), t.push(e);
        }
        return t;
      }, vc = function(e, t) {
        for (let n = 0; n < e.attributes.length; n++) {
          const s = e.attributes[n];
          -1 < s.nodeName.indexOf("css-") ? (t.cssconfig = t.cssconfig || {}, t.cssconfig[s.nodeName.replace("css-", "")] = s.value) : t[s.nodeName] = s.value;
        }
      }, Rc = function(e) {
        let t = null;
        if (e)
          if (typeof e == "string") {
            if (t = r.textToDom$$module$build$src$core$utils$xml(e), t.nodeName.toLowerCase() !== "xml")
              throw TypeError("Toolbox should be an <xml> document.");
          } else
            e instanceof Element && (t = e);
        return t;
      }, r.register$$module$build$src$core$extensions = function(e, t) {
        if (typeof e != "string" || e.trim() === "")
          throw Error('Error: Invalid extension name "' + e + '"');
        if (da[e])
          throw Error('Error: Extension "' + e + '" is already registered.');
        if (typeof t != "function")
          throw Error('Error: Extension "' + e + '" must be a function');
        da[e] = t;
      }, r.registerMixin$$module$build$src$core$extensions = function(e, t) {
        if (!t || typeof t != "object")
          throw Error('Error: Mixin "' + e + '" must be a object');
        r.register$$module$build$src$core$extensions(e, function() {
          this.mixin(t);
        });
      }, r.registerMutator$$module$build$src$core$extensions = function(e, t, n, s) {
        const u = 'Error when registering mutator "' + e + '": ';
        Hs(u, t);
        const A = XT(t, u);
        if (n && typeof n != "function")
          throw Error(u + 'Extension "' + e + '" is not a function');
        r.register$$module$build$src$core$extensions(e, function() {
          A && this.setMutator(new r.MutatorIcon$$module$build$src$core$icons$mutator_icon(s || [], this)), this.mixin(t), n && n.apply(this);
        });
      }, Za = function(e) {
        Oc(e) ? delete da[e] : console.warn('No extension mapping for name "' + e + '" found to unregister');
      }, Oc = function(e) {
        return !!da[e];
      }, Jo = function(e, t, n) {
        const s = da[e];
        if (typeof s != "function")
          throw Error('Error: Extension "' + e + '" not found.');
        let u;
        if (n ? Zo(e, t) : u = jl(t), s.apply(t), n)
          Hs('Error after applying mutator "' + e + '": ', t);
        else if (!bc(
          u,
          t
        ))
          throw Error('Error when applying extension "' + e + '": mutation properties changed when applying a non-mutator extension.');
      }, Zo = function(e, t) {
        if (jl(t).length)
          throw Error('Error: tried to apply mutation "' + e + '" to a block that already has mutator functions.  Block id: ' + t.id);
      }, Qa = function(e, t) {
        return Dc(e.mutationToDom, e.domToMutation, t + " mutationToDom/domToMutation");
      }, NE = function(e, t) {
        return Dc(e.saveExtraState, e.loadExtraState, t + " saveExtraState/loadExtraState");
      }, XT = function(e, t) {
        return Dc(e.compose, e.decompose, t + " compose/decompose");
      }, Dc = function(e, t, n) {
        if (e && t) {
          if (typeof e != "function" || typeof t != "function")
            throw Error(n + " must be a function");
          return !0;
        }
        if (!e && !t)
          return !1;
        throw Error(n + "Must have both or neither functions");
      }, Hs = function(e, t) {
        const n = Qa(t, e), s = NE(t, e);
        if (!n && !s)
          throw Error(e + "Mutations must contain either XML hooks, or JSON hooks, or both");
        XT(t, e);
      }, jl = function(e) {
        const t = [];
        return e.domToMutation !== void 0 && t.push(e.domToMutation), e.mutationToDom !== void 0 && t.push(e.mutationToDom), e.saveExtraState !== void 0 && t.push(e.saveExtraState), e.loadExtraState !== void 0 && t.push(e.loadExtraState), e.compose !== void 0 && t.push(e.compose), e.decompose !== void 0 && t.push(e.decompose), t;
      }, bc = function(e, t) {
        if (t = jl(t), t.length !== e.length)
          return !1;
        for (let n = 0; n < t.length; n++)
          if (e[n] !== t[n])
            return !1;
        return !0;
      }, Pc = function(e) {
        if (typeof document != "object")
          throw Error("runAfterPageLoad() requires browser document.");
        if (document.readyState === "complete")
          e();
        else {
          const t = setInterval(function() {
            document.readyState === "complete" && (clearInterval(t), e());
          }, 10);
        }
      }, r.buildTooltipForDropdown$$module$build$src$core$extensions = function(e, t) {
        const n = [];
        return typeof document == "object" && Pc(function() {
          for (const s in t)
            Nc(t[s]);
        }), function() {
          this.type && n.indexOf(this.type) === -1 && (KT(this, e, t), n.push(this.type)), this.setTooltip((function() {
            var s = String(this.getFieldValue(e));
            let u = t[s];
            return u === null ? n.indexOf(this.type) === -1 && (s = "No tooltip mapping for value " + s + " of field " + e, this.type !== null && (s += " of block type " + this.type), console.warn(s + ".")) : u = Jt(u), u;
          }).bind(this));
        };
      }, KT = function(e, t, n) {
        var s = e.getField(t);
        if (s instanceof zi && !s.isOptionListDynamic()) {
          s = s.getOptions();
          for (let u = 0; u < s.length; u++) {
            const A = s[u][1];
            n[A] === null && console.warn("No tooltip mapping for value " + A + " of field " + t + " of block type " + e.type);
          }
        }
      }, r.buildTooltipWithFieldText$$module$build$src$core$extensions = function(e, t) {
        return typeof document == "object" && Pc(function() {
          Nc(e);
        }), function() {
          this.setTooltip((function() {
            const n = this.getField(t);
            return Jt(e).replace("%1", n ? n.getText() : "");
          }).bind(this));
        };
      }, yE = function() {
        const e = this.tooltip;
        this.setTooltip((function() {
          const t = this.getParent();
          return t && t.getInputsInline() && t.tooltip || e;
        }).bind(this));
      }, pn = function(e, t) {
        return t = e.indexOf(t), t === -1 ? !1 : (e.splice(t, 1), !0);
      }, Ee = function(e, t) {
        return " " + e + "," + t + " ";
      }, Lt = function(e, t) {
        return " " + e + t.join("");
      }, br = function(e, t) {
        return " M " + e + "," + t + " ";
      }, wt = function(e, t) {
        return " m " + e + "," + t + " ";
      }, di = function(e, t) {
        return " l " + e + "," + t + " ";
      }, Ys = function(e) {
        return " l" + e.join("");
      }, Ae = function(e, t) {
        return " " + e + " " + t + " ";
      }, Ft = function(e, t, n, s) {
        return e + " " + n + " " + n + " " + t + s;
      }, qa = function(e, t) {
        o(_e.ICON, e.toString(), t);
      }, zl = function(e) {
        T(_e.ICON, e);
      }, Jl = function(e) {
        if (!(100 < e.getDescendants(!1).length)) {
          var t = e.workspace, n = e.getSvgRoot();
          t.getAudioManager().play("delete");
          var s = t.getSvgXY(n);
          n = n.cloneNode(!0), n.setAttribute("transform", "translate(" + s.x + "," + s.y + ")"), t.getParentSvg().appendChild(n), Zl(n, { x: s.x, y: s.y, width: e.width, height: e.height }, t.RTL, /* @__PURE__ */ new Date(), t.scale);
        }
      }, Zl = function(e, t, n, s, u) {
        const A = ((/* @__PURE__ */ new Date()).getTime() - s.getTime()) / 150;
        1 < A ? _t(e) : (e.setAttribute("transform", "translate(" + (t.x + (n ? -1 : 1) * t.width * u / 2 * A) + "," + (t.y + t.height * u * A) + ") scale(" + (1 - A) * u + ")"), setTimeout(Zl, 10, e, t, n, s, u));
      }, Xs = function(e) {
        const t = e.workspace, n = t.scale;
        if (t.getAudioManager().play("click"), !(1 > n)) {
          var s = t.getSvgXY(e.getSvgRoot());
          e.outputConnection ? (s.x += (e.RTL ? 3 : -3) * n, s.y += 13 * n) : e.previousConnection && (s.x += (e.RTL ? -23 : 23) * n, s.y += 3 * n), e = K(G.CIRCLE, { cx: s.x, cy: s.y, r: 0, fill: "none", stroke: "#888", "stroke-width": 10 }, t.getParentSvg()), Qo(
            e,
            /* @__PURE__ */ new Date(),
            n
          );
        }
      }, Qo = function(e, t, n) {
        const s = ((/* @__PURE__ */ new Date()).getTime() - t.getTime()) / 150;
        1 < s ? _t(e) : (e.setAttribute("r", String(25 * s * n)), e.style.opacity = String(1 - s), D_ = setTimeout(Qo, 10, e, t, n));
      }, jT = function(e) {
        if (Ks(), e.workspace.getAudioManager().play("disconnect"), !(1 > e.workspace.scale)) {
          var t = e.getHeightWidth().height;
          t = Math.atan(10 / t) / Math.PI * 180, e.RTL || (t *= -1), b_ = e, zT(e, t, /* @__PURE__ */ new Date());
        }
      }, zT = function(e, t, n) {
        const s = ((/* @__PURE__ */ new Date()).getTime() - n.getTime()) / 200;
        let u = "";
        1 >= s && (u = `skewX(${Math.round(Math.sin(s * Math.PI * 3) * (1 - s) * t)})`, D_ = setTimeout(zT, 10, e, t, n)), e.getSvgRoot().setAttribute("transform", `${e.getTranslation()} ${u}`);
      }, Ks = function() {
        b_ && (D_ && (clearTimeout(D_), D_ = null), b_.getSvgRoot().setAttribute("transform", b_.getTranslation()), b_ = null);
      }, js = function(e, t, n) {
        const s = n.getBoundingRectangle(), u = s.right - s.left, A = wl(t.top, s.top, t.top + t.height - (s.bottom - s.top)) - s.top;
        let L = t.left;
        return t = t.left + t.width - u, e.RTL ? L = Math.min(t, L) : t = Math.max(L, t), (e = wl(L, s.left, t) - s.left) || A ? (n.moveBy(e, A, ["inbounds"]), !0) : !1;
      }, JT = function(e) {
        return (t) => {
          var n = e.getMetricsManager();
          if (n.hasFixedEdges() && !e.isDragging()) {
            var s;
            if (zc.indexOf((s = t.type) != null ? s : "") !== -1) {
              s = n.getScrollMetrics(!0);
              const u = e_(e, t);
              u && (n = r.getGroup$$module$build$src$core$events$utils() || !1, r.setGroup$$module$build$src$core$events$utils(t.group), js(
                e,
                s,
                u
              ) && !t.group && console.warn("Moved object in bounds but there was no event group. This may break undo."), r.setGroup$$module$build$src$core$events$utils(n));
            } else
              t.type === al && t.scale && t.oldScale && t.scale > t.oldScale && qo(e);
          }
        };
      }, e_ = function(e, t) {
        let n = null;
        switch (t.type) {
          case r.CREATE$$module$build$src$core$events$utils:
          case r.MOVE$$module$build$src$core$events$utils:
            (n = e.getBlockById(t.blockId)) && (n = n.getRootBlock());
            break;
          case qr:
          case qn:
            n = e.getCommentById(t.commentId);
        }
        return n;
      }, qo = function(e) {
        var t = e.getMetricsManager();
        if (t.hasFixedEdges() && !e.isDragging()) {
          t = t.getScrollMetrics(!0);
          var n = e.getTopBoundedElements();
          for (let s = 0, u; u = n[s]; s++)
            js(e, t, u);
        }
      }, $c = function(e) {
        return el(e), Aa || (Aa = new Promise((t) => {
          window.requestAnimationFrame(() => {
            t_(), t();
          });
        })), Aa;
      }, R = function() {
        return Aa || Promise.resolve();
      }, el = function(e) {
        fu.add(e);
        const t = e.getParent();
        t ? el(t) : yu.add(e);
      }, t_ = function() {
        const e = new Set([...yu].map((t) => t.workspace));
        for (const t of yu) {
          if (t.isDisposed() || t.getParent())
            continue;
          dn(t);
          const n = t.getRelativeToSurfaceXY();
          ot(t, n), ZT(
            t,
            n
          );
        }
        for (const t of e)
          t.resizeContents();
        yu.clear(), fu = /* @__PURE__ */ new Set(), Aa = null;
      }, dn = function(e) {
        if (fu.has(e)) {
          for (const t of e.getChildren(!1))
            dn(t);
          e.renderEfficiently();
        }
      }, ot = function(e, t) {
        for (const n of e.getConnections_(!1)) {
          e = n.moveToOffset(t);
          const s = n.targetBlock();
          n.isSuperior() && s && (e || fu.has(s)) && ot(s, Te.sum(t, s.relativeCoords));
        }
      }, ZT = function(e, t) {
        if (e.getIcons) {
          for (const n of e.getIcons())
            n.onLocationChange(t);
          for (const n of e.getChildren(!1))
            ZT(n, Te.sum(t, n.relativeCoords));
        }
      }, QT = function(e, t) {
        const n = [];
        for (const s of e.getIcons())
          (!Ko(s) || s.bubbleIsVisible()) && (n.push({ location: t, icon: s }), s.onLocationChange(t));
        for (const s of e.getChildren(!1))
          n.push(...QT(s, Te.sum(t, s.relativeCoords)));
        return n;
      }, r_ = function(e) {
        Qt.copyInternal(e);
      }, tl = function(e) {
        sr = e.toCopyData();
      }, qT = function() {
        if (!sr)
          return null;
        let e = sr.source;
        return e.isFlyout && (e = e.targetWorkspace), sr.typeCounts && e.isCapacityAvailable(sr.typeCounts) ? e.paste(sr.saveInfo) : null;
      }, Wc = function(e) {
        return Qt.duplicateInternal(e);
      }, fE = function(e) {
        const t = sr;
        r_(e);
        let n, s, u;
        return e = (u = (n = e.toCopyData()) == null || (s = n.source) == null ? void 0 : s.paste(sr.saveInfo)) != null ? u : null, sr = t, e;
      }, CE = function() {
        return Mi;
      }, ep = function(e) {
        Mi = e;
      }, Dn = function(e, t, n) {
        if (Q(mA, n, Ei), t.length) {
          var s = vE(t, n);
          Cu = s, RE(s, e, n), setTimeout(function() {
            s.focus();
          }, 1), Mi = null;
        } else
          n_();
      }, vE = function(e, t) {
        const n = new Zp();
        n.setRole(Ln.MENU);
        for (let s = 0; s < e.length; s++) {
          const u = e[s], A = new Qp(u.text);
          A.setRightToLeft(t), A.setRole(Ln.MENUITEM), n.addChild(A), A.setEnabled(u.enabled), u.enabled && A.onAction(function() {
            n_(), requestAnimationFrame(() => {
              setTimeout(
                () => {
                  u.callback(u.scope);
                },
                0
              );
            });
          }, {});
        }
        return n;
      }, RE = function(e, t, n) {
        const s = ic();
        t = new yt(t.clientY + s.top, t.clientY + s.top, t.clientX + s.left, t.clientX + s.left), OE(e);
        const u = e.getSize();
        n && (t.left += u.width, t.right += u.width, s.left += u.width, s.right += u.width), cr(s, t, u, n), e.focus();
      }, OE = function(e) {
        var t = Gl();
        if (!t)
          throw Error("Attempting to create a context menu when widget div is null");
        t = e.render(t), Re(t, "blocklyContextMenu"), ge(t, "contextmenu", null, DE), e.focus();
      }, DE = function(e) {
        e.preventDefault(), e.stopPropagation();
      }, n_ = function() {
        Ve(mA), Mi = null;
      }, Ei = function() {
        Cu && (Cu.dispose(), Cu = null);
      }, r.callbackFactory$$module$build$src$core$contextmenu = function(e, t) {
        return () => {
          r.disable$$module$build$src$core$events$utils();
          let n;
          try {
            n = r.domToBlock$$module$build$src$core$xml(t, e.workspace);
            const s = e.getRelativeToSurfaceXY();
            s.x = e.RTL ? s.x - r.config$$module$build$src$core$config.snapRadius : s.x + r.config$$module$build$src$core$config.snapRadius, s.y += 2 * r.config$$module$build$src$core$config.snapRadius, n.moveBy(s.x, s.y);
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          nt() && !n.isShadow() && Ce(new (fe(r.CREATE$$module$build$src$core$events$utils))(n)), n.select();
        };
      }, tp = function(e) {
        return { text: r.Msg$$module$build$src$core$msg.REMOVE_COMMENT, enabled: !0, callback: function() {
          r.setGroup$$module$build$src$core$events$utils(!0), e.dispose(), r.setGroup$$module$build$src$core$events$utils(!1);
        } };
      }, rp = function(e) {
        return { text: r.Msg$$module$build$src$core$msg.DUPLICATE_COMMENT, enabled: !0, callback: function() {
          Wc(e);
        } };
      }, bE = function(e, t) {
        const n = { enabled: !0 };
        return n.text = r.Msg$$module$build$src$core$msg.ADD_COMMENT, n.callback = function() {
          const s = new $r(e, r.Msg$$module$build$src$core$msg.WORKSPACE_COMMENT_DEFAULT_TEXT, $r.DEFAULT_SIZE, $r.DEFAULT_SIZE);
          var u = e.getInjectionDiv().getBoundingClientRect();
          u = new Te(t.clientX - u.left, t.clientY - u.top);
          const A = e.getOriginOffsetInPixels();
          u = Te.difference(u, A), u.scale(1 / e.scale), s.moveBy(u.x, u.y), e.rendered && (s.initSvg(), s.render(), s.select());
        }, n;
      }, i_ = function(e) {
        let t = e.outputConnection;
        return (!t || e.previousConnection && e.previousConnection.isConnected()) && (t = e.previousConnection), t;
      }, np = function(e) {
        return e.isDynamic;
      }, Jn = function(e, t) {
        o(_e.RENDERER, e, t);
      }, PE = function(e) {
        T(_e.RENDERER, e);
      }, ip = function(e, t, n) {
        return e = new (y(_e.RENDERER, e))(e), e.init(t, n), e;
      }, bn = function() {
        pt.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.UNDO;
        }, preconditionFn(e) {
          return 0 < e.workspace.getUndoStack().length ? "enabled" : "disabled";
        }, callback(e) {
          e.workspace.undo(!1);
        }, scopeType: pt.ScopeType.WORKSPACE, id: "undoWorkspace", weight: 1 });
      }, op = function() {
        pt.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.REDO;
        }, preconditionFn(e) {
          return 0 < e.workspace.getRedoStack().length ? "enabled" : "disabled";
        }, callback(e) {
          e.workspace.undo(!0);
        }, scopeType: pt.ScopeType.WORKSPACE, id: "redoWorkspace", weight: 2 });
      }, lp = function() {
        pt.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.CLEAN_UP;
        }, preconditionFn(e) {
          return e.workspace.isMovable() ? 1 < e.workspace.getTopBlocks(!1).length ? "enabled" : "disabled" : "hidden";
        }, callback(e) {
          e.workspace.cleanUp();
        }, scopeType: pt.ScopeType.WORKSPACE, id: "cleanWorkspace", weight: 3 });
      }, sp = function(e, t) {
        function n(A) {
          u--, A.setCollapsed(e), u === 0 && r.setGroup$$module$build$src$core$events$utils(!1);
        }
        let s = 0, u = 0;
        r.setGroup$$module$build$src$core$events$utils(!0);
        for (let A = 0; A < t.length; A++) {
          let L = t[A];
          for (; L; )
            u++, setTimeout(n.bind(null, L), s), L = L.getNextBlock(), s += 10;
        }
      }, ap = function() {
        pt.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.COLLAPSE_ALL;
        }, preconditionFn(e) {
          if (e.workspace.options.collapse) {
            e = e.workspace.getTopBlocks(!1);
            for (let t = 0; t < e.length; t++) {
              let n = e[t];
              for (; n; ) {
                if (!n.isCollapsed())
                  return "enabled";
                n = n.getNextBlock();
              }
            }
            return "disabled";
          }
          return "hidden";
        }, callback(e) {
          sp(
            !0,
            e.workspace.getTopBlocks(!0)
          );
        }, scopeType: pt.ScopeType.WORKSPACE, id: "collapseWorkspace", weight: 4 });
      }, _p = function() {
        pt.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.EXPAND_ALL;
        }, preconditionFn(e) {
          if (e.workspace.options.collapse) {
            e = e.workspace.getTopBlocks(!1);
            for (let t = 0; t < e.length; t++) {
              let n = e[t];
              for (; n; ) {
                if (n.isCollapsed())
                  return "enabled";
                n = n.getNextBlock();
              }
            }
            return "disabled";
          }
          return "hidden";
        }, callback(e) {
          sp(
            !1,
            e.workspace.getTopBlocks(!0)
          );
        }, scopeType: pt.ScopeType.WORKSPACE, id: "expandWorkspace", weight: 5 });
      }, kc = function(e, t) {
        if (e.isDeletable())
          Array.prototype.push.apply(t, e.getDescendants(!1));
        else {
          e = e.getChildren(!1);
          for (let n = 0; n < e.length; n++)
            kc(e[n], t);
        }
      }, o_ = function(e) {
        const t = [];
        e = e.getTopBlocks(!0);
        for (let n = 0; n < e.length; n++)
          kc(e[n], t);
        return t;
      }, l_ = function(e, t) {
        t ? r.setGroup$$module$build$src$core$events$utils(t) : (r.setGroup$$module$build$src$core$events$utils(!0), t = r.getGroup$$module$build$src$core$events$utils());
        const n = e.shift();
        n && (n.isDeadOrDying() ? l_(e, t) : (n.dispose(!1, !0), setTimeout(l_, 10, e, t))), r.setGroup$$module$build$src$core$events$utils(!1);
      }, cp = function() {
        pt.registry.register({
          displayText(e) {
            return e.workspace ? (e = o_(e.workspace).length, e === 1 ? r.Msg$$module$build$src$core$msg.DELETE_BLOCK : r.Msg$$module$build$src$core$msg.DELETE_X_BLOCKS.replace("%1", `${e}`)) : "";
          },
          preconditionFn(e) {
            return e.workspace && 0 < o_(e.workspace).length ? "enabled" : "disabled";
          },
          callback(e) {
            if (e.workspace) {
              e.workspace.cancelCurrentGesture();
              var t = o_(e.workspace);
              2 > t.length ? l_(t) : jr(r.Msg$$module$build$src$core$msg.DELETE_ALL_BLOCKS.replace("%1", String(t.length)), function(n) {
                n && l_(t);
              });
            }
          },
          scopeType: pt.ScopeType.WORKSPACE,
          id: "workspaceDelete",
          weight: 6
        });
      }, wc = function() {
        bn(), op(), lp(), ap(), _p(), cp();
      }, Ql = function() {
        pt.registry.register({
          displayText() {
            return r.Msg$$module$build$src$core$msg.DUPLICATE_BLOCK;
          },
          preconditionFn(e) {
            return e = e.block, !e.isInFlyout && e.isDeletable() && e.isMovable() ? e.isDuplicatable() ? "enabled" : "disabled" : "hidden";
          },
          callback(e) {
            e.block && Wc(e.block);
          },
          scopeType: pt.ScopeType.BLOCK,
          id: "blockDuplicate",
          weight: 1
        });
      }, zs = function() {
        pt.registry.register({ displayText(e) {
          return e.block.hasIcon(Or.TYPE) ? r.Msg$$module$build$src$core$msg.REMOVE_COMMENT : r.Msg$$module$build$src$core$msg.ADD_COMMENT;
        }, preconditionFn(e) {
          return e = e.block, !e.isInFlyout && e.workspace.options.comments && !e.isCollapsed() && e.isEditable() ? "enabled" : "hidden";
        }, callback(e) {
          e = e.block, e.hasIcon(Or.TYPE) ? e.setCommentText(null) : e.setCommentText("");
        }, scopeType: pt.ScopeType.BLOCK, id: "blockComment", weight: 2 });
      }, up = function() {
        pt.registry.register({ displayText(e) {
          return e.block.getInputsInline() ? r.Msg$$module$build$src$core$msg.EXTERNAL_INPUTS : r.Msg$$module$build$src$core$msg.INLINE_INPUTS;
        }, preconditionFn(e) {
          if (e = e.block, !e.isInFlyout && e.isMovable() && !e.isCollapsed()) {
            for (let t = 1; t < e.inputList.length; t++)
              if (!(e.inputList[t - 1] instanceof ku || e.inputList[t] instanceof ku))
                return "enabled";
          }
          return "hidden";
        }, callback(e) {
          e.block.setInputsInline(!e.block.getInputsInline());
        }, scopeType: pt.ScopeType.BLOCK, id: "blockInline", weight: 3 });
      }, Fc = function() {
        pt.registry.register({
          displayText(e) {
            return e.block.isCollapsed() ? r.Msg$$module$build$src$core$msg.EXPAND_BLOCK : r.Msg$$module$build$src$core$msg.COLLAPSE_BLOCK;
          },
          preconditionFn(e) {
            return e = e.block, !e.isInFlyout && e.isMovable() && e.workspace.options.collapse ? "enabled" : "hidden";
          },
          callback(e) {
            e.block.setCollapsed(!e.block.isCollapsed());
          },
          scopeType: pt.ScopeType.BLOCK,
          id: "blockCollapseExpand",
          weight: 4
        });
      }, Tp = function() {
        pt.registry.register({ displayText(e) {
          return e.block.isEnabled() ? r.Msg$$module$build$src$core$msg.DISABLE_BLOCK : r.Msg$$module$build$src$core$msg.ENABLE_BLOCK;
        }, preconditionFn(e) {
          return e = e.block, !e.isInFlyout && e.workspace.options.disable && e.isEditable() ? e.getInheritedDisabled() ? "disabled" : "enabled" : "hidden";
        }, callback(e) {
          e = e.block;
          const t = r.getGroup$$module$build$src$core$events$utils();
          t || r.setGroup$$module$build$src$core$events$utils(!0), e.setEnabled(!e.isEnabled()), r.setGroup$$module$build$src$core$events$utils(t);
        }, scopeType: pt.ScopeType.BLOCK, id: "blockDisable", weight: 5 });
      }, Ai = function() {
        pt.registry.register({ displayText(e) {
          var t = e.block;
          return e = t.getDescendants(!1).length, (t = t.getNextBlock()) && (e -= t.getDescendants(!1).length), e === 1 ? r.Msg$$module$build$src$core$msg.DELETE_BLOCK : r.Msg$$module$build$src$core$msg.DELETE_X_BLOCKS.replace("%1", `${e}`);
        }, preconditionFn(e) {
          return !e.block.isInFlyout && e.block.isDeletable() ? "enabled" : "hidden";
        }, callback(e) {
          e.block && e.block.checkAndDelete();
        }, scopeType: pt.ScopeType.BLOCK, id: "blockDelete", weight: 6 });
      }, s_ = function() {
        pt.registry.register({ displayText() {
          return r.Msg$$module$build$src$core$msg.HELP;
        }, preconditionFn(e) {
          return e = e.block, (typeof e.helpUrl == "function" ? e.helpUrl() : e.helpUrl) ? "enabled" : "hidden";
        }, callback(e) {
          e.block.showHelp();
        }, scopeType: pt.ScopeType.BLOCK, id: "blockHelp", weight: 7 });
      }, rl = function() {
        Ql(), zs(), up(), Fc(), Tp(), Ai(), s_();
      }, En = function() {
        wc(), rl();
      }, nl = function(e) {
        return e.getProcedureModel !== void 0 && e.doProcedureUpdate !== void 0 && e.isProcedureDef !== void 0;
      }, a_ = function(e) {
        return e.startPublishing !== void 0 && e.stopPublishing !== void 0;
      }, __ = function(e) {
        const t = e.getProcedureMap().getProcedures().filter((s) => !s.getReturnTypes()).map((s) => [s.getName(), s.getParameters().map((u) => u.getName()), !1]);
        e.getBlocksByType("procedures_defnoreturn", !1).forEach((s) => {
          !nl(s) && V(s) && t.push(s.getProcedureDef());
        });
        const n = e.getProcedureMap().getProcedures().filter((s) => !!s.getReturnTypes()).map((s) => [s.getName(), s.getParameters().map((u) => u.getName()), !0]);
        return e.getBlocksByType("procedures_defreturn", !1).forEach((s) => {
          !nl(s) && V(s) && n.push(s.getProcedureDef());
        }), t.sort(ql), n.sort(ql), [t, n];
      }, ql = function(e, t) {
        return e[0].localeCompare(t[0], void 0, { sensitivity: "base" });
      }, r.findLegalName$$module$build$src$core$procedures = function(e, t) {
        if (t.isInFlyout)
          return e;
        for (e = e || r.Msg$$module$build$src$core$msg.UNNAMED_KEY || "unnamed"; !Io(e, t.workspace, t); ) {
          const n = e.match(/^(.*?)(\d+)$/);
          e = n ? n[1] + (parseInt(n[2]) + 1) : e + "2";
        }
        return e;
      }, Io = function(e, t, n) {
        return !Bc(e, t, n);
      }, Bc = function(e, t, n) {
        for (const s of t.getAllBlocks(!1))
          if (s !== n && V(s) && r.Names$$module$build$src$core$names.equals(s.getProcedureDef()[0], e))
            return !0;
        n = n && nl(n) ? n == null ? void 0 : n.getProcedureModel() : void 0;
        for (const s of t.getProcedureMap().getProcedures())
          if (s !== n && r.Names$$module$build$src$core$names.equals(
            s.getName(),
            e
          ))
            return !0;
        return !1;
      }, r.rename$$module$build$src$core$procedures = function(e) {
        var t = this.getSourceBlock();
        if (!t)
          throw new lr();
        e = e.trim();
        const n = r.findLegalName$$module$build$src$core$procedures(e, t);
        nl(t) && !t.isInsertionMarker() && t.getProcedureModel().setName(n);
        const s = this.getValue();
        if (s !== e && s !== n)
          for (e = t.workspace.getAllBlocks(!1), t = 0; t < e.length; t++) {
            const u = e[t];
            u.renameProcedure && u.renameProcedure(s, n);
          }
        return n;
      }, Uc = function(e) {
        function t(A, L) {
          for (let q = 0; q < A.length; q++) {
            var $ = A[q][0];
            const Le = A[q][1], _r = r.createElement$$module$build$src$core$utils$xml("block");
            _r.setAttribute("type", L), _r.setAttribute("gap", "16");
            const Bt = r.createElement$$module$build$src$core$utils$xml("mutation");
            for (Bt.setAttribute("name", $), _r.appendChild(Bt), $ = 0; $ < Le.length; $++) {
              const oi = r.createElement$$module$build$src$core$utils$xml("arg");
              oi.setAttribute("name", Le[$]), Bt.appendChild(oi);
            }
            n.push(_r);
          }
        }
        const n = [];
        if (Zr.procedures_defnoreturn) {
          var s = r.createElement$$module$build$src$core$utils$xml("block");
          s.setAttribute("type", "procedures_defnoreturn"), s.setAttribute("gap", "16");
          var u = r.createElement$$module$build$src$core$utils$xml("field");
          u.setAttribute("name", "NAME"), u.appendChild(r.createTextNode$$module$build$src$core$utils$xml(r.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_PROCEDURE)), s.appendChild(u), n.push(s);
        }
        return Zr.procedures_defreturn && (s = r.createElement$$module$build$src$core$utils$xml("block"), s.setAttribute("type", "procedures_defreturn"), s.setAttribute("gap", "16"), u = r.createElement$$module$build$src$core$utils$xml("field"), u.setAttribute("name", "NAME"), u.appendChild(r.createTextNode$$module$build$src$core$utils$xml(r.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_PROCEDURE)), s.appendChild(u), n.push(s)), Zr.procedures_ifreturn && (s = r.createElement$$module$build$src$core$utils$xml("block"), s.setAttribute("type", "procedures_ifreturn"), s.setAttribute("gap", "16"), n.push(s)), n.length && n[n.length - 1].setAttribute("gap", "24"), e = __(e), t(e[0], "procedures_callnoreturn"), t(e[1], "procedures_callreturn"), n;
      }, Js = function(e) {
        var t = [], n = e.getBlocksByType("procedures_mutatorarg", !1);
        for (let A = 0, L; L = n[A]; A++)
          t.push(L.getFieldValue("NAME"));
        n = r.createElement$$module$build$src$core$utils$xml("xml");
        const s = r.createElement$$module$build$src$core$utils$xml("block");
        s.setAttribute("type", "procedures_mutatorarg");
        const u = r.createElement$$module$build$src$core$utils$xml("field");
        u.setAttribute("name", "NAME"), t = po(
          r.DEFAULT_ARG$$module$build$src$core$procedures,
          t
        ), t = r.createTextNode$$module$build$src$core$utils$xml(t), u.appendChild(t), s.appendChild(u), n.appendChild(s), e.updateToolbox(n);
      }, pp = function(e) {
        if (e.type === Si && e.bubbleType === "mutator" && e.isOpen && e.blockId) {
          e = le(e.workspaceId).getBlockById(e.blockId);
          var t = e.type;
          (t === "procedures_defnoreturn" || t === "procedures_defreturn") && (e = e.getIcon(r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE).getWorkspace(), Js(e), e.addChangeListener(dp));
        }
      }, dp = function(e) {
        (e.type === r.CREATE$$module$build$src$core$events$utils || e.type === r.DELETE$$module$build$src$core$events$utils || e.type === r.CHANGE$$module$build$src$core$events$utils || e.type === No) && (e = le(e.workspaceId), Js(e));
      }, Mr = function(e, t) {
        return t.getAllBlocks(!1).filter((n) => Vc(n, e) || oe(n) && r.Names$$module$build$src$core$names.equals(n.getProcedureCall(), e));
      }, Vc = function(e, t) {
        return nl(e) && !e.isProcedureDef() && e.getProcedureModel() && r.Names$$module$build$src$core$names.equals(e.getProcedureModel().getName(), t);
      }, r.mutateCallers$$module$build$src$core$procedures = function(e) {
        const t = Dr();
        var n = e.getProcedureDef()[0];
        const s = e.mutationToDom(!0);
        e = Mr(n, e.workspace);
        for (let A = 0, L; L = e[A]; A++) {
          n = (n = L.mutationToDom()) && Xr(n), L.domToMutation && L.domToMutation(s);
          var u = L.mutationToDom();
          u = u && Xr(u), n !== u && (Er(!1), Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(L, "mutation", null, n, u)), Er(t));
        }
      }, r.getDefinition$$module$build$src$core$procedures = function(e, t) {
        for (const n of t.getAllBlocks(!1))
          if (nl(n) && n.isProcedureDef() && r.Names$$module$build$src$core$names.equals(n.getProcedureModel().getName(), e) || V(n) && r.Names$$module$build$src$core$names.equals(n.getProcedureDef()[0], e))
            return n;
        return null;
      }, Gc = function(e) {
        ki(e.getTargetWorkspace(), void 0, "String");
      }, Zn = function(e) {
        ki(e.getTargetWorkspace(), void 0, "Number");
      }, c_ = function(e) {
        ki(e.getTargetWorkspace(), void 0, "Colour");
      }, es = function(e) {
        let t = [], n = document.createElement("button");
        return n.setAttribute("text", r.Msg$$module$build$src$core$msg.NEW_STRING_VARIABLE), n.setAttribute("callbackKey", "CREATE_VARIABLE_STRING"), t.push(n), n = document.createElement("button"), n.setAttribute("text", r.Msg$$module$build$src$core$msg.NEW_NUMBER_VARIABLE), n.setAttribute("callbackKey", "CREATE_VARIABLE_NUMBER"), t.push(n), n = document.createElement("button"), n.setAttribute("text", r.Msg$$module$build$src$core$msg.NEW_COLOUR_VARIABLE), n.setAttribute("callbackKey", "CREATE_VARIABLE_COLOUR"), t.push(n), e.registerButtonCallback("CREATE_VARIABLE_STRING", Gc), e.registerButtonCallback("CREATE_VARIABLE_NUMBER", Zn), e.registerButtonCallback("CREATE_VARIABLE_COLOUR", c_), e = Mo(e), t = t.concat(e);
      }, Mo = function(e) {
        e = e.getAllVariables();
        const t = [];
        if (0 < e.length) {
          if (Zr.variables_set_dynamic) {
            var n = e[e.length - 1];
            const s = r.createElement$$module$build$src$core$utils$xml("block");
            s.setAttribute("type", "variables_set_dynamic"), s.setAttribute("gap", "24"), s.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(n)), t.push(s);
          }
          if (Zr.variables_get_dynamic) {
            e.sort(ra.compareByName);
            for (let s = 0, u; u = e[s]; s++)
              n = r.createElement$$module$build$src$core$utils$xml("block"), n.setAttribute("type", "variables_get_dynamic"), n.setAttribute("gap", "8"), n.appendChild(r.generateVariableFieldDom$$module$build$src$core$variables(u)), t.push(n);
          }
        }
        return t;
      }, u_ = function(e, t, n, s, u, A) {
        const L = A.scrollbar && A.scrollbar.canScrollVertically();
        return e.horizontal === fa.LEFT ? (n = u.absoluteMetrics.left + n, L && A.RTL && (n += Zt.scrollbarThickness)) : (n = u.absoluteMetrics.left + u.viewMetrics.width - t.width - n, L && !A.RTL && (n -= Zt.scrollbarThickness)), e.vertical === fi.TOP ? e = u.absoluteMetrics.top + s : (e = u.absoluteMetrics.top + u.viewMetrics.height - t.height - s, A.scrollbar && A.scrollbar.canScrollHorizontally() && (e -= Zt.scrollbarThickness)), new yt(e, e + t.height, n, n + t.width);
      }, Cr = function(e, t) {
        return { horizontal: t.toolboxMetrics.position === Ge.LEFT || e.horizontalLayout && !e.RTL ? fa.RIGHT : fa.LEFT, vertical: t.toolboxMetrics.position === Ge.BOTTOM ? fi.TOP : fi.BOTTOM };
      }, Zs = function(e, t, n, s) {
        const u = e.left, A = e.right - e.left, L = e.bottom - e.top;
        for (let $ = 0; $ < s.length; $++) {
          const q = s[$];
          e.intersects(q) && (e = n === Nl.UP ? q.top - L - t : q.bottom + t, e = new yt(e, e + L, u, u + A), $ = -1);
        }
        return e;
      }, $E = function(e, t) {
        var n = null;
        n = typeof e == "string" ? document.getElementById(e) || document.querySelector(e) : e;
        let s;
        if (!document.contains(n) && document !== ((s = n) == null ? void 0 : s.ownerDocument))
          throw Error("Error: container is not in current document");
        e = new ti(t || {}), t = document.createElement("div"), t.className = "injectionDiv", t.tabIndex = 0, gt(t, Dt.LABEL, r.Msg$$module$build$src$core$msg.WORKSPACE_ARIA_LABEL), n.appendChild(t), n = WE(t, e);
        const u = kE(n, e);
        return xc(u), Ne(u), Ze(u), t.addEventListener("focusin", function() {
          Ne(u);
        }), u;
      }, WE = function(e, t) {
        e.setAttribute("dir", "LTR"), dT(t.hasCss, t.pathToMedia), e = K(G.SVG, { xmlns: A_, "xmlns:html": fo, "xmlns:xlink": kn, version: "1.1", class: "blocklySvg", tabindex: "0" }, e);
        const n = K(
          G.DEFS,
          {},
          e
        ), s = String(Math.random()).substring(2);
        return t.gridPattern = Cd.createDom(s, t.gridOptions, n), e;
      }, kE = function(e, t) {
        t.parentWorkspace = null, t = new Ci(t);
        const n = t.options;
        t.scale = n.zoomOptions.startScale, e.appendChild(t.createDom("blocklyMainBackground"));
        var s = t.getInjectionDiv(), u = t.getRenderer().getClassName();
        return u && Re(s, u), (u = t.getTheme().getClassName()) && Re(s, u), !n.hasCategories && n.languageTree && (s = t.addFlyout(G.SVG), mr(s, e)), n.hasTrashcan && t.addTrashcan(), n.zoomOptions && n.zoomOptions.controls && t.addZoomControls(), t.getThemeManager().subscribe(e, "workspaceBackgroundColour", "background-color"), t.translate(0, 0), t.addChangeListener(JT(t)), Ze(t), x(), Va(), UT(), t;
      }, xc = function(e) {
        const t = e.options;
        var n = e.getParentSvg();
        if (ge(n.parentNode, "contextmenu", null, function(s) {
          ba(s) || s.preventDefault();
        }), n = ge(window, "resize", null, function() {
          So(), e.hideComponents(!0), wT(), un(), Ze(e), qo(e);
        }), e.setResizeHandlerWrapper(n), Qs(), t.languageTree) {
          n = e.getToolbox();
          const s = e.getFlyout(!0);
          n ? n.init() : s && (s.init(e), s.show(t.languageTree), typeof s.scrollToStart == "function" && s.scrollToStart());
        }
        t.hasTrashcan && e.trashcan.init(), t.zoomOptions && t.zoomOptions.controls && e.zoomControls_.init(), t.moveOptions && t.moveOptions.scrollbars ? (e.scrollbar = new fd(e, t.moveOptions.scrollbars === !0 || !!t.moveOptions.scrollbars.horizontal, t.moveOptions.scrollbars === !0 || !!t.moveOptions.scrollbars.vertical, "blocklyMainWorkspaceScrollbar"), e.scrollbar.resize()) : e.setMetrics({ x: 0.5, y: 0.5 }), t.hasSounds && Ep(t.pathToMedia, e);
      }, wE = function(e) {
        const t = ae();
        t && !(ba(e) || t.rendered && !t.isVisible()) && At.registry.onKeyDown(t, e);
      }, Qs = function() {
        BA || (ge(document, "scroll", null, function() {
          const e = ue();
          for (let t = 0, n; n = e[t]; t++)
            n instanceof Ci && n.updateInverseScreenCTM();
        }), ge(document, "keydown", null, wE), Ir(
          document,
          "touchend",
          null,
          ee
        ), Ir(document, "touchcancel", null, ee), la && ge(window, "orientationchange", document, function() {
          Ze(ae());
        })), BA = !0;
      }, Ep = function(e, t) {
        function n() {
          for (; u.length; ) {
            const A = u.pop();
            A && Mt(A);
          }
          s.preload();
        }
        const s = t.getAudioManager();
        s.load([e + "click.mp3", e + "click.wav", e + "click.ogg"], "click"), s.load([e + "disconnect.wav", e + "disconnect.mp3", e + "disconnect.ogg"], "disconnect"), s.load([e + "delete.mp3", e + "delete.ogg", e + "delete.wav"], "delete");
        const u = [];
        u.push(ge(document, "pointermove", null, n, !0)), u.push(ge(document, "touchstart", null, n, !0));
      }, FE = function(e) {
        return e.getType !== void 0 && e.initView !== void 0 && e.dispose !== void 0 && e.getWeight !== void 0 && e.getSize !== void 0 && e.applyColour !== void 0 && e.hideForInsertionMarker !== void 0 && e.updateEditable !== void 0 && e.updateCollapsed !== void 0 && e.isShownWhenCollapsed !== void 0 && e.setOffsetInBlock !== void 0 && e.onLocationChange !== void 0 && e.onClick !== void 0;
      }, Ap = function(e) {
        const t = { id: e.getId(), name: e.getName(), returnTypes: e.getReturnTypes() };
        return e.getParameters().length && (t.parameters = e.getParameters().map((n) => ts(n))), t;
      }, ts = function(e) {
        const t = { id: e.getId(), name: e.getName() };
        return e.getTypes().length && (t.types = e.getTypes()), t;
      }, Sp = function(e, t, n, s) {
        if (e = new e(s, n.name, n.id).setReturnTypes(n.returnTypes), !n.parameters)
          return e;
        for (const [u, A] of n.parameters.entries())
          e.insertParameter(hp(t, A, s), u);
        return e;
      }, hp = function(e, t, n) {
        return e = new e(n, t.name, t.id), t.types && e.setTypes(t.types), e;
      }, Hc = function(e) {
        const t = /* @__PURE__ */ Object.create(null), n = U(_e.SERIALIZER, !0);
        for (const s in n) {
          let u;
          const A = (u = n[s]) == null ? void 0 : u.save(e);
          A && (t[s] = A);
        }
        return t;
      }, mp = function(e, t, { recordUndo: n = !1 } = {}) {
        var s = U(_e.SERIALIZER, !0);
        if (s) {
          s = Object.entries(s).sort((A, L) => L[1].priority - A[1].priority);
          var u = Dr();
          Er(n), (n = r.getGroup$$module$build$src$core$events$utils()) || r.setGroup$$module$build$src$core$events$utils(!0), Ur(), t instanceof Ci && t.setResizesEnabled(!1);
          for (const [, A] of s.reverse()) {
            let L;
            (L = A) == null || L.clear(t);
          }
          for (let [A, L] of s.reverse())
            if (e[A]) {
              let $;
              ($ = L) == null || $.load(e[A], t);
            }
          t instanceof Ci && t.setResizesEnabled(!0), tr(), Ce(new (fe(is))(t)), r.setGroup$$module$build$src$core$events$utils(n), Er(u);
        }
      }, Ip = function() {
        At.registry.register({ name: eo.ESCAPE, preconditionFn(e) {
          return !e.options.readOnly;
        }, callback(e) {
          return e.hideChaff(), !0;
        }, keyCodes: [Qe.ESC] });
      }, Mp = function() {
        At.registry.register({ name: eo.DELETE, preconditionFn(e) {
          const t = Fe();
          return !e.options.readOnly && t != null && t.isDeletable();
        }, callback(e, t) {
          return t.preventDefault(), ko.inProgress() ? !1 : (Fe().checkAndDelete(), !0);
        }, keyCodes: [
          Qe.DELETE,
          Qe.BACKSPACE
        ] });
      }, gp = function() {
        const e = At.registry.createSerializedKey(Qe.C, [Qe.CTRL]), t = At.registry.createSerializedKey(Qe.C, [Qe.ALT]), n = At.registry.createSerializedKey(
          Qe.C,
          [Qe.META]
        );
        At.registry.register({ name: eo.COPY, preconditionFn(s) {
          const u = Fe();
          return !s.options.readOnly && !ko.inProgress() && u != null && u.isDeletable() && u.isMovable();
        }, callback(s, u) {
          return u.preventDefault(), s.hideChaff(), r_(Fe()), !0;
        }, keyCodes: [e, t, n] });
      }, Yc = function() {
        const e = At.registry.createSerializedKey(Qe.X, [Qe.CTRL]), t = At.registry.createSerializedKey(Qe.X, [Qe.ALT]), n = At.registry.createSerializedKey(Qe.X, [Qe.META]);
        At.registry.register({ name: eo.CUT, preconditionFn(s) {
          const u = Fe();
          return !s.options.readOnly && !ko.inProgress() && u != null && u instanceof Fn && u.isDeletable() && u.isMovable() && !u.workspace.isFlyout;
        }, callback() {
          const s = Fe();
          return s ? (r_(s), s.checkAndDelete(), !0) : !1;
        }, keyCodes: [e, t, n] });
      }, T_ = function() {
        const e = At.registry.createSerializedKey(Qe.V, [Qe.CTRL]), t = At.registry.createSerializedKey(Qe.V, [Qe.ALT]), n = At.registry.createSerializedKey(
          Qe.V,
          [Qe.META]
        );
        At.registry.register({ name: eo.PASTE, preconditionFn(s) {
          return !s.options.readOnly && !ko.inProgress();
        }, callback() {
          return !!qT();
        }, keyCodes: [e, t, n] });
      }, Lp = function() {
        const e = At.registry.createSerializedKey(Qe.Z, [Qe.CTRL]), t = At.registry.createSerializedKey(Qe.Z, [Qe.ALT]), n = At.registry.createSerializedKey(
          Qe.Z,
          [Qe.META]
        );
        At.registry.register({ name: eo.UNDO, preconditionFn(s) {
          return !s.options.readOnly && !ko.inProgress();
        }, callback(s) {
          return s.hideChaff(), s.undo(!1), !0;
        }, keyCodes: [e, t, n] });
      }, p_ = function() {
        const e = At.registry.createSerializedKey(Qe.Z, [Qe.SHIFT, Qe.CTRL]), t = At.registry.createSerializedKey(Qe.Z, [
          Qe.SHIFT,
          Qe.ALT
        ]), n = At.registry.createSerializedKey(Qe.Z, [Qe.SHIFT, Qe.META]), s = At.registry.createSerializedKey(Qe.Y, [Qe.CTRL]);
        At.registry.register({
          name: eo.REDO,
          preconditionFn(u) {
            return !ko.inProgress() && !u.options.readOnly;
          },
          callback(u) {
            return u.hideChaff(), u.undo(!0), !0;
          },
          keyCodes: [e, t, n, s]
        });
      }, Xc = function() {
        Ip(), Mp(), gp(), Yc(), T_(), Lp(), p_();
      }, Np = function(e) {
        return e.isSelectable();
      }, yp = function(e) {
        ae().hideChaff(e);
      }, Oe = Oe || {}, Oe.scope = {}, Oe.ASSUME_ES5 = !1, Oe.ASSUME_NO_NATIVE_MAP = !1, Oe.ASSUME_NO_NATIVE_SET = !1, Oe.SIMPLE_FROUND_POLYFILL = !1, Oe.ISOLATE_POLYFILLS = !1, Oe.FORCE_POLYFILL_PROMISE = !1, Oe.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1, Oe.defineProperty = Oe.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, t, n) {
        return e == Array.prototype || e == Object.prototype || (e[t] = n.value), e;
      }, Oe.getGlobal = function(e) {
        e = [typeof globalThis == "object" && globalThis, e, typeof window == "object" && window, typeof self == "object" && self, typeof ln == "object" && ln];
        for (var t = 0; t < e.length; ++t) {
          var n = e[t];
          if (n && n.Math == Math)
            return n;
        }
        throw Error("Cannot find global object");
      }, Oe.global = Oe.getGlobal(this), Oe.IS_SYMBOL_NATIVE = typeof Symbol == "function" && typeof Symbol("x") == "symbol", Oe.TRUST_ES6_POLYFILLS = !Oe.ISOLATE_POLYFILLS || Oe.IS_SYMBOL_NATIVE, Oe.polyfills = {}, Oe.propertyToPolyfillSymbol = {}, Oe.POLYFILL_PREFIX = "$jscp$", Oe.polyfill = function(e, t, n, s) {
        t && (Oe.ISOLATE_POLYFILLS ? Oe.polyfillIsolated(e, t, n, s) : Oe.polyfillUnisolated(e, t, n, s));
      }, Oe.polyfillUnisolated = function(e, t, n, s) {
        for (n = Oe.global, e = e.split("."), s = 0; s < e.length - 1; s++) {
          var u = e[s];
          if (!(u in n))
            return;
          n = n[u];
        }
        e = e[e.length - 1], s = n[e], t = t(s), t != s && t != null && Oe.defineProperty(n, e, { configurable: !0, writable: !0, value: t });
      }, Oe.polyfillIsolated = function(e, t, n, s) {
        var u = e.split(".");
        e = u.length === 1, s = u[0], s = !e && s in Oe.polyfills ? Oe.polyfills : Oe.global;
        for (var A = 0; A < u.length - 1; A++) {
          var L = u[A];
          if (!(L in s))
            return;
          s = s[L];
        }
        u = u[u.length - 1], n = Oe.IS_SYMBOL_NATIVE && n === "es6" ? s[u] : null, t = t(n), t != null && (e ? Oe.defineProperty(Oe.polyfills, u, { configurable: !0, writable: !0, value: t }) : t !== n && (Oe.propertyToPolyfillSymbol[u] === void 0 && (n = 1e9 * Math.random() >>> 0, Oe.propertyToPolyfillSymbol[u] = Oe.IS_SYMBOL_NATIVE ? Oe.global.Symbol(u) : Oe.POLYFILL_PREFIX + n + "$" + u), Oe.defineProperty(s, Oe.propertyToPolyfillSymbol[u], { configurable: !0, writable: !0, value: t })));
      }, Oe.polyfill("globalThis", function(e) {
        return e || Oe.global;
      }, "es_2020", "es3"), Oe.arrayIteratorImpl = function(e) {
        var t = 0;
        return function() {
          return t < e.length ? { done: !1, value: e[t++] } : { done: !0 };
        };
      }, Oe.arrayIterator = function(e) {
        return { next: Oe.arrayIteratorImpl(e) };
      }, Oe.initSymbol = function() {
      }, Oe.iteratorPrototype = function(e) {
        return e = { next: e }, e[Symbol.iterator] = function() {
          return this;
        }, e;
      }, Oe.iteratorFromArray = function(e, t) {
        e instanceof String && (e += "");
        var n = 0, s = !1, u = { next: function() {
          if (!s && n < e.length) {
            var A = n++;
            return { value: t(A, e[A]), done: !1 };
          }
          return s = !0, { done: !0, value: void 0 };
        } };
        return u[Symbol.iterator] = function() {
          return u;
        }, u;
      }, Oe.polyfill("Array.prototype.values", function(e) {
        return e || function() {
          return Oe.iteratorFromArray(this, function(t, n) {
            return n;
          });
        };
      }, "es8", "es3"), Oe.polyfill("Array.prototype.flat", function(e) {
        return e || function(t) {
          t = t === void 0 ? 1 : t;
          var n = [];
          return Array.prototype.forEach.call(this, function(s) {
            Array.isArray(s) && 0 < t ? (s = Array.prototype.flat.call(s, t - 1), n.push.apply(n, s)) : n.push(s);
          }), n;
        };
      }, "es9", "es5"), Oe.owns = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, Oe.polyfill("Object.entries", function(e) {
        return e || function(t) {
          var n = [], s;
          for (s in t)
            Oe.owns(t, s) && n.push([s, t[s]]);
          return n;
        };
      }, "es8", "es3"), Oe.polyfill("Object.values", function(e) {
        return e || function(t) {
          var n = [], s;
          for (s in t)
            Oe.owns(t, s) && n.push(t[s]);
          return n;
        };
      }, "es8", "es3");
      var An = An || {};
      An.global = globalThis || root, An.define = function(e, t) {
        return t;
      }, An.DEBUG = !1, An.DISALLOW_TEST_ONLY_CODE = !An.DEBUG, An.provide = function(e) {
      }, An.module = function(e) {
      }, An.module.get = function(e) {
      }, An.module.declareLegacyNamespace = function() {
      }, An.setTestOnly = function(e) {
        if (An.DISALLOW_TEST_ONLY_CODE)
          throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
      }, An.require = function(e) {
      }, An.requireType = function(e) {
      };
      var go = /* @__PURE__ */ Object.create(null), BE = { typeMap: go }, Kc = /* @__PURE__ */ Object.create(null), Vi = "default", _e = class {
        constructor(e) {
          this.name = e;
        }
        toString() {
          return this.name;
        }
      };
      _e.CONNECTION_CHECKER = new _e("connectionChecker"), _e.CURSOR = new _e("cursor"), _e.EVENT = new _e("event"), _e.FIELD = new _e("field"), _e.INPUT = new _e("input"), _e.RENDERER = new _e("renderer"), _e.TOOLBOX = new _e("toolbox"), _e.THEME = new _e("theme"), _e.TOOLBOX_ITEM = new _e("toolboxItem"), _e.FLYOUTS_VERTICAL_TOOLBOX = new _e("flyoutsVerticalToolbox"), _e.FLYOUTS_HORIZONTAL_TOOLBOX = new _e("flyoutsHorizontalToolbox"), _e.METRICS_MANAGER = new _e("metricsManager"), _e.BLOCK_DRAGGER = new _e("blockDragger"), _e.SERIALIZER = new _e("serializer"), _e.ICON = new _e("icon");
      var Pn = {};
      Pn.DEFAULT = Vi, Pn.TEST_ONLY = BE, Pn.Type = _e, Pn.getAllItems = U, Pn.getClass = y, Pn.getClassFromOptions = Z, Pn.getObject = b, Pn.hasItem = h, Pn.register = o, Pn.unregister = T;
      var Zr = /* @__PURE__ */ Object.create(null), rs = /* @__PURE__ */ Object.create(null), UE, jc = null, rt, qs = [], VE = { defineBlocksWithJsonArrayInternal: Dl }, nr = {};
      nr.TEST_ONLY = VE, nr.createBlockDefinitionsFromJsonArray = r.createBlockDefinitionsFromJsonArray$$module$build$src$core$common, nr.defineBlocks = r.defineBlocks$$module$build$src$core$common, nr.defineBlocksWithJsonArray = xn, nr.draggingConnections = qs, nr.getAllWorkspaces = ue, nr.getBlockTypeCounts = Pt, nr.getMainWorkspace = ae, nr.getParentContainer = dr, nr.getSelected = Fe, nr.getWorkspaceById = le, nr.registerWorkspace = be, nr.setMainWorkspace = Ne, nr.setParentContainer = er, nr.setSelected = at, nr.svgResize = Ze, nr.unregisterWorkpace = Ke;
      var fp = "!#$%()*+,-./:;=?@[]^_`{|}~ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", GE = { genUid: () => {
        const e = fp.length, t = [];
        for (let n = 0; 20 > n; n++)
          t[n] = fp.charAt(Math.random() * e);
        return t.join("");
      } }, $S = 0, Qr = {};
      Qr.TEST_ONLY = GE, Qr.genUid = Yr, Qr.getNextUniqueId = si;
      var Cp, Lo, ea, No, yo, gr, $n, ta, il, Qn, Gi, ol, Si, ll, sl, Wn, al, qr, _l, ns, qn, is, zc, os, d_, Ye;
      Cp = "", Lo = !0, ea = 0, r.CREATE$$module$build$src$core$events$utils = "create", r.CREATE$$module$build$src$core$events$utils, r.DELETE$$module$build$src$core$events$utils = "delete", r.DELETE$$module$build$src$core$events$utils, r.CHANGE$$module$build$src$core$events$utils = "change", r.CHANGE$$module$build$src$core$events$utils, No = "block_field_intermediate_change", r.MOVE$$module$build$src$core$events$utils = "move", r.MOVE$$module$build$src$core$events$utils, yo = "var_create", gr = "var_delete", $n = "var_rename", ta = "ui", il = "drag", Qn = "selected", Gi = "click", ol = "marker_move", Si = "bubble_open", ll = "trashcan_open", sl = "toolbox_item_select", Wn = "theme_change", al = "viewport_change", qr = "comment_create", _l = "comment_delete", ns = "comment_change", qn = "comment_move", is = "finished_loading", zc = [r.CREATE$$module$build$src$core$events$utils, r.MOVE$$module$build$src$core$events$utils, qr, qn], os = [], d_ = { FIRE_QUEUE: os, fireNow: an, fireInternal: Ps, setGroupInternal: Fr }, Ye = {}, Ye.BLOCK_CHANGE = r.CHANGE$$module$build$src$core$events$utils, Ye.BLOCK_CREATE = r.CREATE$$module$build$src$core$events$utils, Ye.BLOCK_DELETE = r.DELETE$$module$build$src$core$events$utils, Ye.BLOCK_DRAG = il, Ye.BLOCK_FIELD_INTERMEDIATE_CHANGE = No, Ye.BLOCK_MOVE = r.MOVE$$module$build$src$core$events$utils, Ye.BUBBLE_OPEN = Si, Ye.BUMP_EVENTS = zc, Ye.CHANGE = r.CHANGE$$module$build$src$core$events$utils, Ye.CLICK = Gi, Ye.COMMENT_CHANGE = ns, Ye.COMMENT_CREATE = qr, Ye.COMMENT_DELETE = _l, Ye.COMMENT_MOVE = qn, Ye.CREATE = r.CREATE$$module$build$src$core$events$utils, Ye.DELETE = r.DELETE$$module$build$src$core$events$utils, Ye.FINISHED_LOADING = is, Ye.MARKER_MOVE = ol, Ye.MOVE = r.MOVE$$module$build$src$core$events$utils, Ye.SELECTED = Qn, Ye.TEST_ONLY = d_, Ye.THEME_CHANGE = Wn, Ye.TOOLBOX_ITEM_SELECT = sl, Ye.TRASHCAN_OPEN = ll, Ye.UI = ta, Ye.VAR_CREATE = yo, Ye.VAR_DELETE = gr, Ye.VAR_RENAME = $n, Ye.VIEWPORT_CHANGE = al, Ye.clearPendingUndo = ao, Ye.disable = r.disable$$module$build$src$core$events$utils, Ye.disableOrphans = Hn, Ye.enable = r.enable$$module$build$src$core$events$utils, Ye.filter = Sr, Ye.fire = Ce, Ye.fromJson = bl, Ye.get = fe, Ye.getDescendantIds = _o, Ye.getGroup = r.getGroup$$module$build$src$core$events$utils, Ye.getRecordUndo = Dr, Ye.isEnabled = nt, Ye.setGroup = r.setGroup$$module$build$src$core$events$utils, Ye.setRecordUndo = Er, function(e) {
        e[e.VALUE = 1] = "VALUE", e[e.STATEMENT = 3] = "STATEMENT", e[e.DUMMY = 5] = "DUMMY", e[e.CUSTOM = 6] = "CUSTOM";
      }(r.inputTypes$$module$build$src$core$inputs$input_types || (r.inputTypes$$module$build$src$core$inputs$input_types = {})), r.inputTypes$$module$build$src$core$inputs$input_types;
      var Jc = { parseFromString: function() {
        throw Error("DOMParser was not found in the global scope and was not properly injected using injectDependencies");
      } }, Zc = { serializeToString: function() {
        throw Error("XMLSerializer was not foundin the global scope and was not properly injected using injectDependencies");
      } }, { document: E_, DOMParser: vr, XMLSerializer: Sn } = globalThis;
      vr && (Jc = new vr()), Sn && (Zc = new Sn());
      var xE = "https://developers.google.com/blockly/xml", WS = /[\x00-\x09\x0B\x0C\x0E-\x1F]/g, xi = {};
      xi.NAME_SPACE = xE, xi.createElement = r.createElement$$module$build$src$core$utils$xml, xi.createTextNode = r.createTextNode$$module$build$src$core$utils$xml, xi.domToText = Xr, xi.injectDependencies = Br, xi.textToDom = r.textToDom$$module$build$src$core$utils$xml;
      var Lr = class {
        constructor(e) {
          this.name = e;
        }
        toString() {
          return this.name;
        }
        equals(e) {
          return this.name === e.toString();
        }
      };
      Lr.MUTATOR = new Lr("mutator"), Lr.WARNING = new Lr("warning"), Lr.COMMENT = new Lr("comment");
      var ls = {};
      ls.warn = hr;
      var A_ = "http://www.w3.org/2000/svg", fo = "http://www.w3.org/1999/xhtml", kn = "http://www.w3.org/1999/xlink", hn;
      (function(e) {
        e[e.ELEMENT_NODE = 1] = "ELEMENT_NODE", e[e.TEXT_NODE = 3] = "TEXT_NODE", e[e.COMMENT_NODE = 8] = "COMMENT_NODE";
      })(hn || (hn = {}));
      var en = null, vp = 0, S_ = null, ur = {};
      ur.HTML_NS = fo, ur.NodeType = hn, ur.SVG_NS = A_, ur.XLINK_NS = kn, ur.addClass = Re, ur.containsNode = xo, ur.createSvgElement = K, ur.getFastTextWidth = Kr, ur.getFastTextWidthWithSizeString = _i, ur.getTextWidth = Pi, ur.hasClass = Di, ur.insertAfter = mr, ur.measureFontMetrics = Xn, ur.removeClass = Ue, ur.removeClasses = co, ur.removeNode = _t, ur.setCssTransform = bi, ur.startTextWidthCache = Ur, ur.stopTextWidthCache = tr;
      var It = class {
        constructor(e, t) {
          this.width = e, this.height = t;
        }
        static equals(e, t) {
          return e === t ? !0 : e && t ? e.width === t.width && e.height === t.height : !1;
        }
      }, Rp = function(e, t) {
        window.alert(e), t && t();
      }, h_ = function(e, t) {
        t(window.confirm(e));
      }, Qc = function(e, t, n) {
        n(window.prompt(e, t));
      }, m_ = { confirmInternal: To }, cl = {};
      cl.TEST_ONLY = m_, cl.alert = uo, cl.confirm = jr, cl.prompt = m, cl.setAlert = $i, cl.setConfirm = k, cl.setPrompt = D;
      var qc, ss;
      r.Msg$$module$build$src$core$msg = /* @__PURE__ */ Object.create(null), qc = function(e) {
        Object.keys(e).forEach(function(t) {
          r.Msg$$module$build$src$core$msg[t] = e[t];
        });
      }, ss = {}, ss.Msg = r.Msg$$module$build$src$core$msg, ss.setLocale = qc;
      var as = class {
        constructor() {
          this.workspaceId = void 0, this.isUiEvent = !1, this.type = "", this.group = r.getGroup$$module$build$src$core$events$utils(), this.recordUndo = Dr();
        }
        toJson() {
          return { type: this.type, group: this.group };
        }
        static fromJson(e, t, n) {
          return n.isBlank = !1, n.group = e.group || "", n.workspaceId = t.id, n;
        }
        isNull() {
          return !1;
        }
        run(e) {
        }
        getEventWorkspace_() {
          let e;
          if (this.workspaceId && (e = le(this.workspaceId)), !e)
            throw Error("Workspace is null. Event must have been generated from real Blockly events.");
          return e;
        }
      }, _s = class extends as {
        constructor(e) {
          super(), this.isBlank = typeof e > "u", e && (this.varId = e.getId(), this.workspaceId = e.workspace.id);
        }
        toJson() {
          const e = super.toJson();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          return e.varId = this.varId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new _s()), t.varId = e.varId, t;
        }
      }, Op = class extends _s {
        constructor(e) {
          super(e), this.type = yo, e && (this.varType = e.type, this.varName = e.name);
        }
        toJson() {
          const e = super.toJson();
          if (this.varType === void 0)
            throw Error("The var type is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          return e.varType = this.varType, e.varName = this.varName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Op()), t.varType = e.varType, t.varName = e.varName, t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          e ? t.createVariable(
            this.varName,
            this.varType,
            this.varId
          ) : t.deleteVariableById(this.varId);
        }
      };
      o(_e.EVENT, yo, Op);
      var ra = class {
        constructor(e, t, n, s) {
          this.workspace = e, this.name = t, this.type = n || "", this.id_ = s || Yr();
        }
        getId() {
          return this.id_;
        }
        static compareByName(e, t) {
          return e.name.localeCompare(t.name, void 0, { sensitivity: "base" });
        }
      }, hi = "VARIABLE", eu = "ijkmnopqrstuvwxyzabcdefgh", Dp = { generateUniqueNameInternal: rc }, Ar = {};
      Ar.CATEGORY_NAME = hi, Ar.TEST_ONLY = Dp, Ar.VAR_LETTER_OPTIONS = eu, Ar.allDeveloperVariables = r.allDeveloperVariables$$module$build$src$core$variables, Ar.allUsedVarModels = r.allUsedVarModels$$module$build$src$core$variables, Ar.createVariableButtonHandler = ki, Ar.flyoutCategory = ke, Ar.flyoutCategoryBlocks = $t, Ar.generateUniqueName = Wi, Ar.generateUniqueNameFromOptions = po, Ar.generateVariableFieldDom = r.generateVariableFieldDom$$module$build$src$core$variables, Ar.getAddedVariables = W, Ar.getOrCreateVariablePackage = r.getOrCreateVariablePackage$$module$build$src$core$variables, Ar.getVariable = r.getVariable$$module$build$src$core$variables, Ar.nameUsedWithAnyType = Pl, Ar.nameUsedWithConflictingParam = Ws, Ar.promptName = Xt, Ar.renameVariable = r.renameVariable$$module$build$src$core$variables;
      var Te = class {
        constructor(e, t) {
          this.x = e, this.y = t;
        }
        clone() {
          return new Te(this.x, this.y);
        }
        scale(e) {
          return this.x *= e, this.y *= e, this;
        }
        translate(e, t) {
          return this.x += e, this.y += t, this;
        }
        static equals(e, t) {
          return e === t ? !0 : e && t ? e.x === t.x && e.y === t.y : !1;
        }
        static distance(e, t) {
          const n = e.x - t.x;
          return e = e.y - t.y, Math.sqrt(n * n + e * e);
        }
        static magnitude(e) {
          return Math.sqrt(e.x * e.x + e.y * e.y);
        }
        static difference(e, t) {
          return new Te(e.x - t.x, e.y - t.y);
        }
        static sum(e, t) {
          return new Te(e.x + t.x, e.y + t.y);
        }
      }, Hi = class {
        constructor(e, t, n, s, u) {
          this.workspace = e, this.editable = this.movable = this.deletable = !0, this.disposed_ = !1, this.isComment = !0, this.id = u && !e.getCommentById(u) ? u : Yr(), e.addTopComment(this), this.xy_ = new Te(0, 0), this.height_ = n, this.width_ = s, this.RTL = e.RTL, this.content_ = t, Hi.fireCreateEvent(this);
        }
        dispose() {
          this.disposed_ || (nt() && Ce(new (fe(_l))(this)), this.workspace.removeTopComment(this), this.disposed_ = !0);
        }
        getHeight() {
          return this.height_;
        }
        setHeight(e) {
          this.height_ = e;
        }
        getWidth() {
          return this.width_;
        }
        setWidth(e) {
          this.width_ = e;
        }
        getRelativeToSurfaceXY() {
          return new Te(this.xy_.x, this.xy_.y);
        }
        moveBy(e, t) {
          const n = new (fe(qn))(this);
          this.xy_.translate(e, t), n.recordNew(), Ce(n);
        }
        isDeletable() {
          return this.deletable && !(this.workspace && this.workspace.options.readOnly);
        }
        setDeletable(e) {
          this.deletable = e;
        }
        isMovable() {
          return this.movable && !(this.workspace && this.workspace.options.readOnly);
        }
        setMovable(e) {
          this.movable = e;
        }
        isEditable() {
          return this.editable && !(this.workspace && this.workspace.options.readOnly);
        }
        setEditable(e) {
          this.editable = e;
        }
        getContent() {
          return this.content_;
        }
        setContent(e) {
          this.content_ !== e && (Ce(new (fe(ns))(
            this,
            this.content_,
            e
          )), this.content_ = e);
        }
        toXmlWithXY(e) {
          return e = this.toXml(e), e.setAttribute("x", String(Math.round(this.xy_.x))), e.setAttribute("y", String(Math.round(this.xy_.y))), e.setAttribute("h", String(this.height_)), e.setAttribute("w", String(this.width_)), e;
        }
        toXml(e) {
          const t = r.createElement$$module$build$src$core$utils$xml("comment");
          return e || (t.id = this.id), t.textContent = this.getContent(), t;
        }
        static fireCreateEvent(e) {
          if (nt()) {
            const t = r.getGroup$$module$build$src$core$events$utils();
            t || r.setGroup$$module$build$src$core$events$utils(!0);
            try {
              Ce(new (fe(qr))(e));
            } finally {
              r.setGroup$$module$build$src$core$events$utils(t);
            }
          }
        }
        static fromXml(e, t) {
          var n = Hi.parseAttributes(e);
          return t = new Hi(t, n.content, n.h, n.w, n.id), n = e.getAttribute("x"), e = e.getAttribute("y"), n = n ? parseInt(n, 10) : NaN, e = e ? parseInt(e, 10) : NaN, isNaN(n) || isNaN(e) || t.moveBy(n, e), Hi.fireCreateEvent(t), t;
        }
        static parseAttributes(e) {
          const t = e.getAttribute("h"), n = e.getAttribute("w"), s = e.getAttribute("x"), u = e.getAttribute("y"), A = e.getAttribute("id");
          if (!A)
            throw Error("No ID present in XML comment definition.");
          let L;
          return { id: A, h: t ? parseInt(t) : 100, w: n ? parseInt(n) : 100, x: s ? parseInt(s) : NaN, y: u ? parseInt(u) : NaN, content: (L = e.textContent) != null ? L : "" };
        }
      }, Yi = class extends as {
        constructor(e) {
          super(), this.recordUndo = !1, this.isUiEvent = !0, this.isBlank = typeof e > "u", this.workspaceId = e || "";
        }
      }, mi = class extends Yi {
        constructor(e, t, n) {
          super(n), this.type = Qn, this.oldElementId = e ?? void 0, this.newElementId = t ?? void 0;
        }
        toJson() {
          const e = super.toJson();
          return e.oldElementId = this.oldElementId, e.newElementId = this.newElementId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new mi()), t.oldElementId = e.oldElementId, t.newElementId = e.newElementId, t;
        }
      };
      o(_e.EVENT, Qn, mi);
      var bp = 750, tu = "ontouchstart" in globalThis || !!(globalThis.document && document.documentElement && "ontouchstart" in document.documentElement) || !(!globalThis.navigator || !globalThis.navigator.maxTouchPoints && !globalThis.navigator.msMaxTouchPoints), na = null, Xi = {
        mousedown: ["pointerdown"],
        mouseenter: ["pointerenter"],
        mouseleave: ["pointerleave"],
        mousemove: ["pointermove"],
        mouseout: ["pointerout"],
        mouseover: ["pointerover"],
        mouseup: ["pointerup", "pointercancel"],
        touchend: ["pointerup"],
        touchcancel: ["pointercancel"]
      }, Co = 0, Pe = {};
      Pe.TOUCH_ENABLED = tu, Pe.TOUCH_MAP = Xi, Pe.checkTouchIdentifier = Yo, Pe.clearTouchIdentifier = Me, Pe.getTouchIdentifierFromEvent = rr, Pe.longStart = H, Pe.longStop = ee, Pe.shouldHandleEvent = He;
      var ia, ru, ul, HE, oa, I_, Rr, YE, XE, Pp;
      (function(e) {
        function t(s) {
          return n.indexOf(s.toUpperCase()) !== -1;
        }
        ia = e;
        const n = ia.toUpperCase();
        ru = t("JavaFX"), ul = t("WebKit"), HE = t("Gecko") && !ul, oa = t("Android"), e = globalThis.navigator && globalThis.navigator.maxTouchPoints, I_ = t("iPad") || t("Macintosh") && 0 < e, Rr = t("iPhone") && !I_, YE = t("Macintosh"), XE = I_ || oa && !t("Mobile") || t("Silk"), Pp = !XE && (Rr || oa);
      })(globalThis.navigator && globalThis.navigator.userAgent || "");
      var kS = ia, KE = ru, $p = HE, nu = oa, la = I_, Ki = Rr, Pr = YE, M_ = Pp, vo = {};
      vo.ANDROID = nu, vo.GECKO = $p, vo.IPAD = la, vo.IPHONE = Ki, vo.JavaFx = KE, vo.MAC = Pr, vo.MOBILE = M_, vo.raw = kS;
      var iu = 40, jE = 125, Ro = {};
      Ro.bind = Ir, Ro.conditionalBind = ge, Ro.getScrollDeltaPixels = ks, Ro.isRightButton = Xo, Ro.isTargetInput = ba, Ro.mouseToSvg = $l, Ro.unbind = Mt;
      var cs = !1, ou = `
.blocklySvg {
  background-color: #fff;
  outline: none;
  overflow: hidden;  /* IE overflows by default. */
  position: absolute;
  display: block;
}

.blocklyWidgetDiv {
  display: none;
  position: absolute;
  z-index: 99999;  /* big value for bootstrap3 compatibility */
}

.injectionDiv {
  height: 100%;
  position: relative;
  overflow: hidden;  /* So blocks in drag surface disappear at edges */
  touch-action: none;
}

.blocklyNonSelectable {
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}

.blocklyBlockCanvas.blocklyCanvasTransitioning,
.blocklyBubbleCanvas.blocklyCanvasTransitioning {
  transition: transform .5s;
}

.blocklyTooltipDiv {
  background-color: #ffffc7;
  border: 1px solid #ddc;
  box-shadow: 4px 4px 20px 1px rgba(0,0,0,.15);
  color: #000;
  display: none;
  font: 9pt sans-serif;
  opacity: .9;
  padding: 2px;
  position: absolute;
  z-index: 100000;  /* big value for bootstrap3 compatibility */
}

.blocklyDropDownDiv {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  display: none;
  border: 1px solid;
  border-color: #dadce0;
  background-color: #fff;
  border-radius: 2px;
  padding: 4px;
  box-shadow: 0 0 3px 1px rgba(0,0,0,.3);
}

.blocklyDropDownDiv.blocklyFocused {
  box-shadow: 0 0 6px 1px rgba(0,0,0,.3);
}

.blocklyDropDownContent {
  max-height: 300px;  /* @todo: spec for maximum height. */
  overflow: auto;
  overflow-x: hidden;
  position: relative;
}

.blocklyDropDownArrow {
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  z-index: -1;
  background-color: inherit;
  border-color: inherit;
}

.blocklyDropDownButton {
  display: inline-block;
  float: left;
  padding: 0;
  margin: 4px;
  border-radius: 4px;
  outline: none;
  border: 1px solid;
  transition: box-shadow .1s;
  cursor: pointer;
}

.blocklyArrowTop {
  border-top: 1px solid;
  border-left: 1px solid;
  border-top-left-radius: 4px;
  border-color: inherit;
}

.blocklyArrowBottom {
  border-bottom: 1px solid;
  border-right: 1px solid;
  border-bottom-right-radius: 4px;
  border-color: inherit;
}

.blocklyResizeSE {
  cursor: se-resize;
  fill: #aaa;
}

.blocklyResizeSW {
  cursor: sw-resize;
  fill: #aaa;
}

.blocklyResizeLine {
  stroke: #515A5A;
  stroke-width: 1;
}

.blocklyHighlightedConnectionPath {
  fill: none;
  stroke: #fc3;
  stroke-width: 4px;
}

.blocklyPathLight {
  fill: none;
  stroke-linecap: round;
  stroke-width: 1;
}

.blocklySelected>.blocklyPathLight {
  display: none;
}

.blocklyDraggable {
  cursor: grab;
  cursor: -webkit-grab;
}

.blocklyDragging {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

  /* Changes cursor on mouse down. Not effective in Firefox because of
     https://bugzilla.mozilla.org/show_bug.cgi?id=771241 */
.blocklyDraggable:active {
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

.blocklyDragging.blocklyDraggingDelete {
  cursor: url("<<<PATH>>>/handdelete.cur"), auto;
}

.blocklyDragging>.blocklyPath,
.blocklyDragging>.blocklyPathLight {
  fill-opacity: .8;
  stroke-opacity: .8;
}

.blocklyDragging>.blocklyPathDark {
  display: none;
}

.blocklyDisabled>.blocklyPath {
  fill-opacity: .5;
  stroke-opacity: .5;
}

.blocklyDisabled>.blocklyPathLight,
.blocklyDisabled>.blocklyPathDark {
  display: none;
}

.blocklyInsertionMarker>.blocklyPath,
.blocklyInsertionMarker>.blocklyPathLight,
.blocklyInsertionMarker>.blocklyPathDark {
  fill-opacity: .2;
  stroke: none;
}

.blocklyMultilineText {
  font-family: monospace;
}

.blocklyNonEditableText>text {
  pointer-events: none;
}

.blocklyFlyout {
  position: absolute;
  z-index: 20;
}

.blocklyText text {
  cursor: default;
}

/*
  Don't allow users to select text.  It gets annoying when trying to
  drag a block and selected text moves instead.
*/
.blocklySvg text {
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  cursor: inherit;
}

.blocklyHidden {
  display: none;
}

.blocklyFieldDropdown:not(.blocklyHidden) {
  display: block;
}

.blocklyIconGroup {
  cursor: default;
}

.blocklyIconGroup:not(:hover),
.blocklyIconGroupReadonly {
  opacity: .6;
}

.blocklyIconShape {
  fill: #00f;
  stroke: #fff;
  stroke-width: 1px;
}

.blocklyIconSymbol {
  fill: #fff;
}

.blocklyMinimalBody {
  margin: 0;
  padding: 0;
}

.blocklyHtmlInput {
  border: none;
  border-radius: 4px;
  height: 100%;
  margin: 0;
  outline: none;
  padding: 0;
  width: 100%;
  text-align: center;
  display: block;
  box-sizing: border-box;
}

/* Remove the increase and decrease arrows on the field number editor */
input.blocklyHtmlInput[type=number]::-webkit-inner-spin-button,
input.blocklyHtmlInput[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.blocklyMainBackground {
  stroke-width: 1;
  stroke: #c6c6c6;  /* Equates to #ddd due to border being off-pixel. */
}

.blocklyMutatorBackground {
  fill: #fff;
  stroke: #ddd;
  stroke-width: 1;
}

.blocklyFlyoutBackground {
  fill: #ddd;
  fill-opacity: .8;
}

.blocklyMainWorkspaceScrollbar {
  z-index: 20;
}

.blocklyFlyoutScrollbar {
  z-index: 30;
}

.blocklyScrollbarHorizontal,
.blocklyScrollbarVertical {
  position: absolute;
  outline: none;
}

.blocklyScrollbarBackground {
  opacity: 0;
}

.blocklyScrollbarHandle {
  fill: #ccc;
}

.blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,
.blocklyScrollbarHandle:hover {
  fill: #bbb;
}

/* Darken flyout scrollbars due to being on a grey background. */
/* By contrast, workspace scrollbars are on a white background. */
.blocklyFlyout .blocklyScrollbarHandle {
  fill: #bbb;
}

.blocklyFlyout .blocklyScrollbarBackground:hover+.blocklyScrollbarHandle,
.blocklyFlyout .blocklyScrollbarHandle:hover {
  fill: #aaa;
}

.blocklyInvalidInput {
  background: #faa;
}

.blocklyVerticalMarker {
  stroke-width: 3px;
  fill: rgba(255,255,255,.5);
  pointer-events: none;
}

.blocklyComputeCanvas {
  position: absolute;
  width: 0;
  height: 0;
}

.blocklyNoPointerEvents {
  pointer-events: none;
}

.blocklyContextMenu {
  border-radius: 4px;
  max-height: 100%;
}

.blocklyDropdownMenu {
  border-radius: 2px;
  padding: 0 !important;
}

.blocklyDropdownMenu .blocklyMenuItem {
  /* 28px on the left for icon or checkbox. */
  padding-left: 28px;
}

/* BiDi override for the resting state. */
.blocklyDropdownMenu .blocklyMenuItemRtl {
  /* Flip left/right padding for BiDi. */
  padding-left: 5px;
  padding-right: 28px;
}

.blocklyWidgetDiv .blocklyMenu {
  background: #fff;
  border: 1px solid transparent;
  box-shadow: 0 0 3px 1px rgba(0,0,0,.3);
  font: normal 13px Arial, sans-serif;
  margin: 0;
  outline: none;
  padding: 4px 0;
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  z-index: 20000;  /* Arbitrary, but some apps depend on it... */
}

.blocklyWidgetDiv .blocklyMenu.blocklyFocused {
  box-shadow: 0 0 6px 1px rgba(0,0,0,.3);
}

.blocklyDropDownDiv .blocklyMenu {
  background: inherit;  /* Compatibility with gapi, reset from goog-menu */
  border: inherit;  /* Compatibility with gapi, reset from goog-menu */
  font: normal 13px "Helvetica Neue", Helvetica, sans-serif;
  outline: none;
  position: relative;  /* Compatibility with gapi, reset from goog-menu */
  z-index: 20000;  /* Arbitrary, but some apps depend on it... */
}

/* State: resting. */
.blocklyMenuItem {
  border: none;
  color: #000;
  cursor: pointer;
  list-style: none;
  margin: 0;
  /* 7em on the right for shortcut. */
  min-width: 7em;
  padding: 6px 15px;
  white-space: nowrap;
}

/* State: disabled. */
.blocklyMenuItemDisabled {
  color: #ccc;
  cursor: inherit;
}

/* State: hover. */
.blocklyMenuItemHighlight {
  background-color: rgba(0,0,0,.1);
}

/* State: selected/checked. */
.blocklyMenuItemCheckbox {
  height: 16px;
  position: absolute;
  width: 16px;
}

.blocklyMenuItemSelected .blocklyMenuItemCheckbox {
  background: url(<<<PATH>>>/sprites.png) no-repeat -48px -16px;
  float: left;
  margin-left: -24px;
  position: static;  /* Scroll with the menu. */
}

.blocklyMenuItemRtl .blocklyMenuItemCheckbox {
  float: right;
  margin-right: -24px;
}
`, lu = {};
      lu.inject = dT, lu.register = Kn;
      var yt = class {
        constructor(e, t, n, s) {
          this.top = e, this.bottom = t, this.left = n, this.right = s;
        }
        getHeight() {
          return this.bottom - this.top;
        }
        getWidth() {
          return this.right - this.left;
        }
        contains(e, t) {
          return e >= this.left && e <= this.right && t >= this.top && t <= this.bottom;
        }
        intersects(e) {
          return !(this.left > e.right || this.right < e.left || this.top > e.bottom || this.bottom < e.top);
        }
      }, G = class {
        constructor(e) {
          this.tagName = e;
        }
        toString() {
          return this.tagName;
        }
      };
      G.ANIMATE = new G("animate"), G.CIRCLE = new G("circle"), G.CLIPPATH = new G("clipPath"), G.DEFS = new G("defs"), G.FECOMPOSITE = new G("feComposite"), G.FECOMPONENTTRANSFER = new G("feComponentTransfer"), G.FEFLOOD = new G("feFlood"), G.FEFUNCA = new G("feFuncA"), G.FEGAUSSIANBLUR = new G("feGaussianBlur"), G.FEPOINTLIGHT = new G("fePointLight"), G.FESPECULARLIGHTING = new G("feSpecularLighting"), G.FILTER = new G("filter"), G.FOREIGNOBJECT = new G("foreignObject"), G.G = new G("g"), G.IMAGE = new G("image"), G.LINE = new G("line"), G.PATH = new G("path"), G.PATTERN = new G("pattern"), G.POLYGON = new G("polygon"), G.RECT = new G("rect"), G.SVG = new G("svg"), G.TEXT = new G("text"), G.TSPAN = new G("tspan");
      var zE = { getSizeInternal: Jd }, Oo = {};
      Oo.TEST_ONLY = zE, Oo.getBorderBox = ws, Oo.getComputedStyle = wi, Oo.getContainerOffsetToScrollInto = ST, Oo.getPageOffset = ci, Oo.getSize = Pa, Oo.getViewportPageOffset = AT, Oo.scrollIntoContainerView = nc;
      var Wp = /translate\(\s*([-+\d.e]+)([ ,]\s*([-+\d.e]+)\s*)?/, kp = /transform:\s*translate(?:3d)?\(\s*([-+\d.e]+)\s*px([ ,]\s*([-+\d.e]+)\s*px)?/, wS = { XY_REGEX: Wp, XY_STYLE_REGEX: kp }, Do = {};
      Do.TEST_ONLY = wS, Do.getDocumentScroll = oc, Do.getInjectionDivXY = $a, Do.getRelativeXY = Wl, Do.getViewportBBox = ic, Do.screenToWsCoordinates = Zd;
      var Tr = 8, Tl = 3, wp = 2, $r = class extends Hi {
        constructor(e, t, n, s, u) {
          super(e, t, n, s, u), this.onMouseMoveWrapper = this.onMouseUpWrapper = null, this.eventsInit = !1, this.deleteIconBorder = this.deleteGroup = this.resizeGroup = this.foreignObject = this.svgHandleTarget = this.svgRectTarget = this.textarea = null, this.rendered = this.autoLayout = this.focused = !1, this.svgGroup = K(G.G, { class: "blocklyComment" }), this.workspace = e, this.svgRect_ = K(G.RECT, { class: "blocklyCommentRect", x: 0, y: 0, rx: Tl, ry: Tl }), this.svgGroup.appendChild(this.svgRect_), this.render();
        }
        dispose() {
          this.disposed_ || (Fe() === this && (this.unselect(), this.workspace.cancelCurrentGesture()), nt() && Ce(new (fe(_l))(this)), _t(this.svgGroup), this.disposeInternal(), r.disable$$module$build$src$core$events$utils(), super.dispose(), r.enable$$module$build$src$core$events$utils());
        }
        initSvg(e) {
          if (!this.workspace.rendered)
            throw TypeError("Workspace is headless.");
          this.workspace.options.readOnly || this.eventsInit || (ge(this.svgRectTarget, "pointerdown", this, this.pathMouseDown), ge(this.svgHandleTarget, "pointerdown", this, this.pathMouseDown)), this.eventsInit = !0, this.updateMovable(), this.getSvgRoot().parentNode || this.workspace.getBubbleCanvas().appendChild(this.getSvgRoot()), !e && this.textarea && this.textarea.select();
        }
        pathMouseDown(e) {
          const t = this.workspace.getGesture(e);
          t && t.handleBubbleStart(e, this);
        }
        showContextMenu(e) {
          throw Error("The implementation of showContextMenu should be monkey-patched in by blockly.ts");
        }
        select() {
          if (Fe() !== this) {
            var e = null;
            if (Fe()) {
              e = Fe().id, r.disable$$module$build$src$core$events$utils();
              try {
                Fe().unselect();
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
            }
            e = new (fe(Qn))(e, this.id, this.workspace.id), Ce(e), at(this), this.addSelect();
          }
        }
        unselect() {
          if (Fe() === this) {
            var e = new (fe(Qn))(this.id, null, this.workspace.id);
            Ce(e), at(null), this.removeSelect(), this.blurFocus();
          }
        }
        addSelect() {
          Re(this.svgGroup, "blocklySelected"), this.setFocus();
        }
        removeSelect() {
          Re(this.svgGroup, "blocklySelected"), this.blurFocus();
        }
        addFocus() {
          Re(this.svgGroup, "blocklyFocused");
        }
        removeFocus() {
          Ue(this.svgGroup, "blocklyFocused");
        }
        getRelativeToSurfaceXY() {
          let e = 0, t = 0, n = this.getSvgRoot();
          if (n)
            do {
              const s = Wl(n);
              e += s.x, t += s.y, n = n.parentNode;
            } while (n && n !== this.workspace.getBubbleCanvas() && n !== null);
          return this.xy_ = new Te(e, t);
        }
        moveBy(e, t) {
          const n = new (fe(qn))(this), s = this.getRelativeToSurfaceXY();
          this.translate(s.x + e, s.y + t), this.xy_ = new Te(s.x + e, s.y + t), n.recordNew(), Ce(n), this.workspace.resizeContents();
        }
        translate(e, t) {
          this.xy_ = new Te(e, t), this.getSvgRoot().setAttribute("transform", "translate(" + e + "," + t + ")");
        }
        moveDuringDrag(e) {
          e = `translate(${e.x}, ${e.y})`, this.getSvgRoot().setAttribute("transform", e);
        }
        moveTo(e, t) {
          this.translate(e, t);
        }
        clearTransformAttributes() {
          this.getSvgRoot().removeAttribute("transform");
        }
        getBoundingRectangle() {
          var e = this.getRelativeToSurfaceXY();
          const t = this.getHeightWidth(), n = e.y, s = e.y + t.height;
          let u;
          return this.RTL ? (u = e.x - t.width, e = e.x) : (u = e.x, e = e.x + t.width), new yt(n, s, u, e);
        }
        updateMovable() {
          this.isMovable() ? Re(this.svgGroup, "blocklyDraggable") : Ue(this.svgGroup, "blocklyDraggable");
        }
        setMovable(e) {
          super.setMovable(e), this.updateMovable();
        }
        setEditable(e) {
          super.setEditable(e), this.textarea && (this.textarea.readOnly = !e);
        }
        setDragging(e) {
          e ? Re(this.getSvgRoot(), "blocklyDragging") : Ue(
            this.getSvgRoot(),
            "blocklyDragging"
          );
        }
        getSvgRoot() {
          return this.svgGroup;
        }
        getContent() {
          return this.textarea ? this.textarea.value : this.content_;
        }
        setContent(e) {
          super.setContent(e), this.textarea && (this.textarea.value = e);
        }
        setDeleteStyle(e) {
          e ? Re(this.svgGroup, "blocklyDraggingDelete") : Ue(this.svgGroup, "blocklyDraggingDelete");
        }
        setAutoLayout(e) {
        }
        toXmlWithXY(e) {
          let t = 0;
          this.workspace.RTL && (t = this.workspace.getWidth()), e = this.toXml(e);
          const n = this.getRelativeToSurfaceXY();
          return e.setAttribute("x", String(Math.round(this.workspace.RTL ? t - n.x : n.x))), e.setAttribute("y", String(Math.round(n.y))), e.setAttribute("h", String(this.getHeight())), e.setAttribute("w", String(this.getWidth())), e;
        }
        toCopyData() {
          return { saveInfo: this.toXmlWithXY(), source: this.workspace, typeCounts: null };
        }
        getHeightWidth() {
          return { width: this.getWidth(), height: this.getHeight() };
        }
        render() {
          if (!this.rendered) {
            var e = this.getHeightWidth(), t = this.createEditor();
            this.svgGroup.appendChild(t), this.svgHandleTarget = K(
              G.RECT,
              { class: "blocklyCommentHandleTarget", x: 0, y: 0 }
            ), this.svgGroup.appendChild(this.svgHandleTarget), this.svgRectTarget = K(G.RECT, { class: "blocklyCommentTarget", x: 0, y: 0, rx: Tl, ry: Tl }), this.svgGroup.appendChild(this.svgRectTarget), this.addResizeDom(), this.isDeletable() && this.addDeleteDom(), this.setSize(e.width, e.height), this.textarea.value = this.content_, this.rendered = !0, this.resizeGroup && ge(this.resizeGroup, "pointerdown", this, this.resizeMouseDown), this.isDeletable() && (ge(this.deleteGroup, "pointerdown", this, this.deleteMouseDown), ge(this.deleteGroup, "pointerout", this, this.deleteMouseOut), ge(
              this.deleteGroup,
              "pointerup",
              this,
              this.deleteMouseUp
            ));
          }
        }
        createEditor() {
          this.foreignObject = K(G.FOREIGNOBJECT, { x: 0, y: $r.TOP_OFFSET, class: "blocklyCommentForeignObject" });
          const e = document.createElementNS(fo, "body");
          e.setAttribute("xmlns", fo), e.className = "blocklyMinimalBody";
          const t = document.createElementNS(
            fo,
            "textarea"
          );
          return t.className = "blocklyCommentTextarea", t.setAttribute("dir", this.RTL ? "RTL" : "LTR"), t.readOnly = !this.isEditable(), e.appendChild(t), this.textarea = t, this.foreignObject.appendChild(e), ge(t, "wheel", this, function(n) {
            n.stopPropagation();
          }), ge(t, "change", this, function(n) {
            this.setContent(t.value);
          }), this.foreignObject;
        }
        addResizeDom() {
          this.resizeGroup = K(
            G.G,
            { class: this.RTL ? "blocklyResizeSW" : "blocklyResizeSE" },
            this.svgGroup
          ), K(G.POLYGON, { points: `0,${Tr} ${Tr},${Tr} ${Tr},0` }, this.resizeGroup), K(
            G.LINE,
            { class: "blocklyResizeLine", x1: Tr / 3, y1: Tr - 1, x2: Tr - 1, y2: Tr / 3 },
            this.resizeGroup
          ), K(G.LINE, { class: "blocklyResizeLine", x1: 2 * Tr / 3, y1: Tr - 1, x2: Tr - 1, y2: 2 * Tr / 3 }, this.resizeGroup);
        }
        addDeleteDom() {
          this.deleteGroup = K(G.G, { class: "blocklyCommentDeleteIcon" }, this.svgGroup), this.deleteIconBorder = K(G.CIRCLE, { class: "blocklyDeleteIconShape", r: "7", cx: "7.5", cy: "7.5" }, this.deleteGroup), K(G.LINE, { x1: "5", y1: "10", x2: "10", y2: "5", stroke: "#fff", "stroke-width": "2" }, this.deleteGroup), K(G.LINE, { x1: "5", y1: "5", x2: "10", y2: "10", stroke: "#fff", "stroke-width": "2" }, this.deleteGroup);
        }
        resizeMouseDown(e) {
          this.unbindDragEvents(), Xo(e) || (this.workspace.startDrag(e, new Te(this.workspace.RTL ? -this.width_ : this.width_, this.height_)), this.onMouseUpWrapper = ge(document, "pointerup", this, this.resizeMouseUp), this.onMouseMoveWrapper = ge(document, "pointermove", this, this.resizeMouseMove), this.workspace.hideChaff()), e.stopPropagation();
        }
        deleteMouseDown(e) {
          this.deleteIconBorder && Re(this.deleteIconBorder, "blocklyDeleteIconHighlighted"), e.stopPropagation();
        }
        deleteMouseOut(e) {
          this.deleteIconBorder && Ue(this.deleteIconBorder, "blocklyDeleteIconHighlighted");
        }
        deleteMouseUp(e) {
          this.dispose(), e.stopPropagation();
        }
        unbindDragEvents() {
          this.onMouseUpWrapper && (Mt(this.onMouseUpWrapper), this.onMouseUpWrapper = null), this.onMouseMoveWrapper && (Mt(this.onMouseMoveWrapper), this.onMouseMoveWrapper = null);
        }
        resizeMouseUp(e) {
          Me(), this.unbindDragEvents();
        }
        resizeMouseMove(e) {
          this.autoLayout = !1, e = this.workspace.moveDrag(e), this.setSize(this.RTL ? -e.x : e.x, e.y);
        }
        resizeComment() {
          const e = this.getHeightWidth(), t = $r.TOP_OFFSET, n = 2 * wp;
          let s;
          (s = this.foreignObject) == null || s.setAttribute("width", String(e.width));
          let u;
          if ((u = this.foreignObject) == null || u.setAttribute("height", String(e.height - t)), this.RTL) {
            let A;
            (A = this.foreignObject) == null || A.setAttribute("x", String(-e.width));
          }
          this.textarea && (this.textarea.style.width = e.width - n + "px", this.textarea.style.height = e.height - n - t + "px");
        }
        setSize(e, t) {
          e = Math.max(e, 45), t = Math.max(t, 20 + $r.TOP_OFFSET), this.width_ = e, this.height_ = t, this.svgRect_.setAttribute("width", `${e}`), this.svgRect_.setAttribute("height", `${t}`);
          let n;
          (n = this.svgRectTarget) == null || n.setAttribute("width", `${e}`);
          let s;
          (s = this.svgRectTarget) == null || s.setAttribute("height", `${t}`);
          let u;
          (u = this.svgHandleTarget) == null || u.setAttribute(
            "width",
            `${e}`
          );
          let A;
          if ((A = this.svgHandleTarget) == null || A.setAttribute("height", String($r.TOP_OFFSET)), this.RTL) {
            this.svgRect_.setAttribute("transform", "scale(-1 1)");
            let L;
            (L = this.svgRectTarget) == null || L.setAttribute("transform", "scale(-1 1)");
          }
          if (this.resizeGroup)
            if (this.RTL) {
              this.resizeGroup.setAttribute("transform", "translate(" + (-e + Tr) + "," + (t - Tr) + ") scale(-1 1)");
              let L;
              (L = this.deleteGroup) == null || L.setAttribute("transform", "translate(" + (-e + Tr) + "," + -Tr + ") scale(-1 1)");
            } else {
              this.resizeGroup.setAttribute("transform", "translate(" + (e - Tr) + "," + (t - Tr) + ")");
              let L;
              (L = this.deleteGroup) == null || L.setAttribute("transform", "translate(" + (e - Tr) + "," + -Tr + ")");
            }
          this.resizeComment();
        }
        disposeInternal() {
          this.disposed_ = !0;
        }
        setFocus() {
          this.focused = !0, setTimeout(() => {
            this.disposed_ || (this.textarea.focus(), this.addFocus(), this.svgRectTarget && Re(this.svgRectTarget, "blocklyCommentTargetFocused"), this.svgHandleTarget && Re(this.svgHandleTarget, "blocklyCommentHandleTargetFocused"));
          }, 0);
        }
        blurFocus() {
          this.focused = !1, setTimeout(() => {
            this.disposed_ || (this.textarea.blur(), this.removeFocus(), this.svgRectTarget && Ue(this.svgRectTarget, "blocklyCommentTargetFocused"), this.svgHandleTarget && Ue(this.svgHandleTarget, "blocklyCommentHandleTargetFocused"));
          }, 0);
        }
        static fromXmlRendered(e, t, n) {
          r.disable$$module$build$src$core$events$utils();
          let s;
          try {
            const u = Hi.parseAttributes(e);
            if (s = new $r(
              t,
              u.content,
              u.h,
              u.w,
              u.id
            ), t.rendered && (s.initSvg(!0), s.render()), !isNaN(u.x) && !isNaN(u.y))
              if (t.RTL) {
                const A = n || t.getWidth();
                s.moveBy(A - u.x, u.y);
              } else
                s.moveBy(u.x, u.y);
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return Hi.fireCreateEvent(s), s;
        }
      };
      $r.DEFAULT_SIZE = 100, $r.TOP_OFFSET = 10, Kn(`
.blocklyCommentForeignObject {
  position: relative;
  z-index: 0;
}

.blocklyCommentRect {
  fill: #E7DE8E;
  stroke: #bcA903;
  stroke-width: 1px;
}

.blocklyCommentTarget {
  fill: transparent;
  stroke: #bcA903;
}

.blocklyCommentTargetFocused {
  fill: none;
}

.blocklyCommentHandleTarget {
  fill: none;
}

.blocklyCommentHandleTargetFocused {
  fill: transparent;
}

.blocklyFocused>.blocklyCommentRect {
  fill: #B9B272;
  stroke: #B9B272;
}

.blocklySelected>.blocklyCommentTarget {
  stroke: #fc3;
  stroke-width: 3px;
}

.blocklyCommentDeleteIcon {
  cursor: pointer;
  fill: #000;
  display: none;
}

.blocklySelected > .blocklyCommentDeleteIcon {
  display: block;
}

.blocklyDeleteIconShape {
  fill: #000;
  stroke: #000;
  stroke-width: 1px;
}

.blocklyDeleteIconShape.blocklyDeleteIconHighlighted {
  stroke: #fc3;
}
`);
      var mn = {};
      mn.appendDomToWorkspace = gT, mn.blockToDom = Eo, mn.blockToDomWithXY = Wa, mn.clearWorkspaceAndLoadFromXml = wa, mn.deleteNext = eE, mn.domToBlock = r.domToBlock$$module$build$src$core$xml, mn.domToPrettyText = MT, mn.domToText = Fi, mn.domToVariables = LT, mn.domToWorkspace = r.domToWorkspace$$module$build$src$core$xml, mn.variablesToDom = hT, mn.workspaceToDom = Qd;
      var bo = class extends Error {
      }, Fp = class extends bo {
        constructor(e) {
          super("Expected to find a 'type' property, defining the block type"), this.state = e;
        }
      }, In = class extends bo {
        constructor(e, t, n) {
          super(`The block ${t.toDevString()} is missing a(n) ${e}
connection`), this.block = t, this.state = n;
        }
      }, pl = class extends bo {
        constructor(e, t, n, s) {
          super(`The block ${n.toDevString()} could not connect its
${t} to its parent, because: ${e}`), this.childBlock = n, this.childState = s;
        }
      }, JE = class extends bo {
        constructor(e) {
          super(`Encountered a real block which is defined as a child of a shadow
block. It is an invariant of Blockly that shadow blocks only have shadow
children`), this.state = e;
        }
      }, Bp = class extends bo {
        constructor(e, t, n) {
          super(`Cannot add an icon of type '${e}' to the block ${t.toDevString()}, because there is no icon registered with type '${e}'. Make sure that all of your icons have been registered.`), this.block = t, this.state = n;
        }
      }, us = {};
      us.BadConnectionCheck = pl, us.DeserializationError = bo, us.MissingBlockType = Fp, us.MissingConnection = In, us.RealChildOfShadow = JE, us.UnregisteredIcon = Bp;
      var ZE = 100, QE = 75, qE = 50, su = {};
      su.BLOCKS = qE, su.PROCEDURES = QE, su.VARIABLES = ZE;
      var Up = {};
      Up.register = Ua, Up.unregister = vT;
      var eA = class {
        constructor() {
          this.priority = qE;
        }
        save(e) {
          const t = [];
          for (const n of e.getTopBlocks(!1))
            (e = ui(n, { addCoordinates: !0, doFullSerialization: !1 })) && t.push(e);
          return t.length ? { languageVersion: 0, blocks: t } : null;
        }
        load(e, t) {
          e = e.blocks;
          for (const n of e)
            Bi(
              n,
              t,
              { recordUndo: Dr() }
            );
        }
        clear(e) {
          for (const t of e.getTopBlocks(!1))
            t.dispose(!1);
        }
      };
      Ua("blocks", new eA());
      var g_ = {};
      g_.BlockSerializer = eA, g_.append = Bi, g_.appendInternal = _c, g_.save = ui;
      var Ts = class extends as {
        constructor(e) {
          super(), this.isBlank = !e, e && (this.blockId = e.id, this.workspaceId = e.workspace.id);
        }
        toJson() {
          const e = super.toJson();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          return e.blockId = this.blockId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Ts()), t.blockId = e.blockId, t;
        }
      }, Vp = class extends Ts {
        constructor(e) {
          super(e), this.type = r.CREATE$$module$build$src$core$events$utils, e && (e.isShadow() && (this.recordUndo = !1), this.xml = Wa(e), this.ids = _o(e), this.json = ui(e, { addCoordinates: !0 }));
        }
        toJson() {
          const e = super.toJson();
          if (!this.xml)
            throw Error("The block XML is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.json)
            throw Error("The block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          return e.xml = Fi(this.xml), e.ids = this.ids, e.json = this.json, this.recordUndo || (e.recordUndo = this.recordUndo), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Vp()), t.xml = r.textToDom$$module$build$src$core$utils$xml(e.xml), t.ids = e.ids, t.json = e.json, e.recordUndo !== void 0 && (t.recordUndo = e.recordUndo), t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.json)
            throw Error("The block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (e)
            Bi(this.json, t);
          else
            for (e = 0; e < this.ids.length; e++) {
              const n = this.ids[e], s = t.getBlockById(n);
              s ? s.dispose(!1) : n === this.blockId && console.warn("Can't uncreate non-existent block: " + n);
            }
        }
      };
      o(_e.EVENT, r.CREATE$$module$build$src$core$events$utils, Vp);
      var tA = class extends as {
        constructor(e) {
          super(), this.isBlank = !0, this.recordUndo = !1, this.type = is, this.isBlank = !!e, e && (this.workspaceId = e.id);
        }
      };
      o(_e.EVENT, is, tA);
      var dl = class extends Ts {
        constructor(e, t, n, s, u) {
          super(e), this.type = r.CHANGE$$module$build$src$core$events$utils, e && (this.element = t, this.name = n || void 0, this.oldValue = s, this.newValue = u);
        }
        toJson() {
          const e = super.toJson();
          if (!this.element)
            throw Error("The changed element is undefined. Either pass an element to the constructor, or call fromJson");
          return e.element = this.element, e.name = this.name, e.oldValue = this.oldValue, e.newValue = this.newValue, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new dl()), t.element = e.element, t.name = e.name, t.oldValue = e.oldValue, t.newValue = e.newValue, t;
        }
        isNull() {
          return this.oldValue === this.newValue;
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          if (t = t.getBlockById(this.blockId), !t)
            throw Error("The associated block is undefined. Either pass a block to the constructor, or call fromJson");
          var n = t.getIcon(Lr.MUTATOR);
          switch (n && Ko(n) && n.bubbleIsVisible() && n.setBubbleVisible(!1), e = e ? this.newValue : this.oldValue, this.element) {
            case "field":
              (t = t.getField(this.name)) ? t.setValue(e) : console.warn("Can't set non-existent field: " + this.name);
              break;
            case "comment":
              t.setCommentText(e || null);
              break;
            case "collapsed":
              t.setCollapsed(!!e);
              break;
            case "disabled":
              t.setEnabled(!e);
              break;
            case "inline":
              t.setInputsInline(!!e);
              break;
            case "mutation":
              n = dl.getExtraBlockState_(t), t.loadExtraState ? t.loadExtraState(JSON.parse(e || "{}")) : t.domToMutation && t.domToMutation(r.textToDom$$module$build$src$core$utils$xml(e || "<mutation/>")), Ce(new dl(t, "mutation", null, n, e));
              break;
            default:
              console.warn("Unknown change type: " + this.element);
          }
        }
        static getExtraBlockState_(e) {
          return e.saveExtraState ? (e = e.saveExtraState()) ? JSON.stringify(e) : "" : e.mutationToDom && (e = e.mutationToDom()) ? Fi(e) : "";
        }
      };
      o(_e.EVENT, r.CHANGE$$module$build$src$core$events$utils, dl);
      var au = class extends Ts {
        constructor(e) {
          if (super(e), this.type = r.DELETE$$module$build$src$core$events$utils, e) {
            if (e.getParent())
              throw Error("Connected blocks cannot be deleted.");
            e.isShadow() && (this.recordUndo = !1), this.oldXml = Wa(e), this.ids = _o(e), this.wasShadow = e.isShadow(), this.oldJson = ui(
              e,
              { addCoordinates: !0 }
            );
          }
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldXml)
            throw Error("The old block XML is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (this.wasShadow === void 0)
            throw Error("Whether the block was a shadow is undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.oldJson)
            throw Error("The old block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          return e.oldXml = Fi(this.oldXml), e.ids = this.ids, e.wasShadow = this.wasShadow, e.oldJson = this.oldJson, this.recordUndo || (e.recordUndo = this.recordUndo), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new au()), t.oldXml = r.textToDom$$module$build$src$core$utils$xml(e.oldXml), t.ids = e.ids, t.wasShadow = e.wasShadow || t.oldXml.tagName.toLowerCase() === "shadow", t.oldJson = e.oldJson, e.recordUndo !== void 0 && (t.recordUndo = e.recordUndo), t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.ids)
            throw Error("The block IDs are undefined. Either pass a block to the constructor, or call fromJson");
          if (!this.oldJson)
            throw Error("The old block JSON is undefined. Either pass a block to the constructor, or call fromJson");
          if (e)
            for (e = 0; e < this.ids.length; e++) {
              const n = this.ids[e], s = t.getBlockById(n);
              s ? s.dispose(!1) : n === this.blockId && console.warn("Can't delete non-existent block: " + n);
            }
          else
            Bi(
              this.oldJson,
              t
            );
        }
      };
      o(_e.EVENT, r.DELETE$$module$build$src$core$events$utils, au);
      var me;
      (function(e) {
        e[e.INPUT_VALUE = 1] = "INPUT_VALUE", e[e.OUTPUT_VALUE = 2] = "OUTPUT_VALUE", e[e.NEXT_STATEMENT = 3] = "NEXT_STATEMENT", e[e.PREVIOUS_STATEMENT = 4] = "PREVIOUS_STATEMENT";
      })(me || (me = {}));
      var ut = class {
        constructor(e, t) {
          this.type = t, this.targetConnection = null, this.disposed = !1, this.shadowDom = this.check = null, this.y = this.x = 0, this.shadowState = null, this.sourceBlock_ = e;
        }
        connect_(e) {
          const t = me.INPUT_VALUE, n = this.getSourceBlock();
          var s = e.getSourceBlock();
          e.isConnected() && e.disconnectInternal(!1);
          let u;
          if (this.isConnected()) {
            const L = this.stashShadowState(), $ = this.targetBlock();
            $.isShadow() ? $.dispose(!1) : (this.disconnectInternal(), u = $), this.applyShadowState(L);
          }
          let A;
          nt() && (A = new (fe(r.MOVE$$module$build$src$core$events$utils))(s), A.setReason(["connect"])), PT(this, e), s.setParent(n), A && (A.recordNew(), Ce(A)), u && (e = this.type === t ? u.outputConnection : u.previousConnection) && ((s = ut.getConnectionForOrphanedConnection(
            s,
            e
          )) ? e.connect(s) : e.onFailedConnect(this));
        }
        dispose() {
          if (this.isConnected()) {
            this.setShadowStateInternal();
            const e = this.targetBlock();
            e && !e.isDeadOrDying() && e.unplug();
          }
          this.disposed = !0;
        }
        getSourceBlock() {
          return this.sourceBlock_;
        }
        isSuperior() {
          return this.type === me.INPUT_VALUE || this.type === me.NEXT_STATEMENT;
        }
        isConnected() {
          return !!this.targetConnection;
        }
        getConnectionChecker() {
          return this.sourceBlock_.workspace.connectionChecker;
        }
        onFailedConnect(e) {
        }
        connect(e) {
          if (this.targetConnection === e)
            return !0;
          if (this.getConnectionChecker().canConnect(this, e, !1)) {
            const t = r.getGroup$$module$build$src$core$events$utils();
            t || r.setGroup$$module$build$src$core$events$utils(!0), this.isSuperior() ? this.connect_(e) : e.connect_(this), r.setGroup$$module$build$src$core$events$utils(t);
          }
          return this.isConnected();
        }
        disconnect() {
          this.disconnectInternal();
        }
        disconnectInternal(e = !0) {
          const { parentConnection: t, childConnection: n } = this.getParentAndChildConnections();
          if (!t || !n)
            throw Error("Source connection not connected.");
          const s = r.getGroup$$module$build$src$core$events$utils();
          s || r.setGroup$$module$build$src$core$events$utils(!0);
          let u;
          nt() && (u = new (fe(r.MOVE$$module$build$src$core$events$utils))(n.getSourceBlock()), u.setReason(["disconnect"]));
          const A = this.targetConnection;
          A && (A.targetConnection = null), this.targetConnection = null, e && n.getSourceBlock().setParent(null), u && (u.recordNew(), Ce(u)), n.getSourceBlock().isShadow() || t.respawnShadow_(), r.setGroup$$module$build$src$core$events$utils(s);
        }
        getParentAndChildConnections() {
          return this.targetConnection ? this.isSuperior() ? { parentConnection: this, childConnection: this.targetConnection } : { parentConnection: this.targetConnection, childConnection: this } : {};
        }
        respawnShadow_() {
          this.createShadowBlock(!0);
        }
        reconnect(e, t) {
          if (this.getSourceBlock().isDeadOrDying())
            return !1;
          var n;
          return t = (n = e.getInput(t)) == null ? void 0 : n.connection, n = this.targetBlock(), n && n !== e || !t || t.targetConnection === this ? !1 : (t.isConnected() && t.disconnect(), t.connect(this), !0);
        }
        targetBlock() {
          if (this.isConnected()) {
            let e, t;
            return (t = (e = this.targetConnection) == null ? void 0 : e.getSourceBlock()) != null ? t : null;
          }
          return null;
        }
        onCheckChanged_() {
          !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || (this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug();
        }
        setCheck(e) {
          return e ? (Array.isArray(e) || (e = [e]), this.check = e, this.onCheckChanged_()) : this.check = null, this;
        }
        getCheck() {
          return this.check;
        }
        setShadowDom(e) {
          this.setShadowStateInternal({ shadowDom: e });
        }
        getShadowDom(e) {
          return e && this.targetBlock().isShadow() ? Eo(this.targetBlock()) : this.shadowDom;
        }
        setShadowState(e) {
          this.setShadowStateInternal({ shadowState: e });
        }
        getShadowState(e) {
          return e && this.targetBlock() && this.targetBlock().isShadow() ? ui(this.targetBlock()) : this.shadowState;
        }
        neighbours(e) {
          return [];
        }
        getParentInput() {
          let e = null;
          const t = this.sourceBlock_.inputList;
          for (let n = 0; n < t.length; n++)
            if (t[n].connection === this) {
              e = t[n];
              break;
            }
          return e;
        }
        toString() {
          const e = this.sourceBlock_;
          if (!e)
            return "Orphan Connection";
          if (e.outputConnection === this)
            var t = "Output Connection of ";
          else if (e.previousConnection === this)
            t = "Previous Connection of ";
          else if (e.nextConnection === this)
            t = "Next Connection of ";
          else {
            t = null;
            for (let n = 0, s; s = e.inputList[n]; n++)
              if (s.connection === this) {
                t = s;
                break;
              }
            if (t)
              t = 'Input "' + t.name + '" connection on ';
            else
              return console.warn("Connection not actually connected to sourceBlock_"), "Orphan Connection";
          }
          return t + e.toDevString();
        }
        stashShadowState() {
          const e = this.getShadowDom(!0), t = this.getShadowState(!0);
          return this.shadowState = this.shadowDom = null, { shadowDom: e, shadowState: t };
        }
        applyShadowState({ shadowDom: e, shadowState: t }) {
          this.shadowDom = e, this.shadowState = t;
        }
        setShadowStateInternal({ shadowDom: e = null, shadowState: t = null } = {}) {
          this.shadowDom = e, this.shadowState = t, (e = this.targetBlock()) ? e.isShadow() ? (e.dispose(!1), this.getSourceBlock().isDeadOrDying() || (this.respawnShadow_(), this.targetBlock() && this.targetBlock().isShadow() && this.serializeShadow(this.targetBlock()))) : (e = this.createShadowBlock(!1), this.serializeShadow(e), e && e.dispose(!1)) : (this.respawnShadow_(), this.targetBlock() && this.targetBlock().isShadow() && this.serializeShadow(this.targetBlock()));
        }
        createShadowBlock(e) {
          var t = this.getSourceBlock();
          const n = this.getShadowState(), s = this.getShadowDom();
          if (t.isDeadOrDying() || !n && !s)
            return null;
          if (n)
            return t = _c(n, t.workspace, { parentConnection: e ? this : void 0, isShadow: !0, recordUndo: !1 });
          if (s) {
            if (t = r.domToBlock$$module$build$src$core$xml(
              s,
              t.workspace
            ), e)
              if (this.type === me.INPUT_VALUE) {
                if (!t.outputConnection)
                  throw Error("Shadow block is missing an output connection");
                if (!this.connect(t.outputConnection))
                  throw Error("Could not connect shadow block to connection");
              } else if (this.type === me.NEXT_STATEMENT) {
                if (!t.previousConnection)
                  throw Error("Shadow block is missing previous connection");
                if (!this.connect(t.previousConnection))
                  throw Error("Could not connect shadow block to connection");
              } else
                throw Error("Cannot connect a shadow block to a previous/output connection");
            return t;
          }
          return null;
        }
        serializeShadow(e) {
          e && (this.shadowDom = Eo(e), this.shadowState = ui(e));
        }
        static getConnectionForOrphanedConnection(e, t) {
          if (t.type === me.OUTPUT_VALUE)
            return fr(e, t.getSourceBlock());
          e = e.lastConnectionInStack(!0);
          const n = t.getConnectionChecker();
          return e && n.canConnect(t, e, !1) ? e : null;
        }
      };
      ut.CAN_CONNECT = 0, ut.REASON_SELF_CONNECTION = 1, ut.REASON_WRONG_TYPE = 2, ut.REASON_TARGET_NULL = 3, ut.REASON_CHECKS_FAILED = 4, ut.REASON_DIFFERENT_WORKSPACES = 5, ut.REASON_SHADOW_PARENT = 6, ut.REASON_DRAG_CHECKS_FAILED = 7, ut.REASON_PREVIOUS_AND_OUTPUT = 8;
      var sa = "_TEMP_COLLAPSED_INPUT", _u = "_TEMP_COLLAPSED_FIELD", cu = {};
      cu.COLLAPSED_FIELD_NAME = _u, cu.COLLAPSED_INPUT_NAME = sa;
      var rA = class extends Error {
        constructor(e) {
          super(`Tried to append an icon of type ${e.getType()} when an icon of that type already exists on the block. Use getIcon to access the existing icon.`), this.icon = e;
        }
      }, nA = {};
      nA.DuplicateIconType = rA;
      var uu = {};
      uu.clamp = wl, uu.toDegrees = Ao, uu.toRadians = jo;
      var L_ = 16, Gp = 1, iA = 12, Mn = 16, Tu = 0.25, xp = null, ps = null, ds = "", aa = "", Tt, _a, Es, N_ = null, El = null, oA = null, Hp = { getBoundsInfo: function() {
        const e = ci(N_), t = Pa(N_);
        return { left: e.x, right: e.x + t.width, top: e.y, bottom: e.y + t.height, width: t.width, height: t.height };
      }, getPositionMetrics: function(e, t, n, s) {
        const u = Hp.getBoundsInfo(), A = Pa(Tt);
        return t + A.height < u.bottom ? uc(e, t, u, A) : s - A.height > u.top ? Ui(n, s, u, A) : t + A.height < document.documentElement.clientHeight ? uc(e, t, u, A) : s - A.height > document.documentElement.clientTop ? Ui(n, s, u, A) : Ha(e, u, A);
      } }, ir = {};
      ir.ANIMATION_TIME = Tu, ir.ARROW_HORIZONTAL_PADDING = iA, ir.ARROW_SIZE = L_, ir.BORDER_SIZE = Gp, ir.PADDING_Y = Mn, ir.TEST_ONLY = Hp, ir.clearContent = Ga, ir.createDom = Va, ir.getContentDiv = Fl, ir.getOwner = cc, ir.getPositionX = Bl, ir.hide = Bs, ir.hideIfOwner = Rn, ir.hideWithoutAnimation = Ti, ir.isVisible = kt, ir.repositionForWindowResize = wT, ir.setBoundsElement = _n, ir.setColour = xa, ir.show = kT, ir.showPositionedByBlock = $T, ir.showPositionedByField = Fs;
      var y_ = class {
        constructor(e) {
          this.workspace = e, this.cursorSvg_ = this.cursor_ = null, this.markers = /* @__PURE__ */ new Map(), this.markerSvg_ = null;
        }
        registerMarker(e, t) {
          this.markers.has(e) && this.unregisterMarker(e), t.setDrawer(this.workspace.getRenderer().makeMarkerDrawer(this.workspace, t)), this.setMarkerSvg(t.getDrawer().createDom()), this.markers.set(e, t);
        }
        unregisterMarker(e) {
          const t = this.markers.get(e);
          if (t)
            t.dispose(), this.markers.delete(e);
          else
            throw Error("Marker with ID " + e + " does not exist. Can only unregister markers that exist.");
        }
        getCursor() {
          return this.cursor_;
        }
        getMarker(e) {
          return this.markers.get(e) || null;
        }
        setCursor(e) {
          this.cursor_ && this.cursor_.getDrawer() && this.cursor_.getDrawer().dispose(), (this.cursor_ = e) && (e = this.workspace.getRenderer().makeMarkerDrawer(this.workspace, this.cursor_), this.cursor_.setDrawer(e), this.setCursorSvg(this.cursor_.getDrawer().createDom()));
        }
        setCursorSvg(e) {
          e ? (this.workspace.getBlockCanvas().appendChild(e), this.cursorSvg_ = e) : this.cursorSvg_ = null;
        }
        setMarkerSvg(e) {
          e ? this.workspace.getBlockCanvas() && (this.cursorSvg_ ? this.workspace.getBlockCanvas().insertBefore(e, this.cursorSvg_) : this.workspace.getBlockCanvas().appendChild(e)) : this.markerSvg_ = null;
        }
        updateMarkers() {
          this.workspace.keyboardAccessibilityMode && this.cursorSvg_ && this.workspace.getCursor().draw();
        }
        dispose() {
          const e = Object.keys(this.markers);
          for (let t = 0, n; n = e[t]; t++)
            this.unregisterMarker(n);
          this.markers.clear(), this.cursor_ && (this.cursor_.dispose(), this.cursor_ = null);
        }
      };
      y_.LOCAL_MARKER = "local_marker_1";
      var As = {};
      As.commonWordPrefix = Tc, As.commonWordSuffix = Us, As.isNumber = r.isNumber$$module$build$src$core$utils$string, As.shortestStringLength = Xa, As.startsWith = EE, As.wrap = r.wrap$$module$build$src$core$utils$string;
      var pu = void 0, f_ = !1, ca = !1, lA = 50, sA = 0, Ss = 0, Yp = 0, Xp = 0, ei = null, C_ = null, Kp = 0, jp = 10, aA = 10, _A = 750, ua = 5, or = null, Nr = {};
      Nr.HOVER_MS = _A, Nr.LIMIT = lA, Nr.MARGINS = ua, Nr.OFFSET_X = Kp, Nr.OFFSET_Y = jp, Nr.RADIUS_OK = aA, Nr.bindMouseEvents = Vs, Nr.block = VT, Nr.createDom = UT, Nr.dispose = mc, Nr.getCustomTooltip = Ac, Nr.getDiv = AE, Nr.getTooltipOfObject = zo, Nr.hide = So, Nr.isVisible = BT, Nr.setCustomTooltip = Ec, Nr.unbindMouseEvents = Jr, Nr.unblock = GT;
      var zp = 0.45, Jp = 0.65, cA = { aqua: "#00ffff", black: "#000000", blue: "#0000ff", fuchsia: "#ff00ff", gray: "#808080", green: "#008000", lime: "#00ff00", maroon: "#800000", navy: "#000080", olive: "#808000", purple: "#800080", red: "#ff0000", silver: "#c0c0c0", teal: "#008080", white: "#ffffff", yellow: "#ffff00" }, Gr = {};
      Gr.blend = jn, Gr.getHsvSaturation = xT, Gr.getHsvValue = Mc, Gr.hexToRgb = gc, Gr.hsvToHex = Lc, Gr.hueToHex = On, Gr.names = cA, Gr.parse = pi, Gr.rgbToHex = ja, Gr.setHsvSaturation = Ic, Gr.setHsvValue = ho;
      var v_ = {};
      v_.checkMessageReferences = Nc, v_.parseBlockColour = xs, v_.replaceMessageReferences = Jt, v_.tokenizeInterpolation = HT;
      var Ta = null, du = null, hs = "", pa = "", gn, ji = {};
      ji.createDom = x, ji.getDiv = Gl, ji.hide = j, ji.hideIfOwner = Ve, ji.isVisible = Ie, ji.positionWithAnchor = cr, ji.repositionForWindowResize = un, ji.show = Q, ji.testOnly_setDiv = xl;
      var lt = class {
        constructor(e, t, n) {
          this.DEFAULT_VALUE = null, this.name = void 0, this.constants_ = this.mouseDownWrapper_ = this.textContent_ = this.textElement_ = this.borderRect_ = this.fieldGroup_ = this.markerSvg_ = this.cursorSvg_ = this.tooltip_ = this.validator_ = null, this.disposed = !1, this.maxDisplayLength = 50, this.sourceBlock_ = null, this.enabled_ = this.visible_ = this.isDirty_ = !0, this.suffixField = this.prefixField = this.clickTarget_ = null, this.EDITABLE = !0, this.SERIALIZABLE = !1, this.CURSOR = "", this.value_ = "DEFAULT_VALUE" in new.target.prototype ? new.target.prototype.DEFAULT_VALUE : this.DEFAULT_VALUE, this.size_ = new It(0, 0), e !== lt.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          e.tooltip && this.setTooltip(Jt(e.tooltip));
        }
        setSourceBlock(e) {
          if (this.sourceBlock_)
            throw Error("Field already bound to a block");
          this.sourceBlock_ = e;
        }
        getConstants() {
          return !this.constants_ && this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying() && this.sourceBlock_.workspace.rendered && (this.constants_ = this.sourceBlock_.workspace.getRenderer().getConstants()), this.constants_;
        }
        getSourceBlock() {
          return this.sourceBlock_;
        }
        init() {
          this.fieldGroup_ || (this.fieldGroup_ = K(G.G, {}), this.isVisible() || (this.fieldGroup_.style.display = "none"), this.sourceBlock_.getSvgRoot().appendChild(this.fieldGroup_), this.initView(), this.updateEditable(), this.setTooltip(this.tooltip_), this.bindEvents_(), this.initModel());
        }
        initView() {
          this.createBorderRect_(), this.createTextElement_();
        }
        initModel() {
        }
        createBorderRect_() {
          this.borderRect_ = K(G.RECT, { rx: this.getConstants().FIELD_BORDER_RECT_RADIUS, ry: this.getConstants().FIELD_BORDER_RECT_RADIUS, x: 0, y: 0, height: this.size_.height, width: this.size_.width, class: "blocklyFieldRect" }, this.fieldGroup_);
        }
        createTextElement_() {
          this.textElement_ = K(G.TEXT, { class: "blocklyText" }, this.fieldGroup_), this.getConstants().FIELD_TEXT_BASELINE_CENTER && this.textElement_.setAttribute("dominant-baseline", "central"), this.textContent_ = document.createTextNode(""), this.textElement_.appendChild(this.textContent_);
        }
        bindEvents_() {
          const e = this.getClickTarget_();
          if (!e)
            throw Error("A click target has not been set.");
          Vs(e), this.mouseDownWrapper_ = ge(e, "pointerdown", this, this.onMouseDown_);
        }
        fromXml(e) {
          this.setValue(e.textContent);
        }
        toXml(e) {
          return e.textContent = this.getValue(), e;
        }
        saveState(e) {
          return e = this.saveLegacyState(lt), e !== null ? e : this.getValue();
        }
        loadState(e) {
          this.loadLegacyState(lt, e) || this.setValue(e);
        }
        saveLegacyState(e) {
          return e.prototype.saveState === this.saveState && e.prototype.toXml !== this.toXml ? (e = r.createElement$$module$build$src$core$utils$xml("field"), e.setAttribute("name", this.name || ""), Xr(this.toXml(e)).replace(' xmlns="https://developers.google.com/blockly/xml"', "")) : null;
        }
        loadLegacyState(e, t) {
          return e.prototype.loadState === this.loadState && e.prototype.fromXml !== this.fromXml ? (this.fromXml(r.textToDom$$module$build$src$core$utils$xml(t)), !0) : !1;
        }
        dispose() {
          Rn(this), Ve(this);
          let e;
          (e = this.getSourceBlock()) != null && e.isDeadOrDying() || _t(this.fieldGroup_), this.disposed = !0;
        }
        updateEditable() {
          const e = this.fieldGroup_, t = this.getSourceBlock();
          this.EDITABLE && e && t && (this.enabled_ && t.isEditable() ? (Re(e, "blocklyEditableText"), Ue(e, "blocklyNonEditableText"), e.style.cursor = this.CURSOR) : (Re(e, "blocklyNonEditableText"), Ue(e, "blocklyEditableText"), e.style.cursor = ""));
        }
        setEnabled(e) {
          this.enabled_ = e, this.updateEditable();
        }
        isEnabled() {
          return this.enabled_;
        }
        isClickable() {
          return this.enabled_ && !!this.sourceBlock_ && this.sourceBlock_.isEditable() && this.showEditor_ !== lt.prototype.showEditor_;
        }
        isCurrentlyEditable() {
          return this.enabled_ && this.EDITABLE && !!this.sourceBlock_ && this.sourceBlock_.isEditable();
        }
        isSerializable() {
          let e = !1;
          return this.name && (this.SERIALIZABLE ? e = !0 : this.EDITABLE && (console.warn("Detected an editable field that was not serializable. Please define SERIALIZABLE property as true on all editable custom fields. Proceeding with serialization."), e = !0)), e;
        }
        isVisible() {
          return this.visible_;
        }
        setVisible(e) {
          if (this.visible_ !== e) {
            this.visible_ = e;
            var t = this.fieldGroup_;
            t && (t.style.display = e ? "block" : "none");
          }
        }
        setValidator(e) {
          this.validator_ = e;
        }
        getValidator() {
          return this.validator_;
        }
        getSvgRoot() {
          return this.fieldGroup_;
        }
        getBorderRect() {
          if (!this.borderRect_)
            throw Error(`The border rectangle is ${this.borderRect_}.`);
          return this.borderRect_;
        }
        getTextElement() {
          if (!this.textElement_)
            throw Error(`The text element is ${this.textElement_}.`);
          return this.textElement_;
        }
        getTextContent() {
          if (!this.textContent_)
            throw Error(`The text content is ${this.textContent_}.`);
          return this.textContent_;
        }
        applyColour() {
        }
        render_() {
          this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_()), this.updateSize_();
        }
        showEditor(e) {
          this.isClickable() && this.showEditor_(e);
        }
        showEditor_(e) {
        }
        repositionForWindowResize() {
          return !1;
        }
        updateSize_(e) {
          const t = this.getConstants();
          e = e !== void 0 ? e : this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
          let n = 2 * e, s = t.FIELD_TEXT_HEIGHT, u = 0;
          this.textElement_ && (u = Kr(
            this.textElement_,
            t.FIELD_TEXT_FONTSIZE,
            t.FIELD_TEXT_FONTWEIGHT,
            t.FIELD_TEXT_FONTFAMILY
          ), n += u), this.borderRect_ && (s = Math.max(s, t.FIELD_BORDER_RECT_HEIGHT)), this.size_.height = s, this.size_.width = n, this.positionTextElement_(e, u), this.positionBorderRect_();
        }
        positionTextElement_(e, t) {
          if (this.textElement_) {
            var n = this.getConstants(), s = this.size_.height / 2, u;
            this.textElement_.setAttribute("x", String((u = this.getSourceBlock()) != null && u.RTL ? this.size_.width - t - e : e)), this.textElement_.setAttribute("y", String(n.FIELD_TEXT_BASELINE_CENTER ? s : s - n.FIELD_TEXT_HEIGHT / 2 + n.FIELD_TEXT_BASELINE));
          }
        }
        positionBorderRect_() {
          this.borderRect_ && (this.borderRect_.setAttribute("width", String(this.size_.width)), this.borderRect_.setAttribute("height", String(this.size_.height)), this.borderRect_.setAttribute("rx", String(this.getConstants().FIELD_BORDER_RECT_RADIUS)), this.borderRect_.setAttribute("ry", String(this.getConstants().FIELD_BORDER_RECT_RADIUS)));
        }
        getSize() {
          return this.isVisible() ? (this.isDirty_ ? (this.render_(), this.isDirty_ = !1) : this.visible_ && this.size_.width === 0 && (this.render_(), this.size_.width !== 0 && console.warn("Deprecated use of setting size_.width to 0 to rerender a field. Set field.isDirty_ to true instead.")), this.size_) : new It(0, 0);
        }
        getScaledBBox() {
          let e;
          var t = this.getSourceBlock();
          if (!t)
            throw new lr();
          if (this.borderRect_) {
            var n = this.borderRect_.getBoundingClientRect();
            e = ci(this.borderRect_), t = n.width, n = n.height;
          } else {
            n = this.sourceBlock_.getHeightWidth();
            const s = t.workspace.scale;
            e = this.getAbsoluteXY_(), t = (n.width + 1) * s, n = (n.height + 1) * s, $p ? (e.x += 1.5 * s, e.y += 1.5 * s) : (e.x -= 0.5 * s, e.y -= 0.5 * s);
          }
          return new yt(e.y, e.y + n, e.x, e.x + t);
        }
        getDisplayText_() {
          let e = this.getText();
          return e ? (e.length > this.maxDisplayLength && (e = e.substring(0, this.maxDisplayLength - 2) + "…"), e = e.replace(/\s/g, lt.NBSP), this.sourceBlock_ && this.sourceBlock_.RTL && (e += "‏"), e) : lt.NBSP;
        }
        getText() {
          const e = this.getText_();
          return String(e !== null ? e : this.getValue());
        }
        getText_() {
          return null;
        }
        markDirty() {
          this.isDirty_ = !0, this.constants_ = null;
        }
        forceRerender() {
          this.isDirty_ = !0, this.sourceBlock_ && this.sourceBlock_.rendered && (this.sourceBlock_.queueRender(), this.sourceBlock_.bumpNeighbours());
        }
        setValue(e, t = !0) {
          if (e !== null) {
            var n = this.doClassValidation_(e);
            if (e = this.processValidation_(e, n), !(e instanceof Error)) {
              var s;
              n = (s = this.getValidator()) == null ? void 0 : s.call(
                this,
                e
              ), s = this.processValidation_(e, n), s instanceof Error || (e = this.sourceBlock_, e && e.disposed || (n = this.getValue(), n === s ? this.doValueUpdate_(s) : (this.doValueUpdate_(s), t && e && nt() && Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(e, "field", this.name || null, n, s)), this.isDirty_ && this.forceRerender())));
            }
          }
        }
        processValidation_(e, t) {
          return t === null ? (this.doValueInvalid_(e), this.isDirty_ && this.forceRerender(), Error()) : t === void 0 ? e : t;
        }
        getValue() {
          return this.value_;
        }
        doClassValidation_(e) {
          return e ?? null;
        }
        doValueUpdate_(e) {
          this.value_ = e, this.isDirty_ = !0;
        }
        doValueInvalid_(e) {
        }
        onMouseDown_(e) {
          this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying() && (e = this.sourceBlock_.workspace.getGesture(e)) && e.setStartField(this);
        }
        setTooltip(e) {
          e || e === "" || (e = this.sourceBlock_);
          const t = this.getClickTarget_();
          t ? t.tooltip = e : this.tooltip_ = e;
        }
        getTooltip() {
          const e = this.getClickTarget_();
          return zo(e || { tooltip: this.tooltip_ });
        }
        getClickTarget_() {
          return this.clickTarget_ || this.getSvgRoot();
        }
        getAbsoluteXY_() {
          return ci(this.getClickTarget_());
        }
        referencesVariables() {
          return !1;
        }
        refreshVariableName() {
        }
        getParentInput() {
          let e = null;
          const t = this.getSourceBlock();
          if (!t)
            throw new lr();
          const n = t.inputList;
          for (let s = 0; s < t.inputList.length; s++) {
            const u = n[s], A = u.fieldRow;
            for (let L = 0; L < A.length; L++)
              if (A[L] === this) {
                e = u;
                break;
              }
          }
          return e;
        }
        getFlipRtl() {
          return !1;
        }
        isTabNavigable() {
          return !1;
        }
        onShortcut(e) {
          return !1;
        }
        setCursorSvg(e) {
          if (e) {
            if (!this.fieldGroup_)
              throw Error(`The field group is ${this.fieldGroup_}.`);
            this.fieldGroup_.appendChild(e), this.cursorSvg_ = e;
          } else
            this.cursorSvg_ = null;
        }
        setMarkerSvg(e) {
          if (e) {
            if (!this.fieldGroup_)
              throw Error(`The field group is ${this.fieldGroup_}.`);
            this.fieldGroup_.appendChild(e), this.markerSvg_ = e;
          } else
            this.markerSvg_ = null;
        }
        updateMarkers_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new lr();
          e = e.workspace, e.keyboardAccessibilityMode && this.cursorSvg_ && e.getCursor().draw(), e.keyboardAccessibilityMode && this.markerSvg_ && e.getMarker(y_.LOCAL_MARKER).draw();
        }
      };
      lt.NBSP = " ", lt.SKIP_SETUP = Symbol("SKIP_SETUP");
      var lr = class extends Error {
        constructor() {
          super("The field has not yet been attached to its input. Call appendField to attach it.");
        }
      }, uA = { fromJsonInternal: Hl }, R_ = {};
      R_.TEST_ONLY = uA, R_.fromJson = r.fromJson$$module$build$src$core$field_registry, R_.register = Vr, R_.unregister = ME;
      var FS = "aria-", BS = "role", Ln;
      (function(e) {
        e.GRID = "grid", e.GRIDCELL = "gridcell", e.GROUP = "group", e.LISTBOX = "listbox", e.MENU = "menu", e.MENUITEM = "menuitem", e.MENUITEMCHECKBOX = "menuitemcheckbox", e.OPTION = "option", e.PRESENTATION = "presentation", e.ROW = "row", e.TREE = "tree", e.TREEITEM = "treeitem";
      })(Ln || (Ln = {}));
      var Dt;
      (function(e) {
        e.ACTIVEDESCENDANT = "activedescendant", e.COLCOUNT = "colcount", e.DISABLED = "disabled", e.EXPANDED = "expanded", e.INVALID = "invalid", e.LABEL = "label", e.LABELLEDBY = "labelledby", e.LEVEL = "level", e.ORIENTATION = "orientation", e.POSINSET = "posinset", e.ROWCOUNT = "rowcount", e.SELECTED = "selected", e.SETSIZE = "setsize", e.VALUEMAX = "valuemax", e.VALUEMIN = "valuemin";
      })(Dt || (Dt = {}));
      var O_ = {};
      O_.Role = Ln, O_.State = Dt, O_.setRole = Tn, O_.setState = gt;
      var Zp = class {
        constructor() {
          this.menuItems = [], this.roleName = this.element = this.onKeyDownHandler = this.mouseLeaveHandler = this.mouseEnterHandler = this.clickHandler = this.mouseOverHandler = this.highlightedItem = this.openingCoords = null;
        }
        addChild(e) {
          this.menuItems.push(e);
        }
        render(e) {
          const t = document.createElement("div");
          t.className = "blocklyMenu goog-menu blocklyNonSelectable", t.tabIndex = 0, this.roleName && Tn(t, this.roleName), this.element = t;
          for (let n = 0, s; s = this.menuItems[n]; n++)
            t.appendChild(s.createDom());
          return this.mouseOverHandler = ge(t, "pointerover", this, this.handleMouseOver, !0), this.clickHandler = ge(t, "pointerup", this, this.handleClick, !0), this.mouseEnterHandler = ge(t, "pointerenter", this, this.handleMouseEnter, !0), this.mouseLeaveHandler = ge(
            t,
            "pointerleave",
            this,
            this.handleMouseLeave,
            !0
          ), this.onKeyDownHandler = ge(t, "keydown", this, this.handleKeyEvent), e.appendChild(t), t;
        }
        getElement() {
          return this.element;
        }
        focus() {
          const e = this.getElement();
          e && (e.focus({ preventScroll: !0 }), Re(e, "blocklyFocused"));
        }
        blur() {
          const e = this.getElement();
          e && (e.blur(), Ue(e, "blocklyFocused"));
        }
        setRole(e) {
          this.roleName = e;
        }
        dispose() {
          this.mouseOverHandler && (Mt(this.mouseOverHandler), this.mouseOverHandler = null), this.clickHandler && (Mt(this.clickHandler), this.clickHandler = null), this.mouseEnterHandler && (Mt(this.mouseEnterHandler), this.mouseEnterHandler = null), this.mouseLeaveHandler && (Mt(this.mouseLeaveHandler), this.mouseLeaveHandler = null), this.onKeyDownHandler && (Mt(this.onKeyDownHandler), this.onKeyDownHandler = null);
          for (let e = 0, t; t = this.menuItems[e]; e++)
            t.dispose();
          this.element = null;
        }
        getMenuItem(e) {
          const t = this.getElement();
          for (; e && e !== t; ) {
            if (e.classList.contains("blocklyMenuItem")) {
              for (let n = 0, s; s = this.menuItems[n]; n++)
                if (s.getElement() === e)
                  return s;
            }
            e = e.parentElement;
          }
          return null;
        }
        setHighlighted(e) {
          var t = this.highlightedItem;
          t && (t.setHighlighted(!1), this.highlightedItem = null), e && (e.setHighlighted(!0), this.highlightedItem = e, t = this.getElement(), nc(
            e.getElement(),
            t
          ), gt(t, Dt.ACTIVEDESCENDANT, e.getId()));
        }
        highlightNext() {
          const e = this.highlightedItem ? this.menuItems.indexOf(this.highlightedItem) : -1;
          this.highlightHelper(e, 1);
        }
        highlightPrevious() {
          const e = this.highlightedItem ? this.menuItems.indexOf(this.highlightedItem) : -1;
          this.highlightHelper(0 > e ? this.menuItems.length : e, -1);
        }
        highlightFirst() {
          this.highlightHelper(-1, 1);
        }
        highlightLast() {
          this.highlightHelper(this.menuItems.length, -1);
        }
        highlightHelper(e, t) {
          e += t;
          let n;
          for (; n = this.menuItems[e]; ) {
            if (n.isEnabled()) {
              this.setHighlighted(n);
              break;
            }
            e += t;
          }
        }
        handleMouseOver(e) {
          (e = this.getMenuItem(e.target)) && (e.isEnabled() ? this.highlightedItem !== e && this.setHighlighted(e) : this.setHighlighted(null));
        }
        handleClick(e) {
          const t = this.openingCoords;
          if (this.openingCoords = null, t && typeof e.clientX == "number") {
            const n = new Te(e.clientX, e.clientY);
            if (1 > Te.distance(t, n))
              return;
          }
          (e = this.getMenuItem(e.target)) && e.performAction();
        }
        handleMouseEnter(e) {
          this.focus();
        }
        handleMouseLeave(e) {
          this.getElement() && (this.blur(), this.setHighlighted(null));
        }
        handleKeyEvent(e) {
          if (this.menuItems.length && !(e.shiftKey || e.ctrlKey || e.metaKey || e.altKey)) {
            var t = this.highlightedItem;
            switch (e.key) {
              case "Enter":
              case " ":
                t && t.performAction();
                break;
              case "ArrowUp":
                this.highlightPrevious();
                break;
              case "ArrowDown":
                this.highlightNext();
                break;
              case "PageUp":
              case "Home":
                this.highlightFirst();
                break;
              case "PageDown":
              case "End":
                this.highlightLast();
                break;
              default:
                return;
            }
            e.preventDefault(), e.stopPropagation();
          }
        }
        getSize() {
          const e = this.getElement(), t = Pa(e);
          return t.height = e.scrollHeight, t;
        }
      }, Qp = class {
        constructor(e, t) {
          this.content = e, this.opt_value = t, this.enabled = !0, this.element = null, this.rightToLeft = !1, this.roleName = null, this.highlight = this.checked = this.checkable = !1, this.actionHandler = null;
        }
        createDom() {
          const e = document.createElement("div");
          e.id = si(), this.element = e, e.className = "blocklyMenuItem goog-menuitem " + (this.enabled ? "" : "blocklyMenuItemDisabled goog-menuitem-disabled ") + (this.checked ? "blocklyMenuItemSelected goog-option-selected " : "") + (this.highlight ? "blocklyMenuItemHighlight goog-menuitem-highlight " : "") + (this.rightToLeft ? "blocklyMenuItemRtl goog-menuitem-rtl " : "");
          const t = document.createElement("div");
          if (t.className = "blocklyMenuItemContent goog-menuitem-content", this.checkable) {
            var n = document.createElement("div");
            n.className = "blocklyMenuItemCheckbox goog-menuitem-checkbox", t.appendChild(n);
          }
          return n = this.content, typeof this.content == "string" && (n = document.createTextNode(this.content)), t.appendChild(n), e.appendChild(t), this.roleName && Tn(e, this.roleName), gt(e, Dt.SELECTED, this.checkable && this.checked || !1), gt(e, Dt.DISABLED, !this.enabled), e;
        }
        dispose() {
          this.element = null;
        }
        getElement() {
          return this.element;
        }
        getId() {
          return this.element.id;
        }
        getValue() {
          let e;
          return (e = this.opt_value) != null ? e : null;
        }
        setRightToLeft(e) {
          this.rightToLeft = e;
        }
        setRole(e) {
          this.roleName = e;
        }
        setCheckable(e) {
          this.checkable = e;
        }
        setChecked(e) {
          this.checked = e;
        }
        setHighlighted(e) {
          this.highlight = e;
          const t = this.getElement();
          t && this.isEnabled() && (e ? (Re(t, "blocklyMenuItemHighlight"), Re(t, "goog-menuitem-highlight")) : (Ue(t, "blocklyMenuItemHighlight"), Ue(t, "goog-menuitem-highlight")));
        }
        isEnabled() {
          return this.enabled;
        }
        setEnabled(e) {
          this.enabled = e;
        }
        performAction() {
          this.isEnabled() && this.actionHandler && this.actionHandler(this);
        }
        onAction(e, t) {
          this.actionHandler = e.bind(t);
        }
      }, zi = class extends lt {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.svgArrow = this.arrow = this.imageElement = this.menu_ = this.selectedMenuItem = null, this.SERIALIZABLE = !0, this.CURSOR = "default", this.clickTarget_ = this.suffixField = this.prefixField = this.generatedOptions = null, e !== lt.SKIP_SETUP && (Array.isArray(e) ? (fc(e), e = mt(e), this.menuGenerator_ = e.options, this.prefixField = e.prefix || null, this.suffixField = e.suffix || null) : this.menuGenerator_ = e, this.selectedOption = this.getOptions(!1)[0], n && this.configure_(n), this.setValue(this.selectedOption[1]), t && this.setValidator(t));
        }
        fromXml(e) {
          this.isOptionListDynamic() && this.getOptions(!1), this.setValue(e.textContent);
        }
        loadState(e) {
          this.loadLegacyState(zi, e) || (this.isOptionListDynamic() && this.getOptions(!1), this.setValue(e));
        }
        initView() {
          this.shouldAddBorderRect_() ? this.createBorderRect_() : this.clickTarget_ = this.sourceBlock_.getSvgRoot(), this.createTextElement_(), this.imageElement = K(G.IMAGE, {}, this.fieldGroup_), this.getConstants().FIELD_DROPDOWN_SVG_ARROW ? this.createSVGArrow_() : this.createTextArrow_(), this.borderRect_ && Re(this.borderRect_, "blocklyDropdownRect");
        }
        shouldAddBorderRect_() {
          let e;
          return !this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW && !((e = this.getSourceBlock()) != null && e.isShadow());
        }
        createTextArrow_() {
          this.arrow = K(G.TSPAN, {}, this.textElement_);
          let e;
          this.arrow.appendChild(document.createTextNode((e = this.getSourceBlock()) != null && e.RTL ? zi.ARROW_CHAR + " " : " " + zi.ARROW_CHAR));
          let t;
          (t = this.getSourceBlock()) != null && t.RTL ? this.getTextElement().insertBefore(this.arrow, this.textContent_) : this.getTextElement().appendChild(this.arrow);
        }
        createSVGArrow_() {
          this.svgArrow = K(G.IMAGE, { height: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px", width: this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE + "px" }, this.fieldGroup_), this.svgArrow.setAttributeNS(
            kn,
            "xlink:href",
            this.getConstants().FIELD_DROPDOWN_SVG_ARROW_DATAURI
          );
        }
        showEditor_(e) {
          var t = this.getSourceBlock();
          if (!t)
            throw new lr();
          this.dropdownCreate(), this.menu_.openingCoords = e && typeof e.clientX == "number" ? new Te(e.clientX, e.clientY) : null, Ga(), e = this.menu_.render(Fl()), Re(e, "blocklyDropdownMenu"), this.getConstants().FIELD_DROPDOWN_COLOURED_DIV && (e = t.isShadow() ? t.getParent().getColour() : t.getColour(), t = t.isShadow() ? t.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary, xa(e, t)), Fs(this, this.dropdownDispose_.bind(this)), this.menu_.focus(), this.selectedMenuItem && (this.menu_.setHighlighted(this.selectedMenuItem), nc(
            this.selectedMenuItem.getElement(),
            Fl(),
            !0
          )), this.applyColour();
        }
        dropdownCreate() {
          const e = this.getSourceBlock();
          if (!e)
            throw new lr();
          const t = new Zp();
          t.setRole(Ln.LISTBOX), this.menu_ = t;
          const n = this.getOptions(!1);
          this.selectedMenuItem = null;
          for (let u = 0; u < n.length; u++) {
            const [A, L] = n[u];
            if (typeof A == "object") {
              var s = new Image(A.width, A.height);
              s.src = A.src, s.alt = A.alt || "";
            } else
              s = A;
            s = new Qp(s, L), s.setRole(Ln.OPTION), s.setRightToLeft(e.RTL), s.setCheckable(!0), t.addChild(s), s.setChecked(L === this.value_), L === this.value_ && (this.selectedMenuItem = s), s.onAction(this.handleMenuActionEvent, this);
          }
        }
        dropdownDispose_() {
          this.menu_ && this.menu_.dispose(), this.selectedMenuItem = this.menu_ = null, this.applyColour();
        }
        handleMenuActionEvent(e) {
          Rn(this, !0), this.onItemSelected_(
            this.menu_,
            e
          );
        }
        onItemSelected_(e, t) {
          this.setValue(t.getValue());
        }
        isOptionListDynamic() {
          return typeof this.menuGenerator_ == "function";
        }
        getOptions(e) {
          if (!this.menuGenerator_)
            throw TypeError("A menu generator was never defined.");
          return Array.isArray(this.menuGenerator_) ? this.menuGenerator_ : e && this.generatedOptions ? this.generatedOptions : (this.generatedOptions = this.menuGenerator_(), fc(this.generatedOptions), this.generatedOptions);
        }
        doClassValidation_(e) {
          return this.getOptions(!0).some((t) => t[1] === e) ? e : (this.sourceBlock_ && console.warn("Cannot set the dropdown's value to an unavailable option. Block type: " + this.sourceBlock_.type + ", Field name: " + this.name + ", Value: " + e), null);
        }
        doValueUpdate_(e) {
          super.doValueUpdate_(e), e = this.getOptions(!0);
          for (let t = 0, n; n = e[t]; t++)
            n[1] === this.value_ && (this.selectedOption = n);
        }
        applyColour() {
          const e = this.sourceBlock_.style;
          this.borderRect_ && (this.borderRect_.setAttribute("stroke", e.colourTertiary), this.menu_ ? this.borderRect_.setAttribute("fill", e.colourTertiary) : this.borderRect_.setAttribute("fill", "transparent")), this.sourceBlock_ && this.arrow && (this.sourceBlock_.isShadow() ? this.arrow.style.fill = e.colourSecondary : this.arrow.style.fill = e.colourPrimary);
        }
        render_() {
          this.getTextContent().nodeValue = "", this.imageElement.style.display = "none";
          const e = this.selectedOption && this.selectedOption[0];
          e && typeof e == "object" ? this.renderSelectedImage(e) : this.renderSelectedText(), this.positionBorderRect_();
        }
        renderSelectedImage(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new lr();
          this.imageElement.style.display = "", this.imageElement.setAttributeNS(kn, "xlink:href", e.src), this.imageElement.setAttribute("height", String(e.height)), this.imageElement.setAttribute("width", String(e.width));
          const n = Number(e.height);
          e = Number(e.width);
          var s = !!this.borderRect_;
          const u = Math.max(s ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, n + VS);
          s = s ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
          let A;
          A = this.svgArrow ? this.positionSVGArrow(e + s, u / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2) : Kr(this.arrow, this.getConstants().FIELD_TEXT_FONTSIZE, this.getConstants().FIELD_TEXT_FONTWEIGHT, this.getConstants().FIELD_TEXT_FONTFAMILY), this.size_.width = e + A + 2 * s, this.size_.height = u;
          let L = 0;
          t.RTL ? this.imageElement.setAttribute("x", `${s + A}`) : (L = e + A, this.getTextElement().setAttribute("text-anchor", "end"), this.imageElement.setAttribute("x", `${s}`)), this.imageElement.setAttribute(
            "y",
            String(u / 2 - n / 2)
          ), this.positionTextElement_(L + s, e + A);
        }
        renderSelectedText() {
          this.getTextContent().nodeValue = this.getDisplayText_();
          var e = this.getTextElement();
          Re(e, "blocklyDropdownText"), e.setAttribute("text-anchor", "start");
          var t = !!this.borderRect_;
          e = Math.max(t ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0, this.getConstants().FIELD_TEXT_HEIGHT);
          const n = Kr(
            this.getTextElement(),
            this.getConstants().FIELD_TEXT_FONTSIZE,
            this.getConstants().FIELD_TEXT_FONTWEIGHT,
            this.getConstants().FIELD_TEXT_FONTFAMILY
          );
          t = t ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
          let s = 0;
          this.svgArrow && (s = this.positionSVGArrow(n + t, e / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2)), this.size_.width = n + s + 2 * t, this.size_.height = e, this.positionTextElement_(t, n);
        }
        positionSVGArrow(e, t) {
          if (!this.svgArrow)
            return 0;
          const n = this.getSourceBlock();
          if (!n)
            throw new lr();
          const s = this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0, u = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING, A = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE;
          return this.svgArrow.setAttribute("transform", "translate(" + (n.RTL ? s : e + u) + "," + t + ")"), A + u;
        }
        getText_() {
          if (!this.selectedOption)
            return null;
          const e = this.selectedOption[0];
          return typeof e == "object" ? e.alt : e;
        }
        static fromJson(e) {
          if (!e.options)
            throw Error("options are required for the dropdown field. The options property must be assigned an array of [humanReadableValue, languageNeutralValue] tuples.");
          return new this(e.options, void 0, e);
        }
      };
      zi.CHECKMARK_OVERHANG = 25, zi.MAX_MENU_HEIGHT_VH = 0.45, zi.ARROW_CHAR = "▾";
      var US = 5, VS = 2 * US;
      Vr("field_dropdown", zi);
      var Eu = class {
        constructor(e) {
          this.sourceBlock = e, this.offsetInBlock = new Te(0, 0), this.workspaceLocation = new Te(0, 0), this.svgRoot = null;
        }
        getType() {
          throw Error("Icons must implement getType");
        }
        initView(e) {
          if (!this.svgRoot) {
            var t = this.sourceBlock;
            this.svgRoot = K(G.G, { class: "blocklyIconGroup" }), t.getSvgRoot().appendChild(this.svgRoot), this.updateSvgRootOffset(), ge(this.svgRoot, "pointerdown", this, e);
          }
        }
        dispose() {
          _t(this.svgRoot);
        }
        getWeight() {
          return -1;
        }
        getSize() {
          return new It(0, 0);
        }
        applyColour() {
        }
        updateEditable() {
        }
        updateCollapsed() {
          this.svgRoot && (this.sourceBlock.isCollapsed() ? this.svgRoot.style.display = "none" : this.svgRoot.style.display = "block", Ko(this) && this.setBubbleVisible(!1));
        }
        hideForInsertionMarker() {
          this.svgRoot && (this.svgRoot.style.display = "none");
        }
        isShownWhenCollapsed() {
          return !1;
        }
        setOffsetInBlock(e) {
          this.offsetInBlock = e, this.updateSvgRootOffset();
        }
        updateSvgRootOffset() {
          let e;
          (e = this.svgRoot) == null || e.setAttribute("transform", `translate(${this.offsetInBlock.x}, ${this.offsetInBlock.y})`);
        }
        onLocationChange(e) {
          this.workspaceLocation = Te.sum(e, this.offsetInBlock);
        }
        onClick() {
        }
        setVisible(e) {
          hr(
            "setVisible",
            "v10",
            "v11",
            "setBubbleVisible"
          ), Ko(this) && this.setBubbleVisible(e);
        }
      }, Zt = class {
        constructor(e, t, n, s, u) {
          this.workspace = e, this.horizontal = t, this.oldHostMetrics = null, this.ratio = 1, this.origin = new Te(0, 0), this.startDragHandle = this.handlePosition = this.handleLength = this.scrollbarLength = this.startDragMouse = 0, this.containerVisible = this.isHandleVisible = !0, this.position = new Te(0, 0), this.onMouseMoveWrapper_ = this.onMouseUpWrapper_ = null, this.pair = n || !1, this.margin = u !== void 0 ? u : Zt.DEFAULT_SCROLLBAR_MARGIN, e = "blocklyScrollbar" + (this.horizontal ? "Horizontal" : "Vertical"), s && (e += " " + s), this.outerSvg = K(G.SVG, { class: e }), s = K(G.G, {}, this.outerSvg), this.svgBackground = K(
            G.RECT,
            { class: "blocklyScrollbarBackground" },
            s
          ), e = Math.floor((Zt.scrollbarThickness - 5) / 2), this.svgHandle = K(G.RECT, { class: "blocklyScrollbarHandle", rx: e, ry: e }, s), this.workspace.getThemeManager().subscribe(this.svgHandle, "scrollbarColour", "fill"), this.workspace.getThemeManager().subscribe(this.svgHandle, "scrollbarOpacity", "fill-opacity"), mr(
            this.outerSvg,
            this.workspace.getParentSvg()
          ), this.setInitialThickness(), t ? (this.lengthAttribute_ = "width", this.positionAttribute_ = "x") : (this.lengthAttribute_ = "height", this.positionAttribute_ = "y"), this.onMouseDownBarWrapper_ = ge(this.svgBackground, "pointerdown", this, this.onMouseDownBar), this.onMouseDownHandleWrapper_ = ge(this.svgHandle, "pointerdown", this, this.onMouseDownHandle);
        }
        setInitialThickness() {
          const e = Zt.scrollbarThickness;
          this.horizontal ? (this.svgBackground.setAttribute("height", String(e)), this.outerSvg.setAttribute("height", String(e)), this.svgHandle.setAttribute("height", String(e - 5)), this.svgHandle.setAttribute("y", "2.5")) : (this.svgBackground.setAttribute("width", String(e)), this.outerSvg.setAttribute("width", String(e)), this.svgHandle.setAttribute("width", String(e - 5)), this.svgHandle.setAttribute("x", "2.5"));
        }
        dispose() {
          this.cleanUp(), Mt(this.onMouseDownBarWrapper_), Mt(this.onMouseDownHandleWrapper_), _t(this.outerSvg), this.workspace.getThemeManager().unsubscribe(this.svgHandle);
        }
        constrainHandleLength(e) {
          return e = 0 >= e || isNaN(e) ? 0 : Math.min(e, this.scrollbarLength);
        }
        setHandleLength(e) {
          this.handleLength = e, this.svgHandle.setAttribute(this.lengthAttribute_, String(this.handleLength));
        }
        constrainHandlePosition(e) {
          return e = 0 >= e || isNaN(e) ? 0 : Math.min(e, this.scrollbarLength - this.handleLength);
        }
        setHandlePosition(e) {
          this.handlePosition = e, this.svgHandle.setAttribute(
            this.positionAttribute_,
            String(this.handlePosition)
          );
        }
        setScrollbarLength(e) {
          this.scrollbarLength = e, this.outerSvg.setAttribute(this.lengthAttribute_, String(this.scrollbarLength)), this.svgBackground.setAttribute(this.lengthAttribute_, String(this.scrollbarLength));
        }
        setPosition(e, t) {
          this.position.x = e, this.position.y = t, bi(this.outerSvg, "translate(" + (this.position.x + this.origin.x) + "px," + (this.position.y + this.origin.y) + "px)");
        }
        resize(e) {
          !e && (e = this.workspace.getMetrics(), !e) || this.oldHostMetrics && Zt.metricsAreEquivalent(e, this.oldHostMetrics) || (this.horizontal ? this.resizeHorizontal(e) : this.resizeVertical(e), this.oldHostMetrics = e, this.updateMetrics());
        }
        requiresViewResize(e) {
          return this.oldHostMetrics ? this.oldHostMetrics.viewWidth !== e.viewWidth || this.oldHostMetrics.viewHeight !== e.viewHeight || this.oldHostMetrics.absoluteLeft !== e.absoluteLeft || this.oldHostMetrics.absoluteTop !== e.absoluteTop : !0;
        }
        resizeHorizontal(e) {
          this.requiresViewResize(e) ? this.resizeViewHorizontal(e) : this.resizeContentHorizontal(e);
        }
        resizeViewHorizontal(e) {
          var t = e.viewWidth - 2 * this.margin;
          this.pair && (t -= Zt.scrollbarThickness), this.setScrollbarLength(Math.max(0, t)), t = e.absoluteLeft + this.margin, this.pair && this.workspace.RTL && (t += Zt.scrollbarThickness), this.setPosition(t, e.absoluteTop + e.viewHeight - Zt.scrollbarThickness - this.margin), this.resizeContentHorizontal(e);
        }
        resizeContentHorizontal(e) {
          if (e.viewWidth >= e.scrollWidth)
            this.setHandleLength(this.scrollbarLength), this.setHandlePosition(0), this.pair || this.setVisible(!1);
          else {
            this.pair || this.setVisible(!0);
            var t = this.scrollbarLength * e.viewWidth / e.scrollWidth;
            t = this.constrainHandleLength(t), this.setHandleLength(t), t = e.scrollWidth - e.viewWidth;
            var n = this.scrollbarLength - this.handleLength;
            e = (e.viewLeft - e.scrollLeft) / t * n, e = this.constrainHandlePosition(e), this.setHandlePosition(e), this.ratio = n / t;
          }
        }
        resizeVertical(e) {
          this.requiresViewResize(e) ? this.resizeViewVertical(e) : this.resizeContentVertical(e);
        }
        resizeViewVertical(e) {
          let t = e.viewHeight - 2 * this.margin;
          this.pair && (t -= Zt.scrollbarThickness), this.setScrollbarLength(Math.max(0, t)), this.setPosition(this.workspace.RTL ? e.absoluteLeft + this.margin : e.absoluteLeft + e.viewWidth - Zt.scrollbarThickness - this.margin, e.absoluteTop + this.margin), this.resizeContentVertical(e);
        }
        resizeContentVertical(e) {
          if (e.viewHeight >= e.scrollHeight)
            this.setHandleLength(this.scrollbarLength), this.setHandlePosition(0), this.pair || this.setVisible(!1);
          else {
            this.pair || this.setVisible(!0);
            var t = this.scrollbarLength * e.viewHeight / e.scrollHeight;
            t = this.constrainHandleLength(t), this.setHandleLength(t), t = e.scrollHeight - e.viewHeight;
            var n = this.scrollbarLength - this.handleLength;
            e = (e.viewTop - e.scrollTop) / t * n, e = this.constrainHandlePosition(e), this.setHandlePosition(e), this.ratio = n / t;
          }
        }
        isVisible() {
          return this.isHandleVisible;
        }
        setContainerVisible(e) {
          const t = e !== this.containerVisible;
          this.containerVisible = e, t && this.updateDisplay_();
        }
        setVisible(e) {
          const t = e !== this.isVisible();
          if (this.pair)
            throw Error("Unable to toggle visibility of paired scrollbars.");
          this.isHandleVisible = e, t && this.updateDisplay_();
        }
        updateDisplay_() {
          this.containerVisible && this.isVisible() ? this.outerSvg.setAttribute("display", "block") : this.outerSvg.setAttribute("display", "none");
        }
        onMouseDownBar(e) {
          if (this.workspace.markFocused(), Me(), this.cleanUp(), Xo(e))
            e.stopPropagation();
          else {
            var t = $l(e, this.workspace.getParentSvg(), this.workspace.getInverseScreenCTM());
            t = this.horizontal ? t.x : t.y;
            var n = $a(this.svgHandle);
            n = this.horizontal ? n.x : n.y;
            var s = this.handlePosition, u = 0.95 * this.handleLength;
            t <= n ? s -= u : t >= n + this.handleLength && (s += u), this.setHandlePosition(this.constrainHandlePosition(s)), this.updateMetrics(), e.stopPropagation(), e.preventDefault();
          }
        }
        onMouseDownHandle(e) {
          this.workspace.markFocused(), this.cleanUp(), Xo(e) ? e.stopPropagation() : (this.startDragHandle = this.handlePosition, this.startDragMouse = this.horizontal ? e.clientX : e.clientY, this.onMouseUpWrapper_ = ge(document, "pointerup", this, this.onMouseUpHandle), this.onMouseMoveWrapper_ = ge(document, "pointermove", this, this.onMouseMoveHandle), e.stopPropagation(), e.preventDefault());
        }
        onMouseMoveHandle(e) {
          this.setHandlePosition(this.constrainHandlePosition(this.startDragHandle + ((this.horizontal ? e.clientX : e.clientY) - this.startDragMouse))), this.updateMetrics();
        }
        onMouseUpHandle() {
          Me(), this.cleanUp();
        }
        cleanUp() {
          this.workspace.hideChaff(!0), this.onMouseUpWrapper_ && (Mt(this.onMouseUpWrapper_), this.onMouseUpWrapper_ = null), this.onMouseMoveWrapper_ && (Mt(this.onMouseMoveWrapper_), this.onMouseMoveWrapper_ = null);
        }
        getRatio_() {
          let e = this.handlePosition / (this.scrollbarLength - this.handleLength);
          return isNaN(e) && (e = 0), e;
        }
        updateMetrics() {
          const e = this.getRatio_();
          this.horizontal ? this.workspace.setMetrics({ x: e }) : this.workspace.setMetrics({ y: e });
        }
        set(e, t) {
          this.setHandlePosition(this.constrainHandlePosition(e * this.ratio)), (t || t === void 0) && this.updateMetrics();
        }
        setOrigin(e, t) {
          this.origin = new Te(e, t);
        }
        static metricsAreEquivalent(e, t) {
          return e.viewWidth === t.viewWidth && e.viewHeight === t.viewHeight && e.viewLeft === t.viewLeft && e.viewTop === t.viewTop && e.absoluteTop === t.absoluteTop && e.absoluteLeft === t.absoluteLeft && e.scrollWidth === t.scrollWidth && e.scrollHeight === t.scrollHeight && e.scrollLeft === t.scrollLeft && e.scrollTop === t.scrollTop;
        }
      };
      Zt.scrollbarThickness = tu ? 25 : 15, Zt.DEFAULT_SCROLLBAR_MARGIN = 0.5;
      var Au, je = class {
        constructor(e, t, n) {
          this.workspace = e, this.anchor = t, this.ownerRect = n, this.size = new It(0, 0), this.colour = "#ffffff", this.disposed = !1, this.relativeLeft = this.relativeTop = 0, this.svgRoot = K(G.G, {}, e.getBubbleCanvas()), e = K(
            G.G,
            { filter: `url(#${this.workspace.getRenderer().getConstants().embossFilterId})` },
            this.svgRoot
          ), this.tail = K(G.PATH, {}, e), this.background = K(G.RECT, { class: "blocklyDraggable", x: 0, y: 0, rx: je.BORDER_WIDTH, ry: je.BORDER_WIDTH }, e), this.contentContainer = K(
            G.G,
            {},
            this.svgRoot
          ), ge(this.background, "pointerdown", this, this.onMouseDown);
        }
        dispose() {
          _t(this.svgRoot), this.disposed = !0;
        }
        setAnchorLocation(e, t = !1) {
          this.anchor = e, t ? this.positionByRect(this.ownerRect) : this.positionRelativeToAnchor(), this.renderTail();
        }
        setPositionRelativeToAnchor(e, t) {
          this.relativeLeft = e, this.relativeTop = t, this.positionRelativeToAnchor(), this.renderTail();
        }
        getSize() {
          return this.size;
        }
        setSize(e, t = !1) {
          e.width = Math.max(e.width, je.MIN_SIZE), e.height = Math.max(e.height, je.MIN_SIZE), this.size = e, this.background.setAttribute("width", `${e.width}`), this.background.setAttribute("height", `${e.height}`), t ? this.positionByRect(this.ownerRect) : this.positionRelativeToAnchor(), this.renderTail();
        }
        getColour() {
          return this.colour;
        }
        setColour(e) {
          this.colour = e, this.tail.setAttribute("fill", e), this.background.setAttribute("fill", e);
        }
        onMouseDown(e) {
          let t;
          (t = this.workspace.getGesture(e)) == null || t.handleBubbleStart(e, this);
        }
        positionRelativeToAnchor() {
          let e = this.anchor.x;
          e = this.workspace.RTL ? e - (this.relativeLeft + this.size.width) : e + this.relativeLeft, this.moveTo(e, this.relativeTop + this.anchor.y);
        }
        moveTo(e, t) {
          this.svgRoot.setAttribute("transform", `translate(${e}, ${t})`);
        }
        positionByRect(e = new yt(0, 0, 0, 0)) {
          var t = this.workspace.getMetricsManager().getViewMetrics(!0), n = this.getOptimalRelativeLeft(t), s = this.getOptimalRelativeTop(t);
          const u = { x: n, y: -this.size.height - this.workspace.getRenderer().getConstants().MIN_BLOCK_HEIGHT }, A = { x: -this.size.width - 30, y: s };
          s = { x: e.getWidth(), y: s };
          var L = { x: n, y: e.getHeight() };
          n = e.getWidth() < e.getHeight() ? s : L, e = e.getWidth() < e.getHeight() ? L : s, s = this.getOverlap(u, t), L = this.getOverlap(A, t);
          const $ = this.getOverlap(n, t);
          t = this.getOverlap(e, t), t = Math.max(s, L, $, t), s === t ? (this.relativeLeft = u.x, this.relativeTop = u.y) : L === t ? (this.relativeLeft = A.x, this.relativeTop = A.y) : $ === t ? (this.relativeLeft = n.x, this.relativeTop = n.y) : (this.relativeLeft = e.x, this.relativeTop = e.y), this.positionRelativeToAnchor();
        }
        getOverlap(e, t) {
          var n = this.workspace.RTL ? this.anchor.x - e.x - this.size.width : e.x + this.anchor.x;
          return e = e.y + this.anchor.y, Math.max(0, Math.min(1, (Math.min(n + this.size.width, t.left + t.width) - Math.max(n, t.left)) * (Math.min(e + this.size.height, t.top + t.height) - Math.max(e, t.top)) / (this.size.width * this.size.height)));
        }
        getOptimalRelativeLeft(e) {
          let t = -this.size.width / 4;
          if (this.size.width > e.width)
            return t;
          if (e = this.getWorkspaceViewRect(e), this.workspace.RTL) {
            var n = this.anchor.x - t;
            n - this.size.width < e.left ? t = -(e.left - this.anchor.x + this.size.width) : n > e.right && (t = -(e.right - this.anchor.x));
          } else {
            n = t + this.anchor.x;
            const s = n + this.size.width;
            n < e.left ? t = e.left - this.anchor.x : s > e.right && (t = e.right - this.anchor.x - this.size.width);
          }
          return t;
        }
        getOptimalRelativeTop(e) {
          let t = -this.size.height / 4;
          if (this.size.height > e.height)
            return t;
          const n = this.anchor.y + t, s = n + this.size.height;
          return e = this.getWorkspaceViewRect(e), n < e.top ? t = e.top - this.anchor.y : s > e.bottom && (t = e.bottom - this.anchor.y - this.size.height), t;
        }
        getWorkspaceViewRect(e) {
          const t = e.top;
          let n = e.top + e.height, s = e.left;
          return e = e.left + e.width, n -= this.getScrollbarThickness(), this.workspace.RTL ? s -= this.getScrollbarThickness() : e -= this.getScrollbarThickness(), new yt(t, n, s, e);
        }
        getScrollbarThickness() {
          return Zt.scrollbarThickness / this.workspace.scale;
        }
        renderTail() {
          const e = [];
          var t = this.size.width / 2, n = this.size.height / 2, s = -this.relativeLeft, u = -this.relativeTop;
          if (t === s && n === u)
            e.push("M " + t + "," + n);
          else {
            u -= n, s -= t, this.workspace.RTL && (s *= -1);
            var A = Math.sqrt(u * u + s * s), L = Math.acos(s / A);
            0 > u && (L = 2 * Math.PI - L);
            var $ = L + Math.PI / 2;
            $ > 2 * Math.PI && ($ -= 2 * Math.PI);
            var q = Math.sin($);
            const _r = Math.cos($);
            let Bt = (this.size.width + this.size.height) / je.TAIL_THICKNESS;
            Bt = Math.min(Bt, this.size.width, this.size.height) / 4, $ = 1 - je.ANCHOR_RADIUS / A, s = t + $ * s, u = n + $ * u, $ = t + Bt * _r;
            const oi = n + Bt * q;
            t -= Bt * _r, n -= Bt * q, q = jo(this.workspace.RTL ? -je.TAIL_ANGLE : je.TAIL_ANGLE), q = L + q, q > 2 * Math.PI && (q -= 2 * Math.PI), L = Math.sin(q) * A / je.TAIL_BEND, A = Math.cos(q) * A / je.TAIL_BEND, e.push("M" + $ + "," + oi), e.push("C" + ($ + A) + "," + (oi + L) + " " + s + "," + u + " " + s + "," + u), e.push("C" + s + "," + u + " " + (t + A) + "," + (n + L) + " " + t + "," + n);
          }
          e.push("z");
          let Le;
          (Le = this.tail) == null || Le.setAttribute("d", e.join(" "));
        }
        bringToFront() {
          let e;
          const t = (e = this.svgRoot) == null ? void 0 : e.parentNode;
          return this.svgRoot && (t == null ? void 0 : t.lastChild) !== this.svgRoot ? (t == null || t.appendChild(this.svgRoot), !0) : !1;
        }
        getRelativeToSurfaceXY() {
          return new Te(this.workspace.RTL ? -this.relativeLeft + this.anchor.x - this.size.width : this.anchor.x + this.relativeLeft, this.anchor.y + this.relativeTop);
        }
        getSvgRoot() {
          return this.svgRoot;
        }
        moveDuringDrag(e) {
          this.moveTo(
            e.x,
            e.y
          ), this.relativeLeft = this.workspace.RTL ? this.anchor.x - e.x - this.size.width : e.x - this.anchor.x, this.relativeTop = e.y - this.anchor.y, this.renderTail();
        }
        setDragging(e) {
        }
        setDeleteStyle(e) {
        }
        isDeletable() {
          return !1;
        }
        showContextMenu(e) {
        }
      };
      Au = je, je.BORDER_WIDTH = 6, je.DOUBLE_BORDER = 2 * Au.BORDER_WIDTH, je.MIN_SIZE = Au.DOUBLE_BORDER, je.TAIL_THICKNESS = 1, je.TAIL_ANGLE = 20, je.TAIL_BEND = 4, je.ANCHOR_RADIUS = 8;
      var TA = {};
      TA.deepMerge = zn;
      var ms = class {
        constructor(e, t, n, s) {
          this.name = e, this.startHats = !1, this.blockStyles = t || /* @__PURE__ */ Object.create(null), this.categoryStyles = n || /* @__PURE__ */ Object.create(null), this.componentStyles = s || /* @__PURE__ */ Object.create(null), this.fontStyle = /* @__PURE__ */ Object.create(null), o(_e.THEME, e, this, !0);
        }
        getClassName() {
          return this.name + "-theme";
        }
        setBlockStyle(e, t) {
          this.blockStyles[e] = t;
        }
        setCategoryStyle(e, t) {
          this.categoryStyles[e] = t;
        }
        getComponentStyle(e) {
          if (e = this.componentStyles[e], !e)
            return null;
          if (typeof e == "string") {
            const t = this.getComponentStyle(e);
            if (t)
              return t;
          }
          return `${e}`;
        }
        setComponentStyle(e, t) {
          this.componentStyles[e] = t;
        }
        setFontStyle(e) {
          this.fontStyle = e;
        }
        setStartHats(e) {
          this.startHats = e;
        }
        static defineTheme(e, t) {
          e = e.toLowerCase();
          const n = new ms(e);
          let s = t.base;
          if (s) {
            if (typeof s == "string") {
              let u;
              s = (u = b(_e.THEME, s)) != null ? u : void 0;
            }
            s instanceof ms && (zn(n, s), n.name = e);
          }
          return zn(n.blockStyles, t.blockStyles), zn(n.categoryStyles, t.categoryStyles), zn(n.componentStyles, t.componentStyles), zn(n.fontStyle, t.fontStyle), t.startHats !== null && (n.startHats = t.startHats), n;
        }
      }, GS = { colour_blocks: { colourPrimary: "20" }, list_blocks: { colourPrimary: "260" }, logic_blocks: { colourPrimary: "210" }, loop_blocks: { colourPrimary: "120" }, math_blocks: { colourPrimary: "230" }, procedure_blocks: { colourPrimary: "290" }, text_blocks: { colourPrimary: "160" }, variable_blocks: { colourPrimary: "330" }, variable_dynamic_blocks: { colourPrimary: "310" }, hat_blocks: { colourPrimary: "330", hat: "cap" } }, Su = {
        colour_category: { colour: "20" },
        list_category: { colour: "260" },
        logic_category: { colour: "210" },
        loop_category: { colour: "120" },
        math_category: { colour: "230" },
        procedure_category: { colour: "290" },
        text_category: { colour: "160" },
        variable_category: { colour: "330" },
        variable_dynamic_category: { colour: "310" }
      }, hu = new ms("classic", GS, Su), qp = "categoryToolbox", pA = "flyoutToolbox", Ge;
      (function(e) {
        e[e.TOP = 0] = "TOP", e[e.BOTTOM = 1] = "BOTTOM", e[e.LEFT = 2] = "LEFT", e[e.RIGHT = 3] = "RIGHT";
      })(Ge || (Ge = {}));
      var dA = { hasCategoriesInternal: mo }, Al = {};
      Al.Position = Ge, Al.TEST_ONLY = dA, Al.convertFlyoutDefToJsonArray = Ja, Al.convertToolboxDefToJson = Cc, Al.hasCategories = Yl, Al.isCategoryCollapsible = Xl, Al.parseToolboxTree = Rc;
      var ti = class {
        constructor(e) {
          this.gridPattern = null, this.getMetrics = this.setMetrics = void 0;
          let t = null, n = !1;
          var s = !1, u = !1, A = !1, L = !1, $ = !1;
          const q = !!e.readOnly;
          if (!q) {
            var Le;
            t = Cc((Le = e.toolbox) != null ? Le : null), n = Yl(t), s = e.trashcan, s = s === void 0 ? n : s, u = e.collapse, u = u === void 0 ? n : u, A = e.comments, A = A === void 0 ? n : A, L = e.disable, L = L === void 0 ? n : L, $ = e.sounds, $ = $ === void 0 ? !0 : $;
          }
          Le = e.maxTrashcanContents, s ? Le === void 0 && (Le = 32) : Le = 0;
          const _r = !!e.rtl;
          let Bt = e.horizontalLayout;
          Bt === void 0 && (Bt = !1);
          var oi = e.toolboxPosition !== "end";
          oi = Bt ? oi ? Ge.TOP : Ge.BOTTOM : oi === _r ? Ge.RIGHT : Ge.LEFT;
          let ju = e.css;
          ju === void 0 && (ju = !0);
          let zu = "https://blockly-demo.appspot.com/static/media/";
          e.media ? zu = e.media.endsWith("/") ? e.media : e.media + "/" : "path" in e && (hr("path", "Nov 2014", "Jul 2023", "media"), zu = e.path + "media/");
          const om = e.oneBasedIndex, VM = e.renderer || "geras", GM = e.plugins || {};
          let th = e.modalInputs;
          th === void 0 && (th = !0), this.RTL = _r, this.oneBasedIndex = om === void 0 ? !0 : om, this.collapse = u, this.comments = A, this.disable = L, this.readOnly = q, this.maxBlocks = e.maxBlocks || 1 / 0;
          let lm;
          this.maxInstances = (lm = e.maxInstances) != null ? lm : null, this.modalInputs = th, this.pathToMedia = zu, this.hasCategories = n, this.moveOptions = ti.parseMoveOptions_(
            e,
            n
          ), this.hasScrollbars = !!this.moveOptions.scrollbars, this.hasTrashcan = s, this.maxTrashcanContents = Le, this.hasSounds = $, this.hasCss = ju, this.horizontalLayout = Bt, this.languageTree = t, this.gridOptions = ti.parseGridOptions_(e), this.zoomOptions = ti.parseZoomOptions_(e), this.toolboxPosition = oi, this.theme = ti.parseThemeOptions_(e), this.renderer = VM;
          let sm;
          this.rendererOverrides = (sm = e.rendererOverrides) != null ? sm : null;
          let am;
          this.parentWorkspace = (am = e.parentWorkspace) != null ? am : null, this.plugins = GM;
        }
        static parseMoveOptions_(e, t) {
          const n = e.move || {}, s = {};
          return n.scrollbars === void 0 && e.scrollbars === void 0 ? s.scrollbars = t : typeof n.scrollbars == "object" ? (s.scrollbars = { horizontal: !!n.scrollbars.horizontal, vertical: !!n.scrollbars.vertical }, s.scrollbars.horizontal && s.scrollbars.vertical ? s.scrollbars = !0 : s.scrollbars.horizontal || s.scrollbars.vertical || (s.scrollbars = !1)) : s.scrollbars = !!n.scrollbars || !!e.scrollbars, s.wheel = s.scrollbars && n.wheel !== void 0 ? !!n.wheel : typeof s.scrollbars == "object", s.drag = s.scrollbars ? n.drag === void 0 ? !0 : !!n.drag : !1, s;
        }
        static parseZoomOptions_(e) {
          e = e.zoom || {};
          const t = {};
          return t.controls = e.controls === void 0 ? !1 : !!e.controls, t.wheel = e.wheel === void 0 ? !1 : !!e.wheel, t.startScale = e.startScale === void 0 ? 1 : Number(e.startScale), t.maxScale = e.maxScale === void 0 ? 3 : Number(e.maxScale), t.minScale = e.minScale === void 0 ? 0.3 : Number(e.minScale), t.scaleSpeed = e.scaleSpeed === void 0 ? 1.2 : Number(e.scaleSpeed), t.pinch = e.pinch === void 0 ? t.wheel || t.controls : !!e.pinch, t;
        }
        static parseGridOptions_(e) {
          e = e.grid || {};
          const t = {};
          return t.spacing = Number(e.spacing) || 0, t.colour = e.colour || "#888", t.length = e.length === void 0 ? 1 : Number(e.length), t.snap = 0 < t.spacing && !!e.snap, t;
        }
        static parseThemeOptions_(e) {
          return e = e.theme || hu, typeof e == "string" ? b(_e.THEME, e) : e instanceof ms ? e : ms.defineTheme(e.name || "builtin" + si(), e);
        }
      }, Po = class extends je {
        constructor(e, t, n, s) {
          super(t, n, s), this.workspace = t, this.anchor = n, this.ownerRect = s, this.autoLayout = !0, t = new ti(e), this.validateWorkspaceOptions(t), this.svgDialog = K(
            G.SVG,
            { x: je.BORDER_WIDTH, y: je.BORDER_WIDTH },
            this.contentContainer
          ), e.parentWorkspace = this.workspace, this.miniWorkspace = this.newWorkspaceSvg(new ti(e)), e = this.miniWorkspace.createDom("blocklyMutatorBackground"), this.svgDialog.appendChild(e), t.languageTree && (e.insertBefore(this.miniWorkspace.addFlyout(G.G), this.miniWorkspace.getCanvas()), e = this.miniWorkspace.getFlyout(), e == null || e.init(this.miniWorkspace), e == null || e.show(t.languageTree)), this.miniWorkspace.addChangeListener(this.onWorkspaceChange.bind(this));
          let u, A;
          (u = this.miniWorkspace.getFlyout()) == null || (A = u.getWorkspace()) == null || A.addChangeListener(this.onWorkspaceChange.bind(this)), this.updateBubbleSize();
        }
        dispose() {
          this.miniWorkspace.dispose(), super.dispose();
        }
        getWorkspace() {
          return this.miniWorkspace;
        }
        addWorkspaceChangeListener(e) {
          this.miniWorkspace.addChangeListener(e);
        }
        validateWorkspaceOptions(e) {
          if (e.hasCategories)
            throw Error("The miniworkspace bubble does not support toolboxes with categories");
          if (e.hasTrashcan)
            throw Error("The miniworkspace bubble does not support trashcans");
          if (e.zoomOptions.controls || e.zoomOptions.wheel || e.zoomOptions.pinch)
            throw Error("The miniworkspace bubble does not support zooming");
          if (e.moveOptions.scrollbars || e.moveOptions.wheel || e.moveOptions.drag)
            throw Error("The miniworkspace bubble does not scrolling/moving the workspace");
          if (e.horizontalLayout)
            throw Error("The miniworkspace bubble does not support horizontal layouts");
        }
        onWorkspaceChange() {
          this.bumpBlocksIntoBounds(), this.updateBubbleSize();
        }
        bumpBlocksIntoBounds() {
          if (!this.miniWorkspace.isDragging())
            for (const e of this.miniWorkspace.getTopBlocks(!1)) {
              const t = e.getRelativeToSurfaceXY();
              if (20 > t.y && e.moveBy(0, 20 - t.y), e.RTL) {
                let n = -20;
                const s = this.miniWorkspace.getFlyout();
                s && (n -= s.getWidth()), t.x > n && e.moveBy(n - t.x, 0);
              } else
                20 > t.x && e.moveBy(20 - t.x, 0);
            }
        }
        updateBubbleSize() {
          if (!this.miniWorkspace.isDragging()) {
            var e = this.getSize(), t = this.calculateWorkspaceSize();
            Math.abs(e.width - t.width) < Po.MINIMUM_VIEW_CHANGE && Math.abs(e.height - t.height) < Po.MINIMUM_VIEW_CHANGE || (this.svgDialog.setAttribute("width", `${t.width}px`), this.svgDialog.setAttribute("height", `${t.height}px`), this.miniWorkspace.setCachedParentSvgSize(t.width, t.height), this.miniWorkspace.RTL && this.miniWorkspace.getCanvas().setAttribute("transform", `translate(${t.width}, 0)`), this.setSize(new It(t.width + je.DOUBLE_BORDER, t.height + je.DOUBLE_BORDER), this.autoLayout), this.miniWorkspace.resize(), this.miniWorkspace.recordDragTargets());
          }
        }
        calculateWorkspaceSize() {
          const e = this.miniWorkspace.getCanvas().getBBox();
          let t = e.width + e.x, n = e.height + Po.MARGIN;
          const s = this.miniWorkspace.getFlyout();
          if (s) {
            const u = s.getWorkspace().getMetricsManager().getScrollMetrics();
            n = Math.max(n, u.height + 20), t += s.getWidth();
          }
          return this.miniWorkspace.RTL && (t = -e.x), t += Po.MARGIN, new It(
            t,
            n
          );
        }
        updateBlockStyles() {
          for (var e of this.miniWorkspace.getAllBlocks(!1))
            e.setStyle(e.getStyleName());
          let t;
          if (e = (t = this.miniWorkspace.getFlyout()) == null ? void 0 : t.getWorkspace())
            for (const n of e.getAllBlocks(!1))
              n.setStyle(n.getStyleName());
        }
        moveDuringDrag(e) {
          super.moveDuringDrag(e), this.autoLayout = !1;
        }
        moveTo(e, t) {
          super.moveTo(e, t), this.miniWorkspace.recordDragTargets();
        }
        newWorkspaceSvg(e) {
          throw Error("The implementation of newWorkspaceSvg should be monkey-patched in by blockly.ts");
        }
      };
      Po.MINIMUM_VIEW_CHANGE = 10, Po.MARGIN = 3 * je.DOUBLE_BORDER;
      var mu, Iu;
      mu = 17, Iu = 16, r.MutatorIcon$$module$build$src$core$icons$mutator_icon = class extends Eu {
        constructor(e, t) {
          super(t), this.flyoutBlockTypes = e, this.sourceBlock = t, this.updateWorkspacePid = this.rootBlock = this.miniWorkspaceBubble = null;
        }
        getType() {
          return r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE;
        }
        initView(e) {
          this.svgRoot || (super.initView(e), K(G.RECT, {
            class: "blocklyIconShape",
            rx: "4",
            ry: "4",
            height: "16",
            width: "16"
          }, this.svgRoot), K(
            G.PATH,
            { class: "blocklyIconSymbol", d: "m4.203,7.296 0,1.368 -0.92,0.677 -0.11,0.41 0.9,1.559 0.41,0.11 1.043,-0.457 1.187,0.683 0.127,1.134 0.3,0.3 1.8,0 0.3,-0.299 0.127,-1.138 1.185,-0.682 1.046,0.458 0.409,-0.11 0.9,-1.559 -0.11,-0.41 -0.92,-0.677 0,-1.366 0.92,-0.677 0.11,-0.41 -0.9,-1.559 -0.409,-0.109 -1.046,0.458 -1.185,-0.682 -0.127,-1.138 -0.3,-0.299 -1.8,0 -0.3,0.3 -0.126,1.135 -1.187,0.682 -1.043,-0.457 -0.41,0.11 -0.899,1.559 0.108,0.409z" },
            this.svgRoot
          ), K(G.CIRCLE, { class: "blocklyIconShape", r: "2.7", cx: "8", cy: "8" }, this.svgRoot));
        }
        dispose() {
          super.dispose();
          let e;
          (e = this.miniWorkspaceBubble) == null || e.dispose();
        }
        getWeight() {
          return r.MutatorIcon$$module$build$src$core$icons$mutator_icon.WEIGHT;
        }
        getSize() {
          return new It(mu, mu);
        }
        applyColour() {
          super.applyColour();
          let e;
          (e = this.miniWorkspaceBubble) == null || e.setColour(this.sourceBlock.style.colourPrimary);
          let t;
          (t = this.miniWorkspaceBubble) == null || t.updateBlockStyles();
        }
        updateCollapsed() {
          super.updateCollapsed(), this.sourceBlock.isCollapsed() && this.setBubbleVisible(!1);
        }
        onLocationChange(e) {
          super.onLocationChange(e);
          let t;
          (t = this.miniWorkspaceBubble) == null || t.setAnchorLocation(this.getAnchorLocation());
        }
        onClick() {
          super.onClick(), this.setBubbleVisible(!this.bubbleIsVisible());
        }
        bubbleIsVisible() {
          return !!this.miniWorkspaceBubble;
        }
        setBubbleVisible(e) {
          if (this.bubbleIsVisible() !== e) {
            if (e) {
              this.miniWorkspaceBubble = new Po(this.getMiniWorkspaceConfig(), this.sourceBlock.workspace, this.getAnchorLocation(), this.getBubbleOwnerRect()), this.applyColour(), this.createRootBlock(), this.addSaveConnectionsListener();
              let t;
              (t = this.miniWorkspaceBubble) == null || t.addWorkspaceChangeListener(this.createMiniWorkspaceChangeListener());
            } else {
              let t;
              (t = this.miniWorkspaceBubble) == null || t.dispose(), this.miniWorkspaceBubble = null;
            }
            Ce(new (fe(Si))(
              this.sourceBlock,
              e,
              "mutator"
            ));
          }
        }
        getMiniWorkspaceConfig() {
          let e;
          const t = { disable: !1, media: this.sourceBlock.workspace.options.pathToMedia, rtl: this.sourceBlock.RTL, renderer: this.sourceBlock.workspace.options.renderer, rendererOverrides: (e = this.sourceBlock.workspace.options.rendererOverrides) != null ? e : void 0 };
          return this.flyoutBlockTypes.length && (t.toolbox = { kind: "flyoutToolbox", contents: this.flyoutBlockTypes.map((n) => ({ kind: "block", type: n })) }), t;
        }
        getAnchorLocation() {
          const e = mu / 2;
          return Te.sum(this.workspaceLocation, new Te(e, e));
        }
        getBubbleOwnerRect() {
          const e = this.sourceBlock.getSvgRoot().getBBox();
          return new yt(e.y, e.y + e.height, e.x, e.x + e.width);
        }
        createRootBlock() {
          this.rootBlock = this.sourceBlock.decompose(this.miniWorkspaceBubble.getWorkspace());
          for (var e of this.rootBlock.getDescendants(!1))
            e.queueRender();
          this.rootBlock.setMovable(!1), this.rootBlock.setDeletable(!1);
          let t, n, s, u;
          e = (u = (t = this.miniWorkspaceBubble) == null || (n = t.getWorkspace()) == null || (s = n.getFlyout()) == null ? void 0 : s.getWidth()) != null ? u : 0, this.rootBlock.moveBy(this.rootBlock.RTL ? -(e + Iu) : Iu, Iu);
        }
        addSaveConnectionsListener() {
          if (this.sourceBlock.saveConnections && this.rootBlock) {
            var e = () => {
              this.sourceBlock.saveConnections && this.rootBlock && this.sourceBlock.saveConnections(this.rootBlock);
            };
            e(), this.sourceBlock.workspace.addChangeListener(e);
          }
        }
        createMiniWorkspaceChangeListener() {
          return (e) => {
            r.MutatorIcon$$module$build$src$core$icons$mutator_icon.isIgnorableMutatorEvent(e) || this.updateWorkspacePid || (this.updateWorkspacePid = setTimeout(() => {
              this.updateWorkspacePid = null, this.recomposeSourceBlock();
            }, 0));
          };
        }
        static isIgnorableMutatorEvent(e) {
          return e.isUiEvent || e.type === r.CREATE$$module$build$src$core$events$utils || e.type === r.CHANGE$$module$build$src$core$events$utils && e.element === "disabled";
        }
        recomposeSourceBlock() {
          if (this.rootBlock) {
            var e = r.getGroup$$module$build$src$core$events$utils();
            e || r.setGroup$$module$build$src$core$events$utils(!0);
            var t = dl.getExtraBlockState_(this.sourceBlock);
            this.sourceBlock.compose(this.rootBlock);
            var n = dl.getExtraBlockState_(this.sourceBlock);
            t !== n && Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(
              this.sourceBlock,
              "mutation",
              null,
              t,
              n
            )), r.setGroup$$module$build$src$core$events$utils(e);
          }
        }
        getWorkspace() {
          let e;
          return (e = this.miniWorkspaceBubble) == null ? void 0 : e.getWorkspace();
        }
        static reconnect(e, t, n) {
          return hr("MutatorIcon.reconnect", "v10", "v11", "connection.reconnect"), e ? e.reconnect(t, n) : !1;
        }
        static findParentWs(e) {
          return hr("MutatorIcon.findParentWs", "v10", "v11", "workspace.getRootWorkspace"), e.getRootWorkspace();
        }
      }, r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE = Lr.MUTATOR, r.MutatorIcon$$module$build$src$core$icons$mutator_icon.WEIGHT = 1, r.MutatorIcon$$module$build$src$core$icons$mutator_icon;
      var da = /* @__PURE__ */ Object.create(null), Mu = { allExtensions: da };
      r.register$$module$build$src$core$extensions("parent_tooltip_when_inline", yE);
      var ri = {};
      ri.TEST_ONLY = Mu, ri.apply = Jo, ri.buildTooltipForDropdown = r.buildTooltipForDropdown$$module$build$src$core$extensions, ri.buildTooltipWithFieldText = r.buildTooltipWithFieldText$$module$build$src$core$extensions, ri.isRegistered = Oc, ri.register = r.register$$module$build$src$core$extensions, ri.registerMixin = r.registerMixin$$module$build$src$core$extensions, ri.registerMutator = r.registerMutator$$module$build$src$core$extensions, ri.runAfterPageLoad = Pc, ri.unregister = Za, function(e) {
        e[e.LEFT = -1] = "LEFT", e[e.CENTRE = 0] = "CENTRE", e[e.RIGHT = 1] = "RIGHT";
      }(r.Align$$module$build$src$core$inputs$align || (r.Align$$module$build$src$core$inputs$align = {})), r.Align$$module$build$src$core$inputs$align;
      var ed = {};
      ed.removeElem = pn;
      var Qe;
      (function(e) {
        e[e.WIN_KEY_FF_LINUX = 0] = "WIN_KEY_FF_LINUX", e[e.MAC_ENTER = 3] = "MAC_ENTER", e[e.BACKSPACE = 8] = "BACKSPACE", e[e.TAB = 9] = "TAB", e[e.NUM_CENTER = 12] = "NUM_CENTER", e[e.ENTER = 13] = "ENTER", e[e.SHIFT = 16] = "SHIFT", e[e.CTRL = 17] = "CTRL", e[e.ALT = 18] = "ALT", e[e.PAUSE = 19] = "PAUSE", e[e.CAPS_LOCK = 20] = "CAPS_LOCK", e[e.ESC = 27] = "ESC", e[e.SPACE = 32] = "SPACE", e[e.PAGE_UP = 33] = "PAGE_UP", e[e.PAGE_DOWN = 34] = "PAGE_DOWN", e[e.END = 35] = "END", e[e.HOME = 36] = "HOME", e[e.LEFT = 37] = "LEFT", e[e.UP = 38] = "UP", e[e.RIGHT = 39] = "RIGHT", e[e.DOWN = 40] = "DOWN", e[e.PLUS_SIGN = 43] = "PLUS_SIGN", e[e.PRINT_SCREEN = 44] = "PRINT_SCREEN", e[e.INSERT = 45] = "INSERT", e[e.DELETE = 46] = "DELETE", e[e.ZERO = 48] = "ZERO", e[e.ONE = 49] = "ONE", e[e.TWO = 50] = "TWO", e[e.THREE = 51] = "THREE", e[e.FOUR = 52] = "FOUR", e[e.FIVE = 53] = "FIVE", e[e.SIX = 54] = "SIX", e[e.SEVEN = 55] = "SEVEN", e[e.EIGHT = 56] = "EIGHT", e[e.NINE = 57] = "NINE", e[e.FF_SEMICOLON = 59] = "FF_SEMICOLON", e[e.FF_EQUALS = 61] = "FF_EQUALS", e[e.FF_DASH = 173] = "FF_DASH", e[e.FF_HASH = 163] = "FF_HASH", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.AT_SIGN = 64] = "AT_SIGN", e[e.A = 65] = "A", e[e.B = 66] = "B", e[e.C = 67] = "C", e[e.D = 68] = "D", e[e.E = 69] = "E", e[e.F = 70] = "F", e[e.G = 71] = "G", e[e.H = 72] = "H", e[e.I = 73] = "I", e[e.J = 74] = "J", e[e.K = 75] = "K", e[e.L = 76] = "L", e[e.M = 77] = "M", e[e.N = 78] = "N", e[e.O = 79] = "O", e[e.P = 80] = "P", e[e.Q = 81] = "Q", e[e.R = 82] = "R", e[e.S = 83] = "S", e[e.T = 84] = "T", e[e.U = 85] = "U", e[e.V = 86] = "V", e[e.W = 87] = "W", e[e.X = 88] = "X", e[e.Y = 89] = "Y", e[e.Z = 90] = "Z", e[e.META = 91] = "META", e[e.WIN_KEY_RIGHT = 92] = "WIN_KEY_RIGHT", e[e.CONTEXT_MENU = 93] = "CONTEXT_MENU", e[e.NUM_ZERO = 96] = "NUM_ZERO", e[e.NUM_ONE = 97] = "NUM_ONE", e[e.NUM_TWO = 98] = "NUM_TWO", e[e.NUM_THREE = 99] = "NUM_THREE", e[e.NUM_FOUR = 100] = "NUM_FOUR", e[e.NUM_FIVE = 101] = "NUM_FIVE", e[e.NUM_SIX = 102] = "NUM_SIX", e[e.NUM_SEVEN = 103] = "NUM_SEVEN", e[e.NUM_EIGHT = 104] = "NUM_EIGHT", e[e.NUM_NINE = 105] = "NUM_NINE", e[e.NUM_MULTIPLY = 106] = "NUM_MULTIPLY", e[e.NUM_PLUS = 107] = "NUM_PLUS", e[e.NUM_MINUS = 109] = "NUM_MINUS", e[e.NUM_PERIOD = 110] = "NUM_PERIOD", e[e.NUM_DIVISION = 111] = "NUM_DIVISION", e[e.F1 = 112] = "F1", e[e.F2 = 113] = "F2", e[e.F3 = 114] = "F3", e[e.F4 = 115] = "F4", e[e.F5 = 116] = "F5", e[e.F6 = 117] = "F6", e[e.F7 = 118] = "F7", e[e.F8 = 119] = "F8", e[e.F9 = 120] = "F9", e[e.F10 = 121] = "F10", e[e.F11 = 122] = "F11", e[e.F12 = 123] = "F12", e[e.NUMLOCK = 144] = "NUMLOCK", e[e.SCROLL_LOCK = 145] = "SCROLL_LOCK", e[e.FIRST_MEDIA_KEY = 166] = "FIRST_MEDIA_KEY", e[e.LAST_MEDIA_KEY = 183] = "LAST_MEDIA_KEY", e[e.SEMICOLON = 186] = "SEMICOLON", e[e.DASH = 189] = "DASH", e[e.EQUALS = 187] = "EQUALS", e[e.COMMA = 188] = "COMMA", e[e.PERIOD = 190] = "PERIOD", e[e.SLASH = 191] = "SLASH", e[e.APOSTROPHE = 192] = "APOSTROPHE", e[e.TILDE = 192] = "TILDE", e[e.SINGLE_QUOTE = 222] = "SINGLE_QUOTE", e[e.OPEN_SQUARE_BRACKET = 219] = "OPEN_SQUARE_BRACKET", e[e.BACKSLASH = 220] = "BACKSLASH", e[e.CLOSE_SQUARE_BRACKET = 221] = "CLOSE_SQUARE_BRACKET", e[e.WIN_KEY = 224] = "WIN_KEY", e[e.MAC_FF_META = 224] = "MAC_FF_META", e[e.MAC_WK_CMD_LEFT = 91] = "MAC_WK_CMD_LEFT", e[e.MAC_WK_CMD_RIGHT = 93] = "MAC_WK_CMD_RIGHT", e[e.WIN_IME = 229] = "WIN_IME", e[e.VK_NONAME = 252] = "VK_NONAME", e[e.PHANTOM = 255] = "PHANTOM";
      })(Qe || (Qe = {}));
      var Ii = {};
      Ii.arc = Ft, Ii.curve = Lt, Ii.line = Ys, Ii.lineOnAxis = Ae, Ii.lineTo = di, Ii.moveBy = wt, Ii.moveTo = br, Ii.point = Ee;
      var Gt = {};
      Gt.Coordinate = Te, Gt.KeyCodes = Qe, Gt.Rect = yt, Gt.Size = It, Gt.Svg = G, Gt.aria = O_, Gt.array = ed, Gt.browserEvents = Ro, Gt.colour = Gr, Gt.deprecation = ls, Gt.dom = ur, Gt.extensions = ri, Gt.idGenerator = Qr, Gt.math = uu, Gt.object = TA, Gt.parsing = v_, Gt.string = As, Gt.style = Oo, Gt.svgMath = Do, Gt.svgPaths = Ii, Gt.toolbox = Al, Gt.userAgent = vo, Gt.xml = xi;
      var gu = {};
      gu.register = qa, gu.unregister = zl;
      var Lu = class extends je {
        constructor(e, t, n, s) {
          super(t, n, s), this.text = e, this.workspace = t, this.anchor = n, this.ownerRect = s, this.paragraph = this.stringToSvg(e, this.contentContainer), this.updateBubbleSize();
        }
        getText() {
          return this.text;
        }
        setText(e) {
          this.text = e, _t(this.paragraph), this.paragraph = this.stringToSvg(e, this.contentContainer), this.updateBubbleSize();
        }
        stringToSvg(e, t) {
          return t = this.createParagraph(t), e = this.createSpans(t, e), this.workspace.RTL && this.rightAlignSpans(t.getBBox().width, e), t;
        }
        createParagraph(e) {
          return K(G.TEXT, { class: "blocklyText blocklyBubbleText blocklyNoPointerEvents", y: je.BORDER_WIDTH }, e);
        }
        createSpans(e, t) {
          return t.split(`
`).map((n) => {
            const s = K(
              G.TSPAN,
              { dy: "1em", x: je.BORDER_WIDTH },
              e
            );
            return n = document.createTextNode(n), s.appendChild(n), s;
          });
        }
        rightAlignSpans(e, t) {
          for (const n of t)
            n.setAttribute("text-anchor", "end"), n.setAttribute("x", `${e + je.BORDER_WIDTH}`);
        }
        updateBubbleSize() {
          const e = this.paragraph.getBBox();
          this.setSize(
            new It(e.width + 2 * je.BORDER_WIDTH, e.height + 2 * je.BORDER_WIDTH),
            !0
          );
        }
      }, td = class extends je {
        constructor(e, t, n) {
          super(e, t, n), this.workspace = e, this.anchor = t, this.ownerRect = n, this.resizePointerMoveListener = this.resizePointerUpListener = null, this.textChangeListeners = [], this.sizeChangeListeners = [], this.text = "", this.DEFAULT_SIZE = new It(160 + je.DOUBLE_BORDER, 80 + je.DOUBLE_BORDER), this.MIN_SIZE = new It(45 + je.DOUBLE_BORDER, 20 + je.DOUBLE_BORDER), { inputRoot: this.inputRoot, textArea: this.textArea } = this.createEditor(this.contentContainer), this.resizeGroup = this.createResizeHandle(this.svgRoot), this.setSize(this.DEFAULT_SIZE, !0);
        }
        getText() {
          return this.text;
        }
        setText(e) {
          this.text = e, this.textArea.value = e, this.onTextChange();
        }
        addTextChangeListener(e) {
          this.textChangeListeners.push(e);
        }
        addSizeChangeListener(e) {
          this.sizeChangeListeners.push(e);
        }
        createEditor(e) {
          e = K(G.FOREIGNOBJECT, { x: je.BORDER_WIDTH, y: je.BORDER_WIDTH }, e);
          const t = document.createElementNS(fo, "body");
          t.setAttribute("xmlns", fo), t.className = "blocklyMinimalBody";
          const n = document.createElementNS(fo, "textarea");
          return n.className = "blocklyCommentTextarea", n.setAttribute("dir", this.workspace.RTL ? "RTL" : "LTR"), t.appendChild(n), e.appendChild(t), this.bindTextAreaEvents(n), setTimeout(() => {
            n.focus();
          }, 0), { inputRoot: e, textArea: n };
        }
        bindTextAreaEvents(e) {
          ge(e, "wheel", this, (t) => {
            t.stopPropagation();
          }), ge(e, "focus", this, this.onStartEdit, !0), ge(e, "change", this, this.onTextChange);
        }
        createResizeHandle(e) {
          e = K(G.G, { class: this.workspace.RTL ? "blocklyResizeSW" : "blocklyResizeSE" }, e);
          const t = 2 * je.BORDER_WIDTH;
          return K(G.POLYGON, { points: `0,${t} ${t},${t} ${t},0` }, e), K(G.LINE, { class: "blocklyResizeLine", x1: t / 3, y1: t - 1, x2: t - 1, y2: t / 3 }, e), K(G.LINE, { class: "blocklyResizeLine", x1: 2 * t / 3, y1: t - 1, x2: t - 1, y2: 2 * t / 3 }, e), ge(e, "pointerdown", this, this.onResizePointerDown), e;
        }
        setSize(e, t = !1) {
          e.width = Math.max(e.width, this.MIN_SIZE.width), e.height = Math.max(e.height, this.MIN_SIZE.height);
          const n = e.width - je.DOUBLE_BORDER, s = e.height - je.DOUBLE_BORDER;
          this.inputRoot.setAttribute("width", `${n}`), this.inputRoot.setAttribute("height", `${s}`), this.textArea.style.width = `${n - 4}px`, this.textArea.style.height = `${s - 4}px`, this.workspace.RTL ? this.resizeGroup.setAttribute("transform", `translate(${je.DOUBLE_BORDER}, ${s}) scale(-1 1)`) : this.resizeGroup.setAttribute("transform", `translate(${n}, ${s})`), super.setSize(e, t), this.onSizeChange();
        }
        getSize() {
          return super.getSize();
        }
        onResizePointerDown(e) {
          this.bringToFront(), Xo(e) || (this.workspace.startDrag(e, new Te(this.workspace.RTL ? -this.getSize().width : this.getSize().width, this.getSize().height)), this.resizePointerUpListener = ge(document, "pointerup", this, this.onResizePointerUp), this.resizePointerMoveListener = ge(document, "pointermove", this, this.onResizePointerMove), this.workspace.hideChaff()), e.stopPropagation();
        }
        onResizePointerUp(e) {
          Me(), this.resizePointerUpListener && (Mt(this.resizePointerUpListener), this.resizePointerUpListener = null), this.resizePointerMoveListener && (Mt(this.resizePointerMoveListener), this.resizePointerMoveListener = null);
        }
        onResizePointerMove(e) {
          e = this.workspace.moveDrag(e), this.setSize(new It(this.workspace.RTL ? -e.x : e.x, e.y), !1), this.onSizeChange();
        }
        onStartEdit() {
          this.bringToFront() && this.textArea.focus();
        }
        onTextChange() {
          this.text = this.textArea.value;
          for (const e of this.textChangeListeners)
            e();
        }
        onSizeChange() {
          for (const e of this.sizeChangeListeners)
            e();
        }
      };
      Kn(`
.blocklyCommentTextarea {
  background-color: #fef49c;
  border: 0;
  display: block;
  margin: 0;
  outline: 0;
  padding: 3px;
  resize: none;
  text-overflow: hidden;
}
`);
      var rd = 17, EA = 160, AA = 80, Or = class extends Eu {
        constructor(e) {
          super(e), this.sourceBlock = e, this.textBubble = this.textInputBubble = null, this.text = "", this.bubbleSize = new It(
            EA,
            AA
          ), this.bubbleVisiblity = !1;
        }
        getType() {
          return Or.TYPE;
        }
        initView(e) {
          this.svgRoot || (super.initView(e), K(G.CIRCLE, { class: "blocklyIconShape", r: "8", cx: "8", cy: "8" }, this.svgRoot), K(
            G.PATH,
            { class: "blocklyIconSymbol", d: "m6.8,10h2c0.003,-0.617 0.271,-0.962 0.633,-1.266 2.875,-2.4050.607,-5.534 -3.765,-3.874v1.7c3.12,-1.657 3.698,0.118 2.336,1.25-1.201,0.998 -1.201,1.528 -1.204,2.19z" },
            this.svgRoot
          ), K(G.RECT, { class: "blocklyIconSymbol", x: "6.8", y: "10.78", height: "2", width: "2" }, this.svgRoot));
        }
        dispose() {
          super.dispose();
          let e;
          (e = this.textInputBubble) == null || e.dispose();
          let t;
          (t = this.textBubble) == null || t.dispose();
        }
        getWeight() {
          return Or.WEIGHT;
        }
        getSize() {
          return new It(rd, rd);
        }
        applyColour() {
          super.applyColour();
          const e = this.sourceBlock.style.colourPrimary;
          let t;
          (t = this.textInputBubble) == null || t.setColour(e);
          let n;
          (n = this.textBubble) == null || n.setColour(e);
        }
        updateEditable() {
          super.updateEditable(), this.bubbleIsVisible() && (this.setBubbleVisible(!1), this.setBubbleVisible(!0));
        }
        onLocationChange(e) {
          super.onLocationChange(e), e = this.getAnchorLocation();
          let t;
          (t = this.textInputBubble) == null || t.setAnchorLocation(e);
          let n;
          (n = this.textBubble) == null || n.setAnchorLocation(e);
        }
        setText(e) {
          this.text = e;
          let t;
          (t = this.textInputBubble) == null || t.setText(this.text);
          let n;
          (n = this.textBubble) == null || n.setText(this.text);
        }
        getText() {
          return this.text;
        }
        setBubbleSize(e) {
          this.bubbleSize = e;
          let t;
          (t = this.textInputBubble) == null || t.setSize(this.bubbleSize, !0);
        }
        getBubbleSize() {
          return this.bubbleSize;
        }
        saveState() {
          return this.text ? { text: this.text, pinned: this.bubbleIsVisible(), height: this.bubbleSize.height, width: this.bubbleSize.width } : null;
        }
        loadState(e) {
          let t;
          this.text = (t = e.text) != null ? t : "";
          let n, s;
          this.bubbleSize = new It((n = e.width) != null ? n : EA, (s = e.height) != null ? s : AA);
          let u;
          this.bubbleVisiblity = (u = e.pinned) != null ? u : !1, setTimeout(() => this.setBubbleVisible(this.bubbleVisiblity), 1);
        }
        onClick() {
          super.onClick(), this.setBubbleVisible(!this.bubbleIsVisible());
        }
        onTextChange() {
          this.textInputBubble && (this.text = this.textInputBubble.getText());
        }
        onSizeChange() {
          this.textInputBubble && (this.bubbleSize = this.textInputBubble.getSize());
        }
        bubbleIsVisible() {
          return this.bubbleVisiblity;
        }
        setBubbleVisible(e) {
          (!e || !this.textBubble && !this.textInputBubble) && (e || this.textBubble || this.textInputBubble) && (this.bubbleVisiblity = e, this.sourceBlock.rendered && !this.sourceBlock.isInFlyout && (e ? (this.sourceBlock.isEditable() ? this.showEditableBubble() : this.showNonEditableBubble(), this.applyColour()) : this.hideBubble(), Ce(new (fe(Si))(this.sourceBlock, e, "comment"))));
        }
        showEditableBubble() {
          this.textInputBubble = new td(this.sourceBlock.workspace, this.getAnchorLocation(), this.getBubbleOwnerRect()), this.textInputBubble.setText(this.getText()), this.textInputBubble.setSize(this.bubbleSize, !0), this.textInputBubble.addTextChangeListener(() => this.onTextChange()), this.textInputBubble.addSizeChangeListener(() => this.onSizeChange());
        }
        showNonEditableBubble() {
          this.textBubble = new Lu(
            this.getText(),
            this.sourceBlock.workspace,
            this.getAnchorLocation(),
            this.getBubbleOwnerRect()
          );
        }
        hideBubble() {
          let e;
          (e = this.textInputBubble) == null || e.dispose(), this.textInputBubble = null;
          let t;
          (t = this.textBubble) == null || t.dispose(), this.textBubble = null;
        }
        getAnchorLocation() {
          const e = rd / 2;
          return Te.sum(this.workspaceLocation, new Te(e, e));
        }
        getBubbleOwnerRect() {
          const e = this.sourceBlock.getSvgRoot().getBBox();
          return new yt(
            e.y,
            e.y + e.height,
            e.x,
            e.x + e.width
          );
        }
      };
      Or.TYPE = Lr.COMMENT, Or.WEIGHT = 3, qa(Or.TYPE, Or);
      var Ji = class extends lt {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.class = null, this.EDITABLE = !1, this.maxDisplayLength = 1 / 0, e !== lt.SKIP_SETUP && (n ? this.configure_(n) : this.class = t || null, this.setValue(e));
        }
        configure_(e) {
          super.configure_(e), e.class && (this.class = e.class);
        }
        initView() {
          this.createTextElement_(), this.class && Re(
            this.getTextElement(),
            this.class
          );
        }
        doClassValidation_(e) {
          return e == null ? null : `${e}`;
        }
        setClass(e) {
          this.textElement_ && (this.class && Ue(this.textElement_, this.class), e && Re(this.textElement_, e)), this.class = e;
        }
        static fromJson(e) {
          return new this(Jt(e.text), void 0, e);
        }
      };
      Vr("field_label", Ji), Ji.prototype.DEFAULT_VALUE = "";
      var $o = class {
        constructor(e, t) {
          this.name = e, this.sourceBlock = t, this.fieldRow = [], this.align = r.Align$$module$build$src$core$inputs$input.LEFT, this.visible = !0, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.CUSTOM, this.connection = null;
        }
        getSourceBlock() {
          return this.sourceBlock;
        }
        appendField(e, t) {
          return this.insertFieldAt(this.fieldRow.length, e, t), this;
        }
        insertFieldAt(e, t, n) {
          if (0 > e || e > this.fieldRow.length)
            throw Error("index " + e + " out of bounds.");
          return (t || t === "" && n) && (typeof t == "string" && (t = r.fromJson$$module$build$src$core$field_registry({ type: "field_label", text: t })), t.setSourceBlock(this.sourceBlock), this.sourceBlock.rendered && (t.init(), t.applyColour()), t.name = n, t.setVisible(this.isVisible()), t.prefixField && (e = this.insertFieldAt(e, t.prefixField)), this.fieldRow.splice(e, 0, t), e++, t.suffixField && (e = this.insertFieldAt(e, t.suffixField)), this.sourceBlock.rendered && (this.sourceBlock.queueRender(), this.sourceBlock.bumpNeighbours())), e;
        }
        removeField(e, t) {
          for (let n = 0, s; s = this.fieldRow[n]; n++)
            if (s.name === e)
              return s.dispose(), this.fieldRow.splice(n, 1), this.sourceBlock.rendered && (this.sourceBlock.queueRender(), this.sourceBlock.bumpNeighbours()), !0;
          if (t)
            return !1;
          throw Error('Field "' + e + '" not found.');
        }
        isVisible() {
          return this.visible;
        }
        setVisible(e) {
          let t = [];
          if (this.visible === e)
            return t;
          this.visible = e;
          for (let s = 0, u; u = this.fieldRow[s]; s++)
            u.setVisible(e);
          if (this.connection) {
            var n = this.connection;
            e ? t = n.startTrackingAll() : n.stopTrackingAll(), (n = n.targetBlock()) && (n.getSvgRoot().style.display = e ? "block" : "none");
          }
          return t;
        }
        markDirty() {
          for (let e = 0, t; t = this.fieldRow[e]; e++)
            t.markDirty();
        }
        setCheck(e) {
          if (!this.connection)
            throw Error("This input does not have a connection.");
          return this.connection.setCheck(e), this;
        }
        setAlign(e) {
          return this.align = e, this.sourceBlock.rendered && this.sourceBlock.queueRender(), this;
        }
        setShadowDom(e) {
          if (!this.connection)
            throw Error("This input does not have a connection.");
          return this.connection.setShadowDom(e), this;
        }
        getShadowDom() {
          if (!this.connection)
            throw Error("This input does not have a connection.");
          return this.connection.getShadowDom();
        }
        init() {
          if (this.sourceBlock.workspace.rendered)
            for (let e = 0; e < this.fieldRow.length; e++)
              this.fieldRow[e].init();
        }
        dispose() {
          for (let e = 0, t; t = this.fieldRow[e]; e++)
            t.dispose();
          this.connection && this.connection.dispose();
        }
        makeConnection(e) {
          return this.sourceBlock.makeConnection_(e);
        }
      }, nd;
      (function(e) {
        e = e.Align || (e.Align = {}), e[e.LEFT = -1] = "LEFT", e[e.CENTRE = 0] = "CENTRE", e[e.RIGHT = 1] = "RIGHT";
      })($o || ($o = {})), r.Align$$module$build$src$core$inputs$input = $o.Align, nd = {}, nd.Align = r.Align$$module$build$src$core$inputs$input, nd.Input = $o;
      var ni = class extends $o {
        constructor(e, t) {
          super(e, t), this.name = e, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.DUMMY;
        }
      }, id;
      r.ValueInput$$module$build$src$core$inputs$value_input = class extends $o {
        constructor(e, t) {
          if (!e)
            throw Error("Value inputs must have a non-empty name");
          super(e, t), this.name = e, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.VALUE, this.connection = this.makeConnection(me.INPUT_VALUE);
        }
      }, id = {}, id.ValueInput = r.ValueInput$$module$build$src$core$inputs$value_input;
      var wn = class extends $o {
        constructor(e, t) {
          if (!e)
            throw Error("Statement inputs must have a non-empty name");
          super(e, t), this.name = e, this.type = r.inputTypes$$module$build$src$core$inputs$input_types.STATEMENT, this.connection = this.makeConnection(me.NEXT_STATEMENT);
        }
      }, Ea = class {
        constructor(e, t, n) {
          if (this.data = null, this.disposed = !1, this.hue_ = null, this.colour_ = "#000000", this.styleName_ = "", this.suppressPrefixSuffix = !1, this.previousConnection = this.nextConnection = this.outputConnection = null, this.inputList = [], this.icons = [], this.disabled = !1, this.tooltip = "", this.contextMenu = !0, this.parentBlock_ = null, this.childBlocks_ = [], this.editable_ = this.movable_ = this.deletable_ = !0, this.collapsed_ = this.isShadow_ = !1, this.outputShape_ = null, this.isInsertionMarker_ = this.disposing = !1, this.onchangeWrapper_ = this.helpUrl = this.rendered = null, this.statementInputCount = 0, this.workspace = e, this.id = n && !e.getBlockById(n) ? n : Yr(), e.setBlockById(this.id, this), this.xy_ = new Te(0, 0), this.isInFlyout = e.isFlyout, this.isInMutator = e.isMutator, this.RTL = e.RTL, t) {
            if (this.type = t, n = Zr[t], !n || typeof n != "object")
              throw TypeError("Invalid block definition for type: " + t);
            Object.assign(this, n);
          }
          e.addTopBlock(this), e.addTypedBlock(this), new.target === Ea && this.doInit_();
        }
        doInit_() {
          const e = r.getGroup$$module$build$src$core$events$utils();
          e || r.setGroup$$module$build$src$core$events$utils(!0);
          const t = Dr();
          try {
            typeof this.init == "function" && (Er(!1), this.init(), Er(t)), nt() && Ce(new (fe(r.CREATE$$module$build$src$core$events$utils))(this));
          } finally {
            r.setGroup$$module$build$src$core$events$utils(e), Er(t);
          }
          this.inputsInlineDefault = this.inputsInline, typeof this.onchange == "function" && this.setOnChange(this.onchange);
        }
        dispose(e) {
          this.isDeadOrDying() || (this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.unplug(e), nt() && Ce(new (fe(r.DELETE$$module$build$src$core$events$utils))(this)), this.workspace.removeTopBlock(this), this.disposeInternal());
        }
        disposeInternal() {
          this.isDeadOrDying() || (this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.workspace.removeTypedBlock(this), this.workspace.removeBlockById(this.id), this.disposing = !0, typeof this.destroy == "function" && this.destroy(), this.childBlocks_.forEach((e) => e.disposeInternal()), this.inputList.forEach((e) => e.dispose()), this.inputList.length = 0, this.getConnections_(!0).forEach((e) => e.dispose()), this.disposed = !0);
        }
        isDeadOrDying() {
          return this.disposing || this.disposed;
        }
        initModel() {
          for (let e = 0, t; t = this.inputList[e]; e++)
            for (let n = 0, s; s = t.fieldRow[n]; n++)
              s.initModel && s.initModel();
        }
        unplug(e) {
          this.outputConnection && this.unplugFromRow_(e), this.previousConnection && this.unplugFromStack_(e);
        }
        unplugFromRow_(e) {
          let t = null, n;
          (n = this.outputConnection) != null && n.isConnected() && (t = this.outputConnection.targetConnection, this.outputConnection.disconnect()), t && e && (e = this.getOnlyValueConnection_()) && e.isConnected() && !e.targetBlock().isShadow() && (e = e.targetConnection, e == null || e.disconnect(), this.workspace.connectionChecker.canConnect(e, t, !1) ? t.connect(e) : e == null || e.onFailedConnect(t));
        }
        getOnlyValueConnection_() {
          let e = null;
          for (let t = 0; t < this.inputList.length; t++) {
            const n = this.inputList[t].connection;
            if (n && n.type === me.INPUT_VALUE && n.targetConnection) {
              if (e)
                return null;
              e = n;
            }
          }
          return e;
        }
        unplugFromStack_(e) {
          let t = null;
          var n;
          if ((n = this.previousConnection) != null && n.isConnected() && (t = this.previousConnection.targetConnection, this.previousConnection.disconnect()), n = this.getNextBlock(), e && n && !n.isShadow()) {
            let s, u;
            e = (u = (s = this.nextConnection) == null ? void 0 : s.targetConnection) != null ? u : null, e == null || e.disconnect(), t && this.workspace.connectionChecker.canConnect(t, e, !1) && t.connect(e);
          }
        }
        getConnections_(e) {
          e = [], this.outputConnection && e.push(this.outputConnection), this.previousConnection && e.push(this.previousConnection), this.nextConnection && e.push(this.nextConnection);
          for (let t = 0, n; n = this.inputList[t]; t++)
            n.connection && e.push(n.connection);
          return e;
        }
        lastConnectionInStack(e) {
          let t = this.nextConnection;
          for (; t; ) {
            const n = t.targetBlock();
            if (!n || e && n.isShadow())
              return t;
            t = n.nextConnection;
          }
          return null;
        }
        bumpNeighbours() {
        }
        getParent() {
          return this.parentBlock_;
        }
        getInputWithBlock(e) {
          for (let t = 0, n; n = this.inputList[t]; t++)
            if (n.connection && n.connection.targetBlock() === e)
              return n;
          return null;
        }
        getSurroundParent() {
          let e = this, t;
          do
            if (t = e, e = e.getParent(), !e)
              return null;
          while (e.getNextBlock() === t);
          return e;
        }
        getNextBlock() {
          return this.nextConnection && this.nextConnection.targetBlock();
        }
        getPreviousBlock() {
          return this.previousConnection && this.previousConnection.targetBlock();
        }
        getFirstStatementConnection() {
          for (let e = 0, t; t = this.inputList[e]; e++)
            if (t.connection && t.connection.type === me.NEXT_STATEMENT)
              return t.connection;
          return null;
        }
        getRootBlock() {
          let e, t = this;
          do
            e = t, t = e.parentBlock_;
          while (t);
          return e;
        }
        getTopStackBlock() {
          let e = this, t;
          do
            t = e.getPreviousBlock();
          while (t && t.getNextBlock() === e && (e = t));
          return e;
        }
        getChildren(e) {
          if (!e)
            return this.childBlocks_;
          e = [];
          for (let n = 0, s; s = this.inputList[n]; n++)
            if (s.connection) {
              var t = s.connection.targetBlock();
              t && e.push(t);
            }
          return (t = this.getNextBlock()) && e.push(t), e;
        }
        setParent(e) {
          if (e !== this.parentBlock_) {
            var t = this.previousConnection && this.previousConnection.targetBlock() || this.outputConnection && this.outputConnection.targetBlock(), n = !!t;
            if (n && e && t !== e)
              throw Error("Block connected to superior one that is not new parent.");
            if (!n && e)
              throw Error("Block not connected to new parent.");
            if (n && !e)
              throw Error("Cannot set parent to null while block is still connected to superior block.");
            this.parentBlock_ ? pn(this.parentBlock_.childBlocks_, this) : this.workspace.removeTopBlock(this), (this.parentBlock_ = e) ? e.childBlocks_.push(this) : this.workspace.addTopBlock(this);
          }
        }
        getDescendants(e) {
          const t = [this], n = this.getChildren(e);
          for (let s, u = 0; s = n[u]; u++)
            t.push(...s.getDescendants(e));
          return t;
        }
        isDeletable() {
          return this.deletable_ && !this.isShadow_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnDeletable() {
          return this.deletable_;
        }
        setDeletable(e) {
          this.deletable_ = e;
        }
        isMovable() {
          return this.movable_ && !this.isShadow_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnMovable() {
          return this.movable_;
        }
        setMovable(e) {
          this.movable_ = e;
        }
        isDuplicatable() {
          return this.workspace.hasBlockLimits() ? this.workspace.isCapacityAvailable(Pt(
            this,
            !0
          )) : !0;
        }
        isShadow() {
          return this.isShadow_;
        }
        setShadow(e) {
          this.isShadow_ = e;
        }
        isInsertionMarker() {
          return this.isInsertionMarker_;
        }
        setInsertionMarker(e) {
          this.isInsertionMarker_ = e;
        }
        isEditable() {
          return this.editable_ && !this.isDeadOrDying() && !this.workspace.options.readOnly;
        }
        isOwnEditable() {
          return this.editable_;
        }
        setEditable(e) {
          this.editable_ = e;
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let s = 0, u; u = n.fieldRow[s]; s++)
              u.updateEditable();
        }
        isDisposed() {
          return this.disposed;
        }
        getMatchingConnection(e, t) {
          const n = this.getConnections_(!0);
          if (e = e.getConnections_(!0), n.length !== e.length)
            throw Error("Connection lists did not match in length.");
          for (let s = 0; s < e.length; s++)
            if (e[s] === t)
              return n[s];
          return null;
        }
        setHelpUrl(e) {
          this.helpUrl = e;
        }
        setTooltip(e) {
          this.tooltip = e;
        }
        getTooltip() {
          return zo(this);
        }
        getColour() {
          return this.colour_;
        }
        getStyleName() {
          return this.styleName_;
        }
        getHue() {
          return this.hue_;
        }
        setColour(e) {
          e = xs(e), this.hue_ = e.hue, this.colour_ = e.hex;
        }
        setStyle(e) {
          this.styleName_ = e;
        }
        setOnChange(e) {
          if (e && typeof e != "function")
            throw Error("onchange must be a function.");
          this.onchangeWrapper_ && this.workspace.removeChangeListener(this.onchangeWrapper_), this.onchange = e, this.onchangeWrapper_ = e.bind(this), this.workspace.addChangeListener(this.onchangeWrapper_);
        }
        getField(e) {
          if (typeof e != "string")
            throw TypeError("Block.prototype.getField expects a string with the field name but received " + (e === void 0 ? "nothing" : e + " of type " + typeof e) + " instead");
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let s = 0, u; u = n.fieldRow[s]; s++)
              if (u.name === e)
                return u;
          return null;
        }
        getVars() {
          const e = [];
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let s = 0, u; u = n.fieldRow[s]; s++)
              u.referencesVariables() && e.push(u.getValue());
          return e;
        }
        getVarModels() {
          const e = [];
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let s = 0, u; u = n.fieldRow[s]; s++)
              if (u.referencesVariables()) {
                const A = this.workspace.getVariableById(u.getValue());
                A && e.push(A);
              }
          return e;
        }
        updateVarName(e) {
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let s = 0, u; u = n.fieldRow[s]; s++)
              u.referencesVariables() && e.getId() === u.getValue() && u.refreshVariableName();
        }
        renameVarById(e, t) {
          for (let n = 0, s; s = this.inputList[n]; n++)
            for (let u = 0, A; A = s.fieldRow[u]; u++)
              A.referencesVariables() && e === A.getValue() && A.setValue(t);
        }
        getFieldValue(e) {
          return (e = this.getField(e)) ? e.getValue() : null;
        }
        setFieldValue(e, t) {
          const n = this.getField(t);
          if (!n)
            throw Error('Field "' + t + '" not found.');
          n.setValue(e);
        }
        setPreviousStatement(e, t) {
          if (e)
            t === void 0 && (t = null), this.previousConnection || (this.previousConnection = this.makeConnection_(me.PREVIOUS_STATEMENT)), this.previousConnection.setCheck(t);
          else if (this.previousConnection) {
            if (this.previousConnection.isConnected())
              throw Error("Must disconnect previous statement before removing connection.");
            this.previousConnection.dispose(), this.previousConnection = null;
          }
        }
        setNextStatement(e, t) {
          if (e)
            t === void 0 && (t = null), this.nextConnection || (this.nextConnection = this.makeConnection_(me.NEXT_STATEMENT)), this.nextConnection.setCheck(t);
          else if (this.nextConnection) {
            if (this.nextConnection.isConnected())
              throw Error("Must disconnect next statement before removing connection.");
            this.nextConnection.dispose(), this.nextConnection = null;
          }
        }
        setOutput(e, t) {
          if (e)
            t === void 0 && (t = null), this.outputConnection || (this.outputConnection = this.makeConnection_(me.OUTPUT_VALUE)), this.outputConnection.setCheck(t);
          else if (this.outputConnection) {
            if (this.outputConnection.isConnected())
              throw Error("Must disconnect output value before removing connection.");
            this.outputConnection.dispose(), this.outputConnection = null;
          }
        }
        setInputsInline(e) {
          this.inputsInline !== e && (Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(this, "inline", null, this.inputsInline, e)), this.inputsInline = e);
        }
        getInputsInline() {
          if (this.inputsInline !== void 0)
            return this.inputsInline;
          for (var e = 1; e < this.inputList.length; e++)
            if (this.inputList[e - 1] instanceof ni && this.inputList[e] instanceof ni)
              return !1;
          for (e = 1; e < this.inputList.length; e++)
            if (this.inputList[e - 1] instanceof r.ValueInput$$module$build$src$core$inputs$value_input && this.inputList[e] instanceof ni)
              return !0;
          return !1;
        }
        setOutputShape(e) {
          this.outputShape_ = e;
        }
        getOutputShape() {
          return this.outputShape_;
        }
        isEnabled() {
          return !this.disabled;
        }
        setEnabled(e) {
          if (this.isEnabled() !== e) {
            const t = this.disabled;
            this.disabled = !e, Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(
              this,
              "disabled",
              null,
              t,
              !e
            ));
          }
        }
        getInheritedDisabled() {
          let e = this.getSurroundParent();
          for (; e; ) {
            if (e.disabled)
              return !0;
            e = e.getSurroundParent();
          }
          return !1;
        }
        isCollapsed() {
          return this.collapsed_;
        }
        setCollapsed(e) {
          this.collapsed_ !== e && (Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(this, "collapsed", null, this.collapsed_, e)), this.collapsed_ = e);
        }
        toString(e, t) {
          t = this.toTokens(t);
          for (let s = 2; s < t.length; s++)
            t[s - 2] === "(" && t[s] === ")" && (t[s - 2] = t[s - 1], t.splice(s - 1, 2));
          let n = "";
          return t = t.reduce((s, u) => (s = s + (n === "(" || u === ")" ? "" : " ") + u, n = u[u.length - 1], s), ""), t = t.trim() || "???", e && t.length > e && (t = t.substring(0, e - 3) + "..."), t;
        }
        toTokens(e = "?") {
          const t = [];
          for (const s of this.inputList)
            if (s.name != sa) {
              for (const u of s.fieldRow)
                t.push(u.getText());
              if (s.connection) {
                const u = s.connection.targetBlock();
                if (u) {
                  var n = s.connection;
                  let A = n.getCheck();
                  !A && n.targetConnection && (A = n.targetConnection.getCheck()), (n = !!A && (A.indexOf("Boolean") !== -1 || A.indexOf("Number") !== -1)) && t.push("("), t.push(...u.toTokens(e)), n && t.push(")");
                } else
                  t.push(e);
              }
            }
          return t;
        }
        appendValueInput(e) {
          return this.appendInput(new r.ValueInput$$module$build$src$core$inputs$value_input(e, this));
        }
        appendStatementInput(e) {
          return this.statementInputCount++, this.appendInput(new wn(e, this));
        }
        appendDummyInput(e = "") {
          return this.appendInput(new ni(
            e,
            this
          ));
        }
        appendInput(e) {
          return this.inputList.push(e), e;
        }
        appendInputFromRegistry(e, t) {
          return (e = y(_e.INPUT, e, !1)) ? this.appendInput(new e(t, this)) : null;
        }
        jsonInit(e) {
          var t = e.type ? 'Block "' + e.type + '": ' : "";
          if (e.output && e.previousStatement)
            throw Error(t + "Must not have both an output and a previousStatement.");
          if (e.style && e.style.hat && (this.hat = e.style.hat, e.style = null), e.style && e.colour)
            throw Error(t + "Must not have both a colour and a style.");
          e.style ? this.jsonInitStyle_(e, t) : this.jsonInitColour_(e, t);
          for (var n = 0; e["message" + n] !== void 0; )
            this.interpolate_(e["message" + n], e["args" + n] || [], e["lastDummyAlign" + n], t), n++;
          if (e.inputsInline !== void 0 && this.setInputsInline(e.inputsInline), e.output !== void 0 && this.setOutput(!0, e.output), e.outputShape !== void 0 && this.setOutputShape(e.outputShape), e.previousStatement !== void 0 && this.setPreviousStatement(!0, e.previousStatement), e.nextStatement !== void 0 && this.setNextStatement(!0, e.nextStatement), e.tooltip !== void 0 && (n = Jt(e.tooltip), this.setTooltip(n)), e.enableContextMenu !== void 0 && (this.contextMenu = !!e.enableContextMenu), e.suppressPrefixSuffix !== void 0 && (this.suppressPrefixSuffix = !!e.suppressPrefixSuffix), e.helpUrl !== void 0 && (n = Jt(e.helpUrl), this.setHelpUrl(n)), typeof e.extensions == "string" && (console.warn(t + "JSON attribute 'extensions' should be an array of strings. Found raw string in JSON for '" + e.type + "' block."), e.extensions = [e.extensions]), e.mutator !== void 0 && Jo(e.mutator, this, !0), e = e.extensions, Array.isArray(e))
            for (t = 0; t < e.length; t++)
              Jo(e[t], this, !1);
        }
        jsonInitColour_(e, t) {
          if ("colour" in e)
            if (e.colour === void 0)
              console.warn(t + "Undefined colour value.");
            else {
              e = e.colour;
              try {
                this.setColour(e);
              } catch {
                console.warn(t + "Illegal colour value: ", e);
              }
            }
        }
        jsonInitStyle_(e, t) {
          e = e.style;
          try {
            this.setStyle(e);
          } catch {
            console.warn(t + "Style does not exist: ", e);
          }
        }
        mixin(e, t) {
          if (t !== void 0 && typeof t != "boolean")
            throw Error("opt_disableCheck must be a boolean if provided");
          if (!t) {
            t = [];
            for (const n in e)
              this[n] !== void 0 && t.push(n);
            if (t.length)
              throw Error("Mixin will overwrite block members: " + JSON.stringify(t));
          }
          Object.assign(this, e);
        }
        interpolate_(e, t, n, s) {
          e = HT(e), this.validateTokens_(e, t.length), t = this.interpolateArguments_(e, t, n), n = [];
          for (let u = 0, A; A = t[u]; u++)
            if (this.isInputKeyword_(A.type)) {
              if (e = this.inputFromJson_(A, s)) {
                for (let L = 0, $; $ = n[L]; L++)
                  e.appendField($[0], $[1]);
                n.length = 0;
              }
            } else
              (e = this.fieldFromJson_(A)) && n.push([e, A.name]);
        }
        validateTokens_(e, t) {
          const n = [];
          let s = 0;
          for (let u = 0; u < e.length; u++) {
            const A = e[u];
            if (typeof A == "number") {
              if (1 > A || A > t)
                throw Error('Block "' + this.type + '": Message index %' + A + " out of range.");
              if (n[A])
                throw Error('Block "' + this.type + '": Message index %' + A + " duplicated.");
              n[A] = !0, s++;
            }
          }
          if (s !== t)
            throw Error('Block "' + this.type + '": Message does not reference all ' + t + " arg(s).");
        }
        interpolateArguments_(e, t, n) {
          const s = [];
          for (let u = 0; u < e.length; u++) {
            let A = e[u];
            typeof A == "number" && (A = t[A - 1]), !(typeof A == "string" && (A = this.stringToFieldJson_(A), !A)) && s.push(A);
          }
          return (e = s.length) && !this.isInputKeyword_(s[e - 1].type) && (e = { type: "input_dummy" }, n && (e.align = n), s.push(e)), s;
        }
        fieldFromJson_(e) {
          const t = r.fromJson$$module$build$src$core$field_registry(e);
          return !t && e.alt ? typeof e.alt == "string" ? (e = this.stringToFieldJson_(e.alt)) ? this.fieldFromJson_(e) : null : this.fieldFromJson_(e.alt) : t;
        }
        inputFromJson_(e, t) {
          var n = { LEFT: r.Align$$module$build$src$core$inputs$align.LEFT, RIGHT: r.Align$$module$build$src$core$inputs$align.RIGHT, CENTRE: r.Align$$module$build$src$core$inputs$align.CENTRE, CENTER: r.Align$$module$build$src$core$inputs$align.CENTRE };
          let s;
          switch (e.type) {
            case "input_value":
              s = this.appendValueInput(e.name);
              break;
            case "input_statement":
              s = this.appendStatementInput(e.name);
              break;
            case "input_dummy":
              s = this.appendDummyInput(e.name);
              break;
            default:
              s = this.appendInputFromRegistry(
                e.type,
                e.name
              );
          }
          return s ? (e.check && s.setCheck(e.check), e.align && (n = n[e.align.toUpperCase()], n === void 0 ? console.warn(t + "Illegal align value: ", e.align) : s.setAlign(n)), s) : null;
        }
        isInputKeyword_(e) {
          return e === "input_value" || e === "input_statement" || e === "input_dummy" || h(_e.INPUT, e);
        }
        stringToFieldJson_(e) {
          return (e = e.trim()) ? { type: "field_label", text: e } : null;
        }
        moveInputBefore(e, t) {
          if (e !== t) {
            var n = -1, s = t ? -1 : this.inputList.length;
            for (let u = 0, A; A = this.inputList[u]; u++)
              if (A.name === e) {
                if (n = u, s !== -1)
                  break;
              } else if (t && A.name === t && (s = u, n !== -1))
                break;
            if (n === -1)
              throw Error('Named input "' + e + '" not found.');
            if (s === -1)
              throw Error('Reference input "' + t + '" not found.');
            this.moveNumberedInputBefore(n, s);
          }
        }
        moveNumberedInputBefore(e, t) {
          if (e === t)
            throw Error("Can't move input to itself.");
          if (e >= this.inputList.length)
            throw RangeError("Input index " + e + " out of bounds.");
          if (t > this.inputList.length)
            throw RangeError("Reference input " + t + " out of bounds.");
          const n = this.inputList[e];
          this.inputList.splice(e, 1), e < t && t--, this.inputList.splice(t, 0, n);
        }
        removeInput(e, t) {
          for (let n = 0, s; s = this.inputList[n]; n++)
            if (s.name === e)
              return s instanceof wn && this.statementInputCount--, s.dispose(), this.inputList.splice(n, 1), !0;
          if (t)
            return !1;
          throw Error("Input not found: " + e);
        }
        getInput(e) {
          for (let t = 0, n; n = this.inputList[t]; t++)
            if (n.name === e)
              return n;
          return null;
        }
        getInputTargetBlock(e) {
          return (e = this.getInput(e)) && e.connection && e.connection.targetBlock();
        }
        getCommentText() {
          let e, t;
          return (t = (e = this.getIcon(Or.TYPE)) == null ? void 0 : e.getText()) != null ? t : null;
        }
        setCommentText(e) {
          var t;
          let n;
          const s = (n = (t = this.getIcon(Or.TYPE)) == null ? void 0 : t.getText()) != null ? n : null;
          s !== e && (Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(this, "comment", null, s, e)), e !== null ? ((t = this.getIcon(Or.TYPE)) || (t = this.addIcon(new Or(this))), t.setText(e)) : this.removeIcon(Or.TYPE));
        }
        setWarningText(e, t) {
        }
        setMutator(e) {
        }
        addIcon(e) {
          if (this.hasIcon(e.getType()))
            throw new rA(e);
          return this.icons.push(e), this.icons.sort((t, n) => t.getWeight() - n.getWeight()), e;
        }
        removeIcon(e) {
          if (!this.hasIcon(e))
            return !1;
          let t;
          return (t = this.getIcon(e)) == null || t.dispose(), this.icons = this.icons.filter((n) => !n.getType().equals(e)), !0;
        }
        hasIcon(e) {
          return this.icons.some((t) => t.getType().equals(e));
        }
        getIcon(e) {
          return e instanceof Lr ? this.icons.find((t) => t.getType().equals(e)) : this.icons.find((t) => t.getType().toString() === e);
        }
        getIcons() {
          return [...this.icons];
        }
        getRelativeToSurfaceXY() {
          return this.xy_;
        }
        moveBy(e, t, n) {
          if (this.parentBlock_)
            throw Error("Block has parent");
          const s = new (fe(r.MOVE$$module$build$src$core$events$utils))(this);
          n && s.setReason(n), this.xy_.translate(e, t), s.recordNew(), Ce(s);
        }
        makeConnection_(e) {
          return new ut(this, e);
        }
        allInputsFilled(e) {
          if (e === void 0 && (e = !0), !e && this.isShadow())
            return !1;
          for (let n = 0, s; s = this.inputList[n]; n++)
            if (s.connection) {
              var t = s.connection.targetBlock();
              if (!t || !t.allInputsFilled(e))
                return !1;
            }
          return (t = this.getNextBlock()) ? t.allInputsFilled(e) : !0;
        }
        toDevString() {
          let e = this.type ? '"' + this.type + '" block' : "Block";
          return this.id && (e += ' (id="' + this.id + '")'), e;
        }
      };
      Ea.COLLAPSED_INPUT_NAME = sa, Ea.COLLAPSED_FIELD_NAME = _u;
      var D_ = null, b_ = null, P_ = {};
      P_.connectionUiEffect = Xs, P_.disconnectUiEffect = jT, P_.disconnectUiStop = Ks, P_.disposeUiEffect = Jl;
      var od = class extends Yi {
        constructor(e, t, n) {
          super(e ? e.workspace.id : void 0), this.type = il, e && (this.blockId = e.id, this.isStart = t, this.blocks = n);
        }
        toJson() {
          const e = super.toJson();
          if (this.isStart === void 0)
            throw Error("Whether this event is the start of a drag is undefined. Either pass the value to the constructor, or call fromJson");
          if (this.blockId === void 0)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          return e.isStart = this.isStart, e.blockId = this.blockId, e.blocks = this.blocks, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new od()), t.isStart = e.isStart, t.blockId = e.blockId, t.blocks = e.blocks, t;
        }
      };
      o(_e.EVENT, il, od);
      var Nu = {};
      Nu.bumpIntoBounds = js, Nu.bumpIntoBoundsHandler = JT, Nu.bumpTopObjectsIntoBounds = qo;
      var yu = /* @__PURE__ */ new Set(), fu = /* @__PURE__ */ new WeakSet(), Aa = null, ld = {};
      ld.finishQueuedRenders = R, ld.queueRender = $c;
      var Wo = class {
        constructor(e) {
          this.name_ = e;
        }
        toString() {
          return this.name_;
        }
      };
      Wo.POSITIONABLE = new Wo("positionable"), Wo.DRAG_TARGET = new Wo("drag_target"), Wo.DELETE_AREA = new Wo("delete_area"), Wo.AUTOHIDEABLE = new Wo("autohideable");
      var ft = class {
        constructor() {
          this.componentData = /* @__PURE__ */ new Map(), this.capabilityToComponentIds = /* @__PURE__ */ new Map();
        }
        addComponent(e, t) {
          const n = e.component.id;
          if (!t && this.componentData.has(n)) {
            var s;
            throw Error('Plugin "' + n + '" with capabilities "' + ((s = this.componentData.get(n)) == null ? void 0 : s.capabilities) + '" already added.');
          }
          for (this.componentData.set(n, e), t = [], s = 0; s < e.capabilities.length; s++) {
            const u = String(e.capabilities[s]).toLowerCase();
            if (t.push(u), this.capabilityToComponentIds.has(u)) {
              let A;
              (A = this.capabilityToComponentIds.get(u)) == null || A.push(n);
            } else
              this.capabilityToComponentIds.set(u, [n]);
          }
          this.componentData.get(n).capabilities = t;
        }
        removeComponent(e) {
          const t = this.componentData.get(e);
          if (t) {
            for (let n = 0; n < t.capabilities.length; n++) {
              const s = String(t.capabilities[n]).toLowerCase();
              pn(this.capabilityToComponentIds.get(s), e);
            }
            this.componentData.delete(e);
          }
        }
        addCapability(e, t) {
          if (!this.getComponent(e))
            throw Error('Cannot add capability, "' + t + '". Plugin "' + e + '" has not been added to the ComponentManager');
          if (this.hasCapability(e, t))
            console.warn('Plugin "' + e + 'already has capability "' + t + '"');
          else {
            t = `${t}`.toLowerCase();
            var n;
            (n = this.componentData.get(e)) == null || n.capabilities.push(t);
            var s;
            (s = this.capabilityToComponentIds.get(t)) == null || s.push(e);
          }
        }
        removeCapability(e, t) {
          if (!this.getComponent(e))
            throw Error('Cannot remove capability, "' + t + '". Plugin "' + e + '" has not been added to the ComponentManager');
          this.hasCapability(e, t) ? (t = `${t}`.toLowerCase(), pn(
            this.componentData.get(e).capabilities,
            t
          ), pn(this.capabilityToComponentIds.get(t), e)) : console.warn('Plugin "' + e + `doesn't have capability "` + t + '" to remove');
        }
        hasCapability(e, t) {
          return t = `${t}`.toLowerCase(), this.componentData.has(e) && this.componentData.get(e).capabilities.indexOf(t) !== -1;
        }
        getComponent(e) {
          let t;
          return (t = this.componentData.get(e)) == null ? void 0 : t.component;
        }
        getComponents(e, t) {
          if (e = `${e}`.toLowerCase(), e = this.capabilityToComponentIds.get(e), !e)
            return [];
          const n = [];
          if (t) {
            const s = [];
            e.forEach((u) => {
              s.push(this.componentData.get(u));
            }), s.sort(function(u, A) {
              return u.weight - A.weight;
            }), s.forEach(function(u) {
              n.push(u.component);
            });
          } else
            e.forEach((s) => {
              n.push(this.componentData.get(s).component);
            });
          return n;
        }
      };
      ft.Capability = Wo;
      var sd, SA;
      sd = 28, r.config$$module$build$src$core$config = { dragRadius: 5, flyoutDragRadius: 10, snapRadius: sd, connectingSnapRadius: sd, currentConnectionPreference: 8, bumpDelay: 250 }, SA = {}, SA.config = r.config$$module$build$src$core$config;
      var Sl = "The insertion marker manager tried to create a marker but the result is missing %1. If you are using a mutator, make sure your domToMutation method is properly defined.", $e = class {
        constructor(e) {
          this.activeCandidate = this.lastMarker = this.lastOnStack = null, this.wouldDeleteBlock = !1, this.fadedBlock = this.highlightedBlock = this.markerConnection = null, at(e), this.topBlock = e, this.workspace = e.workspace, this.firstMarker = this.createMarkerBlock(this.topBlock), this.availableConnections = this.initAvailableConnections(), this.lastOnStack && (this.lastMarker = this.createMarkerBlock(this.lastOnStack.getSourceBlock()));
        }
        dispose() {
          this.availableConnections.length = 0, this.disposeInsertionMarker(this.firstMarker), this.disposeInsertionMarker(this.lastMarker);
        }
        updateAvailableConnections() {
          this.availableConnections = this.initAvailableConnections();
        }
        wouldConnectBlock() {
          return !!this.activeCandidate;
        }
        applyConnections() {
          if (this.activeCandidate) {
            r.disable$$module$build$src$core$events$utils(), this.hidePreview(), r.enable$$module$build$src$core$events$utils();
            var { local: e, closest: t } = this.activeCandidate;
            if (e.connect(t), this.topBlock.rendered) {
              const n = e.isSuperior() ? t : e, s = this.topBlock.getRootBlock();
              R().then(() => {
                Xs(n.getSourceBlock()), setTimeout(() => {
                  s.bringToFront();
                }, 0);
              });
            }
          }
        }
        update(e, t) {
          const n = this.getCandidate(e);
          ((this.wouldDeleteBlock = this.shouldDelete(!!n, t)) || this.shouldUpdatePreviews(
            n,
            e
          )) && (r.disable$$module$build$src$core$events$utils(), this.maybeHidePreview(n), this.maybeShowPreview(n), r.enable$$module$build$src$core$events$utils());
        }
        createMarkerBlock(e) {
          var t = e.type;
          r.disable$$module$build$src$core$events$utils();
          let n;
          try {
            if (n = this.workspace.newBlock(t), n.setInsertionMarker(!0), e.saveExtraState) {
              var s = e.saveExtraState();
              s && n.loadExtraState && n.loadExtraState(s);
            } else if (e.mutationToDom) {
              const u = e.mutationToDom();
              u && n.domToMutation && n.domToMutation(u);
            }
            for (t = 0; t < e.inputList.length; t++) {
              const u = e.inputList[t];
              if (u.name === sa)
                continue;
              const A = n.inputList[t];
              if (!A)
                throw Error(Sl.replace("%1", "an input"));
              for (s = 0; s < u.fieldRow.length; s++) {
                const L = u.fieldRow[s], $ = A.fieldRow[s];
                if (!$)
                  throw Error(Sl.replace("%1", "a field"));
                $.setValue(L.getValue());
              }
            }
            n.setCollapsed(e.isCollapsed()), n.setInputsInline(e.getInputsInline()), n.initSvg(), n.getSvgRoot().setAttribute("visibility", "hidden");
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return n;
        }
        initAvailableConnections() {
          const e = this.topBlock.getConnections_(!1), t = this.topBlock.lastConnectionInStack(!0);
          return t && t !== this.topBlock.nextConnection && (e.push(t), this.lastOnStack = t), e;
        }
        shouldUpdatePreviews(e, t) {
          if (!e)
            return !!this.activeCandidate;
          if (!this.activeCandidate)
            return !0;
          const { local: n, closest: s } = this.activeCandidate;
          if (s === e.closest && n === e.local)
            return !1;
          const u = n.x + t.x - s.x;
          return t = n.y + t.y - s.y, e.radius < Math.sqrt(u * u + t * t) - r.config$$module$build$src$core$config.currentConnectionPreference;
        }
        getCandidate(e) {
          this.markerConnection && this.markerConnection.isConnected() || this.updateAvailableConnections();
          let t = this.getStartRadius(), n = null;
          for (let s = 0; s < this.availableConnections.length; s++) {
            const u = this.availableConnections[s], A = u.closest(t, e);
            A.connection && (n = { closest: A.connection, local: u, radius: A.radius }, t = A.radius);
          }
          return n;
        }
        getStartRadius() {
          return this.activeCandidate ? r.config$$module$build$src$core$config.connectingSnapRadius : r.config$$module$build$src$core$config.snapRadius;
        }
        shouldDelete(e, t) {
          return t && this.workspace.getComponentManager().hasCapability(t.id, ft.Capability.DELETE_AREA) ? t.wouldDelete(this.topBlock, e) : !1;
        }
        maybeShowPreview(e) {
          if (!this.wouldDeleteBlock && e) {
            var t = e.closest, n;
            t === ((n = this.activeCandidate) == null ? void 0 : n.closest) || t.getSourceBlock().isInsertionMarker() ? console.log("Trying to connect to an insertion marker") : (this.activeCandidate = e, this.showPreview(this.activeCandidate));
          }
        }
        showPreview(e) {
          const t = this.workspace.getRenderer();
          switch (t.getConnectionPreviewMethod(e.closest, e.local, this.topBlock)) {
            case $e.PREVIEW_TYPE.INPUT_OUTLINE:
              this.showInsertionInputOutline(e);
              break;
            case $e.PREVIEW_TYPE.INSERTION_MARKER:
              this.showInsertionMarker(e);
              break;
            case $e.PREVIEW_TYPE.REPLACEMENT_FADE:
              this.showReplacementFade(e);
          }
          t.shouldHighlightConnection(e.closest) && e.closest.highlight();
        }
        maybeHidePreview(e) {
          if (!e)
            this.hidePreview();
          else if (this.activeCandidate) {
            const t = this.activeCandidate.local !== e.local;
            (this.activeCandidate.closest !== e.closest || t || this.wouldDeleteBlock) && this.hidePreview();
          }
          this.activeCandidate = this.markerConnection = null;
        }
        hidePreview() {
          let e;
          const t = (e = this.activeCandidate) == null ? void 0 : e.closest;
          t && t.targetBlock() && this.workspace.getRenderer().shouldHighlightConnection(t) && t.unhighlight(), this.hideReplacementFade(), this.hideInsertionInputOutline(), this.hideInsertionMarker();
        }
        showInsertionMarker(e) {
          const { local: t, closest: n } = e;
          let s = (e = this.lastOnStack && t === this.lastOnStack) ? this.lastMarker : this.firstMarker;
          if (!s)
            throw Error("Cannot show the insertion marker because there is no insertion marker block");
          let u;
          try {
            u = s.getMatchingConnection(t.getSourceBlock(), t);
          } catch {
            if (e && this.lastOnStack ? (this.disposeInsertionMarker(this.lastMarker), s = this.lastMarker = this.createMarkerBlock(this.lastOnStack.getSourceBlock())) : (this.disposeInsertionMarker(this.firstMarker), s = this.firstMarker = this.createMarkerBlock(this.topBlock)), !s)
              throw Error("Cannot show the insertion marker because there is no insertion marker block");
            u = s.getMatchingConnection(t.getSourceBlock(), t);
          }
          if (!u)
            throw Error("Cannot show the insertion marker because there is no associated connection");
          if (u === this.markerConnection)
            throw Error("Made it to showInsertionMarker_ even though the marker isn't changing");
          s.render(), s.rendered = !0, s.getSvgRoot().setAttribute("visibility", "visible"), u && n && s.positionNearConnection(
            u,
            n
          ), n && u.connect(n), this.markerConnection = u;
        }
        hideInsertionMarker() {
          if (this.markerConnection) {
            var e = this.markerConnection, t = e.getSourceBlock(), n = t.outputConnection, s;
            if ((s = t.previousConnection) != null && s.targetConnection || n != null && n.targetConnection)
              t.unplug(!0);
            else {
              let u;
              (u = e.targetBlock()) == null || u.unplug(!1);
            }
            if (e.targetConnection)
              throw Error("markerConnection still connected at the end of disconnectInsertionMarker");
            this.markerConnection = null, (e = t.getSvgRoot()) && e.setAttribute(
              "visibility",
              "hidden"
            );
          }
        }
        showInsertionInputOutline(e) {
          e = e.closest, this.highlightedBlock = e.getSourceBlock(), this.highlightedBlock.highlightShapeForInput(e, !0);
        }
        hideInsertionInputOutline() {
          if (this.highlightedBlock) {
            if (!this.activeCandidate)
              throw Error("Cannot hide the insertion marker outline because there is no active candidate");
            this.highlightedBlock.highlightShapeForInput(this.activeCandidate.closest, !1), this.highlightedBlock = null;
          }
        }
        showReplacementFade(e) {
          if (this.fadedBlock = e.closest.targetBlock(), !this.fadedBlock)
            throw Error("Cannot show the replacement fade because the closest connection does not have a target block");
          this.fadedBlock.fadeForReplacement(!0);
        }
        hideReplacementFade() {
          this.fadedBlock && (this.fadedBlock.fadeForReplacement(!1), this.fadedBlock = null);
        }
        getInsertionMarkers() {
          const e = [];
          return this.firstMarker && e.push(this.firstMarker), this.lastMarker && e.push(this.lastMarker), e;
        }
        disposeInsertionMarker(e) {
          if (e) {
            r.disable$$module$build$src$core$events$utils();
            try {
              e.dispose();
            } finally {
              r.enable$$module$build$src$core$events$utils();
            }
          }
        }
      };
      (function(e) {
        e = e.PREVIEW_TYPE || (e.PREVIEW_TYPE = {}), e[e.INSERTION_MARKER = 0] = "INSERTION_MARKER", e[e.INPUT_OUTLINE = 1] = "INPUT_OUTLINE", e[e.REPLACEMENT_FADE = 2] = "REPLACEMENT_FADE";
      })($e || ($e = {})), $e.PREVIEW_TYPE;
      var hA = class {
        constructor(e, t) {
          this.dragTarget_ = null, this.wouldDeleteBlock_ = !1, this.draggingBlock_ = e, this.draggedConnectionManager_ = new $e(this.draggingBlock_), this.workspace_ = t, this.startXY_ = this.draggingBlock_.getRelativeToSurfaceXY(), this.dragIconData_ = QT(e, this.startXY_);
        }
        dispose() {
          this.dragIconData_.length = 0, this.draggedConnectionManager_ && this.draggedConnectionManager_.dispose();
        }
        startDrag(e, t) {
          r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.fireDragStartEvent_(), this.workspace_.isMutator && this.draggingBlock_.bringToFront(), Ur(), this.workspace_.setResizesEnabled(!1), Ks(), this.shouldDisconnect_(t) && this.disconnectBlock_(t, e), this.draggingBlock_.setDragging(!0);
        }
        shouldDisconnect_(e) {
          return !!(this.draggingBlock_.getParent() || e && this.draggingBlock_.nextConnection && this.draggingBlock_.nextConnection.targetBlock());
        }
        disconnectBlock_(e, t) {
          this.draggingBlock_.unplug(e), e = this.pixelsToWorkspaceUnits_(t), e = Te.sum(this.startXY_, e), this.draggingBlock_.translate(e.x, e.y), jT(this.draggingBlock_), this.draggedConnectionManager_.updateAvailableConnections();
        }
        fireDragStartEvent_() {
          const e = new (fe(il))(
            this.draggingBlock_,
            !0,
            this.draggingBlock_.getDescendants(!1)
          );
          Ce(e);
        }
        drag(e, t) {
          t = this.pixelsToWorkspaceUnits_(t);
          var n = Te.sum(this.startXY_, t);
          this.draggingBlock_.moveDuringDrag(n), this.dragIcons_(t), n = this.dragTarget_, this.dragTarget_ = this.workspace_.getDragTarget(e), this.draggedConnectionManager_.update(t, this.dragTarget_), e = this.wouldDeleteBlock_, this.wouldDeleteBlock_ = this.draggedConnectionManager_.wouldDeleteBlock, e !== this.wouldDeleteBlock_ && this.updateCursorDuringBlockDrag_(), this.dragTarget_ !== n && (n && n.onDragExit(this.draggingBlock_), this.dragTarget_ && this.dragTarget_.onDragEnter(this.draggingBlock_)), this.dragTarget_ && this.dragTarget_.onDragOver(this.draggingBlock_);
        }
        endDrag(e, t) {
          this.drag(e, t), this.dragIconData_ = [], this.fireDragEndEvent_(), tr(), Ks(), e = null, this.dragTarget_ && this.dragTarget_.shouldPreventMove(this.draggingBlock_) || (e = this.getNewLocationAfterDrag_(t).delta), this.dragTarget_ && this.dragTarget_.onDrop(this.draggingBlock_), this.maybeDeleteBlock_() || (this.draggingBlock_.setDragging(!1), e ? this.updateBlockAfterMove_() : js(this.draggingBlock_.workspace, this.workspace_.getMetricsManager().getScrollMetrics(!0), this.draggingBlock_)), this.workspace_.setResizesEnabled(!0), r.setGroup$$module$build$src$core$events$utils(!1);
        }
        getNewLocationAfterDrag_(e) {
          e = this.pixelsToWorkspaceUnits_(e);
          const t = Te.sum(this.startXY_, e);
          return { delta: e, newLocation: t };
        }
        maybeDeleteBlock_() {
          return this.wouldDeleteBlock_ ? (this.fireMoveEvent_(), this.draggingBlock_.dispose(!1, !0), qs.length = 0, !0) : !1;
        }
        updateBlockAfterMove_() {
          this.fireMoveEvent_(), this.draggedConnectionManager_.wouldConnectBlock() ? this.draggedConnectionManager_.applyConnections() : this.draggingBlock_.queueRender(), this.draggingBlock_.scheduleSnapAndBump();
        }
        fireDragEndEvent_() {
          const e = new (fe(il))(this.draggingBlock_, !1, this.draggingBlock_.getDescendants(!1));
          Ce(e);
        }
        updateToolboxStyle_(e) {
          const t = this.workspace_.getToolbox();
          if (t) {
            const n = this.draggingBlock_.isDeletable() ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
            e && typeof t.removeStyle == "function" ? t.removeStyle(n) : e || typeof t.addStyle != "function" || t.addStyle(n);
          }
        }
        fireMoveEvent_() {
          if (!this.draggingBlock_.isDeadOrDying()) {
            var e = new (fe(r.MOVE$$module$build$src$core$events$utils))(this.draggingBlock_);
            e.setReason(["drag"]), e.oldCoordinate = this.startXY_, e.recordNew(), Ce(e);
          }
        }
        updateCursorDuringBlockDrag_() {
          this.draggingBlock_.setDeleteStyle(this.wouldDeleteBlock_);
        }
        pixelsToWorkspaceUnits_(e) {
          return e = new Te(e.x / this.workspace_.scale, e.y / this.workspace_.scale), this.workspace_.isMutator && e.scale(1 / this.workspace_.options.parentWorkspace.scale), e;
        }
        dragIcons_(e) {
          for (const t of this.dragIconData_)
            t.icon.onLocationChange(Te.sum(t.location, e));
        }
        getInsertionMarkers() {
          return this.draggedConnectionManager_ && this.draggedConnectionManager_.getInsertionMarkers ? this.draggedConnectionManager_.getInsertionMarkers() : [];
        }
      };
      o(_e.BLOCK_DRAGGER, Vi, hA);
      var sr = null, Qt = { duplicateInternal: fE, copyInternal: tl }, $_ = {};
      $_.TEST_ONLY = Qt, $_.copy = r_, $_.duplicate = Wc, $_.paste = qT;
      var Mi = null, mA = {}, Cu = null, Zi = {};
      Zi.callbackFactory = r.callbackFactory$$module$build$src$core$contextmenu, Zi.commentDeleteOption = tp, Zi.commentDuplicateOption = rp, Zi.dispose = Ei, Zi.getCurrentBlock = CE, Zi.hide = n_, Zi.setCurrentBlock = ep, Zi.show = Dn, Zi.workspaceCommentOption = bE;
      var pt = class {
        constructor() {
          this.registry_ = /* @__PURE__ */ new Map(), this.reset();
        }
        reset() {
          this.registry_.clear();
        }
        register(e) {
          if (this.registry_.has(e.id))
            throw Error('Menu item with ID "' + e.id + '" is already registered.');
          this.registry_.set(e.id, e);
        }
        unregister(e) {
          if (!this.registry_.has(e))
            throw Error('Menu item with ID "' + e + '" not found.');
          this.registry_.delete(e);
        }
        getItem(e) {
          let t;
          return (t = this.registry_.get(e)) != null ? t : null;
        }
        getContextMenuOptions(e, t) {
          const n = [];
          for (const u of this.registry_.values())
            if (e === u.scopeType) {
              var s = u.preconditionFn(t);
              s !== "hidden" && (s = { text: typeof u.displayText == "function" ? u.displayText(t) : u.displayText, enabled: s === "enabled", callback: u.callback, scope: t, weight: u.weight }, n.push(s));
            }
          return n.sort(function(u, A) {
            return u.weight - A.weight;
          }), n;
        }
      };
      (function(e) {
        var t = e.ScopeType || (e.ScopeType = {});
        t.BLOCK = "block", t.WORKSPACE = "workspace", e.registry = new e();
      })(pt || (pt = {})), pt.ScopeType;
      var IA = 30, vu = !0, Is = [];
      Is[me.INPUT_VALUE] = me.OUTPUT_VALUE, Is[me.OUTPUT_VALUE] = me.INPUT_VALUE, Is[me.NEXT_STATEMENT] = me.PREVIOUS_STATEMENT, Is[me.PREVIOUS_STATEMENT] = me.NEXT_STATEMENT;
      var gi = "RENAME_VARIABLE_ID", Ru = "DELETE_VARIABLE_ID", ie = class {
        constructor(e, t, n) {
          if (this.wsCoordinate = null, !t)
            throw Error("Cannot create a node without a location.");
          this.type = e, this.isConnectionLocation = ie.isConnectionType(e), this.location = t, this.processParams(n || null);
        }
        processParams(e) {
          e && e.wsCoordinate && (this.wsCoordinate = e.wsCoordinate);
        }
        getLocation() {
          return this.location;
        }
        getType() {
          return this.type;
        }
        getWsCoordinate() {
          return this.wsCoordinate;
        }
        isConnection() {
          return this.isConnectionLocation;
        }
        findNextForInput() {
          var e = this.location.getParentInput();
          const t = e.getSourceBlock();
          for (e = t.inputList.indexOf(e), e += 1; e < t.inputList.length; e++) {
            const n = t.inputList[e], s = n.fieldRow;
            for (let u = 0; u < s.length; u++) {
              const A = s[u];
              if (A.isClickable() || ie.NAVIGATE_ALL_FIELDS)
                return ie.createFieldNode(A);
            }
            if (n.connection)
              return ie.createInputNode(n);
          }
          return null;
        }
        findNextForField() {
          var e = this.location, t = e.getParentInput();
          const n = e.getSourceBlock();
          if (!n)
            throw Error("The current AST location is not associated with a block");
          var s = n.inputList.indexOf(t);
          for (e = t.fieldRow.indexOf(e) + 1; s < n.inputList.length; s++) {
            t = n.inputList[s];
            const u = t.fieldRow;
            for (; e < u.length; ) {
              if (u[e].isClickable() || ie.NAVIGATE_ALL_FIELDS)
                return ie.createFieldNode(u[e]);
              e++;
            }
            if (e = 0, t.connection)
              return ie.createInputNode(t);
          }
          return null;
        }
        findPrevForInput() {
          const e = this.location.getParentInput(), t = e.getSourceBlock();
          for (var n = t.inputList.indexOf(e); 0 <= n; n--) {
            var s = t.inputList[n];
            if (s.connection && s !== e)
              return ie.createInputNode(s);
            s = s.fieldRow;
            for (let u = s.length - 1; 0 <= u; u--) {
              const A = s[u];
              if (A.isClickable() || ie.NAVIGATE_ALL_FIELDS)
                return ie.createFieldNode(A);
            }
          }
          return null;
        }
        findPrevForField() {
          var e = this.location;
          const t = e.getParentInput(), n = e.getSourceBlock();
          if (!n)
            throw Error("The current AST location is not associated with a block");
          var s = n.inputList.indexOf(t);
          for (e = t.fieldRow.indexOf(e) - 1; 0 <= s; s--) {
            var u = n.inputList[s];
            if (u.connection && u !== t)
              return ie.createInputNode(u);
            for (u = u.fieldRow; -1 < e; ) {
              if (u[e].isClickable() || ie.NAVIGATE_ALL_FIELDS)
                return ie.createFieldNode(u[e]);
              e--;
            }
            0 <= s - 1 && (e = n.inputList[s - 1].fieldRow.length - 1);
          }
          return null;
        }
        navigateBetweenStacks(e) {
          var t = this.getLocation();
          if (t.getSourceBlock) {
            var n = t.getSourceBlock();
            n && (t = n);
          }
          if (!t || t.isDeadOrDying())
            return null;
          n = t.getRootBlock(), t = n.workspace.getTopBlocks(!0);
          for (let s = 0; s < t.length; s++)
            if (n.id === t[s].id)
              return e = s + (e ? 1 : -1), e === -1 || e === t.length ? null : ie.createStackNode(t[e]);
          throw Error("Couldn't find " + (e ? "next" : "previous") + " stack?!");
        }
        findTopASTNodeForBlock(e) {
          const t = i_(e);
          return t ? ie.createConnectionNode(t) : ie.createBlockNode(e);
        }
        getOutAstNodeForBlock(e) {
          if (!e)
            return null;
          e = e.getTopStackBlock();
          const t = i_(e);
          return t && t.targetConnection && t.targetConnection.getParentInput() ? ie.createInputNode(t.targetConnection.getParentInput()) : ie.createStackNode(e);
        }
        findFirstFieldOrInput(e) {
          e = e.inputList;
          for (let t = 0; t < e.length; t++) {
            const n = e[t], s = n.fieldRow;
            for (let u = 0; u < s.length; u++) {
              const A = s[u];
              if (A.isClickable() || ie.NAVIGATE_ALL_FIELDS)
                return ie.createFieldNode(A);
            }
            if (n.connection)
              return ie.createInputNode(n);
          }
          return null;
        }
        getSourceBlock() {
          return this.getType() === ie.types.BLOCK ? this.getLocation() : this.getType() === ie.types.STACK ? this.getLocation() : this.getType() === ie.types.WORKSPACE ? null : this.getLocation().getSourceBlock();
        }
        next() {
          switch (this.type) {
            case ie.types.STACK:
              return this.navigateBetweenStacks(!0);
            case ie.types.OUTPUT:
              return ie.createBlockNode(this.location.getSourceBlock());
            case ie.types.FIELD:
              return this.findNextForField();
            case ie.types.INPUT:
              return this.findNextForInput();
            case ie.types.BLOCK:
              const e = this.location.nextConnection;
              if (!e)
                break;
              return ie.createConnectionNode(e);
            case ie.types.PREVIOUS:
              return ie.createBlockNode(this.location.getSourceBlock());
            case ie.types.NEXT:
              return ie.createConnectionNode(this.location.targetConnection);
          }
          return null;
        }
        in() {
          switch (this.type) {
            case ie.types.WORKSPACE:
              const e = this.location.getTopBlocks(!0);
              if (0 < e.length)
                return ie.createStackNode(e[0]);
              break;
            case ie.types.STACK:
              return this.findTopASTNodeForBlock(this.location);
            case ie.types.BLOCK:
              return this.findFirstFieldOrInput(this.location);
            case ie.types.INPUT:
              return ie.createConnectionNode(this.location.targetConnection);
          }
          return null;
        }
        prev() {
          switch (this.type) {
            case ie.types.STACK:
              return this.navigateBetweenStacks(!1);
            case ie.types.FIELD:
              return this.findPrevForField();
            case ie.types.INPUT:
              return this.findPrevForInput();
            case ie.types.BLOCK:
              var e = i_(this.location);
              if (!e)
                break;
              return ie.createConnectionNode(e);
            case ie.types.PREVIOUS:
              if ((e = this.location.targetConnection) && !e.getParentInput())
                return ie.createConnectionNode(e);
              break;
            case ie.types.NEXT:
              return ie.createBlockNode(this.location.getSourceBlock());
          }
          return null;
        }
        out() {
          switch (this.type) {
            case ie.types.STACK:
              var e = this.location, t = e.getRelativeToSurfaceXY();
              return t = new Te(t.x, t.y + ie.DEFAULT_OFFSET_Y), ie.createWorkspaceNode(
                e.workspace,
                t
              );
            case ie.types.OUTPUT:
              return e = this.location, (t = e.targetConnection) ? ie.createConnectionNode(t) : ie.createStackNode(e.getSourceBlock());
            case ie.types.FIELD:
              if (e = this.location.getSourceBlock(), !e)
                throw Error("The current AST location is not associated with a block");
              return ie.createBlockNode(e);
            case ie.types.INPUT:
              return ie.createBlockNode(this.location.getSourceBlock());
            case ie.types.BLOCK:
              return this.getOutAstNodeForBlock(this.location);
            case ie.types.PREVIOUS:
              return this.getOutAstNodeForBlock(this.location.getSourceBlock());
            case ie.types.NEXT:
              return this.getOutAstNodeForBlock(this.location.getSourceBlock());
          }
          return null;
        }
        static isConnectionType(e) {
          switch (e) {
            case ie.types.PREVIOUS:
            case ie.types.NEXT:
            case ie.types.INPUT:
            case ie.types.OUTPUT:
              return !0;
          }
          return !1;
        }
        static createFieldNode(e) {
          return e ? new ie(ie.types.FIELD, e) : null;
        }
        static createConnectionNode(e) {
          if (!e)
            return null;
          const t = e.type;
          return t === me.INPUT_VALUE || t === me.NEXT_STATEMENT && e.getParentInput() ? ie.createInputNode(e.getParentInput()) : t === me.NEXT_STATEMENT ? new ie(ie.types.NEXT, e) : t === me.OUTPUT_VALUE ? new ie(ie.types.OUTPUT, e) : t === me.PREVIOUS_STATEMENT ? new ie(
            ie.types.PREVIOUS,
            e
          ) : null;
        }
        static createInputNode(e) {
          return e && e.connection ? new ie(ie.types.INPUT, e.connection) : null;
        }
        static createBlockNode(e) {
          return e ? new ie(ie.types.BLOCK, e) : null;
        }
        static createStackNode(e) {
          return e ? new ie(
            ie.types.STACK,
            e
          ) : null;
        }
        static createWorkspaceNode(e, t) {
          return t && e ? new ie(ie.types.WORKSPACE, e, { wsCoordinate: t }) : null;
        }
        static createTopNode(e) {
          const t = i_(e);
          return t ? ie.createConnectionNode(t) : ie.createBlockNode(e);
        }
      };
      ie.NAVIGATE_ALL_FIELDS = !1, ie.DEFAULT_OFFSET_Y = -20, function(e) {
        e = e.types || (e.types = {}), e.FIELD = "field", e.BLOCK = "block", e.INPUT = "input", e.OUTPUT = "output", e.NEXT = "next", e.PREVIOUS = "previous", e.STACK = "stack", e.WORKSPACE = "workspace";
      }(ie || (ie = {}));
      var Kt = class {
        constructor() {
          this.drawer = this.curNode = this.colour = null, this.type = "marker";
        }
        setDrawer(e) {
          this.drawer = e;
        }
        getDrawer() {
          return this.drawer;
        }
        getCurNode() {
          return this.curNode;
        }
        setCurNode(e) {
          const t = this.curNode;
          this.curNode = e, this.drawer && this.drawer.draw(t, this.curNode);
        }
        draw() {
          this.drawer && this.drawer.draw(this.curNode, this.curNode);
        }
        hide() {
          this.drawer && this.drawer.hide();
        }
        dispose() {
          this.getDrawer() && this.getDrawer().dispose();
        }
      }, jt = class extends Kt {
        constructor() {
          super(), this.type = "cursor";
        }
        next() {
          var e = this.getCurNode();
          if (!e)
            return null;
          for (e = e.next(); e && e.next() && (e.getType() === ie.types.NEXT || e.getType() === ie.types.BLOCK); )
            e = e.next();
          return e && this.setCurNode(e), e;
        }
        in() {
          var e = this.getCurNode();
          if (!e)
            return null;
          (e.getType() === ie.types.PREVIOUS || e.getType() === ie.types.OUTPUT) && (e = e.next());
          let t, n;
          return (e = (n = (t = e) == null ? void 0 : t.in()) != null ? n : null) && this.setCurNode(e), e;
        }
        prev() {
          var e = this.getCurNode();
          if (!e)
            return null;
          for (e = e.prev(); e && e.prev() && (e.getType() === ie.types.NEXT || e.getType() === ie.types.BLOCK); )
            e = e.prev();
          return e && this.setCurNode(e), e;
        }
        out() {
          var e = this.getCurNode();
          return e ? ((e = e.out()) && e.getType() === ie.types.BLOCK && (e = e.prev() || e), e && this.setCurNode(e), e) : null;
        }
      };
      o(_e.CURSOR, Vi, jt);
      var Sa = class extends jt {
        constructor() {
          super();
        }
        next() {
          var e = this.getCurNode();
          return e ? ((e = this.getNextNode_(e, this.validNode_)) && this.setCurNode(e), e) : null;
        }
        in() {
          return this.next();
        }
        prev() {
          var e = this.getCurNode();
          return e ? ((e = this.getPreviousNode_(e, this.validNode_)) && this.setCurNode(e), e) : null;
        }
        out() {
          return this.prev();
        }
        getNextNode_(e, t) {
          if (!e)
            return null;
          const n = e.in() || e.next();
          return t(n) ? n : n ? this.getNextNode_(n, t) : (e = this.findSiblingOrParent(e.out()), t(e) ? e : e ? this.getNextNode_(e, t) : null);
        }
        getPreviousNode_(e, t) {
          if (!e)
            return null;
          let n = e.prev();
          return n = n ? this.getRightMostChild(n) : e.out(), t(n) ? n : n ? this.getPreviousNode_(n, t) : null;
        }
        validNode_(e) {
          let t = !1;
          return e = e && e.getType(), (e === ie.types.OUTPUT || e === ie.types.INPUT || e === ie.types.FIELD || e === ie.types.NEXT || e === ie.types.PREVIOUS || e === ie.types.WORKSPACE) && (t = !0), t;
        }
        findSiblingOrParent(e) {
          if (!e)
            return null;
          const t = e.next();
          return t || this.findSiblingOrParent(e.out());
        }
        getRightMostChild(e) {
          if (!e.in())
            return e;
          for (e = e.in(); e && e.next(); )
            e = e.next();
          return this.getRightMostChild(e);
        }
      };
      Sa.registrationName = "basicCursor", o(_e.CURSOR, Sa.registrationName, Sa);
      var MA = class extends Sa {
        validNode_(e) {
          let t = !1;
          const n = e && e.getType();
          return e && (e = e.getLocation(), n === ie.types.FIELD && e && e.isTabNavigable() && e.isClickable() && (t = !0)), t;
        }
      }, ad = 10, tn = class extends ut {
        constructor(e, t) {
          super(e, t), this.targetConnection = this.highlightPath = null, this.db = e.workspace.connectionDBList[t], this.dbOpposite = e.workspace.connectionDBList[Is[t]], this.offsetInBlock = new Te(0, 0), this.trackedState = tn.TrackedState.WILL_TRACK;
        }
        dispose() {
          super.dispose(), this.trackedState === tn.TrackedState.TRACKED && this.db.removeConnection(this, this.y);
        }
        getSourceBlock() {
          return super.getSourceBlock();
        }
        targetBlock() {
          return super.targetBlock();
        }
        distanceFrom(e) {
          const t = this.x - e.x;
          return e = this.y - e.y, Math.sqrt(t * t + e * e);
        }
        bumpAwayFrom(e) {
          if (!this.sourceBlock_.workspace.isDragging()) {
            var t = this.sourceBlock_.getRootBlock();
            if (!t.isInFlyout) {
              var n = !1;
              if (!t.isMovable()) {
                if (t = e.getSourceBlock().getRootBlock(), !t.isMovable())
                  return;
                e = this, n = !0;
              }
              var s = Fe() == t;
              s || t.addSelect();
              var u = e.x + r.config$$module$build$src$core$config.snapRadius + Math.floor(Math.random() * ad) - this.x, A = e.y + r.config$$module$build$src$core$config.snapRadius + Math.floor(Math.random() * ad) - this.y;
              n && (A = -A), t.RTL && (u = e.x - r.config$$module$build$src$core$config.snapRadius - Math.floor(Math.random() * ad) - this.x), t.moveBy(u, A, ["bump"]), s || t.removeSelect();
            }
          }
        }
        moveTo(e, t) {
          let n = !1;
          return this.trackedState === tn.TrackedState.WILL_TRACK ? (this.db.addConnection(this, t), this.trackedState = tn.TrackedState.TRACKED, n = !0) : this.trackedState === tn.TrackedState.TRACKED && (this.db.removeConnection(this, this.y), this.db.addConnection(this, t), n = !0), this.x = e, this.y = t, n;
        }
        moveBy(e, t) {
          return this.moveTo(this.x + e, this.y + t);
        }
        moveToOffset(e) {
          return this.moveTo(e.x + this.offsetInBlock.x, e.y + this.offsetInBlock.y);
        }
        setOffsetInBlock(e, t) {
          this.offsetInBlock.x = e, this.offsetInBlock.y = t;
        }
        getOffsetInBlock() {
          return this.offsetInBlock;
        }
        tighten() {
          const e = this.targetConnection.x - this.x, t = this.targetConnection.y - this.y;
          if (e !== 0 || t !== 0) {
            const s = this.targetBlock();
            var n = s.getSvgRoot();
            if (!n)
              throw Error("block is not rendered.");
            n = Wl(n), s.translate(n.x - e, n.y - t), s.moveConnections(-e, -t);
          }
        }
        tightenEfficiently() {
          var e = this.targetConnection;
          const t = this.targetBlock();
          e && t && (e = Te.difference(this.offsetInBlock, e.offsetInBlock), t.translate(e.x, e.y));
        }
        closest(e, t) {
          return this.dbOpposite.searchForClosest(this, e, t);
        }
        highlight() {
          if (!this.highlightPath) {
            var e = this.sourceBlock_.workspace.getRenderer().getConstants(), t = e.shapeFor(this);
            this.type === me.INPUT_VALUE || this.type === me.OUTPUT_VALUE ? (e = e.TAB_OFFSET_FROM_TOP, t = wt(0, -e) + Ae("v", e) + t.pathDown + Ae("v", e)) : (e = e.NOTCH_OFFSET_LEFT - e.CORNER_RADIUS, t = wt(-e, 0) + Ae("h", e) + t.pathLeft + Ae("h", e)), e = this.offsetInBlock, this.highlightPath = K(G.PATH, { class: "blocklyHighlightedConnectionPath", d: t, transform: `translate(${e.x}, ${e.y})` + (this.sourceBlock_.RTL ? " scale(-1 1)" : "") }, this.sourceBlock_.getSvgRoot());
          }
        }
        unhighlight() {
          this.highlightPath && (_t(this.highlightPath), this.highlightPath = null);
        }
        setTracking(e) {
          e && this.trackedState === tn.TrackedState.TRACKED || !e && this.trackedState === tn.TrackedState.UNTRACKED || this.sourceBlock_.isInFlyout || (e ? (this.db.addConnection(this, this.y), this.trackedState = tn.TrackedState.TRACKED) : (this.trackedState === tn.TrackedState.TRACKED && this.db.removeConnection(
            this,
            this.y
          ), this.trackedState = tn.TrackedState.UNTRACKED));
        }
        stopTrackingAll() {
          if (this.setTracking(!1), this.targetConnection) {
            const e = this.targetBlock().getDescendants(!1);
            for (let t = 0; t < e.length; t++) {
              const n = e[t], s = n.getConnections_(!0);
              for (let u = 0; u < s.length; u++)
                s[u].setTracking(!1);
              for (const u of n.getIcons())
                Ko(u) && u.setBubbleVisible(!1);
            }
          }
        }
        startTrackingAll() {
          this.setTracking(!0);
          let e = [];
          if (this.type !== me.INPUT_VALUE && this.type !== me.NEXT_STATEMENT)
            return e;
          const t = this.targetBlock();
          if (t) {
            let n;
            t.isCollapsed() ? (n = [], t.outputConnection && n.push(t.outputConnection), t.nextConnection && n.push(t.nextConnection), t.previousConnection && n.push(t.previousConnection)) : n = t.getConnections_(!0);
            for (let s = 0; s < n.length; s++)
              e.push(...n[s].startTrackingAll());
            e.length || (e = [t]);
          }
          return e;
        }
        onFailedConnect(e) {
          const t = this.getSourceBlock();
          if (Dr()) {
            const n = r.getGroup$$module$build$src$core$events$utils();
            setTimeout((function() {
              t.isDisposed() || t.getParent() || (r.setGroup$$module$build$src$core$events$utils(n), this.bumpAwayFrom(e), r.setGroup$$module$build$src$core$events$utils(!1));
            }).bind(this), r.config$$module$build$src$core$config.bumpDelay);
          }
        }
        disconnectInternal(e = !0) {
          const { parentConnection: t, childConnection: n } = this.getParentAndChildConnections();
          if (t && n) {
            var s = t.getSourceBlock(), u = n.getSourceBlock();
            super.disconnectInternal(e), s.rendered && s.queueRender(), u.rendered && (u.updateDisabled(), u.queueRender(), u.getSvgRoot().style.display = "block");
          }
        }
        respawnShadow_() {
          super.respawnShadow_();
          const e = this.targetBlock();
          e && (e.initSvg(), e.queueRender());
        }
        neighbours(e) {
          return this.dbOpposite.getNeighbours(this, e);
        }
        connect_(e) {
          super.connect_(e);
          var t = this.getSourceBlock();
          e = e.getSourceBlock();
          const n = t.rendered, s = e.rendered;
          n && t.updateDisabled(), s && e.updateDisabled(), n && s && (this.type === me.NEXT_STATEMENT || this.type === me.PREVIOUS_STATEMENT ? e.queueRender() : t.queueRender()), (t = t.getInputWithBlock(e)) && (t = t.isVisible(), e.getSvgRoot().style.display = t ? "block" : "none");
        }
        onCheckChanged_() {
          !this.isConnected() || this.targetConnection && this.getConnectionChecker().canConnect(this, this.targetConnection, !1) || ((this.isSuperior() ? this.targetBlock() : this.sourceBlock_).unplug(), this.sourceBlock_.bumpNeighbours());
        }
      };
      (function(e) {
        e = e.TrackedState || (e.TrackedState = {}), e[e.WILL_TRACK = -1] = "WILL_TRACK", e[e.UNTRACKED = 0] = "UNTRACKED", e[e.TRACKED = 1] = "TRACKED";
      })(tn || (tn = {})), tn.TrackedState;
      var _d = 17, Li = class extends Eu {
        constructor(e) {
          super(e), this.sourceBlock = e, this.textMap = /* @__PURE__ */ new Map(), this.textBubble = null;
        }
        getType() {
          return Li.TYPE;
        }
        initView(e) {
          this.svgRoot || (super.initView(e), K(
            G.PATH,
            { class: "blocklyIconShape", d: "M2,15Q-1,15 0.5,12L6.5,1.7Q8,-1 9.5,1.7L15.5,12Q17,15 14,15z" },
            this.svgRoot
          ), K(G.PATH, { class: "blocklyIconSymbol", d: "m7,4.8v3.16l0.27,2.27h1.46l0.27,-2.27v-3.16z" }, this.svgRoot), K(G.RECT, { class: "blocklyIconSymbol", x: "7", y: "11", height: "2", width: "2" }, this.svgRoot));
        }
        dispose() {
          super.dispose();
          let e;
          (e = this.textBubble) == null || e.dispose();
        }
        getWeight() {
          return Li.WEIGHT;
        }
        getSize() {
          return new It(
            _d,
            _d
          );
        }
        applyColour() {
          super.applyColour();
          let e;
          (e = this.textBubble) == null || e.setColour(this.sourceBlock.style.colourPrimary);
        }
        updateCollapsed() {
        }
        isShownWhenCollapsed() {
          return !0;
        }
        onLocationChange(e) {
          super.onLocationChange(e);
          let t;
          (t = this.textBubble) == null || t.setAnchorLocation(this.getAnchorLocation());
        }
        addMessage(e, t) {
          if (this.textMap.get(t) === e)
            return this;
          e ? this.textMap.set(t, e) : this.textMap.delete(t);
          let n;
          return (n = this.textBubble) == null || n.setText(this.getText()), this;
        }
        getText() {
          return [...this.textMap.values()].join(`
`);
        }
        onClick() {
          super.onClick(), this.setBubbleVisible(!this.bubbleIsVisible());
        }
        bubbleIsVisible() {
          return !!this.textBubble;
        }
        setBubbleVisible(e) {
          if (this.bubbleIsVisible() !== e) {
            if (e)
              this.textBubble = new Lu(this.getText(), this.sourceBlock.workspace, this.getAnchorLocation(), this.getBubbleOwnerRect()), this.applyColour();
            else {
              let t;
              (t = this.textBubble) == null || t.dispose(), this.textBubble = null;
            }
            Ce(new (fe(Si))(
              this.sourceBlock,
              e,
              "warning"
            ));
          }
        }
        getAnchorLocation() {
          const e = _d / 2;
          return Te.sum(this.workspaceLocation, new Te(e, e));
        }
        getBubbleOwnerRect() {
          const e = this.sourceBlock.getSvgRoot().getBBox();
          return new yt(e.y, e.y + e.height, e.x, e.x + e.width);
        }
      };
      Li.TYPE = Lr.WARNING, Li.WEIGHT = 2;
      var Fn = class extends Ea {
        constructor(e, t, n) {
          super(e, t, n), this.width = this.height = 0, this.warningTextDb = /* @__PURE__ */ new Map(), this.warning = this.mutator = null, this.eventsInit_ = this.renderIsInProgress_ = this.visuallyDisabled = this.rendered = !1, this.translation = "", this.bumpNeighboursPid = 0, this.relativeCoords = new Te(0, 0), this.workspace = e, this.svgGroup_ = K(
            G.G,
            {}
          ), this.style = e.getRenderer().getConstants().getBlockStyle(null), this.pathObject = e.getRenderer().makePathObject(this.svgGroup_, this.style), e = this.pathObject.svgPath, e.tooltip = this, Vs(e), this.svgGroup_.setAttribute("data-id", this.id), this.doInit_();
        }
        initSvg() {
          if (!this.workspace.rendered)
            throw TypeError("Workspace is headless.");
          for (let t = 0, n; n = this.inputList[t]; t++)
            n.init();
          for (var e of this.getIcons())
            e.initView(this.createIconPointerDownListener(e)), e.updateEditable();
          this.applyColour(), this.pathObject.updateMovable(this.isMovable()), e = this.getSvgRoot(), this.workspace.options.readOnly || this.eventsInit_ || !e || ge(e, "pointerdown", this, this.onMouseDown_), this.eventsInit_ = !0, e.parentNode || this.workspace.getCanvas().appendChild(e);
        }
        getColourSecondary() {
          return this.style.colourSecondary;
        }
        getColourTertiary() {
          return this.style.colourTertiary;
        }
        select() {
          if (this.isShadow() && this.getParent())
            this.getParent().select();
          else if (Fe() !== this) {
            var e = null;
            if (Fe()) {
              e = Fe().id, r.disable$$module$build$src$core$events$utils();
              try {
                Fe().unselect();
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
            }
            e = new (fe(Qn))(e, this.id, this.workspace.id), Ce(e), at(this), this.addSelect();
          }
        }
        unselect() {
          if (Fe() === this) {
            var e = new (fe(Qn))(this.id, null, this.workspace.id);
            e.workspaceId = this.workspace.id, Ce(e), at(null), this.removeSelect();
          }
        }
        setParent(e) {
          const t = this.parentBlock_;
          if (e !== t) {
            Ur(), super.setParent(e), tr();
            var n = this.getSvgRoot();
            if (!this.workspace.isClearing && n) {
              var s = this.getRelativeToSurfaceXY();
              e ? e.getSvgRoot().appendChild(n) : t && (this.workspace.getCanvas().appendChild(n), this.translate(s.x, s.y)), this.applyColour();
            }
          }
        }
        getRelativeToSurfaceXY() {
          let e = 0, t = 0, n = this.getSvgRoot();
          if (n)
            do {
              const s = Wl(n);
              e += s.x, t += s.y, n = n.parentNode;
            } while (n && n !== this.workspace.getCanvas());
          return new Te(e, t);
        }
        moveBy(e, t, n) {
          if (this.parentBlock_)
            throw Error("Block has parent");
          const s = nt();
          let u = null;
          s && (u = new (fe(r.MOVE$$module$build$src$core$events$utils))(this), n && u.setReason(n)), n = this.getRelativeToSurfaceXY(), this.translate(n.x + e, n.y + t), this.moveConnections(e, t), s && u && (u.recordNew(), Ce(u)), this.workspace.resizeContents();
        }
        translate(e, t) {
          this.translation = `translate(${e}, ${t})`, this.relativeCoords = new Te(e, t), this.getSvgRoot().setAttribute(
            "transform",
            this.getTranslation()
          );
        }
        getTranslation() {
          return this.translation;
        }
        moveTo(e, t) {
          const n = this.getRelativeToSurfaceXY();
          this.moveBy(e.x - n.x, e.y - n.y, t);
        }
        moveDuringDrag(e) {
          this.translate(e.x, e.y), this.getSvgRoot().setAttribute("transform", this.getTranslation());
        }
        clearTransformAttributes_() {
          this.getSvgRoot().removeAttribute("transform");
        }
        snapToGrid() {
          if (!(this.isDeadOrDying() || this.workspace.isDragging() || this.getParent() || this.isInFlyout)) {
            var e = this.workspace.getGrid();
            if (e && e.shouldSnap()) {
              var t = e.getSpacing(), n = t / 2, s = this.getRelativeToSurfaceXY();
              e = Math.round(Math.round((s.x - n) / t) * t + n - s.x), t = Math.round(Math.round((s.y - n) / t) * t + n - s.y), (e || t) && this.moveBy(e, t, ["snap"]);
            }
          }
        }
        getBoundingRectangle() {
          const e = this.getRelativeToSurfaceXY(), t = this.getHeightWidth();
          let n, s;
          return this.RTL ? (n = e.x - t.width, s = e.x) : (n = e.x, s = e.x + t.width), new yt(e.y, e.y + t.height, n, s);
        }
        markDirty() {
          this.pathObject.constants = this.workspace.getRenderer().getConstants();
          for (let e = 0, t; t = this.inputList[e]; e++)
            t.markDirty();
        }
        setCollapsed(e) {
          this.collapsed_ !== e && (super.setCollapsed(e), this.updateCollapsed_());
        }
        updateCollapsed_() {
          var e = this.isCollapsed();
          const t = sa, n = _u;
          for (let u = 0, A; A = this.inputList[u]; u++)
            A.name !== t && A.setVisible(!e);
          for (var s of this.getIcons())
            s.updateCollapsed();
          e ? (e = this.toString(IA), (s = this.getField(n)) ? s.setValue(e) : (this.getInput(t) || this.appendDummyInput(t)).appendField(
            new Ji(e),
            n
          )) : (this.updateDisabled(), this.removeInput(t));
        }
        tab(e, t) {
          const n = new MA();
          n.setCurNode(ie.createFieldNode(e)), e = n.getCurNode(), t ? n.next() : n.prev(), (t = n.getCurNode()) && t !== e && (t.getLocation().showEditor(), this.workspace.keyboardAccessibilityMode && this.workspace.getCursor().setCurNode(t));
        }
        onMouseDown_(e) {
          const t = this.workspace.getGesture(e);
          t && t.handleBlockStart(e, this);
        }
        showHelp() {
          const e = typeof this.helpUrl == "function" ? this.helpUrl() : this.helpUrl;
          e && window.open(e);
        }
        generateContextMenu() {
          if (this.workspace.options.readOnly || !this.contextMenu)
            return null;
          const e = pt.registry.getContextMenuOptions(pt.ScopeType.BLOCK, { block: this });
          return this.customContextMenu && this.customContextMenu(e), e;
        }
        showContextMenu(e) {
          const t = this.generateContextMenu();
          t && t.length && (Dn(
            e,
            t,
            this.RTL
          ), ep(this));
        }
        moveConnections(e, t) {
          if (this.rendered) {
            for (var n = this.getConnections_(!1), s = 0; s < n.length; s++)
              n[s].moveBy(e, t);
            n = this.getIcons(), s = this.getRelativeToSurfaceXY();
            for (var u of n)
              u.onLocationChange(s);
            for (u = 0; u < this.childBlocks_.length; u++)
              this.childBlocks_[u].moveConnections(e, t);
          }
        }
        setDragging(e) {
          e ? (this.translation = "", qs.push(...this.getConnections_(!0)), Re(
            this.svgGroup_,
            "blocklyDragging"
          )) : (qs.length = 0, Ue(this.svgGroup_, "blocklyDragging"));
          for (let t = 0; t < this.childBlocks_.length; t++)
            this.childBlocks_[t].setDragging(e);
        }
        setMovable(e) {
          super.setMovable(e), this.pathObject.updateMovable(e);
        }
        setEditable(e) {
          super.setEditable(e), e = this.getIcons();
          for (let t = 0; t < e.length; t++)
            e[t].updateEditable();
        }
        setShadow(e) {
          super.setShadow(e), this.applyColour();
        }
        setInsertionMarker(e) {
          this.isInsertionMarker_ !== e && (this.isInsertionMarker_ = e) && (this.setColour(this.workspace.getRenderer().getConstants().INSERTION_MARKER_COLOUR), this.pathObject.updateInsertionMarker(!0));
        }
        getSvgRoot() {
          return this.svgGroup_;
        }
        dispose(e, t) {
          this.isDeadOrDying() || (mc(), n_(), t && this.rendered && (this.unplug(e), Jl(this)), super.dispose(!!e), _t(this.svgGroup_));
        }
        disposeInternal() {
          this.isDeadOrDying() || (super.disposeInternal(), this.rendered = !1, Fe() === this && (this.unselect(), this.workspace.cancelCurrentGesture()), [...this.warningTextDb.values()].forEach((e) => clearTimeout(e)), this.warningTextDb.clear(), this.getIcons().forEach((e) => e.dispose()));
        }
        checkAndDelete() {
          this.workspace.isFlyout || (r.setGroup$$module$build$src$core$events$utils(!0), this.workspace.hideChaff(), this.outputConnection ? this.dispose(!1, !0) : this.dispose(!0, !0), r.setGroup$$module$build$src$core$events$utils(!1));
        }
        toCopyData() {
          return this.isInsertionMarker_ ? null : { saveInfo: ui(this, { addCoordinates: !0, addNextBlocks: !1 }), source: this.workspace, typeCounts: Pt(this, !0) };
        }
        applyColour() {
          this.pathObject.applyColour(this);
          const e = this.getIcons();
          for (let t = 0; t < e.length; t++)
            e[t].applyColour();
          for (let t = 0, n; n = this.inputList[t]; t++)
            for (let s = 0, u; u = n.fieldRow[s]; s++)
              u.applyColour();
        }
        updateDisabled() {
          const e = !this.isEnabled() || this.getInheritedDisabled();
          if (this.visuallyDisabled === e) {
            let t;
            (t = this.getNextBlock()) == null || t.updateDisabled();
          } else {
            this.applyColour(), this.visuallyDisabled = e;
            for (const t of this.getChildren(!1))
              t.updateDisabled();
          }
        }
        getCommentIcon() {
          hr("getCommentIcon", "v10", "v11", "getIcon");
          let e;
          return (e = this.getIcon(Or.TYPE)) != null ? e : null;
        }
        setWarningText(e, t) {
          const n = t || "";
          if (n)
            this.warningTextDb.has(n) && (clearTimeout(this.warningTextDb.get(n)), this.warningTextDb.delete(n));
          else {
            for (var s of this.warningTextDb.values())
              clearTimeout(s);
            this.warningTextDb.clear();
          }
          if (this.workspace.isDragging())
            this.warningTextDb.set(n, setTimeout(() => {
              this.isDeadOrDying() || (this.warningTextDb.delete(n), this.setWarningText(e, n));
            }, 100));
          else if (this.isInFlyout && (e = null), t = this.getIcon(Li.TYPE), typeof e == "string") {
            s = this.getSurroundParent();
            let u = null;
            for (; s; )
              s.isCollapsed() && (u = s), s = s.getSurroundParent();
            u && u.setWarningText(
              r.Msg$$module$build$src$core$msg.COLLAPSED_WARNINGS_WARNING,
              Fn.COLLAPSED_WARNING_ID
            ), t ? t.addMessage(e, n) : this.addIcon(new Li(this).addMessage(e, n));
          } else
            t && (n ? t.getText() || this.removeIcon(Li.TYPE) : this.removeIcon(Li.TYPE));
        }
        setMutator(e) {
          this.removeIcon(r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE), e && this.addIcon(e);
        }
        addIcon(e) {
          return super.addIcon(e), e instanceof Li && (this.warning = e), e instanceof r.MutatorIcon$$module$build$src$core$icons$mutator_icon && (this.mutator = e), this.rendered && (e.initView(this.createIconPointerDownListener(e)), e.applyColour(), e.updateEditable(), this.render(), this.bumpNeighbours()), e;
        }
        createIconPointerDownListener(e) {
          return (t) => {
            this.isDeadOrDying() || (t = this.workspace.getGesture(t)) && t.setStartIcon(e);
          };
        }
        removeIcon(e) {
          const t = super.removeIcon(e);
          return e.equals(Li.TYPE) && (this.warning = null), e.equals(r.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE) && (this.mutator = null), this.rendered && (this.render(), this.bumpNeighbours()), t;
        }
        setEnabled(e) {
          this.isEnabled() !== e && (super.setEnabled(e), this.rendered && !this.getInheritedDisabled() && this.updateDisabled());
        }
        setHighlighted(e) {
          this.rendered && this.pathObject.updateHighlighted(e);
        }
        addSelect() {
          this.pathObject.updateSelected(!0);
        }
        removeSelect() {
          this.pathObject.updateSelected(!1);
        }
        setDeleteStyle(e) {
          this.pathObject.updateDraggingDelete(e);
        }
        getColour() {
          return this.style.colourPrimary;
        }
        setColour(e) {
          super.setColour(e), e = this.workspace.getRenderer().getConstants().getBlockStyleForColour(this.colour_), this.pathObject.setStyle(e.style), this.style = e.style, this.styleName_ = e.name, this.applyColour();
        }
        setStyle(e) {
          const t = this.workspace.getRenderer().getConstants().getBlockStyle(e);
          if (this.styleName_ = e, t)
            this.hat = t.hat, this.pathObject.setStyle(t), this.colour_ = t.colourPrimary, this.style = t, this.applyColour();
          else
            throw Error("Invalid style name: " + e);
        }
        bringToFront() {
          let e = this;
          do {
            const t = e.getSvgRoot(), n = t.parentNode, s = n.childNodes;
            s[s.length - 1] !== t && n.appendChild(t), e = e.getParent();
          } while (e);
        }
        setPreviousStatement(e, t) {
          super.setPreviousStatement(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setNextStatement(e, t) {
          super.setNextStatement(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setOutput(e, t) {
          super.setOutput(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        setInputsInline(e) {
          super.setInputsInline(e), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        removeInput(e, t) {
          return e = super.removeInput(
            e,
            t
          ), this.rendered && (this.queueRender(), this.bumpNeighbours()), e;
        }
        moveNumberedInputBefore(e, t) {
          super.moveNumberedInputBefore(e, t), this.rendered && (this.queueRender(), this.bumpNeighbours());
        }
        appendInput(e) {
          return super.appendInput(e), this.rendered && (this.queueRender(), this.bumpNeighbours()), e;
        }
        setConnectionTracking(e) {
          if (this.previousConnection && this.previousConnection.setTracking(e), this.outputConnection && this.outputConnection.setTracking(e), this.nextConnection) {
            this.nextConnection.setTracking(e);
            var t = this.nextConnection.targetBlock();
            t && t.setConnectionTracking(e);
          }
          if (!this.collapsed_)
            for (t = 0; t < this.inputList.length; t++) {
              var n = this.inputList[t].connection;
              n && (n.setTracking(e), (n = n.targetBlock()) && n.setConnectionTracking(e));
            }
        }
        getConnections_(e) {
          const t = [];
          if ((e || this.rendered) && (this.outputConnection && t.push(this.outputConnection), this.previousConnection && t.push(this.previousConnection), this.nextConnection && t.push(this.nextConnection), e || !this.collapsed_))
            for (let n = 0, s; s = this.inputList[n]; n++)
              s.connection && t.push(s.connection);
          return t;
        }
        lastConnectionInStack(e) {
          return super.lastConnectionInStack(e);
        }
        getMatchingConnection(e, t) {
          return super.getMatchingConnection(e, t);
        }
        makeConnection_(e) {
          return new tn(this, e);
        }
        getNextBlock() {
          return super.getNextBlock();
        }
        getPreviousBlock() {
          return super.getPreviousBlock();
        }
        bumpNeighbours() {
          if (!this.bumpNeighboursPid) {
            var e = r.getGroup$$module$build$src$core$events$utils();
            this.bumpNeighboursPid = setTimeout(() => {
              const t = r.getGroup$$module$build$src$core$events$utils();
              r.setGroup$$module$build$src$core$events$utils(e), this.getRootBlock().bumpNeighboursInternal(), r.setGroup$$module$build$src$core$events$utils(t), this.bumpNeighboursPid = 0;
            }, r.config$$module$build$src$core$config.bumpDelay);
          }
        }
        bumpNeighboursInternal() {
          const e = this.getRootBlock();
          if (!(this.isDeadOrDying() || this.workspace.isDragging() || e.isInFlyout))
            for (const t of this.getConnections_(!1)) {
              if (t.isSuperior()) {
                let n;
                (n = t.targetBlock()) == null || n.bumpNeighboursInternal();
              }
              for (const n of t.neighbours(r.config$$module$build$src$core$config.snapRadius))
                n.getSourceBlock().getRootBlock() !== e && (t.isConnected() && n.isConnected() || (t.isSuperior() ? n.bumpAwayFrom(t) : t.bumpAwayFrom(n)));
            }
        }
        scheduleSnapAndBump() {
          const e = r.getGroup$$module$build$src$core$events$utils();
          setTimeout(() => {
            r.setGroup$$module$build$src$core$events$utils(e), this.snapToGrid(), r.setGroup$$module$build$src$core$events$utils(!1);
          }, r.config$$module$build$src$core$config.bumpDelay / 2), this.bumpNeighbours();
        }
        positionNearConnection(e, t) {
          e.type !== me.NEXT_STATEMENT && e.type !== me.INPUT_VALUE || this.moveBy(t.x - e.x, t.y - e.y);
        }
        getFirstStatementConnection() {
          return super.getFirstStatementConnection();
        }
        getChildren(e) {
          return super.getChildren(e);
        }
        queueRender() {
          return $c(this);
        }
        render(e) {
          if (!this.renderIsInProgress_) {
            this.renderIsInProgress_ = !0;
            try {
              if (this.rendered = !0, Ur(), this.isEnabled() || this.updateDisabled(), this.isCollapsed() && this.updateCollapsed_(), this.workspace.getRenderer().render(this), this.updateConnectionAndIconLocations(), e !== !1) {
                const t = this.getParent();
                t ? t.render(!0) : this.workspace.resizeContents();
              }
              tr(), this.updateMarkers_();
            } finally {
              this.renderIsInProgress_ = !1;
            }
          }
        }
        renderEfficiently() {
          this.rendered = !0, Ur(), this.isCollapsed() && this.updateCollapsed_(), this.workspace.getRenderer().render(this), this.tightenChildrenEfficiently(), tr(), this.updateMarkers_();
        }
        tightenChildrenEfficiently() {
          for (const e of this.inputList) {
            const t = e.connection;
            t && t.tightenEfficiently();
          }
          this.nextConnection && this.nextConnection.tightenEfficiently();
        }
        updateMarkers_() {
          this.workspace.keyboardAccessibilityMode && this.pathObject.cursorSvg && this.workspace.getCursor().draw(), this.workspace.keyboardAccessibilityMode && this.pathObject.markerSvg && this.workspace.getMarker(y_.LOCAL_MARKER).draw();
          for (const e of this.inputList)
            for (const t of e.fieldRow)
              t.updateMarkers_();
        }
        updateConnectionAndIconLocations() {
          const e = this.getRelativeToSurfaceXY();
          this.previousConnection && this.previousConnection.moveToOffset(e), this.outputConnection && this.outputConnection.moveToOffset(e);
          for (let t = 0; t < this.inputList.length; t++) {
            const n = this.inputList[t].connection;
            n && (n.moveToOffset(e), n.isConnected() && n.tighten());
          }
          this.nextConnection && (this.nextConnection.moveToOffset(e), this.nextConnection.isConnected() && this.nextConnection.tighten());
          for (const t of this.getIcons())
            t.onLocationChange(e);
        }
        setCursorSvg(e) {
          this.pathObject.setCursorSvg(e);
        }
        setMarkerSvg(e) {
          this.pathObject.setMarkerSvg(e);
        }
        getHeightWidth() {
          let e = this.height, t = this.width;
          var n = this.getNextBlock();
          if (n) {
            n = n.getHeightWidth();
            const s = this.workspace.getRenderer().getConstants().NOTCH_HEIGHT;
            e += n.height - s, t = Math.max(t, n.width);
          }
          return { height: e, width: t };
        }
        fadeForReplacement(e) {
          this.pathObject.updateReplacementFade(e);
        }
        highlightShapeForInput(e, t) {
          this.pathObject.updateShapeForInputHighlight(e, t);
        }
      };
      Fn.INLINE = -1, Fn.COLLAPSED_WARNING_ID = "TEMP_COLLAPSED_WARNING_";
      var ha = {};
      ha.Bubble = je, ha.MiniWorkspaceBubble = Po, ha.TextBubble = Lu, ha.TextInputBubble = td;
      var ma = class {
        constructor(e, t) {
          this.bubble = e, this.workspace = t, this.dragTarget_ = null, this.wouldDeleteBubble_ = !1, this.startXY_ = this.bubble.getRelativeToSurfaceXY();
        }
        startBubbleDrag() {
          r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.workspace.setResizesEnabled(!1), this.bubble.setAutoLayout && this.bubble.setAutoLayout(!1), this.bubble.setDragging && this.bubble.setDragging(!0);
        }
        dragBubble(e, t) {
          t = this.pixelsToWorkspaceUnits_(t), t = Te.sum(this.startXY_, t), this.bubble.moveDuringDrag(t), t = this.dragTarget_, this.dragTarget_ = this.workspace.getDragTarget(e), e = this.wouldDeleteBubble_, this.wouldDeleteBubble_ = this.shouldDelete_(this.dragTarget_), e !== this.wouldDeleteBubble_ && this.updateCursorDuringBubbleDrag_(), this.dragTarget_ !== t && (t && t.onDragExit(this.bubble), this.dragTarget_ && this.dragTarget_.onDragEnter(this.bubble)), this.dragTarget_ && this.dragTarget_.onDragOver(this.bubble);
        }
        shouldDelete_(e) {
          return e && this.workspace.getComponentManager().hasCapability(e.id, ft.Capability.DELETE_AREA) ? e.wouldDelete(this.bubble, !1) : !1;
        }
        updateCursorDuringBubbleDrag_() {
          this.bubble.setDeleteStyle(this.wouldDeleteBubble_);
        }
        endBubbleDrag(e, t) {
          this.dragBubble(e, t), this.dragTarget_ && this.dragTarget_.shouldPreventMove(this.bubble) ? e = this.startXY_ : (e = this.pixelsToWorkspaceUnits_(t), e = Te.sum(this.startXY_, e)), this.bubble.moveTo(
            e.x,
            e.y
          ), this.dragTarget_ && this.dragTarget_.onDrop(this.bubble), this.wouldDeleteBubble_ ? (this.fireMoveEvent_(), this.bubble.dispose()) : (this.bubble.setDragging && this.bubble.setDragging(!1), this.fireMoveEvent_()), this.workspace.setResizesEnabled(!0), r.setGroup$$module$build$src$core$events$utils(!1);
        }
        fireMoveEvent_() {
          if (this.bubble instanceof $r) {
            const e = new (fe(qn))(this.bubble);
            e.setOldCoordinate(this.startXY_), e.recordNew(), Ce(e);
          }
        }
        pixelsToWorkspaceUnits_(e) {
          return e = new Te(e.x / this.workspace.scale, e.y / this.workspace.scale), this.workspace.isMutator && e.scale(1 / this.workspace.options.parentWorkspace.scale), e;
        }
      }, Ou = class {
        canConnect(e, t, n, s) {
          return this.canConnectWithReason(e, t, n, s) === ut.CAN_CONNECT;
        }
        canConnectWithReason(e, t, n, s) {
          const u = this.doSafetyChecks(e, t);
          return u !== ut.CAN_CONNECT ? u : this.doTypeChecks(e, t) ? n && !this.doDragChecks(e, t, s || 0) ? ut.REASON_DRAG_CHECKS_FAILED : ut.CAN_CONNECT : ut.REASON_CHECKS_FAILED;
        }
        getErrorMessage(e, t, n) {
          switch (e) {
            case ut.REASON_SELF_CONNECTION:
              return "Attempted to connect a block to itself.";
            case ut.REASON_DIFFERENT_WORKSPACES:
              return "Blocks not on same workspace.";
            case ut.REASON_WRONG_TYPE:
              return "Attempt to connect incompatible types.";
            case ut.REASON_TARGET_NULL:
              return "Target connection is null.";
            case ut.REASON_CHECKS_FAILED:
              return "Connection checks failed. " + (t + " expected " + t.getCheck() + ", found " + n.getCheck());
            case ut.REASON_SHADOW_PARENT:
              return "Connecting non-shadow to shadow block.";
            case ut.REASON_DRAG_CHECKS_FAILED:
              return "Drag checks failed.";
            case ut.REASON_PREVIOUS_AND_OUTPUT:
              return "Block would have an output and a previous connection.";
            default:
              return "Unknown connection failure: this should never happen!";
          }
        }
        doSafetyChecks(e, t) {
          if (!e || !t)
            return ut.REASON_TARGET_NULL;
          let n, s, u;
          return e.isSuperior() ? (n = e.getSourceBlock(), s = t.getSourceBlock(), u = t) : (s = e.getSourceBlock(), n = t.getSourceBlock(), u = e, e = t), n === s ? ut.REASON_SELF_CONNECTION : u.type !== Is[e.type] ? ut.REASON_WRONG_TYPE : n.workspace !== s.workspace ? ut.REASON_DIFFERENT_WORKSPACES : n.isShadow() && !s.isShadow() ? ut.REASON_SHADOW_PARENT : u.type === me.OUTPUT_VALUE && s.previousConnection && s.previousConnection.isConnected() || u.type === me.PREVIOUS_STATEMENT && s.outputConnection && s.outputConnection.isConnected() ? ut.REASON_PREVIOUS_AND_OUTPUT : ut.CAN_CONNECT;
        }
        doTypeChecks(e, t) {
          if (e = e.getCheck(), t = t.getCheck(), !e || !t)
            return !0;
          for (let n = 0; n < e.length; n++)
            if (t.indexOf(e[n]) !== -1)
              return !0;
          return !1;
        }
        doDragChecks(e, t, n) {
          if (e.distanceFrom(t) > n || t.getSourceBlock().isInsertionMarker())
            return !1;
          switch (t.type) {
            case me.PREVIOUS_STATEMENT:
              return this.canConnectToPrevious_(e, t);
            case me.OUTPUT_VALUE:
              if (t.isConnected() && !t.targetBlock().isInsertionMarker() || e.isConnected())
                return !1;
              break;
            case me.INPUT_VALUE:
              if (t.isConnected() && !t.targetBlock().isMovable() && !t.targetBlock().isShadow())
                return !1;
              break;
            case me.NEXT_STATEMENT:
              if (t.isConnected() && !e.getSourceBlock().nextConnection && !t.targetBlock().isShadow() && t.targetBlock().nextConnection || t.targetBlock() && !t.targetBlock().isMovable() && !t.targetBlock().isShadow())
                return !1;
              break;
            default:
              return !1;
          }
          return qs.indexOf(t) === -1;
        }
        canConnectToPrevious_(e, t) {
          return e.targetConnection || qs.indexOf(t) !== -1 ? !1 : t.targetConnection ? (e = t.targetBlock(), e.isInsertionMarker() ? !e.getPreviousBlock() : !1) : !0;
        }
      };
      o(_e.CONNECTION_CHECKER, Vi, Ou);
      var Ia = class {
        constructor(e) {
          this.connectionChecker = e, this.connections = [];
        }
        addConnection(e, t) {
          t = this.calculateIndexForYPos(t), this.connections.splice(t, 0, e);
        }
        findIndexOfConnection(e, t) {
          if (!this.connections.length)
            return -1;
          const n = this.calculateIndexForYPos(t);
          if (n >= this.connections.length)
            return -1;
          t = e.y;
          let s = n;
          for (; 0 <= s && this.connections[s].y === t; ) {
            if (this.connections[s] === e)
              return s;
            s--;
          }
          for (s = n; s < this.connections.length && this.connections[s].y === t; ) {
            if (this.connections[s] === e)
              return s;
            s++;
          }
          return -1;
        }
        calculateIndexForYPos(e) {
          if (!this.connections.length)
            return 0;
          let t = 0, n = this.connections.length;
          for (; t < n; ) {
            const s = Math.floor((t + n) / 2);
            if (this.connections[s].y < e)
              t = s + 1;
            else if (this.connections[s].y > e)
              n = s;
            else {
              t = s;
              break;
            }
          }
          return t;
        }
        removeConnection(e, t) {
          if (e = this.findIndexOfConnection(e, t), e === -1)
            throw Error("Unable to find connection in connectionDB.");
          this.connections.splice(e, 1);
        }
        getNeighbours(e, t) {
          function n(Le) {
            const _r = u - s[Le].x, Bt = A - s[Le].y;
            return Math.sqrt(_r * _r + Bt * Bt) <= t && q.push(s[Le]), Bt < t;
          }
          const s = this.connections, u = e.x, A = e.y;
          e = 0;
          let L = s.length - 2, $ = L;
          for (; e < $; )
            s[$].y < A ? e = $ : L = $, $ = Math.floor((e + L) / 2);
          const q = [];
          if (L = e = $, s.length) {
            for (; 0 <= e && n(e); )
              e--;
            do
              L++;
            while (L < s.length && n(L));
          }
          return q;
        }
        isInYRange(e, t, n) {
          return Math.abs(this.connections[e].y - t) <= n;
        }
        searchForClosest(e, t, n) {
          if (!this.connections.length)
            return { connection: null, radius: t };
          const s = e.y, u = e.x;
          e.x = u + n.x, e.y = s + n.y;
          var A = this.calculateIndexForYPos(e.y);
          n = null;
          let L = t, $, q = A - 1;
          for (; 0 <= q && this.isInYRange(q, e.y, t); )
            $ = this.connections[q], this.connectionChecker.canConnect(e, $, !0, L) && (n = $, L = $.distanceFrom(e)), q--;
          for (; A < this.connections.length && this.isInYRange(A, e.y, t); )
            $ = this.connections[A], this.connectionChecker.canConnect(e, $, !0, L) && (n = $, L = $.distanceFrom(e)), A++;
          return e.x = u, e.y = s, { connection: n, radius: L };
        }
        static init(e) {
          const t = [];
          return t[me.INPUT_VALUE] = new Ia(e), t[me.OUTPUT_VALUE] = new Ia(e), t[me.NEXT_STATEMENT] = new Ia(e), t[me.PREVIOUS_STATEMENT] = new Ia(e), t;
        }
      }, Du = class extends Ts {
        constructor(e, t, n, s) {
          super(e), this.type = No, this.recordUndo = !1, e && (this.name = t, this.oldValue = n, this.newValue = s);
        }
        toJson() {
          const e = super.toJson();
          if (!this.name)
            throw Error("The changed field name is undefined. Either pass a name to the constructor, or call fromJson.");
          return e.name = this.name, e.oldValue = this.oldValue, e.newValue = this.newValue, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Du()), t.name = e.name, t.oldValue = e.oldValue, t.newValue = e.newValue, t;
        }
        isNull() {
          return this.oldValue === this.newValue;
        }
      };
      o(_e.EVENT, No, Du);
      var Ma = class extends Ts {
        constructor(e) {
          super(e), this.type = r.MOVE$$module$build$src$core$events$utils, e && (e.isShadow() && (this.recordUndo = !1), e = this.currentLocation_(), this.oldParentId = e.parentId, this.oldInputName = e.inputName, this.oldCoordinate = e.coordinate);
        }
        toJson() {
          const e = super.toJson();
          return e.oldParentId = this.oldParentId, e.oldInputName = this.oldInputName, this.oldCoordinate && (e.oldCoordinate = `${Math.round(this.oldCoordinate.x)}, ${Math.round(this.oldCoordinate.y)}`), e.newParentId = this.newParentId, e.newInputName = this.newInputName, this.newCoordinate && (e.newCoordinate = `${Math.round(this.newCoordinate.x)}, ${Math.round(this.newCoordinate.y)}`), this.reason && (e.reason = this.reason), this.recordUndo || (e.recordUndo = this.recordUndo), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Ma()), t.oldParentId = e.oldParentId, t.oldInputName = e.oldInputName, e.oldCoordinate && (n = e.oldCoordinate.split(","), t.oldCoordinate = new Te(Number(n[0]), Number(n[1]))), t.newParentId = e.newParentId, t.newInputName = e.newInputName, e.newCoordinate && (n = e.newCoordinate.split(","), t.newCoordinate = new Te(Number(n[0]), Number(n[1]))), e.reason !== void 0 && (t.reason = e.reason), e.recordUndo !== void 0 && (t.recordUndo = e.recordUndo), t;
        }
        recordNew() {
          const e = this.currentLocation_();
          this.newParentId = e.parentId, this.newInputName = e.inputName, this.newCoordinate = e.coordinate;
        }
        setReason(e) {
          this.reason = e;
        }
        currentLocation_() {
          var e = this.getEventWorkspace_();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          var t = e.getBlockById(this.blockId);
          if (!t)
            throw Error("The block associated with the block move event could not be found");
          e = {};
          const n = t.getParent();
          return n ? (e.parentId = n.id, (t = n.getInputWithBlock(t)) && (e.inputName = t.name)) : e.coordinate = t.getRelativeToSurfaceXY(), e;
        }
        isNull() {
          return this.oldParentId === this.newParentId && this.oldInputName === this.newInputName && Te.equals(this.oldCoordinate, this.newCoordinate);
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.blockId)
            throw Error("The block ID is undefined. Either pass a block to the constructor, or call fromJson");
          var n = t.getBlockById(this.blockId);
          if (n) {
            var s = e ? this.newParentId : this.oldParentId, u = e ? this.newInputName : this.oldInputName;
            if (e = e ? this.newCoordinate : this.oldCoordinate, s) {
              var A = t.getBlockById(s);
              if (!A) {
                console.warn("Can't connect to non-existent block: " + s);
                return;
              }
            }
            if (n.getParent() && n.unplug(), e)
              u = n.getRelativeToSurfaceXY(), n.moveBy(e.x - u.x, e.y - u.y, this.reason);
            else {
              t = n.outputConnection, (!t || n.previousConnection && n.previousConnection.isConnected()) && (t = n.previousConnection);
              let L, $;
              n = ($ = t) == null ? void 0 : $.type, u ? (n = A.getInput(u)) && (L = n.connection) : n === me.PREVIOUS_STATEMENT && (L = A.nextConnection), L && t ? t.connect(L) : console.warn("Can't connect to non-existent input: " + u);
            }
          } else
            console.warn("Can't move non-existent block: " + this.blockId);
        }
      };
      o(_e.EVENT, r.MOVE$$module$build$src$core$events$utils, Ma);
      var rn = class extends Yi {
        constructor(e, t, n) {
          super(e ? e.workspace.id : void 0), this.type = Si, e && (this.blockId = e.id, this.isOpen = t, this.bubbleType = n);
        }
        toJson() {
          const e = super.toJson();
          if (this.isOpen === void 0)
            throw Error("Whether this event is for opening the bubble is undefined. Either pass the value to the constructor, or call fromJson");
          if (!this.bubbleType)
            throw Error("The type of bubble is undefined. Either pass the value to the constructor, or call fromJson");
          return e.isOpen = this.isOpen, e.bubbleType = this.bubbleType, e.blockId = this.blockId || "", e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new rn()), t.isOpen = e.isOpen, t.bubbleType = e.bubbleType, t.blockId = e.blockId, t;
        }
      }, hl;
      (function(e) {
        e.MUTATOR = "mutator", e.COMMENT = "comment", e.WARNING = "warning";
      })(hl || (hl = {})), o(_e.EVENT, Si, rn);
      var cd = class extends Yi {
        constructor(e, t, n) {
          t = e ? e.workspace.id : t, t === null && (t = void 0), super(t), this.type = Gi, this.blockId = e ? e.id : void 0, this.targetType = n;
        }
        toJson() {
          const e = super.toJson();
          if (!this.targetType)
            throw Error("The click target type is undefined. Either pass a block to the constructor, or call fromJson");
          return e.targetType = this.targetType, e.blockId = this.blockId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new cd()), t.targetType = e.targetType, t.blockId = e.blockId, t;
        }
      }, ud;
      (function(e) {
        e.BLOCK = "block", e.WORKSPACE = "workspace", e.ZOOM_CONTROLS = "zoom_controls";
      })(ud || (ud = {})), o(_e.EVENT, Gi, cd);
      var ml = class extends as {
        constructor(e) {
          super(), this.isBlank = !e, e && (this.commentId = e.id, this.workspaceId = e.workspace.id, this.group = r.getGroup$$module$build$src$core$events$utils(), this.recordUndo = Dr());
        }
        toJson() {
          const e = super.toJson();
          if (!this.commentId)
            throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
          return e.commentId = this.commentId, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new ml()), t.commentId = e.commentId, t;
        }
        static CommentCreateDeleteHelper(e, t) {
          var n = e.getEventWorkspace_();
          if (t) {
            if (t = r.createElement$$module$build$src$core$utils$xml("xml"), !e.xml)
              throw Error("Ecountered a comment event without proper xml");
            t.appendChild(e.xml), r.domToWorkspace$$module$build$src$core$xml(t, n);
          } else {
            if (!e.commentId)
              throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
            (n = n.getCommentById(e.commentId)) ? n.dispose() : console.warn("Can't uncreate non-existent comment: " + e.commentId);
          }
        }
      }, Td = class extends ml {
        constructor(e, t, n) {
          super(e), this.type = ns, e && (this.oldContents_ = typeof t > "u" ? "" : t, this.newContents_ = typeof n > "u" ? "" : n);
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldContents_)
            throw Error("The old contents is undefined. Either pass a value to the constructor, or call fromJson");
          if (!this.newContents_)
            throw Error("The new contents is undefined. Either pass a value to the constructor, or call fromJson");
          return e.oldContents = this.oldContents_, e.newContents = this.newContents_, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Td()), t.oldContents_ = e.oldContents, t.newContents_ = e.newContents, t;
        }
        isNull() {
          return this.oldContents_ === this.newContents_;
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.commentId)
            throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
          if (t = t.getCommentById(this.commentId)) {
            var n = e ? this.newContents_ : this.oldContents_;
            if (!n)
              throw Error(e ? "The new contents is undefined. Either pass a value to the constructor, or call fromJson" : "The old contents is undefined. Either pass a value to the constructor, or call fromJson");
            t.setContent(n);
          } else
            console.warn("Can't change non-existent comment: " + this.commentId);
        }
      };
      o(_e.EVENT, ns, Td);
      var pd = class extends ml {
        constructor(e) {
          super(e), this.type = qr, e && (this.xml = e.toXmlWithXY());
        }
        toJson() {
          const e = super.toJson();
          if (!this.xml)
            throw Error("The comment XML is undefined. Either pass a comment to the constructor, or call fromJson");
          return e.xml = Fi(this.xml), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(
            e,
            t,
            n ?? new pd()
          ), t.xml = r.textToDom$$module$build$src$core$utils$xml(e.xml), t;
        }
        run(e) {
          ml.CommentCreateDeleteHelper(this, e);
        }
      };
      o(_e.EVENT, qr, pd);
      var bu = class extends ml {
        constructor(e) {
          super(e), this.type = _l, e && (this.xml = e.toXmlWithXY());
        }
        run(e) {
          ml.CommentCreateDeleteHelper(this, !e);
        }
        toJson() {
          const e = super.toJson();
          if (!this.xml)
            throw Error("The comment XML is undefined. Either pass a comment to the constructor, or call fromJson");
          return e.xml = Fi(this.xml), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new bu()), t.xml = r.textToDom$$module$build$src$core$utils$xml(e.xml), t;
        }
      };
      o(_e.EVENT, _l, bu);
      var Ni = class extends ml {
        constructor(e) {
          super(e), this.type = qn, e && (this.comment_ = e, this.oldCoordinate_ = e.getRelativeToSurfaceXY());
        }
        recordNew() {
          if (this.newCoordinate_)
            throw Error("Tried to record the new position of a comment on the same event twice.");
          if (!this.comment_)
            throw Error("The comment is undefined. Pass a comment to the constructor if you want to use the record functionality");
          this.newCoordinate_ = this.comment_.getRelativeToSurfaceXY();
        }
        setOldCoordinate(e) {
          this.oldCoordinate_ = e;
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldCoordinate_)
            throw Error("The old comment position is undefined. Either pass a comment to the constructor, or call fromJson");
          if (!this.newCoordinate_)
            throw Error("The new comment position is undefined. Either call recordNew, or call fromJson");
          return e.oldCoordinate = `${Math.round(this.oldCoordinate_.x)}, ${Math.round(this.oldCoordinate_.y)}`, e.newCoordinate = Math.round(this.newCoordinate_.x) + "," + Math.round(this.newCoordinate_.y), e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Ni()), n = e.oldCoordinate.split(","), t.oldCoordinate_ = new Te(Number(n[0]), Number(n[1])), n = e.newCoordinate.split(","), t.newCoordinate_ = new Te(Number(n[0]), Number(n[1])), t;
        }
        isNull() {
          return Te.equals(
            this.oldCoordinate_,
            this.newCoordinate_
          );
        }
        run(e) {
          var t = this.getEventWorkspace_();
          if (!this.commentId)
            throw Error("The comment ID is undefined. Either pass a comment to the constructor, or call fromJson");
          if (t = t.getCommentById(this.commentId)) {
            if (e = e ? this.newCoordinate_ : this.oldCoordinate_, !e)
              throw Error("Either oldCoordinate_ or newCoordinate_ is undefined. Either pass a comment to the constructor and call recordNew, or call fromJson");
            var n = t.getRelativeToSurfaceXY();
            t.moveBy(e.x - n.x, e.y - n.y);
          } else
            console.warn("Can't move non-existent comment: " + this.commentId);
        }
      };
      o(_e.EVENT, qn, Ni);
      var ze = class extends Yi {
        constructor(e, t, n, s) {
          let u = e ? e.workspace.id : void 0;
          s && s.getType() === ie.types.WORKSPACE && (u = s.getLocation().id), super(u), this.type = ol, this.blockId = e == null ? void 0 : e.id, this.oldNode = n || void 0, this.newNode = s, this.isCursor = t;
        }
        toJson() {
          const e = super.toJson();
          if (this.isCursor === void 0)
            throw Error("Whether this is a cursor event or not is undefined. Either pass a value to the constructor, or call fromJson");
          if (!this.newNode)
            throw Error("The new node is undefined. Either pass a node to the constructor, or call fromJson");
          return e.isCursor = this.isCursor, e.blockId = this.blockId, e.oldNode = this.oldNode, e.newNode = this.newNode, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new ze()), t.isCursor = e.isCursor, t.blockId = e.blockId, t.oldNode = e.oldNode, t.newNode = e.newNode, t;
        }
      };
      o(_e.EVENT, ol, ze);
      var Pu = class extends Yi {
        constructor(e, t) {
          super(t), this.type = Wn, this.themeName = e;
        }
        toJson() {
          const e = super.toJson();
          if (!this.themeName)
            throw Error("The theme name is undefined. Either pass a theme name to the constructor, or call fromJson");
          return e.themeName = this.themeName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Pu()), t.themeName = e.themeName, t;
        }
      };
      o(_e.EVENT, Wn, Pu);
      var Nn = class extends Yi {
        constructor(e, t, n) {
          super(n), this.type = sl, this.oldItem = e ?? void 0, this.newItem = t ?? void 0;
        }
        toJson() {
          const e = super.toJson();
          return e.oldItem = this.oldItem, e.newItem = this.newItem, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Nn()), t.oldItem = e.oldItem, t.newItem = e.newItem, t;
        }
      };
      o(_e.EVENT, sl, Nn);
      var $u = class extends Yi {
        constructor(e, t) {
          super(t), this.type = ll, this.isOpen = e;
        }
        toJson() {
          const e = super.toJson();
          if (this.isOpen === void 0)
            throw Error("Whether this is already open or not is undefined. Either pass a value to the constructor, or call fromJson");
          return e.isOpen = this.isOpen, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new $u()), t.isOpen = e.isOpen, t;
        }
      };
      o(_e.EVENT, ll, $u);
      var dd = class extends _s {
        constructor(e) {
          super(e), this.type = gr, e && (this.varType = e.type, this.varName = e.name);
        }
        toJson() {
          const e = super.toJson();
          if (this.varType === void 0)
            throw Error("The var type is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          return e.varType = this.varType, e.varName = this.varName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new dd()), t.varType = e.varType, t.varName = e.varName, t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.varName)
            throw Error("The var name is undefined. Either pass a variable to the constructor, or call fromJson");
          e ? t.deleteVariableById(this.varId) : t.createVariable(this.varName, this.varType, this.varId);
        }
      };
      o(_e.EVENT, gr, dd);
      var St = class extends _s {
        constructor(e, t) {
          super(e), this.type = $n, e && (this.oldName = e.name, this.newName = typeof t > "u" ? "" : t);
        }
        toJson() {
          const e = super.toJson();
          if (!this.oldName)
            throw Error("The old var name is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.newName)
            throw Error("The new var name is undefined. Either pass a value to the constructor, or call fromJson");
          return e.oldName = this.oldName, e.newName = this.newName, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new St()), t.oldName = e.oldName, t.newName = e.newName, t;
        }
        run(e) {
          const t = this.getEventWorkspace_();
          if (!this.varId)
            throw Error("The var ID is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.oldName)
            throw Error("The old var name is undefined. Either pass a variable to the constructor, or call fromJson");
          if (!this.newName)
            throw Error("The new var name is undefined. Either pass a value to the constructor, or call fromJson");
          e ? t.renameVariableById(this.varId, this.newName) : t.renameVariableById(this.varId, this.oldName);
        }
      };
      o(_e.EVENT, $n, St);
      var Ed = class extends Yi {
        constructor(e, t, n, s, u) {
          super(s), this.type = al, this.viewTop = e, this.viewLeft = t, this.scale = n, this.oldScale = u;
        }
        toJson() {
          const e = super.toJson();
          if (this.viewTop === void 0)
            throw Error("The view top is undefined. Either pass a value to the constructor, or call fromJson");
          if (this.viewLeft === void 0)
            throw Error("The view left is undefined. Either pass a value to the constructor, or call fromJson");
          if (this.scale === void 0)
            throw Error("The scale is undefined. Either pass a value to the constructor, or call fromJson");
          if (this.oldScale === void 0)
            throw Error("The old scale is undefined. Either pass a value to the constructor, or call fromJson");
          return e.viewTop = this.viewTop, e.viewLeft = this.viewLeft, e.scale = this.scale, e.oldScale = this.oldScale, e;
        }
        static fromJson(e, t, n) {
          return t = super.fromJson(e, t, n ?? new Ed()), t.viewTop = e.viewTop, t.viewLeft = e.viewLeft, t.scale = e.scale, t.oldScale = e.oldScale, t;
        }
      };
      o(_e.EVENT, al, Ed), r.CHANGE$$module$build$src$core$events$utils, r.CREATE$$module$build$src$core$events$utils, r.DELETE$$module$build$src$core$events$utils, r.MOVE$$module$build$src$core$events$utils, r.CHANGE$$module$build$src$core$events$utils, r.CREATE$$module$build$src$core$events$utils, r.DELETE$$module$build$src$core$events$utils, r.MOVE$$module$build$src$core$events$utils, r.disable$$module$build$src$core$events$utils, r.enable$$module$build$src$core$events$utils, r.getGroup$$module$build$src$core$events$utils, r.setGroup$$module$build$src$core$events$utils;
      var he = {};
      he.Abstract = as, he.BLOCK_CHANGE = r.CHANGE$$module$build$src$core$events$utils, he.BLOCK_CREATE = r.CREATE$$module$build$src$core$events$utils, he.BLOCK_DELETE = r.DELETE$$module$build$src$core$events$utils, he.BLOCK_DRAG = il, he.BLOCK_FIELD_INTERMEDIATE_CHANGE = No, he.BLOCK_MOVE = r.MOVE$$module$build$src$core$events$utils, he.BUBBLE_OPEN = Si, he.BUMP_EVENTS = zc, he.BlockBase = Ts, he.BlockChange = dl, he.BlockCreate = Vp, he.BlockDelete = au, he.BlockDrag = od, he.BlockFieldIntermediateChange = Du, he.BlockMove = Ma, he.BubbleOpen = rn, he.BubbleType = hl, he.CHANGE = r.CHANGE$$module$build$src$core$events$utils, he.CLICK = Gi, he.COMMENT_CHANGE = ns, he.COMMENT_CREATE = qr, he.COMMENT_DELETE = _l, he.COMMENT_MOVE = qn, he.CREATE = r.CREATE$$module$build$src$core$events$utils, he.Click = cd, he.ClickTarget = ud, he.CommentBase = ml, he.CommentChange = Td, he.CommentCreate = pd, he.CommentDelete = bu, he.CommentMove = Ni, he.DELETE = r.DELETE$$module$build$src$core$events$utils, he.FINISHED_LOADING = is, he.FinishedLoading = tA, he.MARKER_MOVE = ol, he.MOVE = r.MOVE$$module$build$src$core$events$utils, he.MarkerMove = ze, he.SELECTED = Qn, he.Selected = mi, he.THEME_CHANGE = Wn, he.TOOLBOX_ITEM_SELECT = sl, he.TRASHCAN_OPEN = ll, he.ThemeChange = Pu, he.ToolboxItemSelect = Nn, he.TrashcanOpen = $u, he.UI = ta, he.UiBase = Yi, he.VAR_CREATE = yo, he.VAR_DELETE = gr, he.VAR_RENAME = $n, he.VIEWPORT_CHANGE = al, he.VarBase = _s, he.VarCreate = Op, he.VarDelete = dd, he.VarRename = St, he.ViewportChange = Ed, he.clearPendingUndo = ao, he.disable = r.disable$$module$build$src$core$events$utils, he.disableOrphans = Hn, he.enable = r.enable$$module$build$src$core$events$utils, he.filter = Sr, he.fire = Ce, he.fromJson = bl, he.get = fe, he.getDescendantIds = _o, he.getGroup = r.getGroup$$module$build$src$core$events$utils, he.getRecordUndo = Dr, he.isEnabled = nt, he.setGroup = r.setGroup$$module$build$src$core$events$utils, he.setRecordUndo = Er;
      var Il = class {
        constructor() {
          this.NO_PADDING = 0, this.SMALL_PADDING = 3, this.MEDIUM_PADDING = 5, this.MEDIUM_LARGE_PADDING = 8, this.LARGE_PADDING = 10, this.TAB_HEIGHT = 15, this.TAB_OFFSET_FROM_TOP = 5, this.TAB_VERTICAL_OVERLAP = 2.5, this.TAB_WIDTH = 8, this.NOTCH_WIDTH = 15, this.NOTCH_HEIGHT = 4, this.MIN_BLOCK_WIDTH = 12, this.EMPTY_BLOCK_SPACER_HEIGHT = 16, this.CORNER_RADIUS = 8, this.NOTCH_OFFSET_LEFT = 15, this.STATEMENT_BOTTOM_SPACER = 0, this.STATEMENT_INPUT_PADDING_LEFT = 20, this.BETWEEN_STATEMENT_PADDING_Y = 4, this.ADD_START_HATS = !1, this.START_HAT_HEIGHT = 15, this.START_HAT_WIDTH = 100, this.SPACER_DEFAULT_HEIGHT = 15, this.MIN_BLOCK_HEIGHT = 24, this.EMPTY_INLINE_INPUT_PADDING = 14.5, this.EXTERNAL_VALUE_INPUT_PADDING = 2, this.JAGGED_TEETH_HEIGHT = 12, this.JAGGED_TEETH_WIDTH = 6, this.FIELD_TEXT_FONTSIZE = 11, this.FIELD_TEXT_FONTWEIGHT = "normal", this.FIELD_TEXT_FONTFAMILY = "sans-serif", this.FIELD_TEXT_BASELINE = this.FIELD_TEXT_HEIGHT = -1, this.FIELD_BORDER_RECT_RADIUS = 4, this.FIELD_BORDER_RECT_HEIGHT = 16, this.FIELD_BORDER_RECT_X_PADDING = 5, this.FIELD_BORDER_RECT_Y_PADDING = 3, this.FIELD_BORDER_RECT_COLOUR = "#fff", this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !1, this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 12, this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = !1, this.FIELD_COLOUR_DEFAULT_WIDTH = 26, this.defs = null, this.embossFilterId = "", this.embossFilter = null, this.disabledPatternId = "", this.disabledPattern = null, this.debugFilterId = "", this.cssNode = this.debugFilter = null, this.CURSOR_COLOUR = "#cc0a0a", this.MARKER_COLOUR = "#4286f4", this.CURSOR_WS_WIDTH = 100, this.WS_CURSOR_HEIGHT = 5, this.CURSOR_STACK_PADDING = 10, this.CURSOR_BLOCK_PADDING = 2, this.CURSOR_STROKE_WIDTH = 4, this.FULL_BLOCK_FIELDS = !1, this.INSERTION_MARKER_COLOUR = "#000000", this.INSERTION_MARKER_OPACITY = 0.2, this.SHAPES = { PUZZLE: 1, NOTCH: 2 }, this.TALL_INPUT_FIELD_OFFSET_Y = this.MEDIUM_PADDING, this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = this.DUMMY_INPUT_MIN_HEIGHT = this.TAB_HEIGHT, this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT, this.TOP_ROW_MIN_HEIGHT = this.MEDIUM_PADDING, this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.BOTTOM_ROW_MIN_HEIGHT = this.MEDIUM_PADDING, this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 11, this.EMPTY_STATEMENT_INPUT_HEIGHT = this.MIN_BLOCK_HEIGHT, this.START_POINT = wt(0, 0), this.FIELD_TEXT_BASELINE_CENTER = !0, this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT, this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING, this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MSIgaGVpZ2h0PSI4Ljc5IiB2aWV3Qm94PSIwIDAgMTIuNzEgOC43OSI+PHRpdGxlPmRyb3Bkb3duLWFycm93PC90aXRsZT48ZyBvcGFjaXR5PSIwLjEiPjxwYXRoIGQ9Ik0xMi43MSwyLjQ0QTIuNDEsMi40MSwwLDAsMSwxMiw0LjE2TDguMDgsOC4wOGEyLjQ1LDIuNDUsMCwwLDEtMy40NSwwTDAuNzIsNC4xNkEyLjQyLDIuNDIsMCwwLDEsMCwyLjQ0LDIuNDgsMi40OCwwLDAsMSwuNzEuNzFDMSwwLjQ3LDEuNDMsMCw2LjM2LDBTMTEuNzUsMC40NiwxMiwuNzFBMi40NCwyLjQ0LDAsMCwxLDEyLjcxLDIuNDRaIiBmaWxsPSIjMjMxZjIwIi8+PC9nPjxwYXRoIGQ9Ik02LjM2LDcuNzlhMS40MywxLjQzLDAsMCwxLTEtLjQyTDEuNDIsMy40NWExLjQ0LDEuNDQsMCwwLDEsMC0yYzAuNTYtLjU2LDkuMzEtMC41Niw5Ljg3LDBhMS40NCwxLjQ0LDAsMCwxLDAsMkw3LjM3LDcuMzdBMS40MywxLjQzLDAsMCwxLDYuMzYsNy43OVoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=", this.FIELD_COLOUR_DEFAULT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT, this.FIELD_CHECKBOX_X_OFFSET = this.FIELD_BORDER_RECT_X_PADDING - 3, this.randomIdentifier = String(Math.random()).substring(2);
        }
        init() {
          this.JAGGED_TEETH = this.makeJaggedTeeth(), this.NOTCH = this.makeNotch(), this.START_HAT = this.makeStartHat(), this.PUZZLE_TAB = this.makePuzzleTab(), this.INSIDE_CORNERS = this.makeInsideCorners(), this.OUTSIDE_CORNERS = this.makeOutsideCorners();
        }
        setTheme(e) {
          this.blockStyles = /* @__PURE__ */ Object.create(null);
          const t = e.blockStyles;
          for (const n in t)
            this.blockStyles[n] = this.validatedBlockStyle_(t[n]);
          this.setDynamicProperties_(e);
        }
        setDynamicProperties_(e) {
          this.setFontConstants_(e), this.setComponentConstants_(e), this.ADD_START_HATS = e.startHats !== void 0 ? e.startHats : this.ADD_START_HATS;
        }
        setFontConstants_(e) {
          e.fontStyle && e.fontStyle.family && (this.FIELD_TEXT_FONTFAMILY = e.fontStyle.family), e.fontStyle && e.fontStyle.weight && (this.FIELD_TEXT_FONTWEIGHT = e.fontStyle.weight), e.fontStyle && e.fontStyle.size && (this.FIELD_TEXT_FONTSIZE = e.fontStyle.size), e = Xn(
            "Hg",
            this.FIELD_TEXT_FONTSIZE + "pt",
            this.FIELD_TEXT_FONTWEIGHT,
            this.FIELD_TEXT_FONTFAMILY
          ), this.FIELD_TEXT_HEIGHT = e.height, this.FIELD_TEXT_BASELINE = e.baseline;
        }
        setComponentConstants_(e) {
          this.CURSOR_COLOUR = e.getComponentStyle("cursorColour") || this.CURSOR_COLOUR, this.MARKER_COLOUR = e.getComponentStyle("markerColour") || this.MARKER_COLOUR, this.INSERTION_MARKER_COLOUR = e.getComponentStyle("insertionMarkerColour") || this.INSERTION_MARKER_COLOUR, this.INSERTION_MARKER_OPACITY = Number(e.getComponentStyle("insertionMarkerOpacity")) || this.INSERTION_MARKER_OPACITY;
        }
        getBlockStyleForColour(e) {
          const t = "auto_" + e;
          return this.blockStyles[t] || (this.blockStyles[t] = this.createBlockStyle_(e)), { style: this.blockStyles[t], name: t };
        }
        getBlockStyle(e) {
          return this.blockStyles[e || ""] || (e && e.indexOf("auto_") === 0 ? this.getBlockStyleForColour(e.substring(5)).style : this.createBlockStyle_("#000000"));
        }
        createBlockStyle_(e) {
          return this.validatedBlockStyle_({ colourPrimary: e });
        }
        validatedBlockStyle_(e) {
          const t = {};
          return e && Object.assign(t, e), e = xs(t.colourPrimary || "#000"), t.colourPrimary = e.hex, t.colourSecondary = t.colourSecondary ? xs(t.colourSecondary).hex : this.generateSecondaryColour_(t.colourPrimary), t.colourTertiary = t.colourTertiary ? xs(t.colourTertiary).hex : this.generateTertiaryColour_(t.colourPrimary), t.hat = t.hat || "", t;
        }
        generateSecondaryColour_(e) {
          return jn("#fff", e, 0.6) || e;
        }
        generateTertiaryColour_(e) {
          return jn(
            "#fff",
            e,
            0.3
          ) || e;
        }
        dispose() {
          this.embossFilter && _t(this.embossFilter), this.disabledPattern && _t(this.disabledPattern), this.debugFilter && _t(this.debugFilter), this.cssNode = null;
        }
        makeJaggedTeeth() {
          const e = this.JAGGED_TEETH_HEIGHT, t = this.JAGGED_TEETH_WIDTH, n = Ys([Ee(t, e / 4), Ee(2 * -t, e / 2), Ee(t, e / 4)]);
          return { height: e, width: t, path: n };
        }
        makeStartHat() {
          const e = this.START_HAT_HEIGHT, t = this.START_HAT_WIDTH, n = Lt("c", [Ee(30, -e), Ee(70, -e), Ee(t, 0)]);
          return { height: e, width: t, path: n };
        }
        makePuzzleTab() {
          function e(A) {
            A = A ? -1 : 1;
            const L = -A;
            var $ = n / 2;
            const q = $ + 2.5, Le = $ + 0.5, _r = Ee(
              -t,
              A * $
            );
            return $ = Ee(t, A * $), Lt("c", [Ee(0, A * q), Ee(-t, L * Le), _r]) + Lt("s", [Ee(t, 2.5 * L), $]);
          }
          const t = this.TAB_WIDTH, n = this.TAB_HEIGHT, s = e(!0), u = e(!1);
          return { type: this.SHAPES.PUZZLE, width: t, height: n, pathDown: u, pathUp: s };
        }
        makeNotch() {
          function e(L) {
            return Ys([Ee(L * s, n), Ee(3 * L, 0), Ee(L * s, -n)]);
          }
          const t = this.NOTCH_WIDTH, n = this.NOTCH_HEIGHT, s = (t - 3) / 2, u = e(1), A = e(-1);
          return { type: this.SHAPES.NOTCH, width: t, height: n, pathLeft: u, pathRight: A };
        }
        makeInsideCorners() {
          const e = this.CORNER_RADIUS, t = Ft("a", "0 0,0", e, Ee(-e, e)), n = Ft("a", "0 0,0", e, Ee(
            e,
            e
          ));
          return { width: e, height: e, pathTop: t, pathBottom: n };
        }
        makeOutsideCorners() {
          const e = this.CORNER_RADIUS, t = wt(0, e) + Ft("a", "0 0,1", e, Ee(e, -e)), n = Ft("a", "0 0,1", e, Ee(e, e)), s = Ft("a", "0 0,1", e, Ee(-e, -e)), u = Ft(
            "a",
            "0 0,1",
            e,
            Ee(-e, e)
          );
          return { topLeft: t, topRight: n, bottomRight: u, bottomLeft: s, rightHeight: e };
        }
        shapeFor(e) {
          switch (e.type) {
            case me.INPUT_VALUE:
            case me.OUTPUT_VALUE:
              return this.PUZZLE_TAB;
            case me.PREVIOUS_STATEMENT:
            case me.NEXT_STATEMENT:
              return this.NOTCH;
            default:
              throw Error("Unknown connection type");
          }
        }
        createDom(e, t, n) {
          this.injectCSS_(t, n), this.defs = K(G.DEFS, {}, e), e = K(G.FILTER, { id: "blocklyEmbossFilter" + this.randomIdentifier }, this.defs), K(G.FEGAUSSIANBLUR, { in: "SourceAlpha", stdDeviation: 1, result: "blur" }, e), t = K(
            G.FESPECULARLIGHTING,
            { in: "blur", surfaceScale: 1, specularConstant: 0.5, specularExponent: 10, "lighting-color": "white", result: "specOut" },
            e
          ), K(G.FEPOINTLIGHT, { x: -5e3, y: -1e4, z: 2e4 }, t), K(G.FECOMPOSITE, { in: "specOut", in2: "SourceAlpha", operator: "in", result: "specOut" }, e), K(
            G.FECOMPOSITE,
            { in: "SourceGraphic", in2: "specOut", operator: "arithmetic", k1: 0, k2: 1, k3: 1, k4: 0 },
            e
          ), this.embossFilterId = e.id, this.embossFilter = e, e = K(G.PATTERN, { id: "blocklyDisabledPattern" + this.randomIdentifier, patternUnits: "userSpaceOnUse", width: 10, height: 10 }, this.defs), K(G.RECT, { width: 10, height: 10, fill: "#aaa" }, e), K(
            G.PATH,
            { d: "M 0 0 L 10 10 M 10 0 L 0 10", stroke: "#cc0" },
            e
          ), this.disabledPatternId = e.id, this.disabledPattern = e, this.createDebugFilter();
        }
        createDebugFilter() {
          if (!this.debugFilter) {
            const e = K(G.FILTER, { id: "blocklyDebugFilter" + this.randomIdentifier, height: "160%", width: "180%", y: "-30%", x: "-40%" }, this.defs), t = K(
              G.FECOMPONENTTRANSFER,
              { result: "outBlur" },
              e
            );
            K(G.FEFUNCA, { type: "table", tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1" }, t), K(G.FEFLOOD, { "flood-color": "#ff0000", "flood-opacity": 0.5, result: "outColor" }, e), K(G.FECOMPOSITE, { in: "outColor", in2: "outBlur", operator: "in", result: "outGlow" }, e), this.debugFilterId = e.id, this.debugFilter = e;
          }
        }
        injectCSS_(e, t) {
          t = this.getCSS_(t), e = "blockly-renderer-style-" + e, this.cssNode = document.getElementById(e);
          const n = t.join(`
`);
          this.cssNode ? this.cssNode.firstChild.textContent = n : (t = document.createElement("style"), t.id = e, e = document.createTextNode(n), t.appendChild(e), document.head.insertBefore(t, document.head.firstChild), this.cssNode = t);
        }
        getCSS_(e) {
          return [
            `${e} .blocklyText, `,
            `${e} .blocklyFlyoutLabelText {`,
            `font: ${this.FIELD_TEXT_FONTWEIGHT} ${this.FIELD_TEXT_FONTSIZE}pt ${this.FIELD_TEXT_FONTFAMILY};`,
            "}",
            `${e} .blocklyText {`,
            "fill: #fff;",
            "}",
            `${e} .blocklyNonEditableText>rect,`,
            `${e} .blocklyEditableText>rect {`,
            `fill: ${this.FIELD_BORDER_RECT_COLOUR};`,
            "fill-opacity: .6;",
            "stroke: none;",
            "}",
            `${e} .blocklyNonEditableText>text,`,
            `${e} .blocklyEditableText>text {`,
            "fill: #000;",
            "}",
            `${e} .blocklyFlyoutLabelText {`,
            "fill: #000;",
            "}",
            `${e} .blocklyText.blocklyBubbleText {`,
            "fill: #000;",
            "}",
            `${e} .blocklyEditableText:not(.editing):hover>rect {`,
            "stroke: #fff;",
            "stroke-width: 2;",
            "}",
            `${e} .blocklyHtmlInput {`,
            `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
            `font-weight: ${this.FIELD_TEXT_FONTWEIGHT};`,
            "}",
            `${e} .blocklySelected>.blocklyPath {`,
            "stroke: #fc3;",
            "stroke-width: 3px;",
            "}",
            `${e} .blocklyHighlightedConnectionPath {`,
            "stroke: #fc3;",
            "}",
            `${e} .blocklyReplaceable .blocklyPath {`,
            "fill-opacity: .5;",
            "}",
            `${e} .blocklyReplaceable .blocklyPathLight,`,
            `${e} .blocklyReplaceable .blocklyPathDark {`,
            "display: none;",
            "}",
            `${e} .blocklyInsertionMarker>.blocklyPath {`,
            `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
            "stroke: none;",
            "}"
          ];
        }
      }, gA = class extends Il {
        constructor() {
          super(), this.GRID_UNIT = 4, this.CURSOR_COLOUR = "#ffa200", this.CURSOR_RADIUS = 5, this.JAGGED_TEETH_WIDTH = this.JAGGED_TEETH_HEIGHT = 0, this.START_HAT_HEIGHT = 22, this.START_HAT_WIDTH = 96, this.SHAPES = { HEXAGONAL: 1, ROUND: 2, SQUARE: 3, PUZZLE: 4, NOTCH: 5 }, this.SHAPE_IN_SHAPE_PADDING = {
            1: { 0: 5 * this.GRID_UNIT, 1: 2 * this.GRID_UNIT, 2: 5 * this.GRID_UNIT, 3: 5 * this.GRID_UNIT },
            2: { 0: 3 * this.GRID_UNIT, 1: 3 * this.GRID_UNIT, 2: 1 * this.GRID_UNIT, 3: 2 * this.GRID_UNIT },
            3: { 0: 2 * this.GRID_UNIT, 1: 2 * this.GRID_UNIT, 2: 2 * this.GRID_UNIT, 3: 2 * this.GRID_UNIT }
          }, this.FULL_BLOCK_FIELDS = !0, this.FIELD_TEXT_FONTWEIGHT = "bold", this.FIELD_TEXT_FONTFAMILY = '"Helvetica Neue", "Segoe UI", Helvetica, sans-serif', this.FIELD_COLOUR_FULL_BLOCK = this.FIELD_TEXTINPUT_BOX_SHADOW = this.FIELD_DROPDOWN_SVG_ARROW = this.FIELD_DROPDOWN_COLOURED_DIV = this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !0, this.SELECTED_GLOW_COLOUR = "#fff200", this.SELECTED_GLOW_SIZE = 0.5, this.REPLACEMENT_GLOW_COLOUR = "#fff200", this.REPLACEMENT_GLOW_SIZE = 2, this.selectedGlowFilterId = "", this.selectedGlowFilter = null, this.replacementGlowFilterId = "", this.SQUARED = this.ROUNDED = this.HEXAGONAL = this.replacementGlowFilter = null, this.SMALL_PADDING = this.GRID_UNIT, this.MEDIUM_PADDING = 2 * this.GRID_UNIT, this.MEDIUM_LARGE_PADDING = 3 * this.GRID_UNIT, this.LARGE_PADDING = 4 * this.GRID_UNIT, this.CORNER_RADIUS = 1 * this.GRID_UNIT, this.NOTCH_WIDTH = 9 * this.GRID_UNIT, this.NOTCH_HEIGHT = 2 * this.GRID_UNIT, this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT = 3 * this.GRID_UNIT, this.MIN_BLOCK_WIDTH = 2 * this.GRID_UNIT, this.MIN_BLOCK_HEIGHT = 12 * this.GRID_UNIT, this.EMPTY_STATEMENT_INPUT_HEIGHT = 6 * this.GRID_UNIT, this.TOP_ROW_MIN_HEIGHT = this.CORNER_RADIUS, this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.BOTTOM_ROW_MIN_HEIGHT = this.CORNER_RADIUS, this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = 6 * this.GRID_UNIT, this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT, this.STATEMENT_INPUT_SPACER_MIN_WIDTH = 40 * this.GRID_UNIT, this.STATEMENT_INPUT_PADDING_LEFT = 4 * this.GRID_UNIT, this.EMPTY_INLINE_INPUT_PADDING = 4 * this.GRID_UNIT, this.EMPTY_INLINE_INPUT_HEIGHT = 8 * this.GRID_UNIT, this.DUMMY_INPUT_MIN_HEIGHT = 8 * this.GRID_UNIT, this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = 6 * this.GRID_UNIT, this.CURSOR_WS_WIDTH = 20 * this.GRID_UNIT, this.FIELD_TEXT_FONTSIZE = 3 * this.GRID_UNIT, this.FIELD_BORDER_RECT_RADIUS = this.CORNER_RADIUS, this.FIELD_BORDER_RECT_X_PADDING = 2 * this.GRID_UNIT, this.FIELD_BORDER_RECT_Y_PADDING = 1.625 * this.GRID_UNIT, this.FIELD_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT, this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = 8 * this.GRID_UNIT, this.FIELD_DROPDOWN_SVG_ARROW_PADDING = this.FIELD_BORDER_RECT_X_PADDING, this.FIELD_COLOUR_DEFAULT_WIDTH = 2 * this.GRID_UNIT, this.FIELD_COLOUR_DEFAULT_HEIGHT = 4 * this.GRID_UNIT, this.FIELD_CHECKBOX_X_OFFSET = 1 * this.GRID_UNIT, this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH = 12 * this.GRID_UNIT;
        }
        setFontConstants_(e) {
          super.setFontConstants_(e), this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = this.FIELD_BORDER_RECT_HEIGHT = this.FIELD_TEXT_HEIGHT + 2 * this.FIELD_BORDER_RECT_Y_PADDING;
        }
        init() {
          super.init(), this.HEXAGONAL = this.makeHexagonal(), this.ROUNDED = this.makeRounded(), this.SQUARED = this.makeSquared(), this.STATEMENT_INPUT_NOTCH_OFFSET = this.NOTCH_OFFSET_LEFT + this.INSIDE_CORNERS.rightWidth;
        }
        setDynamicProperties_(e) {
          super.setDynamicProperties_(e), this.SELECTED_GLOW_COLOUR = e.getComponentStyle("selectedGlowColour") || this.SELECTED_GLOW_COLOUR;
          const t = Number(e.getComponentStyle("selectedGlowSize"));
          this.SELECTED_GLOW_SIZE = t && !isNaN(t) ? t : this.SELECTED_GLOW_SIZE, this.REPLACEMENT_GLOW_COLOUR = e.getComponentStyle("replacementGlowColour") || this.REPLACEMENT_GLOW_COLOUR, this.REPLACEMENT_GLOW_SIZE = (e = Number(e.getComponentStyle("replacementGlowSize"))) && !isNaN(e) ? e : this.REPLACEMENT_GLOW_SIZE;
        }
        dispose() {
          super.dispose(), this.selectedGlowFilter && _t(this.selectedGlowFilter), this.replacementGlowFilter && _t(this.replacementGlowFilter);
        }
        makeStartHat() {
          const e = this.START_HAT_HEIGHT, t = this.START_HAT_WIDTH, n = Lt("c", [Ee(
            25,
            -e
          ), Ee(71, -e), Ee(t, 0)]);
          return { height: e, width: t, path: n };
        }
        makeHexagonal() {
          function e(n, s, u) {
            var A = n / 2;
            return A = A > t ? t : A, u = u ? -1 : 1, n = (s ? -1 : 1) * n / 2, di(-u * A, n) + di(u * A, n);
          }
          const t = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH;
          return { type: this.SHAPES.HEXAGONAL, isDynamic: !0, width(n) {
            return n /= 2, n > t ? t : n;
          }, height(n) {
            return n;
          }, connectionOffsetY(n) {
            return n / 2;
          }, connectionOffsetX(n) {
            return -n;
          }, pathDown(n) {
            return e(n, !1, !1);
          }, pathUp(n) {
            return e(n, !0, !1);
          }, pathRightDown(n) {
            return e(n, !1, !0);
          }, pathRightUp(n) {
            return e(n, !1, !0);
          } };
        }
        makeRounded() {
          function e(s, u, A) {
            const L = s > n ? s - n : 0;
            return s = (s > n ? n : s) / 2, Ft("a", "0 0,1", s, Ee((u ? -1 : 1) * s, (u ? -1 : 1) * s)) + Ae("v", (A ? 1 : -1) * L) + Ft("a", "0 0,1", s, Ee((u ? 1 : -1) * s, (u ? -1 : 1) * s));
          }
          const t = this.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, n = 2 * t;
          return { type: this.SHAPES.ROUND, isDynamic: !0, width(s) {
            return s /= 2, s > t ? t : s;
          }, height(s) {
            return s;
          }, connectionOffsetY(s) {
            return s / 2;
          }, connectionOffsetX(s) {
            return -s;
          }, pathDown(s) {
            return e(s, !1, !1);
          }, pathUp(s) {
            return e(s, !0, !1);
          }, pathRightDown(s) {
            return e(s, !1, !0);
          }, pathRightUp(s) {
            return e(s, !1, !0);
          } };
        }
        makeSquared() {
          function e(n, s, u) {
            return n -= 2 * t, Ft("a", "0 0,1", t, Ee((s ? -1 : 1) * t, (s ? -1 : 1) * t)) + Ae("v", (u ? 1 : -1) * n) + Ft("a", "0 0,1", t, Ee((s ? 1 : -1) * t, (s ? -1 : 1) * t));
          }
          const t = this.CORNER_RADIUS;
          return { type: this.SHAPES.SQUARE, isDynamic: !0, width(n) {
            return t;
          }, height(n) {
            return n;
          }, connectionOffsetY(n) {
            return n / 2;
          }, connectionOffsetX(n) {
            return -n;
          }, pathDown(n) {
            return e(n, !1, !1);
          }, pathUp(n) {
            return e(n, !0, !1);
          }, pathRightDown(n) {
            return e(n, !1, !0);
          }, pathRightUp(n) {
            return e(
              n,
              !1,
              !0
            );
          } };
        }
        shapeFor(e) {
          let t = e.getCheck();
          switch (!t && e.targetConnection && (t = e.targetConnection.getCheck()), e.type) {
            case me.INPUT_VALUE:
            case me.OUTPUT_VALUE:
              if (e = e.getSourceBlock().getOutputShape(), e !== null)
                switch (e) {
                  case this.SHAPES.HEXAGONAL:
                    return this.HEXAGONAL;
                  case this.SHAPES.ROUND:
                    return this.ROUNDED;
                  case this.SHAPES.SQUARE:
                    return this.SQUARED;
                }
              return t && t.indexOf("Boolean") !== -1 ? this.HEXAGONAL : t && t.indexOf("Number") !== -1 ? this.ROUNDED : (t && t.indexOf("String"), this.ROUNDED);
            case me.PREVIOUS_STATEMENT:
            case me.NEXT_STATEMENT:
              return this.NOTCH;
            default:
              throw Error("Unknown type");
          }
        }
        makeNotch() {
          function e(Le) {
            return Lt("c", [Ee(Le * u / 2, 0), Ee(Le * u * 3 / 4, L / 2), Ee(Le * u, L)]) + Ys([Ee(Le * u, A)]) + Lt("c", [Ee(Le * u / 4, L / 2), Ee(Le * u / 2, L), Ee(Le * u, L)]) + Ae("h", Le * s) + Lt("c", [Ee(Le * u / 2, 0), Ee(Le * u * 3 / 4, -(L / 2)), Ee(Le * u, -L)]) + Ys([Ee(Le * u, -A)]) + Lt("c", [Ee(Le * u / 4, -(L / 2)), Ee(Le * u / 2, -L), Ee(Le * u, -L)]);
          }
          const t = this.NOTCH_WIDTH, n = this.NOTCH_HEIGHT, s = t / 3, u = s / 3, A = n / 2, L = A / 2, $ = e(1), q = e(-1);
          return {
            type: this.SHAPES.NOTCH,
            width: t,
            height: n,
            pathLeft: $,
            pathRight: q
          };
        }
        makeInsideCorners() {
          const e = this.CORNER_RADIUS, t = Ft("a", "0 0,0", e, Ee(-e, e)), n = Ft("a", "0 0,1", e, Ee(-e, e)), s = Ft("a", "0 0,0", e, Ee(e, e)), u = Ft("a", "0 0,1", e, Ee(
            e,
            e
          ));
          return { width: e, height: e, pathTop: t, pathBottom: s, rightWidth: e, rightHeight: e, pathTopRight: n, pathBottomRight: u };
        }
        generateSecondaryColour_(e) {
          return jn("#000", e, 0.15) || e;
        }
        generateTertiaryColour_(e) {
          return jn("#000", e, 0.25) || e;
        }
        createDom(e, t, n) {
          super.createDom(e, t, n), e = K(G.DEFS, {}, e), t = K(
            G.FILTER,
            { id: "blocklySelectedGlowFilter" + this.randomIdentifier, height: "160%", width: "180%", y: "-30%", x: "-40%" },
            e
          ), K(G.FEGAUSSIANBLUR, { in: "SourceGraphic", stdDeviation: this.SELECTED_GLOW_SIZE }, t), n = K(G.FECOMPONENTTRANSFER, { result: "outBlur" }, t), K(G.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
          }, n), K(G.FEFLOOD, { "flood-color": this.SELECTED_GLOW_COLOUR, "flood-opacity": 1, result: "outColor" }, t), K(G.FECOMPOSITE, { in: "outColor", in2: "outBlur", operator: "in", result: "outGlow" }, t), this.selectedGlowFilterId = t.id, this.selectedGlowFilter = t, e = K(
            G.FILTER,
            { id: "blocklyReplacementGlowFilter" + this.randomIdentifier, height: "160%", width: "180%", y: "-30%", x: "-40%" },
            e
          ), K(G.FEGAUSSIANBLUR, { in: "SourceGraphic", stdDeviation: this.REPLACEMENT_GLOW_SIZE }, e), t = K(G.FECOMPONENTTRANSFER, { result: "outBlur" }, e), K(G.FEFUNCA, {
            type: "table",
            tableValues: "0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1"
          }, t), K(G.FEFLOOD, { "flood-color": this.REPLACEMENT_GLOW_COLOUR, "flood-opacity": 1, result: "outColor" }, e), K(G.FECOMPOSITE, { in: "outColor", in2: "outBlur", operator: "in", result: "outGlow" }, e), K(G.FECOMPOSITE, {
            in: "SourceGraphic",
            in2: "outGlow",
            operator: "over"
          }, e), this.replacementGlowFilterId = e.id, this.replacementGlowFilter = e;
        }
        getCSS_(e) {
          return [
            `${e} .blocklyText,`,
            `${e} .blocklyFlyoutLabelText {`,
            `font: ${this.FIELD_TEXT_FONTWEIGHT} ${this.FIELD_TEXT_FONTSIZE}pt ${this.FIELD_TEXT_FONTFAMILY};`,
            "}",
            `${e} .blocklyText {`,
            "fill: #fff;",
            "}",
            `${e} .blocklyNonEditableText>rect:not(.blocklyDropdownRect),`,
            `${e} .blocklyEditableText>rect:not(.blocklyDropdownRect) {`,
            `fill: ${this.FIELD_BORDER_RECT_COLOUR};`,
            "}",
            `${e} .blocklyNonEditableText>text,`,
            `${e} .blocklyEditableText>text,`,
            `${e} .blocklyNonEditableText>g>text,`,
            `${e} .blocklyEditableText>g>text {`,
            "fill: #575E75;",
            "}",
            `${e} .blocklyFlyoutLabelText {`,
            "fill: #575E75;",
            "}",
            `${e} .blocklyText.blocklyBubbleText {`,
            "fill: #575E75;",
            "}",
            `${e} .blocklyDraggable:not(.blocklyDisabled)`,
            " .blocklyEditableText:not(.editing):hover>rect,",
            `${e} .blocklyDraggable:not(.blocklyDisabled)`,
            " .blocklyEditableText:not(.editing):hover>.blocklyPath {",
            "stroke: #fff;",
            "stroke-width: 2;",
            "}",
            `${e} .blocklyHtmlInput {`,
            `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
            `font-weight: ${this.FIELD_TEXT_FONTWEIGHT};`,
            "color: #575E75;",
            "}",
            `${e} .blocklyDropdownText {`,
            "fill: #fff !important;",
            "}",
            `${e}.blocklyWidgetDiv .goog-menuitem,`,
            `${e}.blocklyDropDownDiv .goog-menuitem {`,
            `font-family: ${this.FIELD_TEXT_FONTFAMILY};`,
            "}",
            `${e}.blocklyDropDownDiv .goog-menuitem-content {`,
            "color: #fff;",
            "}",
            `${e} .blocklyHighlightedConnectionPath {`,
            `stroke: ${this.SELECTED_GLOW_COLOUR};`,
            "}",
            `${e} .blocklyDisabled > .blocklyOutlinePath {`,
            `fill: url(#blocklyDisabledPattern${this.randomIdentifier})`,
            "}",
            `${e} .blocklyInsertionMarker>.blocklyPath {`,
            `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
            "stroke: none;",
            "}"
          ];
        }
      }, xS = class {
        constructor() {
          this.NONE = 0, this.FIELD = 1, this.HAT = 2, this.ICON = 4, this.SPACER = 8, this.BETWEEN_ROW_SPACER = 16, this.IN_ROW_SPACER = 32, this.EXTERNAL_VALUE_INPUT = 64, this.INPUT = 128, this.INLINE_INPUT = 256, this.STATEMENT_INPUT = 512, this.CONNECTION = 1024, this.PREVIOUS_CONNECTION = 2048, this.NEXT_CONNECTION = 4096, this.OUTPUT_CONNECTION = 8192, this.CORNER = 16384, this.LEFT_SQUARE_CORNER = 32768, this.LEFT_ROUND_CORNER = 65536, this.RIGHT_SQUARE_CORNER = 131072, this.RIGHT_ROUND_CORNER = 262144, this.JAGGED_EDGE = 524288, this.ROW = 1048576, this.TOP_ROW = 2097152, this.BOTTOM_ROW = 4194304, this.INPUT_ROW = 8388608, this.LEFT_CORNER = this.LEFT_SQUARE_CORNER | this.LEFT_ROUND_CORNER, this.RIGHT_CORNER = this.RIGHT_SQUARE_CORNER | this.RIGHT_ROUND_CORNER, this.nextTypeValue_ = 16777216;
        }
        getType(e) {
          return Object.prototype.hasOwnProperty.call(this, e) || (this[e] = this.nextTypeValue_, this.nextTypeValue_ <<= 1), this[e];
        }
        isField(e) {
          return e.type & this.FIELD;
        }
        isHat(e) {
          return e.type & this.HAT;
        }
        isIcon(e) {
          return e.type & this.ICON;
        }
        isSpacer(e) {
          return e.type & this.SPACER;
        }
        isInRowSpacer(e) {
          return e.type & this.IN_ROW_SPACER;
        }
        isInput(e) {
          return e.type & this.INPUT;
        }
        isExternalInput(e) {
          return e.type & this.EXTERNAL_VALUE_INPUT;
        }
        isInlineInput(e) {
          return e.type & this.INLINE_INPUT;
        }
        isStatementInput(e) {
          return e.type & this.STATEMENT_INPUT;
        }
        isPreviousConnection(e) {
          return e.type & this.PREVIOUS_CONNECTION;
        }
        isNextConnection(e) {
          return e.type & this.NEXT_CONNECTION;
        }
        isPreviousOrNextConnection(e) {
          return e.type & (this.PREVIOUS_CONNECTION | this.NEXT_CONNECTION);
        }
        isLeftRoundedCorner(e) {
          return e.type & this.LEFT_ROUND_CORNER;
        }
        isRightRoundedCorner(e) {
          return e.type & this.RIGHT_ROUND_CORNER;
        }
        isLeftSquareCorner(e) {
          return e.type & this.LEFT_SQUARE_CORNER;
        }
        isRightSquareCorner(e) {
          return e.type & this.RIGHT_SQUARE_CORNER;
        }
        isCorner(e) {
          return e.type & this.CORNER;
        }
        isJaggedEdge(e) {
          return e.type & this.JAGGED_EDGE;
        }
        isRow(e) {
          return e.type & this.ROW;
        }
        isBetweenRowSpacer(e) {
          return e.type & this.BETWEEN_ROW_SPACER;
        }
        isTopRow(e) {
          return e.type & this.TOP_ROW;
        }
        isBottomRow(e) {
          return e.type & this.BOTTOM_ROW;
        }
        isTopOrBottomRow(e) {
          return e.type & (this.TOP_ROW | this.BOTTOM_ROW);
        }
        isInputRow(e) {
          return e.type & this.INPUT_ROW;
        }
      }, F = new xS(), Qi = class {
        constructor(e) {
          this.centerline = this.xPos = this.height = this.width = 0, this.constants_ = e, this.type = F.NONE, this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        }
      }, Ms = class extends Qi {
        constructor(e, t) {
          super(e), this.connectionModel = t, this.shape = this.constants_.shapeFor(t), this.isDynamicShape = "isDynamic" in this.shape && this.shape.isDynamic, this.type |= F.CONNECTION;
        }
      }, W_ = class {
        constructor(e, t) {
          this.inlinePath_ = this.outlinePath_ = "", this.block_ = e, this.info_ = t, this.topLeft_ = e.getRelativeToSurfaceXY(), this.constants_ = t.getRenderer().getConstants();
        }
        draw() {
          this.drawOutline_(), this.drawInternals_(), this.block_.pathObject.setPath(this.outlinePath_ + `
` + this.inlinePath_), this.info_.RTL && this.block_.pathObject.flipRTL(), this.recordSizeOnBlock_();
        }
        hideHiddenIcons_() {
          hr(
            "hideHiddenIcons_",
            "v10",
            "v11"
          );
        }
        recordSizeOnBlock_() {
          this.block_.height = this.info_.height, this.block_.width = this.info_.widthWithChildren;
        }
        drawOutline_() {
          this.drawTop_();
          for (let e = 1; e < this.info_.rows.length - 1; e++) {
            const t = this.info_.rows[e];
            t.hasJaggedEdge ? this.drawJaggedEdge_(t) : t.hasStatement ? this.drawStatementInput_(t) : t.hasExternalInput ? this.drawValueInput_(t) : this.drawRightSideRow_(t);
          }
          this.drawBottom_(), this.drawLeft_();
        }
        drawTop_() {
          const e = this.info_.topRow, t = e.elements;
          this.positionPreviousConnection_(), this.outlinePath_ += wt(e.xPos, this.info_.startY);
          for (let n = 0, s; s = t[n]; n++)
            F.isLeftRoundedCorner(s) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topLeft : F.isRightRoundedCorner(s) ? this.outlinePath_ += this.constants_.OUTSIDE_CORNERS.topRight : F.isPreviousConnection(s) && s instanceof Ms ? this.outlinePath_ += s.shape.pathLeft : F.isHat(s) ? this.outlinePath_ += this.constants_.START_HAT.path : F.isSpacer(s) && (this.outlinePath_ += Ae("h", s.width));
          this.outlinePath_ += Ae("v", e.height);
        }
        drawJaggedEdge_(e) {
          this.outlinePath_ += this.constants_.JAGGED_TEETH.path + Ae(
            "v",
            e.height - this.constants_.JAGGED_TEETH.height
          );
        }
        drawValueInput_(e) {
          const t = e.getLastInput();
          this.positionExternalValueConnection_(e);
          const n = np(t.shape) ? t.shape.pathDown(t.height) : t.shape.pathDown;
          this.outlinePath_ += Ae("H", t.xPos + t.width) + n + Ae("v", e.height - t.connectionHeight);
        }
        drawStatementInput_(e) {
          var t = e.getLastInput();
          if (t) {
            var n = t.xPos + t.notchOffset + t.shape.width;
            t = t.shape.pathRight + Ae("h", -(t.notchOffset - this.constants_.INSIDE_CORNERS.width)) + this.constants_.INSIDE_CORNERS.pathTop;
            var s = e.height - 2 * this.constants_.INSIDE_CORNERS.height;
            this.outlinePath_ += Ae("H", n) + t + Ae("v", s) + this.constants_.INSIDE_CORNERS.pathBottom + Ae("H", e.xPos + e.width), this.positionStatementInputConnection_(e);
          }
        }
        drawRightSideRow_(e) {
          this.outlinePath_ += Ae("V", e.yPos + e.height);
        }
        drawBottom_() {
          const e = this.info_.bottomRow, t = e.elements;
          this.positionNextConnection_();
          let n = 0, s = "";
          for (let u = t.length - 1, A; A = t[u]; u--)
            F.isNextConnection(A) && A instanceof Ms ? s += A.shape.pathRight : F.isLeftSquareCorner(A) ? s += Ae(
              "H",
              e.xPos
            ) : F.isLeftRoundedCorner(A) ? s += this.constants_.OUTSIDE_CORNERS.bottomLeft : F.isRightRoundedCorner(A) ? (s += this.constants_.OUTSIDE_CORNERS.bottomRight, n = this.constants_.OUTSIDE_CORNERS.rightHeight) : F.isSpacer(A) && (s += Ae("h", -1 * A.width));
          this.outlinePath_ += Ae(
            "V",
            e.baseline - n
          ), this.outlinePath_ += s;
        }
        drawLeft_() {
          var e = this.info_.outputConnection;
          if (this.positionOutputConnection_(), e) {
            const t = e.connectionOffsetY + e.height;
            e = np(e.shape) ? e.shape.pathUp(e.height) : e.shape.pathUp, this.outlinePath_ += Ae("V", t) + e;
          }
          this.outlinePath_ += "z";
        }
        drawInternals_() {
          for (let e = 0, t; t = this.info_.rows[e]; e++)
            for (let n = 0, s; s = t.elements[n]; n++)
              F.isInlineInput(s) ? this.drawInlineInput_(s) : (F.isIcon(s) || F.isField(s)) && this.layoutField_(s);
        }
        layoutField_(e) {
          const t = e.centerline - e.height / 2;
          let n = e.xPos;
          var s = "";
          this.info_.RTL && (n = -(n + e.width), e.flipRtl && (n += e.width, s = "scale(-1 1)")), F.isIcon(e) ? (s = e.icon, s.setOffsetInBlock(new Te(n, t)), this.info_.isInsertionMarker && s.hideForInsertionMarker()) : (e = e.field.getSvgRoot(), e.setAttribute("transform", "translate(" + n + "," + t + ")" + s), this.info_.isInsertionMarker && e.setAttribute("display", "none"));
        }
        drawInlineInput_(e) {
          const t = e.width, n = e.height, s = e.connectionOffsetY, u = e.connectionHeight + s;
          this.inlinePath_ += br(e.xPos + e.connectionWidth, e.centerline - n / 2) + Ae("v", s) + e.shape.pathDown + Ae("v", n - u) + Ae("h", t - e.connectionWidth) + Ae("v", -n) + "z", this.positionInlineInputConnection_(e);
        }
        positionInlineInputConnection_(e) {
          const t = e.centerline - e.height / 2;
          if (e.connectionModel) {
            let n = e.xPos + e.connectionWidth + e.connectionOffsetX;
            this.info_.RTL && (n *= -1), e.connectionModel.setOffsetInBlock(n, t + e.connectionOffsetY);
          }
        }
        positionStatementInputConnection_(e) {
          const t = e.getLastInput();
          if (t != null && t.connectionModel) {
            let n = e.xPos + e.statementEdge + t.notchOffset;
            this.info_.RTL && (n *= -1), t.connectionModel.setOffsetInBlock(n, e.yPos);
          }
        }
        positionExternalValueConnection_(e) {
          const t = e.getLastInput();
          if (t && t.connectionModel) {
            let n = e.xPos + e.width;
            this.info_.RTL && (n *= -1), t.connectionModel.setOffsetInBlock(n, e.yPos);
          }
        }
        positionPreviousConnection_() {
          const e = this.info_.topRow;
          if (e.connection) {
            const t = e.xPos + e.notchOffset;
            e.connection.connectionModel.setOffsetInBlock(this.info_.RTL ? -t : t, 0);
          }
        }
        positionNextConnection_() {
          const e = this.info_.bottomRow;
          if (e.connection) {
            const t = e.connection, n = t.xPos;
            t.connectionModel.setOffsetInBlock(this.info_.RTL ? -n : n, e.baseline);
          }
        }
        positionOutputConnection_() {
          if (this.info_.outputConnection) {
            const e = this.info_.startX + this.info_.outputConnection.connectionOffsetX;
            this.block_.outputConnection.setOffsetInBlock(this.info_.RTL ? -e : e, this.info_.outputConnection.connectionOffsetY);
          }
        }
      }, LA = class extends W_ {
        constructor(e, t) {
          super(e, t);
        }
        draw() {
          const e = this.block_.pathObject;
          e.beginDrawing(), this.drawOutline_(), this.drawInternals_(), e.setPath(this.outlinePath_ + `
` + this.inlinePath_), this.info_.RTL && e.flipRTL(), this.recordSizeOnBlock_(), this.info_.outputConnection && (e.outputShapeType = this.info_.outputConnection.shape.type), e.endDrawing();
        }
        drawOutline_() {
          this.info_.outputConnection && this.info_.outputConnection.isDynamicShape && !this.info_.hasStatementInput && !this.info_.bottomRow.hasNextConnection ? (this.drawFlatTop_(), this.drawRightDynamicConnection_(), this.drawFlatBottom_(), this.drawLeftDynamicConnection_()) : super.drawOutline_();
        }
        drawLeft_() {
          this.info_.outputConnection && this.info_.outputConnection.isDynamicShape ? this.drawLeftDynamicConnection_() : super.drawLeft_();
        }
        drawRightSideRow_(e) {
          if (!(0 >= e.height)) {
            if (F.isSpacer(e)) {
              const s = e.precedesStatement;
              var t = e.followsStatement;
              if (s || t) {
                const u = this.constants_.INSIDE_CORNERS;
                var n = u.rightHeight;
                n = e.height - (s ? n : 0), t = t ? u.pathBottomRight : "", e = 0 < n ? Ae("V", e.yPos + n) : "", this.outlinePath_ += t + e + (s ? u.pathTopRight : "");
                return;
              }
            }
            this.outlinePath_ += Ae("V", e.yPos + e.height);
          }
        }
        drawRightDynamicConnection_() {
          if (!this.info_.outputConnection)
            throw Error("Cannot draw the output connection of a block that doesn't have one");
          this.outlinePath_ += this.info_.outputConnection.shape.pathRightDown(this.info_.outputConnection.height);
        }
        drawLeftDynamicConnection_() {
          if (!this.info_.outputConnection)
            throw Error("Cannot draw the output connection of a block that doesn't have one");
          this.positionOutputConnection_(), this.outlinePath_ += this.info_.outputConnection.shape.pathUp(this.info_.outputConnection.height), this.outlinePath_ += "z";
        }
        drawFlatTop_() {
          const e = this.info_.topRow;
          this.positionPreviousConnection_(), this.outlinePath_ += wt(
            e.xPos,
            this.info_.startY
          ), this.outlinePath_ += Ae("h", e.width);
        }
        drawFlatBottom_() {
          const e = this.info_.bottomRow;
          this.positionNextConnection_(), this.outlinePath_ += Ae("V", e.baseline), this.outlinePath_ += Ae("h", -e.width);
        }
        drawInlineInput_(e) {
          this.positionInlineInputConnection_(e);
          const t = e.input.name;
          if (!e.connectedBlock && !this.info_.isInsertionMarker) {
            var n = e.width - 2 * e.connectionWidth;
            e = br(e.xPos + e.connectionWidth, e.centerline - e.height / 2) + Ae("h", n) + e.shape.pathRightDown(e.height) + Ae("h", -n) + e.shape.pathUp(e.height) + "z", this.block_.pathObject.setOutlinePath(t, e);
          }
        }
        drawStatementInput_(e) {
          var t = e.getLastInput();
          const n = t.xPos + t.notchOffset + t.shape.width, s = this.constants_.INSIDE_CORNERS, u = t.shape.pathRight + Ae(
            "h",
            -(t.notchOffset - s.width)
          ) + s.pathTop, A = e.height - 2 * s.height;
          t = s.pathBottom + Ae("h", t.notchOffset - s.width) + (t.connectedBottomNextConnection ? "" : t.shape.pathLeft), this.outlinePath_ += Ae("H", n) + u + Ae("v", A) + t + Ae("H", e.xPos + e.width), this.positionStatementInputConnection_(e);
        }
      }, gs = class extends lt {
        constructor(e, t, n, s, u, A, L) {
          if (super(lt.SKIP_SETUP), this.imageElement = this.clickHandler = null, this.flipRtl = this.isDirty_ = this.EDITABLE = !1, this.altText = "", n = Number(Jt(n)), t = Number(Jt(t)), isNaN(n) || isNaN(t))
            throw Error("Height and width values of an image field must cast to numbers.");
          if (0 >= n || 0 >= t)
            throw Error("Height and width values of an image field must be greater than 0.");
          this.size_ = new It(t, n + gs.Y_PADDING), this.imageHeight = n, typeof u == "function" && (this.clickHandler = u), e !== lt.SKIP_SETUP && (L ? this.configure_(L) : (this.flipRtl = !!A, this.altText = Jt(s) || ""), this.setValue(Jt(e)));
        }
        configure_(e) {
          super.configure_(e), e.flipRtl && (this.flipRtl = e.flipRtl), e.alt && (this.altText = Jt(e.alt));
        }
        initView() {
          this.imageElement = K(G.IMAGE, { height: this.imageHeight + "px", width: this.size_.width + "px", alt: this.altText }, this.fieldGroup_), this.imageElement.setAttributeNS(kn, "xlink:href", this.value_), this.clickHandler && (this.imageElement.style.cursor = "pointer");
        }
        updateSize_() {
        }
        doClassValidation_(e) {
          return typeof e != "string" ? null : e;
        }
        doValueUpdate_(e) {
          this.value_ = e, this.imageElement && this.imageElement.setAttributeNS(kn, "xlink:href", this.value_);
        }
        getFlipRtl() {
          return this.flipRtl;
        }
        setAlt(e) {
          e !== this.altText && (this.altText = e || "", this.imageElement && this.imageElement.setAttribute("alt", this.altText));
        }
        showEditor_() {
          this.clickHandler && this.clickHandler(this);
        }
        setOnClickHandler(e) {
          this.clickHandler = e;
        }
        getText_() {
          return this.altText;
        }
        static fromJson(e) {
          if (!e.src || !e.width || !e.height)
            throw Error("src, width, and height values for an image field arerequired. The width and height must be non-zero.");
          return new this(e.src, e.width, e.height, void 0, void 0, void 0, e);
        }
      };
      gs.Y_PADDING = 1, Vr("field_image", gs), gs.prototype.DEFAULT_VALUE = "";
      var k_ = class extends lt {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.spellcheck_ = !0, this.htmlInput_ = null, this.isTextValid_ = this.isBeingEdited_ = !1, this.onKeyInputWrapper_ = this.onKeyDownWrapper_ = this.valueWhenEditorWasOpened_ = null, this.fullBlockClickTarget_ = !1, this.workspace_ = null, this.SERIALIZABLE = !0, this.CURSOR = "text", e !== lt.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.spellcheck !== void 0 && (this.spellcheck_ = e.spellcheck);
        }
        initView() {
          const e = this.getSourceBlock();
          if (!e)
            throw new lr();
          if (this.getConstants().FULL_BLOCK_FIELDS) {
            let t = 0, n = 0;
            for (let s = 0, u; u = e.inputList[s]; s++) {
              for (let A = 0; u.fieldRow[A]; A++)
                t++;
              u.connection && n++;
            }
            this.fullBlockClickTarget_ = 1 >= t && e.outputConnection && !n;
          } else
            this.fullBlockClickTarget_ = !1;
          this.fullBlockClickTarget_ ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : this.createBorderRect_(), this.createTextElement_();
        }
        doValueInvalid_(e) {
          this.isBeingEdited_ && (this.isDirty_ = !0, this.isTextValid_ = !1, e = this.value_, this.value_ = this.htmlInput_.getAttribute("data-untyped-default-value"), this.sourceBlock_ && nt() && Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(this.sourceBlock_, "field", this.name || null, e, this.value_)));
        }
        doValueUpdate_(e) {
          this.isTextValid_ = this.isDirty_ = !0, this.value_ = e;
        }
        applyColour() {
          if (this.sourceBlock_ && this.getConstants().FULL_BLOCK_FIELDS) {
            var e = this.sourceBlock_;
            this.borderRect_ ? this.borderRect_.setAttribute("stroke", e.style.colourTertiary) : e.pathObject.svgPath.setAttribute("fill", this.getConstants().FIELD_BORDER_RECT_COLOUR);
          }
        }
        render_() {
          if (super.render_(), this.isBeingEdited_) {
            this.resizeEditor_();
            const e = this.htmlInput_;
            this.isTextValid_ ? (Ue(e, "blocklyInvalidInput"), gt(
              e,
              Dt.INVALID,
              !1
            )) : (Re(e, "blocklyInvalidInput"), gt(e, Dt.INVALID, !0));
          }
        }
        setSpellcheck(e) {
          e !== this.spellcheck_ && (this.spellcheck_ = e, this.htmlInput_ && this.htmlInput_.setAttribute("spellcheck", this.spellcheck_));
        }
        showEditor_(e, t = !1) {
          this.workspace_ = this.sourceBlock_.workspace, !t && this.workspace_.options.modalInputs && (M_ || nu || la) ? this.showPromptEditor_() : this.showInlineEditor_(t);
        }
        showPromptEditor_() {
          m(r.Msg$$module$build$src$core$msg.CHANGE_VALUE_TITLE, this.getText(), (e) => {
            e !== null && this.setValue(this.getValueFromEditorText_(e));
          });
        }
        showInlineEditor_(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new lr();
          Q(this, t.RTL, this.widgetDispose_.bind(this)), this.htmlInput_ = this.widgetCreate_(), this.isBeingEdited_ = !0, this.valueWhenEditorWasOpened_ = this.value_, e || (this.htmlInput_.focus({ preventScroll: !0 }), this.htmlInput_.select());
        }
        widgetCreate_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new lr();
          r.setGroup$$module$build$src$core$events$utils(!0);
          const t = Gl();
          var n = this.getClickTarget_();
          if (!n)
            throw Error("A click target has not been set.");
          Re(
            n,
            "editing"
          ), n = document.createElement("input"), n.className = "blocklyHtmlInput", n.setAttribute("spellcheck", this.spellcheck_);
          const s = this.workspace_.getScale();
          var u = this.getConstants().FIELD_TEXT_FONTSIZE * s + "pt";
          return t.style.fontSize = u, n.style.fontSize = u, u = k_.BORDERRADIUS * s + "px", this.fullBlockClickTarget_ && (u = this.getScaledBBox(), u = (u.bottom - u.top) / 2 + "px", e = e.getParent() ? e.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary, n.style.border = 1 * s + "px solid " + e, t.style.borderRadius = u, t.style.transition = "box-shadow 0.25s ease 0s", this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW && (t.style.boxShadow = "rgba(255, 255, 255, 0.3) 0 0 0 " + 4 * s + "px")), n.style.borderRadius = u, t.appendChild(n), n.value = n.defaultValue = this.getEditorText_(this.value_), n.setAttribute("data-untyped-default-value", String(this.value_)), this.resizeEditor_(), this.bindInputEvents_(n), n;
        }
        widgetDispose_() {
          this.isBeingEdited_ = !1, this.isTextValid_ = !0, this.forceRerender(), this.onFinishEditing_(this.value_), this.sourceBlock_ && nt() && this.valueWhenEditorWasOpened_ !== null && this.valueWhenEditorWasOpened_ !== this.value_ && (Ce(new (fe(r.CHANGE$$module$build$src$core$events$utils))(this.sourceBlock_, "field", this.name || null, this.valueWhenEditorWasOpened_, this.value_)), this.valueWhenEditorWasOpened_ = null), r.setGroup$$module$build$src$core$events$utils(!1), this.unbindInputEvents_();
          var e = Gl().style;
          if (e.width = "auto", e.height = "auto", e.fontSize = "", e.transition = "", e.boxShadow = "", this.htmlInput_ = null, e = this.getClickTarget_(), !e)
            throw Error("A click target has not been set.");
          Ue(e, "editing");
        }
        onFinishEditing_(e) {
        }
        bindInputEvents_(e) {
          this.onKeyDownWrapper_ = ge(e, "keydown", this, this.onHtmlInputKeyDown_), this.onKeyInputWrapper_ = ge(e, "input", this, this.onHtmlInputChange_);
        }
        unbindInputEvents_() {
          this.onKeyDownWrapper_ && (Mt(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null), this.onKeyInputWrapper_ && (Mt(this.onKeyInputWrapper_), this.onKeyInputWrapper_ = null);
        }
        onHtmlInputKeyDown_(e) {
          e.key === "Enter" ? (j(), Ti()) : e.key === "Escape" ? (this.setValue(this.htmlInput_.getAttribute("data-untyped-default-value")), j(), Ti()) : e.key === "Tab" && (j(), Ti(), this.sourceBlock_.tab(this, !e.shiftKey), e.preventDefault());
        }
        onHtmlInputChange_(e) {
          e = this.value_, this.setValue(this.getValueFromEditorText_(this.htmlInput_.value), !1), this.sourceBlock_ && nt() && this.value_ !== e && Ce(new (fe(No))(
            this.sourceBlock_,
            this.name || null,
            e,
            this.value_
          )), R().then(() => {
            this.resizeEditor_();
          });
        }
        setEditorValue_(e, t = !0) {
          this.isDirty_ = !0, this.isBeingEdited_ && (this.htmlInput_.value = this.getEditorText_(e)), this.setValue(e, t);
        }
        resizeEditor_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new lr();
          const t = Gl(), n = this.getScaledBBox();
          t.style.width = n.right - n.left + "px", t.style.height = n.bottom - n.top + "px", e = new Te(e.RTL ? n.right - t.offsetWidth : n.left, n.top), t.style.left = e.x + "px", t.style.top = e.y + "px";
        }
        repositionForWindowResize() {
          const e = this.getSourceBlock();
          return e instanceof Fn ? (js(this.workspace_, this.workspace_.getMetricsManager().getViewMetrics(!0), e), this.resizeEditor_(), !0) : !1;
        }
        isTabNavigable() {
          return !0;
        }
        getText_() {
          return this.isBeingEdited_ && this.htmlInput_ ? this.htmlInput_.value : null;
        }
        getEditorText_(e) {
          return `${e}`;
        }
        getValueFromEditorText_(e) {
          return e;
        }
      };
      k_.BORDERRADIUS = 4;
      var ga = class extends k_ {
        constructor(e, t, n) {
          super(e, t, n);
        }
        doClassValidation_(e) {
          return e === void 0 ? null : `${e}`;
        }
        static fromJson(e) {
          return new this(Jt(e.text), void 0, e);
        }
      };
      Vr("field_input", ga), ga.prototype.DEFAULT_VALUE = "";
      var w_ = class {
        constructor(e) {
          this.elements = [], this.xPos = this.yPos = this.widthWithConnectedBlocks = this.minWidth = this.minHeight = this.width = this.height = 0, this.hasStatement = this.hasExternalInput = !1, this.statementEdge = 0, this.hasJaggedEdge = this.hasDummyInput = this.hasInlineInput = !1, this.align = null, this.constants_ = e, this.type = F.ROW, this.notchOffset = this.constants_.NOTCH_OFFSET_LEFT;
        }
        getLastInput() {
          for (let e = this.elements.length - 1; 0 <= e; e--) {
            const t = this.elements[e];
            if (F.isInput(t))
              return t;
          }
          return null;
        }
        measure() {
          throw Error("Unexpected attempt to measure a base Row.");
        }
        startsWithElemSpacer() {
          return !0;
        }
        endsWithElemSpacer() {
          return !0;
        }
        getFirstSpacer() {
          for (let e = 0; e < this.elements.length; e++) {
            const t = this.elements[e];
            if (F.isSpacer(t))
              return t;
          }
          return null;
        }
        getLastSpacer() {
          for (let e = this.elements.length - 1; 0 <= e; e--) {
            const t = this.elements[e];
            if (F.isSpacer(t))
              return t;
          }
          return null;
        }
      }, Ad = class extends w_ {
        constructor(e) {
          super(e), this.hasNextConnection = !1, this.connection = null, this.baseline = this.descenderHeight = 0, this.type |= F.BOTTOM_ROW;
        }
        hasLeftSquareCorner(e) {
          return !!e.outputConnection || !!e.getNextBlock();
        }
        hasRightSquareCorner(e) {
          return !0;
        }
        measure() {
          let e = 0, t = 0, n = 0;
          for (let s = 0; s < this.elements.length; s++) {
            const u = this.elements[s];
            t += u.width, F.isSpacer(u) || (F.isNextConnection(u) ? n = Math.max(n, u.height) : e = Math.max(e, u.height));
          }
          this.width = Math.max(this.minWidth, t), this.height = Math.max(this.minHeight, e) + n, this.descenderHeight = n, this.widthWithConnectedBlocks = this.width;
        }
        startsWithElemSpacer() {
          return !1;
        }
        endsWithElemSpacer() {
          return !1;
        }
      }, Ml = class extends Ms {
        constructor(e, t) {
          super(e, t.connection), this.input = t, this.connectionOffsetY = this.connectionOffsetX = 0, this.type |= F.INPUT, this.align = t.align, (this.connectedBlock = t.connection && t.connection.targetBlock() ? t.connection.targetBlock() : null) ? (e = this.connectedBlock.getHeightWidth(), this.connectedBlockWidth = e.width, this.connectedBlockHeight = e.height) : this.connectedBlockHeight = this.connectedBlockWidth = 0;
        }
      }, La = class extends Ml {
        constructor(e, t) {
          super(e, t), this.height = 0, this.type |= F.EXTERNAL_VALUE_INPUT, this.height = this.connectedBlock ? this.connectedBlockHeight - this.constants_.TAB_OFFSET_FROM_TOP - this.constants_.MEDIUM_PADDING : this.shape.height, this.width = this.shape.width + this.constants_.EXTERNAL_VALUE_INPUT_PADDING, this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP, this.connectionHeight = this.shape.height, this.connectionWidth = this.shape.width;
        }
      }, Na = class extends Qi {
        constructor(e, t, n) {
          super(e), this.field = t, this.parentInput = n, this.isEditable = t.EDITABLE, this.flipRtl = t.getFlipRtl(), this.type |= F.FIELD, e = this.field.getSize(), this.height = e.height, this.width = e.width;
        }
      }, F_ = class extends Qi {
        constructor(e) {
          super(e), this.type |= F.HAT, this.height = this.constants_.START_HAT.height, this.width = this.constants_.START_HAT.width, this.ascenderHeight = this.height;
        }
      }, NA = class extends Qi {
        constructor(e, t) {
          super(e), this.icon = t, this.flipRtl = !1, this.isVisible = Ko(t) && t.bubbleIsVisible(), this.type |= F.ICON, e = t.getSize(), this.height = e.height, this.width = e.width;
        }
      }, Bn = class extends Qi {
        constructor(e, t) {
          super(e), this.type = this.type | F.SPACER | F.IN_ROW_SPACER, this.width = t, this.height = this.constants_.SPACER_DEFAULT_HEIGHT;
        }
      }, Sd = class extends Ml {
        constructor(e, t) {
          super(e, t), this.type |= F.INLINE_INPUT, this.connectedBlock ? (this.width = this.connectedBlockWidth, this.height = this.connectedBlockHeight) : (this.height = this.constants_.EMPTY_INLINE_INPUT_HEIGHT, this.width = this.constants_.EMPTY_INLINE_INPUT_PADDING), this.connectionHeight = this.isDynamicShape ? this.shape.height(this.height) : this.shape.height, this.connectionWidth = this.isDynamicShape ? this.shape.width(this.height) : this.shape.width, this.connectedBlock || (this.width += this.connectionWidth * (this.isDynamicShape ? 2 : 1)), this.connectionOffsetY = "connectionOffsetY" in this.shape ? this.shape.connectionOffsetY(this.connectionHeight) : this.constants_.TAB_OFFSET_FROM_TOP, this.connectionOffsetX = "connectionOffsetX" in this.shape ? this.shape.connectionOffsetX(this.connectionWidth) : 0;
        }
      }, ar = class extends Ml {
        constructor(e, t) {
          super(e, t), this.type |= F.STATEMENT_INPUT, this.height = this.connectedBlock ? this.connectedBlockHeight + this.constants_.STATEMENT_BOTTOM_SPACER : this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT, this.width = this.constants_.STATEMENT_INPUT_NOTCH_OFFSET + this.shape.width;
        }
      }, xr = class extends w_ {
        constructor(e) {
          super(e), this.connectedBlockWidths = 0, this.type |= F.INPUT_ROW;
        }
        measure() {
          this.width = this.minWidth, this.height = this.minHeight;
          let e = 0;
          for (let t = 0; t < this.elements.length; t++) {
            const n = this.elements[t];
            this.width += n.width, F.isInput(n) && n instanceof Ml && (F.isStatementInput(n) && n instanceof ar ? e += n.connectedBlockWidth : F.isExternalInput(n) && n instanceof La && n.connectedBlockWidth !== 0 && (e += n.connectedBlockWidth - n.connectionWidth)), F.isSpacer(n) || (this.height = Math.max(this.height, n.height));
          }
          this.connectedBlockWidths = e, this.widthWithConnectedBlocks = this.width + e;
        }
        endsWithElemSpacer() {
          return !this.hasExternalInput && !this.hasStatement;
        }
      }, yA = class extends Qi {
        constructor(e) {
          super(e), this.type |= F.JAGGED_EDGE, this.height = this.constants_.JAGGED_TEETH.height, this.width = this.constants_.JAGGED_TEETH.width;
        }
      }, fA = class extends Ms {
        constructor(e, t) {
          super(e, t), this.type |= F.NEXT_CONNECTION, this.height = this.shape.height, this.width = this.shape.width;
        }
      }, CA = class extends Ms {
        constructor(e, t) {
          super(e, t), this.connectionOffsetX = 0, this.type |= F.OUTPUT_CONNECTION, this.height = this.isDynamicShape ? 0 : this.shape.height, this.startX = this.width = this.isDynamicShape ? 0 : this.shape.width, this.connectionOffsetY = this.constants_.TAB_OFFSET_FROM_TOP;
        }
      }, hd = class extends Ms {
        constructor(e, t) {
          super(e, t), this.type |= F.PREVIOUS_CONNECTION, this.height = this.shape.height, this.width = this.shape.width;
        }
      }, B_ = class extends Qi {
        constructor(e, t) {
          super(e), this.type = (t && t !== "left" ? F.RIGHT_ROUND_CORNER : F.LEFT_ROUND_CORNER) | F.CORNER, this.width = this.constants_.CORNER_RADIUS, this.height = this.constants_.CORNER_RADIUS / 2;
        }
      }, md = class extends w_ {
        constructor(e, t, n) {
          super(e), this.height = t, this.width = n, this.precedesStatement = this.followsStatement = !1, this.widthWithConnectedBlocks = 0, this.type = this.type | F.SPACER | F.BETWEEN_ROW_SPACER, this.elements = [new Bn(
            this.constants_,
            n
          )];
        }
        measure() {
        }
      }, U_ = class extends Qi {
        constructor(e, t) {
          super(e), this.type = (t && t !== "left" ? F.RIGHT_SQUARE_CORNER : F.LEFT_SQUARE_CORNER) | F.CORNER, this.width = this.height = this.constants_.NO_PADDING;
        }
      }, Wu = class extends w_ {
        constructor(e) {
          super(e), this.ascenderHeight = this.capline = 0, this.hasPreviousConnection = !1, this.connection = null, this.type |= F.TOP_ROW;
        }
        hasLeftSquareCorner(e) {
          const t = (e.hat ? e.hat === "cap" : this.constants_.ADD_START_HATS) && !e.outputConnection && !e.previousConnection, n = e.getPreviousBlock();
          return !!e.outputConnection || t || (n ? n.getNextBlock() === e : !1);
        }
        hasRightSquareCorner(e) {
          return !0;
        }
        measure() {
          let e = 0, t = 0, n = 0;
          for (let s = 0; s < this.elements.length; s++) {
            const u = this.elements[s];
            t += u.width, F.isSpacer(u) || (F.isHat(u) && u instanceof F_ ? n = Math.max(n, u.ascenderHeight) : e = Math.max(e, u.height));
          }
          this.width = Math.max(this.minWidth, t), this.height = Math.max(this.minHeight, e) + n, this.capline = this.ascenderHeight = n, this.widthWithConnectedBlocks = this.width;
        }
        startsWithElemSpacer() {
          return !1;
        }
        endsWithElemSpacer() {
          return !1;
        }
      }, ya = class {
        constructor(e, t) {
          this.statementEdge = this.width = this.widthWithChildren = this.height = 0, this.rows = [], this.inputRows = [], this.startY = this.startX = 0, this.renderer_ = e, this.block_ = t, this.constants_ = this.renderer_.getConstants(), this.outputConnection = t.outputConnection ? new CA(this.constants_, t.outputConnection) : null, this.isInline = t.getInputsInline() && !t.isCollapsed(), this.isCollapsed = t.isCollapsed(), this.isInsertionMarker = t.isInsertionMarker(), this.RTL = t.RTL, this.topRow = new Wu(this.constants_), this.bottomRow = new Ad(this.constants_);
        }
        getRenderer() {
          return this.renderer_;
        }
        measure() {
          this.createRows_(), this.addElemSpacing_(), this.addRowSpacing_(), this.computeBounds_(), this.alignRowElements_(), this.finalize_();
        }
        createRows_() {
          this.populateTopRow_(), this.rows.push(this.topRow);
          let e = new xr(this.constants_);
          this.inputRows.push(e);
          var t = this.block_.getIcons();
          for (let n = 0, s; s = t[n]; n++) {
            const u = new NA(this.constants_, s);
            this.isCollapsed && !s.isShownWhenCollapsed() || e.elements.push(u);
          }
          t = void 0;
          for (let n = 0, s; s = this.block_.inputList[n]; n++)
            if (s.isVisible()) {
              this.shouldStartNewRow_(s, t) && (this.rows.push(e), e = new xr(this.constants_), this.inputRows.push(e));
              for (let u = 0, A; A = s.fieldRow[u]; u++)
                e.elements.push(new Na(this.constants_, A, s));
              this.addInput_(s, e), t = s;
            }
          this.isCollapsed && (e.hasJaggedEdge = !0, e.elements.push(new yA(this.constants_))), (e.elements.length || e.hasDummyInput) && this.rows.push(e), this.populateBottomRow_(), this.rows.push(this.bottomRow);
        }
        populateTopRow_() {
          var e = !!this.block_.previousConnection;
          const t = (this.block_.hat ? this.block_.hat === "cap" : this.constants_.ADD_START_HATS) && !this.outputConnection && !e;
          let n = this.topRow.hasLeftSquareCorner(this.block_) ? U_ : B_;
          this.topRow.elements.push(new n(this.constants_)), t ? (e = new F_(this.constants_), this.topRow.elements.push(e), this.topRow.capline = e.ascenderHeight) : e && (this.topRow.hasPreviousConnection = !0, this.topRow.connection = new hd(this.constants_, this.block_.previousConnection), this.topRow.elements.push(this.topRow.connection)), this.block_.inputList.length && this.block_.inputList[0] instanceof wn && !this.block_.isCollapsed() ? this.topRow.minHeight = this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT : this.topRow.minHeight = this.constants_.TOP_ROW_MIN_HEIGHT, n = this.topRow.hasRightSquareCorner(this.block_) ? U_ : B_, this.topRow.elements.push(new n(this.constants_, "right"));
        }
        populateBottomRow_() {
          this.bottomRow.hasNextConnection = !!this.block_.nextConnection, this.bottomRow.minHeight = this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1] instanceof wn ? this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT : this.constants_.BOTTOM_ROW_MIN_HEIGHT, this.bottomRow.hasLeftSquareCorner(this.block_) ? this.bottomRow.elements.push(new U_(this.constants_)) : this.bottomRow.elements.push(new B_(this.constants_)), this.bottomRow.hasNextConnection && (this.bottomRow.connection = new fA(
            this.constants_,
            this.block_.nextConnection
          ), this.bottomRow.elements.push(this.bottomRow.connection)), this.bottomRow.hasRightSquareCorner(this.block_) ? this.bottomRow.elements.push(new U_(this.constants_, "right")) : this.bottomRow.elements.push(new B_(this.constants_, "right"));
        }
        addInput_(e, t) {
          this.isInline && e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new Sd(
            this.constants_,
            e
          )), t.hasInlineInput = !0) : e instanceof wn ? (t.elements.push(new ar(this.constants_, e)), t.hasStatement = !0) : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new La(this.constants_, e)), t.hasExternalInput = !0) : e instanceof ni && (t.minHeight = Math.max(t.minHeight, e.getSourceBlock() && e.getSourceBlock().isShadow() ? this.constants_.DUMMY_INPUT_SHADOW_MIN_HEIGHT : this.constants_.DUMMY_INPUT_MIN_HEIGHT), t.hasDummyInput = !0), t.align === null && (t.align = e.align);
        }
        shouldStartNewRow_(e, t) {
          return t ? e instanceof wn || t instanceof wn ? !0 : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input || e instanceof ni ? !this.isInline : !1 : !1;
        }
        addElemSpacing_() {
          for (let e = 0, t; t = this.rows[e]; e++) {
            const n = t.elements;
            if (t.elements = [], t.startsWithElemSpacer() && t.elements.push(new Bn(this.constants_, this.getInRowSpacing_(null, n[0]))), n.length) {
              for (let s = 0; s < n.length - 1; s++) {
                t.elements.push(n[s]);
                const u = this.getInRowSpacing_(n[s], n[s + 1]);
                t.elements.push(new Bn(this.constants_, u));
              }
              t.elements.push(n[n.length - 1]), t.endsWithElemSpacer() && t.elements.push(new Bn(this.constants_, this.getInRowSpacing_(n[n.length - 1], null)));
            }
          }
        }
        getInRowSpacing_(e, t) {
          if (!e && t && F.isStatementInput(t))
            return this.constants_.STATEMENT_INPUT_PADDING_LEFT;
          if (e && F.isInput(e) && !t) {
            if (F.isExternalInput(e))
              return this.constants_.NO_PADDING;
            if (F.isInlineInput(e))
              return this.constants_.LARGE_PADDING;
            if (F.isStatementInput(e))
              return this.constants_.NO_PADDING;
          }
          return e && F.isLeftSquareCorner(e) && t && (F.isPreviousConnection(t) || F.isNextConnection(t)) ? t.notchOffset : e && F.isLeftRoundedCorner(e) && t && (F.isPreviousConnection(t) || F.isNextConnection(t)) ? t.notchOffset - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
        }
        computeBounds_() {
          let e = 0, t = 0, n = 0;
          for (let u = 0, A; A = this.rows[u]; u++) {
            if (A.measure(), t = Math.max(t, A.width), A.hasStatement) {
              var s = A.getLastInput();
              let L, $;
              s = A.width - (($ = (L = s) == null ? void 0 : L.width) != null ? $ : 0), e = Math.max(e, s);
            }
            n = Math.max(n, A.widthWithConnectedBlocks);
          }
          this.statementEdge = e, this.width = t;
          for (let u = 0, A; A = this.rows[u]; u++)
            A.hasStatement && (A.statementEdge = this.statementEdge);
          this.widthWithChildren = Math.max(t, n), this.outputConnection && (this.startX = this.outputConnection.width, this.width += this.outputConnection.width, this.widthWithChildren += this.outputConnection.width);
        }
        alignRowElements_() {
          for (let t = 0, n; n = this.rows[t]; t++)
            if (n.hasStatement)
              this.alignStatementRow_(n);
            else {
              var e = n.width;
              e = this.getDesiredRowWidth_(n) - e, 0 < e && this.addAlignmentPadding_(n, e), F.isTopOrBottomRow(n) && (n.widthWithConnectedBlocks = n.width);
            }
        }
        getDesiredRowWidth_(e) {
          return this.width - this.startX;
        }
        addAlignmentPadding_(e, t) {
          const n = e.getFirstSpacer(), s = e.getLastSpacer();
          if ((e.hasExternalInput || e.hasStatement) && (e.widthWithConnectedBlocks += t), e.align === r.Align$$module$build$src$core$inputs$align.LEFT && s)
            s.width += t;
          else if (e.align === r.Align$$module$build$src$core$inputs$align.CENTRE && n && s)
            n.width += t / 2, s.width += t / 2;
          else if (e.align === r.Align$$module$build$src$core$inputs$align.RIGHT && n)
            n.width += t;
          else if (s)
            s.width += t;
          else
            return;
          e.width += t;
        }
        alignStatementRow_(e) {
          const t = e.getLastInput();
          if (t) {
            var n = e.width - t.width, s = this.statementEdge;
            n = s - n, 0 < n && this.addAlignmentPadding_(e, n), n = e.width, s = this.getDesiredRowWidth_(e), t.width += s - n, t.height = Math.max(t.height, e.height), e.width += s - n, e.widthWithConnectedBlocks = Math.max(e.width, this.statementEdge + e.connectedBlockWidths);
          }
        }
        addRowSpacing_() {
          const e = this.rows;
          this.rows = [];
          for (let t = 0; t < e.length; t++)
            this.rows.push(e[t]), t !== e.length - 1 && this.rows.push(this.makeSpacerRow_(
              e[t],
              e[t + 1]
            ));
        }
        makeSpacerRow_(e, t) {
          var n = this.getSpacerRowHeight_(e, t);
          const s = this.getSpacerRowWidth_(e, t);
          return n = new md(this.constants_, n, s), e.hasStatement && (n.followsStatement = !0), t.hasStatement && (n.precedesStatement = !0), n;
        }
        getSpacerRowWidth_(e, t) {
          return this.width - this.startX;
        }
        getSpacerRowHeight_(e, t) {
          return this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(e, t) {
          return F.isSpacer(t) ? e.yPos + t.height / 2 : F.isBottomRow(e) ? (e = e.yPos + e.height - e.descenderHeight, F.isNextConnection(t) ? e + t.height / 2 : e - t.height / 2) : F.isTopRow(e) ? F.isHat(t) ? e.capline - t.height / 2 : e.capline + t.height / 2 : e.yPos + e.height / 2;
        }
        recordElemPositions_(e) {
          let t = e.xPos;
          for (let n = 0, s; s = e.elements[n]; n++)
            F.isSpacer(s) && (s.height = e.height), s.xPos = t, s.centerline = this.getElemCenterline_(e, s), t += s.width;
        }
        finalize_() {
          let e = 0, t = 0;
          for (let n = 0, s; s = this.rows[n]; n++)
            s.yPos = t, s.xPos = this.startX, t += s.height, e = Math.max(e, s.widthWithConnectedBlocks), this.recordElemPositions_(s);
          if (this.outputConnection && this.block_.nextConnection) {
            const n = this.block_.nextConnection.targetBlock();
            n && (e = Math.max(e, n.getHeightWidth().width));
          }
          this.widthWithChildren = e + this.startX, this.height = t, this.startY = this.topRow.capline, this.bottomRow.baseline = t - this.bottomRow.descenderHeight;
        }
      }, vA = class extends Ad {
        constructor(e) {
          super(e);
        }
        endsWithElemSpacer() {
          return !1;
        }
        hasLeftSquareCorner(e) {
          return !!e.outputConnection;
        }
        hasRightSquareCorner(e) {
          return !!e.outputConnection && !e.statementInputCount && !e.nextConnection;
        }
      }, ku = class extends ar {
        constructor(e, t) {
          if (super(e, t), this.connectedBottomNextConnection = !1, this.connectedBlock) {
            for (e = this.connectedBlock; t = e.getNextBlock(); )
              e = t;
            e.nextConnection || (this.height = this.connectedBlockHeight, this.connectedBottomNextConnection = !0);
          }
        }
      }, Id = class extends Qi {
        constructor(e) {
          super(e), this.width = this.height = 0, this.type |= F.getType("RIGHT_CONNECTION");
        }
      }, Md = class extends Wu {
        constructor(e) {
          super(e);
        }
        endsWithElemSpacer() {
          return !1;
        }
        hasLeftSquareCorner(e) {
          const t = (e.hat ? e.hat === "cap" : this.constants_.ADD_START_HATS) && !e.outputConnection && !e.previousConnection;
          return !!e.outputConnection || t;
        }
        hasRightSquareCorner(e) {
          return !!e.outputConnection && !e.statementInputCount && !e.nextConnection;
        }
      }, RA = class extends ya {
        constructor(e, t) {
          super(e, t), this.isInline = !0, this.renderer_ = e, this.constants_ = this.renderer_.getConstants(), this.topRow = new Md(this.constants_), this.bottomRow = new vA(this.constants_), this.isMultiRow = !t.getInputsInline() || t.isCollapsed(), this.hasStatementInput = 0 < t.statementInputCount, this.rightSide = this.outputConnection ? new Id(this.constants_) : null, this.rightAlignedDummyInputs = /* @__PURE__ */ new WeakMap();
        }
        getRenderer() {
          return this.renderer_;
        }
        measure() {
          this.createRows_(), this.addElemSpacing_(), this.addRowSpacing_(), this.adjustXPosition_(), this.computeBounds_(), this.alignRowElements_(), this.finalize_();
        }
        shouldStartNewRow_(e, t) {
          return t ? e instanceof wn || t instanceof wn ? !0 : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input || e instanceof ni ? !this.isInline || this.isMultiRow : !1 : !1;
        }
        getDesiredRowWidth_(e) {
          return e.hasStatement ? this.width - this.startX - (this.constants_.INSIDE_CORNERS.rightWidth || 0) : super.getDesiredRowWidth_(e);
        }
        getInRowSpacing_(e, t) {
          return e && t || !this.outputConnection || !this.outputConnection.isDynamicShape || this.hasStatementInput || this.bottomRow.hasNextConnection ? !e && t && F.isStatementInput(t) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : e && F.isLeftRoundedCorner(e) && t && (F.isPreviousConnection(t) || F.isNextConnection(t)) ? t.notchOffset - this.constants_.CORNER_RADIUS : e && F.isLeftSquareCorner(e) && t && F.isHat(t) ? this.constants_.NO_PADDING : this.constants_.MEDIUM_PADDING : this.constants_.NO_PADDING;
        }
        getSpacerRowHeight_(e, t) {
          if (F.isTopRow(e) && F.isBottomRow(t))
            return this.constants_.EMPTY_BLOCK_SPACER_HEIGHT;
          const n = F.isInputRow(e) && e.hasStatement, s = F.isInputRow(t) && t.hasStatement;
          return s || n ? (e = Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.INSIDE_CORNERS.rightHeight || 0), s && n ? Math.max(e, this.constants_.DUMMY_INPUT_MIN_HEIGHT) : e) : F.isTopRow(e) ? e.hasPreviousConnection || this.outputConnection && !this.hasStatementInput ? this.constants_.NO_PADDING : Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : F.isBottomRow(t) ? this.outputConnection ? !t.hasNextConnection && this.hasStatementInput ? Math.abs(this.constants_.NOTCH_HEIGHT - this.constants_.CORNER_RADIUS) : this.constants_.NO_PADDING : Math.max(this.topRow.minHeight, Math.max(this.constants_.NOTCH_HEIGHT, this.constants_.CORNER_RADIUS)) - this.constants_.CORNER_RADIUS : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowWidth_(e, t) {
          const n = this.width - this.startX;
          return F.isInputRow(e) && e.hasStatement || F.isInputRow(t) && t.hasStatement ? Math.max(n, this.constants_.STATEMENT_INPUT_SPACER_MIN_WIDTH) : n;
        }
        getElemCenterline_(e, t) {
          if (e.hasStatement && !F.isSpacer(t) && !F.isStatementInput(t))
            return e.yPos + this.constants_.EMPTY_STATEMENT_INPUT_HEIGHT / 2;
          if (F.isInlineInput(t) && t instanceof Ml) {
            const n = t.connectedBlock;
            if (n && n.outputConnection && n.nextConnection)
              return e.yPos + n.height / 2;
          }
          return super.getElemCenterline_(e, t);
        }
        addInput_(e, t) {
          if (e instanceof ni && t.hasDummyInput && t.align === r.Align$$module$build$src$core$inputs$align.LEFT && e.align === r.Align$$module$build$src$core$inputs$align.RIGHT)
            this.rightAlignedDummyInputs.set(t, e);
          else if (e instanceof wn) {
            t.elements.push(new ku(
              this.constants_,
              e
            )), t.hasStatement = !0, t.align === null && (t.align = e.align);
            return;
          }
          super.addInput_(e, t);
        }
        addAlignmentPadding_(e, t) {
          if (this.rightAlignedDummyInputs.get(e)) {
            let n;
            for (let s = 0; s < e.elements.length; s++) {
              const u = e.elements[s];
              if (F.isSpacer(u) && (n = u), F.isField(u) && u instanceof Na && u.parentInput === this.rightAlignedDummyInputs.get(e))
                break;
            }
            if (n) {
              n.width += t, e.width += t;
              return;
            }
          }
          super.addAlignmentPadding_(e, t);
        }
        adjustXPosition_() {
          const e = this.constants_.NOTCH_OFFSET_LEFT + this.constants_.NOTCH_WIDTH;
          let t = e;
          for (let u = 2; u < this.rows.length - 1; u += 2) {
            var n = this.rows[u - 1];
            const A = this.rows[u];
            var s = this.rows[u + 1];
            if (n = u === 2 ? !!this.topRow.hasPreviousConnection : !!n.followsStatement, s = u + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!s.precedesStatement, F.isInputRow(A) && A.hasStatement) {
              A.measure();
              let L, $;
              t = A.width - (($ = (L = A.getLastInput()) == null ? void 0 : L.width) != null ? $ : 0) + e;
            } else if (n && (u === 2 || s) && F.isInputRow(A) && !A.hasStatement) {
              s = A.xPos, n = null;
              for (let L = 0; L < A.elements.length; L++) {
                const $ = A.elements[L];
                F.isSpacer($) && (n = $), n && (F.isField($) || F.isInput($)) && s < t && !(F.isField($) && $ instanceof Na && ($.field instanceof Ji || $.field instanceof gs)) && (n.width += t - s), s += $.width;
              }
            }
          }
        }
        finalizeOutputConnection_() {
          if (this.outputConnection && this.outputConnection.isDynamicShape) {
            var e = this.outputConnection.shape;
            if ("isDynamic" in e && e.isDynamic) {
              for (var t = 0, n = 0; n < this.rows.length; n++) {
                const s = this.rows[n];
                s.yPos = t, t += s.height;
              }
              this.height = t, n = this.bottomRow.hasNextConnection ? this.height - this.bottomRow.descenderHeight : this.height, t = e.height(n), n = e.width(n), this.outputConnection.height = t, this.outputConnection.width = n, this.outputConnection.startX = n, this.outputConnection.connectionOffsetY = e.connectionOffsetY(t), this.outputConnection.connectionOffsetX = e.connectionOffsetX(n), e = 0, this.hasStatementInput || this.bottomRow.hasNextConnection || (e = n, this.rightSide.height = t, this.rightSide.width = e, this.rightSide.centerline = t / 2, this.rightSide.xPos = this.width + e), this.startX = n, this.width += n + e, this.widthWithChildren += n + e;
            }
          }
        }
        finalizeHorizontalAlignment_() {
          if (this.outputConnection && !this.hasStatementInput && !this.bottomRow.hasNextConnection) {
            for (var e = 0, t = 0; t < this.rows.length; t++) {
              var n = this.rows[t];
              if (!F.isInputRow(n))
                continue;
              e = n.elements[n.elements.length - 2];
              let s = this.getNegativeSpacing_(n.elements[1]), u = this.getNegativeSpacing_(e);
              e = s + u;
              const A = this.constants_.MIN_BLOCK_WIDTH + 2 * this.outputConnection.width;
              this.width - e < A && (e = this.width - A, s = e / 2, u = e / 2), n.elements.unshift(new Bn(this.constants_, -s)), n.elements.push(new Bn(this.constants_, -u));
            }
            if (e)
              for (this.width -= e, this.widthWithChildren -= e, this.rightSide.xPos -= e, t = 0; t < this.rows.length; t++)
                n = this.rows[t], F.isTopOrBottomRow(n) && (n.elements[1].width -= e), n.width -= e, n.widthWithConnectedBlocks -= e;
          }
        }
        getNegativeSpacing_(e) {
          if (!e || !this.outputConnection)
            return 0;
          const t = this.outputConnection.width;
          var n = this.outputConnection.shape.type;
          const s = this.constants_;
          if (this.isMultiRow && 1 < this.inputRows.length)
            switch (n) {
              case s.SHAPES.ROUND:
                return n = this.constants_.MAX_DYNAMIC_CONNECTION_SHAPE_WIDTH, n = this.height / 2 > n ? n : this.height / 2, t - n * (1 - Math.sin(Math.acos((n - this.constants_.SMALL_PADDING) / n)));
              default:
                return 0;
            }
          if (F.isInlineInput(e) && e instanceof Ml) {
            const u = e.connectedBlock;
            return e = u ? u.pathObject.outputShapeType : e.shape.type, e == null || u && u.outputConnection && (u.statementInputCount || u.nextConnection) || n === s.SHAPES.HEXAGONAL && n !== e ? 0 : t - this.constants_.SHAPE_IN_SHAPE_PADDING[n][e];
          }
          return F.isField(e) && e instanceof Na ? n === s.SHAPES.ROUND && e.field instanceof ga ? t - 2.75 * s.GRID_UNIT : t - this.constants_.SHAPE_IN_SHAPE_PADDING[n][0] : F.isIcon(e) ? this.constants_.SMALL_PADDING : 0;
        }
        finalizeVerticalAlignment_() {
          if (!this.outputConnection)
            for (let s = 2; s < this.rows.length - 1; s += 2) {
              const u = this.rows[s - 1], A = this.rows[s], L = this.rows[s + 1];
              var e = s === 2, t = s + 2 >= this.rows.length - 1 ? !!this.bottomRow.hasNextConnection : !!L.precedesStatement;
              if (e ? this.topRow.hasPreviousConnection : u.followsStatement) {
                var n = A.elements[1];
                if (n = A.elements.length === 3 && n instanceof Na && (n.field instanceof Ji || n.field instanceof gs), !e && n)
                  u.height -= this.constants_.SMALL_PADDING, L.height -= this.constants_.SMALL_PADDING, A.height -= this.constants_.MEDIUM_PADDING;
                else if (!e && !t)
                  u.height += this.constants_.SMALL_PADDING;
                else if (t) {
                  for (e = !1, t = 0; t < A.elements.length; t++)
                    if (n = A.elements[t], n instanceof Ml && F.isInlineInput(n) && n.connectedBlock && !n.connectedBlock.isShadow() && 40 <= n.connectedBlock.getHeightWidth().height) {
                      e = !0;
                      break;
                    }
                  e && (u.height -= this.constants_.SMALL_PADDING, L.height -= this.constants_.SMALL_PADDING);
                }
              }
            }
        }
        finalize_() {
          this.finalizeOutputConnection_(), this.finalizeHorizontalAlignment_(), this.finalizeVerticalAlignment_(), super.finalize_(), this.rightSide && (this.widthWithChildren += this.rightSide.width);
        }
      }, HS = "blocklyCursor", YS = "blocklyMarker", XS = 0.75, gl = class {
        constructor(e, t, n) {
          this.workspace = e, this.marker = n, this.markerSvgRect_ = this.markerSvgLine_ = this.markerInput_ = this.markerBlock_ = this.svgGroup_ = this.markerSvg_ = this.currentMarkerSvg = this.parent = null, this.constants_ = t, e = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR, this.colour_ = n.colour || e;
        }
        getSvgRoot() {
          return this.svgGroup_;
        }
        getMarker() {
          return this.marker;
        }
        isCursor() {
          return this.marker.type === "cursor";
        }
        createDom() {
          const e = this.isCursor() ? HS : YS;
          return this.svgGroup_ = K(G.G, { class: e }), this.createDomInternal_(), this.svgGroup_;
        }
        setParent_(e) {
          this.isCursor() ? (this.parent && this.parent.setCursorSvg(null), e.setCursorSvg(this.getSvgRoot())) : (this.parent && this.parent.setMarkerSvg(null), e.setMarkerSvg(this.getSvgRoot())), this.parent = e;
        }
        draw(e, t) {
          if (t) {
            this.constants_ = this.workspace.getRenderer().getConstants();
            var n = this.isCursor() ? this.constants_.CURSOR_COLOUR : this.constants_.MARKER_COLOUR;
            this.colour_ = this.marker.colour || n, this.applyColour_(t), this.showAtLocation_(t), this.fireMarkerEvent(e, t), e = this.currentMarkerSvg.childNodes[0], e !== void 0 && e.beginElement && e.beginElement();
          } else
            this.hide();
        }
        showAtLocation_(e) {
          const t = e.getLocation().type;
          e.getType() === ie.types.BLOCK ? this.showWithBlock_(e) : e.getType() === ie.types.OUTPUT ? this.showWithOutput_(e) : t === me.INPUT_VALUE ? this.showWithInput_(e) : t === me.NEXT_STATEMENT ? this.showWithNext_(e) : e.getType() === ie.types.PREVIOUS ? this.showWithPrevious_(e) : e.getType() === ie.types.FIELD ? this.showWithField_(e) : e.getType() === ie.types.WORKSPACE ? this.showWithCoordinates_(e) : e.getType() === ie.types.STACK && this.showWithStack_(e);
        }
        showWithBlockPrevOutput(e) {
          e = e.getSourceBlock();
          const t = e.width;
          var n = e.height, s = n * XS;
          const u = this.constants_.CURSOR_BLOCK_PADDING;
          e.previousConnection ? (n = this.constants_.shapeFor(e.previousConnection), this.positionPrevious_(t, u, s, n)) : e.outputConnection ? (s = this.constants_.shapeFor(e.outputConnection), this.positionOutput_(t, n, s)) : this.positionBlock_(t, u, s), this.setParent_(e), this.showCurrent_();
        }
        showWithBlock_(e) {
          this.showWithBlockPrevOutput(e);
        }
        showWithPrevious_(e) {
          this.showWithBlockPrevOutput(e);
        }
        showWithOutput_(e) {
          this.showWithBlockPrevOutput(e);
        }
        showWithCoordinates_(e) {
          var t = e.getWsCoordinate();
          e = t.x, t = t.y, this.workspace.RTL && (e -= this.constants_.CURSOR_WS_WIDTH), this.positionLine_(e, t, this.constants_.CURSOR_WS_WIDTH), this.setParent_(this.workspace), this.showCurrent_();
        }
        showWithField_(e) {
          e = e.getLocation();
          const t = e.getSize().width, n = e.getSize().height;
          this.positionRect_(0, 0, t, n), this.setParent_(e), this.showCurrent_();
        }
        showWithInput_(e) {
          e = e.getLocation();
          const t = e.getSourceBlock();
          this.positionInput_(e), this.setParent_(t), this.showCurrent_();
        }
        showWithNext_(e) {
          var t = e.getLocation();
          e = t.getSourceBlock();
          let n = 0;
          t = t.getOffsetInBlock().y;
          const s = e.getHeightWidth().width;
          this.workspace.RTL && (n = -s), this.positionLine_(n, t, s), this.setParent_(e), this.showCurrent_();
        }
        showWithStack_(e) {
          e = e.getLocation();
          var t = e.getHeightWidth();
          const n = t.width + this.constants_.CURSOR_STACK_PADDING;
          t = t.height + this.constants_.CURSOR_STACK_PADDING;
          const s = -this.constants_.CURSOR_STACK_PADDING / 2, u = -this.constants_.CURSOR_STACK_PADDING / 2;
          let A = s;
          this.workspace.RTL && (A = -(n + s)), this.positionRect_(A, u, n, t), this.setParent_(e), this.showCurrent_();
        }
        showCurrent_() {
          this.hide(), this.currentMarkerSvg && (this.currentMarkerSvg.style.display = "");
        }
        positionBlock_(e, t, n) {
          if (e = wt(-t, n) + Ae("V", -t) + Ae("H", e + 2 * t) + Ae("V", n), !this.markerBlock_)
            throw Error("createDom should be called before positioning the marker");
          this.markerBlock_.setAttribute("d", e), this.workspace.RTL && this.flipRtl(this.markerBlock_), this.currentMarkerSvg = this.markerBlock_;
        }
        positionInput_(e) {
          const t = e.getOffsetInBlock().x, n = e.getOffsetInBlock().y;
          e = br(0, 0) + this.constants_.shapeFor(e).pathDown, this.markerInput_.setAttribute("d", e), this.markerInput_.setAttribute("transform", "translate(" + t + "," + n + ")" + (this.workspace.RTL ? " scale(-1 1)" : "")), this.currentMarkerSvg = this.markerInput_;
        }
        positionLine_(e, t, n) {
          if (!this.markerSvgLine_)
            throw Error("createDom should be called before positioning the line");
          this.markerSvgLine_.setAttribute("x", `${e}`), this.markerSvgLine_.setAttribute("y", `${t}`), this.markerSvgLine_.setAttribute("width", `${n}`), this.currentMarkerSvg = this.markerSvgLine_;
        }
        positionOutput_(e, t, n) {
          if (!this.markerBlock_)
            throw Error("createDom should be called before positioning the output");
          e = wt(e, 0) + Ae("h", -(e - n.width)) + Ae("v", this.constants_.TAB_OFFSET_FROM_TOP) + n.pathDown + Ae("V", t) + Ae("H", e), this.markerBlock_.setAttribute("d", e), this.workspace.RTL && this.flipRtl(this.markerBlock_), this.currentMarkerSvg = this.markerBlock_;
        }
        positionPrevious_(e, t, n, s) {
          if (!this.markerBlock_)
            throw Error("createDom should be called before positioning the previous connection marker");
          e = wt(-t, n) + Ae(
            "V",
            -t
          ) + Ae("H", this.constants_.NOTCH_OFFSET_LEFT) + s.pathLeft + Ae("H", e + 2 * t) + Ae("V", n), this.markerBlock_.setAttribute("d", e), this.workspace.RTL && this.flipRtl(this.markerBlock_), this.currentMarkerSvg = this.markerBlock_;
        }
        positionRect_(e, t, n, s) {
          if (!this.markerSvgRect_)
            throw Error("createDom should be called before positioning the rect");
          this.markerSvgRect_.setAttribute(
            "x",
            `${e}`
          ), this.markerSvgRect_.setAttribute("y", `${t}`), this.markerSvgRect_.setAttribute("width", `${n}`), this.markerSvgRect_.setAttribute("height", `${s}`), this.currentMarkerSvg = this.markerSvgRect_;
        }
        flipRtl(e) {
          e.setAttribute("transform", "scale(-1 1)");
        }
        hide() {
          if (!(this.markerSvgLine_ && this.markerSvgRect_ && this.markerInput_ && this.markerBlock_))
            throw Error("createDom should be called before hiding the marker");
          this.markerSvgLine_.style.display = "none", this.markerSvgRect_.style.display = "none", this.markerInput_.style.display = "none", this.markerBlock_.style.display = "none";
        }
        fireMarkerEvent(e, t) {
          const n = t.getSourceBlock();
          e = new (fe(ol))(n, this.isCursor(), e, t), Ce(e);
        }
        getBlinkProperties_() {
          return { attributeType: "XML", attributeName: "fill", dur: "1s", values: this.colour_ + ";transparent;transparent;", repeatCount: "indefinite" };
        }
        createDomInternal_() {
          if (this.markerSvg_ = K(
            G.G,
            { width: this.constants_.CURSOR_WS_WIDTH, height: this.constants_.WS_CURSOR_HEIGHT },
            this.svgGroup_
          ), this.markerSvgLine_ = K(G.RECT, { width: this.constants_.CURSOR_WS_WIDTH, height: this.constants_.WS_CURSOR_HEIGHT, style: "display: none" }, this.markerSvg_), this.markerSvgRect_ = K(
            G.RECT,
            { class: "blocklyVerticalMarker", rx: 10, ry: 10, style: "display: none" },
            this.markerSvg_
          ), this.markerInput_ = K(G.PATH, { transform: "", style: "display: none" }, this.markerSvg_), this.markerBlock_ = K(G.PATH, { transform: "", style: "display: none", fill: "none", "stroke-width": this.constants_.CURSOR_STROKE_WIDTH }, this.markerSvg_), this.isCursor()) {
            const e = this.getBlinkProperties_();
            K(
              G.ANIMATE,
              e,
              this.markerSvgLine_
            ), K(G.ANIMATE, e, this.markerInput_), K(G.ANIMATE, Object.assign({}, e, { attributeName: "stroke" }), this.markerBlock_);
          }
          return this.markerSvg_;
        }
        applyColour_(e) {
          if (!(this.markerSvgLine_ && this.markerSvgRect_ && this.markerInput_ && this.markerBlock_))
            throw Error("createDom should be called before applying color to the markerj");
          this.markerSvgLine_.setAttribute("fill", this.colour_), this.markerSvgRect_.setAttribute("stroke", this.colour_), this.markerInput_.setAttribute("fill", this.colour_), this.markerBlock_.setAttribute("stroke", this.colour_), this.isCursor() && (e = this.colour_ + ";transparent;transparent;", this.markerSvgLine_.firstElementChild.setAttribute("values", e), this.markerInput_.firstElementChild.setAttribute("values", e), this.markerBlock_.firstElementChild.setAttribute("values", e));
        }
        dispose() {
          this.svgGroup_ && _t(this.svgGroup_);
        }
      }, OA = class extends gl {
        constructor(e, t, n) {
          super(e, t, n), this.markerCircle = null;
        }
        showWithInputOutput(e) {
          const t = e.getSourceBlock();
          e = e.getLocation().getOffsetInBlock(), this.positionCircle(e.x, e.y), this.setParent_(t), this.showCurrent_();
        }
        showWithOutput_(e) {
          this.showWithInputOutput(e);
        }
        showWithInput_(e) {
          this.showWithInputOutput(e);
        }
        showWithBlock_(e) {
          e = e.getLocation();
          const t = e.getHeightWidth();
          this.positionRect_(0, 0, t.width, t.height), this.setParent_(e), this.showCurrent_();
        }
        positionCircle(e, t) {
          let n;
          (n = this.markerCircle) == null || n.setAttribute("cx", `${e}`);
          let s;
          (s = this.markerCircle) == null || s.setAttribute("cy", `${t}`), this.currentMarkerSvg = this.markerCircle;
        }
        hide() {
          super.hide(), this.markerCircle && (this.markerCircle.style.display = "none");
        }
        createDomInternal_() {
          if (super.createDomInternal_(), this.markerCircle = K(
            G.CIRCLE,
            { r: this.constants_.CURSOR_RADIUS, style: "display: none", "stroke-width": this.constants_.CURSOR_STROKE_WIDTH },
            this.markerSvg_
          ), this.isCursor()) {
            const e = this.getBlinkProperties_();
            K(G.ANIMATE, e, this.markerCircle);
          }
          return this.markerSvg_;
        }
        applyColour_(e) {
          super.applyColour_(e);
          let t;
          (t = this.markerCircle) == null || t.setAttribute("fill", this.colour_);
          let n;
          if ((n = this.markerCircle) == null || n.setAttribute("stroke", this.colour_), this.isCursor()) {
            e = this.colour_ + ";transparent;transparent;";
            let s;
            (s = this.markerCircle) == null || s.firstElementChild.setAttribute("values", e);
          }
        }
      }, wu = class {
        constructor(e, t, n) {
          this.markerSvg = this.cursorSvg = null, this.constants = n, this.style = t, this.svgRoot = e, this.svgPath = K(G.PATH, { class: "blocklyPath" }, this.svgRoot);
        }
        setPath(e) {
          this.svgPath.setAttribute("d", e);
        }
        flipRTL() {
          this.svgPath.setAttribute("transform", "scale(-1 1)");
        }
        setCursorSvg(e) {
          e ? (this.svgRoot.appendChild(e), this.cursorSvg = e) : this.cursorSvg = null;
        }
        setMarkerSvg(e) {
          e ? (this.cursorSvg ? this.svgRoot.insertBefore(e, this.cursorSvg) : this.svgRoot.appendChild(e), this.markerSvg = e) : this.markerSvg = null;
        }
        applyColour(e) {
          this.svgPath.setAttribute("stroke", this.style.colourTertiary), this.svgPath.setAttribute("fill", this.style.colourPrimary), this.updateShadow_(e.isShadow()), this.updateDisabled_(!e.isEnabled() || e.getInheritedDisabled());
        }
        setStyle(e) {
          this.style = e;
        }
        setClass_(e, t) {
          e && (t ? Re(this.svgRoot, e) : Ue(
            this.svgRoot,
            e
          ));
        }
        updateHighlighted(e) {
          e ? this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")") : this.svgPath.setAttribute("filter", "none");
        }
        updateShadow_(e) {
          e && (this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary));
        }
        updateDisabled_(e) {
          this.setClass_("blocklyDisabled", e), e && this.svgPath.setAttribute("fill", "url(#" + this.constants.disabledPatternId + ")");
        }
        updateSelected(e) {
          this.setClass_("blocklySelected", e);
        }
        updateDraggingDelete(e) {
          this.setClass_(
            "blocklyDraggingDelete",
            e
          );
        }
        updateInsertionMarker(e) {
          this.setClass_("blocklyInsertionMarker", e);
        }
        updateMovable(e) {
          this.setClass_("blocklyDraggable", e);
        }
        updateReplacementFade(e) {
          this.setClass_("blocklyReplaceable", e);
        }
        updateShapeForInputHighlight(e, t) {
        }
      }, DA = class extends wu {
        constructor(e, t, n) {
          super(e, t, n), this.svgPathSelected = null, this.outlines = /* @__PURE__ */ new Map(), this.remainingOutlines = /* @__PURE__ */ new Set(), this.outputShapeType = null, this.constants = n;
        }
        setPath(e) {
          super.setPath(e), this.svgPathSelected && this.svgPathSelected.setAttribute("d", e);
        }
        applyColour(e) {
          super.applyColour(e);
          const t = e.getParent();
          e.isShadow() && t && this.svgPath.setAttribute("stroke", t.style.colourTertiary);
          for (const n of this.outlines.values())
            n.setAttribute("fill", this.style.colourTertiary);
        }
        flipRTL() {
          super.flipRTL();
          for (const e of this.outlines.values())
            e.setAttribute("transform", "scale(-1 1)");
        }
        updateSelected(e) {
          this.setClass_("blocklySelected", e), e ? this.svgPathSelected || (this.svgPathSelected = this.svgPath.cloneNode(!0), this.svgPathSelected.setAttribute("fill", "none"), this.svgPathSelected.setAttribute("filter", "url(#" + this.constants.selectedGlowFilterId + ")"), this.svgRoot.appendChild(this.svgPathSelected)) : this.svgPathSelected && (this.svgRoot.removeChild(this.svgPathSelected), this.svgPathSelected = null);
        }
        updateReplacementFade(e) {
          this.setClass_("blocklyReplaceable", e), e ? this.svgPath.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : this.svgPath.removeAttribute("filter");
        }
        updateShapeForInputHighlight(e, t) {
          e = e.getParentInput().name, (e = this.getOutlinePath(e)) && (t ? e.setAttribute("filter", "url(#" + this.constants.replacementGlowFilterId + ")") : e.removeAttribute("filter"));
        }
        beginDrawing() {
          this.remainingOutlines.clear();
          for (const e of this.outlines.keys())
            this.remainingOutlines.add(e);
        }
        endDrawing() {
          if (this.remainingOutlines.size)
            for (const e of this.remainingOutlines)
              this.removeOutlinePath(e);
          this.remainingOutlines.clear();
        }
        setOutlinePath(e, t) {
          e = this.getOutlinePath(e), e.setAttribute("d", t), e.setAttribute("fill", this.style.colourTertiary);
        }
        getOutlinePath(e) {
          return this.outlines.has(e) || this.outlines.set(e, K(G.PATH, {
            class: "blocklyOutlinePath",
            d: ""
          }, this.svgRoot)), this.remainingOutlines.delete(e), this.outlines.get(e);
        }
        removeOutlinePath(e) {
          let t, n;
          (t = this.outlines.get(e)) == null || (n = t.parentNode) == null || n.removeChild(this.outlines.get(e)), this.outlines.delete(e);
        }
      }, V_ = class {
        constructor(e) {
          this.overrides = null, this.name = e;
        }
        getClassName() {
          return this.name + "-renderer";
        }
        init(e, t) {
          this.constants_ = this.makeConstants_(), t && (this.overrides = t, Object.assign(this.constants_, t)), this.constants_.setTheme(e), this.constants_.init();
        }
        createDom(e, t) {
          this.constants_.createDom(e, this.name + "-" + t.name, "." + this.getClassName() + "." + t.getClassName());
        }
        refreshDom(e, t) {
          const n = this.getConstants();
          n.dispose(), this.constants_ = this.makeConstants_(), this.overrides && Object.assign(this.constants_, this.overrides), this.constants_.randomIdentifier = n.randomIdentifier, this.constants_.setTheme(t), this.constants_.init(), this.createDom(e, t);
        }
        dispose() {
          this.constants_ && this.constants_.dispose();
        }
        makeConstants_() {
          return new Il();
        }
        makeRenderInfo_(e) {
          return new ya(this, e);
        }
        makeDrawer_(e, t) {
          return new W_(
            e,
            t
          );
        }
        makeMarkerDrawer(e, t) {
          return new gl(e, this.getConstants(), t);
        }
        makePathObject(e, t) {
          return new wu(e, t, this.constants_);
        }
        getConstants() {
          return this.constants_;
        }
        shouldHighlightConnection(e) {
          return !0;
        }
        orphanCanConnectAtEnd(e, t, n) {
          return !!ut.getConnectionForOrphanedConnection(e, n === me.OUTPUT_VALUE ? t.outputConnection : t.previousConnection);
        }
        getConnectionPreviewMethod(e, t, n) {
          return t.type === me.OUTPUT_VALUE || t.type === me.PREVIOUS_STATEMENT ? !e.isConnected() || this.orphanCanConnectAtEnd(n, e.targetBlock(), t.type) ? $e.PREVIEW_TYPE.INSERTION_MARKER : $e.PREVIEW_TYPE.REPLACEMENT_FADE : $e.PREVIEW_TYPE.INSERTION_MARKER;
        }
        render(e) {
          const t = this.makeRenderInfo_(e);
          t.measure(), this.makeDrawer_(e, t).draw();
        }
      }, ht = {};
      ht.BottomRow = Ad, ht.Connection = Ms, ht.ConstantProvider = Il, ht.Drawer = W_, ht.ExternalValueInput = La, ht.Field = Na, ht.Hat = F_, ht.Icon = NA, ht.InRowSpacer = Bn, ht.InlineInput = Sd, ht.InputConnection = Ml, ht.InputRow = xr, ht.JaggedEdge = yA, ht.MarkerSvg = gl, ht.Measurable = Qi, ht.NextConnection = fA, ht.OutputConnection = CA, ht.PathObject = wu, ht.PreviousConnection = hd, ht.RenderInfo = ya, ht.Renderer = V_, ht.RoundCorner = B_, ht.Row = w_, ht.SpacerRow = md, ht.SquareCorner = U_, ht.StatementInput = ar, ht.TopRow = Wu, ht.Types = F, ht.init = ip, ht.register = Jn, ht.unregister = PE;
      var gd = class extends V_ {
        constructor(e) {
          super(e);
        }
        makeConstants_() {
          return new gA();
        }
        makeRenderInfo_(e) {
          return new RA(this, e);
        }
        makeDrawer_(e, t) {
          return new LA(e, t);
        }
        makeMarkerDrawer(e, t) {
          return new OA(
            e,
            this.getConstants(),
            t
          );
        }
        makePathObject(e, t) {
          return new DA(e, t, this.getConstants());
        }
        getConstants() {
          return this.constants_;
        }
        shouldHighlightConnection(e) {
          return e.type !== me.INPUT_VALUE && e.type !== me.OUTPUT_VALUE;
        }
        getConnectionPreviewMethod(e, t, n) {
          return t.type === me.OUTPUT_VALUE ? e.isConnected() ? $e.PREVIEW_TYPE.REPLACEMENT_FADE : $e.PREVIEW_TYPE.INPUT_OUTLINE : super.getConnectionPreviewMethod(e, t, n);
        }
      };
      Jn("zelos", gd);
      var ii = {};
      ii.BottomRow = vA, ii.ConstantProvider = gA, ii.Drawer = LA, ii.MarkerSvg = OA, ii.PathObject = DA, ii.RenderInfo = RA, ii.Renderer = gd, ii.RightConnectionShape = Id, ii.StatementInput = ku, ii.TopRow = Md, En();
      var nn = {};
      nn.registerCleanup = lp, nn.registerCollapse = ap, nn.registerCollapseExpandBlock = Fc, nn.registerComment = zs, nn.registerDefaultOptions = En, nn.registerDelete = Ai, nn.registerDeleteAll = cp, nn.registerDisable = Tp, nn.registerDuplicate = Ql, nn.registerExpand = _p, nn.registerHelp = s_, nn.registerInline = up, nn.registerRedo = op, nn.registerUndo = bn;
      var bA = class {
        constructor() {
        }
        onDragEnter(e) {
        }
        onDragOver(e) {
        }
        onDragExit(e) {
        }
        onDrop(e) {
        }
        getClientRect() {
          return null;
        }
        shouldPreventMove(e) {
          return !1;
        }
      }, Fu = class extends bA {
        constructor() {
          super(), this.wouldDelete_ = !1;
        }
        wouldDelete(e, t) {
          return e instanceof Fn ? (e = !e.getParent() && e.isDeletable(), this.updateWouldDelete_(e && !t)) : this.updateWouldDelete_(e.isDeletable()), this.wouldDelete_;
        }
        updateWouldDelete_(e) {
          this.wouldDelete_ = e;
        }
      }, tt = class extends k_ {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.clockwise = tt.CLOCKWISE, this.offset = tt.OFFSET, this.wrap = tt.WRAP, this.round = tt.ROUND, this.boundEvents = [], this.symbol_ = this.gauge = this.line = null, e !== lt.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          switch (super.configure_(e), e.mode) {
            case Bu.COMPASS:
              this.clockwise = !0, this.offset = 90;
              break;
            case Bu.PROTRACTOR:
              this.clockwise = !1, this.offset = 0;
          }
          e.clockwise && (this.clockwise = e.clockwise), e.offset && (this.offset = e.offset), e.wrap && (this.wrap = e.wrap), e.round && (this.round = e.round);
        }
        initView() {
          super.initView(), this.symbol_ = K(G.TSPAN, {}), this.symbol_.appendChild(document.createTextNode("°")), this.getTextElement().appendChild(this.symbol_);
        }
        render_() {
          super.render_(), this.updateGraph();
        }
        showEditor_(e) {
          super.showEditor_(e, M_ || nu || la), e = this.dropdownCreate(), Fl().appendChild(e), this.sourceBlock_ instanceof Fn && xa(this.sourceBlock_.style.colourPrimary, this.sourceBlock_.style.colourTertiary), Fs(this, this.dropdownDispose.bind(this)), this.updateGraph();
        }
        dropdownCreate() {
          const e = K(G.SVG, {
            xmlns: A_,
            "xmlns:html": fo,
            "xmlns:xlink": kn,
            version: "1.1",
            height: 2 * tt.HALF + "px",
            width: 2 * tt.HALF + "px",
            style: "touch-action: none"
          }), t = K(
            G.CIRCLE,
            { cx: tt.HALF, cy: tt.HALF, r: tt.RADIUS, class: "blocklyAngleCircle" },
            e
          );
          this.gauge = K(G.PATH, { class: "blocklyAngleGauge" }, e), this.line = K(G.LINE, { x1: tt.HALF, y1: tt.HALF, class: "blocklyAngleLine" }, e);
          for (let n = 0; 360 > n; n += 15)
            K(G.LINE, { x1: tt.HALF + tt.RADIUS, y1: tt.HALF, x2: tt.HALF + tt.RADIUS - (n % 45 === 0 ? 10 : 5), y2: tt.HALF, class: "blocklyAngleMarks", transform: "rotate(" + n + "," + tt.HALF + "," + tt.HALF + ")" }, e);
          return this.boundEvents.push(ge(
            e,
            "click",
            this,
            this.hide
          )), this.boundEvents.push(ge(t, "pointerdown", this, this.onMouseMove_, !0)), this.boundEvents.push(ge(t, "pointermove", this, this.onMouseMove_, !0)), e;
        }
        dropdownDispose() {
          for (const e of this.boundEvents)
            Mt(e);
          this.boundEvents.length = 0, this.line = this.gauge = null;
        }
        hide() {
          Rn(this), j();
        }
        onMouseMove_(e) {
          var t = this.gauge.ownerSVGElement.getBoundingClientRect();
          const n = e.clientX - t.left - tt.HALF;
          e = e.clientY - t.top - tt.HALF, t = Math.atan(-e / n), isNaN(t) || (t = Ao(t), 0 > n ? t += 180 : 0 < e && (t += 360), t = this.clockwise ? this.offset + 360 - t : 360 - (this.offset - t), this.displayMouseOrKeyboardValue(t));
        }
        displayMouseOrKeyboardValue(e) {
          if (this.round && (e = Math.round(e / this.round) * this.round), e = this.wrapValue(e), e !== this.value_) {
            const t = this.value_;
            this.setEditorValue_(e, !1), this.sourceBlock_ && nt() && this.value_ !== t && Ce(new (fe(No))(this.sourceBlock_, this.name || null, t, this.value_));
          }
        }
        updateGraph() {
          if (this.gauge && this.line) {
            var e = Number(this.getText()) + this.offset, t = jo(e % 360);
            e = [
              "M ",
              tt.HALF,
              ",",
              tt.HALF
            ];
            var n = tt.HALF, s = tt.HALF;
            if (!isNaN(t)) {
              const u = Number(this.clockwise), A = jo(this.offset), L = Math.cos(A) * tt.RADIUS, $ = Math.sin(A) * -tt.RADIUS;
              u && (t = 2 * A - t), n += Math.cos(t) * tt.RADIUS, s -= Math.sin(t) * tt.RADIUS, t = Math.abs(Math.floor((t - A) / Math.PI) % 2), u && (t = 1 - t), e.push(" l ", L, ",", $, " A ", tt.RADIUS, ",", tt.RADIUS, " 0 ", t, " ", u, " ", n, ",", s, " z");
            }
            this.gauge.setAttribute("d", e.join("")), this.line.setAttribute("x2", `${n}`), this.line.setAttribute("y2", `${s}`);
          }
        }
        onHtmlInputKeyDown_(e) {
          super.onHtmlInputKeyDown_(e);
          var t = this.getSourceBlock();
          if (!t)
            throw new lr();
          let n = 0;
          switch (e.key) {
            case "ArrowLeft":
              n = t.RTL ? 1 : -1;
              break;
            case "ArrowRight":
              n = t.RTL ? -1 : 1;
              break;
            case "ArrowDown":
              n = -1;
              break;
            case "ArrowUp":
              n = 1;
          }
          n && (t = this.getValue(), this.displayMouseOrKeyboardValue(t + n * this.round), e.preventDefault(), e.stopPropagation());
        }
        doClassValidation_(e) {
          return e = Number(e), isNaN(e) || !isFinite(e) ? null : this.wrapValue(e);
        }
        wrapValue(e) {
          return e %= 360, 0 > e && (e += 360), e > this.wrap && (e -= 360), e;
        }
        static fromJson(e) {
          return new this(e.angle, void 0, e);
        }
      };
      tt.HALF = 50, tt.RADIUS = tt.HALF - 1, tt.CLOCKWISE = !1, tt.OFFSET = 0, tt.WRAP = 360, tt.ROUND = 15, Vr("field_angle", tt), tt.prototype.DEFAULT_VALUE = 0, Kn(`
.blocklyAngleCircle {
  stroke: #444;
  stroke-width: 1;
  fill: #ddd;
  fill-opacity: 0.8;
}

.blocklyAngleMarks {
  stroke: #444;
  stroke-width: 1;
}

.blocklyAngleGauge {
  fill: #f88;
  fill-opacity: 0.8;
  pointer-events: none;
}

.blocklyAngleLine {
  stroke: #f00;
  stroke-width: 2;
  stroke-linecap: round;
  pointer-events: none;
}
`);
      var Bu;
      (function(e) {
        e.COMPASS = "compass", e.PROTRACTOR = "protractor";
      })(Bu || (Bu = {}));
      var Ls = class extends lt {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.SERIALIZABLE = !0, this.CURSOR = "default", this.value_ = this.value_, this.checkChar = Ls.CHECK_CHAR, e !== lt.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.checkCharacter && (this.checkChar = e.checkCharacter);
        }
        saveState() {
          const e = this.saveLegacyState(Ls);
          return e !== null ? e : this.getValueBoolean();
        }
        initView() {
          super.initView();
          const e = this.getTextElement();
          Re(e, "blocklyCheckbox"), e.style.display = this.value_ ? "block" : "none";
        }
        render_() {
          this.textContent_ && (this.textContent_.nodeValue = this.getDisplayText_()), this.updateSize_(this.getConstants().FIELD_CHECKBOX_X_OFFSET);
        }
        getDisplayText_() {
          return this.checkChar;
        }
        setCheckCharacter(e) {
          this.checkChar = e || Ls.CHECK_CHAR, this.forceRerender();
        }
        showEditor_() {
          this.setValue(!this.value_);
        }
        doClassValidation_(e) {
          return e === !0 || e === "TRUE" ? "TRUE" : e === !1 || e === "FALSE" ? "FALSE" : null;
        }
        doValueUpdate_(e) {
          this.value_ = this.convertValueToBool_(e), this.textElement_ && (this.textElement_.style.display = this.value_ ? "block" : "none");
        }
        getValue() {
          return this.value_ ? "TRUE" : "FALSE";
        }
        getValueBoolean() {
          return this.value_;
        }
        getText() {
          return String(this.convertValueToBool_(this.value_));
        }
        convertValueToBool_(e) {
          return typeof e == "string" ? e === "TRUE" : !!e;
        }
        static fromJson(e) {
          return new this(e.checked, void 0, e);
        }
      };
      Ls.CHECK_CHAR = "✓", Vr("field_checkbox", Ls), Ls.prototype.DEFAULT_VALUE = !1;
      var Un = class extends lt {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.highlightedIndex = this.picker = null, this.boundEvents = [], this.SERIALIZABLE = !0, this.CURSOR = "default", this.isDirty_ = !1, this.titles = this.colours = null, this.columns = 0, e !== lt.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.colourOptions && (this.colours = e.colourOptions), e.colourTitles && (this.titles = e.colourTitles), e.columns && (this.columns = e.columns);
        }
        initView() {
          this.size_ = new It(this.getConstants().FIELD_COLOUR_DEFAULT_WIDTH, this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT), this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.sourceBlock_ instanceof Fn && (this.clickTarget_ = this.sourceBlock_.getSvgRoot()) : (this.createBorderRect_(), this.getBorderRect().style.fillOpacity = "1");
        }
        applyColour() {
          this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.sourceBlock_ instanceof Fn && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", this.getValue()), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff")) : this.borderRect_ && (this.borderRect_.style.fill = this.getValue());
        }
        doClassValidation_(e) {
          return typeof e != "string" ? null : pi(e);
        }
        doValueUpdate_(e) {
          this.value_ = e, this.borderRect_ ? this.borderRect_.style.fill = e : this.sourceBlock_ && this.sourceBlock_.rendered && this.sourceBlock_ instanceof Fn && (this.sourceBlock_.pathObject.svgPath.setAttribute("fill", e), this.sourceBlock_.pathObject.svgPath.setAttribute("stroke", "#fff"));
        }
        getText() {
          let e = this.value_;
          return /^#(.)\1(.)\2(.)\3$/.test(e) && (e = "#" + e[1] + e[3] + e[5]), e;
        }
        setColours(e, t) {
          return this.colours = e, t && (this.titles = t), this;
        }
        setColumns(e) {
          return this.columns = e, this;
        }
        showEditor_() {
          this.dropdownCreate(), Fl().appendChild(this.picker), Fs(this, this.dropdownDispose.bind(this)), this.picker.focus({ preventScroll: !0 });
        }
        onClick(e) {
          e = (e = e.target) && e.getAttribute("data-colour"), e !== null && (this.setValue(e), Rn(this));
        }
        onKeyDown(e) {
          let t = !0;
          var n;
          switch (e.key) {
            case "ArrowUp":
              this.moveHighlightBy(0, -1);
              break;
            case "ArrowDown":
              this.moveHighlightBy(0, 1);
              break;
            case "ArrowLeft":
              this.moveHighlightBy(-1, 0);
              break;
            case "ArrowRight":
              this.moveHighlightBy(
                1,
                0
              );
              break;
            case "Enter":
              (n = this.getHighlighted()) && (n = n.getAttribute("data-colour"), n !== null && this.setValue(n)), Ti();
              break;
            default:
              t = !1;
          }
          t && e.stopPropagation();
        }
        moveHighlightBy(e, t) {
          if (this.highlightedIndex) {
            var n = this.colours || Un.COLOURS, s = this.columns || Un.COLUMNS, u = this.highlightedIndex % s, A = Math.floor(this.highlightedIndex / s);
            u += e, A += t, 0 > e ? 0 > u && 0 < A ? (u = s - 1, A--) : 0 > u && (u = 0) : 0 < e ? u > s - 1 && A < Math.floor(n.length / s) - 1 ? (u = 0, A++) : u > s - 1 && u-- : 0 > t ? 0 > A && (A = 0) : 0 < t && A > Math.floor(n.length / s) - 1 && (A = Math.floor(n.length / s) - 1), this.setHighlightedCell(this.picker.childNodes[A].childNodes[u], A * s + u);
          }
        }
        onMouseMove(e) {
          const t = (e = e.target) && Number(e.getAttribute("data-index"));
          t !== null && t !== this.highlightedIndex && this.setHighlightedCell(e, t);
        }
        onMouseEnter() {
          let e;
          (e = this.picker) == null || e.focus({ preventScroll: !0 });
        }
        onMouseLeave() {
          var e;
          (e = this.picker) == null || e.blur(), (e = this.getHighlighted()) && Ue(e, "blocklyColourHighlighted");
        }
        getHighlighted() {
          if (!this.highlightedIndex)
            return null;
          const e = this.columns || Un.COLUMNS, t = this.picker.childNodes[Math.floor(this.highlightedIndex / e)];
          return t ? t.childNodes[this.highlightedIndex % e] : null;
        }
        setHighlightedCell(e, t) {
          const n = this.getHighlighted();
          n && Ue(n, "blocklyColourHighlighted"), Re(e, "blocklyColourHighlighted"), this.highlightedIndex = t, (e = e.getAttribute("id")) && this.picker && gt(this.picker, Dt.ACTIVEDESCENDANT, e);
        }
        dropdownCreate() {
          const e = this.columns || Un.COLUMNS, t = this.colours || Un.COLOURS, n = this.titles || Un.TITLES, s = this.getValue(), u = document.createElement("table");
          u.className = "blocklyColourTable", u.tabIndex = 0, u.dir = "ltr", Tn(u, Ln.GRID), gt(u, Dt.EXPANDED, !0), gt(u, Dt.ROWCOUNT, Math.floor(t.length / e)), gt(u, Dt.COLCOUNT, e);
          let A;
          for (let L = 0; L < t.length; L++) {
            L % e === 0 && (A = document.createElement("tr"), Tn(
              A,
              Ln.ROW
            ), u.appendChild(A));
            const $ = document.createElement("td");
            A.appendChild($), $.setAttribute("data-colour", t[L]), $.title = n[L] || t[L], $.id = si(), $.setAttribute("data-index", `${L}`), Tn($, Ln.GRIDCELL), gt($, Dt.LABEL, t[L]), gt(
              $,
              Dt.SELECTED,
              t[L] === s
            ), $.style.backgroundColor = t[L], t[L] === s && ($.className = "blocklyColourSelected", this.highlightedIndex = L);
          }
          this.boundEvents.push(ge(u, "pointerdown", this, this.onClick, !0)), this.boundEvents.push(ge(u, "pointermove", this, this.onMouseMove, !0)), this.boundEvents.push(ge(
            u,
            "pointerenter",
            this,
            this.onMouseEnter,
            !0
          )), this.boundEvents.push(ge(u, "pointerleave", this, this.onMouseLeave, !0)), this.boundEvents.push(ge(u, "keydown", this, this.onKeyDown, !1)), this.picker = u;
        }
        dropdownDispose() {
          for (const e of this.boundEvents)
            Mt(e);
          this.boundEvents.length = 0, this.highlightedIndex = this.picker = null;
        }
        static fromJson(e) {
          return new this(e.colour, void 0, e);
        }
      };
      Un.COLOURS = "#ffffff #cccccc #c0c0c0 #999999 #666666 #333333 #000000 #ffcccc #ff6666 #ff0000 #cc0000 #990000 #660000 #330000 #ffcc99 #ff9966 #ff9900 #ff6600 #cc6600 #993300 #663300 #ffff99 #ffff66 #ffcc66 #ffcc33 #cc9933 #996633 #663333 #ffffcc #ffff33 #ffff00 #ffcc00 #999900 #666600 #333300 #99ff99 #66ff99 #33ff33 #33cc00 #009900 #006600 #003300 #99ffff #33ffff #66cccc #00cccc #339999 #336666 #003333 #ccffff #66ffff #33ccff #3366ff #3333ff #000099 #000066 #ccccff #9999ff #6666cc #6633ff #6600cc #333399 #330099 #ffccff #ff99ff #cc66cc #cc33cc #993399 #663366 #330033".split(" "), Un.TITLES = [], Un.COLUMNS = 7, Un.prototype.DEFAULT_VALUE = Un.COLOURS[0], Vr("field_colour", Un), Kn(`
.blocklyColourTable {
  border-collapse: collapse;
  display: block;
  outline: none;
  padding: 1px;
}

.blocklyColourTable>tr>td {
  border: 0.5px solid #888;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  padding: 0;
  width: 20px;
}

.blocklyColourTable>tr>td.blocklyColourHighlighted {
  border-color: #eee;
  box-shadow: 2px 2px 7px 2px rgba(0, 0, 0, 0.3);
  position: relative;
}

.blocklyColourSelected, .blocklyColourSelected:hover {
  border-color: #eee !important;
  outline: 1px solid #333;
  position: relative;
}
`);
      var PA = class extends Ji {
        constructor(e, t, n) {
          super(String(e ?? ""), t, n), this.EDITABLE = !1, this.SERIALIZABLE = !0;
        }
        static fromJson(e) {
          return new this(Jt(e.text), void 0, e);
        }
      };
      Vr("field_label_serializable", PA);
      var Ld = class extends ga {
        constructor(e, t, n) {
          super(lt.SKIP_SETUP), this.textGroup = null, this.maxLines_ = 1 / 0, this.isOverflowedY_ = !1, e !== lt.SKIP_SETUP && (n && this.configure_(n), this.setValue(e), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), e.maxLines && this.setMaxLines(e.maxLines);
        }
        toXml(e) {
          return e.textContent = this.getValue().replace(
            /\n/g,
            "&#10;"
          ), e;
        }
        fromXml(e) {
          this.setValue(e.textContent.replace(/&#10;/g, `
`));
        }
        saveState() {
          const e = this.saveLegacyState(Ld);
          return e !== null ? e : this.getValue();
        }
        loadState(e) {
          this.loadLegacyState(lt, e) || this.setValue(e);
        }
        initView() {
          this.createBorderRect_(), this.textGroup = K(G.G, { class: "blocklyEditableText" }, this.fieldGroup_);
        }
        getDisplayText_() {
          const e = this.getSourceBlock();
          if (!e)
            throw new lr();
          let t = this.getText();
          if (!t)
            return lt.NBSP;
          const n = t.split(`
`);
          t = "";
          const s = this.isOverflowedY_ ? this.maxLines_ : n.length;
          for (let u = 0; u < s; u++) {
            let A = n[u];
            A.length > this.maxDisplayLength ? A = A.substring(0, this.maxDisplayLength - 4) + "..." : this.isOverflowedY_ && u === s - 1 && (A = A.substring(0, A.length - 3) + "..."), A = A.replace(/\s/g, lt.NBSP), t += A, u !== s - 1 && (t += `
`);
          }
          return e.RTL && (t += "‏"), t;
        }
        doValueUpdate_(e) {
          super.doValueUpdate_(e), this.value_ !== null && (this.isOverflowedY_ = this.value_.split(`
`).length > this.maxLines_);
        }
        render_() {
          var e = this.getSourceBlock();
          if (!e)
            throw new lr();
          for (var t, n = this.textGroup; t = n.firstChild; )
            n.removeChild(t);
          t = this.getDisplayText_().split(`
`);
          let s = 0;
          for (let u = 0; u < t.length; u++) {
            const A = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING;
            K(
              G.TEXT,
              { class: "blocklyText blocklyMultilineText", x: this.getConstants().FIELD_BORDER_RECT_X_PADDING, y: s + this.getConstants().FIELD_BORDER_RECT_Y_PADDING, dy: this.getConstants().FIELD_TEXT_BASELINE },
              n
            ).appendChild(document.createTextNode(t[u])), s += A;
          }
          this.isBeingEdited_ && (n = this.htmlInput_, this.isOverflowedY_ ? Re(n, "blocklyHtmlTextAreaInputOverflowedY") : Ue(n, "blocklyHtmlTextAreaInputOverflowedY")), this.updateSize_(), this.isBeingEdited_ && (e.RTL ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_(), e = this.htmlInput_, this.isTextValid_ ? (Ue(e, "blocklyInvalidInput"), gt(e, Dt.INVALID, !1)) : (Re(e, "blocklyInvalidInput"), gt(e, Dt.INVALID, !0)));
        }
        updateSize_() {
          var e = this.textGroup.childNodes;
          const t = this.getConstants().FIELD_TEXT_FONTSIZE, n = this.getConstants().FIELD_TEXT_FONTWEIGHT, s = this.getConstants().FIELD_TEXT_FONTFAMILY;
          let u = 0, A = 0;
          for (var L = 0; L < e.length; L++) {
            var $ = Kr(e[L], t, n, s);
            $ > u && (u = $), A += this.getConstants().FIELD_TEXT_HEIGHT + (0 < L ? this.getConstants().FIELD_BORDER_RECT_Y_PADDING : 0);
          }
          if (this.isBeingEdited_) {
            for (e = String(this.value_).split(`
`), L = K(G.TEXT, { class: "blocklyText blocklyMultilineText" }), $ = 0; $ < e.length; $++) {
              e[$].length > this.maxDisplayLength && (e[$] = e[$].substring(0, this.maxDisplayLength)), L.textContent = e[$];
              const q = Kr(L, t, n, s);
              q > u && (u = q);
            }
            u += this.htmlInput_.offsetWidth - this.htmlInput_.clientWidth;
          }
          this.borderRect_ && (A += 2 * this.getConstants().FIELD_BORDER_RECT_Y_PADDING, u += 2 * this.getConstants().FIELD_BORDER_RECT_X_PADDING, this.borderRect_.setAttribute("width", `${u}`), this.borderRect_.setAttribute("height", `${A}`)), this.size_.width = u, this.size_.height = A, this.positionBorderRect_();
        }
        showEditor_(e, t) {
          super.showEditor_(e, t), this.forceRerender();
        }
        widgetCreate_() {
          const e = Gl(), t = this.workspace_.getScale(), n = document.createElement("textarea");
          n.className = "blocklyHtmlInput blocklyHtmlTextAreaInput", n.setAttribute("spellcheck", String(this.spellcheck_));
          var s = this.getConstants().FIELD_TEXT_FONTSIZE * t + "pt";
          e.style.fontSize = s, n.style.fontSize = s, n.style.borderRadius = ga.BORDERRADIUS * t + "px", s = this.getConstants().FIELD_BORDER_RECT_X_PADDING * t;
          const u = this.getConstants().FIELD_BORDER_RECT_Y_PADDING * t / 2;
          return n.style.padding = u + "px " + s + "px " + u + "px " + s + "px", s = this.getConstants().FIELD_TEXT_HEIGHT + this.getConstants().FIELD_BORDER_RECT_Y_PADDING, n.style.lineHeight = s * t + "px", e.appendChild(n), n.value = n.defaultValue = this.getEditorText_(this.value_), n.setAttribute("data-untyped-default-value", String(this.value_)), n.setAttribute("data-old-value", ""), $p ? setTimeout(this.resizeEditor_.bind(this), 0) : this.resizeEditor_(), this.bindInputEvents_(n), n;
        }
        setMaxLines(e) {
          typeof e == "number" && 0 < e && e !== this.maxLines_ && (this.maxLines_ = e, this.forceRerender());
        }
        getMaxLines() {
          return this.maxLines_;
        }
        onHtmlInputKeyDown_(e) {
          e.key !== "Enter" && super.onHtmlInputKeyDown_(e);
        }
        static fromJson(e) {
          return new this(Jt(e.text), void 0, e);
        }
      };
      Vr("field_multilinetext", Ld), Kn(`
.blocklyHtmlTextAreaInput {
  font-family: monospace;
  resize: none;
  overflow: hidden;
  height: 100%;
  text-align: left;
}

.blocklyHtmlTextAreaInputOverflowedY {
  overflow-y: scroll;
}
`);
      var Nd = class extends k_ {
        constructor(e, t, n, s, u, A) {
          super(lt.SKIP_SETUP), this.min_ = -1 / 0, this.max_ = 1 / 0, this.precision_ = 0, this.decimalPlaces = null, this.spellcheck_ = !1, e !== lt.SKIP_SETUP && (A ? this.configure_(A) : this.setConstraints(t, n, s), this.setValue(e), u && this.setValidator(u));
        }
        configure_(e) {
          super.configure_(e), this.setMinInternal(e.min), this.setMaxInternal(e.max), this.setPrecisionInternal(e.precision);
        }
        setConstraints(e, t, n) {
          this.setMinInternal(e), this.setMaxInternal(t), this.setPrecisionInternal(n), this.setValue(this.getValue());
        }
        setMin(e) {
          this.setMinInternal(e), this.setValue(this.getValue());
        }
        setMinInternal(e) {
          e == null ? this.min_ = -1 / 0 : (e = Number(e), isNaN(e) || (this.min_ = e));
        }
        getMin() {
          return this.min_;
        }
        setMax(e) {
          this.setMaxInternal(e), this.setValue(this.getValue());
        }
        setMaxInternal(e) {
          e == null ? this.max_ = 1 / 0 : (e = Number(e), isNaN(e) || (this.max_ = e));
        }
        getMax() {
          return this.max_;
        }
        setPrecision(e) {
          this.setPrecisionInternal(e), this.setValue(this.getValue());
        }
        setPrecisionInternal(e) {
          this.precision_ = Number(e) || 0;
          let t = String(this.precision_);
          t.indexOf("e") !== -1 && (t = this.precision_.toLocaleString("en-US", { maximumFractionDigits: 20 }));
          const n = t.indexOf(".");
          this.decimalPlaces = n === -1 ? e ? 0 : null : t.length - n - 1;
        }
        getPrecision() {
          return this.precision_;
        }
        doClassValidation_(e) {
          return e === null || (e = `${e}`.replace(/O/gi, "0"), e = e.replace(/,/g, ""), e = e.replace(/infinity/i, "Infinity"), e = Number(e || 0), isNaN(e)) ? null : (e = Math.min(Math.max(
            e,
            this.min_
          ), this.max_), this.precision_ && isFinite(e) && (e = Math.round(e / this.precision_) * this.precision_), this.decimalPlaces !== null && (e = Number(e.toFixed(this.decimalPlaces))), e);
        }
        widgetCreate_() {
          const e = super.widgetCreate_();
          return -1 / 0 < this.min_ && (e.min = `${this.min_}`, gt(e, Dt.VALUEMIN, this.min_)), 1 / 0 > this.max_ && (e.max = `${this.max_}`, gt(
            e,
            Dt.VALUEMAX,
            this.max_
          )), e;
        }
        static fromJson(e) {
          return new this(e.value, void 0, void 0, void 0, void 0, e);
        }
      };
      Vr("field_number", Nd), Nd.prototype.DEFAULT_VALUE = 0;
      var G_ = class extends zi {
        constructor(e, t, n, s, u) {
          super(lt.SKIP_SETUP), this.defaultType = "", this.variableTypes = [], this.variable = null, this.SERIALIZABLE = !0, this.menuGenerator_ = G_.dropdownCreate, this.defaultVariableName = typeof e == "string" ? e : "", this.size_ = new It(0, 0), e !== lt.SKIP_SETUP && (u ? this.configure_(u) : this.setTypes(n, s), t && this.setValidator(t));
        }
        configure_(e) {
          super.configure_(e), this.setTypes(e.variableTypes, e.defaultType);
        }
        initModel() {
          var e = this.getSourceBlock();
          if (!e)
            throw new lr();
          this.variable || (e = r.getOrCreateVariablePackage$$module$build$src$core$variables(e.workspace, null, this.defaultVariableName, this.defaultType), this.doValueUpdate_(e.getId()));
        }
        shouldAddBorderRect_() {
          const e = this.getSourceBlock();
          if (!e)
            throw new lr();
          return super.shouldAddBorderRect_() && (!this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || e.type !== "variables_get");
        }
        fromXml(e) {
          var t = this.getSourceBlock();
          if (!t)
            throw new lr();
          const n = e.getAttribute("id"), s = e.textContent, u = e.getAttribute("variabletype") || e.getAttribute("variableType") || "";
          if (t = r.getOrCreateVariablePackage$$module$build$src$core$variables(t.workspace, n, s, u), u !== null && u !== t.type)
            throw Error("Serialized variable type with id '" + t.getId() + "' had type " + t.type + ", and does not match variable field that references it: " + Fi(e) + ".");
          this.setValue(t.getId());
        }
        toXml(e) {
          return this.initModel(), e.id = this.variable.getId(), e.textContent = this.variable.name, this.variable.type && e.setAttribute("variabletype", this.variable.type), e;
        }
        saveState(e) {
          var t = this.saveLegacyState(G_);
          return t !== null || (this.initModel(), t = { id: this.variable.getId() }, e && (t.name = this.variable.name, t.type = this.variable.type)), t;
        }
        loadState(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new lr();
          this.loadLegacyState(G_, e) || (e = r.getOrCreateVariablePackage$$module$build$src$core$variables(t.workspace, e.id || null, e.name, e.type || ""), this.setValue(e.getId()));
        }
        setSourceBlock(e) {
          if (e.isShadow())
            throw Error("Variable fields are not allowed to exist on shadow blocks.");
          super.setSourceBlock(e);
        }
        getValue() {
          return this.variable ? this.variable.getId() : null;
        }
        getText() {
          return this.variable ? this.variable.name : "";
        }
        getVariable() {
          return this.variable;
        }
        getValidator() {
          return this.variable ? this.validator_ : null;
        }
        doClassValidation_(e) {
          if (e === null)
            return null;
          var t = this.getSourceBlock();
          if (!t)
            throw new lr();
          return t = r.getVariable$$module$build$src$core$variables(t.workspace, e), t ? (t = t.type, this.typeIsAllowed(t) ? e : (console.warn("Variable type doesn't match this field!  Type was " + t), null)) : (console.warn("Variable id doesn't point to a real variable! ID was " + e), null);
        }
        doValueUpdate_(e) {
          const t = this.getSourceBlock();
          if (!t)
            throw new lr();
          this.variable = r.getVariable$$module$build$src$core$variables(t.workspace, e), super.doValueUpdate_(e);
        }
        typeIsAllowed(e) {
          const t = this.getVariableTypes();
          if (!t)
            return !0;
          for (let n = 0; n < t.length; n++)
            if (e === t[n])
              return !0;
          return !1;
        }
        getVariableTypes() {
          var e = this.variableTypes;
          if (e === null && this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying())
            return this.sourceBlock_.workspace.getVariableTypes();
          if (e = e || [""], e.length === 0)
            throw e = this.getText(), Error("'variableTypes' of field variable " + e + " was an empty list");
          return e;
        }
        setTypes(e = null, t = "") {
          if (Array.isArray(e)) {
            let n = !1;
            for (let s = 0; s < e.length; s++)
              e[s] === t && (n = !0);
            if (!n)
              throw Error("Invalid default type '" + t + "' in the definition of a FieldVariable");
          } else if (e !== null)
            throw Error("'variableTypes' was not an array in the definition of a FieldVariable");
          this.defaultType = t, this.variableTypes = e;
        }
        refreshVariableName() {
          this.forceRerender();
        }
        onItemSelected_(e, t) {
          if (e = t.getValue(), this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying()) {
            if (e === gi) {
              r.renameVariable$$module$build$src$core$variables(this.sourceBlock_.workspace, this.variable);
              return;
            }
            if (e === Ru) {
              this.sourceBlock_.workspace.deleteVariableById(this.variable.getId());
              return;
            }
          }
          this.setValue(e);
        }
        referencesVariables() {
          return !0;
        }
        static fromJson(e) {
          return new this(
            Jt(e.variable),
            void 0,
            void 0,
            void 0,
            e
          );
        }
        static dropdownCreate() {
          if (!this.variable)
            throw Error("Tried to call dropdownCreate on a variable field with no variable selected.");
          const e = this.getText();
          let t = [];
          if (this.sourceBlock_ && !this.sourceBlock_.isDeadOrDying())
            for (var n = this.getVariableTypes(), s = 0; s < n.length; s++) {
              const u = this.sourceBlock_.workspace.getVariablesOfType(n[s]);
              t = t.concat(u);
            }
          for (t.sort(ra.compareByName), n = [], s = 0; s < t.length; s++)
            n[s] = [t[s].name, t[s].getId()];
          return n.push([r.Msg$$module$build$src$core$msg.RENAME_VARIABLE, gi]), r.Msg$$module$build$src$core$msg.DELETE_VARIABLE && n.push([r.Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace("%1", e), Ru]), n;
        }
      };
      Vr("field_variable", G_);
      var yi = class {
        constructor(e, t, n, s) {
          this.workspace = e, this.targetWorkspace = t, this.isLabel_ = s, this.onMouseUpWrapper = null, this.height = this.width = 0, this.svgText = this.svgGroup = null, this.text = n.text, this.position = new Te(0, 0), this.callbackKey = n.callbackKey || n.callbackkey, this.cssClass = n["web-class"] || null, this.info = n;
        }
        createDom() {
          var e = this.isLabel_ ? "blocklyFlyoutLabel" : "blocklyFlyoutButton";
          this.cssClass && (e += " " + this.cssClass), this.svgGroup = K(G.G, { class: e }, this.workspace.getCanvas());
          let t;
          this.isLabel_ || (t = K(G.RECT, { class: "blocklyFlyoutButtonShadow", rx: yi.BORDER_RADIUS, ry: yi.BORDER_RADIUS, x: 1, y: 1 }, this.svgGroup)), e = K(
            G.RECT,
            { class: this.isLabel_ ? "blocklyFlyoutLabelBackground" : "blocklyFlyoutButtonBackground", rx: yi.BORDER_RADIUS, ry: yi.BORDER_RADIUS },
            this.svgGroup
          );
          const n = K(G.TEXT, { class: this.isLabel_ ? "blocklyFlyoutLabelText" : "blocklyText", x: 0, y: 0, "text-anchor": "middle" }, this.svgGroup);
          var s = Jt(this.text);
          this.workspace.RTL && (s += "‏"), n.textContent = s, this.isLabel_ && (this.svgText = n, this.workspace.getThemeManager().subscribe(this.svgText, "flyoutForegroundColour", "fill"));
          const u = wi(n, "fontSize"), A = wi(n, "fontWeight"), L = wi(n, "fontFamily");
          if (this.width = _i(n, u, A, L), s = Xn(
            s,
            u,
            A,
            L
          ), this.height = s.height, !this.isLabel_) {
            this.width += 2 * yi.TEXT_MARGIN_X, this.height += 2 * yi.TEXT_MARGIN_Y;
            let $;
            ($ = t) == null || $.setAttribute("width", String(this.width));
            let q;
            (q = t) == null || q.setAttribute("height", String(this.height));
          }
          return e.setAttribute("width", String(this.width)), e.setAttribute("height", String(this.height)), n.setAttribute("x", String(this.width / 2)), n.setAttribute("y", String(this.height / 2 - s.height / 2 + s.baseline)), this.updateTransform(), this.onMouseUpWrapper = ge(this.svgGroup, "pointerup", this, this.onMouseUp), this.svgGroup;
        }
        show() {
          this.updateTransform(), this.svgGroup.setAttribute("display", "block");
        }
        updateTransform() {
          this.svgGroup.setAttribute("transform", "translate(" + this.position.x + "," + this.position.y + ")");
        }
        moveTo(e, t) {
          this.position.x = e, this.position.y = t, this.updateTransform();
        }
        isLabel() {
          return this.isLabel_;
        }
        getPosition() {
          return this.position;
        }
        getButtonText() {
          return this.text;
        }
        getTargetWorkspace() {
          return this.targetWorkspace;
        }
        dispose() {
          this.onMouseUpWrapper && Mt(this.onMouseUpWrapper), this.svgGroup && _t(this.svgGroup), this.svgText && this.workspace.getThemeManager().unsubscribe(this.svgText);
        }
        onMouseUp(e) {
          (e = this.targetWorkspace.getGesture(e)) && e.cancel(), this.isLabel_ && this.callbackKey ? console.warn("Labels should not have callbacks. Label text: " + this.text) : this.isLabel_ || this.callbackKey && this.targetWorkspace.getButtonCallback(this.callbackKey) ? this.isLabel_ || (e = this.targetWorkspace.getButtonCallback(this.callbackKey)) && e(this) : console.warn("Buttons should have callbacks. Button text: " + this.text);
        }
      };
      yi.TEXT_MARGIN_X = 5, yi.TEXT_MARGIN_Y = 2, yi.BORDER_RADIUS = 4, Kn(`
.blocklyFlyoutButton {
  fill: #888;
  cursor: default;
}

.blocklyFlyoutButtonShadow {
  fill: #666;
}

.blocklyFlyoutButton:hover {
  fill: #aaa;
}

.blocklyFlyoutLabel {
  cursor: default;
}

.blocklyFlyoutLabelBackground {
  opacity: 0;
}
`);
      var yd = class {
        constructor(e) {
          this.workspace_ = e;
        }
        getDimensionsPx_(e) {
          let t = 0, n = 0;
          return e && (t = e.getWidth(), n = e.getHeight()), new It(t, n);
        }
        getFlyoutMetrics(e) {
          return e = this.getDimensionsPx_(this.workspace_.getFlyout(e)), { width: e.width, height: e.height, position: this.workspace_.toolboxPosition };
        }
        getToolboxMetrics() {
          const e = this.getDimensionsPx_(this.workspace_.getToolbox());
          return { width: e.width, height: e.height, position: this.workspace_.toolboxPosition };
        }
        getSvgMetrics() {
          return this.workspace_.getCachedParentSvgSize();
        }
        getAbsoluteMetrics() {
          let e = 0;
          const t = this.getToolboxMetrics(), n = this.getFlyoutMetrics(!0), s = !!this.workspace_.getToolbox(), u = !!this.workspace_.getFlyout(!0);
          var A = s ? t.position : n.position, L = A === Ge.LEFT;
          return A = A === Ge.TOP, s && L ? e = t.width : u && L && (e = n.width), L = 0, s && A ? L = t.height : u && A && (L = n.height), { top: L, left: e };
        }
        getViewMetrics(e) {
          e = e ? this.workspace_.scale : 1;
          const t = this.getSvgMetrics(), n = this.getToolboxMetrics(), s = this.getFlyoutMetrics(!0), u = this.workspace_.getToolbox() ? n.position : s.position;
          return this.workspace_.getToolbox() ? u === Ge.TOP || u === Ge.BOTTOM ? t.height -= n.height : (u === Ge.LEFT || u === Ge.RIGHT) && (t.width -= n.width) : this.workspace_.getFlyout(!0) && (u === Ge.TOP || u === Ge.BOTTOM ? t.height -= s.height : (u === Ge.LEFT || u === Ge.RIGHT) && (t.width -= s.width)), { height: t.height / e, width: t.width / e, top: -this.workspace_.scrollY / e, left: -this.workspace_.scrollX / e };
        }
        getContentMetrics(e) {
          e = e ? 1 : this.workspace_.scale;
          const t = this.workspace_.getBlocksBoundingBox();
          return { height: (t.bottom - t.top) * e, width: (t.right - t.left) * e, top: t.top * e, left: t.left * e };
        }
        hasFixedEdges() {
          return !this.workspace_.isMovableHorizontally() || !this.workspace_.isMovableVertically();
        }
        getComputedFixedEdges_(e) {
          if (!this.hasFixedEdges())
            return {};
          const t = this.workspace_.isMovableHorizontally(), n = this.workspace_.isMovableVertically();
          e = e || this.getViewMetrics(!1);
          const s = {};
          return n || (s.top = e.top, s.bottom = e.top + e.height), t || (s.left = e.left, s.right = e.left + e.width), s;
        }
        getPaddedContent_(e, t) {
          const n = t.top + t.height, s = t.left + t.width, u = e.width;
          e = e.height;
          const A = u / 2, L = e / 2;
          return { top: Math.min(t.top - L, n - e), bottom: Math.max(n + L, t.top + e), left: Math.min(t.left - A, s - u), right: Math.max(s + A, t.left + u) };
        }
        getScrollMetrics(e, t, n) {
          e = e ? this.workspace_.scale : 1, t = t || this.getViewMetrics(!1);
          var s = n || this.getContentMetrics();
          n = this.getComputedFixedEdges_(t), t = this.getPaddedContent_(t, s), s = n.top !== void 0 ? n.top : t.top;
          const u = n.left !== void 0 ? n.left : t.left;
          return { top: s / e, left: u / e, width: ((n.right !== void 0 ? n.right : t.right) - u) / e, height: ((n.bottom !== void 0 ? n.bottom : t.bottom) - s) / e };
        }
        getUiMetrics() {
          return { viewMetrics: this.getViewMetrics(), absoluteMetrics: this.getAbsoluteMetrics(), toolboxMetrics: this.getToolboxMetrics() };
        }
        getMetrics() {
          const e = this.getToolboxMetrics(), t = this.getFlyoutMetrics(!0), n = this.getSvgMetrics(), s = this.getAbsoluteMetrics(), u = this.getViewMetrics(), A = this.getContentMetrics(), L = this.getScrollMetrics(!1, u, A);
          return {
            contentHeight: A.height,
            contentWidth: A.width,
            contentTop: A.top,
            contentLeft: A.left,
            scrollHeight: L.height,
            scrollWidth: L.width,
            scrollTop: L.top,
            scrollLeft: L.left,
            viewHeight: u.height,
            viewWidth: u.width,
            viewTop: u.top,
            viewLeft: u.left,
            absoluteTop: s.top,
            absoluteLeft: s.left,
            svgHeight: n.height,
            svgWidth: n.width,
            toolboxWidth: e.width,
            toolboxHeight: e.height,
            toolboxPosition: e.position,
            flyoutWidth: t.width,
            flyoutHeight: t.height
          };
        }
      };
      o(_e.METRICS_MANAGER, Vi, yd);
      var $A = class extends yd {
        constructor(e, t) {
          super(e), this.flyout_ = t;
        }
        getBoundingBox_() {
          let e;
          try {
            e = this.workspace_.getCanvas().getBBox();
          } catch {
            e = { height: 0, y: 0, width: 0, x: 0 };
          }
          return e;
        }
        getContentMetrics(e) {
          const t = this.getBoundingBox_();
          return e = e ? 1 : this.workspace_.scale, { height: t.height * e, width: t.width * e, top: t.y * e, left: t.x * e };
        }
        getScrollMetrics(e, t, n) {
          return t = n || this.getContentMetrics(), n = this.flyout_.MARGIN * this.workspace_.scale, e = e ? this.workspace_.scale : 1, { height: (t.height + 2 * n) / e, width: (t.width + t.left + n) / e, top: 0, left: 0 };
        }
      }, fd = class {
        constructor(e, t, n, s, u) {
          this.workspace = e, this.oldHostMetrics_ = this.corner_ = this.vScroll = this.hScroll = null, t = t === void 0 ? !0 : t, n = n === void 0 ? !0 : n;
          const A = t && n;
          t && (this.hScroll = new Zt(e, !0, A, s, u)), n && (this.vScroll = new Zt(e, !1, A, s, u)), A && (this.corner_ = K(G.RECT, {
            height: Zt.scrollbarThickness,
            width: Zt.scrollbarThickness,
            class: "blocklyScrollbarBackground"
          }), mr(this.corner_, e.getBubbleCanvas()));
        }
        dispose() {
          _t(this.corner_), this.oldHostMetrics_ = this.corner_ = null, this.hScroll && (this.hScroll.dispose(), this.hScroll = null), this.vScroll && (this.vScroll.dispose(), this.vScroll = null);
        }
        resize() {
          const e = this.workspace.getMetrics();
          if (e) {
            var t = !1, n = !1;
            if (this.oldHostMetrics_ && this.oldHostMetrics_.viewWidth === e.viewWidth && this.oldHostMetrics_.viewHeight === e.viewHeight && this.oldHostMetrics_.absoluteTop === e.absoluteTop && this.oldHostMetrics_.absoluteLeft === e.absoluteLeft ? (this.oldHostMetrics_ && this.oldHostMetrics_.scrollWidth === e.scrollWidth && this.oldHostMetrics_.viewLeft === e.viewLeft && this.oldHostMetrics_.scrollLeft === e.scrollLeft || (t = !0), this.oldHostMetrics_ && this.oldHostMetrics_.scrollHeight === e.scrollHeight && this.oldHostMetrics_.viewTop === e.viewTop && this.oldHostMetrics_.scrollTop === e.scrollTop || (n = !0)) : n = t = !0, t || n) {
              try {
                r.disable$$module$build$src$core$events$utils(), this.hScroll && t && this.hScroll.resize(e), this.vScroll && n && this.vScroll.resize(e);
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
              this.workspace.maybeFireViewportChangeEvent();
            }
            if (this.hScroll && this.vScroll) {
              if (!this.oldHostMetrics_ || this.oldHostMetrics_.viewWidth !== e.viewWidth || this.oldHostMetrics_.absoluteLeft !== e.absoluteLeft) {
                let s;
                (s = this.corner_) == null || s.setAttribute("x", String(this.vScroll.position.x));
              }
              if (!this.oldHostMetrics_ || this.oldHostMetrics_.viewHeight !== e.viewHeight || this.oldHostMetrics_.absoluteTop !== e.absoluteTop) {
                let s;
                (s = this.corner_) == null || s.setAttribute("y", String(this.hScroll.position.y));
              }
            }
            this.oldHostMetrics_ = e;
          }
        }
        canScrollHorizontally() {
          return !!this.hScroll;
        }
        canScrollVertically() {
          return !!this.vScroll;
        }
        setOrigin(e, t) {
          this.hScroll && this.hScroll.setOrigin(e, t), this.vScroll && this.vScroll.setOrigin(e, t);
        }
        set(e, t, n) {
          this.hScroll && this.hScroll.set(e, !1), this.vScroll && this.vScroll.set(t, !1), (n || n === void 0) && (e = {}, this.hScroll && (e.x = this.hScroll.getRatio_()), this.vScroll && (e.y = this.vScroll.getRatio_()), this.workspace.setMetrics(e));
        }
        setX(e) {
          this.hScroll && this.hScroll.set(e, !0);
        }
        setY(e) {
          this.vScroll && this.vScroll.set(e, !0);
        }
        setContainerVisible(e) {
          this.hScroll && this.hScroll.setContainerVisible(e), this.vScroll && this.vScroll.setContainerVisible(e);
        }
        isVisible() {
          let e = !1;
          return this.hScroll && (e = this.hScroll.isVisible()), this.vScroll && (e = e || this.vScroll.isVisible()), e;
        }
        resizeContent(e) {
          this.hScroll && this.hScroll.resizeContentHorizontal(e), this.vScroll && this.vScroll.resizeContentVertical(e);
        }
        resizeView(e) {
          this.hScroll && this.hScroll.resizeViewHorizontal(e), this.vScroll && this.vScroll.resizeViewVertical(e);
        }
      }, WA = class {
        constructor(e) {
          this.workspace = e, this.horizontalScrollEnabled_ = this.workspace.isMovableHorizontally(), this.verticalScrollEnabled_ = this.workspace.isMovableVertically(), this.startScrollXY_ = new Te(e.scrollX, e.scrollY);
        }
        dispose() {
          this.workspace = null;
        }
        startDrag() {
          Fe() && Fe().unselect();
        }
        endDrag(e) {
          this.drag(e);
        }
        drag(e) {
          if (e = Te.sum(this.startScrollXY_, e), this.horizontalScrollEnabled_ && this.verticalScrollEnabled_)
            this.workspace.scroll(e.x, e.y);
          else if (this.horizontalScrollEnabled_)
            this.workspace.scroll(e.x, this.workspace.scrollY);
          else if (this.verticalScrollEnabled_)
            this.workspace.scroll(this.workspace.scrollX, e.y);
          else
            throw new TypeError("Invalid state.");
        }
      }, KS = 5, jS = 6, ko = class {
        constructor(e, t) {
          this.creatorWorkspace = t, this.mouseDownXY = new Te(0, 0), this.startWorkspace_ = this.targetBlock = this.startBlock = this.startIcon = this.startField = this.startBubble = null, this.hasExceededDragRadius = !1, this.boundEvents = [], this.flyout = this.workspaceDragger = this.blockDragger = this.bubbleDragger = null, this.isMultiTouch_ = this.isEnding_ = this.gestureHasStarted = this.calledUpdateIsDragging = !1, this.cachedPoints = /* @__PURE__ */ new Map(), this.startDistance = this.previousScale = 0, this.currentDropdownOwner = this.isPinchZoomEnabled = null, this.mostRecentEvent = e, this.currentDragDeltaXY = new Te(0, 0), this.healStack = !vu;
        }
        dispose() {
          Me(), GT(), this.creatorWorkspace.clearGesture();
          for (const e of this.boundEvents)
            Mt(e);
          this.boundEvents.length = 0, this.blockDragger && this.blockDragger.dispose(), this.workspaceDragger && this.workspaceDragger.dispose();
        }
        updateFromEvent(e) {
          const t = new Te(e.clientX, e.clientY);
          this.updateDragDelta(t) && (this.updateIsDragging(), ee()), this.mostRecentEvent = e;
        }
        updateDragDelta(e) {
          return this.currentDragDeltaXY = Te.difference(
            e,
            this.mouseDownXY
          ), this.hasExceededDragRadius ? !1 : this.hasExceededDragRadius = Te.magnitude(this.currentDragDeltaXY) > (this.flyout ? r.config$$module$build$src$core$config.flyoutDragRadius : r.config$$module$build$src$core$config.dragRadius);
        }
        updateIsDraggingFromFlyout() {
          let e;
          if (!this.targetBlock || (e = this.flyout) == null || !e.isBlockCreatable(this.targetBlock))
            return !1;
          if (!this.flyout.targetWorkspace)
            throw Error(`Cannot update dragging from the flyout because the ' +
          'flyout's target workspace is undefined`);
          return !this.flyout.isScrollable() || this.flyout.isDragTowardWorkspace(this.currentDragDeltaXY) ? (this.startWorkspace_ = this.flyout.targetWorkspace, this.startWorkspace_.updateScreenCalculationsIfScrolled(), r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.startBlock = null, this.targetBlock = this.flyout.createBlock(this.targetBlock), this.targetBlock.select(), !0) : !1;
        }
        updateIsDraggingBubble() {
          return this.startBubble ? (this.startDraggingBubble(), !0) : !1;
        }
        updateIsDraggingBlock() {
          if (!this.targetBlock)
            return !1;
          if (this.flyout) {
            if (this.updateIsDraggingFromFlyout())
              return this.startDraggingBlock(), !0;
          } else if (this.targetBlock.isMovable())
            return this.startDraggingBlock(), !0;
          return !1;
        }
        updateIsDraggingWorkspace() {
          if (!this.startWorkspace_)
            throw Error("Cannot update dragging the workspace because the start workspace is undefined");
          (this.flyout ? this.flyout.isScrollable() : this.startWorkspace_ && this.startWorkspace_.isDraggable()) && (this.workspaceDragger = new WA(this.startWorkspace_), this.workspaceDragger.startDrag());
        }
        updateIsDragging() {
          if (this.calledUpdateIsDragging)
            throw Error("updateIsDragging_ should only be called once per gesture.");
          this.calledUpdateIsDragging = !0, this.updateIsDraggingBubble() || this.updateIsDraggingBlock() || this.updateIsDraggingWorkspace();
        }
        startDraggingBlock() {
          this.blockDragger = new (Z(_e.BLOCK_DRAGGER, this.creatorWorkspace.options, !0))(this.targetBlock, this.startWorkspace_), this.blockDragger.startDrag(this.currentDragDeltaXY, this.healStack), this.blockDragger.drag(this.mostRecentEvent, this.currentDragDeltaXY);
        }
        startDraggingBubble() {
          if (!this.startBubble)
            throw Error("Cannot update dragging the bubble because the start bubble is undefined");
          if (!this.startWorkspace_)
            throw Error("Cannot update dragging the bubble because the start workspace is undefined");
          this.bubbleDragger = new ma(this.startBubble, this.startWorkspace_), this.bubbleDragger.startBubbleDrag(), this.bubbleDragger.dragBubble(this.mostRecentEvent, this.currentDragDeltaXY);
        }
        doStart(e) {
          if (!this.startWorkspace_)
            throw Error("Cannot start the touch gesture becauase the start workspace is undefined");
          this.isPinchZoomEnabled = this.startWorkspace_.options.zoomOptions && this.startWorkspace_.options.zoomOptions.pinch, ba(e) ? this.cancel() : (this.gestureHasStarted = !0, Ks(), this.startWorkspace_.updateScreenCalculationsIfScrolled(), this.startWorkspace_.isMutator && this.startWorkspace_.resize(), this.currentDropdownOwner = cc(), this.startWorkspace_.hideChaff(!!this.flyout), this.startWorkspace_.markFocused(), this.mostRecentEvent = e, VT(), this.targetBlock && this.targetBlock.select(), Xo(e) ? this.handleRightClick(e) : (e.type.toLowerCase() === "pointerdown" && e.pointerType !== "mouse" && H(
            e,
            this
          ), this.mouseDownXY = new Te(e.clientX, e.clientY), this.healStack = e.altKey || e.ctrlKey || e.metaKey, this.bindMouseEvents(e), this.isEnding_ || this.handleTouchStart(e)));
        }
        bindMouseEvents(e) {
          this.boundEvents.push(ge(document, "pointerdown", null, this.handleStart.bind(this), !0)), this.boundEvents.push(ge(document, "pointermove", null, this.handleMove.bind(this), !0)), this.boundEvents.push(ge(document, "pointerup", null, this.handleUp.bind(this), !0)), e.preventDefault(), e.stopPropagation();
        }
        handleStart(e) {
          this.isDragging() || (this.handleTouchStart(e), this.isMultiTouch() && ee());
        }
        handleMove(e) {
          this.isDragging() && He(e) || !this.isMultiTouch() ? (this.updateFromEvent(e), this.workspaceDragger ? this.workspaceDragger.drag(this.currentDragDeltaXY) : this.blockDragger ? this.blockDragger.drag(this.mostRecentEvent, this.currentDragDeltaXY) : this.bubbleDragger && this.bubbleDragger.dragBubble(this.mostRecentEvent, this.currentDragDeltaXY), e.preventDefault(), e.stopPropagation()) : this.isMultiTouch() && (this.handleTouchMove(e), ee());
        }
        handleUp(e) {
          if (this.isDragging() || this.handleTouchEnd(e), !this.isMultiTouch() || this.isDragging()) {
            if (!He(e))
              return;
            if (this.updateFromEvent(e), ee(), this.isEnding_) {
              console.log("Trying to end a gesture recursively.");
              return;
            }
            this.isEnding_ = !0, this.bubbleDragger ? this.bubbleDragger.endBubbleDrag(e, this.currentDragDeltaXY) : this.blockDragger ? this.blockDragger.endDrag(e, this.currentDragDeltaXY) : this.workspaceDragger ? this.workspaceDragger.endDrag(this.currentDragDeltaXY) : this.isBubbleClick() ? this.doBubbleClick() : this.isFieldClick() ? this.doFieldClick() : this.isIconClick() ? this.doIconClick() : this.isBlockClick() ? this.doBlockClick() : this.isWorkspaceClick() && this.doWorkspaceClick(e);
          }
          e.preventDefault(), e.stopPropagation(), this.dispose();
        }
        handleTouchStart(e) {
          var t = rr(e);
          this.cachedPoints.set(t, this.getTouchPoint(e));
          var n = Array.from(this.cachedPoints.keys());
          n.length === 2 && (t = this.cachedPoints.get(n[0]), n = this.cachedPoints.get(n[1]), this.startDistance = Te.distance(t, n), this.isMultiTouch_ = !0, e.preventDefault());
        }
        handleTouchMove(e) {
          const t = rr(e);
          this.cachedPoints.set(t, this.getTouchPoint(e)), this.isPinchZoomEnabled && this.cachedPoints.size === 2 ? this.handlePinch(e) : this.handleMove(e);
        }
        handlePinch(e) {
          var t = Array.from(this.cachedPoints.keys()), n = this.cachedPoints.get(t[0]);
          if (t = this.cachedPoints.get(t[1]), n = Te.distance(n, t) / this.startDistance, 0 < this.previousScale && 1 / 0 > this.previousScale) {
            if (t = n - this.previousScale, t = 0 < t ? t * KS : t * jS, !this.startWorkspace_)
              throw Error("Cannot handle a pinch because the start workspace is undefined");
            const s = this.startWorkspace_, u = $l(e, s.getParentSvg(), s.getInverseScreenCTM());
            s.zoom(u.x, u.y, t);
          }
          this.previousScale = n, e.preventDefault();
        }
        handleTouchEnd(e) {
          e = rr(e), this.cachedPoints.has(e) && this.cachedPoints.delete(e), 2 > this.cachedPoints.size && (this.cachedPoints.clear(), this.previousScale = 0);
        }
        getTouchPoint(e) {
          return this.startWorkspace_ ? new Te(e.pageX, e.pageY) : null;
        }
        isMultiTouch() {
          return this.isMultiTouch_;
        }
        cancel() {
          this.isEnding_ || (ee(), this.bubbleDragger ? this.bubbleDragger.endBubbleDrag(this.mostRecentEvent, this.currentDragDeltaXY) : this.blockDragger ? this.blockDragger.endDrag(this.mostRecentEvent, this.currentDragDeltaXY) : this.workspaceDragger && this.workspaceDragger.endDrag(this.currentDragDeltaXY), this.dispose());
        }
        handleRightClick(e) {
          this.targetBlock ? (this.bringBlockToFront(), this.targetBlock.workspace.hideChaff(!!this.flyout), this.targetBlock.showContextMenu(e)) : this.startBubble ? this.startBubble.showContextMenu(e) : this.startWorkspace_ && !this.flyout && (this.startWorkspace_.hideChaff(), this.startWorkspace_.showContextMenu(e)), e.preventDefault(), e.stopPropagation(), this.dispose();
        }
        handleWsStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleWsStart, but the gesture had already been started.");
          this.setStartWorkspace(t), this.mostRecentEvent = e, this.doStart(e);
        }
        fireWorkspaceClick(e) {
          Ce(new (fe(Gi))(null, e.id, "workspace"));
        }
        handleFlyoutStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleFlyoutStart, but the gesture had already been started.");
          this.setStartFlyout(t), this.handleWsStart(e, t.getWorkspace());
        }
        handleBlockStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleBlockStart, but the gesture had already been started.");
          this.setStartBlock(t), this.mostRecentEvent = e;
        }
        handleBubbleStart(e, t) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.handleBubbleStart, but the gesture had already been started.");
          this.setStartBubble(t), this.mostRecentEvent = e;
        }
        doBubbleClick() {
          this.startBubble instanceof $r && (this.startBubble.setFocus(), this.startBubble.select());
        }
        doFieldClick() {
          if (!this.startField)
            throw Error("Cannot do a field click because the start field is undefined");
          this.currentDropdownOwner !== this.startField && this.startField.showEditor(this.mostRecentEvent), this.bringBlockToFront();
        }
        doIconClick() {
          if (!this.startIcon)
            throw Error("Cannot do an icon click because the start icon is undefined");
          this.startIcon.onClick();
        }
        doBlockClick() {
          if (this.flyout && this.flyout.autoClose) {
            if (!this.targetBlock)
              throw Error("Cannot do a block click because the target block is undefined");
            this.targetBlock.isEnabled() && (r.getGroup$$module$build$src$core$events$utils() || r.setGroup$$module$build$src$core$events$utils(!0), this.flyout.createBlock(this.targetBlock).scheduleSnapAndBump());
          } else {
            if (!this.startWorkspace_)
              throw Error("Cannot do a block click because the start workspace is undefined");
            const e = new (fe(Gi))(this.startBlock, this.startWorkspace_.id, "block");
            Ce(e);
          }
          this.bringBlockToFront(), r.setGroup$$module$build$src$core$events$utils(!1);
        }
        doWorkspaceClick(e) {
          e = this.creatorWorkspace, Fe() && Fe().unselect(), this.fireWorkspaceClick(this.startWorkspace_ || e);
        }
        bringBlockToFront() {
          this.targetBlock && !this.flyout && this.targetBlock.bringToFront();
        }
        setStartField(e) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.setStartField, but the gesture had already been started.");
          this.startField || (this.startField = e);
        }
        setStartIcon(e) {
          if (this.gestureHasStarted)
            throw Error("Tried to call gesture.setStartIcon, but the gesture had already been started.");
          this.startIcon || (this.startIcon = e);
        }
        setStartBubble(e) {
          this.startBubble || (this.startBubble = e);
        }
        setStartBlock(e) {
          this.startBlock || this.startBubble || (this.startBlock = e, e.isInFlyout && e !== e.getRootBlock() ? this.setTargetBlock(e.getRootBlock()) : this.setTargetBlock(e));
        }
        setTargetBlock(e) {
          e.isShadow() ? this.setTargetBlock(e.getParent()) : this.targetBlock = e;
        }
        setStartWorkspace(e) {
          this.startWorkspace_ || (this.startWorkspace_ = e);
        }
        setStartFlyout(e) {
          this.flyout || (this.flyout = e);
        }
        isBubbleClick() {
          return !!this.startBubble && !this.hasExceededDragRadius;
        }
        isBlockClick() {
          return !!this.startBlock && !this.hasExceededDragRadius && !this.isFieldClick() && !this.isIconClick();
        }
        isFieldClick() {
          return (this.startField ? this.startField.isClickable() : !1) && !this.hasExceededDragRadius && (!this.flyout || !this.flyout.autoClose);
        }
        isIconClick() {
          return !!this.startIcon && !this.hasExceededDragRadius;
        }
        isWorkspaceClick() {
          return !this.startBlock && !this.startBubble && !this.startField && !this.hasExceededDragRadius;
        }
        isDragging() {
          return !!this.workspaceDragger || !!this.blockDragger || !!this.bubbleDragger;
        }
        hasStarted() {
          return this.gestureHasStarted;
        }
        getInsertionMarkers() {
          return this.blockDragger ? this.blockDragger.getInsertionMarkers() : [];
        }
        getCurrentDragger() {
          let e, t;
          return (t = (e = this.blockDragger) != null ? e : this.workspaceDragger) != null ? t : this.bubbleDragger;
        }
        static inProgress() {
          const e = ue();
          for (let t = 0, n; n = e[t]; t++)
            if (n.currentGesture_)
              return !0;
          return !1;
        }
      }, Cd = class {
        constructor(e, t) {
          this.pattern = e;
          let n;
          this.spacing = (n = t.spacing) != null ? n : 0;
          let s;
          this.length = (s = t.length) != null ? s : 1, this.line2 = (this.line1 = e.firstChild) && this.line1.nextSibling;
          let u;
          this.snapToGrid = (u = t.snap) != null ? u : !1;
        }
        shouldSnap() {
          return this.snapToGrid;
        }
        getSpacing() {
          return this.spacing;
        }
        getPatternId() {
          return this.pattern.id;
        }
        update(e) {
          var t = this.spacing * e;
          this.pattern.setAttribute("width", `${t}`), this.pattern.setAttribute("height", `${t}`), t = Math.floor(this.spacing / 2) + 0.5;
          let n = t - this.length / 2, s = t + this.length / 2;
          t *= e, n *= e, s *= e, this.setLineAttributes(this.line1, e, n, s, t, t), this.setLineAttributes(this.line2, e, t, t, n, s);
        }
        setLineAttributes(e, t, n, s, u, A) {
          e && (e.setAttribute("stroke-width", `${t}`), e.setAttribute("x1", `${n}`), e.setAttribute("y1", `${u}`), e.setAttribute("x2", `${s}`), e.setAttribute("y2", `${A}`));
        }
        moveTo(e, t) {
          this.pattern.setAttribute("x", `${e}`), this.pattern.setAttribute("y", `${t}`);
        }
        static createDom(e, t, n) {
          e = K(
            G.PATTERN,
            { id: "blocklyGridPattern" + e, patternUnits: "userSpaceOnUse" },
            n
          );
          let s, u;
          if (0 < ((s = t.length) != null ? s : 1) && 0 < ((u = t.spacing) != null ? u : 0)) {
            K(G.LINE, { stroke: t.colour }, e);
            let A;
            (A = t.length) != null && A && K(G.LINE, { stroke: t.colour }, e);
          } else
            K(G.LINE, {}, e);
          return e;
        }
      };
      r.Names$$module$build$src$core$names = class {
        constructor(e, t) {
          this.db = /* @__PURE__ */ new Map(), this.dbReverse = /* @__PURE__ */ new Set(), this.variableMap = null, this.variablePrefix = t || "", this.reservedWords = new Set(e ? e.split(",") : []);
        }
        reset() {
          this.db.clear(), this.dbReverse.clear(), this.variableMap = null;
        }
        setVariableMap(e) {
          this.variableMap = e;
        }
        getNameForUserVariable(e) {
          return this.variableMap ? (e = this.variableMap.getVariableById(e)) ? e.name : null : (console.warn(`Deprecated call to Names.prototype.getName without defining a variable map. To fix, add the following code in your generator's init() function:
Blockly.YourGeneratorName.nameDB_.setVariableMap(workspace.getVariableMap());`), null);
        }
        populateVariables(e) {
          e = r.allUsedVarModels$$module$build$src$core$variables(e);
          for (let t = 0; t < e.length; t++)
            this.getName(e[t].getId(), r.NameType$$module$build$src$core$names.VARIABLE);
        }
        populateProcedures(e) {
          throw Error("The implementation of populateProcedures should be monkey-patched in by blockly.ts");
        }
        getName(e, t) {
          let n = e;
          t === r.NameType$$module$build$src$core$names.VARIABLE && (e = this.getNameForUserVariable(e)) && (n = e), e = n.toLowerCase();
          const s = t === r.NameType$$module$build$src$core$names.VARIABLE || t === r.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE ? this.variablePrefix : "";
          this.db.has(t) || this.db.set(t, /* @__PURE__ */ new Map());
          const u = this.db.get(t);
          return u.has(e) ? s + u.get(e) : (t = this.getDistinctName(n, t), u.set(e, t.substr(s.length)), t);
        }
        getUserNames(e) {
          let t;
          return (e = (t = this.db.get(e)) == null ? void 0 : t.keys()) ? Array.from(e) : [];
        }
        getDistinctName(e, t) {
          e = this.safeName(e);
          let n = null, s, u;
          for (; this.dbReverse.has(e + ((s = n) != null ? s : "")) || this.reservedWords.has(e + ((u = n) != null ? u : "")); )
            n = n ? n + 1 : 2;
          let A;
          return e += (A = n) != null ? A : "", this.dbReverse.add(e), (t === r.NameType$$module$build$src$core$names.VARIABLE || t === r.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE ? this.variablePrefix : "") + e;
        }
        safeName(e) {
          return e ? (e = encodeURI(e.replace(/ /g, "_")).replace(/[^\w]/g, "_"), "0123456789".indexOf(e[0]) !== -1 && (e = "my_" + e)) : e = r.Msg$$module$build$src$core$msg.UNNAMED_KEY || "unnamed", e;
        }
        static equals(e, t) {
          return e.toLowerCase() === t.toLowerCase();
        }
      }, function(e) {
        e = e.NameType || (e.NameType = {}), e.DEVELOPER_VARIABLE = "DEVELOPER_VARIABLE", e.VARIABLE = "VARIABLE", e.PROCEDURE = "PROCEDURE";
      }(r.Names$$module$build$src$core$names || (r.Names$$module$build$src$core$names = {})), r.NameType$$module$build$src$core$names = r.Names$$module$build$src$core$names.NameType, r.Names$$module$build$src$core$names.DEVELOPER_VARIABLE_TYPE = r.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE, r.NameType$$module$build$src$core$names, r.Names$$module$build$src$core$names;
      var kA = class extends Map {
        constructor() {
          super();
        }
        set(e, t) {
          return this.get(e) === t ? this : (super.set(e, t), a_(t) && t.startPublishing(), this);
        }
        delete(e) {
          const t = this.get(e);
          return e = super.delete(e), e && (a_(t) && t.stopPublishing(), e);
        }
        clear() {
          if (this.size)
            for (const e of this.keys())
              this.delete(e);
        }
        add(e) {
          return this.set(
            e.getId(),
            e
          );
        }
        getProcedures() {
          return [...this.values()];
        }
      }, Ll = {};
      Ll.CommentIcon = Or, Ll.Icon = Eu, Ll.IconType = Lr, Ll.MutatorIcon = r.MutatorIcon$$module$build$src$core$icons$mutator_icon, Ll.WarningIcon = Li, Ll.exceptions = nA, Ll.registry = gu;
      var Uu, Wr;
      Uu = "PROCEDURE", r.DEFAULT_ARG$$module$build$src$core$procedures = "x", Wr = {}, Wr.CATEGORY_NAME = Uu, Wr.DEFAULT_ARG = r.DEFAULT_ARG$$module$build$src$core$procedures, Wr.ObservableProcedureMap = kA, Wr.allProcedures = __, Wr.findLegalName = r.findLegalName$$module$build$src$core$procedures, Wr.flyoutCategory = Uc, Wr.getCallers = Mr, Wr.getDefinition = r.getDefinition$$module$build$src$core$procedures, Wr.isNameUsed = Bc, Wr.isProcedureBlock = nl, Wr.mutateCallers = r.mutateCallers$$module$build$src$core$procedures, Wr.mutatorOpenListener = pp, Wr.rename = r.rename$$module$build$src$core$procedures;
      var wA = class {
        constructor(e, t) {
          this.workspace = e, this.theme = t, this.subscribedWorkspaces_ = [], this.componentDB = /* @__PURE__ */ new Map();
        }
        getTheme() {
          return this.theme;
        }
        setTheme(e) {
          var t = this.theme;
          this.theme = e, (e = this.workspace.getInjectionDiv()) && (t && (t = t.getClassName()) && Ue(e, t), (t = this.theme.getClassName()) && Re(e, t));
          for (let n = 0, s; s = this.subscribedWorkspaces_[n]; n++)
            s.refreshTheme();
          for (const [
            n,
            s
          ] of this.componentDB)
            for (const u of s) {
              e = u.element, t = u.propertyName;
              const A = this.theme && this.theme.getComponentStyle(n);
              e.style.setProperty(t, A || "");
            }
          for (const n of this.subscribedWorkspaces_)
            n.hideChaff();
        }
        subscribeWorkspace(e) {
          this.subscribedWorkspaces_.push(e);
        }
        unsubscribeWorkspace(e) {
          if (!pn(this.subscribedWorkspaces_, e))
            throw Error("Cannot unsubscribe a workspace that hasn't been subscribed.");
        }
        subscribe(e, t, n) {
          this.componentDB.has(t) || this.componentDB.set(
            t,
            []
          ), this.componentDB.get(t).push({ element: e, propertyName: n }), t = this.theme && this.theme.getComponentStyle(t), e.style.setProperty(n, t || "");
        }
        unsubscribe(e) {
          if (e)
            for (const [t, n] of this.componentDB) {
              for (let s = n.length - 1; 0 <= s; s--)
                n[s].element === e && n.splice(s, 1);
              n.length || this.componentDB.delete(t);
            }
        }
        dispose() {
          this.subscribedWorkspaces_.length = 0, this.componentDB.clear();
        }
      }, x_ = "VARIABLE_DYNAMIC", wo = {};
      wo.CATEGORY_NAME = x_, wo.flyoutCategory = es, wo.flyoutCategoryBlocks = Mo, wo.onCreateVariableButtonClick_Colour = c_, wo.onCreateVariableButtonClick_Number = Zn, wo.onCreateVariableButtonClick_String = Gc;
      var Vu = class {
        constructor(e) {
          this.workspace = e, this.variableMap = /* @__PURE__ */ new Map();
        }
        clear() {
          for (const e of this.variableMap.values())
            for (; 0 < e.length; )
              this.deleteVariable(e[0]);
          if (this.variableMap.size !== 0)
            throw Error("Non-empty variable map");
        }
        renameVariable(e, t) {
          if (e.name !== t) {
            var n = this.getVariable(t, e.type), s = this.workspace.getAllBlocks(!1), u = r.getGroup$$module$build$src$core$events$utils();
            u || r.setGroup$$module$build$src$core$events$utils(!0);
            try {
              n && n.getId() !== e.getId() ? this.renameVariableWithConflict_(e, t, n, s) : this.renameVariableAndUses_(e, t, s);
            } finally {
              r.setGroup$$module$build$src$core$events$utils(u);
            }
          }
        }
        renameVariableById(e, t) {
          const n = this.getVariableById(e);
          if (!n)
            throw Error("Tried to rename a variable that didn't exist. ID: " + e);
          this.renameVariable(n, t);
        }
        renameVariableAndUses_(e, t, n) {
          for (Ce(new (fe($n))(e, t)), e.name = t, t = 0; t < n.length; t++)
            n[t].updateVarName(e);
        }
        renameVariableWithConflict_(e, t, n, s) {
          const u = e.type;
          for (t !== n.name && this.renameVariableAndUses_(n, t, s), t = 0; t < s.length; t++)
            s[t].renameVarById(e.getId(), n.getId());
          Ce(new (fe(gr))(e)), pn(this.variableMap.get(u), e);
        }
        createVariable(e, t, n) {
          var s = this.getVariable(e, t);
          if (s) {
            if (n && s.getId() !== n)
              throw Error('Variable "' + e + '" is already in use and its id is "' + s.getId() + '" which conflicts with the passed in id, "' + n + '".');
            return s;
          }
          if (n && this.getVariableById(n))
            throw Error('Variable id, "' + n + '", is already in use.');
          return s = n || Yr(), t = t || "", s = new ra(this.workspace, e, t, s), e = this.variableMap.get(t) || [], e.push(s), this.variableMap.delete(t), this.variableMap.set(t, e), Ce(new (fe(yo))(s)), s;
        }
        deleteVariable(e) {
          const t = e.getId(), n = this.variableMap.get(e.type);
          if (n) {
            for (let s = 0; s < n.length; s++)
              if (n[s].getId() === t) {
                n.splice(s, 1), Ce(new (fe(gr))(e)), n.length === 0 && this.variableMap.delete(e.type);
                break;
              }
          }
        }
        deleteVariableById(e) {
          const t = this.getVariableById(e);
          if (t) {
            var n = t.name;
            const s = this.getVariableUsesById(e);
            for (let u = 0, A; A = s[u]; u++)
              if (A.type === "procedures_defnoreturn" || A.type === "procedures_defreturn") {
                e = String(A.getFieldValue("NAME")), n = r.Msg$$module$build$src$core$msg.CANNOT_DELETE_VARIABLE_PROCEDURE.replace("%1", n).replace("%2", e), uo(n);
                return;
              }
            1 < s.length ? (n = r.Msg$$module$build$src$core$msg.DELETE_VARIABLE_CONFIRMATION.replace("%1", String(s.length)).replace("%2", n), jr(n, (u) => {
              u && t && this.deleteVariableInternal(t, s);
            })) : this.deleteVariableInternal(t, s);
          } else
            console.warn("Can't delete non-existent variable: " + e);
        }
        deleteVariableInternal(e, t) {
          const n = r.getGroup$$module$build$src$core$events$utils();
          n || r.setGroup$$module$build$src$core$events$utils(!0);
          try {
            for (let s = 0; s < t.length; s++)
              t[s].dispose(!0);
            this.deleteVariable(e);
          } finally {
            r.setGroup$$module$build$src$core$events$utils(n);
          }
        }
        getVariable(e, t) {
          if (t = this.variableMap.get(t || "")) {
            for (let n = 0, s; s = t[n]; n++)
              if (r.Names$$module$build$src$core$names.equals(s.name, e))
                return s;
          }
          return null;
        }
        getVariableById(e) {
          for (const t of this.variableMap.values())
            for (const n of t)
              if (n.getId() === e)
                return n;
          return null;
        }
        getVariablesOfType(e) {
          return (e = this.variableMap.get(e || "")) ? e.slice() : [];
        }
        getVariableTypes(e) {
          const t = new Set(this.variableMap.keys());
          if (e && e.getPotentialVariableMap())
            for (const n of e.getPotentialVariableMap().variableMap.keys())
              t.add(n);
          return t.has("") || t.add(""), Array.from(t.values());
        }
        getAllVariables() {
          let e = [];
          for (const t of this.variableMap.values())
            e = e.concat(t);
          return e;
        }
        getAllVariableNames() {
          return Array.from(this.variableMap.values()).flat().map((e) => e.name);
        }
        getVariableUsesById(e) {
          const t = [], n = this.workspace.getAllBlocks(!1);
          for (let s = 0; s < n.length; s++) {
            const u = n[s].getVarModels();
            if (u)
              for (let A = 0; A < u.length; A++)
                u[A].getId() === e && t.push(n[s]);
          }
          return t;
        }
      }, H_ = class {
        get isFlyout() {
          return this.internalIsFlyout;
        }
        get isMutator() {
          return this.internalIsMutator;
        }
        constructor(e) {
          this.isClearing = this.internalIsMutator = this.internalIsFlyout = this.rendered = !1, this.MAX_UNDO = 1024, this.connectionDBList = [], this.topBlocks = [], this.topComments = [], this.commentDB = /* @__PURE__ */ new Map(), this.listeners = [], this.undoStack_ = [], this.redoStack_ = [], this.blockDB = /* @__PURE__ */ new Map(), this.typedBlocksDB = /* @__PURE__ */ new Map(), this.procedureMap = new kA(), this.potentialVariableMap = null, this.id = Yr(), be(this), this.options = e || new ti({}), this.RTL = !!this.options.RTL, this.horizontalLayout = !!this.options.horizontalLayout, this.toolboxPosition = this.options.toolboxPosition, this.connectionChecker = new (Z(_e.CONNECTION_CHECKER, this.options, !0))(this), this.variableMap = new Vu(this);
        }
        dispose() {
          this.listeners.length = 0, this.clear(), Ke(this);
        }
        sortObjects_(e, t) {
          const n = Math.sin(jo(H_.SCAN_ANGLE)) * (this.RTL ? -1 : 1);
          return e = e.getRelativeToSurfaceXY(), t = t.getRelativeToSurfaceXY(), e.y + n * e.x - (t.y + n * t.x);
        }
        addTopBlock(e) {
          this.topBlocks.push(e);
        }
        removeTopBlock(e) {
          if (!pn(
            this.topBlocks,
            e
          ))
            throw Error("Block not present in workspace's list of top-most blocks.");
        }
        getTopBlocks(e) {
          const t = [].concat(this.topBlocks);
          return e && 1 < t.length && t.sort(this.sortObjects_.bind(this)), t;
        }
        addTypedBlock(e) {
          this.typedBlocksDB.has(e.type) || this.typedBlocksDB.set(e.type, []), this.typedBlocksDB.get(e.type).push(e);
        }
        removeTypedBlock(e) {
          pn(this.typedBlocksDB.get(e.type), e), this.typedBlocksDB.get(e.type).length || this.typedBlocksDB.delete(e.type);
        }
        getBlocksByType(e, t) {
          return this.typedBlocksDB.has(e) ? (e = this.typedBlocksDB.get(e).slice(0), t && e && 1 < e.length && e.sort(this.sortObjects_.bind(this)), e.filter(function(n) {
            return !n.isInsertionMarker();
          })) : [];
        }
        addTopComment(e) {
          this.topComments.push(e), this.commentDB.has(e.id) && console.warn('Overriding an existing comment on this workspace, with id "' + e.id + '"'), this.commentDB.set(e.id, e);
        }
        removeTopComment(e) {
          if (!pn(this.topComments, e))
            throw Error("Comment not present in workspace's list of top-most comments.");
          this.commentDB.delete(e.id);
        }
        getTopComments(e) {
          const t = [].concat(this.topComments);
          return e && 1 < t.length && t.sort(this.sortObjects_.bind(this)), t;
        }
        getAllBlocks(e) {
          if (e) {
            var t = this.getTopBlocks(!0);
            e = [];
            for (let n = 0; n < t.length; n++)
              e.push(...t[n].getDescendants(!0));
          } else
            for (e = this.getTopBlocks(!1), t = 0; t < e.length; t++)
              e.push(...e[t].getChildren(!1));
          return e.filter(function(n) {
            return !n.isInsertionMarker();
          });
        }
        clear() {
          this.isClearing = !0;
          try {
            const e = r.getGroup$$module$build$src$core$events$utils();
            for (e || r.setGroup$$module$build$src$core$events$utils(!0); this.topBlocks.length; )
              this.topBlocks[0].dispose(!1);
            for (; this.topComments.length; )
              this.topComments[this.topComments.length - 1].dispose();
            r.setGroup$$module$build$src$core$events$utils(e), this.variableMap.clear(), this.potentialVariableMap && this.potentialVariableMap.clear();
          } finally {
            this.isClearing = !1;
          }
        }
        renameVariableById(e, t) {
          this.variableMap.renameVariableById(e, t);
        }
        createVariable(e, t, n) {
          return this.variableMap.createVariable(e, t, n);
        }
        getVariableUsesById(e) {
          return this.variableMap.getVariableUsesById(e);
        }
        deleteVariableById(e) {
          this.variableMap.deleteVariableById(e);
        }
        getVariable(e, t) {
          return this.variableMap.getVariable(e, t);
        }
        getVariableById(e) {
          return this.variableMap.getVariableById(e);
        }
        getVariablesOfType(e) {
          return this.variableMap.getVariablesOfType(e);
        }
        getVariableTypes() {
          return this.variableMap.getVariableTypes(this);
        }
        getAllVariables() {
          return this.variableMap.getAllVariables();
        }
        getAllVariableNames() {
          return this.variableMap.getAllVariableNames();
        }
        getWidth() {
          return 0;
        }
        newBlock(e, t) {
          throw Error("The implementation of newBlock should be monkey-patched in by blockly.ts");
        }
        remainingCapacity() {
          return isNaN(this.options.maxBlocks) ? 1 / 0 : this.options.maxBlocks - this.getAllBlocks(!1).length;
        }
        remainingCapacityOfType(e) {
          return this.options.maxInstances ? (this.options.maxInstances[e] !== void 0 ? this.options.maxInstances[e] : 1 / 0) - this.getBlocksByType(e, !1).length : 1 / 0;
        }
        isCapacityAvailable(e) {
          if (!this.hasBlockLimits())
            return !0;
          let t = 0;
          for (const n in e) {
            if (e[n] > this.remainingCapacityOfType(n))
              return !1;
            t += e[n];
          }
          return !(t > this.remainingCapacity());
        }
        hasBlockLimits() {
          return this.options.maxBlocks !== 1 / 0 || !!this.options.maxInstances;
        }
        getUndoStack() {
          return this.undoStack_;
        }
        getRedoStack() {
          return this.redoStack_;
        }
        undo(e) {
          var t = e ? this.redoStack_ : this.undoStack_, n = e ? this.undoStack_ : this.redoStack_;
          const s = t.pop();
          if (s) {
            for (var u = [s]; t.length && s.group && s.group === t[t.length - 1].group; ) {
              const A = t.pop();
              A && u.push(A);
            }
            for (t = 0; t < u.length; t++)
              n.push(u[t]);
            u = Sr(u, e), Er(!1);
            try {
              for (n = 0; n < u.length; n++)
                u[n].run(e);
            } finally {
              Er(!0);
            }
          }
        }
        clearUndo() {
          this.undoStack_.length = 0, this.redoStack_.length = 0, ao();
        }
        addChangeListener(e) {
          return this.listeners.push(e), e;
        }
        removeChangeListener(e) {
          pn(this.listeners, e);
        }
        fireChangeListener(e) {
          if (e.recordUndo)
            for (this.undoStack_.push(e), this.redoStack_.length = 0; this.undoStack_.length > this.MAX_UNDO && 0 <= this.MAX_UNDO; )
              this.undoStack_.shift();
          for (let t = 0; t < this.listeners.length; t++)
            (0, this.listeners[t])(e);
        }
        getBlockById(e) {
          return this.blockDB.get(e) || null;
        }
        setBlockById(e, t) {
          this.blockDB.set(e, t);
        }
        removeBlockById(e) {
          this.blockDB.delete(e);
        }
        getCommentById(e) {
          let t;
          return (t = this.commentDB.get(e)) != null ? t : null;
        }
        allInputsFilled(e) {
          const t = this.getTopBlocks(!1);
          for (let n = 0; n < t.length; n++)
            if (!t[n].allInputsFilled(e))
              return !1;
          return !0;
        }
        getPotentialVariableMap() {
          return this.potentialVariableMap;
        }
        createPotentialVariableMap() {
          this.potentialVariableMap = new Vu(this);
        }
        getVariableMap() {
          return this.variableMap;
        }
        setVariableMap(e) {
          this.variableMap = e;
        }
        getProcedureMap() {
          return this.procedureMap;
        }
        getRootWorkspace() {
          let e = null;
          const t = this.options.parentWorkspace;
          return this.isFlyout ? t && t.options && (e = t.options.parentWorkspace) : t && (e = t), e;
        }
        static getById(e) {
          return le(e);
        }
        static getAll() {
          return ue();
        }
      };
      H_.SCAN_ANGLE = 3;
      var zS = 100, FA = class {
        constructor(e) {
          this.parentWorkspace = e, this.sounds = /* @__PURE__ */ new Map(), this.lastSound_ = null;
        }
        dispose() {
          this.sounds.clear();
        }
        load(e, t) {
          if (e.length) {
            try {
              var n = new globalThis.Audio();
            } catch {
              return;
            }
            for (let u = 0; u < e.length; u++) {
              const A = e[u], L = A.match(/\.(\w+)$/);
              if (L && n.canPlayType("audio/" + L[1])) {
                var s = new globalThis.Audio(A);
                break;
              }
            }
            s && this.sounds.set(t, s);
          }
        }
        preload() {
          for (const e of this.sounds.values()) {
            e.volume = 0.01;
            const t = e.play();
            if (t !== void 0 ? t.then(e.pause).catch(function() {
            }) : e.pause(), la || Ki)
              break;
          }
        }
        play(e, t) {
          var n = this.sounds.get(e);
          n ? (e = /* @__PURE__ */ new Date(), this.lastSound_ !== null && e.getTime() - this.lastSound_.getTime() < zS || (this.lastSound_ = e, n = la || nu ? n : n.cloneNode(), n.volume = t === void 0 ? 1 : t, n.play())) : this.parentWorkspace && this.parentWorkspace.getAudioManager().play(e, t);
        }
      }, fi;
      (function(e) {
        e[e.TOP = 0] = "TOP", e[e.BOTTOM = 1] = "BOTTOM";
      })(fi || (fi = {}));
      var fa;
      (function(e) {
        e[e.LEFT = 0] = "LEFT", e[e.RIGHT = 1] = "RIGHT";
      })(fa || (fa = {}));
      var Nl;
      (function(e) {
        e[e.UP = 0] = "UP", e[e.DOWN = 1] = "DOWN";
      })(Nl || (Nl = {}));
      var Ns = {};
      Ns.bumpDirection = Nl, Ns.bumpPositionRect = Zs, Ns.getCornerOppositeToolbox = Cr, Ns.getStartPositionRect = u_, Ns.horizontalPosition = fa, Ns.verticalPosition = fi;
      var Ct = { width: 96, height: 124, url: "sprites.png" }, Gu = class {
        constructor(e) {
          this.workspace = e, this.id = "zoomControls", this.boundEvents = [], this.zoomResetGroup = this.zoomOutGroup = this.zoomInGroup = null, this.HEIGHT = this.WIDTH = 32, this.SMALL_SPACING = 2, this.LARGE_SPACING = 11, this.MARGIN_HORIZONTAL = this.MARGIN_VERTICAL = 20, this.svgGroup = null, this.top = this.left = 0, this.initialized = !1;
        }
        createDom() {
          this.svgGroup = K(G.G, {});
          const e = String(Math.random()).substring(2);
          return this.createZoomOutSvg(e), this.createZoomInSvg(e), this.workspace.isMovable() && this.createZoomResetSvg(e), this.svgGroup;
        }
        init() {
          this.workspace.getComponentManager().addComponent({ component: this, weight: 2, capabilities: [ft.Capability.POSITIONABLE] }), this.initialized = !0;
        }
        dispose() {
          this.workspace.getComponentManager().removeComponent("zoomControls"), this.svgGroup && _t(this.svgGroup);
          for (const e of this.boundEvents)
            Mt(e);
          this.boundEvents.length = 0;
        }
        getBoundingRectangle() {
          let e = this.SMALL_SPACING + 2 * this.HEIGHT;
          return this.zoomResetGroup && (e += this.LARGE_SPACING + this.HEIGHT), new yt(this.top, this.top + e, this.left, this.left + this.WIDTH);
        }
        position(e, t) {
          if (this.initialized) {
            var n = Cr(this.workspace, e), s = this.SMALL_SPACING + 2 * this.HEIGHT;
            if (this.zoomResetGroup && (s += this.LARGE_SPACING + this.HEIGHT), e = u_(
              n,
              new It(this.WIDTH, s),
              this.MARGIN_HORIZONTAL,
              this.MARGIN_VERTICAL,
              e,
              this.workspace
            ), n = n.vertical, t = Zs(e, this.MARGIN_VERTICAL, n === fi.TOP ? Nl.DOWN : Nl.UP, t), n === fi.TOP) {
              var u = this.SMALL_SPACING + this.HEIGHT, A;
              (A = this.zoomInGroup) == null || A.setAttribute("transform", "translate(0, " + u + ")"), this.zoomResetGroup && this.zoomResetGroup.setAttribute("transform", "translate(0, " + (u + this.LARGE_SPACING + this.HEIGHT) + ")");
            } else {
              A = this.zoomResetGroup ? this.LARGE_SPACING + this.HEIGHT : 0;
              let $;
              ($ = this.zoomInGroup) == null || $.setAttribute("transform", "translate(0, " + A + ")"), A = A + this.SMALL_SPACING + this.HEIGHT, (u = this.zoomOutGroup) == null || u.setAttribute("transform", "translate(0, " + A + ")");
            }
            this.top = t.top, this.left = t.left;
            var L;
            (L = this.svgGroup) == null || L.setAttribute("transform", "translate(" + this.left + "," + this.top + ")");
          }
        }
        createZoomOutSvg(e) {
          this.zoomOutGroup = K(G.G, { class: "blocklyZoom" }, this.svgGroup);
          const t = K(G.CLIPPATH, { id: "blocklyZoomoutClipPath" + e }, this.zoomOutGroup);
          K(
            G.RECT,
            { width: 32, height: 32 },
            t
          ), K(G.IMAGE, { width: Ct.width, height: Ct.height, x: -64, y: -92, "clip-path": "url(#blocklyZoomoutClipPath" + e + ")" }, this.zoomOutGroup).setAttributeNS(kn, "xlink:href", this.workspace.options.pathToMedia + Ct.url), this.boundEvents.push(ge(
            this.zoomOutGroup,
            "pointerdown",
            null,
            this.zoom.bind(this, -1)
          ));
        }
        createZoomInSvg(e) {
          this.zoomInGroup = K(G.G, { class: "blocklyZoom" }, this.svgGroup);
          const t = K(G.CLIPPATH, { id: "blocklyZoominClipPath" + e }, this.zoomInGroup);
          K(G.RECT, { width: 32, height: 32 }, t), K(
            G.IMAGE,
            { width: Ct.width, height: Ct.height, x: -32, y: -92, "clip-path": "url(#blocklyZoominClipPath" + e + ")" },
            this.zoomInGroup
          ).setAttributeNS(kn, "xlink:href", this.workspace.options.pathToMedia + Ct.url), this.boundEvents.push(ge(this.zoomInGroup, "pointerdown", null, this.zoom.bind(this, 1)));
        }
        zoom(e, t) {
          this.workspace.markFocused(), this.workspace.zoomCenter(e), this.fireZoomEvent(), Me(), t.stopPropagation(), t.preventDefault();
        }
        createZoomResetSvg(e) {
          this.zoomResetGroup = K(G.G, { class: "blocklyZoom" }, this.svgGroup);
          const t = K(G.CLIPPATH, { id: "blocklyZoomresetClipPath" + e }, this.zoomResetGroup);
          K(
            G.RECT,
            { width: 32, height: 32 },
            t
          ), K(G.IMAGE, { width: Ct.width, height: Ct.height, y: -92, "clip-path": "url(#blocklyZoomresetClipPath" + e + ")" }, this.zoomResetGroup).setAttributeNS(kn, "xlink:href", this.workspace.options.pathToMedia + Ct.url), this.boundEvents.push(ge(
            this.zoomResetGroup,
            "pointerdown",
            null,
            this.resetZoom.bind(this)
          ));
        }
        resetZoom(e) {
          this.workspace.markFocused();
          const t = Math.log(this.workspace.options.zoomOptions.startScale / this.workspace.scale) / Math.log(this.workspace.options.zoomOptions.scaleSpeed);
          this.workspace.beginCanvasTransition(), this.workspace.zoomCenter(t), this.workspace.scrollCenter(), setTimeout(this.workspace.endCanvasTransition.bind(this.workspace), 500), this.fireZoomEvent(), Me(), e.stopPropagation(), e.preventDefault();
        }
        fireZoomEvent() {
          const e = new (fe(Gi))(null, this.workspace.id, "zoom_controls");
          Ce(e);
        }
      };
      Kn(`
.blocklyZoom>image, .blocklyZoom>svg>image {
  opacity: .4;
}

.blocklyZoom>image:hover, .blocklyZoom>svg>image:hover {
  opacity: .6;
}

.blocklyZoom>image:active, .blocklyZoom>svg>image:active {
  opacity: .8;
}
`);
      var JS = 20, Ci = class extends H_ {
        constructor(e) {
          super(e), this.resizeHandlerWrapper = null, this.resizesEnabled = this.isVisible_ = this.rendered = !0, this.startScrollY = this.startScrollX = this.scrollY = this.scrollX = 0, this.dragDeltaXY = null, this.oldScale = this.scale = 1, this.oldLeft = this.oldTop = 0, this.inverseScreenCTM = this.targetWorkspace = this.configureContextMenu = this.lastRecordedPageScroll = this.injectionDiv = this.currentGesture_ = this.toolbox_ = this.flyout = this.scrollbar = this.trashcan = null, this.inverseScreenCTMDirty = !0, this.highlightedBlocks = [], this.toolboxCategoryCallbacks = /* @__PURE__ */ new Map(), this.flyoutButtonCallbacks = /* @__PURE__ */ new Map(), this.cachedParentSvg = null, this.keyboardAccessibilityMode = !1, this.topBoundedElements = [], this.dragTargetAreas = [], this.zoomControls_ = null, this.metricsManager = new (Z(_e.METRICS_MANAGER, e, !0))(this), this.getMetrics = e.getMetrics || this.metricsManager.getMetrics.bind(this.metricsManager), this.setMetrics = e.setMetrics || Ci.setTopLevelWorkspaceMetrics_, this.componentManager = new ft(), this.connectionDBList = Ia.init(this.connectionChecker), this.audioManager = new FA(e.parentWorkspace), this.grid = this.options.gridPattern ? new Cd(this.options.gridPattern, e.gridOptions) : null, this.markerManager = new y_(this), Ar && ke && this.registerToolboxCategoryCallback(hi, ke), wo && es && this.registerToolboxCategoryCallback(
            x_,
            es
          ), Wr && Uc && (this.registerToolboxCategoryCallback(Uu, Uc), this.addChangeListener(pp)), this.themeManager_ = this.options.parentWorkspace ? this.options.parentWorkspace.getThemeManager() : new wA(
            this,
            this.options.theme || hu
          ), this.themeManager_.subscribeWorkspace(this);
          let t;
          this.renderer = ip(this.options.renderer || "geras", this.getTheme(), (t = this.options.rendererOverrides) != null ? t : void 0), this.cachedParentSvgSize = new It(0, 0);
        }
        getMarkerManager() {
          return this.markerManager;
        }
        getMetricsManager() {
          return this.metricsManager;
        }
        setMetricsManager(e) {
          this.metricsManager = e, this.getMetrics = this.metricsManager.getMetrics.bind(this.metricsManager);
        }
        getComponentManager() {
          return this.componentManager;
        }
        setCursorSvg(e) {
          this.markerManager.setCursorSvg(e);
        }
        setMarkerSvg(e) {
          this.markerManager.setMarkerSvg(e);
        }
        getMarker(e) {
          return this.markerManager ? this.markerManager.getMarker(e) : null;
        }
        getCursor() {
          return this.markerManager ? this.markerManager.getCursor() : null;
        }
        getRenderer() {
          return this.renderer;
        }
        getThemeManager() {
          return this.themeManager_;
        }
        getTheme() {
          return this.themeManager_.getTheme();
        }
        setTheme(e) {
          e || (e = hu), this.themeManager_.setTheme(e);
        }
        refreshTheme() {
          this.svgGroup_ && this.renderer.refreshDom(this.svgGroup_, this.getTheme()), this.updateBlockStyles_(this.getAllBlocks(!1).filter(function(t) {
            return !!t.getStyleName();
          })), this.refreshToolboxSelection(), this.toolbox_ && this.toolbox_.refreshTheme(), this.isVisible() && this.setVisible(!0);
          const e = new (fe(Wn))(this.getTheme().name, this.id);
          Ce(e);
        }
        updateBlockStyles_(e) {
          for (let t = 0, n; n = e[t]; t++) {
            const s = n.getStyleName();
            s && n.setStyle(s);
          }
        }
        getInverseScreenCTM() {
          if (this.inverseScreenCTMDirty) {
            const e = this.getParentSvg().getScreenCTM();
            e && (this.inverseScreenCTM = e.inverse(), this.inverseScreenCTMDirty = !1);
          }
          return this.inverseScreenCTM;
        }
        updateInverseScreenCTM() {
          this.inverseScreenCTMDirty = !0;
        }
        isVisible() {
          return this.isVisible_;
        }
        getSvgXY(e) {
          let t = 0, n = 0, s = 1;
          (this.getCanvas().contains(e) || this.getBubbleCanvas().contains(e)) && (s = this.scale);
          do {
            const u = Wl(e);
            (e === this.getCanvas() || e === this.getBubbleCanvas()) && (s = 1), t += u.x * s, n += u.y * s, e = e.parentNode;
          } while (e && e !== this.getParentSvg());
          return new Te(t, n);
        }
        getCachedParentSvgSize() {
          const e = this.cachedParentSvgSize;
          return new It(e.width, e.height);
        }
        getOriginOffsetInPixels() {
          return $a(this.getCanvas());
        }
        getInjectionDiv() {
          if (!this.injectionDiv) {
            let e = this.svgGroup_;
            for (; e; ) {
              if ((" " + (e.getAttribute("class") || "") + " ").indexOf(" injectionDiv ") !== -1) {
                this.injectionDiv = e;
                break;
              }
              e = e.parentNode;
            }
          }
          return this.injectionDiv;
        }
        getBlockCanvas() {
          return this.svgBlockCanvas_;
        }
        setResizeHandlerWrapper(e) {
          this.resizeHandlerWrapper = e;
        }
        createDom(e) {
          return this.svgGroup_ = K(G.G, { class: "blocklyWorkspace" }), e && (this.svgBackground_ = K(
            G.RECT,
            { height: "100%", width: "100%", class: e },
            this.svgGroup_
          ), e === "blocklyMainBackground" && this.grid ? this.svgBackground_.style.fill = "url(#" + this.grid.getPatternId() + ")" : this.themeManager_.subscribe(this.svgBackground_, "workspaceBackgroundColour", "fill")), this.svgBlockCanvas_ = K(G.G, { class: "blocklyBlockCanvas" }, this.svgGroup_), this.svgBubbleCanvas_ = K(
            G.G,
            { class: "blocklyBubbleCanvas" },
            this.svgGroup_
          ), this.isFlyout || (ge(this.svgGroup_, "pointerdown", this, this.onMouseDown_, !1), document.body.addEventListener("wheel", function() {
          }), ge(this.svgGroup_, "wheel", this, this.onMouseWheel_)), this.options.hasCategories && (this.toolbox_ = new (Z(_e.TOOLBOX, this.options, !0))(this)), this.grid && this.grid.update(this.scale), this.recordDragTargets(), (e = Z(_e.CURSOR, this.options)) && this.markerManager.setCursor(new e()), this.renderer.createDom(this.svgGroup_, this.getTheme()), this.svgGroup_;
        }
        dispose() {
          if (this.rendered = !1, this.currentGesture_ && this.currentGesture_.cancel(), this.svgGroup_ && _t(this.svgGroup_), this.toolbox_ && (this.toolbox_.dispose(), this.toolbox_ = null), this.flyout && (this.flyout.dispose(), this.flyout = null), this.trashcan && (this.trashcan.dispose(), this.trashcan = null), this.scrollbar && (this.scrollbar.dispose(), this.scrollbar = null), this.zoomControls_ && this.zoomControls_.dispose(), this.audioManager && this.audioManager.dispose(), this.grid && (this.grid = null), this.renderer.dispose(), this.markerManager && this.markerManager.dispose(), super.dispose(), this.themeManager_ && (this.themeManager_.unsubscribeWorkspace(this), this.themeManager_.unsubscribe(this.svgBackground_), this.options.parentWorkspace || this.themeManager_.dispose()), this.connectionDBList.length = 0, this.toolboxCategoryCallbacks.clear(), this.flyoutButtonCallbacks.clear(), !this.options.parentWorkspace) {
            const e = this.getParentSvg();
            e && e.parentNode && _t(e.parentNode);
          }
          this.resizeHandlerWrapper && (Mt(this.resizeHandlerWrapper), this.resizeHandlerWrapper = null);
        }
        addTrashcan() {
          this.trashcan = Ci.newTrashcan(this);
          const e = this.trashcan.createDom();
          this.svgGroup_.insertBefore(e, this.svgBlockCanvas_);
        }
        static newTrashcan(e) {
          throw Error("The implementation of newTrashcan should be monkey-patched in by blockly.ts");
        }
        addZoomControls() {
          this.zoomControls_ = new Gu(this);
          const e = this.zoomControls_.createDom();
          this.svgGroup_.appendChild(e);
        }
        addFlyout(e) {
          const t = new ti({
            parentWorkspace: this,
            rtl: this.RTL,
            oneBasedIndex: this.options.oneBasedIndex,
            horizontalLayout: this.horizontalLayout,
            renderer: this.options.renderer,
            rendererOverrides: this.options.rendererOverrides,
            move: { scrollbars: !0 }
          });
          return t.toolboxPosition = this.options.toolboxPosition, this.flyout = this.horizontalLayout ? new (Z(_e.FLYOUTS_HORIZONTAL_TOOLBOX, this.options, !0))(t) : new (Z(_e.FLYOUTS_VERTICAL_TOOLBOX, this.options, !0))(t), this.flyout.autoClose = !1, this.flyout.getWorkspace().setVisible(!0), this.flyout.createDom(e);
        }
        getFlyout(e) {
          return this.flyout || e ? this.flyout : this.toolbox_ ? this.toolbox_.getFlyout() : null;
        }
        getToolbox() {
          return this.toolbox_;
        }
        updateScreenCalculations_() {
          this.updateInverseScreenCTM(), this.recordDragTargets();
        }
        resizeContents() {
          this.resizesEnabled && this.rendered && (this.scrollbar && this.scrollbar.resize(), this.updateInverseScreenCTM());
        }
        resize() {
          this.toolbox_ && this.toolbox_.position(), this.flyout && this.flyout.position();
          const e = this.componentManager.getComponents(
            ft.Capability.POSITIONABLE,
            !0
          ), t = this.getMetricsManager().getUiMetrics(), n = [];
          for (let s = 0, u; u = e[s]; s++) {
            u.position(t, n);
            const A = u.getBoundingRectangle();
            A && n.push(A);
          }
          this.scrollbar && this.scrollbar.resize(), this.updateScreenCalculations_();
        }
        updateScreenCalculationsIfScrolled() {
          const e = oc();
          Te.equals(this.lastRecordedPageScroll, e) || (this.lastRecordedPageScroll = e, this.updateScreenCalculations_());
        }
        getCanvas() {
          return this.svgBlockCanvas_;
        }
        setCachedParentSvgSize(e, t) {
          const n = this.getParentSvg();
          e != null && (this.cachedParentSvgSize.width = e, n.setAttribute("data-cached-width", `${e}`)), t != null && (this.cachedParentSvgSize.height = t, n.setAttribute("data-cached-height", `${t}`));
        }
        getBubbleCanvas() {
          return this.svgBubbleCanvas_;
        }
        getParentSvg() {
          if (!this.cachedParentSvg) {
            let e = this.svgGroup_;
            for (; e; ) {
              if (e.tagName === "svg") {
                this.cachedParentSvg = e;
                break;
              }
              e = e.parentNode;
            }
          }
          return this.cachedParentSvg;
        }
        maybeFireViewportChangeEvent() {
          if (nt()) {
            var e = this.scale, t = -this.scrollY, n = -this.scrollX;
            if (!(e === this.oldScale && 1 > Math.abs(t - this.oldTop) && 1 > Math.abs(n - this.oldLeft))) {
              var s = new (fe(al))(t, n, e, this.id, this.oldScale);
              this.oldScale = e, this.oldTop = t, this.oldLeft = n, Ce(s);
            }
          }
        }
        translate(e, t) {
          const n = "translate(" + e + "," + t + ") scale(" + this.scale + ")";
          this.svgBlockCanvas_.setAttribute("transform", n), this.svgBubbleCanvas_.setAttribute(
            "transform",
            n
          ), this.grid && this.grid.moveTo(e, t), this.maybeFireViewportChangeEvent();
        }
        getWidth() {
          const e = this.getMetrics();
          return e ? e.viewWidth / this.scale : 0;
        }
        setVisible(e) {
          if (this.isVisible_ = e, this.svgGroup_)
            if (this.scrollbar && this.scrollbar.setContainerVisible(e), this.getFlyout() && this.getFlyout().setContainerVisible(e), this.getParentSvg().style.display = e ? "block" : "none", this.toolbox_ && this.toolbox_.setVisible(e), e) {
              e = this.getAllBlocks(!1);
              for (let t = e.length - 1; 0 <= t; t--)
                e[t].markDirty();
              this.render(), this.toolbox_ && this.toolbox_.position();
            } else
              this.hideChaff(!0);
        }
        render() {
          for (var e = this.getAllBlocks(!1), t = e.length - 1; 0 <= t; t--)
            e[t].queueRender();
          if (this.currentGesture_)
            for (e = this.currentGesture_.getInsertionMarkers(), t = 0; t < e.length; t++)
              e[t].render(!1);
          this.markerManager.updateMarkers();
        }
        highlightBlock(e, t) {
          if (t === void 0) {
            for (let n = 0, s; s = this.highlightedBlocks[n]; n++)
              s.setHighlighted(!1);
            this.highlightedBlocks.length = 0;
          }
          (e = e ? this.getBlockById(e) : null) && ((t = t === void 0 || t) ? this.highlightedBlocks.indexOf(e) === -1 && this.highlightedBlocks.push(e) : pn(this.highlightedBlocks, e), e.setHighlighted(t));
        }
        paste(e) {
          if (!this.rendered || !e.type && !e.tagName)
            return null;
          this.currentGesture_ && this.currentGesture_.cancel();
          const t = r.getGroup$$module$build$src$core$events$utils();
          t || r.setGroup$$module$build$src$core$events$utils(!0);
          let n;
          try {
            n = e.type ? this.pasteBlock_(null, e) : e.tagName.toLowerCase() === "comment" ? this.pasteWorkspaceComment_(e) : this.pasteBlock_(e, null);
          } finally {
            r.setGroup$$module$build$src$core$events$utils(t);
          }
          return n;
        }
        pasteBlock_(e, t) {
          r.disable$$module$build$src$core$events$utils();
          let n;
          try {
            let s = 0, u = 0;
            if (e) {
              n = r.domToBlock$$module$build$src$core$xml(e, this);
              let A;
              s = parseInt((A = e.getAttribute("x")) != null ? A : "0"), this.RTL && (s = -s);
              let L;
              u = parseInt((L = e.getAttribute("y")) != null ? L : "0");
            } else
              t && (n = Bi(t, this), s = t.x || 10, this.RTL && (s = this.getWidth() - s), u = t.y || 10);
            if (!isNaN(s) && !isNaN(u)) {
              let A;
              do {
                A = !1;
                const L = this.getAllBlocks(!1);
                for (let $ = 0, q; q = L[$]; $++) {
                  const Le = q.getRelativeToSurfaceXY();
                  if (1 >= Math.abs(s - Le.x) && 1 >= Math.abs(u - Le.y)) {
                    A = !0;
                    break;
                  }
                }
                if (!A) {
                  const $ = n.getConnections_(!1);
                  for (let q = 0, Le; Le = $[q]; q++)
                    if (Le.closest(r.config$$module$build$src$core$config.snapRadius, new Te(s, u)).connection) {
                      A = !0;
                      break;
                    }
                }
                A && (s = this.RTL ? s - r.config$$module$build$src$core$config.snapRadius : s + r.config$$module$build$src$core$config.snapRadius, u += 2 * r.config$$module$build$src$core$config.snapRadius);
              } while (A);
              n.moveTo(new Te(
                s,
                u
              ));
            }
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return nt() && !n.isShadow() && Ce(new (fe(r.CREATE$$module$build$src$core$events$utils))(n)), n.select(), n;
        }
        pasteWorkspaceComment_(e) {
          r.disable$$module$build$src$core$events$utils();
          let t;
          try {
            t = $r.fromXmlRendered(e, this);
            let n, s = parseInt((n = e.getAttribute("x")) != null ? n : "0"), u, A = parseInt((u = e.getAttribute("y")) != null ? u : "0");
            isNaN(s) || isNaN(A) || (this.RTL && (s = -s), t.moveBy(s + 50, A + 50));
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          return nt() && Hi.fireCreateEvent(t), t.select(), t;
        }
        refreshToolboxSelection() {
          const e = this.isFlyout ? this.targetWorkspace : this;
          e && !e.currentGesture_ && e.toolbox_ && e.toolbox_.getFlyout() && e.toolbox_.refreshSelection();
        }
        renameVariableById(e, t) {
          super.renameVariableById(e, t), this.refreshToolboxSelection();
        }
        deleteVariableById(e) {
          super.deleteVariableById(e), this.refreshToolboxSelection();
        }
        createVariable(e, t, n) {
          return e = super.createVariable(e, t, n), this.refreshToolboxSelection(), e;
        }
        recordDragTargets() {
          const e = this.componentManager.getComponents(ft.Capability.DRAG_TARGET, !0);
          this.dragTargetAreas = [];
          for (let t = 0, n; n = e[t]; t++) {
            const s = n.getClientRect();
            s && this.dragTargetAreas.push({
              component: n,
              clientRect: s
            });
          }
        }
        newBlock(e, t) {
          throw Error("The implementation of newBlock should be monkey-patched in by blockly.ts");
        }
        getDragTarget(e) {
          for (let t = 0, n; n = this.dragTargetAreas[t]; t++)
            if (n.clientRect.contains(e.clientX, e.clientY))
              return n.component;
          return null;
        }
        onMouseDown_(e) {
          const t = this.getGesture(e);
          t && t.handleWsStart(e, this);
        }
        startDrag(e, t) {
          e = $l(e, this.getParentSvg(), this.getInverseScreenCTM()), e.x /= this.scale, e.y /= this.scale, this.dragDeltaXY = Te.difference(
            t,
            e
          );
        }
        moveDrag(e) {
          return e = $l(e, this.getParentSvg(), this.getInverseScreenCTM()), e.x /= this.scale, e.y /= this.scale, Te.sum(this.dragDeltaXY, e);
        }
        isDragging() {
          return this.currentGesture_ !== null && this.currentGesture_.isDragging();
        }
        isDraggable() {
          return this.options.moveOptions && this.options.moveOptions.drag;
        }
        isMovable() {
          return this.options.moveOptions && !!this.options.moveOptions.scrollbars || this.options.moveOptions && this.options.moveOptions.wheel || this.options.moveOptions && this.options.moveOptions.drag || this.options.zoomOptions && this.options.zoomOptions.wheel || this.options.zoomOptions && this.options.zoomOptions.pinch;
        }
        isMovableHorizontally() {
          const e = !!this.scrollbar;
          return this.isMovable() && (!e || e && this.scrollbar.canScrollHorizontally());
        }
        isMovableVertically() {
          const e = !!this.scrollbar;
          return this.isMovable() && (!e || e && this.scrollbar.canScrollVertically());
        }
        onMouseWheel_(e) {
          if (ko.inProgress())
            e.preventDefault(), e.stopPropagation();
          else {
            var t = this.options.zoomOptions && this.options.zoomOptions.wheel, n = this.options.moveOptions && this.options.moveOptions.wheel;
            if (t || n) {
              var s = ks(e);
              if (Pr)
                var u = e.metaKey;
              t && (e.ctrlKey || u || !n) ? (s = -s.y / 50, t = $l(e, this.getParentSvg(), this.getInverseScreenCTM()), this.zoom(t.x, t.y, s)) : (t = this.scrollX - s.x, n = this.scrollY - s.y, e.shiftKey && !s.x && (t = this.scrollX - s.y, n = this.scrollY), this.scroll(t, n)), e.preventDefault();
            }
          }
        }
        getBlocksBoundingBox() {
          const e = this.getTopBoundedElements();
          if (!e.length)
            return new yt(0, 0, 0, 0);
          const t = e[0].getBoundingRectangle();
          for (let s = 1; s < e.length; s++) {
            var n = e[s];
            n.isInsertionMarker && n.isInsertionMarker() || (n = n.getBoundingRectangle(), n.top < t.top && (t.top = n.top), n.bottom > t.bottom && (t.bottom = n.bottom), n.left < t.left && (t.left = n.left), n.right > t.right && (t.right = n.right));
          }
          return t;
        }
        cleanUp() {
          this.setResizesEnabled(!1), r.setGroup$$module$build$src$core$events$utils(!0);
          const e = this.getTopBlocks(!0);
          let t = 0;
          for (let n = 0, s; s = e[n]; n++) {
            if (!s.isMovable())
              continue;
            const u = s.getRelativeToSurfaceXY();
            s.moveBy(-u.x, t - u.y, ["cleanup"]), s.snapToGrid(), t = s.getRelativeToSurfaceXY().y + s.getHeightWidth().height + this.renderer.getConstants().MIN_BLOCK_HEIGHT;
          }
          r.setGroup$$module$build$src$core$events$utils(!1), this.setResizesEnabled(!0);
        }
        showContextMenu(e) {
          if (!this.options.readOnly && !this.isFlyout) {
            var t = pt.registry.getContextMenuOptions(
              pt.ScopeType.WORKSPACE,
              { workspace: this }
            );
            this.configureContextMenu && this.configureContextMenu(t, e), Dn(e, t, this.RTL);
          }
        }
        updateToolbox(e) {
          if (e = Cc(e)) {
            if (!this.options.languageTree)
              throw Error("Existing toolbox is null.  Can't create new toolbox.");
            if (Yl(e)) {
              if (!this.toolbox_)
                throw Error("Existing toolbox has no categories.  Can't change mode.");
              this.options.languageTree = e, this.toolbox_.render(e);
            } else {
              if (!this.flyout)
                throw Error("Existing toolbox has categories.  Can't change mode.");
              this.options.languageTree = e, this.flyout.show(e);
            }
          } else if (this.options.languageTree)
            throw Error("Can't nullify an existing toolbox.");
        }
        markFocused() {
          this.options.parentWorkspace ? this.options.parentWorkspace.markFocused() : (Ne(this), this.getParentSvg().focus({ preventScroll: !0 }));
        }
        zoom(e, t, n) {
          n = Math.pow(this.options.zoomOptions.scaleSpeed, n);
          const s = this.scale * n;
          if (this.scale !== s) {
            s > this.options.zoomOptions.maxScale ? n = this.options.zoomOptions.maxScale / this.scale : s < this.options.zoomOptions.minScale && (n = this.options.zoomOptions.minScale / this.scale);
            var u = this.getCanvas().getCTM(), A = this.getParentSvg().createSVGPoint();
            A.x = e, A.y = t, A = A.matrixTransform(u.inverse()), e = A.x, t = A.y, u = u.translate(e * (1 - n), t * (1 - n)).scale(n), this.scrollX = u.e, this.scrollY = u.f, this.setScale(s);
          }
        }
        zoomCenter(e) {
          var t = this.getMetrics();
          let n;
          this.flyout ? (n = t.svgWidth ? t.svgWidth / 2 : 0, t = t.svgHeight ? t.svgHeight / 2 : 0) : (n = t.viewWidth / 2 + t.absoluteLeft, t = t.viewHeight / 2 + t.absoluteTop), this.zoom(n, t, e);
        }
        zoomToFit() {
          if (this.isMovable()) {
            var e = this.getMetrics(), t = e.viewWidth;
            e = e.viewHeight;
            var n = this.getBlocksBoundingBox(), s = 2 * JS, u = n.right - n.left + s;
            if (n = n.bottom - n.top + s, u) {
              this.flyout && (this.horizontalLayout ? (e += this.flyout.getHeight(), n += this.flyout.getHeight() / this.scale) : (t += this.flyout.getWidth(), u += this.flyout.getWidth() / this.scale)), t /= u, e /= n, r.disable$$module$build$src$core$events$utils();
              try {
                this.setScale(Math.min(t, e)), this.scrollCenter();
              } finally {
                r.enable$$module$build$src$core$events$utils();
              }
              this.maybeFireViewportChangeEvent();
            }
          } else
            console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        beginCanvasTransition() {
          Re(
            this.svgBlockCanvas_,
            "blocklyCanvasTransitioning"
          ), Re(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
        }
        endCanvasTransition() {
          Ue(this.svgBlockCanvas_, "blocklyCanvasTransitioning"), Ue(this.svgBubbleCanvas_, "blocklyCanvasTransitioning");
        }
        scrollCenter() {
          if (this.isMovable()) {
            var e = this.getMetrics(), t = (e.scrollWidth - e.viewWidth) / 2, n = (e.scrollHeight - e.viewHeight) / 2;
            t = -t - e.scrollLeft, n = -n - e.scrollTop, this.scroll(
              t,
              n
            );
          } else
            console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        centerOnBlock(e, t) {
          if (this.isMovable()) {
            var n = e ? this.getBlockById(e) : null;
            if (n) {
              e = n.getRelativeToSurfaceXY(), n = t ? { height: n.height, width: n.width } : n.getHeightWidth();
              var s = this.scale;
              t = (e.x + (this.RTL ? -1 : 1) * n.width / 2) * s, e = (e.y + n.height / 2) * s, n = this.getMetrics(), this.scroll(-(t - n.viewWidth / 2), -(e - n.viewHeight / 2));
            }
          } else
            console.warn("Tried to move a non-movable workspace. This could result in blocks becoming inaccessible.");
        }
        setScale(e) {
          this.options.zoomOptions.maxScale && e > this.options.zoomOptions.maxScale ? e = this.options.zoomOptions.maxScale : this.options.zoomOptions.minScale && e < this.options.zoomOptions.minScale && (e = this.options.zoomOptions.minScale), this.scale = e, this.hideChaff(!1), (e = this.getFlyout(!1)) && e.isVisible() && (e.reflow(), this.recordDragTargets()), this.grid && this.grid.update(this.scale), e = this.getMetrics(), this.scrollX -= e.absoluteLeft, this.scrollY -= e.absoluteTop, e.viewLeft += e.absoluteLeft, e.viewTop += e.absoluteTop, this.scroll(this.scrollX, this.scrollY), this.scrollbar && (this.flyout ? this.scrollbar.resizeView(e) : this.scrollbar.resizeContent(e));
        }
        getScale() {
          return this.options.parentWorkspace ? this.options.parentWorkspace.getScale() : this.scale;
        }
        scroll(e, t) {
          this.hideChaff(!0);
          const n = this.getMetrics();
          e = Math.min(e, -n.scrollLeft), t = Math.min(t, -n.scrollTop);
          const s = n.scrollTop + Math.max(0, n.scrollHeight - n.viewHeight);
          e = Math.max(e, -(n.scrollLeft + Math.max(0, n.scrollWidth - n.viewWidth))), t = Math.max(t, -s), this.scrollX = e, this.scrollY = t, this.scrollbar && this.scrollbar.set(
            -(e + n.scrollLeft),
            -(t + n.scrollTop),
            !1
          ), e += n.absoluteLeft, t += n.absoluteTop, this.translate(e, t);
        }
        getBlockById(e) {
          return super.getBlockById(e);
        }
        getAllBlocks(e) {
          return super.getAllBlocks(e);
        }
        getTopBlocks(e) {
          return super.getTopBlocks(e);
        }
        addTopBlock(e) {
          this.addTopBoundedElement(e), super.addTopBlock(e);
        }
        removeTopBlock(e) {
          this.removeTopBoundedElement(e), super.removeTopBlock(e);
        }
        addTopComment(e) {
          this.addTopBoundedElement(e), super.addTopComment(e);
        }
        removeTopComment(e) {
          this.removeTopBoundedElement(e), super.removeTopComment(e);
        }
        getRootWorkspace() {
          return super.getRootWorkspace();
        }
        addTopBoundedElement(e) {
          this.topBoundedElements.push(e);
        }
        removeTopBoundedElement(e) {
          pn(
            this.topBoundedElements,
            e
          );
        }
        getTopBoundedElements() {
          return [].concat(this.topBoundedElements);
        }
        setResizesEnabled(e) {
          const t = !this.resizesEnabled && e;
          this.resizesEnabled = e, t && this.resizeContents();
        }
        clear() {
          this.setResizesEnabled(!1), super.clear(), this.topBoundedElements = [], this.setResizesEnabled(!0);
        }
        registerButtonCallback(e, t) {
          if (typeof t != "function")
            throw TypeError("Button callbacks must be functions.");
          this.flyoutButtonCallbacks.set(e, t);
        }
        getButtonCallback(e) {
          let t;
          return (t = this.flyoutButtonCallbacks.get(e)) != null ? t : null;
        }
        removeButtonCallback(e) {
          this.flyoutButtonCallbacks.delete(e);
        }
        registerToolboxCategoryCallback(e, t) {
          if (typeof t != "function")
            throw TypeError("Toolbox category callbacks must be functions.");
          this.toolboxCategoryCallbacks.set(e, t);
        }
        getToolboxCategoryCallback(e) {
          return this.toolboxCategoryCallbacks.get(e) || null;
        }
        removeToolboxCategoryCallback(e) {
          this.toolboxCategoryCallbacks.delete(e);
        }
        getGesture(e) {
          const t = e.type === "pointerdown", n = this.currentGesture_;
          return n ? t && n.hasStarted() ? (console.warn("Tried to start the same gesture twice."), n.cancel(), null) : n : t ? this.currentGesture_ = new ko(
            e,
            this
          ) : null;
        }
        clearGesture() {
          this.currentGesture_ = null;
        }
        cancelCurrentGesture() {
          this.currentGesture_ && this.currentGesture_.cancel();
        }
        getAudioManager() {
          return this.audioManager;
        }
        getGrid() {
          return this.grid;
        }
        hideChaff(e = !1) {
          So(), j(), Ti(), this.hideComponents(e);
        }
        hideComponents(e = !1) {
          this.getComponentManager().getComponents(
            ft.Capability.AUTOHIDEABLE,
            !0
          ).forEach((t) => t.autoHide(e));
        }
        static setTopLevelWorkspaceMetrics_(e) {
          const t = this.getMetrics();
          typeof e.x == "number" && (this.scrollX = -(t.scrollLeft + (t.scrollWidth - t.viewWidth) * e.x)), typeof e.y == "number" && (this.scrollY = -(t.scrollTop + (t.scrollHeight - t.viewHeight) * e.y)), this.translate(this.scrollX + t.absoluteLeft, this.scrollY + t.absoluteTop);
        }
      }, Ca;
      (function(e) {
        e.BLOCK = "block", e.BUTTON = "button";
      })(Ca || (Ca = {}));
      var xu = class extends Fu {
        constructor(e) {
          super(), this.horizontalLayout = !1, this.boundEvents = [], this.filterWrapper = this.reflowWrapper = null, this.mats = [], this.buttons_ = [], this.listeners = [], this.permanentlyDisabled = [], this.recycledBlocks = [], this.autoClose = !0, this.isVisible_ = !1, this.containerVisible = !0, this.CORNER_RADIUS = 8, this.SCROLLBAR_MARGIN = 2.5, this.height_ = this.width_ = 0, this.dragAngleRange_ = 70, this.svgGroup_ = this.svgBackground_ = null, e.setMetrics = this.setMetrics_.bind(this), this.workspace_ = new Ci(e), this.workspace_.setMetricsManager(new $A(this.workspace_, this)), this.workspace_.internalIsFlyout = !0, this.workspace_.setVisible(this.isVisible_), this.id = Yr(), this.RTL = !!e.RTL, this.toolboxPosition_ = e.toolboxPosition, this.tabWidth_ = this.workspace_.getRenderer().getConstants().TAB_WIDTH, this.rectMap_ = /* @__PURE__ */ new WeakMap(), this.MARGIN = this.CORNER_RADIUS, this.GAP_X = 3 * this.MARGIN, this.GAP_Y = 3 * this.MARGIN;
        }
        createDom(e) {
          return this.svgGroup_ = K(e, { class: "blocklyFlyout", style: "display: none" }), this.svgBackground_ = K(G.PATH, { class: "blocklyFlyoutBackground" }, this.svgGroup_), this.svgGroup_.appendChild(this.workspace_.createDom()), this.workspace_.getThemeManager().subscribe(
            this.svgBackground_,
            "flyoutBackgroundColour",
            "fill"
          ), this.workspace_.getThemeManager().subscribe(this.svgBackground_, "flyoutOpacity", "fill-opacity"), this.svgGroup_;
        }
        init(e) {
          this.targetWorkspace = e, this.workspace_.targetWorkspace = e, this.workspace_.scrollbar = new fd(this.workspace_, this.horizontalLayout, !this.horizontalLayout, "blocklyFlyoutScrollbar", this.SCROLLBAR_MARGIN), this.hide(), this.boundEvents.push(ge(
            this.svgGroup_,
            "wheel",
            this,
            this.wheel_
          )), this.autoClose || (this.filterWrapper = this.filterForCapacity.bind(this), this.targetWorkspace.addChangeListener(this.filterWrapper)), this.boundEvents.push(ge(this.svgBackground_, "pointerdown", this, this.onMouseDown)), this.workspace_.getGesture = this.targetWorkspace.getGesture.bind(this.targetWorkspace), this.workspace_.setVariableMap(this.targetWorkspace.getVariableMap()), this.workspace_.createPotentialVariableMap(), e.getComponentManager().addComponent({
            component: this,
            weight: 1,
            capabilities: [ft.Capability.DELETE_AREA, ft.Capability.DRAG_TARGET]
          });
        }
        dispose() {
          this.hide(), this.workspace_.getComponentManager().removeComponent(this.id);
          for (const e of this.boundEvents)
            Mt(e);
          this.boundEvents.length = 0, this.filterWrapper && this.targetWorkspace.removeChangeListener(this.filterWrapper), this.workspace_ && (this.workspace_.getThemeManager().unsubscribe(this.svgBackground_), this.workspace_.dispose()), this.svgGroup_ && _t(this.svgGroup_);
        }
        getWidth() {
          return this.width_;
        }
        getHeight() {
          return this.height_;
        }
        getFlyoutScale() {
          return this.targetWorkspace.scale;
        }
        getWorkspace() {
          return this.workspace_;
        }
        isVisible() {
          return this.isVisible_;
        }
        setVisible(e) {
          const t = e !== this.isVisible();
          this.isVisible_ = e, t && (this.autoClose || this.workspace_.recordDragTargets(), this.updateDisplay());
        }
        setContainerVisible(e) {
          const t = e !== this.containerVisible;
          this.containerVisible = e, t && this.updateDisplay();
        }
        updateDisplay() {
          let e;
          e = this.containerVisible ? this.isVisible() : !1, this.svgGroup_ && (this.svgGroup_.style.display = e ? "block" : "none");
          let t;
          (t = this.workspace_.scrollbar) == null || t.setContainerVisible(e);
        }
        positionAt_(e, t, n, s) {
          let u;
          (u = this.svgGroup_) == null || u.setAttribute("width", `${e}`);
          let A;
          (A = this.svgGroup_) == null || A.setAttribute("height", `${t}`), this.workspace_.setCachedParentSvgSize(e, t), this.svgGroup_ && bi(this.svgGroup_, "translate(" + n + "px," + s + "px)"), (e = this.workspace_.scrollbar) && (e.setOrigin(n, s), e.resize(), e.hScroll && e.hScroll.setPosition(e.hScroll.position.x, e.hScroll.position.y), e.vScroll && e.vScroll.setPosition(e.vScroll.position.x, e.vScroll.position.y));
        }
        hide() {
          if (this.isVisible()) {
            this.setVisible(!1);
            for (const e of this.listeners)
              Mt(e);
            this.listeners.length = 0, this.reflowWrapper && (this.workspace_.removeChangeListener(this.reflowWrapper), this.reflowWrapper = null);
          }
        }
        show(e) {
          this.workspace_.setResizesEnabled(!1), this.hide(), this.clearOldBlocks(), typeof e == "string" && (e = this.getDynamicCategoryContents(e)), this.setVisible(!0), e = Ja(e), e = this.createFlyoutInfo(e), this.layout_(e.contents, e.gaps), this.horizontalLayout ? this.height_ = 0 : this.width_ = 0, this.workspace_.setResizesEnabled(!0), this.reflow(), this.filterForCapacity(), this.position(), this.reflowWrapper = this.reflow.bind(this), this.workspace_.addChangeListener(this.reflowWrapper), this.emptyRecycledBlocks();
        }
        createFlyoutInfo(e) {
          const t = [], n = [];
          this.permanentlyDisabled.length = 0;
          const s = this.horizontalLayout ? this.GAP_X : this.GAP_Y;
          for (const u of e) {
            if ("custom" in u) {
              e = this.getDynamicCategoryContents(u.custom), e = Ja(e);
              const { contents: A, gaps: L } = this.createFlyoutInfo(e);
              t.push(...A), n.push(...L);
            }
            switch (u.kind.toUpperCase()) {
              case "BLOCK":
                e = u;
                const A = this.createFlyoutBlock(e);
                t.push({ type: Ca.BLOCK, block: A }), this.addBlockGap(e, n, s);
                break;
              case "SEP":
                this.addSeparatorGap(u, n, s);
                break;
              case "LABEL":
                e = this.createButton(u, !0), t.push({ type: Ca.BUTTON, button: e }), n.push(s);
                break;
              case "BUTTON":
                e = this.createButton(u, !1), t.push({ type: Ca.BUTTON, button: e }), n.push(s);
            }
          }
          return { contents: t, gaps: n };
        }
        getDynamicCategoryContents(e) {
          if (e = this.workspace_.targetWorkspace.getToolboxCategoryCallback(e), typeof e != "function")
            throw TypeError("Couldn't find a callback function when opening a toolbox category.");
          return e(this.workspace_.targetWorkspace);
        }
        createButton(e, t) {
          return new yi(this.workspace_, this.targetWorkspace, e, t);
        }
        createFlyoutBlock(e) {
          let t;
          return e.blockxml ? (e = typeof e.blockxml == "string" ? r.textToDom$$module$build$src$core$utils$xml(e.blockxml) : e.blockxml, (t = this.getRecycledBlock(e.getAttribute("type"))) || (t = r.domToBlock$$module$build$src$core$xml(e, this.workspace_))) : (t = this.getRecycledBlock(e.type), t || (e.enabled === void 0 && (e.enabled = e.disabled !== "true" && e.disabled !== !0), t = Bi(e, this.workspace_))), t.isEnabled() || this.permanentlyDisabled.push(t), t;
        }
        getRecycledBlock(e) {
          let t = -1;
          for (let n = 0; n < this.recycledBlocks.length; n++)
            if (this.recycledBlocks[n].type === e) {
              t = n;
              break;
            }
          return t === -1 ? void 0 : this.recycledBlocks.splice(t, 1)[0];
        }
        addBlockGap(e, t, n) {
          let s;
          e.gap ? s = parseInt(String(e.gap)) : e.blockxml && (e = typeof e.blockxml == "string" ? r.textToDom$$module$build$src$core$utils$xml(e.blockxml) : e.blockxml, s = parseInt(e.getAttribute("gap"))), t.push(!s || isNaN(s) ? n : s);
        }
        addSeparatorGap(e, t, n) {
          e = parseInt(String(e.gap)), !isNaN(e) && 0 < t.length ? t[t.length - 1] = e : t.push(n);
        }
        clearOldBlocks() {
          var e = this.workspace_.getTopBlocks(!1);
          for (let n = 0, s; s = e[n]; n++)
            this.blockIsRecyclable_(s) ? this.recycleBlock(s) : s.dispose(!1, !1);
          for (e = 0; e < this.mats.length; e++) {
            const n = this.mats[e];
            n && (Jr(n), _t(n));
          }
          this.mats.length = 0;
          for (let n = 0, s; s = this.buttons_[n]; n++)
            s.dispose();
          this.buttons_.length = 0;
          let t;
          (t = this.workspace_.getPotentialVariableMap()) == null || t.clear();
        }
        emptyRecycledBlocks() {
          for (let e = 0; e < this.recycledBlocks.length; e++)
            this.recycledBlocks[e].dispose();
          this.recycledBlocks = [];
        }
        blockIsRecyclable_(e) {
          return !1;
        }
        recycleBlock(e) {
          const t = e.getRelativeToSurfaceXY();
          e.moveBy(-t.x, -t.y), this.recycledBlocks.push(e);
        }
        addBlockListeners_(e, t, n) {
          this.listeners.push(ge(e, "pointerdown", null, this.blockMouseDown(t))), this.listeners.push(ge(
            n,
            "pointerdown",
            null,
            this.blockMouseDown(t)
          )), this.listeners.push(Ir(e, "pointerenter", t, t.addSelect)), this.listeners.push(Ir(e, "pointerleave", t, t.removeSelect)), this.listeners.push(Ir(n, "pointerenter", t, t.addSelect)), this.listeners.push(Ir(n, "pointerleave", t, t.removeSelect));
        }
        blockMouseDown(e) {
          return (t) => {
            const n = this.targetWorkspace.getGesture(t);
            n && (n.setStartBlock(e), n.handleFlyoutStart(t, this));
          };
        }
        onMouseDown(e) {
          const t = this.targetWorkspace.getGesture(e);
          t && t.handleFlyoutStart(e, this);
        }
        isBlockCreatable(e) {
          return e.isEnabled();
        }
        createBlock(e) {
          let t = null;
          r.disable$$module$build$src$core$events$utils();
          var n = this.targetWorkspace.getAllVariables();
          this.targetWorkspace.setResizesEnabled(!1);
          try {
            t = this.placeNewBlock(e);
          } finally {
            r.enable$$module$build$src$core$events$utils();
          }
          if (this.targetWorkspace.hideChaff(), e = W(
            this.targetWorkspace,
            n
          ), nt()) {
            for (r.setGroup$$module$build$src$core$events$utils(!0), n = 0; n < e.length; n++) {
              const s = e[n];
              Ce(new (fe(yo))(s));
            }
            Ce(new (fe(r.CREATE$$module$build$src$core$events$utils))(t));
          }
          return this.autoClose ? this.hide() : this.filterForCapacity(), t;
        }
        initFlyoutButton_(e, t, n) {
          const s = e.createDom();
          e.moveTo(t, n), e.show(), this.listeners.push(ge(s, "pointerdown", this, this.onMouseDown)), this.buttons_.push(e);
        }
        createRect_(e, t, n, s, u) {
          return t = K(G.RECT, { "fill-opacity": 0, x: t, y: n, height: s.height, width: s.width }), t.tooltip = e, Vs(t), this.workspace_.getCanvas().insertBefore(t, e.getSvgRoot()), this.rectMap_.set(e, t), this.mats[u] = t;
        }
        moveRectToBlock_(e, t) {
          const n = t.getHeightWidth();
          e.setAttribute("width", String(n.width)), e.setAttribute("height", String(n.height)), t = t.getRelativeToSurfaceXY(), e.setAttribute("y", String(t.y)), e.setAttribute("x", String(this.RTL ? t.x - n.width : t.x));
        }
        filterForCapacity() {
          const e = this.workspace_.getTopBlocks(!1);
          for (let t = 0, n; n = e[t]; t++)
            if (this.permanentlyDisabled.indexOf(n) === -1) {
              const s = this.targetWorkspace.isCapacityAvailable(Pt(n));
              for (; n; )
                n.setEnabled(s), n = n.getNextBlock();
            }
        }
        reflow() {
          this.reflowWrapper && this.workspace_.removeChangeListener(this.reflowWrapper), this.reflowInternal_(), this.reflowWrapper && this.workspace_.addChangeListener(this.reflowWrapper);
        }
        isScrollable() {
          return this.workspace_.scrollbar ? this.workspace_.scrollbar.isVisible() : !1;
        }
        placeNewBlock(e) {
          var t = this.targetWorkspace;
          if (!e.getSvgRoot())
            throw Error("oldBlock is not rendered");
          const n = ui(e);
          return t.setResizesEnabled(!1), t = Bi(
            n,
            t
          ), this.positionNewBlock(e, t), t;
        }
        positionNewBlock(e, t) {
          const n = this.targetWorkspace;
          var s = n.getOriginOffsetInPixels(), u = this.workspace_.getOriginOffsetInPixels();
          e = e.getRelativeToSurfaceXY(), e.scale(this.workspace_.scale), u = Te.sum(u, e), s = Te.difference(u, s), s.scale(1 / n.scale), t.moveTo(new Te(s.x, s.y));
        }
      };
      xu.FlyoutItemType = Ca;
      var Hu = class extends xu {
        constructor(e) {
          super(e), this.horizontalLayout = !0;
        }
        setMetrics_(e) {
          if (this.isVisible()) {
            var t = this.workspace_.getMetricsManager(), n = t.getScrollMetrics(), s = t.getViewMetrics();
            t = t.getAbsoluteMetrics(), typeof e.x == "number" && (this.workspace_.scrollX = -(n.left + (n.width - s.width) * e.x)), this.workspace_.translate(this.workspace_.scrollX + t.left, this.workspace_.scrollY + t.top);
          }
        }
        getX() {
          return 0;
        }
        getY() {
          if (!this.isVisible())
            return 0;
          var e = this.targetWorkspace.getMetricsManager();
          const t = e.getAbsoluteMetrics(), n = e.getViewMetrics();
          e = e.getToolboxMetrics();
          const s = this.toolboxPosition_ === Ge.TOP;
          return this.targetWorkspace.toolboxPosition === this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? s ? e.height : n.height - this.height_ : s ? 0 : n.height : s ? 0 : n.height + t.top - this.height_;
        }
        position() {
          if (this.isVisible() && this.targetWorkspace.isVisible()) {
            var e = this.targetWorkspace.getMetricsManager().getViewMetrics();
            this.width_ = e.width, this.setBackgroundPath(e.width - 2 * this.CORNER_RADIUS, this.height_ - this.CORNER_RADIUS), e = this.getX();
            var t = this.getY();
            this.positionAt_(this.width_, this.height_, e, t);
          }
        }
        setBackgroundPath(e, t) {
          const n = this.toolboxPosition_ === Ge.TOP, s = ["M 0," + (n ? 0 : this.CORNER_RADIUS)];
          n ? (s.push("h", e + 2 * this.CORNER_RADIUS), s.push("v", t), s.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, -this.CORNER_RADIUS, this.CORNER_RADIUS), s.push("h", -e), s.push(
            "a",
            this.CORNER_RADIUS,
            this.CORNER_RADIUS,
            0,
            0,
            1,
            -this.CORNER_RADIUS,
            -this.CORNER_RADIUS
          )) : (s.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, -this.CORNER_RADIUS), s.push("h", e), s.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, 1, this.CORNER_RADIUS, this.CORNER_RADIUS), s.push("v", t), s.push("h", -e - 2 * this.CORNER_RADIUS)), s.push("z"), this.svgBackground_.setAttribute("d", s.join(" "));
        }
        scrollToStart() {
          let e;
          (e = this.workspace_.scrollbar) == null || e.setX(this.RTL ? 1 / 0 : 0);
        }
        wheel_(e) {
          var t = ks(e);
          if (t = t.x || t.y) {
            const n = this.workspace_.getMetricsManager(), s = n.getScrollMetrics();
            t = n.getViewMetrics().left - s.left + t;
            let u;
            (u = this.workspace_.scrollbar) == null || u.setX(t), j(), Ti();
          }
          e.preventDefault(), e.stopPropagation();
        }
        layout_(e, t) {
          this.workspace_.scale = this.targetWorkspace.scale;
          const n = this.MARGIN;
          let s = n + this.tabWidth_;
          this.RTL && (e = e.reverse());
          for (let $ = 0, q; q = e[$]; $++)
            if (q.type === "block") {
              var u = q.block, A = u.getDescendants(!1);
              for (let _r = 0, Bt; Bt = A[_r]; _r++)
                Bt.isInFlyout = !0;
              A = u.getSvgRoot();
              const Le = u.getHeightWidth();
              var L = u.outputConnection ? this.tabWidth_ : 0;
              L = this.RTL ? s + Le.width : s - L, u.moveBy(L, n), L = this.createRect_(u, L, n, Le, $), s += Le.width + t[$], this.addBlockListeners_(A, u, L);
            } else
              q.type === "button" && (u = q.button, this.initFlyoutButton_(u, s, n), s += u.width + t[$]);
        }
        isDragTowardWorkspace(e) {
          e = Math.atan2(e.y, e.x) / Math.PI * 180;
          const t = this.dragAngleRange_;
          return e < 90 + t && e > 90 - t || e > -90 - t && e < -90 + t;
        }
        getClientRect() {
          if (!this.svgGroup_ || this.autoClose || !this.isVisible())
            return null;
          const e = this.svgGroup_.getBoundingClientRect(), t = e.top;
          return this.toolboxPosition_ === Ge.TOP ? new yt(-1e9, t + e.height, -1e9, 1e9) : new yt(t, 1e9, -1e9, 1e9);
        }
        reflowInternal_() {
          this.workspace_.scale = this.getFlyoutScale();
          let e = 0;
          const t = this.workspace_.getTopBlocks(!1);
          for (let s = 0, u; u = t[s]; s++)
            e = Math.max(e, u.getHeightWidth().height);
          const n = this.buttons_;
          for (let s = 0, u; u = n[s]; s++)
            e = Math.max(e, u.height);
          if (e += 1.5 * this.MARGIN, e *= this.workspace_.scale, e += Zt.scrollbarThickness, this.height_ !== e) {
            for (let s = 0, u; u = t[s]; s++)
              this.rectMap_.has(u) && this.moveRectToBlock_(this.rectMap_.get(u), u);
            this.targetWorkspace.toolboxPosition !== this.toolboxPosition_ || this.toolboxPosition_ !== Ge.TOP || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX, this.targetWorkspace.scrollY + e), this.height_ = e, this.position(), this.targetWorkspace.recordDragTargets();
          }
        }
      };
      o(_e.FLYOUTS_HORIZONTAL_TOOLBOX, Vi, Hu);
      var vd = class extends xu {
        constructor(e) {
          super(e);
        }
        setMetrics_(e) {
          if (this.isVisible()) {
            var t = this.workspace_.getMetricsManager(), n = t.getScrollMetrics(), s = t.getViewMetrics();
            t = t.getAbsoluteMetrics(), typeof e.y == "number" && (this.workspace_.scrollY = -(n.top + (n.height - s.height) * e.y)), this.workspace_.translate(this.workspace_.scrollX + t.left, this.workspace_.scrollY + t.top);
          }
        }
        getX() {
          if (!this.isVisible())
            return 0;
          var e = this.targetWorkspace.getMetricsManager();
          const t = e.getAbsoluteMetrics(), n = e.getViewMetrics();
          return e = e.getToolboxMetrics(), this.targetWorkspace.toolboxPosition === this.toolboxPosition_ ? this.targetWorkspace.getToolbox() ? this.toolboxPosition_ === Ge.LEFT ? e.width : n.width - this.width_ : this.toolboxPosition_ === Ge.LEFT ? 0 : n.width : this.toolboxPosition_ === Ge.LEFT ? 0 : n.width + t.left - this.width_;
        }
        getY() {
          return 0;
        }
        position() {
          if (this.isVisible() && this.targetWorkspace.isVisible()) {
            var e = this.targetWorkspace.getMetricsManager().getViewMetrics();
            this.height_ = e.height, this.setBackgroundPath(this.width_ - this.CORNER_RADIUS, e.height - 2 * this.CORNER_RADIUS), e = this.getX();
            var t = this.getY();
            this.positionAt_(this.width_, this.height_, e, t);
          }
        }
        setBackgroundPath(e, t) {
          const n = this.toolboxPosition_ === Ge.RIGHT;
          var s = e + this.CORNER_RADIUS;
          s = ["M " + (n ? s : 0) + ",0"], s.push("h", n ? -e : e), s.push(
            "a",
            this.CORNER_RADIUS,
            this.CORNER_RADIUS,
            0,
            0,
            n ? 0 : 1,
            n ? -this.CORNER_RADIUS : this.CORNER_RADIUS,
            this.CORNER_RADIUS
          ), s.push("v", Math.max(0, t)), s.push("a", this.CORNER_RADIUS, this.CORNER_RADIUS, 0, 0, n ? 0 : 1, n ? this.CORNER_RADIUS : -this.CORNER_RADIUS, this.CORNER_RADIUS), s.push("h", n ? e : -e), s.push("z"), this.svgBackground_.setAttribute("d", s.join(" "));
        }
        scrollToStart() {
          let e;
          (e = this.workspace_.scrollbar) == null || e.setY(0);
        }
        wheel_(e) {
          var t = ks(e);
          if (t.y) {
            const n = this.workspace_.getMetricsManager(), s = n.getScrollMetrics();
            t = n.getViewMetrics().top - s.top + t.y;
            let u;
            (u = this.workspace_.scrollbar) == null || u.setY(t), j(), Ti();
          }
          e.preventDefault(), e.stopPropagation();
        }
        layout_(e, t) {
          this.workspace_.scale = this.targetWorkspace.scale;
          var n = this.MARGIN;
          const s = this.RTL ? n : n + this.tabWidth_;
          for (let $ = 0, q; q = e[$]; $++)
            if (q.type === "block") {
              var u = q.block, A = u.getDescendants(!1);
              for (let _r = 0, Bt; Bt = A[_r]; _r++)
                Bt.isInFlyout = !0;
              A = u.getSvgRoot();
              const Le = u.getHeightWidth();
              var L = u.outputConnection ? s - this.tabWidth_ : s;
              u.moveBy(L, n), L = this.createRect_(u, this.RTL ? L - Le.width : L, n, Le, $), this.addBlockListeners_(A, u, L), n += Le.height + t[$];
            } else
              q.type === "button" && (u = q.button, this.initFlyoutButton_(u, s, n), n += u.height + t[$]);
        }
        isDragTowardWorkspace(e) {
          e = Math.atan2(e.y, e.x) / Math.PI * 180;
          const t = this.dragAngleRange_;
          return e < t && e > -t || e < -180 + t || e > 180 - t;
        }
        getClientRect() {
          if (!this.svgGroup_ || this.autoClose || !this.isVisible())
            return null;
          const e = this.svgGroup_.getBoundingClientRect(), t = e.left;
          return this.toolboxPosition_ === Ge.LEFT ? new yt(-1e9, 1e9, -1e9, t + e.width) : new yt(-1e9, 1e9, t, 1e9);
        }
        reflowInternal_() {
          this.workspace_.scale = this.getFlyoutScale();
          let e = 0;
          var t = this.workspace_.getTopBlocks(!1);
          for (let s = 0, u; u = t[s]; s++) {
            var n = u.getHeightWidth().width;
            u.outputConnection && (n -= this.tabWidth_), e = Math.max(e, n);
          }
          for (let s = 0, u; u = this.buttons_[s]; s++)
            e = Math.max(e, u.width);
          if (e += 1.5 * this.MARGIN + this.tabWidth_, e *= this.workspace_.scale, e += Zt.scrollbarThickness, this.width_ !== e) {
            for (let s = 0, u; u = t[s]; s++) {
              if (this.RTL) {
                n = u.getRelativeToSurfaceXY().x;
                let A = e / this.workspace_.scale - this.MARGIN;
                u.outputConnection || (A -= this.tabWidth_), u.moveBy(A - n, 0);
              }
              this.rectMap_.has(u) && this.moveRectToBlock_(this.rectMap_.get(u), u);
            }
            if (this.RTL)
              for (let s = 0, u; u = this.buttons_[s]; s++)
                t = u.getPosition().y, u.moveTo(e / this.workspace_.scale - u.width - this.MARGIN - this.tabWidth_, t);
            this.targetWorkspace.toolboxPosition !== this.toolboxPosition_ || this.toolboxPosition_ !== Ge.LEFT || this.targetWorkspace.getToolbox() || this.targetWorkspace.translate(this.targetWorkspace.scrollX + e, this.targetWorkspace.scrollY), this.width_ = e, this.position(), this.targetWorkspace.recordDragTargets();
          }
        }
      };
      vd.registryName = "verticalFlyout", o(_e.FLYOUTS_VERTICAL_TOOLBOX, Vi, vd);
      var Yu;
      r.CodeGenerator$$module$build$src$core$generator = class {
        constructor(e) {
          this.forBlock = /* @__PURE__ */ Object.create(null), this.FUNCTION_NAME_PLACEHOLDER_ = "{leCUI8hutHZI4480Dc}", this.STATEMENT_SUFFIX = this.STATEMENT_PREFIX = this.INFINITE_LOOP_TRAP = null, this.INDENT = "  ", this.COMMENT_WRAP = 60, this.ORDER_OVERRIDES = [], this.isInitialized = null, this.RESERVED_WORDS_ = "", this.definitions_ = /* @__PURE__ */ Object.create(null), this.functionNames_ = /* @__PURE__ */ Object.create(null), this.nameDB_ = void 0, this.name_ = e, this.FUNCTION_NAME_PLACEHOLDER_REGEXP_ = new RegExp(
            this.FUNCTION_NAME_PLACEHOLDER_,
            "g"
          );
        }
        workspaceToCode(e) {
          e || (console.warn("No workspace specified in workspaceToCode call.  Guessing."), e = ae());
          var t = [];
          this.init(e), e = e.getTopBlocks(!0);
          for (let n = 0, s; s = e[n]; n++) {
            let u = this.blockToCode(s);
            Array.isArray(u) && (u = u[0]), u && (s.outputConnection && (u = this.scrubNakedValue(u), this.STATEMENT_PREFIX && !s.suppressPrefixSuffix && (u = this.injectId(this.STATEMENT_PREFIX, s) + u), this.STATEMENT_SUFFIX && !s.suppressPrefixSuffix && (u += this.injectId(
              this.STATEMENT_SUFFIX,
              s
            ))), t.push(u));
          }
          return t = t.join(`
`), t = this.finish(t), t = t.replace(/^\s+\n/, ""), t = t.replace(/\n\s+$/, `
`), t = t.replace(/[ \t]+\n/g, `
`);
        }
        prefixLines(e, t) {
          return t + e.replace(/(?!\n$)\n/g, `
` + t);
        }
        allNestedComments(e) {
          const t = [];
          e = e.getDescendants(!0);
          for (let n = 0; n < e.length; n++) {
            const s = e[n].getCommentText();
            s && t.push(s);
          }
          return t.length && t.push(""), t.join(`
`);
        }
        blockToCode(e, t) {
          if (this.isInitialized === !1 && console.warn("CodeGenerator init was not called before blockToCode was called."), !e)
            return "";
          if (!e.isEnabled())
            return t ? "" : this.blockToCode(e.getNextBlock());
          if (e.isInsertionMarker())
            return t ? "" : this.blockToCode(e.getChildren(!1)[0]);
          var n = this.forBlock[e.type];
          if (!n && this[e.type] && (hr("block generator functions on CodeGenerator objects", "10.0", "11.0", "the .forBlock[blockType] dictionary"), n = this[e.type]), typeof n != "function")
            throw Error(`${this.name_} generator does not know how to generate codefor block type "${e.type}".`);
          if (n = n.call(e, e, this), Array.isArray(n)) {
            if (!e.outputConnection)
              throw TypeError("Expecting string from statement block: " + e.type);
            return [this.scrub_(e, n[0], t), n[1]];
          }
          if (typeof n == "string")
            return this.STATEMENT_PREFIX && !e.suppressPrefixSuffix && (n = this.injectId(this.STATEMENT_PREFIX, e) + n), this.STATEMENT_SUFFIX && !e.suppressPrefixSuffix && (n += this.injectId(this.STATEMENT_SUFFIX, e)), this.scrub_(e, n, t);
          if (n === null)
            return "";
          throw SyntaxError("Invalid code generated: " + n);
        }
        valueToCode(e, t, n) {
          if (isNaN(n))
            throw TypeError("Expecting valid order from block: " + e.type);
          var s = e.getInputTargetBlock(t);
          if (!s || (t = this.blockToCode(s), t === ""))
            return "";
          if (!Array.isArray(t))
            throw TypeError(`Expecting tuple from value block: ${s.type} See developers.google.com/blockly/guides/create-custom-blocks/generating-code for more information`);
          if (e = t[0], t = t[1], isNaN(t))
            throw TypeError("Expecting valid order from value block: " + s.type);
          if (!e)
            return "";
          s = !1;
          var u = Math.floor(n);
          const A = Math.floor(t);
          if (u <= A && (u !== A || u !== 0 && u !== 99)) {
            for (s = !0, u = 0; u < this.ORDER_OVERRIDES.length; u++)
              if (this.ORDER_OVERRIDES[u][0] === n && this.ORDER_OVERRIDES[u][1] === t) {
                s = !1;
                break;
              }
          }
          return s && (e = "(" + e + ")"), e;
        }
        statementToCode(e, t) {
          if (e = e.getInputTargetBlock(t), t = this.blockToCode(e), typeof t != "string")
            throw TypeError("Expecting code from statement block: " + (e && e.type));
          return t && (t = this.prefixLines(t, this.INDENT)), t;
        }
        addLoopTrap(e, t) {
          return this.INFINITE_LOOP_TRAP && (e = this.prefixLines(this.injectId(this.INFINITE_LOOP_TRAP, t), this.INDENT) + e), this.STATEMENT_SUFFIX && !t.suppressPrefixSuffix && (e = this.prefixLines(this.injectId(this.STATEMENT_SUFFIX, t), this.INDENT) + e), this.STATEMENT_PREFIX && !t.suppressPrefixSuffix && (e += this.prefixLines(this.injectId(this.STATEMENT_PREFIX, t), this.INDENT)), e;
        }
        injectId(e, t) {
          return t = t.id.replace(/\$/g, "$$$$"), e.replace(/%1/g, "'" + t + "'");
        }
        addReservedWords(e) {
          this.RESERVED_WORDS_ += e + ",";
        }
        provideFunction_(e, t) {
          if (!this.definitions_[e]) {
            const n = this.nameDB_.getDistinctName(e, r.NameType$$module$build$src$core$names.PROCEDURE);
            this.functionNames_[e] = n, Array.isArray(t) && (t = t.join(`
`)), t = t.trim().replace(this.FUNCTION_NAME_PLACEHOLDER_REGEXP_, n);
            let s;
            for (; s !== t; )
              s = t, t = t.replace(/^(( {2})*) {2}/gm, "$1\0");
            t = t.replace(/\0/g, this.INDENT), this.definitions_[e] = t;
          }
          return this.functionNames_[e];
        }
        init(e) {
          this.definitions_ = /* @__PURE__ */ Object.create(null), this.functionNames_ = /* @__PURE__ */ Object.create(null);
        }
        scrub_(e, t, n) {
          return t;
        }
        finish(e) {
          return this.definitions_ = /* @__PURE__ */ Object.create(null), this.functionNames_ = /* @__PURE__ */ Object.create(null), e;
        }
        scrubNakedValue(e) {
          return e;
        }
      }, Yu = {}, Yu.CodeGenerator = r.CodeGenerator$$module$build$src$core$generator;
      var At = class {
        constructor() {
          this.shortcuts = /* @__PURE__ */ new Map(), this.keyMap = /* @__PURE__ */ new Map(), this.reset();
        }
        reset() {
          this.shortcuts.clear(), this.keyMap.clear();
        }
        register(e, t) {
          if (this.shortcuts.get(e.name) && !t)
            throw Error(`Shortcut named "${e.name}" already exists.`);
          if (this.shortcuts.set(e.name, e), (t = e.keyCodes) && 0 < t.length)
            for (let n = 0; n < t.length; n++)
              this.addKeyMapping(t[n], e.name, !!e.allowCollision);
        }
        unregister(e) {
          return this.shortcuts.get(e) ? (this.removeAllKeyMappings(e), this.shortcuts.delete(e), !0) : (console.warn(`Keyboard shortcut named "${e}" not found.`), !1);
        }
        addKeyMapping(e, t, n) {
          e = `${e}`;
          const s = this.keyMap.get(e);
          if (s && !n)
            throw Error(`Shortcut named "${t}" collides with shortcuts "${s}"`);
          s && n ? s.unshift(t) : this.keyMap.set(e, [t]);
        }
        removeKeyMapping(e, t, n) {
          const s = this.keyMap.get(e);
          if (!s)
            return n || console.warn(`No keyboard shortcut named "${t}" registered with key code "${e}"`), !1;
          const u = s.indexOf(t);
          return -1 < u ? (s.splice(u, 1), s.length === 0 && this.keyMap.delete(e), !0) : (n || console.warn(`No keyboard shortcut named "${t}" registered with key code "${e}"`), !1);
        }
        removeAllKeyMappings(e) {
          for (const t of this.keyMap.keys())
            this.removeKeyMapping(t, e, !0);
        }
        setKeyMap(e) {
          this.keyMap.clear();
          for (const t in e)
            this.keyMap.set(t, e[t]);
        }
        getKeyMap() {
          const e = /* @__PURE__ */ Object.create(null);
          for (const [t, n] of this.keyMap)
            e[t] = n;
          return e;
        }
        getRegistry() {
          const e = /* @__PURE__ */ Object.create(null);
          for (const [t, n] of this.shortcuts)
            e[t] = n;
          return zn(/* @__PURE__ */ Object.create(null), e);
        }
        onKeyDown(e, t) {
          var n = this.serializeKeyEvent_(t);
          if (n = this.getShortcutNamesByKeyCode(n), !n)
            return !1;
          for (let s = 0, u; u = n[s]; s++) {
            const A = this.shortcuts.get(u);
            let L, $;
            if ((L = A) == null || !L.preconditionFn || ($ = A) != null && $.preconditionFn(e)) {
              let q, Le;
              if ((q = A) != null && q.callback && ((Le = A) != null && Le.callback(e, t, A)))
                return !0;
            }
          }
          return !1;
        }
        getShortcutNamesByKeyCode(e) {
          return this.keyMap.get(e) || [];
        }
        getKeyCodesByShortcutName(e) {
          const t = [];
          for (const [n, s] of this.keyMap)
            -1 < s.indexOf(e) && t.push(n);
          return t;
        }
        serializeKeyEvent_(e) {
          let t = "";
          for (const n in At.modifierKeys)
            e.getModifierState(n) && (t !== "" && (t += "+"), t += n);
          return t !== "" && e.keyCode ? t = t + "+" + e.keyCode : e.keyCode && (t = String(e.keyCode)), t;
        }
        checkModifiers_(e) {
          for (let t = 0, n; n = e[t]; t++)
            if (!(n in At.modifierKeys))
              throw Error(n + " is not a valid modifier key.");
        }
        createSerializedKey(e, t) {
          let n = "";
          if (t) {
            this.checkModifiers_(t);
            for (const s in At.modifierKeys)
              -1 < t.indexOf(At.modifierKeys[s]) && (n !== "" && (n += "+"), n += s);
          }
          return n !== "" && e ? n = n + "+" + e : e && (n = `${e}`), n;
        }
      };
      At.registry = new At(), function(e) {
        e = e.modifierKeys || (e.modifierKeys = {}), e[e.Shift = 16] = "Shift", e[e.Control = 17] = "Control", e[e.Alt = 18] = "Alt", e[e.Meta = 91] = "Meta";
      }(At || (At = {}));
      var BA = !1, ys = {};
      ys.Align = r.Align$$module$build$src$core$inputs$align, ys.DummyInput = ni, ys.Input = $o, ys.StatementInput = wn, ys.ValueInput = r.ValueInput$$module$build$src$core$inputs$value_input, ys.inputTypes = r.inputTypes$$module$build$src$core$inputs$input_types;
      var UA = class extends Il {
        constructor() {
          super(), this.FIELD_TEXT_BASELINE_CENTER = !1, this.DARK_PATH_OFFSET = 1, this.MAX_BOTTOM_WIDTH = 30, this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT / 2;
        }
        getCSS_(e) {
          return super.getCSS_(e).concat([
            `${e} .blocklyInsertionMarker>.blocklyPathLight,`,
            `${e} .blocklyInsertionMarker>.blocklyPathDark {`,
            `fill-opacity: ${this.INSERTION_MARKER_OPACITY};`,
            "stroke: none;",
            "}"
          ]);
        }
      }, Rd = class {
        constructor(e) {
          this.inlineSteps_ = this.steps_ = "", this.info_ = e, this.RTL_ = this.info_.RTL, e = e.getRenderer(), this.constants_ = e.getConstants(), this.highlightConstants_ = e.getHighlightConstants(), this.highlightOffset = this.highlightConstants_.OFFSET, this.outsideCornerPaths_ = this.highlightConstants_.OUTSIDE_CORNER, this.insideCornerPaths_ = this.highlightConstants_.INSIDE_CORNER, this.puzzleTabPaths_ = this.highlightConstants_.PUZZLE_TAB, this.notchPaths_ = this.highlightConstants_.NOTCH, this.startPaths_ = this.highlightConstants_.START_HAT, this.jaggedTeethPaths_ = this.highlightConstants_.JAGGED_TEETH;
        }
        getPath() {
          return this.steps_ + `
` + this.inlineSteps_;
        }
        drawTopCorner(e) {
          this.steps_ += wt(e.xPos, this.info_.startY);
          for (let t = 0, n; n = e.elements[t]; t++)
            F.isLeftSquareCorner(n) ? this.steps_ += this.highlightConstants_.START_POINT : F.isLeftRoundedCorner(n) ? this.steps_ += this.outsideCornerPaths_.topLeft(this.RTL_) : F.isPreviousConnection(n) ? this.steps_ += this.notchPaths_.pathLeft : F.isHat(n) ? this.steps_ += this.startPaths_.path(this.RTL_) : F.isSpacer(n) && n.width !== 0 && (this.steps_ += Ae("H", n.xPos + n.width - this.highlightOffset));
          this.steps_ += Ae(
            "H",
            e.xPos + e.width - this.highlightOffset
          );
        }
        drawJaggedEdge_(e) {
          this.info_.RTL && (this.steps_ += this.jaggedTeethPaths_.pathLeft + Ae("v", e.height - this.jaggedTeethPaths_.height - this.highlightOffset));
        }
        drawValueInput(e) {
          const t = e.getLastInput();
          if (this.RTL_) {
            const n = e.height - t.connectionHeight;
            this.steps_ += br(t.xPos + t.width - this.highlightOffset, e.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_) + Ae(
              "v",
              n
            );
          } else
            this.steps_ += br(t.xPos + t.width, e.yPos) + this.puzzleTabPaths_.pathDown(this.RTL_);
        }
        drawStatementInput(e) {
          const t = e.getLastInput();
          if (t)
            if (this.RTL_) {
              const n = e.height - 2 * this.insideCornerPaths_.height;
              this.steps_ += br(t.xPos, e.yPos) + this.insideCornerPaths_.pathTop(this.RTL_) + Ae("v", n) + this.insideCornerPaths_.pathBottom(this.RTL_) + di(e.width - t.xPos - this.insideCornerPaths_.width, 0);
            } else
              this.steps_ += br(t.xPos, e.yPos + e.height) + this.insideCornerPaths_.pathBottom(this.RTL_) + di(e.width - t.xPos - this.insideCornerPaths_.width, 0);
        }
        drawRightSideRow(e) {
          const t = e.xPos + e.width - this.highlightOffset;
          e instanceof md && e.followsStatement && (this.steps_ += Ae("H", t)), this.RTL_ && (this.steps_ += Ae("H", t), e.height > this.highlightOffset && (this.steps_ += Ae("V", e.yPos + e.height - this.highlightOffset)));
        }
        drawBottomRow(e) {
          if (this.RTL_)
            this.steps_ += Ae("V", e.baseline - this.highlightOffset);
          else {
            const t = this.info_.bottomRow.elements[0];
            F.isLeftSquareCorner(t) ? this.steps_ += br(e.xPos + this.highlightOffset, e.baseline - this.highlightOffset) : F.isLeftRoundedCorner(t) && (this.steps_ += br(e.xPos, e.baseline), this.steps_ += this.outsideCornerPaths_.bottomLeft());
          }
        }
        drawLeft() {
          var e = this.info_.outputConnection;
          e && (e = e.connectionOffsetY + e.height, this.RTL_ ? this.steps_ += br(this.info_.startX, e) : (this.steps_ += br(this.info_.startX + this.highlightOffset, this.info_.bottomRow.baseline - this.highlightOffset), this.steps_ += Ae("V", e)), this.steps_ += this.puzzleTabPaths_.pathUp(this.RTL_)), this.RTL_ || (e = this.info_.topRow, F.isLeftRoundedCorner(e.elements[0]) ? this.steps_ += Ae("V", this.outsideCornerPaths_.height) : this.steps_ += Ae("V", e.capline + this.highlightOffset));
        }
        drawInlineInput(e) {
          const t = this.highlightOffset, n = e.xPos + e.connectionWidth;
          var s = e.centerline - e.height / 2;
          const u = e.width - e.connectionWidth, A = s + t;
          this.RTL_ ? (s = e.connectionOffsetY - t, e = e.height - (e.connectionOffsetY + e.connectionHeight) + t, this.inlineSteps_ += br(n - t, A) + Ae("v", s) + this.puzzleTabPaths_.pathDown(this.RTL_) + Ae("v", e) + Ae("h", u)) : this.inlineSteps_ += br(e.xPos + e.width + t, A) + Ae("v", e.height) + Ae("h", -u) + br(n, s + e.connectionOffsetY) + this.puzzleTabPaths_.pathDown(this.RTL_);
        }
      }, VA = class extends W_ {
        constructor(e, t) {
          super(e, t), this.highlighter_ = new Rd(t);
        }
        draw() {
          this.drawOutline_(), this.drawInternals_();
          const e = this.block_.pathObject;
          e.setPath(this.outlinePath_ + `
` + this.inlinePath_), e.setHighlightPath(this.highlighter_.getPath()), this.info_.RTL && e.flipRTL(), this.recordSizeOnBlock_();
        }
        drawTop_() {
          this.highlighter_.drawTopCorner(this.info_.topRow), this.highlighter_.drawRightSideRow(this.info_.topRow), super.drawTop_();
        }
        drawJaggedEdge_(e) {
          this.highlighter_.drawJaggedEdge_(e), super.drawJaggedEdge_(e);
        }
        drawValueInput_(e) {
          this.highlighter_.drawValueInput(e), super.drawValueInput_(e);
        }
        drawStatementInput_(e) {
          this.highlighter_.drawStatementInput(e), super.drawStatementInput_(e);
        }
        drawRightSideRow_(e) {
          this.highlighter_.drawRightSideRow(e), this.outlinePath_ += Ae("H", e.xPos + e.width) + Ae(
            "V",
            e.yPos + e.height
          );
        }
        drawBottom_() {
          this.highlighter_.drawBottomRow(this.info_.bottomRow), super.drawBottom_();
        }
        drawLeft_() {
          this.highlighter_.drawLeft(), super.drawLeft_();
        }
        drawInlineInput_(e) {
          this.highlighter_.drawInlineInput(e), super.drawInlineInput_(e);
        }
        positionInlineInputConnection_(e) {
          const t = e.centerline - e.height / 2;
          if (e.connectionModel) {
            let n = e.xPos + e.connectionWidth + this.constants_.DARK_PATH_OFFSET;
            this.info_.RTL && (n *= -1), e.connectionModel.setOffsetInBlock(n, t + e.connectionOffsetY + this.constants_.DARK_PATH_OFFSET);
          }
        }
        positionStatementInputConnection_(e) {
          const t = e.getLastInput();
          if (t != null && t.connectionModel) {
            let n = e.xPos + e.statementEdge + t.notchOffset;
            n = this.info_.RTL ? -1 * n : n + this.constants_.DARK_PATH_OFFSET, t.connectionModel.setOffsetInBlock(n, e.yPos + this.constants_.DARK_PATH_OFFSET);
          }
        }
        positionExternalValueConnection_(e) {
          const t = e.getLastInput();
          if (t && t.connectionModel) {
            let n = e.xPos + e.width + this.constants_.DARK_PATH_OFFSET;
            this.info_.RTL && (n *= -1), t.connectionModel.setOffsetInBlock(n, e.yPos);
          }
        }
        positionNextConnection_() {
          const e = this.info_.bottomRow;
          if (e.connection) {
            const t = e.connection, n = t.xPos;
            t.connectionModel.setOffsetInBlock((this.info_.RTL ? -n : n) + this.constants_.DARK_PATH_OFFSET / 2, e.baseline + this.constants_.DARK_PATH_OFFSET);
          }
        }
      }, GA = class {
        constructor(e) {
          this.OFFSET = 0.5, this.constantProvider = e, this.START_POINT = wt(this.OFFSET, this.OFFSET);
        }
        init() {
          this.INSIDE_CORNER = this.makeInsideCorner(), this.OUTSIDE_CORNER = this.makeOutsideCorner(), this.PUZZLE_TAB = this.makePuzzleTab(), this.NOTCH = this.makeNotch(), this.JAGGED_TEETH = this.makeJaggedTeeth(), this.START_HAT = this.makeStartHat();
        }
        makeInsideCorner() {
          const e = this.constantProvider.CORNER_RADIUS, t = this.OFFSET, n = (1 - Math.SQRT1_2) * (e + t) - t, s = wt(n, n) + Ft("a", "0 0,0", e, Ee(-n - t, e - n)), u = Ft("a", "0 0,0", e + t, Ee(e + t, e + t)), A = wt(n, -n) + Ft("a", "0 0,0", e + t, Ee(e - n, n + t));
          return { width: e + t, height: e, pathTop(L) {
            return L ? s : "";
          }, pathBottom(L) {
            return L ? u : A;
          } };
        }
        makeOutsideCorner() {
          const e = this.constantProvider.CORNER_RADIUS, t = this.OFFSET, n = (1 - Math.SQRT1_2) * (e - t) + t, s = wt(n, n) + Ft("a", "0 0,1", e - t, Ee(e - n, -n + t)), u = wt(t, e) + Ft("a", "0 0,1", e - t, Ee(e, -e + t)), A = -n, L = wt(n, A) + Ft("a", "0 0,1", e - t, Ee(-n + t, -A - e));
          return { height: e, topLeft($) {
            return $ ? s : u;
          }, bottomLeft() {
            return L;
          } };
        }
        makePuzzleTab() {
          const e = this.constantProvider.TAB_WIDTH, t = this.constantProvider.TAB_HEIGHT, n = wt(-2, -t + 3.4) + di(-0.45 * e, -2.1), s = Ae(
            "v",
            2.5
          ) + wt(0.97 * -e, 2.5) + Lt("q", [Ee(0.05 * -e, 10), Ee(0.3 * e, 9.5)]) + wt(0.67 * e, -1.9) + Ae("v", 2.5), u = Ae("v", -1.5) + wt(-0.92 * e, -0.5) + Lt(
            "q",
            [Ee(-0.19 * e, -5.5), Ee(0, -11)]
          ) + wt(0.92 * e, 1), A = wt(-5, t - 0.7) + di(0.46 * e, -2.1);
          return { width: e, height: t, pathUp(L) {
            return L ? n : u;
          }, pathDown(L) {
            return L ? s : A;
          } };
        }
        makeNotch() {
          return { pathLeft: Ae("h", this.OFFSET) + this.constantProvider.NOTCH.pathLeft };
        }
        makeJaggedTeeth() {
          return { pathLeft: di(
            5.1,
            2.6
          ) + wt(-10.2, 6.8) + di(5.1, 2.6), height: 12, width: 10.2 };
        }
        makeStartHat() {
          const e = this.constantProvider.START_HAT.height, t = wt(25, -8.7) + Lt("c", [Ee(29.7, -6.2), Ee(57.2, -0.5), Ee(75, 8.7)]), n = Lt(
            "c",
            [Ee(17.8, -9.2), Ee(45.3, -14.9), Ee(75, -8.7)]
          ) + br(100.5, e + 0.5);
          return { path(s) {
            return s ? t : n;
          } };
        }
      }, xA = class extends Sd {
        constructor(e, t) {
          super(e, t), this.constants_ = e, this.connectedBlock && (this.width += this.constants_.DARK_PATH_OFFSET, this.height += this.constants_.DARK_PATH_OFFSET);
        }
      }, Xu = class extends ar {
        constructor(e, t) {
          super(e, t), this.constants_ = e, this.connectedBlock && (this.height += this.constants_.DARK_PATH_OFFSET);
        }
      }, Ku = class extends ya {
        constructor(e, t) {
          super(e, t), this.renderer_ = e;
        }
        getRenderer() {
          return this.renderer_;
        }
        populateBottomRow_() {
          super.populateBottomRow_(), this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1] instanceof wn || (this.bottomRow.minHeight = this.constants_.MEDIUM_PADDING - this.constants_.DARK_PATH_OFFSET);
        }
        addInput_(e, t) {
          this.isInline && e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new xA(this.constants_, e)), t.hasInlineInput = !0) : e instanceof wn ? (t.elements.push(new Xu(this.constants_, e)), t.hasStatement = !0) : e instanceof r.ValueInput$$module$build$src$core$inputs$value_input ? (t.elements.push(new La(this.constants_, e)), t.hasExternalInput = !0) : e instanceof ni && (t.minHeight = Math.max(t.minHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT), t.hasDummyInput = !0), this.isInline || t.align !== null || (t.align = e.align);
        }
        addElemSpacing_() {
          let e = !1;
          for (let n = 0, s; s = this.rows[n]; n++)
            s.hasExternalInput && (e = !0);
          for (let n = 0, s; s = this.rows[n]; n++) {
            var t = s.elements;
            if (s.elements = [], s.startsWithElemSpacer() && s.elements.push(new Bn(this.constants_, this.getInRowSpacing_(null, t[0]))), t.length) {
              for (let u = 0; u < t.length - 1; u++) {
                s.elements.push(t[u]);
                const A = this.getInRowSpacing_(t[u], t[u + 1]);
                s.elements.push(new Bn(this.constants_, A));
              }
              s.elements.push(t[t.length - 1]), s.endsWithElemSpacer() && (t = this.getInRowSpacing_(t[t.length - 1], null), e && s.hasDummyInput && (t += this.constants_.TAB_WIDTH), s.elements.push(new Bn(this.constants_, t)));
            }
          }
        }
        getInRowSpacing_(e, t) {
          if (!e)
            return t && F.isField(t) && t.isEditable ? this.constants_.MEDIUM_PADDING : t && F.isInlineInput(t) ? this.constants_.MEDIUM_LARGE_PADDING : t && F.isStatementInput(t) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
          if (!F.isInput(e) && (!t || F.isStatementInput(t)))
            return F.isField(e) && e.isEditable ? this.constants_.MEDIUM_PADDING : F.isIcon(e) ? 2 * this.constants_.LARGE_PADDING + 1 : F.isHat(e) ? this.constants_.NO_PADDING : F.isPreviousOrNextConnection(e) ? this.constants_.LARGE_PADDING : F.isLeftRoundedCorner(e) ? this.constants_.MIN_BLOCK_WIDTH : F.isJaggedEdge(e) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
          if (F.isInput(e) && !t) {
            if (F.isExternalInput(e))
              return this.constants_.NO_PADDING;
            if (F.isInlineInput(e))
              return this.constants_.LARGE_PADDING;
            if (F.isStatementInput(e))
              return this.constants_.NO_PADDING;
          }
          if (!F.isInput(e) && t && F.isInput(t)) {
            if (F.isField(e) && e.isEditable) {
              if (F.isInlineInput(t) || F.isExternalInput(t))
                return this.constants_.SMALL_PADDING;
            } else {
              if (F.isInlineInput(t) || F.isExternalInput(t))
                return this.constants_.MEDIUM_LARGE_PADDING;
              if (F.isStatementInput(t))
                return this.constants_.LARGE_PADDING;
            }
            return this.constants_.LARGE_PADDING - 1;
          }
          if (F.isIcon(e) && t && !F.isInput(t))
            return this.constants_.LARGE_PADDING;
          if (F.isInlineInput(e) && t && F.isField(t))
            return t.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
          if (F.isLeftSquareCorner(e) && t) {
            if (F.isHat(t))
              return this.constants_.NO_PADDING;
            if (F.isPreviousConnection(t))
              return t.notchOffset;
            if (F.isNextConnection(t))
              return t.notchOffset + (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
          }
          if (F.isLeftRoundedCorner(e) && t) {
            if (F.isPreviousConnection(t))
              return t.notchOffset - this.constants_.CORNER_RADIUS;
            if (F.isNextConnection(t))
              return t.notchOffset - this.constants_.CORNER_RADIUS + (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
          }
          return F.isField(e) && t && F.isField(t) && e.isEditable === t.isEditable || t && F.isJaggedEdge(t) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowHeight_(e, t) {
          return F.isTopRow(e) && F.isBottomRow(t) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : F.isTopRow(e) || F.isBottomRow(t) ? this.constants_.NO_PADDING : e.hasExternalInput && t.hasExternalInput ? this.constants_.LARGE_PADDING : !e.hasStatement && t.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : e.hasStatement && t.hasStatement || !e.hasStatement && t.hasDummyInput || e.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(e, t) {
          if (F.isSpacer(t))
            return e.yPos + t.height / 2;
          if (F.isBottomRow(e))
            return e = e.yPos + e.height - e.descenderHeight, F.isNextConnection(t) ? e + t.height / 2 : e - t.height / 2;
          if (F.isTopRow(e))
            return F.isHat(t) ? e.capline - t.height / 2 : e.capline + t.height / 2;
          let n = e.yPos;
          return F.isField(t) || F.isIcon(t) ? (n += t.height / 2, (e.hasInlineInput || e.hasStatement) && t.height + this.constants_.TALL_INPUT_FIELD_OFFSET_Y <= e.height && (n += this.constants_.TALL_INPUT_FIELD_OFFSET_Y)) : n = F.isInlineInput(t) ? n + t.height / 2 : n + e.height / 2, n;
        }
        alignRowElements_() {
          if (this.isInline) {
            var e = 0, t = /* @__PURE__ */ new WeakMap(), n = null;
            for (let s = this.rows.length - 1, u; u = this.rows[s]; s--)
              t.set(u, e), F.isInputRow(u) && (u.hasStatement && this.alignStatementRow_(u), n && n.hasStatement && u.width < n.width ? t.set(u, n.width) : e = u.width, n = u);
            e = 0;
            for (let s = 0, u; u = this.rows[s]; s++)
              u.hasStatement ? e = this.getDesiredRowWidth_(u) : F.isSpacer(u) ? u.width = Math.max(e, t.get(u)) : (n = u.width, e = Math.max(e, t.get(u)) - n, 0 < e && this.addAlignmentPadding_(u, e), e = u.width);
          } else
            super.alignRowElements_();
        }
        getDesiredRowWidth_(e) {
          return this.isInline && e.hasStatement ? this.statementEdge + this.constants_.MAX_BOTTOM_WIDTH + this.startX : super.getDesiredRowWidth_(e);
        }
        finalize_() {
          let e = 0, t = 0;
          for (let s = 0, u; u = this.rows[s]; s++) {
            u.yPos = t, u.xPos = this.startX, t += u.height, e = Math.max(e, u.widthWithConnectedBlocks);
            var n = t - this.topRow.ascenderHeight;
            u === this.bottomRow && n < this.constants_.MIN_BLOCK_HEIGHT && (n = this.constants_.MIN_BLOCK_HEIGHT - n, this.bottomRow.height += n, t += n), this.recordElemPositions_(u);
          }
          this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (n = this.block_.nextConnection.targetBlock()) && (e = Math.max(e, n.getHeightWidth().width - this.constants_.DARK_PATH_OFFSET)), this.bottomRow.baseline = t - this.bottomRow.descenderHeight, this.widthWithChildren = e + this.startX + this.constants_.DARK_PATH_OFFSET, this.width += this.constants_.DARK_PATH_OFFSET, this.height = t + this.constants_.DARK_PATH_OFFSET, this.startY = this.topRow.capline;
        }
      }, HA = class extends wu {
        constructor(e, t, n) {
          super(e, t, n), this.constants = n, this.colourDark = "#000000", this.svgPathDark = K(G.PATH, { class: "blocklyPathDark", transform: "translate(1,1)" }), this.svgRoot.insertBefore(this.svgPathDark, this.svgPath), this.svgPathLight = K(
            G.PATH,
            { class: "blocklyPathLight" },
            this.svgRoot
          );
        }
        setPath(e) {
          this.svgPath.setAttribute("d", e), this.svgPathDark.setAttribute("d", e);
        }
        setHighlightPath(e) {
          this.svgPathLight.setAttribute("d", e);
        }
        flipRTL() {
          this.svgPath.setAttribute("transform", "scale(-1 1)"), this.svgPathLight.setAttribute("transform", "scale(-1 1)"), this.svgPathDark.setAttribute("transform", "translate(1,1) scale(-1 1)");
        }
        applyColour(e) {
          if (this.svgPathLight.style.display = "", this.svgPathDark.style.display = "", !this.style.colourTertiary)
            throw Error("The renderer did not properly initialize the tertiary colour of the block style");
          this.svgPathLight.setAttribute("stroke", this.style.colourTertiary), this.svgPathDark.setAttribute("fill", this.colourDark), super.applyColour(e), this.svgPath.setAttribute("stroke", "none");
        }
        setStyle(e) {
          this.style = e, this.colourDark = jn("#000", this.style.colourPrimary, 0.2) || this.colourDark;
        }
        updateHighlighted(e) {
          e ? (this.svgPath.setAttribute("filter", "url(#" + this.constants.embossFilterId + ")"), this.svgPathLight.style.display = "none") : (this.svgPath.setAttribute("filter", "none"), this.svgPathLight.style.display = "inline");
        }
        updateShadow_(e) {
          if (e) {
            if (this.svgPathLight.style.display = "none", !this.style.colourSecondary)
              throw Error("The renderer did not properly initialize the secondary colour of the block style block style");
            this.svgPathDark.setAttribute("fill", this.style.colourSecondary), this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", this.style.colourSecondary);
          }
        }
        updateDisabled_(e) {
          super.updateDisabled_(e), e && this.svgPath.setAttribute("stroke", "none");
        }
      }, YA = class extends V_ {
        constructor(e) {
          super(e), this.highlightConstants = null;
        }
        init(e, t) {
          super.init(e, t), this.highlightConstants = this.makeHighlightConstants_(), this.highlightConstants.init();
        }
        refreshDom(e, t) {
          super.refreshDom(e, t), this.getHighlightConstants().init();
        }
        makeConstants_() {
          return new UA();
        }
        makeRenderInfo_(e) {
          return new Ku(
            this,
            e
          );
        }
        makeDrawer_(e, t) {
          return new VA(e, t);
        }
        makePathObject(e, t) {
          return new HA(e, t, this.getConstants());
        }
        makeHighlightConstants_() {
          return new GA(this.getConstants());
        }
        getHighlightConstants() {
          if (!this.highlightConstants)
            throw Error("Cannot access the highlight constants because init has not been called");
          return this.highlightConstants;
        }
      };
      Jn("geras", YA);
      var qi = {};
      qi.ConstantProvider = UA, qi.Drawer = VA, qi.HighlightConstantProvider = GA, qi.Highlighter = Rd, qi.InlineInput = xA, qi.PathObject = HA, qi.RenderInfo = Ku, qi.Renderer = YA, qi.StatementInput = Xu;
      var XA = class extends Il {
        constructor() {
          super(), hr("Blockly.minimalist.ConstantProvider", "v10", "v11", "Blockly.blockRendering.ConstantProvider");
        }
      }, KA = class extends W_ {
        constructor(e, t) {
          super(e, t), hr("Blockly.minimalist.Drawer", "v10", "v11", "Blockly.blockRendering.Drawer");
        }
      }, jA = class extends ya {
        constructor(e, t) {
          super(e, t), hr("Blockly.minimalist.RenderInfo", "v10", "v11", "Blockly.blockRendering.RenderInfo");
        }
        getRenderer() {
          return this.renderer_;
        }
      }, zA = class extends V_ {
        constructor(e) {
          super(e), hr("Blockly.minimalist.Renderer", "v10", "v11", "Blockly.blockRendering.Renderer");
        }
        makeConstants_() {
          return new XA();
        }
        makeRenderInfo_(e) {
          return new jA(this, e);
        }
        makeDrawer_(e, t) {
          return new KA(
            e,
            t
          );
        }
      };
      Jn("minimalist", zA);
      var Y_ = {};
      Y_.ConstantProvider = XA, Y_.Drawer = KA, Y_.RenderInfo = jA, Y_.Renderer = zA;
      var JA = class extends ya {
        constructor(e, t) {
          super(e, t);
        }
        getRenderer() {
          return this.renderer_;
        }
        addElemSpacing_() {
          let e = !1;
          for (var t = 0; t < this.rows.length; t++)
            if (this.rows[t].hasExternalInput) {
              e = !0;
              break;
            }
          for (t = 0; t < this.rows.length; t++) {
            const s = this.rows[t];
            var n = s.elements;
            if (s.elements = [], s.startsWithElemSpacer() && s.elements.push(new Bn(
              this.constants_,
              this.getInRowSpacing_(null, n[0])
            )), n.length) {
              for (let u = 0; u < n.length - 1; u++) {
                s.elements.push(n[u]);
                const A = this.getInRowSpacing_(n[u], n[u + 1]);
                s.elements.push(new Bn(this.constants_, A));
              }
              s.elements.push(n[n.length - 1]), s.endsWithElemSpacer() && (n = this.getInRowSpacing_(n[n.length - 1], null), e && s.hasDummyInput && (n += this.constants_.TAB_WIDTH), s.elements.push(new Bn(
                this.constants_,
                n
              )));
            }
          }
        }
        getInRowSpacing_(e, t) {
          if (!e)
            return t && F.isField(t) && t.isEditable ? this.constants_.MEDIUM_PADDING : t && F.isInlineInput(t) ? this.constants_.MEDIUM_LARGE_PADDING : t && F.isStatementInput(t) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.LARGE_PADDING;
          if (!F.isInput(e) && !t)
            return F.isField(e) && e.isEditable ? this.constants_.MEDIUM_PADDING : F.isIcon(e) ? 2 * this.constants_.LARGE_PADDING + 1 : F.isHat(e) ? this.constants_.NO_PADDING : F.isPreviousOrNextConnection(e) ? this.constants_.LARGE_PADDING : F.isLeftRoundedCorner(e) ? this.constants_.MIN_BLOCK_WIDTH : F.isJaggedEdge(e) ? this.constants_.NO_PADDING : this.constants_.LARGE_PADDING;
          if (F.isInput(e) && !t) {
            if (F.isExternalInput(e))
              return this.constants_.NO_PADDING;
            if (F.isInlineInput(e))
              return this.constants_.LARGE_PADDING;
            if (F.isStatementInput(e))
              return this.constants_.NO_PADDING;
          }
          if (!F.isInput(e) && t && F.isInput(t)) {
            if (F.isField(e) && e.isEditable) {
              if (F.isInlineInput(t) || F.isExternalInput(t))
                return this.constants_.SMALL_PADDING;
            } else {
              if (F.isInlineInput(t) || F.isExternalInput(t))
                return this.constants_.MEDIUM_LARGE_PADDING;
              if (F.isStatementInput(t))
                return this.constants_.LARGE_PADDING;
            }
            return this.constants_.LARGE_PADDING - 1;
          }
          if (F.isIcon(e) && t && !F.isInput(t))
            return this.constants_.LARGE_PADDING;
          if (F.isInlineInput(e) && t && F.isField(t))
            return t.isEditable ? this.constants_.MEDIUM_PADDING : this.constants_.LARGE_PADDING;
          if (F.isLeftSquareCorner(e) && t) {
            if (F.isHat(t))
              return this.constants_.NO_PADDING;
            if (F.isPreviousConnection(t) || F.isNextConnection(t))
              return t.notchOffset;
          }
          return F.isLeftRoundedCorner(e) && t ? t.notchOffset - this.constants_.CORNER_RADIUS : F.isField(e) && t && F.isField(t) && e.isEditable === t.isEditable || t && F.isJaggedEdge(t) ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getSpacerRowHeight_(e, t) {
          return F.isTopRow(e) && F.isBottomRow(t) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : F.isTopRow(e) || F.isBottomRow(t) ? this.constants_.NO_PADDING : e.hasExternalInput && t.hasExternalInput ? this.constants_.LARGE_PADDING : !e.hasStatement && t.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : e.hasStatement && t.hasStatement || e.hasDummyInput || t.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
        }
        getElemCenterline_(e, t) {
          if (F.isSpacer(t))
            return e.yPos + t.height / 2;
          if (F.isBottomRow(e))
            return e = e.yPos + e.height - e.descenderHeight, F.isNextConnection(t) ? e + t.height / 2 : e - t.height / 2;
          if (F.isTopRow(e))
            return F.isHat(t) ? e.capline - t.height / 2 : e.capline + t.height / 2;
          let n = e.yPos;
          return n = F.isField(t) && e.hasStatement ? n + (this.constants_.TALL_INPUT_FIELD_OFFSET_Y + t.height / 2) : n + e.height / 2;
        }
        finalize_() {
          let e = 0, t = 0;
          for (var n = 0; n < this.rows.length; n++) {
            const u = this.rows[n];
            u.yPos = t, u.xPos = this.startX, t += u.height, e = Math.max(e, u.widthWithConnectedBlocks);
            var s = t - this.topRow.ascenderHeight;
            u === this.bottomRow && s < this.constants_.MIN_BLOCK_HEIGHT && (s = this.constants_.MIN_BLOCK_HEIGHT - s, this.bottomRow.height += s, t += s), this.recordElemPositions_(u);
          }
          this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (n = this.block_.nextConnection.targetBlock()) && (e = Math.max(e, n.getHeightWidth().width)), this.bottomRow.baseline = t - this.bottomRow.descenderHeight, this.widthWithChildren = e + this.startX, this.height = t, this.startY = this.topRow.capline;
        }
      }, ZA = class extends V_ {
        constructor(e) {
          super(e);
        }
        makeRenderInfo_(e) {
          return new JA(this, e);
        }
      };
      Jn("thrasos", ZA);
      var Od = {};
      Od.RenderInfo = JA, Od.Renderer = ZA;
      var ZS = class {
        constructor(e, t) {
          this.procedureModelClass = e, this.parameterModelClass = t, this.priority = QE;
        }
        save(e) {
          return e = e.getProcedureMap().getProcedures().map((t) => Ap(t)), e.length ? e : null;
        }
        load(e, t) {
          const n = t.getProcedureMap();
          for (const s of e)
            n.add(Sp(
              this.procedureModelClass,
              this.parameterModelClass,
              s,
              t
            ));
        }
        clear(e) {
          e.getProcedureMap().clear();
        }
      }, va = {};
      va.ProcedureSerializer = ZS, va.loadParameter = hp, va.loadProcedure = Sp, va.saveParameter = ts, va.saveProcedure = Ap;
      var QA = class {
        constructor() {
          this.priority = ZE;
        }
        save(e) {
          const t = [];
          for (const n of e.getAllVariables())
            e = { name: n.name, id: n.getId() }, n.type && (e.type = n.type), t.push(e);
          return t.length ? t : null;
        }
        load(e, t) {
          for (const n of e)
            t.createVariable(n.name, n.type, n.id);
        }
        clear(e) {
          e.getVariableMap().clear();
        }
      };
      Ua("variables", new QA());
      var qA = {};
      qA.VariableSerializer = QA;
      var Dd = {};
      Dd.load = mp, Dd.save = Hc;
      var QS = { blocks: g_, exceptions: us, priorities: su, procedures: va, registry: Up, variables: qA, workspaces: Dd }, eo;
      (function(e) {
        e.ESCAPE = "escape", e.DELETE = "delete", e.COPY = "copy", e.CUT = "cut", e.PASTE = "paste", e.UNDO = "undo", e.REDO = "redo";
      })(eo || (eo = {})), Xc();
      var to = {};
      to.names = eo, to.registerCopy = gp, to.registerCut = Yc, to.registerDefaultShortcuts = Xc, to.registerDelete = Mp, to.registerEscape = Ip, to.registerPaste = T_, to.registerRedo = p_, to.registerUndo = Lp;
      var qS = {
        colour_blocks: { colourPrimary: "#CF63CF", colourSecondary: "#C94FC9", colourTertiary: "#BD42BD" },
        list_blocks: { colourPrimary: "#9966FF", colourSecondary: "#855CD6", colourTertiary: "#774DCB" },
        logic_blocks: { colourPrimary: "#4C97FF", colourSecondary: "#4280D7", colourTertiary: "#3373CC" },
        loop_blocks: { colourPrimary: "#0fBD8C", colourSecondary: "#0DA57A", colourTertiary: "#0B8E69" },
        math_blocks: { colourPrimary: "#59C059", colourSecondary: "#46B946", colourTertiary: "#389438" },
        procedure_blocks: { colourPrimary: "#FF6680", colourSecondary: "#FF4D6A", colourTertiary: "#FF3355" },
        text_blocks: { colourPrimary: "#FFBF00", colourSecondary: "#E6AC00", colourTertiary: "#CC9900" },
        variable_blocks: { colourPrimary: "#FF8C1A", colourSecondary: "#FF8000", colourTertiary: "#DB6E00" },
        variable_dynamic_blocks: { colourPrimary: "#FF8C1A", colourSecondary: "#FF8000", colourTertiary: "#DB6E00" },
        hat_blocks: { colourPrimary: "#4C97FF", colourSecondary: "#4280D7", colourTertiary: "#3373CC", hat: "cap" }
      }, eh = { colour_category: { colour: "#CF63CF" }, list_category: { colour: "#9966FF" }, logic_category: { colour: "#4C97FF" }, loop_category: { colour: "#0fBD8C" }, math_category: { colour: "#59C059" }, procedure_category: { colour: "#FF6680" }, text_category: { colour: "#FFBF00" }, variable_category: { colour: "#FF8C1A" }, variable_dynamic_category: { colour: "#FF8C1A" } }, a = new ms("zelos", qS, eh), _ = {};
      _.Classic = hu, _.Zelos = a;
      var p = class {
        constructor(e, t, n) {
          this.id_ = e.toolboxitemid || si(), this.level_ = (this.parent_ = n || null) ? this.parent_.getLevel() + 1 : 0, this.toolboxItemDef_ = e, this.parentToolbox_ = t, this.workspace_ = this.parentToolbox_.getWorkspace();
        }
        init() {
        }
        getDiv() {
          return null;
        }
        getClickTarget() {
          return null;
        }
        getId() {
          return this.id_;
        }
        getParent() {
          return null;
        }
        getLevel() {
          return this.level_;
        }
        isSelectable() {
          return !1;
        }
        isCollapsible() {
          return !1;
        }
        dispose() {
        }
        setVisible_(e) {
        }
      }, S = class extends p {
        constructor(e, t, n) {
          super(e, t, n), this.colour_ = this.name_ = "", this.labelDom_ = this.iconDom_ = this.rowContents_ = this.rowDiv_ = this.htmlDiv_ = null, this.isDisabled_ = this.isHidden_ = !1, this.flyoutItems_ = [], this.cssConfig_ = this.makeDefaultCssConfig_();
        }
        init() {
          this.parseCategoryDef_(this.toolboxItemDef_), this.parseContents_(this.toolboxItemDef_), this.createDom_(), this.toolboxItemDef_.hidden === "true" && this.hide();
        }
        makeDefaultCssConfig_() {
          return { container: "blocklyToolboxCategory", row: "blocklyTreeRow", rowcontentcontainer: "blocklyTreeRowContentContainer", icon: "blocklyTreeIcon", label: "blocklyTreeLabel", contents: "blocklyToolboxContents", selected: "blocklyTreeSelected", openicon: "blocklyTreeIconOpen", closedicon: "blocklyTreeIconClosed" };
        }
        parseContents_(e) {
          if ("custom" in e)
            this.flyoutItems_ = e.custom;
          else if (e = e.contents)
            for (let t = 0; t < e.length; t++) {
              const n = e[t];
              Array.isArray(this.flyoutItems_) && this.flyoutItems_.push(n);
            }
        }
        parseCategoryDef_(e) {
          this.name_ = "name" in e ? Jt(e.name) : "", this.colour_ = this.getColour_(e), Object.assign(this.cssConfig_, e.cssconfig || e.cssConfig);
        }
        createDom_() {
          this.htmlDiv_ = this.createContainer_(), Tn(this.htmlDiv_, Ln.TREEITEM), gt(this.htmlDiv_, Dt.SELECTED, !1), gt(
            this.htmlDiv_,
            Dt.LEVEL,
            this.level_ + 1
          ), this.rowDiv_ = this.createRowContainer_(), this.rowDiv_.style.pointerEvents = "auto", this.htmlDiv_.appendChild(this.rowDiv_), this.rowContents_ = this.createRowContentsContainer_(), this.rowContents_.style.pointerEvents = "none", this.rowDiv_.appendChild(this.rowContents_), this.iconDom_ = this.createIconDom_(), Tn(this.iconDom_, Ln.PRESENTATION), this.rowContents_.appendChild(this.iconDom_), this.labelDom_ = this.createLabelDom_(this.name_), this.rowContents_.appendChild(this.labelDom_);
          const e = this.labelDom_.getAttribute("id");
          return e && gt(this.htmlDiv_, Dt.LABELLEDBY, e), this.addColourBorder_(this.colour_), this.htmlDiv_;
        }
        createContainer_() {
          const e = document.createElement("div"), t = this.cssConfig_.container;
          return t && Re(e, t), e;
        }
        createRowContainer_() {
          const e = document.createElement("div");
          var t = this.cssConfig_.row;
          return t && Re(
            e,
            t
          ), t = `${S.nestedPadding * this.getLevel()}px`, this.workspace_.RTL ? e.style.paddingRight = t : e.style.paddingLeft = t, e;
        }
        createRowContentsContainer_() {
          const e = document.createElement("div"), t = this.cssConfig_.rowcontentcontainer;
          return t && Re(e, t), e;
        }
        createIconDom_() {
          const e = document.createElement("span");
          if (!this.parentToolbox_.isHorizontal()) {
            const t = this.cssConfig_.icon;
            t && Re(
              e,
              t
            );
          }
          return e.style.display = "inline-block", e;
        }
        createLabelDom_(e) {
          const t = document.createElement("span");
          return t.setAttribute("id", this.getId() + ".label"), t.textContent = e, (e = this.cssConfig_.label) && Re(t, e), t;
        }
        refreshTheme() {
          this.colour_ = this.getColour_(this.toolboxItemDef_), this.addColourBorder_(this.colour_);
        }
        addColourBorder_(e) {
          e && (e = S.borderWidth + "px solid " + (e || "#ddd"), this.workspace_.RTL ? this.rowDiv_.style.borderRight = e : this.rowDiv_.style.borderLeft = e);
        }
        getColour_(e) {
          const t = e.categorystyle || e.categoryStyle;
          if ((e = e.colour) && t)
            console.warn('Toolbox category "' + this.name_ + '" must not have both a style and a colour');
          else {
            if (t)
              return this.getColourfromStyle_(t);
            if (e)
              return this.parseColour_(e);
          }
          return "";
        }
        getColourfromStyle_(e) {
          var t = this.workspace_.getTheme();
          if (e && t) {
            if ((t = t.categoryStyles[e]) && t.colour)
              return this.parseColour_(t.colour);
            console.warn('Style "' + e + '" must exist and contain a colour value');
          }
          return "";
        }
        getClickTarget() {
          return this.rowDiv_;
        }
        parseColour_(e) {
          if (e = Jt(e), e == null || e === "")
            return "";
          var t = Number(e);
          return isNaN(t) ? (t = pi(e)) ? t : (console.warn('Toolbox category "' + this.name_ + '" has unrecognized colour attribute: ' + e), "") : On(t);
        }
        openIcon_(e) {
          if (e) {
            var t = this.cssConfig_.closedicon;
            t && co(e, t), (t = this.cssConfig_.openicon) && Re(
              e,
              t
            );
          }
        }
        closeIcon_(e) {
          if (e) {
            var t = this.cssConfig_.openicon;
            t && co(e, t), (t = this.cssConfig_.closedicon) && Re(e, t);
          }
        }
        setVisible_(e) {
          this.htmlDiv_.style.display = e ? "block" : "none", this.isHidden_ = !e, this.parentToolbox_.getSelectedItem() === this && this.parentToolbox_.clearSelection();
        }
        hide() {
          this.setVisible_(!1);
        }
        show() {
          this.setVisible_(!0);
        }
        isVisible() {
          return !this.isHidden_ && this.allAncestorsExpanded_();
        }
        allAncestorsExpanded_() {
          let e = this;
          for (; e.getParent(); )
            if (e = e.getParent(), !e.isExpanded())
              return !1;
          return !0;
        }
        isSelectable() {
          return this.isVisible() && !this.isDisabled_;
        }
        onClick(e) {
        }
        setSelected(e) {
          if (this.rowDiv_) {
            var t = this.cssConfig_.selected;
            if (e) {
              const n = this.parseColour_(S.defaultBackgroundColour);
              this.rowDiv_.style.backgroundColor = this.colour_ || n, t && Re(this.rowDiv_, t);
            } else
              this.rowDiv_.style.backgroundColor = "", t && Ue(
                this.rowDiv_,
                t
              );
            gt(this.htmlDiv_, Dt.SELECTED, e);
          }
        }
        setDisabled(e) {
          this.isDisabled_ = e, this.getDiv().setAttribute("disabled", `${e}`), e ? this.getDiv().setAttribute("disabled", "true") : this.getDiv().removeAttribute("disabled");
        }
        getName() {
          return this.name_;
        }
        getParent() {
          return this.parent_;
        }
        getDiv() {
          return this.htmlDiv_;
        }
        getContents() {
          return this.flyoutItems_;
        }
        updateFlyoutContents(e) {
          this.flyoutItems_ = [], this.toolboxItemDef_ = typeof e == "string" ? {
            kind: this.toolboxItemDef_.kind,
            custom: e,
            id: this.toolboxItemDef_.id,
            categorystyle: this.toolboxItemDef_.categorystyle,
            colour: this.toolboxItemDef_.colour,
            cssconfig: this.toolboxItemDef_.cssconfig,
            hidden: this.toolboxItemDef_.hidden
          } : {
            kind: this.toolboxItemDef_.kind,
            name: "name" in this.toolboxItemDef_ ? this.toolboxItemDef_.name : "",
            contents: Ja(e),
            id: this.toolboxItemDef_.id,
            categorystyle: this.toolboxItemDef_.categorystyle,
            colour: this.toolboxItemDef_.colour,
            cssconfig: this.toolboxItemDef_.cssconfig,
            hidden: this.toolboxItemDef_.hidden
          }, this.parseContents_(this.toolboxItemDef_);
        }
        dispose() {
          _t(this.htmlDiv_);
        }
      };
      S.registrationName = "category", S.nestedPadding = 19, S.borderWidth = 8, S.defaultBackgroundColour = "#57e", Kn(`
.blocklyTreeRow:not(.blocklyTreeSelected):hover {
  background-color: rgba(255, 255, 255, .2);
}

.blocklyToolboxDiv[layout="h"] .blocklyToolboxCategory {
  margin: 1px 5px 1px 0;
}

.blocklyToolboxDiv[dir="RTL"][layout="h"] .blocklyToolboxCategory {
  margin: 1px 0 1px 5px;
}

.blocklyTreeRow {
  height: 22px;
  line-height: 22px;
  margin-bottom: 3px;
  padding-right: 8px;
  white-space: nowrap;
}

.blocklyToolboxDiv[dir="RTL"] .blocklyTreeRow {
  margin-left: 8px;
  padding-right: 0;
}

.blocklyTreeIcon {
  background-image: url(<<<PATH>>>/sprites.png);
  height: 16px;
  vertical-align: middle;
  visibility: hidden;
  width: 16px;
}

.blocklyTreeIconClosed {
  background-position: -32px -1px;
}

.blocklyToolboxDiv[dir="RTL"] .blocklyTreeIconClosed {
  background-position: 0 -1px;
}

.blocklyTreeSelected>.blocklyTreeIconClosed {
  background-position: -32px -17px;
}

.blocklyToolboxDiv[dir="RTL"] .blocklyTreeSelected>.blocklyTreeIconClosed {
  background-position: 0 -17px;
}

.blocklyTreeIconOpen {
  background-position: -16px -1px;
}

.blocklyTreeSelected>.blocklyTreeIconOpen {
  background-position: -16px -17px;
}

.blocklyTreeLabel {
  cursor: default;
  font: 16px sans-serif;
  padding: 0 3px;
  vertical-align: middle;
}

.blocklyToolboxDelete .blocklyTreeLabel {
  cursor: url("<<<PATH>>>/handdelete.cur"), auto;
}

.blocklyTreeSelected .blocklyTreeLabel {
  color: #fff;
}
`), o(_e.TOOLBOX_ITEM, S.registrationName, S);
      var g = class extends p {
        constructor(e, t) {
          super(e, t), this.cssConfig_ = { container: "blocklyTreeSeparator" }, this.htmlDiv_ = null, Object.assign(this.cssConfig_, e.cssconfig || e.cssConfig);
        }
        init() {
          this.createDom_();
        }
        createDom_() {
          const e = document.createElement("div"), t = this.cssConfig_.container;
          return t && Re(e, t), this.htmlDiv_ = e;
        }
        getDiv() {
          return this.htmlDiv_;
        }
        dispose() {
          _t(this.htmlDiv_);
        }
      };
      g.registrationName = "sep", Kn(`
.blocklyTreeSeparator {
  border-bottom: solid #e5e5e5 1px;
  height: 0;
  margin: 5px 0;
}

.blocklyToolboxDiv[layout="h"] .blocklyTreeSeparator {
  border-right: solid #e5e5e5 1px;
  border-bottom: none;
  height: auto;
  margin: 0 5px 0 5px;
  padding: 5px 0;
  width: 0;
}
`), o(_e.TOOLBOX_ITEM, g.registrationName, g);
      var O = class extends S {
        constructor(e, t, n) {
          super(e, t, n), this.subcategoriesDiv_ = null, this.expanded_ = !1, this.toolboxItems_ = [];
        }
        makeDefaultCssConfig_() {
          const e = super.makeDefaultCssConfig_();
          return e.contents = "blocklyToolboxContents", e;
        }
        parseContents_(e) {
          if ("custom" in e)
            this.flyoutItems_ = e.custom;
          else {
            const t = e.contents;
            if (t) {
              this.flyoutItems_ = [], e = !0;
              for (let n = 0; n < t.length; n++) {
                const s = t[n];
                !h(_e.TOOLBOX_ITEM, s.kind) || s.kind.toLowerCase() === g.registrationName && e ? (this.flyoutItems_.push(s), e = !0) : (this.createToolboxItem_(s), e = !1);
              }
            }
          }
        }
        createToolboxItem_(e) {
          let t = e.kind;
          t.toUpperCase() === "CATEGORY" && Xl(e) && (t = O.registrationName), e = new (y(_e.TOOLBOX_ITEM, t))(e, this.parentToolbox_, this), this.toolboxItems_.push(e);
        }
        init() {
          super.init(), this.setExpanded(this.toolboxItemDef_.expanded === "true" || this.toolboxItemDef_.expanded === !0);
        }
        createDom_() {
          super.createDom_();
          const e = this.getChildToolboxItems();
          return this.subcategoriesDiv_ = this.createSubCategoriesDom_(e), Tn(this.subcategoriesDiv_, Ln.GROUP), this.htmlDiv_.appendChild(this.subcategoriesDiv_), this.closeIcon_(this.iconDom_), gt(this.htmlDiv_, Dt.EXPANDED, !1), this.htmlDiv_;
        }
        createIconDom_() {
          const e = document.createElement("span");
          if (!this.parentToolbox_.isHorizontal()) {
            const t = this.cssConfig_.icon;
            t && Re(e, t), e.style.visibility = "visible";
          }
          return e.style.display = "inline-block", e;
        }
        createSubCategoriesDom_(e) {
          const t = document.createElement("div");
          t.style.display = "none";
          var n = this.cssConfig_.contents;
          for (n && Re(t, n), n = 0; n < e.length; n++) {
            const s = e[n];
            s.init();
            const u = s.getDiv();
            if (t.appendChild(u), s.getClickTarget) {
              let A;
              (A = s.getClickTarget()) == null || A.setAttribute("id", s.getId());
            }
          }
          return t;
        }
        setExpanded(e) {
          this.expanded_ !== e && ((this.expanded_ = e) ? (this.subcategoriesDiv_.style.display = "block", this.openIcon_(this.iconDom_)) : (this.subcategoriesDiv_.style.display = "none", this.closeIcon_(this.iconDom_)), gt(
            this.htmlDiv_,
            Dt.EXPANDED,
            e
          ), this.parentToolbox_.handleToolboxItemResize());
        }
        setVisible_(e) {
          this.htmlDiv_.style.display = e ? "block" : "none";
          const t = this.getChildToolboxItems();
          for (let n = 0; n < t.length; n++)
            t[n].setVisible_(e);
          this.isHidden_ = !e, this.parentToolbox_.getSelectedItem() === this && this.parentToolbox_.clearSelection();
        }
        isExpanded() {
          return this.expanded_;
        }
        isCollapsible() {
          return !0;
        }
        onClick(e) {
          this.toggleExpanded();
        }
        toggleExpanded() {
          this.setExpanded(!this.expanded_);
        }
        getDiv() {
          return this.htmlDiv_;
        }
        getChildToolboxItems() {
          return this.toolboxItems_;
        }
      };
      O.registrationName = "collapsibleCategory", o(_e.TOOLBOX_ITEM, O.registrationName, O);
      var P = class extends Fu {
        constructor(e) {
          super(), this.id = "toolbox", this.contentsDiv_ = this.HtmlDiv = null, this.isVisible_ = !1, this.contents_ = [], this.height_ = this.width_ = 0, this.previouslySelectedItem_ = this.selectedItem_ = this.flyout_ = null, this.boundEvents_ = [], this.workspace_ = e, this.toolboxDef_ = e.options.languageTree || { contents: [] }, this.horizontalLayout_ = e.options.horizontalLayout, this.RTL = e.options.RTL, this.contentMap_ = /* @__PURE__ */ Object.create(null), this.toolboxPosition = e.options.toolboxPosition;
        }
        onShortcut(e) {
          return !1;
        }
        init() {
          var e = this.workspace_;
          const t = e.getParentSvg();
          this.flyout_ = this.createFlyout_(), this.HtmlDiv = this.createDom_(this.workspace_), mr(this.flyout_.createDom("svg"), t), this.setVisible(!0), this.flyout_.init(e), this.render(this.toolboxDef_), e = e.getThemeManager(), e.subscribe(this.HtmlDiv, "toolboxBackgroundColour", "background-color"), e.subscribe(
            this.HtmlDiv,
            "toolboxForegroundColour",
            "color"
          ), this.workspace_.getComponentManager().addComponent({ component: this, weight: 1, capabilities: [ft.Capability.AUTOHIDEABLE, ft.Capability.DELETE_AREA, ft.Capability.DRAG_TARGET] });
        }
        createDom_(e) {
          e = e.getParentSvg();
          const t = this.createContainer_();
          return this.contentsDiv_ = this.createContentsContainer_(), this.contentsDiv_.tabIndex = 0, Tn(
            this.contentsDiv_,
            Ln.TREE
          ), t.appendChild(this.contentsDiv_), e.parentNode.insertBefore(t, e), this.attachEvents_(t, this.contentsDiv_), t;
        }
        createContainer_() {
          const e = document.createElement("div");
          return e.setAttribute("layout", this.isHorizontal() ? "h" : "v"), Re(e, "blocklyToolboxDiv"), Re(e, "blocklyNonSelectable"), e.setAttribute("dir", this.RTL ? "RTL" : "LTR"), e;
        }
        createContentsContainer_() {
          const e = document.createElement("div");
          return Re(e, "blocklyToolboxContents"), this.isHorizontal() && (e.style.flexDirection = "row"), e;
        }
        attachEvents_(e, t) {
          e = ge(e, "pointerdown", this, this.onClick_, !1), this.boundEvents_.push(e), t = ge(t, "keydown", this, this.onKeyDown_, !1), this.boundEvents_.push(t);
        }
        onClick_(e) {
          if (Xo(e) || e.target === this.HtmlDiv)
            ae().hideChaff(!1);
          else {
            var t = e.target.getAttribute("id");
            t && (t = this.getToolboxItemById(t), t.isSelectable() && (this.setSelectedItem(t), t.onClick(e))), ae().hideChaff(!0);
          }
          Me();
        }
        onKeyDown_(e) {
          let t = !1;
          switch (e.key) {
            case "ArrowDown":
              t = this.selectNext_();
              break;
            case "ArrowUp":
              t = this.selectPrevious_();
              break;
            case "ArrowLeft":
              t = this.selectParent_();
              break;
            case "ArrowRight":
              t = this.selectChild_();
              break;
            case "Enter":
            case " ":
              this.selectedItem_ && this.selectedItem_.isCollapsible() && (this.selectedItem_.toggleExpanded(), t = !0);
              break;
            default:
              t = !1;
          }
          !t && this.selectedItem_ && this.selectedItem_.onKeyDown && (t = this.selectedItem_.onKeyDown(e)), t && e.preventDefault();
        }
        createFlyout_() {
          const e = this.workspace_, t = new ti({ parentWorkspace: e, rtl: e.RTL, oneBasedIndex: e.options.oneBasedIndex, horizontalLayout: e.horizontalLayout, renderer: e.options.renderer, rendererOverrides: e.options.rendererOverrides, move: { scrollbars: !0 } });
          return t.toolboxPosition = e.options.toolboxPosition, new (e.horizontalLayout ? Z(_e.FLYOUTS_HORIZONTAL_TOOLBOX, e.options, !0) : Z(_e.FLYOUTS_VERTICAL_TOOLBOX, e.options, !0))(t);
        }
        render(e) {
          this.toolboxDef_ = e;
          for (let t = 0; t < this.contents_.length; t++) {
            const n = this.contents_[t];
            n && n.dispose();
          }
          this.contents_ = [], this.contentMap_ = /* @__PURE__ */ Object.create(null), this.renderContents_(e.contents), this.position(), this.handleToolboxItemResize();
        }
        renderContents_(e) {
          const t = document.createDocumentFragment();
          for (let n = 0; n < e.length; n++)
            this.createToolboxItem_(e[n], t);
          this.contentsDiv_.appendChild(t);
        }
        createToolboxItem_(e, t) {
          var n = e.kind;
          n.toUpperCase() === "CATEGORY" && Xl(e) && (n = O.registrationName), (n = y(
            _e.TOOLBOX_ITEM,
            n.toLowerCase()
          )) && (e = new n(e, this), e.init(), this.addToolboxItem_(e), (n = e.getDiv()) && t.appendChild(n), e.getClickTarget() && e.getClickTarget().setAttribute("id", e.getId()));
        }
        addToolboxItem_(e) {
          if (this.contents_.push(e), this.contentMap_[e.getId()] = e, e.isCollapsible()) {
            e = e.getChildToolboxItems();
            for (let t = 0; t < e.length; t++)
              this.addToolboxItem_(e[t]);
          }
        }
        getToolboxItems() {
          return this.contents_;
        }
        addStyle(e) {
          e && this.HtmlDiv && Re(this.HtmlDiv, e);
        }
        removeStyle(e) {
          e && this.HtmlDiv && Ue(this.HtmlDiv, e);
        }
        getClientRect() {
          if (!this.HtmlDiv || !this.isVisible_)
            return null;
          var e = this.HtmlDiv.getBoundingClientRect();
          const t = e.top, n = t + e.height, s = e.left;
          return e = s + e.width, this.toolboxPosition === Ge.TOP ? new yt(-1e7, n, -1e7, 1e7) : this.toolboxPosition === Ge.BOTTOM ? new yt(t, 1e7, -1e7, 1e7) : this.toolboxPosition === Ge.LEFT ? new yt(-1e7, 1e7, -1e7, e) : new yt(-1e7, 1e7, s, 1e7);
        }
        wouldDelete(e, t) {
          return e instanceof Fn ? this.updateWouldDelete_(!e.getParent() && e.isDeletable()) : this.updateWouldDelete_(e.isDeletable()), this.wouldDelete_;
        }
        onDragEnter(e) {
          this.updateCursorDeleteStyle_(!0);
        }
        onDragExit(e) {
          this.updateCursorDeleteStyle_(!1);
        }
        onDrop(e) {
          this.updateCursorDeleteStyle_(!1);
        }
        updateWouldDelete_(e) {
          e !== this.wouldDelete_ && (this.updateCursorDeleteStyle_(!1), this.wouldDelete_ = e, this.updateCursorDeleteStyle_(!0));
        }
        updateCursorDeleteStyle_(e) {
          const t = this.wouldDelete_ ? "blocklyToolboxDelete" : "blocklyToolboxGrab";
          e ? this.addStyle(t) : this.removeStyle(t);
        }
        getToolboxItemById(e) {
          return this.contentMap_[e] || null;
        }
        getWidth() {
          return this.width_;
        }
        getHeight() {
          return this.height_;
        }
        getFlyout() {
          return this.flyout_;
        }
        getWorkspace() {
          return this.workspace_;
        }
        getSelectedItem() {
          return this.selectedItem_;
        }
        getPreviouslySelectedItem() {
          return this.previouslySelectedItem_;
        }
        isHorizontal() {
          return this.horizontalLayout_;
        }
        position() {
          const e = this.workspace_.getMetrics(), t = this.HtmlDiv;
          t && (this.horizontalLayout_ ? (t.style.left = "0", t.style.height = "auto", t.style.width = "100%", this.height_ = t.offsetHeight, this.width_ = e.viewWidth, this.toolboxPosition === Ge.TOP ? t.style.top = "0" : t.style.bottom = "0") : (this.toolboxPosition === Ge.RIGHT ? t.style.right = "0" : t.style.left = "0", t.style.height = "100%", this.width_ = t.offsetWidth, this.height_ = e.viewHeight), this.flyout_.position());
        }
        handleToolboxItemResize() {
          const e = this.workspace_, t = this.HtmlDiv.getBoundingClientRect();
          e.translate(this.toolboxPosition === Ge.LEFT ? e.scrollX + t.width : e.scrollX, this.toolboxPosition === Ge.TOP ? e.scrollY + t.height : e.scrollY), Ze(e);
        }
        clearSelection() {
          this.setSelectedItem(null);
        }
        refreshTheme() {
          for (let e = 0; e < this.contents_.length; e++) {
            const t = this.contents_[e];
            t.refreshTheme && t.refreshTheme();
          }
        }
        refreshSelection() {
          this.selectedItem_ && this.selectedItem_.isSelectable() && this.selectedItem_.getContents().length && this.flyout_.show(this.selectedItem_.getContents());
        }
        setVisible(e) {
          this.isVisible_ !== e && (this.HtmlDiv.style.display = e ? "block" : "none", this.isVisible_ = e, this.workspace_.recordDragTargets());
        }
        autoHide(e) {
          !e && this.flyout_ && this.flyout_.autoClose && this.clearSelection();
        }
        setSelectedItem(e) {
          const t = this.selectedItem_;
          !e && !t || e && !Np(e) || (this.shouldDeselectItem_(
            t,
            e
          ) && t !== null && this.deselectItem_(t), this.shouldSelectItem_(t, e) && e !== null && this.selectItem_(t, e), this.updateFlyout_(t, e), this.fireSelectEvent_(t, e));
        }
        shouldDeselectItem_(e, t) {
          return e !== null && (!e.isCollapsible() || e !== t);
        }
        shouldSelectItem_(e, t) {
          return t !== null && t !== e;
        }
        deselectItem_(e) {
          this.selectedItem_ = null, this.previouslySelectedItem_ = e, e.setSelected(!1), gt(this.contentsDiv_, Dt.ACTIVEDESCENDANT, "");
        }
        selectItem_(e, t) {
          this.selectedItem_ = t, this.previouslySelectedItem_ = e, t.setSelected(!0), gt(this.contentsDiv_, Dt.ACTIVEDESCENDANT, t.getId());
        }
        selectItemByPosition(e) {
          -1 < e && e < this.contents_.length && (e = this.contents_[e], e.isSelectable() && this.setSelectedItem(e));
        }
        updateFlyout_(e, t) {
          t && (e !== t || t.isCollapsible()) && t.getContents().length ? (this.flyout_.show(t.getContents()), this.flyout_.scrollToStart()) : this.flyout_.hide();
        }
        fireSelectEvent_(e, t) {
          const n = e && e.getName();
          let s = t && t.getName();
          e === t && (s = null), e = new (fe(sl))(n, s, this.workspace_.id), Ce(e);
        }
        selectParent_() {
          return this.selectedItem_ ? this.selectedItem_.isCollapsible() && this.selectedItem_.isExpanded() ? (this.selectedItem_.toggleExpanded(), !0) : this.selectedItem_.getParent() && this.selectedItem_.getParent().isSelectable() ? (this.setSelectedItem(this.selectedItem_.getParent()), !0) : !1 : !1;
        }
        selectChild_() {
          if (!this.selectedItem_ || !this.selectedItem_.isCollapsible())
            return !1;
          const e = this.selectedItem_;
          return e.isExpanded() ? this.selectNext_() : e.toggleExpanded(), !0;
        }
        selectNext_() {
          if (!this.selectedItem_)
            return !1;
          let e = this.contents_.indexOf(this.selectedItem_) + 1;
          if (-1 < e && e < this.contents_.length) {
            let t = this.contents_[e];
            for (; t && !t.isSelectable(); )
              t = this.contents_[++e];
            if (t && t.isSelectable())
              return this.setSelectedItem(t), !0;
          }
          return !1;
        }
        selectPrevious_() {
          if (!this.selectedItem_)
            return !1;
          let e = this.contents_.indexOf(this.selectedItem_) - 1;
          if (-1 < e && e < this.contents_.length) {
            let t = this.contents_[e];
            for (; t && !t.isSelectable(); )
              t = this.contents_[--e];
            if (t && t.isSelectable())
              return this.setSelectedItem(t), !0;
          }
          return !1;
        }
        dispose() {
          this.workspace_.getComponentManager().removeComponent("toolbox"), this.flyout_.dispose();
          for (var e = 0; e < this.contents_.length; e++)
            this.contents_[e].dispose();
          for (e = 0; e < this.boundEvents_.length; e++)
            Mt(this.boundEvents_[e]);
          this.boundEvents_ = [], this.contents_ = [], this.HtmlDiv && (this.workspace_.getThemeManager().unsubscribe(this.HtmlDiv), _t(this.HtmlDiv));
        }
      };
      Kn(`
.blocklyToolboxDelete {
  cursor: url("<<<PATH>>>/handdelete.cur"), auto;
}

.blocklyToolboxGrab {
  cursor: url("<<<PATH>>>/handclosed.cur"), auto;
  cursor: grabbing;
  cursor: -webkit-grabbing;
}

/* Category tree in Toolbox. */
.blocklyToolboxDiv {
  background-color: #ddd;
  overflow-x: visible;
  overflow-y: auto;
  padding: 4px 0 4px 0;
  position: absolute;
  z-index: 70;  /* so blocks go under toolbox when dragging */
  -webkit-tap-highlight-color: transparent;  /* issue #1345 */
}

.blocklyToolboxContents {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.blocklyToolboxContents:focus {
  outline: none;
}
`), o(_e.TOOLBOX, Vi, P);
      var w = class extends Fu {
        constructor(e) {
          super(), this.workspace = e, this.id = "trashcan", this.contents = [], this.flyout = null, this.isLidOpen = !1, this.minOpenness = 0, this.lidTask = this.svgLid = this.svgGroup = null, this.top = this.left = this.lidOpen = 0, this.initialized = !1, 0 >= this.workspace.options.maxTrashcanContents || (e = new ti({
            scrollbars: !0,
            parentWorkspace: this.workspace,
            rtl: this.workspace.RTL,
            oneBasedIndex: this.workspace.options.oneBasedIndex,
            renderer: this.workspace.options.renderer,
            rendererOverrides: this.workspace.options.rendererOverrides,
            move: { scrollbars: !0 }
          }), this.workspace.horizontalLayout ? (e.toolboxPosition = this.workspace.toolboxPosition === Ge.TOP ? Ge.BOTTOM : Ge.TOP, this.flyout = new (Z(
            _e.FLYOUTS_HORIZONTAL_TOOLBOX,
            this.workspace.options,
            !0
          ))(e)) : (e.toolboxPosition = this.workspace.toolboxPosition === Ge.RIGHT ? Ge.LEFT : Ge.RIGHT, this.flyout = new (Z(_e.FLYOUTS_VERTICAL_TOOLBOX, this.workspace.options, !0))(e)), this.workspace.addChangeListener(this.onDelete.bind(this)));
        }
        createDom() {
          this.svgGroup = K(
            G.G,
            { class: "blocklyTrash" }
          );
          let e;
          const t = String(Math.random()).substring(2);
          e = K(G.CLIPPATH, { id: "blocklyTrashBodyClipPath" + t }, this.svgGroup), K(G.RECT, { width: Y, height: ne, y: te }, e);
          const n = K(
            G.IMAGE,
            { width: Ct.width, x: -We, height: Ct.height, y: -qe, "clip-path": "url(#blocklyTrashBodyClipPath" + t + ")" },
            this.svgGroup
          );
          return n.setAttributeNS(kn, "xlink:href", this.workspace.options.pathToMedia + Ct.url), e = K(
            G.CLIPPATH,
            { id: "blocklyTrashLidClipPath" + t },
            this.svgGroup
          ), K(G.RECT, { width: Y, height: te }, e), this.svgLid = K(G.IMAGE, {
            width: Ct.width,
            x: -We,
            height: Ct.height,
            y: -qe,
            "clip-path": "url(#blocklyTrashLidClipPath" + t + ")"
          }, this.svgGroup), this.svgLid.setAttributeNS(kn, "xlink:href", this.workspace.options.pathToMedia + Ct.url), Ir(this.svgGroup, "pointerdown", this, this.blockMouseDownWhenOpenable), Ir(this.svgGroup, "pointerup", this, this.click), Ir(n, "pointerover", this, this.mouseOver), Ir(
            n,
            "pointerout",
            this,
            this.mouseOut
          ), this.animateLid(), this.svgGroup;
        }
        init() {
          0 < this.workspace.options.maxTrashcanContents && (mr(this.flyout.createDom(G.SVG), this.workspace.getParentSvg()), this.flyout.init(this.workspace)), this.workspace.getComponentManager().addComponent({ component: this, weight: 1, capabilities: [
            ft.Capability.AUTOHIDEABLE,
            ft.Capability.DELETE_AREA,
            ft.Capability.DRAG_TARGET,
            ft.Capability.POSITIONABLE
          ] }), this.initialized = !0, this.setLidOpen(!1);
        }
        dispose() {
          this.workspace.getComponentManager().removeComponent("trashcan"), this.svgGroup && _t(this.svgGroup), this.lidTask && clearTimeout(this.lidTask);
        }
        hasContents() {
          return !!this.contents.length;
        }
        contentsIsOpen() {
          return !!this.flyout && this.flyout.isVisible();
        }
        openFlyout() {
          if (!this.contentsIsOpen()) {
            var e = this.contents.map(function(n) {
              return JSON.parse(n);
            }), t = this.workspace.getParentSvg().style;
            t.cursor = "wait", setTimeout(() => {
              let n;
              (n = this.flyout) == null || n.show(e), t.cursor = "";
            }, 10), this.fireUiEvent(!0);
          }
        }
        closeFlyout() {
          if (this.contentsIsOpen()) {
            var e;
            (e = this.flyout) == null || e.hide(), this.fireUiEvent(!1), this.workspace.recordDragTargets();
          }
        }
        autoHide(e) {
          !e && this.flyout && this.closeFlyout();
        }
        emptyContents() {
          this.hasContents() && (this.contents.length = 0, this.setMinOpenness(0), this.closeFlyout());
        }
        position(e, t) {
          if (this.initialized) {
            var n = Cr(this.workspace, e);
            e = u_(n, new It(Y, ne + te), Se, se, e, this.workspace), t = Zs(
              e,
              se,
              n.vertical === fi.TOP ? Nl.DOWN : Nl.UP,
              t
            ), this.top = t.top, this.left = t.left;
            var s;
            (s = this.svgGroup) == null || s.setAttribute("transform", "translate(" + this.left + "," + this.top + ")");
          }
        }
        getBoundingRectangle() {
          return new yt(this.top, this.top + ne + te, this.left, this.left + Y);
        }
        getClientRect() {
          if (!this.svgGroup)
            return null;
          var e = this.svgGroup.getBoundingClientRect();
          const t = e.top + qe - ve;
          return e = e.left + We - ve, new yt(t, t + te + ne + 2 * ve, e, e + Y + 2 * ve);
        }
        onDragOver(e) {
          this.setLidOpen(this.wouldDelete_);
        }
        onDragExit(e) {
          this.setLidOpen(!1);
        }
        onDrop(e) {
          setTimeout(this.setLidOpen.bind(this, !1), 100);
        }
        setLidOpen(e) {
          this.isLidOpen !== e && (this.lidTask && clearTimeout(this.lidTask), this.isLidOpen = e, this.animateLid());
        }
        animateLid() {
          const e = ct;
          var t = 1 / (e + 1);
          this.lidOpen += this.isLidOpen ? t : -t, this.lidOpen = Math.min(Math.max(this.lidOpen, this.minOpenness), 1), this.setLidAngle(this.lidOpen * fn), t = yn + this.lidOpen * (on - yn), this.svgGroup && (this.svgGroup.style.opacity = `${t}`), this.lidOpen > this.minOpenness && 1 > this.lidOpen && (this.lidTask = setTimeout(this.animateLid.bind(this), st / e));
        }
        setLidAngle(e) {
          const t = this.workspace.toolboxPosition === Ge.RIGHT || this.workspace.horizontalLayout && this.workspace.RTL;
          let n;
          (n = this.svgLid) == null || n.setAttribute("transform", "rotate(" + (t ? -e : e) + "," + (t ? 4 : Y - 4) + "," + (te - 2) + ")");
        }
        setMinOpenness(e) {
          this.minOpenness = e, this.isLidOpen || this.setLidAngle(e * fn);
        }
        closeLid() {
          this.setLidOpen(!1);
        }
        click() {
          this.hasContents() && this.openFlyout();
        }
        fireUiEvent(e) {
          e = new (fe(ll))(e, this.workspace.id), Ce(e);
        }
        blockMouseDownWhenOpenable(e) {
          !this.contentsIsOpen() && this.hasContents() && e.stopPropagation();
        }
        mouseOver() {
          this.hasContents() && this.setLidOpen(!0);
        }
        mouseOut() {
          this.setLidOpen(!1);
        }
        onDelete(e) {
          if (!(0 >= this.workspace.options.maxTrashcanContents || e.type !== r.DELETE$$module$build$src$core$events$utils || e.type !== r.DELETE$$module$build$src$core$events$utils || e.wasShadow)) {
            if (!e.oldJson)
              throw Error("Encountered a delete event without proper oldJson");
            if (e = JSON.stringify(this.cleanBlockJson(e.oldJson)), this.contents.indexOf(e) === -1) {
              for (this.contents.unshift(e); this.contents.length > this.workspace.options.maxTrashcanContents; )
                this.contents.pop();
              this.setMinOpenness(we);
            }
          }
        }
        cleanBlockJson(e) {
          function t(n) {
            if (n) {
              if (delete n.id, delete n.x, delete n.y, delete n.enabled, n.icons && n.icons.comment) {
                var s = n.icons.comment;
                delete s.height, delete s.width, delete s.pinned;
              }
              s = n.inputs;
              for (var u in s) {
                var A = s[u];
                const L = A.block;
                A = A.shadow, L && t(L), A && t(A);
              }
              n.next && (u = n.next, n = u.block, u = u.shadow, n && t(n), u && t(u));
            }
          }
          return e = JSON.parse(JSON.stringify(e)), t(e), Object.assign({}, { kind: "BLOCK" }, e);
        }
      }, Y = 47, ne = 44, te = 16, se = 20, Se = 20, ve = 10, We = 0, qe = 32, we = 0.1, st = 80, ct = 4, yn = 0.4, on = 0.8, fn = 45, pr = "10.0.2", vi = r.Align$$module$build$src$core$inputs$align.LEFT, Fo = r.Align$$module$build$src$core$inputs$align.CENTRE, eS = r.Align$$module$build$src$core$inputs$align.RIGHT, DM = me.INPUT_VALUE, bM = me.OUTPUT_VALUE, PM = me.NEXT_STATEMENT, $M = me.PREVIOUS_STATEMENT, WM = r.inputTypes$$module$build$src$core$inputs$input_types.DUMMY, kM = Ge.TOP, wM = Ge.BOTTOM, FM = Ge.LEFT, BM = Ge.RIGHT;
      H_.prototype.newBlock = function(e, t) {
        return new Ea(this, e, t);
      }, Ci.prototype.newBlock = function(e, t) {
        return new Fn(this, e, t);
      }, Ci.newTrashcan = function(e) {
        return new w(e);
      }, $r.prototype.showContextMenu = function(e) {
        if (!this.workspace.options.readOnly) {
          var t = [];
          this.isDeletable() && this.isMovable() && (t.push(rp(this)), t.push(tp(this))), Dn(e, t, this.RTL);
        }
      }, Po.prototype.newWorkspaceSvg = function(e) {
        return new Ci(e);
      }, r.Names$$module$build$src$core$names.prototype.populateProcedures = function(e) {
        e = __(e), e = e[0].concat(e[1]);
        for (let t = 0; t < e.length; t++)
          this.getName(e[t][0], r.Names$$module$build$src$core$names.NameType.PROCEDURE);
      };
      var UM = me, z = {};
      return z.ALIGN_CENTRE = Fo, z.ALIGN_LEFT = vi, z.ALIGN_RIGHT = eS, z.ASTNode = ie, z.BasicCursor = Sa, z.Block = Ea, z.BlockDragger = hA, z.BlockSvg = Fn, z.Blocks = Zr, z.Bubble = je, z.BubbleDragger = ma, z.COLLAPSED_FIELD_NAME = _u, z.COLLAPSED_INPUT_NAME = sa, z.COLLAPSE_CHARS = IA, z.CodeGenerator = r.CodeGenerator$$module$build$src$core$generator, z.CollapsibleToolboxCategory = O, z.ComponentManager = ft, z.Connection = ut, z.ConnectionChecker = Ou, z.ConnectionDB = Ia, z.ConnectionType = me, z.ContextMenu = Zi, z.ContextMenuItems = nn, z.ContextMenuRegistry = pt, z.Css = lu, z.Cursor = jt, z.DELETE_VARIABLE_ID = Ru, z.DRAG_STACK = vu, z.DUMMY_INPUT = WM, z.DeleteArea = Fu, z.DragTarget = bA, z.DropDownDiv = ir, z.Events = he, z.Extensions = ri, z.Field = lt, z.FieldAngle = tt, z.FieldCheckbox = Ls, z.FieldColour = Un, z.FieldDropdown = zi, z.FieldImage = gs, z.FieldLabel = Ji, z.FieldLabelSerializable = PA, z.FieldMultilineInput = Ld, z.FieldNumber = Nd, z.FieldTextInput = ga, z.FieldVariable = G_, z.Flyout = xu, z.FlyoutButton = yi, z.FlyoutMetricsManager = $A, z.Generator = r.CodeGenerator$$module$build$src$core$generator, z.Gesture = ko, z.Grid = Cd, z.HorizontalFlyout = Hu, z.INPUT_VALUE = DM, z.Input = $o, z.InsertionMarkerManager = $e, z.Marker = Kt, z.MarkerManager = y_, z.Menu = Zp, z.MenuItem = Qp, z.MetricsManager = yd, z.Msg = r.Msg$$module$build$src$core$msg, z.NEXT_STATEMENT = PM, z.Names = r.Names$$module$build$src$core$names, z.OPPOSITE_TYPE = Is, z.OUTPUT_VALUE = bM, z.Options = ti, z.PREVIOUS_STATEMENT = $M, z.PROCEDURE_CATEGORY_NAME = Uu, z.Procedures = Wr, z.RENAME_VARIABLE_ID = gi, z.RenderedConnection = tn, z.Scrollbar = Zt, z.ScrollbarPair = fd, z.ShortcutItems = to, z.ShortcutRegistry = At, z.TOOLBOX_AT_BOTTOM = wM, z.TOOLBOX_AT_LEFT = FM, z.TOOLBOX_AT_RIGHT = BM, z.TOOLBOX_AT_TOP = kM, z.TabNavigateCursor = MA, z.Theme = ms, z.ThemeManager = wA, z.Themes = _, z.Toolbox = P, z.ToolboxCategory = S, z.ToolboxItem = p, z.ToolboxSeparator = g, z.Tooltip = Nr, z.Touch = Pe, z.Trashcan = w, z.UnattachedFieldError = lr, z.VARIABLE_CATEGORY_NAME = hi, z.VARIABLE_DYNAMIC_CATEGORY_NAME = x_, z.VERSION = pr, z.VariableMap = Vu, z.VariableModel = ra, z.Variables = Ar, z.VariablesDynamic = wo, z.VerticalFlyout = vd, z.WidgetDiv = ji, z.Workspace = H_, z.WorkspaceAudio = FA, z.WorkspaceComment = Hi, z.WorkspaceCommentSvg = $r, z.WorkspaceDragger = WA, z.WorkspaceSvg = Ci, z.Xml = mn, z.ZoomControls = Gu, z.blockAnimations = P_, z.blockRendering = ht, z.browserEvents = Ro, z.bubbles = ha, z.bumpObjects = Nu, z.clipboard = $_, z.common = nr, z.config = r.config$$module$build$src$core$config, z.connectionTypes = UM, z.constants = cu, z.defineBlocksWithJsonArray = xn, z.dialog = cl, z.fieldRegistry = R_, z.geras = qi, z.getMainWorkspace = ae, z.getSelected = Fe, z.hasBubble = Ko, z.hideChaff = yp, z.icons = Ll, z.inject = $E, z.inputTypes = r.inputTypes$$module$build$src$core$inputs$input_types, z.inputs = ys, z.isIcon = FE, z.isObservable = a_, z.isSerializable = Yn, z.isVariableBackedParameterModel = B, z.minimalist = Y_, z.procedures = Wr, z.registry = Pn, z.renderManagement = ld, z.serialization = QS, z.setLocale = qc, z.setParentContainer = er, z.svgResize = Ze, z.thrasos = Od, z.uiPosition = Ns, z.utils = Gt, z.zelos = ii, Object.defineProperties(z, { HSV_SATURATION: { get: function() {
        return ls.warn("Blockly.HSV_SATURATION", "version 10", "version 11", "Blockly.utils.colour.getHsvSaturation()"), Gr.getHsvSaturation();
      }, set: function(e) {
        ls.warn("Blockly.HSV_SATURATION", "version 10", "version 11", "Blockly.utils.colour.setHsvSaturation()"), Gr.setHsvSaturation(e);
      } }, HSV_VALUE: { get: function() {
        return ls.warn(
          "Blockly.HSV_VALUE",
          "version 10",
          "version 11",
          "Blockly.utils.colour.getHsvValue()"
        ), Gr.getHsvValue();
      }, set: function(e) {
        ls.warn("Blockly.HSV_VALUE", "version 10", "version 11", "Blockly.utils.colour.setHsvValue()"), Gr.setHsvValue(e);
      } } }), "Blockly" in globalThis || (globalThis.Blockly = { Msg: ss }), z.__namespace__ = r, z;
    });
  }(oh)), oh.exports;
}
var cm;
function XM() {
  return cm || (cm = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(Bh());
    })(ln, function(r) {
      /**
       * @license
       * Copyright 2020 Google LLC
       * SPDX-License-Identifier: Apache-2.0
       */
      return r;
    });
  }(ih)), ih.exports;
}
var um;
function SI() {
  return um || (um = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(XM());
    })(ln, function(r) {
      return r;
    });
  }(nh)), nh.exports;
}
var lh = { exports: {} }, Tm;
function KM() {
  return Tm || (Tm = 1, function(i, l) {
    (function(r, o) {
      i.exports = o();
    })(ln, function() {
      var r = r || { Msg: /* @__PURE__ */ Object.create(null) };
      return r.Msg.ADD_COMMENT = "Add Comment", r.Msg.CANNOT_DELETE_VARIABLE_PROCEDURE = "Can't delete the variable '%1' because it's part of the definition of the function '%2'", r.Msg.CHANGE_VALUE_TITLE = "Change value:", r.Msg.CLEAN_UP = "Clean up Blocks", r.Msg.COLLAPSED_WARNINGS_WARNING = "Collapsed blocks contain warnings.", r.Msg.COLLAPSE_ALL = "Collapse Blocks", r.Msg.COLLAPSE_BLOCK = "Collapse Block", r.Msg.COLOUR_BLEND_COLOUR1 = "colour 1", r.Msg.COLOUR_BLEND_COLOUR2 = "colour 2", r.Msg.COLOUR_BLEND_HELPURL = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp", r.Msg.COLOUR_BLEND_RATIO = "ratio", r.Msg.COLOUR_BLEND_TITLE = "blend", r.Msg.COLOUR_BLEND_TOOLTIP = "Blends two colours together with a given ratio (0.0 - 1.0).", r.Msg.COLOUR_PICKER_HELPURL = "https://en.wikipedia.org/wiki/Color", r.Msg.COLOUR_PICKER_TOOLTIP = "Choose a colour from the palette.", r.Msg.COLOUR_RANDOM_HELPURL = "http://randomcolour.com", r.Msg.COLOUR_RANDOM_TITLE = "random colour", r.Msg.COLOUR_RANDOM_TOOLTIP = "Choose a colour at random.", r.Msg.COLOUR_RGB_BLUE = "blue", r.Msg.COLOUR_RGB_GREEN = "green", r.Msg.COLOUR_RGB_HELPURL = "https://www.december.com/html/spec/colorpercompact.html", r.Msg.COLOUR_RGB_RED = "red", r.Msg.COLOUR_RGB_TITLE = "colour with", r.Msg.COLOUR_RGB_TOOLTIP = "Create a colour with the specified amount of red, green, and blue. All values must be between 0 and 100.", r.Msg.CONTROLS_FLOW_STATEMENTS_HELPURL = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks", r.Msg.CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK = "break out of loop", r.Msg.CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE = "continue with next iteration of loop", r.Msg.CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK = "Break out of the containing loop.", r.Msg.CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE = "Skip the rest of this loop, and continue with the next iteration.", r.Msg.CONTROLS_FLOW_STATEMENTS_WARNING = "Warning: This block may only be used within a loop.", r.Msg.CONTROLS_FOREACH_HELPURL = "https://github.com/google/blockly/wiki/Loops#for-each", r.Msg.CONTROLS_FOREACH_TITLE = "for each item %1 in list %2", r.Msg.CONTROLS_FOREACH_TOOLTIP = "For each item in a list, set the variable '%1' to the item, and then do some statements.", r.Msg.CONTROLS_FOR_HELPURL = "https://github.com/google/blockly/wiki/Loops#count-with", r.Msg.CONTROLS_FOR_TITLE = "count with %1 from %2 to %3 by %4", r.Msg.CONTROLS_FOR_TOOLTIP = "Have the variable '%1' take on the values from the start number to the end number, counting by the specified interval, and do the specified blocks.", r.Msg.CONTROLS_IF_ELSEIF_TOOLTIP = "Add a condition to the if block.", r.Msg.CONTROLS_IF_ELSE_TOOLTIP = "Add a final, catch-all condition to the if block.", r.Msg.CONTROLS_IF_HELPURL = "https://github.com/google/blockly/wiki/IfElse", r.Msg.CONTROLS_IF_IF_TOOLTIP = "Add, remove, or reorder sections to reconfigure this if block.", r.Msg.CONTROLS_IF_MSG_ELSE = "else", r.Msg.CONTROLS_IF_MSG_ELSEIF = "else if", r.Msg.CONTROLS_IF_MSG_IF = "if", r.Msg.CONTROLS_IF_TOOLTIP_1 = "If a value is true, then do some statements.", r.Msg.CONTROLS_IF_TOOLTIP_2 = "If a value is true, then do the first block of statements. Otherwise, do the second block of statements.", r.Msg.CONTROLS_IF_TOOLTIP_3 = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements.", r.Msg.CONTROLS_IF_TOOLTIP_4 = "If the first value is true, then do the first block of statements. Otherwise, if the second value is true, do the second block of statements. If none of the values are true, do the last block of statements.", r.Msg.CONTROLS_REPEAT_HELPURL = "https://en.wikipedia.org/wiki/For_loop", r.Msg.CONTROLS_REPEAT_INPUT_DO = "do", r.Msg.CONTROLS_REPEAT_TITLE = "repeat %1 times", r.Msg.CONTROLS_REPEAT_TOOLTIP = "Do some statements several times.", r.Msg.CONTROLS_WHILEUNTIL_HELPURL = "https://github.com/google/blockly/wiki/Loops#repeat", r.Msg.CONTROLS_WHILEUNTIL_OPERATOR_UNTIL = "repeat until", r.Msg.CONTROLS_WHILEUNTIL_OPERATOR_WHILE = "repeat while", r.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL = "While a value is false, then do some statements.", r.Msg.CONTROLS_WHILEUNTIL_TOOLTIP_WHILE = "While a value is true, then do some statements.", r.Msg.DELETE_ALL_BLOCKS = "Delete all %1 blocks?", r.Msg.DELETE_BLOCK = "Delete Block", r.Msg.DELETE_VARIABLE = "Delete the '%1' variable", r.Msg.DELETE_VARIABLE_CONFIRMATION = "Delete %1 uses of the '%2' variable?", r.Msg.DELETE_X_BLOCKS = "Delete %1 Blocks", r.Msg.DIALOG_CANCEL = "Cancel", r.Msg.DIALOG_OK = "OK", r.Msg.DISABLE_BLOCK = "Disable Block", r.Msg.DUPLICATE_BLOCK = "Duplicate", r.Msg.DUPLICATE_COMMENT = "Duplicate Comment", r.Msg.ENABLE_BLOCK = "Enable Block", r.Msg.EXPAND_ALL = "Expand Blocks", r.Msg.EXPAND_BLOCK = "Expand Block", r.Msg.EXTERNAL_INPUTS = "External Inputs", r.Msg.HELP = "Help", r.Msg.INLINE_INPUTS = "Inline Inputs", r.Msg.LISTS_CREATE_EMPTY_HELPURL = "https://github.com/google/blockly/wiki/Lists#create-empty-list", r.Msg.LISTS_CREATE_EMPTY_TITLE = "create empty list", r.Msg.LISTS_CREATE_EMPTY_TOOLTIP = "Returns a list, of length 0, containing no data records", r.Msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD = "list", r.Msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP = "Add, remove, or reorder sections to reconfigure this list block.", r.Msg.LISTS_CREATE_WITH_HELPURL = "https://github.com/google/blockly/wiki/Lists#create-list-with", r.Msg.LISTS_CREATE_WITH_INPUT_WITH = "create list with", r.Msg.LISTS_CREATE_WITH_ITEM_TOOLTIP = "Add an item to the list.", r.Msg.LISTS_CREATE_WITH_TOOLTIP = "Create a list with any number of items.", r.Msg.LISTS_GET_INDEX_FIRST = "first", r.Msg.LISTS_GET_INDEX_FROM_END = "# from end", r.Msg.LISTS_GET_INDEX_FROM_START = "#", r.Msg.LISTS_GET_INDEX_GET = "get", r.Msg.LISTS_GET_INDEX_GET_REMOVE = "get and remove", r.Msg.LISTS_GET_INDEX_LAST = "last", r.Msg.LISTS_GET_INDEX_RANDOM = "random", r.Msg.LISTS_GET_INDEX_REMOVE = "remove", r.Msg.LISTS_GET_INDEX_TAIL = "", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST = "Returns the first item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM = "Returns the item at the specified position in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST = "Returns the last item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM = "Returns a random item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST = "Removes and returns the first item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM = "Removes and returns the item at the specified position in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST = "Removes and returns the last item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM = "Removes and returns a random item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST = "Removes the first item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM = "Removes the item at the specified position in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST = "Removes the last item in a list.", r.Msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM = "Removes a random item in a list.", r.Msg.LISTS_GET_SUBLIST_END_FROM_END = "to # from end", r.Msg.LISTS_GET_SUBLIST_END_FROM_START = "to #", r.Msg.LISTS_GET_SUBLIST_END_LAST = "to last", r.Msg.LISTS_GET_SUBLIST_HELPURL = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist", r.Msg.LISTS_GET_SUBLIST_START_FIRST = "get sub-list from first", r.Msg.LISTS_GET_SUBLIST_START_FROM_END = "get sub-list from # from end", r.Msg.LISTS_GET_SUBLIST_START_FROM_START = "get sub-list from #", r.Msg.LISTS_GET_SUBLIST_TAIL = "", r.Msg.LISTS_GET_SUBLIST_TOOLTIP = "Creates a copy of the specified portion of a list.", r.Msg.LISTS_INDEX_FROM_END_TOOLTIP = "%1 is the last item.", r.Msg.LISTS_INDEX_FROM_START_TOOLTIP = "%1 is the first item.", r.Msg.LISTS_INDEX_OF_FIRST = "find first occurrence of item", r.Msg.LISTS_INDEX_OF_HELPURL = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list", r.Msg.LISTS_INDEX_OF_LAST = "find last occurrence of item", r.Msg.LISTS_INDEX_OF_TOOLTIP = "Returns the index of the first/last occurrence of the item in the list. Returns %1 if item is not found.", r.Msg.LISTS_INLIST = "in list", r.Msg.LISTS_ISEMPTY_HELPURL = "https://github.com/google/blockly/wiki/Lists#is-empty", r.Msg.LISTS_ISEMPTY_TITLE = "%1 is empty", r.Msg.LISTS_ISEMPTY_TOOLTIP = "Returns true if the list is empty.", r.Msg.LISTS_LENGTH_HELPURL = "https://github.com/google/blockly/wiki/Lists#length-of", r.Msg.LISTS_LENGTH_TITLE = "length of %1", r.Msg.LISTS_LENGTH_TOOLTIP = "Returns the length of a list.", r.Msg.LISTS_REPEAT_HELPURL = "https://github.com/google/blockly/wiki/Lists#create-list-with", r.Msg.LISTS_REPEAT_TITLE = "create list with item %1 repeated %2 times", r.Msg.LISTS_REPEAT_TOOLTIP = "Creates a list consisting of the given value repeated the specified number of times.", r.Msg.LISTS_REVERSE_HELPURL = "https://github.com/google/blockly/wiki/Lists#reversing-a-list", r.Msg.LISTS_REVERSE_MESSAGE0 = "reverse %1", r.Msg.LISTS_REVERSE_TOOLTIP = "Reverse a copy of a list.", r.Msg.LISTS_SET_INDEX_HELPURL = "https://github.com/google/blockly/wiki/Lists#in-list--set", r.Msg.LISTS_SET_INDEX_INPUT_TO = "as", r.Msg.LISTS_SET_INDEX_INSERT = "insert at", r.Msg.LISTS_SET_INDEX_SET = "set", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST = "Inserts the item at the start of a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM = "Inserts the item at the specified position in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST = "Append the item to the end of a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM = "Inserts the item randomly in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST = "Sets the first item in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM = "Sets the item at the specified position in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST = "Sets the last item in a list.", r.Msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM = "Sets a random item in a list.", r.Msg.LISTS_SORT_HELPURL = "https://github.com/google/blockly/wiki/Lists#sorting-a-list", r.Msg.LISTS_SORT_ORDER_ASCENDING = "ascending", r.Msg.LISTS_SORT_ORDER_DESCENDING = "descending", r.Msg.LISTS_SORT_TITLE = "sort %1 %2 %3", r.Msg.LISTS_SORT_TOOLTIP = "Sort a copy of a list.", r.Msg.LISTS_SORT_TYPE_IGNORECASE = "alphabetic, ignore case", r.Msg.LISTS_SORT_TYPE_NUMERIC = "numeric", r.Msg.LISTS_SORT_TYPE_TEXT = "alphabetic", r.Msg.LISTS_SPLIT_HELPURL = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists", r.Msg.LISTS_SPLIT_LIST_FROM_TEXT = "make list from text", r.Msg.LISTS_SPLIT_TEXT_FROM_LIST = "make text from list", r.Msg.LISTS_SPLIT_TOOLTIP_JOIN = "Join a list of texts into one text, separated by a delimiter.", r.Msg.LISTS_SPLIT_TOOLTIP_SPLIT = "Split text into a list of texts, breaking at each delimiter.", r.Msg.LISTS_SPLIT_WITH_DELIMITER = "with delimiter", r.Msg.LOGIC_BOOLEAN_FALSE = "false", r.Msg.LOGIC_BOOLEAN_HELPURL = "https://github.com/google/blockly/wiki/Logic#values", r.Msg.LOGIC_BOOLEAN_TOOLTIP = "Returns either true or false.", r.Msg.LOGIC_BOOLEAN_TRUE = "true", r.Msg.LOGIC_COMPARE_HELPURL = "https://en.wikipedia.org/wiki/Inequality_(mathematics)", r.Msg.LOGIC_COMPARE_TOOLTIP_EQ = "Return true if both inputs equal each other.", r.Msg.LOGIC_COMPARE_TOOLTIP_GT = "Return true if the first input is greater than the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_GTE = "Return true if the first input is greater than or equal to the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_LT = "Return true if the first input is smaller than the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_LTE = "Return true if the first input is smaller than or equal to the second input.", r.Msg.LOGIC_COMPARE_TOOLTIP_NEQ = "Return true if both inputs are not equal to each other.", r.Msg.LOGIC_NEGATE_HELPURL = "https://github.com/google/blockly/wiki/Logic#not", r.Msg.LOGIC_NEGATE_TITLE = "not %1", r.Msg.LOGIC_NEGATE_TOOLTIP = "Returns true if the input is false. Returns false if the input is true.", r.Msg.LOGIC_NULL = "null", r.Msg.LOGIC_NULL_HELPURL = "https://en.wikipedia.org/wiki/Nullable_type", r.Msg.LOGIC_NULL_TOOLTIP = "Returns null.", r.Msg.LOGIC_OPERATION_AND = "and", r.Msg.LOGIC_OPERATION_HELPURL = "https://github.com/google/blockly/wiki/Logic#logical-operations", r.Msg.LOGIC_OPERATION_OR = "or", r.Msg.LOGIC_OPERATION_TOOLTIP_AND = "Return true if both inputs are true.", r.Msg.LOGIC_OPERATION_TOOLTIP_OR = "Return true if at least one of the inputs is true.", r.Msg.LOGIC_TERNARY_CONDITION = "test", r.Msg.LOGIC_TERNARY_HELPURL = "https://en.wikipedia.org/wiki/%3F:", r.Msg.LOGIC_TERNARY_IF_FALSE = "if false", r.Msg.LOGIC_TERNARY_IF_TRUE = "if true", r.Msg.LOGIC_TERNARY_TOOLTIP = "Check the condition in 'test'. If the condition is true, returns the 'if true' value; otherwise returns the 'if false' value.", r.Msg.MATH_ADDITION_SYMBOL = "+", r.Msg.MATH_ARITHMETIC_HELPURL = "https://en.wikipedia.org/wiki/Arithmetic", r.Msg.MATH_ARITHMETIC_TOOLTIP_ADD = "Return the sum of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_DIVIDE = "Return the quotient of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_MINUS = "Return the difference of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_MULTIPLY = "Return the product of the two numbers.", r.Msg.MATH_ARITHMETIC_TOOLTIP_POWER = "Return the first number raised to the power of the second number.", r.Msg.MATH_ATAN2_HELPURL = "https://en.wikipedia.org/wiki/Atan2", r.Msg.MATH_ATAN2_TITLE = "atan2 of X:%1 Y:%2", r.Msg.MATH_ATAN2_TOOLTIP = "Return the arctangent of point (X, Y) in degrees from -180 to 180.", r.Msg.MATH_CHANGE_HELPURL = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter", r.Msg.MATH_CHANGE_TITLE = "change %1 by %2", r.Msg.MATH_CHANGE_TOOLTIP = "Add a number to variable '%1'.", r.Msg.MATH_CONSTANT_HELPURL = "https://en.wikipedia.org/wiki/Mathematical_constant", r.Msg.MATH_CONSTANT_TOOLTIP = "Return one of the common constants: π (3.141…), e (2.718…), φ (1.618…), sqrt(2) (1.414…), sqrt(½) (0.707…), or ∞ (infinity).", r.Msg.MATH_CONSTRAIN_HELPURL = "https://en.wikipedia.org/wiki/Clamping_(graphics)", r.Msg.MATH_CONSTRAIN_TITLE = "constrain %1 low %2 high %3", r.Msg.MATH_CONSTRAIN_TOOLTIP = "Constrain a number to be between the specified limits (inclusive).", r.Msg.MATH_DIVISION_SYMBOL = "÷", r.Msg.MATH_IS_DIVISIBLE_BY = "is divisible by", r.Msg.MATH_IS_EVEN = "is even", r.Msg.MATH_IS_NEGATIVE = "is negative", r.Msg.MATH_IS_ODD = "is odd", r.Msg.MATH_IS_POSITIVE = "is positive", r.Msg.MATH_IS_PRIME = "is prime", r.Msg.MATH_IS_TOOLTIP = "Check if a number is an even, odd, prime, whole, positive, negative, or if it is divisible by certain number. Returns true or false.", r.Msg.MATH_IS_WHOLE = "is whole", r.Msg.MATH_MODULO_HELPURL = "https://en.wikipedia.org/wiki/Modulo_operation", r.Msg.MATH_MODULO_TITLE = "remainder of %1 ÷ %2", r.Msg.MATH_MODULO_TOOLTIP = "Return the remainder from dividing the two numbers.", r.Msg.MATH_MULTIPLICATION_SYMBOL = "×", r.Msg.MATH_NUMBER_HELPURL = "https://en.wikipedia.org/wiki/Number", r.Msg.MATH_NUMBER_TOOLTIP = "A number.", r.Msg.MATH_ONLIST_HELPURL = "", r.Msg.MATH_ONLIST_OPERATOR_AVERAGE = "average of list", r.Msg.MATH_ONLIST_OPERATOR_MAX = "max of list", r.Msg.MATH_ONLIST_OPERATOR_MEDIAN = "median of list", r.Msg.MATH_ONLIST_OPERATOR_MIN = "min of list", r.Msg.MATH_ONLIST_OPERATOR_MODE = "modes of list", r.Msg.MATH_ONLIST_OPERATOR_RANDOM = "random item of list", r.Msg.MATH_ONLIST_OPERATOR_STD_DEV = "standard deviation of list", r.Msg.MATH_ONLIST_OPERATOR_SUM = "sum of list", r.Msg.MATH_ONLIST_TOOLTIP_AVERAGE = "Return the average (arithmetic mean) of the numeric values in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MAX = "Return the largest number in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MEDIAN = "Return the median number in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MIN = "Return the smallest number in the list.", r.Msg.MATH_ONLIST_TOOLTIP_MODE = "Return a list of the most common item(s) in the list.", r.Msg.MATH_ONLIST_TOOLTIP_RANDOM = "Return a random element from the list.", r.Msg.MATH_ONLIST_TOOLTIP_STD_DEV = "Return the standard deviation of the list.", r.Msg.MATH_ONLIST_TOOLTIP_SUM = "Return the sum of all the numbers in the list.", r.Msg.MATH_POWER_SYMBOL = "^", r.Msg.MATH_RANDOM_FLOAT_HELPURL = "https://en.wikipedia.org/wiki/Random_number_generation", r.Msg.MATH_RANDOM_FLOAT_TITLE_RANDOM = "random fraction", r.Msg.MATH_RANDOM_FLOAT_TOOLTIP = "Return a random fraction between 0.0 (inclusive) and 1.0 (exclusive).", r.Msg.MATH_RANDOM_INT_HELPURL = "https://en.wikipedia.org/wiki/Random_number_generation", r.Msg.MATH_RANDOM_INT_TITLE = "random integer from %1 to %2", r.Msg.MATH_RANDOM_INT_TOOLTIP = "Return a random integer between the two specified limits, inclusive.", r.Msg.MATH_ROUND_HELPURL = "https://en.wikipedia.org/wiki/Rounding", r.Msg.MATH_ROUND_OPERATOR_ROUND = "round", r.Msg.MATH_ROUND_OPERATOR_ROUNDDOWN = "round down", r.Msg.MATH_ROUND_OPERATOR_ROUNDUP = "round up", r.Msg.MATH_ROUND_TOOLTIP = "Round a number up or down.", r.Msg.MATH_SINGLE_HELPURL = "https://en.wikipedia.org/wiki/Square_root", r.Msg.MATH_SINGLE_OP_ABSOLUTE = "absolute", r.Msg.MATH_SINGLE_OP_ROOT = "square root", r.Msg.MATH_SINGLE_TOOLTIP_ABS = "Return the absolute value of a number.", r.Msg.MATH_SINGLE_TOOLTIP_EXP = "Return e to the power of a number.", r.Msg.MATH_SINGLE_TOOLTIP_LN = "Return the natural logarithm of a number.", r.Msg.MATH_SINGLE_TOOLTIP_LOG10 = "Return the base 10 logarithm of a number.", r.Msg.MATH_SINGLE_TOOLTIP_NEG = "Return the negation of a number.", r.Msg.MATH_SINGLE_TOOLTIP_POW10 = "Return 10 to the power of a number.", r.Msg.MATH_SINGLE_TOOLTIP_ROOT = "Return the square root of a number.", r.Msg.MATH_SUBTRACTION_SYMBOL = "-", r.Msg.MATH_TRIG_ACOS = "acos", r.Msg.MATH_TRIG_ASIN = "asin", r.Msg.MATH_TRIG_ATAN = "atan", r.Msg.MATH_TRIG_COS = "cos", r.Msg.MATH_TRIG_HELPURL = "https://en.wikipedia.org/wiki/Trigonometric_functions", r.Msg.MATH_TRIG_SIN = "sin", r.Msg.MATH_TRIG_TAN = "tan", r.Msg.MATH_TRIG_TOOLTIP_ACOS = "Return the arccosine of a number.", r.Msg.MATH_TRIG_TOOLTIP_ASIN = "Return the arcsine of a number.", r.Msg.MATH_TRIG_TOOLTIP_ATAN = "Return the arctangent of a number.", r.Msg.MATH_TRIG_TOOLTIP_COS = "Return the cosine of a degree (not radian).", r.Msg.MATH_TRIG_TOOLTIP_SIN = "Return the sine of a degree (not radian).", r.Msg.MATH_TRIG_TOOLTIP_TAN = "Return the tangent of a degree (not radian).", r.Msg.NEW_COLOUR_VARIABLE = "Create colour variable...", r.Msg.NEW_NUMBER_VARIABLE = "Create number variable...", r.Msg.NEW_STRING_VARIABLE = "Create string variable...", r.Msg.NEW_VARIABLE = "Create variable...", r.Msg.NEW_VARIABLE_TITLE = "New variable name:", r.Msg.NEW_VARIABLE_TYPE_TITLE = "New variable type:", r.Msg.ORDINAL_NUMBER_SUFFIX = "", r.Msg.PROCEDURES_ALLOW_STATEMENTS = "allow statements", r.Msg.PROCEDURES_BEFORE_PARAMS = "with:", r.Msg.PROCEDURES_CALLNORETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_CALLNORETURN_TOOLTIP = "Run the user-defined function '%1'.", r.Msg.PROCEDURES_CALLRETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_CALLRETURN_TOOLTIP = "Run the user-defined function '%1' and use its output.", r.Msg.PROCEDURES_CALL_BEFORE_PARAMS = "with:", r.Msg.PROCEDURES_CREATE_DO = "Create '%1'", r.Msg.PROCEDURES_DEFNORETURN_COMMENT = "Describe this function...", r.Msg.PROCEDURES_DEFNORETURN_DO = "", r.Msg.PROCEDURES_DEFNORETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_DEFNORETURN_PROCEDURE = "do something", r.Msg.PROCEDURES_DEFNORETURN_TITLE = "to", r.Msg.PROCEDURES_DEFNORETURN_TOOLTIP = "Creates a function with no output.", r.Msg.PROCEDURES_DEFRETURN_HELPURL = "https://en.wikipedia.org/wiki/Subroutine", r.Msg.PROCEDURES_DEFRETURN_RETURN = "return", r.Msg.PROCEDURES_DEFRETURN_TOOLTIP = "Creates a function with an output.", r.Msg.PROCEDURES_DEF_DUPLICATE_WARNING = "Warning: This function has duplicate parameters.", r.Msg.PROCEDURES_HIGHLIGHT_DEF = "Highlight function definition", r.Msg.PROCEDURES_IFRETURN_HELPURL = "http://c2.com/cgi/wiki?GuardClause", r.Msg.PROCEDURES_IFRETURN_TOOLTIP = "If a value is true, then return a second value.", r.Msg.PROCEDURES_IFRETURN_WARNING = "Warning: This block may be used only within a function definition.", r.Msg.PROCEDURES_MUTATORARG_TITLE = "input name:", r.Msg.PROCEDURES_MUTATORARG_TOOLTIP = "Add an input to the function.", r.Msg.PROCEDURES_MUTATORCONTAINER_TITLE = "inputs", r.Msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP = "Add, remove, or reorder inputs to this function.", r.Msg.REDO = "Redo", r.Msg.REMOVE_COMMENT = "Remove Comment", r.Msg.RENAME_VARIABLE = "Rename variable...", r.Msg.RENAME_VARIABLE_TITLE = "Rename all '%1' variables to:", r.Msg.TEXT_APPEND_HELPURL = "https://github.com/google/blockly/wiki/Text#text-modification", r.Msg.TEXT_APPEND_TITLE = "to %1 append text %2", r.Msg.TEXT_APPEND_TOOLTIP = "Append some text to variable '%1'.", r.Msg.TEXT_CHANGECASE_HELPURL = "https://github.com/google/blockly/wiki/Text#adjusting-text-case", r.Msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE = "to lower case", r.Msg.TEXT_CHANGECASE_OPERATOR_TITLECASE = "to Title Case", r.Msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE = "to UPPER CASE", r.Msg.TEXT_CHANGECASE_TOOLTIP = "Return a copy of the text in a different case.", r.Msg.TEXT_CHARAT_FIRST = "get first letter", r.Msg.TEXT_CHARAT_FROM_END = "get letter # from end", r.Msg.TEXT_CHARAT_FROM_START = "get letter #", r.Msg.TEXT_CHARAT_HELPURL = "https://github.com/google/blockly/wiki/Text#extracting-text", r.Msg.TEXT_CHARAT_LAST = "get last letter", r.Msg.TEXT_CHARAT_RANDOM = "get random letter", r.Msg.TEXT_CHARAT_TAIL = "", r.Msg.TEXT_CHARAT_TITLE = "in text %1 %2", r.Msg.TEXT_CHARAT_TOOLTIP = "Returns the letter at the specified position.", r.Msg.TEXT_COUNT_HELPURL = "https://github.com/google/blockly/wiki/Text#counting-substrings", r.Msg.TEXT_COUNT_MESSAGE0 = "count %1 in %2", r.Msg.TEXT_COUNT_TOOLTIP = "Count how many times some text occurs within some other text.", r.Msg.TEXT_CREATE_JOIN_ITEM_TOOLTIP = "Add an item to the text.", r.Msg.TEXT_CREATE_JOIN_TITLE_JOIN = "join", r.Msg.TEXT_CREATE_JOIN_TOOLTIP = "Add, remove, or reorder sections to reconfigure this text block.", r.Msg.TEXT_GET_SUBSTRING_END_FROM_END = "to letter # from end", r.Msg.TEXT_GET_SUBSTRING_END_FROM_START = "to letter #", r.Msg.TEXT_GET_SUBSTRING_END_LAST = "to last letter", r.Msg.TEXT_GET_SUBSTRING_HELPURL = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text", r.Msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT = "in text", r.Msg.TEXT_GET_SUBSTRING_START_FIRST = "get substring from first letter", r.Msg.TEXT_GET_SUBSTRING_START_FROM_END = "get substring from letter # from end", r.Msg.TEXT_GET_SUBSTRING_START_FROM_START = "get substring from letter #", r.Msg.TEXT_GET_SUBSTRING_TAIL = "", r.Msg.TEXT_GET_SUBSTRING_TOOLTIP = "Returns a specified portion of the text.", r.Msg.TEXT_INDEXOF_HELPURL = "https://github.com/google/blockly/wiki/Text#finding-text", r.Msg.TEXT_INDEXOF_OPERATOR_FIRST = "find first occurrence of text", r.Msg.TEXT_INDEXOF_OPERATOR_LAST = "find last occurrence of text", r.Msg.TEXT_INDEXOF_TITLE = "in text %1 %2 %3", r.Msg.TEXT_INDEXOF_TOOLTIP = "Returns the index of the first/last occurrence of the first text in the second text. Returns %1 if text is not found.", r.Msg.TEXT_ISEMPTY_HELPURL = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text", r.Msg.TEXT_ISEMPTY_TITLE = "%1 is empty", r.Msg.TEXT_ISEMPTY_TOOLTIP = "Returns true if the provided text is empty.", r.Msg.TEXT_JOIN_HELPURL = "https://github.com/google/blockly/wiki/Text#text-creation", r.Msg.TEXT_JOIN_TITLE_CREATEWITH = "create text with", r.Msg.TEXT_JOIN_TOOLTIP = "Create a piece of text by joining together any number of items.", r.Msg.TEXT_LENGTH_HELPURL = "https://github.com/google/blockly/wiki/Text#text-modification", r.Msg.TEXT_LENGTH_TITLE = "length of %1", r.Msg.TEXT_LENGTH_TOOLTIP = "Returns the number of letters (including spaces) in the provided text.", r.Msg.TEXT_PRINT_HELPURL = "https://github.com/google/blockly/wiki/Text#printing-text", r.Msg.TEXT_PRINT_TITLE = "print %1", r.Msg.TEXT_PRINT_TOOLTIP = "Print the specified text, number or other value.", r.Msg.TEXT_PROMPT_HELPURL = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user", r.Msg.TEXT_PROMPT_TOOLTIP_NUMBER = "Prompt for user for a number.", r.Msg.TEXT_PROMPT_TOOLTIP_TEXT = "Prompt for user for some text.", r.Msg.TEXT_PROMPT_TYPE_NUMBER = "prompt for number with message", r.Msg.TEXT_PROMPT_TYPE_TEXT = "prompt for text with message", r.Msg.TEXT_REPLACE_HELPURL = "https://github.com/google/blockly/wiki/Text#replacing-substrings", r.Msg.TEXT_REPLACE_MESSAGE0 = "replace %1 with %2 in %3", r.Msg.TEXT_REPLACE_TOOLTIP = "Replace all occurances of some text within some other text.", r.Msg.TEXT_REVERSE_HELPURL = "https://github.com/google/blockly/wiki/Text#reversing-text", r.Msg.TEXT_REVERSE_MESSAGE0 = "reverse %1", r.Msg.TEXT_REVERSE_TOOLTIP = "Reverses the order of the characters in the text.", r.Msg.TEXT_TEXT_HELPURL = "https://en.wikipedia.org/wiki/String_(computer_science)", r.Msg.TEXT_TEXT_TOOLTIP = "A letter, word, or line of text.", r.Msg.TEXT_TRIM_HELPURL = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces", r.Msg.TEXT_TRIM_OPERATOR_BOTH = "trim spaces from both sides of", r.Msg.TEXT_TRIM_OPERATOR_LEFT = "trim spaces from left side of", r.Msg.TEXT_TRIM_OPERATOR_RIGHT = "trim spaces from right side of", r.Msg.TEXT_TRIM_TOOLTIP = "Return a copy of the text with spaces removed from one or both ends.", r.Msg.TODAY = "Today", r.Msg.UNDO = "Undo", r.Msg.UNNAMED_KEY = "unnamed", r.Msg.VARIABLES_DEFAULT_NAME = "item", r.Msg.VARIABLES_GET_CREATE_SET = "Create 'set %1'", r.Msg.VARIABLES_GET_HELPURL = "https://github.com/google/blockly/wiki/Variables#get", r.Msg.VARIABLES_GET_TOOLTIP = "Returns the value of this variable.", r.Msg.VARIABLES_SET = "set %1 to %2", r.Msg.VARIABLES_SET_CREATE_GET = "Create 'get %1'", r.Msg.VARIABLES_SET_HELPURL = "https://github.com/google/blockly/wiki/Variables#set", r.Msg.VARIABLES_SET_TOOLTIP = "Sets this variable to be equal to the input.", r.Msg.VARIABLE_ALREADY_EXISTS = "A variable named '%1' already exists.", r.Msg.VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE = "A variable named '%1' already exists for another type: '%2'.", r.Msg.VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER = "A variable named '%1' already exists as a parameter in the procedure '%2'.", r.Msg.WORKSPACE_ARIA_LABEL = "Blockly Workspace", r.Msg.WORKSPACE_COMMENT_DEFAULT_TEXT = "Say something...", r.Msg.CONTROLS_FOREACH_INPUT_DO = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.CONTROLS_FOR_INPUT_DO = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.CONTROLS_IF_ELSEIF_TITLE_ELSEIF = r.Msg.CONTROLS_IF_MSG_ELSEIF, r.Msg.CONTROLS_IF_ELSE_TITLE_ELSE = r.Msg.CONTROLS_IF_MSG_ELSE, r.Msg.CONTROLS_IF_IF_TITLE_IF = r.Msg.CONTROLS_IF_MSG_IF, r.Msg.CONTROLS_IF_MSG_THEN = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.CONTROLS_WHILEUNTIL_INPUT_DO = r.Msg.CONTROLS_REPEAT_INPUT_DO, r.Msg.LISTS_CREATE_WITH_ITEM_TITLE = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.LISTS_GET_INDEX_HELPURL = r.Msg.LISTS_INDEX_OF_HELPURL, r.Msg.LISTS_GET_INDEX_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.LISTS_GET_SUBLIST_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.LISTS_INDEX_OF_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.LISTS_SET_INDEX_INPUT_IN_LIST = r.Msg.LISTS_INLIST, r.Msg.MATH_CHANGE_TITLE_ITEM = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.PROCEDURES_DEFRETURN_COMMENT = r.Msg.PROCEDURES_DEFNORETURN_COMMENT, r.Msg.PROCEDURES_DEFRETURN_DO = r.Msg.PROCEDURES_DEFNORETURN_DO, r.Msg.PROCEDURES_DEFRETURN_PROCEDURE = r.Msg.PROCEDURES_DEFNORETURN_PROCEDURE, r.Msg.PROCEDURES_DEFRETURN_TITLE = r.Msg.PROCEDURES_DEFNORETURN_TITLE, r.Msg.TEXT_APPEND_VARIABLE = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.TEXT_CREATE_JOIN_ITEM_TITLE_ITEM = r.Msg.VARIABLES_DEFAULT_NAME, r.Msg.LOGIC_HUE = "210", r.Msg.LOOPS_HUE = "120", r.Msg.MATH_HUE = "230", r.Msg.TEXTS_HUE = "160", r.Msg.LISTS_HUE = "260", r.Msg.COLOUR_HUE = "20", r.Msg.VARIABLES_HUE = "330", r.Msg.VARIABLES_DYNAMIC_HUE = "310", r.Msg.PROCEDURES_HUE = "290", r.Msg;
    });
  }(lh)), lh.exports;
}
var sh = { exports: {} }, ah = { exports: {} }, pm;
function jM() {
  return pm || (pm = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(Bh());
    })(ln, function(r) {
      var o = r.__namespace__, c = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "colour_picker", message0: "%1", args0: [{ type: "field_colour", name: "COLOUR", colour: "#ff0000" }], output: "Colour", helpUrl: "%{BKY_COLOUR_PICKER_HELPURL}", style: "colour_blocks", tooltip: "%{BKY_COLOUR_PICKER_TOOLTIP}", extensions: ["parent_tooltip_when_inline"] }, {
        type: "colour_random",
        message0: "%{BKY_COLOUR_RANDOM_TITLE}",
        output: "Colour",
        helpUrl: "%{BKY_COLOUR_RANDOM_HELPURL}",
        style: "colour_blocks",
        tooltip: "%{BKY_COLOUR_RANDOM_TOOLTIP}"
      }, { type: "colour_rgb", message0: "%{BKY_COLOUR_RGB_TITLE} %{BKY_COLOUR_RGB_RED} %1 %{BKY_COLOUR_RGB_GREEN} %2 %{BKY_COLOUR_RGB_BLUE} %3", args0: [{ type: "input_value", name: "RED", check: "Number", align: "RIGHT" }, { type: "input_value", name: "GREEN", check: "Number", align: "RIGHT" }, { type: "input_value", name: "BLUE", check: "Number", align: "RIGHT" }], output: "Colour", helpUrl: "%{BKY_COLOUR_RGB_HELPURL}", style: "colour_blocks", tooltip: "%{BKY_COLOUR_RGB_TOOLTIP}" }, {
        type: "colour_blend",
        message0: "%{BKY_COLOUR_BLEND_TITLE} %{BKY_COLOUR_BLEND_COLOUR1} %1 %{BKY_COLOUR_BLEND_COLOUR2} %2 %{BKY_COLOUR_BLEND_RATIO} %3",
        args0: [{ type: "input_value", name: "COLOUR1", check: "Colour", align: "RIGHT" }, { type: "input_value", name: "COLOUR2", check: "Colour", align: "RIGHT" }, { type: "input_value", name: "RATIO", check: "Number", align: "RIGHT" }],
        output: "Colour",
        helpUrl: "%{BKY_COLOUR_BLEND_HELPURL}",
        style: "colour_blocks",
        tooltip: "%{BKY_COLOUR_BLEND_TOOLTIP}"
      }]);
      o.defineBlocks$$module$build$src$core$common(c);
      var T = {};
      T.blocks = c;
      var d = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        { type: "lists_create_empty", message0: "%{BKY_LISTS_CREATE_EMPTY_TITLE}", output: "Array", style: "list_blocks", tooltip: "%{BKY_LISTS_CREATE_EMPTY_TOOLTIP}", helpUrl: "%{BKY_LISTS_CREATE_EMPTY_HELPURL}" },
        {
          type: "lists_repeat",
          message0: "%{BKY_LISTS_REPEAT_TITLE}",
          args0: [{ type: "input_value", name: "ITEM" }, { type: "input_value", name: "NUM", check: "Number" }],
          output: "Array",
          style: "list_blocks",
          tooltip: "%{BKY_LISTS_REPEAT_TOOLTIP}",
          helpUrl: "%{BKY_LISTS_REPEAT_HELPURL}"
        },
        { type: "lists_reverse", message0: "%{BKY_LISTS_REVERSE_MESSAGE0}", args0: [{ type: "input_value", name: "LIST", check: "Array" }], output: "Array", inputsInline: !0, style: "list_blocks", tooltip: "%{BKY_LISTS_REVERSE_TOOLTIP}", helpUrl: "%{BKY_LISTS_REVERSE_HELPURL}" },
        { type: "lists_isEmpty", message0: "%{BKY_LISTS_ISEMPTY_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }], output: "Boolean", style: "list_blocks", tooltip: "%{BKY_LISTS_ISEMPTY_TOOLTIP}", helpUrl: "%{BKY_LISTS_ISEMPTY_HELPURL}" },
        { type: "lists_length", message0: "%{BKY_LISTS_LENGTH_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }], output: "Number", style: "list_blocks", tooltip: "%{BKY_LISTS_LENGTH_TOOLTIP}", helpUrl: "%{BKY_LISTS_LENGTH_HELPURL}" }
      ]), h = { init: function() {
        this.setHelpUrl(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_HELPURL), this.setStyle("list_blocks"), this.itemCount_ = 3, this.updateShape_(), this.setOutput(!0, "Array"), this.setMutator(new o.MutatorIcon$$module$build$src$core$icons$mutator_icon(
          ["lists_create_with_item"],
          this
        )), this.setTooltip(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_TOOLTIP);
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        return m.setAttribute("items", String(this.itemCount_)), m;
      }, domToMutation: function(m) {
        if (m = m.getAttribute("items"), !m)
          throw new TypeError("element did not have items");
        this.itemCount_ = parseInt(m, 10), this.updateShape_();
      }, saveExtraState: function() {
        return { itemCount: this.itemCount_ };
      }, loadExtraState: function(m) {
        this.itemCount_ = m.itemCount, this.updateShape_();
      }, decompose: function(m) {
        const D = m.newBlock("lists_create_with_container");
        D.initSvg();
        let B = D.getInput("STACK").connection;
        for (let V = 0; V < this.itemCount_; V++) {
          const oe = m.newBlock("lists_create_with_item");
          if (oe.initSvg(), !oe.previousConnection)
            throw Error("itemBlock has no previousConnection");
          B.connect(oe.previousConnection), B = oe.nextConnection;
        }
        return D;
      }, compose: function(m) {
        var D = m.getInputTargetBlock("STACK");
        for (m = []; D; )
          D.isInsertionMarker() || m.push(D.valueConnection_), D = D.getNextBlock();
        for (D = 0; D < this.itemCount_; D++) {
          const B = this.getInput("ADD" + D).connection.targetConnection;
          B && m.indexOf(B) === -1 && B.disconnect();
        }
        for (this.itemCount_ = m.length, this.updateShape_(), D = 0; D < this.itemCount_; D++) {
          let B;
          (B = m[D]) == null || B.reconnect(this, "ADD" + D);
        }
      }, saveConnections: function(m) {
        m = m.getInputTargetBlock("STACK");
        let D = 0;
        for (; m; ) {
          if (m.isInsertionMarker()) {
            m = m.getNextBlock();
            continue;
          }
          const B = this.getInput("ADD" + D);
          let V;
          m.valueConnection_ = (V = B) == null ? void 0 : V.connection.targetConnection, m = m.getNextBlock(), D++;
        }
      }, updateShape_: function() {
        this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(o.Msg$$module$build$src$core$msg.LISTS_CREATE_EMPTY_TITLE);
        for (var m = 0; m < this.itemCount_; m++)
          if (!this.getInput("ADD" + m)) {
            const D = this.appendValueInput("ADD" + m).setAlign(o.Align$$module$build$src$core$inputs$align.RIGHT);
            m === 0 && D.appendField(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_INPUT_WITH);
          }
        for (m = this.itemCount_; this.getInput("ADD" + m); m++)
          this.removeInput("ADD" + m);
      } };
      d.lists_create_with = h;
      var y = { init: function() {
        this.setStyle("list_blocks"), this.appendDummyInput().appendField(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_CONTAINER_TITLE_ADD), this.appendStatementInput("STACK"), this.setTooltip(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_CONTAINER_TOOLTIP), this.contextMenu = !1;
      } };
      d.lists_create_with_container = y;
      var b = { init: function() {
        this.setStyle("list_blocks"), this.appendDummyInput().appendField(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_ITEM_TITLE), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setTooltip(o.Msg$$module$build$src$core$msg.LISTS_CREATE_WITH_ITEM_TOOLTIP), this.contextMenu = !1;
      } };
      d.lists_create_with_item = b;
      var U = { init: function() {
        var m = [[o.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_FIRST, "FIRST"], [o.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_LAST, "LAST"]];
        if (this.setHelpUrl(o.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_HELPURL), this.setStyle("list_blocks"), this.setOutput(!0, "Number"), this.appendValueInput("VALUE").setCheck("Array").appendField(o.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_INPUT_IN_LIST), m = o.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: m
        }), !m)
          throw Error("field_dropdown not found");
        this.appendValueInput("FIND").appendField(m, "END"), this.setInputsInline(!0), this.setTooltip(() => o.Msg$$module$build$src$core$msg.LISTS_INDEX_OF_TOOLTIP.replace("%1", this.workspace.options.oneBasedIndex ? "0" : "-1"));
      } };
      d.lists_indexOf = U;
      var Z = {
        init: function() {
          var m = [[o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_GET, "GET"], [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_GET_REMOVE, "GET_REMOVE"], [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_REMOVE, "REMOVE"]];
          this.WHERE_OPTIONS = [
            [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_START, "FROM_START"],
            [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_END, "FROM_END"],
            [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FIRST, "FIRST"],
            [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_LAST, "LAST"],
            [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_RANDOM, "RANDOM"]
          ], this.setHelpUrl(o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_HELPURL), this.setStyle("list_blocks"), m = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: m }), m.setValidator(function(D) {
            D = D === "REMOVE", this.getSourceBlock().updateStatement_(D);
          }), this.appendValueInput("VALUE").setCheck("Array").appendField(o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_INPUT_IN_LIST), this.appendDummyInput().appendField(m, "MODE").appendField("", "SPACE"), this.appendDummyInput("AT"), o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TAIL && this.appendDummyInput("TAIL").appendField(o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TAIL), this.setInputsInline(!0), this.setOutput(!0), this.updateAt_(!0), this.setTooltip(() => {
            const D = this.getFieldValue("MODE"), B = this.getFieldValue("WHERE");
            let V = "";
            switch (D + " " + B) {
              case "GET FROM_START":
              case "GET FROM_END":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_FROM;
                break;
              case "GET FIRST":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_FIRST;
                break;
              case "GET LAST":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_LAST;
                break;
              case "GET RANDOM":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_RANDOM;
                break;
              case "GET_REMOVE FROM_START":
              case "GET_REMOVE FROM_END":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM;
                break;
              case "GET_REMOVE FIRST":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST;
                break;
              case "GET_REMOVE LAST":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST;
                break;
              case "GET_REMOVE RANDOM":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM;
                break;
              case "REMOVE FROM_START":
              case "REMOVE FROM_END":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM;
                break;
              case "REMOVE FIRST":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST;
                break;
              case "REMOVE LAST":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST;
                break;
              case "REMOVE RANDOM":
                V = o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM;
            }
            return (B === "FROM_START" || B === "FROM_END") && (V += "  " + (B === "FROM_START" ? o.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_START_TOOLTIP : o.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_END_TOOLTIP).replace("%1", this.workspace.options.oneBasedIndex ? "#1" : "#0")), V;
          });
        },
        mutationToDom: function() {
          const m = o.createElement$$module$build$src$core$utils$xml("mutation");
          m.setAttribute("statement", String(!this.outputConnection));
          const D = this.getInput("AT") instanceof o.ValueInput$$module$build$src$core$inputs$value_input;
          return m.setAttribute("at", String(D)), m;
        },
        domToMutation: function(m) {
          const D = m.getAttribute("statement") === "true";
          this.updateStatement_(D), m = m.getAttribute("at") !== "false", this.updateAt_(m);
        },
        saveExtraState: function() {
          return this.outputConnection ? null : { isStatement: !0 };
        },
        loadExtraState: function(m) {
          m.isStatement ? this.updateStatement_(!0) : typeof m == "string" && this.domToMutation(o.textToDom$$module$build$src$core$utils$xml(m));
        },
        updateStatement_: function(m) {
          m !== !this.outputConnection && (this.unplug(!0, !0), m ? (this.setOutput(!1), this.setPreviousStatement(!0), this.setNextStatement(!0)) : (this.setPreviousStatement(!1), this.setNextStatement(!1), this.setOutput(!0)));
        },
        updateAt_: function(m) {
          this.removeInput("AT"), this.removeInput("ORDINAL", !0), m ? (this.appendValueInput("AT").setCheck("Number"), o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
          const D = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: this.WHERE_OPTIONS });
          D.setValidator(function(B) {
            const V = B === "FROM_START" || B === "FROM_END";
            if (V !== m) {
              const oe = this.getSourceBlock();
              return oe.updateAt_(V), oe.setFieldValue(B, "WHERE"), null;
            }
          }), this.getInput("AT").appendField(D, "WHERE"), o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_TAIL && this.moveInputBefore("TAIL", null);
        }
      };
      d.lists_getIndex = Z;
      var le = { init: function() {
        var m = [[o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_SET, "SET"], [o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_INSERT, "INSERT"]];
        this.WHERE_OPTIONS = [[o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_START, "FROM_START"], [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FROM_END, "FROM_END"], [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_FIRST, "FIRST"], [o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_LAST, "LAST"], [
          o.Msg$$module$build$src$core$msg.LISTS_GET_INDEX_RANDOM,
          "RANDOM"
        ]], this.setHelpUrl(o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_HELPURL), this.setStyle("list_blocks"), this.appendValueInput("LIST").setCheck("Array").appendField(o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_INPUT_IN_LIST), m = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: m }), this.appendDummyInput().appendField(m, "MODE").appendField("", "SPACE"), this.appendDummyInput("AT"), this.appendValueInput("TO").appendField(o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_INPUT_TO), this.setInputsInline(!0), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setTooltip(o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP), this.updateAt_(!0), this.setTooltip(() => {
          const D = this.getFieldValue("MODE"), B = this.getFieldValue("WHERE");
          let V = "";
          switch (D + " " + B) {
            case "SET FROM_START":
            case "SET FROM_END":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_FROM;
              break;
            case "SET FIRST":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_FIRST;
              break;
            case "SET LAST":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_LAST;
              break;
            case "SET RANDOM":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_SET_RANDOM;
              break;
            case "INSERT FROM_START":
            case "INSERT FROM_END":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FROM;
              break;
            case "INSERT FIRST":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST;
              break;
            case "INSERT LAST":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_LAST;
              break;
            case "INSERT RANDOM":
              V = o.Msg$$module$build$src$core$msg.LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM;
          }
          return (B === "FROM_START" || B === "FROM_END") && (V += "  " + o.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_START_TOOLTIP.replace("%1", this.workspace.options.oneBasedIndex ? "#1" : "#0")), V;
        });
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation"), D = this.getInput("AT") instanceof o.ValueInput$$module$build$src$core$inputs$value_input;
        return m.setAttribute("at", String(D)), m;
      }, domToMutation: function(m) {
        m = m.getAttribute("at") !== "false", this.updateAt_(m);
      }, saveExtraState: function() {
        return null;
      }, loadExtraState: function() {
      }, updateAt_: function(m) {
        this.removeInput("AT"), this.removeInput("ORDINAL", !0), m ? (this.appendValueInput("AT").setCheck("Number"), o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT");
        const D = o.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: this.WHERE_OPTIONS
        });
        D.setValidator(function(B) {
          const V = B === "FROM_START" || B === "FROM_END";
          if (V !== m) {
            const oe = this.getSourceBlock();
            return oe.updateAt_(V), oe.setFieldValue(B, "WHERE"), null;
          }
        }), this.moveInputBefore("AT", "TO"), this.getInput("ORDINAL") && this.moveInputBefore("ORDINAL", "TO"), this.getInput("AT").appendField(D, "WHERE");
      } };
      d.lists_setIndex = le;
      var ue = { init: function() {
        this.WHERE_OPTIONS_1 = [[o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_START_FROM_START, "FROM_START"], [o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_START_FROM_END, "FROM_END"], [o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_START_FIRST, "FIRST"]], this.WHERE_OPTIONS_2 = [
          [o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_END_FROM_START, "FROM_START"],
          [o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_END_FROM_END, "FROM_END"],
          [o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_END_LAST, "LAST"]
        ], this.setHelpUrl(o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_HELPURL), this.setStyle("list_blocks"), this.appendValueInput("LIST").setCheck("Array").appendField(o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_INPUT_IN_LIST), this.appendDummyInput("AT1"), this.appendDummyInput("AT2"), o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TAIL && this.appendDummyInput("TAIL").appendField(o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TAIL), this.setInputsInline(!0), this.setOutput(!0, "Array"), this.updateAt_(1, !0), this.updateAt_(2, !0), this.setTooltip(o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TOOLTIP);
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        var D = this.getInput("AT1") instanceof o.ValueInput$$module$build$src$core$inputs$value_input;
        return m.setAttribute("at1", String(D)), D = this.getInput("AT2") instanceof o.ValueInput$$module$build$src$core$inputs$value_input, m.setAttribute("at2", String(D)), m;
      }, domToMutation: function(m) {
        const D = m.getAttribute("at1") === "true";
        m = m.getAttribute("at2") === "true", this.updateAt_(1, D), this.updateAt_(2, m);
      }, saveExtraState: function() {
        return null;
      }, loadExtraState: function() {
      }, updateAt_: function(m, D) {
        this.removeInput("AT" + m), this.removeInput("ORDINAL" + m, !0), D ? (this.appendValueInput("AT" + m).setCheck("Number"), o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + m).appendField(o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + m);
        const B = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: this["WHERE_OPTIONS_" + m] });
        B.setValidator(function(V) {
          const oe = V === "FROM_START" || V === "FROM_END";
          if (oe !== D) {
            const ke = this.getSourceBlock();
            return ke.updateAt_(m, oe), ke.setFieldValue(V, "WHERE" + m), null;
          }
        }), this.getInput("AT" + m).appendField(B, "WHERE" + m), m === 1 && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2")), o.Msg$$module$build$src$core$msg.LISTS_GET_SUBLIST_TAIL && this.moveInputBefore("TAIL", null);
      } };
      d.lists_getSublist = ue, d.lists_sort = { init: function() {
        this.jsonInit({
          message0: "%{BKY_LISTS_SORT_TITLE}",
          args0: [{ type: "field_dropdown", name: "TYPE", options: [["%{BKY_LISTS_SORT_TYPE_NUMERIC}", "NUMERIC"], ["%{BKY_LISTS_SORT_TYPE_TEXT}", "TEXT"], ["%{BKY_LISTS_SORT_TYPE_IGNORECASE}", "IGNORE_CASE"]] }, { type: "field_dropdown", name: "DIRECTION", options: [["%{BKY_LISTS_SORT_ORDER_ASCENDING}", "1"], ["%{BKY_LISTS_SORT_ORDER_DESCENDING}", "-1"]] }, { type: "input_value", name: "LIST", check: "Array" }],
          output: "Array",
          style: "list_blocks",
          tooltip: "%{BKY_LISTS_SORT_TOOLTIP}",
          helpUrl: "%{BKY_LISTS_SORT_HELPURL}"
        });
      } }, d.lists_split = {
        init: function() {
          const m = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: [[o.Msg$$module$build$src$core$msg.LISTS_SPLIT_LIST_FROM_TEXT, "SPLIT"], [o.Msg$$module$build$src$core$msg.LISTS_SPLIT_TEXT_FROM_LIST, "JOIN"]] });
          if (!m)
            throw Error("field_dropdown not found");
          m.setValidator((D) => {
            this.updateType_(D);
          }), this.setHelpUrl(o.Msg$$module$build$src$core$msg.LISTS_SPLIT_HELPURL), this.setStyle("list_blocks"), this.appendValueInput("INPUT").setCheck("String").appendField(
            m,
            "MODE"
          ), this.appendValueInput("DELIM").setCheck("String").appendField(o.Msg$$module$build$src$core$msg.LISTS_SPLIT_WITH_DELIMITER), this.setInputsInline(!0), this.setOutput(!0, "Array"), this.setTooltip(() => {
            const D = this.getFieldValue("MODE");
            if (D === "SPLIT")
              return o.Msg$$module$build$src$core$msg.LISTS_SPLIT_TOOLTIP_SPLIT;
            if (D === "JOIN")
              return o.Msg$$module$build$src$core$msg.LISTS_SPLIT_TOOLTIP_JOIN;
            throw Error("Unknown mode: " + D);
          });
        },
        updateType_: function(m) {
          if (this.getFieldValue("MODE") !== m) {
            const D = this.getInput("INPUT").connection;
            D.setShadowDom(null);
            const B = D.targetBlock();
            B && (D.disconnect(), B.isShadow() ? B.dispose(!1) : this.bumpNeighbours());
          }
          m === "SPLIT" ? (this.outputConnection.setCheck("Array"), this.getInput("INPUT").setCheck("String")) : (this.outputConnection.setCheck("String"), this.getInput("INPUT").setCheck("Array"));
        },
        mutationToDom: function() {
          const m = o.createElement$$module$build$src$core$utils$xml("mutation");
          return m.setAttribute("mode", this.getFieldValue("MODE")), m;
        },
        domToMutation: function(m) {
          this.updateType_(m.getAttribute("mode"));
        },
        saveExtraState: function() {
          return null;
        },
        loadExtraState: function() {
        }
      }, o.defineBlocks$$module$build$src$core$common(d);
      var be = {};
      be.blocks = d;
      var Ke = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        { type: "logic_boolean", message0: "%1", args0: [{ type: "field_dropdown", name: "BOOL", options: [["%{BKY_LOGIC_BOOLEAN_TRUE}", "TRUE"], ["%{BKY_LOGIC_BOOLEAN_FALSE}", "FALSE"]] }], output: "Boolean", style: "logic_blocks", tooltip: "%{BKY_LOGIC_BOOLEAN_TOOLTIP}", helpUrl: "%{BKY_LOGIC_BOOLEAN_HELPURL}" },
        {
          type: "controls_if",
          message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
          args0: [{ type: "input_value", name: "IF0", check: "Boolean" }],
          message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
          args1: [{ type: "input_statement", name: "DO0" }],
          previousStatement: null,
          nextStatement: null,
          style: "logic_blocks",
          helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
          suppressPrefixSuffix: !0,
          mutator: "controls_if_mutator",
          extensions: ["controls_if_tooltip"]
        },
        {
          type: "controls_ifelse",
          message0: "%{BKY_CONTROLS_IF_MSG_IF} %1",
          args0: [{ type: "input_value", name: "IF0", check: "Boolean" }],
          message1: "%{BKY_CONTROLS_IF_MSG_THEN} %1",
          args1: [{ type: "input_statement", name: "DO0" }],
          message2: "%{BKY_CONTROLS_IF_MSG_ELSE} %1",
          args2: [{ type: "input_statement", name: "ELSE" }],
          previousStatement: null,
          nextStatement: null,
          style: "logic_blocks",
          tooltip: "%{BKYCONTROLS_IF_TOOLTIP_2}",
          helpUrl: "%{BKY_CONTROLS_IF_HELPURL}",
          suppressPrefixSuffix: !0,
          extensions: ["controls_if_tooltip"]
        },
        {
          type: "logic_compare",
          message0: "%1 %2 %3",
          args0: [{ type: "input_value", name: "A" }, { type: "field_dropdown", name: "OP", options: [["=", "EQ"], ["≠", "NEQ"], ["‏<", "LT"], ["‏≤", "LTE"], ["‏>", "GT"], ["‏≥", "GTE"]] }, { type: "input_value", name: "B" }],
          inputsInline: !0,
          output: "Boolean",
          style: "logic_blocks",
          helpUrl: "%{BKY_LOGIC_COMPARE_HELPURL}",
          extensions: ["logic_compare", "logic_op_tooltip"]
        },
        { type: "logic_operation", message0: "%1 %2 %3", args0: [{ type: "input_value", name: "A", check: "Boolean" }, { type: "field_dropdown", name: "OP", options: [["%{BKY_LOGIC_OPERATION_AND}", "AND"], ["%{BKY_LOGIC_OPERATION_OR}", "OR"]] }, { type: "input_value", name: "B", check: "Boolean" }], inputsInline: !0, output: "Boolean", style: "logic_blocks", helpUrl: "%{BKY_LOGIC_OPERATION_HELPURL}", extensions: ["logic_op_tooltip"] },
        { type: "logic_negate", message0: "%{BKY_LOGIC_NEGATE_TITLE}", args0: [{ type: "input_value", name: "BOOL", check: "Boolean" }], output: "Boolean", style: "logic_blocks", tooltip: "%{BKY_LOGIC_NEGATE_TOOLTIP}", helpUrl: "%{BKY_LOGIC_NEGATE_HELPURL}" },
        { type: "logic_null", message0: "%{BKY_LOGIC_NULL}", output: null, style: "logic_blocks", tooltip: "%{BKY_LOGIC_NULL_TOOLTIP}", helpUrl: "%{BKY_LOGIC_NULL_HELPURL}" },
        {
          type: "logic_ternary",
          message0: "%{BKY_LOGIC_TERNARY_CONDITION} %1",
          args0: [{ type: "input_value", name: "IF", check: "Boolean" }],
          message1: "%{BKY_LOGIC_TERNARY_IF_TRUE} %1",
          args1: [{ type: "input_value", name: "THEN" }],
          message2: "%{BKY_LOGIC_TERNARY_IF_FALSE} %1",
          args2: [{ type: "input_value", name: "ELSE" }],
          output: null,
          style: "logic_blocks",
          tooltip: "%{BKY_LOGIC_TERNARY_TOOLTIP}",
          helpUrl: "%{BKY_LOGIC_TERNARY_HELPURL}",
          extensions: ["logic_ternary"]
        },
        { type: "controls_if_if", message0: "%{BKY_CONTROLS_IF_IF_TITLE_IF}", nextStatement: null, enableContextMenu: !1, style: "logic_blocks", tooltip: "%{BKY_CONTROLS_IF_IF_TOOLTIP}" },
        {
          type: "controls_if_elseif",
          message0: "%{BKY_CONTROLS_IF_ELSEIF_TITLE_ELSEIF}",
          previousStatement: null,
          nextStatement: null,
          enableContextMenu: !1,
          style: "logic_blocks",
          tooltip: "%{BKY_CONTROLS_IF_ELSEIF_TOOLTIP}"
        },
        { type: "controls_if_else", message0: "%{BKY_CONTROLS_IF_ELSE_TITLE_ELSE}", previousStatement: null, enableContextMenu: !1, style: "logic_blocks", tooltip: "%{BKY_CONTROLS_IF_ELSE_TOOLTIP}" }
      ]), ae = {
        EQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_EQ}",
        NEQ: "%{BKY_LOGIC_COMPARE_TOOLTIP_NEQ}",
        LT: "%{BKY_LOGIC_COMPARE_TOOLTIP_LT}",
        LTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_LTE}",
        GT: "%{BKY_LOGIC_COMPARE_TOOLTIP_GT}",
        GTE: "%{BKY_LOGIC_COMPARE_TOOLTIP_GTE}",
        AND: "%{BKY_LOGIC_OPERATION_TOOLTIP_AND}",
        OR: "%{BKY_LOGIC_OPERATION_TOOLTIP_OR}"
      };
      o.register$$module$build$src$core$extensions("logic_op_tooltip", o.buildTooltipForDropdown$$module$build$src$core$extensions("OP", ae));
      var Ne = {
        elseifCount_: 0,
        elseCount_: 0,
        mutationToDom: function() {
          if (!this.elseifCount_ && !this.elseCount_)
            return null;
          const m = o.createElement$$module$build$src$core$utils$xml("mutation");
          return this.elseifCount_ && m.setAttribute("elseif", String(this.elseifCount_)), this.elseCount_ && m.setAttribute("else", "1"), m;
        },
        domToMutation: function(m) {
          this.elseifCount_ = parseInt(m.getAttribute("elseif"), 10) || 0, this.elseCount_ = parseInt(m.getAttribute("else"), 10) || 0, this.rebuildShape_();
        },
        saveExtraState: function() {
          if (!this.elseifCount_ && !this.elseCount_)
            return null;
          const m = /* @__PURE__ */ Object.create(null);
          return this.elseifCount_ && (m.elseIfCount = this.elseifCount_), this.elseCount_ && (m.hasElse = !0), m;
        },
        loadExtraState: function(m) {
          this.elseifCount_ = m.elseIfCount || 0, this.elseCount_ = m.hasElse ? 1 : 0, this.updateShape_();
        },
        decompose: function(m) {
          const D = m.newBlock("controls_if_if");
          D.initSvg();
          let B = D.nextConnection;
          for (let V = 1; V <= this.elseifCount_; V++) {
            const oe = m.newBlock("controls_if_elseif");
            oe.initSvg(), B.connect(oe.previousConnection), B = oe.nextConnection;
          }
          return this.elseCount_ && (m = m.newBlock("controls_if_else"), m.initSvg(), B.connect(m.previousConnection)), D;
        },
        compose: function(m) {
          m = m.nextConnection.targetBlock(), this.elseCount_ = this.elseifCount_ = 0;
          const D = [null], B = [null];
          let V = null;
          for (; m; ) {
            if (!m.isInsertionMarker())
              switch (m.type) {
                case "controls_if_elseif":
                  this.elseifCount_++, D.push(m.valueConnection_), B.push(m.statementConnection_);
                  break;
                case "controls_if_else":
                  this.elseCount_++, V = m.statementConnection_;
                  break;
                default:
                  throw TypeError("Unknown block type: " + m.type);
              }
            m = m.getNextBlock();
          }
          this.updateShape_(), this.reconnectChildBlocks_(D, B, V);
        },
        saveConnections: function(m) {
          m = m.nextConnection.targetBlock();
          let D = 1;
          for (; m; ) {
            if (!m.isInsertionMarker())
              switch (m.type) {
                case "controls_if_elseif":
                  var B = this.getInput("IF" + D);
                  const V = this.getInput("DO" + D);
                  m.valueConnection_ = B && B.connection.targetConnection, m.statementConnection_ = V && V.connection.targetConnection, D++;
                  break;
                case "controls_if_else":
                  B = this.getInput("ELSE"), m.statementConnection_ = B && B.connection.targetConnection;
                  break;
                default:
                  throw TypeError("Unknown block type: " + m.type);
              }
            m = m.getNextBlock();
          }
        },
        rebuildShape_: function() {
          const m = [null], D = [null];
          let B = null;
          this.getInput("ELSE") && (B = this.getInput("ELSE").connection.targetConnection);
          for (let V = 1; this.getInput("IF" + V); V++) {
            const oe = this.getInput("IF" + V), ke = this.getInput("DO" + V);
            m.push(oe.connection.targetConnection), D.push(ke.connection.targetConnection);
          }
          this.updateShape_(), this.reconnectChildBlocks_(m, D, B);
        },
        updateShape_: function() {
          this.getInput("ELSE") && this.removeInput("ELSE");
          for (var m = 1; this.getInput("IF" + m); m++)
            this.removeInput("IF" + m), this.removeInput("DO" + m);
          for (m = 1; m <= this.elseifCount_; m++)
            this.appendValueInput("IF" + m).setCheck("Boolean").appendField(o.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_ELSEIF), this.appendStatementInput("DO" + m).appendField(o.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_THEN);
          this.elseCount_ && this.appendStatementInput("ELSE").appendField(o.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_ELSE);
        },
        reconnectChildBlocks_: function(m, D, B) {
          for (let V = 1; V <= this.elseifCount_; V++) {
            let oe;
            (oe = m[V]) == null || oe.reconnect(this, "IF" + V);
            let ke;
            (ke = D[V]) == null || ke.reconnect(this, "DO" + V);
          }
          B == null || B.reconnect(this, "ELSE");
        }
      };
      o.registerMutator$$module$build$src$core$extensions("controls_if_mutator", Ne, null, ["controls_if_elseif", "controls_if_else"]);
      var Fe = function() {
        this.setTooltip((function() {
          if (this.elseifCount_ || this.elseCount_) {
            if (!this.elseifCount_ && this.elseCount_)
              return o.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_2;
            if (this.elseifCount_ && !this.elseCount_)
              return o.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_3;
            if (this.elseifCount_ && this.elseCount_)
              return o.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_4;
          } else
            return o.Msg$$module$build$src$core$msg.CONTROLS_IF_TOOLTIP_1;
          return "";
        }).bind(this));
      };
      o.register$$module$build$src$core$extensions("controls_if_tooltip", Fe);
      var at = { onchange: function(m) {
        this.prevBlocks_ || (this.prevBlocks_ = [null, null]);
        var D = this.getInputTargetBlock("A");
        const B = this.getInputTargetBlock("B");
        D && B && !this.workspace.connectionChecker.doTypeChecks(D.outputConnection, B.outputConnection) && (o.setGroup$$module$build$src$core$events$utils(m.group), m = this.prevBlocks_[0], m !== D && (D.unplug(), !m || m.isDisposed() || m.isShadow() || this.getInput("A").connection.connect(m.outputConnection)), D = this.prevBlocks_[1], D !== B && (B.unplug(), !D || D.isDisposed() || D.isShadow() || this.getInput("B").connection.connect(D.outputConnection)), this.bumpNeighbours(), o.setGroup$$module$build$src$core$events$utils(!1)), this.prevBlocks_[0] = this.getInputTargetBlock("A"), this.prevBlocks_[1] = this.getInputTargetBlock("B");
      } }, dr = function() {
        this.mixin(at);
      };
      o.register$$module$build$src$core$extensions("logic_compare", dr);
      var er = { prevParentConnection_: null, onchange: function(m) {
        const D = this.getInputTargetBlock("THEN"), B = this.getInputTargetBlock("ELSE"), V = this.outputConnection.targetConnection;
        if ((D || B) && V)
          for (let oe = 0; 2 > oe; oe++) {
            const ke = oe === 1 ? D : B;
            ke && !ke.workspace.connectionChecker.doTypeChecks(ke.outputConnection, V) && (o.setGroup$$module$build$src$core$events$utils(m.group), V === this.prevParentConnection_ ? (this.unplug(), V.getSourceBlock().bumpNeighbours()) : (ke.unplug(), ke.bumpNeighbours()), o.setGroup$$module$build$src$core$events$utils(!1));
          }
        this.prevParentConnection_ = V;
      } };
      o.registerMixin$$module$build$src$core$extensions("logic_ternary", er), o.defineBlocks$$module$build$src$core$common(Ke);
      var Ze = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "controls_repeat_ext", message0: "%{BKY_CONTROLS_REPEAT_TITLE}", args0: [{ type: "input_value", name: "TIMES", check: "Number" }], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], previousStatement: null, nextStatement: null, style: "loop_blocks", tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}", helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}" }, {
        type: "controls_repeat",
        message0: "%{BKY_CONTROLS_REPEAT_TITLE}",
        args0: [{ type: "field_number", name: "TIMES", value: 10, min: 0, precision: 1 }],
        message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1",
        args1: [{ type: "input_statement", name: "DO" }],
        previousStatement: null,
        nextStatement: null,
        style: "loop_blocks",
        tooltip: "%{BKY_CONTROLS_REPEAT_TOOLTIP}",
        helpUrl: "%{BKY_CONTROLS_REPEAT_HELPURL}"
      }, { type: "controls_whileUntil", message0: "%1 %2", args0: [
        { type: "field_dropdown", name: "MODE", options: [["%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_WHILE}", "WHILE"], ["%{BKY_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL}", "UNTIL"]] },
        { type: "input_value", name: "BOOL", check: "Boolean" }
      ], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], previousStatement: null, nextStatement: null, style: "loop_blocks", helpUrl: "%{BKY_CONTROLS_WHILEUNTIL_HELPURL}", extensions: ["controls_whileUntil_tooltip"] }, { type: "controls_for", message0: "%{BKY_CONTROLS_FOR_TITLE}", args0: [{ type: "field_variable", name: "VAR", variable: null }, { type: "input_value", name: "FROM", check: "Number", align: "RIGHT" }, {
        type: "input_value",
        name: "TO",
        check: "Number",
        align: "RIGHT"
      }, { type: "input_value", name: "BY", check: "Number", align: "RIGHT" }], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], inputsInline: !0, previousStatement: null, nextStatement: null, style: "loop_blocks", helpUrl: "%{BKY_CONTROLS_FOR_HELPURL}", extensions: ["contextMenu_newGetVariableBlock", "controls_for_tooltip"] }, { type: "controls_forEach", message0: "%{BKY_CONTROLS_FOREACH_TITLE}", args0: [{ type: "field_variable", name: "VAR", variable: null }, {
        type: "input_value",
        name: "LIST",
        check: "Array"
      }], message1: "%{BKY_CONTROLS_REPEAT_INPUT_DO} %1", args1: [{ type: "input_statement", name: "DO" }], previousStatement: null, nextStatement: null, style: "loop_blocks", helpUrl: "%{BKY_CONTROLS_FOREACH_HELPURL}", extensions: ["contextMenu_newGetVariableBlock", "controls_forEach_tooltip"] }, {
        type: "controls_flow_statements",
        message0: "%1",
        args0: [{ type: "field_dropdown", name: "FLOW", options: [["%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK}", "BREAK"], ["%{BKY_CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE}", "CONTINUE"]] }],
        previousStatement: null,
        style: "loop_blocks",
        helpUrl: "%{BKY_CONTROLS_FLOW_STATEMENTS_HELPURL}",
        suppressPrefixSuffix: !0,
        extensions: ["controls_flow_tooltip", "controls_flow_in_loop_check"]
      }]), Pt = { WHILE: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE}", UNTIL: "%{BKY_CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL}" };
      o.register$$module$build$src$core$extensions("controls_whileUntil_tooltip", o.buildTooltipForDropdown$$module$build$src$core$extensions("MODE", Pt));
      var wr = { BREAK: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK}", CONTINUE: "%{BKY_CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE}" };
      o.register$$module$build$src$core$extensions("controls_flow_tooltip", o.buildTooltipForDropdown$$module$build$src$core$extensions("FLOW", wr));
      var xn = { customContextMenu: function(m) {
        if (!this.isInFlyout) {
          var D = this.getField("VAR").getVariable(), B = D.name;
          if (!this.isCollapsed() && B !== null) {
            D = o.generateVariableFieldDom$$module$build$src$core$variables(D);
            const V = o.createElement$$module$build$src$core$utils$xml("block");
            V.setAttribute("type", "variables_get"), V.appendChild(D), m.push({
              enabled: !0,
              text: o.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET.replace("%1", B),
              callback: o.callbackFactory$$module$build$src$core$contextmenu(this, V)
            });
          }
        }
      } };
      o.registerMixin$$module$build$src$core$extensions("contextMenu_newGetVariableBlock", xn), o.register$$module$build$src$core$extensions("controls_for_tooltip", o.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_CONTROLS_FOR_TOOLTIP}", "VAR")), o.register$$module$build$src$core$extensions("controls_forEach_tooltip", o.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_CONTROLS_FOREACH_TOOLTIP}", "VAR"));
      var Dl = /* @__PURE__ */ new Set(["controls_repeat", "controls_repeat_ext", "controls_forEach", "controls_for", "controls_whileUntil"]), si = { getSurroundLoop: function() {
        let m = this;
        do {
          if (Dl.has(m.type))
            return m;
          m = m.getSurroundParent();
        } while (m);
        return null;
      }, onchange: function(m) {
        var D = this.workspace;
        if (D.isDragging && !D.isDragging() && m.type === o.MOVE$$module$build$src$core$events$utils && (D = !!this.getSurroundLoop(), this.setWarningText(D ? null : o.Msg$$module$build$src$core$msg.CONTROLS_FLOW_STATEMENTS_WARNING), !this.isInFlyout)) {
          const B = o.getGroup$$module$build$src$core$events$utils();
          o.setGroup$$module$build$src$core$events$utils(m.group), this.setEnabled(D), o.setGroup$$module$build$src$core$events$utils(B);
        }
      } };
      o.registerMixin$$module$build$src$core$extensions("controls_flow_in_loop_check", si), o.defineBlocks$$module$build$src$core$common(Ze);
      var Yr = {};
      Yr.blocks = Ze, Yr.loopTypes = Dl;
      var Er = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([
        { type: "math_number", message0: "%1", args0: [{ type: "field_number", name: "NUM", value: 0 }], output: "Number", helpUrl: "%{BKY_MATH_NUMBER_HELPURL}", style: "math_blocks", tooltip: "%{BKY_MATH_NUMBER_TOOLTIP}", extensions: ["parent_tooltip_when_inline"] },
        { type: "math_arithmetic", message0: "%1 %2 %3", args0: [{ type: "input_value", name: "A", check: "Number" }, { type: "field_dropdown", name: "OP", options: [[
          "%{BKY_MATH_ADDITION_SYMBOL}",
          "ADD"
        ], ["%{BKY_MATH_SUBTRACTION_SYMBOL}", "MINUS"], ["%{BKY_MATH_MULTIPLICATION_SYMBOL}", "MULTIPLY"], ["%{BKY_MATH_DIVISION_SYMBOL}", "DIVIDE"], ["%{BKY_MATH_POWER_SYMBOL}", "POWER"]] }, { type: "input_value", name: "B", check: "Number" }], inputsInline: !0, output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_ARITHMETIC_HELPURL}", extensions: ["math_op_tooltip"] },
        { type: "math_single", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [["%{BKY_MATH_SINGLE_OP_ROOT}", "ROOT"], [
          "%{BKY_MATH_SINGLE_OP_ABSOLUTE}",
          "ABS"
        ], ["-", "NEG"], ["ln", "LN"], ["log10", "LOG10"], ["e^", "EXP"], ["10^", "POW10"]] }, { type: "input_value", name: "NUM", check: "Number" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_SINGLE_HELPURL}", extensions: ["math_op_tooltip"] },
        { type: "math_trig", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [["%{BKY_MATH_TRIG_SIN}", "SIN"], ["%{BKY_MATH_TRIG_COS}", "COS"], ["%{BKY_MATH_TRIG_TAN}", "TAN"], ["%{BKY_MATH_TRIG_ASIN}", "ASIN"], ["%{BKY_MATH_TRIG_ACOS}", "ACOS"], [
          "%{BKY_MATH_TRIG_ATAN}",
          "ATAN"
        ]] }, { type: "input_value", name: "NUM", check: "Number" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_TRIG_HELPURL}", extensions: ["math_op_tooltip"] },
        { type: "math_constant", message0: "%1", args0: [{ type: "field_dropdown", name: "CONSTANT", options: [["π", "PI"], ["e", "E"], ["φ", "GOLDEN_RATIO"], ["sqrt(2)", "SQRT2"], ["sqrt(½)", "SQRT1_2"], ["∞", "INFINITY"]] }], output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_CONSTANT_TOOLTIP}", helpUrl: "%{BKY_MATH_CONSTANT_HELPURL}" },
        {
          type: "math_number_property",
          message0: "%1 %2",
          args0: [{ type: "input_value", name: "NUMBER_TO_CHECK", check: "Number" }, { type: "field_dropdown", name: "PROPERTY", options: [["%{BKY_MATH_IS_EVEN}", "EVEN"], ["%{BKY_MATH_IS_ODD}", "ODD"], ["%{BKY_MATH_IS_PRIME}", "PRIME"], ["%{BKY_MATH_IS_WHOLE}", "WHOLE"], ["%{BKY_MATH_IS_POSITIVE}", "POSITIVE"], ["%{BKY_MATH_IS_NEGATIVE}", "NEGATIVE"], ["%{BKY_MATH_IS_DIVISIBLE_BY}", "DIVISIBLE_BY"]] }],
          inputsInline: !0,
          output: "Boolean",
          style: "math_blocks",
          tooltip: "%{BKY_MATH_IS_TOOLTIP}",
          mutator: "math_is_divisibleby_mutator"
        },
        { type: "math_change", message0: "%{BKY_MATH_CHANGE_TITLE}", args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_MATH_CHANGE_TITLE_ITEM}" }, { type: "input_value", name: "DELTA", check: "Number" }], previousStatement: null, nextStatement: null, style: "variable_blocks", helpUrl: "%{BKY_MATH_CHANGE_HELPURL}", extensions: ["math_change_tooltip"] },
        { type: "math_round", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [
          ["%{BKY_MATH_ROUND_OPERATOR_ROUND}", "ROUND"],
          ["%{BKY_MATH_ROUND_OPERATOR_ROUNDUP}", "ROUNDUP"],
          ["%{BKY_MATH_ROUND_OPERATOR_ROUNDDOWN}", "ROUNDDOWN"]
        ] }, { type: "input_value", name: "NUM", check: "Number" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_ROUND_HELPURL}", tooltip: "%{BKY_MATH_ROUND_TOOLTIP}" },
        { type: "math_on_list", message0: "%1 %2", args0: [{ type: "field_dropdown", name: "OP", options: [["%{BKY_MATH_ONLIST_OPERATOR_SUM}", "SUM"], ["%{BKY_MATH_ONLIST_OPERATOR_MIN}", "MIN"], ["%{BKY_MATH_ONLIST_OPERATOR_MAX}", "MAX"], ["%{BKY_MATH_ONLIST_OPERATOR_AVERAGE}", "AVERAGE"], [
          "%{BKY_MATH_ONLIST_OPERATOR_MEDIAN}",
          "MEDIAN"
        ], ["%{BKY_MATH_ONLIST_OPERATOR_MODE}", "MODE"], ["%{BKY_MATH_ONLIST_OPERATOR_STD_DEV}", "STD_DEV"], ["%{BKY_MATH_ONLIST_OPERATOR_RANDOM}", "RANDOM"]] }, { type: "input_value", name: "LIST", check: "Array" }], output: "Number", style: "math_blocks", helpUrl: "%{BKY_MATH_ONLIST_HELPURL}", mutator: "math_modes_of_list_mutator", extensions: ["math_op_tooltip"] },
        {
          type: "math_modulo",
          message0: "%{BKY_MATH_MODULO_TITLE}",
          args0: [{ type: "input_value", name: "DIVIDEND", check: "Number" }, { type: "input_value", name: "DIVISOR", check: "Number" }],
          inputsInline: !0,
          output: "Number",
          style: "math_blocks",
          tooltip: "%{BKY_MATH_MODULO_TOOLTIP}",
          helpUrl: "%{BKY_MATH_MODULO_HELPURL}"
        },
        { type: "math_constrain", message0: "%{BKY_MATH_CONSTRAIN_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: "Number" }, { type: "input_value", name: "LOW", check: "Number" }, { type: "input_value", name: "HIGH", check: "Number" }], inputsInline: !0, output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_CONSTRAIN_TOOLTIP}", helpUrl: "%{BKY_MATH_CONSTRAIN_HELPURL}" },
        {
          type: "math_random_int",
          message0: "%{BKY_MATH_RANDOM_INT_TITLE}",
          args0: [{ type: "input_value", name: "FROM", check: "Number" }, { type: "input_value", name: "TO", check: "Number" }],
          inputsInline: !0,
          output: "Number",
          style: "math_blocks",
          tooltip: "%{BKY_MATH_RANDOM_INT_TOOLTIP}",
          helpUrl: "%{BKY_MATH_RANDOM_INT_HELPURL}"
        },
        { type: "math_random_float", message0: "%{BKY_MATH_RANDOM_FLOAT_TITLE_RANDOM}", output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_RANDOM_FLOAT_TOOLTIP}", helpUrl: "%{BKY_MATH_RANDOM_FLOAT_HELPURL}" },
        { type: "math_atan2", message0: "%{BKY_MATH_ATAN2_TITLE}", args0: [{
          type: "input_value",
          name: "X",
          check: "Number"
        }, { type: "input_value", name: "Y", check: "Number" }], inputsInline: !0, output: "Number", style: "math_blocks", tooltip: "%{BKY_MATH_ATAN2_TOOLTIP}", helpUrl: "%{BKY_MATH_ATAN2_HELPURL}" }
      ]), Dr = {
        ADD: "%{BKY_MATH_ARITHMETIC_TOOLTIP_ADD}",
        MINUS: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MINUS}",
        MULTIPLY: "%{BKY_MATH_ARITHMETIC_TOOLTIP_MULTIPLY}",
        DIVIDE: "%{BKY_MATH_ARITHMETIC_TOOLTIP_DIVIDE}",
        POWER: "%{BKY_MATH_ARITHMETIC_TOOLTIP_POWER}",
        ROOT: "%{BKY_MATH_SINGLE_TOOLTIP_ROOT}",
        ABS: "%{BKY_MATH_SINGLE_TOOLTIP_ABS}",
        NEG: "%{BKY_MATH_SINGLE_TOOLTIP_NEG}",
        LN: "%{BKY_MATH_SINGLE_TOOLTIP_LN}",
        LOG10: "%{BKY_MATH_SINGLE_TOOLTIP_LOG10}",
        EXP: "%{BKY_MATH_SINGLE_TOOLTIP_EXP}",
        POW10: "%{BKY_MATH_SINGLE_TOOLTIP_POW10}",
        SIN: "%{BKY_MATH_TRIG_TOOLTIP_SIN}",
        COS: "%{BKY_MATH_TRIG_TOOLTIP_COS}",
        TAN: "%{BKY_MATH_TRIG_TOOLTIP_TAN}",
        ASIN: "%{BKY_MATH_TRIG_TOOLTIP_ASIN}",
        ACOS: "%{BKY_MATH_TRIG_TOOLTIP_ACOS}",
        ATAN: "%{BKY_MATH_TRIG_TOOLTIP_ATAN}",
        SUM: "%{BKY_MATH_ONLIST_TOOLTIP_SUM}",
        MIN: "%{BKY_MATH_ONLIST_TOOLTIP_MIN}",
        MAX: "%{BKY_MATH_ONLIST_TOOLTIP_MAX}",
        AVERAGE: "%{BKY_MATH_ONLIST_TOOLTIP_AVERAGE}",
        MEDIAN: "%{BKY_MATH_ONLIST_TOOLTIP_MEDIAN}",
        MODE: "%{BKY_MATH_ONLIST_TOOLTIP_MODE}",
        STD_DEV: "%{BKY_MATH_ONLIST_TOOLTIP_STD_DEV}",
        RANDOM: "%{BKY_MATH_ONLIST_TOOLTIP_RANDOM}"
      };
      o.register$$module$build$src$core$extensions("math_op_tooltip", o.buildTooltipForDropdown$$module$build$src$core$extensions("OP", Dr));
      var Ce = { mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation"), D = this.getFieldValue("PROPERTY") === "DIVISIBLE_BY";
        return m.setAttribute("divisor_input", String(D)), m;
      }, domToMutation: function(m) {
        m = m.getAttribute("divisor_input") === "true", this.updateShape_(m);
      }, updateShape_: function(m) {
        const D = this.getInput("DIVISOR");
        m ? D || this.appendValueInput("DIVISOR").setCheck("Number") : D && this.removeInput("DIVISOR");
      } }, Ps = function() {
        this.getField("PROPERTY").setValidator(function(m) {
          m = m === "DIVISIBLE_BY", this.getSourceBlock().updateShape_(m);
        });
      };
      o.registerMutator$$module$build$src$core$extensions("math_is_divisibleby_mutator", Ce, Ps), o.register$$module$build$src$core$extensions("math_change_tooltip", o.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_MATH_CHANGE_TOOLTIP}", "VAR"));
      var an = { updateType_: function(m) {
        m === "MODE" ? this.outputConnection.setCheck("Array") : this.outputConnection.setCheck("Number");
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        return m.setAttribute("op", this.getFieldValue("OP")), m;
      }, domToMutation: function(m) {
        if (m = m.getAttribute("op"), m === null)
          throw new TypeError("xmlElement had no op attribute");
        this.updateType_(m);
      } }, Sr = function() {
        this.getField("OP").setValidator((function(m) {
          this.updateType_(m);
        }).bind(this));
      };
      o.registerMutator$$module$build$src$core$extensions("math_modes_of_list_mutator", an, Sr), o.defineBlocks$$module$build$src$core$common(Er);
      var ao = {};
      ao.blocks = Er;
      var nt = {}, Fr = {
        setStatements_: function(m) {
          this.hasStatements_ !== m && (m ? (this.appendStatementInput("STACK").appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_DO), this.getInput("RETURN") && this.moveInputBefore("STACK", "RETURN")) : this.removeInput("STACK", !0), this.hasStatements_ = m);
        },
        updateParams_: function() {
          let m = "";
          this.arguments_.length && (m = o.Msg$$module$build$src$core$msg.PROCEDURES_BEFORE_PARAMS + " " + this.arguments_.join(", ")), o.disable$$module$build$src$core$events$utils();
          try {
            this.setFieldValue(m, "PARAMS");
          } finally {
            o.enable$$module$build$src$core$events$utils();
          }
        },
        mutationToDom: function(m) {
          const D = o.createElement$$module$build$src$core$utils$xml("mutation");
          m && D.setAttribute("name", this.getFieldValue("NAME"));
          for (let B = 0; B < this.argumentVarModels_.length; B++) {
            const V = o.createElement$$module$build$src$core$utils$xml("arg"), oe = this.argumentVarModels_[B];
            V.setAttribute("name", oe.name), V.setAttribute(
              "varid",
              oe.getId()
            ), m && this.paramIds_ && V.setAttribute("paramId", this.paramIds_[B]), D.appendChild(V);
          }
          return this.hasStatements_ || D.setAttribute("statements", "false"), D;
        },
        domToMutation: function(m) {
          this.arguments_ = [], this.argumentVarModels_ = [];
          for (let B = 0, V; V = m.childNodes[B]; B++)
            if (V.nodeName.toLowerCase() === "arg") {
              var D = V;
              const oe = D.getAttribute("name");
              D = D.getAttribute("varid") || D.getAttribute("varId"), this.arguments_.push(oe), D = o.getOrCreateVariablePackage$$module$build$src$core$variables(
                this.workspace,
                D,
                oe,
                ""
              ), D !== null ? this.argumentVarModels_.push(D) : console.log(`Failed to create a variable named "${oe}", ignoring.`);
            }
          this.updateParams_(), o.mutateCallers$$module$build$src$core$procedures(this), this.setStatements_(m.getAttribute("statements") !== "false");
        },
        saveExtraState: function() {
          if (!this.argumentVarModels_.length && this.hasStatements_)
            return null;
          const m = /* @__PURE__ */ Object.create(null);
          if (this.argumentVarModels_.length) {
            m.params = [];
            for (let D = 0; D < this.argumentVarModels_.length; D++)
              m.params.push({
                name: this.argumentVarModels_[D].name,
                id: this.argumentVarModels_[D].getId()
              });
          }
          return this.hasStatements_ || (m.hasStatements = !1), m;
        },
        loadExtraState: function(m) {
          if (this.arguments_ = [], this.argumentVarModels_ = [], m.params)
            for (let B = 0; B < m.params.length; B++) {
              var D = m.params[B];
              D = o.getOrCreateVariablePackage$$module$build$src$core$variables(this.workspace, D.id, D.name, ""), this.arguments_.push(D.name), this.argumentVarModels_.push(D);
            }
          this.updateParams_(), o.mutateCallers$$module$build$src$core$procedures(this), this.setStatements_(m.hasStatements !== !1);
        },
        decompose: function(m) {
          const D = o.createElement$$module$build$src$core$utils$xml("block");
          D.setAttribute("type", "procedures_mutatorcontainer");
          var B = o.createElement$$module$build$src$core$utils$xml("statement");
          B.setAttribute("name", "STACK"), D.appendChild(B);
          for (let oe = 0; oe < this.arguments_.length; oe++) {
            const ke = o.createElement$$module$build$src$core$utils$xml("block");
            ke.setAttribute("type", "procedures_mutatorarg");
            var V = o.createElement$$module$build$src$core$utils$xml("field");
            V.setAttribute(
              "name",
              "NAME"
            );
            const $t = o.createTextNode$$module$build$src$core$utils$xml(this.arguments_[oe]);
            V.appendChild($t), ke.appendChild(V), V = o.createElement$$module$build$src$core$utils$xml("next"), ke.appendChild(V), B.appendChild(ke), B = V;
          }
          return m = o.domToBlock$$module$build$src$core$xml(D, m), this.type === "procedures_defreturn" ? m.setFieldValue(this.hasStatements_, "STATEMENTS") : m.removeInput("STATEMENT_INPUT"), o.mutateCallers$$module$build$src$core$procedures(this), m;
        },
        compose: function(m) {
          this.arguments_ = [], this.paramIds_ = [], this.argumentVarModels_ = [];
          let D = m.getInputTargetBlock("STACK");
          for (; D && !D.isInsertionMarker(); ) {
            var B = D.getFieldValue("NAME");
            this.arguments_.push(B), B = this.workspace.getVariable(B, ""), this.argumentVarModels_.push(B), this.paramIds_.push(D.id), D = D.nextConnection && D.nextConnection.targetBlock();
          }
          if (this.updateParams_(), o.mutateCallers$$module$build$src$core$procedures(this), m = m.getFieldValue("STATEMENTS"), m !== null && (m = m === "TRUE", this.hasStatements_ !== m))
            if (m) {
              this.setStatements_(!0);
              var V;
              (V = this.statementConnection_) == null || V.reconnect(this, "STACK"), this.statementConnection_ = null;
            } else
              V = this.getInput("STACK").connection, (this.statementConnection_ = V.targetConnection) && (V = V.targetBlock(), V.unplug(), V.bumpNeighbours()), this.setStatements_(!1);
        },
        getVars: function() {
          return this.arguments_;
        },
        getVarModels: function() {
          return this.argumentVarModels_;
        },
        renameVarById: function(m, D) {
          var B = this.workspace.getVariableById(m);
          if (B.type === "") {
            B = B.name, D = this.workspace.getVariableById(D);
            var V = !1;
            for (let oe = 0; oe < this.argumentVarModels_.length; oe++)
              this.argumentVarModels_[oe].getId() === m && (this.arguments_[oe] = D.name, this.argumentVarModels_[oe] = D, V = !0);
            V && (this.displayRenamedVar_(B, D.name), o.mutateCallers$$module$build$src$core$procedures(this));
          }
        },
        updateVarName: function(m) {
          const D = m.name;
          let B = !1, V;
          for (let oe = 0; oe < this.argumentVarModels_.length; oe++)
            this.argumentVarModels_[oe].getId() === m.getId() && (V = this.arguments_[oe], this.arguments_[oe] = D, B = !0);
          B && (this.displayRenamedVar_(V, D), o.mutateCallers$$module$build$src$core$procedures(this));
        },
        displayRenamedVar_: function(m, D) {
          this.updateParams_();
          var B = this.getIcon(o.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE);
          if (B && B.bubbleIsVisible()) {
            B = B.getWorkspace().getAllBlocks(!1);
            for (let V = 0, oe; oe = B[V]; V++)
              oe.type === "procedures_mutatorarg" && o.Names$$module$build$src$core$names.equals(m, oe.getFieldValue("NAME")) && oe.setFieldValue(D, "NAME");
          }
        },
        customContextMenu: function(m) {
          if (!this.isInFlyout) {
            var D = this.getFieldValue("NAME"), B = o.createElement$$module$build$src$core$utils$xml("mutation");
            B.setAttribute("name", D);
            for (var V = 0; V < this.arguments_.length; V++) {
              var oe = o.createElement$$module$build$src$core$utils$xml("arg");
              oe.setAttribute("name", this.arguments_[V]), B.appendChild(oe);
            }
            if (V = o.createElement$$module$build$src$core$utils$xml("block"), V.setAttribute("type", this.callType_), V.appendChild(B), m.push({ enabled: !0, text: o.Msg$$module$build$src$core$msg.PROCEDURES_CREATE_DO.replace("%1", D), callback: o.callbackFactory$$module$build$src$core$contextmenu(this, V) }), !this.isCollapsed())
              for (D = 0; D < this.argumentVarModels_.length; D++)
                B = this.argumentVarModels_[D], V = o.generateVariableFieldDom$$module$build$src$core$variables(B), oe = o.createElement$$module$build$src$core$utils$xml("block"), oe.setAttribute("type", "variables_get"), oe.appendChild(V), m.push({ enabled: !0, text: o.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET.replace("%1", B.name), callback: o.callbackFactory$$module$build$src$core$contextmenu(this, oe) });
          }
        }
      };
      nt.procedures_defnoreturn = Object.assign({}, Fr, { init: function() {
        var m = o.findLegalName$$module$build$src$core$procedures("", this);
        m = o.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: m }), m.setValidator(o.rename$$module$build$src$core$procedures), m.setSpellcheck(!1), this.appendDummyInput().appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_TITLE).appendField(m, "NAME").appendField(
          "",
          "PARAMS"
        ), this.setMutator(new o.MutatorIcon$$module$build$src$core$icons$mutator_icon(["procedures_mutatorarg"], this)), (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && o.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_COMMENT && this.setCommentText(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_COMMENT), this.setStyle("procedure_blocks"), this.setTooltip(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_TOOLTIP), this.setHelpUrl(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFNORETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.setStatements_(!0), this.statementConnection_ = null;
      }, getProcedureDef: function() {
        return [this.getFieldValue("NAME"), this.arguments_, !1];
      }, callType_: "procedures_callnoreturn" }), nt.procedures_defreturn = Object.assign({}, Fr, { init: function() {
        var m = o.findLegalName$$module$build$src$core$procedures("", this);
        m = o.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: m }), m.setValidator(o.rename$$module$build$src$core$procedures), m.setSpellcheck(!1), this.appendDummyInput().appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_TITLE).appendField(m, "NAME").appendField(
          "",
          "PARAMS"
        ), this.appendValueInput("RETURN").setAlign(o.Align$$module$build$src$core$inputs$input.RIGHT).appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.setMutator(new o.MutatorIcon$$module$build$src$core$icons$mutator_icon(["procedures_mutatorarg"], this)), (this.workspace.options.comments || this.workspace.options.parentWorkspace && this.workspace.options.parentWorkspace.options.comments) && o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_COMMENT && this.setCommentText(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_COMMENT), this.setStyle("procedure_blocks"), this.setTooltip(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_TOOLTIP), this.setHelpUrl(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.setStatements_(!0), this.statementConnection_ = null;
      }, getProcedureDef: function() {
        return [this.getFieldValue("NAME"), this.arguments_, !0];
      }, callType_: "procedures_callreturn" });
      var _o = { init: function() {
        this.appendDummyInput().appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORCONTAINER_TITLE), this.appendStatementInput("STACK"), this.appendDummyInput("STATEMENT_INPUT").appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_ALLOW_STATEMENTS).appendField(o.fromJson$$module$build$src$core$field_registry({ type: "field_checkbox", checked: !0 }), "STATEMENTS"), this.setStyle("procedure_blocks"), this.setTooltip(o.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORCONTAINER_TOOLTIP), this.contextMenu = !1;
      } };
      nt.procedures_mutatorcontainer = _o;
      var bl = { init: function() {
        const m = o.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: o.DEFAULT_ARG$$module$build$src$core$procedures });
        m.setValidator(this.validator_), m.oldShowEditorFn_ = m.showEditor_, m.showEditor_ = function() {
          this.createdVariables_ = [], this.oldShowEditorFn_();
        }, this.appendDummyInput().appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORARG_TITLE).appendField(m, "NAME"), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setStyle("procedure_blocks"), this.setTooltip(o.Msg$$module$build$src$core$msg.PROCEDURES_MUTATORARG_TOOLTIP), this.contextMenu = !1, m.onFinishEditing_ = this.deleteIntermediateVars_, m.createdVariables_ = [], m.onFinishEditing_("x");
      }, validator_: function(m) {
        var D = this.getSourceBlock();
        const B = D.workspace.getRootWorkspace();
        if (m = m.replace(/[\s\xa0]+/g, " ").replace(/^ | $/g, ""), !m)
          return null;
        const V = (D.workspace.targetWorkspace || D.workspace).getAllBlocks(!1), oe = m.toLowerCase();
        for (let ke = 0; ke < V.length; ke++) {
          if (V[ke].id === this.getSourceBlock().id)
            continue;
          const $t = V[ke].getFieldValue("NAME");
          if ($t && $t.toLowerCase() === oe)
            return null;
        }
        return D.isInFlyout || ((D = B.getVariable(m, "")) && D.name !== m && B.renameVariableById(D.getId(), m), D || (D = B.createVariable(m, "")) && this.createdVariables_ && this.createdVariables_.push(D)), m;
      }, deleteIntermediateVars_: function(m) {
        const D = this.getSourceBlock().workspace.getRootWorkspace();
        if (D)
          for (let B = 0; B < this.createdVariables_.length; B++) {
            const V = this.createdVariables_[B];
            V.name !== m && D.deleteVariableById(V.getId());
          }
      } };
      nt.procedures_mutatorarg = bl;
      var fe = { getProcedureCall: function() {
        return this.getFieldValue("NAME");
      }, renameProcedure: function(m, D) {
        o.Names$$module$build$src$core$names.equals(m, this.getProcedureCall()) && (this.setFieldValue(D, "NAME"), this.setTooltip((this.outputConnection ? o.Msg$$module$build$src$core$msg.PROCEDURES_CALLRETURN_TOOLTIP : o.Msg$$module$build$src$core$msg.PROCEDURES_CALLNORETURN_TOOLTIP).replace("%1", D)));
      }, setProcedureParameters_: function(m, D) {
        var B = o.getDefinition$$module$build$src$core$procedures(
          this.getProcedureCall(),
          this.workspace
        );
        if ((B = (B = B && B.getIcon(o.MutatorIcon$$module$build$src$core$icons$mutator_icon.TYPE)) && B.bubbleIsVisible()) ? this.setCollapsed(!1) : (this.quarkConnections_ = {}, this.quarkIds_ = null), m.join(`
`) === this.arguments_.join(`
`))
          this.quarkIds_ = D;
        else {
          if (D.length !== m.length)
            throw RangeError("paramNames and paramIds must be the same length.");
          this.quarkIds_ || (this.quarkConnections_ = {}, this.quarkIds_ = []);
          for (let oe = 0; oe < this.arguments_.length; oe++) {
            var V = this.getInput("ARG" + oe);
            V && (V = V.connection.targetConnection, this.quarkConnections_[this.quarkIds_[oe]] = V, B && V && D.indexOf(this.quarkIds_[oe]) === -1 && (V.disconnect(), V.getSourceBlock().bumpNeighbours()));
          }
          for (this.arguments_ = [].concat(m), this.argumentVarModels_ = [], m = 0; m < this.arguments_.length; m++)
            B = o.getOrCreateVariablePackage$$module$build$src$core$variables(this.workspace, null, this.arguments_[m], ""), this.argumentVarModels_.push(B);
          if (this.updateShape_(), this.quarkIds_ = D) {
            for (D = 0; D < this.arguments_.length; D++)
              if (m = this.quarkIds_[D], m in this.quarkConnections_) {
                let oe;
                (oe = this.quarkConnections_[m]) != null && oe.reconnect(this, "ARG" + D) || delete this.quarkConnections_[m];
              }
          }
        }
      }, updateShape_: function() {
        for (var m = 0; m < this.arguments_.length; m++) {
          var D = this.getField("ARGNAME" + m);
          if (D) {
            o.disable$$module$build$src$core$events$utils();
            try {
              D.setValue(this.arguments_[m]);
            } finally {
              o.enable$$module$build$src$core$events$utils();
            }
          } else
            D = o.fromJson$$module$build$src$core$field_registry({ type: "field_label", text: this.arguments_[m] }), this.appendValueInput("ARG" + m).setAlign(o.Align$$module$build$src$core$inputs$input.RIGHT).appendField(
              D,
              "ARGNAME" + m
            ).init();
        }
        for (m = this.arguments_.length; this.getInput("ARG" + m); m++)
          this.removeInput("ARG" + m);
        (m = this.getInput("TOPROW")) && (this.arguments_.length ? this.getField("WITH") || (m.appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_CALL_BEFORE_PARAMS, "WITH"), m.init()) : this.getField("WITH") && m.removeField("WITH"));
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        m.setAttribute("name", this.getProcedureCall());
        for (let D = 0; D < this.arguments_.length; D++) {
          const B = o.createElement$$module$build$src$core$utils$xml("arg");
          B.setAttribute("name", this.arguments_[D]), m.appendChild(B);
        }
        return m;
      }, domToMutation: function(m) {
        var D = m.getAttribute("name");
        this.renameProcedure(this.getProcedureCall(), D), D = [];
        const B = [];
        for (let V = 0, oe; oe = m.childNodes[V]; V++)
          oe.nodeName.toLowerCase() === "arg" && (D.push(oe.getAttribute("name")), B.push(oe.getAttribute("paramId")));
        this.setProcedureParameters_(D, B);
      }, saveExtraState: function() {
        const m = /* @__PURE__ */ Object.create(null);
        return m.name = this.getProcedureCall(), this.arguments_.length && (m.params = this.arguments_), m;
      }, loadExtraState: function(m) {
        if (this.renameProcedure(this.getProcedureCall(), m.name), m = m.params) {
          const D = [];
          D.length = m.length, D.fill(null), this.setProcedureParameters_(m, D);
        }
      }, getVars: function() {
        return this.arguments_;
      }, getVarModels: function() {
        return this.argumentVarModels_;
      }, onchange: function(m) {
        if (this.workspace && !this.workspace.isFlyout && m.recordUndo)
          if (m.type === o.CREATE$$module$build$src$core$events$utils && m.ids.indexOf(this.id) !== -1) {
            var D = this.getProcedureCall();
            if (D = o.getDefinition$$module$build$src$core$procedures(D, this.workspace), !D || D.type === this.defType_ && JSON.stringify(D.getVars()) === JSON.stringify(this.arguments_) || (D = null), !D) {
              o.setGroup$$module$build$src$core$events$utils(m.group), m = o.createElement$$module$build$src$core$utils$xml("xml"), D = o.createElement$$module$build$src$core$utils$xml("block"), D.setAttribute("type", this.defType_);
              var B = this.getRelativeToSurfaceXY(), V = B.y + 2 * o.config$$module$build$src$core$config.snapRadius;
              D.setAttribute("x", `${B.x + o.config$$module$build$src$core$config.snapRadius * (this.RTL ? -1 : 1)}`), D.setAttribute("y", `${V}`), B = this.mutationToDom(), D.appendChild(B), B = o.createElement$$module$build$src$core$utils$xml("field"), B.setAttribute("name", "NAME"), V = this.getProcedureCall();
              const oe = o.findLegalName$$module$build$src$core$procedures(V, this);
              V !== oe && this.renameProcedure(V, oe), B.appendChild(o.createTextNode$$module$build$src$core$utils$xml(V)), D.appendChild(B), m.appendChild(D), o.domToWorkspace$$module$build$src$core$xml(
                m,
                this.workspace
              ), o.setGroup$$module$build$src$core$events$utils(!1);
            }
          } else
            m.type === o.DELETE$$module$build$src$core$events$utils ? (D = this.getProcedureCall(), o.getDefinition$$module$build$src$core$procedures(D, this.workspace) || (o.setGroup$$module$build$src$core$events$utils(m.group), this.dispose(!0), o.setGroup$$module$build$src$core$events$utils(!1))) : m.type === o.CHANGE$$module$build$src$core$events$utils && m.element === "disabled" && (D = this.getProcedureCall(), (D = o.getDefinition$$module$build$src$core$procedures(
              D,
              this.workspace
            )) && D.id === m.blockId && ((D = o.getGroup$$module$build$src$core$events$utils()) && console.log("Saw an existing group while responding to a definition change"), o.setGroup$$module$build$src$core$events$utils(m.group), m.newValue ? (this.previousEnabledState_ = this.isEnabled(), this.setEnabled(!1)) : this.setEnabled(this.previousEnabledState_), o.setGroup$$module$build$src$core$events$utils(D)));
      }, customContextMenu: function(m) {
        if (this.workspace.isMovable()) {
          var D = this.getProcedureCall(), B = this.workspace;
          m.push({ enabled: !0, text: o.Msg$$module$build$src$core$msg.PROCEDURES_HIGHLIGHT_DEF, callback: function() {
            const V = o.getDefinition$$module$build$src$core$procedures(D, B);
            V && (B.centerOnBlock(V.id), V.select());
          } });
        }
      } };
      nt.procedures_callnoreturn = Object.assign({}, fe, { init: function() {
        this.appendDummyInput("TOPROW").appendField("", "NAME"), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setStyle("procedure_blocks"), this.setHelpUrl(o.Msg$$module$build$src$core$msg.PROCEDURES_CALLNORETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.quarkConnections_ = {}, this.quarkIds_ = null, this.previousEnabledState_ = !0;
      }, defType_: "procedures_defnoreturn" }), nt.procedures_callreturn = Object.assign({}, fe, { init: function() {
        this.appendDummyInput("TOPROW").appendField("", "NAME"), this.setOutput(!0), this.setStyle("procedure_blocks"), this.setHelpUrl(o.Msg$$module$build$src$core$msg.PROCEDURES_CALLRETURN_HELPURL), this.arguments_ = [], this.argumentVarModels_ = [], this.quarkConnections_ = {}, this.quarkIds_ = null, this.previousEnabledState_ = !0;
      }, defType_: "procedures_defreturn" });
      var Hn = { init: function() {
        this.appendValueInput("CONDITION").setCheck("Boolean").appendField(o.Msg$$module$build$src$core$msg.CONTROLS_IF_MSG_IF), this.appendValueInput("VALUE").appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.setInputsInline(!0), this.setPreviousStatement(!0), this.setNextStatement(!0), this.setStyle("procedure_blocks"), this.setTooltip(o.Msg$$module$build$src$core$msg.PROCEDURES_IFRETURN_TOOLTIP), this.setHelpUrl(o.Msg$$module$build$src$core$msg.PROCEDURES_IFRETURN_HELPURL), this.hasReturnValue_ = !0;
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        return m.setAttribute("value", String(Number(this.hasReturnValue_))), m;
      }, domToMutation: function(m) {
        this.hasReturnValue_ = m.getAttribute("value") === "1", this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN));
      }, onchange: function(m) {
        if (!(this.workspace.isDragging && this.workspace.isDragging() || m.type !== o.MOVE$$module$build$src$core$events$utils)) {
          var D = !1, B = this;
          do {
            if (this.FUNCTION_TYPES.indexOf(B.type) !== -1) {
              D = !0;
              break;
            }
            B = B.getSurroundParent();
          } while (B);
          D ? (B.type === "procedures_defnoreturn" && this.hasReturnValue_ ? (this.removeInput("VALUE"), this.appendDummyInput("VALUE").appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !1) : B.type !== "procedures_defreturn" || this.hasReturnValue_ || (this.removeInput("VALUE"), this.appendValueInput("VALUE").appendField(o.Msg$$module$build$src$core$msg.PROCEDURES_DEFRETURN_RETURN), this.hasReturnValue_ = !0), this.setWarningText(null)) : this.setWarningText(o.Msg$$module$build$src$core$msg.PROCEDURES_IFRETURN_WARNING), this.isInFlyout || (B = o.getGroup$$module$build$src$core$events$utils(), o.setGroup$$module$build$src$core$events$utils(m.group), this.setEnabled(D), o.setGroup$$module$build$src$core$events$utils(B));
        }
      }, FUNCTION_TYPES: ["procedures_defnoreturn", "procedures_defreturn"] };
      nt.procedures_ifreturn = Hn, o.defineBlocks$$module$build$src$core$common(nt);
      var Yn = {};
      Yn.blocks = nt;
      var Br = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "text", message0: "%1", args0: [{ type: "field_input", name: "TEXT", text: "" }], output: "String", style: "text_blocks", helpUrl: "%{BKY_TEXT_TEXT_HELPURL}", tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}", extensions: ["text_quotes", "parent_tooltip_when_inline"] }, { type: "text_multiline", message0: "%1 %2", args0: [{
        type: "field_image",
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAdhgAAHYYBXaITgQAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42/U4J6AAAAP1JREFUOE+Vks0KQUEYhjmRIja4ABtZ2dm5A3t3Ia6AUm7CylYuQRaUhZSlLZJiQbFAyRnPN33y01HOW08z8873zpwzM4F3GWOCruvGIE4/rLaV+Nq1hVGMBqzhqlxgCys4wJA65xnogMHsQ5lujnYHTejBBCK2mE4abjCgMGhNxHgDFWjDSG07kdfVa2pZMf4ZyMAdWmpZMfYOsLiDMYMjlMB+K613QISRhTnITnsYg5yUd0DETmEoMlkFOeIT/A58iyK5E18BuTBfgYXfwNJv4P9/oEBerLylOnRhygmGdPpTTBZAPkde61lbQe4moWUvYUZYLfUNftIY4zwA5X2Z9AYnQrEAAAAASUVORK5CYII=",
        width: 12,
        height: 17,
        alt: "¶"
      }, { type: "field_multilinetext", name: "TEXT", text: "" }], output: "String", style: "text_blocks", helpUrl: "%{BKY_TEXT_TEXT_HELPURL}", tooltip: "%{BKY_TEXT_TEXT_TOOLTIP}", extensions: ["parent_tooltip_when_inline"] }, { type: "text_join", message0: "", output: "String", style: "text_blocks", helpUrl: "%{BKY_TEXT_JOIN_HELPURL}", tooltip: "%{BKY_TEXT_JOIN_TOOLTIP}", mutator: "text_join_mutator" }, { type: "text_create_join_container", message0: "%{BKY_TEXT_CREATE_JOIN_TITLE_JOIN} %1 %2", args0: [
        { type: "input_dummy" },
        { type: "input_statement", name: "STACK" }
      ], style: "text_blocks", tooltip: "%{BKY_TEXT_CREATE_JOIN_TOOLTIP}", enableContextMenu: !1 }, { type: "text_create_join_item", message0: "%{BKY_TEXT_CREATE_JOIN_ITEM_TITLE_ITEM}", previousStatement: null, nextStatement: null, style: "text_blocks", tooltip: "%{BKY_TEXT_CREATE_JOIN_ITEM_TOOLTIP}", enableContextMenu: !1 }, {
        type: "text_append",
        message0: "%{BKY_TEXT_APPEND_TITLE}",
        args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_TEXT_APPEND_VARIABLE}" }, { type: "input_value", name: "TEXT" }],
        previousStatement: null,
        nextStatement: null,
        style: "text_blocks",
        extensions: ["text_append_tooltip"]
      }, { type: "text_length", message0: "%{BKY_TEXT_LENGTH_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }], output: "Number", style: "text_blocks", tooltip: "%{BKY_TEXT_LENGTH_TOOLTIP}", helpUrl: "%{BKY_TEXT_LENGTH_HELPURL}" }, {
        type: "text_isEmpty",
        message0: "%{BKY_TEXT_ISEMPTY_TITLE}",
        args0: [{ type: "input_value", name: "VALUE", check: ["String", "Array"] }],
        output: "Boolean",
        style: "text_blocks",
        tooltip: "%{BKY_TEXT_ISEMPTY_TOOLTIP}",
        helpUrl: "%{BKY_TEXT_ISEMPTY_HELPURL}"
      }, { type: "text_indexOf", message0: "%{BKY_TEXT_INDEXOF_TITLE}", args0: [{ type: "input_value", name: "VALUE", check: "String" }, { type: "field_dropdown", name: "END", options: [["%{BKY_TEXT_INDEXOF_OPERATOR_FIRST}", "FIRST"], ["%{BKY_TEXT_INDEXOF_OPERATOR_LAST}", "LAST"]] }, { type: "input_value", name: "FIND", check: "String" }], output: "Number", style: "text_blocks", helpUrl: "%{BKY_TEXT_INDEXOF_HELPURL}", inputsInline: !0, extensions: ["text_indexOf_tooltip"] }, {
        type: "text_charAt",
        message0: "%{BKY_TEXT_CHARAT_TITLE}",
        args0: [{ type: "input_value", name: "VALUE", check: "String" }, { type: "field_dropdown", name: "WHERE", options: [["%{BKY_TEXT_CHARAT_FROM_START}", "FROM_START"], ["%{BKY_TEXT_CHARAT_FROM_END}", "FROM_END"], ["%{BKY_TEXT_CHARAT_FIRST}", "FIRST"], ["%{BKY_TEXT_CHARAT_LAST}", "LAST"], ["%{BKY_TEXT_CHARAT_RANDOM}", "RANDOM"]] }],
        output: "String",
        style: "text_blocks",
        helpUrl: "%{BKY_TEXT_CHARAT_HELPURL}",
        inputsInline: !0,
        mutator: "text_charAt_mutator"
      }]), Xr = {
        init: function() {
          this.WHERE_OPTIONS_1 = [[o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_START_FROM_START, "FROM_START"], [o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_START_FROM_END, "FROM_END"], [o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_START_FIRST, "FIRST"]], this.WHERE_OPTIONS_2 = [[o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_END_FROM_START, "FROM_START"], [o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_END_FROM_END, "FROM_END"], [o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_END_LAST, "LAST"]], this.setHelpUrl(o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_HELPURL), this.setStyle("text_blocks"), this.appendValueInput("STRING").setCheck("String").appendField(o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_INPUT_IN_TEXT), this.appendDummyInput("AT1"), this.appendDummyInput("AT2"), o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL && this.appendDummyInput("TAIL").appendField(o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL), this.setInputsInline(!0), this.setOutput(!0, "String"), this.updateAt_(1, !0), this.updateAt_(2, !0), this.setTooltip(o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TOOLTIP);
        },
        mutationToDom: function() {
          const m = o.createElement$$module$build$src$core$utils$xml("mutation");
          var D = this.getInput("AT1") instanceof o.ValueInput$$module$build$src$core$inputs$value_input;
          return m.setAttribute("at1", `${D}`), D = this.getInput("AT2") instanceof o.ValueInput$$module$build$src$core$inputs$value_input, m.setAttribute("at2", `${D}`), m;
        },
        domToMutation: function(m) {
          const D = m.getAttribute("at1") === "true";
          m = m.getAttribute("at2") === "true", this.updateAt_(1, D), this.updateAt_(2, m);
        },
        updateAt_: function(m, D) {
          this.removeInput("AT" + m), this.removeInput("ORDINAL" + m, !0), D ? (this.appendValueInput("AT" + m).setCheck("Number"), o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL" + m).appendField(o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)) : this.appendDummyInput("AT" + m), m === 2 && o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(o.Msg$$module$build$src$core$msg.TEXT_GET_SUBSTRING_TAIL));
          const B = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: this["WHERE_OPTIONS_" + m] });
          B.setValidator(function(V) {
            const oe = V === "FROM_START" || V === "FROM_END";
            if (oe !== D) {
              const ke = this.getSourceBlock();
              return ke.updateAt_(m, oe), ke.setFieldValue(V, "WHERE" + m), null;
            }
          }), this.getInput("AT" + m).appendField(B, "WHERE" + m), m === 1 && (this.moveInputBefore("AT1", "AT2"), this.getInput("ORDINAL1") && this.moveInputBefore("ORDINAL1", "AT2"));
        }
      };
      Br.text_getSubstring = Xr, Br.text_changeCase = { init: function() {
        const m = [[o.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_OPERATOR_UPPERCASE, "UPPERCASE"], [o.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_OPERATOR_LOWERCASE, "LOWERCASE"], [o.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_OPERATOR_TITLECASE, "TITLECASE"]];
        this.setHelpUrl(o.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_HELPURL), this.setStyle("text_blocks"), this.appendValueInput("TEXT").setCheck("String").appendField(o.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: m
        }), "CASE"), this.setOutput(!0, "String"), this.setTooltip(o.Msg$$module$build$src$core$msg.TEXT_CHANGECASE_TOOLTIP);
      } }, Br.text_trim = { init: function() {
        const m = [[o.Msg$$module$build$src$core$msg.TEXT_TRIM_OPERATOR_BOTH, "BOTH"], [o.Msg$$module$build$src$core$msg.TEXT_TRIM_OPERATOR_LEFT, "LEFT"], [o.Msg$$module$build$src$core$msg.TEXT_TRIM_OPERATOR_RIGHT, "RIGHT"]];
        this.setHelpUrl(o.Msg$$module$build$src$core$msg.TEXT_TRIM_HELPURL), this.setStyle("text_blocks"), this.appendValueInput("TEXT").setCheck("String").appendField(
          o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: m }),
          "MODE"
        ), this.setOutput(!0, "String"), this.setTooltip(o.Msg$$module$build$src$core$msg.TEXT_TRIM_TOOLTIP);
      } }, Br.text_print = { init: function() {
        this.jsonInit({ message0: o.Msg$$module$build$src$core$msg.TEXT_PRINT_TITLE, args0: [{ type: "input_value", name: "TEXT" }], previousStatement: null, nextStatement: null, style: "text_blocks", tooltip: o.Msg$$module$build$src$core$msg.TEXT_PRINT_TOOLTIP, helpUrl: o.Msg$$module$build$src$core$msg.TEXT_PRINT_HELPURL });
      } };
      var ai = { updateType_: function(m) {
        this.outputConnection.setCheck(m === "NUMBER" ? "Number" : "String");
      }, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        return m.setAttribute("type", this.getFieldValue("TYPE")), m;
      }, domToMutation: function(m) {
        this.updateType_(m.getAttribute("type"));
      } };
      Br.text_prompt_ext = Object.assign({}, ai, { init: function() {
        var m = [[o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_TEXT, "TEXT"], [o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_NUMBER, "NUMBER"]];
        this.setHelpUrl(o.Msg$$module$build$src$core$msg.TEXT_PROMPT_HELPURL), this.setStyle("text_blocks"), m = o.fromJson$$module$build$src$core$field_registry({ type: "field_dropdown", options: m }), m.setValidator((D) => {
          this.updateType_(D);
        }), this.appendValueInput("TEXT").appendField(
          m,
          "TYPE"
        ), this.setOutput(!0, "String"), this.setTooltip(() => this.getFieldValue("TYPE") === "TEXT" ? o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_TEXT : o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_NUMBER);
      } });
      var hr = Object.assign({}, ai, { init: function() {
        this.mixin(K);
        var m = [[o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_TEXT, "TEXT"], [o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TYPE_NUMBER, "NUMBER"]];
        this.setHelpUrl(o.Msg$$module$build$src$core$msg.TEXT_PROMPT_HELPURL), this.setStyle("text_blocks"), m = o.fromJson$$module$build$src$core$field_registry({
          type: "field_dropdown",
          options: m
        }), m.setValidator((D) => {
          this.updateType_(D);
        }), this.appendDummyInput().appendField(m, "TYPE").appendField(this.newQuote_(!0)).appendField(o.fromJson$$module$build$src$core$field_registry({ type: "field_input", text: "" }), "TEXT").appendField(this.newQuote_(!1)), this.setOutput(!0, "String"), this.setTooltip(() => this.getFieldValue("TYPE") === "TEXT" ? o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_TEXT : o.Msg$$module$build$src$core$msg.TEXT_PROMPT_TOOLTIP_NUMBER);
      } });
      Br.text_prompt = hr, Br.text_count = { init: function() {
        this.jsonInit({ message0: o.Msg$$module$build$src$core$msg.TEXT_COUNT_MESSAGE0, args0: [{ type: "input_value", name: "SUB", check: "String" }, { type: "input_value", name: "TEXT", check: "String" }], output: "Number", inputsInline: !0, style: "text_blocks", tooltip: o.Msg$$module$build$src$core$msg.TEXT_COUNT_TOOLTIP, helpUrl: o.Msg$$module$build$src$core$msg.TEXT_COUNT_HELPURL });
      } }, Br.text_replace = { init: function() {
        this.jsonInit({ message0: o.Msg$$module$build$src$core$msg.TEXT_REPLACE_MESSAGE0, args0: [{ type: "input_value", name: "FROM", check: "String" }, { type: "input_value", name: "TO", check: "String" }, { type: "input_value", name: "TEXT", check: "String" }], output: "String", inputsInline: !0, style: "text_blocks", tooltip: o.Msg$$module$build$src$core$msg.TEXT_REPLACE_TOOLTIP, helpUrl: o.Msg$$module$build$src$core$msg.TEXT_REPLACE_HELPURL });
      } }, Br.text_reverse = { init: function() {
        this.jsonInit({ message0: o.Msg$$module$build$src$core$msg.TEXT_REVERSE_MESSAGE0, args0: [{ type: "input_value", name: "TEXT", check: "String" }], output: "String", inputsInline: !0, style: "text_blocks", tooltip: o.Msg$$module$build$src$core$msg.TEXT_REVERSE_TOOLTIP, helpUrl: o.Msg$$module$build$src$core$msg.TEXT_REVERSE_HELPURL });
      } };
      var K = {
        QUOTE_IMAGE_LEFT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAn0lEQVQI1z3OMa5BURSF4f/cQhAKjUQhuQmFNwGJEUi0RKN5rU7FHKhpjEH3TEMtkdBSCY1EIv8r7nFX9e29V7EBAOvu7RPjwmWGH/VuF8CyN9/OAdvqIXYLvtRaNjx9mMTDyo+NjAN1HNcl9ZQ5oQMM3dgDUqDo1l8DzvwmtZN7mnD+PkmLa+4mhrxVA9fRowBWmVBhFy5gYEjKMfz9AylsaRRgGzvZAAAAAElFTkSuQmCC",
        QUOTE_IMAGE_RIGHT_DATAURI: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAQAAAAqJXdxAAAAqUlEQVQI1z3KvUpCcRiA8ef9E4JNHhI0aFEacm1o0BsI0Slx8wa8gLauoDnoBhq7DcfWhggONDmJJgqCPA7neJ7p934EOOKOnM8Q7PDElo/4x4lFb2DmuUjcUzS3URnGib9qaPNbuXvBO3sGPHJDRG6fGVdMSeWDP2q99FQdFrz26Gu5Tq7dFMzUvbXy8KXeAj57cOklgA+u1B5AoslLtGIHQMaCVnwDnADZIFIrXsoXrgAAAABJRU5ErkJggg==",
        QUOTE_IMAGE_WIDTH: 12,
        QUOTE_IMAGE_HEIGHT: 12,
        quoteField_: function(m) {
          for (let D = 0, B; B = this.inputList[D]; D++)
            for (let V = 0, oe; oe = B.fieldRow[V]; V++)
              if (m === oe.name) {
                B.insertFieldAt(V, this.newQuote_(!0)), B.insertFieldAt(V + 2, this.newQuote_(!1));
                return;
              }
          console.warn('field named "' + m + '" not found in ' + this.toDevString());
        },
        newQuote_: function(m) {
          return m = this.RTL ? !m : m, o.fromJson$$module$build$src$core$field_registry({
            type: "field_image",
            src: m ? this.QUOTE_IMAGE_LEFT_DATAURI : this.QUOTE_IMAGE_RIGHT_DATAURI,
            width: this.QUOTE_IMAGE_WIDTH,
            height: this.QUOTE_IMAGE_HEIGHT,
            alt: m ? "“" : "”"
          });
        }
      }, Re = function() {
        this.mixin(K), this.quoteField_("TEXT");
      }, co = {
        itemCount_: 0,
        mutationToDom: function() {
          const m = o.createElement$$module$build$src$core$utils$xml("mutation");
          return m.setAttribute("items", `${this.itemCount_}`), m;
        },
        domToMutation: function(m) {
          this.itemCount_ = parseInt(m.getAttribute("items"), 10), this.updateShape_();
        },
        saveExtraState: function() {
          return { itemCount: this.itemCount_ };
        },
        loadExtraState: function(m) {
          this.itemCount_ = m.itemCount, this.updateShape_();
        },
        decompose: function(m) {
          const D = m.newBlock("text_create_join_container");
          D.initSvg();
          let B = D.getInput("STACK").connection;
          for (let V = 0; V < this.itemCount_; V++) {
            const oe = m.newBlock("text_create_join_item");
            oe.initSvg(), B.connect(oe.previousConnection), B = oe.nextConnection;
          }
          return D;
        },
        compose: function(m) {
          var D = m.getInputTargetBlock("STACK");
          for (m = []; D; )
            D.isInsertionMarker() || m.push(D.valueConnection_), D = D.getNextBlock();
          for (D = 0; D < this.itemCount_; D++) {
            const B = this.getInput("ADD" + D).connection.targetConnection;
            B && m.indexOf(B) === -1 && B.disconnect();
          }
          for (this.itemCount_ = m.length, this.updateShape_(), D = 0; D < this.itemCount_; D++) {
            let B;
            (B = m[D]) == null || B.reconnect(this, "ADD" + D);
          }
        },
        saveConnections: function(m) {
          m = m.getInputTargetBlock("STACK");
          let D = 0;
          for (; m; ) {
            if (m.isInsertionMarker()) {
              m = m.getNextBlock();
              continue;
            }
            const B = this.getInput("ADD" + D);
            m.valueConnection_ = B && B.connection.targetConnection, m = m.getNextBlock(), D++;
          }
        },
        updateShape_: function() {
          this.itemCount_ && this.getInput("EMPTY") ? this.removeInput("EMPTY") : this.itemCount_ || this.getInput("EMPTY") || this.appendDummyInput("EMPTY").appendField(this.newQuote_(!0)).appendField(this.newQuote_(!1));
          for (var m = 0; m < this.itemCount_; m++)
            if (!this.getInput("ADD" + m)) {
              const D = this.appendValueInput("ADD" + m).setAlign(o.Align$$module$build$src$core$inputs$align.RIGHT);
              m === 0 && D.appendField(o.Msg$$module$build$src$core$msg.TEXT_JOIN_TITLE_CREATEWITH);
            }
          for (m = this.itemCount_; this.getInput("ADD" + m); m++)
            this.removeInput("ADD" + m);
        }
      }, Ue = function() {
        this.mixin(K), this.itemCount_ = 2, this.updateShape_(), this.setMutator(new o.MutatorIcon$$module$build$src$core$icons$mutator_icon(["text_create_join_item"], this));
      };
      o.register$$module$build$src$core$extensions("text_append_tooltip", o.buildTooltipWithFieldText$$module$build$src$core$extensions("%{BKY_TEXT_APPEND_TOOLTIP}", "VAR"));
      var Di = function() {
        this.setTooltip(() => o.Msg$$module$build$src$core$msg.TEXT_INDEXOF_TOOLTIP.replace("%1", this.workspace.options.oneBasedIndex ? "0" : "-1"));
      }, _t = { isAt_: !1, mutationToDom: function() {
        const m = o.createElement$$module$build$src$core$utils$xml("mutation");
        return m.setAttribute("at", `${this.isAt_}`), m;
      }, domToMutation: function(m) {
        m = m.getAttribute("at") !== "false", this.updateAt_(m);
      }, updateAt_: function(m) {
        this.removeInput(
          "AT",
          !0
        ), this.removeInput("ORDINAL", !0), m && (this.appendValueInput("AT").setCheck("Number"), o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX && this.appendDummyInput("ORDINAL").appendField(o.Msg$$module$build$src$core$msg.ORDINAL_NUMBER_SUFFIX)), o.Msg$$module$build$src$core$msg.TEXT_CHARAT_TAIL && (this.removeInput("TAIL", !0), this.appendDummyInput("TAIL").appendField(o.Msg$$module$build$src$core$msg.TEXT_CHARAT_TAIL)), this.isAt_ = m;
      } }, mr = function() {
        this.getField("WHERE").setValidator(function(m) {
          m = m === "FROM_START" || m === "FROM_END";
          const D = this.getSourceBlock();
          m !== D.isAt_ && D.updateAt_(m);
        }), this.updateAt_(!0), this.setTooltip(() => {
          var m = this.getFieldValue("WHERE");
          let D = o.Msg$$module$build$src$core$msg.TEXT_CHARAT_TOOLTIP;
          return (m === "FROM_START" || m === "FROM_END") && (m = m === "FROM_START" ? o.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_START_TOOLTIP : o.Msg$$module$build$src$core$msg.LISTS_INDEX_FROM_END_TOOLTIP) && (D += "  " + m.replace("%1", this.workspace.options.oneBasedIndex ? "#1" : "#0")), D;
        });
      };
      o.register$$module$build$src$core$extensions("text_indexOf_tooltip", Di), o.register$$module$build$src$core$extensions("text_quotes", Re), o.registerMutator$$module$build$src$core$extensions("text_join_mutator", co, Ue), o.registerMutator$$module$build$src$core$extensions("text_charAt_mutator", _t, mr), o.defineBlocks$$module$build$src$core$common(Br);
      var xo = {};
      xo.blocks = Br;
      var bi = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "variables_get", message0: "%1", args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_VARIABLES_DEFAULT_NAME}" }], output: null, style: "variable_blocks", helpUrl: "%{BKY_VARIABLES_GET_HELPURL}", tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}", extensions: ["contextMenu_variableSetterGetter"] }, { type: "variables_set", message0: "%{BKY_VARIABLES_SET}", args0: [
        { type: "field_variable", name: "VAR", variable: "%{BKY_VARIABLES_DEFAULT_NAME}" },
        { type: "input_value", name: "VALUE" }
      ], previousStatement: null, nextStatement: null, style: "variable_blocks", tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}", helpUrl: "%{BKY_VARIABLES_SET_HELPURL}", extensions: ["contextMenu_variableSetterGetter"] }]), Ur = { customContextMenu: function(m) {
        if (this.isInFlyout)
          (this.type === "variables_get" || this.type === "variables_get_reporter") && (D = { text: o.Msg$$module$build$src$core$msg.RENAME_VARIABLE, enabled: !0, callback: tr(this) }, B = this.getField("VAR").getText(), B = { text: o.Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace("%1", B), enabled: !0, callback: Pi(this) }, m.unshift(D), m.unshift(B));
        else {
          if (this.type === "variables_get")
            var D = "variables_set", B = o.Msg$$module$build$src$core$msg.VARIABLES_GET_CREATE_SET;
          else
            D = "variables_get", B = o.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET;
          const V = this.getField("VAR").getText(), oe = o.createElement$$module$build$src$core$utils$xml("field");
          oe.setAttribute("name", "VAR"), oe.appendChild(o.createTextNode$$module$build$src$core$utils$xml(V));
          const ke = o.createElement$$module$build$src$core$utils$xml("block");
          ke.setAttribute("type", D), ke.appendChild(oe), m.push({ enabled: 0 < this.workspace.remainingCapacity(), text: B.replace("%1", V), callback: o.callbackFactory$$module$build$src$core$contextmenu(
            this,
            ke
          ) });
        }
      } }, tr = function(m) {
        return function() {
          const D = m.workspace, B = m.getField("VAR").getVariable();
          o.renameVariable$$module$build$src$core$variables(D, B);
        };
      }, Pi = function(m) {
        return function() {
          const D = m.workspace, B = m.getField("VAR").getVariable();
          D.deleteVariableById(B.getId()), D.refreshToolboxSelection();
        };
      };
      o.registerMixin$$module$build$src$core$extensions("contextMenu_variableSetterGetter", Ur), o.defineBlocks$$module$build$src$core$common(bi);
      var Kr = {};
      Kr.blocks = bi;
      var _i = o.createBlockDefinitionsFromJsonArray$$module$build$src$core$common([{ type: "variables_get_dynamic", message0: "%1", args0: [{ type: "field_variable", name: "VAR", variable: "%{BKY_VARIABLES_DEFAULT_NAME}" }], output: null, style: "variable_dynamic_blocks", helpUrl: "%{BKY_VARIABLES_GET_HELPURL}", tooltip: "%{BKY_VARIABLES_GET_TOOLTIP}", extensions: ["contextMenu_variableDynamicSetterGetter"] }, { type: "variables_set_dynamic", message0: "%{BKY_VARIABLES_SET}", args0: [{
        type: "field_variable",
        name: "VAR",
        variable: "%{BKY_VARIABLES_DEFAULT_NAME}"
      }, { type: "input_value", name: "VALUE" }], previousStatement: null, nextStatement: null, style: "variable_dynamic_blocks", tooltip: "%{BKY_VARIABLES_SET_TOOLTIP}", helpUrl: "%{BKY_VARIABLES_SET_HELPURL}", extensions: ["contextMenu_variableDynamicSetterGetter"] }]), Xn = { customContextMenu: function(m) {
        if (this.isInFlyout)
          (this.type === "variables_get_dynamic" || this.type === "variables_get_reporter_dynamic") && (D = { text: o.Msg$$module$build$src$core$msg.RENAME_VARIABLE, enabled: !0, callback: uo(this) }, V = this.getField("VAR").getText(), V = { text: o.Msg$$module$build$src$core$msg.DELETE_VARIABLE.replace(
            "%1",
            V
          ), enabled: !0, callback: $i(this) }, m.unshift(D), m.unshift(V));
        else {
          var D = this.getFieldValue("VAR"), B = this.workspace.getVariableById(D).type;
          if (this.type === "variables_get_dynamic") {
            D = "variables_set_dynamic";
            var V = o.Msg$$module$build$src$core$msg.VARIABLES_GET_CREATE_SET;
          } else
            D = "variables_get_dynamic", V = o.Msg$$module$build$src$core$msg.VARIABLES_SET_CREATE_GET;
          const oe = this.getField("VAR").getText(), ke = o.createElement$$module$build$src$core$utils$xml("field");
          ke.setAttribute("name", "VAR"), ke.setAttribute("variabletype", B), ke.appendChild(o.createTextNode$$module$build$src$core$utils$xml(oe)), B = o.createElement$$module$build$src$core$utils$xml("block"), B.setAttribute("type", D), B.appendChild(ke), m.push({ enabled: 0 < this.workspace.remainingCapacity(), text: V.replace("%1", oe), callback: o.callbackFactory$$module$build$src$core$contextmenu(this, B) });
        }
      }, onchange: function(m) {
        m = this.getFieldValue("VAR"), m = o.getVariable$$module$build$src$core$variables(this.workspace, m), this.type === "variables_get_dynamic" ? this.outputConnection.setCheck(m.type) : this.getInput("VALUE").connection.setCheck(m.type);
      } }, uo = function(m) {
        return function() {
          const D = m.workspace, B = m.getField("VAR").getVariable();
          o.renameVariable$$module$build$src$core$variables(D, B);
        };
      }, $i = function(m) {
        return function() {
          const D = m.workspace, B = m.getField("VAR").getVariable();
          D.deleteVariableById(B.getId()), D.refreshToolboxSelection();
        };
      };
      o.registerMixin$$module$build$src$core$extensions("contextMenu_variableDynamicSetterGetter", Xn), o.defineBlocks$$module$build$src$core$common(_i);
      var jr = {};
      jr.blocks = _i;
      var To = Object.assign({}, c, d, Ke, Ze, Er, nt, bi, _i), k = {};
      return k.blocks = To, k.colour = T, k.lists = be, k.loops = Yr, k.math = ao, k.procedures = Yn, k.texts = xo, k.variables = Kr, k.variablesDynamic = jr, k.__namespace__ = o, k;
    });
  }(ah)), ah.exports;
}
var dm;
function zM() {
  return dm || (dm = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(jM());
    })(ln, function(r) {
      /**
       * @license
       * Copyright 2020 Google LLC
       * SPDX-License-Identifier: Apache-2.0
       */
      return r;
    });
  }(sh)), sh.exports;
}
var _h = { exports: {} }, ch = { exports: {} }, Em;
function JM() {
  return Em || (Em = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(Bh());
    })(ln, function(r) {
      var o = r.__namespace__, c = function(M, v) {
        return [v.quote_(M.getFieldValue("COLOUR")), k.ATOMIC];
      }, T = function(M, v) {
        return [v.provideFunction_("colourRandom", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}() {
  var num = Math.floor(Math.random() * Math.pow(2, 24));
  return '#' + ('00000' + num.toString(16)).substr(-6);
}
`) + "()", k.FUNCTION_CALL];
      }, d = function(M, v) {
        const W = v.valueToCode(M, "RED", k.NONE) || 0, H = v.valueToCode(M, "GREEN", k.NONE) || 0;
        return M = v.valueToCode(M, "BLUE", k.NONE) || 0, [v.provideFunction_(
          "colourRgb",
          `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(r, g, b) {
  r = Math.max(Math.min(Number(r), 100), 0) * 2.55;
  g = Math.max(Math.min(Number(g), 100), 0) * 2.55;
  b = Math.max(Math.min(Number(b), 100), 0) * 2.55;
  r = ('0' + (Math.round(r) || 0).toString(16)).slice(-2);
  g = ('0' + (Math.round(g) || 0).toString(16)).slice(-2);
  b = ('0' + (Math.round(b) || 0).toString(16)).slice(-2);
  return '#' + r + g + b;
}
`
        ) + "(" + W + ", " + H + ", " + M + ")", k.FUNCTION_CALL];
      }, h = function(M, v) {
        const W = v.valueToCode(M, "COLOUR1", k.NONE) || "'#000000'", H = v.valueToCode(M, "COLOUR2", k.NONE) || "'#000000'";
        return M = v.valueToCode(M, "RATIO", k.NONE) || 0.5, [v.provideFunction_("colourBlend", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(c1, c2, ratio) {
  ratio = Math.max(Math.min(Number(ratio), 1), 0);
  var r1 = parseInt(c1.substring(1, 3), 16);
  var g1 = parseInt(c1.substring(3, 5), 16);
  var b1 = parseInt(c1.substring(5, 7), 16);
  var r2 = parseInt(c2.substring(1, 3), 16);
  var g2 = parseInt(c2.substring(3, 5), 16);
  var b2 = parseInt(c2.substring(5, 7), 16);
  var r = Math.round(r1 * (1 - ratio) + r2 * ratio);
  var g = Math.round(g1 * (1 - ratio) + g2 * ratio);
  var b = Math.round(b1 * (1 - ratio) + b2 * ratio);
  r = ('0' + (r || 0).toString(16)).slice(-2);
  g = ('0' + (g || 0).toString(16)).slice(-2);
  b = ('0' + (b || 0).toString(16)).slice(-2);
  return '#' + r + g + b;
}
`) + "(" + W + ", " + H + ", " + M + ")", k.FUNCTION_CALL];
      }, y = function(M, v) {
        return ["[]", k.ATOMIC];
      }, b = function(M, v) {
        const W = Array(M.itemCount_);
        for (let H = 0; H < M.itemCount_; H++)
          W[H] = v.valueToCode(M, "ADD" + H, k.NONE) || "null";
        return ["[" + W.join(", ") + "]", k.ATOMIC];
      }, U = function(M, v) {
        const W = v.provideFunction_("listsRepeat", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(value, n) {
  var array = [];
  for (var i = 0; i < n; i++) {
    array[i] = value;
  }
  return array;
}
`), H = v.valueToCode(M, "ITEM", k.NONE) || "null";
        return M = v.valueToCode(M, "NUM", k.NONE) || "0", [W + "(" + H + ", " + M + ")", k.FUNCTION_CALL];
      }, Z = function(M, v) {
        return [(v.valueToCode(M, "VALUE", k.MEMBER) || "[]") + ".length", k.MEMBER];
      }, le = function(M, v) {
        return ["!" + (v.valueToCode(M, "VALUE", k.MEMBER) || "[]") + ".length", k.LOGICAL_NOT];
      }, ue = function(M, v) {
        const W = M.getFieldValue("END") === "FIRST" ? "indexOf" : "lastIndexOf", H = v.valueToCode(M, "FIND", k.NONE) || "''";
        return v = (v.valueToCode(M, "VALUE", k.MEMBER) || "[]") + "." + W + "(" + H + ")", M.workspace.options.oneBasedIndex ? [v + " + 1", k.ADDITION] : [v, k.FUNCTION_CALL];
      }, be = function(M, v) {
        const W = M.getFieldValue("MODE") || "GET", H = M.getFieldValue("WHERE") || "FROM_START";
        var ee = v.valueToCode(M, "VALUE", H === "RANDOM" ? k.NONE : k.MEMBER) || "[]";
        switch (H) {
          case "FIRST":
            if (W === "GET")
              return [ee + "[0]", k.MEMBER];
            if (W === "GET_REMOVE")
              return [ee + ".shift()", k.MEMBER];
            if (W === "REMOVE")
              return ee + `.shift();
`;
            break;
          case "LAST":
            if (W === "GET")
              return [ee + ".slice(-1)[0]", k.MEMBER];
            if (W === "GET_REMOVE")
              return [ee + ".pop()", k.MEMBER];
            if (W === "REMOVE")
              return ee + `.pop();
`;
            break;
          case "FROM_START":
            if (M = v.getAdjusted(M, "AT"), W === "GET")
              return [ee + "[" + M + "]", k.MEMBER];
            if (W === "GET_REMOVE")
              return [ee + ".splice(" + M + ", 1)[0]", k.FUNCTION_CALL];
            if (W === "REMOVE")
              return ee + ".splice(" + M + `, 1);
`;
            break;
          case "FROM_END":
            if (M = v.getAdjusted(M, "AT", 1, !0), W === "GET")
              return [ee + ".slice(" + M + ")[0]", k.FUNCTION_CALL];
            if (W === "GET_REMOVE")
              return [ee + ".splice(" + M + ", 1)[0]", k.FUNCTION_CALL];
            if (W === "REMOVE")
              return ee + ".splice(" + M + ", 1);";
            break;
          case "RANDOM":
            if (ee = v.provideFunction_("listsGetRandomItem", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(list, remove) {
  var x = Math.floor(Math.random() * list.length);
  if (remove) {
    return list.splice(x, 1)[0];
  } else {
    return list[x];
  }
}
`) + "(" + ee + ", " + (W !== "GET") + ")", W === "GET" || W === "GET_REMOVE")
              return [ee, k.FUNCTION_CALL];
            if (W === "REMOVE")
              return ee + `;
`;
        }
        throw Error("Unhandled combination (lists_getIndex).");
      }, Ke = function(M, v) {
        function W() {
          if (H.match(/^\w+$/))
            return "";
          const rr = v.nameDB_.getDistinctName("tmpList", o.NameType$$module$build$src$core$names.VARIABLE), Yo = "var " + rr + " = " + H + `;
`;
          return H = rr, Yo;
        }
        let H = v.valueToCode(
          M,
          "LIST",
          k.MEMBER
        ) || "[]";
        const ee = M.getFieldValue("MODE") || "GET";
        var Me = M.getFieldValue("WHERE") || "FROM_START";
        const He = v.valueToCode(M, "TO", k.ASSIGNMENT) || "null";
        switch (Me) {
          case "FIRST":
            if (ee === "SET")
              return H + "[0] = " + He + `;
`;
            if (ee === "INSERT")
              return H + ".unshift(" + He + `);
`;
            break;
          case "LAST":
            if (ee === "SET")
              return W() + (H + "[" + H + ".length - 1] = " + He + `;
`);
            if (ee === "INSERT")
              return H + ".push(" + He + `);
`;
            break;
          case "FROM_START":
            if (M = v.getAdjusted(M, "AT"), ee === "SET")
              return H + "[" + M + "] = " + He + `;
`;
            if (ee === "INSERT")
              return H + ".splice(" + M + ", 0, " + He + `);
`;
            break;
          case "FROM_END":
            if (M = v.getAdjusted(M, "AT", 1, !1, k.SUBTRACTION), Me = W(), ee === "SET")
              return Me + (H + "[" + H + ".length - " + M + "] = " + He + `;
`);
            if (ee === "INSERT")
              return Me + (H + ".splice(" + H + ".length - " + M + ", 0, " + He + `);
`);
            break;
          case "RANDOM":
            if (M = W(), Me = v.nameDB_.getDistinctName("tmpX", o.NameType$$module$build$src$core$names.VARIABLE), M += "var " + Me + " = Math.floor(Math.random() * " + H + `.length);
`, ee === "SET")
              return M + (H + "[" + Me + "] = " + He + `;
`);
            if (ee === "INSERT")
              return M + (H + ".splice(" + Me + ", 0, " + He + `);
`);
        }
        throw Error("Unhandled combination (lists_setIndex).");
      }, ae = function(M, v) {
        var W = v.valueToCode(M, "LIST", k.MEMBER) || "[]", H = M.getFieldValue("WHERE1");
        const ee = M.getFieldValue("WHERE2");
        if (H === "FIRST" && ee === "LAST")
          W += ".slice(0)";
        else if (W.match(/^\w+$/) || H !== "FROM_END" && ee === "FROM_START") {
          switch (H) {
            case "FROM_START":
              H = v.getAdjusted(M, "AT1");
              break;
            case "FROM_END":
              H = v.getAdjusted(M, "AT1", 1, !1, k.SUBTRACTION), H = W + ".length - " + H;
              break;
            case "FIRST":
              H = "0";
              break;
            default:
              throw Error("Unhandled option (lists_getSublist).");
          }
          switch (ee) {
            case "FROM_START":
              v = v.getAdjusted(M, "AT2", 1);
              break;
            case "FROM_END":
              v = v.getAdjusted(M, "AT2", 0, !1, k.SUBTRACTION), v = W + ".length - " + v;
              break;
            case "LAST":
              v = W + ".length";
              break;
            default:
              throw Error("Unhandled option (lists_getSublist).");
          }
          W = W + ".slice(" + H + ", " + v + ")";
        } else {
          const Me = v.getAdjusted(M, "AT1");
          M = v.getAdjusted(M, "AT2");
          const He = { FIRST: "First", LAST: "Last", FROM_START: "FromStart", FROM_END: "FromEnd" };
          W = v.provideFunction_("subsequence" + He[H] + He[ee], `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(sequence${H === "FROM_END" || H === "FROM_START" ? ", at1" : ""}${ee === "FROM_END" || ee === "FROM_START" ? ", at2" : ""}) {
  var start = ${B("sequence", H, "at1")};
  var end = ${B("sequence", ee, "at2")} + 1;
  return sequence.slice(start, end);
}
`) + "(" + W + (H === "FROM_END" || H === "FROM_START" ? ", " + Me : "") + (ee === "FROM_END" || ee === "FROM_START" ? ", " + M : "") + ")";
        }
        return [W, k.FUNCTION_CALL];
      }, Ne = function(M, v) {
        const W = v.valueToCode(M, "LIST", k.FUNCTION_CALL) || "[]", H = M.getFieldValue("DIRECTION") === "1" ? 1 : -1;
        return M = M.getFieldValue("TYPE"), v = v.provideFunction_("listsGetSortCompare", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(type, direction) {
  var compareFuncs = {
    'NUMERIC': function(a, b) {
        return Number(a) - Number(b); },
    'TEXT': function(a, b) {
        return String(a) > String(b) ? 1 : -1; },
    'IGNORE_CASE': function(a, b) {
        return String(a).toLowerCase() > String(b).toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; };
}
      `), [W + ".slice().sort(" + v + '("' + M + '", ' + H + "))", k.FUNCTION_CALL];
      }, Fe = function(M, v) {
        let W = v.valueToCode(M, "INPUT", k.MEMBER);
        if (v = v.valueToCode(M, "DELIM", k.NONE) || "''", M = M.getFieldValue("MODE"), M === "SPLIT")
          W || (W = "''"), M = "split";
        else if (M === "JOIN")
          W || (W = "[]"), M = "join";
        else
          throw Error("Unknown mode: " + M);
        return [W + "." + M + "(" + v + ")", k.FUNCTION_CALL];
      }, at = function(M, v) {
        return [(v.valueToCode(M, "LIST", k.FUNCTION_CALL) || "[]") + ".slice().reverse()", k.FUNCTION_CALL];
      }, dr = function(M, v) {
        var W = 0;
        let H = "";
        v.STATEMENT_PREFIX && (H += v.injectId(v.STATEMENT_PREFIX, M));
        do {
          const ee = v.valueToCode(M, "IF" + W, k.NONE) || "false";
          let Me = v.statementToCode(M, "DO" + W);
          v.STATEMENT_SUFFIX && (Me = v.prefixLines(v.injectId(v.STATEMENT_SUFFIX, M), v.INDENT) + Me), H += (0 < W ? " else " : "") + "if (" + ee + `) {
` + Me + "}", W++;
        } while (M.getInput("IF" + W));
        return (M.getInput("ELSE") || v.STATEMENT_SUFFIX) && (W = v.statementToCode(M, "ELSE"), v.STATEMENT_SUFFIX && (W = v.prefixLines(v.injectId(
          v.STATEMENT_SUFFIX,
          M
        ), v.INDENT) + W), H += ` else {
` + W + "}"), H + `
`;
      }, er = function(M, v) {
        const W = { EQ: "==", NEQ: "!=", LT: "<", LTE: "<=", GT: ">", GTE: ">=" }[M.getFieldValue("OP")], H = W === "==" || W === "!=" ? k.EQUALITY : k.RELATIONAL, ee = v.valueToCode(M, "A", H) || "0";
        return M = v.valueToCode(M, "B", H) || "0", [ee + " " + W + " " + M, H];
      }, Ze = function(M, v) {
        const W = M.getFieldValue("OP") === "AND" ? "&&" : "||", H = W === "&&" ? k.LOGICAL_AND : k.LOGICAL_OR;
        let ee = v.valueToCode(M, "A", H);
        return M = v.valueToCode(M, "B", H), ee || M ? (v = W === "&&" ? "true" : "false", ee || (ee = v), M || (M = v)) : M = ee = "false", [ee + " " + W + " " + M, H];
      }, Pt = function(M, v) {
        const W = k.LOGICAL_NOT;
        return ["!" + (v.valueToCode(M, "BOOL", W) || "true"), W];
      }, wr = function(M, v) {
        return [M.getFieldValue("BOOL") === "TRUE" ? "true" : "false", k.ATOMIC];
      }, xn = function(M, v) {
        return ["null", k.ATOMIC];
      }, Dl = function(M, v) {
        const W = v.valueToCode(
          M,
          "IF",
          k.CONDITIONAL
        ) || "false", H = v.valueToCode(M, "THEN", k.CONDITIONAL) || "null";
        return M = v.valueToCode(M, "ELSE", k.CONDITIONAL) || "null", [W + " ? " + H + " : " + M, k.CONDITIONAL];
      }, si = function(M, v) {
        let W;
        W = M.getField("TIMES") ? String(Number(M.getFieldValue("TIMES"))) : v.valueToCode(M, "TIMES", k.ASSIGNMENT) || "0";
        let H = v.statementToCode(M, "DO");
        H = v.addLoopTrap(H, M), M = "";
        const ee = v.nameDB_.getDistinctName("count", o.NameType$$module$build$src$core$names.VARIABLE);
        let Me = W;
        return W.match(/^\w+$/) || o.isNumber$$module$build$src$core$utils$string(W) || (Me = v.nameDB_.getDistinctName("repeat_end", o.NameType$$module$build$src$core$names.VARIABLE), M += "var " + Me + " = " + W + `;
`), M + ("for (var " + ee + " = 0; " + ee + " < " + Me + "; " + ee + `++) {
` + H + `}
`);
      }, Yr = function(M, v) {
        const W = M.getFieldValue("MODE") === "UNTIL";
        let H = v.valueToCode(M, "BOOL", W ? k.LOGICAL_NOT : k.NONE) || "false", ee = v.statementToCode(M, "DO");
        return ee = v.addLoopTrap(ee, M), W && (H = "!" + H), "while (" + H + `) {
` + ee + `}
`;
      }, Er = function(M, v) {
        var W = v.nameDB_.getName(M.getFieldValue("VAR"), o.NameType$$module$build$src$core$names.VARIABLE), H = v.valueToCode(M, "FROM", k.ASSIGNMENT) || "0", ee = v.valueToCode(M, "TO", k.ASSIGNMENT) || "0";
        const Me = v.valueToCode(M, "BY", k.ASSIGNMENT) || "1";
        let He = v.statementToCode(M, "DO");
        if (He = v.addLoopTrap(He, M), o.isNumber$$module$build$src$core$utils$string(H) && o.isNumber$$module$build$src$core$utils$string(ee) && o.isNumber$$module$build$src$core$utils$string(Me))
          v = Number(H) <= Number(ee), M = "for (" + W + " = " + H + "; " + W + (v ? " <= " : " >= ") + ee + "; " + W, W = Math.abs(Number(Me)), M = W === 1 ? M + (v ? "++" : "--") : M + ((v ? " += " : " -= ") + W), M += `) {
` + He + `}
`;
        else {
          M = "";
          let rr = H;
          H.match(/^\w+$/) || o.isNumber$$module$build$src$core$utils$string(H) || (rr = v.nameDB_.getDistinctName(W + "_start", o.NameType$$module$build$src$core$names.VARIABLE), M += "var " + rr + " = " + H + `;
`), H = ee, ee.match(/^\w+$/) || o.isNumber$$module$build$src$core$utils$string(ee) || (H = v.nameDB_.getDistinctName(W + "_end", o.NameType$$module$build$src$core$names.VARIABLE), M += "var " + H + " = " + ee + `;
`), ee = v.nameDB_.getDistinctName(W + "_inc", o.NameType$$module$build$src$core$names.VARIABLE), M += "var " + ee + " = ", M = o.isNumber$$module$build$src$core$utils$string(Me) ? M + (Math.abs(Me) + `;
`) : M + ("Math.abs(" + Me + `);
`), M += "if (" + rr + " > " + H + `) {
`, M += v.INDENT + ee + " = -" + ee + `;
`, M = M + `}
for (` + (W + " = " + rr + "; " + ee + " >= 0 ? " + W + " <= " + H + " : " + W + " >= " + H + "; " + W + " += " + ee + `) {
` + He + `}
`);
        }
        return M;
      }, Dr = function(M, v) {
        const W = v.nameDB_.getName(M.getFieldValue("VAR"), o.NameType$$module$build$src$core$names.VARIABLE);
        var H = v.valueToCode(M, "LIST", k.ASSIGNMENT) || "[]";
        let ee = v.statementToCode(M, "DO");
        ee = v.addLoopTrap(ee, M), M = "";
        let Me = H;
        return H.match(/^\w+$/) || (Me = v.nameDB_.getDistinctName(
          W + "_list",
          o.NameType$$module$build$src$core$names.VARIABLE
        ), M += "var " + Me + " = " + H + `;
`), H = v.nameDB_.getDistinctName(W + "_index", o.NameType$$module$build$src$core$names.VARIABLE), ee = v.INDENT + W + " = " + Me + "[" + H + `];
` + ee, M + ("for (var " + H + " in " + Me + `) {
` + ee + `}
`);
      }, Ce = function(M, v) {
        let W = "";
        if (v.STATEMENT_PREFIX && (W += v.injectId(v.STATEMENT_PREFIX, M)), v.STATEMENT_SUFFIX && (W += v.injectId(v.STATEMENT_SUFFIX, M)), v.STATEMENT_PREFIX) {
          const H = M.getSurroundLoop();
          H && !H.suppressPrefixSuffix && (W += v.injectId(v.STATEMENT_PREFIX, H));
        }
        switch (M.getFieldValue("FLOW")) {
          case "BREAK":
            return W + `break;
`;
          case "CONTINUE":
            return W + `continue;
`;
        }
        throw Error("Unknown flow statement.");
      }, Ps = function(M, v) {
        return M = Number(M.getFieldValue("NUM")), [M, 0 <= M ? k.ATOMIC : k.UNARY_NEGATION];
      }, an = function(M, v) {
        var W = { ADD: [" + ", k.ADDITION], MINUS: [" - ", k.SUBTRACTION], MULTIPLY: [" * ", k.MULTIPLICATION], DIVIDE: [" / ", k.DIVISION], POWER: [null, k.NONE] }[M.getFieldValue("OP")];
        const H = W[0];
        W = W[1];
        const ee = v.valueToCode(M, "A", W) || "0";
        return M = v.valueToCode(M, "B", W) || "0", H ? [ee + H + M, W] : ["Math.pow(" + ee + ", " + M + ")", k.FUNCTION_CALL];
      }, Sr = function(M, v) {
        const W = M.getFieldValue("OP");
        let H;
        if (W === "NEG")
          return M = v.valueToCode(M, "NUM", k.UNARY_NEGATION) || "0", M[0] === "-" && (M = " " + M), ["-" + M, k.UNARY_NEGATION];
        switch (M = W === "SIN" || W === "COS" || W === "TAN" ? v.valueToCode(M, "NUM", k.DIVISION) || "0" : v.valueToCode(M, "NUM", k.NONE) || "0", W) {
          case "ABS":
            H = "Math.abs(" + M + ")";
            break;
          case "ROOT":
            H = "Math.sqrt(" + M + ")";
            break;
          case "LN":
            H = "Math.log(" + M + ")";
            break;
          case "EXP":
            H = "Math.exp(" + M + ")";
            break;
          case "POW10":
            H = "Math.pow(10," + M + ")";
            break;
          case "ROUND":
            H = "Math.round(" + M + ")";
            break;
          case "ROUNDUP":
            H = "Math.ceil(" + M + ")";
            break;
          case "ROUNDDOWN":
            H = "Math.floor(" + M + ")";
            break;
          case "SIN":
            H = "Math.sin(" + M + " / 180 * Math.PI)";
            break;
          case "COS":
            H = "Math.cos(" + M + " / 180 * Math.PI)";
            break;
          case "TAN":
            H = "Math.tan(" + M + " / 180 * Math.PI)";
        }
        if (H)
          return [H, k.FUNCTION_CALL];
        switch (W) {
          case "LOG10":
            H = "Math.log(" + M + ") / Math.log(10)";
            break;
          case "ASIN":
            H = "Math.asin(" + M + ") / Math.PI * 180";
            break;
          case "ACOS":
            H = "Math.acos(" + M + ") / Math.PI * 180";
            break;
          case "ATAN":
            H = "Math.atan(" + M + ") / Math.PI * 180";
            break;
          default:
            throw Error("Unknown math operator: " + W);
        }
        return [H, k.DIVISION];
      }, ao = function(M, v) {
        return {
          PI: ["Math.PI", k.MEMBER],
          E: ["Math.E", k.MEMBER],
          GOLDEN_RATIO: ["(1 + Math.sqrt(5)) / 2", k.DIVISION],
          SQRT2: ["Math.SQRT2", k.MEMBER],
          SQRT1_2: ["Math.SQRT1_2", k.MEMBER],
          INFINITY: ["Infinity", k.ATOMIC]
        }[M.getFieldValue("CONSTANT")];
      }, nt = function(M, v) {
        var W = { EVEN: [
          " % 2 === 0",
          k.MODULUS,
          k.EQUALITY
        ], ODD: [" % 2 === 1", k.MODULUS, k.EQUALITY], WHOLE: [" % 1 === 0", k.MODULUS, k.EQUALITY], POSITIVE: [
          " > 0",
          k.RELATIONAL,
          k.RELATIONAL
        ], NEGATIVE: [" < 0", k.RELATIONAL, k.RELATIONAL], DIVISIBLE_BY: [null, k.MODULUS, k.EQUALITY], PRIME: [
          null,
          k.NONE,
          k.FUNCTION_CALL
        ] };
        const H = M.getFieldValue("PROPERTY"), [ee, Me, He] = W[H];
        return W = v.valueToCode(M, "NUMBER_TO_CHECK", Me) || "0", H === "PRIME" ? M = v.provideFunction_("mathIsPrime", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(n) {
  // https://en.wikipedia.org/wiki/Primality_test#Naive_methods
  if (n == 2 || n == 3) {
    return true;
  }
  // False if n is NaN, negative, is 1, or not whole.
  // And false if n is divisible by 2 or 3.
  if (isNaN(n) || n <= 1 || n % 1 !== 0 || n % 2 === 0 || n % 3 === 0) {
    return false;
  }
  // Check all the numbers of form 6k +/- 1, up to sqrt(n).
  for (var x = 6; x <= Math.sqrt(n) + 1; x += 6) {
    if (n % (x - 1) === 0 || n % (x + 1) === 0) {
      return false;
    }
  }
  return true;
}
`) + "(" + W + ")" : H === "DIVISIBLE_BY" ? (M = v.valueToCode(M, "DIVISOR", k.MODULUS) || "0", M = W + " % " + M + " === 0") : M = W + ee, [M, He];
      }, Fr = function(M, v) {
        const W = v.valueToCode(M, "DELTA", k.ADDITION) || "0";
        return M = v.nameDB_.getName(M.getFieldValue("VAR"), o.NameType$$module$build$src$core$names.VARIABLE), M + " = (typeof " + M + " === 'number' ? " + M + " : 0) + " + W + `;
`;
      }, _o = function(M, v) {
        var W = M.getFieldValue("OP");
        switch (W) {
          case "SUM":
            M = v.valueToCode(M, "LIST", k.MEMBER) || "[]", M += ".reduce(function(x, y) {return x + y;}, 0)";
            break;
          case "MIN":
            M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = "Math.min.apply(null, " + M + ")";
            break;
          case "MAX":
            M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = "Math.max.apply(null, " + M + ")";
            break;
          case "AVERAGE":
            W = v.provideFunction_("mathMean", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(myList) {
  return myList.reduce(function(x, y) {return x + y;}, 0) / myList.length;
}
`), M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = W + "(" + M + ")";
            break;
          case "MEDIAN":
            W = v.provideFunction_("mathMedian", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(myList) {
  var localList = myList.filter(function (x) {return typeof x === 'number';});
  if (!localList.length) return null;
  localList.sort(function(a, b) {return b - a;});
  if (localList.length % 2 === 0) {
    return (localList[localList.length / 2 - 1] + localList[localList.length / 2]) / 2;
  } else {
    return localList[(localList.length - 1) / 2];
  }
}
`), M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = W + "(" + M + ")";
            break;
          case "MODE":
            W = v.provideFunction_("mathModes", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(values) {
  var modes = [];
  var counts = [];
  var maxCount = 0;
  for (var i = 0; i < values.length; i++) {
    var value = values[i];
    var found = false;
    var thisCount;
    for (var j = 0; j < counts.length; j++) {
      if (counts[j][0] === value) {
        thisCount = ++counts[j][1];
        found = true;
        break;
      }
    }
    if (!found) {
      counts.push([value, 1]);
      thisCount = 1;
    }
    maxCount = Math.max(thisCount, maxCount);
  }
  for (var j = 0; j < counts.length; j++) {
    if (counts[j][1] === maxCount) {
        modes.push(counts[j][0]);
    }
  }
  return modes;
}
`), M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = W + "(" + M + ")";
            break;
          case "STD_DEV":
            W = v.provideFunction_("mathStandardDeviation", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(numbers) {
  var n = numbers.length;
  if (!n) return null;
  var mean = numbers.reduce(function(x, y) {return x + y;}) / n;
  var variance = 0;
  for (var j = 0; j < n; j++) {
    variance += Math.pow(numbers[j] - mean, 2);
  }
  variance = variance / n;
  return Math.sqrt(variance);
}
`), M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = W + "(" + M + ")";
            break;
          case "RANDOM":
            W = v.provideFunction_("mathRandomList", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(list) {
  var x = Math.floor(Math.random() * list.length);
  return list[x];
}
`), M = v.valueToCode(M, "LIST", k.NONE) || "[]", M = W + "(" + M + ")";
            break;
          default:
            throw Error("Unknown operator: " + W);
        }
        return [M, k.FUNCTION_CALL];
      }, bl = function(M, v) {
        const W = v.valueToCode(M, "DIVIDEND", k.MODULUS) || "0";
        return M = v.valueToCode(M, "DIVISOR", k.MODULUS) || "0", [W + " % " + M, k.MODULUS];
      }, fe = function(M, v) {
        const W = v.valueToCode(M, "VALUE", k.NONE) || "0", H = v.valueToCode(M, "LOW", k.NONE) || "0";
        return M = v.valueToCode(M, "HIGH", k.NONE) || "Infinity", ["Math.min(Math.max(" + W + ", " + H + "), " + M + ")", k.FUNCTION_CALL];
      }, Hn = function(M, v) {
        const W = v.valueToCode(M, "FROM", k.NONE) || "0";
        return M = v.valueToCode(M, "TO", k.NONE) || "0", [v.provideFunction_("mathRandomInt", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}
`) + "(" + W + ", " + M + ")", k.FUNCTION_CALL];
      }, Yn = function(M, v) {
        return ["Math.random()", k.FUNCTION_CALL];
      }, Br = function(M, v) {
        const W = v.valueToCode(M, "X", k.NONE) || "0";
        return ["Math.atan2(" + (v.valueToCode(
          M,
          "Y",
          k.NONE
        ) || "0") + ", " + W + ") / Math.PI * 180", k.DIVISION];
      }, Xr = function(M, v) {
        const W = v.nameDB_.getName(M.getFieldValue("NAME"), o.NameType$$module$build$src$core$names.PROCEDURE);
        var H = "";
        v.STATEMENT_PREFIX && (H += v.injectId(v.STATEMENT_PREFIX, M)), v.STATEMENT_SUFFIX && (H += v.injectId(v.STATEMENT_SUFFIX, M)), H && (H = v.prefixLines(H, v.INDENT));
        let ee = "";
        v.INFINITE_LOOP_TRAP && (ee = v.prefixLines(v.injectId(v.INFINITE_LOOP_TRAP, M), v.INDENT));
        const Me = v.statementToCode(M, "STACK");
        let He = v.valueToCode(M, "RETURN", k.NONE) || "", rr = "";
        Me && He && (rr = H), He && (He = v.INDENT + "return " + He + `;
`);
        const Yo = [], ge = M.getVars();
        for (let Ir = 0; Ir < ge.length; Ir++)
          Yo[Ir] = v.nameDB_.getName(ge[Ir], o.NameType$$module$build$src$core$names.VARIABLE);
        return H = "function " + W + "(" + Yo.join(", ") + `) {
` + H + ee + Me + rr + He + "}", H = v.scrub_(M, H), v.definitions_["%" + W] = H, null;
      }, ai = function(M, v) {
        const W = v.nameDB_.getName(M.getFieldValue("NAME"), o.NameType$$module$build$src$core$names.PROCEDURE), H = [], ee = M.getVars();
        for (let Me = 0; Me < ee.length; Me++)
          H[Me] = v.valueToCode(M, "ARG" + Me, k.NONE) || "null";
        return [W + "(" + H.join(", ") + ")", k.FUNCTION_CALL];
      }, hr = function(M, v) {
        return v.forBlock.procedures_callreturn(M, v)[0] + `;
`;
      }, K = function(M, v) {
        let W = "if (" + (v.valueToCode(M, "CONDITION", k.NONE) || "false") + `) {
`;
        return v.STATEMENT_SUFFIX && (W += v.prefixLines(v.injectId(v.STATEMENT_SUFFIX, M), v.INDENT)), M.hasReturnValue_ ? (M = v.valueToCode(M, "VALUE", k.NONE) || "null", W += v.INDENT + "return " + M + `;
`) : W += v.INDENT + `return;
`, W + `}
`;
      }, Re = function(M, v) {
        return [v.quote_(M.getFieldValue("TEXT")), k.ATOMIC];
      }, co = function(M, v) {
        return M = v.multiline_quote_(M.getFieldValue("TEXT")), v = M.indexOf("+") !== -1 ? k.ADDITION : k.ATOMIC, [M, v];
      }, Ue = function(M, v) {
        switch (M.itemCount_) {
          case 0:
            return ["''", k.ATOMIC];
          case 1:
            return M = v.valueToCode(M, "ADD0", k.NONE) || "''", po(M);
          case 2:
            var W = v.valueToCode(M, "ADD0", k.NONE) || "''";
            return M = v.valueToCode(
              M,
              "ADD1",
              k.NONE
            ) || "''", [po(W)[0] + " + " + po(M)[0], k.ADDITION];
          default:
            W = Array(M.itemCount_);
            for (let H = 0; H < M.itemCount_; H++)
              W[H] = v.valueToCode(M, "ADD" + H, k.NONE) || "''";
            return [
              "[" + W.join(",") + "].join('')",
              k.FUNCTION_CALL
            ];
        }
      }, Di = function(M, v) {
        const W = v.nameDB_.getName(M.getFieldValue("VAR"), o.NameType$$module$build$src$core$names.VARIABLE);
        return M = v.valueToCode(M, "TEXT", k.NONE) || "''", W + " += " + po(M)[0] + `;
`;
      }, _t = function(M, v) {
        return [(v.valueToCode(M, "VALUE", k.MEMBER) || "''") + ".length", k.MEMBER];
      }, mr = function(M, v) {
        return ["!" + (v.valueToCode(M, "VALUE", k.MEMBER) || "''") + ".length", k.LOGICAL_NOT];
      }, xo = function(M, v) {
        const W = M.getFieldValue("END") === "FIRST" ? "indexOf" : "lastIndexOf", H = v.valueToCode(M, "FIND", k.NONE) || "''";
        return v = (v.valueToCode(M, "VALUE", k.MEMBER) || "''") + "." + W + "(" + H + ")", M.workspace.options.oneBasedIndex ? [v + " + 1", k.ADDITION] : [v, k.FUNCTION_CALL];
      }, bi = function(M, v) {
        const W = M.getFieldValue("WHERE") || "FROM_START", H = v.valueToCode(M, "VALUE", W === "RANDOM" ? k.NONE : k.MEMBER) || "''";
        switch (W) {
          case "FIRST":
            return [H + ".charAt(0)", k.FUNCTION_CALL];
          case "LAST":
            return [H + ".slice(-1)", k.FUNCTION_CALL];
          case "FROM_START":
            return M = v.getAdjusted(M, "AT"), [H + ".charAt(" + M + ")", k.FUNCTION_CALL];
          case "FROM_END":
            return M = v.getAdjusted(M, "AT", 1, !0), [H + ".slice(" + M + ").charAt(0)", k.FUNCTION_CALL];
          case "RANDOM":
            return [v.provideFunction_("textRandomLetter", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(text) {
  var x = Math.floor(Math.random() * text.length);
  return text[x];
}
`) + "(" + H + ")", k.FUNCTION_CALL];
        }
        throw Error("Unhandled option (text_charAt).");
      }, Ur = function(M, v) {
        var W = M.getFieldValue("WHERE1");
        const H = M.getFieldValue("WHERE2");
        var ee = W !== "FROM_END" && W !== "LAST" && H !== "FROM_END" && H !== "LAST", Me = v.valueToCode(M, "STRING", ee ? k.MEMBER : k.NONE) || "''";
        if (W === "FIRST" && H === "LAST")
          return [Me, k.NONE];
        if (Me.match(/^'?\w+'?$/) || ee) {
          switch (W) {
            case "FROM_START":
              W = v.getAdjusted(M, "AT1");
              break;
            case "FROM_END":
              W = v.getAdjusted(M, "AT1", 1, !1, k.SUBTRACTION), W = Me + ".length - " + W;
              break;
            case "FIRST":
              W = "0";
              break;
            default:
              throw Error("Unhandled option (text_getSubstring).");
          }
          switch (H) {
            case "FROM_START":
              v = v.getAdjusted(M, "AT2", 1);
              break;
            case "FROM_END":
              v = v.getAdjusted(M, "AT2", 0, !1, k.SUBTRACTION), v = Me + ".length - " + v;
              break;
            case "LAST":
              v = Me + ".length";
              break;
            default:
              throw Error("Unhandled option (text_getSubstring).");
          }
          Me = Me + ".slice(" + W + ", " + v + ")";
        } else {
          ee = v.getAdjusted(M, "AT1"), M = v.getAdjusted(M, "AT2");
          const He = { FIRST: "First", LAST: "Last", FROM_START: "FromStart", FROM_END: "FromEnd" };
          Me = v.provideFunction_("subsequence" + He[W] + He[H], `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(sequence${W === "FROM_END" || W === "FROM_START" ? ", at1" : ""}${H === "FROM_END" || H === "FROM_START" ? ", at2" : ""}) {
  var start = ${ki("sequence", W, "at1")};
  var end = ${ki("sequence", H, "at2")} + 1;
  return sequence.slice(start, end);
}
`) + "(" + Me + (W === "FROM_END" || W === "FROM_START" ? ", " + ee : "") + (H === "FROM_END" || H === "FROM_START" ? ", " + M : "") + ")";
        }
        return [Me, k.FUNCTION_CALL];
      }, tr = function(M, v) {
        const W = { UPPERCASE: ".toUpperCase()", LOWERCASE: ".toLowerCase()", TITLECASE: null }[M.getFieldValue("CASE")];
        return M = v.valueToCode(M, "TEXT", W ? k.MEMBER : k.NONE) || "''", [W ? M + W : v.provideFunction_("textToTitleCase", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(str) {
  return str.replace(/\\S+/g,
      function(txt) {return txt[0].toUpperCase() + txt.substring(1).toLowerCase();});
}
`) + "(" + M + ")", k.FUNCTION_CALL];
      }, Pi = function(M, v) {
        const W = { LEFT: ".replace(/^[\\s\\xa0]+/, '')", RIGHT: ".replace(/[\\s\\xa0]+$/, '')", BOTH: ".trim()" }[M.getFieldValue("MODE")];
        return [(v.valueToCode(M, "TEXT", k.MEMBER) || "''") + W, k.FUNCTION_CALL];
      }, Kr = function(M, v) {
        return "window.alert(" + (v.valueToCode(M, "TEXT", k.NONE) || "''") + `);
`;
      }, _i = function(M, v) {
        return v = "window.prompt(" + (M.getField("TEXT") ? v.quote_(M.getFieldValue("TEXT")) : v.valueToCode(M, "TEXT", k.NONE) || "''") + ")", M.getFieldValue("TYPE") === "NUMBER" && (v = "Number(" + v + ")"), [v, k.FUNCTION_CALL];
      }, Xn = function(M, v) {
        const W = v.valueToCode(M, "TEXT", k.NONE) || "''";
        return M = v.valueToCode(M, "SUB", k.NONE) || "''", [v.provideFunction_("textCount", `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(haystack, needle) {
  if (needle.length === 0) {
    return haystack.length + 1;
  } else {
    return haystack.split(needle).length - 1;
  }
}
`) + "(" + W + ", " + M + ")", k.FUNCTION_CALL];
      }, uo = function(M, v) {
        const W = v.valueToCode(M, "TEXT", k.NONE) || "''", H = v.valueToCode(M, "FROM", k.NONE) || "''";
        return M = v.valueToCode(M, "TO", k.NONE) || "''", [v.provideFunction_(
          "textReplace",
          `
function ${v.FUNCTION_NAME_PLACEHOLDER_}(haystack, needle, replacement) {
  needle = needle.replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g, '\\\\$1')
                 .replace(/\\x08/g, '\\\\x08');
  return haystack.replace(new RegExp(needle, 'g'), replacement);
}
`
        ) + "(" + W + ", " + H + ", " + M + ")", k.FUNCTION_CALL];
      }, $i = function(M, v) {
        return [(v.valueToCode(M, "TEXT", k.MEMBER) || "''") + ".split('').reverse().join('')", k.FUNCTION_CALL];
      }, jr = function(M, v) {
        return [v.nameDB_.getName(
          M.getFieldValue("VAR"),
          o.NameType$$module$build$src$core$names.VARIABLE
        ), k.ATOMIC];
      }, To = function(M, v) {
        const W = v.valueToCode(M, "VALUE", k.ASSIGNMENT) || "0";
        return v.nameDB_.getName(M.getFieldValue("VAR"), o.NameType$$module$build$src$core$names.VARIABLE) + " = " + W + `;
`;
      }, k = {
        ATOMIC: 0,
        NEW: 1.1,
        MEMBER: 1.2,
        FUNCTION_CALL: 2,
        INCREMENT: 3,
        DECREMENT: 3,
        BITWISE_NOT: 4.1,
        UNARY_PLUS: 4.2,
        UNARY_NEGATION: 4.3,
        LOGICAL_NOT: 4.4,
        TYPEOF: 4.5,
        VOID: 4.6,
        DELETE: 4.7,
        AWAIT: 4.8,
        EXPONENTIATION: 5,
        MULTIPLICATION: 5.1,
        DIVISION: 5.2,
        MODULUS: 5.3,
        SUBTRACTION: 6.1,
        ADDITION: 6.2,
        BITWISE_SHIFT: 7,
        RELATIONAL: 8,
        IN: 8,
        INSTANCEOF: 8,
        EQUALITY: 9,
        BITWISE_AND: 10,
        BITWISE_XOR: 11,
        BITWISE_OR: 12,
        LOGICAL_AND: 13,
        LOGICAL_OR: 14,
        CONDITIONAL: 15,
        ASSIGNMENT: 16,
        YIELD: 17,
        COMMA: 18,
        NONE: 99
      }, m = class extends o.CodeGenerator$$module$build$src$core$generator {
        constructor(M) {
          super(M ?? "JavaScript"), this.ORDER_OVERRIDES = [
            [k.FUNCTION_CALL, k.MEMBER],
            [k.FUNCTION_CALL, k.FUNCTION_CALL],
            [
              k.MEMBER,
              k.MEMBER
            ],
            [k.MEMBER, k.FUNCTION_CALL],
            [k.LOGICAL_NOT, k.LOGICAL_NOT],
            [k.MULTIPLICATION, k.MULTIPLICATION],
            [k.ADDITION, k.ADDITION],
            [k.LOGICAL_AND, k.LOGICAL_AND],
            [k.LOGICAL_OR, k.LOGICAL_OR]
          ], this.isInitialized = !1;
          for (const v in k)
            this["ORDER_" + v] = k[v];
          this.addReservedWords("break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,in,instanceof,new,return,super,switch,this,throw,try,typeof,var,void,while,with,yield,enum,implements,interface,let,package,private,protected,public,static,await,null,true,false,arguments," + Object.getOwnPropertyNames(globalThis).join(","));
        }
        init(M) {
          super.init(M), this.nameDB_ ? this.nameDB_.reset() : this.nameDB_ = new o.Names$$module$build$src$core$names(this.RESERVED_WORDS_), this.nameDB_.setVariableMap(M.getVariableMap()), this.nameDB_.populateVariables(M), this.nameDB_.populateProcedures(M);
          const v = [];
          var W = o.allDeveloperVariables$$module$build$src$core$variables(M);
          for (let H = 0; H < W.length; H++)
            v.push(this.nameDB_.getName(W[H], o.NameType$$module$build$src$core$names.DEVELOPER_VARIABLE));
          for (M = o.allUsedVarModels$$module$build$src$core$variables(M), W = 0; W < M.length; W++)
            v.push(this.nameDB_.getName(
              M[W].getId(),
              o.NameType$$module$build$src$core$names.VARIABLE
            ));
          v.length && (this.definitions_.variables = "var " + v.join(", ") + ";"), this.isInitialized = !0;
        }
        finish(M) {
          const v = Object.values(this.definitions_);
          return super.finish(M), this.isInitialized = !1, this.nameDB_.reset(), v.join(`

`) + `


` + M;
        }
        scrubNakedValue(M) {
          return M + `;
`;
        }
        quote_(M) {
          return M = M.replace(/\\/g, "\\\\").replace(/\n/g, `\\
`).replace(/'/g, "\\'"), "'" + M + "'";
        }
        multiline_quote_(M) {
          return M.split(/\n/g).map(this.quote_).join(` + '\\n' +
`);
        }
        scrub_(M, v, W) {
          let H = "";
          if (!M.outputConnection || !M.outputConnection.targetConnection) {
            var ee = M.getCommentText();
            ee && (ee = o.wrap$$module$build$src$core$utils$string(ee, this.COMMENT_WRAP - 3), H += this.prefixLines(ee + `
`, "// "));
            for (let Me = 0; Me < M.inputList.length; Me++)
              M.inputList[Me].type === o.inputTypes$$module$build$src$core$inputs$input_types.VALUE && (ee = M.inputList[Me].connection.targetBlock()) && (ee = this.allNestedComments(ee)) && (H += this.prefixLines(ee, "// "));
          }
          return M = M.nextConnection && M.nextConnection.targetBlock(), W = W ? "" : this.blockToCode(M), H + v + W;
        }
        getAdjusted(M, v, W, H, ee) {
          W = W || 0, ee = ee || this.ORDER_NONE, M.workspace.options.oneBasedIndex && W--;
          const Me = M.workspace.options.oneBasedIndex ? "1" : "0";
          let He, rr = ee;
          return 0 < W ? He = rr = this.ORDER_ADDITION : 0 > W ? He = rr = this.ORDER_SUBTRACTION : H && (He = rr = this.ORDER_UNARY_NEGATION), M = this.valueToCode(M, v, rr) || Me, o.isNumber$$module$build$src$core$utils$string(M) ? (M = Number(M) + W, H && (M = -M)) : (0 < W ? M = M + " + " + W : 0 > W && (M = M + " - " + -W), H && (M = W ? "-(" + M + ")" : "-" + M), He = Math.floor(He), ee = Math.floor(ee), He && ee >= He && (M = "(" + M + ")")), M;
        }
      }, D = {};
      D.colour_blend = h, D.colour_picker = c, D.colour_random = T, D.colour_rgb = d;
      var B = function(M, v, W) {
        return v === "FIRST" ? "0" : v === "FROM_END" ? M + ".length - 1 - " + W : v === "LAST" ? M + ".length - 1" : W;
      }, V = {};
      V.lists_create_empty = y, V.lists_create_with = b, V.lists_getIndex = be, V.lists_getSublist = ae, V.lists_indexOf = ue, V.lists_isEmpty = le, V.lists_length = Z, V.lists_repeat = U, V.lists_reverse = at, V.lists_setIndex = Ke, V.lists_sort = Ne, V.lists_split = Fe;
      var oe = {};
      oe.controls_if = dr, oe.controls_ifelse = dr, oe.logic_boolean = wr, oe.logic_compare = er, oe.logic_negate = Pt, oe.logic_null = xn, oe.logic_operation = Ze, oe.logic_ternary = Dl;
      var ke = {};
      ke.controls_flow_statements = Ce, ke.controls_for = Er, ke.controls_forEach = Dr, ke.controls_repeat = si, ke.controls_repeat_ext = si, ke.controls_whileUntil = Yr;
      var $t = {};
      $t.math_arithmetic = an, $t.math_atan2 = Br, $t.math_change = Fr, $t.math_constant = ao, $t.math_constrain = fe, $t.math_modulo = bl, $t.math_number = Ps, $t.math_number_property = nt, $t.math_on_list = _o, $t.math_random_float = Yn, $t.math_random_int = Hn, $t.math_round = Sr, $t.math_single = Sr, $t.math_trig = Sr;
      var Wi = {};
      Wi.procedures_callnoreturn = hr, Wi.procedures_callreturn = ai, Wi.procedures_defnoreturn = Xr, Wi.procedures_defreturn = Xr, Wi.procedures_ifreturn = K;
      var rc = /^\s*'([^']|\\')*'\s*$/, po = function(M) {
        return rc.test(M) ? [M, k.ATOMIC] : ["String(" + M + ")", k.FUNCTION_CALL];
      }, ki = function(M, v, W) {
        return v === "FIRST" ? "0" : v === "FROM_END" ? M + ".length - 1 - " + W : v === "LAST" ? M + ".length - 1" : W;
      }, Xt = {};
      Xt.text = Re, Xt.text_append = Di, Xt.text_changeCase = tr, Xt.text_charAt = bi, Xt.text_count = Xn, Xt.text_getSubstring = Ur, Xt.text_indexOf = xo, Xt.text_isEmpty = mr, Xt.text_join = Ue, Xt.text_length = _t, Xt.text_multiline = co, Xt.text_print = Kr, Xt.text_prompt = _i, Xt.text_prompt_ext = _i, Xt.text_replace = uo, Xt.text_reverse = $i, Xt.text_trim = Pi;
      var $s = {};
      $s.variables_get = jr, $s.variables_set = To;
      var Pl = {};
      Pl.variables_get_dynamic = jr, Pl.variables_set_dynamic = To;
      var Ws = new m();
      Object.assign(Ws.forBlock, D, V, oe, ke, $t, Wi, Xt, $s, Pl);
      var Ho = {};
      return Ho.JavascriptGenerator = m, Ho.Order = k, Ho.javascriptGenerator = Ws, Ho.__namespace__ = o, Ho;
    });
  }(ch)), ch.exports;
}
var Am;
function ZM() {
  return Am || (Am = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(SI(), JM());
    })(ln, function(r, o) {
      /**
       * @license
       * Copyright 2020 Google LLC
       * SPDX-License-Identifier: Apache-2.0
       */
      return o;
    });
  }(_h)), _h.exports;
}
var Sm;
function QM() {
  return Sm || (Sm = 1, function(i, l) {
    (function(r, o) {
      i.exports = o(SI(), KM(), zM(), ZM());
    })(ln, function(r, o, c, T) {
      return r.setLocale(o), r;
    });
  }(rh)), rh.exports;
}
(function(i, l) {
  (function(r, o) {
    i.exports = o(QM());
  })(ln, function(r) {
    /**
     * @license
     * Copyright 2019 Google LLC
     * SPDX-License-Identifier: Apache-2.0
     */
    return r;
  });
})(AI);
var X = AI.exports;
const N = /* @__PURE__ */ YM(X);
var TS = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
TS.exports;
(function(i, l) {
  (function() {
    var r, o = "4.17.21", c = 200, T = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", h = "Invalid `variable` option passed into `_.template`", y = "__lodash_hash_undefined__", b = 500, U = "__lodash_placeholder__", Z = 1, le = 2, ue = 4, be = 1, Ke = 2, ae = 1, Ne = 2, Fe = 4, at = 8, dr = 16, er = 32, Ze = 64, Pt = 128, wr = 256, xn = 512, Dl = 30, si = "...", Yr = 800, Er = 16, Dr = 1, Ce = 2, Ps = 3, an = 1 / 0, Sr = 9007199254740991, ao = 17976931348623157e292, nt = NaN, Fr = 4294967295, _o = Fr - 1, bl = Fr >>> 1, fe = [
      ["ary", Pt],
      ["bind", ae],
      ["bindKey", Ne],
      ["curry", at],
      ["curryRight", dr],
      ["flip", xn],
      ["partial", er],
      ["partialRight", Ze],
      ["rearg", wr]
    ], Hn = "[object Arguments]", Yn = "[object Array]", Br = "[object AsyncFunction]", Xr = "[object Boolean]", ai = "[object Date]", hr = "[object DOMException]", K = "[object Error]", Re = "[object Function]", co = "[object GeneratorFunction]", Ue = "[object Map]", Di = "[object Number]", _t = "[object Null]", mr = "[object Object]", xo = "[object Promise]", bi = "[object Proxy]", Ur = "[object RegExp]", tr = "[object Set]", Pi = "[object String]", Kr = "[object Symbol]", _i = "[object Undefined]", Xn = "[object WeakMap]", uo = "[object WeakSet]", $i = "[object ArrayBuffer]", jr = "[object DataView]", To = "[object Float32Array]", k = "[object Float64Array]", m = "[object Int8Array]", D = "[object Int16Array]", B = "[object Int32Array]", V = "[object Uint8Array]", oe = "[object Uint8ClampedArray]", ke = "[object Uint16Array]", $t = "[object Uint32Array]", Wi = /\b__p \+= '';/g, rc = /\b(__p \+=) '' \+/g, po = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ki = /&(?:amp|lt|gt|quot|#39);/g, Xt = /[&<>"']/g, $s = RegExp(ki.source), Pl = RegExp(Xt.source), Ws = /<%-([\s\S]+?)%>/g, Ho = /<%([\s\S]+?)%>/g, M = /<%=([\s\S]+?)%>/g, v = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, W = /^\w*$/, H = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ee = /[\\^$.*+?()[\]{}|]/g, Me = RegExp(ee.source), He = /^\s+/, rr = /\s/, Yo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ge = /\{\n\/\* \[wrapped with (.+)\] \*/, Ir = /,? & /, Mt = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ba = /[()=,{}\[\]\/\s]/, Xo = /\\(\\)?/g, $l = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, ks = /\w*$/, Kn = /^[-+]0x[0-9a-f]+$/i, dT = /^0b[01]+$/i, Pa = /^\[object .+?Constructor\]$/, Jd = /^0o[0-7]+$/i, ET = /^(?:0|[1-9]\d*)$/, wi = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ci = /($^)/, AT = /['\n\r\u2028\u2029\\]/g, ws = "\\ud800-\\udfff", nc = "\\u0300-\\u036f", ST = "\\ufe20-\\ufe2f", Wl = "\\u20d0-\\u20ff", $a = nc + ST + Wl, ic = "\\u2700-\\u27bf", oc = "a-z\\xdf-\\xf6\\xf8-\\xff", Zd = "\\xac\\xb1\\xd7\\xf7", Qd = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", hT = "\\u2000-\\u206f", Wa = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", mT = "A-Z\\xc0-\\xd6\\xd8-\\xde", IT = "\\ufe0e\\ufe0f", Eo = Zd + Qd + hT + Wa, ka = "['’]", Fi = "[" + ws + "]", MT = "[" + Eo + "]", wa = "[" + $a + "]", gT = "\\d+", LT = "[" + ic + "]", NT = "[" + oc + "]", yT = "[^" + ws + Eo + gT + ic + oc + mT + "]", lc = "\\ud83c[\\udffb-\\udfff]", qd = "(?:" + wa + "|" + lc + ")", fT = "[^" + ws + "]", Fa = "(?:\\ud83c[\\udde6-\\uddff]){2}", sc = "[\\ud800-\\udbff][\\udc00-\\udfff]", kl = "[" + mT + "]", Ba = "\\u200d", CT = "(?:" + NT + "|" + yT + ")", eE = "(?:" + kl + "|" + yT + ")", ac = "(?:" + ka + "(?:d|ll|m|re|s|t|ve))?", Ua = "(?:" + ka + "(?:D|LL|M|RE|S|T|VE))?", vT = qd + "?", ui = "[" + IT + "]?", tE = "(?:" + Ba + "(?:" + [fT, Fa, sc].join("|") + ")" + ui + vT + ")*", rE = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", nE = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", RT = ui + vT + tE, iE = "(?:" + [LT, Fa, sc].join("|") + ")" + RT, oE = "(?:" + [fT + wa + "?", wa, Fa, sc, Fi].join("|") + ")", lE = RegExp(ka, "g"), OT = RegExp(wa, "g"), Bi = RegExp(lc + "(?=" + lc + ")|" + oE + RT, "g"), _c = RegExp([
      kl + "?" + NT + "+" + ac + "(?=" + [MT, kl, "$"].join("|") + ")",
      eE + "+" + Ua + "(?=" + [MT, kl + CT, "$"].join("|") + ")",
      kl + "?" + CT + "+" + ac,
      kl + "+" + Ua,
      nE,
      rE,
      gT,
      iE
    ].join("|"), "g"), DT = RegExp("[" + Ba + ws + $a + IT + "]"), sE = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, aE = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], _E = -1, Wt = {};
    Wt[To] = Wt[k] = Wt[m] = Wt[D] = Wt[B] = Wt[V] = Wt[oe] = Wt[ke] = Wt[$t] = !0, Wt[Hn] = Wt[Yn] = Wt[$i] = Wt[Xr] = Wt[jr] = Wt[ai] = Wt[K] = Wt[Re] = Wt[Ue] = Wt[Di] = Wt[mr] = Wt[Ur] = Wt[tr] = Wt[Pi] = Wt[Xn] = !1;
    var Ot = {};
    Ot[Hn] = Ot[Yn] = Ot[$i] = Ot[jr] = Ot[Xr] = Ot[ai] = Ot[To] = Ot[k] = Ot[m] = Ot[D] = Ot[B] = Ot[Ue] = Ot[Di] = Ot[mr] = Ot[Ur] = Ot[tr] = Ot[Pi] = Ot[Kr] = Ot[V] = Ot[oe] = Ot[ke] = Ot[$t] = !0, Ot[K] = Ot[Re] = Ot[Xn] = !1;
    var cE = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, uE = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, TE = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, bT = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, pE = parseFloat, Ko = parseInt, PT = typeof ln == "object" && ln && ln.Object === Object && ln, dE = typeof self == "object" && self && self.Object === Object && self, fr = PT || dE || Function("return this")(), jo = l && !l.nodeType && l, Ao = jo && !0 && i && !i.nodeType && i, wl = Ao && Ao.exports === jo, Va = wl && PT.process, _n = function() {
      try {
        var x = Ao && Ao.require && Ao.require("util").types;
        return x || Va && Va.binding && Va.binding("util");
      } catch {
      }
    }(), cc = _n && _n.isArrayBuffer, Fl = _n && _n.isDate, Ga = _n && _n.isMap, xa = _n && _n.isRegExp, $T = _n && _n.isSet, Fs = _n && _n.isTypedArray;
    function zr(x, Q, j) {
      switch (j.length) {
        case 0:
          return x.call(Q);
        case 1:
          return x.call(Q, j[0]);
        case 2:
          return x.call(Q, j[0], j[1]);
        case 3:
          return x.call(Q, j[0], j[1], j[2]);
      }
      return x.apply(Q, j);
    }
    function WT(x, Q, j, Ie) {
      for (var Ve = -1, Et = x == null ? 0 : x.length; ++Ve < Et; ) {
        var cr = x[Ve];
        Q(Ie, cr, j(cr), x);
      }
      return Ie;
    }
    function cn(x, Q) {
      for (var j = -1, Ie = x == null ? 0 : x.length; ++j < Ie && Q(x[j], j, x) !== !1; )
        ;
      return x;
    }
    function kT(x, Q) {
      for (var j = x == null ? 0 : x.length; j-- && Q(x[j], j, x) !== !1; )
        ;
      return x;
    }
    function uc(x, Q) {
      for (var j = -1, Ie = x == null ? 0 : x.length; ++j < Ie; )
        if (!Q(x[j], j, x))
          return !1;
      return !0;
    }
    function Ui(x, Q) {
      for (var j = -1, Ie = x == null ? 0 : x.length, Ve = 0, Et = []; ++j < Ie; ) {
        var cr = x[j];
        Q(cr, j, x) && (Et[Ve++] = cr);
      }
      return Et;
    }
    function Ha(x, Q) {
      var j = x == null ? 0 : x.length;
      return !!j && Ul(x, Q, 0) > -1;
    }
    function Bl(x, Q, j) {
      for (var Ie = -1, Ve = x == null ? 0 : x.length; ++Ie < Ve; )
        if (j(Q, x[Ie]))
          return !0;
      return !1;
    }
    function kt(x, Q) {
      for (var j = -1, Ie = x == null ? 0 : x.length, Ve = Array(Ie); ++j < Ie; )
        Ve[j] = Q(x[j], j, x);
      return Ve;
    }
    function Rn(x, Q) {
      for (var j = -1, Ie = Q.length, Ve = x.length; ++j < Ie; )
        x[Ve + j] = Q[j];
      return x;
    }
    function Bs(x, Q, j, Ie) {
      var Ve = -1, Et = x == null ? 0 : x.length;
      for (Ie && Et && (j = x[++Ve]); ++Ve < Et; )
        j = Q(j, x[Ve], Ve, x);
      return j;
    }
    function Ti(x, Q, j, Ie) {
      var Ve = x == null ? 0 : x.length;
      for (Ie && Ve && (j = x[--Ve]); Ve--; )
        j = Q(j, x[Ve], Ve, x);
      return j;
    }
    function Ya(x, Q) {
      for (var j = -1, Ie = x == null ? 0 : x.length; ++j < Ie; )
        if (Q(x[j], j, x))
          return !0;
      return !1;
    }
    var wT = Ec("length");
    function EE(x) {
      return x.split("");
    }
    function Xa(x) {
      return x.match(Mt) || [];
    }
    function Tc(x, Q, j) {
      var Ie;
      return j(x, function(Ve, Et, cr) {
        if (Q(Ve, Et, cr))
          return Ie = Et, !1;
      }), Ie;
    }
    function Us(x, Q, j, Ie) {
      for (var Ve = x.length, Et = j + (Ie ? 1 : -1); Ie ? Et-- : ++Et < Ve; )
        if (Q(x[Et], Et, x))
          return Et;
      return -1;
    }
    function Ul(x, Q, j) {
      return Q === Q ? gc(x, Q, j) : Us(x, dc, j);
    }
    function pc(x, Q, j, Ie) {
      for (var Ve = j - 1, Et = x.length; ++Ve < Et; )
        if (Ie(x[Ve], Q))
          return Ve;
      return -1;
    }
    function dc(x) {
      return x !== x;
    }
    function FT(x, Q) {
      var j = x == null ? 0 : x.length;
      return j ? zo(x, Q) / j : nt;
    }
    function Ec(x) {
      return function(Q) {
        return Q == null ? r : Q[x];
      };
    }
    function Ac(x) {
      return function(Q) {
        return x == null ? r : x[Q];
      };
    }
    function BT(x, Q, j, Ie, Ve) {
      return Ve(x, function(Et, cr, Nt) {
        j = Ie ? (Ie = !1, Et) : Q(j, Et, cr, Nt);
      }), j;
    }
    function AE(x, Q) {
      var j = x.length;
      for (x.sort(Q); j--; )
        x[j] = x[j].value;
      return x;
    }
    function zo(x, Q) {
      for (var j, Ie = -1, Ve = x.length; ++Ie < Ve; ) {
        var Et = Q(x[Ie]);
        Et !== r && (j = j === r ? Et : j + Et);
      }
      return j;
    }
    function Ka(x, Q) {
      for (var j = -1, Ie = Array(x); ++j < x; )
        Ie[j] = Q(j);
      return Ie;
    }
    function UT(x, Q) {
      return kt(Q, function(j) {
        return [j, x[j]];
      });
    }
    function Vs(x) {
      return x && x.slice(0, za(x) + 1).replace(He, "");
    }
    function Jr(x) {
      return function(Q) {
        return x(Q);
      };
    }
    function Sc(x, Q) {
      return kt(Q, function(j) {
        return x[j];
      });
    }
    function Gs(x, Q) {
      return x.has(Q);
    }
    function hc(x, Q) {
      for (var j = -1, Ie = x.length; ++j < Ie && Ul(Q, x[j], 0) > -1; )
        ;
      return j;
    }
    function mc(x, Q) {
      for (var j = x.length; j-- && Ul(Q, x[j], 0) > -1; )
        ;
      return j;
    }
    function So(x, Q) {
      for (var j = x.length, Ie = 0; j--; )
        x[j] === Q && ++Ie;
      return Ie;
    }
    var VT = Ac(cE), GT = Ac(uE);
    function SE(x) {
      return "\\" + bT[x];
    }
    function hE(x, Q) {
      return x == null ? r : x[Q];
    }
    function Vl(x) {
      return DT.test(x);
    }
    function mE(x) {
      return sE.test(x);
    }
    function xT(x) {
      for (var Q, j = []; !(Q = x.next()).done; )
        j.push(Q.value);
      return j;
    }
    function Ic(x) {
      var Q = -1, j = Array(x.size);
      return x.forEach(function(Ie, Ve) {
        j[++Q] = [Ve, Ie];
      }), j;
    }
    function Mc(x, Q) {
      return function(j) {
        return x(Q(j));
      };
    }
    function ho(x, Q) {
      for (var j = -1, Ie = x.length, Ve = 0, Et = []; ++j < Ie; ) {
        var cr = x[j];
        (cr === Q || cr === U) && (x[j] = U, Et[Ve++] = j);
      }
      return Et;
    }
    function pi(x) {
      var Q = -1, j = Array(x.size);
      return x.forEach(function(Ie) {
        j[++Q] = Ie;
      }), j;
    }
    function ja(x) {
      var Q = -1, j = Array(x.size);
      return x.forEach(function(Ie) {
        j[++Q] = [Ie, Ie];
      }), j;
    }
    function gc(x, Q, j) {
      for (var Ie = j - 1, Ve = x.length; ++Ie < Ve; )
        if (x[Ie] === Q)
          return Ie;
      return -1;
    }
    function Lc(x, Q, j) {
      for (var Ie = j + 1; Ie--; )
        if (x[Ie] === Q)
          return Ie;
      return Ie;
    }
    function jn(x) {
      return Vl(x) ? Jt(x) : wT(x);
    }
    function On(x) {
      return Vl(x) ? Nc(x) : EE(x);
    }
    function za(x) {
      for (var Q = x.length; Q-- && rr.test(x.charAt(Q)); )
        ;
      return Q;
    }
    var HT = Ac(TE);
    function Jt(x) {
      for (var Q = Bi.lastIndex = 0; Bi.test(x); )
        ++Q;
      return Q;
    }
    function Nc(x) {
      return x.match(Bi) || [];
    }
    function xs(x) {
      return x.match(_c) || [];
    }
    var Gl = function x(Q) {
      Q = Q == null ? fr : xl.defaults(fr.Object(), Q, xl.pick(fr, aE));
      var j = Q.Array, Ie = Q.Date, Ve = Q.Error, Et = Q.Function, cr = Q.Math, Nt = Q.Object, yc = Q.RegExp, IE = Q.String, un = Q.TypeError, Vr = j.prototype, ME = Et.prototype, Hl = Nt.prototype, Tn = Q["__core-js_shared__"], gt = ME.toString, mt = Hl.hasOwnProperty, gE = 0, fc = function() {
        var a = /[^.]+$/.exec(Tn && Tn.keys && Tn.keys.IE_PROTO || "");
        return a ? "Symbol(src)_1." + a : "";
      }(), zn = Hl.toString, Cc = gt.call(Nt), LE = fr._, Ja = yc(
        "^" + gt.call(mt).replace(ee, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Yl = wl ? Q.Buffer : r, mo = Q.Symbol, Xl = Q.Uint8Array, YT = Yl ? Yl.allocUnsafe : r, Kl = Mc(Nt.getPrototypeOf, Nt), vc = Nt.create, Rc = Hl.propertyIsEnumerable, Za = Vr.splice, Oc = mo ? mo.isConcatSpreadable : r, Jo = mo ? mo.iterator : r, Zo = mo ? mo.toStringTag : r, Qa = function() {
        try {
          var a = ul(Nt, "defineProperty");
          return a({}, "", {}), a;
        } catch {
        }
      }(), NE = Q.clearTimeout !== fr.clearTimeout && Q.clearTimeout, XT = Ie && Ie.now !== fr.Date.now && Ie.now, Dc = Q.setTimeout !== fr.setTimeout && Q.setTimeout, Hs = cr.ceil, jl = cr.floor, bc = Nt.getOwnPropertySymbols, Pc = Yl ? Yl.isBuffer : r, KT = Q.isFinite, yE = Vr.join, pn = Mc(Nt.keys, Nt), Ee = cr.max, Lt = cr.min, br = Ie.now, wt = Q.parseInt, di = cr.random, Ys = Vr.reverse, Ae = ul(Q, "DataView"), Ft = ul(Q, "Map"), qa = ul(Q, "Promise"), zl = ul(Q, "Set"), Jl = ul(Q, "WeakMap"), Zl = ul(Nt, "create"), Xs = Jl && new Jl(), Qo = {}, jT = pl(Ae), zT = pl(Ft), Ks = pl(qa), js = pl(zl), JT = pl(Jl), e_ = mo ? mo.prototype : r, qo = e_ ? e_.valueOf : r, $c = e_ ? e_.toString : r;
      function R(a) {
        if (jt(a) && !$e(a) && !(a instanceof ot)) {
          if (a instanceof dn)
            return a;
          if (mt.call(a, "__wrapped__"))
            return Bp(a);
        }
        return new dn(a);
      }
      var el = /* @__PURE__ */ function() {
        function a() {
        }
        return function(_) {
          if (!Kt(_))
            return {};
          if (vc)
            return vc(_);
          a.prototype = _;
          var p = new a();
          return a.prototype = r, p;
        };
      }();
      function t_() {
      }
      function dn(a, _) {
        this.__wrapped__ = a, this.__actions__ = [], this.__chain__ = !!_, this.__index__ = 0, this.__values__ = r;
      }
      R.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Ws,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Ho,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: M,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: R
        }
      }, R.prototype = t_.prototype, R.prototype.constructor = R, dn.prototype = el(t_.prototype), dn.prototype.constructor = dn;
      function ot(a) {
        this.__wrapped__ = a, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Fr, this.__views__ = [];
      }
      function ZT() {
        var a = new ot(this.__wrapped__);
        return a.__actions__ = vr(this.__actions__), a.__dir__ = this.__dir__, a.__filtered__ = this.__filtered__, a.__iteratees__ = vr(this.__iteratees__), a.__takeCount__ = this.__takeCount__, a.__views__ = vr(this.__views__), a;
      }
      function QT() {
        if (this.__filtered__) {
          var a = new ot(this);
          a.__dir__ = -1, a.__filtered__ = !0;
        } else
          a = this.clone(), a.__dir__ *= -1;
        return a;
      }
      function r_() {
        var a = this.__wrapped__.value(), _ = this.__dir__, p = $e(a), S = _ < 0, g = p ? a.length : 0, O = YE(0, g, this.__views__), P = O.start, w = O.end, Y = w - P, ne = S ? w : P - 1, te = this.__iteratees__, se = te.length, Se = 0, ve = Lt(Y, this.__takeCount__);
        if (!p || !S && g == Y && ve == Y)
          return Gi(a, this.__actions__);
        var We = [];
        e:
          for (; Y-- && Se < ve; ) {
            ne += _;
            for (var qe = -1, we = a[ne]; ++qe < se; ) {
              var st = te[qe], ct = st.iteratee, yn = st.type, on = ct(we);
              if (yn == Ce)
                we = on;
              else if (!on) {
                if (yn == Dr)
                  continue e;
                break e;
              }
            }
            We[Se++] = we;
          }
        return We;
      }
      ot.prototype = el(t_.prototype), ot.prototype.constructor = ot;
      function tl(a) {
        var _ = -1, p = a == null ? 0 : a.length;
        for (this.clear(); ++_ < p; ) {
          var S = a[_];
          this.set(S[0], S[1]);
        }
      }
      function qT() {
        this.__data__ = Zl ? Zl(null) : {}, this.size = 0;
      }
      function Wc(a) {
        var _ = this.has(a) && delete this.__data__[a];
        return this.size -= _ ? 1 : 0, _;
      }
      function fE(a) {
        var _ = this.__data__;
        if (Zl) {
          var p = _[a];
          return p === y ? r : p;
        }
        return mt.call(_, a) ? _[a] : r;
      }
      function CE(a) {
        var _ = this.__data__;
        return Zl ? _[a] !== r : mt.call(_, a);
      }
      function ep(a, _) {
        var p = this.__data__;
        return this.size += this.has(a) ? 0 : 1, p[a] = Zl && _ === r ? y : _, this;
      }
      tl.prototype.clear = qT, tl.prototype.delete = Wc, tl.prototype.get = fE, tl.prototype.has = CE, tl.prototype.set = ep;
      function Dn(a) {
        var _ = -1, p = a == null ? 0 : a.length;
        for (this.clear(); ++_ < p; ) {
          var S = a[_];
          this.set(S[0], S[1]);
        }
      }
      function vE() {
        this.__data__ = [], this.size = 0;
      }
      function RE(a) {
        var _ = this.__data__, p = zs(_, a);
        if (p < 0)
          return !1;
        var S = _.length - 1;
        return p == S ? _.pop() : Za.call(_, p, 1), --this.size, !0;
      }
      function OE(a) {
        var _ = this.__data__, p = zs(_, a);
        return p < 0 ? r : _[p][1];
      }
      function DE(a) {
        return zs(this.__data__, a) > -1;
      }
      function n_(a, _) {
        var p = this.__data__, S = zs(p, a);
        return S < 0 ? (++this.size, p.push([a, _])) : p[S][1] = _, this;
      }
      Dn.prototype.clear = vE, Dn.prototype.delete = RE, Dn.prototype.get = OE, Dn.prototype.has = DE, Dn.prototype.set = n_;
      function Ei(a) {
        var _ = -1, p = a == null ? 0 : a.length;
        for (this.clear(); ++_ < p; ) {
          var S = a[_];
          this.set(S[0], S[1]);
        }
      }
      function tp() {
        this.size = 0, this.__data__ = {
          hash: new tl(),
          map: new (Ft || Dn)(),
          string: new tl()
        };
      }
      function rp(a) {
        var _ = ia(this, a).delete(a);
        return this.size -= _ ? 1 : 0, _;
      }
      function bE(a) {
        return ia(this, a).get(a);
      }
      function i_(a) {
        return ia(this, a).has(a);
      }
      function np(a, _) {
        var p = ia(this, a), S = p.size;
        return p.set(a, _), this.size += p.size == S ? 0 : 1, this;
      }
      Ei.prototype.clear = tp, Ei.prototype.delete = rp, Ei.prototype.get = bE, Ei.prototype.has = i_, Ei.prototype.set = np;
      function Jn(a) {
        var _ = -1, p = a == null ? 0 : a.length;
        for (this.__data__ = new Ei(); ++_ < p; )
          this.add(a[_]);
      }
      function PE(a) {
        return this.__data__.set(a, y), this;
      }
      function ip(a) {
        return this.__data__.has(a);
      }
      Jn.prototype.add = Jn.prototype.push = PE, Jn.prototype.has = ip;
      function bn(a) {
        var _ = this.__data__ = new Dn(a);
        this.size = _.size;
      }
      function op() {
        this.__data__ = new Dn(), this.size = 0;
      }
      function lp(a) {
        var _ = this.__data__, p = _.delete(a);
        return this.size = _.size, p;
      }
      function sp(a) {
        return this.__data__.get(a);
      }
      function ap(a) {
        return this.__data__.has(a);
      }
      function _p(a, _) {
        var p = this.__data__;
        if (p instanceof Dn) {
          var S = p.__data__;
          if (!Ft || S.length < c - 1)
            return S.push([a, _]), this.size = ++p.size, this;
          p = this.__data__ = new Ei(S);
        }
        return p.set(a, _), this.size = p.size, this;
      }
      bn.prototype.clear = op, bn.prototype.delete = lp, bn.prototype.get = sp, bn.prototype.has = ap, bn.prototype.set = _p;
      function kc(a, _) {
        var p = $e(a), S = !p && Sl(a), g = !p && !S && Mi(a), O = !p && !S && !g && hl(a), P = p || S || g || O, w = P ? Ka(a.length, IE) : [], Y = w.length;
        for (var ne in a)
          (_ || mt.call(a, ne)) && !(P && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ne == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          g && (ne == "offset" || ne == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          O && (ne == "buffer" || ne == "byteLength" || ne == "byteOffset") || // Skip index properties.
          Ki(ne, Y))) && w.push(ne);
        return w;
      }
      function o_(a) {
        var _ = a.length;
        return _ ? a[rs(0, _ - 1)] : r;
      }
      function l_(a, _) {
        return bo(vr(a), rl(_, 0, a.length));
      }
      function cp(a) {
        return bo(vr(a));
      }
      function wc(a, _, p) {
        (p !== r && !ft(a[_], p) || p === r && !(_ in a)) && Ai(a, _, p);
      }
      function Ql(a, _, p) {
        var S = a[_];
        (!(mt.call(a, _) && ft(S, p)) || p === r && !(_ in a)) && Ai(a, _, p);
      }
      function zs(a, _) {
        for (var p = a.length; p--; )
          if (ft(a[p][0], _))
            return p;
        return -1;
      }
      function up(a, _, p, S) {
        return Io(a, function(g, O, P) {
          _(S, g, p(g), P);
        }), S;
      }
      function Fc(a, _) {
        return a && Sn(_, ar(_), a);
      }
      function Tp(a, _) {
        return a && Sn(_, xr(_), a);
      }
      function Ai(a, _, p) {
        _ == "__proto__" && Qa ? Qa(a, _, {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        }) : a[_] = p;
      }
      function s_(a, _) {
        for (var p = -1, S = _.length, g = j(S), O = a == null; ++p < S; )
          g[p] = O ? r : La(a, _[p]);
        return g;
      }
      function rl(a, _, p) {
        return a === a && (p !== r && (a = a <= p ? a : p), _ !== r && (a = a >= _ ? a : _)), a;
      }
      function En(a, _, p, S, g, O) {
        var P, w = _ & Z, Y = _ & le, ne = _ & ue;
        if (p && (P = g ? p(a, S, g, O) : p(a)), P !== r)
          return P;
        if (!Kt(a))
          return a;
        var te = $e(a);
        if (te) {
          if (P = kS(a), !w)
            return vr(a, P);
        } else {
          var se = Rr(a), Se = se == Re || se == co;
          if (Mi(a))
            return ns(a, w);
          if (se == mr || se == Hn || Se && !g) {
            if (P = Y || Se ? {} : KE(a), !w)
              return Y ? WS(a, Tp(P, a)) : xE(a, Fc(P, a));
          } else {
            if (!Ot[se])
              return g ? a : {};
            P = $p(a, se, w);
          }
        }
        O || (O = new bn());
        var ve = O.get(a);
        if (ve)
          return ve;
        O.set(a, P), Du(a) ? a.forEach(function(we) {
          P.add(En(we, _, p, we, a, O));
        }) : Sa(a) && a.forEach(function(we, st) {
          P.set(st, En(we, _, p, st, a, O));
        });
        var We = ne ? Y ? tu : bp : Y ? xr : ar, qe = te ? r : We(a);
        return cn(qe || a, function(we, st) {
          qe && (st = we, we = a[st]), Ql(P, st, En(we, _, p, st, a, O));
        }), P;
      }
      function nl(a) {
        var _ = ar(a);
        return function(p) {
          return a_(p, a, _);
        };
      }
      function a_(a, _, p) {
        var S = p.length;
        if (a == null)
          return !S;
        for (a = Nt(a); S--; ) {
          var g = p[S], O = _[g], P = a[g];
          if (P === r && !(g in a) || !O(P))
            return !1;
        }
        return !0;
      }
      function __(a, _, p) {
        if (typeof a != "function")
          throw new un(d);
        return Tl(function() {
          a.apply(r, p);
        }, _);
      }
      function ql(a, _, p, S) {
        var g = -1, O = Ha, P = !0, w = a.length, Y = [], ne = _.length;
        if (!w)
          return Y;
        p && (_ = kt(_, Jr(p))), S ? (O = Bl, P = !1) : _.length >= c && (O = Gs, P = !1, _ = new Jn(_));
        e:
          for (; ++g < w; ) {
            var te = a[g], se = p == null ? te : p(te);
            if (te = S || te !== 0 ? te : 0, P && se === se) {
              for (var Se = ne; Se--; )
                if (_[Se] === se)
                  continue e;
              Y.push(te);
            } else
              O(_, se, S) || Y.push(te);
          }
        return Y;
      }
      var Io = ls(Zn), Bc = ls(c_, !0);
      function Uc(a, _) {
        var p = !0;
        return Io(a, function(S, g, O) {
          return p = !!_(S, g, O), p;
        }), p;
      }
      function Js(a, _, p) {
        for (var S = -1, g = a.length; ++S < g; ) {
          var O = a[S], P = _(O);
          if (P != null && (w === r ? P === P && !rn(P) : p(P, w)))
            var w = P, Y = O;
        }
        return Y;
      }
      function pp(a, _, p, S) {
        var g = a.length;
        for (p = ze(p), p < 0 && (p = -p > g ? 0 : g + p), S = S === r || S > g ? g : ze(S), S < 0 && (S += g), S = p > S ? 0 : Pu(S); p < S; )
          a[p++] = _;
        return a;
      }
      function dp(a, _) {
        var p = [];
        return Io(a, function(S, g, O) {
          _(S, g, O) && p.push(S);
        }), p;
      }
      function Mr(a, _, p, S, g) {
        var O = -1, P = a.length;
        for (p || (p = la), g || (g = []); ++O < P; ) {
          var w = a[O];
          _ > 0 && p(w) ? _ > 1 ? Mr(w, _ - 1, p, S, g) : Rn(g, w) : S || (g[g.length] = w);
        }
        return g;
      }
      var Vc = A_(), Gc = A_(!0);
      function Zn(a, _) {
        return a && Vc(a, _, ar);
      }
      function c_(a, _) {
        return a && Gc(a, _, ar);
      }
      function es(a, _) {
        return Ui(_, function(p) {
          return gi(a[p]);
        });
      }
      function Mo(a, _) {
        _ = Wn(_, a);
        for (var p = 0, S = _.length; a != null && p < S; )
          a = a[In(_[p++])];
        return p && p == S ? a : r;
      }
      function u_(a, _, p) {
        var S = _(a);
        return $e(a) ? S : Rn(S, p(a));
      }
      function Cr(a) {
        return a == null ? a === r ? _i : _t : Zo && Zo in Nt(a) ? HE(a) : Oo(a);
      }
      function Zs(a, _) {
        return a > _;
      }
      function $E(a, _) {
        return a != null && mt.call(a, _);
      }
      function WE(a, _) {
        return a != null && _ in Nt(a);
      }
      function kE(a, _, p) {
        return a >= Lt(_, p) && a < Ee(_, p);
      }
      function xc(a, _, p) {
        for (var S = p ? Bl : Ha, g = a[0].length, O = a.length, P = O, w = j(O), Y = 1 / 0, ne = []; P--; ) {
          var te = a[P];
          P && _ && (te = kt(te, Jr(_))), Y = Lt(te.length, Y), w[P] = !p && (_ || g >= 120 && te.length >= 120) ? new Jn(P && te) : r;
        }
        te = a[0];
        var se = -1, Se = w[0];
        e:
          for (; ++se < g && ne.length < Y; ) {
            var ve = te[se], We = _ ? _(ve) : ve;
            if (ve = p || ve !== 0 ? ve : 0, !(Se ? Gs(Se, We) : S(ne, We, p))) {
              for (P = O; --P; ) {
                var qe = w[P];
                if (!(qe ? Gs(qe, We) : S(a[P], We, p)))
                  continue e;
              }
              Se && Se.push(We), ne.push(ve);
            }
          }
        return ne;
      }
      function wE(a, _, p, S) {
        return Zn(a, function(g, O, P) {
          _(S, p(g), O, P);
        }), S;
      }
      function Qs(a, _, p) {
        _ = Wn(_, a), a = kp(a, _);
        var S = a == null ? a : a[In(Mn(_))];
        return S == null ? r : zr(S, a, p);
      }
      function Ep(a) {
        return jt(a) && Cr(a) == Hn;
      }
      function FE(a) {
        return jt(a) && Cr(a) == $i;
      }
      function Ap(a) {
        return jt(a) && Cr(a) == ai;
      }
      function ts(a, _, p, S, g) {
        return a === _ ? !0 : a == null || _ == null || !jt(a) && !jt(_) ? a !== a && _ !== _ : Sp(a, _, p, S, ts, g);
      }
      function Sp(a, _, p, S, g, O) {
        var P = $e(a), w = $e(_), Y = P ? Yn : Rr(a), ne = w ? Yn : Rr(_);
        Y = Y == Hn ? mr : Y, ne = ne == Hn ? mr : ne;
        var te = Y == mr, se = ne == mr, Se = Y == ne;
        if (Se && Mi(a)) {
          if (!Mi(_))
            return !1;
          P = !0, te = !1;
        }
        if (Se && !te)
          return O || (O = new bn()), P || hl(a) ? Te(a, _, p, S, g, O) : Hi(a, _, Y, p, S, g, O);
        if (!(p & be)) {
          var ve = te && mt.call(a, "__wrapped__"), We = se && mt.call(_, "__wrapped__");
          if (ve || We) {
            var qe = ve ? a.value() : a, we = We ? _.value() : _;
            return O || (O = new bn()), g(qe, we, p, S, O);
          }
        }
        return Se ? (O || (O = new bn()), Yi(a, _, p, S, g, O)) : !1;
      }
      function hp(a) {
        return jt(a) && Rr(a) == Ue;
      }
      function Hc(a, _, p, S) {
        var g = p.length, O = g, P = !S;
        if (a == null)
          return !O;
        for (a = Nt(a); g--; ) {
          var w = p[g];
          if (P && w[2] ? w[1] !== a[w[0]] : !(w[0] in a))
            return !1;
        }
        for (; ++g < O; ) {
          w = p[g];
          var Y = w[0], ne = a[Y], te = w[1];
          if (P && w[2]) {
            if (ne === r && !(Y in a))
              return !1;
          } else {
            var se = new bn();
            if (S)
              var Se = S(ne, te, Y, a, _, se);
            if (!(Se === r ? ts(te, ne, be | Ke, S, se) : Se))
              return !1;
          }
        }
        return !0;
      }
      function mp(a) {
        if (!Kt(a) || jE(a))
          return !1;
        var _ = gi(a) ? Ja : Pa;
        return _.test(pl(a));
      }
      function Ip(a) {
        return jt(a) && Cr(a) == Ur;
      }
      function Mp(a) {
        return jt(a) && Rr(a) == tr;
      }
      function gp(a) {
        return jt(a) && ie(a.length) && !!Wt[Cr(a)];
      }
      function Yc(a) {
        return typeof a == "function" ? a : a == null ? Ct : typeof a == "object" ? $e(a) ? yp(a[0], a[1]) : Np(a) : Rd(a);
      }
      function T_(a) {
        if (!cs(a))
          return pn(a);
        var _ = [];
        for (var p in Nt(a))
          mt.call(a, p) && p != "constructor" && _.push(p);
        return _;
      }
      function Lp(a) {
        if (!Kt(a))
          return zE(a);
        var _ = cs(a), p = [];
        for (var S in a)
          S == "constructor" && (_ || !mt.call(a, S)) || p.push(S);
        return p;
      }
      function p_(a, _) {
        return a < _;
      }
      function Xc(a, _) {
        var p = -1, S = sr(a) ? j(a.length) : [];
        return Io(a, function(g, O, P) {
          S[++p] = _(g, O, P);
        }), S;
      }
      function Np(a) {
        var _ = ru(a);
        return _.length == 1 && _[0][2] ? lu(_[0][0], _[0][1]) : function(p) {
          return p === a || Hc(p, a, _);
        };
      }
      function yp(a, _) {
        return M_(a) && ou(_) ? lu(In(a), _) : function(p) {
          var S = La(p, a);
          return S === r && S === _ ? F_(p, a) : ts(_, S, be | Ke);
        };
      }
      function Oe(a, _, p, S, g) {
        a !== _ && Vc(_, function(O, P) {
          if (g || (g = new bn()), Kt(O))
            An(a, _, P, p, Oe, S, g);
          else {
            var w = S ? S(Do(a, P), O, P + "", a, _, g) : r;
            w === r && (w = O), wc(a, P, w);
          }
        }, xr);
      }
      function An(a, _, p, S, g, O, P) {
        var w = Do(a, p), Y = Do(_, p), ne = P.get(Y);
        if (ne) {
          wc(a, p, ne);
          return;
        }
        var te = O ? O(w, Y, p + "", a, _, P) : r, se = te === r;
        if (se) {
          var Se = $e(Y), ve = !Se && Mi(Y), We = !Se && !ve && hl(Y);
          te = Y, Se || ve || We ? $e(w) ? te = w : Qt(w) ? te = vr(w) : ve ? (se = !1, te = ns(Y, !0)) : We ? (se = !1, te = d_(Y, !0)) : te = [] : ma(Y) || Sl(Y) ? (te = w, Sl(w) ? te = $u(w) : (!Kt(w) || gi(w)) && (te = KE(Y))) : se = !1;
        }
        se && (P.set(Y, te), g(te, Y, S, O, P), P.delete(Y)), wc(a, p, te);
      }
      function go(a, _) {
        var p = a.length;
        if (p)
          return _ += _ < 0 ? p : 0, Ki(_, p) ? a[_] : r;
      }
      function BE(a, _, p) {
        _.length ? _ = kt(_, function(O) {
          return $e(O) ? function(P) {
            return Mo(P, O.length === 1 ? O[0] : O);
          } : O;
        }) : _ = [Ct];
        var S = -1;
        _ = kt(_, Jr(Pe()));
        var g = Xc(a, function(O, P, w) {
          var Y = kt(_, function(ne) {
            return ne(O);
          });
          return { criteria: Y, index: ++S, value: O };
        });
        return AE(g, function(O, P) {
          return Jc(O, P, p);
        });
      }
      function Kc(a, _) {
        return Vi(a, _, function(p, S) {
          return F_(a, S);
        });
      }
      function Vi(a, _, p) {
        for (var S = -1, g = _.length, O = {}; ++S < g; ) {
          var P = _[S], w = Mo(a, P);
          p(w, P) && nr(O, Wn(P, a), w);
        }
        return O;
      }
      function _e(a) {
        return function(_) {
          return Mo(_, a);
        };
      }
      function Pn(a, _, p, S) {
        var g = S ? pc : Ul, O = -1, P = _.length, w = a;
        for (a === _ && (_ = vr(_)), p && (w = kt(a, Jr(p))); ++O < P; )
          for (var Y = 0, ne = _[O], te = p ? p(ne) : ne; (Y = g(w, te, Y, S)) > -1; )
            w !== a && Za.call(w, Y, 1), Za.call(a, Y, 1);
        return a;
      }
      function Zr(a, _) {
        for (var p = a ? _.length : 0, S = p - 1; p--; ) {
          var g = _[p];
          if (p == S || g !== O) {
            var O = g;
            Ki(g) ? Za.call(a, g, 1) : ta(a, g);
          }
        }
        return a;
      }
      function rs(a, _) {
        return a + jl(di() * (_ - a + 1));
      }
      function UE(a, _, p, S) {
        for (var g = -1, O = Ee(Hs((_ - a) / (p || 1)), 0), P = j(O); O--; )
          P[S ? O : ++g] = a, a += p;
        return P;
      }
      function jc(a, _) {
        var p = "";
        if (!a || _ < 1 || _ > Sr)
          return p;
        do
          _ % 2 && (p += a), _ = jl(_ / 2), _ && (a += a);
        while (_);
        return p;
      }
      function rt(a, _) {
        return wp(Wp(a, _, Ct), a + "");
      }
      function qs(a) {
        return o_(gl(a));
      }
      function VE(a, _) {
        var p = gl(a);
        return bo(p, rl(_, 0, p.length));
      }
      function nr(a, _, p, S) {
        if (!Kt(a))
          return a;
        _ = Wn(_, a);
        for (var g = -1, O = _.length, P = O - 1, w = a; w != null && ++g < O; ) {
          var Y = In(_[g]), ne = p;
          if (Y === "__proto__" || Y === "constructor" || Y === "prototype")
            return a;
          if (g != P) {
            var te = w[Y];
            ne = S ? S(te, Y, w) : r, ne === r && (ne = Kt(te) ? te : Ki(_[g + 1]) ? [] : {});
          }
          Ql(w, Y, ne), w = w[Y];
        }
        return a;
      }
      var fp = Xs ? function(a, _) {
        return Xs.set(a, _), a;
      } : Ct, GE = Qa ? function(a, _) {
        return Qa(a, "toString", {
          configurable: !0,
          enumerable: !1,
          value: fi(_),
          writable: !0
        });
      } : Ct;
      function $S(a) {
        return bo(gl(a));
      }
      function Qr(a, _, p) {
        var S = -1, g = a.length;
        _ < 0 && (_ = -_ > g ? 0 : g + _), p = p > g ? g : p, p < 0 && (p += g), g = _ > p ? 0 : p - _ >>> 0, _ >>>= 0;
        for (var O = j(g); ++S < g; )
          O[S] = a[S + _];
        return O;
      }
      function Cp(a, _) {
        var p;
        return Io(a, function(S, g, O) {
          return p = _(S, g, O), !p;
        }), !!p;
      }
      function Lo(a, _, p) {
        var S = 0, g = a == null ? S : a.length;
        if (typeof _ == "number" && _ === _ && g <= bl) {
          for (; S < g; ) {
            var O = S + g >>> 1, P = a[O];
            P !== null && !rn(P) && (p ? P <= _ : P < _) ? S = O + 1 : g = O;
          }
          return g;
        }
        return ea(a, _, Ct, p);
      }
      function ea(a, _, p, S) {
        var g = 0, O = a == null ? 0 : a.length;
        if (O === 0)
          return 0;
        _ = p(_);
        for (var P = _ !== _, w = _ === null, Y = rn(_), ne = _ === r; g < O; ) {
          var te = jl((g + O) / 2), se = p(a[te]), Se = se !== r, ve = se === null, We = se === se, qe = rn(se);
          if (P)
            var we = S || We;
          else
            ne ? we = We && (S || Se) : w ? we = We && Se && (S || !ve) : Y ? we = We && Se && !ve && (S || !qe) : ve || qe ? we = !1 : we = S ? se <= _ : se < _;
          we ? g = te + 1 : O = te;
        }
        return Lt(O, _o);
      }
      function No(a, _) {
        for (var p = -1, S = a.length, g = 0, O = []; ++p < S; ) {
          var P = a[p], w = _ ? _(P) : P;
          if (!p || !ft(w, Y)) {
            var Y = w;
            O[g++] = P === 0 ? 0 : P;
          }
        }
        return O;
      }
      function yo(a) {
        return typeof a == "number" ? a : rn(a) ? nt : +a;
      }
      function gr(a) {
        if (typeof a == "string")
          return a;
        if ($e(a))
          return kt(a, gr) + "";
        if (rn(a))
          return $c ? $c.call(a) : "";
        var _ = a + "";
        return _ == "0" && 1 / a == -an ? "-0" : _;
      }
      function $n(a, _, p) {
        var S = -1, g = Ha, O = a.length, P = !0, w = [], Y = w;
        if (p)
          P = !1, g = Bl;
        else if (O >= c) {
          var ne = _ ? null : Op(a);
          if (ne)
            return pi(ne);
          P = !1, g = Gs, Y = new Jn();
        } else
          Y = _ ? [] : w;
        e:
          for (; ++S < O; ) {
            var te = a[S], se = _ ? _(te) : te;
            if (te = p || te !== 0 ? te : 0, P && se === se) {
              for (var Se = Y.length; Se--; )
                if (Y[Se] === se)
                  continue e;
              _ && Y.push(se), w.push(te);
            } else
              g(Y, se, p) || (Y !== w && Y.push(se), w.push(te));
          }
        return w;
      }
      function ta(a, _) {
        return _ = Wn(_, a), a = kp(a, _), a == null || delete a[In(Mn(_))];
      }
      function il(a, _, p, S) {
        return nr(a, _, p(Mo(a, _)), S);
      }
      function Qn(a, _, p, S) {
        for (var g = a.length, O = S ? g : -1; (S ? O-- : ++O < g) && _(a[O], O, a); )
          ;
        return p ? Qr(a, S ? 0 : O, S ? O + 1 : g) : Qr(a, S ? O + 1 : 0, S ? g : O);
      }
      function Gi(a, _) {
        var p = a;
        return p instanceof ot && (p = p.value()), Bs(_, function(S, g) {
          return g.func.apply(g.thisArg, Rn([S], g.args));
        }, p);
      }
      function ol(a, _, p) {
        var S = a.length;
        if (S < 2)
          return S ? $n(a[0]) : [];
        for (var g = -1, O = j(S); ++g < S; )
          for (var P = a[g], w = -1; ++w < S; )
            w != g && (O[g] = ql(O[g] || P, a[w], _, p));
        return $n(Mr(O, 1), _, p);
      }
      function Si(a, _, p) {
        for (var S = -1, g = a.length, O = _.length, P = {}; ++S < g; ) {
          var w = S < O ? _[S] : r;
          p(P, a[S], w);
        }
        return P;
      }
      function ll(a) {
        return Qt(a) ? a : [];
      }
      function sl(a) {
        return typeof a == "function" ? a : Ct;
      }
      function Wn(a, _) {
        return $e(a) ? a : M_(a, _) ? [a] : Fp(St(a));
      }
      var al = rt;
      function qr(a, _, p) {
        var S = a.length;
        return p = p === r ? S : p, !_ && p >= S ? a : Qr(a, _, p);
      }
      var _l = NE || function(a) {
        return fr.clearTimeout(a);
      };
      function ns(a, _) {
        if (_)
          return a.slice();
        var p = a.length, S = YT ? YT(p) : new a.constructor(p);
        return a.copy(S), S;
      }
      function qn(a) {
        var _ = new a.constructor(a.byteLength);
        return new Xl(_).set(new Xl(a)), _;
      }
      function is(a, _) {
        var p = _ ? qn(a.buffer) : a.buffer;
        return new a.constructor(p, a.byteOffset, a.byteLength);
      }
      function zc(a) {
        var _ = new a.constructor(a.source, ks.exec(a));
        return _.lastIndex = a.lastIndex, _;
      }
      function os(a) {
        return qo ? Nt(qo.call(a)) : {};
      }
      function d_(a, _) {
        var p = _ ? qn(a.buffer) : a.buffer;
        return new a.constructor(p, a.byteOffset, a.length);
      }
      function Ye(a, _) {
        if (a !== _) {
          var p = a !== r, S = a === null, g = a === a, O = rn(a), P = _ !== r, w = _ === null, Y = _ === _, ne = rn(_);
          if (!w && !ne && !O && a > _ || O && P && Y && !w && !ne || S && P && Y || !p && Y || !g)
            return 1;
          if (!S && !O && !ne && a < _ || ne && p && g && !S && !O || w && p && g || !P && g || !Y)
            return -1;
        }
        return 0;
      }
      function Jc(a, _, p) {
        for (var S = -1, g = a.criteria, O = _.criteria, P = g.length, w = p.length; ++S < P; ) {
          var Y = Ye(g[S], O[S]);
          if (Y) {
            if (S >= w)
              return Y;
            var ne = p[S];
            return Y * (ne == "desc" ? -1 : 1);
          }
        }
        return a.index - _.index;
      }
      function Zc(a, _, p, S) {
        for (var g = -1, O = a.length, P = p.length, w = -1, Y = _.length, ne = Ee(O - P, 0), te = j(Y + ne), se = !S; ++w < Y; )
          te[w] = _[w];
        for (; ++g < P; )
          (se || g < O) && (te[p[g]] = a[g]);
        for (; ne--; )
          te[w++] = a[g++];
        return te;
      }
      function E_(a, _, p, S) {
        for (var g = -1, O = a.length, P = -1, w = p.length, Y = -1, ne = _.length, te = Ee(O - w, 0), se = j(te + ne), Se = !S; ++g < te; )
          se[g] = a[g];
        for (var ve = g; ++Y < ne; )
          se[ve + Y] = _[Y];
        for (; ++P < w; )
          (Se || g < O) && (se[ve + p[P]] = a[g++]);
        return se;
      }
      function vr(a, _) {
        var p = -1, S = a.length;
        for (_ || (_ = j(S)); ++p < S; )
          _[p] = a[p];
        return _;
      }
      function Sn(a, _, p, S) {
        var g = !p;
        p || (p = {});
        for (var O = -1, P = _.length; ++O < P; ) {
          var w = _[O], Y = S ? S(p[w], a[w], w, p, a) : r;
          Y === r && (Y = a[w]), g ? Ai(p, w, Y) : Ql(p, w, Y);
        }
        return p;
      }
      function xE(a, _) {
        return Sn(a, oa(a), _);
      }
      function WS(a, _) {
        return Sn(a, I_(a), _);
      }
      function xi(a, _) {
        return function(p, S) {
          var g = $e(p) ? WT : up, O = _ ? _() : {};
          return g(p, a, Pe(S, 2), O);
        };
      }
      function Lr(a) {
        return rt(function(_, p) {
          var S = -1, g = p.length, O = g > 1 ? p[g - 1] : r, P = g > 2 ? p[2] : r;
          for (O = a.length > 3 && typeof O == "function" ? (g--, O) : r, P && Pr(p[0], p[1], P) && (O = g < 3 ? r : O, g = 1), _ = Nt(_); ++S < g; ) {
            var w = p[S];
            w && a(_, w, S, O);
          }
          return _;
        });
      }
      function ls(a, _) {
        return function(p, S) {
          if (p == null)
            return p;
          if (!sr(p))
            return a(p, S);
          for (var g = p.length, O = _ ? g : -1, P = Nt(p); (_ ? O-- : ++O < g) && S(P[O], O, P) !== !1; )
            ;
          return p;
        };
      }
      function A_(a) {
        return function(_, p, S) {
          for (var g = -1, O = Nt(_), P = S(_), w = P.length; w--; ) {
            var Y = P[a ? w : ++g];
            if (p(O[Y], Y, O) === !1)
              break;
          }
          return _;
        };
      }
      function fo(a, _, p) {
        var S = _ & ae, g = en(a);
        function O() {
          var P = this && this !== fr && this instanceof O ? g : a;
          return P.apply(S ? p : this, arguments);
        }
        return O;
      }
      function kn(a) {
        return function(_) {
          _ = St(_);
          var p = Vl(_) ? On(_) : r, S = p ? p[0] : _.charAt(0), g = p ? qr(p, 1).join("") : _.slice(1);
          return S[a]() + g;
        };
      }
      function hn(a) {
        return function(_) {
          return Bs(wo(ii(_).replace(lE, "")), a, "");
        };
      }
      function en(a) {
        return function() {
          var _ = arguments;
          switch (_.length) {
            case 0:
              return new a();
            case 1:
              return new a(_[0]);
            case 2:
              return new a(_[0], _[1]);
            case 3:
              return new a(_[0], _[1], _[2]);
            case 4:
              return new a(_[0], _[1], _[2], _[3]);
            case 5:
              return new a(_[0], _[1], _[2], _[3], _[4]);
            case 6:
              return new a(_[0], _[1], _[2], _[3], _[4], _[5]);
            case 7:
              return new a(_[0], _[1], _[2], _[3], _[4], _[5], _[6]);
          }
          var p = el(a.prototype), S = a.apply(p, _);
          return Kt(S) ? S : p;
        };
      }
      function vp(a, _, p) {
        var S = en(a);
        function g() {
          for (var O = arguments.length, P = j(O), w = O, Y = Co(g); w--; )
            P[w] = arguments[w];
          var ne = O < 3 && P[0] !== Y && P[O - 1] !== Y ? [] : ho(P, Y);
          if (O -= ne.length, O < p)
            return as(
              a,
              _,
              It,
              g.placeholder,
              r,
              P,
              ne,
              r,
              r,
              p - O
            );
          var te = this && this !== fr && this instanceof g ? S : a;
          return zr(te, this, P);
        }
        return g;
      }
      function S_(a) {
        return function(_, p, S) {
          var g = Nt(_);
          if (!sr(_)) {
            var O = Pe(p, 3);
            _ = ar(_), p = function(w) {
              return O(g[w], w, g);
            };
          }
          var P = a(_, p, S);
          return P > -1 ? g[O ? _[P] : P] : r;
        };
      }
      function ur(a) {
        return mi(function(_) {
          var p = _.length, S = p, g = dn.prototype.thru;
          for (a && _.reverse(); S--; ) {
            var O = _[S];
            if (typeof O != "function")
              throw new un(d);
            if (g && !P && Xi(O) == "wrapper")
              var P = new dn([], !0);
          }
          for (S = P ? S : p; ++S < p; ) {
            O = _[S];
            var w = Xi(O), Y = w == "wrapper" ? na(O) : r;
            Y && iu(Y[0]) && Y[1] == (Pt | at | er | wr) && !Y[4].length && Y[9] == 1 ? P = P[Xi(Y[0])].apply(P, Y[3]) : P = O.length == 1 && iu(O) ? P[w]() : P.thru(O);
          }
          return function() {
            var ne = arguments, te = ne[0];
            if (P && ne.length == 1 && $e(te))
              return P.plant(te).value();
            for (var se = 0, Se = p ? _[se].apply(this, ne) : te; ++se < p; )
              Se = _[se].call(this, Se);
            return Se;
          };
        });
      }
      function It(a, _, p, S, g, O, P, w, Y, ne) {
        var te = _ & Pt, se = _ & ae, Se = _ & Ne, ve = _ & (at | dr), We = _ & xn, qe = Se ? r : en(a);
        function we() {
          for (var st = arguments.length, ct = j(st), yn = st; yn--; )
            ct[yn] = arguments[yn];
          if (ve)
            var on = Co(we), fn = So(ct, on);
          if (S && (ct = Zc(ct, S, g, ve)), O && (ct = E_(ct, O, P, ve)), st -= fn, ve && st < ne) {
            var pr = ho(ct, on);
            return as(
              a,
              _,
              It,
              we.placeholder,
              p,
              ct,
              pr,
              w,
              Y,
              ne - st
            );
          }
          var vi = se ? p : this, Fo = Se ? vi[a] : a;
          return st = ct.length, w ? ct = wS(ct, w) : We && st > 1 && ct.reverse(), te && Y < st && (ct.length = Y), this && this !== fr && this instanceof we && (Fo = qe || en(Fo)), Fo.apply(vi, ct);
        }
        return we;
      }
      function Rp(a, _) {
        return function(p, S) {
          return wE(p, a, _(S), {});
        };
      }
      function h_(a, _) {
        return function(p, S) {
          var g;
          if (p === r && S === r)
            return _;
          if (p !== r && (g = p), S !== r) {
            if (g === r)
              return S;
            typeof p == "string" || typeof S == "string" ? (p = gr(p), S = gr(S)) : (p = yo(p), S = yo(S)), g = a(p, S);
          }
          return g;
        };
      }
      function Qc(a) {
        return mi(function(_) {
          return _ = kt(_, Jr(Pe())), rt(function(p) {
            var S = this;
            return a(_, function(g) {
              return zr(g, S, p);
            });
          });
        });
      }
      function m_(a, _) {
        _ = _ === r ? " " : gr(_);
        var p = _.length;
        if (p < 2)
          return p ? jc(_, a) : _;
        var S = jc(_, Hs(a / jn(_)));
        return Vl(_) ? qr(On(S), 0, a).join("") : S.slice(0, a);
      }
      function cl(a, _, p, S) {
        var g = _ & ae, O = en(a);
        function P() {
          for (var w = -1, Y = arguments.length, ne = -1, te = S.length, se = j(te + Y), Se = this && this !== fr && this instanceof P ? O : a; ++ne < te; )
            se[ne] = S[ne];
          for (; Y--; )
            se[ne++] = arguments[++w];
          return zr(Se, g ? p : this, se);
        }
        return P;
      }
      function qc(a) {
        return function(_, p, S) {
          return S && typeof S != "number" && Pr(_, p, S) && (p = S = r), _ = Ni(_), p === r ? (p = _, _ = 0) : p = Ni(p), S = S === r ? _ < p ? 1 : -1 : Ni(S), UE(_, p, S, a);
        };
      }
      function ss(a) {
        return function(_, p) {
          return typeof _ == "string" && typeof p == "string" || (_ = Nn(_), p = Nn(p)), a(_, p);
        };
      }
      function as(a, _, p, S, g, O, P, w, Y, ne) {
        var te = _ & at, se = te ? P : r, Se = te ? r : P, ve = te ? O : r, We = te ? r : O;
        _ |= te ? er : Ze, _ &= ~(te ? Ze : er), _ & Fe || (_ &= ~(ae | Ne));
        var qe = [
          a,
          _,
          g,
          ve,
          se,
          We,
          Se,
          w,
          Y,
          ne
        ], we = p.apply(r, qe);
        return iu(a) && Tr(we, qe), we.placeholder = S, $r(we, a, _);
      }
      function _s(a) {
        var _ = cr[a];
        return function(p, S) {
          if (p = Nn(p), S = S == null ? 0 : Lt(ze(S), 292), S && KT(p)) {
            var g = (St(p) + "e").split("e"), O = _(g[0] + "e" + (+g[1] + S));
            return g = (St(O) + "e").split("e"), +(g[0] + "e" + (+g[1] - S));
          }
          return _(p);
        };
      }
      var Op = zl && 1 / pi(new zl([, -0]))[1] == an ? function(a) {
        return new zl(a);
      } : Yu;
      function ra(a) {
        return function(_) {
          var p = Rr(_);
          return p == Ue ? Ic(_) : p == tr ? ja(_) : UT(_, a(_));
        };
      }
      function hi(a, _, p, S, g, O, P, w) {
        var Y = _ & Ne;
        if (!Y && typeof a != "function")
          throw new un(d);
        var ne = S ? S.length : 0;
        if (ne || (_ &= ~(er | Ze), S = g = r), P = P === r ? P : Ee(ze(P), 0), w = w === r ? w : ze(w), ne -= g ? g.length : 0, _ & Ze) {
          var te = S, se = g;
          S = g = r;
        }
        var Se = Y ? r : na(a), ve = [
          a,
          _,
          p,
          S,
          g,
          te,
          se,
          O,
          P,
          w
        ];
        if (Se && G(ve, Se), a = ve[0], _ = ve[1], p = ve[2], S = ve[3], g = ve[4], w = ve[9] = ve[9] === r ? Y ? 0 : a.length : Ee(ve[9] - ne, 0), !w && _ & (at | dr) && (_ &= ~(at | dr)), !_ || _ == ae)
          var We = fo(a, _, p);
        else
          _ == at || _ == dr ? We = vp(a, _, w) : (_ == er || _ == (ae | er)) && !g.length ? We = cl(a, _, p, S) : We = It.apply(r, ve);
        var qe = Se ? fp : Tr;
        return $r(qe(We, ve), a, _);
      }
      function eu(a, _, p, S) {
        return a === r || ft(a, Hl[p]) && !mt.call(S, p) ? _ : a;
      }
      function Dp(a, _, p, S, g, O) {
        return Kt(a) && Kt(_) && (O.set(_, a), Oe(a, _, r, Dp, O), O.delete(_)), a;
      }
      function Ar(a) {
        return ma(a) ? r : a;
      }
      function Te(a, _, p, S, g, O) {
        var P = p & be, w = a.length, Y = _.length;
        if (w != Y && !(P && Y > w))
          return !1;
        var ne = O.get(a), te = O.get(_);
        if (ne && te)
          return ne == _ && te == a;
        var se = -1, Se = !0, ve = p & Ke ? new Jn() : r;
        for (O.set(a, _), O.set(_, a); ++se < w; ) {
          var We = a[se], qe = _[se];
          if (S)
            var we = P ? S(qe, We, se, _, a, O) : S(We, qe, se, a, _, O);
          if (we !== r) {
            if (we)
              continue;
            Se = !1;
            break;
          }
          if (ve) {
            if (!Ya(_, function(st, ct) {
              if (!Gs(ve, ct) && (We === st || g(We, st, p, S, O)))
                return ve.push(ct);
            })) {
              Se = !1;
              break;
            }
          } else if (!(We === qe || g(We, qe, p, S, O))) {
            Se = !1;
            break;
          }
        }
        return O.delete(a), O.delete(_), Se;
      }
      function Hi(a, _, p, S, g, O, P) {
        switch (p) {
          case jr:
            if (a.byteLength != _.byteLength || a.byteOffset != _.byteOffset)
              return !1;
            a = a.buffer, _ = _.buffer;
          case $i:
            return !(a.byteLength != _.byteLength || !O(new Xl(a), new Xl(_)));
          case Xr:
          case ai:
          case Di:
            return ft(+a, +_);
          case K:
            return a.name == _.name && a.message == _.message;
          case Ur:
          case Pi:
            return a == _ + "";
          case Ue:
            var w = Ic;
          case tr:
            var Y = S & be;
            if (w || (w = pi), a.size != _.size && !Y)
              return !1;
            var ne = P.get(a);
            if (ne)
              return ne == _;
            S |= Ke, P.set(a, _);
            var te = Te(w(a), w(_), S, g, O, P);
            return P.delete(a), te;
          case Kr:
            if (qo)
              return qo.call(a) == qo.call(_);
        }
        return !1;
      }
      function Yi(a, _, p, S, g, O) {
        var P = p & be, w = bp(a), Y = w.length, ne = bp(_), te = ne.length;
        if (Y != te && !P)
          return !1;
        for (var se = Y; se--; ) {
          var Se = w[se];
          if (!(P ? Se in _ : mt.call(_, Se)))
            return !1;
        }
        var ve = O.get(a), We = O.get(_);
        if (ve && We)
          return ve == _ && We == a;
        var qe = !0;
        O.set(a, _), O.set(_, a);
        for (var we = P; ++se < Y; ) {
          Se = w[se];
          var st = a[Se], ct = _[Se];
          if (S)
            var yn = P ? S(ct, st, Se, _, a, O) : S(st, ct, Se, a, _, O);
          if (!(yn === r ? st === ct || g(st, ct, p, S, O) : yn)) {
            qe = !1;
            break;
          }
          we || (we = Se == "constructor");
        }
        if (qe && !we) {
          var on = a.constructor, fn = _.constructor;
          on != fn && "constructor" in a && "constructor" in _ && !(typeof on == "function" && on instanceof on && typeof fn == "function" && fn instanceof fn) && (qe = !1);
        }
        return O.delete(a), O.delete(_), qe;
      }
      function mi(a) {
        return wp(Wp(a, r, me), a + "");
      }
      function bp(a) {
        return u_(a, ar, oa);
      }
      function tu(a) {
        return u_(a, xr, I_);
      }
      var na = Xs ? function(a) {
        return Xs.get(a);
      } : Yu;
      function Xi(a) {
        for (var _ = a.name + "", p = Qo[_], S = mt.call(Qo, _) ? p.length : 0; S--; ) {
          var g = p[S], O = g.func;
          if (O == null || O == a)
            return g.name;
        }
        return _;
      }
      function Co(a) {
        var _ = mt.call(R, "placeholder") ? R : a;
        return _.placeholder;
      }
      function Pe() {
        var a = R.iteratee || Gu;
        return a = a === Gu ? Yc : a, arguments.length ? a(arguments[0], arguments[1]) : a;
      }
      function ia(a, _) {
        var p = a.__data__;
        return vo(_) ? p[typeof _ == "string" ? "string" : "hash"] : p.map;
      }
      function ru(a) {
        for (var _ = ar(a), p = _.length; p--; ) {
          var S = _[p], g = a[S];
          _[p] = [S, g, ou(g)];
        }
        return _;
      }
      function ul(a, _) {
        var p = hE(a, _);
        return mp(p) ? p : r;
      }
      function HE(a) {
        var _ = mt.call(a, Zo), p = a[Zo];
        try {
          a[Zo] = r;
          var S = !0;
        } catch {
        }
        var g = zn.call(a);
        return S && (_ ? a[Zo] = p : delete a[Zo]), g;
      }
      var oa = bc ? function(a) {
        return a == null ? [] : (a = Nt(a), Ui(bc(a), function(_) {
          return Rc.call(a, _);
        }));
      } : Xu, I_ = bc ? function(a) {
        for (var _ = []; a; )
          Rn(_, oa(a)), a = Kl(a);
        return _;
      } : Xu, Rr = Cr;
      (Ae && Rr(new Ae(new ArrayBuffer(1))) != jr || Ft && Rr(new Ft()) != Ue || qa && Rr(qa.resolve()) != xo || zl && Rr(new zl()) != tr || Jl && Rr(new Jl()) != Xn) && (Rr = function(a) {
        var _ = Cr(a), p = _ == mr ? a.constructor : r, S = p ? pl(p) : "";
        if (S)
          switch (S) {
            case jT:
              return jr;
            case zT:
              return Ue;
            case Ks:
              return xo;
            case js:
              return tr;
            case JT:
              return Xn;
          }
        return _;
      });
      function YE(a, _, p) {
        for (var S = -1, g = p.length; ++S < g; ) {
          var O = p[S], P = O.size;
          switch (O.type) {
            case "drop":
              a += P;
              break;
            case "dropRight":
              _ -= P;
              break;
            case "take":
              _ = Lt(_, a + P);
              break;
            case "takeRight":
              a = Ee(a, _ - P);
              break;
          }
        }
        return { start: a, end: _ };
      }
      function XE(a) {
        var _ = a.match(ge);
        return _ ? _[1].split(Ir) : [];
      }
      function Pp(a, _, p) {
        _ = Wn(_, a);
        for (var S = -1, g = _.length, O = !1; ++S < g; ) {
          var P = In(_[S]);
          if (!(O = a != null && p(a, P)))
            break;
          a = a[P];
        }
        return O || ++S != g ? O : (g = a == null ? 0 : a.length, !!g && ie(g) && Ki(P, g) && ($e(a) || Sl(a)));
      }
      function kS(a) {
        var _ = a.length, p = new a.constructor(_);
        return _ && typeof a[0] == "string" && mt.call(a, "index") && (p.index = a.index, p.input = a.input), p;
      }
      function KE(a) {
        return typeof a.constructor == "function" && !cs(a) ? el(Kl(a)) : {};
      }
      function $p(a, _, p) {
        var S = a.constructor;
        switch (_) {
          case $i:
            return qn(a);
          case Xr:
          case ai:
            return new S(+a);
          case jr:
            return is(a, p);
          case To:
          case k:
          case m:
          case D:
          case B:
          case V:
          case oe:
          case ke:
          case $t:
            return d_(a, p);
          case Ue:
            return new S();
          case Di:
          case Pi:
            return new S(a);
          case Ur:
            return zc(a);
          case tr:
            return new S();
          case Kr:
            return os(a);
        }
      }
      function nu(a, _) {
        var p = _.length;
        if (!p)
          return a;
        var S = p - 1;
        return _[S] = (p > 1 ? "& " : "") + _[S], _ = _.join(p > 2 ? ", " : " "), a.replace(Yo, `{
/* [wrapped with ` + _ + `] */
`);
      }
      function la(a) {
        return $e(a) || Sl(a) || !!(Oc && a && a[Oc]);
      }
      function Ki(a, _) {
        var p = typeof a;
        return _ = _ ?? Sr, !!_ && (p == "number" || p != "symbol" && ET.test(a)) && a > -1 && a % 1 == 0 && a < _;
      }
      function Pr(a, _, p) {
        if (!Kt(p))
          return !1;
        var S = typeof _;
        return (S == "number" ? sr(p) && Ki(_, p.length) : S == "string" && _ in p) ? ft(p[_], a) : !1;
      }
      function M_(a, _) {
        if ($e(a))
          return !1;
        var p = typeof a;
        return p == "number" || p == "symbol" || p == "boolean" || a == null || rn(a) ? !0 : W.test(a) || !v.test(a) || _ != null && a in Nt(_);
      }
      function vo(a) {
        var _ = typeof a;
        return _ == "string" || _ == "number" || _ == "symbol" || _ == "boolean" ? a !== "__proto__" : a === null;
      }
      function iu(a) {
        var _ = Xi(a), p = R[_];
        if (typeof p != "function" || !(_ in ot.prototype))
          return !1;
        if (a === p)
          return !0;
        var S = na(p);
        return !!S && a === S[0];
      }
      function jE(a) {
        return !!fc && fc in a;
      }
      var Ro = Tn ? gi : Ku;
      function cs(a) {
        var _ = a && a.constructor, p = typeof _ == "function" && _.prototype || Hl;
        return a === p;
      }
      function ou(a) {
        return a === a && !Kt(a);
      }
      function lu(a, _) {
        return function(p) {
          return p == null ? !1 : p[a] === _ && (_ !== r || a in Nt(p));
        };
      }
      function yt(a) {
        var _ = Or(a, function(S) {
          return p.size === b && p.clear(), S;
        }), p = _.cache;
        return _;
      }
      function G(a, _) {
        var p = a[1], S = _[1], g = p | S, O = g < (ae | Ne | Pt), P = S == Pt && p == at || S == Pt && p == wr && a[7].length <= _[8] || S == (Pt | wr) && _[7].length <= _[8] && p == at;
        if (!(O || P))
          return a;
        S & ae && (a[2] = _[2], g |= p & ae ? 0 : Fe);
        var w = _[3];
        if (w) {
          var Y = a[3];
          a[3] = Y ? Zc(Y, w, _[4]) : w, a[4] = Y ? ho(a[3], U) : _[4];
        }
        return w = _[5], w && (Y = a[5], a[5] = Y ? E_(Y, w, _[6]) : w, a[6] = Y ? ho(a[5], U) : _[6]), w = _[7], w && (a[7] = w), S & Pt && (a[8] = a[8] == null ? _[8] : Lt(a[8], _[8])), a[9] == null && (a[9] = _[9]), a[0] = _[0], a[1] = g, a;
      }
      function zE(a) {
        var _ = [];
        if (a != null)
          for (var p in Nt(a))
            _.push(p);
        return _;
      }
      function Oo(a) {
        return zn.call(a);
      }
      function Wp(a, _, p) {
        return _ = Ee(_ === r ? a.length - 1 : _, 0), function() {
          for (var S = arguments, g = -1, O = Ee(S.length - _, 0), P = j(O); ++g < O; )
            P[g] = S[_ + g];
          g = -1;
          for (var w = j(_ + 1); ++g < _; )
            w[g] = S[g];
          return w[_] = p(P), zr(a, this, w);
        };
      }
      function kp(a, _) {
        return _.length < 2 ? a : Mo(a, Qr(_, 0, -1));
      }
      function wS(a, _) {
        for (var p = a.length, S = Lt(_.length, p), g = vr(a); S--; ) {
          var O = _[S];
          a[S] = Ki(O, p) ? g[O] : r;
        }
        return a;
      }
      function Do(a, _) {
        if (!(_ === "constructor" && typeof a[_] == "function") && _ != "__proto__")
          return a[_];
      }
      var Tr = mn(fp), Tl = Dc || function(a, _) {
        return fr.setTimeout(a, _);
      }, wp = mn(GE);
      function $r(a, _, p) {
        var S = _ + "";
        return wp(a, nu(S, JE(XE(S), p)));
      }
      function mn(a) {
        var _ = 0, p = 0;
        return function() {
          var S = br(), g = Er - (S - p);
          if (p = S, g > 0) {
            if (++_ >= Yr)
              return arguments[0];
          } else
            _ = 0;
          return a.apply(r, arguments);
        };
      }
      function bo(a, _) {
        var p = -1, S = a.length, g = S - 1;
        for (_ = _ === r ? S : _; ++p < _; ) {
          var O = rs(p, g), P = a[O];
          a[O] = a[p], a[p] = P;
        }
        return a.length = _, a;
      }
      var Fp = yt(function(a) {
        var _ = [];
        return a.charCodeAt(0) === 46 && _.push(""), a.replace(H, function(p, S, g, O) {
          _.push(g ? O.replace(Xo, "$1") : S || p);
        }), _;
      });
      function In(a) {
        if (typeof a == "string" || rn(a))
          return a;
        var _ = a + "";
        return _ == "0" && 1 / a == -an ? "-0" : _;
      }
      function pl(a) {
        if (a != null) {
          try {
            return gt.call(a);
          } catch {
          }
          try {
            return a + "";
          } catch {
          }
        }
        return "";
      }
      function JE(a, _) {
        return cn(fe, function(p) {
          var S = "_." + p[0];
          _ & p[1] && !Ha(a, S) && a.push(S);
        }), a.sort();
      }
      function Bp(a) {
        if (a instanceof ot)
          return a.clone();
        var _ = new dn(a.__wrapped__, a.__chain__);
        return _.__actions__ = vr(a.__actions__), _.__index__ = a.__index__, _.__values__ = a.__values__, _;
      }
      function us(a, _, p) {
        (p ? Pr(a, _, p) : _ === r) ? _ = 1 : _ = Ee(ze(_), 0);
        var S = a == null ? 0 : a.length;
        if (!S || _ < 1)
          return [];
        for (var g = 0, O = 0, P = j(Hs(S / _)); g < S; )
          P[O++] = Qr(a, g, g += _);
        return P;
      }
      function ZE(a) {
        for (var _ = -1, p = a == null ? 0 : a.length, S = 0, g = []; ++_ < p; ) {
          var O = a[_];
          O && (g[S++] = O);
        }
        return g;
      }
      function QE() {
        var a = arguments.length;
        if (!a)
          return [];
        for (var _ = j(a - 1), p = arguments[0], S = a; S--; )
          _[S - 1] = arguments[S];
        return Rn($e(p) ? vr(p) : [p], Mr(_, 1));
      }
      var qE = rt(function(a, _) {
        return Qt(a) ? ql(a, Mr(_, 1, Qt, !0)) : [];
      }), su = rt(function(a, _) {
        var p = Mn(_);
        return Qt(p) && (p = r), Qt(a) ? ql(a, Mr(_, 1, Qt, !0), Pe(p, 2)) : [];
      }), Up = rt(function(a, _) {
        var p = Mn(_);
        return Qt(p) && (p = r), Qt(a) ? ql(a, Mr(_, 1, Qt, !0), r, p) : [];
      });
      function eA(a, _, p) {
        var S = a == null ? 0 : a.length;
        return S ? (_ = p || _ === r ? 1 : ze(_), Qr(a, _ < 0 ? 0 : _, S)) : [];
      }
      function g_(a, _, p) {
        var S = a == null ? 0 : a.length;
        return S ? (_ = p || _ === r ? 1 : ze(_), _ = S - _, Qr(a, 0, _ < 0 ? 0 : _)) : [];
      }
      function Ts(a, _) {
        return a && a.length ? Qn(a, Pe(_, 3), !0, !0) : [];
      }
      function Vp(a, _) {
        return a && a.length ? Qn(a, Pe(_, 3), !0) : [];
      }
      function tA(a, _, p, S) {
        var g = a == null ? 0 : a.length;
        return g ? (p && typeof p != "number" && Pr(a, _, p) && (p = 0, S = g), pp(a, _, p, S)) : [];
      }
      function dl(a, _, p) {
        var S = a == null ? 0 : a.length;
        if (!S)
          return -1;
        var g = p == null ? 0 : ze(p);
        return g < 0 && (g = Ee(S + g, 0)), Us(a, Pe(_, 3), g);
      }
      function au(a, _, p) {
        var S = a == null ? 0 : a.length;
        if (!S)
          return -1;
        var g = S - 1;
        return p !== r && (g = ze(p), g = p < 0 ? Ee(S + g, 0) : Lt(g, S - 1)), Us(a, Pe(_, 3), g, !0);
      }
      function me(a) {
        var _ = a == null ? 0 : a.length;
        return _ ? Mr(a, 1) : [];
      }
      function ut(a) {
        var _ = a == null ? 0 : a.length;
        return _ ? Mr(a, an) : [];
      }
      function sa(a, _) {
        var p = a == null ? 0 : a.length;
        return p ? (_ = _ === r ? 1 : ze(_), Mr(a, _)) : [];
      }
      function _u(a) {
        for (var _ = -1, p = a == null ? 0 : a.length, S = {}; ++_ < p; ) {
          var g = a[_];
          S[g[0]] = g[1];
        }
        return S;
      }
      function cu(a) {
        return a && a.length ? a[0] : r;
      }
      function rA(a, _, p) {
        var S = a == null ? 0 : a.length;
        if (!S)
          return -1;
        var g = p == null ? 0 : ze(p);
        return g < 0 && (g = Ee(S + g, 0)), Ul(a, _, g);
      }
      function nA(a) {
        var _ = a == null ? 0 : a.length;
        return _ ? Qr(a, 0, -1) : [];
      }
      var uu = rt(function(a) {
        var _ = kt(a, ll);
        return _.length && _[0] === a[0] ? xc(_) : [];
      }), L_ = rt(function(a) {
        var _ = Mn(a), p = kt(a, ll);
        return _ === Mn(p) ? _ = r : p.pop(), p.length && p[0] === a[0] ? xc(p, Pe(_, 2)) : [];
      }), Gp = rt(function(a) {
        var _ = Mn(a), p = kt(a, ll);
        return _ = typeof _ == "function" ? _ : r, _ && p.pop(), p.length && p[0] === a[0] ? xc(p, r, _) : [];
      });
      function iA(a, _) {
        return a == null ? "" : yE.call(a, _);
      }
      function Mn(a) {
        var _ = a == null ? 0 : a.length;
        return _ ? a[_ - 1] : r;
      }
      function Tu(a, _, p) {
        var S = a == null ? 0 : a.length;
        if (!S)
          return -1;
        var g = S;
        return p !== r && (g = ze(p), g = g < 0 ? Ee(S + g, 0) : Lt(g, S - 1)), _ === _ ? Lc(a, _, g) : Us(a, dc, g, !0);
      }
      function xp(a, _) {
        return a && a.length ? go(a, ze(_)) : r;
      }
      var ps = rt(ds);
      function ds(a, _) {
        return a && a.length && _ && _.length ? Pn(a, _) : a;
      }
      function aa(a, _, p) {
        return a && a.length && _ && _.length ? Pn(a, _, Pe(p, 2)) : a;
      }
      function Tt(a, _, p) {
        return a && a.length && _ && _.length ? Pn(a, _, r, p) : a;
      }
      var _a = mi(function(a, _) {
        var p = a == null ? 0 : a.length, S = s_(a, _);
        return Zr(a, kt(_, function(g) {
          return Ki(g, p) ? +g : g;
        }).sort(Ye)), S;
      });
      function Es(a, _) {
        var p = [];
        if (!(a && a.length))
          return p;
        var S = -1, g = [], O = a.length;
        for (_ = Pe(_, 3); ++S < O; ) {
          var P = a[S];
          _(P, S, a) && (p.push(P), g.push(S));
        }
        return Zr(a, g), p;
      }
      function N_(a) {
        return a == null ? a : Ys.call(a);
      }
      function El(a, _, p) {
        var S = a == null ? 0 : a.length;
        return S ? (p && typeof p != "number" && Pr(a, _, p) ? (_ = 0, p = S) : (_ = _ == null ? 0 : ze(_), p = p === r ? S : ze(p)), Qr(a, _, p)) : [];
      }
      function oA(a, _) {
        return Lo(a, _);
      }
      function Hp(a, _, p) {
        return ea(a, _, Pe(p, 2));
      }
      function ir(a, _) {
        var p = a == null ? 0 : a.length;
        if (p) {
          var S = Lo(a, _);
          if (S < p && ft(a[S], _))
            return S;
        }
        return -1;
      }
      function y_(a, _) {
        return Lo(a, _, !0);
      }
      function As(a, _, p) {
        return ea(a, _, Pe(p, 2), !0);
      }
      function pu(a, _) {
        var p = a == null ? 0 : a.length;
        if (p) {
          var S = Lo(a, _, !0) - 1;
          if (ft(a[S], _))
            return S;
        }
        return -1;
      }
      function f_(a) {
        return a && a.length ? No(a) : [];
      }
      function ca(a, _) {
        return a && a.length ? No(a, Pe(_, 2)) : [];
      }
      function lA(a) {
        var _ = a == null ? 0 : a.length;
        return _ ? Qr(a, 1, _) : [];
      }
      function sA(a, _, p) {
        return a && a.length ? (_ = p || _ === r ? 1 : ze(_), Qr(a, 0, _ < 0 ? 0 : _)) : [];
      }
      function Ss(a, _, p) {
        var S = a == null ? 0 : a.length;
        return S ? (_ = p || _ === r ? 1 : ze(_), _ = S - _, Qr(a, _ < 0 ? 0 : _, S)) : [];
      }
      function Yp(a, _) {
        return a && a.length ? Qn(a, Pe(_, 3), !1, !0) : [];
      }
      function Xp(a, _) {
        return a && a.length ? Qn(a, Pe(_, 3)) : [];
      }
      var ei = rt(function(a) {
        return $n(Mr(a, 1, Qt, !0));
      }), C_ = rt(function(a) {
        var _ = Mn(a);
        return Qt(_) && (_ = r), $n(Mr(a, 1, Qt, !0), Pe(_, 2));
      }), Kp = rt(function(a) {
        var _ = Mn(a);
        return _ = typeof _ == "function" ? _ : r, $n(Mr(a, 1, Qt, !0), r, _);
      });
      function jp(a) {
        return a && a.length ? $n(a) : [];
      }
      function aA(a, _) {
        return a && a.length ? $n(a, Pe(_, 2)) : [];
      }
      function _A(a, _) {
        return _ = typeof _ == "function" ? _ : r, a && a.length ? $n(a, r, _) : [];
      }
      function ua(a) {
        if (!(a && a.length))
          return [];
        var _ = 0;
        return a = Ui(a, function(p) {
          if (Qt(p))
            return _ = Ee(p.length, _), !0;
        }), Ka(_, function(p) {
          return kt(a, Ec(p));
        });
      }
      function or(a, _) {
        if (!(a && a.length))
          return [];
        var p = ua(a);
        return _ == null ? p : kt(p, function(S) {
          return zr(_, r, S);
        });
      }
      var Nr = rt(function(a, _) {
        return Qt(a) ? ql(a, _) : [];
      }), zp = rt(function(a) {
        return ol(Ui(a, Qt));
      }), Jp = rt(function(a) {
        var _ = Mn(a);
        return Qt(_) && (_ = r), ol(Ui(a, Qt), Pe(_, 2));
      }), cA = rt(function(a) {
        var _ = Mn(a);
        return _ = typeof _ == "function" ? _ : r, ol(Ui(a, Qt), r, _);
      }), Gr = rt(ua);
      function v_(a, _) {
        return Si(a || [], _ || [], Ql);
      }
      function Ta(a, _) {
        return Si(a || [], _ || [], nr);
      }
      var du = rt(function(a) {
        var _ = a.length, p = _ > 1 ? a[_ - 1] : r;
        return p = typeof p == "function" ? (a.pop(), p) : r, or(a, p);
      });
      function hs(a) {
        var _ = R(a);
        return _.__chain__ = !0, _;
      }
      function pa(a, _) {
        return _(a), a;
      }
      function gn(a, _) {
        return _(a);
      }
      var ji = mi(function(a) {
        var _ = a.length, p = _ ? a[0] : 0, S = this.__wrapped__, g = function(O) {
          return s_(O, a);
        };
        return _ > 1 || this.__actions__.length || !(S instanceof ot) || !Ki(p) ? this.thru(g) : (S = S.slice(p, +p + (_ ? 1 : 0)), S.__actions__.push({
          func: gn,
          args: [g],
          thisArg: r
        }), new dn(S, this.__chain__).thru(function(O) {
          return _ && !O.length && O.push(r), O;
        }));
      });
      function lt() {
        return hs(this);
      }
      function lr() {
        return new dn(this.value(), this.__chain__);
      }
      function uA() {
        this.__values__ === r && (this.__values__ = bu(this.value()));
        var a = this.__index__ >= this.__values__.length, _ = a ? r : this.__values__[this.__index__++];
        return { done: a, value: _ };
      }
      function R_() {
        return this;
      }
      function FS(a) {
        for (var _, p = this; p instanceof t_; ) {
          var S = Bp(p);
          S.__index__ = 0, S.__values__ = r, _ ? g.__wrapped__ = S : _ = S;
          var g = S;
          p = p.__wrapped__;
        }
        return g.__wrapped__ = a, _;
      }
      function BS() {
        var a = this.__wrapped__;
        if (a instanceof ot) {
          var _ = a;
          return this.__actions__.length && (_ = new ot(this)), _ = _.reverse(), _.__actions__.push({
            func: gn,
            args: [N_],
            thisArg: r
          }), new dn(_, this.__chain__);
        }
        return this.thru(N_);
      }
      function Ln() {
        return Gi(this.__wrapped__, this.__actions__);
      }
      var Dt = xi(function(a, _, p) {
        mt.call(a, p) ? ++a[p] : Ai(a, p, 1);
      });
      function O_(a, _, p) {
        var S = $e(a) ? uc : Uc;
        return p && Pr(a, _, p) && (_ = r), S(a, Pe(_, 3));
      }
      function Zp(a, _) {
        var p = $e(a) ? Ui : dp;
        return p(a, Pe(_, 3));
      }
      var Qp = S_(dl), zi = S_(au);
      function US(a, _) {
        return Mr(Su(a, _), 1);
      }
      function VS(a, _) {
        return Mr(Su(a, _), an);
      }
      function Eu(a, _, p) {
        return p = p === r ? 1 : ze(p), Mr(Su(a, _), p);
      }
      function Zt(a, _) {
        var p = $e(a) ? cn : Io;
        return p(a, Pe(_, 3));
      }
      function Au(a, _) {
        var p = $e(a) ? kT : Bc;
        return p(a, Pe(_, 3));
      }
      var je = xi(function(a, _, p) {
        mt.call(a, p) ? a[p].push(_) : Ai(a, p, [_]);
      });
      function TA(a, _, p, S) {
        a = sr(a) ? a : gl(a), p = p && !S ? ze(p) : 0;
        var g = a.length;
        return p < 0 && (p = Ee(g + p, 0)), Ma(a) ? p <= g && a.indexOf(_, p) > -1 : !!g && Ul(a, _, p) > -1;
      }
      var ms = rt(function(a, _, p) {
        var S = -1, g = typeof _ == "function", O = sr(a) ? j(a.length) : [];
        return Io(a, function(P) {
          O[++S] = g ? zr(_, P, p) : Qs(P, _, p);
        }), O;
      }), GS = xi(function(a, _, p) {
        Ai(a, p, _);
      });
      function Su(a, _) {
        var p = $e(a) ? kt : Xc;
        return p(a, Pe(_, 3));
      }
      function hu(a, _, p, S) {
        return a == null ? [] : ($e(_) || (_ = _ == null ? [] : [_]), p = S ? r : p, $e(p) || (p = p == null ? [] : [p]), BE(a, _, p));
      }
      var qp = xi(function(a, _, p) {
        a[p ? 0 : 1].push(_);
      }, function() {
        return [[], []];
      });
      function pA(a, _, p) {
        var S = $e(a) ? Bs : BT, g = arguments.length < 3;
        return S(a, Pe(_, 4), p, g, Io);
      }
      function Ge(a, _, p) {
        var S = $e(a) ? Ti : BT, g = arguments.length < 3;
        return S(a, Pe(_, 4), p, g, Bc);
      }
      function dA(a, _) {
        var p = $e(a) ? Ui : dp;
        return p(a, Ji(Pe(_, 3)));
      }
      function Al(a) {
        var _ = $e(a) ? o_ : qs;
        return _(a);
      }
      function ti(a, _, p) {
        (p ? Pr(a, _, p) : _ === r) ? _ = 1 : _ = ze(_);
        var S = $e(a) ? l_ : VE;
        return S(a, _);
      }
      function Po(a) {
        var _ = $e(a) ? cp : $S;
        return _(a);
      }
      function mu(a) {
        if (a == null)
          return 0;
        if (sr(a))
          return Ma(a) ? jn(a) : a.length;
        var _ = Rr(a);
        return _ == Ue || _ == tr ? a.size : T_(a).length;
      }
      function Iu(a, _, p) {
        var S = $e(a) ? Ya : Cp;
        return p && Pr(a, _, p) && (_ = r), S(a, Pe(_, 3));
      }
      var da = rt(function(a, _) {
        if (a == null)
          return [];
        var p = _.length;
        return p > 1 && Pr(a, _[0], _[1]) ? _ = [] : p > 2 && Pr(_[0], _[1], _[2]) && (_ = [_[0]]), BE(a, Mr(_, 1), []);
      }), Mu = XT || function() {
        return fr.Date.now();
      };
      function ri(a, _) {
        if (typeof _ != "function")
          throw new un(d);
        return a = ze(a), function() {
          if (--a < 1)
            return _.apply(this, arguments);
        };
      }
      function ed(a, _, p) {
        return _ = p ? r : _, _ = a && _ == null ? a.length : _, hi(a, Pt, r, r, r, r, _);
      }
      function Qe(a, _) {
        var p;
        if (typeof _ != "function")
          throw new un(d);
        return a = ze(a), function() {
          return --a > 0 && (p = _.apply(this, arguments)), a <= 1 && (_ = r), p;
        };
      }
      var Ii = rt(function(a, _, p) {
        var S = ae;
        if (p.length) {
          var g = ho(p, Co(Ii));
          S |= er;
        }
        return hi(a, S, _, p, g);
      }), Gt = rt(function(a, _, p) {
        var S = ae | Ne;
        if (p.length) {
          var g = ho(p, Co(Gt));
          S |= er;
        }
        return hi(_, S, a, p, g);
      });
      function gu(a, _, p) {
        _ = p ? r : _;
        var S = hi(a, at, r, r, r, r, r, _);
        return S.placeholder = gu.placeholder, S;
      }
      function Lu(a, _, p) {
        _ = p ? r : _;
        var S = hi(a, dr, r, r, r, r, r, _);
        return S.placeholder = Lu.placeholder, S;
      }
      function td(a, _, p) {
        var S, g, O, P, w, Y, ne = 0, te = !1, se = !1, Se = !0;
        if (typeof a != "function")
          throw new un(d);
        _ = Nn(_) || 0, Kt(p) && (te = !!p.leading, se = "maxWait" in p, O = se ? Ee(Nn(p.maxWait) || 0, _) : O, Se = "trailing" in p ? !!p.trailing : Se);
        function ve(pr) {
          var vi = S, Fo = g;
          return S = g = r, ne = pr, P = a.apply(Fo, vi), P;
        }
        function We(pr) {
          return ne = pr, w = Tl(st, _), te ? ve(pr) : P;
        }
        function qe(pr) {
          var vi = pr - Y, Fo = pr - ne, eS = _ - vi;
          return se ? Lt(eS, O - Fo) : eS;
        }
        function we(pr) {
          var vi = pr - Y, Fo = pr - ne;
          return Y === r || vi >= _ || vi < 0 || se && Fo >= O;
        }
        function st() {
          var pr = Mu();
          if (we(pr))
            return ct(pr);
          w = Tl(st, qe(pr));
        }
        function ct(pr) {
          return w = r, Se && S ? ve(pr) : (S = g = r, P);
        }
        function yn() {
          w !== r && _l(w), ne = 0, S = Y = g = w = r;
        }
        function on() {
          return w === r ? P : ct(Mu());
        }
        function fn() {
          var pr = Mu(), vi = we(pr);
          if (S = arguments, g = this, Y = pr, vi) {
            if (w === r)
              return We(Y);
            if (se)
              return _l(w), w = Tl(st, _), ve(Y);
          }
          return w === r && (w = Tl(st, _)), P;
        }
        return fn.cancel = yn, fn.flush = on, fn;
      }
      var rd = rt(function(a, _) {
        return __(a, 1, _);
      }), EA = rt(function(a, _, p) {
        return __(a, Nn(_) || 0, p);
      });
      function AA(a) {
        return hi(a, xn);
      }
      function Or(a, _) {
        if (typeof a != "function" || _ != null && typeof _ != "function")
          throw new un(d);
        var p = function() {
          var S = arguments, g = _ ? _.apply(this, S) : S[0], O = p.cache;
          if (O.has(g))
            return O.get(g);
          var P = a.apply(this, S);
          return p.cache = O.set(g, P) || O, P;
        };
        return p.cache = new (Or.Cache || Ei)(), p;
      }
      Or.Cache = Ei;
      function Ji(a) {
        if (typeof a != "function")
          throw new un(d);
        return function() {
          var _ = arguments;
          switch (_.length) {
            case 0:
              return !a.call(this);
            case 1:
              return !a.call(this, _[0]);
            case 2:
              return !a.call(this, _[0], _[1]);
            case 3:
              return !a.call(this, _[0], _[1], _[2]);
          }
          return !a.apply(this, _);
        };
      }
      function $o(a) {
        return Qe(2, a);
      }
      var nd = al(function(a, _) {
        _ = _.length == 1 && $e(_[0]) ? kt(_[0], Jr(Pe())) : kt(Mr(_, 1), Jr(Pe()));
        var p = _.length;
        return rt(function(S) {
          for (var g = -1, O = Lt(S.length, p); ++g < O; )
            S[g] = _[g].call(this, S[g]);
          return zr(a, this, S);
        });
      }), ni = rt(function(a, _) {
        var p = ho(_, Co(ni));
        return hi(a, er, r, _, p);
      }), id = rt(function(a, _) {
        var p = ho(_, Co(id));
        return hi(a, Ze, r, _, p);
      }), wn = mi(function(a, _) {
        return hi(a, wr, r, r, r, _);
      });
      function Ea(a, _) {
        if (typeof a != "function")
          throw new un(d);
        return _ = _ === r ? _ : ze(_), rt(a, _);
      }
      function D_(a, _) {
        if (typeof a != "function")
          throw new un(d);
        return _ = _ == null ? 0 : Ee(ze(_), 0), rt(function(p) {
          var S = p[_], g = qr(p, 0, _);
          return S && Rn(g, S), zr(a, this, g);
        });
      }
      function b_(a, _, p) {
        var S = !0, g = !0;
        if (typeof a != "function")
          throw new un(d);
        return Kt(p) && (S = "leading" in p ? !!p.leading : S, g = "trailing" in p ? !!p.trailing : g), td(a, _, {
          leading: S,
          maxWait: _,
          trailing: g
        });
      }
      function P_(a) {
        return ed(a, 1);
      }
      function od(a, _) {
        return ni(sl(_), a);
      }
      function Nu() {
        if (!arguments.length)
          return [];
        var a = arguments[0];
        return $e(a) ? a : [a];
      }
      function yu(a) {
        return En(a, ue);
      }
      function fu(a, _) {
        return _ = typeof _ == "function" ? _ : r, En(a, ue, _);
      }
      function Aa(a) {
        return En(a, Z | ue);
      }
      function ld(a, _) {
        return _ = typeof _ == "function" ? _ : r, En(a, Z | ue, _);
      }
      function Wo(a, _) {
        return _ == null || a_(a, _, ar(_));
      }
      function ft(a, _) {
        return a === _ || a !== a && _ !== _;
      }
      var sd = ss(Zs), SA = ss(function(a, _) {
        return a >= _;
      }), Sl = Ep(/* @__PURE__ */ function() {
        return arguments;
      }()) ? Ep : function(a) {
        return jt(a) && mt.call(a, "callee") && !Rc.call(a, "callee");
      }, $e = j.isArray, hA = cc ? Jr(cc) : FE;
      function sr(a) {
        return a != null && ie(a.length) && !gi(a);
      }
      function Qt(a) {
        return jt(a) && sr(a);
      }
      function $_(a) {
        return a === !0 || a === !1 || jt(a) && Cr(a) == Xr;
      }
      var Mi = Pc || Ku, mA = Fl ? Jr(Fl) : Ap;
      function Cu(a) {
        return jt(a) && a.nodeType === 1 && !ma(a);
      }
      function Zi(a) {
        if (a == null)
          return !0;
        if (sr(a) && ($e(a) || typeof a == "string" || typeof a.splice == "function" || Mi(a) || hl(a) || Sl(a)))
          return !a.length;
        var _ = Rr(a);
        if (_ == Ue || _ == tr)
          return !a.size;
        if (cs(a))
          return !T_(a).length;
        for (var p in a)
          if (mt.call(a, p))
            return !1;
        return !0;
      }
      function pt(a, _) {
        return ts(a, _);
      }
      function IA(a, _, p) {
        p = typeof p == "function" ? p : r;
        var S = p ? p(a, _) : r;
        return S === r ? ts(a, _, r, p) : !!S;
      }
      function vu(a) {
        if (!jt(a))
          return !1;
        var _ = Cr(a);
        return _ == K || _ == hr || typeof a.message == "string" && typeof a.name == "string" && !ma(a);
      }
      function Is(a) {
        return typeof a == "number" && KT(a);
      }
      function gi(a) {
        if (!Kt(a))
          return !1;
        var _ = Cr(a);
        return _ == Re || _ == co || _ == Br || _ == bi;
      }
      function Ru(a) {
        return typeof a == "number" && a == ze(a);
      }
      function ie(a) {
        return typeof a == "number" && a > -1 && a % 1 == 0 && a <= Sr;
      }
      function Kt(a) {
        var _ = typeof a;
        return a != null && (_ == "object" || _ == "function");
      }
      function jt(a) {
        return a != null && typeof a == "object";
      }
      var Sa = Ga ? Jr(Ga) : hp;
      function MA(a, _) {
        return a === _ || Hc(a, _, ru(_));
      }
      function ad(a, _, p) {
        return p = typeof p == "function" ? p : r, Hc(a, _, ru(_), p);
      }
      function tn(a) {
        return ha(a) && a != +a;
      }
      function _d(a) {
        if (Ro(a))
          throw new Ve(T);
        return mp(a);
      }
      function Li(a) {
        return a === null;
      }
      function Fn(a) {
        return a == null;
      }
      function ha(a) {
        return typeof a == "number" || jt(a) && Cr(a) == Di;
      }
      function ma(a) {
        if (!jt(a) || Cr(a) != mr)
          return !1;
        var _ = Kl(a);
        if (_ === null)
          return !0;
        var p = mt.call(_, "constructor") && _.constructor;
        return typeof p == "function" && p instanceof p && gt.call(p) == Cc;
      }
      var Ou = xa ? Jr(xa) : Ip;
      function Ia(a) {
        return Ru(a) && a >= -Sr && a <= Sr;
      }
      var Du = $T ? Jr($T) : Mp;
      function Ma(a) {
        return typeof a == "string" || !$e(a) && jt(a) && Cr(a) == Pi;
      }
      function rn(a) {
        return typeof a == "symbol" || jt(a) && Cr(a) == Kr;
      }
      var hl = Fs ? Jr(Fs) : gp;
      function cd(a) {
        return a === r;
      }
      function ud(a) {
        return jt(a) && Rr(a) == Xn;
      }
      function ml(a) {
        return jt(a) && Cr(a) == uo;
      }
      var Td = ss(p_), pd = ss(function(a, _) {
        return a <= _;
      });
      function bu(a) {
        if (!a)
          return [];
        if (sr(a))
          return Ma(a) ? On(a) : vr(a);
        if (Jo && a[Jo])
          return xT(a[Jo]());
        var _ = Rr(a), p = _ == Ue ? Ic : _ == tr ? pi : gl;
        return p(a);
      }
      function Ni(a) {
        if (!a)
          return a === 0 ? a : 0;
        if (a = Nn(a), a === an || a === -an) {
          var _ = a < 0 ? -1 : 1;
          return _ * ao;
        }
        return a === a ? a : 0;
      }
      function ze(a) {
        var _ = Ni(a), p = _ % 1;
        return _ === _ ? p ? _ - p : _ : 0;
      }
      function Pu(a) {
        return a ? rl(ze(a), 0, Fr) : 0;
      }
      function Nn(a) {
        if (typeof a == "number")
          return a;
        if (rn(a))
          return nt;
        if (Kt(a)) {
          var _ = typeof a.valueOf == "function" ? a.valueOf() : a;
          a = Kt(_) ? _ + "" : _;
        }
        if (typeof a != "string")
          return a === 0 ? a : +a;
        a = Vs(a);
        var p = dT.test(a);
        return p || Jd.test(a) ? Ko(a.slice(2), p ? 2 : 8) : Kn.test(a) ? nt : +a;
      }
      function $u(a) {
        return Sn(a, xr(a));
      }
      function dd(a) {
        return a ? rl(ze(a), -Sr, Sr) : a === 0 ? a : 0;
      }
      function St(a) {
        return a == null ? "" : gr(a);
      }
      var Ed = Lr(function(a, _) {
        if (cs(_) || sr(_)) {
          Sn(_, ar(_), a);
          return;
        }
        for (var p in _)
          mt.call(_, p) && Ql(a, p, _[p]);
      }), he = Lr(function(a, _) {
        Sn(_, xr(_), a);
      }), Il = Lr(function(a, _, p, S) {
        Sn(_, xr(_), a, S);
      }), gA = Lr(function(a, _, p, S) {
        Sn(_, ar(_), a, S);
      }), xS = mi(s_);
      function F(a, _) {
        var p = el(a);
        return _ == null ? p : Fc(p, _);
      }
      var Qi = rt(function(a, _) {
        a = Nt(a);
        var p = -1, S = _.length, g = S > 2 ? _[2] : r;
        for (g && Pr(_[0], _[1], g) && (S = 1); ++p < S; )
          for (var O = _[p], P = xr(O), w = -1, Y = P.length; ++w < Y; ) {
            var ne = P[w], te = a[ne];
            (te === r || ft(te, Hl[ne]) && !mt.call(a, ne)) && (a[ne] = O[ne]);
          }
        return a;
      }), Ms = rt(function(a) {
        return a.push(r, Dp), zr(hd, r, a);
      });
      function W_(a, _) {
        return Tc(a, Pe(_, 3), Zn);
      }
      function LA(a, _) {
        return Tc(a, Pe(_, 3), c_);
      }
      function gs(a, _) {
        return a == null ? a : Vc(a, Pe(_, 3), xr);
      }
      function k_(a, _) {
        return a == null ? a : Gc(a, Pe(_, 3), xr);
      }
      function ga(a, _) {
        return a && Zn(a, Pe(_, 3));
      }
      function w_(a, _) {
        return a && c_(a, Pe(_, 3));
      }
      function Ad(a) {
        return a == null ? [] : es(a, ar(a));
      }
      function Ml(a) {
        return a == null ? [] : es(a, xr(a));
      }
      function La(a, _, p) {
        var S = a == null ? r : Mo(a, _);
        return S === r ? p : S;
      }
      function Na(a, _) {
        return a != null && Pp(a, _, $E);
      }
      function F_(a, _) {
        return a != null && Pp(a, _, WE);
      }
      var NA = Rp(function(a, _, p) {
        _ != null && typeof _.toString != "function" && (_ = zn.call(_)), a[_] = p;
      }, fi(Ct)), Bn = Rp(function(a, _, p) {
        _ != null && typeof _.toString != "function" && (_ = zn.call(_)), mt.call(a, _) ? a[_].push(p) : a[_] = [p];
      }, Pe), Sd = rt(Qs);
      function ar(a) {
        return sr(a) ? kc(a) : T_(a);
      }
      function xr(a) {
        return sr(a) ? kc(a, !0) : Lp(a);
      }
      function yA(a, _) {
        var p = {};
        return _ = Pe(_, 3), Zn(a, function(S, g, O) {
          Ai(p, _(S, g, O), S);
        }), p;
      }
      function fA(a, _) {
        var p = {};
        return _ = Pe(_, 3), Zn(a, function(S, g, O) {
          Ai(p, g, _(S, g, O));
        }), p;
      }
      var CA = Lr(function(a, _, p) {
        Oe(a, _, p);
      }), hd = Lr(function(a, _, p, S) {
        Oe(a, _, p, S);
      }), B_ = mi(function(a, _) {
        var p = {};
        if (a == null)
          return p;
        var S = !1;
        _ = kt(_, function(O) {
          return O = Wn(O, a), S || (S = O.length > 1), O;
        }), Sn(a, tu(a), p), S && (p = En(p, Z | le | ue, Ar));
        for (var g = _.length; g--; )
          ta(p, _[g]);
        return p;
      });
      function md(a, _) {
        return Wu(a, Ji(Pe(_)));
      }
      var U_ = mi(function(a, _) {
        return a == null ? {} : Kc(a, _);
      });
      function Wu(a, _) {
        if (a == null)
          return {};
        var p = kt(tu(a), function(S) {
          return [S];
        });
        return _ = Pe(_), Vi(a, p, function(S, g) {
          return _(S, g[0]);
        });
      }
      function ya(a, _, p) {
        _ = Wn(_, a);
        var S = -1, g = _.length;
        for (g || (g = 1, a = r); ++S < g; ) {
          var O = a == null ? r : a[In(_[S])];
          O === r && (S = g, O = p), a = gi(O) ? O.call(a) : O;
        }
        return a;
      }
      function vA(a, _, p) {
        return a == null ? a : nr(a, _, p);
      }
      function ku(a, _, p, S) {
        return S = typeof S == "function" ? S : r, a == null ? a : nr(a, _, p, S);
      }
      var Id = ra(ar), Md = ra(xr);
      function RA(a, _, p) {
        var S = $e(a), g = S || Mi(a) || hl(a);
        if (_ = Pe(_, 4), p == null) {
          var O = a && a.constructor;
          g ? p = S ? new O() : [] : Kt(a) ? p = gi(O) ? el(Kl(a)) : {} : p = {};
        }
        return (g ? cn : Zn)(a, function(P, w, Y) {
          return _(p, P, w, Y);
        }), p;
      }
      function HS(a, _) {
        return a == null ? !0 : ta(a, _);
      }
      function YS(a, _, p) {
        return a == null ? a : il(a, _, sl(p));
      }
      function XS(a, _, p, S) {
        return S = typeof S == "function" ? S : r, a == null ? a : il(a, _, sl(p), S);
      }
      function gl(a) {
        return a == null ? [] : Sc(a, ar(a));
      }
      function OA(a) {
        return a == null ? [] : Sc(a, xr(a));
      }
      function wu(a, _, p) {
        return p === r && (p = _, _ = r), p !== r && (p = Nn(p), p = p === p ? p : 0), _ !== r && (_ = Nn(_), _ = _ === _ ? _ : 0), rl(Nn(a), _, p);
      }
      function DA(a, _, p) {
        return _ = Ni(_), p === r ? (p = _, _ = 0) : p = Ni(p), a = Nn(a), kE(a, _, p);
      }
      function V_(a, _, p) {
        if (p && typeof p != "boolean" && Pr(a, _, p) && (_ = p = r), p === r && (typeof _ == "boolean" ? (p = _, _ = r) : typeof a == "boolean" && (p = a, a = r)), a === r && _ === r ? (a = 0, _ = 1) : (a = Ni(a), _ === r ? (_ = a, a = 0) : _ = Ni(_)), a > _) {
          var S = a;
          a = _, _ = S;
        }
        if (p || a % 1 || _ % 1) {
          var g = di();
          return Lt(a + g * (_ - a + pE("1e-" + ((g + "").length - 1))), _);
        }
        return rs(a, _);
      }
      var ht = hn(function(a, _, p) {
        return _ = _.toLowerCase(), a + (p ? gd(_) : _);
      });
      function gd(a) {
        return x_(St(a).toLowerCase());
      }
      function ii(a) {
        return a = St(a), a && a.replace(wi, VT).replace(OT, "");
      }
      function nn(a, _, p) {
        a = St(a), _ = gr(_);
        var S = a.length;
        p = p === r ? S : rl(ze(p), 0, S);
        var g = p;
        return p -= _.length, p >= 0 && a.slice(p, g) == _;
      }
      function bA(a) {
        return a = St(a), a && Pl.test(a) ? a.replace(Xt, GT) : a;
      }
      function Fu(a) {
        return a = St(a), a && Me.test(a) ? a.replace(ee, "\\$&") : a;
      }
      var tt = hn(function(a, _, p) {
        return a + (p ? "-" : "") + _.toLowerCase();
      }), Bu = hn(function(a, _, p) {
        return a + (p ? " " : "") + _.toLowerCase();
      }), Ls = kn("toLowerCase");
      function Un(a, _, p) {
        a = St(a), _ = ze(_);
        var S = _ ? jn(a) : 0;
        if (!_ || S >= _)
          return a;
        var g = (_ - S) / 2;
        return m_(jl(g), p) + a + m_(Hs(g), p);
      }
      function PA(a, _, p) {
        a = St(a), _ = ze(_);
        var S = _ ? jn(a) : 0;
        return _ && S < _ ? a + m_(_ - S, p) : a;
      }
      function Ld(a, _, p) {
        a = St(a), _ = ze(_);
        var S = _ ? jn(a) : 0;
        return _ && S < _ ? m_(_ - S, p) + a : a;
      }
      function Nd(a, _, p) {
        return p || _ == null ? _ = 0 : _ && (_ = +_), wt(St(a).replace(He, ""), _ || 0);
      }
      function G_(a, _, p) {
        return (p ? Pr(a, _, p) : _ === r) ? _ = 1 : _ = ze(_), jc(St(a), _);
      }
      function yi() {
        var a = arguments, _ = St(a[0]);
        return a.length < 3 ? _ : _.replace(a[1], a[2]);
      }
      var yd = hn(function(a, _, p) {
        return a + (p ? "_" : "") + _.toLowerCase();
      });
      function $A(a, _, p) {
        return p && typeof p != "number" && Pr(a, _, p) && (_ = p = r), p = p === r ? Fr : p >>> 0, p ? (a = St(a), a && (typeof _ == "string" || _ != null && !Ou(_)) && (_ = gr(_), !_ && Vl(a)) ? qr(On(a), 0, p) : a.split(_, p)) : [];
      }
      var fd = hn(function(a, _, p) {
        return a + (p ? " " : "") + x_(_);
      });
      function WA(a, _, p) {
        return a = St(a), p = p == null ? 0 : rl(ze(p), 0, a.length), _ = gr(_), a.slice(p, p + _.length) == _;
      }
      function KS(a, _, p) {
        var S = R.templateSettings;
        p && Pr(a, _, p) && (_ = r), a = St(a), _ = Il({}, _, S, eu);
        var g = Il({}, _.imports, S.imports, eu), O = ar(g), P = Sc(g, O), w, Y, ne = 0, te = _.interpolate || ci, se = "__p += '", Se = yc(
          (_.escape || ci).source + "|" + te.source + "|" + (te === M ? $l : ci).source + "|" + (_.evaluate || ci).source + "|$",
          "g"
        ), ve = "//# sourceURL=" + (mt.call(_, "sourceURL") ? (_.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++_E + "]") + `
`;
        a.replace(Se, function(we, st, ct, yn, on, fn) {
          return ct || (ct = yn), se += a.slice(ne, fn).replace(AT, SE), st && (w = !0, se += `' +
__e(` + st + `) +
'`), on && (Y = !0, se += `';
` + on + `;
__p += '`), ct && (se += `' +
((__t = (` + ct + `)) == null ? '' : __t) +
'`), ne = fn + we.length, we;
        }), se += `';
`;
        var We = mt.call(_, "variable") && _.variable;
        if (!We)
          se = `with (obj) {
` + se + `
}
`;
        else if (ba.test(We))
          throw new Ve(h);
        se = (Y ? se.replace(Wi, "") : se).replace(rc, "$1").replace(po, "$1;"), se = "function(" + (We || "obj") + `) {
` + (We ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (w ? ", __e = _.escape" : "") + (Y ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + se + `return __p
}`;
        var qe = Vu(function() {
          return Et(O, ve + "return " + se).apply(r, P);
        });
        if (qe.source = se, vu(qe))
          throw qe;
        return qe;
      }
      function jS(a) {
        return St(a).toLowerCase();
      }
      function ko(a) {
        return St(a).toUpperCase();
      }
      function Cd(a, _, p) {
        if (a = St(a), a && (p || _ === r))
          return Vs(a);
        if (!a || !(_ = gr(_)))
          return a;
        var S = On(a), g = On(_), O = hc(S, g), P = mc(S, g) + 1;
        return qr(S, O, P).join("");
      }
      function kA(a, _, p) {
        if (a = St(a), a && (p || _ === r))
          return a.slice(0, za(a) + 1);
        if (!a || !(_ = gr(_)))
          return a;
        var S = On(a), g = mc(S, On(_)) + 1;
        return qr(S, 0, g).join("");
      }
      function Ll(a, _, p) {
        if (a = St(a), a && (p || _ === r))
          return a.replace(He, "");
        if (!a || !(_ = gr(_)))
          return a;
        var S = On(a), g = hc(S, On(_));
        return qr(S, g).join("");
      }
      function Uu(a, _) {
        var p = Dl, S = si;
        if (Kt(_)) {
          var g = "separator" in _ ? _.separator : g;
          p = "length" in _ ? ze(_.length) : p, S = "omission" in _ ? gr(_.omission) : S;
        }
        a = St(a);
        var O = a.length;
        if (Vl(a)) {
          var P = On(a);
          O = P.length;
        }
        if (p >= O)
          return a;
        var w = p - jn(S);
        if (w < 1)
          return S;
        var Y = P ? qr(P, 0, w).join("") : a.slice(0, w);
        if (g === r)
          return Y + S;
        if (P && (w += Y.length - w), Ou(g)) {
          if (a.slice(w).search(g)) {
            var ne, te = Y;
            for (g.global || (g = yc(g.source, St(ks.exec(g)) + "g")), g.lastIndex = 0; ne = g.exec(te); )
              var se = ne.index;
            Y = Y.slice(0, se === r ? w : se);
          }
        } else if (a.indexOf(gr(g), w) != w) {
          var Se = Y.lastIndexOf(g);
          Se > -1 && (Y = Y.slice(0, Se));
        }
        return Y + S;
      }
      function Wr(a) {
        return a = St(a), a && $s.test(a) ? a.replace(ki, HT) : a;
      }
      var wA = hn(function(a, _, p) {
        return a + (p ? " " : "") + _.toUpperCase();
      }), x_ = kn("toUpperCase");
      function wo(a, _, p) {
        return a = St(a), _ = p ? r : _, _ === r ? mE(a) ? xs(a) : Xa(a) : a.match(_) || [];
      }
      var Vu = rt(function(a, _) {
        try {
          return zr(a, r, _);
        } catch (p) {
          return vu(p) ? p : new Ve(p);
        }
      }), H_ = mi(function(a, _) {
        return cn(_, function(p) {
          p = In(p), Ai(a, p, Ii(a[p], a));
        }), a;
      });
      function zS(a) {
        var _ = a == null ? 0 : a.length, p = Pe();
        return a = _ ? kt(a, function(S) {
          if (typeof S[1] != "function")
            throw new un(d);
          return [p(S[0]), S[1]];
        }) : [], rt(function(S) {
          for (var g = -1; ++g < _; ) {
            var O = a[g];
            if (zr(O[0], this, S))
              return zr(O[1], this, S);
          }
        });
      }
      function FA(a) {
        return nl(En(a, Z));
      }
      function fi(a) {
        return function() {
          return a;
        };
      }
      function fa(a, _) {
        return a == null || a !== a ? _ : a;
      }
      var Nl = ur(), Ns = ur(!0);
      function Ct(a) {
        return a;
      }
      function Gu(a) {
        return Yc(typeof a == "function" ? a : En(a, Z));
      }
      function JS(a) {
        return Np(En(a, Z));
      }
      function Ci(a, _) {
        return yp(a, En(_, Z));
      }
      var Ca = rt(function(a, _) {
        return function(p) {
          return Qs(p, a, _);
        };
      }), xu = rt(function(a, _) {
        return function(p) {
          return Qs(a, p, _);
        };
      });
      function Hu(a, _, p) {
        var S = ar(_), g = es(_, S);
        p == null && !(Kt(_) && (g.length || !S.length)) && (p = _, _ = a, a = this, g = es(_, ar(_)));
        var O = !(Kt(p) && "chain" in p) || !!p.chain, P = gi(a);
        return cn(g, function(w) {
          var Y = _[w];
          a[w] = Y, P && (a.prototype[w] = function() {
            var ne = this.__chain__;
            if (O || ne) {
              var te = a(this.__wrapped__), se = te.__actions__ = vr(this.__actions__);
              return se.push({ func: Y, args: arguments, thisArg: a }), te.__chain__ = ne, te;
            }
            return Y.apply(a, Rn([this.value()], arguments));
          });
        }), a;
      }
      function vd() {
        return fr._ === this && (fr._ = LE), this;
      }
      function Yu() {
      }
      function At(a) {
        return a = ze(a), rt(function(_) {
          return go(_, a);
        });
      }
      var BA = Qc(kt), ys = Qc(uc), UA = Qc(Ya);
      function Rd(a) {
        return M_(a) ? Ec(In(a)) : _e(a);
      }
      function VA(a) {
        return function(_) {
          return a == null ? r : Mo(a, _);
        };
      }
      var GA = qc(), xA = qc(!0);
      function Xu() {
        return [];
      }
      function Ku() {
        return !1;
      }
      function HA() {
        return {};
      }
      function YA() {
        return "";
      }
      function qi() {
        return !0;
      }
      function XA(a, _) {
        if (a = ze(a), a < 1 || a > Sr)
          return [];
        var p = Fr, S = Lt(a, Fr);
        _ = Pe(_), a -= Fr;
        for (var g = Ka(S, _); ++p < a; )
          _(p);
        return g;
      }
      function KA(a) {
        return $e(a) ? kt(a, In) : rn(a) ? [a] : vr(Fp(St(a)));
      }
      function jA(a) {
        var _ = ++gE;
        return St(a) + _;
      }
      var zA = h_(function(a, _) {
        return a + _;
      }, 0), Y_ = _s("ceil"), JA = h_(function(a, _) {
        return a / _;
      }, 1), ZA = _s("floor");
      function Od(a) {
        return a && a.length ? Js(a, Ct, Zs) : r;
      }
      function ZS(a, _) {
        return a && a.length ? Js(a, Pe(_, 2), Zs) : r;
      }
      function va(a) {
        return FT(a, Ct);
      }
      function QA(a, _) {
        return FT(a, Pe(_, 2));
      }
      function qA(a) {
        return a && a.length ? Js(a, Ct, p_) : r;
      }
      function Dd(a, _) {
        return a && a.length ? Js(a, Pe(_, 2), p_) : r;
      }
      var QS = h_(function(a, _) {
        return a * _;
      }, 1), eo = _s("round"), to = h_(function(a, _) {
        return a - _;
      }, 0);
      function qS(a) {
        return a && a.length ? zo(a, Ct) : 0;
      }
      function eh(a, _) {
        return a && a.length ? zo(a, Pe(_, 2)) : 0;
      }
      return R.after = ri, R.ary = ed, R.assign = Ed, R.assignIn = he, R.assignInWith = Il, R.assignWith = gA, R.at = xS, R.before = Qe, R.bind = Ii, R.bindAll = H_, R.bindKey = Gt, R.castArray = Nu, R.chain = hs, R.chunk = us, R.compact = ZE, R.concat = QE, R.cond = zS, R.conforms = FA, R.constant = fi, R.countBy = Dt, R.create = F, R.curry = gu, R.curryRight = Lu, R.debounce = td, R.defaults = Qi, R.defaultsDeep = Ms, R.defer = rd, R.delay = EA, R.difference = qE, R.differenceBy = su, R.differenceWith = Up, R.drop = eA, R.dropRight = g_, R.dropRightWhile = Ts, R.dropWhile = Vp, R.fill = tA, R.filter = Zp, R.flatMap = US, R.flatMapDeep = VS, R.flatMapDepth = Eu, R.flatten = me, R.flattenDeep = ut, R.flattenDepth = sa, R.flip = AA, R.flow = Nl, R.flowRight = Ns, R.fromPairs = _u, R.functions = Ad, R.functionsIn = Ml, R.groupBy = je, R.initial = nA, R.intersection = uu, R.intersectionBy = L_, R.intersectionWith = Gp, R.invert = NA, R.invertBy = Bn, R.invokeMap = ms, R.iteratee = Gu, R.keyBy = GS, R.keys = ar, R.keysIn = xr, R.map = Su, R.mapKeys = yA, R.mapValues = fA, R.matches = JS, R.matchesProperty = Ci, R.memoize = Or, R.merge = CA, R.mergeWith = hd, R.method = Ca, R.methodOf = xu, R.mixin = Hu, R.negate = Ji, R.nthArg = At, R.omit = B_, R.omitBy = md, R.once = $o, R.orderBy = hu, R.over = BA, R.overArgs = nd, R.overEvery = ys, R.overSome = UA, R.partial = ni, R.partialRight = id, R.partition = qp, R.pick = U_, R.pickBy = Wu, R.property = Rd, R.propertyOf = VA, R.pull = ps, R.pullAll = ds, R.pullAllBy = aa, R.pullAllWith = Tt, R.pullAt = _a, R.range = GA, R.rangeRight = xA, R.rearg = wn, R.reject = dA, R.remove = Es, R.rest = Ea, R.reverse = N_, R.sampleSize = ti, R.set = vA, R.setWith = ku, R.shuffle = Po, R.slice = El, R.sortBy = da, R.sortedUniq = f_, R.sortedUniqBy = ca, R.split = $A, R.spread = D_, R.tail = lA, R.take = sA, R.takeRight = Ss, R.takeRightWhile = Yp, R.takeWhile = Xp, R.tap = pa, R.throttle = b_, R.thru = gn, R.toArray = bu, R.toPairs = Id, R.toPairsIn = Md, R.toPath = KA, R.toPlainObject = $u, R.transform = RA, R.unary = P_, R.union = ei, R.unionBy = C_, R.unionWith = Kp, R.uniq = jp, R.uniqBy = aA, R.uniqWith = _A, R.unset = HS, R.unzip = ua, R.unzipWith = or, R.update = YS, R.updateWith = XS, R.values = gl, R.valuesIn = OA, R.without = Nr, R.words = wo, R.wrap = od, R.xor = zp, R.xorBy = Jp, R.xorWith = cA, R.zip = Gr, R.zipObject = v_, R.zipObjectDeep = Ta, R.zipWith = du, R.entries = Id, R.entriesIn = Md, R.extend = he, R.extendWith = Il, Hu(R, R), R.add = zA, R.attempt = Vu, R.camelCase = ht, R.capitalize = gd, R.ceil = Y_, R.clamp = wu, R.clone = yu, R.cloneDeep = Aa, R.cloneDeepWith = ld, R.cloneWith = fu, R.conformsTo = Wo, R.deburr = ii, R.defaultTo = fa, R.divide = JA, R.endsWith = nn, R.eq = ft, R.escape = bA, R.escapeRegExp = Fu, R.every = O_, R.find = Qp, R.findIndex = dl, R.findKey = W_, R.findLast = zi, R.findLastIndex = au, R.findLastKey = LA, R.floor = ZA, R.forEach = Zt, R.forEachRight = Au, R.forIn = gs, R.forInRight = k_, R.forOwn = ga, R.forOwnRight = w_, R.get = La, R.gt = sd, R.gte = SA, R.has = Na, R.hasIn = F_, R.head = cu, R.identity = Ct, R.includes = TA, R.indexOf = rA, R.inRange = DA, R.invoke = Sd, R.isArguments = Sl, R.isArray = $e, R.isArrayBuffer = hA, R.isArrayLike = sr, R.isArrayLikeObject = Qt, R.isBoolean = $_, R.isBuffer = Mi, R.isDate = mA, R.isElement = Cu, R.isEmpty = Zi, R.isEqual = pt, R.isEqualWith = IA, R.isError = vu, R.isFinite = Is, R.isFunction = gi, R.isInteger = Ru, R.isLength = ie, R.isMap = Sa, R.isMatch = MA, R.isMatchWith = ad, R.isNaN = tn, R.isNative = _d, R.isNil = Fn, R.isNull = Li, R.isNumber = ha, R.isObject = Kt, R.isObjectLike = jt, R.isPlainObject = ma, R.isRegExp = Ou, R.isSafeInteger = Ia, R.isSet = Du, R.isString = Ma, R.isSymbol = rn, R.isTypedArray = hl, R.isUndefined = cd, R.isWeakMap = ud, R.isWeakSet = ml, R.join = iA, R.kebabCase = tt, R.last = Mn, R.lastIndexOf = Tu, R.lowerCase = Bu, R.lowerFirst = Ls, R.lt = Td, R.lte = pd, R.max = Od, R.maxBy = ZS, R.mean = va, R.meanBy = QA, R.min = qA, R.minBy = Dd, R.stubArray = Xu, R.stubFalse = Ku, R.stubObject = HA, R.stubString = YA, R.stubTrue = qi, R.multiply = QS, R.nth = xp, R.noConflict = vd, R.noop = Yu, R.now = Mu, R.pad = Un, R.padEnd = PA, R.padStart = Ld, R.parseInt = Nd, R.random = V_, R.reduce = pA, R.reduceRight = Ge, R.repeat = G_, R.replace = yi, R.result = ya, R.round = eo, R.runInContext = x, R.sample = Al, R.size = mu, R.snakeCase = yd, R.some = Iu, R.sortedIndex = oA, R.sortedIndexBy = Hp, R.sortedIndexOf = ir, R.sortedLastIndex = y_, R.sortedLastIndexBy = As, R.sortedLastIndexOf = pu, R.startCase = fd, R.startsWith = WA, R.subtract = to, R.sum = qS, R.sumBy = eh, R.template = KS, R.times = XA, R.toFinite = Ni, R.toInteger = ze, R.toLength = Pu, R.toLower = jS, R.toNumber = Nn, R.toSafeInteger = dd, R.toString = St, R.toUpper = ko, R.trim = Cd, R.trimEnd = kA, R.trimStart = Ll, R.truncate = Uu, R.unescape = Wr, R.uniqueId = jA, R.upperCase = wA, R.upperFirst = x_, R.each = Zt, R.eachRight = Au, R.first = cu, Hu(R, function() {
        var a = {};
        return Zn(R, function(_, p) {
          mt.call(R.prototype, p) || (a[p] = _);
        }), a;
      }(), { chain: !1 }), R.VERSION = o, cn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(a) {
        R[a].placeholder = R;
      }), cn(["drop", "take"], function(a, _) {
        ot.prototype[a] = function(p) {
          p = p === r ? 1 : Ee(ze(p), 0);
          var S = this.__filtered__ && !_ ? new ot(this) : this.clone();
          return S.__filtered__ ? S.__takeCount__ = Lt(p, S.__takeCount__) : S.__views__.push({
            size: Lt(p, Fr),
            type: a + (S.__dir__ < 0 ? "Right" : "")
          }), S;
        }, ot.prototype[a + "Right"] = function(p) {
          return this.reverse()[a](p).reverse();
        };
      }), cn(["filter", "map", "takeWhile"], function(a, _) {
        var p = _ + 1, S = p == Dr || p == Ps;
        ot.prototype[a] = function(g) {
          var O = this.clone();
          return O.__iteratees__.push({
            iteratee: Pe(g, 3),
            type: p
          }), O.__filtered__ = O.__filtered__ || S, O;
        };
      }), cn(["head", "last"], function(a, _) {
        var p = "take" + (_ ? "Right" : "");
        ot.prototype[a] = function() {
          return this[p](1).value()[0];
        };
      }), cn(["initial", "tail"], function(a, _) {
        var p = "drop" + (_ ? "" : "Right");
        ot.prototype[a] = function() {
          return this.__filtered__ ? new ot(this) : this[p](1);
        };
      }), ot.prototype.compact = function() {
        return this.filter(Ct);
      }, ot.prototype.find = function(a) {
        return this.filter(a).head();
      }, ot.prototype.findLast = function(a) {
        return this.reverse().find(a);
      }, ot.prototype.invokeMap = rt(function(a, _) {
        return typeof a == "function" ? new ot(this) : this.map(function(p) {
          return Qs(p, a, _);
        });
      }), ot.prototype.reject = function(a) {
        return this.filter(Ji(Pe(a)));
      }, ot.prototype.slice = function(a, _) {
        a = ze(a);
        var p = this;
        return p.__filtered__ && (a > 0 || _ < 0) ? new ot(p) : (a < 0 ? p = p.takeRight(-a) : a && (p = p.drop(a)), _ !== r && (_ = ze(_), p = _ < 0 ? p.dropRight(-_) : p.take(_ - a)), p);
      }, ot.prototype.takeRightWhile = function(a) {
        return this.reverse().takeWhile(a).reverse();
      }, ot.prototype.toArray = function() {
        return this.take(Fr);
      }, Zn(ot.prototype, function(a, _) {
        var p = /^(?:filter|find|map|reject)|While$/.test(_), S = /^(?:head|last)$/.test(_), g = R[S ? "take" + (_ == "last" ? "Right" : "") : _], O = S || /^find/.test(_);
        g && (R.prototype[_] = function() {
          var P = this.__wrapped__, w = S ? [1] : arguments, Y = P instanceof ot, ne = w[0], te = Y || $e(P), se = function(st) {
            var ct = g.apply(R, Rn([st], w));
            return S && Se ? ct[0] : ct;
          };
          te && p && typeof ne == "function" && ne.length != 1 && (Y = te = !1);
          var Se = this.__chain__, ve = !!this.__actions__.length, We = O && !Se, qe = Y && !ve;
          if (!O && te) {
            P = qe ? P : new ot(this);
            var we = a.apply(P, w);
            return we.__actions__.push({ func: gn, args: [se], thisArg: r }), new dn(we, Se);
          }
          return We && qe ? a.apply(this, w) : (we = this.thru(se), We ? S ? we.value()[0] : we.value() : we);
        });
      }), cn(["pop", "push", "shift", "sort", "splice", "unshift"], function(a) {
        var _ = Vr[a], p = /^(?:push|sort|unshift)$/.test(a) ? "tap" : "thru", S = /^(?:pop|shift)$/.test(a);
        R.prototype[a] = function() {
          var g = arguments;
          if (S && !this.__chain__) {
            var O = this.value();
            return _.apply($e(O) ? O : [], g);
          }
          return this[p](function(P) {
            return _.apply($e(P) ? P : [], g);
          });
        };
      }), Zn(ot.prototype, function(a, _) {
        var p = R[_];
        if (p) {
          var S = p.name + "";
          mt.call(Qo, S) || (Qo[S] = []), Qo[S].push({ name: _, func: p });
        }
      }), Qo[It(r, Ne).name] = [{
        name: "wrapper",
        func: r
      }], ot.prototype.clone = ZT, ot.prototype.reverse = QT, ot.prototype.value = r_, R.prototype.at = ji, R.prototype.chain = lt, R.prototype.commit = lr, R.prototype.next = uA, R.prototype.plant = FS, R.prototype.reverse = BS, R.prototype.toJSON = R.prototype.valueOf = R.prototype.value = Ln, R.prototype.first = R.prototype.head, Jo && (R.prototype[Jo] = R_), R;
    }, xl = Gl();
    Ao ? ((Ao.exports = xl)._ = xl, jo._ = xl) : fr._ = xl;
  }).call(ln);
})(TS, TS.exports);
var mS = TS.exports;
const qM = {
  common_blocks: {
    colourPrimary: "#B38E20",
    colourTertiary: "#503D04"
  },
  event_blocks: {
    colourPrimary: "#984848",
    colourTertiary: "#542929"
  },
  action_blocks: {
    colourPrimary: "#79803B",
    colourTertiary: "#444917"
  },
  logic_blocks: {
    colourPrimary: "#205C48",
    colourTertiary: "#1D3D32"
  },
  condition_blocks: {
    colourPrimary: "#205C48",
    colourTertiary: "#1D3D32"
  },
  module_blocks: {
    colourPrimary: "#326884",
    colourTertiary: "#284C5E"
  },
  data_blocks: {
    colourPrimary: "#984877",
    colourTertiary: "#612046"
  },
  var_blocks: {
    colourPrimary: "#3B5383",
    colourTertiary: "#2A3957"
  },
  function_blocks: {
    colourPrimary: "#544280",
    colourTertiary: "#392D57"
  },
  enum_blocks: {
    colourPrimary: "#4F4F5B",
    colourTertiary: "#363636"
  },
  external_blocks: {
    colourPrimary: "#5148A1",
    colourTertiary: "#342E66"
  },
  shadow_blocks: {
    colourPrimary: "#3A3A3A",
    colourTertiary: "#333333"
  },
  comment_blocks: {
    colourPrimary: "#43414D",
    colourTertiary: "#363A41"
  },
  deprecated_blocks: {
    colourPrimary: "#48484D ",
    colourTertiary: "#363A41"
  },
  input_blocks: {
    colourPrimary: "#984877",
    colourTertiary: "#612046"
  },
  game_blocks: {
    colourPrimary: "#326884",
    colourTertiary: "#284C5E"
  },
  entity_blocks: {
    colourPrimary: "#79803B",
    colourTertiary: "#444917"
  }
}, eg = {}, tg = {
  workspaceBackgroundColour: "#14161B",
  toolboxBackgroundColour: "#C4C4C4",
  flyoutBackgroundColour: "#191B20",
  flyoutOpacity: 1,
  scrollbarColour: "#4D5158",
  scrollbarOpacity: 1
}, rg = {
  family: "Din, JhengHei",
  size: 12
}, hI = {
  blockStyles: qM,
  categoryStyles: eg,
  componentStyles: tg,
  fontStyle: rg,
  name: "customTheme"
}, Uh = mS.cloneDeep(hI);
Uh.blockStyles.input_blocks.colourPrimary = "#585555";
Uh.blockStyles.input_blocks.colourTertiary = "#747474";
X.Theme.defineTheme("customTheme", hI);
X.Theme.defineTheme("craftlandTheme", Uh);
const ng = `
  data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZ
  XdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMu
  b3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNiIgY3k9IjYiIHI9IjUuNSIgc3Ryb2t
  lPSIjQkFCRUM1Ii8+CjxjaXJjbGUgY3g9IjYiIGN5PSI2IiByPSIyIiBmaWxsPSIjQk
  FCRUM1Ii8+Cjwvc3ZnPgo=
`;
class ig extends X.blockRendering.ConstantProvider {
  constructor() {
    super();
    C(this, "IsCraftland");
    C(this, "DARK_PATH_OFFSET");
    C(this, "MAX_BOTTOM_WIDTH");
    C(this, "SPACER_WIDTH");
    C(this, "BREAKPOINT_RADUIS");
    C(this, "FIELD_RESOURCE_SELECTOR_SVG_SIZE");
    C(this, "FIELD_RESOURCE_SELECTOR_SVG_DATAURI");
    C(this, "EMPTY_INPUT_WIDTH");
    this.FIELD_TEXT_BASELINE_CENTER = !1, this.DARK_PATH_OFFSET = 1, this.MAX_BOTTOM_WIDTH = 30, this.STATEMENT_BOTTOM_SPACER = -this.NOTCH_HEIGHT, this.NOTCH_WIDTH = 28, this.NOTCH_HEIGHT = 4, this.NOTCH_OFFSET_LEFT = 13, this.TAB_WIDTH = 4, this.TAB_HEIGHT = 8, this.EMPTY_INLINE_INPUT_HEIGHT = this.TAB_HEIGHT + 14, this.TAB_OFFSET_FROM_TOP = 4, this.MEDIUM_PADDING = 6, this.LARGE_PADDING = 8, this.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT = this.LARGE_PADDING, this.FIELD_BORDER_RECT_X_PADDING = 8, this.FIELD_BORDER_RECT_Y_PADDING = 2, this.FIELD_BORDER_RECT_HEIGHT = 24, this.FIELD_IN_SHADOW_BORDER_RECT_HEIGHT = 20, this.FIELD_DROPDOWN_BORDER_RECT_HEIGHT = 24, this.FIELD_BORDER_RECT_RADIUS = 0, this.TOP_ROW_MIN_HEIGHT = 2, this.BOTTOM_ROW_MIN_HEIGHT = 2, this.DUMMY_INPUT_SHADOW_MIN_HEIGHT = 20, this.DUMMY_INPUT_MIN_HEIGHT = 20, this.MIN_BLOCK_HEIGHT = 24, this.FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW = !0, this.FIELD_BORDER_RECT_COLOUR = "#3E3E48", this.FIELD_DROPDOWN_SVG_ARROW = !0, this.SPACER_WIDTH = 10, this.FIELD_COLOUR_DEFAULT_HEIGHT = 20, this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6"><defs><style>.cls-1{fill: %23c3c3c3;fill-rule: evenodd;}</style></defs><path id="icon_ecaarrow" class="cls-1" d="M788,413h-2l-3,3-3-3h-2l5,5Z" transform="translate(-778 -412.5)"/></svg>', this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 9, this.CORNER_RADIUS = 0, this.BREAKPOINT_RADUIS = 3, this.FULL_BLOCK_FIELDS = !1, this.FIELD_RESOURCE_SELECTOR_SVG_SIZE = 12, this.FIELD_RESOURCE_SELECTOR_SVG_DATAURI = ng;
  }
  init() {
    super.init(), this.EMPTY_INPUT_WIDTH = this.IsCraftland ? 60 : 0, this.IsCraftland && (this.FIELD_DROPDOWN_SVG_ARROW_DATAURI = 'data:image/svg+xml;utf8,      <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">        <path d="M4 20L24 40L44 20" stroke="white" stroke-width="8" fill="none" stroke-linecap="round" stroke-linejoin="round"/>      </svg>', this.FIELD_DROPDOWN_SVG_ARROW_SIZE = 12);
  }
  shapeFor(r) {
    switch (r.type) {
      case X.ConnectionType.INPUT_VALUE:
      case X.ConnectionType.OUTPUT_VALUE:
        return this.PUZZLE_TAB;
      case X.ConnectionType.PREVIOUS_STATEMENT:
      case X.ConnectionType.NEXT_STATEMENT:
        return this.NOTCH;
      default:
        throw Error("Unknown connection type");
    }
  }
  makeNotch() {
    const r = this.NOTCH_WIDTH, o = this.NOTCH_HEIGHT, c = 10, T = 4;
    function d(b) {
      return X.utils.svgPaths.line([
        X.utils.svgPaths.point(b * T, o),
        X.utils.svgPaths.point(b * c * 2, 0),
        X.utils.svgPaths.point(b * T, -o)
      ]);
    }
    const h = d(1), y = d(-1);
    return {
      type: this.SHAPES.NOTCH,
      width: r,
      height: o,
      pathLeft: h,
      pathRight: y
    };
  }
  makePuzzleTab() {
    const r = this.TAB_WIDTH, o = this.TAB_HEIGHT / 2;
    function c(h) {
      return h ? X.utils.svgPaths.lineTo(-r, -o) + X.utils.svgPaths.lineTo(r, -o) : X.utils.svgPaths.lineTo(-r, o) + X.utils.svgPaths.lineTo(r, o);
    }
    const T = c(!0), d = c(!1);
    return {
      type: this.SHAPES.PUZZLE,
      width: r,
      height: o,
      pathDown: d,
      pathUp: T
    };
  }
  setFontConstants_(r) {
    r.fontStyle && r.fontStyle.family && (this.FIELD_TEXT_FONTFAMILY = r.fontStyle.family), r.fontStyle && r.fontStyle.weight && (this.FIELD_TEXT_FONTWEIGHT = r.fontStyle.weight), r.fontStyle && r.fontStyle.size && (this.FIELD_TEXT_FONTSIZE = r.fontStyle.size);
    const o = og(
      "Hg",
      this.FIELD_TEXT_FONTSIZE + "px",
      this.FIELD_TEXT_FONTWEIGHT,
      this.FIELD_TEXT_FONTFAMILY
    );
    this.FIELD_TEXT_HEIGHT = o.height, this.FIELD_TEXT_BASELINE = o.baseline;
  }
  getCSS_(r) {
    const o = this.IsCraftland ? "black" : "none";
    return super.getCSS_(r).concat([
      /* eslint-disable indent */
      // Insertion marker.
      r + " .blocklyInsertionMarker>.blocklyPathDark {",
      "fill-opacity: " + this.INSERTION_MARKER_OPACITY + ";",
      "stroke: none;",
      "}",
      r + " .blocklyText, ",
      r + " .blocklyFlyoutLabelText {",
      "font: " + this.FIELD_TEXT_FONTWEIGHT + " " + this.FIELD_TEXT_FONTSIZE + "px " + this.FIELD_TEXT_FONTFAMILY + ";",
      "}",
      r + " .blocklyFlyoutLabelText {",
      "fill: #797979;",
      "}",
      r + " .blocklyInvalidInput,",
      r + " .blocklyHtmlInput {",
      "font-family: " + this.FIELD_TEXT_FONTFAMILY + ";",
      "font-weight: " + this.FIELD_TEXT_FONTWEIGHT + ";",
      "text-align: center;",
      "color: #D9D9D9;",
      "}",
      r + " .blocklyEditableText>rect {",
      "fill: " + this.FIELD_BORDER_RECT_COLOUR + ";",
      "fill-opacity: 1;",
      `stroke: ${o};`,
      "}",
      r + " .blocklyNonEditableText>rect {",
      ...this.IsCraftland ? [
        "display: none;"
      ] : [
        "fill: " + this.FIELD_BORDER_RECT_COLOUR + ";",
        "fill-opacity: 1;",
        "stroke: none;"
      ],
      "}",
      r + " .blocklyNonEditableText>text,",
      r + " .blocklyEditableText>text {",
      "fill: #D9D9D9;",
      "}",
      r + " .shadow-block text {",
      "fill: #8e8e8e;",
      "}",
      r + " .blocklyNonEditableText>text.blocklyDropdownText tspan,",
      r + " .blocklyEditableText>text.blocklyDropdownText tspan {",
      "fill: #C3C3C3 !important;",
      "}",
      r + " .blocklySelected>.blocklyPath,",
      r + " .blocklyPathLight {",
      "stroke-width: 2px;",
      "display: inline;",
      "}",
      // Editable field hover.
      r + " .blocklyEditableText:not(.editing):hover>rect {",
      "stroke: #fff;",
      "stroke-width: 1;",
      "}"
      /* eslint-enable indent */
    ]);
  }
}
let uh = /* @__PURE__ */ new Map();
function og(i, l, r, o) {
  let c = i + l + r + o;
  if (uh.has(c))
    return uh.get(c);
  let T = X.utils.dom.measureFontMetrics(
    i,
    l,
    r,
    o
  );
  return uh.set(c, T), T;
}
const { svgPaths: yr } = X.utils, { Types: Ju, Connection: hm } = X.blockRendering;
class lg extends X.blockRendering.Drawer {
  constructor(r, o) {
    super(r, o);
    C(this, "cuteSquare_");
    C(this, "beakpoint_");
    this.cuteSquare_ = !this.block_.isShadow() && !this.block_.isInsertionMarker() && o.outputConnection ? new Sg(o) : null;
  }
  draw() {
    this.drawOutline_(), this.drawInternals_();
    const r = this.block_.pathObject;
    r.setPath(this.outlinePath_ + `
` + this.inlinePath_, this.outlinePath_), r.setBreakpoint(), this.cuteSquare_ && r.setSquarePath(this.cuteSquare_.getPath()), this.info_.RTL && r.flipRTL(), this.recordSizeOnBlock_();
  }
  drawTop_() {
    const r = this.info_.topRow, o = r.elements;
    this.positionPreviousConnection_(), this.outlinePath_ += yr.moveBy(r.xPos, this.info_.startY);
    for (let c = 0, T; T = o[c]; c++)
      Ju.isPreviousConnection(T) && T instanceof hm ? this.outlinePath_ += T.shape.pathLeft : Ju.isHat(T) ? this.outlinePath_ += this.constants_.START_HAT.path : Ju.isSpacer(T) && (this.outlinePath_ += yr.lineOnAxis("h", T.width));
    this.outlinePath_ += yr.lineOnAxis("v", r.height);
  }
  drawJaggedEdge_(r) {
    super.drawJaggedEdge_(r);
  }
  drawValueInput_(r) {
    const o = (
      /** @type {ExternalValueInput|InlineInput} */
      r.getLastInput()
    );
    this.positionExternalValueConnection_(r);
    const c = typeof o.shape.pathDown == "function" ? o.shape.pathDown(o.height) : o.shape.pathDown, T = (r.height - this.constants_.TAB_HEIGHT) / 2;
    this.outlinePath_ += yr.lineOnAxis("H", o.xPos + o.width) + yr.lineOnAxis("v", T) + c + yr.lineOnAxis("v", T);
  }
  drawStatementInput_(r) {
    const o = r.getLastInput(), c = o.xPos + o.notchOffset + o.shape.width, T = o.shape.pathRight + yr.lineOnAxis(
      "h",
      -o.notchOffset
    );
    this.outlinePath_ += yr.lineOnAxis("H", c) + T + yr.lineOnAxis("v", r.height + this.constants_.DARK_PATH_OFFSET) + yr.lineOnAxis("H", r.xPos + r.width), this.positionStatementInputConnection_(r);
  }
  drawRightSideRow_(r) {
    this.outlinePath_ += yr.lineOnAxis("H", r.xPos + r.width) + yr.lineOnAxis("V", r.yPos + r.height);
  }
  drawBottom_() {
    const r = this.info_.bottomRow, o = r.elements;
    this.positionNextConnection_();
    let c = 0, T = "";
    for (let d = o.length - 1, h; h = o[d]; d--)
      Ju.isNextConnection(h) && h instanceof hm ? T += h.shape.pathRight : Ju.isLeftSquareCorner(h) ? T += yr.lineOnAxis("H", r.xPos) : Ju.isSpacer(h) && (T += yr.lineOnAxis("h", h.width * -1));
    this.outlinePath_ += yr.lineOnAxis("V", r.baseline - c), this.outlinePath_ += T;
  }
  drawLeft_() {
    var o;
    const r = this.info_.outputConnection;
    if (this.positionOutputConnection_(), r) {
      const T = this.info_.bottomRow.baseline / 2 - this.constants_.TAB_HEIGHT / 2, d = typeof r.shape.pathUp == "function" ? r.shape.pathUp(r.height) : r.shape.pathUp;
      (o = this.cuteSquare_) == null || o.drawer(this.info_.startX - 1, this.info_.height - T), this.outlinePath_ += yr.lineOnAxis("v", -T) + d + X.utils.svgPaths.lineOnAxis("V", 0);
    }
    this.outlinePath_ += "z";
  }
  positionOutputConnection_() {
    if (this.info_.outputConnection) {
      const r = this.info_.startX + this.info_.outputConnection.connectionOffsetX, o = this.info_.RTL ? -r : r, T = this.info_.bottomRow.baseline / 2 - this.constants_.TAB_HEIGHT / 2;
      this.block_.outputConnection.setOffsetInBlock(o, T + 1);
    }
  }
  drawInlineInput_(r) {
    const o = r.width, c = r.height, T = r.centerline - c / 2, d = (r.height - this.constants_.TAB_HEIGHT) / 2, h = d, y = r.xPos + r.connectionWidth;
    this.inlinePath_ += yr.moveTo(y, T) + yr.lineOnAxis("v", d) + r.shape.pathDown + yr.lineOnAxis("v", h) + yr.lineOnAxis("h", o - r.connectionWidth) + yr.lineOnAxis("v", -c) + "z", this.positionInlineInputConnection_(r);
  }
  positionInlineInputConnection_(r) {
    const o = r.centerline - r.height / 2, c = (r.height - this.constants_.TAB_HEIGHT) / 2;
    if (r.connectionModel) {
      let T = r.xPos + r.connectionWidth + this.constants_.DARK_PATH_OFFSET;
      this.info_.RTL && (T *= -1), r.connectionModel.setOffsetInBlock(
        T,
        o + c + this.constants_.DARK_PATH_OFFSET
      );
    }
  }
  positionStatementInputConnection_(r) {
    const o = r.getLastInput();
    if (o.connectionModel) {
      let c = r.xPos + r.statementEdge + o.notchOffset;
      this.info_.RTL ? c *= -1 : c += this.constants_.DARK_PATH_OFFSET / 2, o.connectionModel.setOffsetInBlock(
        c,
        r.yPos + this.constants_.DARK_PATH_OFFSET
      );
    }
  }
  positionExternalValueConnection_(r) {
    const o = r.getLastInput(), c = (r.height - this.constants_.TAB_HEIGHT) / 2;
    if (o.connectionModel) {
      let T = r.xPos + r.width + this.constants_.DARK_PATH_OFFSET;
      this.info_.RTL && (T *= -1), o.connectionModel.setOffsetInBlock(T, r.yPos + c);
    }
  }
  positionNextConnection_() {
    const r = this.info_.bottomRow;
    if (r.connection) {
      const o = r.connection, c = o.xPos, T = (this.info_.RTL ? -c : c) + this.constants_.DARK_PATH_OFFSET / 2;
      o.connectionModel.setOffsetInBlock(
        T,
        r.baseline + this.constants_.DARK_PATH_OFFSET
      );
    }
  }
}
class sg extends X.blockRendering.InlineInput {
  constructor(l, r) {
    super(l, r), this.connectedBlock && (this.width += this.constants_.DARK_PATH_OFFSET, this.height += this.constants_.DARK_PATH_OFFSET);
  }
}
const { colour: mm, dom: bd, Svg: tS } = X.utils, { PathObject: ag } = X.blockRendering;
class _g extends ag {
  constructor(r, o, c) {
    super(r, o, c);
    C(this, "svgPathDark");
    C(this, "svgPathLight");
    C(this, "svgPathSquare");
    C(this, "svgPathPoint");
    C(this, "colourDark");
    C(this, "colourWhite");
    this.constants = c, this.svgPathDark = bd.createSvgElement(
      tS.PATH,
      { class: "blocklyPathDark", transform: "translate(1,1)" }
    ), this.svgRoot.insertBefore(this.svgPathDark, this.svgPath), this.svgPathLight = bd.createSvgElement(
      tS.PATH,
      { class: "blocklyPathLight" },
      this.svgRoot
    ), this.svgPathSquare = bd.createSvgElement(
      tS.PATH,
      { class: "blocklyPathSquare" },
      this.svgRoot
    ), this.svgPathPoint = bd.createSvgElement(
      tS.CIRCLE,
      { class: "beakpointPath", cx: 6, cy: 6, r: 0 },
      this.svgRoot
    ), this.colourDark = "#000000", this.colourWhite = "#ffffff";
  }
  setPath(r, o) {
    this.svgPath.setAttribute("d", r), this.svgPathDark.setAttribute("d", o), this.svgPathLight.setAttribute("d", r);
  }
  setSquarePath(r) {
    this.svgPathSquare.setAttribute("d", r);
  }
  setBreakpoint() {
    this.svgPathPoint.setAttribute("r", this.constants.BREAKPOINT_RADUIS);
  }
  flipRTL() {
    this.svgPath.setAttribute("transform", "scale(-1 1)"), this.svgPathLight.setAttribute("transform", "scale(-1 1)"), this.svgPathDark.setAttribute("transform", "translate(1,1) scale(-1 1)"), this.svgPathSquare.setAttribute("transform", "translate(1,1) scale(-1 1)");
  }
  applyColour(r) {
    this.svgPathLight.style.display = "", this.svgPathDark.style.display = "", this.svgPathDark.setAttribute("fill", this.colourDark), this.svgPathSquare.setAttribute("fill", "#FFC736"), this.applyBreakpointColor(r), super.applyColour(r);
  }
  applyBreakpointColor(r) {
    this.svgPathPoint.setAttribute("fill", "none"), this.svgPathPoint.setAttribute("stroke", "none");
  }
  setStyle(r) {
    this.style = r, this.colourDark = mm.blend("#000", this.style.colourPrimary, 0.2) || this.colourDark, this.colourWhite = mm.blend("#fff", this.style.colourPrimary, 0.3) || this.colourWhite;
  }
  updateHighlighted(r) {
    r ? (this.svgPathLight.setAttribute(
      "stroke",
      "#ffffff"
    ), this.svgPath.style.display = "none") : (this.svgPathLight.setAttribute("stroke", "none"), this.svgPath.style.display = "inline");
  }
  updateBreakpointStyle(r) {
    this.svgPath.style.display = r ? "inline" : "none";
  }
  updateShadow_(r) {
    r && (this.svgPathDark.setAttribute("fill", "none"), this.svgPath.setAttribute("stroke", "none"), this.svgPath.setAttribute("fill", "none"));
  }
  updateDisabled_(r) {
    super.updateDisabled_(r), r && (this.svgPathLight.setAttribute("stroke", "none"), this.svgPath.setAttribute("stroke", "none"));
  }
  updateSelected(r) {
    this.setClass_("blocklySelected", r), bd.hasClass(this.svgRoot, "blocklyDisabled") || this.svgPath.setAttribute(
      "fill",
      r ? this.colourWhite : this.style.colourPrimary
    );
  }
}
const {
  BottomRow: SR,
  ExternalValueInput: cg,
  Field: ug,
  InRowSpacer: Th,
  RenderInfo: Tg,
  TopRow: hR,
  Types: xe
} = X.blockRendering;
class pg extends Tg {
  constructor(l, r) {
    super(l, r);
  }
  getRenderer() {
    return this.renderer_;
  }
  createRows_() {
    this.populateTopRow_(), this.rows.push(this.topRow);
    let l = new X.blockRendering.InputRow(this.constants_);
    this.inputRows.push(l);
    const r = this.block_.getIcons();
    for (let c = 0, T; T = r[c]; c++) {
      const d = new X.blockRendering.Icon(this.constants_, T);
      (!this.isCollapsed || T.isShownWhenCollapsed()) && l.elements.push(d);
    }
    let o = null;
    for (let c = 0, T; T = this.block_.inputList[c]; c++)
      if (T.isVisible()) {
        this.shouldStartNewRow_(T, o) && (this.rows.push(l), l = new X.blockRendering.InputRow(this.constants_), this.inputRows.push(l));
        for (let d = 0, h; h = T.fieldRow[d]; d++) {
          let y = new ug(this.constants_, h, T), b = h.minWidth;
          y.width < b && (y.width = b), l.elements.push(y);
        }
        this.addInput_(T, l), o = T;
      }
    this.isCollapsed && (l.hasJaggedEdge = !0, l.elements.push(new X.blockRendering.JaggedEdge(this.constants_))), (l.elements.length || l.hasDummyInput) && this.rows.push(l), this.populateBottomRow_(), this.rows.push(this.bottomRow);
  }
  populateTopRow_() {
    const l = !!this.block_.previousConnection, r = (this.block_.hat ? this.block_.hat === "cap" : this.constants_.ADD_START_HATS) && !this.outputConnection && !l;
    let o = X.blockRendering.SquareCorner;
    if (this.topRow.elements.push(new o(this.constants_)), r) {
      const T = new X.blockRendering.Hat(this.constants_);
      this.topRow.elements.push(T), this.topRow.capline = T.ascenderHeight;
    } else
      l && (this.topRow.hasPreviousConnection = !0, this.topRow.connection = new X.blockRendering.PreviousConnection(
        this.constants_,
        this.block_.previousConnection
      ), this.topRow.elements.push(this.topRow.connection));
    this.block_.inputList.length && this.block_.inputList[0].type === X.inputTypes.STATEMENT && !this.block_.isCollapsed() ? this.topRow.minHeight = this.constants_.TOP_ROW_PRECEDES_STATEMENT_MIN_HEIGHT : l ? this.topRow.minHeight = this.constants_.NOTCH_HEIGHT + this.constants_.FIELD_BORDER_RECT_Y_PADDING : this.topRow.minHeight = this.constants_.TOP_ROW_MIN_HEIGHT, this.topRow.elements.push(new o(this.constants_, "right"));
  }
  populateBottomRow_() {
    this.bottomRow.hasNextConnection = !!this.block_.nextConnection, this.block_.inputList.length && this.block_.inputList[this.block_.inputList.length - 1].type === X.inputTypes.STATEMENT ? this.bottomRow.minHeight = this.constants_.BOTTOM_ROW_AFTER_STATEMENT_MIN_HEIGHT : this.bottomRow.hasNextConnection && this.block_.inputList.find((r) => r.type !== X.inputTypes.DUMMY) ? this.bottomRow.minHeight = this.constants_.NOTCH_HEIGHT + this.constants_.FIELD_BORDER_RECT_Y_PADDING : this.bottomRow.minHeight = this.constants_.BOTTOM_ROW_MIN_HEIGHT, this.bottomRow.elements.push(new X.blockRendering.SquareCorner(this.constants_)), this.bottomRow.hasNextConnection && (this.bottomRow.connection = new X.blockRendering.NextConnection(
      this.constants_,
      this.block_.nextConnection
    ), this.bottomRow.elements.push(this.bottomRow.connection)), this.bottomRow.elements.push(new X.blockRendering.SquareCorner(this.constants_, "right"));
  }
  addInput_(l, r) {
    if (this.isInline && l.type === X.inputTypes.VALUE) {
      let o = new sg(this.constants_, l);
      o.connectedBlock || o.width < this.constants_.EMPTY_INPUT_WIDTH && (o.width = this.constants_.EMPTY_INPUT_WIDTH), r.elements.push(o), r.hasInlineInput = !0;
    } else
      l.type === X.inputTypes.STATEMENT ? (r.elements.push(new Eg(this.constants_, l)), r.hasStatement = !0) : l.type === X.inputTypes.VALUE ? (r.elements.push(new cg(this.constants_, l)), r.hasExternalInput = !0) : l.type === X.inputTypes.DUMMY && (r.minHeight = Math.max(r.minHeight, this.constants_.DUMMY_INPUT_MIN_HEIGHT), r.hasDummyInput = !0);
    !this.isInline && r.align === null && (r.align = X.ALIGN_LEFT);
  }
  addElemSpacing_() {
    let l = !1;
    for (let r = 0, o; o = this.rows[r]; r++)
      o.hasExternalInput && (l = !0);
    for (let r = 0, o; o = this.rows[r]; r++) {
      const c = o.elements;
      if (o.elements = [], o.startsWithElemSpacer() && o.elements.push(new Th(
        this.constants_,
        this.getInRowSpacing_(null, c[0])
      )), !!c.length) {
        for (let T = 0; T < c.length - 1; T++) {
          o.elements.push(c[T]);
          const d = this.getInRowSpacing_(c[T], c[T + 1]);
          o.elements.push(new Th(this.constants_, d));
        }
        if (o.elements.push(c[c.length - 1]), o.elements.length && o.endsWithElemSpacer()) {
          let T = this.getInRowSpacing_(c[c.length - 1], null);
          l && o.hasDummyInput && (T += this.constants_.TAB_WIDTH), o.elements.push(new Th(this.constants_, T));
        }
      }
    }
  }
  getInRowSpacing_(l, r) {
    if (!l)
      return r && xe.isField(r) && /** @type {Field} */
      r.isEditable ? this.constants_.SPACER_WIDTH : r && xe.isInlineInput(r) ? this.constants_.SPACER_WIDTH : r && xe.isStatementInput(r) ? this.constants_.STATEMENT_INPUT_PADDING_LEFT : this.constants_.FIELD_BORDER_RECT_X_PADDING;
    if (!xe.isInput(l) && (!r || xe.isStatementInput(r)))
      return xe.isField(l) && /** @type {Field} */
      l.isEditable ? this.constants_.SPACER_WIDTH : xe.isIcon(l) ? this.constants_.LARGE_PADDING * 2 + 1 : xe.isHat(l) ? this.constants_.NO_PADDING : xe.isPreviousOrNextConnection(l) ? this.constants_.LARGE_PADDING : xe.isLeftRoundedCorner(l) ? this.constants_.MIN_BLOCK_WIDTH : xe.isJaggedEdge(l) ? this.constants_.NO_PADDING : this.constants_.FIELD_BORDER_RECT_X_PADDING;
    if (xe.isInput(l) && !r) {
      if (xe.isExternalInput(l))
        return this.constants_.NO_PADDING;
      if (xe.isInlineInput(l))
        return this.constants_.SPACER_WIDTH;
      if (xe.isStatementInput(l))
        return this.constants_.NO_PADDING;
    }
    if (!xe.isInput(l) && r && xe.isInput(r)) {
      if (xe.isField(l) && /** @type {Field} */
      l.isEditable) {
        if (xe.isInlineInput(r))
          return this.constants_.SPACER_WIDTH;
        if (xe.isExternalInput(r))
          return this.constants_.SPACER_WIDTH;
      } else {
        if (xe.isInlineInput(r))
          return this.constants_.SPACER_WIDTH;
        if (xe.isExternalInput(r))
          return this.constants_.SPACER_WIDTH;
        if (xe.isStatementInput(r))
          return this.constants_.SPACER_WIDTH;
      }
      return this.constants_.SPACER_WIDTH - 1;
    }
    if (xe.isIcon(l) && r && !xe.isInput(r))
      return this.constants_.SPACER_WIDTH;
    if (xe.isInlineInput(l) && r && xe.isField(r))
      return (
        /** @type {Field} */
        r.isEditable ? this.constants_.SPACER_WIDTH : this.constants_.SPACER_WIDTH
      );
    if (xe.isLeftSquareCorner(l) && r) {
      if (xe.isHat(r))
        return this.constants_.NO_PADDING;
      if (xe.isPreviousConnection(r))
        return r.notchOffset;
      if (xe.isNextConnection(r)) {
        const o = (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET / 2;
        return r.notchOffset + o;
      }
    }
    if (xe.isLeftRoundedCorner(l) && r) {
      if (xe.isPreviousConnection(r))
        return r.notchOffset - this.constants_.CORNER_RADIUS;
      if (xe.isNextConnection(r)) {
        const o = (this.RTL ? 1 : -1) * this.constants_.DARK_PATH_OFFSET;
        return r.notchOffset - this.constants_.CORNER_RADIUS + o;
      }
    }
    return xe.isField(l) && r && xe.isField(r) && /** @type {Field} */
    l.isEditable === /** @type {Field} */
    r.isEditable ? this.constants_.SPACER_WIDTH : r && xe.isJaggedEdge(r) ? this.constants_.SPACER_WIDTH : this.constants_.FIELD_BORDER_RECT_X_PADDING;
  }
  getSpacerRowHeight_(l, r) {
    return xe.isTopRow(l) && xe.isBottomRow(r) ? this.constants_.EMPTY_BLOCK_SPACER_HEIGHT : xe.isTopRow(l) || xe.isBottomRow(r) ? this.constants_.NO_PADDING : l.hasExternalInput && r.hasExternalInput ? this.constants_.LARGE_PADDING : !l.hasStatement && r.hasStatement ? this.constants_.BETWEEN_STATEMENT_PADDING_Y : l.hasStatement && r.hasStatement ? this.constants_.LARGE_PADDING : !l.hasStatement && r.hasDummyInput ? this.constants_.LARGE_PADDING : l.hasDummyInput ? this.constants_.LARGE_PADDING : this.constants_.MEDIUM_PADDING;
  }
  getElemCenterline_(l, r) {
    if (xe.isSpacer(r))
      return l.yPos + r.height / 2;
    if (xe.isBottomRow(l)) {
      const c = (
        /** @type {!BottomRow} */
        l
      ), T = c.yPos + c.height - c.descenderHeight;
      return xe.isNextConnection(r) ? T + r.height / 2 : T - r.height / 2;
    }
    if (xe.isTopRow(l)) {
      const c = (
        /** @type {!TopRow} */
        l
      );
      return xe.isHat(r) ? c.capline - r.height / 2 : c.capline + r.height / 2;
    }
    let o = l.yPos;
    return o += l.height / 2, o;
  }
  alignRowElements_() {
    if (!this.isInline) {
      super.alignRowElements_();
      return;
    }
    let l = 0;
    const r = /* @__PURE__ */ new WeakMap();
    let o = null;
    for (let T = this.rows.length - 1, d; d = this.rows[T]; T--)
      r.set(d, l), xe.isInputRow(d) && (d.hasStatement && this.alignStatementRow_(d), o && o.hasStatement && d.width < o.width ? r.set(d, o.width) : l = Math.max(d.width, l), o = d);
    let c = 0;
    for (let T = 0, d; d = this.rows[T]; T++)
      if (d.hasStatement)
        c = this.getDesiredRowWidth_(d);
      else if (xe.isSpacer(d))
        d.width = Math.max(c, r.get(d));
      else {
        const h = d.width, b = Math.max(c, r.get(d)) - h;
        b > 0 && this.addAlignmentPadding_(d, b), c = d.width;
      }
  }
  getDesiredRowWidth_(l) {
    return this.isInline && l.hasStatement ? this.statementEdge + this.constants_.MAX_BOTTOM_WIDTH + this.startX : super.getDesiredRowWidth_(l);
  }
  finalize_() {
    let l = 0, r = 0;
    for (let o = 0, c; c = this.rows[o]; o++) {
      c.yPos = r, c.xPos = this.startX, r += c.height, l = Math.max(l, c.widthWithConnectedBlocks);
      const T = r - this.topRow.ascenderHeight;
      if (c === this.bottomRow && T < this.constants_.MIN_BLOCK_HEIGHT) {
        const d = this.constants_.MIN_BLOCK_HEIGHT - T;
        this.bottomRow.height += d, r += d;
      }
      this.recordElemPositions_(c);
    }
    this.outputConnection && this.block_.nextConnection && this.block_.nextConnection.isConnected() && (l = Math.max(
      l,
      this.block_.nextConnection.targetBlock().getHeightWidth().width - this.constants_.DARK_PATH_OFFSET
    )), this.bottomRow.baseline = r - this.bottomRow.descenderHeight, this.widthWithChildren = l + this.startX + this.constants_.DARK_PATH_OFFSET, this.width += this.constants_.DARK_PATH_OFFSET, this.height = r, this.block_.isShadow() || (this.height += this.constants_.DARK_PATH_OFFSET), this.startY = this.topRow.capline;
  }
}
class dg extends X.blockRendering.StatementInput {
  constructor(l, r) {
    super(l, r), this.connectedBlock && (this.height += this.constants_.DARK_PATH_OFFSET);
  }
}
const Eg = dg;
class Ag {
  constructor(l) {
    C(this, "info_");
    C(this, "RTL_");
    C(this, "constants_");
    C(this, "offset_", 1);
    C(this, "outsidePaths_");
    C(this, "len", 4);
    this.info_ = l, this.RTL_ = this.info_.RTL;
    const r = l.getRenderer();
    this.constants_ = r.getConstants(), this.outsidePaths_ = "";
  }
  getPath() {
    return this.outsidePaths_;
  }
  drawer(l, r) {
    this.outsidePaths_ += X.utils.svgPaths.moveTo(l + this.offset_, r - this.offset_) + X.utils.svgPaths.lineTo(this.len, -this.len) + X.utils.svgPaths.lineTo(-this.len, -this.len) + X.utils.svgPaths.lineTo(-this.len, this.len) + X.utils.svgPaths.lineTo(this.len, this.len);
  }
}
const Sg = Ag;
class hg extends X.blockRendering.Renderer {
  constructor(l) {
    super(l);
  }
  init(l, r) {
    super.init(l, r);
  }
  refreshDom(l, r) {
    super.refreshDom(l, r);
  }
  makeConstants_() {
    return new ig();
  }
  makeRenderInfo_(l) {
    return new pg(this, l);
  }
  makeDrawer_(l, r) {
    return new lg(l, r);
  }
  makePathObject(l, r) {
    return new _g(l, r, this.getConstants());
  }
}
X.blockRendering.register("eca_renderer", hg);
class Rt {
  Equals(l) {
    return this === l;
  }
  GetHashCode() {
    return de.GetHashCode(this.toString());
  }
  ToString() {
    return this.GetType().Name;
  }
  toString() {
    return this.ToString();
  }
  GetType() {
    return new Gh(this.constructor.toString().match(/function (\w*)/)[1]);
  }
  static ReferenceEquals(l, r) {
    return l === r;
  }
  static GenericEquals(l, r) {
    return typeof l == "object" ? l.Equals(r) : l === r;
  }
  static GenericToString(l) {
    return typeof l == "object" ? l.ToString() : l.toString();
  }
  static GenericGetHashCode(l) {
    return typeof l == "object" ? l.GetHashCode() : de.GetHashCode(this.toString());
  }
}
class vn extends Rt {
  constructor(r = "") {
    super();
    C(this, "Message");
    this.Message = r;
  }
  ToString() {
    return "Exception: " + this.Message;
  }
}
class kr {
  static IndexOf(l, r) {
    var o, c = l.length;
    for (o = 0; o < c; o++)
      if (l[o] === r)
        return o;
    return -1;
  }
  static ToEnumerable(l) {
    return new MI(l);
  }
  static Resize(l, r) {
    if (l[0] === null) {
      l[0] = new Array(r);
      return;
    }
    if (l[0].length !== r)
      throw new j_();
  }
  static ConvertAll(l, r) {
    return l.map(r);
  }
  static Reverse(l) {
    l.reverse();
  }
  static FindAll(l, r) {
    return l.filter(r);
  }
}
class Im {
  static Parse(l, r, o) {
    return parseFloat(l);
  }
  static ToString(l, r, o) {
    return l.toString();
  }
  static GetHashCode(l) {
    return l;
  }
  static IsInfinity(l) {
    return l === 1 / 0;
  }
  static TryParse(l, r) {
    try {
      return r[0] = parseFloat(l), !0;
    } catch {
      return r[0] = 0, !1;
    }
  }
  static IsNaN(l) {
    return isNaN(l);
  }
}
const Bd = class Bd {
  static escapeRegExp(l) {
    var r = /[\\^$.*+?()[\]{}|]/g, o = RegExp(r.source);
    return l && o.test(l) ? l.replace(o, "\\$&") : l;
  }
  static IndexOf(l, r, o) {
    var c;
    return typeof r == "number" ? c = String.fromCharCode(r) : c = r, l.indexOf(c, o);
  }
  static LastIndexOf(l, r, o) {
    var c;
    return typeof r == "number" ? c = String.fromCharCode(r) : c = r, l.lastIndexOf(c, o);
  }
  static IndexOfAny(l, r, o = 0) {
    for (var c = o; c < l.length; ++c)
      for (var T = l.charCodeAt(c), d = 0; d < r.length; ++d)
        if (T == r[d])
          return c;
    return -1;
  }
  static GetHashCode(l) {
    var r = 0, o, c, T;
    if (l.length == 0)
      return r;
    for (o = 0, c = l.length; o < c; o++)
      T = l.charCodeAt(o), r = (r << 5) - r + T, r |= 0;
    return r;
  }
  static Replace(l, r, o) {
    var c = typeof r == "number" ? String.fromCharCode(r) : r, T = typeof o == "number" ? String.fromCharCode(o) : o;
    return l.replace(c, T);
  }
  static Substring(l, r, o = -1) {
    return o < 0 ? l.substr(r) : l.substr(r, o);
  }
  /*static Remove(str: string, startIndex: number): string*/
  static Remove(l, r, o) {
    return typeof o === void 0 ? l.substring(0, r) : l.substring(0, r) + l.substring(r + o);
  }
  /*static Remove(str: string, startIndex: number, length?: number): string
  {
  	throw new NotImplementedException(); // do we care that ts->js compiler will get rid of this syntactic sugar?
  }*/
  static Trim(l, r) {
    if (r == null)
      return l.trim();
    let o = 0;
    for (; o < l.length && r.includes(l.charCodeAt(o)); )
      o++;
    let c = l.length - 1;
    for (; c >= 0 && r.includes(l.charCodeAt(c)); )
      c--;
    return l.substring(o, c + 1);
  }
  static TrimStart(l, r = [
    32
    /* space */
  ]) {
    let o = 0;
    for (; o < l.length && r.includes(l.charCodeAt(o)); )
      o++;
    return l.substring(o);
  }
  static TrimEnd(l, r = [
    32
    /* space */
  ]) {
    let o = l.length - 1;
    for (; o >= 0 && r.includes(l.charCodeAt(o)); )
      o--;
    return l.substring(0, o + 1);
  }
  static ToUpperInvariant(l) {
    return l.toUpperCase();
  }
  static ToLowerInvariant(l) {
    return l.toLowerCase();
  }
  static Contains(l, r) {
    return l.indexOf(r) >= 0;
  }
  static StartsWith(l, r, o) {
    return l.indexOf(r) === 0;
  }
  static EndsWith(l, r, o) {
    let c = l.lastIndexOf(r);
    return c >= 0 && c == l.length - r.length;
  }
  static Format(l, r, o, c, T, d, h) {
    if (r.constructor === Array) {
      for (var y = l, b = r.length; b--; )
        y = y.replace(new RegExp("\\{" + b + "\\}", "gm"), r[b]);
      return y;
    } else {
      var U = [r, o, c, T, d, h];
      return Bd.Format(l, U);
    }
  }
  static IsNullOrEmpty(l) {
    return !l;
  }
  static Join(l, r) {
    return r.join(l);
  }
  static Concat(l) {
    throw new j_();
  }
  static FromChars(l, r = 1) {
    if (typeof l == "number") {
      for (var o = String.fromCharCode(l), c = 1; c < r; c++)
        o += String.fromCharCode(l);
      return o;
    }
    throw new j_();
  }
  static Split(l, r, o) {
    var c = new RegExp(`[${Bd.escapeRegExp(String.fromCharCode(...r))}]`);
    return l.split(c);
  }
};
C(Bd, "Empty", "");
let de = Bd;
var Vh = /* @__PURE__ */ ((i) => (i[i.RemoveEmptyEntries = 0] = "RemoveEmptyEntries", i))(Vh || {});
class Gh extends Rt {
  constructor(l) {
    super(), this.Name = l;
  }
  Equals(l) {
    return l instanceof Gh && l.Name === this.Name;
  }
}
class mg extends vn {
}
class mI {
}
C(mI, "NewLine", `
`);
class Ig extends Rt {
  constructor() {
    super(...arguments);
    C(this, "NumberDecimalSeparator", ".");
    C(this, "NumberGroupSeparator", ",");
  }
}
const SS = class SS extends Rt {
};
C(SS, "UTF8", new SS());
let Mm = SS;
const qu = class qu extends Rt {
  constructor(r) {
    super();
    C(this, "Name", "Invariant");
    C(this, "nfi", new Ig());
  }
  GetFormat(r) {
    return r.Name === "NumberFormatInfo" ? this.nfi : null;
  }
};
C(qu, "InvariantCulture", new qu("Invariant")), C(qu, "CurrentCulture", qu.InvariantCulture);
let gm = qu;
class j_ extends vn {
  constructor(l = "Not implemented") {
    super(l);
  }
}
class it extends Rt {
  constructor(r) {
    super();
    C(this, "array", new Array());
    arguments.length == 1 && r.constructor !== Number && this.AddRange(r);
  }
  [Symbol.iterator]() {
    return this.array[Symbol.iterator]();
  }
  Add(r) {
    this.array.push(r);
  }
  AddRange(r) {
    for (var o = r.GetEnumerator(); o.MoveNext(); )
      this.Add(o.Current);
  }
  get Count() {
    return this.array.length;
  }
  get_Item(r) {
    return this.array[r];
  }
  set_Item(r, o) {
    this.array[r] = o;
  }
  GetEnumerator() {
    return new gI(this);
  }
  Remove(r) {
    var o = this.IndexOf(r);
    return o >= 0 ? (this.RemoveAt(o), !0) : !1;
  }
  RemoveAt(r) {
    this.array.splice(r, 1);
  }
  RemoveRange(r, o) {
    this.array.splice(r, o);
  }
  Insert(r, o) {
    this.array.splice(r, 0, o);
  }
  Clear() {
    this.array = new Array();
  }
  Sort(r) {
    this.array.sort(r);
  }
  ToArray() {
    return this.array.slice(0);
  }
  RemoveAll(r) {
    for (var o = new Array(), c = 0; c < this.array.length; c++)
      r(this.array[c]) || o.push(this.array[c]);
    this.array = o;
  }
  FindAll(r) {
    return new MI(this.array.filter(r));
  }
  Reverse() {
    this.array.reverse();
  }
  IndexOf(r) {
    return this.array.indexOf(r);
  }
  ForEach(r) {
    this.array.forEach(r);
  }
  FindIndex(r) {
    return this.array.findIndex(r);
  }
  Find(r) {
    return this.array.find(r);
  }
  Contains(r) {
    return this.array.indexOf(r) >= 0;
  }
}
class II extends Rt {
  constructor(r) {
    super();
    C(this, "array");
    C(this, "index", -1);
    this.array = r;
  }
  MoveNext() {
    return this.index++, this.index < this.array.length;
  }
  get Current() {
    return this.array[this.index];
  }
  Dispose() {
  }
}
class MI extends Rt {
  constructor(r) {
    super();
    C(this, "array");
    this.array = r;
  }
  GetEnumerator() {
    return new II(this.array);
  }
  [Symbol.iterator]() {
    return this.array[Symbol.iterator]();
  }
}
class gI extends II {
  constructor(l) {
    super(l.array);
  }
}
class Cl extends Rt {
  constructor(r) {
    super();
    C(this, "store");
    this.store = new Set(r);
  }
  [Symbol.iterator]() {
    return this.store[Symbol.iterator]();
  }
  Add(r) {
    return this.store.has(r) ? !1 : (this.store.add(r), !0);
  }
  Remove(r) {
    return this.store.has(r) ? (this.store.delete(r), !0) : !1;
  }
  GetEnumerator() {
    return new Mg(this);
  }
  Contains(r) {
    return this.store.has(r);
  }
  get Count() {
    return this.store.size;
  }
  Clear() {
    this.store.clear();
  }
}
class Mg extends Rt {
  constructor(r) {
    super();
    C(this, "iterator");
    C(this, "Current");
    this.iterator = r.store[Symbol.iterator]();
  }
  Dispose() {
  }
  MoveNext() {
    let r = this.iterator.next();
    return this.Current = r.value, !r.done;
  }
}
class LI extends Rt {
  constructor(r, o) {
    super();
    C(this, "Key");
    C(this, "Value");
    this.Key = r, this.Value = o;
  }
}
class gg {
  constructor(l) {
    C(this, "iter");
    this.iter = l;
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    let l = this.iter.next();
    return {
      done: l.done,
      value: l.value == null ? l.value : new LI(l.value[0], l.value[1])
    };
  }
}
class ro extends Rt {
  constructor(r) {
    super();
    C(this, "map", /* @__PURE__ */ new Map());
  }
  [Symbol.iterator]() {
    return new gg(this.map[Symbol.iterator]());
  }
  get_Item(r) {
    return this.map.get(r);
  }
  set_Item(r, o) {
    this.map.set(r, o);
  }
  Add(r, o) {
    if (this.map.has(r))
      throw new mg();
    this.map.set(r, o);
  }
  ContainsKey(r) {
    return this.map.has(r);
  }
  TryGetValue(r, o) {
    let c = this.map.get(r);
    return c != null ? (o[0] = c, !0) : !1;
  }
  Remove(r) {
    this.map.delete(r);
  }
  Clear() {
    this.map.clear();
  }
  get Count() {
    return this.map.size;
  }
  GetEnumerator() {
    var r = new it();
    for (var o of this.map)
      r.Add(new LI(o[0], o[1]));
    return new Lg(r);
  }
  get Keys() {
    var r = new Ng();
    for (var o of this.map)
      r.Add(o[0]);
    return r;
  }
  get Values() {
    var r = new yg();
    for (var o of this.map)
      r.Add(o[1]);
    return r;
  }
}
class Lg extends gI {
  constructor(l) {
    super(l);
  }
}
class Ng extends it {
}
class yg extends it {
}
class fg extends Rt {
  constructor() {
    super(...arguments);
    C(this, "parts", new Array());
  }
  Append(r) {
    var o = typeof r == "number" ? String.fromCharCode(r) : r;
    this.parts.push(o);
  }
  AppendLine(r) {
    r != null && this.parts.push(r), this.parts.push(mI.NewLine);
  }
  AppendFormat(r, o, c, T) {
    throw new j_();
  }
  ToString() {
    return this.parts.join("");
  }
  get Length() {
    for (var r = 0, o = 0; o < this.parts.length; o++)
      r += this.parts[o].length;
    return r;
  }
  Clear() {
    return this.parts.length = 0, this;
  }
  get_Item(r) {
    for (var o = 0, c = 0; c < this.parts.length; ++c) {
      var T = this.parts[c];
      if (r < o + T.length)
        return T.charCodeAt(r - o);
      o += T.length;
    }
    return 0;
  }
}
class Bo extends Rt {
  static ToArray(l) {
    const r = [], o = l.GetEnumerator();
    for (; o.MoveNext(); )
      r.push(o.Current);
    return r;
  }
  static ToList(l) {
    return new it(l);
  }
  static Empty() {
    return new it();
  }
  static Range(l, r) {
    for (var o = l + r, c = new it(), T = l; T < o; T++)
      c.Add(T);
    return c;
  }
  static Select(l, r) {
    for (var o = new it(), c = l.GetEnumerator(); c.MoveNext(); )
      o.Add(r(c.Current));
    return o;
  }
  static SelectMany(l, r, o) {
    throw new j_();
  }
  static Where(l, r) {
    for (var o = new it(), c = l.GetEnumerator(); c.MoveNext(); )
      r(c.Current) && o.Add(c.Current);
    return o;
  }
  static OrderBy(l, r) {
    for (var o = new it(), c = l.GetEnumerator(); c.MoveNext(); )
      o.Add(c.Current);
    return o.array.sort(function(T, d) {
      var h = r(T), y = r(d);
      return h === y ? 0 : h < y ? -1 : 1;
    }), o;
  }
  static OrderByDescending(l, r) {
    for (var o = new it(), c = l.GetEnumerator(); c.MoveNext(); )
      o.Add(c.Current);
    return o.array.sort(function(T, d) {
      var h = r(T), y = r(d);
      return h === y ? 0 : h < y ? 1 : -1;
    }), o;
  }
  static ThenBy(l, r) {
    return Bo.OrderBy(l, r);
  }
  static Concat(l, r) {
    var o = new it(l);
    return o.AddRange(r), o;
  }
  static Take(l, r) {
    for (var o = new it(), c = l.GetEnumerator(); o.Count < r && c.MoveNext(); )
      o.Add(c.Current);
    return o;
  }
  static Skip(l, r) {
    for (var o = new it(), c = l.GetEnumerator(), T = 0; c.MoveNext(); )
      T >= r && o.Add(c.Current), T++;
    return o;
  }
  static Distinct(l) {
    throw new j_();
  }
  static Cast(l) {
    return l;
  }
  static OfType(l) {
    throw new j_();
  }
  static Contains(l, r) {
    if (typeof l == "string") {
      for (let c = 0; c < l.length; ++c)
        if (l.charCodeAt(c) == r)
          return !0;
    } else
      for (var o = l.GetEnumerator(); o.MoveNext(); )
        if (o.Current === r)
          return !0;
    return !1;
  }
  static FirstOrDefault(l, r) {
    for (var o = l.GetEnumerator(); o.MoveNext(); )
      if (r == null || r(o.Current))
        return o.Current;
    return null;
  }
  static LastOrDefault(l, r) {
    for (var o = l.GetEnumerator(), c = null; o.MoveNext(); )
      (r == null || r(o.Current)) && (c = o.Current);
    return c;
  }
  static Last(l, r) {
    for (var o = l.GetEnumerator(), c = void 0, T = !1; o.MoveNext(); )
      (r == null || r(o.Current)) && (c = o.Current, T = !0);
    if (T && c)
      return c;
    throw new vn("Not found");
  }
  static First(l, r) {
    for (var o = l.GetEnumerator(); o.MoveNext(); )
      if (r == null || r(o.Current))
        return o.Current;
    throw new vn("Not found");
  }
  static Any(l, r) {
    for (var o = l.GetEnumerator(); o.MoveNext(); )
      if (r(o.Current))
        return !0;
    return !1;
  }
  static All(l, r) {
    for (var o = l.GetEnumerator(); o.MoveNext(); )
      if (!r(o.Current))
        return !1;
    return !0;
  }
  static Count(l, r) {
    for (var o = 0, c = l.GetEnumerator(); c.MoveNext(); )
      (r == null || r(c.Current)) && ++o;
    return o;
  }
  static Sum(l, r) {
    for (var o = 0, c = l.GetEnumerator(); c.MoveNext(); )
      o += r != null ? r(c.Current) : c.Current;
    return o;
  }
  static Max(l, r) {
    for (var o = Number.MIN_VALUE, c = l.GetEnumerator(); c.MoveNext(); ) {
      var T = r != null ? r(c.Current) : c.Current;
      T > o && (o = T);
    }
    return o;
  }
  static Min(l, r) {
    for (var o = Number.MAX_VALUE, c = l.GetEnumerator(); c.MoveNext(); ) {
      var T = r != null ? r(c.Current) : c.Current;
      T < o && (o = T);
    }
    return o;
  }
  static ToDictionary(l, r, o) {
    for (var c = new ro(), T = l.GetEnumerator(); T.MoveNext(); ) {
      var d = T.Current, h = r(d), y = o(d);
      c.Add(h, y);
    }
    return c;
  }
}
class ph extends Rt {
  static WriteLine(l) {
    console.log(l);
  }
  static Assert(l, r) {
    if (!l)
      throw new vn(r);
  }
}
const eT = class eT extends Rt {
  constructor() {
    super();
    C(this, "ManagedThreadId");
    this.ManagedThreadId = eT.nextId++;
  }
};
C(eT, "nextId", 1), C(eT, "CurrentThread", new eT());
let Lm = eT;
function Nm(i) {
  let l = new Rt();
  return Object.assign(l, i), l;
}
function Cg(i, l) {
  return l instanceof i ? l : null;
}
class vt extends Rt {
  constructor(r, o = "") {
    super();
    C(this, "Name", "");
    C(this, "Label", "");
    C(this, "Tip", "");
    this.Name = r, de.IsNullOrEmpty(o) ? this.Label = r : this.Label = o;
  }
  static op_Implicit(r) {
    return new vt(r, "");
  }
}
class pe extends Rt {
  constructor() {
    super();
  }
}
C(pe, "Prop_LeftValue", "left"), C(pe, "Prop_RightValue", "right"), C(pe, "Prop_Condition", "Condition"), C(pe, "Prop_This", "this"), C(pe, "Prop_Index", "index"), C(pe, "Prop_Value", "value"), C(pe, "Prop_Signature", "signature"), C(pe, "Prop_Body", "content"), C(pe, "Prop_TemplateList", "functions"), C(pe, "Prop_TruthBlock", "truth"), C(pe, "Prop_FalseBlock", "false"), C(pe, "Prop_Element", "element"), C(pe, "Prop_Do", "do"), C(pe, "Prop_VarDefines", "variables"), C(pe, "Prop_Start", "start"), C(pe, "Prop_End", "end"), C(pe, "Prop_Step", "step"), C(pe, "Prop_X", "X"), C(pe, "Prop_Y", "Y"), C(pe, "Prop_Z", "Z"), C(pe, "Key_Out", "out"), C(pe, "CONTROLS_IF", "if"), C(pe, "CONTROLS_FOR", "for"), C(pe, "CONTROLS_FOREACH", "foreach"), C(pe, "CONTROLS_WHILE", "while"), C(pe, "CONTROLS_BREAK", "break"), C(pe, "CONTROLS_CONTINUE", "continue"), C(pe, "CONTROLS_RETURN", "return"), C(pe, "COMPARE_GRAPH", "Compare"), C(pe, "ARITH_GRAPH", "Arithmetic"), C(pe, "ENTITY_PICKENTITY", "pickEntity"), C(pe, "ENTITY_GETPROPERTY", "getProperty"), C(pe, "ENTITY_SETPROPERTY", "setProperty"), C(pe, "ENTITY_THISENTITY", "thisEntity"), C(pe, "TRUE", "true"), C(pe, "FALSE", "false"), C(pe, "GlobalScope", "G"), C(pe, "MechanismScope", "K"), C(pe, "ARITHMETIC", "Arithmetic"), C(pe, "CONDITION", "Condition"), C(pe, "ACTIONBLOCK", "ActionBlock"), C(pe, "CALLTYPE_WAIT", "wait"), C(pe, "CALLTYPE_START", "start"), C(pe, "CONDITION_IF", "if"), C(pe, "CONDITION_ELSEIF", "else if"), C(pe, "CONDITION_ELSE", "else"), C(pe, "ROOT_ECASYSTEM", "/ECASystem"), C(pe, "SetOp_Set", ""), C(pe, "SetOp_Inc", "Inc"), C(pe, "SetOp_Dec", "Dec"), C(pe, "SetOp_Mul", "Mul"), C(pe, "SetOp_Div", "Div"), C(pe, "SetOperators", [
  "",
  "Inc",
  "Dec",
  "Mul",
  "Div"
]), C(pe, "Arith_Add", "AD"), C(pe, "Arith_Sub", "SB"), C(pe, "Arith_Mul", "MU"), C(pe, "Arith_Div", "DV"), C(pe, "Arith_Mod", "MD"), C(pe, "Arithmetics", [
  "AD",
  "SB",
  "MU",
  "DV",
  "MD"
]), C(pe, "Condition_EQ", "EQ"), C(pe, "Condition_NQ", "NQ"), C(pe, "Condition_LS", "LS"), C(pe, "Condition_LQ", "LQ"), C(pe, "Condition_GR", "GR"), C(pe, "Condition_GQ", "GQ"), C(pe, "Condition_AN", "AN"), C(pe, "Condition_OR", "OR"), C(pe, "Conditions", [
  "EQ",
  "NQ",
  "LS",
  "LQ",
  "GR",
  "GQ",
  "AN",
  "OR"
]), C(pe, "OnEventProperties", kr.ToEnumerable([
  vt.op_Implicit("Condition")
])), C(pe, "ArithmeticProperties", kr.ToEnumerable([
  vt.op_Implicit("left"),
  vt.op_Implicit("right")
])), C(pe, "GetPropertyProperties", kr.ToEnumerable([
  vt.op_Implicit("this")
])), C(pe, "GetElementProperties", kr.ToEnumerable([
  vt.op_Implicit("this"),
  vt.op_Implicit("index")
])), C(pe, "SetPropertyProperties", kr.ToEnumerable([
  vt.op_Implicit("this"),
  vt.op_Implicit("value")
])), C(pe, "SetGlobalProperties", kr.ToEnumerable([
  vt.op_Implicit("value")
])), C(pe, "FuncDefineProperties", kr.ToEnumerable([
  vt.op_Implicit("signature"),
  vt.op_Implicit("content")
])), C(pe, "CodeGraphProperties", kr.ToEnumerable([
  vt.op_Implicit("variables"),
  vt.op_Implicit("functions")
])), C(pe, "IfElseProperties", kr.ToEnumerable([
  vt.op_Implicit("Condition")
])), C(pe, "AsTypeProperties", kr.ToEnumerable([
  vt.op_Implicit("value")
])), C(pe, "ReturnProperties", kr.ToEnumerable([
  vt.op_Implicit("value")
])), C(pe, "ForEachProperties", kr.ToEnumerable([
  vt.op_Implicit("value"),
  vt.op_Implicit("do")
])), C(pe, "ForIndexProperties", kr.ToEnumerable([
  vt.op_Implicit("start"),
  vt.op_Implicit("end"),
  vt.op_Implicit("step"),
  vt.op_Implicit("do")
])), C(pe, "WhileLoopProperties", kr.ToEnumerable([
  vt.op_Implicit("Condition")
])), C(pe, "VarDefineProperties", kr.ToEnumerable([
  vt.op_Implicit("value")
])), C(pe, "CallExternFunctionProperties", kr.ToEnumerable([
  vt.op_Implicit("this")
])), C(pe, "Vector3Properties", kr.ToEnumerable([
  vt.op_Implicit("X"),
  vt.op_Implicit("Y"),
  vt.op_Implicit("Z")
]));
class NI extends Rt {
  constructor() {
    super();
    C(this, "descriptionFile", null);
    C(this, "charsToTrim", [
      32,
      /*' '*/
      9,
      /*'\t'*/
      13,
      /*'\r'*/
      10
    ]);
  }
  ParseTexts(r, o) {
    this.descriptionFile = o;
    let c = r.GetEnumerator(), T = new it(), d = new ym();
    for (; c.MoveNext(); )
      if (this.readline(c.Current, d), !de.IsNullOrEmpty(d.name) || !de.IsNullOrEmpty(d.main)) {
        let h;
        if (d.main == "event") {
          let y = new Dg(d.name, ""), b = "Global", U = "", Z = T.GetEnumerator();
          try {
            for (; Z.MoveNext(); ) {
              let ue = Z.Current;
              if (ue.Name == "Owner") {
                b = ue.Value, U = ue.m_Label;
                break;
              }
            }
          } finally {
            Z.Dispose();
          }
          o.events.set_Item(b + "::" + d.name, y), h = y, h.Category = U;
          let le;
          (() => {
            let ue = [], be = o.event_ownertypes.TryGetValue(y.Name, ue);
            return le = ue[0], be;
          })() || (le = new it(), o.event_ownertypes.set_Item(y.Name, le)), le.Add(b), (() => {
            let ue = [], be = o.ownertype_events.TryGetValue(b, ue);
            return le = ue[0], be;
          })() || (le = new it(), o.ownertype_events.set_Item(b, le)), le.Add(y.Name);
        } else if (d.main == "action") {
          let y = new Og(d.name, "");
          o.actions.set_Item(d.name, y), h = y, h.Category = o.Texts.CATEGORY_ACTIONS;
        } else if (d.main == "alias") {
          d.type = de.Replace(de.Replace(d.type, " ", ""), "	", ""), this.checkForwardType(d);
          let y = new xt("alias", d.name, d.type);
          o.DefineType(d.name, y), h = y;
        } else if (d.main == "generic") {
          de.IsNullOrEmpty(d.type) || (d.type = de.Replace(de.Replace(d.type, " ", ""), "	", ""), this.checkForwardType(d));
          let y = new xt("generic", d.name, d.type);
          o.DefineType(d.name, y), h = y;
        } else if (d.main == "type")
          if (Bo.Contains(d.name, 124) || Bo.Contains(d.name, 38) || Bo.Contains(d.name, 95))
            h = o.GetVarType(d.name);
          else {
            de.IsNullOrEmpty(d.type) || (d.type = de.Replace(de.Replace(d.type, " ", ""), "	", ""), this.checkForwardType(d));
            let y = new xt("type", d.name, d.type);
            o.DefineType(d.name, y), h = y;
          }
        else if (d.main == "enum") {
          de.IsNullOrEmpty(d.type) || (d.type = de.Replace(de.Replace(d.type, " ", ""), "	", ""), this.checkForwardType(d));
          let y = new xt("enum", d.name, d.type);
          y.IsEnum = !0, o.DefineType(d.name, y), o.enumTypes.Add(y), h = y, h.Category = o.Texts.CATEGORY_ENUMS;
        } else if (d.main == "variable") {
          let y = new bg(d.name, d.type);
          o.variables.set_Item(d.name, y), h = y, h.Category = o.Texts.CATEGORY_VARIABLES;
        } else
          d.main == "setup" ? h = new Ri("setup", d.name, d.type) : h = new Ri(d.main, d.name, d.type);
        if (h.SetValue(d.value), h.SetLabel(d.rawLabel), h.DoLoc(o), d.hasChildren && this.enterSubs(h, c), d.IsAttribute ? (h.PostLoad(o), T.Add(h)) : (h.Attributes = T, T = new it(), h.PostLoad(o)), d.main == "setup" && o.Setup(h), d.main == "partial") {
          let y = o.getType(d.name);
          if (y != null) {
            let b = h.Items.GetEnumerator();
            try {
              for (; b.MoveNext(); ) {
                let U = b.Current;
                y.Items.Add(U);
              }
            } finally {
              b.Dispose();
            }
          }
        }
      }
  }
  checkForwardType(r) {
    if (this.descriptionFile.GetVarType(r.type) == null)
      throw new vn(de.Format("{0} is null", r.type));
  }
  enterSubs(r, o) {
    r.Items = new it();
    let c = new it();
    for (; o.MoveNext(); ) {
      let T = new ym();
      if (this.readline(o.Current, T), T.name == "}")
        break;
      if (!de.IsNullOrEmpty(T.name)) {
        let d = new Ri(T.main, T.name, T.type);
        d.SetValue(T.value), d.SetLabel(T.rawLabel), d.DoLoc(this.descriptionFile), T.hasChildren && this.enterSubs(d, o), T.IsAttribute ? (d.PostLoad(this.descriptionFile), c.Add(d)) : (d.Attributes = c, d.PostLoad(this.descriptionFile), r.Items.Add(d), c = new it());
      }
    }
  }
  readline(r, o) {
    return r = this.cleancomments(r), r = this.getRawLabel(r, o), r = this.getHasChildren(r, o), r = this.getValue(r, o), r = this.getType(r, o), this.getMainAndName(r, o), o;
  }
  cleancomments(r) {
    let o = de.IndexOf(r, "//"), c;
    return o >= 0 ? c = de.Substring(r, 0, o) : c = r, c;
  }
  getRawLabel(r, o) {
    let c = de.IndexOf(r, "#");
    return c >= 0 ? (o.rawLabel = de.Trim(de.Substring(r, c + 1)), r = de.Substring(r, 0, c)) : o.rawLabel = "", r;
  }
  getHasChildren(r, o) {
    let c = de.IndexOf(r, 123);
    return c >= 0 ? (r = de.Substring(r, 0, c), o.hasChildren = !0) : o.hasChildren = !1, r;
  }
  getValue(r, o) {
    let c = de.IndexOf(r, 61);
    return c >= 0 ? (o.value = de.Trim(de.Substring(r, c + 1)), r = de.Substring(r, 0, c)) : o.value = "", r;
  }
  getType(r, o) {
    let c = de.IndexOf(r, 58);
    return c >= 0 ? (o.type = de.Trim(de.Substring(r, c + 1)), r = de.Substring(r, 0, c)) : o.type = "", r;
  }
  getMainAndName(r, o) {
    o.IsAttribute = !1, r = de.Trim(r, this.charsToTrim), de.StartsWith(r, "@") && (o.IsAttribute = !0);
    let c = de.IndexOf(r, 32);
    c > 0 ? (o.main = de.Substring(r, 0, c), o.name = de.Trim(de.Substring(r, c + 1), this.charsToTrim)) : o.IsAttribute ? (o.main = r, o.name = de.Substring(r, 1)) : (o.main = "", o.name = r);
  }
}
class ym extends Rt {
  constructor() {
    super();
    C(this, "main", "");
    C(this, "name", "");
    C(this, "type", "");
    C(this, "value", "");
    C(this, "rawLabel", "");
    C(this, "hasChildren", !1);
    C(this, "IsAttribute", !1);
  }
}
class vg extends Rt {
  constructor() {
    super();
    C(this, "CATEGORY_BASIC", "基本");
    C(this, "CATEGORY_COMBINED", "复合");
    C(this, "CATEGORY_CONTROLS", "流程控制");
    C(this, "CATEGORY_ACTIONS", "动作");
    C(this, "CATEGORY_VARIABLES", "取值");
    C(this, "CATEGORY_ENUMS", "枚举");
    C(this, "CATEGORY_FUNCTIONS", "函数");
    C(this, "CATEGORY_EDIT", "编辑");
    C(this, "CATEGORY_COMPARE", "比较");
    C(this, "CATEGORY_ENTITY", "实体");
    C(this, "CATEGORY_ARITHMETIC", "运算");
    C(this, "CATEGORY_LOCALVARS", "变量");
    C(this, "CATEGORY_GLOBAL", "全局");
    C(this, "CATEGORY_GLOBALVARS", "全局变量");
    C(this, "CATEGORY_MECHANISM", "关卡参数");
    C(this, "CATEGORY_MORE", "更多");
    C(this, "CATEGORY_PROPERTY", "属性");
    C(this, "CATEGORY_TYPES", "类型");
    C(this, "CATEGORY_ASTYPE", "类型转换");
    C(this, "CATEGORY_SETVAR", "设置");
    C(this, "CATEGORY_EXTERN", "外部脚本");
    C(this, "Arithmetics", null);
    C(this, "Conditions", null);
    C(this, "SetOperators", null);
  }
}
class Rg extends Rt {
  constructor() {
    super();
    C(this, "EntityType", 0);
    C(this, "Name", "");
    C(this, "defines", new it());
  }
}
const fl = class fl extends Rt {
  constructor() {
    super();
    C(this, "Texts", new vg());
    C(this, "PRIDefineMode", 0);
    C(this, "PRIDefines", new it());
    C(this, "tempEventSets", new Cl());
    C(this, "cacheElements", new it());
    C(this, "allowAccept", !0);
    C(this, "varTypes", new ro());
    C(this, "events", new ro());
    C(this, "actions", new ro());
    C(this, "variables", new ro());
    C(this, "event_ownertypes", new ro());
    C(this, "ownertype_events", new ro());
    C(this, "m_typeWithBase", new ro());
    C(this, "m_typeNoBase", new ro());
    C(this, "temp_hashes", new Cl());
    C(this, "enumTypes", new it());
    C(this, "EntityTypes", new it());
    C(this, "voidType", new xt("type", "void", ""));
    C(this, "unknownType", new xt("type", "unknown", "").WithLabel("未知"));
    C(this, "setups", new fm());
    C(this, "m_FormalLogicAdaptor", null);
    C(this, "m_FindGraphProxy", null);
    C(this, "m_LocalizeProxy", null);
    C(this, "m_DebugProxy", null);
    C(this, "m_JsonProxy", null);
    C(this, "nullType", null);
    C(this, "anyType", null);
    C(this, "objectType", null);
    C(this, "entityType", null);
    C(this, "boolType", null);
    C(this, "intType", null);
    C(this, "floatType", null);
    C(this, "stringType", null);
    C(this, "arrayType", null);
    C(this, "numberType", null);
    C(this, "typeType", null);
    C(this, "listGenericType", null);
    C(this, "GlobalEntityType", null);
    C(this, "vector3Type", null);
    C(this, "vector2Type", null);
    this.m_FormalLogicAdaptor = new Pg(this);
  }
  get VarTypes() {
    return this.varTypes;
  }
  Load(r) {
    this.setups = new fm(), this.m_typeWithBase.Clear(), this.m_typeNoBase.Clear(), this.enumTypes.Clear(), this.events.Clear(), this.event_ownertypes.Clear(), this.ownertype_events.Clear(), this.actions.Clear(), this.varTypes.Clear(), this.variables.Clear(), this.InitDefaultTypes();
    let o = de.Split(r, fl.splits, Vh.RemoveEmptyEntries);
    return new NI().ParseTexts(kr.ToEnumerable(o), this), this.postLoad(), !0;
  }
  GenerateTypeEnums() {
    let r = this.enumTypes.GetEnumerator();
    try {
      for (; r.MoveNext(); ) {
        let o = r.Current;
        if (o.Attributes != null) {
          let c = o.Attributes.GetEnumerator();
          try {
            for (; c.MoveNext(); ) {
              let T = c.Current;
              if (T.Main == "@genTypeEnum" && (o.Items.Clear(), T.Name == "base")) {
                let d = this.GetVarType(T.Value), h = this.varTypes.GetEnumerator();
                try {
                  for (; h.MoveNext(); ) {
                    let y = h.Current, b = y.Value;
                    if (b != this.anyType && b != this.nullType && y.Key == b.Name && !b.IsGeneric && this.CheckIsExtention(d, b)) {
                      let U = o.Items, Z = new Ri("", b.Name, "");
                      Z.Label = b.Label, Z.Value = b.Name, Z.m_ApiLevel = b.m_ApiLevel, Z.m_Tip = b.m_Tip, U.Add(Z);
                    }
                  }
                } finally {
                  h.Dispose();
                }
              }
            }
          } finally {
            c.Dispose();
          }
        }
      }
    } finally {
      r.Dispose();
    }
  }
  VisitBases(r) {
    if (r != null && r.Bases == null) {
      if (r.Bases = new Cl(), r.IsFormalLogic) {
        let o = r instanceof Hr ? r : null;
        if (o.Operator == 2) {
          let T = null;
          for (let d = 0; d < o.SubLogics.Count; d = d + 1) {
            let h = o.SubLogics.get_Item(d) instanceof xt ? o.SubLogics.get_Item(d) : null;
            if (h != null)
              if (T == null)
                T = new Cl(), this.addBaseTypeToBases(r, h);
              else {
                this.VisitBases(h), !h.IsAlias && !h.IsFormalLogic && r.Bases.Contains(h.Name) && T.Add(h.Name);
                let y = h.Bases.GetEnumerator();
                try {
                  for (; y.MoveNext(); ) {
                    let U = y.Current;
                    r.Bases.Contains(U) && T.Add(U);
                  }
                } finally {
                  y.Dispose();
                }
                let b = r.Bases;
                if (r.Bases = T, T = b, T.Clear(), r.Bases.Count == 0)
                  break;
              }
          }
        } else {
          let T = o.SubLogics.GetEnumerator();
          try {
            for (; T.MoveNext(); ) {
              let d = T.Current;
              d != null && this.addBaseTypeToBases(r, d);
            }
          } finally {
            T.Dispose();
          }
        }
      } else if (r.Type != "") {
        let o = this.GetVarType(r.Type);
        o != null && this.addBaseTypeToBases(r, o);
      }
    }
  }
  addBaseTypeToBases(r, o) {
    this.VisitBases(o), !o.IsAlias && !o.IsFormalLogic && r.Bases.Add(o.Name);
    let c = o.Bases.GetEnumerator();
    try {
      for (; c.MoveNext(); ) {
        let T = c.Current;
        r.Bases.Add(T);
      }
    } finally {
      c.Dispose();
    }
  }
  postLoad() {
    this.FinalizeDefaultType(), this.EntityTypes.Clear();
    let r = this.varTypes.GetEnumerator();
    try {
      for (; r.MoveNext(); ) {
        let c = r.Current.Value;
        if (!c.IsAlias && !c.IsFormalLogic && c.Bases.Contains(this.entityType.Name) && (this.EntityTypes.Contains(c) || this.EntityTypes.Add(c)), de.IsNullOrEmpty(c.Category)) {
          let T = c.Bases.GetEnumerator();
          try {
            for (; T.MoveNext(); ) {
              let d = T.Current, h = this.GetVarType(d);
              if (h != this.objectType && h != null) {
                c.Category = h.CategoryLabel;
                break;
              }
            }
          } finally {
            T.Dispose();
          }
        }
      }
    } finally {
      r.Dispose();
    }
    if (this.EntityTypes != null) {
      let o = new ro(), c = this.PRIDefines.GetEnumerator();
      try {
        for (; c.MoveNext(); ) {
          let d = c.Current, h = d.Name != null ? d.Name : "";
          o.ContainsKey(h) || o.Add(h, d);
        }
      } finally {
        c.Dispose();
      }
      this.PRIDefines.Clear();
      let T = this.EntityTypes.GetEnumerator();
      try {
        for (; T.MoveNext(); ) {
          let d = T.Current;
          if (d.IntValue != 0) {
            let h;
            (() => {
              let U = [], Z = o.TryGetValue(d.Name, U);
              return h = U[0], Z;
            })() || (h = new Rg()), this.PRIDefines.Add(h), h.Name = d.m_Name, h.EntityType = d.IntValue;
            let y = d.IntValue * 1e3;
            this.PRIDefineMode == 1 && (y = y + 999);
            let b = h.defines.GetEnumerator();
            try {
              for (; b.MoveNext(); ) {
                let U = b.Current;
                d.Items == null && (d.Items = new it());
                let Z = d.Items, le = new Ri("", U.m_Name, U.Type);
                le.Value = U.Value, le.Items = U.Items, le.Label = U.Label;
                let ue = le, be;
                this.PRIDefineMode == 1 ? y = (be = y) - 1 : y = (be = y) + 1, ue.IntValue = be, Z.Add(le);
              }
            } finally {
              b.Dispose();
            }
          }
        }
      } finally {
        T.Dispose();
      }
    }
    this.GenerateTypeEnums();
  }
  RefreshCustomPRI(r) {
    let o = this.getType(r.Name);
    if (o != null && !o.IsAlias && !o.IsEnum && !o.IsFormalLogic && !o.IsGeneric && this.CheckIsExtention(this.entityType, o)) {
      let c = o.Items;
      for (let h = c.Count - 1; h >= 0; h = h - 1)
        c.get_Item(h).IntValue > 0 && c.RemoveAt(h);
      let T = o.IntValue * 1e3;
      this.PRIDefineMode == 1 && (T = T + 999);
      let d = r.defines.GetEnumerator();
      try {
        for (; d.MoveNext(); ) {
          let h = d.Current;
          o.Items == null && (o.Items = new it());
          let y = o.Items, b = new Ri("", h.m_Name, h.Type);
          b.Value = h.Value, b.Items = h.Items, b.Label = h.Label;
          let U = b, Z;
          this.PRIDefineMode == 1 ? T = (Z = T) - 1 : T = (Z = T) + 1, U.IntValue = Z, y.Add(b);
        }
      } finally {
        d.Dispose();
      }
    }
  }
  GetEventDefine(r) {
    let o;
    return (() => {
      let c = [], T = this.events.TryGetValue(r, c);
      return o = c[0], T;
    })(), o;
  }
  FindEventDefine(r, o) {
    let c = this.GetVarType(o), T;
    if (c != null) {
      o = c.Name;
      let d = o + "::" + r, h;
      if ((() => {
        let b = [], U = this.events.TryGetValue(d, b);
        return h = b[0], U;
      })())
        return T = h, T;
      let y = c.Bases.GetEnumerator();
      try {
        for (; y.MoveNext(); ) {
          let b = y.Current;
          if ((() => {
            let U = [], Z = this.events.TryGetValue(b + "::" + r, U);
            return h = U[0], Z;
          })())
            return T = h, T;
        }
      } finally {
        y.Dispose();
      }
    }
    if (o != this.GlobalEntityType.Name) {
      let d;
      if ((() => {
        let h = [], y = this.events.TryGetValue(this.GlobalEntityType.Name + "::" + r, h);
        return d = h[0], y;
      })())
        return T = d, T;
    }
    return T = null, T;
  }
  GetEventsByOwnerType(r, o = !0) {
    this.tempEventSets.Clear();
    let c = new it();
    o && r != this.GlobalEntityType.Name && this.addEventsToList(c, this.GlobalEntityType.Name), this.addEventsToList(c, r);
    let d = this.GetVarType(r).Bases.GetEnumerator();
    try {
      for (; d.MoveNext(); ) {
        let h = d.Current;
        this.addEventsToList(c, h);
      }
    } finally {
      d.Dispose();
    }
    return c;
  }
  addEventsToList(r, o) {
    let c;
    if ((() => {
      let T = [], d = this.ownertype_events.TryGetValue(o, T);
      return c = T[0], d;
    })()) {
      let T = c.GetEnumerator();
      try {
        for (; T.MoveNext(); ) {
          let d = T.Current;
          if (!this.tempEventSets.Contains(d)) {
            this.tempEventSets.Add(d);
            let h = this.GetEventDefine(o + "::" + d);
            h != null && r.Add(h);
          }
        }
      } finally {
        T.Dispose();
      }
    }
  }
  getType(r) {
    let o, c;
    return (() => {
      let T = [], d = this.varTypes.TryGetValue(r, T);
      return o = T[0], d;
    })() ? c = o : c = null, c;
  }
  CheckNextVarType(r, o) {
    let c = o[0], T = de.IndexOfAny(r, fl.chars, c), d;
    if (T < 0)
      o[0] = r.length, d = this.getType(de.Substring(r, c));
    else if (r.charCodeAt(T) == 95) {
      let h = de.Substring(r, c, T - c), y = this.getType(h);
      if (o[0] = T, y == null)
        throw new vn("cannot find type " + h);
      if (y.IsGeneric) {
        let b = this.cacheElements.Count, U = y.Items.GetEnumerator();
        try {
          for (; U.MoveNext(); ) {
            let ue = U.Current;
            o[0] < r.length && r.charCodeAt(o[0]) == 95 && (o[0] = o[0] + 1);
            let be = !1;
            r.charCodeAt(o[0]) == 60 && (o[0] = o[0] + 1, be = !0);
            let Ke = (() => {
              let ae = [
                o[0]
              ], Ne = this.CheckNextVarType(r, ae);
              return o[0] = ae[0], Ne;
            })();
            if (be) {
              if (r.charCodeAt(o[0]) != 62)
                throw new vn("ECA CheckNextVarType Wait for >");
              o[0] = o[0] + 1;
            }
            this.cacheElements.Add(Ke);
          }
        } finally {
          U.Dispose();
        }
        let Z = de.Substring(r, c, o[0] - c), le = this.getType(Z);
        if (le == null) {
          le = new xt("type", Z, y.Type);
          let ue = y.Label;
          le.GenericType = y.Name, le.ElementTypes = new Array(y.Items.Count);
          for (let Ke = 0; Ke < y.Items.Count; Ke = Ke + 1) {
            let ae = this.cacheElements.get_Item(b + Ke);
            ae != null ? (le.ElementTypes[Ke] = ae.Name, ue = ue + "<" + ae.Label + ">") : le.ElementTypes[Ke] = "";
          }
          let be = this.GetVarType(y.Type);
          le.Category = be.CategoryLabel, le.Label = ue, y.Attributes != null && (le.Attributes = Bo.ToList(y.Attributes)), this.DefineType(Z, le);
        } else if (le.ElementTypes == null) {
          le.ElementTypes = new Array(y.Items.Count);
          for (let ue = 0; ue < y.Items.Count; ue = ue + 1) {
            let be = this.cacheElements.get_Item(b + ue);
            be != null ? le.ElementTypes[ue] = be.Name : le.ElementTypes[ue] = "";
          }
        }
        this.cacheElements.RemoveRange(b, this.cacheElements.Count - b), d = le;
      } else
        d = y;
    } else {
      T = c;
      let h = Cg(xt, (() => {
        let y = [
          T
        ], b = Cs.ParseAndSimplify(r, y, this.m_FormalLogicAdaptor);
        return T = y[0], b;
      })());
      h.m_Name = de.Substring(r, c, T - c), o[0] = T, d = h;
    }
    return d;
  }
  GetGenericVarType(r, o, c) {
    let T;
    if (!r.IsGeneric)
      T = null;
    else {
      let d = r.Name;
      if (o.IsFormalLogic ? d = d + "_<" + o.Name + ">" : d = d + "_" + o.Name, c != null)
        for (let y = 0; y < c.length; y = y + 1) {
          let b = c[y];
          b.IsFormalLogic ? d = d + "_<" + b.Name + ">" : d = d + "_" + b.Name;
        }
      let h = this.getType(d);
      if (h != null)
        T = h;
      else if (r.Items.Count != (c != null ? c.length + 1 : 1))
        T = null;
      else {
        h = new xt("type", d, r.Type), h.Value = r.Value, h.IntValue = r.IntValue, h.FloatValue = r.FloatValue;
        let b = this.GetVarType(r.Type);
        if (h.Category = b.CategoryLabel, h.Label = r.Label + "<" + o.Label + ">", r.Attributes != null && (h.Attributes = Bo.ToList(r.Attributes)), c != null) {
          h.ElementTypes = new Array(c.length + 1), h.ElementTypes[0] = o.Name;
          let U = 1;
          for (let Z = 0; Z < c.length; Z = Z + 1) {
            let le = c[Z], ue = h;
            ue.Label = ue.Label + "<" + le.Label + ">", h.ElementTypes[U] = le.Name, U = U + 1;
          }
        } else
          h.ElementTypes = [
            o.Name
          ];
        h.GenericType = r.Name, this.DefineType(d, h), T = h;
      }
    }
    return T;
  }
  GetVarTypeFromWord(r) {
    let o;
    if (r == "[]")
      o = this.arrayType;
    else {
      r = this.normalizeTypeName(r);
      let c = this.getType(r);
      c != null ? o = c : (c = this.analyzeGenericType(r), c == null ? o = this.unknownType : o = c);
    }
    return o;
  }
  GetVarType(r) {
    let o;
    if (r == null)
      o = null;
    else if (r == "[]")
      o = this.arrayType;
    else {
      r = this.normalizeTypeName(r), r = de.Replace(r, " ", "");
      let c;
      if ((() => {
        let T = [], d = this.varTypes.TryGetValue(r, T);
        return c = T[0], d;
      })())
        o = c;
      else if (de.IndexOfAny(r, fl.charsFormalLogic) < 0)
        o = null;
      else {
        try {
          let T = Cs.ParseAndSimplify(r, this.m_FormalLogicAdaptor) instanceof xt ? Cs.ParseAndSimplify(r, this.m_FormalLogicAdaptor) : null;
          if (T != null) {
            let d = this.getType(r);
            if (d != null)
              return o = d, o;
            T.m_Name = r, this.DefineType(r, T);
          }
          return o = T, o;
        } catch (T) {
          if (T instanceof vn)
            this.LogError("GetVarType exception on " + r, T);
          else
            throw T;
        }
        o = null;
      }
    }
    return o;
  }
  normalizeTypeName(r) {
    if (de.EndsWith(r, "?"))
      r = de.Trim(de.Substring(r, 0, r.length - 1));
    else
      for (; de.EndsWith(r, "[]"); )
        r = this.listGenericType.Name + "_" + de.Trim(de.Substring(r, 0, r.length - 2));
    return r;
  }
  analyzeGenericType(r) {
    let o;
    if (de.IndexOfAny(r, fl.chars) < 0)
      o = null;
    else {
      let c = 0, T = (() => {
        let d = [
          c
        ], h = this.CheckNextVarType(r, d);
        return c = d[0], h;
      })();
      if (c != r.length || T == null)
        throw new vn(r + " is not a correct type");
      o = T;
    }
    return o;
  }
  TryGetVarType(r, o) {
    return o[0] = this.GetVarType(r), o[0] != null;
  }
  CheckFinalSelfAcceptable(r, o) {
    let c;
    if (r == null)
      c = !1;
    else if (o == null)
      c = !1;
    else if (o == r)
      c = !0;
    else if (r == this.objectType)
      c = !0;
    else if (r == this.anyType)
      c = !0;
    else if (o == this.anyType)
      c = !0;
    else {
      if (r.Attributes != null && this.allowAccept) {
        let T = r.Attributes.GetEnumerator();
        try {
          for (; T.MoveNext(); ) {
            let d = T.Current;
            if (d.Main == "@Accept" && d.Name == o.Name)
              return c = !0, c;
          }
        } finally {
          T.Dispose();
        }
      }
      if (de.IsNullOrEmpty(r.GenericType))
        c = !1;
      else if (r.GenericType == o.GenericType)
        if (r.ElementTypes.length != o.ElementTypes.length)
          c = !1;
        else {
          for (let T = 0; T < r.ElementTypes.length; T = T + 1) {
            let d = this.GetFormalLogicNoBases(r.ElementTypes[T]), h = this.GetFormalLogicWithBases(o.ElementTypes[T]);
            if (!Cs.CheckAssignable(d, h, this.m_FormalLogicAdaptor))
              return c = !1, c;
          }
          c = !0;
        }
      else
        c = !1;
    }
    return c;
  }
  CheckIsExtention(r, o) {
    return r != null && o != null && (r == o || o.Bases.Contains(r.Name));
  }
  CheckIsAssignable(r, o, c = !0, T) {
    return arguments.length == 4 && (r == null || r instanceof xt) && (o == null || o instanceof xt) && (c == null || c.constructor == Boolean) && (T == null || T.constructor == Boolean) ? this.CheckIsAssignable_ECADescriptionFile_0(r, o, c, T) : this.CheckIsAssignable_ECADescriptionFile_1(r, o, c);
  }
  CheckIsAssignable_ECADescriptionFile_0(r, o, c, T) {
    let d = this.allowAccept;
    this.allowAccept = T;
    let h = this.CheckIsAssignable(r, o, c);
    return this.allowAccept = d, h;
  }
  CheckIsAssignable_ECADescriptionFile_1(r, o, c) {
    let T;
    if (r == null)
      T = !1;
    else if (o == null)
      T = !1;
    else if (o == this.nullType && c)
      T = !0;
    else if (r == this.anyType)
      T = !0;
    else if (o == this.anyType && this.allowAccept)
      T = !0;
    else if (o == this.anyType && (o = this.objectType), r == o)
      T = !0;
    else {
      let d = this.GetFormalLogicNoBases(r.Name), h = this.GetFormalLogicWithBases(o.Name);
      T = Cs.CheckAssignable(d, h, this.m_FormalLogicAdaptor);
    }
    return T;
  }
  GetTypeID(r) {
    let o = 0;
    if (r != null)
      if (r.IntValue > 0)
        o = r.IntValue;
      else {
        let c = r.Bases.GetEnumerator();
        try {
          for (; c.MoveNext(); ) {
            let T = c.Current, d = this.GetVarType(T);
            if (d != null && d.IntValue > 0) {
              o = d.IntValue;
              break;
            }
          }
        } finally {
          c.Dispose();
        }
      }
    return o;
  }
  IsArray(r) {
    return r == this.arrayType || r.Bases.Contains(this.arrayType.Name);
  }
  DefineType(r, o) {
    this.VisitBases(o), this.varTypes.set_Item(r, o);
  }
  GetFormalLogicNoBases(r) {
    let o, c;
    if ((() => {
      let T = [], d = this.m_typeNoBase.TryGetValue(r, T);
      return o = T[0], d;
    })())
      c = o;
    else {
      if (o = this.GetFormalLogicWithBases(r), o instanceof Hr) {
        let T = o instanceof Hr ? o : null;
        if (T.Operator == 1)
          o = this.hidebasesInAnds(T);
        else if (T.Operator == 2) {
          let d = new Hr();
          d.Operator = 2;
          let h = T.SubLogics.GetEnumerator();
          try {
            for (; h.MoveNext(); ) {
              let y = h.Current;
              if (y instanceof Hr) {
                let b = y instanceof Hr ? y : null;
                d.SubLogics.Add(this.hidebasesInAnds(b));
              } else
                d.SubLogics.Add(y);
            }
          } finally {
            h.Dispose();
          }
          o = d;
        }
      }
      this.m_typeNoBase.set_Item(r, o), c = o;
    }
    return c;
  }
  hidebasesInAnds(r) {
    this.temp_hashes.Clear();
    let o = r.SubLogics.GetEnumerator();
    try {
      for (; o.MoveNext(); ) {
        let y = o.Current.Bases.GetEnumerator();
        try {
          for (; y.MoveNext(); ) {
            let b = y.Current;
            this.temp_hashes.Add(b);
          }
        } finally {
          y.Dispose();
        }
      }
    } finally {
      o.Dispose();
    }
    let c = new Hr();
    c.Operator = 1;
    let T = r.SubLogics.GetEnumerator();
    try {
      for (; T.MoveNext(); ) {
        let h = T.Current;
        this.temp_hashes.Contains(h.Name) || c.SubLogics.Add(h);
      }
    } finally {
      T.Dispose();
    }
    let d;
    return c.SubLogics.Count == 1 ? d = c.SubLogics.get_Item(0) instanceof xt ? c.SubLogics.get_Item(0) : null : (c.SubLogics.Count == 0, d = c), d;
  }
  GetFormalLogicWithBases(r) {
    let o, c;
    if ((() => {
      let T = [], d = this.m_typeWithBase.TryGetValue(r, T);
      return o = T[0], d;
    })())
      c = o;
    else {
      for (o = this.GetVarType(r); o != null && o.IsAlias; )
        o = this.GetVarType(o.Type);
      if (o == null && (o = this.unknownType), o instanceof Hr)
        this.m_typeWithBase.set_Item(r, o);
      else if (de.IsNullOrEmpty(o.Type))
        this.m_typeWithBase.set_Item(r, o);
      else {
        let T = this.GetFormalLogicWithBases(o.Type), d = new Hr();
        d.Operator = 1, d.SubLogics.Add(o), d.SubLogics.Add(T), o = Cs.Simplify(d, this.m_FormalLogicAdaptor) instanceof xt ? Cs.Simplify(d, this.m_FormalLogicAdaptor) : null, this.m_typeWithBase.set_Item(r, o);
      }
      c = o;
    }
    return c;
  }
  InitDefaultTypes() {
    this.GlobalEntityType = null;
  }
  FinalizeDefaultType() {
    this.anyType = this.finalizeDefaultType("any"), this.intType = this.finalizeDefaultType("int"), this.floatType = this.finalizeDefaultType("float"), this.numberType = this.finalizeDefaultType("number"), this.boolType = this.finalizeDefaultType("bool"), this.stringType = this.finalizeDefaultType("string"), this.entityType = this.finalizeDefaultType("entity"), this.nullType = this.finalizeDefaultType("null"), this.typeType = this.finalizeDefaultType("type"), this.arrayType = this.finalizeDefaultType("array"), this.GlobalEntityType = this.finalizeDefaultType("global"), this.listGenericType = this.finalizeDefaultType("listGeneric"), this.objectType = this.finalizeDefaultType("object"), this.vector3Type = this.finalizeDefaultType("Vector3"), this.vector2Type = this.finalizeDefaultType("Vector2"), this.unknownType.Bases = new Cl(), this.voidType.Bases = new Cl();
  }
  finalizeDefaultType(r) {
    let o = this.setups.get_Item(r), c;
    if (de.IsNullOrEmpty(o))
      c = null;
    else {
      let T = this.getType(o);
      T == null && (T = new xt("type", o, ""), T.Bases = new Cl(), this.varTypes.set_Item(o, T), this.LogError(de.Concat([
        "No define default type ",
        r,
        " ",
        o,
        ".  Give a default type"
      ]), null)), o != r && this.varTypes.set_Item(r, T), c = T;
    }
    return c;
  }
  Setup(r) {
    this.setups.ContainsKey(r.m_Name) ? this.setups.set_Item(r.m_Name, r.Value) : this.LogError("You are entering unknown Setup " + r.m_Name, null);
  }
  Log(r) {
    this.m_DebugProxy != null && this.m_DebugProxy.Log(r);
  }
  LogError(r, o = null) {
    this.m_DebugProxy != null && this.m_DebugProxy.LogError(r, o);
  }
  Assert(r, o = null) {
    this.m_DebugProxy != null && this.m_DebugProxy.Assert(r, o);
  }
  SetDebugProxy(r) {
    this.m_DebugProxy = r;
  }
  SetAssetGUIDProxy(r) {
    this.m_FindGraphProxy = r;
  }
  SetLocalizeProxy(r) {
    this.m_LocalizeProxy = r;
  }
  SetJsonProxy(r) {
    this.m_JsonProxy = r;
  }
  FindAsset(r) {
    let o;
    return this.m_FindGraphProxy == null ? o = null : o = this.m_FindGraphProxy.FindAsset(r), o;
  }
  GetGUID(r) {
    let o;
    return this.m_FindGraphProxy == null ? o = null : o = this.m_FindGraphProxy.GetAssetGUID(r), o;
  }
  JsonParse(r) {
    let o;
    return de.IsNullOrEmpty(r) || this.m_JsonProxy == null ? o = null : o = this.m_JsonProxy.Parse(r), o;
  }
  JsonStringify(r, o) {
    let c;
    return this.m_JsonProxy == null ? c = null : c = this.m_JsonProxy.Serialize(r, o), c;
  }
  Localize(r) {
    let o;
    if (this.m_LocalizeProxy == null)
      o = r;
    else {
      let c = new fg(), T = 0, d = r.length, h = -1;
      for (; T < d; ) {
        let y = r.charCodeAt(T);
        if (h < 0)
          y == 37 ? (T = T + 1, T < d ? r.charCodeAt(T) == 40 ? h = T + 1 : (c.Append(y), c.Append(r.charCodeAt(T))) : c.Append(y)) : c.Append(y);
        else if (y == 41) {
          let b = T - h;
          if (b > 0) {
            let U = de.Substring(r, h, b), Z = this.m_LocalizeProxy.Localize(U);
            c.Append(Z);
          }
          h = -1;
        }
        T = T + 1;
      }
      o = c.ToString();
    }
    return o;
  }
};
C(fl, "CurrentDescriptionFile", null), C(fl, "splits", [
  13,
  /*'\r'*/
  10
]), C(fl, "chars", [
  95,
  /*'_'*/
  124,
  /*'|'*/
  38,
  /*'&'*/
  62
]), C(fl, "charsFormalLogic", [
  124,
  /*'|'*/
  38,
  /*'&'*/
  40,
  /*'('*/
  41,
  /*')'*/
  95
]);
let ce = fl;
class fm extends ro {
  constructor() {
    super(), super.set_Item("any", "any"), super.set_Item("null", "null"), super.set_Item("object", "Object"), super.set_Item("bool", "bool"), super.set_Item("int", "int"), super.set_Item("float", "float"), super.set_Item("number", "number"), super.set_Item("string", "string"), super.set_Item("type", "type"), super.set_Item("array", "array"), super.set_Item("listGeneric", "ListT"), super.set_Item("entity", "entity"), super.set_Item("global", "Global"), super.set_Item("Vector3", "Vector3"), super.set_Item("Vector2", "Vector2");
  }
}
class Ri extends Rt {
  constructor(r, o, c) {
    super();
    C(this, "Main", "");
    C(this, "m_Name", "");
    C(this, "Type", "");
    C(this, "Value", "");
    C(this, "m_Label", "");
    C(this, "m_LabelKey", "");
    C(this, "m_Tip", "");
    C(this, "m_TipKey", "");
    C(this, "m_ApiLevel", 0);
    C(this, "m_ScriptName", "");
    C(this, "m_Category", "");
    C(this, "m_Async", !1);
    C(this, "IntValue", 0);
    C(this, "FloatValue", 0);
    C(this, "Items", null);
    C(this, "Attributes", null);
    C(this, "ModuleID", 0);
    C(this, "m_ModuleLib", "");
    C(this, "m_ApiTarget", 0);
    C(this, "Addable", null);
    C(this, "Conflicts", null);
    if (arguments.length == 0) {
      this.constructor_0();
      return;
    }
    this.constructor_1(r, o, c);
  }
  get Operator() {
    return -1;
  }
  get ScriptName() {
    let r;
    return de.IsNullOrEmpty(this.m_ScriptName) ? r = this.m_Name : r = this.m_ScriptName, r;
  }
  get CategoryLabel() {
    let r;
    return de.IsNullOrEmpty(this.Category) ? r = this.Label : r = this.Category + "/" + this.Label, r;
  }
  set Label(r) {
    this.m_Label = r;
  }
  get Label() {
    return de.IsNullOrEmpty(this.m_Label) ? this.m_Name : this.m_Label;
  }
  get Name() {
    return this.m_Name;
  }
  set Category(r) {
    this.m_Category = r;
  }
  get Category() {
    return this.m_Category;
  }
  set Tip(r) {
    this.m_Tip = r;
  }
  get Tip() {
    return this.m_Tip;
  }
  get TipKey() {
    return this.m_TipKey;
  }
  get IsAsync() {
    return this.m_Async;
  }
  constructor_0() {
  }
  constructor_1(r, o, c) {
    this.Main = r, this.m_Name = o, this.Type = c;
  }
  ToString() {
    return this.m_Name;
  }
  GetItem(r) {
    let o;
    if (this.Items != null) {
      let c = this.Items.GetEnumerator();
      try {
        for (; c.MoveNext(); ) {
          let T = c.Current;
          if (T.m_Name == r)
            return o = T, o;
        }
      } finally {
        c.Dispose();
      }
    }
    return o = null, o;
  }
  PostLoad(r) {
    if (this.Attributes != null) {
      let o = this.Attributes.GetEnumerator();
      try {
        for (; o.MoveNext(); ) {
          let c = o.Current;
          switch (c.Main) {
            case "@Tip":
              this.m_Tip = r.Localize(c.Value), this.m_TipKey = this.getLabelKey(c.Value);
              break;
            case "@ApiLevel":
              this.m_ApiLevel = c.IntValue;
              break;
            case "@ScriptName":
              this.m_ScriptName = c.Value;
              break;
            case "@ModuleID":
              this.ModuleID = c.IntValue;
              break;
            case "@ModuleLib":
              this.m_ModuleLib = c.Value;
              break;
            case "@ApiTarget":
              this.m_ApiTarget = c.IntValue;
              break;
            case "@Addable":
              this.Addable = r.JsonParse(c.Value);
              break;
            case "@Conflict":
              this.Conflicts = r.JsonParse(c.Value);
              break;
            case "@Return":
              this.returnTip = r.Localize(c.Value);
              break;
            case "@Async":
              this.m_Async = de.IsNullOrEmpty(c.Value);
              break;
          }
        }
      } finally {
        o.Dispose();
      }
    }
  }
  SetValue(r) {
    this.Value = r, (() => {
      let o = [], c = Im.TryParse(this.Value, o);
      return this.IntValue = o[0], c;
    })() ? this.FloatValue = this.IntValue : (() => {
      let o = [], c = Im.TryParse(this.Value, o);
      return this.FloatValue = o[0], c;
    })() && (this.IntValue = this.FloatValue);
  }
  SetLabel(r) {
    if (r != null) {
      r = de.Trim(r), de.Trim(
        r,
        [
          47
        ]
        /*'/'*/
      );
      let o = de.LastIndexOf(r, 47);
      if (o != -1 && o < r.length - 1) {
        let c = de.Substring(r, 0, o);
        this.Category = c, r = de.Substring(r, o + 1);
      }
      de.IsNullOrEmpty(r) || (this.m_Label = r, this.m_LabelKey = this.getLabelKey(r));
    }
  }
  getLabelKey(r) {
    let o = de.LastIndexOf(r, "%("), c;
    return o >= 0 && o < r.length - 3 ? c = de.Substring(r, o + 2, r.length - o - 3) : c = r, c;
  }
  DoLoc(r) {
    de.IsNullOrEmpty(this.m_Category) || (this.m_Category = r.Localize(this.m_Category)), de.IsNullOrEmpty(this.m_Label) || (this.m_Label = r.Localize(this.m_Label));
  }
}
class xt extends Ri {
  constructor(r, o, c) {
    super(r, o, c);
    C(this, "IsGeneric", !1);
    C(this, "IsEnum", !1);
    C(this, "IsAlias", !1);
    C(this, "IsFormalLogic", !1);
    C(this, "GenericType", "");
    C(this, "ElementTypes", null);
    C(this, "Bases", null);
    this.IsGeneric = r == "generic", this.IsAlias = r == "alias", this.Items = new it();
  }
  get ElementType() {
    let r;
    return this.ElementTypes != null && this.ElementTypes.length > 0 ? r = this.ElementTypes[0] : r = "any", r;
  }
  WithCategory(r) {
    return this.Category = r, this;
  }
  WithLabel(r) {
    return this.m_Label = r, this;
  }
  WithValue(r) {
    return super.SetValue(r), this;
  }
}
class Hr extends xt {
  constructor() {
    super("formal", "", "");
    C(this, "SubLogics", new it());
    C(this, "_Operator", 0);
    this.IsFormalLogic = !0;
  }
  get Operator() {
    return this._Operator;
  }
  set Operator(r) {
    this._Operator = r;
  }
}
class xh extends Ri {
  constructor(r, o, c) {
    super(r, o, c);
    C(this, "_properties", null);
  }
  get Parameters() {
    if (this._properties == null && (this._properties = new it(), this.Items != null)) {
      let r = this.Items.GetEnumerator();
      try {
        for (; r.MoveNext(); ) {
          let o = r.Current;
          this._properties.Add(o);
        }
      } finally {
        r.Dispose();
      }
    }
    return this._properties;
  }
  get ReturnType() {
    return null;
  }
}
class Og extends xh {
  constructor(l, r = "") {
    super("action", l, ""), this.Category = r;
  }
}
class Dg extends xh {
  constructor(r, o) {
    super("event", r, o);
    C(this, "owner", "Global");
  }
  PostLoad(r) {
    if (super.PostLoad(r), this.Attributes != null) {
      let o = this.Attributes.GetEnumerator();
      try {
        for (; o.MoveNext(); ) {
          let c = o.Current;
          c.Main == "@Owner" && (this.owner = c.Value);
        }
      } finally {
        o.Dispose();
      }
    }
  }
}
class bg extends xh {
  constructor(r, o) {
    super("variable", r, o);
    C(this, "thisName", null);
    C(this, "returnTip", "");
  }
  get ReturnType() {
    return this.Type;
  }
  PostLoad(r) {
    super.PostLoad(r);
    let o = this.Items.GetEnumerator();
    try {
      for (; o.MoveNext(); ) {
        let c = o.Current;
        (c.m_Name == "this" || c.Main == "this") && (this.thisName = c);
      }
    } finally {
      o.Dispose();
    }
  }
}
class Pg extends Rt {
  constructor(r) {
    super();
    C(this, "m_description", null);
    this.m_description = r;
  }
  CreateContainer() {
    return new Hr();
  }
  CreateItem(r) {
    if (this.m_description.GetVarTypeFromWord(r) == null)
      throw new vn(de.Format("get type `{0}` before it defined", r));
    return this.m_description.GetFormalLogicWithBases(r);
  }
  GetContainerOperator(r) {
    let o = r instanceof Hr ? r : null, c;
    return o != null ? c = o.Operator : c = 0, c;
  }
  PopFromContainer(r) {
    let o = r instanceof Hr ? r : null, c;
    if (o != null) {
      let T = o.SubLogics;
      if (T.Count > 0) {
        let d = T.get_Item(T.Count - 1);
        return T.RemoveAt(T.Count - 1), c = d, c;
      }
    }
    return c = null, c;
  }
  PushToContainer(r, o) {
    let c = r instanceof Hr ? r : null;
    if (c != null) {
      let T = o instanceof xt ? o : null;
      T != null && c.SubLogics.Add(T);
    }
  }
  SetContainerOperator(r, o) {
    let c = r instanceof Hr ? r : null;
    c != null && (c.Operator = o);
  }
  GetSubFormalLogics(r) {
    let o;
    return r instanceof Hr ? o = r.SubLogics : o = null, o;
  }
  ClearContainer(r) {
    if (r instanceof Hr) {
      let o = r instanceof Hr ? r : null;
      o.Operator = 0, o.SubLogics.Clear();
    }
  }
  IsAcceptable(r, o) {
    return this.m_description.CheckFinalSelfAcceptable(r instanceof xt ? r : null, o instanceof xt ? o : null);
  }
}
class Vn extends Rt {
  static CheckIsAssignable(l, r, o) {
    return arguments.length == 3 && (l == null || l instanceof xt) && (r == null || r.constructor == String) && (o == null || o instanceof ce) ? Vn.CheckIsAssignable_ECAHelper_0(l, r, o) : Vn.CheckIsAssignable_ECAHelper_1(l, r, o);
  }
  static CheckIsAssignable_ECAHelper_0(l, r, o) {
    let c;
    return (() => {
      let T = [], d = o.TryGetVarType(r, T);
      return c = T[0], d;
    })(), c != null && Vn.CheckIsAssignable(l, c, o);
  }
  static IsArithType(l, r) {
    return l == r.intType || l == r.floatType;
  }
  static CheckIsAssignable_ECAHelper_1(l, r, o) {
    return o.CheckIsAssignable(l, r, !0);
  }
  static CheckSenderType(l, r, o) {
    let c;
    return l != null && (l.Name == "Global" || Vn.CheckIsAssignable(l, r, o)) ? (c = !0, c) : (c = !1, c);
  }
  static GetObjectPropertyVarItem(l, r, o, c) {
    return arguments.length == 3 && (l == null || l instanceof ce) && (r == null || r instanceof xt) && (o == null || o.constructor == String) ? Vn.GetObjectPropertyVarItem_ECAHelper_0(l, r, o) : Vn.GetObjectPropertyVarItem_ECAHelper_1(l, r, o, c);
  }
  static GetObjectPropertyVarItem_ECAHelper_0(l, r, o) {
    return (() => {
      let c = [], T = Vn.GetObjectPropertyVarItem(l, r, o, c);
      return c[0], T;
    })();
  }
  static GetObjectPropertyVarItem_ECAHelper_1(l, r, o, c) {
    c[0] = null;
    let T;
    if (r == null)
      T = null;
    else if (r.IsEnum)
      T = null;
    else {
      c[0] = r;
      let d = r.GetItem(o);
      if (d != null)
        T = d;
      else {
        let h = r.Bases.GetEnumerator();
        try {
          for (; h.MoveNext(); ) {
            let y = h.Current, b = l.GetVarType(y);
            if (b != null && !b.IsEnum) {
              c[0] = b;
              let U = b.GetItem(o);
              if (U != null)
                return T = U, T;
            }
          }
        } finally {
          h.Dispose();
        }
        c[0] = null, T = null;
      }
    }
    return T;
  }
  static GetObjectPropertyVarType(l, r, o) {
    let c;
    if (l == null)
      c = null;
    else if (l.IsEnum)
      c = null;
    else {
      let T = Vn.GetObjectPropertyVarItem(o, l, r);
      T != null ? c = o.GetVarType(T.Type) : c = null;
    }
    return c;
  }
  constructor() {
    super();
  }
}
var yI = /* @__PURE__ */ ((i) => (i[i.EndNode = -1] = "EndNode", i[i.None = 0] = "None", i[i.And = 1] = "And", i[i.Or = 2] = "Or", i))(yI || {});
class X_ extends Rt {
  constructor(r = null) {
    super();
    C(this, "word", "");
    C(this, "_operator", 0);
    C(this, "SubLogics", null);
    r != null ? (this.word = r, this.Operator = -1) : this.SubLogics = new it();
  }
  set Operator(r) {
    this._operator = r;
  }
  get Operator() {
    return this._operator;
  }
  ToString() {
    let r;
    if (this.Operator == 0)
      this.SubLogics.Count > 0 ? r = this.SubLogics.get_Item(0).ToString() : r = "";
    else if (this.Operator == -1)
      r = this.word;
    else {
      let o = this.Operator != 1 ? " | " : " & ";
      r = "( " + de.Join(o, Bo.ToArray(Bo.Select(this.SubLogics, (c) => c.ToString()))) + " ) ";
    }
    return r;
  }
}
const Ud = class Ud extends Rt {
  ClearContainer(l) {
    let r = l instanceof X_ ? l : null;
    r != null && (r.Operator = 0, r.SubLogics.Clear());
  }
  CreateContainer() {
    return new X_(null);
  }
  CreateItem(l) {
    let r;
    if (!(() => {
      let o = [], c = Ud.s_dicts.TryGetValue(l, o);
      return r = o[0], c;
    })()) {
      let o = new X_(l);
      Ud.s_dicts.set_Item(l, o), r = o;
    }
    return r;
  }
  GetSubFormalLogics(l) {
    let r = l instanceof X_ ? l : null, o;
    return r == null ? o = null : o = r.SubLogics, o;
  }
  PopFromContainer(l) {
    let r = l instanceof X_ ? l : null, o;
    if (r == null)
      o = null;
    else {
      let c = r.SubLogics.Count;
      if (c > 0) {
        let T = r.SubLogics.get_Item(c - 1);
        r.SubLogics.RemoveAt(c - 1), o = T;
      } else
        o = null;
    }
    return o;
  }
  PushToContainer(l, r) {
    let o = l instanceof X_ ? l : null;
    o != null && o.SubLogics.Add(r);
  }
  SetContainerOperator(l, r) {
    let o = l instanceof X_ ? l : null;
    o != null && (o.Operator = r);
  }
  IsAcceptable(l, r) {
    return l == r;
  }
  constructor() {
    super();
  }
};
C(Ud, "s_dicts", new ro());
let Ch = Ud;
const De = class De extends Rt {
  static DoTest() {
    De.s_adapter = new Ch(), De.Parse("A", null), De.Parse("A & B", null);
    let l = De.Parse("A & (B | C)", null);
    De.Simplify(l, null);
    let r = De.Parse("A | ( B &C )", null);
    De.Simplify(r, null);
    let o = De.Parse("A |B&C", null);
    De.Simplify(o, null);
    let c = De.Parse("A & (A & B)", null);
    De.Simplify(c, null);
    let T = De.Parse("A | (A & B)", null);
    De.Simplify(T, null);
    let d = De.Parse("(A | (A &B)) &(C|A&D)", null);
    De.Simplify(d, null);
    let h = De.Parse("A & (A |B) & ( C |(D&E|F) &G)", null);
    De.Simplify(h, null), De.Parse("A & B_<xyz&anything|ddd>_C | D", null), De.s_adapter = null;
  }
  static ParseAndSimplify(l, r, o) {
    return arguments.length == 2 && (l == null || l.constructor == String) ? De.ParseAndSimplify_FormalLogicUtil_0(l, r) : De.ParseAndSimplify_FormalLogicUtil_1(l, r, o);
  }
  static ParseAndSimplify_FormalLogicUtil_0(l, r) {
    return De.Simplify(De.Parse(l, r), r);
  }
  static Parse(l, r, o) {
    return arguments.length == 2 && (l == null || l.constructor == String) ? De.Parse_FormalLogicUtil_0(l, r) : De.Parse_FormalLogicUtil_1(l, r, o);
  }
  static Parse_FormalLogicUtil_0(l, r) {
    r == null && (r = De.s_adapter);
    let o;
    if (r == null)
      o = null;
    else {
      let c = 0;
      o = (() => {
        let T = [
          c
        ], d = De.Parse(l, T, r);
        return c = T[0], d;
      })();
    }
    return o;
  }
  static ParseAndSimplify_FormalLogicUtil_1(l, r, o) {
    return De.Simplify((() => {
      let c = [
        r[0]
      ], T = De.Parse(l, c, o);
      return r[0] = c[0], T;
    })(), o);
  }
  static Parse_FormalLogicUtil_1(l, r, o) {
    o == null && (o = De.s_adapter);
    let c;
    if (o == null)
      c = null;
    else {
      let T = l.length, d = o.CreateContainer(), h = d, y = 0;
      for (; r[0] < T; ) {
        let b = r[0], U = (() => {
          let le = [
            b
          ], ue = De.skipAngle(l, T, le);
          return b = le[0], ue;
        })(), Z = de.Trim(de.Substring(l, r[0], b - r[0]));
        if (Z != "") {
          if (y != 0)
            throw new vn("Wait & | ), but got word " + Z);
          if (o.PushToContainer(h, o.CreateItem(Z)), U == 62)
            return r[0] = b, c = d, c;
          y = 1, r[0] = b + 1;
        }
        if (y == 0) {
          if (U != 40)
            throw new vn("Wait word, but got operator or end");
          r[0] = b + 1;
          let le = (() => {
            let ue = [
              r[0]
            ], be = De.Parse(l, ue, o);
            return r[0] = ue[0], be;
          })();
          o.PushToContainer(h, le), y = 2;
        } else if (y == 1) {
          if (U == 0 || U == 41) {
            r[0] = b;
            break;
          }
          if (U != 124 && U != 38)
            throw new vn("Wait oeprator got ( ");
          let le = h.Operator, ue = U != 124 ? 1 : 2;
          if (le == 0)
            o.SetContainerOperator(h, ue);
          else if (ue == 2 && le == 1)
            h == d && (d = o.CreateContainer(), o.SetContainerOperator(d, ue), o.PushToContainer(d, h)), h = d;
          else if (U == 38 && le == 2) {
            if (h != d)
              throw new vn("Impossible from algorithem");
            h = o.CreateContainer(), o.SetContainerOperator(
              h,
              1
              /* And */
            );
            let be = o.PopFromContainer(d);
            o.PushToContainer(h, be), o.PushToContainer(d, h);
          }
          y = 0, r[0] = b + 1;
        } else if (y == 2) {
          if (U != 41)
            throw new vn("Wait ) got others");
          y = 1, r[0] = b + 1;
        }
      }
      c = d;
    }
    return c;
  }
  static skipAngle(l, r, o) {
    let c = 0, T;
    for (; o[0] = de.IndexOfAny(l, De.ops, o[0]), T = 0, !(o[0] < 0); ) {
      if (T = l.charCodeAt(o[0]), T == 60)
        c = c + 1;
      else if (T == 62)
        c = c - 1;
      else if (c == 0)
        return T;
      if (c < 0)
        return T;
      o[0] = o[0] + 1;
    }
    return o[0] = r, T;
  }
  static alloc() {
    let l;
    if (De.s_caches.Count == 0)
      l = new it();
    else {
      let r = De.s_caches.get_Item(De.s_caches.Count - 1);
      De.s_caches.RemoveAt(De.s_caches.Count - 1), l = r;
    }
    return l;
  }
  static free(l) {
    l.Clear(), De.s_caches.Add(l);
  }
  static simplify(l, r) {
    let o = De.alloc(), c;
    if (l.Operator == -1) {
      let T = o, d = new Cl();
      d.Add(l), T.Add(d), c = o;
    } else if (l.Operator == 0) {
      let T = r.GetSubFormalLogics(l);
      c = De.simplify(Bo.First(T), r);
    } else {
      if (l.Operator == 2) {
        let d = r.GetSubFormalLogics(l).GetEnumerator();
        try {
          for (; d.MoveNext(); ) {
            let h = d.Current, y = De.simplify(h, r), b = y.GetEnumerator();
            try {
              for (; b.MoveNext(); ) {
                let U = b.Current;
                o.Add(U);
              }
            } finally {
              b.Dispose();
            }
            De.free(y);
          }
        } finally {
          d != null && d.Dispose();
        }
      } else if (l.Operator == 1) {
        o.Add(new Cl());
        let d = r.GetSubFormalLogics(l).GetEnumerator();
        try {
          for (; d.MoveNext(); ) {
            let h = d.Current, y = o;
            o = De.alloc();
            let b = De.simplify(h, r), U = y.GetEnumerator();
            try {
              for (; U.MoveNext(); ) {
                let Z = U.Current, le = b.GetEnumerator();
                try {
                  for (; le.MoveNext(); ) {
                    let ue = le.Current, be = new Cl(Z), Ke = ue.GetEnumerator();
                    try {
                      for (; Ke.MoveNext(); ) {
                        let ae = Ke.Current;
                        be.Add(ae);
                      }
                    } finally {
                      Ke.Dispose();
                    }
                    o.Add(be);
                  }
                } finally {
                  le.Dispose();
                }
              }
            } finally {
              U.Dispose();
            }
            De.free(y);
          }
        } finally {
          d != null && d.Dispose();
        }
      }
      o = De.simplifyHashes(o, !0), c = o;
    }
    return c;
  }
  static Simplify(l, r = null) {
    return r == null && (r = De.s_adapter), De.orAndsToLogic(De.simplify(l, r), r);
  }
  static orAndsToLogic(l, r) {
    let o;
    if (l.Count == 0)
      o = r.CreateContainer();
    else if (l.Count == 1) {
      let c = l.get_Item(0);
      o = De.pushAnds(null, c, r);
    } else {
      let c = r.CreateContainer();
      r.ClearContainer(c), r.SetContainerOperator(
        c,
        2
        /* Or */
      );
      let T = l.GetEnumerator();
      try {
        for (; T.MoveNext(); ) {
          let d = T.Current;
          r.PushToContainer(c, De.pushAnds(null, d, r));
        }
      } finally {
        T.Dispose();
      }
      o = c;
    }
    return o;
  }
  static pushAnds(l, r, o) {
    ph.Assert(r.Count > 0, "Ands should at least one element");
    let c;
    if (r.Count == 1) {
      let T = Bo.First(r);
      ph.Assert(T.Operator == -1, "simplified logics second level should be only EndNode"), c = T;
    } else {
      l == null ? l = o.CreateContainer() : o.ClearContainer(l), o.SetContainerOperator(
        l,
        1
        /* And */
      );
      let T = r.GetEnumerator();
      try {
        for (; T.MoveNext(); ) {
          let d = T.Current;
          ph.Assert(d.Operator == -1, "simplified logics second level should be only EndNode"), o.PushToContainer(l, d);
        }
      } finally {
        T.Dispose();
      }
      c = l;
    }
    return c;
  }
  static simplifyHashes(l, r = !0) {
    let o = De.alloc();
    l.Sort((c, T) => c.Count - T.Count);
    for (let c = 0; c < l.Count; c = c + 1) {
      let T = l.get_Item(c), d = !1;
      for (let h = 0; h < o.Count; h = h + 1) {
        let y = o.get_Item(h);
        d = !0;
        let b = y.GetEnumerator();
        try {
          for (; b.MoveNext(); ) {
            let U = b.Current;
            if (!T.Contains(U)) {
              d = !1;
              break;
            }
          }
        } finally {
          b.Dispose();
        }
        if (d)
          break;
      }
      d || o.Add(T);
    }
    return r && De.free(l), o;
  }
  static CheckAssignable(l, r, o) {
    o == null && (o = De.s_adapter);
    let c;
    if (r.Operator == 2) {
      let d = o.GetSubFormalLogics(r).GetEnumerator();
      try {
        for (; d.MoveNext(); ) {
          let h = d.Current;
          if (!De.CheckAssignable(l, h, o))
            return c = !1, c;
        }
      } finally {
        d != null && d.Dispose();
      }
      c = !0;
    } else {
      if (r.Operator == 1)
        if (l.Operator == 2) {
          let d = o.GetSubFormalLogics(l).GetEnumerator();
          try {
            for (; d.MoveNext(); ) {
              let h = d.Current;
              if (De.CheckAssignable(h, r, o))
                return c = !0, c;
            }
          } finally {
            d != null && d.Dispose();
          }
        } else {
          if (l.Operator == 1) {
            let T = o.GetSubFormalLogics(l), d = o.GetSubFormalLogics(r), h = T.GetEnumerator();
            try {
              for (; h.MoveNext(); ) {
                let y = h.Current, b = !1, U = d.GetEnumerator();
                try {
                  for (; U.MoveNext(); ) {
                    let Z = U.Current;
                    if (o.IsAcceptable(y, Z)) {
                      b = !0;
                      break;
                    }
                  }
                } finally {
                  U != null && U.Dispose();
                }
                if (!b)
                  return c = !1, c;
              }
            } finally {
              h != null && h.Dispose();
            }
            return c = !0, c;
          }
          if (l.Operator == -1) {
            let d = o.GetSubFormalLogics(r).GetEnumerator();
            try {
              for (; d.MoveNext(); ) {
                let h = d.Current;
                if (o.IsAcceptable(l, h))
                  return c = !0, c;
              }
            } finally {
              d != null && d.Dispose();
            }
            return c = !1, c;
          }
        }
      else if (r.Operator == -1)
        if (l.Operator == 2) {
          let d = o.GetSubFormalLogics(l).GetEnumerator();
          try {
            for (; d.MoveNext(); ) {
              let h = d.Current;
              if (De.CheckAssignable(h, r, o))
                return c = !0, c;
            }
          } finally {
            d != null && d.Dispose();
          }
        } else {
          if (l.Operator == 1) {
            let d = o.GetSubFormalLogics(l).GetEnumerator();
            try {
              for (; d.MoveNext(); ) {
                let h = d.Current;
                if (!o.IsAcceptable(h, r))
                  return c = !1, c;
              }
            } finally {
              d != null && d.Dispose();
            }
            return c = !0, c;
          }
          if (l.Operator == -1)
            return c = o.IsAcceptable(l, r), c;
        }
      c = !1;
    }
    return c;
  }
  constructor() {
    super();
  }
};
C(De, "s_adapter", null), C(De, "ops", [
  40,
  /*'('*/
  41,
  /*')'*/
  124,
  /*'|'*/
  38,
  /*'&'*/
  60,
  /*'<'*/
  62
]), C(De, "s_caches", new it());
let Cs = De;
var ye = function(i, l) {
  return i == null ? "" : Wg(i, l);
};
let vh;
function $g(i) {
  vh = i;
}
function Wg(i, l) {
  return vh ? vh.doLoc(i, l) : i;
}
var fI = /* @__PURE__ */ ((i) => (i.English = "en", i.SimplifiedChinese = "zh-cn", i.TraditionalChinese = "zh-tw", i.Thai = "th", i.Vietnamese = "vn", i.Indonesia = "ind", i.BrazilianPortuguese = "pt-br", i.Spanish = "es", i.Russian = "ru", i.Korean = "ko", i.French = "fr", i.German = "de", i.Turkish = "tr", i.Hindi = "hi", i.Japanese = "ja", i.Romanian = "ro", i.Arabic = "ar", i.Burmese = "my", i.Urdu = "ur", i.Bengali = "bn", i))(fI || {});
const Cm = "en";
class kg {
  constructor() {
    C(this, "locData", {});
    C(this, "locLang");
    C(this, "curLocData");
    this.locLang = "en";
  }
  hasLang(l) {
    return this.locData[l] != null;
  }
  async init(l) {
    await this.loadLocData(l);
  }
  async loadLocData(l) {
    const r = /* @__PURE__ */ Object.assign({ "./Config/Loc/FE/fe_loc-ar.json": () => import("./fe_loc-ar-BtT68rcu.js"), "./Config/Loc/FE/fe_loc-en.json": () => import("./fe_loc-en-C9gpzVVJ.js"), "./Config/Loc/FE/fe_loc-es.json": () => import("./fe_loc-es-i5nIyn8X.js"), "./Config/Loc/FE/fe_loc-id.json": () => import("./fe_loc-id-Cg1as6OH.js"), "./Config/Loc/FE/fe_loc-pt.json": () => import("./fe_loc-pt-iqJ4vP64.js"), "./Config/Loc/FE/fe_loc-th.json": () => import("./fe_loc-th-DEqJ6XEN.js"), "./Config/Loc/FE/fe_loc-vi.json": () => import("./fe_loc-vi-BHK2xLT8.js"), "./Config/Loc/FE/fe_loc-zh-Hans.json": () => import("./fe_loc-zh-Hans-Dv5ftVQP.js"), "./Config/Loc/FE/fe_loc-zh-Hant.json": () => import("./fe_loc-zh-Hant-tYLZBu2L.js"), "./Config/Loc/FF/ar.json": () => import("./ar-B1-IRpWM.js"), "./Config/Loc/FF/bn.json": () => import("./bn-eweKUPyk.js"), "./Config/Loc/FF/de.json": () => import("./de-y7q9M1Fh.js"), "./Config/Loc/FF/en-in.json": () => import("./en-in-DxI1KRWU.js"), "./Config/Loc/FF/en.json": () => import("./en-BLNHmQLD.js"), "./Config/Loc/FF/es.json": () => import("./es-BlWOaCo1.js"), "./Config/Loc/FF/fr.json": () => import("./fr-DLPBivDf.js"), "./Config/Loc/FF/hi.json": () => import("./hi-B-rytAOF.js"), "./Config/Loc/FF/ind.json": () => import("./ind-BH1eBXoj.js"), "./Config/Loc/FF/ja.json": () => import("./ja-BYuTwn-T.js"), "./Config/Loc/FF/ko.json": () => import("./ko-DxfdhOrg.js"), "./Config/Loc/FF/my.json": () => import("./my-BX745sIQ.js"), "./Config/Loc/FF/pt-br.json": () => import("./pt-br-C215HI-a.js"), "./Config/Loc/FF/ro.json": () => import("./ro-BgjAMTXs.js"), "./Config/Loc/FF/ru.json": () => import("./ru-y-KU3Skk.js"), "./Config/Loc/FF/th.json": () => import("./th-DTEyRX77.js"), "./Config/Loc/FF/tr.json": () => import("./tr-Kst30DGV.js"), "./Config/Loc/FF/ur.json": () => import("./ur-CJMgEqAU.js"), "./Config/Loc/FF/vn.json": () => import("./vn-D_UbQ9I3.js"), "./Config/Loc/FF/zh-cn.json": () => import("./zh-cn-CVxTNnQO.js"), "./Config/Loc/FF/zh-tw.json": () => import("./zh-tw-D383rpqv.js") });
    let o = [];
    return Object.entries(r).forEach(([c, T]) => {
      const d = wg(c, ".json"), h = Fg(d);
      (h === Cm || h === l) && o.push(new Promise(async (y, b) => {
        try {
          const U = await T();
          y({
            locale: h,
            data: U.default
          });
        } catch (U) {
          console.error("load localization json error", U), b(U);
        }
      }));
    }), Promise.all(o).then((c) => {
      c.forEach((T) => {
        const d = T.locale;
        this.locData[d] || (this.locData[d] = {});
        const h = T.data;
        this.locData[d] = Object.assign(this.locData[d], h);
      });
    });
  }
  SetLanguage(l) {
    this.locLang = l, this.curLocData = this.locData[l];
  }
  doLoc(l, r) {
    if (!this.curLocData)
      return l;
    let o = this.curLocData[l];
    if (o || (o = this.locData[Cm][l] ?? l), Array.isArray(r))
      r.forEach((c, T) => {
        o = o.replace(`{${T}}`, c);
      });
    else if (typeof r == "object")
      for (const [c, T] of Object.entries(r))
        o = o.replace(`{${c}}`, T);
    return o;
  }
}
function wg(i, l) {
  i = i.replace(/\/+$/, "");
  let r = i.substring(i.lastIndexOf("/") + 1);
  return r.slice(-l.length) === l && (r = r.slice(0, -l.length)), r;
}
function Fg(i) {
  const l = "fe_loc-";
  if (i.startsWith(l)) {
    let r = i.replace(l, "");
    switch (r) {
      case "zh-Hant":
        r = "zh-tw";
        break;
      case "zh-Hans":
        r = "zh-cn";
        break;
      case "vi":
        r = "vn";
        break;
      case "id":
        r = "ind";
        break;
      case "pt":
        r = "pt-br";
        break;
    }
    return r;
  }
  return i;
}
const re = {
  If_Craftland: "T_34_WZ_WS_LOGIC5_NAME",
  Foreach_craftland: "T_34_WZ_WS_LOGIC7_NAME",
  Warning_TypeAssign: "T_37_SP_WS_LOG_VAR_ASSIGNMENT_OPERATOR_MISMATCH",
  Warning_NoDefine: "FE_0_HW_WARNING_NODEFINE",
  Warning_LowLevel: "FE_0_HW_WARNING_NODEFINE",
  Warning_Deprecated: "T_40_XXJ_WS_OBSOLETE",
  Warning_Param_NoDefine: "FE_0_HW_WARNING_PARAM_NODEFINE",
  Warning_ReturnNotInFunction: "FE_0_HW_WARNING_RETURNNOTINFUNCTION",
  Warning_FunctionSignature_ReturnType: "FE_0_HW_WARNING_FUNCTIONSIGNATURE_RETURNTYPE",
  Warning_FunctionSignature_Parameters: "FE_0_HW_WARNING_FUNCTIONSIGNATURE_PARAMETERS",
  Warning_LocalVar_NoDefine: "FE_0_HW_WARNING_LOCALVAR_NODEFINE",
  Warning_LocalVar_OOS: "FE_0_HW_WARNING_LOCALVAR_OOS",
  Deprecated: "T_42_XXJ_WS_OBSOLETE",
  Tip_NoExternal: "FE_0_HW_TIP_NOEXTERNAL",
  Tip_NotTransform: "FE_43A_HZY_ERROR_TIP1",
  ListTypeLabel: "FE_0_HW_GRAPH_LISTTYPELABEL",
  ListGet: "FE_0_HW_GRAPH_LISTGET",
  // Get xxx idx
  ListCreate: "FE_0_HW_GRAPH_CREATELIST",
  //TODO: 使用如下定义替换三部分组成
  //Set %1 [%2] = %3
  ListSet: "FE_0_HW_GRAPH_LISTSET",
  ListSet_1: "[",
  ListSet_2: "] =",
  //TODO: 使用如下定义替换两部分组成
  //Append %1 with value %2    
  ListAppend: "FE_0_HW_GRAPH_LISTAPPEND",
  ListAppend_1: "FE_0_HW_GRAPH_LISTAPPEND_1",
  //TODO: 使用如下定义替换三部分组成
  //Insert %1 with value %2 at %3
  ListInsert: "FE_0_HW_GRAPH_LISTINSERT",
  ListInsert_1: "FE_0_HW_GRAPH_LISTINSERT_1",
  ListInsert_2: "FE_0_HW_GRAPH_LISTINSERT_2",
  NewMap: "T_40_XXJ_WS_NEWMAP_NAMEKEY",
  ConditionalStatement: "FE_38_B_ECA_CONDITIONAL_STATEMENT",
  If: "FE_0_HW_GRAPH_IF",
  ElseIf: "FE_0_HW_GRAPH_ELSEIF",
  Else: "FE_0_HW_GRAPH_ELSE",
  ExternalCall: "FE_0_HW_GRAPH_EXTERNALCALL",
  CallReturn: "FE_0_HW_GRAPH_CALLRETURN",
  ParallelCall: "FE_0_HW_GRAPH_PARALLELCALL",
  SerialCall: "FE_0_HW_GRAPH_SERIALCALL",
  Int: "FE_0_HW_GRAPH_INT",
  Index: "FE_0_HW_GRAPH_INDEX",
  // 数组编号
  Text: "FE_0_HW_GRAPH_TEXT",
  Float: "FE_0_HW_GRAPH_FLOAT",
  Number: "FE_0_HW_GRAPH_NUMBER",
  NULL: "FE_0_HW_GRAPH_NULL",
  PI: "T_42_XXJ_WS_MATHPI",
  E: "T_42_XXJ_WS_MATHE",
  Vector3: "T_34_M_WS_VECTOR",
  Boolean: "T_34_M_WS_BOOL",
  Color: "T_34_M_WS_COLOUR",
  FunctionDefineValution: "FE_0_HW_GRAPH_FUNCTION_DEFINE_VAL",
  FunctionDefineAction: "FE_0_HW_GRAPH_FUNCTION_DEFINE_ACT",
  FunctionDefineReturn: "FE_0_HW_GRAPH_FUNCTION_DEFINE_RETURN",
  FunctionDefineBehaviorAction: "T_41_XXJ_WS_BTREENODESTATE",
  FunctionXBTAction: "FE_42_JH_AIEDITOR_ACTIONFUNCNAME",
  FunctionXBTCondition: "FE_42_JH_AIEDITOR_TICKFUNCNAME",
  ReturnSentense: "FE_0_HW_GRAPH_RETURN_SENTENSE",
  FunctionCall: "FE_38_B_ECA_CALL_FUNCTION",
  FunctionCallTooltip: "FE_42A_HZY_WS_FUNCTIONCALL_D",
  FunctionMutatorParameters: "FE_0_HW_GRAPH_FUNCTION_MUTATOR_PARA",
  While: "T_34_WZ_WS_LOGIC8_NAME",
  //TODO: 使用如下定义替换四部分组成
  // for index %1 from %2 to %3 by step %4        
  ForIndex: "FE_0_HW_GRAPH_FOR_INDEX",
  ForIndex_1: "FE_0_HW_GRAPH_FOR_INDEX_1",
  ForIndex_2: "FE_0_HW_GRAPH_FOR_INDEX_2",
  ForIndex_3: "FE_0_HW_GRAPH_FOR_INDEX_3",
  //TODO: 使用如下定义替换三部分组成
  // foreach  %1  %2 in %3
  Foreach: "FE_0_HW_GRAPH_FOREACH",
  Foreach_2: "FE_0_HW_GRAPH_FOREACH_2",
  Break: "FE_0_HW_GRAPH_BREAK",
  Continue: "FE_0_HW_GRAPH_CONTINUE",
  //TODO: 使用如下定义替换两部分组成
  // get %1 from %2
  PropertyGet: "FE_0_HW_GRAPH_PROPERTY_GET",
  PropertyGet_1: "FE_0_HW_GRAPH_PROPERTY_GET_1",
  // get %1 of %2
  PropertyGet_2: "T_34_WT_WS_ENTITY4_NAME",
  PropertyGet_3: "T_34_WT_WS_ENTITY2_PARAM3",
  TupleGet: "T_50_HJ_SEARCHKEY_TUPLEGET",
  //TODO: 使用如下定义替换三部分组成
  // set %1 %2 with %3
  PropertySet: "FE_0_HW_GRAPH_PROPERTY_SET",
  PropertySet_1: "",
  PropertySet_2: "FE_0_HW_GRAPH_PROPERTY_SET_2",
  TupleSet: "T_50_HJ_SEARCHKEY_TUPLESET",
  //TODO: 使用如下定义替换三部分组成
  // extern get %graph %property from %entity
  ExternalGet: "FE_0_HW_GRAPH_EXTERNAL_GET",
  ExternalGet_2: "FE_0_HW_GRAPH_EXTERNAL_GET_2",
  //TODO: 使用如下定义替换四部分组成
  // extern set %entity %graph %property with %value
  ExternalSet: "FE_0_HW_GRAPH_EXTERNAL_SET",
  ExternalSet_3: "FE_0_HW_GRAPH_EXTERNAL_SET_3",
  // get global %1
  GlobalGet: "FE_0_HW_GRAPH_GLOBAL_GET",
  //TODO: 使用如下定义替换两部分组成
  // set global %1 with %2
  GlobalSet: "T_40_XXJ_WS_SETGLOBAL",
  GlobalSet_1: "FE_0_HW_GRAPH_GLOBAL_SET_1",
  UnkownType: "FE_0_HW_GRAPH_UNKOWN_TYPE",
  Unselected: "FE_0_HW_GRAPH_NONE",
  // 未选择时出现的内容
  None: "T_41_XXJ_WS_NONE1",
  AsType: "FE_0_HW_GRAPH_AS_TYPE",
  //TODO: 使用如下定义替换两部分组成
  // %1 = %2
  LocalvarSet: "FE_0_HW_GRAPH_PROPERTY_SET",
  LocalvarSet_1: "=",
  LocalvarGet: "",
  LcoalvarDefine: "FE_44_M_WS_LOCALVAR",
  LcoalvarDefineTooltip: "FE_42A_HZY_WS_LOCALVAR_D",
  OpAnd: "FE_0_HW_GRAPH_OP_AND",
  OpOr: "FE_0_HW_GRAPH_OP_OR",
  ArithAdd: "+",
  ArithSub: "-",
  ArithMultiply: "×",
  ArithDivide: "÷",
  ArithMod: "%",
  CompareEqual: "==",
  CompareNotEqual: "≠",
  // ≠
  CompareLess: "‏<",
  // <
  CompareLessEqual: "‏≤",
  // ≤
  CompareGreater: "‏>",
  // >
  CompareGreaterEqual: "‏≥",
  // ≥
  ThisEntity: "T_47_XXJ_WS_THISENTITY",
  CreateHud: "T_34_SP_WS_BLOCK6_NAME",
  CreateHud_Tip: "T_34_SP_WS_BLOCK6_NAMEDESC",
  CreateHud_OwnerPlayer: "T_34_SP_WS_BLOCK6_PARAM2_NAME",
  CreateHud_OwnerPlayer_Tip: "T_34_SP_WS_BLOCK6_PARAM2_NAMEDESC",
  GetWidgetFromCustomHud: "T_34_M_WS_GETCONTROL",
  CustomHud: "T_34_M_WS_CUSTOMINF",
  PickEntity: "FE_0_HW_GRAPH_PICK_ENTITY",
  //选择场景物件
  PickWidget: "FE_0_HW_GRAPH_PICK_WIDGET",
  //选择UI控件
  SceneID: "FE_0_Q_SENCE_ENUM",
  //场景枚举
  SceneFile: "FE_0_F_PROJECT_SCENE",
  ItemGoodsLabel: "T_35_WZY_WS_ITEMSTYPE_NAMEDESC",
  SoundLabel: "T_34_M_WS_SOUND",
  PrefabLabel: "FE_0_F_PROJECT_PREFAB",
  IconLabel: "T_34_M_WS_ICON",
  TextureIDLabel: "T_38_WZY_WS_TEXTUREID",
  EffectIDLabel: "T_38_WZY_WS_PARTICALMAP",
  DynamicCreateItemLabel: "T_36_WZY_WS_CREABLEOB",
  EffectLabel: "T_34_M_WS_VFX",
  InternalHud: "T_36_WZY_WS_HUDTYPE",
  False: "FE_0_Q_FALSE",
  True: "FE_0_Q_TRUE",
  More: "FE_0_B_ECA_MORE",
  GetVar: "FE_0_HW_CATEGORY_VARIBLE",
  SetVar: "FE_38_B_ECA_SET_VARIABLE",
  FixFunctionCaller: "以下参数与定义不相符",
  FixFunctionCallerTip: "删除多余参数",
  LocalizationKeyParams: "FE_38_B_ECA_PARALIST",
  ECAScript: "FE_0_F_ECA_SCRIPT",
  Script: "FE_40_B_SCRIPT",
  // eca + fcg
  Behavior: "FE_41_JH_BT_BTNAME",
  Entity: "T_34_M_WS_ENTITY",
  Concat: "T_34_LY_WS_JOIN",
  StringConcatTip: "T_34_LY_WS_STRC_DESC",
  Value: "T_34_WT_WS_ENTITY2_PARAM4",
  ClothSkinSet: "T_40_XXJ_WS_SETPLAYERCLOTHIDBYWARDROBETYPE_DESCKEY",
  WeaponSkinSet: "T_40_XXJ_WS_SETPLAYERWEAPONSKINIDBYWEAPONID_NAMEKEY",
  Player: "T_34_WT_WS_ENTITY7_PARAM1",
  WardrobeType: "T_40_XXJ_WS_WARDROBETYPE_NAMEKEY",
  ClothID: "T_40_XXJ_WS_CLOTHID_NAMEKEY",
  WeaponIDLabel: "FE_40_XXJ_WEASKINSTYPE",
  ClothIDLabel: "FE_40_XXJ_CLOTHESTYPE",
  VehicleSkinIDLabel: "T_42_XXJ_WS_VEHICLESKINID",
  BagIDLabel: "T_44_XXJ_WS_BAGSKINID",
  PlayerSkill: "T_44_XXJ_WS_PLAYERSKILLID",
  PetSkill: "T_37_WZY_WS_PETSKILL",
  Comment: "FE_40_SD_NOTE",
  EmoteIDLabel: "T_32_LC_NEWVAULT_EMOTE",
  Object3DResourceLabel: "T_41_XXJ_WS_RESOURCEID",
  Resource: "FE_0_HW_MENU_ASSET",
  Enum: "FE_39_B_ENUM",
  Arithmetic: "T_36_WZY_WS_ARITHMETIC_NAME",
  Compare: "T_34_WZ_WS_LOGIC2_NAME",
  VarIn: "FE_42_XXJ_INVAR",
  VarOut: "FE_42_XXJ_OUTVAR",
  ReadAcc: "T_41_XXJ_WS_READDBACCUMULATEDDATA",
  WriteAcc: "T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET",
  WorkShopCode: "T_42_XXJ_WS_WORKSHOPCODE",
  SheetName: "T_40_XXJ_WS_DBTABLENAME",
  SheetKey: "T_40_XXJ_WS_DBKEY_NAMEKEY",
  VectorOperation: "FE_43_XXJ_VECTOR3OPERATIONS",
  VectorDotProduct: "T_34_LY_WS_VDP",
  VectorCrossProduct: "T_34_LY_WS_VCP",
  VectorDistance: "FE_0_HW_CAMERA_DISTANCE",
  VectorIncludedAngle: "T_34_LY_WS_VANG",
  VectorGetter: "FE_43_XXJ_GETVECTOR3COMPONENT",
  VectorSetter: "FE_43_XXJ_SETVECTOR3COMPONENT",
  Vector2Operation: "FE_43_XXJ_VECTOR2OPERATIONS",
  Vector2Getter: "FE_43_XXJ_GETVECTOR2COMPONENT",
  Vector2Setter: "FE_43_XXJ_SETVECTOR2COMPONENT",
  PlayerDataID: "T_43_YU_WS_PLAYERDATAID",
  AnimationClipID: "T_43_YU_WS_ANIMATIONCLIPID",
  AtlasIDLabel: "T_54_META_TYP_39_I15",
  PrintInfo: "T_44_XXJ_WS_PRINT",
  LogString: "T_46_META_WS_A_LOG",
  LogWarning: "T_46_META_WS_E_WARNING",
  LogError: "TXT_MESSAGEBOX_ERROR",
  RegisteredAsset: "FE_44_XXJ_GETRIGISTERASSETBYKEY",
  AssetType: "FE_44_XXJ_ASSETTYPE",
  AssetName: "FE_44_XXJ_WS_RIGISTERRESNAME",
  Component: "T_38_WZY_WS_COMPONENT",
  Type: "T_34_WT_WS_ENTITY13_PARAM1",
  NumToString: "FE_46_XXJ_NUMTOFLOAT",
  NumFormatG: "FE_46_XXJ_NUMTOFLOAT2",
  NumFormatType: "FE_46_XXJ_FORMAT",
  NumFormatF: "FE_46_XXJ_NUMTOFLOAT1",
  NumFormatE: "FE_46_XXJ_NUMTOFLOAT3",
  NumFormatN: "FE_46_LJY_NUMTOSTRING5",
  NumFormatP: "FE_46_XXJ_NUMTOFLOAT4",
  FormatValue: "FE_46_XXJ_FORMATVALUE",
  CollectRes: "FE_46_XXJ_RESCOLLECT",
  NecessaryRes: "FE_46_XXJ_MUSTRES",
  DynamicRes: "FE_46_XXJ_DYNAMICRES",
  PersonaID: "T_47_XXJ_WS_PERSONAID",
  ObsoleteTip: "FE_44_XXJ_COMPOBSOLETE",
  Obsoleted: "T_42_XXJ_WS_OBSOLETE",
  AnimationController: "T_49_META_TYP_314_I1_D",
  AnimationState: "T_46_META_WS_A_STATE",
  GetPropertyId: "T_48_META_API_2014_P0"
};
let f = {};
function Bg() {
  f = {};
  for (let i in re) {
    let l = i;
    f[l] = ye(re[l]);
  }
}
var I = /* @__PURE__ */ ((i) => (i.shadow_craftland = "shc", i.action = "a", i.valution = "v", i.event = "e", i.propertyref = "p", i.get_property_id = "gpi", i.list_set = "lis", i.list_get = "lig", i.list_insert = "lii", i.list_append = "lia", i.list_create = "lic", i.list_dictionary = "lid", i.ctrl_ifelse = "ife", i.ctrl_ifelse1 = "ife1", i.loop_while = "lpw", i.loop_forindex = "lpi", i.loop_foreach = "lpe", i.loop_continue = "lpc", i.loop_break = "lpb", i.op_logic = "opl", i.op_compare = "opc", i.op_arith = "opa", i.op_string = "ops", i.input_null = "nul", i.input_pi = "pi", i.input_e = "ie", i.input_int = "ipi", i.input_intplus = "ipp", i.input_float = "ipf", i.input_text = "ipt", i.input_color = "ipc", i.input_boolean = "ipb", i.input_enum = "ipe", i.input_number = "ipn", i.input_vector3 = "ipv", i.input_vector2 = "ipv2", i.input_localization_key = "ipk", i.input_bezier = "ipbz", i.input_tag = "iptag", i.input_textarea = "ipta", i.input_comments = "ipcm", i.key_enum = "kye", i.externvar_get = "exg", i.externvar_set = "exs", i.extern_call_value = "exv", i.extern_call_action = "exa", i.function_definition_valution = "fnv", i.function_definition_action = "fna", i.function_return = "fnr", i.function_xbt_action = "fnxbta", i.function_xbt_condition = "fnxbtc", i.function_mutator_container = "fnc", i.function_mutator_parameter = "fnp", i.function_call_value = "fcv", i.function_call_action = "fca", i.graphvar_get = "grg", i.graphvar_set = "grs", i.pick_entity = "pke", i.pick_hudwidget = "pkw", i.pick_hudwidgetid = "pwi", i.pick_itemgoods = "pki", i.pick_sound = "psd", i.pick_script = "psc", i.pick_xbt = "pxbt", i.pick_csv = "pcv", i.pick_prefab = "pfb", i.pick_icon = "pin", i.pick_atlas = "patl", i.pick_texture = "ptx", i.pick_effect = "pef", i.pick_cloth_skin = "pkch", i.pick_weapon_skin = "pkws", i.pick_emote_skin = "pem", i.pick_vehicle_skin = "pvs", i.pick_hud = "pkh", i.pick_obj3d = "pk3", i.raw_resource = "rrs", i.pick_dynamic_create_item = "pkdc", i.pick_effect_type = "pet", i.pick_internal_hud = "pih", i.pick_player_data_id = "ppd", i.pick_animation_clip_id = "pac", i.pick_animation_ctrl_id = "pal", i.pick_material_id = "pim", i.pick_mesh_id = "pme", i.pick_bag_id = "pkbg", i.pick_skill_id = "pkskl", i.pick_pet_skill_id = "pkpskl", i.pick_scene_id = "pks", i.pick_particles_id = "ppt", i.pick_performance = "pperformance", i.create_hud_deprecated = "chd", i.property_get = "prg", i.property_set = "prs", i.globalvar_get = "glg", i.globalvar_set = "gls", i.shadow_type = "tys", i.shadow_default = "tyd", i.as_type = "tya", i.typeid = "tyi", i.componentid = "tyc", i.localvar_get = "lcg", i.localvar_set = "lcs", i.localvar_def = "lcd", i.this_entity = "ent", i.hud_buttonevent = "hbe", i.hud_joystickevent = "hje", i.sheet_data = "sdt", i.sheet_data_client = "sdc", i.sheet_rank = "srk", i.sheet_statistic = "sst", i.sheet_multicol = "smc", i.sheet_multicol_client = "smcc", i.sheet_column = "scl", i.read_statistic = "rst", i.write_statistic = "wst", i.read_statistic_v2 = "rst2", i.write_statistic_v2 = "wst2", i.write_statistic_cross_map = "wstc", i.read_statistic_err = "rst3", i.write_statistic_err = "wst3", i.write_statistic_cross_map_err = "wstc3", i.write_statistic_err_v2 = "wst4", i.write_statistic_cross_map_err_v2 = "wstc4", i.statistic_sheet_operation = "sstop", i.data_storage_integrate = "dsms", i.signal_shoot = "sls", i.signal_shootv2 = "slsv2", i.signal_receive = "slr", i.signal_shootV3 = "ss", i.signal_shootV4 = "slsv4", i.vector3_operation = "v3op", i.vector3_get = "v3g", i.vector3_set = "v3s", i.vector3_setxyz = "v3sxyz", i.vector2_operation = "v2op", i.vector2_get = "v2g", i.vector2_set = "v2s", i.vector2_setxy = "v2sxy", i.print_info = "print", i.pick_registeredAsset = "pkassett", i.num_to_string = "n2s", i.pick_persona_id = "persona", i.tuple_get = "tug", i.tuple_set = "tus", i.tuple_create = "tuc", i.animation_state = "ast", i))(I || {});
for (let i in I)
  I[i];
var Ht = /* @__PURE__ */ ((i) => (i.InVar = "", i.OutVar = "o", i))(Ht || {});
function Rl(i) {
  return "P" + i;
}
var E = /* @__PURE__ */ ((i) => (i.Value = "V", i.Header = "A", i.This = "H", i.Label = "B", i.Item = "I", i.Name = "N", i.Type = "T", i.Property = "P", i.Operator = "O", i.Index = "X", i.Condition = "C", i.ConditionIds = "CIDS", i.Code = "D", i.Return = "R", i.Entity = "E", i.GraphID = "G", i.ParamList = "L", i.Dimensions = "DIM", i.V1 = "V1", i.V2 = "V2", i.V3 = "V3", i.From = "FR", i.To = "TO", i.Step = "ST", i.Range = "RN", i.Player = "PL", i.T1 = "T1", i.T2 = "T2", i.Key = "K", i.VarRef = "VR", i.VarID = "VI", i.VarDef = "VD", i.OwnerType = "OT", i.GraphName = "GN", i.Color = "CO", i.ColorStr = "CS", i.Hud = "HD", i.BlockStyle = "BSTYL", i.Bezier = "BZ", i.EntityTag = "ETAG", i.WardrobeType = "WRT", i.TypeLabel = "TPL", i.Owner = "ow", i.AssetType = "AssetTP", i.Version = "VER", i))(E || {}), Vd = /* @__PURE__ */ ((i) => (i.Start = "S", i.Wait = "W", i))(Vd || {}), dt = /* @__PURE__ */ ((i) => (i.Unknown = "UK", i.Add = "AD", i.Substract = "SU", i.Multiply = "MU", i.Divide = "DI", i.Mod = "MD", i))(dt || {}), Wd = /* @__PURE__ */ ((i) => (i.And = "AND", i.Or = "OR", i))(Wd || {}), fs = /* @__PURE__ */ ((i) => (i.Equal = "EQ", i.NotEqual = "NE", i.Greater = "GT", i.GreaterEqual = "GE", i.Less = "LT", i.LessEqual = "LE", i))(fs || {}), et = /* @__PURE__ */ ((i) => (i.Addition = "Addition", i.Subtraction = "Subtraction", i.Multiplication = "Multiplication", i.DotProduct = "DotProduct", i.CrossProduct = "CrossProduct", i.Distance = "Distance", i.IncludedAngle = "IncludedAngle", i))(et || {}), yl = /* @__PURE__ */ ((i) => (i.Regular = "G", i.Float = "F", i.ScientificNotation = "E", i.ThousandsSeparator = "N", i.Percentage = "P", i))(yl || {});
function Ut(i) {
  if (i.saveExtraState) {
    const l = i.saveExtraState();
    return l ? JSON.stringify(l) : "";
  } else if (i.mutationToDom) {
    const l = i.mutationToDom();
    return l ? N.Xml.domToText(l) : "";
  }
  return "";
}
let J = {
  SceneName: "",
  SceneId: "",
  OwnerType: "",
  ComponentTypes: "",
  curTarget: 0,
  graphElementMap: /* @__PURE__ */ new Map(),
  // key is Graph Element Id
  geIdReverseMap: /* @__PURE__ */ new Map(),
  // block.type=>geId or name=>geId
  internalBlocks: /* @__PURE__ */ new Map(),
  availableInternalModIds: [],
  //get entity Info
  func_getEntityInfo: null,
  func_getPrefabInfo: null,
  func_entityPickList: null,
  func_hudWidgetList: null,
  func_hudList: null,
  func_pickSceneEntity: null,
  func_showResourceSelector: null,
  containsKey: null
};
J.containsKey = function(i, l) {
  return i ? i.toLowerCase().includes(l) : !1;
};
const Hh = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTAuODA0MiIgeT0iMS44OTQ4OCIgd2lkdGg9IjIuOCIgaGVpZ2h0PSIxMS45IiByeD0iMS40IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMC44MDQyIDEuODk0ODgpIiBzdHJva2U9IiNEQ0UwRTciIHN0cm9rZS13aWR0aD0iMC43Ii8+CjxyZWN0IHg9IjIuODg0NzciIHk9IjEwLjgwNDMiIHdpZHRoPSIxLjQiIGhlaWdodD0iMS40IiByeD0iMC43IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAyLjg4NDc3IDEwLjgwNDMpIiBzdHJva2U9IiNEQ0UwRTciIHN0cm9rZS13aWR0aD0iMC43Ii8+CjxwYXRoIGQ9Ik05LjU2Njc2IDIuNjM3MzRDMTAuMjUwMiAxLjk1MzkyIDExLjM1ODIgMS45NTM5MiAxMi4wNDE2IDIuNjM3MzRDMTIuNzI1MSAzLjMyMDc2IDEyLjcyNTEgNC40Mjg4IDEyLjA0MTYgNS4xMTIyMUw4LjgyNDMgOC4zMjk1NUw2LjM0OTQzIDUuODU0NjdMOS41NjY3NiAyLjYzNzM0WiIgZmlsbD0iI0RDRTBFNyIvPgo8cGF0aCBkPSJNNS42MDc0OSA0LjYxNzEyQzUuNzQ0MTggNC40ODA0MyA1Ljk2NTc4IDQuNDgwNDMgNi4xMDI0NyA0LjYxNzEyTDEwLjA2MjMgOC41NzY5MUMxMC4xOTg5IDguNzEzNiAxMC4xOTg5IDguOTM1MjEgMTAuMDYyMyA5LjA3MTg5QzkuOTI1NTggOS4yMDg1NyA5LjcwMzk3IDkuMjA4NTcgOS41NjcyOSA5LjA3MTg5TDUuNjA3NDkgNS4xMTIwOUM1LjQ3MDgxIDQuOTc1NDEgNS40NzA4MSA0Ljc1MzggNS42MDc0OSA0LjYxNzEyWiIgZmlsbD0iI0RDRTBFNyIvPgo8L3N2Zz4K", Ug = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8bGluZSB4MT0iMjAiIHkxPSIwIiB4Mj0iMjAiIHkyPSI0MCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI2IiBvcGFjaXR5PSIwLjUiIC8+CiAgPGxpbmUgeDE9IjAiIHkxPSIyMCIgeDI9IjE3IiB5Mj0iMjAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iNiIgb3BhY2l0eT0iMC41IiAvPgogIDxsaW5lIHgxPSIyMyIgeTE9IjIwIiB4Mj0iNDAiIHkyPSIyMCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSI2IiBvcGFjaXR5PSIwLjUiIC8+Cjwvc3ZnPg==", Vg = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjg1NjkgMTEuODU5OVYxMC43MTQySDE4LjU3MTJWMTEuODU5OUgxMi44NTY5Wk0xMi44NTY5IDE0Ljk5OTlWMTMuODU0M0gxOC41NzEyVjE0Ljk5OTlIMTIuODU2OVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik03LjY0NjMyIDVMOC43MDc0NCA5LjE4MTNMMTIuODczNiA1SDE1TDEzLjk5NDIgNS43NjUxOUw5LjM4NDA2IDEwLjExMzRMMTAuNzcyNSAxNC40ODQ5TDExLjQyODYgMTUuMjI2OUg5LjA3NjM1TDcuOTM2MTIgMTEuMjU4NkwzLjg0OTA3IDE1LjIyNjlIMS40Mjg3NUwyLjY5NTczIDE0LjQ4NDlMNy4yODE3OSAxMC4xMTM0TDUuOTQ5MDQgNS43NjUxOUw1IDVINy42NDYzMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=", vl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41IDAuNUgwLjVWMTEuNUgxMS41VjAuNVpNNi44NzUgMi41SDUuMTI1VjUuMTI1SDIuNVY2Ljg3NUg1LjEyNVY5LjVINi44NzVWNi44NzVIOS41VjUuMTI1SDYuODc1VjIuNVoiIGZpbGw9IiNEQ0UwRTciLz4KPC9zdmc+Cg==", Os = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41IDAuNUgwLjVWMTEuNUgxMS41VjAuNVpNOS41IDUuMTI1VjYuODc1SDIuNVY1LjEyNUg5LjVaIiBmaWxsPSIjRENFMEU3Ii8+Cjwvc3ZnPgo=", CI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDIgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHgxPSIxLjI1IiB5MT0iLTIuMTg1NTdlLTA4IiB4Mj0iMS4yNSIgeTI9IjI0IiBzdHJva2U9IiMyNzI3MzQiLz4KPC9zdmc+Cg==", vI = "data:image/svg+xml;base64,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";
function li(i, l, r = !0) {
  i.getSourceBlock().workspace.IsCraftland && (l = {
    type: I.shadow_craftland
  });
  const c = function(T, d) {
    return JSON.stringify(T) === JSON.stringify(d);
  };
  i.connection.setShadowState(l), setTimeout(() => {
    var h;
    let T = (h = i.connection) == null ? void 0 : h.getShadowState(!0), d;
    T ? T.type == l.type ? r && !c(T.extraState || "", l.extraState || "") && (d = T, d.extraState = l.extraState) : T.type == I.shadow_type && !c(T, l) && (d = l) : d = l, d && i.connection.setShadowState(d);
  });
}
function sn(i, l, r = !1) {
  if (i.setCheck(l), i.getSourceBlock().isInsertionMarker())
    return;
  if (i.getSourceBlock().workspace.IsCraftland) {
    let d = {
      type: I.shadow_craftland
    };
    i.connection.setShadowState(d);
    return;
  }
  let c = i.connection.getShadowState();
  if (c == null) {
    if (!r)
      return;
    c = Xe(l), i.connection.setShadowState(c);
    return;
  }
  let T = i.connection.targetBlock();
  T && T.isShadow() && T.rendered && T.UpdateShadowVarType ? T.UpdateShadowVarType(l) : (c.type == I.shadow_type || r) && (c = Xe(l), i.connection.setShadowState(c));
}
let Gg = !1, RI = {
  varType: "",
  onchange(i) {
    if (i instanceof X.Events.Click) {
      if (i.blockId != this.id || this.isInFlyout)
        return;
      let l = Date.now(), r = l - this.dbclickCheck;
      r > 0 && r < 500 ? (this.createBlock(Gg), this.dbclickCheck = 0) : this.dbclickCheck = l;
    }
  },
  createBlock(i = !1) {
    if (this.getParent() == null)
      return;
    const r = ce.CurrentDescriptionFile;
    let o = r.GetVarType(this.varType);
    if (o == null)
      return;
    let c = this.workspace, T = c == null ? void 0 : c.graphData, d = (T == null ? void 0 : T.componentTypes) ?? (T == null ? void 0 : T.ownerType), h = iL(o, r, { ownerType: d }, i);
    if (h) {
      N.Events.setGroup(!0);
      const y = N.serialization.blocks.append(h, this.workspace, { recordUndo: !0 });
      this.outputConnection.targetConnection.connect(y.outputConnection), N.Events.setGroup(!1);
    }
  },
  dbclickCheck: 0
}, xg = {
  ...RI,
  varType: "",
  /** placeholder默认是对应类型的名称，也可以手动设置 */
  placeholder: "",
  geId: I.shadow_type,
  init() {
    let i = new X.FieldLabel("");
    this.workspace.IsCraftland && (i.minWidth = 40), this.appendDummyInput().appendField(i, E.Label), this.setOutput(!0), this.varType = "", this.setStyle("shadow_blocks"), this.svgGroup_.setAttribute("class", "shadow-block");
  },
  UpdateShadowVarType(i, l) {
    var d;
    let r = ce.CurrentDescriptionFile, o = (d = this.outputConnection.targetConnection) == null ? void 0 : d.getCheck();
    if (o && o.length > 0 && (i = o[0]), i == this.varType)
      return;
    let c = r.GetVarType(i), T = c ? c.Label : i + f.UnkownType;
    this.setFieldValue(l || T, E.Label), this.setOutput(!0), this.varType = i;
  },
  saveExtraState() {
    let i = this.varType;
    return this.placeholder && (i += "__" + this.placeholder), i;
  },
  loadExtraState(i) {
    let l = this.varType;
    if (typeof i == "string") {
      let r = i.split("__");
      l = r[0], this.placeholder = r[1] || "";
    }
    this.UpdateShadowVarType(l, this.placeholder);
  }
}, Hg = {
  ...RI,
  varType: "",
  geId: I.shadow_type,
  init() {
    this.appendDummyInput().appendField("", E.Label), this.setOutput(!0), this.varType = "", this.setStyle("shadow_blocks"), this.svgGroup_.setAttribute("class", "shadow-block");
  },
  UpdateShadowVarType(i) {
    var c;
    let l = ce.CurrentDescriptionFile, r = (c = this.outputConnection.targetConnection) == null ? void 0 : c.getCheck();
    if (r && r.length > 0 && (i = r[0]), i == this.varType)
      return;
    this.varType = i;
    let o = l.GetVarType(i);
    if (o != null)
      if (l.IsArray(o))
        this.setFieldValue("[]", E.Label);
      else if (o.IsEnum) {
        let T = o.Items.get_Item(0);
        T ? this.setFieldValue(T.Label, E.Label) : this.setFieldValue(f.NULL, E.Label);
      } else
        o == l.intType || o == l.numberType || o == l.floatType ? this.setFieldValue("0", E.Label) : o == l.boolType ? this.setFieldValue(f.False, E.Label) : o == l.stringType ? this.setFieldValue('""', E.Label) : o == l.vector3Type ? this.setFieldValue("0 0 0", E.Label) : o == l.vector2Type ? this.setFieldValue("0 0", E.Label) : o == l.GetVarType("Color") ? this.setFieldValue("#FFFFFF", E.Label) : this.setFieldValue(f.NULL, E.Label);
  },
  saveExtraState() {
    return this.varType;
  },
  loadExtraState(i) {
    let l = this.varType;
    typeof i == "string" && (l = i), this.UpdateShadowVarType(l);
  }
}, Yg = {
  init() {
    this.appendDummyInput().appendField(" ").appendField(new X.FieldImage(Ug, 18, 18, "+"), E.Label).appendField(" "), this.setOutput(!0), this.setStyle("shadow_blocks"), this.svgGroup_.setAttribute("class", "shadow-block");
  }
};
const Xg = function(i, l) {
  if (l.CheckIsAssignable(l.GetVarType("HudWidget"), i))
    return [{
      kind: "block",
      type: I.valution,
      extraState: {
        [E.Index]: 102,
        [E.ParamList]: [2, 3]
      }
    }];
}, Kg = (i, l, r) => {
  if (l.CheckIsAssignable(l.entityType, i) && l.CheckIsAssignable(i, r))
    return J.internalBlocks.get("this_entity");
}, jg = (i, l) => {
  var r, o;
  if (l.CheckIsAssignable(i, l.GetVarType("MapT_any_any"))) {
    let c = Object.assign({}, J.internalBlocks.get("map_dictionary"));
    return c.fields = {
      [E.T1]: ((r = i.ElementTypes) == null ? void 0 : r[0]) ?? "",
      [E.T2]: ((o = i.ElementTypes) == null ? void 0 : o[1]) ?? ""
    }, c;
  }
}, zg = (i, l) => {
  if (l.CheckIsAssignable(i, l.GetVarType("ListT_any"))) {
    let r = nL(i, l.arrayType, l), o = [];
    if (r) {
      for (let c of r) {
        let T = Object.assign({}, J.internalBlocks.get("list_create"));
        T.fields = {
          [E.Type]: c.ElementType
        }, o.push(T);
      }
      return o;
    }
  }
}, OI = (i, l) => {
  if (l.CheckIsAssignable(i, l.numberType))
    return J.internalBlocks.get("input_number");
}, DI = (i, l) => {
  if (l.CheckIsAssignable(i, l.stringType))
    return J.internalBlocks.get("input_text");
}, Jg = (i, l) => {
  if (l.CheckIsAssignable(i, l.floatType))
    return J.internalBlocks.get("input_float");
}, Zg = (i, l) => {
  if (l.CheckIsAssignable(i, l.intType))
    return J.internalBlocks.get("input_int");
}, Qg = (i, l) => {
  if (l.CheckIsAssignable(i, l.GetVarType("Color")))
    return J.internalBlocks.get("input_color");
}, bI = (i, l) => {
  if (l.CheckIsAssignable(i, l.boolType))
    return J.internalBlocks.get("logic_boolean");
}, qg = (i, l) => {
  if (l.CheckIsAssignable(i, l.vector3Type))
    return {
      kind: "block",
      type: I.valution,
      extraState: {
        [E.Index]: 56,
        [E.ParamList]: [1, 2, 3]
      }
    };
}, eL = (i, l) => {
  if (l.CheckIsAssignable(i, l.vector2Type))
    return {
      kind: "block",
      type: I.valution,
      extraState: {
        [E.Index]: 702,
        [E.ParamList]: [1, 2]
      }
    };
}, tL = (i, l) => {
  if (i == l.anyType || i == l.objectType) {
    let r = [], o = [
      DI,
      OI,
      bI
    ];
    for (let c of o) {
      let T = c(i, l);
      mS.isArray(T) ? r.push(...T) : T && r.push(T);
    }
    return r;
  }
};
let rL = [
  (i) => J.internalBlocks.get(i.Name),
  (i) => {
    if (i.IsEnum) {
      let l = {
        type: I.input_enum,
        extraState: i.Name
      }, r = J.geIdReverseMap.get(i.Name);
      if (r) {
        let o = J.graphElementMap.get(r);
        l = J.internalBlocks.get(o.fe_custom), l || (l = {
          type: I.input_enum,
          extraState: r
        });
      }
      return l;
    }
  },
  Xg,
  Kg,
  jg,
  zg,
  OI,
  DI,
  Jg,
  Zg,
  Qg,
  bI,
  eL,
  qg
];
function nL(i, l, r) {
  if (i = r.GetFormalLogicNoBases(i.Name), i instanceof Hr && i.Operator == yI.Or) {
    let o = [];
    for (let c of i.SubLogics) {
      let T = c;
      r.CheckIsAssignable(l, T) && o.push(T);
    }
    return o.length ? o : null;
  }
  return r.CheckIsAssignable(l, i) ? [i] : null;
}
function iL(i, l, r, o) {
  let c, T = l.GetVarType(r.ownerType), d = 0;
  o && (d = 1);
  let h = tL(i, l);
  if (h)
    c = h;
  else {
    c = [];
    for (let y of rL) {
      let b = y(i, l, T);
      if (b)
        if (mS.isArray(b)) {
          for (let U of b)
            if (c.push(U), c.length > d)
              break;
        } else
          c.push(b);
      if (b === !1 || c.length > d)
        break;
    }
  }
  if (c.length > 0)
    return d = d % c.length, c[d];
}
function Xe(i) {
  return {
    type: I.shadow_type,
    extraState: i
  };
}
function oL(i) {
  return {
    type: I.shadow_default,
    extraState: i
  };
}
function lL(i) {
  N.Blocks[I.shadow_type] = xg, N.Blocks[I.shadow_default] = Hg, N.Blocks[I.shadow_craftland] = Yg;
}
function Yh() {
  const i = this.getConstants();
  this.borderRect_ && (this.borderRect_.setAttribute("width", `${this.size_.width}`), this.getSourceBlock().isShadow() ? (this.borderRect_.setAttribute("height", `${i.FIELD_IN_SHADOW_BORDER_RECT_HEIGHT}`), this.borderRect_.setAttribute("y", `${i.FIELD_BORDER_RECT_Y_PADDING}`)) : this.borderRect_.setAttribute("height", `${i.FIELD_BORDER_RECT_HEIGHT}`));
}
const tT = class tT extends N.FieldDropdown {
  //override
  constructor(r, o, c) {
    var l = (...kb) => (super(...kb), //@ts-ignore
    C(this, "menuGenerator_"), this);
    if (N.Field.SKIP_SETUP === r ? l(r) : l(r, o, c), r === N.Field.SKIP_SETUP)
      return;
    this.menuGenerator_ = r, this.validator_ = null;
    let T = this.getOptions(!0);
    if (T != null) {
      for (let d = 0; d < T.length; ++d)
        if (!T[d][1].startsWith(tT.SpecialItem)) {
          this.selectedOption = T[d], this.setValue(T[d][1]);
          break;
        }
    }
    o && this.setValidator(o);
  }
  initView() {
    super.initView(), this.clickTarget_ = this.getSvgRoot();
  }
  positionBorderRect_() {
    Yh.bind(this)();
  }
  setOptions(r) {
    this.menuGenerator_ = r, this.UpdateDisplay();
  }
  setValue(r) {
    r.startsWith(tT.SpecialItem) || super.setValue(r);
  }
  shouldAddBorderRect_() {
    let r = super.shouldAddBorderRect_(), o = 0;
    for (let c = 0, T; T = this.getSourceBlock().inputList[c]; c++) {
      for (let d = 0; T.fieldRow[d]; d++)
        if (T.fieldRow[d].EDITABLE && o++, o >= 2)
          return !0;
      if (T.connection)
        return !0;
    }
    return r;
  }
  getText_() {
    let r = this;
    if (!r.selectedOption)
      return null;
    const o = r.selectedOption[2] || r.selectedOption[0];
    return typeof o == "object" && o != null ? o.alt : o;
  }
  UpdateDisplay() {
    let r = this, o = this.getValue(), c = this.getText();
    this.getOptions(), r.selectedOption = [o + f.UnkownType, o], this.doValueUpdate_(o), this.getText() != c && (this.markDirty(), this.forceRerender());
  }
  getOptions(r) {
    let o = super.getOptions(r), c = this;
    if (!r) {
      let T = this.getValue(), d = this.getText();
      c.selectedOption = [T + f.UnkownType, T], this.doValueUpdate_(T), this.getText() != d && (this.markDirty(), this.forceRerender());
    }
    return o;
  }
  doClassValidation_(r) {
    return r;
  }
  getValueDefaultOptions(r) {
    var o;
    return (o = this.sourceBlock_) != null && o.workspace.IsCraftland ? this.getOptions(!0)[0] ?? [f.Unselected, r] : r == "" ? [f.Unselected, r] : [r + f.UnkownType, r];
  }
  doValueUpdate_(r) {
    let o = this;
    o.selectedOption = this.getValueDefaultOptions(r), super.doValueUpdate_(r);
  }
  onItemSelected_(r, o) {
    let c = o.getValue();
    return c.startsWith(tT.SpecialItem) || this.setValue(c), !0;
  }
  getTextElement() {
    return this.textElement_;
  }
};
C(tT, "SpecialItem", "DROPDOWNV2SPECIALITEM");
let Je = tT;
class Gn extends Je {
  constructor(r, o, c) {
    super(r, o, c);
    C(this, "showSearch", !1);
    C(this, "selectTree_", null);
    c && typeof c.showSearch == "boolean" && (this.showSearch = c.showSearch);
  }
  /**
   * Create a dropdown menu under the text.
   * @param {Event=} opt_e Optional mouse event that triggered the field to
   *     open, or undefined if triggered programmatically.
   * @protected
   */
  showEditor_(r) {
    this.selectTreeCreate_(), X.DropDownDiv.clearContent();
    const o = X.DropDownDiv.getContentDiv(), c = this.selectTree_.$mount();
    o.appendChild(c.$el), X.DropDownDiv.showPositionedByField(this, this.selectTreeDispose_.bind(this));
  }
  getDropdownData() {
    return null;
  }
  /**
   * Create the select tree editor.
   * @private
   */
  selectTreeCreate_() {
  }
  /**
   * Disposes of events and DOM-references belonging to the select tree editor.
   * @private
   */
  selectTreeDispose_() {
    this.selectTree_ && this.selectTree_.$destroy(), this.selectTree_ = null;
  }
  /**
   * Handle an action in the select tree.
   * @param nodeItem The selected tree node.
   * @private
   */
  handleSelectTreeActionEvent_(r) {
    X.DropDownDiv.hideIfOwner(this, !0), this.onNodeSelected_(r);
  }
  /**
   * Handle the selection of an item in the select tree.
   * @param nodeItem The selected node.
   * @protected
   */
  onNodeSelected_(r) {
    this.setValue(r.value);
  }
}
const vm = "!!More";
class oo extends Gn {
  constructor(r, o, c) {
    super([[f.Unselected, ""]]);
    C(this, "baseType", "");
    C(this, "hasAuto", !1);
    C(this, "hasMore", !1);
    C(this, "curMore", !1);
    C(this, "checkExtension", !1);
    C(this, "autoLabel", "");
    this.menuGenerator_ = this.TypeGenerator, typeof r == "string" ? this.baseType = r : (this.baseType = r.baseType ?? "", this.hasMore = r.hasMore ?? !1, this.hasAuto = r.hasAuto ?? !1, this.checkExtension = r.checkExtension ?? !1);
    let T = this.getOptions();
    c && this.configure_(c);
    for (let d = 0; d < T.length; ++d)
      if (!T[d][1].startsWith(Je.SpecialItem)) {
        this.setValue(T[d][1]);
        break;
      }
    this.validator_ = o;
  }
  positionBorderRect_() {
    Yh.bind(this)();
  }
  doClassValidation_(r) {
    let o = ce.CurrentDescriptionFile.GetVarType(r);
    return o ? o.Name : r;
  }
  getValueDefaultOptions(r) {
    if (!r)
      return [f.Unselected, "", "", { style: "fill: var(--red_err5);" }];
    let o = ce.CurrentDescriptionFile.GetVarType(r);
    return o ? [o.Label, o.Name, ""] : [r + f.UnkownType, r, "", { style: "fill: var(--red_err5);" }];
  }
  showEditor(r) {
    this.curMore = !1, super.showEditor(r);
  }
  doValueUpdate_(r) {
    if (r == vm) {
      this.curMore = !0, this.showEditor_();
      return;
    }
    super.doValueUpdate_(r);
  }
  SetAutoLabel(r) {
    this.autoLabel != r && (this.autoLabel = r, this.UpdateDisplay());
  }
  TypeGenerator() {
    let r = ce.CurrentDescriptionFile, o = [], c = this.getValue(), T = r.GetVarType(c), d = r.GetVarType(this.baseType);
    if (this.curMore && (d = null), T && T != r.anyType) {
      let y = o.length;
      if (r.IsArray(T)) {
        var h = r.GetVarType(T.ElementType);
        h != null && (d == null || Vn.CheckIsAssignable(d, h, r)) && o.findIndex((Z) => Z[1] === h.Name) === -1 && o.push([h.Label, h.Name]);
      }
      let b = r.GetGenericVarType(r.listGenericType, T);
      (d == null || r.CheckIsAssignable(d, b)) && o.findIndex((Z) => Z[1] === b.Name) === -1 && o.push([b.Label, b.Name]), y != o.length && o.splice(y, 0, ["----------------", Je.SpecialItem + "--"]);
    }
    if (this.hasAuto) {
      let y = "Auto";
      this.autoLabel && (y += "(" + this.autoLabel + ")"), o.unshift([y, "$Auto"]);
    }
    return this.hasMore && d && !this.curMore && d != r.anyType && d != r.objectType && o.push([f.More, vm]), o.length == 0 && o.push(["None", ""]), o;
  }
  getDropdownData() {
    return [];
  }
}
let Xh = {
  type: I.input_intplus
}, IS = {
  geId: void 0,
  getElementType() {
    let i = "", l = ce.CurrentDescriptionFile, r, o = this.getInput(E.This);
    if (o != null && (r = o.connection.targetBlock()), r != null) {
      let c = r.outputConnection.getCheck();
      if (c != null) {
        let T = l.GetVarType(c[0]);
        T != null && l.IsArray(T) && (i = T.ElementType);
      }
    }
    return i;
  }
};
function sL() {
  let i = null, l = this.outputConnection.getCheck();
  l != null && l.length == 1 && (i = l[0]);
  let r = this.getElementType();
  return r != i ? (this.setOutput(!0, r), !0) : !1;
}
function Kh() {
  let i = this.getInput(E.Value), l = i.connection.getCheck(), r = null;
  l && l.length == 1 && (r = l[0]);
  let o = this.getElementType();
  return r != o && sn(i, o), !1;
}
let aL = {
  ...IS,
  geId: I.list_get,
  locKey: re.ListGet,
  init() {
    this.appendValueInput(E.This).setAlign(N.ALIGN_RIGHT).appendField(f.ListGet).setCheck("[]").connection.setShadowState(Xe("[]")), this.appendValueInput(E.Index).setCheck("int").connection.setShadowState(Xh), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setOutput(!0, ""), this.setStyle("data_blocks");
  },
  DetermineTypes: sL,
  search(i, l) {
    return [f.ListTypeLabel, f.ListGet].find((r) => J.containsKey(r, i)) || !1;
  }
}, _L = {
  ...IS,
  debugAvailable: !0,
  geId: I.list_set,
  locKey: re.ListTypeLabel,
  init() {
    this.appendValueInput(E.This).setAlign(N.ALIGN_RIGHT).appendField(f.ListSet).setCheck("[]").connection.setShadowState(Xe("[]")), this.appendValueInput(E.Index).appendField(f.ListSet_1).setAlign(N.ALIGN_RIGHT).setCheck("int").connection.setShadowState(Xh), this.appendValueInput(E.Value).appendField(f.ListSet_2).connection.setShadowState(Xe("")), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setPreviousStatement(!0), this.setNextStatement(!0, "action"), this.setStyle("data_blocks");
  },
  DetermineTypes: Kh,
  search(i, l) {
    return !1;
  }
}, cL = {
  ...IS,
  debugAvailable: !0,
  geId: I.list_append,
  locKey: re.ListAppend,
  init() {
    this.appendValueInput(E.This).setAlign(N.ALIGN_RIGHT).appendField(f.ListAppend).setCheck("[]").connection.setShadowState(Xe("[]")), this.appendValueInput(E.Value).appendField(f.ListAppend_1).connection.setShadowState(Xe("")), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setPreviousStatement(!0), this.setNextStatement(!0, "action"), this.setStyle("data_blocks");
  },
  DetermineTypes: Kh,
  search(i, l) {
    return !1;
  }
}, uL = {
  ...IS,
  geId: I.list_insert,
  locKey: re.ListInsert,
  init() {
    this.appendValueInput(E.This).setAlign(N.ALIGN_RIGHT).appendField(f.ListInsert).setCheck("[]").connection.setShadowState(Xe("[]")), this.appendValueInput(E.Value).appendField(f.ListInsert_1).connection.setShadowState(Xe("")), this.appendValueInput(E.Index).appendField(f.ListInsert_2).setAlign(N.ALIGN_RIGHT).setCheck("int").connection.setShadowState(Xh), this.setInputsInline(!0), this.setTooltip(""), this.setHelpUrl(""), this.setPreviousStatement(!0), this.setNextStatement(!0, "action"), this.setStyle("data_blocks");
  },
  DetermineTypes: Kh,
  search(i, l) {
    return !1;
  }
}, TL = {
  itemCount_: 0,
  locKey: re.ListCreate,
  init() {
    this.itemCount_ = 0, this.setInputsInline(!0), this.appendDummyInput().appendField(new N.FieldImage(vl, 14, 14, "+", (i) => this.onAddItem(i))).appendField(f.ListCreate).appendField(new oo(""), E.Type), this.setStyle("data_blocks"), this.varType = "any", this.setOutput(!0, "ListT_any");
  },
  /**
   * Returns the state of this block as a JSON serializable object.
   * @return {{itemCount: number}} The state of this block, ie the item count.
   */
  saveExtraState: function() {
    return {
      [E.Index]: this.itemCount_
    };
  },
  /**
   * Applies the given state to this block.
   * @param {*} state The state to apply to this block, ie the item count.
   */
  loadExtraState: function(i) {
    let l = i[E.Index];
    l > 100 && (l = 100, i[E.Index] = 100), this.updateShape_(i[E.Index]);
  },
  updateShape_(i) {
    for (; this.itemCount_ < i; )
      this.addPart_();
    for (; this.itemCount_ > i; )
      this.removePart_();
  },
  addPart_: function() {
    this.appendDummyInput("NEW_LINE_" + this.itemCount_), this.appendValueInput(E.Item + this.itemCount_).appendField(new N.FieldImage(Os, 14, 14, "-", (i) => this.onRemoveItem(i)), this.itemCount_.toString()).appendField("[" + this.itemCount_ + "]").setCheck(this.varType).connection.setShadowState(Xe(this.varType)), this.itemCount_++;
  },
  removePart_: function() {
    this.itemCount_--, this.removeInput("NEW_LINE_" + this.itemCount_), this.removeInput(E.Item + this.itemCount_);
  },
  onAddItem(i) {
    N.Events.setGroup(!0);
    const l = Ut(this);
    this.addPart_();
    const r = Ut(this);
    l != r && N.Events.fire(new N.Events.BlockChange(
      this,
      "mutation",
      null,
      l,
      r
    )), N.Events.setGroup(!1);
  },
  onRemoveItem(i) {
    var c;
    N.Events.setGroup(!0);
    const l = Ut(this);
    let r = Number(i.name);
    for (let T = r; T < this.itemCount_; ++T) {
      let d = this.inputList[T * 2 + 2], h = this.inputList[(T + 1) * 2 + 2];
      d != null && d.connection.targetConnection && ((c = d.connection.targetBlock()) == null || c.dispose(!0)), d && (h != null && h.connection.targetConnection) && d.connection.connect(h.connection.targetConnection);
    }
    this.removePart_();
    const o = Ut(this);
    l != o && N.Events.fire(new N.Events.BlockChange(
      this,
      "mutation",
      null,
      l,
      o
    )), N.Events.setGroup(!1);
  },
  DetermineTypes() {
    let i = this.getFieldValue(E.Type);
    if (this.varType != i) {
      this.varType = i;
      for (let c = 0; c < this.itemCount_; c++)
        this.inputList[c * 2 + 2].setCheck(this.varType).connection.setShadowState(Xe(this.varType));
      var l = ce.CurrentDescriptionFile, r = l.GetVarType(i);
      r == null && (r = l.anyType);
      var o = l.GetGenericVarType(l.listGenericType, r);
      return this.setOutput(!0, o.Name), !0;
    }
  },
  search(i, l) {
    return [f.ListCreate, "ListCreate", "array"].find((r) => J.containsKey(r, i)) || !1;
  }
}, pL = {
  itemCount: 0,
  keyType: "any",
  valueType: "any",
  locKey: re.NewMap,
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.onAddItem();
    })).appendField(f.NewMap).appendField("Key").appendField(new oo(""), E.T1).appendField("Value").appendField(new oo(""), E.T2), this.setStyle("data_blocks"), this.setOutput(!0, "MapT_any_any");
  },
  saveExtraState() {
    return {
      [E.Index]: this.itemCount
    };
  },
  loadExtraState(i) {
    this.updateShape_(i[E.Index]);
  },
  DetermineTypes() {
    let i = this.getFieldValue(E.T1), l = this.getFieldValue(E.T2), r = !1, o = !1;
    if (i !== this.keyType && (r = !0, this.keyType = i), l !== this.valueType && (o = !0, this.valueType = l), r || o) {
      for (let c = 0; c < this.itemCount; c++)
        r && this.inputList[c * 3 + 2].setCheck(this.keyType).connection.setShadowState(Xe(this.keyType + "__Key")), o && this.inputList[c * 3 + 3].setCheck(this.valueType).connection.setShadowState(Xe(this.valueType + "__Value"));
      this.setOutput(!0, `MapT_${i}_${l}`);
    }
    return r || o;
  },
  updateShape_(i) {
    for (; this.itemCount < i; )
      this.addPart();
    for (; this.itemCount > i; )
      this.deletePart();
  },
  onAddItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    this.addPart();
    const l = Ut(this);
    i != l && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, l)), N.Events.setGroup(!1);
  },
  addPart() {
    this.appendDummyInput("NEW_LINE_" + this.itemCount).appendField(
      new N.FieldImage(Os, 14, 14, "-", (i) => this.onDeleteItem(i)),
      this.itemCount.toString()
    ), this.appendValueInput(E.Key + this.itemCount).setCheck(this.keyType).connection.setShadowState(Xe(this.keyType + "__Key")), this.appendValueInput(E.Value + this.itemCount).setCheck(this.valueType).connection.setShadowState(Xe(this.valueType + "__Value")), this.itemCount++;
  },
  onDeleteItem(i) {
    var c, T;
    if (!i.name)
      return;
    N.Events.setGroup(!0);
    const l = Ut(this), r = Number(i.name);
    for (let d = r; d < this.itemCount; d++) {
      const h = this.inputList[d * 3 + 2], y = this.inputList[(d + 1) * 3 + 2];
      h != null && h.connection.targetConnection && ((c = h.connection.targetBlock()) == null || c.dispose(!0)), h && (y != null && y.connection.targetConnection) && h.connection.connect(y.connection.targetConnection);
      const b = this.inputList[d * 3 + 3], U = this.inputList[(d + 1) * 3 + 3];
      b != null && b.connection.targetConnection && ((T = b.connection.targetBlock()) == null || T.dispose(!0)), b && (U != null && U.connection.targetConnection) && b.connection.connect(U.connection.targetConnection);
    }
    this.deletePart();
    const o = Ut(this);
    l != o && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, l, o)), N.Events.setGroup(!1);
  },
  deletePart() {
    this.itemCount--, this.removeInput("NEW_LINE_" + this.itemCount), this.removeInput(E.Key + this.itemCount), this.removeInput(E.Value + this.itemCount);
  },
  search(i) {
    return [f.NewMap, "NewMap"].find((l) => J.containsKey(l, i)) || !1;
  }
};
function dL(i) {
  N.Blocks[I.list_get] = aL, N.Blocks[I.list_set] = _L, N.Blocks[I.list_append] = cL, N.Blocks[I.list_insert] = uL, N.Blocks[I.list_create] = TL, N.Blocks[I.list_dictionary] = pL, i.set("array_get", { kind: "block", type: I.list_get }), i.set("array_set", { kind: "block", type: I.list_set }), i.set("list_append", { kind: "block", type: I.list_append }), i.set("list_insert", { kind: "block", type: I.list_insert }), i.set("list_create", { kind: "block", type: I.list_create }), i.set("map_dictionary", { kind: "block", type: I.list_dictionary });
}
const { dom: rS, aria: nS, userAgent: dh, Coordinate: EL } = X.utils, hS = class hS extends X.Field {
  /**
   * @param value The initial value of the field. Should cast to a string.
   *     Defaults to an empty string if null or undefined. Also accepts
   *     Field.SKIP_SETUP if you wish to skip setup (only used by subclasses
   *     that want to handle configuration and setting the field value after
   *     their own constructors have run).
   * @param validator A function that is called to validate changes to the
   *     field's value. Takes in a string & returns a validated string, or null
   *     to abort the change.
   * @param config A map of options used to configure the field.
   *     See the [field creation documentation]{@link
   * https://developers.google.com/blockly/guides/create-custom-blocks/fields/built-in-fields/text-input#creation}
   * for a list of properties this parameter supports.
   */
  constructor(r, o, c) {
    super(X.Field.SKIP_SETUP);
    /** Allow browser to spellcheck this field. */
    C(this, "spellcheck_", !0);
    /** The HTML input element. */
    C(this, "htmlInput_", null);
    /** True if the field's value is currently being edited via the UI. */
    C(this, "isBeingEdited_", !1);
    /**
     * True if the value currently displayed in the field's editory UI is valid.
     */
    C(this, "isTextValid_", !1);
    /** Key down event data. */
    C(this, "onKeyDownWrapper_", null);
    /** Key input event data. */
    C(this, "onKeyInputWrapper_", null);
    /**
     * Whether the field should consider the whole parent block to be its click
     * target.
     */
    C(this, "fullBlockClickTarget_", !1);
    /** The workspace that this field belongs to. */
    C(this, "workspace_", null);
    /**
     * Serializable fields are saved by the serializer, non-serializable fields
     * are not. Editable fields should also be serializable.
     */
    C(this, "SERIALIZABLE", !0);
    /** Mouse cursor style when over the hotspot that initiates the editor. */
    C(this, "CURSOR", "text");
    r !== X.Field.SKIP_SETUP && (c && this.configure_(c), this.setValue(r), o && this.setValidator(o));
  }
  configure_(r) {
    super.configure_(r), r.spellcheck !== void 0 && (this.spellcheck_ = r.spellcheck);
  }
  /** @internal */
  initView() {
    const r = this.getSourceBlock();
    if (!r)
      throw new X.UnattachedFieldError();
    if (this.getConstants().FULL_BLOCK_FIELDS) {
      let o = 0, c = 0;
      for (let T = 0, d; d = r.inputList[T]; T++) {
        for (let h = 0; d.fieldRow[h]; h++)
          o++;
        d.connection && c++;
      }
      this.fullBlockClickTarget_ = o <= 1 && r.outputConnection && !c;
    } else
      this.fullBlockClickTarget_ = !1;
    this.fullBlockClickTarget_ ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : this.createBorderRect_(), this.createTextElement_();
  }
  /**
   * Called by setValue if the text input is not valid. If the field is
   * currently being edited it reverts value of the field to the previous
   * value while allowing the display text to be handled by the htmlInput_.
   *
   * @param _invalidValue The input value that was determined to be invalid.
   *    This is not used by the text input because its display value is stored
   * on the htmlInput_.
   */
  doValueInvalid_(r) {
    if (this.isBeingEdited_) {
      this.isDirty_ = !0, this.isTextValid_ = !1;
      const o = this.value_;
      this.value_ = this.htmlInput_.getAttribute("data-untyped-default-value"), this.sourceBlock_ && X.Events.isEnabled() && X.Events.fire(new (X.Events.get(X.Events.BLOCK_CHANGE))(
        this.sourceBlock_,
        "field",
        this.name || null,
        o,
        this.value_
      ));
    }
  }
  /**
   * Called by setValue if the text input is valid. Updates the value of the
   * field, and updates the text of the field if it is not currently being
   * edited (i.e. handled by the htmlInput_).
   *
   * @param newValue The value to be saved. The default validator guarantees
   *     that this is a string.
   */
  doValueUpdate_(r) {
    this.isDirty_ = !0, this.isTextValid_ = !0, this.value_ = r;
  }
  /**
   * Updates text field to match the colour/style of the block.
   *
   * @internal
   */
  applyColour() {
    if (!this.sourceBlock_ || !this.getConstants().FULL_BLOCK_FIELDS)
      return;
    const r = this.sourceBlock_;
    this.borderRect_ ? this.borderRect_.setAttribute("stroke", r.style.colourTertiary) : r.pathObject.svgPath.setAttribute(
      "fill",
      this.getConstants().FIELD_BORDER_RECT_COLOUR
    );
  }
  /**
   * Updates the colour of the htmlInput given the current validity of the
   * field's value.
   */
  render_() {
    if (super.render_(), this.isBeingEdited_) {
      this.resizeEditor_();
      const r = this.htmlInput_;
      this.isTextValid_ ? (rS.removeClass(r, "blocklyInvalidInput"), nS.setState(r, nS.State.INVALID, !1)) : (rS.addClass(r, "blocklyInvalidInput"), nS.setState(r, nS.State.INVALID, !0));
    }
  }
  /**
   * Set whether this field is spellchecked by the browser.
   *
   * @param check True if checked.
   */
  setSpellcheck(r) {
    r !== this.spellcheck_ && (this.spellcheck_ = r, this.htmlInput_ && this.htmlInput_.setAttribute(
      "spellcheck",
      this.spellcheck_
    ));
  }
  /**
   * Show an editor for the field.
   * Shows the inline free-text editor on top of the text by default.
   * Shows a prompt editor for mobile browsers if the modalInputs option is
   * enabled.
   *
   * @param _e Optional mouse event that triggered the field to open, or
   *     undefined if triggered programmatically.
   * @param quietInput True if editor should be created without focus.
   *     Defaults to false.
   */
  showEditor_(r, o = !1) {
    this.workspace_ = this.sourceBlock_.workspace, !o && this.workspace_.options.modalInputs && (dh.MOBILE || dh.ANDROID || dh.IPAD) ? this.showPromptEditor_() : this.showInlineEditor_(o);
  }
  /**
   * Create and show a text input editor that is a prompt (usually a popup).
   * Mobile browsers may have issues with in-line textareas (focus and
   * keyboards).
   */
  showPromptEditor_() {
    X.dialog.prompt(
      X.Msg.CHANGE_VALUE_TITLE,
      this.getText(),
      (r) => {
        r !== null && this.setValue(this.getValueFromEditorText_(r));
      }
    );
  }
  /**
   * Create and show a text input editor that sits directly over the text input.
   *
   * @param quietInput True if editor should be created without focus.
   */
  showInlineEditor_(r) {
    const o = this.getSourceBlock();
    if (!o)
      throw new X.UnattachedFieldError();
    X.WidgetDiv.show(this, o.RTL, this.widgetDispose_.bind(this)), this.htmlInput_ = this.widgetCreate_(), this.isBeingEdited_ = !0, r || (this.htmlInput_.focus({
      preventScroll: !0
    }), this.htmlInput_.select());
  }
  /**
   * Create the text input editor widget.
   *
   * @returns The newly created text input editor.
   */
  widgetCreate_() {
    const r = this.getSourceBlock();
    if (!r)
      throw new X.UnattachedFieldError();
    X.Events.setGroup(!0);
    const o = X.WidgetDiv.getDiv(), c = this.getClickTarget_();
    if (!c)
      throw new Error("A click target has not been set.");
    rS.addClass(c, "editing");
    const T = document.createElement("input");
    T.className = "blocklyHtmlInput", T.setAttribute(
      "spellcheck",
      this.spellcheck_
    );
    const d = this.workspace_.getScale(), h = this.getConstants().FIELD_TEXT_FONTSIZE * d + "px";
    o.style.fontSize = h, T.style.fontSize = h;
    let y = hS.BORDERRADIUS * d + "px";
    if (this.fullBlockClickTarget_) {
      const b = this.getScaledBBox();
      y = (b.bottom - b.top) / 2 + "px";
      const U = r.getParent() ? r.getParent().style.colourTertiary : this.sourceBlock_.style.colourTertiary;
      T.style.border = 1 * d + "px solid " + U, o.style.borderRadius = y, o.style.transition = "box-shadow 0.25s ease 0s", this.getConstants().FIELD_TEXTINPUT_BOX_SHADOW && (o.style.boxShadow = "rgba(255, 255, 255, 0.3) 0 0 0 " + 4 * d + "px");
    }
    return T.style.borderRadius = y, o.appendChild(T), T.value = T.defaultValue = this.getEditorText_(this.value_), T.setAttribute("data-untyped-default-value", String(this.value_)), this.resizeEditor_(), this.bindInputEvents_(T), T;
  }
  /**
   * Closes the editor, saves the results, and disposes of any events or
   * DOM-references belonging to the editor.
   */
  widgetDispose_() {
    this.isBeingEdited_ = !1, this.isTextValid_ = !0, this.forceRerender(), this.onFinishEditing_(this.value_), X.Events.setGroup(!1), this.unbindInputEvents_();
    const r = X.WidgetDiv.getDiv().style;
    r.width = "auto", r.height = "auto", r.fontSize = "", r.transition = "", r.boxShadow = "", this.htmlInput_ = null;
    const o = this.getClickTarget_();
    if (!o)
      throw new Error("A click target has not been set.");
    rS.removeClass(o, "editing");
  }
  /**
   * A callback triggered when the user is done editing the field via the UI.
   *
   * @param _value The new value of the field.
   */
  onFinishEditing_(r) {
  }
  // NOP by default.
  // TODO(#2496): Support people passing a func into the field.
  /**
   * Bind handlers for user input on the text input field's editor.
   *
   * @param htmlInput The htmlInput to which event handlers will be bound.
   */
  bindInputEvents_(r) {
    this.onKeyDownWrapper_ = X.browserEvents.conditionalBind(
      r,
      "keydown",
      this,
      this.onHtmlInputKeyDown_
    ), this.onKeyInputWrapper_ = X.browserEvents.conditionalBind(
      r,
      "input",
      this,
      this.onHtmlInputChange_
    );
  }
  /** Unbind handlers for user input and workspace size changes. */
  unbindInputEvents_() {
    this.onKeyDownWrapper_ && (X.browserEvents.unbind(this.onKeyDownWrapper_), this.onKeyDownWrapper_ = null), this.onKeyInputWrapper_ && (X.browserEvents.unbind(this.onKeyInputWrapper_), this.onKeyInputWrapper_ = null);
  }
  /**
   * Handle key down to the editor.
   *
   * @param e Keyboard event.
   */
  onHtmlInputKeyDown_(r) {
    r.key === "Enter" ? (X.WidgetDiv.hide(), X.DropDownDiv.hideWithoutAnimation()) : r.key === "Escape" ? (this.setValue(
      this.htmlInput_.getAttribute("data-untyped-default-value")
    ), X.WidgetDiv.hide(), X.DropDownDiv.hideWithoutAnimation()) : r.key === "Tab" && (X.WidgetDiv.hide(), X.DropDownDiv.hideWithoutAnimation(), this.sourceBlock_.tab(this, !r.shiftKey), r.preventDefault());
  }
  /**
   * Handle a change to the editor.
   *
   * @param _e Keyboard event.
   */
  onHtmlInputChange_(r) {
    this.setValue(this.getValueFromEditorText_(this.htmlInput_.value));
  }
  /**
   * Set the HTML input value and the field's internal value. The difference
   * between this and `setValue` is that this also updates the HTML input
   * value whilst editing.
   *
   * @param newValue New value.
   */
  setEditorValue_(r) {
    this.isDirty_ = !0, this.isBeingEdited_ && (this.htmlInput_.value = this.getEditorText_(r)), this.setValue(r);
  }
  /** Resize the editor to fit the text. */
  resizeEditor_() {
    const r = this.getSourceBlock();
    if (!r)
      throw new X.UnattachedFieldError();
    const o = X.WidgetDiv.getDiv(), c = this.getScaledBBox();
    o.style.width = c.right - c.left + "px", o.style.height = c.bottom - c.top + "px";
    const T = r.RTL ? c.right - o.offsetWidth : c.left, d = new EL(T, c.top);
    o.style.left = d.x + "px", o.style.top = d.y + "px";
  }
  /**
   * Returns whether or not the field is tab navigable.
   *
   * @returns True if the field is tab navigable.
   */
  isTabNavigable() {
    return !0;
  }
  /**
   * Use the `getText_` developer hook to override the field's text
   * representation. When we're currently editing, return the current HTML value
   * instead. Otherwise, return null which tells the field to use the default
   * behaviour (which is a string cast of the field's value).
   *
   * @returns The HTML value if we're editing, otherwise null.
   */
  getText_() {
    return this.isBeingEdited_ && this.htmlInput_ ? this.htmlInput_.value : null;
  }
  /**
   * Transform the provided value into a text to show in the HTML input.
   * Override this method if the field's HTML input representation is different
   * than the field's value. This should be coupled with an override of
   * `getValueFromEditorText_`.
   *
   * @param value The value stored in this field.
   * @returns The text to show on the HTML input.
   */
  getEditorText_(r) {
    return `${r}`;
  }
  /**
   * Transform the text received from the HTML input into a value to store
   * in this field.
   * Override this method if the field's HTML input representation is different
   * than the field's value. This should be coupled with an override of
   * `getEditorText_`.
   *
   * @param text Text received from the HTML input.
   * @returns The value to store.
   */
  getValueFromEditorText_(r) {
    return r;
  }
};
/**
 * Pixel size of input border radius.
 * Should match blocklyText's border-radius in CSS.
 */
C(hS, "BORDERRADIUS", 4);
let Rh = hS;
const { dom: pS, Svg: AL } = X.utils;
let Ds;
function SL(i, l) {
  var c;
  let o = i.workspace.getAllBlocks(!1);
  for (let T of o) {
    let d = T;
    ((c = d.vardef) == null ? void 0 : c.id) == l.id && aT(d);
  }
}
class PI extends X.FieldLabel {
  constructor(r, o, c) {
    super(r, void 0, c);
    C(this, "fieldRef");
    this.fieldRef = o;
  }
  initView() {
    this.createBorderRect_(), this.createTextElement_(), pS.addClass(this.fieldGroup_, "blocklyDragOutSet");
  }
  createBorderRect_() {
    this.borderRect_ = pS.createSvgElement(
      "path",
      {},
      this.fieldGroup_
    );
  }
  positionBorderRect_() {
    if (!this.borderRect_)
      return;
    let r = this.size_.width, o = this.size_.height;
    const c = `m 0,0  h 10  l 3,3  10,0  3,-3  H${r}  V${o} H28  l -3,3  -10,0  -3,-3 H 0 z`;
    this.borderRect_.setAttribute(
      "d",
      c
    );
  }
  getDragOutBlockState() {
    let o = this.getSourceBlock().getField(this.fieldRef);
    if (!(o instanceof Vt))
      return null;
    let c = o.getVarDefine();
    return c ? {
      kind: "block",
      type: I.localvar_set,
      extraState: c.id,
      fields: {
        [E.VarRef]: c.name
      }
    } : null;
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const o = this.sourceBlock_.workspace.getGesture(r);
    if (Ds ?? (Ds = !1), o && r.button === 0 && !Ds) {
      let c = MS(this.sourceBlock_.workspace);
      o.setStartBlock(this.sourceBlock_), o.handleFlyoutStart(r, c), c.targetWorkspace = this.sourceBlock_.workspace, c.refField = this;
    }
  }
}
class hL extends X.FieldImage {
  constructor(r, o, c, T, d, h, y) {
    super(o, c, T, d, void 0, h, y);
    C(this, "fieldRef");
    this.fieldRef = r;
  }
  // override initView(): void { 
  //     this.createBorderRect_();
  //     this.createTextElement_();
  //     dom.addClass(this.fieldGroup_, 'blocklyDragOutSet');
  // }
  getDragOutBlockState() {
    let o = this.getSourceBlock().getField(this.fieldRef);
    if (!(o instanceof Vt))
      return null;
    let c = o.getVarDefine();
    return c ? {
      kind: "block",
      type: I.localvar_set,
      extraState: c.id,
      fields: {
        [E.VarRef]: c.name
      }
    } : null;
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const o = this.sourceBlock_.workspace.getGesture(r);
    if (Ds ?? (Ds = !1), o && r.button === 0 && !Ds) {
      let c = MS(this.sourceBlock_.workspace);
      o.setStartBlock(this.sourceBlock_), o.handleFlyoutStart(r, c), c.targetWorkspace = this.sourceBlock_.workspace, c.refField = this;
    }
  }
}
class Vt extends Rh {
  constructor(r, o, c) {
    super(X.Field.SKIP_SETUP);
    C(this, "value_", {});
    C(this, "DEFAULT_VALUE", {});
    C(this, "SERIALIZABLE", !0);
    C(this, "cuteSqaurePath", "");
    C(this, "cuteSquareSvg");
    C(this, "vardef", { id: "", name: "", type: "", blockId: "" });
    c && this.configure_(c), this.setValue(r), o && this.setValidator(o);
  }
  initView() {
    super.initView(), pS.addClass(this.borderRect_, "blocklyFieldEntity");
  }
  initCuteSquare() {
    const r = this.size_.height / 2 + 4;
    this.cuteSqaurePath = "", this.cuteSqaurePath += X.utils.svgPaths.moveTo(0, r) + X.utils.svgPaths.lineTo(4, -4) + X.utils.svgPaths.lineTo(-4, -4) + X.utils.svgPaths.lineTo(-4, 4) + X.utils.svgPaths.lineTo(4, 4), this.cuteSquareSvg || (this.cuteSquareSvg = pS.createSvgElement(
      AL.PATH,
      { class: "blocklyPathSquare" },
      this.fieldGroup_
    ), this.cuteSquareSvg.setAttribute("fill", "#FFC736")), this.cuteSquareSvg.setAttribute("d", this.cuteSqaurePath);
  }
  positionBorderRect_() {
    super.positionBorderRect_(), this.initCuteSquare();
  }
  getValue() {
    return this.value_;
  }
  getVarDefine() {
    return this.vardef.id = this.sourceBlock_.id + this.name, this.vardef.blockId = this.sourceBlock_.id, this.vardef.name = this.value_.name, this.vardef.type = this.value_.type, this.vardef;
  }
  // override initView(): void {
  //     super.initView()
  // }
  applyColour() {
    if (this.borderRect_) {
      const r = this.sourceBlock_;
      this.borderRect_.setAttribute("fill", X.utils.colour.blend("#ffffff", r.style.colourPrimary, 0.1)), this.borderRect_.setAttribute("stroke", r.style.colourTertiary);
    }
  }
  updateEditable() {
  }
  // collapse will use this
  getText_() {
    var r;
    return ((r = this.vardef) == null ? void 0 : r.name) ?? "";
  }
  getEditorText_(r) {
    return typeof r == "string" ? r : typeof r == "object" && r != null ? r.name ?? "" : String(r);
  }
  doClassValidation_(r) {
    if ((this.value_ == null || typeof this.value_ != "object") && (this.value_ = {}), typeof r == "string" && (r = { name: r }), typeof r == "object") {
      let o = { ...this.value_ }, c = !1;
      if (r.name && o.name != r.name && (o.name = r.name, this.vardef.name = o.name, c = !0), r.type != null && o.type != r.type) {
        o.type = r.type, this.vardef.type = o.type, c = !0;
        let T = ce.CurrentDescriptionFile.getType(o.type);
        T ? this.setTooltip(T.Label) : this.setTooltip(f.UnkownType);
      }
      return c && this.sourceBlock_ && SL(this.sourceBlock_, this.vardef), c ? o : this.value_;
    }
    return null;
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const o = this.sourceBlock_.workspace.getGesture(r);
    if (Ds ?? (Ds = !1), o && r.button === 0 && !Ds) {
      let c = MS(this.sourceBlock_.workspace);
      o.setStartBlock(this.sourceBlock_), o.handleFlyoutStart(r, c), c.targetWorkspace = this.sourceBlock_.workspace, c.refField = this;
    }
  }
  getDragOutBlockState() {
    let r = "", o = "", c = this.getVarDefine();
    return c && (r = c.name, o = c.id), {
      kind: "block",
      type: I.localvar_get,
      extraState: o,
      fields: {
        [E.VarRef]: r
      }
    };
  }
  static fromJson(r) {
    const o = r.name, c = r.type;
    return new this({ name: o, type: c }, void 0, r);
  }
}
class mL extends X.VerticalFlyout {
  constructor() {
    super(...arguments);
    C(this, "refField");
    C(this, "autoClose", !1);
  }
  isBlockCreatable(r) {
    return !0;
  }
  // override isBlockCreatable_(block: BlockSvg): boolean {
  //     return true
  // }
  createBlock(r) {
    let o = null;
    X.Events.disable(), this.targetWorkspace.setResizesEnabled(!1);
    try {
      o = this.placenewblock();
    } finally {
      X.Events.enable();
    }
    return X.Events.isEnabled() && (X.Events.setGroup(!0), X.Events.fire(new (X.Events.get(X.Events.BLOCK_CREATE))(o))), o;
  }
  placenewblock() {
    if (this.refField == null)
      throw Error("refField is null.");
    let r = this.refField.getSourceBlock();
    const o = this.targetWorkspace;
    if (!r.getSvgRoot())
      throw Error("oldBlock is not rendered.");
    let T = this.refField.getDragOutBlockState();
    if (T == null)
      throw Error("blockState not defined.");
    o.setResizesEnabled(!1);
    const d = X.serialization.blocks.append(T, o, { recordUndo: !0 });
    let h = r.getRelativeToSurfaceXY(), b = this.refField.getSvgRoot().transform.baseVal.consolidate().matrix;
    return h.x += b.e, h.y += b.f, d.moveTo(new X.utils.Coordinate(h.x, h.y)), d;
  }
}
let iS;
function MS(i) {
  if (iS != null)
    return iS;
  const l = new X.Options(
    /** @type {!BlocklyOptions} */
    {
      parentWorkspace: i,
      rtl: i.RTL,
      oneBasedIndex: i.options.oneBasedIndex,
      renderer: i.options.renderer,
      rendererOverrides: i.options.rendererOverrides,
      theme: i.options.theme
    }
  );
  return iS = new mL(l), iS;
}
N.fieldRegistry.register("field_vardef", Vt);
class IL {
  constructor() {
    C(this, "oldGroup");
    this.oldGroup = N.Events.getGroup();
  }
  Leave() {
    this.oldGroup != null && N.Events.setGroup(this.oldGroup), this.oldGroup = null;
  }
}
function Da(i) {
  let l = new IL();
  return i.group ? N.Events.setGroup(i.group) : (N.Events.setGroup(!0), i.group = N.Events.getGroup()), l;
}
let $I = /* @__PURE__ */ new Map();
function sT() {
  return $I;
}
let Oh = "";
function Dh() {
  return Oh;
}
function WI(i, l) {
  let r = $I.get(Oh);
  if (r) {
    for (let o = 0; o < r.functions.length; ++o) {
      let c = r.functions[o];
      if (c.id == i) {
        typeof l == "string" ? (c = JSON.parse(JSON.stringify(c)), c.name = l, r.functions[o] = c) : l == null ? r.functions.splice(o, 1) : (l.graphId = Oh, r.functions[o] = l);
        return;
      }
    }
    l != null && typeof l != "string" && r.functions.push(l);
  }
}
function ML(i) {
  return null;
}
const gL = [
  "HudEmptyWidget",
  //HudEmpty = 0,
  "HudImageWidget",
  //HudImage = 1,
  "HudLabelWidget",
  //HudLabel = 2,
  "HudButtonWidget",
  //HudButton = 3,
  "HudInputWidget",
  //HudInput = 4 ,
  "HudPanel",
  //HudPanel = 5 ,
  "HudScrollView",
  //HudScrollView = 6 ,
  "HudGrid",
  //HudGrid = 7 ,
  "HudLayout",
  //HudLayout = 8, 
  "HudEffect"
  //HudEffect = 9,
];
function LL(i) {
  return gL[i];
}
class NL {
  constructor(l) {
    C(this, "descriptionFile");
    this.descriptionFile = l;
  }
  getValue(l, r) {
    let o = this.getBlock(l);
    if (o)
      return RL(this, o, r);
    {
      let c = typeof l;
      if (c === "number" || c === "string")
        return l;
    }
  }
  getElementType(l, r) {
    let o = this.getVarType(l);
    return o && o.GenericType && o.ElementTypes && o.ElementTypes.length > r ? this.descriptionFile.GetVarType(o.ElementTypes[r]) : null;
  }
  getSheetType(l) {
    let r = this.getBlock(l);
    if (!r)
      return this.descriptionFile.anyType;
    if (r.type === I.sheet_data || r.type === I.sheet_rank) {
      const o = this.getFieldValue(r, E.Value);
      if (o) {
        const c = o.split("--")[1] ?? "any";
        return this.descriptionFile.GetVarType(c);
      }
    }
    return null;
  }
  parseTokens(l) {
    let r = [], o = l.length;
    for (let c = 0; c < o; ++c)
      if (this.calcuToken(r, l[c]), r.length == 0)
        return null;
    if (r.length == 0)
      return null;
    for (let c = r.length - 1; c >= 0; --c) {
      let T = this.getVarType(r[c]);
      if (T)
        return T;
    }
    return null;
  }
  calcuToken(l, r) {
    if (r.startsWith(".")) {
      if (l.length == 0)
        return;
      let o = l.pop();
      if (r == ".EnumToType") {
        let c = this.getEnumedType(o);
        c ? l.push(c) : l.push(null);
        return;
      } else if (r == ".ItemIDToType") {
        this.getValue(o, "int");
        let c = ML(), T = this.descriptionFile.GetVarType(c);
        T ? l.push(T) : l.push(null);
        return;
      } else if (r === ".WidgetType") {
        let c = this.getValue(o, "int"), T = LL(c), d = this.descriptionFile.GetVarType(T);
        d ? l.push(d) : l.push(null);
        return;
      } else if (r == ".IsList") {
        let c = this.getVarType(o);
        c && this.descriptionFile.IsArray(c) ? l.push(!0) : l.push(!1);
        return;
      } else if (r.startsWith(".T")) {
        let c = Number.parseInt(r.substring(2));
        if (!Number.isNaN(c)) {
          let T = this.getElementType(o, c);
          if (T !== void 0) {
            l.push(T);
            return;
          }
        }
      } else if (r == ".SheetType") {
        let c = this.getSheetType(o);
        if (c !== void 0) {
          l.push(c);
          return;
        }
      } else if (r == ".InternalHudType") {
        const c = this.getBlock(o);
        if (!c)
          return;
        if (c.type === I.input_enum) {
          const T = this.getEnumedType(o);
          l.push(T || null);
        } else {
          const T = this.getElementType(o, 0);
          T && l.push(T);
        }
        return;
      }
    } else if (r == ">") {
      if (l.length == 0)
        return;
      let o = l.pop(), c = this.getVarType(o);
      if (c && c.IsGeneric && c.Items && l.length >= c.Items.Count) {
        let T = l.splice(l.length - c.Items.Count + 1), d = this.getVarType(l.pop());
        if (d == null) {
          l.splice(0);
          return;
        }
        for (let y = 0; y < T.length; ++y)
          if ((T[y] = this.getVarType(T[y])) == null) {
            l.splice(0);
            return;
          }
        let h = this.descriptionFile.GetGenericVarType(c, d, T);
        if (h != null) {
          l.push(h);
          return;
        }
      }
    } else if (r == "?") {
      if (l.length >= 3) {
        if (l.pop() === !0) {
          let c = l.pop();
          l.pop(), l.push(c);
        } else {
          l.pop();
          let c = l.pop();
          l.push(c);
        }
        return;
      }
    } else if (r.match(/^\?+$/)) {
      let o = r.length;
      if (l.length >= o) {
        let c = null;
        for (let T = 0; T < o; ++T) {
          let d = l.pop();
          c == null && (c = d);
        }
        l.push(c);
        return;
      }
    } else if (r == "?number") {
      let o = "";
      for (; l.length > 0; ) {
        let c = l.pop(), T = this.getVarType(c);
        if (c == 0) {
          o === "int" ? l.push(this.descriptionFile.intType) : o === "float" ? l.push(this.descriptionFile.floatType) : l.push(this.descriptionFile.numberType);
          return;
        }
        o !== "float" && (T ? this.descriptionFile.CheckIsAssignable(this.descriptionFile.intType, T, !1, !1) ? o === "" && (o = "int") : this.descriptionFile.CheckIsAssignable(this.descriptionFile.floatType, T, !1, !1) ? o = "float" : o = "number" : o = "number");
      }
      return;
    } else {
      let o = this.getInput(r);
      if (o != null) {
        l.push(o);
        return;
      } else {
        let c = this.descriptionFile.GetVarType(r);
        if (c != null) {
          l.push(c);
          return;
        } else {
          let T = r.toLocaleLowerCase();
          if (T === "true" || T === "false" || !Number.isNaN(Number(T))) {
            l.push(r);
            return;
          }
        }
      }
    }
    l.splice(0);
  }
}
const yL = -(2 ** 31), fL = 2 ** 31 - 1;
let CL = /\s+|(?=[.>])|(?:[>])/, Rm = /* @__PURE__ */ new Map();
function vL(i) {
  if (i == null)
    return null;
  let l = Rm.get(i);
  if (l)
    return l;
  let r = i.split(";"), o = {};
  Rm.set(i, o);
  let c = !1;
  for (let T = 0; T < r.length; ++T) {
    let h = r[T].split("=");
    if (h.length >= 2) {
      let y = h[0].trim(), b = h[1].split(CL);
      o[y] = b, c = !0;
    }
  }
  return c ? o : null;
}
function RL(i, l, r) {
  var o, c, T;
  if (l.type == I.input_enum) {
    let d = i.getFieldValue(l, E.Item), h = i.getExtraValue(l);
    if (h) {
      let y;
      if (typeof h == "string")
        y = i.descriptionFile.GetVarType(h);
      else if (typeof h == "number") {
        const b = J.graphElementMap.get(h);
        y = i.descriptionFile.GetVarType(b == null ? void 0 : b.ref);
      }
      if (y && y.IsEnum) {
        let b = i.descriptionFile.GetVarType(r);
        if (i.descriptionFile.CheckIsAssignable(b, y))
          return r === "int" ? (o = y.GetItem(d)) == null ? void 0 : o.IntValue : r === "float" ? (c = y.GetItem(d)) == null ? void 0 : c.FloatValue : (T = y.GetItem(d)) == null ? void 0 : T.Value;
      }
    }
  } else if (l.type === I.input_int) {
    if (r === "int" || r === "float")
      return i.getFieldValue(l, E.Value);
  } else if (l.type === I.input_float) {
    if (r === "float")
      return i.getFieldValue(l, E.Value);
  } else if (l.type === I.input_number) {
    let d = i.getFieldValue(l, E.Value);
    const h = Number(d);
    let y = d.indexOf(".") !== -1;
    if ((h < yL || h > fL) && (y = !0), r === "int" && !y)
      return h;
    if (r === "float")
      return h;
  } else if (l.type === I.input_text) {
    let d = i.getFieldValue(l, E.Value);
    if (r === "string")
      return d == null ? void 0 : d.toString();
  } else if (l.type === I.pick_dynamic_create_item) {
    i.getFieldValue(l, E.Value);
    return;
  }
}
function aT(i) {
  if (i.DetermineTypes && i.DetermineTypes() && i.outputConnection) {
    let l = i.outputConnection.targetBlock();
    l && aT(l);
  }
}
function OL() {
  let i = this.outputConnection.getCheck(), l = "";
  i && i.length == 1 && (l = i[0]);
  let r = ce.CurrentDescriptionFile, o = r.intType, c = r.floatType, T = "";
  for (let d of this.inputList)
    if (d.type == N.inputTypes.VALUE)
      if (i = d.connection.getCheck(), i && i.length == 1 && i[0] == "number") {
        let h = d.connection.targetConnection, y;
        if (h && h.getCheck() && h.getCheck().length == 1 && (y = r.GetVarType(h.getCheck()[0])), r.CheckIsAssignable(c, y, !1, !1)) {
          T = "float";
          break;
        } else
          r.CheckIsAssignable(o, y, !1, !1) ? T === "" && (T = "int") : T = "number";
      } else
        (i == null ? void 0 : i.length) === 1 && (i[0] === "int" || i[0] === "float") && (T = i[0]);
  return T === "" && (T = "number"), T != l ? (this.setOutput(!0, T), !0) : !1;
}
let Om = /* @__PURE__ */ new Map();
function kI(i) {
  let l = Om.get(i);
  if (l)
    return l;
  let r = vL(i);
  return l = function() {
    return DL.call(this, r);
  }, Om.set(i, l), l;
}
function DL(i) {
  let l = ce.CurrentDescriptionFile, r = !1, o = new bL(this, l);
  for (let c in i) {
    let T = i[c], d = o.parseTokens(T);
    if (d == null) {
      let U = this.paramInfo[c];
      U && (d = l.GetVarType(U.inputType));
    }
    let h = (d == null ? void 0 : d.Name) ?? "any", y = (d == null ? void 0 : d.Label) ?? "";
    if (c == "R") {
      if (this.outputConnection) {
        let b = this.outputConnection.getCheck();
        if ((b == null ? void 0 : b[0]) != h) {
          this.setOutput(!0, h), r = !0;
          let Z = this.action;
          Z && this.setTooltip(Z.Label + `
` + f.ReturnSentense + " " + y);
        }
      }
    } else {
      let b = this.getInput(c);
      if (b != null && b.connection != null) {
        let U = b.connection.getCheck();
        (U == null ? void 0 : U[0]) != h && sn(b, h);
      } else {
        let U = this.getField(c);
        if (U instanceof Vt) {
          U.setValue({ type: h }, !1);
          let Z = N.Events.getRecordUndo();
          N.Events.setRecordUndo(!1);
          const le = this.getField(c + "L");
          le && le.setValue(y, !1), N.Events.setRecordUndo(Z);
        }
      }
    }
  }
  return r;
}
class bL extends NL {
  constructor(r, o) {
    super(o);
    C(this, "block");
    this.block = r;
  }
  getVarType(r) {
    let o;
    if (r instanceof xt)
      return r;
    if (r instanceof N.Input) {
      let c = r.connection.targetBlock();
      if (c == null)
        return this.descriptionFile.anyType;
      {
        let T = c.outputConnection.getCheck(), d = T == null ? void 0 : T[0];
        d && (o = this.descriptionFile.GetVarType(d));
      }
    }
    return o;
  }
  getEnumedType(r) {
    var c;
    var o = null;
    if (r instanceof N.Input) {
      let T = r.connection.targetBlock();
      if (T && T.type == I.input_enum) {
        let d = T.getFieldValue(E.Item), h = T.varType;
        if (h) {
          let y = this.descriptionFile.GetVarType(h);
          if (y && y.IsEnum) {
            let b = (c = y.GetItem(d)) == null ? void 0 : c.Value;
            b && (o = this.descriptionFile.GetVarType(b));
          }
        }
      }
    }
    return o;
  }
  getInput(r) {
    return this.block.getInput(r);
  }
  getBlock(r) {
    if (r instanceof N.Input)
      return r.connection.targetBlock();
  }
  getFieldValue(r, o) {
    if (r instanceof N.Block)
      return r.getFieldValue(o);
  }
  getExtraValue(r) {
    if (r instanceof N.Block)
      return r.saveExtraState();
  }
}
let PL = {
  geId: I.as_type,
  locKey: re.AsType,
  init() {
    this.setStyle("action_blocks"), this.setInputsInline(!0), this.appendValueInput(E.Value).appendField(f.AsType).appendField(new oo({ hasMore: !0 }), E.Type).connection.setShadowState(Xe("any")), this.setOutput(!0);
  },
  DetermineTypes() {
    let i = this.outputConnection.getCheck(), l = null;
    i && i.length == 1 && (l = i[0]);
    let o = this.getInput(E.Value).connection.targetConnection, c = "";
    o && o.getCheck() && o.getCheck().length == 1 && (c = o.getCheck()[0]);
    let T = this.getField(E.Type);
    T.baseType = c;
    let d = this.getFieldValue(E.Type);
    if (o) {
      let h = ce.CurrentDescriptionFile, y = h.GetVarType(c);
      if (y)
        if (Vn.CheckIsAssignable(y, d, h))
          this.setWarningText(null, "AS");
        else {
          let b = h.GetVarType(d);
          b ? this.setWarningText(y.Label + ` ${f.Tip_NotTransform} ` + b.Label, "AS") : this.setWarningText(ye(re.Warning_NoDefine, [d]), "NODEF");
        }
    } else
      this.setWarningText(null, "AS");
    return l != d ? (this.setOutput(!0, d), !0) : !1;
  },
  search(i) {
    return ["as", f.AsType].find((l) => J.containsKey(l, i)) || !1;
  }
};
function $L(i) {
  N.Blocks[I.as_type] = PL, i.set("as_type", { kind: "block", type: I.as_type });
}
let WL = {
  lastCondition: null,
  geId: I.ctrl_ifelse,
  locKey: re.ConditionalStatement,
  init: function() {
    let i = function(r) {
      return this.getSourceBlock().updateStatement_(r), r;
    }, l = new Je([[f.If, "if"], [f.ElseIf, "elseif"], [f.Else, "else"]], i);
    this.setInputsInline(!0), this.appendValueInput(E.Condition).setCheck("bool").appendField(l, E.Type).connection.setShadowState(Xe("bool")), this.appendStatementInput(E.Code).setCheck("action"), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setColour(130), this.setTooltip(""), this.setHelpUrl(""), this.setStyle("logic_blocks");
  },
  updateStatement_: function(i) {
    let l = this.getFieldValue(E.Type);
    if (i != l) {
      let r = this.getInput(E.Condition);
      i == "else" ? (VL.call(this, r), this.setPreviousStatement(!0, ["ifelse"]), this.setNextStatement(!0, ["action"]), this.geId = `ex_${I.ctrl_ifelse}_else}`) : i == "if" ? (Dm.call(this, r), this.setPreviousStatement(!0, ["ifelse", "action"]), this.setNextStatement(!0, ["action", "ifelse"]), this.geId = `ex_${I.ctrl_ifelse}_if}`) : i == "elseif" && (Dm.call(this, r), this.setPreviousStatement(!0, ["ifelse"]), this.setNextStatement(!0, ["action", "ifelse"]), this.geId = `ex_${I.ctrl_ifelse}_elseif}`);
    }
  },
  search(i, l) {
    var o;
    if (!i)
      return !1;
    let r = (o = l.fields) == null ? void 0 : o[E.Type];
    if (r == i)
      return r;
    switch (r) {
      case "if":
        return J.containsKey(f.If, i) ? f.If : !1;
      case "elseif":
        return J.containsKey(f.ElseIf, i) ? f.ElseIf : !1;
      case "else":
        return J.containsKey(f.Else, i) ? f.Else : !1;
    }
  },
  lastConditionBlock: null,
  lastConditionConnection: null
}, wI = {
  operationCount: 1,
  saveExtraState() {
    return {
      [E.Index]: this.operationCount
    };
  },
  loadExtraState(i) {
    this.updateShape_(i[E.Index]);
  },
  updateShape_(i) {
    const l = this;
    for (; this.operationCount < i; )
      l.addOperation();
    for (; this.operationCount > i; )
      l.deleteOperation();
  },
  addButtons() {
    const l = 10, r = this.appendDummyInput("buttons");
    this.operationCount > 1 && r.appendField(new N.FieldImage(Os, 14, 14, "-", () => {
      this.onDeleteItem();
    })), this.operationCount < l && r.appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.onAddItem();
    }));
  },
  onAddItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    this.addOperation();
    const r = Ut(this);
    i != r && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, r)), N.Events.setGroup(!1);
  },
  onDeleteItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    this.deleteOperation();
    const r = Ut(this);
    i != r && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, r)), N.Events.setGroup(!1);
  }
}, kL = {
  ...wI,
  geId: I.op_arith,
  locKey: re.Arithmetic,
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "float"), li(
      this.appendValueInput(E.V1).setCheck("number"),
      { type: I.input_number }
    ), li(
      this.appendValueInput(E.V2).setCheck("number").appendField(new Je(
        [
          [f.ArithAdd, dt.Add],
          [f.ArithSub, dt.Substract],
          [f.ArithMultiply, dt.Multiply],
          [f.ArithDivide, dt.Divide],
          [f.ArithMod, dt.Mod]
        ]
      ), E.Operator),
      { type: I.input_number }
    ), this.addButtons();
  },
  addOperation() {
    this.removeInput("buttons"), this.operationCount++, li(
      this.appendValueInput(E.Value + (this.operationCount + 1)).setCheck("number").appendField(new N.FieldImage(CI, 3, 24, void 0, void 0, void 0, { imageClass: "hover-show-image" })).appendField(new Je(
        [
          [f.ArithAdd, dt.Add],
          [f.ArithSub, dt.Substract],
          [f.ArithMultiply, dt.Multiply],
          [f.ArithDivide, dt.Divide],
          [f.ArithMod, dt.Mod]
        ]
      ), E.Operator + this.operationCount),
      { type: I.input_number }
    ), this.addButtons();
  },
  deleteOperation() {
    this.removeInput("buttons"), this.removeInput(E.Value + (this.operationCount + 1)), this.operationCount--, this.addButtons();
  },
  DetermineTypes() {
    for (let i = 1; i <= this.operationCount; i++) {
      let l = E.Operator + (i === 1 ? "" : i);
      if (this.getFieldValue(l) == dt.Mod)
        sn(this.getInput(E.Value + i), "int"), sn(this.getInput(E.Value + (i + 1)), "int");
      else {
        let o = i - 1;
        this.getFieldValue(E.Operator + (o === 1 ? "" : o)) !== dt.Mod && sn(this.getInput(E.Value + i), "number"), sn(this.getInput(E.Value + (i + 1)), "number");
      }
    }
    return OL.call(this);
  },
  search(i, l) {
    return !1;
  }
}, wL = {
  ...wI,
  geId: I.op_logic,
  locKey: "and/or",
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "bool"), this.appendValueInput(E.V1).setCheck("bool").connection.setShadowState(Xe("bool")), this.appendValueInput(E.V2).setCheck("bool").appendField(new Je(
      [
        [f.OpAnd, Wd.And],
        [f.OpOr, Wd.Or]
      ]
    ), E.Operator).connection.setShadowState(Xe("bool")), this.addButtons();
  },
  search(i, l) {
    if (!i)
      return !1;
    let r = [f.OpAnd, f.OpOr].find((o) => J.containsKey(o, i));
    return r || ["and", "or"].find((o) => o === i) || !1;
  },
  addOperation() {
    this.removeInput("buttons"), this.operationCount++, this.appendValueInput(E.Value + (this.operationCount + 1)).setCheck("bool").appendField(new N.FieldImage(CI, 3, 24, void 0, void 0, void 0, { imageClass: "hover-show-image" })).appendField(new Je(
      [
        [f.OpAnd, Wd.And],
        [f.OpOr, Wd.Or]
      ]
    ), E.Operator + this.operationCount).connection.setShadowState(Xe("bool")), this.addButtons();
  },
  deleteOperation() {
    this.removeInput("buttons"), this.removeInput(E.Value + (this.operationCount + 1)), this.operationCount--, this.addButtons();
  }
}, FL = {
  geId: I.op_compare,
  locKey: re.Compare,
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "bool"), li(
      this.appendValueInput(E.V1).setCheck(""),
      { type: I.shadow_type }
    ), li(
      this.appendValueInput(E.V2).setCheck("").appendField(new Je(
        [
          [f.CompareEqual, fs.Equal],
          [f.CompareNotEqual, fs.NotEqual],
          [f.CompareLess, fs.Less],
          [f.CompareLessEqual, fs.LessEqual],
          [f.CompareGreater, fs.Greater],
          [f.CompareGreaterEqual, fs.GreaterEqual]
        ]
      ), E.Operator),
      { type: I.shadow_type }
    );
  },
  DetermineTypes() {
    var o, c;
    switch (this.getFieldValue(E.Operator)) {
      case fs.Equal:
      case fs.NotEqual:
        sn(this.getInput(E.V1), "any"), sn(this.getInput(E.V2), "any");
        break;
      default:
        sn(this.getInput(E.V1), "number"), sn(this.getInput(E.V2), "number");
        break;
    }
    let l = this.getInput(E.V1).connection.targetConnection, r = this.getInput(E.V2).connection.targetConnection;
    if (this.setWarningText(null, "TYPENOTEQUAL"), l && r) {
      const T = ce.CurrentDescriptionFile, d = (o = l.getCheck()) == null ? void 0 : o[0], h = (c = r.getCheck()) == null ? void 0 : c[0], y = d == null ? void 0 : d.toLowerCase(), b = h == null ? void 0 : h.toLowerCase(), U = T.GetVarType(d), Z = T.GetVarType(h);
      d && h && y !== "any" && b !== "any" && y !== b && !Vn.CheckIsAssignable(U, h, T) && !Vn.CheckIsAssignable(Z, d, T) && this.setWarningText(ye("FE_41B_HZY_COMPARE_NOTSAME"), "TYPENOTEQUAL");
    }
  },
  search(i, l) {
    return i && ["==", "<", ">", "!=", "<=", ">="].find((o) => J.containsKey(o, i)) || !1;
  }
}, BL = {
  geId: I.op_string,
  valueCount: 0,
  locKey: re.Concat,
  init() {
    this.appendDummyInput().appendField(f.Concat, E.Label), this.updateShape_(2), this.setInputsInline(!0), this.setOutput(!0, "string"), this.setTooltip(f.StringConcatTip), this.setStyle("data_blocks");
  },
  search(i) {
    return [f.Concat, "StrConcat"].find((l) => J.containsKey(l, i)) || !1;
  },
  saveExtraState() {
    return {
      [E.Index]: this.valueCount
    };
  },
  loadExtraState(i) {
    this.updateShape_(i[E.Index]);
  },
  DetermineTypes() {
    var i;
    for (let l = 1; l <= this.valueCount; l++) {
      const r = this.getInputTargetBlock(E.Property + l), o = (i = r == null ? void 0 : r.outputConnection) == null ? void 0 : i.getCheck();
      if (Array.isArray(o) && o.includes("LocString"))
        return this.setWarningText(ye("FE_40A_B_ECA_TIPS1"), "TYPE"), !1;
    }
    return this.setWarningText(null, "TYPE"), !1;
  },
  updateShape_(i) {
    for (; this.valueCount < i; )
      this.addStrValue();
    for (; this.valueCount > i; )
      this.deleteStrValue();
  },
  addButtons() {
    const l = 10, r = this.appendDummyInput("buttons");
    this.valueCount > 2 && r.appendField(new N.FieldImage(Os, 14, 14, "-", () => {
      this.onDeleteItem();
    })), this.valueCount < l && r.appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.onAddItem();
    }));
  },
  onAddItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    this.addStrValue();
    const l = Ut(this);
    i != l && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, l)), N.Events.setGroup(!1);
  },
  addStrValue() {
    this.getInput("buttons") && this.removeInput("buttons");
    let i = ++this.valueCount;
    li(
      this.appendValueInput(E.Property + i).appendField(f.Value + i).setCheck("Object").setAlign(N.ALIGN_RIGHT),
      {
        type: I.shadow_type,
        extraState: "Object"
      }
    ), this.addButtons();
  },
  onDeleteItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    this.deleteStrValue();
    const l = Ut(this);
    i != l && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, l)), N.Events.setGroup(!1);
  },
  deleteStrValue() {
    this.removeInput("buttons"), this.removeInput(E.Property + this.valueCount), this.valueCount--, this.addButtons();
  }
}, UL = {
  geId: I.ctrl_ifelse1,
  locKey: re.ConditionalStatement,
  uniqueIds: [],
  conditionCount: 1,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.Condition).setCheck("bool").appendField(f.If, E.Label).connection.setShadowState(Xe("bool")), this.appendStatementInput(E.Code).setCheck("action"), this.appendDummyInput("addbtn").setAlign(N.ALIGN_RIGHT).appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.addCondition();
    })), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setStyle("logic_blocks"), this.uniqueIds = [];
  },
  saveExtraState() {
    return {
      [E.Index]: this.conditionCount,
      [E.ConditionIds]: [...this.uniqueIds]
    };
  },
  loadExtraState(i) {
    const l = i[E.ConditionIds] || [], r = i[E.Index];
    if (this.conditionCount >= r) {
      if (this.conditionCount === r) {
        this.uniqueIds = [...l];
        return;
      }
      i[E.Index] === 1 ? this.delCondition(0) : [...this.uniqueIds].forEach((c) => {
        l.includes(c) || this.delCondition(c);
      });
    } else {
      this.conditionCount === 1 && l.length && this.addCondition(), l.forEach((c) => {
        this.addCondition(c);
      });
      let o = i[E.Index] - this.conditionCount;
      if (o > 0)
        for (; o; )
          this.addCondition(), o--;
    }
  },
  addCondition(i) {
    N.Events.setGroup(!0);
    const l = Ut(this);
    if (this.conditionCount > 1) {
      let o = i ?? this.newId();
      const c = `${E.Condition}_${o}`, T = this.uniqueIds.findIndex((b) => b === o);
      let d = null, h = null;
      if (T > -1) {
        if (this.getInput(c))
          return;
        d = T - 1;
      } else
        this.uniqueIds.push(o);
      this.appendValueInput(c).setCheck("bool").appendField(f.ElseIf, E.Label).connection.setShadowState(Xe("bool")), this.appendDummyInput(`del_${o}`).appendField(new N.FieldImage(Os, 14, 14, "-", () => {
        this.delCondition(o);
      })).setAlign(N.ALIGN_RIGHT), this.appendStatementInput(`${E.Code}_${o}`).setCheck("action");
      const y = this.getInput("else");
      d > 0 ? h = `${E.Condition}_${d}` : y && (y.fieldRow.findIndex((b) => b.name === "del") > -1 && y.removeField("del"), h = "else"), h && (this.moveInputBefore(c, h), this.moveInputBefore(`del_${o}`, h), this.moveInputBefore(`${E.Code}_${o}`, h));
    } else
      this.removeInput("addbtn"), this.appendDummyInput("else").appendField(f.Else, E.Label).appendField(new N.FieldImage(Os, 14, 14, "-", () => {
        this.delCondition(0);
      }), "del").appendField(new N.FieldImage(vl, 14, 14, "+", () => {
        this.addCondition();
      }), "add"), this.appendStatementInput(`${E.Code}_else`).setCheck("action");
    this.conditionCount++;
    const r = Ut(this);
    l !== r && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, l, r)), N.Events.setGroup(!1);
  },
  delCondition(i) {
    N.Events.setGroup(!0);
    const l = Ut(this);
    let r = "else", o = `${E.Code}_else`;
    if (i > 0) {
      const T = this.uniqueIds.findIndex((d) => i === d);
      T > -1 && this.uniqueIds.splice(T, 1), r = `${E.Condition}_${i}`, o = `${E.Code}_${i}`;
    }
    this.removeInput(r), this.removeInput(o), r !== "else" && this.removeInput(`del_${i}`), this.conditionCount--;
    const c = Ut(this);
    l !== c && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, l, c)), this.conditionCount === 1 ? this.appendDummyInput("addbtn").setAlign(N.ALIGN_RIGHT).appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.addCondition();
    })) : this.conditionCount === 2 && this.getInput("else").insertFieldAt(1, new N.FieldImage(Os, 14, 14, "-", () => {
      this.delCondition(0);
    }), "del"), N.Events.setGroup(!1);
  },
  newId() {
    let i = 1;
    for (; this.uniqueIds.includes(i); )
      i++;
    return i;
  },
  search(i) {
    return [f.If, f.ElseIf, f.Else].find((l) => J.containsKey(l, i)) || !1;
  }
};
function VL(i) {
  if (i.type != N.inputTypes.DUMMY) {
    let l = N.Events.getRecordUndo();
    N.Events.setRecordUndo(!1), i.setShadowDom(null);
    let r = i.connection.targetBlock();
    r && (r.unplug(!0), r.isShadow() && (r.dispose(!1), r = null)), this.lastConditionBlock = r, this.lastCondition = i.connection, i.connection = null, i.type = N.inputTypes.DUMMY, N.Events.setRecordUndo(l);
  }
}
function Dm(i) {
  if (i.type != N.inputTypes.VALUE) {
    let l = N.Events.getRecordUndo();
    N.Events.setRecordUndo(!1), i.connection = this.lastCondition, i.type = N.inputTypes.VALUE;
    let r = this.lastConditionBlock;
    r && !r.disposed && !r.outputConnection.targetConnection && i.connection.connect(r.outputConnection), i.connection.setShadowState(Xe("bool")), N.Events.setRecordUndo(l);
  }
}
function GL(i) {
  N.Blocks[I.ctrl_ifelse] = WL, N.Blocks[I.op_arith] = kL, N.Blocks[I.op_logic] = wL, N.Blocks[I.op_compare] = FL, N.Blocks[I.op_string] = BL, N.Blocks[I.ctrl_ifelse1] = UL, i.set("if", { kind: "block", type: I.ctrl_ifelse1, extraState: {
    [E.Index]: 1
  } }), i.set("ifelse", { kind: "block", type: I.ctrl_ifelse1, extraState: {
    [E.Index]: 2
  } }), i.set(
    "ifelse:if",
    {
      kind: "block",
      type: I.ctrl_ifelse,
      fields: {
        [E.Type]: "if"
      }
    }
  ), i.set(
    "ifelse:elseif",
    {
      kind: "block",
      type: I.ctrl_ifelse,
      fields: {
        [E.Type]: "elseif"
      }
    }
  ), i.set("ifelse:else", {
    kind: "block",
    type: I.ctrl_ifelse,
    fields: {
      [E.Type]: "else"
    }
  }), i.set("logic_operation", { kind: "block", type: I.op_logic }), i.set("logic_compare", { kind: "block", type: I.op_compare }), i.set("math_arithmetic", { kind: "block", type: I.op_arith }), i.set("str_concat", { kind: "block", type: I.op_string });
}
class Vo extends X.FieldTextInput {
  constructor(l, r, o) {
    super(l, r, o);
  }
  widgetCreate_() {
    const l = super.widgetCreate_(), r = this.workspace_.getScale(), o = this.getConstants().FIELD_TEXT_FONTSIZE * r + "px";
    return l.style.fontSize = o, l.style.borderRadius = "0", l.style.padding = "0 " + this.getConstants().FIELD_BORDER_RECT_X_PADDING * r + "px", this.resizeEditor_(), l.addEventListener("click", (c) => {
      c.stopPropagation(), c.preventDefault();
    }), l;
  }
  showEditor_(l, r) {
    this.workspace_ = this.sourceBlock_.workspace;
    const o = r || !1;
    !o && (X.utils.userAgent.MOBILE || X.utils.userAgent.ANDROID || X.utils.userAgent.IPAD) ? this.showPromptEditor_() : this.showInlineEditor_(o);
  }
  resizeEditor_() {
    const l = X.WidgetDiv.getDiv(), r = this.getScaledBBox();
    l.style.width = r.right - r.left + 1 + "px", l.style.height = r.bottom - r.top + "px";
    const o = this.sourceBlock_.RTL ? r.right - l.offsetWidth : r.left, c = new X.utils.Coordinate(o, r.top);
    l.style.left = c.x + "px", l.style.top = c.y + "px";
  }
}
X.fieldRegistry.unregister("field_input");
X.fieldRegistry.register("field_input", Vo);
class Ra extends X.FieldNumber {
  constructor(r, o, c, T, d, h) {
    super(r, o, c, T, d, h);
    C(this, "EDITABLE", !0);
  }
  widgetCreate_() {
    const r = super.widgetCreate_(), o = this.workspace_.getScale(), c = this.getConstants().FIELD_TEXT_FONTSIZE * o + "px";
    return r.style.fontSize = c, r.style.borderRadius = "0", r.style.padding = "0 " + this.getConstants().FIELD_BORDER_RECT_X_PADDING * o + "px", this.resizeEditor_(), r.addEventListener("click", (T) => {
      T.stopPropagation(), T.preventDefault();
    }), r;
  }
}
class Gd extends N.Field {
  constructor(r, o, c) {
    super(r, o, c);
    C(this, "DEFAULT_VALUE", "#FF00FF");
    C(this, "CURSOR", "default");
    C(this, "SERIALIZABLE", !0);
    /**
     * Whether text editing is enabled on this field.
     * @type {boolean}
     * @private
     */
    C(this, "textEditEnabled_", !1);
  }
  static fromJson(r) {
    var o = N.utils.parsing.replaceMessageReferences(r.text);
    return new Gd(o, void 0, r);
  }
  /**
  * Copied form the color field
  */
  initView() {
    this.size_ = new N.utils.Size(
      this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT,
      this.getConstants().FIELD_COLOUR_DEFAULT_HEIGHT
    ), this.getConstants().FIELD_COLOUR_FULL_BLOCK ? this.clickTarget_ = this.sourceBlock_.getSvgRoot() : (this.createBorderRect_(), this.borderRect_.style.fillOpacity = "1");
  }
  /**
   * Show the inline free-text editor on top of the text.
   * @param {Event=} _opt_e Optional mouse event that triggered the field to open,
   *     or undefined if triggered programmatically.
   * @param {boolean=} opt_quietInput True if editor should be created without
   *     focus.  Defaults to false.
   * @protected
   */
  showEditor_(r) {
  }
  /**
   * Copied from colour field
   * Update the value of this colour field, and update the displayed colour.
   * @param {*} newValue The value to be saved. The default validator guarantees
   * that this is a colour in '#rrggbb' format.
   * @protected
   */
  doValueUpdate_(r) {
    this.value_ = r;
    let o = this.sourceBlock_;
    this.borderRect_ ? this.borderRect_.style.fill = /** @type {string} */
    r : this.sourceBlock_ && this.sourceBlock_.rendered && (o.pathObject.svgPath.setAttribute("fill", r), o.pathObject.svgPath.setAttribute("stroke", "#fff"));
  }
  /**
   * Copied from colour field
   * @override
   */
  applyColour() {
    if (!this.getConstants().FIELD_COLOUR_FULL_BLOCK)
      this.borderRect_ && (this.borderRect_.style.fill = /** @type {string} */
      this.getValue());
    else {
      let r = this.sourceBlock_;
      r.pathObject.svgPath.setAttribute("fill", this.getValue()), r.pathObject.svgPath.setAttribute("stroke", "#fff");
    }
  }
  /**
  * Set the html input value and the field's internal value. The difference
  * between this and ``setValue`` is that this also updates the html input
  * value whilst editing.
  * @param {*} newValue New value.
  * @protected
  */
  setEditorValue_(r) {
    this.setValue(r);
  }
  updateSize_(r) {
    super.updateSize_(r), this.size_.width = this.size_.height, this.positionBorderRect_();
  }
}
N.fieldRegistry.register("field_color_picker", Gd);
let xL = 0;
class gS extends N.FieldTextInput {
  constructor(r, o, c) {
    super(r, o, c);
    C(this, "FRAME_SIZE", 24);
    C(this, "bezierPath");
    C(this, "clipPathRect");
    C(this, "boundEvents", []);
  }
  static fromJson(r) {
    var o = N.utils.parsing.replaceMessageReferences(r.text);
    return new gS(o, void 0, r);
  }
  initView() {
    this.size_ = new N.utils.Size(this.FRAME_SIZE, this.FRAME_SIZE), this.createBorderRect_();
    const r = this.getSvgRoot(), o = "clipPath" + xL++, c = N.utils.dom.createSvgElement("clipPath", {
      id: o
    });
    this.clipPathRect = N.utils.dom.createSvgElement("rect", {
      width: this.FRAME_SIZE,
      height: this.FRAME_SIZE
    }), c.appendChild(this.clipPathRect), r.appendChild(c), this.bezierPath = N.utils.dom.createSvgElement("path", {
      d: this.pathD,
      stroke: "#FFFFFF",
      fill: "transparent",
      style: `clip-path: url(#${o});`
    }), r.appendChild(this.bezierPath);
  }
  updateSize_(r) {
    var o, c, T, d;
    super.updateSize_(r), this.FRAME_SIZE = ((o = this.getBorderRect()) == null ? void 0 : o.height.baseVal.value) ?? 24, this.size_.width = this.size_.height = this.FRAME_SIZE, (c = this.bezierPath) == null || c.setAttribute("d", this.pathD), (T = this.clipPathRect) == null || T.setAttribute("width", this.FRAME_SIZE.toString()), (d = this.clipPathRect) == null || d.setAttribute("height", this.FRAME_SIZE.toString()), this.positionBorderRect_();
  }
  get pathD() {
    const r = this.FRAME_SIZE, o = (ue) => Math.round(ue * r), c = this.value_.split(",").map((ue) => Number(ue)), [T, d, h, y, b, U, Z, le] = c;
    return `M ${o(T)} ${o(d)} C ${o(h)} ${o(y)}, ${o(b)} ${o(U)}, ${o(Z)} ${o(le)}`;
  }
  setEditorValue_(r) {
    this.setValue(r);
  }
  doValueUpdate_(r) {
    var o;
    this.value_ = r, (o = this.bezierPath) == null || o.setAttribute("d", this.pathD);
  }
  showEditor_(r) {
  }
  // onDashboardEvent(value: string) {
  //     this.setEditorValue_('0,0,1,1');
  //     console.log(value);
  //     this.resizeEditor_();
  // }
  render_() {
    super.render_();
  }
}
N.fieldRegistry.register("field_bezier_curve", gS);
class FI extends X.FieldMultilineInput {
  constructor(l, r, o) {
    super(l, r, o);
  }
  /**
   * Updates the size of the field based on the text.
   * @protected
   */
  updateSize_() {
    const l = this.textGroup.childNodes;
    let r = 0, o = 0;
    for (let c = 0; c < l.length; c++) {
      const T = l[c], d = this.getConstants(), h = X.utils.dom.getFastTextWidth(
        T,
        d.FIELD_TEXT_FONTSIZE,
        d.FIELD_TEXT_FONTWEIGHT,
        d.FIELD_TEXT_FONTFAMILY
      );
      h > r && (r = h), o += this.getConstants().FIELD_TEXT_HEIGHT + (c > 0 ? this.getConstants().FIELD_BORDER_RECT_Y_PADDING : 0);
    }
    if (this.isBeingEdited_) {
      const c = this.value_.split(`
`), T = X.utils.dom.createSvgElement(
        X.utils.Svg.TEXT,
        { class: "blocklyText blocklyMultilineText" }
      ), d = this.getConstants().FIELD_TEXT_FONTSIZE, h = this.getConstants().FIELD_TEXT_FONTWEIGHT, y = this.getConstants().FIELD_TEXT_FONTFAMILY;
      for (let U = 0; U < c.length; U++) {
        c[U].length > this.maxDisplayLength && (c[U] = c[U].substring(0, this.maxDisplayLength)), T.textContent = c[U];
        const Z = X.utils.dom.getFastTextWidth(
          T,
          d,
          h,
          y
        );
        Z > r && (r = Z);
      }
      const b = this.htmlInput_.offsetWidth - this.htmlInput_.clientWidth;
      r += b;
    }
    this.borderRect_ && (o += this.getConstants().FIELD_BORDER_RECT_Y_PADDING * 2, r += this.getConstants().FIELD_BORDER_RECT_X_PADDING * 2, this.borderRect_.setAttribute("width", String(r)), this.borderRect_.setAttribute("height", String(o))), this.size_.width = r, this.size_.height = o, this.positionBorderRect_();
  }
}
X.fieldRegistry.unregister("field_multilinetext");
X.fieldRegistry.register("field_multilinetext", FI);
const BI = -2147483648, UI = 2147483647;
let jd = X.BlockSvg.prototype.setShadow;
function Q_(i) {
  let l = i.init;
  return l && (i.init = function() {
    l.call(this), this.workspace.IsCraftland && this.inputList[0].removeField(E.Label);
  }), i;
}
let HL = Q_(
  {
    geId: I.input_number,
    locKey: re.Number,
    init() {
      let i = function(l) {
        const r = this.getValue();
        let o = String(l);
        o = o.replace(/O/ig, "0"), o = o.replace(/,/g, ""), o = o.replace(/infinity/i, "Infinity");
        let c = Number(o || 0);
        if (isNaN(c))
          return r;
        c = Math.min(Math.max(c, -1 / 0), 1 / 0);
        let T = String(c);
        return o.indexOf(".") !== -1 && Number.isInteger(c) && (T = c.toFixed(1)), T;
      };
      this.setOutput(!0, "int"), this.appendDummyInput().appendField(f.Number, E.Label).appendField(new Vo(0, i), E.Value), this.setStyle("input_blocks");
    },
    loadExtraState(i) {
    },
    saveExtraState() {
    },
    DetermineTypes() {
      let i = this.getFieldValue(E.Value), l = String(i).indexOf(".") !== -1, r = this.outputConnection.getCheck()[0], o = "float";
      return i = Number(i), i >= BI && i <= UI && !l && Number.isInteger(i) && (o = "int"), o != r ? (this.setOutput(!0, o), !0) : !1;
    },
    setShadow(i) {
      jd.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
    },
    search(i, l) {
      return ["number", f.Number].find((r) => J.containsKey(r, i)) || !1;
    }
  }
), YL = Q_(
  {
    geId: I.input_int,
    locKey: re.Int,
    init() {
      this.setOutput(!0, "int"), this.appendDummyInput().appendField(f.Int, E.Label).appendField(new Ra(0, BI, UI, 1), E.Value), this.setStyle("input_blocks");
    },
    loadExtraState(i) {
    },
    saveExtraState() {
    },
    setShadow(i) {
      jd.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
    },
    search(i, l) {
      return ["int", f.Int].find((r) => J.containsKey(r, i)) || !1;
    }
  }
), XL = Q_(
  {
    geId: I.input_null,
    locKey: re.NULL,
    init() {
      this.setOutput(!0, "any"), this.appendDummyInput().appendField(f.NULL), this.setStyle("input_blocks");
    },
    loadExtraState(i) {
    },
    saveExtraState() {
    },
    search(i, l) {
      return ["null", f.NULL].find((r) => J.containsKey(r, i)) || !1;
    }
  }
), KL = {
  geId: I.input_pi,
  locKey: re.PI,
  init() {
    this.setOutput(!0, "float"), this.appendDummyInput().appendField(f.PI), this.setStyle("shadow_blocks");
  },
  search(i, l) {
    return ["pi", f.PI].find((r) => J.containsKey(r, i)) || !1;
  }
}, jL = {
  geId: I.input_e,
  locKey: re.E,
  init() {
    this.setOutput(!0, "float"), this.appendDummyInput().appendField(f.E), this.setStyle("shadow_blocks");
  },
  search(i, l) {
    return ["e", f.E].find((r) => J.containsKey(r, i)) || !1;
  }
}, zL = {
  geId: I.input_intplus,
  locKey: re.Int,
  init: function() {
    this.setOutput(!0, "int"), this.appendDummyInput().appendField(new Ra(0, 0, 2147483647, 1), E.Value), this.setStyle("input_blocks");
  },
  loadExtraState(i) {
  },
  saveExtraState() {
  },
  search(i, l) {
    return ["int", f.Int].find((r) => J.containsKey(r, i)) || !1;
  }
}, JL = Q_(
  {
    geId: I.input_float,
    locKey: re.Float,
    init: function() {
      this.setOutput(!0, "float"), this.appendDummyInput().appendField(f.Float, E.Label).appendField(new Ra(0), E.Value), this.setStyle("input_blocks");
    },
    loadExtraState(i) {
    },
    saveExtraState() {
    },
    setShadow(i) {
      jd.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
    },
    search(i, l) {
      return ["float", f.Float].find((r) => J.containsKey(r, i)) || !1;
    }
  }
), ZL = Q_(
  {
    geId: I.input_text,
    locKey: re.Text,
    init: function() {
      this.setOutput(!0, "string"), this.appendDummyInput().appendField(f.Text, E.Label).appendField(new Vo(), E.Value), this.setStyle("input_blocks");
    },
    loadExtraState(i) {
    },
    saveExtraState() {
    },
    setShadow(i) {
      jd.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
    },
    search(i, l) {
      return ["string", "text", f.Text].find((r) => J.containsKey(r, i)) || !1;
    }
  }
), QL = Q_({
  geId: I.input_textarea,
  init: function() {
    const i = new FI();
    i.setMaxLines(30), this.setOutput(!0, "string"), this.appendDummyInput().appendField(i, E.Value), this.setStyle("input_blocks");
  }
}), qL = {
  geId: I.input_boolean,
  locKey: re.Boolean,
  init() {
    this.setOutput(!0, "bool"), this.appendDummyInput().appendField(new Je([
      [f.False, "F"],
      [f.True, "T"]
    ]), E.Value), this.setStyle("input_blocks");
  },
  loadExtraState(i) {
  },
  saveExtraState() {
  },
  setShadow(i) {
    jd.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
  },
  search(i, l) {
    return ["bool", "boolean", f.Boolean, f.True, f.False].find((r) => J.containsKey(r, i)) || !1;
  }
}, e0 = {
  geId: I.input_vector3,
  locKey: re.Vector3,
  init() {
    this.setOutput(!0, "Vector3"), this.appendDummyInput().appendField("X").appendField(new Ra(), E.V1).appendField("Y").appendField(new Ra(), E.V2).appendField("Z").appendField(new Ra(), E.V3), this.setStyle("input_blocks");
  },
  loadExtraState(i) {
  },
  saveExtraState() {
  },
  search(i, l) {
    return ["Vector3", f.Vector3].find((r) => J.containsKey(r, i)) || !1;
  }
}, t0 = {
  geId: I.input_vector2,
  init() {
    this.setOutput(!0, "Vector2"), this.appendDummyInput().appendField("X").appendField(new Ra(), E.V1).appendField("Y").appendField(new Ra(), E.V2), this.setStyle("input_blocks");
  }
}, r0 = /^#[0-9a-fA-F]{6}$/, n0 = {
  geId: I.input_color,
  locKey: re.Color,
  init() {
    const i = this.workspace.IsCraftland;
    let l = function(r) {
      return r.match(r0) ? r.toLowerCase() : null;
    };
    i ? this.appendDummyInput().appendField(ye("T_34_M_WS_COLOUR")).appendField(new Gd("#ffffff", l), E.Color) : this.appendDummyInput().appendField(new Gd("#ff00ff", l), E.Color).appendField(new Vo("#ff00ff", l), E.ColorStr).appendField(new X.FieldImage(Hh, 20, 20, "pick", () => {
      this.showColorEyeDropper();
    })), this.setOutput(!0, "Color"), this.setStyle("input_blocks"), this.setTooltip(""), this.setHelpUrl("");
  },
  loadExtraState(i) {
  },
  saveExtraState() {
  },
  showColorEyeDropper() {
  },
  onchange(i) {
    if (i instanceof N.Events.BlockChange && i.type == N.Events.BLOCK_CHANGE && i.blockId == this.id && i.element == "field") {
      if (N.Events.disable(), i.name == E.Color) {
        let l = this.getFieldValue(E.ColorStr), r = i.newValue;
        r && l != r && this.setFieldValue(r, E.ColorStr);
      } else if (i.name == E.ColorStr) {
        let l = this.getFieldValue(E.Color), r = i.newValue;
        r && l != r && this.setFieldValue(r, E.Color);
      }
      N.Events.enable();
    }
  },
  search(i, l) {
    return ["color", f.Color].find((r) => J.containsKey(r, i)) || !1;
  }
}, i0 = Q_(
  {
    isTypeEnum: !1,
    nextTypeChanged: !1,
    varType: "",
    locKey: re.Enum,
    setNextTypeChanged() {
      this.nextTypeChanged = this.isTypeEnum;
    },
    init() {
      this.appendDummyInput("").appendField("", E.Label).appendField(new Gn(
        [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]],
        (i) => (this.setNextTypeChanged(), i)
      ), E.Item), this.setStyle("input_blocks"), this.setHelpUrl(""), this.setOutput(!0), this.setTooltip(() => "");
    },
    loadExtraState(i) {
      let l = "";
      if (typeof i == "string")
        this.geId = l = i;
      else if (typeof i == "number") {
        this.geId = i;
        let r = J.graphElementMap.get(i);
        r && (l = r.ref, this.workspace.IsCraftland || this.setStyle(r.block_style));
      } else
        this.geId = l = i.varType;
      l && this.varType != l && (this.varType = l, this.updateShape_()), this.isShadow() && this.inputList[0].removeField(E.Label, !0);
    },
    saveExtraState() {
      return this.geId;
    },
    updateShape_() {
      let i = ce.CurrentDescriptionFile, l = i.GetVarType(this.varType);
      l == null || !l.IsEnum || (this.locKey = `${f.Enum}: ${l.Label}`, this.setOutput(!0, this.varType), this.isTypeEnum = !1, l.Bases.Contains(i.typeType.Name) ? this.isTypeEnum = !0 : (l.Name === "DynamicCreateItemID" || l.Name === "HudWidgetType") && (this.isTypeEnum = !0), this.getField(E.Label) && this.setFieldValue(l.Label, E.Label));
    },
    search(i, l) {
      return !1;
    },
    DetermineTypes() {
      return this.nextTypeChanged ? (this.nextTypeChanged = !1, !0) : !1;
    },
    UpdateDisplayByScene(i, l) {
      this.varType == "SceneID" && l === "Scene" && this.updateShape_();
    },
    onchange(i) {
      if (i.type === "block_define_change") {
        let l = i.defineKey;
        (l === "customEnum" || l === this.varType) && (N.Events.disable(), this.updateShape_(), N.Events.enable());
      }
    }
  }
), o0 = {
  geId: I.input_localization_key,
  locKey: "KEY",
  init: function() {
    this.setOutput(!0, "LocString"), this.setInputsInline(!0), this.appendValueInput(E.V1).appendField("KEY").setCheck("string").setAlign(X.ALIGN_RIGHT).connection.setShadowState({
      type: I.key_enum,
      extraState: ""
    }), this.appendValueInput(E.V2).appendField(f.LocalizationKeyParams).setCheck("[]").setAlign(X.ALIGN_RIGHT).connection.setShadowState(Xe("[]")), this.setStyle("data_blocks");
  },
  search(i) {
    return ["KEY", f.LocalizationKeyParams].find((l) => J.containsKey(l, i)) || !1;
  }
}, l0 = {
  geId: I.key_enum,
  varType: "",
  init() {
    this.appendDummyInput("").appendField("KEY", E.Label).appendField(
      new Gn(
        u0,
        null,
        { showSearch: !0 }
      ),
      E.Item
    ), this.setOutput(!0, "String"), this.setStyle("data_blocks");
  }
}, s0 = {
  geId: I.input_bezier,
  locKey: "TWEEN CURVE BEZIER",
  init() {
    this.appendDummyInput().appendField(new gS("0,1,0.1,0.9,0.9,0.1,1,0"), E.Bezier).appendField(new X.FieldLabelSerializable("LinearIncrease"), "BezierText"), this.setOutput(!0, "BezierCurve"), this.setStyle("data_blocks"), this.setTooltip(""), this.setHelpUrl("");
  },
  loadExtraState(i) {
  },
  saveExtraState() {
  },
  presets: [
    { name: "Ease", value: [0.25, 0.1, 0.25, 1] },
    { name: "Ease In", value: [0.42, 0, 1, 1] },
    { name: "Ease Out", value: [0, 0, 0.58, 1] },
    { name: "Ease Both", value: [0.42, 0, 0.58, 1] },
    { name: "Linear", value: [0, 0, 1, 1] }
  ],
  getStoragePresets() {
    return [];
  },
  getLabel(i) {
    let l = 0, r = "Custom";
    const o = [...this.presets, ...this.getStoragePresets()];
    for (; l < o.length; ) {
      if (o[l].value.join(",") === i) {
        r = o[l].name;
        break;
      }
      l += 1;
    }
    return r;
  },
  onchange(i) {
    i instanceof N.Events.BlockChange && i.type == N.Events.BLOCK_CHANGE && i.blockId == this.id && i.element == "field" && (N.Events.disable(), i.name == E.Bezier && (this.setFieldValue(i.newValue, E.Bezier), this.setFieldValue(this.getLabel(i.newValue), "BezierText")), N.Events.enable());
  },
  search(i) {
    return J.containsKey("TWEEN CURVE BEZIER", i) ? "TWEEN CURVE BEZIER" : !1;
  },
  updateBezierLabel() {
    const i = this.getLabel(this.getFieldValue(E.Bezier));
    this.setFieldValue(i, "BezierText");
  }
}, a0 = {
  geId: I.input_tag,
  sheetTypeTypeChanged: !1,
  init() {
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(
      new Gn(
        () => [[f.Unselected, ""]],
        (i) => (this.sheetTypeTypeChanged = !0, i)
      ),
      Rl(2)
    );
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, _0 = {
  geId: I.input_comments,
  locKey: re.Comment,
  init() {
    this.setInputsInline(!0), this.setStyle("comment_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendValueInput(E.Value);
  },
  search(i) {
    return J.containsKey(f.Comment, i) ? f.Comment : !1;
  }
}, c0 = {
  geId: I.num_to_string,
  locKey: re.NumToString,
  formatType: yl.Regular,
  init() {
    this.setStyle("data_blocks"), this.setOutput(!0, "string"), this.setInputsInline(!0), this.appendDummyInput().appendField(f.NumToString, E.Label), this.appendValueInput(E.Value).appendField(f.Value).setCheck("number").connection.setShadowState({
      type: I.input_number
    }), this.appendDummyInput().appendField(f.NumFormatType).appendField(new Je(
      [
        [f.NumFormatF, yl.Float],
        [f.NumFormatG, yl.Regular],
        [f.NumFormatE, yl.ScientificNotation],
        [f.NumFormatN, yl.ThousandsSeparator],
        [f.NumFormatP, yl.Percentage]
      ],
      (i) => (this.formatType = i, this.updateShape_(), i)
    ), E.To), this.appendValueInput(E.Range).appendField(f.FormatValue).setCheck("number").connection.setShadowState({
      type: I.input_int,
      fields: {
        [E.Value]: 2
      }
    });
  },
  loadExtraState(i) {
    this.formatType = i[E.To], this.updateShape_();
  },
  saveExtraState() {
    return {
      [E.To]: this.formatType
    };
  },
  updateShape_() {
    const i = this.formatType, l = [
      yl.Float,
      yl.ScientificNotation,
      yl.Percentage
    ].includes(i), r = this.getInput(E.Range);
    l && !r ? this.appendValueInput(E.Range).appendField(f.FormatValue).setCheck("number").connection.setShadowState({
      type: I.input_int,
      fields: {
        [E.Value]: 2
      }
    }) : !l && r && this.removeInput(E.Range, !0);
  },
  search(i) {
    return ["NumTostring", f.NumToString].find((l) => J.containsKey(l, i)) || !1;
  }
};
function u0() {
  return [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
function T0(i) {
  N.Blocks[I.input_int] = YL, N.Blocks[I.input_number] = HL, N.Blocks[I.input_intplus] = zL, N.Blocks[I.input_float] = JL, N.Blocks[I.input_text] = ZL, N.Blocks[I.input_color] = n0, N.Blocks[I.input_bezier] = s0, N.Blocks[I.input_boolean] = qL, N.Blocks[I.input_enum] = i0, N.Blocks[I.input_null] = XL, N.Blocks[I.input_vector3] = e0, N.Blocks[I.input_vector2] = t0, N.Blocks[I.input_localization_key] = o0, N.Blocks[I.key_enum] = l0, N.Blocks[I.input_tag] = a0, N.Blocks[I.input_textarea] = QL, N.Blocks[I.input_comments] = _0, N.Blocks[I.input_pi] = KL, N.Blocks[I.input_e] = jL, N.Blocks[I.num_to_string] = c0, i.set("input_int", { kind: "block", type: I.input_int }), i.set("input_number", { kind: "block", type: I.input_number }), i.set("input_float", { kind: "block", type: I.input_float }), i.set("input_intplus", { kind: "block", type: I.input_intplus }), i.set("input_text", { kind: "block", type: I.input_text }), i.set("input_color", { kind: "block", type: I.input_color }), i.set("input_bezier", { kind: "block", type: I.input_bezier }), i.set("logic_boolean", { kind: "block", type: I.input_boolean }), i.set("input_null", { kind: "block", type: I.input_null }), i.set("input_vector3", { kind: "block", type: I.input_vector3 }), i.set("input_vector2", { kind: "block", type: I.input_vector2 }), i.set("input_localization_key", { kind: "block", type: I.input_localization_key }), i.set("key_enum", { kind: "block", type: I.key_enum }), i.set("InputTag", { kind: "block", type: I.input_tag }), i.set("input_textarea", { kind: "block", type: I.input_textarea }), i.set("input_comments", { kind: "block", type: I.input_comments }), i.set("input_pi", { kind: "block", type: I.input_pi }), i.set("input_e", { kind: "block", type: I.input_e }), i.set("num_to_string", { kind: "block", type: I.num_to_string });
}
var xd;
((i) => {
  i.CUSTOM_BLOCK_DEFINE_CHANGE = "block_define_change";
  class l extends N.Events.Abstract {
    constructor(c, T) {
      super();
      C(this, "isBlank", !0);
      C(this, "defineKey");
      C(this, "ownerType");
      this.type = i.CUSTOM_BLOCK_DEFINE_CHANGE, this.workspaceId = c, this.defineKey = T.id, this.ownerType = T.ownerType, this.isBlank = typeof c > "u";
    }
  }
  i.BlockDefineChange = l;
})(xd || (xd = {}));
N.registry.register(N.registry.Type.EVENT, xd.CUSTOM_BLOCK_DEFINE_CHANGE, xd.BlockDefineChange);
const p0 = 1e5, d0 = 1e6;
var z_;
((i) => {
  function l(ae, Ne) {
    ae.events.set_Item(`${Ne.owner}::${Ne.Name}`, Ne);
    let Fe = ae.event_ownertypes.get_Item(Ne.Name);
    Fe || (Fe = new it(), ae.event_ownertypes.set_Item(Ne.Name, Fe)), Fe.Add(Ne.owner);
    let at = ae.ownertype_events.get_Item(Ne.owner);
    at || (at = new it(), ae.ownertype_events.set_Item(Ne.owner, at)), at.Add(Ne.Name);
  }
  i.AddEvent = l;
  function r(ae, Ne) {
    ae.events.Remove(`${Ne.owner}::${Ne.Name}`);
    let Fe = ae.ownertype_events.get_Item(Ne.owner);
    Fe && Fe.Remove(Ne.Name);
    let at = ae.event_ownertypes.get_Item(Ne.Name);
    at && at.Remove(Ne.owner);
  }
  i.RemoveEvent = r;
  function o(ae) {
    let Ne = ae;
    Ne._sortedVarType = null, Ne._sortedComponentTypes = null;
  }
  i.SetSortedTypesDirty = o;
  function c(ae) {
    return ae.m_ApiLevel >= 10;
  }
  i.IsLowApiLevel = c;
  function T(ae) {
    let Ne = ae.m_ApiLevel;
    return Ne >= 1 && Ne <= 3;
  }
  i.IsDevApi = T;
  function d(ae) {
    return "*" + ae;
  }
  i.GetDevApiLabel = d;
  function h(ae) {
    switch (ae) {
      case "String":
        return "";
      case "Int":
        return 0;
      case "Float":
        return 0;
      case "Bool":
        return !1;
      case "List":
        return [];
      case "Color":
        return { r: 255, g: 255, b: 255, a: 1 };
      case "Vector3":
        return {
          x: 0,
          y: 0,
          z: 0
        };
      default:
        return ae.includes("ListT_") ? [] : null;
    }
  }
  i.GetInitialValue = h;
  function y(ae) {
    return ae.IntValue >= p0 || //@ts-expect-error
    ae.IsEnum && !ae.IntValue;
  }
  i.IsCustomType = y;
  function b(ae) {
    const Ne = ce.CurrentDescriptionFile, Fe = Ne.GetVarType("Component");
    return Ne.CheckIsExtention(Fe, ae) && y(ae);
  }
  i.IsCustomComponentType = b;
  function U(ae) {
    return y(ae) && !ae.m_ModuleLib;
  }
  i.IsOwnModuleCustomType = U;
  function Z(ae) {
    return y(ae) && !!ae.m_ModuleLib;
  }
  i.IsOtherModuleCustomType = Z;
  function le(ae) {
    return Math.floor(ae / d0);
  }
  i.GetNamespaceIntFromTypeID = le;
  function ue(ae) {
    var Ne;
    return b(ae) || !!((Ne = ae == null ? void 0 : ae.Addable) != null && Ne.length);
  }
  i.IsDynamicAddableComponent = ue;
  function be(ae, Ne) {
    var dr;
    if (!ae || !Ne || !ue(ae))
      return !1;
    if (b(ae))
      return !0;
    const Fe = ce.CurrentDescriptionFile;
    let at = !1;
    return (dr = ae == null ? void 0 : ae.Addable) == null || dr.forEach((er) => {
      let Ze = Fe.GetVarType(er);
      at = at || !!Ze && Fe.CheckIsExtention(Ze, Ne);
    }), at;
  }
  i.IsComponentAddableToEntity = be;
  function Ke(ae, Ne) {
    let Fe = de.Split(ae, ce.splits, Vh.RemoveEmptyEntries);
    return new NI().ParseTexts(kr.ToEnumerable(Fe), Ne), Ne.postLoad(), !0;
  }
  i.LoadAdditional = Ke;
})(z_ || (z_ = {}));
var VI = /* @__PURE__ */ ((i) => (i[i.server = 2] = "server", i[i.client = 1] = "client", i[i.clientAndServer = 0] = "clientAndServer", i))(VI || {}), GI = /* @__PURE__ */ ((i) => (i[i.get = 0] = "get", i[i.set = 1] = "set", i[i.formula = 2] = "formula", i[i.tween = 3] = "tween", i[i.tuple_get = 4] = "tuple_get", i[i.tuple_set = 5] = "tuple_set", i))(GI || {});
const kd = "Tuple";
let bh = {
  currentCheck: "",
  fromType: "",
  method: 0,
  initialTips: "",
  getThisType() {
    return this.getFirstThisType();
  },
  getFirstThisType() {
    let i, l = this.getInput(E.This);
    if (l != null && (i = l.connection.targetBlock()), i == null)
      return this.fromType;
    let r = i.outputConnection.getCheck();
    return r == null || r.length < 1 ? "" : r[0];
  },
  /**
   * @param propertyIndex get the output of a specified property, start from 1
   * @returns output type(ECADefineBase) of the block
   */
  getShouldCheck() {
    let i = ce.CurrentDescriptionFile, l = this.getFirstThisType(), r = this.getFieldValue(E.Property);
    return J_(l, r, i);
  },
  updateShouldChecks() {
    return !1;
  },
  DetermineTypes() {
    let i = this.updateShouldChecks(), l = this.getShouldCheck(), r = (l == null ? void 0 : l.Type) ?? "";
    if (l)
      z_.IsLowApiLevel(l) ? this.setWarningText(ye(re.Warning_LowLevel, [l.Label]), "NODEF") : this.setWarningText(null, "NODEF");
    else {
      let T = this.getFieldValue(E.Property);
      this.setWarningText(ye(re.Warning_LowLevel, [T]), "NODEF");
    }
    let o = (l == null ? void 0 : l.Tip) ?? "";
    if (o ? this.setTooltip(this.initialTips + `
${l.Label}: ${o}`) : this.setTooltip(this.initialTips), this.method == 1) {
      const T = this.getField(E.Operator);
      T && T.opType !== r && (T.setOpType(r), T.UpdateDisplay());
    }
    let c = this.currentCheck != r;
    return (c || i) && this.updatePropertyFieldDisplays(), c ? (this.setCurrentCheck(r), !0) : !1;
  },
  updatePropertyFieldDisplays() {
    let i = this.getField(E.Property);
    i.getOptions(!1), i.UpdateDisplay();
  },
  setCurrentCheck(i) {
    if (this.currentCheck = i, this.method == 0)
      this.setOutput(!0, i);
    else if (this.method == 1) {
      let l = this.getInput(E.Value);
      l != null && this.rendered && sn(l, i);
    }
  }
};
function zd(i, l, r, o) {
  if (i == "Global")
    return {
      ...bh,
      debugAvailable: l == 1,
      fromType: i,
      method: l,
      locKey: l === 0 ? re.GlobalGet : re.GlobalSet,
      init() {
        this.method == 0 ? (this.appendDummyInput("").appendField(f.GlobalGet).appendField(new Rs(this.method), E.Property), this.geId = r) : (this.appendValueInput(E.Value).appendField(f.GlobalSet).appendField(new Rs(this.method), E.Property).appendField(new Hd(), E.Operator).connection.setShadowState(Xe("")), this.geId = r), this.setInputsInline(!0), this.setColour(20), this.setTooltip(""), this.setHelpUrl(""), this.setStyle(o), this.method == 0 ? this.setOutput(!0) : this.method == 1 && (this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"));
      },
      search(c, T) {
        var b, U;
        const h = [l === 0 ? f.GlobalGet : f.GlobalSet], y = ((b = T == null ? void 0 : T.fields) == null ? void 0 : b[E.Property]) ?? "";
        if (y) {
          const Z = (U = J_(i, y, ce.CurrentDescriptionFile)) == null ? void 0 : U.Label;
          Z && h.push(Z);
        }
        return h.find((Z) => J.containsKey(Z, c)) || !1;
      }
    };
  {
    let c = l == 0 || l == 4;
    return {
      ...bh,
      debugAvailable: l == 1,
      fromType: i,
      method: l,
      locKey: c ? re.PropertyGet : re.PropertySet,
      init() {
        c ? (this.appendDummyInput("").appendField(f.PropertyGet).appendField(new Rs(this.method), E.Property), this.appendValueInput(E.This).appendField(f.PropertyGet_1).setAlign(N.ALIGN_RIGHT).setCheck(i).connection.setShadowState(Xe(i)), this.geId = r, this.locKey = re.PropertyGet) : (this.appendValueInput(E.This).appendField(f.PropertySet).setAlign(N.ALIGN_RIGHT).setCheck(i).connection.setShadowState(Xe(i)), this.appendValueInput(E.Value).appendField(new Rs(this.method), E.Property).appendField(new Hd(), E.Operator).connection.setShadowState(Xe("")), this.geId = r, this.locKey = re.PropertySet), this.setInputsInline(!0), this.setHelpUrl(""), c ? this.setOutput(!0) : (this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action")), this.setStyle(o);
      },
      search(T) {
        return (c ? [f.PropertyGet, "get"] : [f.PropertySet, "set"]).find((h) => J.containsKey(h, T)) || !1;
      }
    };
  }
}
let E0 = {
  ...bh,
  debugAvailable: !1,
  fromType: "Component",
  method: 0,
  propertyCount: 1,
  thisTypes: null,
  locKey: re.PropertyGet_2,
  init() {
    this.appendDummyInput("").appendField(f.PropertyGet_2), this.appendValueInput(E.This).appendField(f.Entity).setAlign(N.ALIGN_RIGHT).setCheck("Component").connection.setShadowState(Xe("Component")), this.appendDummyInput("").appendField(f.PropertyGet_3).appendField(new Rs(this.method), E.Property), this.geId = I.property_get, this.setInputsInline(!0), this.setHelpUrl(""), this.setOutput(!0), this.setStyle("action_blocks");
  },
  // overwrite not override
  getThisType(i) {
    if (i == null)
      return this.getFirstThisType();
    this.thisTypes == null && this.updateShouldChecks();
    let l = 0;
    return i.name != E.Property && i.name.startsWith(E.Property) && (l = Number.parseInt(i.name.substring(E.Property.length)) - 1), l < this.thisTypes.length ? this.thisTypes[l] : "";
  },
  // overwrite not override
  getShouldCheck() {
    let i = ce.CurrentDescriptionFile, l = this.propertyCount || 1;
    if (l != this.thisTypes.length && (this.updateShouldChecks(), l != this.thisTypes.length))
      return null;
    let r = this.thisTypes[this.thisTypes.length - 1], o = this.getFieldValue(l == 1 ? E.Property : E.Property + l);
    return J_(r, o, i);
  },
  // overwrite not override
  updatePropertyFieldDisplays() {
    let i = this.getField(E.Property);
    i.getOptions(!1), i.UpdateDisplay();
    for (let l = 2; l <= this.propertyCount; ++l)
      i = this.getField(E.Property + l), i.getOptions(!1), i.UpdateDisplay();
  },
  updateShouldChecks(i = !1) {
    let l = this.thisTypes;
    this.thisTypes = [];
    let r = ce.CurrentDescriptionFile, o = this.getFirstThisType(), c = this.getFieldValue(E.Property);
    this.thisTypes.push(o);
    for (let T = 2; T <= this.propertyCount; ++T) {
      let d = J_(o, c, r);
      if (d ? o = d.Type : o = "", i) {
        let h = r.GetVarType(o);
        if (h == null || !h.Bases.Contains("Component"))
          break;
      }
      this.thisTypes.push(o), c = this.getFieldValue(E.Property + T);
    }
    if (i && this.thisTypes.length != this.propertyCount)
      return this.updateShape_(this.thisTypes.length), !0;
    if (this.thisTypes.length === (l == null ? void 0 : l.length)) {
      for (let T = 0; T < l.length; ++T)
        if (this.thisTypes[T] != l[T])
          return !0;
      return !1;
    }
    return !0;
  },
  saveExtraState() {
    return {
      [E.Index]: this.propertyCount,
      [E.Type]: this.currentCheck
    };
  },
  saveExtraStateWithFields() {
    let i = {};
    for (let l = 2; l <= this.propertyCount; ++l) {
      const r = E.Property + l;
      i[r] = this.getFieldValue(r);
    }
    return JSON.stringify({
      [E.Index]: this.propertyCount,
      [E.Type]: this.currentCheck,
      FIELDS: i
    });
  },
  loadExtraState(i) {
    if (this.updateShape_(i[E.Index], i[E.Type]), i.FIELDS)
      for (let l in i.FIELDS)
        this.setFieldValue(i.FIELDS[l], l);
  },
  updateShape_(i, l) {
    for (; this.propertyCount < i; )
      this.addProperty();
    for (; this.propertyCount > i; )
      this.deleteProperty();
    l !== void 0 && this.setButtons(l);
  },
  onchange(i) {
    if (i instanceof N.Events.BlockChange && i.blockId == this.id) {
      if (i.element == "field" && i.name && i.name.includes(E.Property)) {
        let l = Da(i);
        this.recordMutation(
          () => this.updateShouldChecks(!0)
        ), aT(this), l.Leave();
      }
      this.setButtons(this.currentCheck);
    }
  },
  search(i) {
    return J.containsKey(f.PropertyGet_2, i) ? f.PropertyGet_2 : !1;
  },
  setButtons(i) {
    var o;
    this.propertyCount > 1 ? (!this.getInput("button_delete") && this.appendDummyInput("button_delete").appendField(new N.FieldImage(Os, 14, 14, "+", () => {
      this.onDeleteItem();
    })), this.getInput("button_add") && this.removeInput("button_add")) : this.getInput("button_delete") && this.removeInput("button_delete");
    let r = ce.CurrentDescriptionFile.GetVarType(i);
    i === "Entity" || (o = r == null ? void 0 : r.Bases) != null && o.Contains("Entity") ? !this.getInput("button_add") && this.appendDummyInput("button_add").appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.onAddItem();
    })) : this.getInput("button_add") && this.removeInput("button_add");
  },
  deleteButtons() {
    this.getInput("button_add") && this.removeInput("button_add"), this.getInput("button_delete") && this.removeInput("button_delete");
  },
  onAddItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    this.addProperty();
    const l = Ut(this);
    i != l && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, l)), N.Events.setGroup(!1);
  },
  addProperty() {
    this.deleteButtons(), this.propertyCount++, this.appendDummyInput(E.Item + this.propertyCount).appendField(f.PropertyGet_3).appendField(
      new Rs(this.method),
      this.propertyCount === 1 ? E.Property : E.Property + this.propertyCount
    );
  },
  onDeleteItem() {
    N.Events.setGroup(!0), this.recordMutation(
      () => this.deleteProperty()
    ), N.Events.setGroup(!1);
  },
  recordMutation(i) {
    const l = Ut(this), r = this.saveExtraStateWithFields();
    i();
    const o = Ut(this);
    l != o && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, r, o));
  },
  deleteProperty() {
    this.deleteButtons();
    let i = this.getFieldValue(E.Property + this.propertyCount);
    return this.removeInput(E.Item + this.propertyCount), this.propertyCount--, i;
  }
}, A0 = {
  geId: I.this_entity,
  locKey: re.ThisEntity,
  init() {
    let i = J.ComponentTypes ?? J.OwnerType;
    this.appendDummyInput().appendField(f.ThisEntity), this.setOutput(!0, i), this.setStyle("action_blocks");
  },
  DetermineTypes() {
    var o;
    let i = (o = this.outputConnection.getCheck()) == null ? void 0 : o[0], l = J.ComponentTypes ?? J.OwnerType;
    const r = this.getParentEventOwner();
    return r && r !== "Global" && (l += `&${r}`), l != i ? (this.setOutput(!0, l), !0) : !1;
  },
  triggerCheck() {
  },
  getParentEventOwner() {
    let i = this;
    do {
      if (i.type == I.event)
        break;
      i = i.getParent();
    } while (i);
    if (!i)
      return;
    const l = i.action;
    return l == null ? void 0 : l.owner;
  },
  onchange(i) {
    let l = this.workspace;
    if (l.isDragging && l.isDragging())
      return;
    let r = this;
    if (i.type == X.Events.BLOCK_MOVE) {
      let c = !1, T = !1;
      const d = i.blockId;
      do {
        if (r.id === d && (T = !0), r.type == I.event) {
          c = !0;
          break;
        }
        r = r.getParent();
      } while (r);
      if (c && T) {
        const h = Da(i);
        try {
          this.DetermineTypes();
        } finally {
          h.Leave();
        }
      }
    }
  },
  search(i) {
    return [f.ThisEntity, "thisentity"].find((l) => J.containsKey(l, i)) || !1;
  }
};
class Rs extends Gn {
  constructor(r, o, c, T) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]]);
    C(this, "method");
    C(this, "fromType");
    this.method = r, this.fromType = T, this.menuGenerator_ = this.generateProperties;
    let d = this.getOptions();
    c && this.configure_(c), this.setValue(d[0][1]), this.validator_ = o;
  }
  getObjectType() {
    return this.sourceBlock_ && "getThisType" in this.sourceBlock_ ? this.sourceBlock_.getThisType(this) : "";
  }
  getValueDefaultOptions(r) {
    if (r) {
      let o = r.split(":"), c = o[0], T = o[1], h = ce.CurrentDescriptionFile.GetVarType(T);
      if (h && h.GetItem(c))
        return [r + f.UnkownType, r, "", { style: "fill: var(--red_err5);" }];
    }
    return [f.Unselected, r, "", { style: "fill: var(--red_err5);" }];
  }
  doClassValidation_(r) {
    if (!r.includes(":")) {
      let o = this.getOptions(!0);
      for (let c of o) {
        let T = c[1].split(":");
        if (r == T[0])
          return c[1];
      }
    }
  }
  generateProperties() {
    let r = ce.CurrentDescriptionFile, o = this.fromType || this.getObjectType();
    if (o) {
      let c = r.GetVarType(o);
      if (c == null || c.IsEnum)
        return [
          [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
        ];
      {
        let T = [], d = /* @__PURE__ */ new Set();
        this.addProperties(c, T, d);
        for (let h of c.Bases) {
          let y = r.GetVarType(h);
          this.addProperties(y, T, d);
        }
        return T.length == 0 ? [
          [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
        ] : T;
      }
    } else
      return [
        [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
      ];
  }
  addProperties(r, o, c) {
    if (!r)
      return;
    let T = ce.CurrentDescriptionFile;
    if (!(this.method == 2 && !T.CheckIsExtention(T.GetVarType("FormulableEntity"), r)))
      for (let d of r.Items) {
        if (z_.IsLowApiLevel(d) || d.m_ApiTarget != null && !R0(d.m_ApiTarget))
          continue;
        if (this.method == 2) {
          if (d.IntValue >= 0)
            continue;
          let U = T.GetVarType(d.Type);
          if (U != T.floatType && U != T.intType)
            continue;
        } else if (this.method == 1) {
          if (d.Main == "get")
            continue;
        } else if (this.method == 3 && (d.Main == "get" || !["Vector2", "Vector3", "Float", "Int", "Color", "Quaternion"].includes(d.Type)))
          continue;
        let h = d.Label, y = T.GetVarType(d.Type), b = d.Type;
        y && (b = y.Label), c.has(h) && (h = h + "(" + r.Label + ")"), c.add(h), z_.IsDevApi(d) && (h = "*" + h), o.push([h + "    " + b, d.Name + ":" + r.Name, h]);
      }
  }
}
class Hd extends Je {
  constructor() {
    super([["=", dt.Unknown]]);
    C(this, "opType", "");
    this.menuGenerator_ = this.opGenerator;
  }
  setOpType(r) {
    this.opType = r;
  }
  opGenerator() {
    return ["", "int", "float", "number"].includes(this.opType.toLowerCase()) ? [
      ["=", dt.Unknown],
      ["+=", dt.Add],
      ["-=", dt.Substract],
      ["*=", dt.Multiply],
      ["/=", dt.Divide]
    ] : [["=", dt.Unknown]];
  }
}
let S0 = {
  init() {
    this.setOutput(!0, "Property"), this.appendDummyInput().appendField(new Rs(
      2
      /* formula */
    ), E.Property);
  },
  getThisType() {
    let i = this.outputConnection.targetConnection, l = i == null ? void 0 : i.getCheck(), r = l == null ? void 0 : l[0];
    if (r) {
      let o = ce.CurrentDescriptionFile, c = o.GetVarType(r);
      if (c && o.CheckIsExtention(o.getType("Property"), c))
        return c.ElementType;
    }
    return "";
  },
  loadExtraState(i) {
    if (typeof i == "number" && GI[i]) {
      let l = this.getField(E.Property);
      l.method = i;
    }
  },
  saveExtraState() {
    let i = this.getField(E.Property);
    return i == null ? void 0 : i.method;
  },
  ReversedDetermineType() {
    this.getField(E.Property).UpdateDisplay();
  },
  DetermineTypes() {
    return this.getField(E.Property).UpdateDisplay(), !1;
  }
}, h0 = {
  itemCount: 0,
  TupleType: kd,
  locKey: re.NewMap,
  getThisType() {
    return this.TupleType;
  },
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.onAddItem();
    })).appendField("Create Tuple").appendField(new oo({ baseType: kd, checkExtension: !0 }), E.Type), this.setStyle("data_blocks"), this.setOutput(!0, kd);
  },
  saveExtraState() {
    return {
      [E.Index]: this.itemCount
    };
  },
  loadExtraState(i) {
    this.updateShape_(i[E.Index]);
  },
  DetermineTypes() {
    let i = this.getFieldValue(E.Type), l = !1;
    if (i !== this.TupleType && (l = !0, this.TupleType = i), l) {
      const r = ce.CurrentDescriptionFile;
      for (let o = 0; o < this.itemCount; o++) {
        this.getField(E.Key + o).UpdateDisplay();
        let T = this.getFieldValue(E.Key + o), d = J_(this.TupleType, T, r), h = "";
        d && (h = d.Type), this.inputList[o * 2 + 2].setCheck(h).connection.setShadowState(Xe(h));
      }
      this.setOutput(!0, this.TupleType);
    }
    return l;
  },
  updateShape_(i) {
    for (; this.itemCount < i; )
      this.addPart();
    for (; this.itemCount > i; )
      this.deletePart();
  },
  onAddItem() {
    N.Events.setGroup(!0);
    const i = Ut(this);
    let l = this.itemCount;
    this.addPart();
    const r = Ut(this);
    if (i != r) {
      N.Events.fire(new N.Events.BlockChange(this, "mutation", null, i, r));
      let o = ce.CurrentDescriptionFile.GetVarType(this.TupleType), c = /* @__PURE__ */ new Set();
      if (o != null) {
        for (let d of o.Items) {
          if (z_.IsLowApiLevel(d) || d.Main == "get")
            continue;
          let h = d.Name + ":" + this.TupleType;
          c.has(h) || c.add(h);
        }
        for (let d = 0; d < l; ++d) {
          let h = this.getFieldValue(E.Key + d);
          c.delete(h);
        }
      }
      let T = c.size > 0 ? c.values().next().value : "";
      if (T) {
        let d = this.getField(E.Key + (this.itemCount - 1));
        d.setValue(T), d.UpdateDisplay();
      }
    }
    N.Events.setGroup(!1);
  },
  addPart() {
    let i = this.itemCount, l = (r) => {
      let o = J_(this.TupleType, r, ce.CurrentDescriptionFile), c = this.getInput(E.Value + i);
      return c.connection.setShadowState(Xe(o == null ? void 0 : o.Type)), c.setCheck(o == null ? void 0 : o.Type), r;
    };
    this.appendDummyInput("NEW_LINE_" + this.itemCount).appendField(
      new N.FieldImage(Os, 14, 14, "-", (r) => this.onDeleteItem(r)),
      i.toString()
    ).appendField(new Rs(5, l), E.Key + i), this.appendValueInput(E.Value + i).connection.setShadowState(Xe("")), this.itemCount++;
  },
  onDeleteItem(i) {
    var c;
    if (!i.name)
      return;
    N.Events.setGroup(!0);
    const l = Ut(this), r = Number(i.name);
    for (let T = r; T < this.itemCount; T++) {
      let d = this.getFieldValue(E.Key + (T + 1)) ?? "";
      this.setFieldValue(d, E.Key + T);
      const h = this.inputList[T * 2 + 2], y = this.inputList[(T + 1) * 2 + 2];
      h != null && h.connection.targetConnection && ((c = h.connection.targetBlock()) == null || c.dispose(!0)), h && (y != null && y.connection.targetConnection) && h.connection.connect(y.connection.targetConnection);
    }
    this.deletePart();
    const o = Ut(this);
    l != o && N.Events.fire(new N.Events.BlockChange(this, "mutation", null, l, o)), N.Events.setGroup(!1);
  },
  deletePart() {
    this.itemCount--, this.removeInput("NEW_LINE_" + this.itemCount), this.removeInput(E.Value + this.itemCount);
  },
  search(i) {
    return [f.NewMap, "NewMap"].find((l) => J.containsKey(l, i)) || !1;
  }
}, m0 = {
  locKey: re.GetPropertyId,
  init() {
    this.appendDummyInput("").appendField(f.GetPropertyId), this.appendDummyInput().appendField(new oo({ baseType: "Component", checkExtension: !0 }), E.Type), this.appendDummyInput("").appendField(f.PropertyGet_3).appendField(new Rs(
      0
      /* get */
    ), E.Property), this.geId = I.get_property_id, this.setOutput(!0, "Property"), this.setInputsInline(!0), this.setHelpUrl(""), this.setStyle("action_blocks"), this.setTooltip(() => `${ye("FE_44_SD_TIPSFCG")}: 
${this.getScriptSyntax()}`);
  },
  getShouldCheck() {
    let i = ce.CurrentDescriptionFile, l = this.getFieldValue(E.Type), r = this.getFieldValue(E.Property);
    return J_(l, r, i);
  },
  // a public method used in FieldProperty
  getThisType() {
    return this.getFieldValue(E.Type);
  },
  DetermineTypes() {
    let i = this.getField(E.Property);
    i.getOptions(!1), i.UpdateDisplay(), I0(this.getShouldCheck(), this.setWarningText.bind(this), this.getFieldValue.bind(this));
  },
  getScriptSyntax() {
    return "";
  },
  search(i, l) {
    return [f.GetPropertyId].find((o) => J.containsKey(o, i)) || !1;
  }
};
function J_(i, l, r) {
  if (!i)
    return null;
  let o = l.split(":"), c = i;
  if (o.length >= 2) {
    c = o[1], l = o[0];
    let d = r.GetVarType(i);
    if (d == null || c != i && !d.Bases.Contains(c))
      return null;
  }
  let T = r.GetVarType(c);
  if (!(T == null || T.IsEnum)) {
    for (let d of T.Items)
      if (d.Name == l)
        return d;
  }
  return null;
}
const I0 = (i, l, r) => {
  if (i)
    i.m_ApiLevel >= 10 ? l(ye(re.Warning_Deprecated, [i.Label]), "NODEF") : z_.IsLowApiLevel(i) ? l(ye(re.Warning_LowLevel, [i.Label]), "NODEF") : l(null, "NODEF");
  else {
    let o = r(E.Property);
    l(ye(re.Warning_NoDefine, [o]), "NODEF");
  }
};
let M0 = zd("Component", 1, I.property_set, "action_blocks"), g0 = zd("Global", 0, I.globalvar_get, "module_blocks"), L0 = zd("Global", 1, I.globalvar_set, "module_blocks"), N0 = zd(kd, 4, I.tuple_get, "data_blocks"), y0 = zd(kd, 5, I.tuple_set, "data_blocks"), f0 = {
  locKey: re.Type,
  init() {
    this.setOutput(!0, "Type"), this.appendDummyInput().appendField(new oo(""), E.Type), this.setStyle("data_blocks");
  },
  search(i, l) {
    return [f.Type].find((o) => J.containsKey(o, i)) || !1;
  }
}, C0 = {
  locKey: re.Component,
  init() {
    this.setOutput(!0, "Type"), this.appendDummyInput().appendField(new oo({ baseType: "Component", checkExtension: !0 }), E.Type), this.setStyle("data_blocks");
  },
  search(i, l) {
    return [f.Component, f.Type].find((o) => J.containsKey(o, i)) || !1;
  }
};
function v0(i) {
  N.Blocks[I.property_get] = E0, N.Blocks[I.property_set] = M0, N.Blocks[I.globalvar_get] = g0, N.Blocks[I.globalvar_set] = L0, N.Blocks[I.this_entity] = A0, N.Blocks[I.propertyref] = S0, N.Blocks[I.typeid] = f0, N.Blocks[I.componentid] = C0, N.Blocks[I.tuple_get] = N0, N.Blocks[I.tuple_set] = y0, N.Blocks[I.tuple_create] = h0, N.Blocks[I.get_property_id] = m0, i.set("property_get", { kind: "block", type: I.property_get }), i.set("property_set", { kind: "block", type: I.property_set }), i.set("globalvar_get", { kind: "block", type: I.globalvar_get }), i.set("globalvar_set", { kind: "block", type: I.globalvar_set }), i.set("this_entity", { kind: "block", type: I.this_entity }), i.set("FormulaProperty", {
    kind: "block",
    type: I.propertyref,
    extraState: 2
    /* formula */
  }), i.set("TweenProperty", {
    kind: "block",
    type: I.propertyref,
    extraState: 3
    /* tween */
  }), i.set("Type", { kind: "block", type: I.typeid }), i.set("ComponentID", { kind: "block", type: I.componentid }), i.set("tuple_get", { kind: "block", type: I.tuple_get }), i.set("tuple_set", { kind: "block", type: I.tuple_set }), i.set("tuple_create", { kind: "block", type: I.tuple_create }), i.set("get_property_id", { kind: "block", type: I.get_property_id });
}
function R0(i) {
  return i === VI.clientAndServer ? !0 : J.curTarget === i;
}
const xI = X.ContextMenuRegistry.ScopeType, bm = "$Auto";
var bt = /* @__PURE__ */ ((i) => (i[i.SelfDefine = 0] = "SelfDefine", i[i.NextStatements = 1] = "NextStatements", i[i.ChildStatements = 2] = "ChildStatements", i[i.ChildInputs = 3] = "ChildInputs", i))(bt || {});
function lo(i, l, r, o) {
  let c = i.getField(l);
  if (c == null || !c.getVarDefine || i.isEnabled && !i.isEnabled())
    return null;
  let T = c.getVarDefine();
  return o && T.name == r || !o && T.id == r ? T : null;
}
function so(i, l, r) {
  for (let o of i.inputList) {
    if (o.type != N.inputTypes.VALUE)
      continue;
    let c = o.connection.targetBlock();
    if (c == null)
      continue;
    let T = O0(c, l, r);
    if (T || (T = so(c, l, r), T))
      return T;
  }
  return null;
}
function O0(i, l, r) {
  if (i.isEnabled && !i.isEnabled())
    return null;
  for (let o of i.inputList)
    for (let c of o.fieldRow) {
      if (c == null || !c.getVarDefine)
        continue;
      let T = c.getVarDefine();
      if (r && T.name == l)
        return T;
      if (!r && T.id == l)
        return T;
    }
}
let HI = {
  isOOS: !1,
  vardef: null,
  SetVarType: null,
  // abstract
  recordType: "",
  //记录的类型
  UpdateVardef() {
    let i = this.vardef;
    if (i == null) {
      this.setWarningText(ye(re.Warning_NoDefine, [""]), "NOREF");
      return;
    }
    let l = this.getField(E.VarRef);
    if (l.getValue() != i.name) {
      let o = N.Events.getRecordUndo();
      N.Events.setRecordUndo(!1), l.setValue(i.name), N.Events.setRecordUndo(o);
    }
    this.SetVarType(i.type);
  },
  updateLocalScopedVarDefine(i) {
    let l = this;
    if (this.vardef) {
      let r = this.vardef.id;
      for (; l != null; ) {
        let o = l;
        if (l = l.getParent(), l != null) {
          let c = null, T = Eh(l, o);
          if (l.getVarDefine)
            c = l.getVarDefine(r, Eh(l, o));
          else if (T == 1 && (c = so(this, r, !1), c))
            return c;
          if (c != null)
            return this.isOOS = !1, this.vardef = c, this.setWarningText(null, "NOREF"), c;
        }
      }
    }
    for (l = this; l != null; ) {
      let r = l;
      if (l = l.getParent(), l != null) {
        let o = null, c = Eh(l, r);
        if (l.getVarDefine)
          o = l.getVarDefine(i, c, !0);
        else if (c == 1 && (o = so(this, i, !0), o))
          return o;
        if (o != null)
          return this.isOOS = !1, this.vardef = o, this.setWarningText(null, "NOREF"), o;
      }
    }
    return this.isOOS = !0, this.vardef ? this.setWarningText(f.Warning_LocalVar_OOS, "NOREF") : this.setWarningText(f.Warning_LocalVar_NoDefine, "NOREF"), null;
  },
  onchange(i) {
    if (i.type == N.Events.CREATE || i.type == N.Events.MOVE || i.type == N.Events.CHANGE && i.element === "disabled") {
      let l = this.getField(E.VarRef), r = l == null ? void 0 : l.getValue();
      if (!r)
        return;
      const o = Da(i);
      try {
        this.updateLocalScopedVarDefine(r), aT(this);
      } finally {
        o.Leave();
      }
    }
  },
  DetermineTypes() {
    let i = this.recordType;
    if (this.UpdateVardef(), this.type === I.localvar_set) {
      const l = this.getField(E.Operator);
      l && l.opType !== this.recordType && (l.setOpType(this.recordType), l.UpdateDisplay());
    }
    return i != this.recordType;
  },
  loadExtraState(i) {
    if (typeof i == "string") {
      let l = D0(i);
      l && (this.vardef = l, this.UpdateVardef());
    }
  },
  saveExtraState() {
    var i;
    return (i = this.vardef) == null ? void 0 : i.id;
  }
};
function D0(i) {
  let l = N.getMainWorkspace();
  for (; l.options.parentWorkspace; )
    l = l.options.parentWorkspace;
  let r = i.substring(0, 20), o = l.getBlockById(r);
  return o == null && (r = Number.parseInt(i).toString(), i = i.replace(" ", ""), o = l.getBlockById(r)), o ? o.getVarDefine(
    i,
    0
    /* SelfDefine */
  ) : null;
}
let b0 = {
  ...HI,
  geId: I.localvar_get,
  init() {
    this.setInputsInline(!0), this.appendDummyInput(E.Value).appendField(new X.FieldLabelSerializable(), E.VarRef), this.setOutput(!0), this.setStyle("shadow_blocks");
  },
  SetVarType(i) {
    if (i != this.recordType) {
      this.recordType = i, this.setOutput(!0, i);
      let l = ce.CurrentDescriptionFile.GetVarType(i);
      l ? this.setTooltip(l.Label) : this.setTooltip(f.UnkownType);
    }
  }
}, P0 = {
  ...HI,
  debugAvailable: !0,
  geId: I.localvar_set,
  locKey: re.LocalvarSet,
  init() {
    this.setInputsInline(!this.isInFlyout), this.isInFlyout && this.setEditable(!1);
    let i = this.appendValueInput(E.Value);
    i.appendField(f.LocalvarSet).appendField(new X.FieldLabelSerializable(), E.VarRef), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.isInFlyout || (i.appendField(new Hd(), E.Operator), i.connection.setShadowState(Xe(""))), this.setStyle("var_blocks");
  },
  SetVarType(i) {
    if (i != this.recordType) {
      this.recordType = i;
      let l = this.getInput(E.Value);
      sn(l, i);
    }
  },
  search(i, l) {
    const r = [f.LocalvarSet], o = l.fields && l.fields[E.VarRef];
    return o && r.push(o), r.find((c) => J.containsKey(c, i)) || !1;
  }
};
xI.BLOCK;
xI.BLOCK;
function Eh(i, l) {
  let r = 2;
  return i.getNextBlock() === l ? r = 1 : l.outputConnection && (r = 3), r;
}
let $0 = {
  debugAvailable: !0,
  geId: I.localvar_def,
  locKey: re.LcoalvarDefine,
  init() {
    const i = this.workspace.IsCraftland, l = !i;
    let r = "var" + (Math.random() * 1e3).toFixed(0), o = function(T) {
      let d = T;
      return T === bm && (d = "any"), this.getSourceBlock().getField(E.VarDef).setValue({ type: d }), T;
    };
    this.inputsInline = !0, this.inputsInlineDefault = !0;
    let c;
    i ? c = new hL(E.VarDef, Vg, 24, 24) : c = new PI(f.LocalvarSet, E.VarDef), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendValueInput(E.Value).appendField(f.LcoalvarDefine).appendField(new Vt({ name: r }), E.VarDef).appendField(new oo({ hasAuto: l }, o), E.Type), this.appendDummyInput().appendField(c), this.setTooltip(f.LcoalvarDefineTooltip), this.setStyle("var_blocks");
  },
  getVarDefine(i, l, r) {
    if (l == 1 || l == 0) {
      let o = lo(this, E.VarDef, i, r);
      if (o)
        return o;
    }
    return l == 1 ? so(this, i, r) : null;
  },
  DetermineTypes() {
    var T;
    let i = this.getInput(E.Value), l = i.connection.getCheck(), r = "";
    l && (r = l[0]);
    let o = this.getFieldValue(E.Type), c = "";
    {
      let d = (T = i.connection.targetConnection) == null ? void 0 : T.getCheck();
      d ? c = d[0] : c = "";
      let h = "", y = ce.CurrentDescriptionFile.GetVarType(c);
      h = (y == null ? void 0 : y.Label) ?? "", this.getField(E.Type).SetAutoLabel(h);
    }
    o === bm && (o = c, this.getField(E.VarDef).setValue({ type: o }, !1)), r != o && (i.setCheck(o), this.updateShadowDefaultValue());
  },
  updateShadowDefaultValue() {
    let i = this.getInput(E.Value), l = oL(this.getFieldValue(E.Type));
    i.connection.setShadowState(l), setTimeout(() => {
      var o;
      let r = (o = i.connection) == null ? void 0 : o.getShadowState(!0);
      r ? r.type == l.type ? r.extraState = l.extraState : r.type == I.shadow_type && (r = l) : r = l, i.connection.setShadowState(r);
    });
  },
  search(i, l) {
    var c;
    const r = [f.LcoalvarDefine], o = l.fields && ((c = l.fields[E.VarDef]) == null ? void 0 : c.name);
    return o && r.push(o), r.find((T) => J.containsKey(T, i)) || !1;
  }
};
function W0(i) {
  N.Blocks[I.localvar_def] = $0, N.Blocks[I.localvar_get] = b0, N.Blocks[I.localvar_set] = P0, i.set("localvar_get", { kind: "block", type: I.localvar_get }), i.set("localvar_set", { kind: "block", type: I.localvar_set }), i.set("localvar_def", { kind: "block", type: I.localvar_def });
}
let k0 = {
  geId: "ifelse_craftland",
  locKey: re.ConditionalStatement,
  uniqueIds: [],
  conditionCount: 1,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.Condition).setCheck("bool").appendField(f.If_Craftland, E.Label), this.appendStatementInput(E.Code).setCheck("action"), this.appendDummyInput().appendField("     "), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setStyle("logic_blocks"), this.uniqueIds = [];
  }
}, w0 = {
  geId: "ifelse_craftland",
  locKey: re.ConditionalStatement,
  uniqueIds: [],
  conditionCount: 1,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.Condition).setCheck("bool").appendField(f.If_Craftland, E.Label), this.appendStatementInput(E.Code), this.appendDummyInput().appendField(f.Else).appendField("     "), this.appendStatementInput(E.Code + "_else").setCheck("action"), this.appendDummyInput().appendField("     "), this.setPreviousStatement(!0, null), this.setNextStatement(!0, null), this.setStyle("logic_blocks"), this.uniqueIds = [];
  }
}, F0 = {
  geId: "EntityGetter_craftland",
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField("No entity").appendField(new X.FieldImage(Hh, 20, 20, "pick")), this.setStyle("input_blocks");
  }
}, B0 = {
  geId: "EntityGetter_craftland",
  init() {
    this.setInputsInline(!0), this.appendDummyInput().appendField("Empty list"), this.setStyle("input_blocks");
  }
};
function U0(i) {
  N.Blocks.if_craftland = k0, N.Blocks.ifelse_craftland = w0, N.Blocks.EntityGetter_craftland = F0, N.Blocks.EmptyList_craftland = B0, i.set("if_craftland", { kind: "block", type: "if_craftland", extraState: {
    [E.Index]: 1
  } }), i.set("ifelse_craftland", { kind: "block", type: "ifelse_craftland", extraState: {
    [E.Index]: 2
  } }), i.set("loop_forindex_craftland", {
    kind: "block",
    type: I.loop_forindex,
    inputs: {
      [E.From]: { block: { type: I.input_int, fields: { [E.Value]: 0 } } },
      [E.To]: { block: { type: I.input_int, fields: { [E.Value]: 10 } } },
      [E.Step]: { block: { type: I.input_int, fields: { [E.Value]: 1 } } }
    }
  }), i.set("ConstFloatOrInt_craftland", {
    kind: "block",
    type: I.input_number
  }), i.set("ConstVector3_craftland", {
    kind: "block",
    type: I.input_vector3
  }), i.set("EntityGetter_craftland", {
    kind: "block",
    type: "EntityGetter_craftland"
  }), i.set("EmptyList_craftland", {
    kind: "block",
    type: "EmptyList_craftland"
  }), i.set("loop_break_craftland", { kind: "block", type: I.loop_break }), i.set("loop_continue_craftland", { kind: "block", type: I.loop_continue }), i.set("ProcessCtlReturn_craftland", { kind: "block", type: I.function_return, extraState: { rt: "" } }), i.set("ProcessCtlReturnVoid_craftland", { kind: "block", type: I.function_return, extraState: { rt: null } });
}
var YI = typeof global == "object" && global && global.Object === Object && global, V0 = typeof self == "object" && self && self.Object === Object && self, Go = YI || V0 || Function("return this")(), iT = Go.Symbol, XI = Object.prototype, G0 = XI.hasOwnProperty, x0 = XI.toString, Pd = iT ? iT.toStringTag : void 0;
function H0(i) {
  var l = G0.call(i, Pd), r = i[Pd];
  try {
    i[Pd] = void 0;
    var o = !0;
  } catch {
  }
  var c = x0.call(i);
  return o && (l ? i[Pd] = r : delete i[Pd]), c;
}
var Y0 = Object.prototype, X0 = Y0.toString;
function K0(i) {
  return X0.call(i);
}
var j0 = "[object Null]", z0 = "[object Undefined]", Pm = iT ? iT.toStringTag : void 0;
function _T(i) {
  return i == null ? i === void 0 ? z0 : j0 : Pm && Pm in Object(i) ? H0(i) : K0(i);
}
function cT(i) {
  return i != null && typeof i == "object";
}
var J0 = "[object Symbol]";
function Z0(i) {
  return typeof i == "symbol" || cT(i) && _T(i) == J0;
}
var jh = Array.isArray, Q0 = /\s/;
function q0(i) {
  for (var l = i.length; l-- && Q0.test(i.charAt(l)); )
    ;
  return l;
}
var e4 = /^\s+/;
function t4(i) {
  return i && i.slice(0, q0(i) + 1).replace(e4, "");
}
function Oa(i) {
  var l = typeof i;
  return i != null && (l == "object" || l == "function");
}
var $m = NaN, r4 = /^[-+]0x[0-9a-f]+$/i, n4 = /^0b[01]+$/i, i4 = /^0o[0-7]+$/i, o4 = parseInt;
function Wm(i) {
  if (typeof i == "number")
    return i;
  if (Z0(i))
    return $m;
  if (Oa(i)) {
    var l = typeof i.valueOf == "function" ? i.valueOf() : i;
    i = Oa(l) ? l + "" : l;
  }
  if (typeof i != "string")
    return i === 0 ? i : +i;
  i = t4(i);
  var r = n4.test(i);
  return r || i4.test(i) ? o4(i.slice(2), r ? 2 : 8) : r4.test(i) ? $m : +i;
}
var l4 = "[object AsyncFunction]", s4 = "[object Function]", a4 = "[object GeneratorFunction]", _4 = "[object Proxy]";
function KI(i) {
  if (!Oa(i))
    return !1;
  var l = _T(i);
  return l == s4 || l == a4 || l == l4 || l == _4;
}
var Ah = Go["__core-js_shared__"], km = function() {
  var i = /[^.]+$/.exec(Ah && Ah.keys && Ah.keys.IE_PROTO || "");
  return i ? "Symbol(src)_1." + i : "";
}();
function c4(i) {
  return !!km && km in i;
}
var u4 = Function.prototype, T4 = u4.toString;
function q_(i) {
  if (i != null) {
    try {
      return T4.call(i);
    } catch {
    }
    try {
      return i + "";
    } catch {
    }
  }
  return "";
}
var p4 = /[\\^$.*+?()[\]{}|]/g, d4 = /^\[object .+?Constructor\]$/, E4 = Function.prototype, A4 = Object.prototype, S4 = E4.toString, h4 = A4.hasOwnProperty, m4 = RegExp(
  "^" + S4.call(h4).replace(p4, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function I4(i) {
  if (!Oa(i) || c4(i))
    return !1;
  var l = KI(i) ? m4 : d4;
  return l.test(q_(i));
}
function M4(i, l) {
  return i == null ? void 0 : i[l];
}
function ec(i, l) {
  var r = M4(i, l);
  return I4(r) ? r : void 0;
}
var Ph = ec(Go, "WeakMap"), wm = Object.create, g4 = /* @__PURE__ */ function() {
  function i() {
  }
  return function(l) {
    if (!Oa(l))
      return {};
    if (wm)
      return wm(l);
    i.prototype = l;
    var r = new i();
    return i.prototype = void 0, r;
  };
}();
function L4(i, l) {
  var r = -1, o = i.length;
  for (l || (l = Array(o)); ++r < o; )
    l[r] = i[r];
  return l;
}
var Fm = function() {
  try {
    var i = ec(Object, "defineProperty");
    return i({}, "", {}), i;
  } catch {
  }
}();
function N4(i, l) {
  for (var r = -1, o = i == null ? 0 : i.length; ++r < o && l(i[r], r, i) !== !1; )
    ;
  return i;
}
var y4 = 9007199254740991, f4 = /^(?:0|[1-9]\d*)$/;
function C4(i, l) {
  var r = typeof i;
  return l = l ?? y4, !!l && (r == "number" || r != "symbol" && f4.test(i)) && i > -1 && i % 1 == 0 && i < l;
}
function jI(i, l, r) {
  l == "__proto__" && Fm ? Fm(i, l, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : i[l] = r;
}
function zI(i, l) {
  return i === l || i !== i && l !== l;
}
var v4 = Object.prototype, R4 = v4.hasOwnProperty;
function JI(i, l, r) {
  var o = i[l];
  (!(R4.call(i, l) && zI(o, r)) || r === void 0 && !(l in i)) && jI(i, l, r);
}
function LS(i, l, r, o) {
  var c = !r;
  r || (r = {});
  for (var T = -1, d = l.length; ++T < d; ) {
    var h = l[T], y = void 0;
    y === void 0 && (y = i[h]), c ? jI(r, h, y) : JI(r, h, y);
  }
  return r;
}
var O4 = 9007199254740991;
function ZI(i) {
  return typeof i == "number" && i > -1 && i % 1 == 0 && i <= O4;
}
function QI(i) {
  return i != null && ZI(i.length) && !KI(i);
}
var D4 = Object.prototype;
function zh(i) {
  var l = i && i.constructor, r = typeof l == "function" && l.prototype || D4;
  return i === r;
}
function b4(i, l) {
  for (var r = -1, o = Array(i); ++r < i; )
    o[r] = l(r);
  return o;
}
var P4 = "[object Arguments]";
function Bm(i) {
  return cT(i) && _T(i) == P4;
}
var qI = Object.prototype, $4 = qI.hasOwnProperty, W4 = qI.propertyIsEnumerable, k4 = Bm(/* @__PURE__ */ function() {
  return arguments;
}()) ? Bm : function(i) {
  return cT(i) && $4.call(i, "callee") && !W4.call(i, "callee");
};
function w4() {
  return !1;
}
var eM = typeof exports == "object" && exports && !exports.nodeType && exports, Um = eM && typeof module == "object" && module && !module.nodeType && module, F4 = Um && Um.exports === eM, Vm = F4 ? Go.Buffer : void 0, B4 = Vm ? Vm.isBuffer : void 0, tM = B4 || w4, U4 = "[object Arguments]", V4 = "[object Array]", G4 = "[object Boolean]", x4 = "[object Date]", H4 = "[object Error]", Y4 = "[object Function]", X4 = "[object Map]", K4 = "[object Number]", j4 = "[object Object]", z4 = "[object RegExp]", J4 = "[object Set]", Z4 = "[object String]", Q4 = "[object WeakMap]", q4 = "[object ArrayBuffer]", eN = "[object DataView]", tN = "[object Float32Array]", rN = "[object Float64Array]", nN = "[object Int8Array]", iN = "[object Int16Array]", oN = "[object Int32Array]", lN = "[object Uint8Array]", sN = "[object Uint8ClampedArray]", aN = "[object Uint16Array]", _N = "[object Uint32Array]", qt = {};
qt[tN] = qt[rN] = qt[nN] = qt[iN] = qt[oN] = qt[lN] = qt[sN] = qt[aN] = qt[_N] = !0;
qt[U4] = qt[V4] = qt[q4] = qt[G4] = qt[eN] = qt[x4] = qt[H4] = qt[Y4] = qt[X4] = qt[K4] = qt[j4] = qt[z4] = qt[J4] = qt[Z4] = qt[Q4] = !1;
function cN(i) {
  return cT(i) && ZI(i.length) && !!qt[_T(i)];
}
function Jh(i) {
  return function(l) {
    return i(l);
  };
}
var rM = typeof exports == "object" && exports && !exports.nodeType && exports, wd = rM && typeof module == "object" && module && !module.nodeType && module, uN = wd && wd.exports === rM, Sh = uN && YI.process, oT = function() {
  try {
    var i = wd && wd.require && wd.require("util").types;
    return i || Sh && Sh.binding && Sh.binding("util");
  } catch {
  }
}(), Gm = oT && oT.isTypedArray, TN = Gm ? Jh(Gm) : cN, pN = Object.prototype, dN = pN.hasOwnProperty;
function nM(i, l) {
  var r = jh(i), o = !r && k4(i), c = !r && !o && tM(i), T = !r && !o && !c && TN(i), d = r || o || c || T, h = d ? b4(i.length, String) : [], y = h.length;
  for (var b in i)
    (l || dN.call(i, b)) && !(d && // Safari 9 has enumerable `arguments.length` in strict mode.
    (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    c && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    T && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
    C4(b, y))) && h.push(b);
  return h;
}
function iM(i, l) {
  return function(r) {
    return i(l(r));
  };
}
var EN = iM(Object.keys, Object), AN = Object.prototype, SN = AN.hasOwnProperty;
function hN(i) {
  if (!zh(i))
    return EN(i);
  var l = [];
  for (var r in Object(i))
    SN.call(i, r) && r != "constructor" && l.push(r);
  return l;
}
function Zh(i) {
  return QI(i) ? nM(i) : hN(i);
}
function mN(i) {
  var l = [];
  if (i != null)
    for (var r in Object(i))
      l.push(r);
  return l;
}
var IN = Object.prototype, MN = IN.hasOwnProperty;
function gN(i) {
  if (!Oa(i))
    return mN(i);
  var l = zh(i), r = [];
  for (var o in i)
    o == "constructor" && (l || !MN.call(i, o)) || r.push(o);
  return r;
}
function Qh(i) {
  return QI(i) ? nM(i, !0) : gN(i);
}
var Yd = ec(Object, "create");
function LN() {
  this.__data__ = Yd ? Yd(null) : {}, this.size = 0;
}
function NN(i) {
  var l = this.has(i) && delete this.__data__[i];
  return this.size -= l ? 1 : 0, l;
}
var yN = "__lodash_hash_undefined__", fN = Object.prototype, CN = fN.hasOwnProperty;
function vN(i) {
  var l = this.__data__;
  if (Yd) {
    var r = l[i];
    return r === yN ? void 0 : r;
  }
  return CN.call(l, i) ? l[i] : void 0;
}
var RN = Object.prototype, ON = RN.hasOwnProperty;
function DN(i) {
  var l = this.__data__;
  return Yd ? l[i] !== void 0 : ON.call(l, i);
}
var bN = "__lodash_hash_undefined__";
function PN(i, l) {
  var r = this.__data__;
  return this.size += this.has(i) ? 0 : 1, r[i] = Yd && l === void 0 ? bN : l, this;
}
function Z_(i) {
  var l = -1, r = i == null ? 0 : i.length;
  for (this.clear(); ++l < r; ) {
    var o = i[l];
    this.set(o[0], o[1]);
  }
}
Z_.prototype.clear = LN;
Z_.prototype.delete = NN;
Z_.prototype.get = vN;
Z_.prototype.has = DN;
Z_.prototype.set = PN;
function $N() {
  this.__data__ = [], this.size = 0;
}
function NS(i, l) {
  for (var r = i.length; r--; )
    if (zI(i[r][0], l))
      return r;
  return -1;
}
var WN = Array.prototype, kN = WN.splice;
function wN(i) {
  var l = this.__data__, r = NS(l, i);
  if (r < 0)
    return !1;
  var o = l.length - 1;
  return r == o ? l.pop() : kN.call(l, r, 1), --this.size, !0;
}
function FN(i) {
  var l = this.__data__, r = NS(l, i);
  return r < 0 ? void 0 : l[r][1];
}
function BN(i) {
  return NS(this.__data__, i) > -1;
}
function UN(i, l) {
  var r = this.__data__, o = NS(r, i);
  return o < 0 ? (++this.size, r.push([i, l])) : r[o][1] = l, this;
}
function bs(i) {
  var l = -1, r = i == null ? 0 : i.length;
  for (this.clear(); ++l < r; ) {
    var o = i[l];
    this.set(o[0], o[1]);
  }
}
bs.prototype.clear = $N;
bs.prototype.delete = wN;
bs.prototype.get = FN;
bs.prototype.has = BN;
bs.prototype.set = UN;
var Xd = ec(Go, "Map");
function VN() {
  this.size = 0, this.__data__ = {
    hash: new Z_(),
    map: new (Xd || bs)(),
    string: new Z_()
  };
}
function GN(i) {
  var l = typeof i;
  return l == "string" || l == "number" || l == "symbol" || l == "boolean" ? i !== "__proto__" : i === null;
}
function yS(i, l) {
  var r = i.__data__;
  return GN(l) ? r[typeof l == "string" ? "string" : "hash"] : r.map;
}
function xN(i) {
  var l = yS(this, i).delete(i);
  return this.size -= l ? 1 : 0, l;
}
function HN(i) {
  return yS(this, i).get(i);
}
function YN(i) {
  return yS(this, i).has(i);
}
function XN(i, l) {
  var r = yS(this, i), o = r.size;
  return r.set(i, l), this.size += r.size == o ? 0 : 1, this;
}
function uT(i) {
  var l = -1, r = i == null ? 0 : i.length;
  for (this.clear(); ++l < r; ) {
    var o = i[l];
    this.set(o[0], o[1]);
  }
}
uT.prototype.clear = VN;
uT.prototype.delete = xN;
uT.prototype.get = HN;
uT.prototype.has = YN;
uT.prototype.set = XN;
function oM(i, l) {
  for (var r = -1, o = l.length, c = i.length; ++r < o; )
    i[c + r] = l[r];
  return i;
}
var lM = iM(Object.getPrototypeOf, Object);
function KN() {
  this.__data__ = new bs(), this.size = 0;
}
function jN(i) {
  var l = this.__data__, r = l.delete(i);
  return this.size = l.size, r;
}
function zN(i) {
  return this.__data__.get(i);
}
function JN(i) {
  return this.__data__.has(i);
}
var ZN = 200;
function QN(i, l) {
  var r = this.__data__;
  if (r instanceof bs) {
    var o = r.__data__;
    if (!Xd || o.length < ZN - 1)
      return o.push([i, l]), this.size = ++r.size, this;
    r = this.__data__ = new uT(o);
  }
  return r.set(i, l), this.size = r.size, this;
}
function TT(i) {
  var l = this.__data__ = new bs(i);
  this.size = l.size;
}
TT.prototype.clear = KN;
TT.prototype.delete = jN;
TT.prototype.get = zN;
TT.prototype.has = JN;
TT.prototype.set = QN;
function qN(i, l) {
  return i && LS(l, Zh(l), i);
}
function ey(i, l) {
  return i && LS(l, Qh(l), i);
}
var sM = typeof exports == "object" && exports && !exports.nodeType && exports, xm = sM && typeof module == "object" && module && !module.nodeType && module, ty = xm && xm.exports === sM, Hm = ty ? Go.Buffer : void 0, Ym = Hm ? Hm.allocUnsafe : void 0;
function ry(i, l) {
  if (l)
    return i.slice();
  var r = i.length, o = Ym ? Ym(r) : new i.constructor(r);
  return i.copy(o), o;
}
function ny(i, l) {
  for (var r = -1, o = i == null ? 0 : i.length, c = 0, T = []; ++r < o; ) {
    var d = i[r];
    l(d, r, i) && (T[c++] = d);
  }
  return T;
}
function aM() {
  return [];
}
var iy = Object.prototype, oy = iy.propertyIsEnumerable, Xm = Object.getOwnPropertySymbols, qh = Xm ? function(i) {
  return i == null ? [] : (i = Object(i), ny(Xm(i), function(l) {
    return oy.call(i, l);
  }));
} : aM;
function ly(i, l) {
  return LS(i, qh(i), l);
}
var sy = Object.getOwnPropertySymbols, _M = sy ? function(i) {
  for (var l = []; i; )
    oM(l, qh(i)), i = lM(i);
  return l;
} : aM;
function ay(i, l) {
  return LS(i, _M(i), l);
}
function cM(i, l, r) {
  var o = l(i);
  return jh(i) ? o : oM(o, r(i));
}
function _y(i) {
  return cM(i, Zh, qh);
}
function cy(i) {
  return cM(i, Qh, _M);
}
var $h = ec(Go, "DataView"), Wh = ec(Go, "Promise"), kh = ec(Go, "Set"), Km = "[object Map]", uy = "[object Object]", jm = "[object Promise]", zm = "[object Set]", Jm = "[object WeakMap]", Zm = "[object DataView]", Ty = q_($h), py = q_(Xd), dy = q_(Wh), Ey = q_(kh), Ay = q_(Ph), vs = _T;
($h && vs(new $h(new ArrayBuffer(1))) != Zm || Xd && vs(new Xd()) != Km || Wh && vs(Wh.resolve()) != jm || kh && vs(new kh()) != zm || Ph && vs(new Ph()) != Jm) && (vs = function(i) {
  var l = _T(i), r = l == uy ? i.constructor : void 0, o = r ? q_(r) : "";
  if (o)
    switch (o) {
      case Ty:
        return Zm;
      case py:
        return Km;
      case dy:
        return jm;
      case Ey:
        return zm;
      case Ay:
        return Jm;
    }
  return l;
});
var Sy = Object.prototype, hy = Sy.hasOwnProperty;
function my(i) {
  var l = i.length, r = new i.constructor(l);
  return l && typeof i[0] == "string" && hy.call(i, "index") && (r.index = i.index, r.input = i.input), r;
}
var Qm = Go.Uint8Array;
function em(i) {
  var l = new i.constructor(i.byteLength);
  return new Qm(l).set(new Qm(i)), l;
}
function Iy(i, l) {
  var r = l ? em(i.buffer) : i.buffer;
  return new i.constructor(r, i.byteOffset, i.byteLength);
}
var My = /\w*$/;
function gy(i) {
  var l = new i.constructor(i.source, My.exec(i));
  return l.lastIndex = i.lastIndex, l;
}
var qm = iT ? iT.prototype : void 0, eI = qm ? qm.valueOf : void 0;
function Ly(i) {
  return eI ? Object(eI.call(i)) : {};
}
function Ny(i, l) {
  var r = l ? em(i.buffer) : i.buffer;
  return new i.constructor(r, i.byteOffset, i.length);
}
var yy = "[object Boolean]", fy = "[object Date]", Cy = "[object Map]", vy = "[object Number]", Ry = "[object RegExp]", Oy = "[object Set]", Dy = "[object String]", by = "[object Symbol]", Py = "[object ArrayBuffer]", $y = "[object DataView]", Wy = "[object Float32Array]", ky = "[object Float64Array]", wy = "[object Int8Array]", Fy = "[object Int16Array]", By = "[object Int32Array]", Uy = "[object Uint8Array]", Vy = "[object Uint8ClampedArray]", Gy = "[object Uint16Array]", xy = "[object Uint32Array]";
function Hy(i, l, r) {
  var o = i.constructor;
  switch (l) {
    case Py:
      return em(i);
    case yy:
    case fy:
      return new o(+i);
    case $y:
      return Iy(i, r);
    case Wy:
    case ky:
    case wy:
    case Fy:
    case By:
    case Uy:
    case Vy:
    case Gy:
    case xy:
      return Ny(i, r);
    case Cy:
      return new o();
    case vy:
    case Dy:
      return new o(i);
    case Ry:
      return gy(i);
    case Oy:
      return new o();
    case by:
      return Ly(i);
  }
}
function Yy(i) {
  return typeof i.constructor == "function" && !zh(i) ? g4(lM(i)) : {};
}
var Xy = "[object Map]";
function Ky(i) {
  return cT(i) && vs(i) == Xy;
}
var tI = oT && oT.isMap, jy = tI ? Jh(tI) : Ky, zy = "[object Set]";
function Jy(i) {
  return cT(i) && vs(i) == zy;
}
var rI = oT && oT.isSet, Zy = rI ? Jh(rI) : Jy, Qy = 1, qy = 2, ef = 4, uM = "[object Arguments]", tf = "[object Array]", rf = "[object Boolean]", nf = "[object Date]", of = "[object Error]", TM = "[object Function]", lf = "[object GeneratorFunction]", sf = "[object Map]", af = "[object Number]", pM = "[object Object]", _f = "[object RegExp]", cf = "[object Set]", uf = "[object String]", Tf = "[object Symbol]", pf = "[object WeakMap]", df = "[object ArrayBuffer]", Ef = "[object DataView]", Af = "[object Float32Array]", Sf = "[object Float64Array]", hf = "[object Int8Array]", mf = "[object Int16Array]", If = "[object Int32Array]", Mf = "[object Uint8Array]", gf = "[object Uint8ClampedArray]", Lf = "[object Uint16Array]", Nf = "[object Uint32Array]", zt = {};
zt[uM] = zt[tf] = zt[df] = zt[Ef] = zt[rf] = zt[nf] = zt[Af] = zt[Sf] = zt[hf] = zt[mf] = zt[If] = zt[sf] = zt[af] = zt[pM] = zt[_f] = zt[cf] = zt[uf] = zt[Tf] = zt[Mf] = zt[gf] = zt[Lf] = zt[Nf] = !0;
zt[of] = zt[TM] = zt[pf] = !1;
function aS(i, l, r, o, c, T) {
  var d, h = l & Qy, y = l & qy, b = l & ef;
  if (d !== void 0)
    return d;
  if (!Oa(i))
    return i;
  var U = jh(i);
  if (U) {
    if (d = my(i), !h)
      return L4(i, d);
  } else {
    var Z = vs(i), le = Z == TM || Z == lf;
    if (tM(i))
      return ry(i, h);
    if (Z == pM || Z == uM || le && !c) {
      if (d = y || le ? {} : Yy(i), !h)
        return y ? ay(i, ey(d, i)) : ly(i, qN(d, i));
    } else {
      if (!zt[Z])
        return c ? i : {};
      d = Hy(i, Z, h);
    }
  }
  T || (T = new TT());
  var ue = T.get(i);
  if (ue)
    return ue;
  T.set(i, d), Zy(i) ? i.forEach(function(ae) {
    d.add(aS(ae, l, r, ae, i, T));
  }) : jy(i) && i.forEach(function(ae, Ne) {
    d.set(Ne, aS(ae, l, r, Ne, i, T));
  });
  var be = b ? y ? cy : _y : y ? Qh : Zh, Ke = U ? void 0 : be(i);
  return N4(Ke || i, function(ae, Ne) {
    Ke && (Ne = ae, ae = i[Ne]), JI(d, Ne, aS(ae, l, r, Ne, i, T));
  }), d;
}
var yf = 1, ff = 4;
function dM(i) {
  return aS(i, yf | ff);
}
var hh = function() {
  return Go.Date.now();
}, Cf = "Expected a function", vf = Math.max, Rf = Math.min;
function Of(i, l, r) {
  var o, c, T, d, h, y, b = 0, U = !1, Z = !1, le = !0;
  if (typeof i != "function")
    throw new TypeError(Cf);
  l = Wm(l) || 0, Oa(r) && (U = !!r.leading, Z = "maxWait" in r, T = Z ? vf(Wm(r.maxWait) || 0, l) : T, le = "trailing" in r ? !!r.trailing : le);
  function ue(Ze) {
    var Pt = o, wr = c;
    return o = c = void 0, b = Ze, d = i.apply(wr, Pt), d;
  }
  function be(Ze) {
    return b = Ze, h = setTimeout(Ne, l), U ? ue(Ze) : d;
  }
  function Ke(Ze) {
    var Pt = Ze - y, wr = Ze - b, xn = l - Pt;
    return Z ? Rf(xn, T - wr) : xn;
  }
  function ae(Ze) {
    var Pt = Ze - y, wr = Ze - b;
    return y === void 0 || Pt >= l || Pt < 0 || Z && wr >= T;
  }
  function Ne() {
    var Ze = hh();
    if (ae(Ze))
      return Fe(Ze);
    h = setTimeout(Ne, Ke(Ze));
  }
  function Fe(Ze) {
    return h = void 0, le && o ? ue(Ze) : (o = c = void 0, d);
  }
  function at() {
    h !== void 0 && clearTimeout(h), b = 0, o = y = c = h = void 0;
  }
  function dr() {
    return h === void 0 ? d : Fe(hh());
  }
  function er() {
    var Ze = hh(), Pt = ae(Ze);
    if (o = arguments, c = this, y = Ze, Pt) {
      if (h === void 0)
        return be(y);
      if (Z)
        return clearTimeout(h), h = setTimeout(Ne, l), ue(y);
    }
    return h === void 0 && (h = setTimeout(Ne, l)), d;
  }
  return er.cancel = at, er.flush = dr, er;
}
function Oi(i, l, r) {
  let o = Rl(l), c = ye(re.Warning_Param_NoDefine, [o]);
  r == Ht.OutVar ? i.appendDummyInput(o).appendField(c).appendField(new Vt({ name: o, type: "" }), o) : i.appendValueInput(o).appendField(c), i.setWarningText(c, "NODEF");
}
function dS(i, l, r, o, c, T) {
  let d = l.GetVarType(o.Type), h = d, y = Rl(c);
  const b = i.workspace.IsCraftland;
  let U = null, Z = i.paramInfo[y];
  if (Z) {
    let Ke = Z.inputType;
    Ke && (h = l.GetVarType(Ke)), Z.bShadow && (U = Z.block);
  } else
    U = J.internalBlocks.get(o.Type);
  h || (h = d);
  let le = Ht.InVar;
  (o.Main == "out" || r.Main == "event") && (le = Ht.OutVar), T == null && (T = o.Main == "out" ? Ht.OutVar : Ht.InVar);
  let ue = le != T, be;
  if (ue && (be = `Param "${o.Label}" in/out mismatch`, i.setWarningText(be, y)), r.Main == "event" || T == Ht.OutVar) {
    let Ke = i.appendDummyInput(y).appendField(new Vt({ name: o.Label, type: o.Type }), y);
    if (!b) {
      let ae = new X.FieldLabel(d.Label, ue ? "red-label" : void 0);
      Ke.appendField(ae, y + "L"), ae.setTooltip(be ?? o.Tip);
    }
  } else {
    let Ke = i.appendValueInput(y).appendField(new X.FieldLabel(o.Label, ue ? "red-label" : void 0)).setCheck(o.Type).setAlign(X.ALIGN_RIGHT);
    Ke.fieldRow[0].setTooltip(be ?? o.Tip), U || (U = EM(h, l, o.Type, Z)), li(Ke, U);
  }
}
function nI(i, l) {
  i.appendDummyInput("NEW_LINE_" + l);
}
function Ol(i, l = !1, r) {
  const o = ce.CurrentDescriptionFile;
  let c = "";
  if (i.Type) {
    let h = o.GetVarType(i.Type);
    h && (c = `
` + f.FunctionDefineReturn + " " + h.Label);
  }
  let T = i.m_ScriptName || i.Name;
  if (r !== void 0) {
    const h = J.graphElementMap.get(r);
    h != null && h.syntax_tooltip && (T = h.syntax_tooltip);
  }
  let d = i.Tip + c + `

${ye("FE_44_SD_TIPSFCG")}: ${T}`;
  return (l || i.m_ApiLevel < 4) && (d += `
--------------------------------------`, l && (d += `
` + ye("FE_42_HJ_BLOCKDESCINTERNAL")), i.m_ApiLevel < 4 && (d += `
` + ye("FE_42_HJ_BLOCKDESCTEST"))), d.trim();
}
const iI = "EVA_TITLE_INPUT", oI = "EVA_ASYNC_ICON_FIELD";
let Uo = {
  // actionType: '', // either be action/event/variable type
  // actionEnum: 0, // the id of it, we can result it to find a rename 
  paramInfo: {},
  paramOrder: [],
  paramOpers: [],
  // idx is orderId-1, orderId is paramOrder[index]
  ecatype: void 0,
  geId: 0,
  apiname: "",
  isDev: !1,
  useCustomTooltip: !1,
  action: null,
  fixOwnerType: null,
  // special event should fix owner type
  locKey: void 0,
  common_init() {
    this.appendDummyInput(iI).appendField("", E.Label), this.setInputsInline(!0), this.geId = 0;
  },
  getVarDefine(i, l, r) {
    if (this.action == null)
      return null;
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let o = this.action, c = 1;
      for (let T of o.Items) {
        let d = Rl(c);
        if (T.Main == "out" || o.Main == "event") {
          let h = lo(this, d, i, r);
          if (h)
            return h;
        }
        ++c;
      }
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  },
  UpdateDisplay() {
    if (this.geId) {
      let i = J.graphElementMap.get(this.geId);
      i && this.resolveApi(i.ref, i.ParsedParamOrder);
    } else
      this.apiname && this.resolveApi(this.apiname);
    this.updateTitle();
  },
  updateTitle() {
    this.action && this.updateTitle_(this.action.Label, this.action.m_ApiLevel);
  },
  syncAsyncIcon_() {
    var r;
    const i = this.getInput(iI);
    if (!i || !((r = this.action) != null && r.IsAsync))
      return;
    if (!i.fieldRow.some((o) => o.name === oI)) {
      const o = new N.FieldImage(vI, 20, 20, "async");
      o.setTooltip(ye("FE_53A_HZY_BLOCK_ASYNCHRONOUS")), i.insertFieldAt(0, o, oI);
    }
  },
  loadExtraState(i) {
    const l = this.workspace.IsCraftland;
    let r = i[E.Index], o = i[E.Type];
    this.apiname = o, this.paramOrder = i[E.ParamList], this.paramOpers = i[E.Operator] ?? [], this.paramInfo = {}, i[E.OwnerType] && (this.fixOwnerType = i[E.OwnerType]);
    let c = J.graphElementMap.get(r);
    c ? (this.geId = r, this.resolveApi(c.ref, c.ParsedParamOrder), this.setStyle(l ? c.block_style_cl : c.block_style), this.DetermineTypes = kI(c.fe_custom), this.isDev = c.dev_only, this.paramInfo = dM(c.ParsedParamInfo) ?? {}) : (this.geId = 0, this.resolveApi(o)), this.updateShape_();
  },
  saveExtraState() {
    var i;
    return {
      [E.Index]: this.geId,
      [E.ParamList]: this.paramOrder,
      [E.Operator]: this.paramOpers,
      [E.Type]: ((i = this.action) == null ? void 0 : i.Name) ?? this.apiname,
      [E.OwnerType]: this.fixOwnerType
    };
  },
  updateTitle_(i, l) {
    var r;
    l == 10 && (i += " " + f.Deprecated), this.isDev ? this.setFieldValue("*" + i, E.Label) : this.setFieldValue(i, E.Label), this.syncAsyncIcon_(), l < 4 && l != 0 && ((r = this.getField(E.Label)) == null || r.setClass("blocklyLowApiLevel")), l == 10 && this.setStyle("deprecated_blocks");
  },
  updateShape_() {
    for (let c = 1; c < 10; ++c)
      this.setWarningText(null, "P" + c);
    let i = ce.CurrentDescriptionFile, l = this.action;
    if (l == null) {
      let c = this.paramOrder;
      if (c) {
        let T = this.paramOpers;
        c.forEach((d, h) => {
          let y = T[h];
          this.ecatype === "event" && (y = Ht.OutVar), d === -1 ? nI(this, h) : Oi(this, d, y);
        });
      }
      return;
    }
    if (!this.useCustomTooltip) {
      const c = Ol(this.action, this.isDev, this.geId);
      this.setTooltip(c);
    }
    this.updateTitle(), this.ecatype === "valuation" && (this.setOutput(!0, l.Type), this.paramInfo.R = { inputType: l.Type });
    let r = this.paramOrder, o = this.paramOpers;
    if (r == null) {
      this.paramOrder = [];
      let c = 1;
      for (let T of l.Items) {
        this.paramOrder.push(c);
        let d = o[c - 1];
        this.ecatype === "event" && (d = Ht.OutVar), dS(this, i, l, T, c, d), c++;
      }
    } else
      r.forEach((c, T) => {
        if (c === -1)
          nI(this, T);
        else {
          let d = o[c - 1];
          this.ecatype === "event" && (d = Ht.OutVar);
          let h = l.Items.get_Item(c - 1);
          h == null ? Oi(this, c, d) : dS(this, i, l, h, c, d);
        }
      });
  },
  resolveApi(i, l) {
    let r = ce.CurrentDescriptionFile;
    if (this.locKey = `desc:${i}`, this.ecatype === "action")
      this.action = r.actions.map.get(i);
    else if (this.ecatype === "valuation")
      this.action = r.variables.map.get(i);
    else if (this.ecatype === "event") {
      let c = this.fixOwnerType ?? J.OwnerType ?? "Global";
      this.action = r.FindEventDefine(i, c), i != null && i.endsWith("receive") && !this.action && (this.action = r.FindEventDefine(i.substring(0, i.length - 7), c));
    } else if (this.ecatype === "signal") {
      let c = this.fixOwnerType ?? J.OwnerType ?? "Global";
      this.action = r.FindEventDefine(i, c);
    } else
      this.action = null;
    this.action && (this.locKey = `desc:${this.action.ScriptName}`);
    let o = this.paramOrder;
    if (o) {
      this.paramOrder = l == null ? void 0 : l.slice(), this.paramOrder == null && (this.paramOrder = []);
      for (let c of o)
        this.paramOrder.indexOf(c) == -1 && this.paramOrder.push(c);
    }
    if (this.action && this.paramOrder) {
      for (let c of this.paramOrder)
        if (this.paramOpers[c - 1] == null) {
          let T = Ht.InVar;
          if (this.ecatype == "event")
            T = Ht.OutVar;
          else {
            let d = this.action.Items.get_Item(c - 1);
            d && d.Main == "out" && (T = Ht.OutVar);
          }
          this.paramOpers[c - 1] = T;
        }
    }
    this.action == null ? (this.setWarningText(ye(re.Warning_NoDefine, [i]), "NODEF"), this.setFieldValue(ye(re.Warning_NoDefine, [i]), E.Label)) : this.action.m_ApiLevel >= 10 ? this.setWarningText(ye(re.Warning_Deprecated, [i]), "NODEF") : this.setWarningText(null, "NODEF");
  },
  compose(i) {
  },
  decompose(i) {
    return null;
  },
  search(i, l) {
    var d, h;
    let r = ce.CurrentDescriptionFile, o = (d = l.extraState) == null ? void 0 : d[E.Index], c = J.graphElementMap.get(o);
    if (c == null)
      return !1;
    let T;
    if (l.type == I.event || l.type == I.hud_buttonevent || l.type == I.hud_joystickevent) {
      const y = (h = l.extraState) != null && h[E.OwnerType] ? l.extraState[E.OwnerType] : J.OwnerType;
      T = r.FindEventDefine(c.ref, y);
    } else
      l.type == I.action ? T = r.actions.get_Item(c.ref) : l.type == I.valution && (T = r.variables.get_Item(c.ref));
    return T == null ? !1 : [T.Label, T.Name, T.ScriptName].find((y) => J.containsKey(y, i)) ?? !1;
  }
}, Df = {
  ...Uo,
  debugAvailable: !0,
  ecatype: "action",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.common_init();
  },
  onchange(i) {
    this.geId === 305 && bf();
  }
};
const bf = (i, l) => {
};
let Pf = {
  ...Uo,
  ecatype: "valuation",
  init() {
    this.setOutput(!0), this.common_init(), this.DetermineTypes && this.DetermineTypes();
  }
}, $f = {
  ...Uo,
  ecatype: "event",
  init() {
    this.hat = "cap", this.common_init(), this.setNextStatement(!0, "action");
  }
};
function EM(i, l, r, o) {
  let c = I.shadow_type, T, d;
  if (i.IsEnum)
    c = I.input_enum, T = i.Name;
  else if (i == l.boolType)
    c = I.input_boolean;
  else if (i == l.intType)
    c = I.input_int, o && o.defaultValue && (d = {
      [E.Value]: parseInt(o.defaultValue)
    });
  else if (i == l.floatType)
    c = I.input_float;
  else if (i == l.stringType)
    c = I.input_text;
  else if (i == l.numberType)
    c = I.input_number;
  else if (i == l.vector3Type)
    c = I.input_vector3;
  else if (i.Name == "Color")
    c = I.input_color;
  else if (Vn.CheckIsAssignable(l.typeType, i, l)) {
    for (let h of l.enumTypes)
      if (h.Type == i.Name) {
        c = I.input_enum, T = h.Name;
        break;
      }
    T ?? (T = r);
  } else
    T = r;
  return {
    type: c,
    extraState: T,
    fields: d
  };
}
var ES;
((i) => {
  i.MAIN_SCENE_CHANGE = "main_scene_change";
  class l extends N.Events.Abstract {
    constructor() {
      super();
      C(this, "isBlank", !0);
      this.type = i.MAIN_SCENE_CHANGE;
    }
  }
  i.MainSceneChange = l;
})(ES || (ES = {}));
N.registry.register(
  N.registry.Type.EVENT,
  ES.MAIN_SCENE_CHANGE,
  ES.MainSceneChange
);
function Wf(i) {
  N.Blocks[I.action] = Df, N.Blocks[I.valution] = Pf, N.Blocks[I.event] = $f;
}
let kf = {
  debugAvailable: !0,
  IsLoop: !0,
  geId: I.loop_while,
  locKey: re.While,
  init() {
    this.setInputsInline(!0), this.setStyle("logic_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), li(
      this.appendValueInput(E.Condition).appendField(f.While).setCheck("bool"),
      Xe("bool")
    ), this.appendStatementInput(E.Code);
  },
  search(i, l) {
    return ["while", f.While].find((r) => J.containsKey(r, i)) || !1;
  }
}, AM = {
  IsLoop: !0,
  getVarDefine(i, l, r) {
    if (l == bt.ChildStatements || l == bt.SelfDefine)
      return lo(this, E.Index, i, r) ?? lo(this, E.Item, i, r);
    if (l == bt.NextStatements)
      return so(this, i, r);
  }
}, wf = {
  ...AM,
  debugAvailable: !0,
  geId: I.loop_forindex,
  locKey: re.ForIndex,
  init() {
    const i = this.workspace.IsCraftland;
    this.setInputsInline(!0), this.setStyle("logic_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendDummyInput().appendField(this.workspace.IsCraftland ? ye("T_34_WZ_WS_LOGIC6_NAME") : f.ForIndex), this.appendDummyInput(E.Index).conditionAppendField(i, "Index name").appendField(new Vt({ name: "i", type: "int" }), E.Index), this.appendValueInput(E.From).appendField(i ? ye("T_34_WZ_WS_LOGIC6_PARAM2_NAME") : f.ForIndex_1).setCheck("number").setAlign(X.ALIGN_RIGHT), this.appendValueInput(E.To).appendField(i ? ye("T_34_WZ_WS_LOGIC6_PARAM3_NAME") : f.ForIndex_2).setCheck("number").setAlign(X.ALIGN_RIGHT), this.appendValueInput(E.Step).appendField(i ? ye("T_34_WZ_WS_LOGIC6_PARAM4_NAME") : f.ForIndex_3).setCheck("number").setAlign(X.ALIGN_RIGHT), this.appendStatementInput(E.Code);
  },
  search(i, l) {
    return ["for", f.ForIndex].find((r) => J.containsKey(r, i)) || !1;
  }
}, Ff = {
  ...AM,
  debugAvailable: !0,
  geId: I.loop_foreach,
  locKey: re.Foreach,
  init() {
    const i = this.workspace.IsCraftland;
    this.setInputsInline(!0), this.setStyle("logic_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendDummyInput().appendField(this.workspace.IsCraftland ? f.Foreach_craftland : f.Foreach), this.appendDummyInput(E.Index).conditionAppendField(i, "Index name").appendField(new Vt({ name: i ? "Index name" : "key" }), E.Index).appendField("", E.T1), this.appendDummyInput().conditionAppendField(i, ye("T_34_WZ_WS_LOGIC7_PARAM1_NAME")).appendField(new Vt({ name: i ? ye("T_34_WZ_WS_LOGIC7_PARAM1_NAME") : "value" }), E.Item).appendField("", E.Type), li(
      this.appendValueInput(E.Range).appendField(i ? ye("T_34_WZ_WS_LOGIC7_PARAM3_NAME") : f.Foreach_2).setCheck("List|Map").setAlign(X.ALIGN_RIGHT),
      Xe(`List|Map__${ye("T_40_XXJ_WS_DICTANDLIST")}`)
    ), this.appendStatementInput(E.Code);
  },
  search(i, l) {
    return ["foreach", f.Foreach].find((r) => J.containsKey(r, i)) || !1;
  },
  DetermineTypes() {
    var d, h;
    let i = this.getInputTargetBlock(E.Range), l = this.getField(E.Index), r = this.getField(E.Item), o, c;
    if (i != null) {
      let y = i.outputConnection.getCheck();
      if (y && y.length >= 1) {
        let b = ce.CurrentDescriptionFile, U = b.GetVarType(y[0]), Z = b.GetVarType("Map");
        U && b.IsArray(U) ? (o = b.intType, c = b.GetVarType(U.ElementType)) : U && (U === Z || U.Bases.Contains(Z.Name)) && (o = b.GetVarType((d = U.ElementTypes) == null ? void 0 : d[0]) ?? b.anyType, c = b.GetVarType((h = U.ElementTypes) == null ? void 0 : h[1]) ?? b.anyType);
      }
    }
    let T = N.Events.getRecordUndo();
    N.Events.setRecordUndo(!1);
    try {
      o ? (l.setValue({ type: o.Name }), this.setFieldValue(o.Label, E.T1)) : (l.setValue({ type: "" }), this.setFieldValue("", E.T1)), c ? (r.setValue({ type: c.Name }), this.setFieldValue(c.Label, E.Type)) : (r.setValue({ type: "" }), this.setFieldValue("", E.Type));
    } finally {
      T && N.Events.setRecordUndo(T);
    }
  }
}, SM = {
  onchange(i) {
    let l = this.workspace;
    if (l.isDragging && l.isDragging())
      return;
    if (i.type == X.Events.BLOCK_MOVE) {
      let o = !1, c = this;
      do {
        if (c.IsLoop) {
          o = !0;
          break;
        }
        c = c.getSurroundParent();
      } while (c);
      o ? this.setWarningText(null, "LOOP") : this.setWarningText(N.Msg.CONTROLS_FLOW_STATEMENTS_WARNING, "LOOP");
    }
  }
}, Bf = {
  ...SM,
  debugAvailable: !0,
  geId: I.loop_break,
  locKey: re.Break,
  init() {
    this.setStyle("logic_blocks"), this.setPreviousStatement(!0), this.appendDummyInput().appendField(f.Break);
  },
  search(i, l) {
    return ["break", f.Break].find((r) => J.containsKey(r, i)) || !1;
  }
}, Uf = {
  ...SM,
  debugAvailable: !0,
  geId: I.loop_continue,
  locKey: re.Continue,
  init() {
    this.setStyle("logic_blocks"), this.setPreviousStatement(!0), this.appendDummyInput().appendField(f.Continue);
  },
  search(i, l) {
    return ["continue", f.Continue].find((r) => J.containsKey(r, i)) || !1;
  }
};
function Vf(i) {
  N.Blocks[I.loop_while] = kf, N.Blocks[I.loop_forindex] = wf, N.Blocks[I.loop_foreach] = Ff, N.Blocks[I.loop_break] = Bf, N.Blocks[I.loop_continue] = Uf, i.set("loop_while", { kind: "block", type: I.loop_while }), i.set("loop_forindex", {
    kind: "block",
    type: I.loop_forindex,
    inputs: {
      [E.From]: { shadow: { type: I.input_int, fields: { [E.Value]: 0 } } },
      [E.To]: { shadow: { type: I.input_int, fields: { [E.Value]: 10 } } },
      [E.Step]: { shadow: { type: I.input_int, fields: { [E.Value]: 1 } } }
    }
  }), i.set("loop_foreach", { kind: "block", type: I.loop_foreach }), i.set("loop_break", { kind: "block", type: I.loop_break }), i.set("loop_continue", { kind: "block", type: I.loop_continue });
}
var no;
((i) => {
  class l extends N.Events.Abstract {
    constructor(h, y) {
      super();
      C(this, "varId");
      C(this, "isBlank", !0);
      this.isBlank = typeof h > "u", this.varId = this.isBlank ? "" : h.id, this.workspaceId = this.isBlank ? "" : y;
    }
  }
  i.GraphVarBase = l, i.GRAPHVAR_EDIT = "graphvar_rename", i.GRAPHVAR_CREATE = "graphvar_create", i.GRAPHVAR_DELETE = "graphvar_delete", i.CUSTOM_BLOCK_DEFINE_DELETE = "block_define_delete";
  class r extends l {
    constructor(h, y, b, U, Z) {
      super(y, h);
      C(this, "oldName");
      C(this, "newName");
      C(this, "oldType");
      C(this, "newType");
      C(this, "oldValue");
      C(this, "newValue");
      this.type = i.GRAPHVAR_EDIT, b !== void 0 && (this.oldName = y.name), U !== void 0 && (this.oldType = y.type), Z !== void 0 && (this.oldValue = JSON.stringify(y.value)), this.newName = b, this.newType = U, this.newValue = JSON.stringify(Z);
    }
    /**
     * Encode the event as JSON.
     * @return {!Object} JSON representation.
     */
    toJson() {
      let h = super.toJson();
      return h.oldName = this.oldName, h.newName = this.newName, h.oldType = this.oldType, h.newType = this.newType, h.oldValue = this.oldValue, h.newValue = this.newValue, h;
    }
    /**
     * Decode the JSON event.
     * @param {!Object} json JSON representation.
     */
    fromJson(h) {
      this.isBlank = !1, this.group = h.group, this.oldName = h.oldName, this.newName = h.newName, this.oldType = h.oldType, this.newType = h.newType, this.oldValue = h.oldValue, this.newValue = h.newValue;
    }
    run(h) {
      const y = this.getEventWorkspace_();
      if (h) {
        let b;
        this.newValue && (b = JSON.parse(this.newValue)), Cn.Get(y).edit(this.varId, this.newName, this.newType, b);
      } else {
        let b;
        this.newValue && (b = JSON.parse(this.oldValue)), Cn.Get(y).edit(this.varId, this.oldName, this.oldType, b);
      }
    }
  }
  i.GraphVarEdit = r;
  class o extends l {
    constructor(h, y) {
      super(y, h);
      C(this, "varName");
      C(this, "varType");
      C(this, "varValue");
      this.type = i.GRAPHVAR_CREATE, this.varName = y.name, this.varType = y.type, this.varValue = JSON.stringify(y.value);
    }
    /**
     * Encode the event as JSON.
     * @return {!Object} JSON representation.
     */
    toJson() {
      let h = super.toJson();
      return h.varName = this.varName, h.varType = this.varType, h.varValue = this.varValue, h;
    }
    /**
     * Decode the JSON event.
     * @param {!Object} json JSON representation.
     */
    fromJson(h) {
      this.isBlank = !1, this.group = h.group, this.varName = h.varName, this.varType = h.varType, this.varValue = h.varValue;
    }
    run(h) {
      const y = this.getEventWorkspace_();
      if (h) {
        let b = null;
        this.varValue && (b = JSON.parse(this.varValue)), Cn.Get(y).createWithId(this.varId, this.varName, this.varType, b);
      } else
        Cn.Get(y).delete(this.varId);
    }
  }
  i.GraphVarCreate = o;
  class c extends l {
    constructor(h, y) {
      super(y, h);
      C(this, "varName");
      C(this, "varType");
      C(this, "varValue");
      this.type = i.GRAPHVAR_DELETE, this.varName = y.name, this.varType = y.type, this.varValue = JSON.stringify(y.value);
    }
    /**
     * Encode the event as JSON.
     * @return {!Object} JSON representation.
     */
    toJson() {
      let h = super.toJson();
      return h.varName = this.varName, h.varType = this.varType, h.varValue = this.varValue, h;
    }
    /**
     * Decode the JSON event.
     * @param {!Object} json JSON representation.
     */
    fromJson(h) {
      this.isBlank = !1, this.group = h.group, this.varName = h.varName, this.varType = h.varType, this.varValue = h.varValue;
    }
    run(h) {
      const y = this.getEventWorkspace_();
      if (h)
        Cn.Get(y).delete(this.varId);
      else {
        let b = null;
        this.varValue && (b = JSON.parse(this.varValue)), Cn.Get(y).createWithId(this.varId, this.varName, this.varType, b);
      }
    }
  }
  i.GraphVarDelete = c;
})(no || (no = {}));
class Cn {
  constructor() {
    C(this, "variables", /* @__PURE__ */ new Map());
    C(this, "workspace");
    C(this, "encStr", "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  }
  getByName(l) {
    for (let [r, o] of this.variables)
      if (o.name == l)
        return o;
    return null;
  }
  get(l) {
    return this.variables.get(l);
  }
  createWithId(l, r, o, c) {
    return this.get(l) != null ? (console.warn("create with duplicated id"), null) : this.getByName(r) ? (console.error("create with duplicated name"), null) : this._create(l, r, o, c);
  }
  create(l, r, o) {
    if (l = l.trim(), this.getByName(l))
      return console.error("create with duplicated name"), null;
    let c = this.encStr.length, T = "v";
    for (let d = 0; d < 8; ++d)
      T += this.encStr[Math.floor(Math.random() * c)];
    for (; this.variables.has(T); )
      T += this.encStr[Math.floor(Math.random() * c)];
    return this._create(T, l, r, o);
  }
  _create(l, r, o, c) {
    let T = {
      id: l,
      name: r,
      type: o,
      value: c
    }, d = new (N.Events.get(no.GRAPHVAR_CREATE))(this.workspace.id, T);
    return N.Events.fire(d), this.variables.set(l, T), T;
  }
  edit(l, r, o, c) {
    let T = this.get(l);
    if (T == null)
      return;
    let d = new (N.Events.get(no.GRAPHVAR_EDIT))(this.workspace.id, T, r, o, c);
    N.Events.fire(d), r !== void 0 && (T.name = r), o !== void 0 && (T.type = o), c !== void 0 && (T.value = c);
  }
  delete(l) {
    let r = this.get(l);
    if (r) {
      let o = new (N.Events.get(no.GRAPHVAR_DELETE))(this.workspace.id, r);
      N.Events.fire(o), this.variables.delete(l);
    }
  }
  clear() {
    this.variables.clear();
  }
  static Get(l) {
    let r = l, o = r.graphVariables;
    return o instanceof Cn ? o : r.targetWorkspace ? Cn.Get(r.targetWorkspace) : (o = new Cn(), r.graphVariables = o, o.workspace = l, o);
  }
  static Set(l, r) {
    let o = l;
    o.graphVariables = r;
  }
}
N.utils.xml;
class fS extends Gn {
  constructor(r, o, c) {
    super(X.Field.SKIP_SETUP);
    C(this, "variable_");
    this.menuGenerator_ = fS.dropdownCreate, r !== X.Field.SKIP_SETUP && (c && this.configure_(c), o && this.setValidator(o));
  }
  getVariable() {
    return this.variable_;
  }
  getText() {
    return this.variable_ ? this.variable_.name : "";
  }
  static dropdownCreate() {
    var T;
    let r = ce.CurrentDescriptionFile, o = (T = this.getSourceBlock()) == null ? void 0 : T.workspace;
    const c = [];
    if (o != null) {
      let d = Cn.Get(o).variables;
      for (let [h, y] of d) {
        let b = r.GetVarType(y.type), U = b ? b.Label : y.type;
        c.push(
          [y.name + " : " + U, y.id]
        );
      }
    }
    return c.length == 0 && c.push([f.Unselected, "", "", { style: "fill: var(--red_err5);" }]), c;
  }
  /**
   * Update the value of this variable field, as well as its variable and text.
   *
   * The variable ID should be valid at this point, but if a variable field
   * validator returns a bad ID, this could break.
   * @param {*} newId The value to be saved.
   * @protected
   */
  doValueUpdate_(r) {
    this.variable_ = Cn.Get(this.sourceBlock_.workspace).get(r), super.doValueUpdate_(r);
  }
  referencesVariables() {
    return !0;
  }
  refreshVariableName() {
    this.forceRerender();
  }
}
const hM = {
  /**
   * Add menu option to create getter/setter block for this setter/getter.
   * @param {!Array} options List of menu options to add to.
   * @this {Block}
   */
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     // Getter blocks have the option to create a setter block, and vice versa.
  //     if(!this.isEditable()) return options;
  //     if (!this.isInFlyout) {
  //         let oppositeType;
  //         let contextMenuMsg;
  //         const id = this.getFieldValue(SerializeKeys.VarRef);
  //         const varInfo = GraphVars.Get(this.workspace).get(id);
  //         if (!varInfo) {
  //             return options;
  //         }
  //         const varType = varInfo.type;
  //         if (this.type === BlockTypes.graphvar_get) {
  //             oppositeType = BlockTypes.graphvar_set;
  //             contextMenuMsg = Msg['VARIABLES_GET_CREATE_SET'];
  //         } else {
  //             oppositeType = BlockTypes.graphvar_get;
  //             contextMenuMsg = Msg['VARIABLES_SET_CREATE_GET'];
  //         }
  //         const name = this.getField(SerializeKeys.VarRef).getText();
  //         const xmlField = xml.createElement('field');
  //         xmlField.setAttribute('name', SerializeKeys.VarRef);
  //         xmlField.setAttribute('variabletype', varType);
  //         xmlField.appendChild(xml.createTextNode(id));
  //         const xmlBlock = xml.createElement('block');
  //         xmlBlock.setAttribute('type', oppositeType);
  //         xmlBlock.appendChild(xmlField);
  //         options.push({
  //             enabled: this.workspace.remainingCapacity() > 0,
  //             text: contextMenuMsg.replace('%1', name),
  //             callback: ContextMenu.callbackFactory(this, xmlBlock),
  //         });
  //     } else {
  //         const searchOption = {
  //             text: $t('FE_44_HZY_SEARCH_VARIABLENAME'),
  //             enabled: true,
  //             callback: () => {
  //                 const name = (this.getField(SerializeKeys.VarRef) as FieldGraphVar)?.getVariable()?.name;
  //                 if(name) {
  //                     const cm = GModuleManager.Get(ICommandModule);
  //                     cm.Send(ECommandActionIds.toolbar_logic_search, name);
  //                 }
  //             }
  //         };
  //         options.splice(1, 0, searchOption);
  //         //if (this.type === BlockTypes.graphvar_set) {
  //             const renameOption = {
  //                 text: $t('FE_0_B_WORK_EDIT_VARIABLE'),
  //                 enabled: true,
  //                 callback: renameOptionCallbackFactory(this),
  //             };
  //             const name = this.getField(SerializeKeys.VarRef).getText();
  //             const deleteOption = {
  //                 text: Msg['DELETE_VARIABLE'].replace('%1', name),
  //                 enabled: true,
  //                 callback: deleteOptionCallbackFactory(this),
  //             };
  //             options.unshift(renameOption);
  //             options.unshift(deleteOption);
  //        // }
  //     }
  // },
  /**
   * Called whenever anything on the workspace changes.
   * Set the connection type for this block.
   * @param {AbstractEvent} _e Change event.
   * @this {Block}
   */
  onchange(i) {
    if (i instanceof no.GraphVarBase) {
      let l = Da(i);
      try {
        aT(this);
      } finally {
        l.Leave();
      }
    }
  },
  DetermineTypes() {
    const i = this.getFieldValue(E.VarRef), l = Cn.Get(this.workspace).get(i);
    l == null ? this.setWarningText(ye(re.Warning_NoDefine, [i]), "NODEF") : this.setWarningText(null, "NODEF");
    const r = (l == null ? void 0 : l.type) ?? "";
    if (this.type === I.graphvar_get) {
      let c = this.outputConnection.getCheck(), T = null;
      if (c && c.length == 1 && (T = c[0]), T != r)
        return this.outputConnection.setCheck(r), !0;
      var o = this.getField(E.VarRef);
      o.refreshVariableName();
    } else if (this.type === I.graphvar_set) {
      let c = this.getInput(E.Value);
      sn(c, r);
      var o = this.getField(E.VarRef);
      o.refreshVariableName();
      const d = this.getField(E.Operator);
      d && d.opType !== r && (d.setOpType(r), d.UpdateDisplay());
    }
  },
  initToolTip() {
    this.setTooltip(() => "");
  }
};
let Gf = {
  ...hM,
  geId: I.graphvar_get,
  locKey: re.GetVar,
  init() {
    this.setInputsInline(!0), this.inputsInlineDefault = !0, this.setStyle("var_blocks"), this.appendDummyInput().appendField(new fS("item"), E.VarRef), this.setOutput(!0), this.initToolTip();
  },
  search(i, l, r, o) {
    return !1;
  }
}, xf = {
  ...hM,
  debugAvailable: !0,
  geId: I.graphvar_set,
  locKey: re.SetVar,
  init() {
    this.setInputsInline(!0), this.inputsInlineDefault = !0, this.setStyle("var_blocks"), this.appendValueInput(E.Value).appendField(f.SetVar).appendField(new fS("item"), E.VarRef).appendField(new Hd(), E.Operator).connection.setShadowState(Xe("")), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.initToolTip();
  },
  search(i, l, r, o) {
    return !1;
  }
};
function Hf(i) {
  N.Blocks[I.graphvar_get] = Gf, N.Blocks[I.graphvar_set] = xf, i.set("graphvar_def", {
    kind: "customButton",
    text: ye("FE_0_HW_WORK_CREATE_VARIABLE"),
    background: {
      show: !0,
      rx: 0,
      ry: 0,
      borderWidth: 1
    },
    callbackKey: "CREATE_GRAPH_VAR"
  }), i.set("graphvar_get", { kind: "block", type: I.graphvar_get }), i.set("graphvar_set", { kind: "block", type: I.graphvar_set });
}
class Yf {
  constructor() {
    C(this, "priority", 99);
  }
  save(l) {
    let r = Cn.Get(l);
    if (r) {
      const o = [];
      for (const [c, T] of r.variables)
        o.push(T);
      return o.length ? o : null;
    }
  }
  /**
   * Deserializes the variable defined by the given state into the given
   * workspace.
   * @param {!Array<!State>} state The state of the variables to deserialize.
   * @param {!Workspace} workspace The workspace to deserialize into.
   */
  load(l, r) {
    let o = Cn.Get(r);
    for (const c of l) {
      let T = {
        id: c.id,
        name: c.name,
        type: c.type,
        value: c.value
      };
      o.variables.set(T.id, T);
    }
  }
  /**
   * Disposes of any variables that exist on the workspace.
   * @param {!Workspace} workspace The workspace to clear the variables of.
   */
  clear(l) {
    Cn.Get(l).clear();
  }
}
N.serialization.registry.unregister("variables");
N.serialization.registry.register("variables", new Yf());
N.registry.register(N.registry.Type.EVENT, no.GRAPHVAR_EDIT, no.GraphVarEdit);
N.registry.register(N.registry.Type.EVENT, no.GRAPHVAR_CREATE, no.GraphVarCreate);
N.registry.register(N.registry.Type.EVENT, no.GRAPHVAR_DELETE, no.GraphVarDelete);
class Xf {
  constructor() {
    C(this, "isDisposed", !1);
    C(this, "disposableObjectCollection");
    AS.Add(this);
  }
  CollectDisposalObject(l) {
    this.disposableObjectCollection || (this.disposableObjectCollection = new Kf()), this.disposableObjectCollection.Collect(l);
  }
  IsDisposed() {
    return this.isDisposed;
  }
  Dispose() {
    this.isDisposed || (this.isDisposed = !0, AS.Remove(this), this.disposableObjectCollection && this.disposableObjectCollection.Dispose());
  }
}
class Kf {
  constructor() {
    C(this, "isDisposed", !1);
    C(this, "disposableObjs");
    AS.Add(this);
  }
  Collect(l) {
    if (l) {
      if (this.disposableObjs || (this.disposableObjs = /* @__PURE__ */ new Set()), this.isDisposed) {
        console.error("try to add a disposable object into disposed collection");
        return;
      }
      this.disposableObjs.add(l);
    }
  }
  Dispose() {
    if (!this.isDisposed && (AS.Remove(this), this.isDisposed = !0, !!this.disposableObjs)) {
      for (let l of this.disposableObjs)
        l.Dispose();
      this.disposableObjs.clear();
    }
  }
}
class jf {
  constructor() {
    C(this, "comp", new Xf());
  }
  CollectDisposalObject(l) {
    this.comp.CollectDisposalObject(l);
  }
  IsDisposed() {
    return this.comp.IsDisposed();
  }
  Dispose() {
    this.IsDisposed() || (this.comp.Dispose(), this.OnDispose());
  }
  OnDispose() {
  }
}
const AS = new class {
  // private trackedOrder = new UniqueIDGen();
  //private trackedObjects = new Map<IDisposableObject, TrackInfo>();
  Add(i) {
  }
  Remove(i) {
  }
  // public CheckLeak() {
  //     console.log(`------------------ LEAK REPORT BEGIN (${this.trackedObjects.size})------------------`);
  //     let index = 0;
  //     let trackedList = new Array<TrackInfo>(this.trackedObjects.size);
  //     this.trackedObjects.forEach((v, k) => {
  //         trackedList[index] = v;
  //         index++;
  //     });
  //     trackedList.sort((a, b) => {
  //         return a.order < b.order ? -1 : 1;
  //     });
  //     for (let i = 0; i < trackedList.length; ++i) {
  //         console.log(trackedList[i].obj);
  //         console.log(`[@${i} #${trackedList[i].order} callstack]: \n${trackedList[i].stack}`);
  //     }
  //     console.log(`------------------ LEAK REPORT END (${this.trackedObjects.size})------------------`);
  // }
}(), zf = new class extends jf {
  constructor() {
    super(...arguments);
    C(this, "_Mods", /* @__PURE__ */ new Map());
  }
  Register(l, r) {
    this._Mods.has(l) || (this._Mods.set(l, r), this.CollectDisposalObject(r));
  }
  Get(l) {
    return this._Mods.get(l);
  }
  OnDispose() {
    this._Mods.forEach((l, r) => {
      l.Dispose();
    }), this._Mods.clear();
  }
}();
let mh = /* @__PURE__ */ new Map();
function Jf(i) {
  if (mh.has(i))
    return mh.get(i);
  const l = function() {
  };
  return l.toString = () => i, mh.set(i, l), l;
}
const Zf = Jf("reserved.mod.project"), lI = N.utils.Svg;
class Yt extends X.Field {
  constructor(r, o, c) {
    super("", o, c);
    C(this, "SERIALIZABLE", !0);
    /** Tspan based arrow element. */
    C(this, "arrow_", null);
    /** SVG based arrow element. */
    C(this, "svgArrow_", null);
    // TODO: we may display image
    C(this, "imageElement_", null);
    C(this, "resourceType");
    C(this, "subinfo");
    C(this, "defaultLabel", "");
    C(this, "nullable", !1);
    C(this, "resourceNotFound", !1);
    C(this, "previousText");
    this.resourceType = r.type, this.defaultLabel = r.defaultLabel, this.subinfo = r.subinfo, this.nullable = r.nullable || !1;
  }
  SetSubInfo(r, o) {
    this.subinfo = r, o != null && (this.defaultLabel = o);
  }
  get SubInfo() {
    return this.subinfo;
  }
  initView() {
    this.shouldAddBorderRect_() ? this.createBorderRect_() : this.clickTarget_ = this.getSvgRoot(), this.createTextElement_(), this.imageElement_ = N.utils.dom.createSvgElement(lI.IMAGE, {}, this.fieldGroup_), this.createSVGSelector_(), this.borderRect_ && N.utils.dom.addClass(this.borderRect_, "blocklyDropdownRect");
  }
  UpdateDisplay() {
    this.previousText !== this.getText_() && (this.markDirty(), this.forceRerender());
  }
  /** Draws the border with the correct width. */
  render_() {
    this.getTextContent().nodeValue = "", this.imageElement_.style.display = "none", this.renderSelectedText_(), this.positionBorderRect_();
  }
  /** Renders the selected option, which must be text. */
  renderSelectedText_() {
    this.getTextContent().nodeValue = this.getDisplayText_();
    const r = this.getTextElement();
    N.utils.dom.addClass(r, "blocklyDropdownText"), r.setAttribute("text-anchor", "start"), r.setAttribute("style", this.resourceNotFound ? "fill: var(--red_err5)" : "");
    const o = !!this.borderRect_, c = Math.max(
      o ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0,
      this.getConstants().FIELD_TEXT_HEIGHT
    ), T = N.utils.dom.getFastTextWidth(
      this.getTextElement(),
      this.getConstants().FIELD_TEXT_FONTSIZE,
      this.getConstants().FIELD_TEXT_FONTWEIGHT,
      this.getConstants().FIELD_TEXT_FONTFAMILY
    ), d = o ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
    let h = 0;
    this.svgArrow_ && (h = this.positionSVGArrow_(
      T + d,
      c / 2 - this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE / 2
    )), this.size_.width = T + h + d * 2, this.size_.height = c, this.positionTextElement_(d, T);
  }
  /**
   * Position a drop-down arrow at the appropriate location at render-time.
   *
   * @param x X position the arrow is being rendered at, in px.
   * @param y Y position the arrow is being rendered at, in px.
   * @returns Amount of space the arrow is taking up, in px.
   */
  positionSVGArrow_(r, o) {
    if (!this.svgArrow_)
      return 0;
    const T = !!this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0, d = this.getConstants().FIELD_DROPDOWN_SVG_ARROW_PADDING, h = this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE, y = this.getSourceBlock().RTL ? T : r + d;
    return this.svgArrow_.setAttribute(
      "transform",
      "translate(" + y + "," + o + ")"
    ), h + d;
  }
  createSVGSelector_() {
    this.svgArrow_ = N.utils.dom.createSvgElement(
      lI.IMAGE,
      {
        height: this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE + "px",
        width: this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_SIZE + "px"
      },
      this.fieldGroup_
    ), this.svgArrow_.setAttributeNS(
      N.utils.dom.XLINK_NS,
      "xlink:href",
      this.getConstants().FIELD_RESOURCE_SELECTOR_SVG_DATAURI
    );
  }
  getTextElement() {
    return this.textElement_;
  }
  getTextContent() {
    return this.textContent_;
  }
  getText_() {
    this.previousText = this.defaultLabel;
    let r = this.value_;
    if (this.resourceNotFound = !this.nullable, !r)
      return this.defaultLabel;
    this.resourceNotFound = !1;
    let c = zf.Get(Zf).FindGFile(r);
    if (c && c.treeViewData) {
      let T = ye(c.treeViewData.name);
      return this.previousText = T, T;
    }
    return this.resourceNotFound = !0, this.previousText = r, r;
  }
  shouldAddBorderRect_() {
    let r = !this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW || this.getConstants().FIELD_DROPDOWN_NO_BORDER_RECT_SHADOW && !this.getSourceBlock().isShadow(), o = 0;
    for (let c = 0, T; T = this.getSourceBlock().inputList[c]; c++) {
      for (let d = 0; T.fieldRow[d]; d++)
        if (T.fieldRow[d].EDITABLE && o++, o >= 2)
          return !0;
      if (T.connection)
        return !0;
    }
    return r;
  }
  showEditor_(r) {
    J.func_showResourceSelector && J.func_showResourceSelector(this.getValue(), {
      type: this.resourceType,
      info: this.subinfo,
      onChange: (o) => {
      }
    });
  }
  applyColour() {
    const r = this.sourceBlock_.style;
    this.borderRect_ && (this.borderRect_.setAttribute("stroke", r.colourTertiary), this.borderRect_.setAttribute("fill", "transparent"));
  }
  refreshText() {
    var r;
    ((r = this.textContent_) == null ? void 0 : r.nodeValue) !== this.getDisplayText_() && this.forceRerender();
  }
}
let mM = X.BlockSvg.prototype.setShadow;
function Qf(i, l) {
  let r = J.func_entityPickList;
  return r ? r(i, l) : [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
class qf extends Gn {
  constructor(l, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], l, r), this.menuGenerator_ = () => {
      let o = this.sourceBlock_.getFieldValue(E.Hud);
      return Qf(o, "Component");
    };
  }
  getValueDefaultOptions(l) {
    return this.sourceBlock_ == null ? [l, l] : [l + f.UnkownType, l, "", { style: "fill: var(--red_err5);" }];
  }
}
let eC = {
  geId: I.pick_entity,
  locKey: re.PickEntity,
  init() {
    this.appendDummyInput().appendField(f.PickEntity, E.Label).appendField(new Yt({ type: "GFileType", subinfo: "scene", defaultLabel: f.SceneFile }), E.Hud).appendField(new qf(), E.Entity).appendField(new X.FieldImage(Hh, 20, 20, "pick", (i) => rC(this))), this.setOutput(!0), Fd && Fd.block_style ? this.setStyle(Fd.block_style) : this.setStyle("module_blocks");
  },
  setShadow(i) {
    mM.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
  },
  DetermineTypes() {
    let i = this.outputConnection.getCheck(), l = null;
    i && i.length == 1 && (l = i[0]);
    let r = this.getFieldValue(E.Hud);
    if (!r && J.SceneName) {
      const d = `${J.SceneName}.scene`, y = [].find((b) => b.name === d);
      y && (r = y.id, this.setFieldValue(r, E.Hud));
    }
    this.UpdateDisplayByScene();
    let o = this.getFieldValue(E.Entity), c = "Component", T = J.func_getEntityInfo;
    if (T && r) {
      let d = T(r, o);
      d && d.ecaType && (c = d.ecaType);
    }
    if (c != l) {
      this.setOutput(!0, c);
      let h = ce.CurrentDescriptionFile.GetVarType(c);
      return this.setTooltip(h.Label), !0;
    }
  },
  UpdateDisplayByScene(i, l) {
    let r = this.getField(E.Hud);
    (!i || i === r.getValue()) && (r.UpdateDisplay(), this.getField(E.Entity).UpdateDisplay());
  },
  search(i, l) {
    return ["pickentity", f.PickEntity].find((r) => J.containsKey(r, i)) || !1;
  }
}, tC = {
  geId: I.pick_prefab,
  locKey: re.PrefabLabel,
  init() {
    this.appendDummyInput().appendField(new Yt({ type: "Prefab", defaultLabel: f.PrefabLabel }), E.Entity), this.setOutput(!0, "$PrefabT_Entity"), rT && rT.block_style ? this.setStyle(rT.block_style) : this.setStyle("module_blocks");
  },
  setShadow(i) {
    mM.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
  },
  UpdateDisplayByScene(i) {
    let l = this.getField(E.Entity);
    (!i || i === l.getValue()) && l.refreshText();
  },
  search(i) {
    return ["pickprefab", f.PrefabLabel].find((l) => J.containsKey(l, i)) || !1;
  },
  DetermineTypes() {
    let i = ce.CurrentDescriptionFile, l = this.outputConnection.getCheck(), r = null;
    l && l.length == 1 && (r = l[0]);
    let o = this.getFieldValue(E.Entity), c = "$PrefabT_Component", T = J.func_getEntityInfo;
    if (T && o) {
      let d = T(o, "$PrefabRoot");
      if (d && d.ecaType) {
        const h = i.GetVarType("$PrefabT"), y = i.GetVarType(d.ecaType);
        y && (c = i.GetGenericVarType(h, y).Name);
      }
    }
    if (c != r) {
      this.setOutput(!0, c);
      let d = i.GetVarType(c);
      return this.setTooltip(d.Label), !0;
    }
  }
};
function rC(i) {
  let l = J.func_pickSceneEntity;
  if (l == null)
    return;
  const r = i.getFieldValue(E.Hud);
  l("Component", r).then((o) => {
    X.Events.setGroup(!0), i.setFieldValue(o.sceneId, E.Hud), i.setFieldValue(o.entityId, E.Entity), i.getField(E.Entity).UpdateDisplay(), X.Events.setGroup(!1);
  }, (o) => {
  });
}
var Fd, rT;
function nC(i) {
  N.Blocks[I.pick_entity] = eC, N.Blocks[I.pick_prefab] = tC, Fd = { kind: "block", type: I.pick_entity }, rT = { kind: "block", type: I.pick_prefab }, i.set("EntityGetter", Fd), i.set("PrefabGetter", rT), i.set("PrefabID", rT);
}
const { dom: sI } = X.utils;
function nT(i = "MyFunction") {
  return i + (Math.random() * 1e4).toFixed(0);
}
let iC = {
  argId: "",
  geId: I.function_mutator_parameter,
  init() {
    let i = this.isInFlyout ? "" : nT("Param");
    this.argId = nT("_arg"), this.appendDummyInput(E.ParamList).appendField(new X.FieldDropdown([[f.VarIn, ""], [f.VarOut, "out"]]), E.Operator).appendField(new Vo(i, (l) => l || null), E.Name).appendField(new oo(""), E.Type), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("function_blocks");
  }
}, oC = {
  geId: I.function_mutator_container,
  init() {
    this.appendDummyInput().appendField(new N.FieldImage(vl, 14, 14, "+", () => {
      this.onAddItem();
    })).appendField(f.FunctionMutatorParameters), this.appendStatementInput(E.ParamList), this.setStyle("function_blocks");
  },
  onAddItem() {
    let i = {
      type: I.function_mutator_parameter
    }, l = this.getInputTargetBlock(E.ParamList);
    if (l == null) {
      const r = N.serialization.blocks.append(i, this.workspace, { recordUndo: !0 });
      this.getInput(E.ParamList).connection.connect(r.previousConnection);
    } else {
      const r = N.serialization.blocks.append(i, this.workspace, { recordUndo: !0 });
      l.lastConnectionInStack(!0).connect(r.previousConnection);
    }
  }
}, CS = {
  arguments_: [],
  getFunctionDef() {
    let i = this.arguments_;
    for (let l of i) {
      let r = this.getFieldValue(l.id);
      r && (l.type = r.type);
    }
    return {
      id: this.id,
      name: this.getFieldValue(E.Name),
      params: this.arguments_,
      returnType: this.getFieldValue(E.Return)
    };
  },
  compose(i) {
    this.arguments_ = [];
    let l = i.getInputTargetBlock(E.ParamList);
    for (; l && !l.isInsertionMarker(); ) {
      const o = l.argId, c = l.getFieldValue(E.Operator) === "out", T = l.getFieldValue(E.Name), d = l.getFieldValue(E.Type);
      this.arguments_.push({ id: o, name: T, type: d, isOut: c }), l = l.nextConnection && l.nextConnection.targetBlock();
    }
    this.updateShape_(this.arguments_), Kd(this);
  },
  decompose(i) {
    var l = i.newBlock(I.function_mutator_container);
    l.initSvg();
    var r = l.getInput(E.ParamList).connection;
    for (var o of this.arguments_) {
      var c = i.newBlock(I.function_mutator_parameter);
      c.initSvg(), c.argId = o.id, c.setFieldValue(o.isOut ? "out" : "", E.Operator), c.setFieldValue(o.name, E.Name), c.setFieldValue(o.type, E.Type), r.connect(c.previousConnection), r = c.nextConnection;
    }
    return l;
  },
  saveExtraState() {
    return this.arguments_;
  },
  loadExtraState(i) {
    let l = [];
    if (i) {
      for (let r of i)
        typeof r == "string" ? l.push({
          id: r,
          name: "",
          type: "any"
        }) : l.push(r);
      this.arguments_ = l, this.updateShape_(l);
    }
  },
  updateTypeLabel(i) {
    if (i instanceof Vt) {
      let l = ce.CurrentDescriptionFile, r = i.vardef, o = l.GetVarType(r.type), c = r.type;
      o != null && (c = o.Label);
      let T = this.arguments_.find((h) => h.id === i.name);
      T && (T.name = r.name);
      let d = X.Events.getRecordUndo();
      X.Events.setRecordUndo(!1), this.getField("label" + i.name) && this.setFieldValue(c, "label" + i.name), X.Events.setRecordUndo(d);
    }
  },
  updateShape_(i) {
    let l = ce.CurrentDescriptionFile, r = this;
    for (let T of i) {
      T.name == "" && (T.name = nT("Param"));
      let d = l.GetVarType(T.type), h = T.type;
      d != null && (h = d.Label);
      let y = this.getInput(T.id);
      y ? (y.fieldRow[0].setValue(T.isOut ? f.VarOut : f.VarIn), y.fieldRow[2].setValue(h), y.fieldRow[1].setValue(T)) : y = this.appendDummyInput(T.id).appendField(T.isOut ? f.VarOut : f.VarIn).appendField(new Vt(T, c), T.id).appendField(h, "label" + T.id).appendField(new PI(f.LocalvarSet, T.id)), this.moveInputBefore(T.id, E.Code);
    }
    let o = E.Code;
    for (i.length > 0 && (o = i[0].id); this.inputList[1].name != o; )
      this.removeInput(this.inputList[1].name);
    function c(T) {
      return setTimeout(() => {
        Kd(r), r.updateTypeLabel(this);
      }), T;
    }
  },
  getVarDefine(i, l, r) {
    if (l == bt.ChildStatements || l == bt.SelfDefine) {
      for (let o of this.inputList)
        if (o.name) {
          let c = lo(this, o.name, i, r);
          if (c)
            return c;
        }
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  },
  initTooltips() {
    this.setTooltip(() => "");
  },
  checkHasReturn() {
    if (!this.getField(E.Return))
      return;
    let i = this.getInput(E.Code).connection.targetBlock();
    l(i) ? this.setWarningText(null, "funcret") : this.setWarningText(ye("FE_42_XXJ_NORETURN"), "funcret");
    function l(r) {
      for (; r; ) {
        if (r.type == I.function_return)
          return !0;
        for (let o of r.inputList)
          if (o.type === X.inputTypes.STATEMENT && l(o.connection.targetBlock()))
            return !0;
        r = r.getNextBlock();
      }
    }
  }
}, Ih = {
  ...CS,
  geId: I.function_definition_valution,
  locKey: re.FunctionDefineValution,
  init() {
    this.setInputsInline(!0);
    const i = this.workspace.IsCraftland;
    let l = this.appendDummyInput(E.Header).appendField(f.FunctionDefineValution);
    i || l.appendField(new Vo(RS(this), vS), E.Name).appendField(f.FunctionDefineReturn).appendField(new oo(""), E.Return).appendField(new OS(f.ReturnSentense, ""), E.Return + "_drag"), this.appendStatementInput(E.Code), i && this.appendValueInput(E.Return).appendField("return Value"), this.setStyle("function_blocks"), i || this.setMutator(new N.icons.MutatorIcon([], this)), this.initTooltips();
  },
  onchange(i) {
    if (i instanceof X.Events.BlockMove) {
      const r = i.reason ?? [];
      let o;
      if (r.includes("connect"))
        o = i.newParentId;
      else if (r.includes("disconnect"))
        o = i.oldParentId;
      else
        return;
      let T = this.workspace.getBlockById(o);
      for (; T != null && T.getParent(); )
        T = T.getParent();
      (T == null ? void 0 : T.id) === this.id && this.checkHasReturn();
    }
    if (!(i instanceof X.Events.BlockChange) || i.blockId != this.id)
      return;
    let l = Da(i);
    i.type == N.Events.BLOCK_CHANGE && i.element == "field" && i.name == E.Return && Kd(this), l.Leave();
  },
  search(i, l, r, o) {
    return !1;
  }
}, lC = {
  ...CS,
  geId: I.function_definition_action,
  locKey: re.FunctionDefineAction,
  init() {
    const i = this.workspace.IsCraftland;
    let l = this.appendDummyInput(E.Header).appendField(f.FunctionDefineAction);
    i || l.appendField(new Vo(RS(this, !1), vS), E.Name).appendField(new OS(f.ReturnSentense, ""), E.Return + "_drag"), this.appendStatementInput(E.Code), i && this.appendDummyInput(), this.setStyle("function_blocks"), i || this.setMutator(new N.icons.MutatorIcon([], this)), this.initTooltips();
  },
  search(i, l, r, o) {
    return !1;
  }
};
({
  ...CS,
  geId: I.function_xbt_action,
  locKey: re.FunctionXBTAction
});
({
  ...CS,
  geId: I.function_xbt_condition,
  locKey: re.FunctionXBTCondition
});
let tm = {
  paramCount: 0,
  state_: {},
  locKey: re.FunctionCall,
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     if (this.isInFlyout) {
  //         const searchOption = {
  //             text: $t('FE_44_HZY_SEARCH_FUNCTIONNAME'),
  //             enabled: true,
  //             callback: () => {
  //                 const name = this.getField(SerializeKeys.Name)?.getValue();
  //                 if(name) {
  //                     const cm = GModuleManager.Get(ICommandModule);
  //                     cm.Send(ECommandActionIds.toolbar_logic_search, name);
  //                 }
  //             }
  //         };
  //         options.splice(1, 0, searchOption);
  //     }
  // },
  findDefinition() {
    return uC(this.state_, this.workspace);
  },
  saveExtraState() {
    return this.state_;
  },
  loadExtraState(i) {
    var l;
    this.state_ = i, (l = this.state_) != null && l.tooltip && this.setTooltip(this.state_.tooltip), this.updateFunction();
  },
  updateFunction() {
    this.checkFunctionReference(), this.updateFunctionShape_();
  },
  updateFunctionShape_() {
    if (this.setFieldValue(this.state_.name, E.Name), this.removeInput("fixButton", !0), this.state_.params)
      for (let o = 0; o < this.state_.params.length; ++o) {
        o == this.paramCount && this.appendDummyInput("fixButton").appendField(f.FixFunctionCaller).appendField(new X.FieldImage("aa", 20, 20, "FIX", () => {
          let h = this.findDefinition();
          h && this.loadExtraState(h);
        }, !1, { tooltip: f.FixFunctionCallerTip }));
        let c = this.state_.params[o], T = this.getInput(c.id), d = c.isOut ? f.VarOut : c.name;
        T ? c.isOut && T.type != N.inputTypes.DUMMY ? (this.removeInput(c.id), T = this.appendDummyInput(c.id), T.appendField(c.name, "label" + c.id), T.appendField(new Vt({ name: c.name, type: c.type }), c.id)) : !c.isOut && T.type != N.inputTypes.VALUE ? (this.removeInput(c.id), T = this.appendValueInput(c.id), T.appendField(d, "label" + c.id)) : T.fieldRow[0].setValue(d) : c.isOut ? (T = this.appendDummyInput(c.id), T.appendField(d, "label" + c.id), T.appendField(new Vt({ name: c.name, type: c.type }), c.id)) : (T = this.appendValueInput(c.id), T.appendField(d, "label" + c.id)), c.isOut ? (N.Events.disable(), T.fieldRow[1].setValue({ type: c.type }), N.Events.enable()) : (T.setCheck(c.type), N.Events.disable(), T.connection.setShadowState(Xe(c.type)), N.Events.enable()), this.moveInputBefore(T.name, null);
      }
    let i = N.constants.COLLAPSED_INPUT_NAME;
    this.state_.params.length > 0 && (i = this.state_.params[0].id);
    let l = -1;
    for (let o = 0; o < this.inputList.length; ++o)
      if (this.inputList[o].name == E.Header) {
        l = o + 1;
        break;
      }
    for (; this.inputList.length > l && this.inputList[l].name != i; )
      this.removeInput(this.inputList[l].name);
    if (this.getField(E.Return)) {
      this.setOutput(!0, this.state_.returnType);
      let o = ce.CurrentDescriptionFile.GetVarType(this.state_.returnType);
      N.Events.disable(), o != null ? this.setFieldValue(o.Label, E.Return) : this.setFieldValue(f.UnkownType, E.Return), N.Events.enable();
    }
  },
  renameFunction(i, l) {
    this.state_.name == i && (this.state_.name = l, this.setFieldValue(this.state_.name, E.Name));
  },
  checkFunctionReference() {
    let i = X.Events.getRecordUndo();
    X.Events.setRecordUndo(!1);
    try {
      let l = this.state_;
      if (this.paramCount = 0, !this.isInFlyout) {
        let r = this.findDefinition();
        if (r == null)
          this.setWarningText(ye(re.Warning_NoDefine, [l.name]), "NODEF");
        else {
          this.paramCount = r.params.length, this.state_ = dM(r);
          for (let o of l.params)
            this.state_.params.find((c) => c.id == o.id) || this.state_.params.push(o);
          if (this.state_.params.length != r.params.length) {
            this.setWarningText(f.Warning_FunctionSignature_Parameters, "NODEF");
            return;
          }
          this.state_.id = r.id, this.state_.name = r.name, this.setWarningText(null, "NODEF");
        }
      }
    } finally {
      X.Events.setRecordUndo(i);
    }
  },
  getVarDefine(i, l, r) {
    if (l == bt.NextStatements || l == bt.SelfDefine) {
      for (let o of this.inputList)
        if (o.name) {
          let c = lo(this, o.name, i, r);
          if (c)
            return c;
        }
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  },
  onchange(i) {
    i.type === X.Events.FINISHED_LOADING && this.updateFunction(), i instanceof X.Events.BlockDelete && !i.wasShadow && this.checkFunctionReference();
  },
  search(i, l) {
    var r;
    return (((r = l == null ? void 0 : l.extraState) == null ? void 0 : r.name) || "").toLocaleLowerCase().includes(i) ? l.extraState.name : [f.FunctionCall].find((o) => J.containsKey(o, i)) ?? !1;
  },
  UpdateDisplay() {
    this.updateFunction();
  }
}, sC = {
  ...tm,
  geId: I.function_call_value,
  init: function() {
    this.setInputsInline(!0), this.appendDummyInput(E.Header).appendField("", E.Name).appendField(f.CallReturn).appendField(new X.FieldLabel("", void 0, void 0), E.Return), this.setStyle("function_blocks"), this.setOutput(!0, this.state_.returnType);
  }
}, aC = {
  ...tm,
  debugAvailable: !0,
  geId: I.function_call_action,
  locKey: re.FunctionCall,
  init: function() {
    this.setInputsInline(!0), this.appendDummyInput(E.Header).appendField(new Je([[f.SerialCall, Vd.Wait], [f.ParallelCall, Vd.Start]]), E.Type).appendField("", E.Name), this.setStyle("function_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setTooltip(f.FunctionCallTooltip);
  }
}, _C = {
  debugAvailable: !0,
  returnType: "",
  geId: I.function_return,
  locKey: re.ReturnSentense,
  init() {
    this.setStyle("function_blocks"), this.setInputsInline(!0), this.setPreviousStatement(!0), this.setNextStatement(!1), sn(
      this.appendValueInput(E.Return).appendField(f.ReturnSentense).conditionAppendField(this.workspace.IsCraftland, "Return value"),
      this.returnType,
      !0
    );
  },
  loadExtraState(i) {
    this.returnType = i.rt;
    let l = this.getInput(E.Return);
    this.returnType == null ? l.type == X.inputTypes.VALUE && (this.removeInput(E.Return), this.appendDummyInput(E.Return).appendField(f.ReturnSentense)) : (l.type == X.inputTypes.DUMMY && (this.removeInput(E.Return), l = this.appendValueInput(E.Return).appendField(f.ReturnSentense)), sn(l, this.returnType, !0));
  },
  saveExtraState() {
    return {
      rt: this.returnType
    };
  },
  onchange(i) {
    let l = this.workspace;
    if (l.isDragging && l.isDragging())
      return;
    let r = i.type == X.Events.BLOCK_MOVE;
    if (i instanceof X.Events.BlockChange && i.type == X.Events.BLOCK_CHANGE && i.element == "field" && i.name == E.Return && (r = !0), r) {
      let o = !1, c = this;
      do {
        if (c.type == I.function_definition_valution || c.type == I.function_definition_action || c.type === I.function_xbt_action || c.type === I.function_xbt_condition) {
          o = !0;
          break;
        }
        c = c.getSurroundParent();
      } while (c);
      const T = Da(i);
      try {
        if (o) {
          let h = c.getFunctionDef().returnType;
          this.loadExtraState({ rt: h }), this.setWarningText(null, "RET");
        } else
          this.setWarningText(f.Warning_ReturnNotInFunction, "RET");
      } finally {
        T.Leave();
      }
    }
  },
  search(i) {
    return ["return", f.ReturnSentense].find((l) => J.containsKey(l, i)) || !1;
  }
};
function cC(i) {
  N.Blocks[I.function_mutator_container] = oC, N.Blocks[I.function_mutator_parameter] = iC, N.Blocks[I.function_definition_valution] = Ih, N.Blocks[I.function_definition_action] = lC, N.Blocks[I.function_xbt_action] = Ih, N.Blocks[I.function_xbt_condition] = Ih, N.Blocks[I.function_call_value] = sC, N.Blocks[I.function_call_action] = aC, N.Blocks[I.function_return] = _C, i.set("function_definition", { kind: "block", type: I.function_definition_valution }), i.set("function_definition_noreturn", { kind: "block", type: I.function_definition_action }), i.set("function_return", { kind: "block", type: I.function_return });
}
function uC(i, l, r) {
  let o = l.getAllBlocks(!1);
  for (let c = 0; c < o.length; c++) {
    let T = o[c];
    if (T.getFunctionDef != null) {
      let d = T.getFunctionDef();
      if (d && d.id == i.id)
        return T.isEnabled() ? d : null;
    }
  }
  for (let c = 0; c < o.length; c++) {
    let T = o[c];
    if (T.getFunctionDef != null) {
      let d = T.getFunctionDef();
      if (d && d.name == i.name)
        return T.isEnabled() ? d : null;
    }
  }
  return null;
}
const Kd = Of((i) => {
  var T, d;
  if (i.isInsertionMarker())
    return;
  const l = i.getFunctionDef();
  l.graphId = Dh(), WI(l.id, l);
  const r = l.id;
  let o = N.Events.getRecordUndo();
  N.Events.setRecordUndo(!1);
  const c = ((T = i.workspace) == null ? void 0 : T.getAllBlocks(!1)) || [];
  for (let h = 0; h < c.length; h++) {
    const y = c[h];
    if ((d = y.state_) != null && d.id) {
      let b = y.state_.graphId;
      const U = y.state_.id;
      (b == Dh() || b == null) && U == r && y.loadExtraState(l);
    }
  }
  N.Events.setRecordUndo(o);
}, 100), TC = function(i, l, r) {
  const o = l.getAllBlocks(!1);
  for (let c = 0; c < o.length; c++) {
    if (o[c] === r)
      continue;
    const T = o[c];
    if (T.getFunctionDef) {
      const d = T.getFunctionDef();
      if (X.Names.equals(d.name, i))
        return !0;
    }
  }
  return !1;
};
function pC(i, l, r) {
  return !TC(i, l, r);
}
function dC(i, l) {
  if (l.isInFlyout)
    return i;
  for (i = i || "unnamed"; !pC(i, l.workspace, l); ) {
    const r = i.match(/^(.*?)(\d+)$/);
    r ? i = r[1] + (parseInt(r[2], 10) + 1) : i += "2";
  }
  return i;
}
function vS(i) {
  if (this.sourceBlock_.isInsertionMarker())
    return;
  i = i.trim();
  const l = dC(i, this.getSourceBlock()), r = this.getValue();
  if (r !== i && r !== l) {
    let o = this.sourceBlock_.id;
    WI(o, l);
    const c = this.getSourceBlock().workspace.getAllBlocks(!1);
    for (let T = 0; T < c.length; T++) {
      const d = c[T];
      d.renameFunction && d.renameFunction(r, l);
    }
  }
  return l;
}
var aI, _I;
function RS(i, l = !0, r = "MyFunction") {
  return i.workspace.isFlyout ? l ? aI = aI ?? nT(r) : _I = _I ?? nT(r) : nT(r);
}
class OS extends X.FieldLabel {
  constructor(r, o, c) {
    super(r);
    C(this, "fieldRef");
    this.fieldRef = o;
  }
  initView() {
    this.createBorderRect_(), this.createTextElement_(), sI.addClass(this.fieldGroup_, "blocklyDragOutReturn");
  }
  createBorderRect_() {
    this.borderRect_ = sI.createSvgElement(
      "path",
      {},
      this.fieldGroup_
    );
  }
  positionBorderRect_() {
    if (!this.borderRect_)
      return;
    let r = this.size_.width, o = this.size_.height;
    const c = `m 0,0  h 10  l 3,3  10,0  3,-3  H${r}  V${o} H 0 z`;
    this.borderRect_.setAttribute(
      "d",
      c
    );
  }
  getDragOutBlockState() {
    let o = this.getSourceBlock().getField(this.fieldRef), c = o == null ? void 0 : o.getValue();
    return {
      kind: "block",
      type: I.function_return,
      extraState: { rt: c }
    };
  }
  onMouseDown_(r) {
    if (super.onMouseDown_(r), !this.sourceBlock_ || this.sourceBlock_.disposed || this.sourceBlock_.isInFlyout)
      return;
    const o = this.sourceBlock_.workspace.getGesture(r);
    if (Mh ?? (Mh = !1), o && r.button === 0 && !Mh) {
      let c = MS(this.sourceBlock_.workspace);
      o.setStartBlock(this.sourceBlock_), o.handleFlyoutStart(r, c), c.targetWorkspace = this.sourceBlock_.workspace, c.refField = this;
    }
  }
}
let Mh;
class IM extends N.Field {
  constructor() {
    super(...arguments);
    C(this, "SERIALIZABLE", !0);
  }
  initView() {
  }
  updateSize_(r) {
    this.size_ = {
      width: 1,
      height: 1
    };
  }
  positionBorderRect_() {
    Yh.bind(this)();
  }
}
function EC(i) {
  let l = sT().get(i.graphId);
  if (l && l.functions) {
    for (let r = 0; r < l.functions.length; ++r) {
      let o = l.functions[r];
      if (o.id == i.id)
        return o;
    }
    for (let r = 0; r < l.functions.length; ++r) {
      let o = l.functions[r];
      if (o.name == i.name)
        return o;
    }
  }
  return null;
}
class MM extends Gn {
  constructor() {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]]);
    C(this, "graphId");
    this.menuGenerator_ = this.menuGenerator;
  }
  UpdateGraphID(r) {
    if (r) {
      if (r == this.graphId)
        return;
      this.graphId = r;
    }
    this.getOptions(!1), this.doValueUpdate_(this.getValue());
  }
  menuGenerator() {
    var c;
    let o = sT().get(this.graphId);
    if (o && ((c = o.vars) == null ? void 0 : c.length) > 0) {
      let T = ce.CurrentDescriptionFile, d = [];
      for (let h = 0; h < o.vars.length; ++h) {
        let y = T.GetVarType(o.vars[h].type), b = y ? y.Label : o.vars[h].type;
        d.push([o.vars[h].name + " : " + b, o.vars[h].id, o.vars[h].name, o.vars[h].type]);
      }
      return d;
    }
    return [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
  }
  getSelectedType() {
    const r = this.selectedOption;
    return r != null && r[3] && typeof r[3] == "string" ? r[3] : "";
  }
}
let gM = {
  OnGraphIDChanged(i) {
    let l = this.getSourceBlock(), o = sT().get(i);
    o ? l.setFieldValue(o.name, E.GraphName) : l.setFieldValue(i, E.GraphName), l.getField(E.VarID).UpdateGraphID(i);
  },
  DetermineTypes() {
    let l = this.getField(E.VarID).getSelectedType();
    if (this.type === I.externvar_set) {
      const c = this.getField(E.Operator);
      c && c.opType !== l && (c.setOpType(l), c.UpdateDisplay());
    }
    const r = this.getField(E.GraphID), o = this.getFieldValue(E.GraphID);
    return this.OnGraphIDChanged.call(r, o), this.setCheckType(l);
  },
  setCheckType: null
  //abstract
}, AC = {
  ...gM,
  geId: I.externvar_get,
  locKey: re.ExternalGet,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.This).appendField(f.ExternalGet).appendField(new IM("", this.OnGraphIDChanged), E.GraphID).appendField("", E.GraphName).appendField(new MM(), E.VarID).appendField(f.ExternalGet_2).setCheck("Component").connection.setShadowState(Xe("Component")), this.setOutput(!0), this.setStyle("action_blocks");
  },
  search(i, l) {
    var b;
    if (J.containsKey(f.ExternalGet, i))
      return f.ExternalGet;
    const r = sT(), o = l.fields[E.GraphID], c = r.get(o);
    if (!c)
      return !1;
    const { name: T } = c;
    if (J.containsKey(T, i))
      return T;
    const { vars: d } = c, h = l.fields[E.VarID], y = (b = d.find((U) => U.id === h)) == null ? void 0 : b.name;
    return y && J.containsKey(y, i) ? y : !1;
  },
  setCheckType(i) {
    const l = this.outputConnection.getCheck();
    return ((l == null ? void 0 : l[0]) ?? "") != i ? (this.setOutput(!0, i), !0) : !1;
  }
}, SC = {
  ...gM,
  debugAvailable: !0,
  geId: I.externvar_set,
  locKey: re.ExternalSet,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.This).appendField(f.ExternalSet).setCheck("Component").connection.setShadowState(Xe("Component")), this.appendValueInput(E.Value).appendField(new IM("", this.OnGraphIDChanged), E.GraphID).appendField("", E.GraphName).appendField(new MM(), E.VarID).appendField(new Hd(), E.Operator).connection.setShadowState(Xe("any")), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("action_blocks");
  },
  search(i, l) {
    var b;
    if (J.containsKey(f.ExternalSet, i))
      return f.ExternalSet;
    const r = sT(), o = l.fields[E.GraphID], c = r.get(o);
    if (!c)
      return !1;
    const { name: T } = c;
    if (J.containsKey(T, i))
      return T;
    const { vars: d } = c, h = l.fields[E.VarID], y = (b = d.find((U) => U.id === h)) == null ? void 0 : b.name;
    return y && J.containsKey(y, i) ? y : !1;
  },
  setCheckType(i) {
    var o;
    const l = this.getInput(E.Value);
    return (((o = l.connection.getCheck()) == null ? void 0 : o[0]) ?? "") != i ? (sn(l, i), !0) : !1;
  }
}, LM = {
  ...tm,
  findDefinition() {
    return this.state_.graphId, EC(this.state_);
  },
  updateShape() {
    this.updateFunctionShape_();
    let i = this.state_.graphId, r = sT().get(i);
    r ? this.setFieldValue(r.name, E.GraphName) : this.setFieldValue(i, E.GraphName);
  },
  renameFunction(i, l) {
    this.state_.graphId == Dh() && this.state_.name == i && (this.state_.name = l, this.setFieldValue(this.state_.name, E.Name));
  },
  search(i, l) {
    var r;
    return (((r = l == null ? void 0 : l.extraState) == null ? void 0 : r.name) || "").toLocaleLowerCase().includes(i) ? l.extraState.name : [f.ExternalCall, f.FunctionCall].find((o) => J.containsKey(o, i)) || !1;
  }
}, hC = {
  ...LM,
  geId: I.extern_call_value,
  locKey: re.ExternalCall,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.This).appendField(f.ExternalCall).setCheck("Component").connection.setShadowState(Xe("Component")), this.appendDummyInput(E.Header).appendField("", E.GraphName).appendField("", E.Name).appendField(f.CallReturn).appendField("", E.Return), this.setStyle("action_blocks"), this.setOutput(!0);
  }
}, mC = {
  ...LM,
  debugAvailable: !0,
  geId: I.extern_call_value,
  locKey: re.ExternalCall,
  init() {
    this.setInputsInline(!0), this.appendValueInput(E.This).appendField(f.ExternalCall).setCheck("Component").connection.setShadowState(Xe("Component")), this.appendDummyInput(E.Header).appendField(new Je([[f.SerialCall, Vd.Wait], [f.ParallelCall, Vd.Start]]), E.Type).appendField("", E.GraphName).appendField("", E.Name), this.setStyle("action_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action");
  }
};
function IC(i) {
  X.Blocks[I.externvar_get] = AC, X.Blocks[I.externvar_set] = SC, X.Blocks[I.extern_call_value] = hC, X.Blocks[I.extern_call_action] = mC;
}
function MC(i, l) {
  let r = J.func_hudWidgetList;
  return r ? r(i, l) : [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
function gC() {
  let i = J.func_hudList;
  return i ? i() : [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
}
class NM extends Gn {
  constructor(r, o, c) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], o, c);
    C(this, "hudFile");
    this.menuGenerator_ = () => {
      let T = this.getSourceBlock().getFieldValue(E.Hud) ?? "", d = r;
      return d || (d = this.getSourceBlock().getFieldValue(E.Type) ?? ""), MC(T, d);
    };
  }
  UpdateDisplay() {
    let r = this.getValue(), o = this.getText();
    this.getOptions(), this.doValueUpdate_(r), this.getText() != o && (this.markDirty(), this.forceRerender());
  }
  getValueDefaultOptions(r) {
    let o = this.getSourceBlock();
    if (o != null) {
      let c = o.getFieldValue(E.Hud), T = J.func_getEntityInfo;
      if (c && T) {
        let d = T(c, r);
        if (d)
          return [d.name, d.entityId];
      }
    }
    return super.getValueDefaultOptions(r);
  }
}
class DS extends Gn {
  constructor(r, o) {
    super([[f.CustomHud, ""]], r, o);
    C(this, "hudFile");
    this.menuGenerator_ = () => (this.getSourceBlock().getFieldValue(E.Type), gC());
  }
  UpdateDisplay() {
    let r = this, o = this.getValue(), c = this.getText();
    this.getOptions(), r.selectedOption_ = [o + f.UnkownType, o, "", { style: "{ fill: var(--red_err5); }" }], this.doValueUpdate_(o), this.getText() != c && (this.markDirty(), this.forceRerender());
  }
}
let LC = {
  locKey: "CustomHudWidgetID",
  init() {
    this.appendDummyInput().appendField(new DS(), E.Hud).appendField(new NM(), E.Entity), this.setOutput(!0, "CustomHudWidgetID"), cS && cS.block_style ? this.setStyle(cS.block_style) : this.setStyle("action_blocks");
  },
  DetermineTypes() {
    let i = this.outputConnection.getCheck(), l = null;
    i && i.length == 1 && (l = i[0]);
    let r = "CustomHudWidgetID", o = J.func_getEntityInfo, c = this.getFieldValue(E.Hud), T = this.getFieldValue(E.Entity);
    if (o && c) {
      let d = o(c, T);
      d && d.ecaType && (r = `$HudWidgetIDT_${d.ecaType}`);
    }
    if (r != l) {
      this.setOutput(!0, r);
      let h = ce.CurrentDescriptionFile.GetVarType(r);
      return this.setTooltip((h == null ? void 0 : h.Label) || null), this.UpdateDisplayByScene(), !0;
    }
  },
  UpdateDisplayByScene(i, l) {
    let r = this.getField(E.Hud);
    (!i || i === r.getValue()) && (r.UpdateDisplay(), this.getField(E.Entity).UpdateDisplay());
  },
  search(i) {
    const l = ce.CurrentDescriptionFile.GetVarType("CustomHudWidgetID");
    return ["CustomHudWidgetID", l.Label, l.ScriptName].find((r) => J.containsKey(r, i)) || !1;
  }
}, NC = {
  locKey: re.PickWidget,
  init() {
    this.appendValueInput(E.Hud).appendField(new oo("HudWidget"), E.Type).appendField(f.GetWidgetFromCustomHud).setCheck("CustomHud").connection.setShadowState(Xe("CustomHud")), this.appendDummyInput().appendField(new DS(), E.Hud).appendField(new NM(), E.Entity), this.setOutput(!0, "HudWidget"), _S && _S.block_style ? this.setStyle(_S.block_style) : this.setStyle("action_blocks");
  },
  DetermineTypes() {
    let i = this.outputConnection.getCheck(), l = null;
    i && i.length == 1 && (l = i[0]);
    let r = this.getFieldValue(E.Type), o = J.func_getEntityInfo, c = this.getFieldValue(E.Hud), T = this.getFieldValue(E.Entity);
    if (o && c) {
      let d = o(c, T);
      d && d.ecaType && (r = d.ecaType);
    }
    if (r != l) {
      this.setOutput(!0, r);
      let h = ce.CurrentDescriptionFile.GetVarType(r);
      return this.setTooltip(h.Label), this.UpdateDisplayByScene(), !0;
    }
  },
  UpdateDisplayByScene(i, l) {
    let r = this.getField(E.Hud);
    (!i || i === r.getValue()) && (r.UpdateDisplay(), this.getField(E.Entity).UpdateDisplay());
  },
  search(i) {
    return ["pickwidget", f.PickWidget].find((l) => J.containsKey(l, i)) || !1;
  }
}, yC = {
  debugAvailable: !0,
  geId: I.create_hud_deprecated,
  locKey: re.CreateHud,
  init() {
    let i;
    this.appendDummyInput().appendField(f.CreateHud).appendField(new Vt({ name: "CustomHud", type: "CustomHud" }), E.Entity), i = this.appendValueInput(E.Player).appendField(f.CreateHud_OwnerPlayer).setCheck("Player"), i.fieldRow[0].setTooltip(f.CreateHud_OwnerPlayer_Tip), i.connection.setShadowState(Xe("Player")), this.appendDummyInput().appendField(new DS(), E.Hud), this.setNextStatement(!0, "action"), this.setPreviousStatement(!0, "action"), uS && uS.block_style ? this.setStyle(uS.block_style) : this.setStyle("action_blocks"), this.setTooltip(f.CreateHud_Tip);
  },
  UpdateDisplayByScene(i, l) {
    let r = this.getField(E.Hud);
    (!i || i === r.getValue()) && r.UpdateDisplay();
  },
  search(i) {
    return ["createhud", f.CreateHud].find((l) => J.containsKey(l, i)) || !1;
  },
  getVarDefine(i, l, r) {
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let o = lo(this, E.Entity, i, r);
      if (o)
        return o;
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  }
};
var _S = { kind: "block", type: I.pick_hudwidget, block_style: "" }, cS = { kind: "block", type: I.pick_hudwidgetid, block_style: "" }, uS = { kind: "block", type: I.create_hud_deprecated, block_style: "" };
function fC(i) {
  N.Blocks[I.pick_hudwidget] = NC, N.Blocks[I.create_hud_deprecated] = yC, N.Blocks[I.pick_hudwidgetid] = LC, i.set("pickhudwidget", _S), i.set("createhud", uS), i.set("CustomHudWidgetID", cS);
}
let CC = {
  ...Uo,
  ecatype: "event",
  fixOwnerType: "HudButtonWidget",
  init() {
    this.hat = "cap", this.appendDummyInput().appendField("", E.Label).appendField(new Vo(), E.Name).appendField(new Vt({ name: "Button", type: "HudButtonWidget" }), E.This), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.inputsInlineDefault = !0;
  },
  getVarDefine: function(i, l, r) {
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let c = E.This, T = lo(this, c, i, r);
      if (T)
        return T;
    }
    return Uo.getVarDefine.call(this, i, l, r);
  },
  updateTitle_(i) {
    let l = i, r = "Callback";
    this.setFieldValue(l, E.Label), this.getFieldValue(E.Name) || this.setFieldValue(yM(r), E.Name);
  }
}, vC = {
  ...Uo,
  ecatype: "event",
  fixOwnerType: "HudJoystick",
  init() {
    this.hat = "cap", this.appendDummyInput().appendField("", E.Label).appendField(new Vo(), E.Name).appendField(new Vt({ name: "Joystick", type: "HudJoystick" }), E.This), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.inputsInlineDefault = !0;
  },
  getVarDefine: function(i, l, r) {
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let c = E.This, T = lo(this, c, i, r);
      if (T)
        return T;
    }
    return Uo.getVarDefine.call(this, i, l, r);
  },
  updateTitle_(i) {
    let l = i, r = "Callback";
    this.setFieldValue(l, E.Label), this.getFieldValue(E.Name) || this.setFieldValue(yM(r), E.Name);
  }
};
function RC(i) {
  N.Blocks[I.hud_buttonevent] = CC, N.Blocks[I.hud_joystickevent] = vC;
}
function yM(i = "Callback") {
  return i + (Math.random() * 1e4).toFixed(0);
}
let OC = {
  locKey: re.IconLabel,
  init() {
    this.setOutput(!0, "SpriteID"), this.appendDummyInput().appendField(new Yt({
      type: "Icon",
      defaultLabel: f.IconLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(i) {
  },
  search(i, l) {
    let o = ce.CurrentDescriptionFile.GetVarType("SpriteID");
    return [o.Label, o.Name].find((c) => J.containsKey(c, i)) || !1;
  }
}, DC = {
  locKey: re.AtlasIDLabel,
  init() {
    this.setOutput(!0, "AtlasID"), this.appendDummyInput().appendField(new Yt({
      type: "AtlasID",
      defaultLabel: f.AtlasIDLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  search(i, l) {
    return ["AtlasID", f.AtlasIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, bC = {
  locKey: re.ItemGoodsLabel,
  init() {
    this.setOutput(!0, "ItemID"), this.appendDummyInput().appendField(new Yt({
      type: "ItemGoods",
      defaultLabel: f.ItemGoodsLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
    let i = this.getField(E.Value);
    return i == null ? void 0 : i.SubInfo;
  },
  loadExtraState(i) {
    let l = this.getField(E.Value), r = i == null ? void 0 : i.entityType, c = ce.CurrentDescriptionFile.GetVarType(r);
    l.SetSubInfo(i, (c == null ? void 0 : c.Label) + " ID");
  },
  search(i, l) {
    var d;
    let r = ce.CurrentDescriptionFile, o = r.GetVarType("ItemID"), c = (d = l == null ? void 0 : l.extraState) == null ? void 0 : d.entityType, T = r.GetVarType(c);
    return [o.Label, o.Name, (T == null ? void 0 : T.Label) ?? "", (T == null ? void 0 : T.Name) ?? ""].find((h) => J.containsKey(h, i)) || !1;
  }
};
const wh = "AudioType";
let PC = {
  locKey: re.SoundLabel,
  init() {
    this.setOutput(!0, wh), this.appendDummyInput().appendField(new Yt({
      type: "Sound",
      defaultLabel: f.SoundLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(i) {
  },
  search(i, l) {
    let o = ce.CurrentDescriptionFile.GetVarType(wh);
    return [o.Label, o.Name].find((c) => J.containsKey(c, i)) || !1;
  }
}, $C = {
  locKey: re.TextureIDLabel,
  init() {
    this.setOutput(!0, "TextureID"), this.appendDummyInput().appendField(new Yt({
      type: "Texture",
      defaultLabel: f.TextureIDLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(i) {
  },
  search(i, l) {
    return ["texture", f.TextureIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, WC = {
  locKey: re.EffectIDLabel,
  init() {
    this.setOutput(!0, "TextureID"), this.appendDummyInput().appendField(new Yt({
      type: "PresentEffectTexType",
      defaultLabel: f.EffectIDLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  saveExtraState() {
  },
  loadExtraState(i) {
  },
  search(i, l) {
    return ["presenteffecttextype", f.EffectIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, kC = {
  locKey: re.Script,
  init() {
    this.setOutput(!0, "GraphID"), this.appendDummyInput().appendField(new Yt({ type: "Script", defaultLabel: f.Script }), E.Value), this.setStyle("data_blocks");
  },
  search(i, l) {
    return ["eca", "script", f.ECAScript, f.Script].find((r) => J.containsKey(r, i)) || !1;
  }
}, wC = {
  locKey: re.Behavior,
  init() {
    this.setOutput(!0, "BTreeID"), this.appendDummyInput().appendField(new Yt({ type: "Behavior", defaultLabel: f.Behavior }), E.Value), this.setStyle("data_blocks");
  },
  search(i, l) {
    return ["behavior", "xbt", f.Behavior].find((r) => J.containsKey(r, i)) || !1;
  }
}, FC = {
  locKey: re.CustomHud,
  init() {
    this.setOutput(!0, "CustomHudID"), this.appendDummyInput().appendField(new DS(), E.Hud), this.setStyle("data_blocks");
  },
  search(i, l) {
    return ["customhud", f.CustomHud].find((r) => J.containsKey(r, i)) || !1;
  }
}, BC = {
  init() {
    this.setOutput(!0, "CsvID"), this.appendDummyInput().appendField(new Yt({ type: "CSV", defaultLabel: "CSV" }), E.Value), this.setStyle("data_blocks");
  }
}, UC = {
  relateParamVal: null,
  locKey: re.CustomHud,
  init() {
    this.setOutput(!0, "ClothID"), this.appendDummyInput().appendField(f.ClothIDLabel, E.Label).appendField(
      new Yt(
        {
          type: "ClothSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      E.Value
    ), this.setStyle("data_blocks");
  },
  search(i, l) {
    return ["ClothID", f.ClothIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, VC = {
  locKey: re.WeaponIDLabel,
  init() {
    this.setOutput(!0, "WeaponSkinID"), this.appendDummyInput().appendField(f.WeaponIDLabel, E.Label).appendField(
      new Yt(
        {
          type: "WeaponSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      E.Value
    ), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(i, l) {
    return ["WeaponSkinID", f.WeaponIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, GC = {
  locKey: re.EmoteIDLabel,
  init() {
    this.setOutput(!0, "EmoteType"), this.appendDummyInput().appendField(new Yt({
      type: "EmoteSkin",
      defaultLabel: f.EmoteIDLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(i, l) {
    return ["EmoteSkinID", f.EmoteIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, xC = {
  locKey: re.Object3DResourceLabel,
  init() {
    this.setOutput(!0, "String"), this.appendDummyInput().appendField(new Yt({
      type: "Object3DResource",
      defaultLabel: f.Object3DResourceLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(i, l) {
    return ["Obj3DRes", "Object3DResource", f.Object3DResourceLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, HC = {
  locKey: re.PlayerDataID,
  init() {
    this.setOutput(!0, "PlayerDataID"), this.setStyle("data_blocks"), this.appendDummyInput().appendField(new Yt({
      type: "PlayerDataID",
      defaultLabel: f.PlayerDataID
    }), E.Value);
  },
  search(i) {
    return ["PlayerDataID", f.PlayerDataID].find((l) => J.containsKey(l, i)) || !1;
  }
}, YC = {
  locKey: re.PersonaID,
  init() {
    this.setOutput(!0, "PersonaID"), this.setStyle("data_blocks"), this.appendDummyInput().appendField(new Yt({
      type: "PersonaID",
      defaultLabel: f.PersonaID
    }), E.Value);
  },
  search(i) {
    return ["PersonaID", f.PersonaID].find((l) => J.containsKey(l, i)) || !1;
  }
}, XC = {
  locKey: re.AnimationClipID,
  init() {
    this.setOutput(!0, "AnimationClipID"), this.setStyle("data_blocks"), this.appendDummyInput().appendField(new Yt({
      type: "AnimationClipID",
      defaultLabel: f.AnimationClipID
    }), E.Value);
  },
  search(i) {
    return ["AnimationClipID", f.AnimationClipID].find((l) => J.containsKey(l, i)) || !1;
  }
}, KC = {
  locKey: re.BagIDLabel,
  init() {
    this.setOutput(!0, "BagSkinID"), this.appendDummyInput().appendField(f.BagIDLabel, E.Label).appendField(
      new Yt(
        {
          type: "BagSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      E.Value
    ), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(i, l) {
    return ["BagSkinID", f.BagIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
}, jC = {
  locKey: re.PlayerSkill,
  init() {
    this.setOutput(!0, "PlayerSkillID"), this.appendDummyInput().appendField(new Yt({
      type: "PlayerSkillType",
      defaultLabel: f.PlayerSkill
    }), E.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(i, l) {
    return ["PlayerSkillID", f.PlayerSkill].find((r) => J.containsKey(r, i)) || !1;
  }
}, zC = {
  locKey: re.PetSkill,
  init() {
    this.setOutput(!0, "PetSkillID"), this.appendDummyInput().appendField(new Yt({
      type: "PetSkillID",
      defaultLabel: f.PetSkill
    }), E.Value), this.setStyle("data_blocks");
  },
  updateShape_() {
  },
  search(i, l) {
    return ["PetSkillID", f.PetSkill].find((r) => J.containsKey(r, i)) || !1;
  }
};
function Zu(i) {
  let l = i, r = ye(l), o = "";
  return {
    locKey: l,
    init() {
      this.setOutput(!0, o), this.setStyle("data_blocks");
      let c = new Yt({
        type: "GFileType",
        defaultLabel: r
      });
      c.SetSubInfo(i), this.appendDummyInput().appendField(c, E.Value);
    },
    search(c) {
      return [i, r].find((T) => J.containsKey(T, c)) || !1;
    }
  };
}
const Fh = [
  ["None", ""],
  ["变身ID", "HumanModelID"],
  ["ItemID", "ItemID"],
  // here refer to LevelObjectID   don't change
  ["ItemGoodsID", "ItemGoodsID"],
  // here refer to ItemID  don't change
  ["SpriteID", "SpriteID"],
  ["TextureID", "TextureID"],
  ["WeaponSkinID", "WeaponSkinID"],
  ["ClothID", "ClothID"],
  ["MeshID", "MeshID"],
  ["BagSkinID", "BagSkinID"]
], JC = [
  ["必须资源", ""],
  ["动态下载资源", "D"]
];
let ZC = {
  locKey: re.Resource,
  init() {
    this.setOutput(!0, "String"), this.appendDummyInput().appendField("* Raw 资源").appendField(new Je(JC), E.Condition).appendField(new Je(Fh), E.Type).appendField(new N.FieldTextInput(), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    var o;
    let i = this.getFieldValue(E.Type), l = (o = this.outputConnection.getCheck()) == null ? void 0 : o[0], r = "String";
    switch (i) {
      default:
        r = i;
        break;
    }
    if (l != r)
      return this.setOutput(!0, r), !0;
  },
  search(i, l) {
    for (let r of Fh) {
      if (J.containsKey(r[0], i))
        return r[0];
      if (J.containsKey(r[1], i))
        return r[1];
    }
    return ["资源", "Raw Resource"].find((r) => J.containsKey(r, i)) || !1;
  }
}, QC = {
  locKey: re.VehicleSkinIDLabel,
  init() {
    this.setOutput(!0, "VehicleSkinID"), this.appendDummyInput().appendField(f.VehicleSkinIDLabel, E.Label).appendField(
      new Yt(
        {
          type: "VehicleSkin",
          defaultLabel: f.None,
          nullable: !0
        }
      ),
      E.Value
    ), this.setStyle("data_blocks");
  },
  search(i, l) {
    return ["VehicleSkinID", f.VehicleSkinIDLabel].find((r) => J.containsKey(r, i)) || !1;
  }
};
const qC = "DynamicCreateItemID";
let ev = {
  locKey: re.DynamicCreateItemLabel,
  nextTypeChanged: !1,
  setNextTypeChanged() {
    this.nextTypeChanged = !0;
  },
  init() {
    this.setOutput(!0, qC), this.appendDummyInput().appendField(f.DynamicCreateItemLabel, E.Label).appendField(
      new Yt({
        type: "DynamicCreateItem",
        defaultLabel: f.Unselected
      }, () => this.setNextTypeChanged()),
      E.Value
    ), this.setStyle("data_blocks");
  },
  search(i) {
    return ["DynamicCreateItemID", f.DynamicCreateItemLabel].find((l) => J.containsKey(l, i)) || !1;
  },
  DetermineTypes() {
    return this.nextTypeChanged ? (this.nextTypeChanged = !1, !0) : !1;
  },
  setShadow(i) {
    var l, r;
    N.BlockSvg.prototype.setShadow.call(this, i), i && ((r = (l = this.inputList) == null ? void 0 : l[0]) == null || r.removeField(E.Label, !0));
  }
}, tv = {
  locKey: re.EffectLabel,
  init() {
    this.setOutput(!0, "EffectID"), this.appendDummyInput().appendField(new Yt({
      type: "EffectType",
      defaultLabel: f.EffectLabel
    }), E.Value), this.setStyle("data_blocks");
  },
  search(i) {
    return ["EffectID", "EffectType", f.EffectLabel].find((l) => J.containsKey(l, i)) || !1;
  }
}, rv = {
  locKey: re.InternalHud,
  init() {
    this.setOutput(!0, "$InternalHudTypeT_InternalHud"), this.appendDummyInput().appendField(new Yt({
      type: "InternalHudType",
      defaultLabel: f.InternalHud
    }), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    var c;
    const i = (c = this.outputConnection) == null ? void 0 : c.getCheck();
    let l;
    i && i.length === 1 && (l = i[0]);
    let r = "$InternalHudTypeT_InternalHud";
    const o = this.getFieldValue(E.Value) ?? "";
    if (o.startsWith("InternalHud_")) {
      const T = o.slice(12), d = ce.CurrentDescriptionFile, h = d.GetVarType(T);
      if (h) {
        const y = d.GetVarType("$InternalHudTypeT");
        r = d.GetGenericVarType(y, h).Name;
      }
    }
    return r != l ? (this.setOutput(!0, r), !0) : !1;
  },
  search(i) {
    return ["InternalHudType", f.InternalHud].find((l) => J.containsKey(l, i)) || !1;
  }
};
function nv(i) {
  N.Blocks[I.pick_itemgoods] = bC, i.set("ItemGoodsIDType", { kind: "block", type: I.pick_itemgoods }), i.set("ItemID", { kind: "block", type: I.pick_itemgoods }), i.set("EquipItemID_Attachment", { kind: "block", type: I.pick_itemgoods, extraState: { entityType: "Attachment" } }), N.Blocks[I.pick_sound] = PC, i.set(wh, { kind: "block", type: I.pick_sound }), i.set("AudioID", { kind: "block", type: I.pick_sound }), N.Blocks[I.pick_icon] = OC, i.set("IconType", { kind: "block", type: I.pick_icon }), i.set("SpriteID", { kind: "block", type: I.pick_icon }), N.Blocks[I.pick_atlas] = DC, i.set("AtlasID", { kind: "block", type: I.pick_atlas }), N.Blocks[I.pick_script] = kC, i.set("ScriptID", { kind: "block", type: I.pick_script }), N.Blocks[I.pick_xbt] = wC, i.set("BTreeID", { kind: "block", type: I.pick_xbt }), N.Blocks[I.pick_hud] = FC, i.set("CustomHudID", { kind: "block", type: I.pick_hud }), N.Blocks[I.pick_csv] = BC, i.set("SelectCSV", { kind: "block", type: I.pick_csv }), i.set("CsvID", { kind: "block", type: I.pick_csv }), N.Blocks[I.pick_texture] = $C, i.set("TextureID", { kind: "block", type: I.pick_texture }), N.Blocks[I.pick_effect] = WC, i.set("PresentEffectTexType", { kind: "block", type: I.pick_effect }), N.Blocks[I.pick_cloth_skin] = UC, i.set("ClothID", { kind: "block", type: I.pick_cloth_skin }), N.Blocks[I.pick_weapon_skin] = VC, i.set("WeaponSkinID", { kind: "block", type: I.pick_weapon_skin }), N.Blocks[I.pick_vehicle_skin] = QC, i.set("VehicleSkinID", { kind: "block", type: I.pick_vehicle_skin }), N.Blocks[I.pick_emote_skin] = GC, i.set("EmoteType", { kind: "block", type: I.pick_emote_skin }), N.Blocks[I.pick_obj3d] = xC, i.set("Object3DResourceID", { kind: "block", type: I.pick_obj3d }), N.Blocks[I.pick_bag_id] = KC, i.set("BagSkinID", { kind: "block", type: I.pick_bag_id }), N.Blocks[I.pick_skill_id] = jC, i.set("PlayerSkillID", { kind: "block", type: I.pick_skill_id }), N.Blocks[I.pick_pet_skill_id] = zC, i.set("PetSkillID", { kind: "block", type: I.pick_pet_skill_id }), N.Blocks[I.raw_resource] = ZC, i.set("RawResource", { kind: "block", type: I.raw_resource });
  for (let l of Fh) {
    let r = l[1];
    r && i.set("RawResource_" + r, { kind: "block", type: I.raw_resource, fields: {
      [E.Type]: r
    } });
  }
  N.Blocks[I.pick_dynamic_create_item] = ev, i.set("DynamicCreateItemID", { kind: "block", type: I.pick_dynamic_create_item }), N.Blocks[I.pick_effect_type] = tv, i.set("EffectType", { kind: "block", type: I.pick_effect_type }), i.set("EffectID", { kind: "block", type: I.pick_effect_type }), N.Blocks[I.pick_internal_hud] = rv, i.set("InternalHudType", { kind: "block", type: I.pick_internal_hud }), N.Blocks[I.pick_player_data_id] = HC, i.set("PlayerDataID", { kind: "block", type: I.pick_player_data_id }), N.Blocks[I.pick_persona_id] = YC, i.set("PersonaID", { kind: "block", type: I.pick_persona_id }), N.Blocks[I.pick_animation_clip_id] = XC, i.set("AnimationClipID", { kind: "block", type: I.pick_animation_clip_id }), N.Blocks[I.pick_animation_ctrl_id] = Zu("ac"), i.set("AnimationCtrlID", { kind: "block", type: I.pick_animation_ctrl_id }), N.Blocks[I.pick_material_id] = Zu("material"), i.set("MaterialID", { kind: "block", type: I.pick_material_id }), N.Blocks[I.pick_mesh_id] = Zu("mesh"), i.set("MeshID", { kind: "block", type: I.pick_mesh_id }), N.Blocks[I.pick_scene_id] = Zu("scene"), i.set("SceneID", { kind: "block", type: I.pick_scene_id }), N.Blocks[I.pick_particles_id] = Zu("particles"), i.set("ParticlesID", { kind: "block", type: I.pick_particles_id }), N.Blocks[I.pick_performance] = Zu("performance"), i.set("PerformanceID", { kind: "block", type: I.pick_performance });
}
const iv = [
  ["FE_39_M_RANKDATA", "Leaderboard"],
  ["FE_41_B_DATA_ACCUMULATED_SHEET", "Accumulation"],
  ["FE_39_M_ORDIDATA", "DataStore"]
], ov = {
  ReadValue: "FE_53A_HZY_DATASTORAGE_READ_VALUE",
  WriteValue: "FE_53A_HZY_DATASTORAGE_WRITE_VALUE",
  DeleteValue: "FE_53A_HZY_DATASTORAGE_DELETE_VALUE",
  BatchReadValue: "FE_53A_HZY_DATASTORAGE_BATCH_READ_VALUE",
  ReadAssociationValue: "FE_53A_HZY_DATASTORAGE_READ_ASSOCIATION_VALUE",
  WriteAssociationValue: "FE_53A_HZY_DATASTORAGE_WRITE_ASSOCIATION_VALUE",
  ReadColumnValue: "FE_53A_HZY_DATASTORAGE_READ_COLUMN_VALUE"
}, lv = [
  ["T_46_META_WS_E_FALSE", "No"],
  ["T_46_META_WS_E_TRUE", "Yes"]
], sv = {
  vReadCache: "FE_53A_HZY_DATASTORAGE_READ_CACHE",
  vWriteMode: "FE_53A_HZY_DATASTORAGE_WRITE_MODE",
  vDeleteBy: "FE_53A_HZY_DATASTORAGE_DELETE_BY",
  vReadBy: "FE_53A_HZY_DATASTORAGE_READ_BY"
}, av = {
  vReadCache: [["T_46_META_WS_E_TRUE", "true"], ["T_46_META_WS_E_FALSE", "false"]],
  vWriteMode: [["FE_53A_HZY_DATASTORAGE_BLOCKING", "Blocking"], ["FE_53A_HZY_DATASTORAGE_ASYNC", "Async"]],
  vDeleteBy: [["T_46_META_WS_A_KEY", "Key"], ["FE_53A_HZY_DATASTORAGE_ORDER", "Order"]],
  vReadBy: [["T_46_META_WS_A_KEY", "Key"], ["T_46_META_WS_A_RANGE", "Range"]]
}, rm = [
  // Data Store - ReadValue
  { name: "ReadDBSheetValue_V2", ref: "ReadDBSheetValue_V2", geid: 791, d1: "DataStore", d2: "ReadValue", d3: "No", vReadCache: "true" },
  { name: "ReadDBSheetValueNoCache", ref: "ReadDBSheetValueNoCache", geid: 1006, d1: "DataStore", d2: "ReadValue", d3: "No", vReadCache: "false" },
  { name: "ReadDBSheetValueByWorkshopCode_V2", ref: "ReadDBSheetValue_V2", geid: 801, d1: "DataStore", d2: "ReadValue", d3: "Yes", vReadCache: "true" },
  { name: "ReadDBSheetValueByWorkshopCodeNoCache", ref: "ReadDBSheetValueNoCache", geid: 999, d1: "DataStore", d2: "ReadValue", d3: "Yes", vReadCache: "false" },
  // Data Store - WriteValue
  { name: "WriteDBSheetValueBlocking", ref: "WriteDBSheetValueBlocking", geid: 793, d1: "DataStore", d2: "WriteValue", d3: "No", vWriteMode: "Blocking" },
  { name: "WriteDBSheetValueAsync", ref: "WriteDBSheetValueAsync", geid: 1017, d1: "DataStore", d2: "WriteValue", d3: "No", vWriteMode: "Async" },
  { name: "WriteDBSheetValueByWorkshopCodeBlocking", ref: "WriteDBSheetValueBlocking", geid: 803, d1: "DataStore", d2: "WriteValue", d3: "Yes", vWriteMode: "Blocking" },
  { name: "WriteDBSheetValueByWorkshopCodeAsync", ref: "WriteDBSheetValueAsync", geid: 1010, d1: "DataStore", d2: "WriteValue", d3: "Yes", vWriteMode: "Async" },
  // Data Store - DeleteValue
  { name: "DeleteDBSheetValueAsync", ref: "DeleteDBSheetValueAsync", geid: 1011, d1: "DataStore", d2: "DeleteValue", d3: "No" },
  { name: "DeleteDBSheetValueByWorkshopCodeAsync", ref: "DeleteDBSheetValueAsync", geid: 1012, d1: "DataStore", d2: "DeleteValue", d3: "Yes" },
  // Data Store - BatchReadValue
  { name: "BatchReadDBSheetValue", ref: "BatchReadDBSheetValue", geid: 819, d1: "DataStore", d2: "BatchReadValue", d3: "No" },
  { name: "BatchReadDBSheetValueByWorkshopCode", ref: "BatchReadDBSheetValue", geid: 837, d1: "DataStore", d2: "BatchReadValue", d3: "Yes" },
  // Data Store - ReadColumnValue
  { name: "ReadDBSheetColumnValue", ref: "ReadDBSheetColumnValue", geid: 952, d1: "DataStore", d2: "ReadColumnValue", d3: "No", vReadCache: "true" },
  { name: "ReadDBSheetColumnValueNoCache", ref: "ReadDBSheetColumnValueNoCache", geid: 997, d1: "DataStore", d2: "ReadColumnValue", d3: "No", vReadCache: "false" },
  { name: "ReadDBSheetColumnValueByWorkshopCode", ref: "ReadDBSheetColumnValue", geid: 953, d1: "DataStore", d2: "ReadColumnValue", d3: "Yes", vReadCache: "true" },
  { name: "ReadDBSheetColumnValueByWorkshopCodeNoCache", ref: "ReadDBSheetColumnValueNoCache", geid: 998, d1: "DataStore", d2: "ReadColumnValue", d3: "Yes", vReadCache: "false" },
  // Leaderboard - ReadValue
  { name: "ReadDBLeaderboardValue_V2", ref: "ReadDBLeaderboardValue_V2", geid: 794, d1: "Leaderboard", d2: "ReadValue", d3: "No", vReadBy: "Key" },
  { name: "ReadDBLeaderboardValuesByRange_V2", ref: "ReadDBLeaderboardValuesByRange_V2", geid: 798, d1: "Leaderboard", d2: "ReadValue", d3: "No", vReadBy: "Range" },
  { name: "ReadDBLeaderboardValueByWorkshopCode_V2", ref: "ReadDBLeaderboardValue_V2", geid: 804, d1: "Leaderboard", d2: "ReadValue", d3: "Yes", vReadBy: "Key" },
  { name: "ReadDBLeaderboardValuesByRangeAndWorkshopCode_V2", ref: "ReadDBLeaderboardValuesByRange_V2", geid: 808, d1: "Leaderboard", d2: "ReadValue", d3: "Yes", vReadBy: "Range" },
  // Leaderboard - WriteValue
  { name: "WriteDBLeaderboardValueAsync", ref: "WriteDBLeaderboardValueAsync", geid: 1013, d1: "Leaderboard", d2: "WriteValue", d3: "No" },
  { name: "WriteDBLeaderboardValueByWorkshopCodeAsync", ref: "WriteDBLeaderboardValueAsync", geid: 1014, d1: "Leaderboard", d2: "WriteValue", d3: "Yes" },
  // Leaderboard - DeleteValue
  { name: "DeleteDBLeaderboardValueByKeyAsync", ref: "DeleteDBLeaderboardValueByKeyAsync", geid: 1020, d1: "Leaderboard", d2: "DeleteValue", d3: "No", vDeleteBy: "Key" },
  { name: "DeleteDBLeaderboardValueByOrderAsync", ref: "DeleteDBLeaderboardValueByOrderAsync", geid: 1024, d1: "Leaderboard", d2: "DeleteValue", d3: "No", vDeleteBy: "Order" },
  { name: "DeleteDBLeaderboardValueByKeyAndWorkshopCodeAsync", ref: "DeleteDBLeaderboardValueByKeyAsync", geid: 1021, d1: "Leaderboard", d2: "DeleteValue", d3: "Yes", vDeleteBy: "Key" },
  { name: "DeleteDBLeaderboardValueByOrderAndWorkshopCodeAsync", ref: "DeleteDBLeaderboardValueByOrderAsync", geid: 1029, d1: "Leaderboard", d2: "DeleteValue", d3: "Yes", vDeleteBy: "Order" },
  // Leaderboard - ReadAssociationValue
  { name: "ReadDBLeaderboardAssociationValue", ref: "ReadDBLeaderboardAssociationValue", geid: 954, d1: "Leaderboard", d2: "ReadAssociationValue", d3: "No", vReadBy: "Key" },
  { name: "ReadDBLeaderboardAssociationValuesByRange", ref: "ReadDBLeaderboardAssociationValuesByRange", geid: 956, d1: "Leaderboard", d2: "ReadAssociationValue", d3: "No", vReadBy: "Range" },
  { name: "ReadDBLeaderboardAssociationValueByWorkshopCode", ref: "ReadDBLeaderboardAssociationValue", geid: 955, d1: "Leaderboard", d2: "ReadAssociationValue", d3: "Yes", vReadBy: "Key" },
  { name: "ReadDBLeaderboardAssociationValuesByRangeByWorkshop", ref: "ReadDBLeaderboardAssociationValuesByRange", geid: 957, d1: "Leaderboard", d2: "ReadAssociationValue", d3: "Yes", vReadBy: "Range" },
  // Leaderboard - WriteAssociationValue
  { name: "WriteDBLeaderboardAssociationValueAsync", ref: "WriteDBLeaderboardAssociationValueAsync", geid: 1022, d1: "Leaderboard", d2: "WriteAssociationValue", d3: "No" },
  { name: "WriteDBLeaderboardAssociationValueByWorkshopCodeAsync", ref: "WriteDBLeaderboardAssociationValueAsync", geid: 1023, d1: "Leaderboard", d2: "WriteAssociationValue", d3: "Yes" },
  // Accumulation - ReadValue
  { name: "ReadDBAccumulatedData_V2", ref: "ReadDBAccumulatedData_V2", geid: 799, d1: "Accumulation", d2: "ReadValue", d3: "No" },
  { name: "ReadDBAccumulatedDataByWorkshopCode_V2", ref: "ReadDBAccumulatedData_V2", geid: 809, d1: "Accumulation", d2: "ReadValue", d3: "Yes" },
  // Accumulation - WriteValue
  { name: "WriteDBAccumulatedDataOffsetAsync", ref: "WriteDBAccumulatedDataOffsetAsync", geid: 1015, d1: "Accumulation", d2: "WriteValue", d3: "No" },
  { name: "WriteDBAccumulatedDataOffsetByWorkshopCodeAsync", ref: "WriteDBAccumulatedDataOffsetAsync", geid: 1016, d1: "Accumulation", d2: "WriteValue", d3: "Yes" }
], fM = ["vReadCache", "vWriteMode", "vDeleteBy", "vReadBy"];
function nm(i) {
  return i.map(([l, r]) => [ye(l), r]);
}
function _v(i, l) {
  return `${i}|${l}`;
}
const cI = /* @__PURE__ */ new Map();
function cv(i, l) {
  const r = _v(i, l), o = cI.get(r);
  if (o)
    return o;
  const c = rm.filter((h) => h.d1 === i && h.d2 === l), T = [];
  for (const h of fM)
    c.some((y) => y[h] !== void 0) && T.push(h);
  const d = { vKeys: T };
  return cI.set(r, d), d;
}
function uv() {
  return nm(iv);
}
function Tv(i) {
  const l = /* @__PURE__ */ new Set();
  for (const r of rm)
    r.d1 === i && l.add(r.d2);
  return Array.from(l).map((r) => {
    const o = ov[r];
    return [o ? ye(o) : r, r];
  });
}
function pv() {
  return nm(lv);
}
function gh(i, l) {
  return cv(i, l);
}
function dv(i) {
  return nm(av[i] ?? []);
}
function Ev(i) {
  const l = sv[i];
  return l ? ye(l) : i;
}
function uI(i) {
  for (const l of rm) {
    if (l.d1 !== i.d1 || l.d2 !== i.d2 || l.d3 !== i.d3)
      continue;
    let r = !0;
    for (const o of fM) {
      const c = l[o], T = i[o];
      if (c !== void 0 && c !== T) {
        r = !1;
        break;
      }
      if (c === void 0 && T !== void 0) {
        r = !1;
        break;
      }
    }
    if (r)
      return { name: l.name, ref: l.ref, geid: l.geid };
  }
  return null;
}
const pT = {
  onchange(i) {
    if (i.type === lT.DATA_STORAGE_CHANGE) {
      const l = this.getField(E.Value);
      l == null || l.UpdateDisplay();
    }
  }
}, CM = {
  onchange(i) {
    if (i.type === lT.DATA_STORAGE_CHANGE) {
      const l = this.getField(E.Property + "2");
      l == null || l.UpdateDisplay();
    }
  }
};
let Av = {
  ...pT,
  geId: I.sheet_data,
  sheetTypeTypeChanged: !1,
  init() {
    const i = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new Je(i, (l) => (this.sheetTypeTypeChanged = !0, l)), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, Sv = {
  ...pT,
  geId: I.sheet_data_client,
  sheetTypeTypeChanged: !1,
  init() {
    const i = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new Je(i, (l) => (this.sheetTypeTypeChanged = !0, l)), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, hv = {
  ...pT,
  geId: I.sheet_rank,
  sheetTypeTypeChanged: !1,
  init() {
    const i = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new Je(i, (l) => (this.sheetTypeTypeChanged = !0, l)), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, mv = {
  ...pT,
  geId: I.sheet_statistic,
  init() {
    const i = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new Je(i), E.Value), this.setStyle("deprecated_blocks");
  },
  DetermineTypes() {
    return !0;
  }
}, Iv = {
  ...pT,
  geId: I.sheet_multicol,
  sheetTypeTypeChanged: !1,
  init() {
    const i = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new Je(i, (l) => (this.sheetTypeTypeChanged = !0, l)), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, Mv = {
  ...pT,
  geId: I.sheet_multicol_client,
  sheetTypeTypeChanged: !1,
  init() {
    const i = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
    this.setOutput(!0, "string"), this.appendDummyInput().appendField(new Je(i, (l) => (this.sheetTypeTypeChanged = !0, l)), E.Value), this.setStyle("data_blocks");
  },
  DetermineTypes() {
    return this.sheetTypeTypeChanged ? (this.sheetTypeTypeChanged = !1, !0) : !1;
  }
}, im = {
  ...CM,
  geId: I.read_statistic,
  locKey: re.ReadAcc,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("ReadDBAccumulatedData"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck(l[0].Type).connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput().appendField(
      new Vt({
        name: ye("T_40_XXJ_WS_RESULT_NAMEKEY"),
        type: "Int"
      }),
      E.Property + "3"
    ).appendField(Be(l[2].Label, l[2].Tip)), this.appendValueInput(E.Property + "4").appendField(Be(l[3].Label, l[3].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  },
  DetermineTypes() {
    const i = this.getField(E.Property + "2");
    return i == null || i.UpdateDisplay(), !1;
  },
  search(i) {
    return ["ReadDBAccumulatedData", f.ReadAcc].find((l) => J.containsKey(l, i)) || !1;
  },
  getSheetId() {
    const i = this.getInputTargetBlock(E.Property + "1");
    return (i == null ? void 0 : i.getFieldValue(E.Value)) || "";
  },
  getVarDefine(i, l, r) {
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let o = E.Property + "3", c = lo(this, o, i, r);
      if (c)
        return c;
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  }
}, gv = {
  ...im,
  geId: I.read_statistic_v2,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("ReadDBAccumulatedData"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck(l[0].Type).connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput().appendField(
      new Vt({
        name: ye("T_40_XXJ_WS_RESULT_NAMEKEY"),
        type: "Int"
      }),
      E.Property + "3"
    ).appendField(Be(l[2].Label, l[2].Tip)), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  }
}, Lv = {
  ...im,
  geId: I.read_statistic_err,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("ReadDBAccumulatedData_V2"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck(l[0].Type).setCheck("String").connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput().appendField(
      new Vt({
        name: ye("T_40_XXJ_WS_RESULT_NAMEKEY"),
        type: "Int"
      }),
      E.Property + "3"
    ).appendField(Be(l[2].Label, l[2].Tip));
    let r = ce.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(E.Property + "5").appendField(new Vt({ name: r.Label, type: l[4].Type }), E.Property + "5").appendField(Be(l[4].Label, l[4].Tip), E.Property + "5L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks");
  }
}, bS = {
  ...CM,
  geId: I.write_statistic,
  locKey: re.WriteAcc,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffset"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("String").connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "3").appendField(Be(l[2].Label, l[2].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int }), this.appendValueInput(E.Property + "4").appendField(Be(l[3].Label, l[3].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  },
  DetermineTypes() {
    const i = this.getField(E.Property + "2");
    return i == null || i.UpdateDisplay(), !1;
  },
  search(i) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((l) => J.containsKey(l, i)) || !1;
  },
  getSheetId() {
    const i = this.getInputTargetBlock(E.Property + "1");
    return (i == null ? void 0 : i.getFieldValue(E.Value)) || "";
  }
}, Nv = {
  ...bS,
  geId: I.write_statistic_v2,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffset"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("String").connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "3").appendField(Be(l[2].Label, l[2].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  }
}, yv = {
  ...bS,
  geId: I.write_statistic_err,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffset_V2"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("String").connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "3").appendField(Be(l[2].Label, l[2].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int });
    let r = ce.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(E.Property + "5").appendField(new Vt({ name: r.Label, type: r.Name }), E.Property + "5").appendField(Be(l[4].Label, l[4].Tip), E.Property + "5L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks"), this.setWarningText(ye(re.Warning_Deprecated), "NODEF"), this.setStyle("deprecated_blocks");
  }
}, fv = {
  ...bS,
  geId: I.write_statistic_err_v2,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffsetAsync"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be(i.Label, i.Tip)), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("String").connection.setShadowState({
      type: I.sheet_statistic
    }), this.appendDummyInput("").appendField(Be(l[1].Label, l[1].Tip)).appendField(new tc(), E.Property + "2"), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "3").appendField(Be(l[2].Label, l[2].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int });
    let r = ce.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(E.Property + "5").appendField(new Vt({ name: r.Label, type: r.Name }), E.Property + "5").appendField(Be(l[4].Label, l[4].Tip), E.Property + "5L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks");
  }
}, Cv = {
  geId: I.write_statistic_cross_map,
  locKey: re.WriteAcc,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffset"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be("*" + i.Label, i.Tip, "blocklyLowApiLevel")), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.appendValueInput(E.Property + "2").appendField(Be(l[1].Label, l[1].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "4").appendField(Be(l[3].Label, l[3].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int }), this.appendValueInput(E.Property + "5").appendField(Be(l[4].Label, l[4].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("deprecated_blocks");
  },
  loadExtraState() {
  },
  saveExtraState() {
    return {
      [E.Index]: 670
    };
  },
  search(i) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((l) => J.containsKey(l, i)) || !1;
  }
}, vv = {
  geId: I.write_statistic_cross_map_err,
  locKey: re.WriteAcc,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffset_V2"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be("*" + i.Label, i.Tip, "blocklyLowApiLevel")), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.appendValueInput(E.Property + "2").appendField(Be(l[1].Label, l[1].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "4").appendField(Be(l[3].Label, l[3].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int }), this.appendValueInput(E.Property + "5").appendField(Be(l[4].Label, l[4].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text });
    let r = ce.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(E.Property + "6").appendField(new Vt({ name: r.Label, type: r.Name }), E.Property + "6").appendField(Be(l[5].Label, l[5].Tip), E.Property + "6L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks"), this.setWarningText(ye(re.Warning_Deprecated), "NODEF"), this.setStyle("deprecated_blocks");
  },
  loadExtraState() {
  },
  saveExtraState() {
    return {
      [E.Index]: 810
    };
  },
  search(i) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((l) => J.containsKey(l, i)) || !1;
  },
  getVarDefine(i, l, r) {
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let o = E.Property + "6", c = lo(this, o, i, r);
      if (c)
        return c;
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  }
}, Rv = {
  geId: I.write_statistic_cross_map_err_v2,
  locKey: re.WriteAcc,
  init() {
    const i = ce.CurrentDescriptionFile.actions.get_Item("WriteDBAccumulatedDataOffsetAsync"), l = i.Items.array;
    this.appendDummyInput("").appendField(Be("*" + i.Label, i.Tip, "blocklyLowApiLevel")), this.appendValueInput(E.Property + "1").appendField(Be(l[0].Label, l[0].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.appendValueInput(E.Property + "2").appendField(Be(l[1].Label, l[1].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text }), this.appendDummyInput("").appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.appendValueInput(E.Property + "4").appendField(Be(l[3].Label, l[3].Tip)).setCheck("int").connection.setShadowState({ type: I.input_int }), this.appendValueInput(E.Property + "5").appendField(Be(l[4].Label, l[4].Tip)).setCheck("string").connection.setShadowState({ type: I.input_text });
    let r = ce.CurrentDescriptionFile.GetVarType("ErrorCode");
    this.appendDummyInput(E.Property + "6").appendField(new Vt({ name: r.Label, type: r.Name }), E.Property + "6").appendField(Be(l[5].Label, l[5].Tip), E.Property + "6L"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks");
  },
  loadExtraState() {
  },
  saveExtraState() {
    return {
      [E.Index]: 810
    };
  },
  search(i) {
    return ["WriteDBAccumulatedDataOffset", f.WriteAcc].find((l) => J.containsKey(l, i)) || !1;
  },
  getVarDefine(i, l, r) {
    if (l == bt.SelfDefine || l == bt.NextStatements) {
      let o = E.Property + "6", c = lo(this, o, i, r);
      if (c)
        return c;
    }
    return l == bt.NextStatements ? so(this, i, r) : null;
  }
};
class tc extends Gn {
  constructor(l, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], l, r), this.menuGenerator_ = this.getSheetKeys;
  }
  getSheetKeys() {
    return [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
  }
}
let Ov = {
  previousValue: null,
  init() {
    this.setOutput(!0, "TupleIndex"), this.appendDummyInput().appendField(new Dv(), E.Property), this.setStyle("data_blocks");
  },
  getSheetType() {
    let i = this.outputConnection.targetConnection, l = i == null ? void 0 : i.getCheck(), r = l == null ? void 0 : l[0];
    if (r) {
      const o = ce.CurrentDescriptionFile;
      let c = o.GetVarType(r);
      if (c && o.CheckIsExtention(o.getType("TupleIndex"), c))
        return c.ElementType;
    }
    return "";
  },
  DetermineTypes() {
    let i = this.getField(E.Property);
    i.UpdateDisplay();
    let l = i.getValue();
    return this.previousValue != l ? (this.previousValue = l, !0) : !1;
  }
};
class Dv extends Gn {
  constructor(l, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], l, r), this.menuGenerator_ = this.generateProperties;
  }
  getValueDefaultOptions(l) {
    var r;
    if (l) {
      const o = l.split("--"), c = o[0], T = o[1], h = ce.CurrentDescriptionFile.GetVarType(c), y = (r = h == null ? void 0 : h.Items) == null ? void 0 : r.get_Item(T);
      if (y)
        return [y.Name, `${c}--${T}`];
    }
    return [f.Unselected, l, "", { style: "fill: var(--red_err5);" }];
  }
  getSheetType() {
    return this.sourceBlock_ && "getSheetType" in this.sourceBlock_ ? this.sourceBlock_.getSheetType(this) : "";
  }
  generateProperties() {
    const l = this.getSheetType();
    if (!l)
      return [
        [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
      ];
    const o = ce.CurrentDescriptionFile.GetVarType(l);
    if (!o)
      return [
        [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
      ];
    const c = [];
    for (const T of o.Items)
      c.push([T.Label, `${l}--${T.Value}`]);
    return c.length ? c : [
      [f.Unselected, "", "", { style: "fill: var(--red_err5);" }]
    ];
  }
}
function Be(i, l, r) {
  let o = new N.FieldLabel(i);
  return o.setTooltip(l), r && o.setClass(r), o;
}
const oS = "NEW_LINE_API", $d = "EVA_TITLE_INPUT", Lh = "EVA_ASYNC_ICON_FIELD";
function K_(i) {
  return E.Dimensions + i;
}
let bv = {
  action: null,
  paramOrder: null,
  paramOpers: [],
  paramInfo: {},
  init() {
    this.appendDummyInput(K_("D1")).appendField(new Je(
      () => [[ye("FE_53A_HZY_DATASTORAGE_SELECT_TYPE"), "", "", { style: "fill: var(--red_err5);" }], ...uv()]
    ), "D1"), this.setInputsInline(!0), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("module_blocks"), this.setTooltip(ye("FE_53A_HZY_DATASTORAGE_BLOCK_D"));
  },
  getRenderedDimKeys() {
    return this.inputList.map((i) => i.name).filter((i) => !!i && i.startsWith(E.Dimensions)).map((i) => i.slice(E.Dimensions.length));
  },
  buildNextDimension() {
    const i = this.getFieldValue("D1");
    if (!i)
      return;
    if (!this.getInput(K_("D2"))) {
      const c = Tv(i);
      this.appendDummyInput(K_("D2")).appendField(ye("FE_53A_HZY_DATASTORAGE_OPERATION")).appendField(new Je(
        () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }], ...c]
      ), "D2");
      return;
    }
    const l = this.getFieldValue("D2");
    if (!l)
      return;
    const r = gh(i, l);
    for (const c of r.vKeys) {
      if (!this.getInput(K_(c))) {
        const d = dv(c);
        this.appendDummyInput(K_(c)).appendField(Ev(c)).appendField(new Je(
          () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }], ...d]
        ), c);
        return;
      }
      if (!this.getFieldValue(c))
        return;
    }
    if (!this.getInput(K_("D3"))) {
      this.appendDummyInput(K_("D3")).appendField(ye("FE_53A_HZY_DATASTORAGE_BY_WORKSHOP_CODE")).appendField(new Je(
        () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }], ...pv()]
      ), "D3");
      return;
    }
    this.getFieldValue("D3") && this.tryResolveAndRender();
  },
  tryResolveAndRender() {
    const i = this.collectDimensions(), l = uI(i);
    if (!l) {
      this.removeActionParams();
      return;
    }
    this.renderActionParams(l.ref, l.geid);
  },
  collectDimensions() {
    const i = {};
    i.d1 = this.getFieldValue("D1") || void 0, i.d2 = this.getFieldValue("D2") || void 0, i.d3 = this.getFieldValue("D3") || void 0;
    const l = i.d1, r = i.d2;
    if (l && r) {
      const o = gh(l, r);
      for (const c of o.vKeys) {
        const T = this.getFieldValue(c);
        T && (i[c] = T);
      }
    }
    return i;
  },
  renderActionParams(i, l) {
    const r = ce.CurrentDescriptionFile, o = r.actions.get_Item(i);
    if (!o) {
      this.removeActionParams(), this.setWarningText(`API "${i}" not found in description`, "NODEF");
      return;
    }
    this.getInput(oS) || this.appendDummyInput(oS), this.action = o, this.updateTitle_(o.Label), this.setWarningText(null, "NODEF");
    const c = J.graphElementMap.get(l) ?? null;
    c ? (this.geId = c.id, this.paramInfo = mS.cloneDeep(c.ParsedParamInfo) ?? {}) : this.paramInfo = {};
    const T = c == null ? void 0 : c.ParsedParamOrder;
    if (this.paramOrder = [], this.paramOpers = [], T)
      T.forEach((d, h) => {
        if (this.paramOrder.push(d), d === -1) {
          this.appendDummyInput("NEW_LINE_" + h);
          return;
        }
        const y = o.Items.get_Item(d - 1), b = y && y.Main === "out" ? Ht.OutVar : Ht.InVar;
        this.paramOpers[d - 1] = b, y ? dS(this, r, o, y, d, b) : Oi(this, d, b);
      });
    else {
      let d = 1;
      for (const h of o.Items) {
        this.paramOrder.push(d);
        const y = h.Main === "out" ? Ht.OutVar : Ht.InVar;
        this.paramOpers[d - 1] = y, dS(this, r, o, h, d, y), d++;
      }
    }
    this.setTooltip(Ol(o, !1, l)), this.DetermineTypes = void 0, c != null && c.fe_custom && (this.DetermineTypes = kI(c.fe_custom), aT(this));
  },
  removeActionParams() {
    if (this.removeTitleInput_(), this.getInput(oS) && this.removeInput(oS), this.paramOrder)
      for (const [i, l] of this.paramOrder.entries()) {
        if (l === -1) {
          const o = "NEW_LINE_" + i;
          this.getInput(o) && this.removeInput(o);
          continue;
        }
        const r = Rl(l);
        this.getInput(r) && this.removeInput(r);
      }
    this.paramOrder = null, this.paramOpers = [], this.action = null, this.paramInfo = {}, this.DetermineTypes = void 0, this.geId = I.data_storage_integrate, this.setTooltip(ye("FE_53A_HZY_DATASTORAGE_BLOCK_D"));
  },
  saveExtraState() {
    const i = this.collectDimensions(), l = uI(i);
    return {
      [E.Dimensions]: i,
      [E.Index]: (l == null ? void 0 : l.geid) ?? 0,
      [E.Type]: (l == null ? void 0 : l.ref) ?? "",
      [E.ParamList]: this.paramOrder,
      [E.Operator]: this.paramOpers
    };
  },
  loadExtraState(i) {
    if (!i || typeof i != "object")
      return;
    const l = i[E.Dimensions] ?? i.dimensions ?? {};
    if (l.d1 && (this.setFieldValue(l.d1, "D1"), this.buildNextDimension()), l.d2 && (this.setFieldValue(l.d2, "D2"), this.buildNextDimension()), l.d1 && l.d2) {
      const r = gh(l.d1, l.d2);
      for (const o of r.vKeys) {
        const c = l[o];
        c && (this.setFieldValue(c, o), this.buildNextDimension());
      }
    }
    l.d3 && (this.setFieldValue(l.d3, "D3"), this.buildNextDimension()), (i[E.ParamList] || i.paramOrder) && (this.paramOrder = i[E.ParamList] ?? i.paramOrder, this.paramOpers = i[E.Operator] ?? i.paramOpers ?? []);
  },
  ensureTitleInput_() {
    this.getInput($d) || this.appendDummyInput($d).appendField("", E.Label);
  },
  removeTitleInput_() {
    this.getInput($d) && this.removeInput($d);
  },
  updateTitle_(i) {
    this.ensureTitleInput_(), this.setFieldValue(i, E.Label), this.syncAsyncIcon_();
  },
  syncAsyncIcon_() {
    var r;
    const i = this.getInput($d);
    if (!i)
      return;
    const l = i.fieldRow.some((o) => o.name === Lh);
    if (!((r = this.action) != null && r.IsAsync)) {
      l && i.removeField(Lh, !0);
      return;
    }
    if (!l) {
      const o = new N.FieldImage(vI, 20, 20, "async");
      o.setTooltip(ye("FE_53A_HZY_BLOCK_ASYNCHRONOUS")), i.insertFieldAt(0, o, Lh);
    }
  }
}, Pv = {
  geId: I.statistic_sheet_operation,
  init() {
    this.setOutput(!0, "int"), this.appendDummyInput().appendField(new Je(
      [
        ["+=", dt.Add],
        ["-=", dt.Substract]
      ]
    ), E.Operator), this.setStyle("data_blocks");
  }
};
function $v(i) {
  N.Blocks[I.sheet_data] = Av, N.Blocks[I.sheet_data_client] = Sv, N.Blocks[I.sheet_rank] = hv, N.Blocks[I.sheet_statistic] = mv, N.Blocks[I.sheet_multicol] = Iv, N.Blocks[I.sheet_multicol_client] = Mv, N.Blocks[I.read_statistic] = im, N.Blocks[I.write_statistic] = bS, N.Blocks[I.read_statistic_v2] = gv, N.Blocks[I.write_statistic_v2] = Nv, N.Blocks[I.write_statistic_cross_map] = Cv, N.Blocks[I.read_statistic_err] = Lv, N.Blocks[I.write_statistic_err] = yv, N.Blocks[I.write_statistic_cross_map_err] = vv, N.Blocks[I.write_statistic_err_v2] = fv, N.Blocks[I.write_statistic_cross_map_err_v2] = Rv, N.Blocks[I.statistic_sheet_operation] = Pv, N.Blocks[I.sheet_column] = Ov, N.Blocks[I.data_storage_integrate] = bv, i.set("DataSheet", { kind: "block", type: I.sheet_data }), i.set("DataSheetClient", { kind: "block", type: I.sheet_data_client }), i.set("RankSheet", { kind: "block", type: I.sheet_rank }), i.set("MulticolSheet", { kind: "block", type: I.sheet_multicol }), i.set("MulticolSheetClient", { kind: "block", type: I.sheet_multicol_client }), i.set("SheetColumn", { kind: "block", type: I.sheet_column }), i.set("StatisticalSheet", { kind: "block", type: I.sheet_statistic }), i.set("ReadStatisticalSheet", { kind: "block", type: I.read_statistic }), i.set("WriteStatisticalSheet", { kind: "block", type: I.write_statistic }), i.set("ReadStatisticalSheetV2", { kind: "block", type: I.read_statistic_v2 }), i.set("WriteStatisticalSheetV2", { kind: "block", type: I.write_statistic_v2 }), i.set("WriteStatisticalSheetCrossMap", { kind: "block", type: I.write_statistic_cross_map }), i.set("ReadStatisticalSheet_ERR", { kind: "block", type: I.read_statistic_err }), i.set("WriteStatisticalSheet_ERR", { kind: "block", type: I.write_statistic_err }), i.set("WriteStatisticalSheetCross_ERR", { kind: "block", type: I.write_statistic_cross_map_err }), i.set("WriteStatisticalSheet_ERR_V2", { kind: "block", type: I.write_statistic_err_v2 }), i.set("WriteStatisticalSheetCross_ERR_V2", { kind: "block", type: I.write_statistic_cross_map_err_v2 }), i.set("StatisticSheetOperation", { kind: "block", type: I.statistic_sheet_operation }), i.set("DataStorageIntegrate", { kind: "block", type: I.data_storage_integrate });
}
var lT;
((i) => {
  i.DATA_STORAGE_CHANGE = "data_storage_change";
  class l extends N.Events.Abstract {
    constructor(c) {
      super();
      C(this, "defineKey");
      C(this, "isBlank");
      this.type = i.DATA_STORAGE_CHANGE, this.workspaceId = c;
    }
  }
  i.DataStorageChange = l;
})(lT || (lT = {}));
N.registry.register(
  N.registry.Type.EVENT,
  lT.DATA_STORAGE_CHANGE,
  lT.DataStorageChange
);
const Wv = 1;
function io(i, l, r, o, c = !1) {
  var Z;
  let T = l.GetVarType(r.Type), d = T, h = Rl(o), y = null, b = i.paramInfo[h];
  if (b) {
    let le = b.inputType;
    le && (d = l.GetVarType(le)), b.bShadow && (y = b.block);
  }
  d || (d = T);
  const U = i.getInput(h);
  if (c)
    U && i.removeInput(h), i.appendDummyInput(h).appendField(new Vt({ name: r.Label, type: r.Type }), h);
  else {
    let le;
    U && ((Z = U.connection) != null && Z.targetBlock() && (le = U.connection.targetConnection, U.connection.disconnect()), i.removeInput(h));
    let ue = i.appendValueInput(h).appendField(r.Label).setCheck(r.Type);
    ue.fieldRow[0].setTooltip(r.Tip), y ?? (y = EM(d, l, r.Type, b)), li(ue, y), le && ue.connection.connect(le), sn(ue, r.Type);
  }
}
function PS(i, l, r) {
  return !1;
}
const vM = {
  ...Uo,
  ecatype: "action",
  fixOwnerType: "HudSignalWidget",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.common_init(), this.setStyle("event_blocks");
  },
  updateShape_() {
    let i = ce.CurrentDescriptionFile, l = this.action;
    if (l == null) {
      let o = this.paramOrder;
      if (o)
        for (let c of o)
          Oi(this, c, Ht.InVar);
      return;
    }
    if (l.Type) {
      let o = i.GetVarType(l.Type);
      o && "" + f.FunctionDefineReturn + o.Label;
    }
    this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [l.Label]), l.m_ApiLevel);
    let r = this.paramOrder;
    if (r == null) {
      this.paramOrder = [];
      let o = 1;
      for (let c of l.Items)
        this.paramOrder.push(o), io(this, i, c, o), o++;
    } else
      for (let o of r) {
        let c = l.Items.get_Item(o - 1);
        c == null ? Oi(this, o, Ht.InVar) : io(this, i, c, o);
      }
  },
  search(i, l) {
    return PS();
  },
  UpdateDisplay() {
    if (this.geId) {
      let i = J.graphElementMap.get(this.geId);
      i && this.resolveApi(i.ref, i.ParsedParamOrder);
    } else
      this.apiname && this.resolveApi(this.apiname);
    if (this.action) {
      let i = this.action;
      this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [i.Label]), i.m_ApiLevel);
    }
  }
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(deleteSignal);
  //     }
  // },
}, kv = {
  ...vM,
  updateShape_() {
    let i = ce.CurrentDescriptionFile;
    if (this.action == null) {
      let l = this.paramOrder;
      if (l)
        for (let r of l)
          Oi(this, r, Ht.InVar);
      return;
    }
    if (this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [this.action.Label])), this.paramOrder)
      for (let l of this.paramOrder) {
        const r = this.action.Items.get_Item(l - 1);
        r ? io(this, i, r, l) : Oi(this, l, Ht.InVar);
      }
    else {
      this.paramOrder = [];
      let l = Wv;
      for (let r of this.action.Items)
        this.paramOrder.push(l), io(this, i, r, l), l++;
    }
  }
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(deleteSignal);
  //     }
  // },
}, wv = {
  ...Uo,
  old_loadExtraState: Uo.loadExtraState,
  loadExtraState(i) {
    this.hasCrossPlatform = !!(i != null && i[E.Code]), this.old_loadExtraState(i);
  },
  saveExtraState() {
    var i;
    return {
      [E.Index]: this.geId,
      [E.ParamList]: this.paramOrder,
      [E.Operator]: this.paramOpers,
      [E.Type]: (i = this.action) == null ? void 0 : i.Name,
      [E.OwnerType]: this.fixOwnerType,
      [E.Code]: this.hasCrossPlatform
    };
  },
  ecatype: "signal",
  hasCrossPlatform: !1,
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.common_init(), this.setStyle("event_blocks");
  },
  updateShape_() {
    let i = ce.CurrentDescriptionFile, l = this.action, r = l == null ? void 0 : l.owner, o = this.appendValueInput(E.Owner).appendField(ye("T_34_M_WS_ENTITY")).setCheck(r);
    if (o.fieldRow[0].setTooltip(ye("T_40_XXJ_WS_TARGETENTITY_DESCKEY")), li(o, { type: I.shadow_type, extraState: r }), this.hasCrossPlatform) {
      let T = this.appendValueInput(E.V1).appendField(ye("T_43_YU_WS_CROSSPLATFORM")).setCheck("Bool");
      T.fieldRow[0].setTooltip(ye("T_43_YU_WS_CROSSPLATFORM_D")), li(T, { type: I.input_boolean });
    }
    if (l == null) {
      let T = this.paramOrder;
      if (T)
        for (let d of T)
          Oi(this, d, Ht.InVar);
      return;
    }
    this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [l.Label]));
    let c = this.paramOrder;
    if (c == null) {
      this.paramOrder = [];
      let T = 1;
      for (let d of l.Items)
        this.paramOrder.push(T), io(this, i, d, T), T++;
    } else
      for (let T of c) {
        let d = l.Items.get_Item(T - 1);
        d == null ? Oi(this, T, Ht.InVar) : io(this, i, d, T);
      }
  },
  search(i, l) {
    return PS();
  },
  updateTitle() {
    this.action && this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [this.action.Label]), this.action.m_ApiLevel);
  }
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(deleteSignal);
  //     }
  // },
}, RM = {
  ...Uo,
  loadExtraState(i) {
    let l = i[E.Type];
    this.apiname = l, this.paramOrder = i[E.ParamList], this.paramInfo = {}, i[E.OwnerType] && (this.fixOwnerType = i[E.OwnerType]), this.geId = 0, this.resolveApi(l), this.updateShape_();
  },
  onchange(i) {
    if (i.type === N.Events.FINISHED_LOADING && this.UpdateDisplay(), i.type === xd.CUSTOM_BLOCK_DEFINE_CHANGE) {
      const l = this.action;
      if (i.defineKey === (l == null ? void 0 : l.Name)) {
        const o = i.ownerType;
        o && (this.fixOwnerType = o), this.resolveApi(l.Name), this.UpdateDisplay();
      }
    }
  }
}, Fv = {
  ...RM,
  ecatype: "signal",
  init() {
    this.common_init(), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setStyle("event_blocks");
  },
  // customContextMenu(options: Array<Blockly.ContextMenuRegistry.ContextMenuOption | Blockly.ContextMenuRegistry.LegacyContextMenuOption>) {
  //     const action = (this as Blockly.Block as IBlockEVACommon).action;
  //     if (this.isInFlyout && action && !action.m_ModuleLib) {
  //         const editSignal = {
  //             text: $t('FE_45_XXJ_EDITCUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(ICommandModule).Send(
  //                     ECommandActionIds.menu_event_setting,
  //                     true,
  //                     action.Name
  //                 );
  //             },
  //         };
  //         const deleteSignal = {
  //             text: $t('FE_45_XXJ_DELETECUSTOMEVENT', [action.Label]),
  //             enabled: true,
  //             callback: () => {
  //                 GModuleManager.Get(IEventManagementModule).deleteCustomEvent(action as ECAPackage.ECAEventDefine);
  //             },
  //         };
  //         options.push(editSignal, deleteSignal);
  //     }
  // },
  updateShape_() {
    const i = () => {
      const d = ce.CurrentDescriptionFile, h = [], y = d.GetVarType("PlatformType");
      for (let b of y.Items)
        h.push([b.Label, b.Value]);
      return h;
    };
    let l = ce.CurrentDescriptionFile, r = this.action, o = r == null ? void 0 : r.owner, c = this.appendValueInput(E.Owner).appendField(ye("T_34_M_WS_ENTITY")).setCheck(o);
    if (c.fieldRow[0].setTooltip(ye("T_40_XXJ_WS_TARGETENTITY_DESCKEY")), li(c, { type: I.shadow_type, extraState: o }), this.appendDummyInput(E.Condition).appendField(ye("T_45_XXJ_WS_TARGETSIDE")).appendField(new Gn(i), E.To), r == null) {
      let d = this.paramOrder;
      if (d)
        for (let h of d)
          Oi(this, h, Ht.InVar);
      return;
    }
    this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [r.Label]));
    let T = this.paramOrder;
    if (T == null) {
      this.paramOrder = [];
      let d = 1;
      for (let h of r.Items)
        this.paramOrder.push(d), io(this, l, h, d), d++;
    } else
      for (let d of T) {
        let h = r.Items.get_Item(d - 1);
        h == null ? Oi(this, d, Ht.InVar) : io(this, l, h, d);
      }
  },
  UpdateDisplay() {
    N.Events.disable();
    let i = ce.CurrentDescriptionFile, l = this.action;
    if (!l) {
      N.Events.enable();
      return;
    }
    let r = l == null ? void 0 : l.owner, o = this.getInput(E.Owner);
    o == null || o.setCheck(r), li(o, { type: I.shadow_type, extraState: r }), this.updateTitle_(ye("FE_49_XXJ_SENDEVENT", [l.Label])), this.paramOrder = [];
    let c = 1;
    for (let d of l.Items)
      this.paramOrder.push(c), io(this, i, d, c), c++;
    let T = Rl(c);
    for (; this.getInput(T); )
      this.removeInput(T, !0), c++, T = Rl(c);
    N.Events.enable();
  },
  search(i, l) {
    return PS();
  }
}, Bv = {
  ...RM,
  ecatype: "event",
  init() {
    this.hat = "cap", this.common_init(), this.setNextStatement(!0, "action"), this.setStyle("event_blocks");
  },
  updateShape_() {
    let i = ce.CurrentDescriptionFile, l = this.action;
    if (l == null) {
      let c = this.paramOrder;
      if (c)
        for (let T of c)
          Oi(this, T, Ht.OutVar);
      return;
    }
    let r = "";
    if (l.Type) {
      let c = i.GetVarType(l.Type);
      c && (r = `
` + f.FunctionDefineReturn + " " + c.Label);
    }
    this.setTooltip(l.Tip + r), this.updateTitle();
    let o = this.paramOrder;
    if (o == null) {
      this.paramOrder = [];
      let c = 1;
      for (let T of l.Items)
        this.paramOrder.push(c), io(this, i, T, c, !0), c++;
    } else
      for (let c of o) {
        let T = l.Items.get_Item(c - 1);
        T == null ? Oi(this, c, Ht.OutVar) : io(this, i, T, c, !0);
      }
  },
  UpdateDisplay() {
    N.Events.disable();
    let i = ce.CurrentDescriptionFile, l = this.action;
    if (!l) {
      N.Events.enable();
      return;
    }
    this.updateTitle(), this.paramOrder = [];
    let r = 1;
    for (let c of l.Items)
      this.paramOrder.push(r), io(this, i, c, r, !0), r++;
    let o = Rl(r);
    for (; this.getInput(o); )
      this.removeInput(o, !0), r++, o = Rl(r);
    N.Events.enable();
  },
  search(i, l) {
    return PS();
  },
  updateTitle() {
    this.action && this.updateTitle_(ye("FE_49_XXJ_RECEIVEEVENT", [this.action.Label]), this.action.m_ApiLevel);
  }
};
function Uv(i) {
  N.Blocks[I.signal_shoot] = vM, N.Blocks[I.signal_shootv2] = kv, N.Blocks[I.signal_receive] = Bv, N.Blocks[I.signal_shootV3] = wv, N.Blocks[I.signal_shootV4] = Fv;
}
const Vv = {
  geId: I.vector3_operation,
  locKey: re.VectorOperation,
  operator: et.Addition,
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector3"), this.appendValueInput(E.V1).setCheck("Vector3").appendField(f.VectorOperation).connection.setShadowState({
      type: I.input_vector3
    }), this.appendDummyInput().appendField(
      new Je(
        [
          ["+", et.Addition],
          ["-", et.Subtraction],
          ["x", et.Multiplication],
          [f.VectorDotProduct, et.DotProduct],
          [f.VectorCrossProduct, et.CrossProduct],
          [f.VectorDistance, et.Distance],
          [f.VectorIncludedAngle, et.IncludedAngle]
        ],
        (i) => (this.updateShape_(i), i)
      ),
      E.Operator
    ), this.appendValueInput(E.V2).setCheck("Vector3").connection.setShadowState({
      type: I.input_vector3
    }), this.setStyle("data_blocks");
  },
  loadExtraState(i) {
    this.updateShape_(i == null ? void 0 : i[E.Operator]);
  },
  saveExtraState() {
    return {
      [E.Operator]: this.operator
    };
  },
  updateShape_(i) {
    var d, h, y, b;
    const l = (U) => {
      switch (U) {
        case et.Addition:
        case et.Subtraction:
        case et.Multiplication:
        case et.CrossProduct:
          return "Vector3";
        case et.DotProduct:
        case et.Distance:
        case et.IncludedAngle:
          return "float";
        default:
          return "";
      }
    };
    this.setOutput(!!l(i), l(i));
    const r = ce.CurrentDescriptionFile;
    let o;
    switch (i) {
      case et.Addition:
        o = r.variables.get_Item("VectorAdd");
        break;
      case et.Subtraction:
        o = r.variables.get_Item("VectorSub");
        break;
      case et.Multiplication:
        o = r.variables.get_Item("VectorMul");
        break;
      case et.DotProduct:
        o = r.variables.get_Item("VectorDot");
        break;
      case et.CrossProduct:
        o = r.variables.get_Item("VectorCross");
        break;
      case et.Distance:
        o = r.variables.get_Item("VectorDistance");
        break;
      case et.IncludedAngle:
        o = r.variables.get_Item("VectorAngel");
        break;
    }
    if (o) {
      const U = Ol(o);
      this.setTooltip(U);
    } else
      this.setTooltip("");
    if (this.operator === i)
      return;
    const c = (U) => U === et.Multiplication ? "InputNumber" : "Vector3", T = this.operator;
    this.operator = i, c(T) !== c(i) && (c(i) === "InputNumber" ? (h = (d = this.getInput(E.V2)) == null ? void 0 : d.setCheck("float")) == null || h.connection.setShadowState({
      type: I.input_float
    }) : (b = (y = this.getInput(E.V2)) == null ? void 0 : y.setCheck("Vector3")) == null || b.connection.setShadowState({
      type: I.input_vector3
    }));
  },
  search(i) {
    return [f.VectorOperation].find((l) => J.containsKey(l, i)) || !1;
  }
}, Gv = {
  geId: I.vector3_get,
  locKey: re.VectorGetter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "float"), this.appendValueInput(E.Value).setCheck("Vector3").appendField(f.VectorGetter).appendField(
      new Je(
        [
          ["X", "X"],
          ["Y", "Y"],
          ["Z", "Z"]
        ],
        (i) => (this.property = i, this.updateTooltip(i), i)
      ),
      E.Property
    ).connection.setShadowState({
      type: I.input_vector3
    });
  },
  loadExtraState(i) {
    this.updateTooltip(i == null ? void 0 : i[E.Property]);
  },
  saveExtraState() {
    return {
      [E.Property]: this.property
    };
  },
  updateTooltip(i) {
    const l = ce.CurrentDescriptionFile;
    let r, o = "";
    switch (i) {
      case "X":
        r = l.variables.get_Item("VectorGetX");
        break;
      case "Y":
        r = l.variables.get_Item("VectorGetY");
        break;
      case "Z":
        r = l.variables.get_Item("VectorGetZ");
        break;
    }
    r && (o = Ol(r)), this.setTooltip(o);
  },
  search(i) {
    return [f.VectorGetter].find((l) => J.containsKey(l, i)) || !1;
  }
}, xv = {
  geId: I.vector3_set,
  locKey: re.VectorSetter,
  property: "X",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.setStyle("data_blocks"), this.appendValueInput(E.Item).setCheck("Vector3").appendField(f.VectorSetter).appendField(
      new Je(
        [
          ["X", "X"],
          ["Y", "Y"],
          ["Z", "Z"]
        ],
        (i) => (this.property = i, this.updateTooltip(i), i)
      ),
      E.Property
    ).connection.setShadowState({
      type: I.input_vector3
    }), this.appendValueInput(E.Value).setCheck("float").connection.setShadowState({
      type: I.input_float
    });
  },
  loadExtraState(i) {
    this.updateTooltip(i == null ? void 0 : i[E.Property]);
  },
  saveExtraState() {
    return {
      [E.Property]: this.property
    };
  },
  updateTooltip(i) {
    const l = ce.CurrentDescriptionFile;
    let r, o = "";
    switch (i) {
      case "X":
        r = l.actions.get_Item("VectorSetX");
        break;
      case "Y":
        r = l.actions.get_Item("VectorSetY");
        break;
      case "Z":
        r = l.actions.get_Item("VectorSetZ");
        break;
    }
    r && (o = Ol(r)), this.setTooltip(o);
  },
  search(i) {
    return [f.VectorSetter].find((l) => J.containsKey(l, i)) || !1;
  }
}, Hv = {
  geId: I.vector3_setxyz,
  locKey: re.VectorSetter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector3"), this.setStyle("data_blocks"), this.appendValueInput(E.Item).setCheck("Vector3").appendField(f.VectorSetter).appendField(
      new Je(
        [
          ["X", "X"],
          ["Y", "Y"],
          ["Z", "Z"]
        ],
        (i) => (this.property = i, this.updateTooltip(i), i)
      ),
      E.Property
    ).connection.setShadowState({
      type: I.input_vector3
    }), this.appendValueInput(E.Value).setCheck("float").connection.setShadowState({
      type: I.input_float
    });
  },
  loadExtraState(i) {
    this.updateTooltip(i == null ? void 0 : i[E.Property]);
  },
  saveExtraState() {
    return {
      [E.Property]: this.property
    };
  },
  updateTooltip(i) {
    const l = ce.CurrentDescriptionFile;
    let r, o = "";
    switch (i) {
      case "X":
        r = l.variables.get_Item("VectorSetXClient");
        break;
      case "Y":
        r = l.variables.get_Item("VectorSetYClient");
        break;
      case "Z":
        r = l.variables.get_Item("VectorSetZClient");
        break;
    }
    r && (o = Ol(r)), this.setTooltip(o);
  },
  search(i) {
    return [f.VectorSetter].find((l) => J.containsKey(l, i)) || !1;
  }
}, Yv = {
  geId: I.vector2_operation,
  locKey: re.Vector2Operation,
  operator: et.Addition,
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector2"), this.appendValueInput(E.V1).setCheck("Vector2").appendField(f.Vector2Operation).connection.setShadowState({
      type: I.input_vector2
    }), this.appendDummyInput().appendField(
      new Je(
        [
          ["+", et.Addition],
          ["-", et.Subtraction],
          ["x", et.Multiplication],
          [f.VectorDotProduct, et.DotProduct],
          [f.VectorDistance, et.Distance],
          [f.VectorIncludedAngle, et.IncludedAngle]
        ],
        (i) => (this.updateShape_(i), i)
      ),
      E.Operator
    ), this.appendValueInput(E.V2).setCheck("Vector2").connection.setShadowState({
      type: I.input_vector2
    }), this.setStyle("data_blocks");
  },
  loadExtraState(i) {
    this.updateShape_(i == null ? void 0 : i[E.Operator]);
  },
  saveExtraState() {
    return {
      [E.Operator]: this.operator
    };
  },
  updateShape_(i) {
    var d, h, y, b;
    const l = (U) => {
      switch (U) {
        case et.Addition:
        case et.Subtraction:
        case et.Multiplication:
          return "Vector2";
        case et.DotProduct:
        case et.Distance:
        case et.IncludedAngle:
          return "float";
        default:
          return "";
      }
    };
    this.setOutput(!!l(i), l(i));
    const r = ce.CurrentDescriptionFile;
    let o;
    switch (i) {
      case et.Addition:
        o = r.variables.get_Item("Vector2Add");
        break;
      case et.Subtraction:
        o = r.variables.get_Item("Vector2Sub");
        break;
      case et.Multiplication:
        o = r.variables.get_Item("Vector2Scale");
        break;
      case et.DotProduct:
        o = r.variables.get_Item("Vector2Dot");
        break;
      case et.Distance:
        o = r.variables.get_Item("Vector2Distance");
        break;
      case et.IncludedAngle:
        o = r.variables.get_Item("Vector2Angle");
        break;
    }
    if (o) {
      const U = Ol(o);
      this.setTooltip(U);
    } else
      this.setTooltip("");
    if (this.operator === i)
      return;
    const c = (U) => U === et.Multiplication ? "InputNumber" : "Vector2", T = this.operator;
    this.operator = i, c(T) !== c(i) && (c(i) === "InputNumber" ? (h = (d = this.getInput(E.V2)) == null ? void 0 : d.setCheck("float")) == null || h.connection.setShadowState({
      type: I.input_float
    }) : (b = (y = this.getInput(E.V2)) == null ? void 0 : y.setCheck("Vector2")) == null || b.connection.setShadowState({
      type: I.input_vector2
    }));
  },
  search(i) {
    return [f.Vector2Operation].find((l) => J.containsKey(l, i)) || !1;
  }
}, Xv = {
  geId: I.vector2_get,
  locKey: re.Vector2Getter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setStyle("data_blocks"), this.setOutput(!0, "float"), this.appendValueInput(E.Value).setCheck("Vector2").appendField(f.Vector2Getter).appendField(
      new Je(
        [
          ["X", "X"],
          ["Y", "Y"]
        ],
        (i) => (this.property = i, this.updateTooltip(i), i)
      ),
      E.Property
    ).connection.setShadowState({
      type: I.input_vector2
    });
  },
  loadExtraState(i) {
    this.updateTooltip(i == null ? void 0 : i[E.Property]);
  },
  saveExtraState() {
    return {
      [E.Property]: this.property
    };
  },
  updateTooltip(i) {
    const l = ce.CurrentDescriptionFile;
    let r, o = "";
    switch (i) {
      case "X":
        r = l.variables.get_Item("Vector2GetX");
        break;
      case "Y":
        r = l.variables.get_Item("Vector2GetY");
        break;
    }
    r && (o = Ol(r)), this.setTooltip(o);
  },
  search(i) {
    return [f.Vector2Getter].find((l) => J.containsKey(l, i)) || !1;
  }
}, Kv = {
  geId: I.vector2_set,
  locKey: re.Vector2Setter,
  property: "X",
  init() {
    this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.setInputsInline(!0), this.setStyle("data_blocks"), this.appendValueInput(E.Item).setCheck("Vector2").appendField(f.Vector2Setter).appendField(
      new Je(
        [
          ["X", "X"],
          ["Y", "Y"]
        ],
        (i) => (this.property = i, this.updateTooltip(i), i)
      ),
      E.Property
    ).connection.setShadowState({
      type: I.input_vector2
    }), this.appendValueInput(E.Value).setCheck("float").connection.setShadowState({
      type: I.input_float
    });
  },
  loadExtraState(i) {
    this.updateTooltip(i == null ? void 0 : i[E.Property]);
  },
  saveExtraState() {
    return {
      [E.Property]: this.property
    };
  },
  updateTooltip(i) {
    const l = ce.CurrentDescriptionFile;
    let r, o = "";
    switch (i) {
      case "X":
        r = l.actions.get_Item("Vector2SetX");
        break;
      case "Y":
        r = l.actions.get_Item("Vector2SetY");
        break;
    }
    r && (o = Ol(r)), this.setTooltip(o);
  },
  search(i) {
    return [f.Vector2Setter].find((l) => J.containsKey(l, i)) || !1;
  }
}, jv = {
  geId: I.vector2_setxy,
  locKey: re.Vector2Setter,
  property: "X",
  init() {
    this.setInputsInline(!0), this.setOutput(!0, "Vector2"), this.setStyle("data_blocks"), this.appendValueInput(E.Item).setCheck("Vector2").appendField(f.Vector2Setter).appendField(
      new Je(
        [
          ["X", "X"],
          ["Y", "Y"]
        ],
        (i) => (this.property = i, this.updateTooltip(i), i)
      ),
      E.Property
    ).connection.setShadowState({
      type: I.input_vector2
    }), this.appendValueInput(E.Value).setCheck("float").connection.setShadowState({
      type: I.input_float
    });
  },
  loadExtraState(i) {
    this.updateTooltip(i == null ? void 0 : i[E.Property]);
  },
  saveExtraState() {
    return {
      [E.Property]: this.property
    };
  },
  updateTooltip(i) {
    const l = ce.CurrentDescriptionFile;
    let r, o = "";
    switch (i) {
      case "X":
        r = l.variables.get_Item("Vector2SetXClient");
        break;
      case "Y":
        r = l.variables.get_Item("Vector2SetYClient");
        break;
    }
    r && (o = Ol(r)), this.setTooltip(o);
  },
  search(i) {
    return [f.Vector2Setter].find((l) => J.containsKey(l, i)) || !1;
  }
};
function zv(i) {
  N.Blocks[I.vector3_operation] = Vv, N.Blocks[I.vector3_get] = Gv, N.Blocks[I.vector3_set] = xv, N.Blocks[I.vector3_setxyz] = Hv, N.Blocks[I.vector2_operation] = Yv, N.Blocks[I.vector2_get] = Xv, N.Blocks[I.vector2_set] = Kv, N.Blocks[I.vector2_setxy] = jv, i.set("Vector3Operation", { kind: "block", type: I.vector3_operation }), i.set("Vector3Getter", { kind: "block", type: I.vector3_get }), i.set("Vector3Setter", { kind: "block", type: I.vector3_set }), i.set("Vector3xyzSetter", { kind: "block", type: I.vector3_setxyz }), i.set("Vector2Operation", { kind: "block", type: I.vector2_operation }), i.set("Vector2Getter", { kind: "block", type: I.vector2_get }), i.set("Vector2Setter", { kind: "block", type: I.vector2_set }), i.set("Vector2xySetter", { kind: "block", type: I.vector2_setxy });
}
const Jv = {
  debugAvailable: !0,
  locKey: re.PrintInfo,
  geId: 0,
  init() {
    this.setInputsInline(!0), this.setStyle("action_blocks"), this.setPreviousStatement(!0, "action"), this.setNextStatement(!0, "action"), this.appendDummyInput().appendField(f.PrintInfo).appendField(new Je([
      [f.LogString, "PrintString"],
      [f.LogWarning, "PrintWarning"],
      [f.LogError, "PrintError"]
    ]), E.Type), this.appendValueInput(E.Value).setAlign(X.ALIGN_RIGHT).setCheck("Object").connection.setShadowState(Xe("Object"));
  },
  updateShape_() {
  },
  search(i, l) {
    return ["PrintString", f.LogString, "PrintWarning", f.LogWarning, "PrintError", f.LogError].find((r) => J.containsKey(r, i)) || !1;
  }
};
function Zv(i) {
  N.Blocks[I.print_info] = Jv, i.set("PrintInfo", {
    kind: "block",
    type: I.print_info,
    fields: {
      [E.Type]: "PrintString"
    }
  });
}
const TI = () => [
  {
    label: f.Unselected,
    type: "",
    id: ""
  }
], Qv = {
  debugAvailable: !1,
  locKey: re.RegisteredAsset,
  geId: 0,
  init() {
    const i = TI();
    let l = function() {
      return i.map((r) => [ye(r.label), r.id]);
    };
    this.setStyle("data_blocks"), this.setInputsInline(!0), this.appendDummyInput().appendField(f.RegisteredAsset).appendField(f.AssetType).appendField(new Gn(l), E.AssetType), this.appendValueInput(E.Name).appendField(f.AssetName).setAlign(X.ALIGN_RIGHT).setCheck("String").connection.setShadowState(Xe("String")), this.setOutput(!0, "any");
  },
  updateShape_() {
  },
  DetermineTypes() {
    var c;
    let i = this.getFieldValue(E.AssetType), l = this.outputConnection.getCheck()[0], o = (c = TI().find((T) => T.id === i)) == null ? void 0 : c.type;
    return o && o != l ? (this.setOutput(!0, o), !0) : !1;
  },
  search(i, l) {
    return ["asset", f.RegisteredAsset].find((r) => J.containsKey(r, i)) || !1;
  }
};
function qv(i) {
  N.Blocks[I.pick_registeredAsset] = Qv, i.set("PickRegisteredAsset", {
    kind: "block",
    type: I.pick_registeredAsset,
    fields: {
      [E.AssetType]: ""
    }
  });
}
const eR = {
  geId: I.animation_state,
  init() {
    this.appendDummyInput().appendField(f.AnimationState, E.Label).appendField(
      new Yt({
        type: "GFileType",
        subinfo: "ac",
        defaultLabel: f.AnimationController
      }),
      E.Hud
    ).appendField(new tR(), E.Entity), this.setOutput(!0, "String"), this.setStyle("data_blocks");
  },
  setShadow(i) {
    N.BlockSvg.prototype.setShadow.call(this, i), i && this.inputList[0].removeField(E.Label, !0);
  },
  DetermineTypes() {
    return this.getField(E.Entity).UpdateDisplay(), !1;
  }
};
class tR extends Gn {
  constructor(l, r) {
    super([[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]], l, r), this.menuGenerator_ = () => [[f.Unselected, "", "", { style: "fill: var(--red_err5);" }]];
  }
}
function rR(i) {
  N.Blocks[I.animation_state] = eR, i.set("AnimStateName", { kind: "block", type: I.animation_state });
}
function nR() {
  let i = /* @__PURE__ */ new Map();
  return U0(i), dL(i), cC(i), GL(i), T0(i), v0(i), W0(i), Vf(i), $L(i), Hf(i), nC(i), IC(), lL(), fC(i), Wf(), RC(), nv(i), $v(i), Uv(), zv(i), Zv(i), qv(i), rR(i), i;
}
const iR = `//Basic Type Redirection\r
setup bool = Bool\r
setup int = Int\r
setup float = Float\r
setup number = Number\r
setup string = String\r
setup entity = Component\r
setup array = List\r
setup listGeneric = ListT\r
setup type = Type\r
setup global = Global\r
\r
type any         #%(T_36_WZY_WS_ANYTYPE)\r
type null        #%(T_NULL)\r
\r
\r
@ApiLevel=4\r
@ScriptName=Object\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Object  = 0 { #%(T_46_META_WS_C_OBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Type\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Type : Object = 1027 { #%(T_46_META_WS_C_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type entity : Object = 240 { #%(T_46_META_WS_ENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Property\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Property : Object = 180 { #%(T_46_META_WS_C_PROPERTY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EventID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EventID : Object = 358 { #%(T_46_META_WS_C_EVENTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TypeEnum\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@genTypeEnum base = Object\r
enum TypeEnum : Type = 98 { #%(T_46_META_WS_C_TYPEENUM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Bool\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Bool : Object = 2 { #%(T_46_META_WS_C_BOOL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Int\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Int : Object = 3 { #%(T_46_META_WS_C_INT)\r
}\r
\r
@Accept Int\r
@ApiLevel=4\r
@ScriptName=Float\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Float : Object = 4 { #%(T_46_META_WS_C_FLOAT)\r
}\r
\r
@Accept Int\r
@ApiLevel=4\r
@ScriptName=Int64\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Int64 : Object = 108 { #%(T_46_META_WS_C_INT64)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=BigFloat\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type BigFloat : Object = 69 { #%(T_36_WZY_WS_BIGFLOAT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Number\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias Number : Object&(Int|Int64|Float|BigFloat) = 7 #%(T_46_META_WS_C_NUMBER)\r
\r
@ApiLevel=4\r
@ScriptName=String\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type String : Object = 5 { #%(T_46_META_WS_C_STRING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Color\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Color : Object = 87 { #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UUID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type UUID : Object = 261 { #%(T_46_META_WS_C_UUID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AssetConfigID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type AssetConfigID : Int = 282 { #%(T_46_META_WS_C_ASSETCONFIGID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AssetID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AssetID : String = 283 { #%(T_46_META_WS_C_ASSETID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PersonaID\r
@ModuleID=43\r
@ModuleLib=LLM\r
type PersonaID : AssetID = 423 { #%(T_47_XXJ_WS_PERSONAID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlotID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlotID : AssetID = 443 { #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CollectionID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type CollectionID : AssetConfigID = 373 { #%(T_46_META_WS_C_COLLECTIONID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ItemID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type ItemID : AssetConfigID = 264 { #%(T_46_META_WS_C_ITEMID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LevelObjectID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type LevelObjectID : AssetConfigID = 351 { #%(T_46_META_WS_C_LEVELOBJECTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WeaponSkinID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type WeaponSkinID : CollectionID = 262 { #%(T_46_META_WS_C_WEAPONSKINID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OutfitID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type ClothID : CollectionID = 263 { #%(T_46_META_WS_C_OUTFITID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BackpackSkinID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type BagSkinID : CollectionID = 388 { #%(T_46_META_WS_C_BACKPACKSKINID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HumanModelID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type HumanModelID : CollectionID = 284 { #%(T_46_META_WS_C_HUMANMODELID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=List\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type List : Object = 1 { #%(T_46_META_WS_C_LIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
generic ListT : List = 19 { #%(T_46_META_WS_C_LISTT)\r
    T0 : Object\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Map\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Map : Object = 216 { #%(T_46_META_WS_C_MAP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MapT\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
generic MapT : Map = 217 { #%(T_46_META_WS_C_MAPT)\r
    T0 : Object\r
    T1 : Object\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListOrMap\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias ListOrMap : Object&(List|Map) = 285 #%(T_46_META_WS_C_LISTORMAP)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Type\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Type : List = 162 { #%(T_46_META_WS_C_LISTT_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TypeOrTypeList\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias TypeOrListType : Object&(Type|ListT_Type) = 163 #%(T_46_META_WS_C_TYPEORTYPELIST)\r
\r
@Accept Vector3\r
@ApiLevel=4\r
@ScriptName=Vector2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Vector2 : Object = 159 { #%(T_46_META_WS_C_VECTOR2)\r
}\r
\r
@Accept DirectedPoint\r
@ApiLevel=4\r
@ScriptName=Vector3\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Vector3 : Object = 6 { #%(T_46_META_WS_C_VECTOR3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Quaternion\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type Quaternion : Object = 151 { #%(T_46_META_WS_C_QUATERNION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BezierCurve\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type BezierCurve : Object = 331 { #%(T_46_META_WS_C_BEZIERCURVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Condition\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias Condition : Bool = 8 #%(T_46_META_WS_C_CONDITION)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Condition\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Condition : List = 9 { #%(T_46_META_WS_C_LISTT_CONDITION)\r
}\r
\r
@Accept Vector3\r
@ApiLevel=10\r
@ScriptName=DirectedPoint_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type DirectedPoint : Object = 18 { #%(T_36_WZY_WS_DIRPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LocString\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type LocString : String = 149 { #%(T_46_META_WS_C_LOCKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MeshID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MeshID : AssetID = 181 { #%(T_46_META_WS_C_MESHID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerDataID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlayerDataID : AssetID = 368 { #%(T_46_META_WS_C_PLAYERDATAID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationClipID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AnimationClipID : AssetID = 369 { #%(T_46_META_WS_C_ANIMATIONCLIPID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MaterialID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MaterialID : AssetID = 182 { #%(T_46_META_WS_C_MATERIALID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColliderCollectionID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ColliderID : AssetID = 202 { #%(T_46_META_WS_C_COLLIDERCOLLECTIONID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TextureID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TextureID : AssetID = 183 { #%(T_46_META_WS_C_TEXTUREID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpriteID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SpriteID : AssetID = 214 { #%(T_46_META_WS_C_SPRITEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AtlasID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AtlasID : AssetID = 476 { #%(T_54_META_TYP_39_I15)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScriptID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type GraphID : AssetID = 286 { #%(T_46_META_WS_C_SCRIPTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StaticScriptID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type StaticGraphID : AssetID = 287 { #%(T_46_META_WS_C_STATICSCRIPTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type CustomHudID : AssetConfigID = 288 { #%(T_46_META_WS_C_CUSTOMUIID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIWidgetID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type CustomHudWidgetID : AssetConfigID = 325 { #%(T_46_META_WS_C_CUSTOMUIWIDGETID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VehicleSkinID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@NotNull=True\r
type VehicleSkinID : CollectionID = 334 { #%(T_46_META_WS_C_VEHICLESKINID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PrefabID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PrefabID : AssetID = 289 { #%(T_46_META_WS_C_PREFABID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResourceID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ResourceID : AssetID = 497 { #%(T_41_XXJ_WS_RESUUID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIAssetID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomHudAssetID : AssetID = 452 { #%(T_50_META_TYP_452)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AudioID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AudioID : AssetID = 378 { #%(T_46_META_WS_C_AUDIOID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CsvID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CsvID : AssetID = 379 { #%(T_46_META_WS_C_CSVID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EffectID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EffectID : AssetID = 380 { #%(T_46_META_WS_C_EFFECTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeID\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BTreeID : AssetID = 328 { #%(T_46_META_WS_C_BEVTREEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationControllerID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AnimationCtrlID : AssetID = 381 { #%(T_46_META_WS_C_ANIMATIONCONTROLLERID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ParticlesID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ParticlesID : AssetID = 425 { #%(T_47_XXJ_WS_PARTICLESID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayableControllerID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlayableControllerResID : AssetID = 445 { #%(T_49_META_TYP_445)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Bool\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Bool : List = 45 { #%(T_46_META_WS_C_LISTT_BOOL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Int\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Int : List = 46 { #%(T_46_META_WS_C_LISTT_INT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IntOrIntList\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias IntOrListInt : Object&(Int|ListT_Int) = 91 #%(T_46_META_WS_C_INTORINTLIST)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Float\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Float : List = 47 { #%(T_46_META_WS_C_LISTT_FLOAT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_String\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_String : List = 48 { #%(T_46_META_WS_C_LISTT_STRING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Vector3\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Vector3 : List = 49 { #%(T_46_META_WS_C_LISTT_VECTOR3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_LocKey\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_LocString : List = 189 { #%(T_46_META_WS_C_LISTT_LOCKEY)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=InternalBuffType\r
@ModuleID=10011\r
@ModuleLib=Buff\r
enum InternalBuffType : Int = 303 { #%(T_41_XXJ_WS_INTERNALBUFFTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Test_AddPlayerMaxHP\r
    Test_AddPlayerMaxHP = 262 #%(T_41_XXJ_WS_ADDPLAYERMAXHP)\r
	@ApiLevel=4\r
	@ScriptName=Test_RecoverPlayerHPContinusly\r
    Test_RecoverPlayerHPContinusly = 285 #%(T_41_XXJ_WS_RECOVERPLAYERHP)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=ListT_BuffType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_InternalBuffType : List = 304 { #%(T_41_XXJ_WS_LISTT_INTERNALBUFFTYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PlayerSkillType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerSkillType : Int = 223 { #%(T_39_WZY_WS_SKILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Gluttony\r
    EatFast_lv6 = 706 #%(TXT_OB7_JRW_SKILL_NAME_FOODIEBOY)\r
	@ApiLevel=4\r
	@ScriptName=Dash\r
    MoveFast_lv6 = 206 #%(TXT_SKILL_NAME_RUNNER)\r
	@ApiLevel=4\r
	@ScriptName=Camouflage\r
    Monkey_lv6 = 1206 #%(T_12_R_SKILL_NAME_MONKEYGOD)\r
	@ApiLevel=4\r
	@ScriptName=TimeTurner\r
    SpaceShield_lv6 = 3806 #%(T_25_C_SKILL_NAME_BOUNTYHUNTER)\r
	@ApiLevel=4\r
	@ScriptName=SplitBlitz\r
    GrenadeSplite_lv6 = 6306 #%(T_39_WH_SKILL_NAME_GRENADESPLIT)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
    PlayerSprint = 60001 #%(TXT_TUTORIAL_HUD_LABEL10)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ListT_SkillType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_PlayerSkillType : List = 224 { #%(T_39_WZY_WS_SKILLLIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkillID\r
@ModuleID=10010\r
@ModuleLib=Player\r
@NotNull=True\r
type PlayerSkillID : AssetConfigID = 385 { #%(T_46_META_WS_C_SKILLID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_SkillID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_PlayerSkillID : List = 386 { #%(T_46_META_WS_C_LISTT_SKILLID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Component\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Component : Object = 164 { #%(T_46_META_WS_C_COMPONENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Entity\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Entity : Component = 10 { #%(T_46_META_WS_C_ENTITY)\r
	@ApiLevel=10\r
	@Default=true\r
	@ScriptName=Enable_Deprecated\r
    Enable : Bool = -10000 #%(T_36_WZY_AVAILAB)\r
	@ApiLevel=4\r
	@ScriptName=Tags\r
    TagsList : ListT_String = -10001 #%(T_46_META_WS_P_TAGS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ActiveSelf\r
    ActiveSelf : Bool = -10002 #%(T_46_META_WS_P_ACTIVESELF)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ActiveParent\r
    get ActiveParent : Bool = -10003 #%(T_40_XXJ_WS_ACTIVEPARENT_NAMEKEY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ActiveInHierarchy\r
    get ActiveInHierarchy : Bool = -10004 #%(T_46_META_WS_P_ACTIVEINHIERARCHY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Enable\r
    EnableLogic : Bool = -10005 #%(T_38_WZY_WS_ACTIVEB)\r
	@ApiLevel=4\r
	@ScriptName=Name\r
    EntityName : String = -10006 #%(T_46_META_WS_P_NAME)\r
	@ApiLevel=4\r
	@ScriptName=AOISetting\r
    get AOISetting : Int = -10007 #%(T_47_XXJ_WS_AOISETTING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Terrain\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Terrain : Entity = 383 { #%(T_46_META_WS_C_TERRAIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Transform\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Transform : Entity = 97 { #%(T_46_META_WS_C_TRANSFORM)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
    Position : Vector3 = -97000 #%(T_46_META_WS_P_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
    Rotation : Vector3 = -97001 #%(T_46_META_WS_P_ROTATION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
    Scale : Vector3 = -97002 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=Parent\r
    Parent : Transform = -97003 #%(T_46_META_WS_P_PARENT)\r
	@ApiLevel=4\r
	@Default=math.Quaternion_Identity()\r
	@ScriptName=RotationQ\r
    RotationQ : Quaternion = -97004 #%(T_46_META_WS_P_ROTATIONQ)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    LocalPosition : Vector3 = -97005 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@Default=math.Quaternion_Identity()\r
	@ScriptName=LocalRotationQ\r
    LocalRotationQ : Quaternion = -97006 #%(T_46_META_WS_P_LOCALROTATIONQ)\r
	@ApiLevel=4\r
	@ScriptName=LocalRotation\r
    LocalRotation : Vector3 = -97007 #%(T_46_META_WS_P_LOCALROTATION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=LocalScale\r
    LocalScale : Vector3 = -97008 #%(T_46_META_WS_P_LOCALSCALE)\r
	@ApiLevel=4\r
	@ScriptName=Up\r
    Up : Vector3 = -97009 #%(T_46_META_WS_P_UP)\r
	@ApiLevel=4\r
	@ScriptName=Right\r
    Right : Vector3 = -97010 #%(T_46_META_WS_P_RIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Forward\r
    Forward : Vector3 = -97011 #%(T_46_META_WS_P_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Visibility\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Visibility : Entity = 170 { #%(T_46_META_WS_C_VISIBILITY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    Visible : Bool = -170000 #%(T_46_META_WS_P_VISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=VisibilityLayer\r
    VisibilityLayer : Int = -170001 #%(T_46_META_WS_P_VISIBILITYLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicAppearance\r
@Conflict=["MeshRender","SimpleRender"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Appearance : Visibility = 125 { #%(T_46_META_WS_C_BASICAPPEARANCE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=DiffuseColor\r
    DiffuseColor : Color = -125000 #%(T_46_META_WS_P_DIFFUSECOLOR)\r
	@ApiLevel=10\r
	@Default=0\r
	@ScriptName=RimColor\r
    RimColor : Color = -125001 #%(T_46_META_WS_P_RIMCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseTexture\r
    DiffuseTexture : TextureID = -125002 #%(T_46_META_WS_P_DIFFUSETEXTURE)\r
	@ApiLevel=10\r
	@ScriptName=RimTexture\r
    RimTexture : TextureID = -125003 #%(T_46_META_WS_P_RIMTEXTURE)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseAlpha\r
    DiffuseAlpha : Int = -125004 #%(T_46_META_WS_P_DIFFUSEALPHA)\r
	@ApiLevel=10\r
	@ScriptName=RimAlpha\r
    RimAlpha : Int = -125005 #%(T_46_META_WS_P_RIMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Collider\r
@Addable=["ColliderShape"]\r
@Conflict=["PhysicalCCT"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Collider : Entity = 165 { #%(T_46_META_WS_C_COLLIDER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Enable\r
    Collidable : Bool = -165000 #%(T_46_META_WS_P_ENABLE)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsTrigger\r
    get IsTrigger : Bool = -165001 #%(T_40_XXJ_WS_ISTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=PhysicalLayer\r
    PhysicalLayer : Int = -165002 #%(T_46_META_WS_P_PHYSICALLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RigidbodyType\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum RigidbodyType : Int = 256 { #%(T_46_META_WS_C_RIGIDBODYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Static\r
    Static = 1 #%(T_46_META_WS_E_STATIC)\r
	@ApiLevel=4\r
	@ScriptName=Dynamic\r
    Dynamic = 2 #%(T_46_META_WS_E_DYNAMIC)\r
	@ApiLevel=4\r
	@ScriptName=Kinematic\r
    Kinematic = 3 #%(T_46_META_WS_E_KINEMATIC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Rigidbody\r
@Addable=["ComplexRigidbody"]\r
@Conflict=["PhysicalCCT"]\r
@ModuleID=33\r
@ModuleLib=Physics\r
type Rigidbody : Entity = 257 { #%(T_46_META_WS_C_RIGIDBODY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Type\r
    Type : RigidbodyType = -257000 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=UseGravity\r
    UseGravity : Bool = -257001 #%(T_46_META_WS_P_USEGRAVITY)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Mass\r
    Mass : Float = -257002 #%(T_46_META_WS_P_MASS)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=CenterOfMass\r
    get CenterOfMass : Vector3 = -257003 #%(T_46_META_WS_P_CENTEROFMASS)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=Velocity\r
    Velocity : Vector3 = -257004 #%(T_46_META_WS_P_VELOCITY)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=AngularVelocity\r
    AngularVelocity : Vector3 = -257005 #%(T_46_META_WS_P_ANGULARVELOCITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Drag\r
    Drag : Float = -257006 #%(T_46_META_WS_P_DRAG)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=AngularDrag\r
    AngularDrag : Float = -257007 #%(T_46_META_WS_P_ANGULARDRAG)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Constrain\r
    Constrain : Int = -257008 #%(T_46_META_WS_P_CONSTRAIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RigidbodyConstrainType\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum RigidbodyConstrainType : Int = 317 { #%(T_46_META_WS_C_RIGIDBODYCONSTRAINTYPE)\r
	@ApiLevel=4\r
	@ScriptName=None\r
    None = 0 #%(T_46_META_WS_E_NONE)\r
	@ApiLevel=4\r
	@ScriptName=FreezePositionX\r
    FreezePositionX = 2 #%(T_46_META_WS_E_FREEZEPOSITIONX)\r
	@ApiLevel=4\r
	@ScriptName=FreezePositionY\r
    FreezePositionY = 4 #%(T_46_META_WS_E_FREEZEPOSITIONY)\r
	@ApiLevel=4\r
	@ScriptName=FreezePositionZ\r
    FreezePositionZ = 8 #%(T_46_META_WS_E_FREEZEPOSITIONZ)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotationX\r
    FreezeRotationX = 16 #%(T_46_META_WS_E_FREEZEROTATIONX)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotationY\r
    FreezeRotationY = 32 #%(T_46_META_WS_E_FREEZEROTATIONY)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotationZ\r
    FreezeRotationZ = 64 #%(T_46_META_WS_E_FREEZEROTATIONZ)\r
	@ApiLevel=4\r
	@ScriptName=FreezePosition\r
    FreezePosition = 14 #%(T_46_META_WS_E_FREEZEPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=FreezeRotation\r
    FreezeRotation = 112 #%(T_46_META_WS_E_FREEZEROTATION)\r
	@ApiLevel=4\r
	@ScriptName=FreezeAll\r
    FreezeAll = 126 #%(T_46_META_WS_E_FREEZEALL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ForceType\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum ForceType : Int = 324 { #%(T_46_META_WS_C_FORCETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Force\r
    Force = 1 #%(T_46_META_WS_E_FORCE)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
    Acceleration = 2 #%(T_46_META_WS_E_ACCELERATION)\r
	@ApiLevel=4\r
	@ScriptName=Impulse\r
    Impulse = 3 #%(T_46_META_WS_E_IMPULSE)\r
	@ApiLevel=4\r
	@ScriptName=Velocity\r
    Velocity = 4 #%(T_46_META_WS_E_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CharacterController\r
@Addable=["CustomLevelObject"]\r
@Conflict=["Collider","ColliderShape","Rigidbody"]\r
@ModuleID=33\r
@ModuleLib=Physics\r
type PhysicalCCT : Entity = 359 { #%(T_46_META_WS_C_CHARACTERCONTROLLER)\r
	@ApiLevel=4\r
	@ScriptName=UsePhysicalCCT\r
    UsePhysicalCCT : Bool = -359000 #%(T_46_META_WS_P_USEPHYSICALCCT)\r
	@ApiLevel=4\r
	@Default=45\r
	@ScriptName=SlopeLimit\r
    SlopeLimit : Float = -359001 #%(T_46_META_WS_P_SLOPELIMIT)\r
	@ApiLevel=4\r
	@Default=0.3\r
	@ScriptName=StepOffset\r
    StepOffset : Float = -359002 #%(T_46_META_WS_P_STEPOFFSET)\r
	@ApiLevel=4\r
	@Default=0.08\r
	@ScriptName=SkinWidth\r
    SkinWidth : Float = -359003 #%(T_46_META_WS_P_SKINWIDTH)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=MinMoveDistance\r
    MinMoveDistance : Float = -359004 #%(T_46_META_WS_P_MINMOVEDISTANCE)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, 0.75, 0)\r
	@ScriptName=CenterOffset\r
    get CenterOffset : Vector3 = -359005 #%(T_46_META_WS_P_CENTEROFFSET)\r
	@ApiLevel=4\r
	@Default=0.3\r
	@ScriptName=Radius\r
    Radius : Float = -359006 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@Default=1.34\r
	@ScriptName=Height\r
    Height : Float = -359007 #%(T_46_META_WS_P_HEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Velocity\r
    get Velocity : Vector3 = -359008 #%(T_46_META_WS_P_VELOCITY)\r
	@ApiLevel=10\r
	@Default=10\r
	@ScriptName=MaxSpeed\r
    MaxSpeed : Float = -359009 #%(T_46_META_WS_P_MAXSPEED)\r
	@ApiLevel=4\r
	@ScriptName=Gravity\r
    Gravity : Vector3 = -359010 #%(T_46_META_WS_P_GRAVITY)\r
	@ApiLevel=4\r
	@Default=50\r
	@ScriptName=Mass\r
    Mass : Float = -359011 #%(T_46_META_WS_P_MASS)\r
	@ApiLevel=4\r
	@ScriptName=IsSliding\r
    get IsSliding : Bool = -359012 #%(T_46_META_WS_P_ISSLIDING)\r
	@ApiLevel=10\r
	@ScriptName=IsTopColliding\r
    get IsTopColliding : Bool = -359013 #%(T_46_META_WS_P_ISTOPCOLLIDING)\r
	@ApiLevel=10\r
	@ScriptName=IsSideColliding\r
    get IsSideColliding : Bool = -359014 #%(T_46_META_WS_P_ISSIDECOLLIDING)\r
	@ApiLevel=10\r
	@ScriptName=IsBottomColliding\r
    get IsBottomColliding : Bool = -359015 #%(T_46_META_WS_P_ISBOTTOMCOLLIDING)\r
	@ApiLevel=4\r
	@ScriptName=IsServerDriven\r
    IsServerDriven : Bool = -359016 #%(T_46_META_WS_P_ISSERVERDRIVEN)\r
	@ApiLevel=4\r
	@ScriptName=UseCustomPushForce\r
    UseCustomPushForce : Bool = -359017 #%(T_46_META_WS_P_USECUSTOMPUSHFORCE)\r
	@ApiLevel=4\r
	@ScriptName=CustomPushForce\r
    CustomPushForce : Float = -359018 #%(T_46_META_WS_P_CUSTOMPUSHFORCE)\r
	@ApiLevel=4\r
	@ScriptName=IsGrounded\r
    get IsGrounded : Bool = -359019 #%(T_46_META_WS_P_ISGROUNDED)\r
	@ApiLevel=4\r
	@ScriptName=PhysicalLayer\r
    get PhysicalLayer : Int = -359020 #%(T_46_META_WS_P_PHYSICALLAYER)\r
	@ApiLevel=4\r
	@ScriptName=EnableRotateWithGravity\r
    get EnableRotateWithGravity : Bool = -359021 #%(T_46_META_WS_P_ENABLEROTATEWITHGRAVITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerCCT\r
@Addable=["Player"]\r
@ModuleID=33\r
@ModuleLib=Physics\r
type PlayerCCT : PhysicalCCT = 399 { #%(T_46_META_WS_C_PLAYERCCT)\r
	@ApiLevel=4\r
	@Default=0.8\r
	@ScriptName=JumpHeight\r
    JumpHeight : Float = -399000 #%(T_46_META_WS_P_JUMPHEIGHT)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=MaxJumpCount\r
    MaxJumpCount : Int = -399001 #%(T_46_META_WS_P_MAXJUMPCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=RemainJumpCount\r
    get RemainJumpCount : Int = -399002 #%(T_46_META_WS_P_REMAINJUMPCOUNT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableMoveInMidair\r
    CanMoveInAir : Bool = -399003 #%(T_46_META_WS_P_ENABLEMOVEINMIDAIR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PhysicalMover\r
@Addable=["Rigidbody"]\r
@ModuleID=33\r
@ModuleLib=Physics\r
type PhysicalMover : Entity = 395 { #%(T_46_META_WS_C_PHYSICALMOVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PhysicalObject\r
@ModuleID=33\r
@ModuleLib=Physics\r
alias PhysicalObject : Entity&(PhysicalCCT|Rigidbody) = 393 #%(T_46_META_WS_C_PHYSICALOBJECT)\r
\r
@ApiLevel=4\r
@ScriptName=EntityOrPrefabID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias EntityOrPrefabID : Object&(Entity|PrefabID) = 270 #%(T_46_META_WS_C_ENTITYORPREFABID)\r
\r
@ApiLevel=4\r
@ScriptName=AnimationControllerAttachable\r
@Addable=["CustomLevelObject","AI"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AnimationControllerAble : Entity = 314 { #%(T_46_META_WS_C_ANIMATIONCONTROLLERATTACHABLE)\r
	@ApiLevel=4\r
	@ScriptName=AnimationControllerResID\r
    AnimationControllerResUUID : AnimationCtrlID = -314000 #%(T_46_META_WS_P_ANIMATIONCONTROLLERRESID)\r
	@ApiLevel=4\r
	@ScriptName=AnimationController\r
    get AnimationController : AnimationController = -314001 #%(T_46_META_WS_P_ANIMATIONCONTROLLER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Appearance\r
@Addable=["CustomLevelObject","AI","Player"]\r
@ModuleID=38\r
@ModuleLib=Avatar\r
type AvatarAble : Entity = 327 { #%(T_46_META_WS_C_APPEARENCE)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
    get AvatarResUUID : String = -327000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskA\r
    get PartVisableMask1 : Int = -327001 #%(T_46_META_WS_P_PARTMASKA)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskB\r
    get PartVisableMask2 : Int = -327002 #%(T_46_META_WS_P_PARTMASKA)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskC\r
    get PartVisableMask3 : Int = -327003 #%(T_46_META_WS_P_PARTMASKA)\r
	@ApiLevel=4\r
	@ScriptName=PartMaskD\r
    get PartVisableMask4 : Int = -327004 #%(T_46_META_WS_P_PARTMASKA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuiltinRender\r
@Conflict=["MeshRender","Appearance"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SimpleRender : Visibility = 184 { #%(T_46_META_WS_C_BUILTINRENDER)\r
	@ApiLevel=4\r
	@ScriptName=ResourceID\r
    ResUUID : String = -184000 #%(T_46_META_WS_P_RESOURCEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BatchCombineRender\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type BatchCombineRender : Visibility = 366 { #%(T_46_META_WS_C_BATCHCOMBINERENDER)\r
	@ApiLevel=4\r
	@ScriptName=ResourceID\r
    ResUUID : String = -366000 #%(T_46_META_WS_P_RESOURCEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomRender\r
@Addable=["CustomLevelObject"]\r
@Conflict=["SimpleRender","Appearance"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MeshRender : Visibility = 185 { #%(T_40_ZQ_WS_COMPONENT_CUSTOMRENDER)\r
	@ApiLevel=4\r
	@ScriptName=MeshID\r
    MeshID : MeshID = -185000 #%(T_43_YU_WS_MESHID1)\r
	@ApiLevel=4\r
	@ScriptName=MaterialIDList\r
    Materials : ListT_MaterialID = -185001 #%(T_43_YU_WS_MATERIALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Aimable\r
@Addable=["LevelObject"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type AimableEntity : Entity = 107 { #%(T_46_META_WS_C_AIMABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AimAssistable\r
@Addable=["AimableEntity"]\r
@ModuleID=10016\r
@ModuleLib=Combat\r
type AimAssistEntity : AimableEntity = 321 { #%(T_46_META_WS_C_AIMASSISTABLE)\r
	@ApiLevel=4\r
	@Default=25\r
	@ScriptName=AimAssistDistance\r
    AimAssistDistance : Float = -321000 #%(T_46_META_WS_P_AIMASSISTDISTANCE)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, 0, 0)\r
	@ScriptName=AimAssistCenterOffset\r
    AimAssistCenterOffset : Vector3 = -321001 #%(T_46_META_WS_P_AIMASSISTCENTEROFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Container\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ItemContainerGenerator : Entity = 153 { #%(T_46_META_WS_C_CONTAINER)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=DescriptiveColor\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type DescriptiveColor : Entity = 357 { #%(T_45_META_WS_DESCRIPTIVECOLOR)\r
	@ApiLevel=3\r
	@Default=-1\r
	@ScriptName=Surface\r
    Surface : Color = -357000 #%(T_35_SP_WS_IMAGE03)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=Border\r
    Border : Color = -357001 #%(T_35_SP_WS_IMAGE04)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerBackpack\r
@ModuleID=10014\r
@ModuleLib=Items\r
type PlayerBag : Entity = 315 { #%(T_46_META_WS_C_PLAYERBACKPACK)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
    get Owner : Player = -315000 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=4\r
	@ScriptName=MaxCapacity\r
    get MaxCapacity : Int = -315001 #%(T_46_META_WS_P_MAXCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=UsedCapacity\r
    get CurCapacity : Int = -315002 #%(T_46_META_WS_P_USEDCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=AllItems\r
    get AllItemGoodsType : ListT_ItemGoodsIDType = -315003 #%(T_46_META_WS_P_ALLITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkyboxType\r
@ModuleID=10012\r
@ModuleLib=Scene\r
enum SkyboxEnvBaseType : String = 123 { #%(T_46_META_WS_C_SKYBOXTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Day\r
    Day = UGC_SKYENV_DAY #%(T_46_META_WS_E_DAY)\r
	@ApiLevel=4\r
	@ScriptName=Night\r
    Night = UGC_SKYENV_NIGHT #%(T_46_META_WS_E_NIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Dusk\r
    Eve = UGC_SKYENV_EVE #%(T_46_META_WS_E_DUSK)\r
	@ApiLevel=4\r
	@ScriptName=City\r
    CityBuilding = UGC_SKYENV_CITY #%(T_46_META_WS_E_CITY)\r
	@ApiLevel=4\r
	@ScriptName=Colorful\r
    Colorful = UGC_SKYENV_COLORFULSKY #%(T_40_XYL_WS_COLORFULSKY)\r
	@ApiLevel=4\r
	@ScriptName=FrostGalaxy\r
    SnowSky = UGC_SKYENV_SNOW #%(T_46_META_WS_E_FROST GALAXY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EmoteType\r
@ModuleID=10017\r
@ModuleLib=Collection\r
enum EmoteType : AnimationClipID = 166 { #%(T_46_META_WS_C_EMOTETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Ridicule\r
    Emote1 = 909034005 #%(T_46_META_WS_E_RIDICULE)\r
	@ApiLevel=4\r
	@ScriptName=RidiculeFunny\r
    Emote2 = 909034007 #%(T_46_META_WS_E_RIDICULEFUNNY)\r
	@ApiLevel=4\r
	@ScriptName=GreatConductor\r
    Emote3 = 909034004 #%(T_46_META_WS_E_GREATCONDUCTOR)\r
	@ApiLevel=4\r
	@ScriptName=Energetic\r
    Emote4 = 909000127 #%(T_46_META_WS_E_ENERGETIC)\r
	@ApiLevel=4\r
	@ScriptName=BattleInStyle\r
    Emote5 = 909000099 #%(T_46_META_WS_E_BATTLEINSTYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkyBox\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type SkyboxEnv : Entity = 122 { #%(T_46_META_WS_C_SKYBOX)\r
	@ApiLevel=4\r
	@Default=UGC_SKYENV_DAY\r
	@ScriptName=SkyBoxResource\r
    BaseSkyEnvRes : SkyboxEnvBaseType = -122000 #%(T_46_META_WS_P_SKYBOXRESOURCE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=LightColor\r
    LightColor : Color = -122001 #%(T_46_META_WS_P_LIGHTCOLOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=LightIntensity\r
    LightIntensity : Float = -122002 #%(T_46_META_WS_P_LIGHTINTENSITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Darkness\r
    Darkness : Float = -122003 #%(T_46_META_WS_P_DARKNESS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=ShadowStrength\r
    ShadowStrength : Float = -122004 #%(T_46_META_WS_P_SHADOWSTRENGTH)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=TerrainWetness\r
    TerrainWetness : Float = -122005 #%(T_46_META_WS_P_TERRAINWETNESS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=LensFlare\r
    LensFlare : Float = -122006 #%(T_46_META_WS_P_LENSFLARE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=FogColor\r
    FogColor : Color = -122007 #%(T_46_META_WS_P_FOGCOLOR)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=AmbientColor\r
    AmbientColor : Color = -122008 #%(T_46_META_WS_P_AMBIENTCOLOR)\r
	@ApiLevel=10\r
	@Default=false\r
	@ScriptName=NightMode_Deprecated\r
    NightMode : Bool = -122009 #%(T_37_WZY_WS_NIGHTMODE)\r
	@ApiLevel=4\r
	@Default=true\r
    Fog : Bool = -122011 #%(T_47_XXJ_WS_FOG)\r
	@ApiLevel=4\r
	@Default=1\r
    FogMode : FogModeType = -122012 #%(T_47_XXJ_WS_FOGMODE)\r
	@ApiLevel=4\r
	@Default=0.01\r
    FogDensity : Float = -122013 #%(T_47_XXJ_WS_FOGDENSITY)\r
	@ApiLevel=4\r
	@Default=50\r
    FogStartDistance : Float = -122014 #%(T_47_XXJ_WS_FOGSTARTDISTANCE)\r
	@ApiLevel=4\r
	@Default=1000\r
    FogEndDistance : Float = -122015 #%(T_47_XXJ_WS_FOGENDDISTANCE)\r
	@ApiLevel=3\r
	@Default=false\r
    EnableUGCFogFeature : Bool = -122016 #%(T_47_XXJ_WS_ENABLEUGCFOGFEATURE)\r
	@ApiLevel=4\r
    LightRotate : Quaternion = -122017 #%(T_47_XXJ_WS_LIGHTROTATE)\r
	@ApiLevel=4\r
	@Default=false\r
    EnableUGCLightRotateFeature : Bool = -122018 #%(T_47_XXJ_WS_ENABLEUGCLIGHTROTATEFEATURE)\r
	@ApiLevel=4\r
    CustomMaterial : MaterialID = -122019 #%(T_49_META_TYP_122_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FogModeType\r
@ModuleID=10012\r
@ModuleLib=Scene\r
enum FogModeType : Int = 424 { #%(T_47_XXJ_WS_FOGMODETYPE)\r
	@ApiLevel=4\r
    Linear = 1 #%(T_47_XXJ_WS_LINEAR)\r
	@ApiLevel=4\r
    Exponential = 2 #%(T_47_XXJ_WS_EXPONENTIAL)\r
	@ApiLevel=4\r
    ExponentialSquared = 3 #%(T_47_XXJ_WS_EXPONENTIALSQUARED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Global\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Global : Entity = 11 { #%(T_34_WT_WS_ENTITY_PARAM1)\r
	@ApiLevel=3\r
	@ScriptName=IsInvalid\r
    get IsInvalidMatch : Bool = -11000 #%(T_34_WT_WS_ENTITY_PARAM2)\r
	@ApiLevel=4\r
	@ScriptName=GameTimeCount\r
    get GameTimeMs : Int = -11001 #%(T_46_META_WS_P_GAMETIMECOUNT)\r
	@ApiLevel=4\r
	@ScriptName=CurrentRoundIndex\r
    get CurRoundIndex : Int = -11002 #%(T_46_META_WS_P_CURRENTROUNDINDEX)\r
	@ApiLevel=4\r
	@ScriptName=CurrentPhaseIndex\r
    get CurPhaseIndex : Int = -11003 #%(T_46_META_WS_P_CURRENTPHASEINDEX)\r
	@ApiLevel=3\r
	@ScriptName=ModeTemplateID\r
    get ModeTemplateID : Int = -11004 #%(T_34_WT_WS_ENTITY_PARAM6)\r
	@ApiLevel=4\r
	@ScriptName=EnablePlayerRevive\r
    get HumanCanRevive : Bool = -11005 #%(T_46_META_WS_P_ENABLEPLAYERREVIVE)\r
	@ApiLevel=4\r
	@ScriptName=EnableBotRevive\r
    get BotCanRevive : Bool = -11006 #%(T_46_META_WS_P_ENABLEBOTREVIVE)\r
	@ApiLevel=4\r
	@ScriptName=ReviveCD\r
    get ReviveCDTime : Int = -11007 #%(T_46_META_WS_P_REVIVECD)\r
	@ApiLevel=4\r
	@ScriptName=TeamNum\r
    get TeamNum : Int = -11008 #%(T_46_META_WS_P_TEAMNUM)\r
	@ApiLevel=4\r
	@ScriptName=TeamMemberNum\r
    get TeamMemberNum : Int = -11009 #%(T_46_META_WS_P_TEAMMEMBERNUM)\r
	@ApiLevel=3\r
	@ScriptName=ResetEquipment\r
    get ResetEquipment : Bool = -11010 #%(T_34_WT_WS_ENTITY_PARAM12)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneEnabled\r
    get SafeZoneEnabled : Bool = -11011 #%(T_34_WT_WS_ENTITY_PARAM13)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneSize\r
    get SafeZoneSize : Float = -11012 #%(T_34_WT_WS_ENTITY_PARAM14)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneStartTime\r
    get SafeZoneStartTime : Float = -11013 #%(T_34_WT_WS_ENTITY_PARAM15)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneShrinkTime\r
    get SafeZoneShrinkTime : Float = -11014 #%(T_34_WT_WS_ENTITY_PARAM16)\r
	@ApiLevel=3\r
	@ScriptName=SafeZoneDamage\r
    get SafeZoneDamage : Float = -11015 #%(T_34_WT_WS_ENTITY_PARAM17)\r
	@ApiLevel=10\r
	@ScriptName=TargetScore\r
    get TargetScore : Int = -11016 #%(T_34_WT_WS_ENTITY_PARAM18)\r
	@ApiLevel=10\r
	@ScriptName=KillingScore\r
    get KillingScore : Int = -11017 #%(T_34_WT_WS_ENTITY_PARAM19)\r
	@ApiLevel=3\r
	@ScriptName=ReviveType\r
    get ReviveRule : Int = -11018 #%(T_34_WT_WS_ENTITY_PARAM20)\r
	@ApiLevel=10\r
	@ScriptName=PlayerRoundScoreType\r
    PlayerRoundRankingRuleScoreType : ListT_Int = -11019 #%(T_34_WT_WS_ENTITY_PARAM21)\r
	@ApiLevel=10\r
	@ScriptName=PlayerRoundSortType\r
    PlayerRoundRankingRuleSortType : ListT_Int = -11020 #%(T_34_WT_WS_ENTITY_PARAM22)\r
	@ApiLevel=10\r
	@ScriptName=TeamRoundScoreType\r
    TeamRoundRankingRuleScoreType : ListT_Int = -11021 #%(T_34_WT_WS_ENTITY_PARAM23)\r
	@ApiLevel=10\r
	@ScriptName=TeamRoundSortType\r
    TeamRoundRankingRuleSortType : ListT_Int = -11022 #%(T_34_WT_WS_ENTITY_PARAM24)\r
	@ApiLevel=10\r
	@ScriptName=MVPScoreType\r
    MVPRuleScoreType : ListT_Int = -11023 #%(T_34_WT_WS_ENTITY_PARAM25)\r
	@ApiLevel=10\r
	@ScriptName=MVPScoreWeight\r
    MVPRuleScoreWeight : ListT_Int = -11024 #%(T_34_WT_WS_ENTITY_PARAM26)\r
	@ApiLevel=10\r
	@ScriptName=RoundScore\r
    RoundRankToScoreMap : ListT_Int = -11025 #%(T_34_WT_WS_ENTITY_PARAM27)\r
	@ApiLevel=10\r
	@ScriptName=ShowScoreTypeResult\r
    ScoreTypeToShowResult : ListT_Int = -11026 #%(T_34_WT_WS_ENTITY_PARAM28)\r
	@ApiLevel=4\r
	@ScriptName=TotalRoundCount\r
    get SumRoundCount : Int = -11027 #%(T_46_META_WS_P_TOTALROUNDCOUNT)\r
	@ApiLevel=10\r
	@ScriptName=TeamScoreType\r
    TeamRankAccumulateScoreType : Int = -11028 #%(T_24_V_TRAINING_AIMBOT_GAMESCORE)\r
	@ApiLevel=10\r
	@ScriptName=TeamScoreOrder\r
    TeamRankAccumulateScoreOrder : Int = -11029 #%(T_39_XXJ_WS_RANK1)\r
	@ApiLevel=10\r
	@ScriptName=PlayerScoreType\r
    PlayerRankAccumulateScoreType : Int = -11030 #%(T_42_ZZ_GUILDWAR_PERSONALSCORE)\r
	@ApiLevel=10\r
	@ScriptName=PlayerScoreOrder\r
    PlayerRankAccumulateScoreOrder : Int = -11031 #%(T_39_XXJ_WS_RANK2)\r
	@ApiLevel=3\r
	@ScriptName=EcoCoinRoundBegin\r
    EcoRoundMoney : Int = -11032 #%(T_36_JH_WS_BASEMONEY)\r
	@ApiLevel=3\r
	@ScriptName=EcoCoinKill\r
    EcoKillMoney : Int = -11033 #%(T_36_JH_WS_KILLMONEY)\r
	@ApiLevel=3\r
	@ScriptName=EcoCoinWin\r
    EcoWinMoney : Int = -11034 #%(T_36_JH_WS_WINMONEY)\r
	@ApiLevel=3\r
	@ScriptName=IsShowCoin\r
    CoinHudShow : Bool = -11035 #%(T_36_JH_WS_COINHUD)\r
	@ApiLevel=4\r
	@ScriptName=SkyboxEnv\r
    SkyboxEnv : SkyboxEnv = -11036 #%(T_46_META_WS_P_SKYBOXENV)\r
	@ApiLevel=4\r
	@ScriptName=GameFrameCount\r
    get FrameCount : Int = -11037 #%(T_46_META_WS_P_GAMEFRAMECOUNT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsMoveable\r
    get MatchCanMove : Bool = -11038 #%(T_46_META_WS_P_ISMOVEABLE)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=CustomGameResult\r
    CustomMatchResult : Bool = -11039 #%(T_46_META_WS_P_CUSTOMGAMERESULT)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=EnableJoin\r
    get EnableHalfwayJoin : Bool = -11040 #%(T_39_WZY_WS_ENABLEJOIN)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=EnableLowFrame\r
    get EnableEnergySavingMode : Bool = -11041 #%(T_41_XXJ_WS_ENABLEENERGYSAVINGMODE)\r
	@ApiLevel=4\r
	@ScriptName=DeltaTime\r
    get DeltaTime : Int = -11042 #%(T_46_META_WS_P_DELTATIME)\r
	@ApiLevel=4\r
    get FixedDeltaTime : Int = -11043 #%(T_46_META_WS_P_FIXEDDELTATIME)\r
	@ApiLevel=3\r
    get DistanceVolumes : String = -11044 #%(T_50_META_TYP_11_I44)\r
	@ApiLevel=4\r
	@ScriptName=Filter\r
    Filter : BaseFilter = -11045 #%(T_54_XYL_PHOTOFILTER_ENTITY_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Rankable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type RankableEntity : Entity = 84 { #%(T_46_META_WS_C_RANKABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Scoreable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ScoreableEntity : Entity = 85 { #%(T_46_META_WS_C_SCOREABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Team\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Team : Entity&ScoreableEntity&RankableEntity = 15 { #%(T_46_META_WS_C_TEAM)\r
	@ApiLevel=4\r
	@ScriptName=IsAced\r
    get IsACE : Bool = -15000 #%(T_46_META_WS_P_ISACE)\r
	@ApiLevel=4\r
	@ScriptName=AllTeammates\r
    get AllPlayers : ListT_Player = -15001 #%(T_46_META_WS_P_ALLTEAMMATES)\r
	@ApiLevel=10\r
	@ScriptName=TeamIndex\r
    get TeamIndex : Int = -15002 #%(T_34_LY_WS_INDEX)\r
	@ApiLevel=4\r
	@ScriptName=AttackableTeams\r
    get HostileTeams : ListT_Team = -15003 #%(T_46_META_WS_P_HOSTILETEAMS)\r
	@ApiLevel=3\r
	@ScriptName=FriendTeams\r
    get FriendlyTeams : ListT_Team = -15004 #%(T_37_WZY_FRIDTEAM)\r
	@ApiLevel=4\r
	@ScriptName=TeamSeq\r
    get TeamSeq : Int = -15005 #%(T_46_META_WS_P_TEAMSEQ)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsShowTeammateName\r
    IsShowHudName : Bool = -15006 #%(T_51_META_TYP_15_I6)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Combatable\r
@Addable=["CustomLevelObject"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type FightingEntity : AimableEntity = 12 { #%(T_46_META_WS_C_COMBATABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Buffable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type BuffableEntity : Entity = 306 { #%(T_46_META_WS_C_BUFFABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Spawn\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SpawnableEntity : Entity = 77 { #%(T_46_META_WS_C_SPAWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Spawnable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type InstanceEntity : Entity = 78 { #%(T_46_META_WS_C_SPAWNABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerStateType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerStateType : Int = 32 { #%(T_46_META_WS_C_PLAYERSTATETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Alive\r
    Alive = 1 #%(T_46_META_WS_E_ALIVE)\r
	@ApiLevel=4\r
	@ScriptName=KnockedDown\r
    KnockDown = 2 #%(T_46_META_WS_E_KNOCKEDDOWN)\r
	@ApiLevel=4\r
	@ScriptName=Dead\r
    Dead = 3 #%(T_46_META_WS_E_DEAD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerPoseType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerPhysXPoseType : Int = 372 { #%(T_46_META_WS_C_PLAYERPOSETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Standing\r
    EPHYSXPOSE_STANDING = 0 #%(T_46_META_WS_E_STANDING)\r
	@ApiLevel=4\r
	@ScriptName=Crouching\r
    EPHYSXPOSE_CROUCHING = 1 #%(T_46_META_WS_E_CROUCHING)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
    EPHYSXPOSE_DASHING = 2 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@ScriptName=Prone\r
    EPHYSXPOSE_CREEPING = 3 #%(T_46_META_WS_E_PRONE)\r
	@ApiLevel=3\r
	@ScriptName=Swimdash\r
    EPHYSXPOSE_SWIMDASH = 4 #EPHYSXPOSE_SWIMDASH\r
	@ApiLevel=3\r
	@ScriptName=Skydiving\r
    EPHYSXPOSE_SKYDIVING = 5 #EPHYSXPOSE_SKYDIVING\r
	@ApiLevel=3\r
	@ScriptName=Crossover\r
    EPHYSXPOSE_CROSSOVER = 6 #EPHYSXPOSE_CROSSOVER\r
	@ApiLevel=3\r
	@ScriptName=Climbover\r
    EPHYSXPOSE_CLIMBOVER = 7 #EPHYSXPOSE_CLIMBOVER\r
	@ApiLevel=3\r
	@ScriptName=Knockdown\r
    EPHYSXPOSE_KNOCKDOWN = 8 #EPHYSXPOSE_KNOCKDOWN\r
	@ApiLevel=3\r
	@ScriptName=Swimsurfing\r
    EPHYSXPOSE_SWIMSURFING = 9 #EPHYSXPOSE_SWIMSURFING\r
	@ApiLevel=3\r
	@ScriptName=Highfalling\r
    EPHYSXPOSE_HIGHFALLING = 10 #EPHYSXPOSE_HIGHFALLING\r
	@ApiLevel=4\r
	@ScriptName=LowFalling\r
    EPHYSXPOSE_LOWFALLING = 11 #%(T_46_META_WS_E_LOWFALLING)\r
	@ApiLevel=3\r
	@ScriptName=Jetflyrush\r
    EPHYSXPOSE_JETFLYRUSH = 12 #EPHYSXPOSE_JETFLYRUSH\r
	@ApiLevel=3\r
	@ScriptName=Secondfalling\r
    EPHYSXPOSE_SECONDFALLING = 13 #EPHYSXPOSE_SECONDFALLING\r
	@ApiLevel=3\r
	@ScriptName=Sitting\r
    EPHYSXPOSE_SITTING = 14 #EPHYSXPOSE_SITTING\r
	@ApiLevel=3\r
	@ScriptName=Catapultfalling\r
    EPHYSXPOSE_CATAPULTFALLING = 15 #EPHYSXPOSE_CATAPULTFALLING\r
	@ApiLevel=3\r
	@ScriptName=Catapultstanding\r
    EPHYSXPOSE_CATAPULTSTANDING = 16 #EPHYSXPOSE_CATAPULTSTANDING\r
	@ApiLevel=3\r
	@ScriptName=Gliding\r
    EPHYSXPOSE_GLIDING = 17 #EPHYSXPOSE_GLIDING\r
	@ApiLevel=3\r
	@ScriptName=Glidefalling\r
    EPHYSXPOSE_GLIDEFALLING = 18 #EPHYSXPOSE_GLIDEFALLING\r
	@ApiLevel=3\r
	@ScriptName=Fountainfalling\r
    EPHYSXPOSE_FOUNTAINFALLING = 19 #EPHYSXPOSE_FOUNTAINFALLING\r
	@ApiLevel=3\r
	@ScriptName=Humantirefalling\r
    EPHYSXPOSE_HUMANTIREFALLING = 20 #EPHYSXPOSE_HUMANTIREFALLING\r
	@ApiLevel=3\r
	@ScriptName=Partydance\r
    EPHYSXPOSE_PARTYDANCE = 21 #EPHYSXPOSE_PARTYDANCE\r
	@ApiLevel=3\r
	@ScriptName=Flightroamrush\r
    EPHYSXPOSE_FLIGHTROAMRUSH = 22 #EPHYSXPOSE_FLIGHTROAMRUSH\r
	@ApiLevel=3\r
	@ScriptName=Cannonstanding\r
    EPHYSXPOSE_CANNONSTANDING = 23 #EPHYSXPOSE_CANNONSTANDING\r
	@ApiLevel=3\r
	@ScriptName=Platform_Falling\r
    EPHYSXPOSE_PLATFORM_FALLING = 24 #EPHYSXPOSE_PLATFORM_FALLING\r
	@ApiLevel=3\r
	@ScriptName=Jumppadfalling\r
    EPHYSXPOSE_JUMPPADFALLING = 25 #EPHYSXPOSE_JUMPPADFALLING\r
	@ApiLevel=3\r
	@ScriptName=Stropfalling\r
    EPHYSXPOSE_STROPFALLING = 26 #EPHYSXPOSE_STROPFALLING\r
	@ApiLevel=3\r
	@ScriptName=Count\r
    EPHYSXPOSE_COUNT = 27 #EPHYSXPOSE_COUNT\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Resettable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ResetableEntity : Entity = 28 { #%(T_46_META_WS_C_RESETABLE)\r
	@ApiLevel=4\r
	@ScriptName=ResetPerRound\r
    ResetPerRound : Bool = -28000 #%(T_46_META_WS_P_RESETPERROUND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GenderType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum GenderType : Int = 272 { #%(T_46_META_WS_C_GENDERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=FeMale\r
    FeMale = 1 #%(T_46_META_WS_E_FEMALE)\r
	@ApiLevel=4\r
	@ScriptName=Male\r
    Male = 2 #%(T_46_META_WS_E_MALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOutfit\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type PlayerAvatarInfo : Entity = 269 { #%(T_46_META_WS_C_PLAYEROUTFIT)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
    get Owner : Player = -269000 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=4\r
	@ScriptName=Set\r
    get CustomClothSetID : ClothID = -269001 #%(T_46_META_WS_P_SET)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
    get CustomClothHairID : ClothID = -269002 #%(T_46_META_WS_P_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Mask\r
    get CustomClothHeadAdditiveID : ClothID = -269003 #%(T_46_META_WS_P_MASK)\r
	@ApiLevel=4\r
	@ScriptName=Facepaint\r
    get CustomClothFaceID : ClothID = -269004 #%(T_46_META_WS_P_FACEPAINT)\r
	@ApiLevel=4\r
	@ScriptName=Top\r
    get CustomClothChestID : ClothID = -269005 #%(T_46_META_WS_P_TOP)\r
	@ApiLevel=4\r
	@ScriptName=Bottom\r
    get CustomClothLegsID : ClothID = -269006 #%(T_46_META_WS_P_BUTTOM)\r
	@ApiLevel=4\r
	@ScriptName=Shoes\r
    get CustomClothFeetID : ClothID = -269007 #%(T_46_META_WS_P_SHOES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TransformClothInfo\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type TransformClothInfo : Entity = 428 { #%(T_48_META_TYP_428)\r
	@ApiLevel=3\r
	@ScriptName=CurWeaponSkinID\r
    get CurWeaponSkinID : WeaponSkinID = -428000 #%(T_46_META_WS_P_WEAPONSKINIDS)\r
	@ApiLevel=3\r
	@ScriptName=BackpackSkinID\r
    get BagSkinID : Int = -428001 #%(T_46_META_WS_P_BACKPACKSKINID)\r
	@ApiLevel=3\r
	@ScriptName=Set\r
    get CustomClothSetID : ClothID = -428002 #%(T_46_META_WS_P_SET)\r
	@ApiLevel=3\r
	@ScriptName=Head\r
    get CustomClothHairID : ClothID = -428003 #%(T_46_META_WS_P_HEAD)\r
	@ApiLevel=3\r
	@ScriptName=Mask\r
    get CustomClothHeadAdditiveID : ClothID = -428004 #%(T_46_META_WS_P_MASK)\r
	@ApiLevel=3\r
	@ScriptName=Facepaint\r
    get CustomClothFaceID : ClothID = -428005 #%(T_46_META_WS_P_FACEPAINT)\r
	@ApiLevel=3\r
	@ScriptName=Top\r
    get CustomClothChestID : ClothID = -428006 #%(T_46_META_WS_P_TOP)\r
	@ApiLevel=3\r
	@ScriptName=Bottom\r
    get CustomClothLegsID : ClothID = -428007 #%(T_46_META_WS_P_BUTTOM)\r
	@ApiLevel=3\r
	@ScriptName=Shoes\r
    get CustomClothFeetID : ClothID = -428008 #%(T_46_META_WS_P_SHOES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ProfilePictureWidget\r
@ModuleID=16\r
@ModuleLib=Hud\r
type ProfileInfo : Entity = 326 { #%(T_46_META_WS_C_PROFILEPICTUREWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=AccountID\r
    get AccountID : UUID = -326000 #%(T_46_META_WS_P_ACCOUNTID)\r
	@ApiLevel=4\r
	@ScriptName=AvatarID\r
    get HeadID : String = -326001 #%(T_46_META_WS_P_AVATARID)\r
	@ApiLevel=4\r
	@ScriptName=BannerID\r
    get BannerID : String = -326002 #%(T_46_META_WS_P_BANNERID)\r
	@ApiLevel=4\r
	@ScriptName=PinID\r
    get PinID : String = -326003 #%(T_46_META_WS_P_PINID)\r
	@ApiLevel=4\r
	@ScriptName=NickName\r
    get NickName : String = -326004 #%(T_46_META_WS_P_NICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=BRRank\r
    get BRRank : Int = -326005 #%(T_46_META_WS_P_BRRANK)\r
	@ApiLevel=4\r
	@ScriptName=HighestBRrank\r
    get BRPeakRank : Int = -326006 #%(T_46_META_WS_P_HIGHESTBRRANK)\r
	@ApiLevel=4\r
	@ScriptName=CSRank\r
    get CSRank : Int = -326007 #%(T_46_META_WS_P_CSRANK)\r
	@ApiLevel=4\r
	@ScriptName=HighestCSrank\r
    get CSPeakRank : Int = -326008 #%(T_46_META_WS_P_HIGHESTCSRANK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Formulable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type FormulableEntity : Entity = 93 { #%(T_46_META_WS_C_FORMULABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Player\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Player : FightingEntity&ScoreableEntity&RankableEntity&Visibility&BuffableEntity&FormulableEntity&AnimationControllerAble = 14 { #%(T_46_META_WS_C_PLAYER)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
    HP : Int = -14000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
    HPMAX : Int = -14001 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=IsMonster\r
    get IsAI : Bool = -14002 #%(T_46_META_WS_P_ISAI)\r
	@ApiLevel=4\r
	@ScriptName=PlayerStatus\r
    get State : PlayerStateType = -14003 #%(T_46_META_WS_P_PLAYERSTATUS)\r
	@ApiLevel=4\r
	@ScriptName=LastSurvivalTime\r
    get LastSurvivalTime : Int = -14004 #%(T_46_META_WS_P_LASTSURVIVALTIME)\r
	@ApiLevel=4\r
	@ScriptName=Invincible\r
    GodState : Bool = -14005 #%(T_46_META_WS_P_INVINCIBLE)\r
	@ApiLevel=4\r
	@ScriptName=HostTeam\r
    get HostTeamEntity : Team = -14006 #%(T_46_META_WS_P_HOSTTEAM)\r
	@ApiLevel=4\r
	@ScriptName=LastCheckPointID\r
    LastCheckPointID : Int = -14007 #%(T_46_META_WS_P_LASTCHECKPOINTID)\r
	@ApiLevel=4\r
	@ScriptName=TargetCheckpointID\r
    NextCheckPointID : Int = -14008 #%(T_46_META_WS_P_TARGETCHECKPOINTID)\r
	@ApiLevel=10\r
	@ScriptName=BornPosition_Deprecated\r
    get BornPosition : DirectedPoint = -14009 #%(T_34_WT_WS_PLAYERENTITY_PARAM9)\r
	@ApiLevel=10\r
	@ScriptName=RevivePosition_Deprecated\r
    RevivePosition : DirectedPoint = -14010 #%(T_34_WT_WS_PLAYERENTITY_PARAM10)\r
	@ApiLevel=3\r
	@ScriptName=Faction_ForInfection\r
    Faction : Int = -14011 #%(T_40_XXJ_WS_FACINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=WeaponDamageRate\r
    UGCWeaponDamageRate : Float = -14012 #%(T_46_META_WS_P_WEAPONDAMAGERATE)\r
	@ApiLevel=3\r
	@ScriptName=HumanModel\r
    HumanModel : HumanModelID = -14013 #%(T_34_WT_WS_PLAYERENTITY_PARAM13)\r
	@ApiLevel=4\r
	@ScriptName=RunSpeedScale\r
    RunSpeedScale : Float = -14014 #%(T_46_META_WS_P_RUNSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=JumpHeightScale\r
    JumpHeightScale : Float = -14015 #%(T_46_META_WS_P_JUMPHEIGHTSCALE)\r
	@ApiLevel=3\r
	@ScriptName=Identity_ForInfection\r
    Identity : Int = -14016 #%(T_34_WT_WS_PLAYERENTITY_PARAM17)\r
	@ApiLevel=3\r
	@ScriptName=MonsterLevel\r
    ZombieLevel : Int = -14017 #%(T_43_XXJ_WS_LEVEL_D1)\r
	@ApiLevel=10\r
	@ScriptName=DirectPosition_Deprecated\r
    get DirectPosition : DirectedPoint = -14018 #%(T_36_WZY_WS_DIRPOINT)\r
	@ApiLevel=4\r
	@ScriptName=NickName\r
    get NickName : String = -14019 #%(T_46_META_WS_P_NICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=DamageTakenPercent\r
    InjuredScale : Float = -14020 #%(T_46_META_WS_P_DAMAGETAKENPCT)\r
	@ApiLevel=4\r
	@ScriptName=EP\r
    EP : Int = -14021 #%(T_46_META_WS_P_EP)\r
	@ApiLevel=4\r
	@ScriptName=EPMAX\r
    EPMAX : Int = -14022 #%(T_46_META_WS_P_EPMAX)\r
	@ApiLevel=4\r
	@ScriptName=MainWeapon\r
    get WeaponInHand : Weapon = -14023 #%(T_46_META_WS_P_MAINWEAPON)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsDropOnEliminated\r
    RemoveAllEquipmentOnDeath : Bool = -14024 #%(T_46_META_WS_P_ISDROPONELIMINATED)\r
	@ApiLevel=10\r
	@Default=false\r
	@ScriptName=SkipKnockdown\r
    SkipKnockdown : Bool = -14025 #%(T_36_WZY_WS_SKIPKNODOWN)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=AimAssistType\r
    AimAssistType : AimAssistType = -14026 #%(T_46_META_WS_P_AIMASSISTTYPE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=AllowLockByAimAssist\r
    CanBeLockedByAimAssist : Bool = -14027 #%(T_46_META_WS_P_ALLOWLOCKBYAIMASSIST)\r
	@ApiLevel=4\r
	@ScriptName=MuteVoiceChat\r
    get MuteVoice : Bool = -14028 #%(T_46_META_WS_P_DISABLEVOICECHAT)\r
	@ApiLevel=4\r
	@ScriptName=MuteQuickChat\r
    get MuteQuickChat : Bool = -14029 #%(T_46_META_WS_P_DISABLEQUICKCHAT)\r
	@ApiLevel=4\r
	@ScriptName=ChatChannel\r
    get ChatChannel : ChatChannel = -14030 #%(T_46_META_WS_P_CHATCHANNEL)\r
	@ApiLevel=10\r
	@ScriptName=MovementStatus_Deprecated\r
    get MovementStatus : PlayerBehaviorStatus = -14031 #%(T_42_XXJ_WS_MOVEMENTSTATUS)\r
	@ApiLevel=10\r
	@ScriptName=SprintStatus_Deprecated\r
    get SprintStatus : PlayerBehaviorStatus = -14032 #%(T_42_XXJ_WS_SPRINTSTATUS)\r
	@ApiLevel=10\r
	@ScriptName=AttackStatus_Deprecated\r
    get AttackStatus : PlayerBehaviorStatus = -14033 #%(T_42_XXJ_WS_ATTACKSTATUS)\r
	@ApiLevel=10\r
	@ScriptName=JumpStatus_Deprecated\r
    get JumpStatus : PlayerBehaviorStatus = -14034 #%(T_42_XXJ_WS_JUMPSTATUS)\r
	@ApiLevel=4\r
	@ScriptName=DisableItemPickup\r
    PickupItemDisabled : Bool = -14035 #%(T_46_META_WS_P_DISABLEITEMPICKUP)\r
	@ApiLevel=4\r
	@ScriptName=DisableItemDrop\r
    DropItemDisabled : Bool = -14036 #%(T_46_META_WS_P_DISABLEITEMDROP)\r
	@ApiLevel=4\r
	@ScriptName=AttackableTargets\r
    get HostilePlayers : ListT_Player = -14037 #%(T_46_META_WS_P_ATTTACKABLETARGETS)\r
	@ApiLevel=4\r
	@ScriptName=FriendPlayers\r
    get FriendlyPlayers : ListT_Player = -14038 #%(T_46_META_WS_P_FRIENDLYPLAYERS)\r
	@ApiLevel=10\r
	@ScriptName=Faction\r
    get FactionEntity : Faction = -14039 #%(T_46_META_WS_P_FACTION)\r
	@ApiLevel=10\r
	@ScriptName=NumberInFaction\r
    get FactionIndex : Int = -14040 #%(T_46_META_WS_P_NUMBERINFACTION)\r
	@ApiLevel=4\r
	@ScriptName=MainCamera\r
    CurrentCameraConfig : CameraConfig = -14041 #%(T_46_META_WS_P_MAIN CAMERA)\r
	@ApiLevel=4\r
	@Default=-9.8\r
	@ScriptName=Gravity\r
    CustomGravity : Float = -14042 #%(T_46_META_WS_P_GRAVITY)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
    get Helmet : Helmet = -14043 #%(T_46_META_WS_P_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
    get Vest : Vest = -14044 #%(T_46_META_WS_P_VEST)\r
	@ApiLevel=4\r
	@ScriptName=CrouchWalkSpeedScale\r
    CrouchSpeedScale : Float = -14045 #%(T_46_META_WS_P_CROUCHWALKSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=SprintSpeedScale\r
    DashSpeedScale : Float = -14046 #%(T_46_META_WS_P_SPRINTSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=DownedCrawlSpeedScale\r
    KnockDownSpeedScale : Float = -14047 #%(T_46_META_WS_P_DOWNEDCRAWLSPEEDSCALE)\r
	@ApiLevel=4\r
	@ScriptName=CrawlSpeedScale\r
    CreepSpeedScale : Float = -14048 #%(T_46_META_WS_P_CRAWLSPEEDSCALE)\r
	@ApiLevel=10\r
	@Default=&math.Vector3(1, 1, 1)\r
	@ScriptName=HeadBonesScale_Deprecated\r
    HeadBonesScale : Vector3 = -14049 #%(T_39_WZY_WS_HEADSCALE)\r
	@ApiLevel=10\r
	@Default=&math.Vector3(1, 1, 1)\r
	@ScriptName=BodyBonesScale_Deprecated\r
    BodyBonesScale : Vector3 = -14050 #%(T_39_WZY_WS_BODYSCALE)\r
	@ApiLevel=10\r
	@Default=&math.Vector3(1, 1, 1)\r
	@ScriptName=LimbBonesScale_Deprecated\r
    LimbBonesScale : Vector3 = -14051 #%(T_39_WZY_WS_LIMBSCALE)\r
	@ApiLevel=4\r
	@ScriptName=UserUID\r
    get UserUID : UUID = -14052 #%(T_46_META_WS_P_USERUID)\r
	@ApiLevel=4\r
	@ScriptName=HeadshotDamageReduction\r
    UGCHeadshotDamageDecreaseScale : Float = -14053 #%(T_46_META_WS_P_HEADSHOTDAMAGEREDUCTION)\r
	@ApiLevel=4\r
	@ScriptName=Outfit\r
    get PlayerAvatar : PlayerAvatarInfo = -14054 #%(T_46_META_WS_P_OUTFIT)\r
	@ApiLevel=4\r
	@ScriptName=Gender\r
    get Gender : GenderType = -14055 #%(T_46_META_WS_P_GENDER)\r
	@ApiLevel=4\r
	@ScriptName=WeaponSkinIDs\r
    get WeaponSkinID : ListT_WeaponSkinID = -14056 #%(T_46_META_WS_P_WEAPONSKINIDS)\r
	@ApiLevel=4\r
	@ScriptName=SpawnPoint\r
    get BornPositionVec3 : Vector3 = -14057 #%(T_46_META_WS_P_SPAWNPOINT)\r
	@ApiLevel=4\r
	@ScriptName=RevivalPoint\r
    RevivePositionVec3 : Vector3 = -14058 #%(T_46_META_WS_P_REVIVALPOINT)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
    get DirectPositionVec3 : Vector3 = -14059 #%(T_46_META_WS_P_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Forward\r
    get DirectForwardVec3 : Vector3 = -14060 #%(T_46_META_WS_P_FORWARD)\r
	@ApiLevel=4\r
	@ScriptName=Skeleton\r
    get Bones : Skeleton = -14061 #%(T_46_META_WS_P_SKELETON)\r
	@ApiLevel=4\r
	@ScriptName=Backpack\r
    get PlayerBagEntity : PlayerBag = -14062 #%(T_46_META_WS_P_BACKPACK)\r
	@ApiLevel=4\r
	@ScriptName=TemporaryShieldPoints\r
    TemporaryShield : Int = -14063 #%(T_46_META_WS_P_TEMPORARYSHIELDPOINTS)\r
	@ApiLevel=4\r
	@ScriptName=VehicleSkinIDs\r
    get VehicleSkinIDs : ListT_Int = -14064 #%(T_46_META_WS_P_VEHICLESKINIDS)\r
	@ApiLevel=4\r
	@ScriptName=IsSkipStaggerAnimation\r
    AnimSkipFallingLand : Bool = -14065 #%(T_46_META_WS_P_ISSKIPSTAGGERANIMATION)\r
	@ApiLevel=4\r
	@ScriptName=DisableFallDamage\r
    FallDamageDisabled : Bool = -14066 #%(T_46_META_WS_P_DISABLEFALLDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=CurrentItemInHand\r
    get HandHeldItem : Entity = -14067 #%(T_46_META_WS_P_CURRENTHANDHELDITEM)\r
	@ApiLevel=4\r
	@ScriptName=ItemPickupBanlist\r
    DisablePickUpItems : ListT_ItemGoodsIDType = -14068 #%(T_46_META_WS_P_ITEMPICKUPBANLIST)\r
	@ApiLevel=4\r
	@ScriptName=CustomCharacterResource\r
    ResPlayerUUID : PlayerDataID = -14069 #%(T_46_META_WS_P_CUSTOMCHARACTERRESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=AskBuyTarget\r
    AskBuyTarget : RequestPurchaseType = -14070 #%(T_46_META_WS_P_ASKBUYTARGET)\r
	@ApiLevel=4\r
	@ScriptName=CurrentAnimationResource\r
    get CurrentEmoteClip : AnimationClipID = -14071 #%(T_46_META_WS_P_CURRENTANIMATIONRESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=IsCurrentAnimationLoop\r
    get IsCurrentEmoteLoop : Bool = -14072 #%(T_46_META_WS_P_ISCURRENTANIMATIONLOOP)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=KnockdownStatus\r
    KnockDown : KnockDownStateType = -14073 #%(T_46_META_WS_P_KNOCKDOWNSTATUS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowDamageNumber\r
    ShowDamageNum : Bool = -14074 #%(T_46_META_WS_P_SHOWDAMAGENUMBER)\r
	@ApiLevel=4\r
	@ScriptName=BackpackSkinID\r
    get BagSkinID : Int = -14075 #%(T_46_META_WS_P_BACKPACKSKINID)\r
	@ApiLevel=3\r
	@ScriptName=CanQuitMdiway\r
	@ApiTarget=1\r
    get CanFreeQuit : Bool = -14076 #%(T_48_META_API_90_P1)\r
	@ApiLevel=3\r
	@ScriptName=TransformClothInfo\r
    get TransformClothInfo : TransformClothInfo = -14077 #TransformClothInfo\r
	@ApiLevel=4\r
	@ScriptName=CustomCamera\r
    CurrentNewCamera : BasicCamera = -14078 #%(T_49_META_TYP_449)\r
	@ApiLevel=4\r
	@ScriptName=BindCustomPlayer\r
    get BindedCustomPlayer : Entity = -14079 #%(T_51_META_TYP_14_I79)\r
	@ApiLevel=4\r
    get PlatformPlayerLevel : Int = -14080 #%(T_53_META_TYP_14_I80)\r
	@ApiLevel=4\r
	@Default=1\r
    FallingAngularSpeedScale : Float = -14081 #%(T_55_META_TYP_14_I81)\r
	@ApiLevel=4\r
	@Default=1\r
    RunAngularSpeedScale : Float = -14082 #%(T_55_META_TYP_14_I82)\r
	@ApiLevel=4\r
	@Default=1\r
    CrouchAngularSpeedScale : Float = -14083 #%(T_55_META_TYP_14_I83)\r
	@ApiLevel=4\r
	@Default=1\r
    CrawlAngularSpeedScale : Float = -14084 #%(T_55_META_TYP_14_I84)\r
	@ApiLevel=4\r
	@Default=1\r
    KnockDownAngularSpeedScale : Float = -14085 #%(T_55_META_TYP_14_I85)\r
	@ApiLevel=4\r
	@ApiTarget=1\r
    CameraSensitivity : Float = -14086 #%(T_55_META_TYP_14_I86)\r
	@ApiLevel=4\r
    get CharacterID : Int = -14087 #%(T_55_META_TYP_14_I87)\r
	@ApiLevel=4\r
	@ScriptName=Velocity\r
	@ApiTarget=0\r
    get Velocity : Vector3 = -14088 #%(T_46_META_WS_P_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=KnockDownType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum KnockDownStateType : Int = 382 { #%(T_46_META_WS_C_KNOCKDOWNTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=SkipKnockDown\r
    SkipKnockDown = 1 #%(T_46_META_WS_E_SKIPKNOCKDOWN)\r
	@ApiLevel=4\r
	@ScriptName=NoSkipKnockdown\r
    MustKnockDown = 2 #%(T_46_META_WS_E_NOSKIPKNOCKDOWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeAttachable\r
@Addable=["LevelObject","AI"]\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTreeAttachable : Entity = 293 { #%(T_46_META_WS_C_BEVTREEATTACHABLE)\r
	@ApiLevel=4\r
	@ScriptName=BevTreeID\r
    BTreeID : BTreeID = -293000 #%(T_46_META_WS_P_BEVTREEID)\r
	@ApiLevel=4\r
	@ScriptName=AttachTarget\r
    get TargetTree : BehaviourTree = -293001 #%(T_46_META_WS_P_ATTACHTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeAttachableForClient\r
@Addable=["LevelObject","AI"]\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTreeAttachableForClient : Entity = 461 { #%(T_52_META_TYP_461)\r
	@ApiLevel=4\r
	@ScriptName=BevTreeID\r
    BTreeID : BTreeID = -461000 #%(T_46_META_WS_P_BEVTREEID)\r
	@ApiLevel=4\r
	@ScriptName=AttachTarget\r
    get TargetTree : BehaviourTree = -461001 #%(T_46_META_WS_P_ATTACHTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LevelObject\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type LevelObject : Transform&Visibility = 16 { #%(T_40_XXJ_WS_LEVELOBJECT)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
    get Name : String = -16000 #%(TXT_CLAN_NAME)\r
	@ApiLevel=3\r
	@ScriptName=ItemID\r
    get ItemID : LevelObjectID = -16001 #%(T_40_XXJ_WS_ITEMID_NAMEKEY)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsNavMeshStatic\r
    get IsNavMeshStatic : Bool = -16002 #%(T_41_XXJ_WS_ISNAVMESHSTATIC)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsDynamicObstacle\r
    get IsDynamicObstacle : Bool = -16003 #%(T_44_XXJ_WS_ISDYNAMICOBSTACLE)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsAsyncLoad\r
    get IsAsyncLoad : Bool = -16004 #IsAsyncLoad\r
	@ApiLevel=11\r
	@Default=0\r
	@ScriptName=ShopItemID\r
    get ShopItemID : Int64 = -16005 #ShopItemID\r
	@ApiLevel=11\r
	@Default=0\r
	@ScriptName=ShopItemVersion\r
    get ShopItemVersion : Int = -16006 #ShopItemVersion\r
	@ApiLevel=11\r
	@Default=0\r
	@ScriptName=EditState\r
    get EditState : Int = -16007 #EditState\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_LevelObject\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_LevelObject : List = 17 { #%(T_46_META_WS_C_LISTT_LEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuiltInUIType\r
@ModuleID=31\r
@ModuleLib=Hud\r
@genTypeEnum base = InternalHud\r
enum InternalHudType : Type = 20 { #%(T_46_META_WS_C_BUILTINUITYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PurchaseStatus\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
enum PurchaseStatus : Int = 467 { #%(T_53_META_TYP_467)\r
	@ApiLevel=4\r
	@ScriptName=Purchased\r
    Purchased = 0 #%(T_53_META_TYP_467_I0)\r
	@ApiLevel=4\r
	@ScriptName=NotPurchased\r
    NotPurchased = 1 #%(T_53_META_TYP_467_I1)\r
	@ApiLevel=4\r
	@ScriptName=UnderReview\r
    UnderReview = 2 #%(T_53_META_TYP_467_I2)\r
	@ApiLevel=4\r
	@ScriptName=NetworkError\r
    NetworkError = 3 #%(T_53_META_TYP_467_I3)\r
	@ApiLevel=4\r
	@ScriptName=RegionClosed\r
    RegionClosed = 4 #%(T_54_META_TYP_468_I5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ConsumeStatus\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
enum ConsumeStatus : Int = 468 { #%(T_53_META_TYP_468)\r
	@ApiLevel=4\r
	@ScriptName=Success\r
    Success = 0 #%(T_53_META_TYP_468_I0)\r
	@ApiLevel=4\r
	@ScriptName=InsufficientCount\r
    InsufficientCount = 1 #%(T_53_META_TYP_468_I1)\r
	@ApiLevel=4\r
	@ScriptName=NotFound\r
    NotFound = 2 #%(T_53_META_TYP_468_I2)\r
	@ApiLevel=4\r
	@ScriptName=InvalidCount\r
    InvalidCount = 3 #%(T_53_META_TYP_468_I3)\r
	@ApiLevel=4\r
	@ScriptName=NetworkError\r
    NetworkError = 4 #%(T_53_META_TYP_467_I3)\r
	@ApiLevel=4\r
	@ScriptName=RegionClosed\r
    RegionClosed = 5 #%(T_54_META_TYP_468_I5)\r
	@ApiLevel=4\r
	@ScriptName=UndefinedError\r
    UndefinedError = 999 #%(T_53_META_TYP_468_I5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ProductStatus\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
enum ProductStatus : Int = 501 { #%(T_55_META_TYP_501)\r
	@ApiLevel=4\r
	@ScriptName=NotFound\r
    NotFound = 0 #%(T_55_META_TYP_501_I0)\r
	@ApiLevel=4\r
	@ScriptName=Offline\r
    Offline = 1 #%(T_55_META_TYP_501_I1)\r
	@ApiLevel=4\r
	@ScriptName=PreOnline\r
    PreOnline = 2 #%(T_55_META_TYP_501_I2)\r
	@ApiLevel=4\r
	@ScriptName=Online\r
    Online = 3 #%(T_55_META_TYP_501_I3)\r
	@ApiLevel=4\r
	@ScriptName=NetworkError\r
    NetworkError = 4 #%(T_53_META_TYP_467_I3)\r
	@ApiLevel=4\r
	@ScriptName=RegionClosed\r
    RegionClosed = 5 #%(T_54_META_TYP_468_I5)\r
	@ApiLevel=4\r
	@ScriptName=UndefinedError\r
    UndefinedError = 999 #%(T_53_META_TYP_468_I5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuiltInUI\r
@ModuleID=31\r
@ModuleLib=Hud\r
type InternalHud : Entity = 21 { #%(T_46_META_WS_C_BUILTINUI)\r
	@ApiLevel=3\r
	@ScriptName=Depth\r
    Depth : Int = -21000 #%(T_46_META_WS_P_DEPTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUI\r
@ModuleID=16\r
@ModuleLib=Hud\r
type CustomHud : Entity = 22 { #%(T_46_META_WS_C_CUSTOMUI)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -22000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=PrefabID\r
    get PrefabID : Int = -22001 #%(T_46_META_WS_P_PREFABID)\r
	@ApiLevel=3\r
	@ScriptName=MaxWidgetID\r
    get MaxWidgetID : Int = -22002 #%(T_46_META_WS_P_MAXWIDGETID)\r
	@ApiLevel=4\r
	@ScriptName=Depth\r
    Depth : Int = -22003 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=4\r
	@ScriptName=FollowWorldPosition\r
    OpenPlayerView : Bool = -22004 #%(T_55_META_TYP_22_I4)\r
	@ApiLevel=4\r
	@ScriptName=WorldPosition\r
    WorldPosition : Vector3 = -22005 #%(T_46_META_WS_P_WORLDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=InScene\r
    InScene : Bool = -22006 #%(T_46_META_WS_P_INSCENE)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
    Rotation : Vector3 = -22007 #%(T_46_META_WS_P_ROTATION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
    Scale : Vector3 = -22008 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=UIAssetID\r
    get HudAssetID : CustomHudAssetID = -22009 #%(T_50_META_API_114_P2)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=SceneUIIsBillboard\r
    SceneUIIsBillboard : Bool = -22010 #%(T_55_META_TYP_22_I10)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LevelObjectType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@genTypeEnum base = LevelObject\r
enum LevelObjType : Type = 23 { #%(T_46_META_WS_C_LEVELOBJECTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DamageType\r
@ModuleID=10016\r
@ModuleLib=Combat\r
enum DamageType : Int = 24 { #%(T_46_META_WS_C_DAMAGETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
    Melee = 1 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=Gun\r
    Gun = 2 #%(T_46_META_WS_E_GUN)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
    Grenade = 3 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=ElectricZone\r
    ElectricZone = -1 #%(T_46_META_WS_E_ELECTRICZONE)\r
	@ApiLevel=4\r
	@ScriptName=Vehicle\r
    Vehicle = -2 #%(T_46_META_WS_E_VEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=Falling\r
    Falling = -4 #%(T_46_META_WS_E_FALLING)\r
	@ApiLevel=4\r
	@ScriptName=KillZone\r
    KillZone = -14 #%(T_46_META_WS_E_KILLZONE)\r
	@ApiLevel=4\r
	@ScriptName=Exit\r
    Leave = -50 #%(T_46_META_WS_E_EXIT)\r
	@ApiLevel=4\r
	@ScriptName=Disconnect\r
    Disconnect = -51 #%(T_46_META_WS_E_DISCONNECT)\r
	@ApiLevel=4\r
	@ScriptName=VehicleExplode\r
    VehicleExplode = -6 #%(T_46_META_WS_E_VEHICLEEXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=Airdrop\r
    Airdrop = -8 #%(T_46_META_WS_E_AIRDROP)\r
	@ApiLevel=4\r
	@ScriptName=Burning\r
    Burning = -10 #%(T_46_META_WS_E_BURNING)\r
	@ApiLevel=4\r
	@ScriptName=OilDrumExplode\r
    OildrumExplode = -16 #%(T_46_META_WS_E_OILDRUMEXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=MissileExplode\r
    MissileExplode = -17 #%(T_46_META_WS_E_MISSILEEXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=Monster\r
    Zombie = -19 #%(T_46_META_WS_E_MONSTER)\r
	@ApiLevel=4\r
	@ScriptName=DamageZone\r
    DamageZone = -20 #%(T_46_META_WS_E_DAMAGEZONE)\r
	@ApiLevel=4\r
	@ScriptName=MiniSentry\r
    MiniSentry = -23 #%(T_46_META_WS_E_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=CharacterSkill\r
    ActivitySkill = -31 #%(T_46_META_WS_E_CHARACTERSKILL)\r
	@ApiLevel=4\r
    ExecuteSkill = -40 #%(T_53_META_TYP_24_I18)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Phase\r
@ModuleID=1\r
@ModuleLib=Workflow\r
type Phase : Entity = 25 { #%(T_46_META_WS_C_PHASE)\r
	@ApiLevel=4\r
	@ScriptName=Index\r
    get PhaseIndex : Int = -25000 #%(T_46_META_WS_P_INDEX)\r
	@ApiLevel=4\r
	@ScriptName=StartTime\r
    get PhaseStartTime : Int = -25001 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@ScriptName=EndTime\r
    get PhaseEndTime : Int = -25002 #%(T_46_META_WS_P_ENDTIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    get PhaseDuration : Int = -25003 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Round\r
@ModuleID=2\r
@ModuleLib=Workflow\r
type Round : Entity = 26 { #%(T_46_META_WS_C_ROUND)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ScoreType\r
@ModuleID=5\r
@ModuleLib=GameResult\r
enum ScoreType : Int = 27 { #%(T_34_M_WS_SCORINGTYPE)\r
	@ApiLevel=4\r
	@ScriptName=KillCount\r
    KillCount = 1 #%(T_34_M_WS_ST_KILLCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=DamageSum\r
    DamageSum = 2 #%(T_34_M_WS_ST_DAMAGESUM)\r
	@ApiLevel=4\r
	@ScriptName=AssistCount\r
    AssistCount = 3 #%(T_34_M_WS_ST_ASSISTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=FinishOrder\r
    FinishOrder = 4 #%(T_34_M_WS_ST_FINISHORDER)\r
	@ApiLevel=4\r
	@ScriptName=FinishTimestamp\r
    FinishTimestamp = 5 #%(T_34_M_WS_ST_FINISHTIME)\r
	@ApiLevel=4\r
	@ScriptName=FinishCount\r
    FinishCount = 6 #%(T_34_M_WS_ST_FINISHCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=CheckPointProgress\r
    CheckPointProgress = 7 #%(T_34_M_WS_ST_CHECKPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=RankScore\r
    RankScore = 8 #%(T_34_M_WS_ST_RANKSCORE)\r
	@ApiLevel=4\r
	@ScriptName=SurvivalDuration\r
    SurvivalDuration = 9 #%(T_34_M_WS_ST_SURVIVALDURACTION)\r
	@ApiLevel=4\r
	@ScriptName=MainScore\r
    MainScore = 10 #%(T_34_M_WS_ST_MAINSCORE)\r
	@ApiLevel=4\r
	@ScriptName=MonsterKillCount\r
    ZombieKillCount = 11 #%(T_38_WZY_WS_KILLCONZOM)\r
	@ApiLevel=4\r
	@ScriptName=MonsterAssistCount\r
    ZombieAssistCount = 12 #%(T_38_WZY_WS_ASSCONZOM)\r
	@ApiLevel=4\r
	@ScriptName=MonsterDamageSum\r
    ZombieDamageSum = 13 #%(T_38_WZY_WS_DAMSUMZOM)\r
	@ApiLevel=4\r
	@ScriptName=Unknown\r
    Unknown = 0 #%(T_34_M_WS_ST_UNKOWN)\r
}\r
\r
@Accept EffectID\r
@ApiLevel=4\r
@ScriptName=VFXType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum EffectType : EffectID = 29 { #%(T_34_M_WS_VFXTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Sphere\r
    Sphere = UGC_T_34_LY_WS_VFX1 #%(T_46_META_WS_E_SPHERE)\r
	@ApiLevel=4\r
	@ScriptName=LightBeamPreDiscarded\r
    LightBeam = UGC_T_34_LY_WS_VFX2 #%(T_46_META_WS_E_LIGHTBEAMPREDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=RingPreDiscarded\r
    Ring1 = UGC_T_34_LY_WS_VFX3 #%(T_46_META_WS_E_RINGPREDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=Boom\r
    Ring2 = UGC_T_34_LY_WS_VFX4 #%(T_46_META_WS_E_BOOM)\r
	@ApiLevel=4\r
	@ScriptName=TelePort\r
    Ring3 = UGC_T_34_LY_WS_VFX5 #%(T_46_META_WS_E_TELEPORT)\r
	@ApiLevel=4\r
	@ScriptName=Recover\r
    Ring4 = UGC_T_34_LY_WS_VFX6 #%(T_46_META_WS_E_RECOVER)\r
	@ApiLevel=4\r
	@ScriptName=CircleofHeat\r
    FootBeam = UGC_T_36_M_WS_VFX6 #%(T_46_META_WS_E_CIRCLEOFHEAT)\r
	@ApiLevel=4\r
	@ScriptName=Symbolic\r
    GroundImprint = UGC_T_37_WZY_WS_VFX1 #%(T_46_META_WS_E_SYMBOLIC)\r
	@ApiLevel=4\r
	@ScriptName=Smokey\r
    Smoke = UGC_T_37_WZY_WS_VFX2 #%(T_46_META_WS_E_SMOKEY)\r
	@ApiLevel=4\r
	@ScriptName=CurseExplosion\r
    SpellBlast = UGC_T_37_WZY_WS_VFX3 #%(T_46_META_WS_E_CURSEEXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=FrozenGrenade\r
    IceGrenade = UGC_T_37_WZY_WS_VFX4 #%(T_46_META_WS_E_FROZENGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Frozen\r
    Frozen = UGC_T_37_WZY_WS_VFX5 #%(T_46_META_WS_E_FROZEN)\r
	@ApiLevel=4\r
	@ScriptName=Spotlight\r
    Light = UGC_T_37_WZY_WS_VFX6 #%(T_46_META_WS_E_SPOTLIGHT)\r
	@ApiLevel=4\r
	@ScriptName=UpwardTurbulence\r
    Updraft = UGC_T_37_WZY_WS_VFX7 #%(T_46_META_WS_E_UPWARDTURBULENCE)\r
	@ApiLevel=4\r
	@ScriptName=AtmosphereExplosion\r
    GasExplosion = UGC_T_37_WZY_WS_VFX8 #%(T_46_META_WS_E_ATMOSPHEREEXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=HiderKill\r
    HiderKill = UGC_T_38_WZY_WS_VFX1 #%(T_46_META_WS_E_HIDERKILL)\r
	@ApiLevel=4\r
	@ScriptName=Rampage\r
    SeekerGoBallistic = UGC_T_38_WZY_WS_VFX2 #%(T_46_META_WS_E_RAMPAGE)\r
	@ApiLevel=4\r
	@ScriptName=CloneKill\r
    HiderKillFake = UGC_T_38_WZY_WS_VFX3 #%(T_46_META_WS_E_CLONEKILL)\r
	@ApiLevel=4\r
	@ScriptName=HitFeedback\r
    Shooting = UGC_T_38_WZY_WS_VFX4 #%(T_46_META_WS_E_HITFEEDBACK)\r
	@ApiLevel=4\r
	@ScriptName=Clone\r
    HiderTransfiguration = UGC_T_38_WZY_WS_VFX5 #%(T_46_META_WS_E_CLONE)\r
	@ApiLevel=4\r
	@ScriptName=Disguise\r
    HiderBilocation = UGC_T_38_WZY_WS_VFX6 #%(T_46_META_WS_E_DISGUISE)\r
	@ApiLevel=4\r
	@ScriptName=Portal\r
    Entrance = UGC_T_38_WZY_WS_VFX7 #%(T_46_META_WS_E_PORTAL)\r
	@ApiLevel=4\r
	@ScriptName=FlashbangSparks\r
    Trail = UGC_T_38_WZY_WS_VFX8 #%(T_46_META_WS_E_FLASHBANGSPARKS)\r
	@ApiLevel=4\r
	@ScriptName=FireCharge\r
    Fire = UGC_T_38_WZY_WS_VFX9 #%(T_46_META_WS_E_FIRECHARGE)\r
	@ApiLevel=4\r
	@ScriptName=CyclicCombustion\r
    Digitaluniverse = UGC_T_38_WZY_WS_VFX10 #%(T_46_META_WS_E_CYCLICCOMBUSTION)\r
	@ApiLevel=4\r
	@ScriptName=PoisonGasPreDiscarded\r
    Dragon = UGC_T_38_WZY_WS_VFX11 #%(T_46_META_WS_E_POISONGASPREDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=Heart\r
    HEARTVFX = UGC_T_38_WZY_WS_VFX12 #%(T_46_META_WS_E_HEART)\r
	@ApiLevel=4\r
	@ScriptName=Soccer\r
    FOOTBALLVFX = UGC_T_38_WZY_WS_VFX13 #%(T_46_META_WS_E_SOCCER)\r
	@ApiLevel=4\r
	@ScriptName=MotionTrail\r
    TAILVFX = UGC_T_38_WZY_WS_VFX14 #%(T_46_META_WS_E_MOTIONTRAIL)\r
	@ApiLevel=4\r
	@ScriptName=Door\r
    DOORVFX = UGC_T_38_WZY_WS_VFX15 #%(T_46_META_WS_E_DOOR)\r
	@ApiLevel=4\r
	@ScriptName=FireWork\r
    FIREWORK = UGC_T_38_WZY_WS_VFX16 #%(T_46_META_WS_E_FIREWORK)\r
	@ApiLevel=4\r
	@ScriptName=Sneakers\r
    VFX_Ingame_WS_Water_RopsBuff = VFX_INGAME_WS_WATER_ROPSBUFF #%(T_46_META_WS_E_SNEAKERS)\r
	@ApiLevel=4\r
	@ScriptName=Explosion\r
    VFX_Ingame_WS_Water_Boom = VFX_INGAME_WS_WATER_BOOM #%(T_46_META_WS_E_EXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=Spawnpoint\r
    WS_FF_VFX_SpawnArea = WS_FF_VFX_SPAWNAREA #%(T_46_META_WS_E_SPAWNPOINT)\r
	@ApiLevel=4\r
	@ScriptName=Laser\r
    WS_FF_VFX_Laser = WS_FF_VFX_LASER #%(T_46_META_WS_E_LASER)\r
	@ApiLevel=4\r
	@ScriptName=ReleasingSkill\r
    VFX_Ingame_WS_Water_RechargeMax = VFX_INGAME_WS_WATER_RECHARGEMAX #%(T_46_META_WS_E_RELEASINGSKILL)\r
	@ApiLevel=4\r
	@ScriptName=Ammo\r
    VFX_Ingame_WS_Water_Bullet = VFX_INGAME_WS_WATER_BULLET #%(T_46_META_WS_E_AMMO)\r
	@ApiLevel=4\r
	@ScriptName=HitEffect\r
    VFX_Ingame_WS_Water_Hit = VFX_INGAME_WS_WATER_HIT #%(T_46_META_WS_E_HITEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=FiringEffect\r
    VFX_Ingame_WS_Water_Shot = VFX_INGAME_WS_WATER_SHOT #%(T_46_META_WS_E_FIRINGEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=SpiderWeb\r
    WS_IPBAR_SpiderWeb = WS_IPBAR_SPIDERWEB #%(T_46_META_WS_E_SPIDERWEB)\r
	@ApiLevel=4\r
	@ScriptName=Halo\r
    UGC_T_36_M_WS_VFX6_01 = UGC_T_36_M_WS_VFX6_01 #%(T_46_META_WS_E_HALO)\r
	@ApiLevel=4\r
	@ScriptName=Bubble\r
    UGC_T_36_M_WS_VFX6_02 = UGC_T_36_M_WS_VFX6_02 #%(T_46_META_WS_E_BUBBLE)\r
	@ApiLevel=4\r
	@ScriptName=Dust\r
    VFX_UGC_BOOM_01 = VFX_UGC_BOOM_01 #%(T_46_META_WS_E_DUST)\r
	@ApiLevel=4\r
	@ScriptName=StoneSplash\r
    VFX_UGC_BOOM_02 = VFX_UGC_BOOM_02 #%(T_46_META_WS_E_STONESPLASH)\r
	@ApiLevel=4\r
	@ScriptName=Line\r
    VFX_UGC_RECOVER_01 = VFX_UGC_RECOVER_01 #%(T_46_META_WS_E_LINE)\r
	@ApiLevel=4\r
	@ScriptName=Flicker\r
    VFX_UGC_RECOVER_02 = VFX_UGC_RECOVER_02 #%(T_46_META_WS_E_FLICKER)\r
	@ApiLevel=4\r
	@ScriptName=Ring\r
    VFX_UGC_TELEPORT_01 = VFX_UGC_TELEPORT_01 #%(T_46_META_WS_E_RING)\r
	@ApiLevel=4\r
	@ScriptName=RisingParticle\r
    VFX_UGC_TELEPORT_02 = VFX_UGC_TELEPORT_02 #%(T_46_META_WS_E_RISINGPARTICLE)\r
	@ApiLevel=4\r
	@ScriptName=Smoke\r
    WS_FF_VFX_Cobra_grenade_Explode_01 = WS_FF_VFX_Cobra_grenade_Explode_01 #%(T_46_META_WS_E_SMOKE)\r
	@ApiLevel=4\r
	@ScriptName=Curse\r
    WS_FF_VFX_Cobra_grenade_Explode_02 = WS_FF_VFX_Cobra_grenade_Explode_02 #%(T_46_META_WS_E_CURSE)\r
	@ApiLevel=4\r
	@ScriptName=FreezeZone\r
    WS_FF_VFX_Default_Grenade_Attri_Debuff_01 = WS_FF_VFX_Default_Grenade_Attri_Debuff_01 #%(T_46_META_WS_E_FREEZEZONE)\r
	@ApiLevel=4\r
	@ScriptName=ColdAir\r
    WS_FF_VFX_Default_Grenade_Attri_Debuff_02 = WS_FF_VFX_Default_Grenade_Attri_Debuff_02 #%(T_46_META_WS_E_COLDAIR)\r
	@ApiLevel=4\r
	@ScriptName=Snowflake\r
    WS_FF_VFX_Default_Grenade_Attri_Dot_01 = WS_FF_VFX_Default_Grenade_Attri_Dot_01 #%(T_46_META_WS_E_SNOWFLAKE)\r
	@ApiLevel=4\r
	@ScriptName=Flame\r
    WS_FF_VFX_Emote_Female_Cos_Booyahday21_Gun_01 = WS_FF_VFX_Emote_Female_Cos_Booyahday21_Gun_01 #%(T_46_META_WS_E_FLAME)\r
	@ApiLevel=4\r
	@ScriptName=LightBeam\r
    WS_FF_VFX_Emote_Female_Cos_Cup_01 = WS_FF_VFX_Emote_Female_Cos_Cup_01 #%(T_46_META_WS_E_LIGHTBEAM)\r
	@ApiLevel=4\r
	@ScriptName=SpreadofPoisonGas\r
    WS_FF_VFX_Emote_Female_Cos_Dragon_01 = WS_FF_VFX_Emote_Female_Cos_Dragon_01 #%(T_46_META_WS_E_SPREADOFPOISONGAS)\r
	@ApiLevel=4\r
	@ScriptName=PoisonGas\r
    WS_FF_VFX_Griza_Grenade_Explode_01 = WS_FF_VFX_Griza_Grenade_Explode_01 #%(T_46_META_WS_E_POISONGAS)\r
	@ApiLevel=4\r
	@ScriptName=ExplosiveBlaze\r
    WS_FF_VFX_Griza_Grenade_Explode_02 = WS_FF_VFX_Griza_Grenade_Explode_02 #%(T_46_META_WS_E_EXPLOSIVEBLAZE)\r
	@ApiLevel=4\r
	@ScriptName=LightEffect\r
    WS_FF_VFX_Griza_Grenade_Explode_03 = WS_FF_VFX_Griza_Grenade_Explode_03 #%(T_46_META_WS_E_LIGHTEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=Star\r
    WS_FF_VFX_Griza_Grenade_Explode_04 = WS_FF_VFX_Griza_Grenade_Explode_04 #%(T_46_META_WS_E_STAR)\r
	@ApiLevel=4\r
	@ScriptName=Bonfire\r
    WS_VFX_Fire = WS_VFX_FIRE #%(T_46_META_WS_E_BONFIRE)\r
	@ApiLevel=4\r
	@ScriptName=WaterRing\r
    WS_VFX_Water = WS_VFX_WATER #%(T_46_META_WS_E_WATERRING)\r
	@ApiLevel=4\r
	@ScriptName=Thunder\r
    WS_VFX_Thunder = WS_VFX_THUNDER #%(T_46_META_WS_E_THUNDER)\r
	@ApiLevel=4\r
	@ScriptName=Ink\r
    WS_VFX_Ink = WS_VFX_INK #%(T_46_META_WS_E_INK)\r
	@ApiLevel=4\r
	@ScriptName=BloodBall\r
    WS_VFX_BLOODBALL = WS_VFX_BLOODBALL #%(T_46_META_WS_E_BLOODBALL)\r
	@ApiLevel=4\r
	@ScriptName=BlackHole\r
    WS_VFX_BLACKHOLE = WS_VFX_BLACKHOLE #%(T_46_META_WS_E_BLACKHOLE)\r
	@ApiLevel=4\r
	@ScriptName=BlackHoleBoom\r
    WS_VFX_BLACKHOLE_BOOM = WS_VFX_BLACKHOLE_BOOM #%(T_46_META_WS_E_BLACKHOLEBOOM)\r
	@ApiLevel=4\r
	@ScriptName=Tracerlight\r
    WS_VFX_LIGHTING = WS_VFX_LIGHTING #%(T_47_HJ_WS_VFX_LIGHTING)\r
	@ApiLevel=4\r
	@ScriptName=Trailing\r
    WS_VFX_TRAILING = WS_VFX_TRAILING #%(T_47_HJ_WS_VFX_TRAILING)\r
	@ApiLevel=4\r
	@ScriptName=Ques\r
    WS_VFX_Question_Mark = WS_VFX_QUESTION_MARK #%(T_53_XJ_VFX_QUES)\r
	@ApiLevel=4\r
	@ScriptName=HaloEffect\r
    WS_VFX_Halo = WS_VFX_HALO #%(T_53_XJ_VFX_HALO)\r
	@ApiLevel=4\r
	@ScriptName=LaserEffect\r
    WS_VFX_Laser = WS_VFX_LASER #%(T_53_XJ_VFX_LASER)\r
	@ApiLevel=4\r
	@ScriptName=BonfireEffect\r
    WS_VFX_Bonfire = WS_VFX_BONFIRE #%(T_53_XJ_VFX_BONFIRE)\r
	@ApiLevel=4\r
	@ScriptName=Fog\r
    WS_VFX_FLOG = WS_VFX_FLOG #%(T_47_HJ_WS_VFX_FOG)\r
}\r
\r
@Accept WeaponSkinID\r
@ApiLevel=4\r
@ScriptName=WeaponSkinType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum WeaponSkinType : WeaponSkinID = 419 { #%(T_47_XXJ_WS_WEAPONSKINTYPE)\r
}\r
\r
@Accept VehicleSkinID\r
@ApiLevel=4\r
@ScriptName=VehicleSkinType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum VehicleSkinType : VehicleSkinID = 420 { #%(T_47_XXJ_WS_VEHICLESKINTYPE)\r
}\r
\r
@Accept ClothID\r
@ApiLevel=4\r
@ScriptName=ClothType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum ClothType : ClothID = 421 { #%(T_47_XXJ_WS_CLOTHTYPE)\r
}\r
\r
@Accept BagSkinID\r
@ApiLevel=4\r
@ScriptName=BagSkinType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum BagSkinType : BagSkinID = 422 { #%(T_47_XXJ_WS_BAGSKINTYPE)\r
}\r
\r
@Accept TextureID\r
@ApiLevel=4\r
@ScriptName=TextureType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum TextureType : TextureID = 160 { #%(T_46_META_WS_C_TEXTURETYPE)\r
	@ApiLevel=4\r
	@ScriptName=BrickA\r
    SceneEdit_Cube_Texture_Bricks = SceneEdit_Cube_Texture_Bricks #%(T_46_META_WS_E_BRICKA)\r
	@ApiLevel=4\r
	@ScriptName=TileA\r
    SceneEdit_Cube_frame_Texture_01 = SceneEdit_Cube_frame_Texture_01 #%(T_46_META_WS_E_TILEA)\r
	@ApiLevel=4\r
	@ScriptName=TileB\r
    SceneEdit_Cube_frame_Texture_02 = SceneEdit_Cube_frame_Texture_02 #%(T_46_META_WS_E_TILEB)\r
	@ApiLevel=4\r
	@ScriptName=TileC\r
    SceneEdit_Cube_frame_Texture_03 = SceneEdit_Cube_frame_Texture_03 #%(T_46_META_WS_E_TILEC)\r
	@ApiLevel=4\r
	@ScriptName=BambooA\r
    SceneEdit_Cube_Texture_Bamboo_01 = SceneEdit_Cube_Texture_Bamboo_01 #%(T_46_META_WS_E_BAMBOOA)\r
	@ApiLevel=4\r
	@ScriptName=CementA\r
    SceneEdit_Cube_Texture_Cement_01 = SceneEdit_Cube_Texture_Cement_01 #%(T_46_META_WS_E_CEMENTA)\r
	@ApiLevel=4\r
	@ScriptName=ContainerA\r
    SceneEdit_Cube_Texture_Container_01 = SceneEdit_Cube_Texture_Container_01 #%(T_46_META_WS_E_CONTAINERA)\r
	@ApiLevel=4\r
	@ScriptName=LawnA\r
    SceneEdit_Cube_Texture_Grassland_01 = SceneEdit_Cube_Texture_Grassland_01 #%(T_46_META_WS_E_LAWNA)\r
	@ApiLevel=4\r
	@ScriptName=IceA\r
    SceneEdit_Cube_Texture_Ice_01 = SceneEdit_Cube_Texture_Ice_01 #%(T_46_META_WS_E_ICEA)\r
	@ApiLevel=4\r
	@ScriptName=MagmaA\r
    SceneEdit_Cube_Texture_Magma_01 = SceneEdit_Cube_Texture_Magma_01 #%(T_46_META_WS_E_MAGMAA)\r
	@ApiLevel=4\r
	@ScriptName=SandA\r
    SceneEdit_Cube_Texture_Sand_01 = SceneEdit_Cube_Texture_Sand_01 #%(T_46_META_WS_E_SANDA)\r
	@ApiLevel=4\r
	@ScriptName=SnowA\r
    SceneEdit_Cube_Texture_Snow_01 = SceneEdit_Cube_Texture_Snow_01 #%(T_46_META_WS_E_SNOWA)\r
	@ApiLevel=4\r
	@ScriptName=WoodA\r
    SceneEdit_Cube_Texture_Wood_01 = SceneEdit_Cube_Texture_Wood_01 #%(T_46_META_WS_E_WOODA)\r
	@ApiLevel=4\r
	@ScriptName=StoneA\r
    SceneEdit_Cube_Texture_Stone_01 = SceneEdit_Cube_Texture_Stone_01 #%(T_46_META_WS_E_TONEA)\r
	@ApiLevel=4\r
	@ScriptName=LawnB\r
    SceneEdit_Cube_Texture_Grassland_02 = SceneEdit_Cube_Texture_Grassland_02 #%(T_46_META_WS_E_LAWNB)\r
	@ApiLevel=4\r
	@ScriptName=BrickB\r
    SceneEdit_Cube_Texture_Wall_01 = SceneEdit_Cube_Texture_Wall_01 #%(T_46_META_WS_E_BRICKB)\r
	@ApiLevel=4\r
	@ScriptName=BrickC\r
    SceneEdit_Cube_Texture_Wall_02 = SceneEdit_Cube_Texture_Wall_02 #%(T_46_META_WS_E_BRICKC)\r
	@ApiLevel=4\r
	@ScriptName=Clear\r
    SceneEdit_Cube_Clear = SceneEdit_Cube_Clear #%(T_46_META_WS_E_CLEAR)\r
}\r
\r
@Accept SpriteID\r
@ApiLevel=4\r
@ScriptName=IconType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum IconType : SpriteID = 30 { #%(T_46_META_WS_C_ICONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Square\r
    Square = T_34_M_WS_ICON_SQUARE #%(T_46_META_WS_E_SQUARE)\r
	@ApiLevel=4\r
	@ScriptName=Quadrilateral\r
    Quadrilateral = T_34_M_WS_ICON_QUADRI #%(T_46_META_WS_E_QUADRILATERAL)\r
	@ApiLevel=4\r
	@ScriptName=RightTrapezoid\r
    RightAngledTrapezoid = T_34_M_WS_ICON_RIGHTTRAPEZOID #%(T_46_META_WS_E_RIGHTTRAPEZOID)\r
	@ApiLevel=4\r
	@ScriptName=Trapezoid\r
    Trapezoid = T_34_M_WS_ICON_TRAPEZOID #%(T_46_META_WS_E_TRAPEZOID)\r
	@ApiLevel=4\r
	@ScriptName=Hexagon\r
    Hexagon = T_34_M_WS_ICON_HEXAGON #%(T_46_META_WS_E_HEXAGON)\r
	@ApiLevel=4\r
	@ScriptName=Circle\r
    Round = T_34_M_WS_ICON_CIRCULAR #%(T_46_META_WS_E_CIRCLE)\r
	@ApiLevel=4\r
	@ScriptName=Triangle\r
    Triangle = T_34_M_WS_ICON_TRIANGLE #%(T_46_META_WS_E_TRIANGLE)\r
	@ApiLevel=4\r
	@ScriptName=ExclamationMark\r
    ExclamationMark = T_34_M_WS_ICON_EXCLAMATIONMARK #%(T_46_META_WS_E_EXCLAMATIONMARK)\r
	@ApiLevel=4\r
	@ScriptName=QuestionMark\r
    QuestionMark = T_34_M_WS_ICON_QUESTIONMARK #%(T_46_META_WS_E_QUESTIONMARK)\r
	@ApiLevel=4\r
	@ScriptName=Mark\r
    Sign = T_34_M_WS_ICON_SIGN #%(T_46_META_WS_E_MARK)\r
	@ApiLevel=4\r
	@ScriptName=Arrow\r
    Arrow = T_34_M_WS_ICON_ARROW #%(T_46_META_WS_E_ARROW)\r
	@ApiLevel=4\r
	@ScriptName=Pin\r
    Callout = T_34_M_WS_ICON_TAGGING #%(T_46_META_WS_E_PIN)\r
	@ApiLevel=4\r
	@ScriptName=Stone\r
    Stone = T_34_M_WS_ICON_STONE #%(T_46_META_WS_E_STONE)\r
	@ApiLevel=4\r
	@ScriptName=Scissors\r
    Scissors = T_34_M_WS_ICON_SCISSORS #%(T_46_META_WS_E_SCISSORS)\r
	@ApiLevel=4\r
	@ScriptName=Palm\r
    Cloth = T_34_M_WS_ICON_CLOTH #%(T_46_META_WS_E_PALM)\r
	@ApiLevel=4\r
	@ScriptName=ThumbsUp\r
    Praise = T_34_M_WS_ICON_UP #%(T_46_META_WS_E_THUMBSUP)\r
	@ApiLevel=4\r
	@ScriptName=Right\r
    Yes = T_34_M_WS_ICON_YES #%(T_46_META_WS_E_RIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Wrong\r
    Wrong = T_34_M_WS_ICON_WRONG #%(T_46_META_WS_E_WRONG)\r
	@ApiLevel=4\r
	@ScriptName=Plus\r
    Plus = T_34_M_WS_ICON_PLUS #%(T_46_META_WS_E_PLUS)\r
	@ApiLevel=4\r
	@ScriptName=Lightning\r
    Lightning = T_34_M_WS_ICON_LIGHTNING #%(T_46_META_WS_E_LIGHTNING)\r
	@ApiLevel=4\r
	@ScriptName=Heart\r
    Heart = T_34_M_WS_ICON_HEART #%(T_46_META_WS_E_HEART)\r
	@ApiLevel=4\r
	@ScriptName=Star\r
    Star = T_34_M_WS_ICON_STAR #%(T_46_META_WS_E_STAR)\r
	@ApiLevel=4\r
	@ScriptName=Moon\r
    Moon = T_34_M_WS_ICON_MONTH #%(T_46_META_WS_E_MOON)\r
	@ApiLevel=4\r
	@ScriptName=Sun\r
    Sun = T_34_M_WS_ICON_DAY #%(T_46_META_WS_E_SUN)\r
	@ApiLevel=4\r
	@ScriptName=Eye\r
    Glasses = T_34_M_WS_ICON_GLASSES #%(T_46_META_WS_E_EYE)\r
	@ApiLevel=4\r
	@ScriptName=Key\r
    Key = T_34_M_WS_ICON_KEY #%(T_46_META_WS_E_KEY)\r
	@ApiLevel=4\r
	@ScriptName=Trophy\r
    Trophy = T_34_M_WS_ICON_TROPHY #%(T_46_META_WS_E_TROPHY)\r
	@ApiLevel=4\r
	@ScriptName=Flag\r
    Flag = T_34_M_WS_ICON_FLAG #%(T_46_META_WS_E_FLAG)\r
	@ApiLevel=4\r
	@ScriptName=Hourglass\r
    Hourglass = T_34_M_WS_ICON_HOURGLASS #%(T_46_META_WS_E_HOURGLASS)\r
	@ApiLevel=4\r
	@ScriptName=Folder\r
    Folder = T_34_M_WS_ICON_FOLDER #%(T_46_META_WS_E_FOLDER)\r
	@ApiLevel=4\r
	@ScriptName=OpenFolder\r
    OpenFolder = T_34_M_WS_ICON_OPENFOLDER #%(T_46_META_WS_E_OPENFOLDER)\r
	@ApiLevel=4\r
	@ScriptName=House\r
    House = T_34_M_WS_ICON_HOUSE #%(T_46_META_WS_E_HOUSE)\r
	@ApiLevel=4\r
	@ScriptName=Rest\r
    Rest = T_34_M_WS_ICON_REST #%(T_46_META_WS_E_REST)\r
	@ApiLevel=4\r
	@ScriptName=Refresh\r
    Refresh = T_34_M_WS_ICON_REFRESH #%(T_46_META_WS_E_REFRESH)\r
	@ApiLevel=4\r
	@ScriptName=Loop\r
    Loop = T_34_M_WS_ICON_LOOP #%(T_46_META_WS_E_LOOP)\r
	@ApiLevel=4\r
	@ScriptName=MagnifyingGlass\r
    Magnifier = T_34_M_WS_ICON_MAGNIFIER #%(T_46_META_WS_E_MAGNIFYINGGLASS)\r
	@ApiLevel=4\r
	@ScriptName=TrashCan\r
    TrashCan = T_34_M_WS_ICON_TRASHCAN #%(T_46_META_WS_E_TRASHCAN)\r
	@ApiLevel=4\r
	@ScriptName=Back\r
    Return = T_34_M_WS_ICON_RETURN #%(T_46_META_WS_E_BACK)\r
	@ApiLevel=4\r
	@ScriptName=Diamond\r
    Diamonds = T_34_M_WS_ICON_DIAMONDS #%(T_46_META_WS_E_DIAMOND)\r
	@ApiLevel=4\r
	@ScriptName=SwimRing\r
    SwimmingCircle = T_34_M_WS_ICON_SWIMMINGCIRCLE #%(T_46_META_WS_E_SWIMRING)\r
	@ApiLevel=4\r
	@ScriptName=Money\r
    Money = T_34_M_WS_ICON_MONEY #%(T_46_META_WS_E_MONEY)\r
	@ApiLevel=4\r
	@ScriptName=Lock\r
    Lock = T_34_M_WS_ICON_LOCK #%(T_46_META_WS_E_LOCK)\r
	@ApiLevel=4\r
	@ScriptName=Setting\r
    SetUp = T_34_M_WS_ICON_SETUP #%(T_46_META_WS_E_SETTING)\r
	@ApiLevel=4\r
	@ScriptName=SignOut\r
    SignOut = T_34_M_WS_ICON_SIGNOUT #%(T_46_META_WS_E_SIGNOUT)\r
	@ApiLevel=4\r
	@ScriptName=Dialogue\r
    Dialogue = T_34_M_WS_ICON_DIALOGUE #%(T_46_META_WS_E_DIALOGUE)\r
	@ApiLevel=4\r
	@ScriptName=Crosshair\r
    FrontSight = T_34_M_WS_ICON_COLLIMATION #%(T_46_META_WS_E_CROSSHAIR)\r
	@ApiLevel=4\r
	@ScriptName=Gun\r
    Gun = T_34_M_WS_ICON_GUN #%(T_46_META_WS_E_GUN)\r
	@ApiLevel=4\r
	@ScriptName=Sword\r
    Sword = T_34_M_WS_ICON_THESWORD #%(T_46_META_WS_E_SWORD)\r
	@ApiLevel=4\r
	@ScriptName=Blast\r
    Blast = T_34_M_WS_ICON_BLAST #%(T_46_META_WS_E_BLAST)\r
	@ApiLevel=4\r
	@ScriptName=Aim\r
    Aim = T_34_M_WS_ICON_AIM #%(T_46_META_WS_E_AIM)\r
	@ApiLevel=4\r
	@ScriptName=Cross\r
    Cross = T_34_M_WS_ICON_CROSS #%(T_46_META_WS_E_CROSS)\r
	@ApiLevel=4\r
	@ScriptName=Shield\r
    Defense = T_34_M_WS_ICON_DEFENSE #%(T_46_META_WS_E_SHIELD)\r
	@ApiLevel=4\r
	@ScriptName=Monster\r
    Corpse = T_34_M_WS_ICON_CORPSE #%(T_46_META_WS_E_ZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=Recycle\r
    Recycling = T_34_M_WS_ICON_RECYCLING #%(T_46_META_WS_E_RECYCLE)\r
	@ApiLevel=4\r
	@ScriptName=Gift\r
    Gift = FF_WS_7Days #%(T_46_META_WS_E_GIFT)\r
	@ApiLevel=4\r
	@ScriptName=Clothes\r
    Clothes = FF_WS_Clothes #%(T_46_META_WS_E_CLOTHES)\r
	@ApiLevel=4\r
	@ScriptName=Game\r
    Game = FF_WS_Debug_01 #%(T_46_META_WS_E_GAME)\r
	@ApiLevel=4\r
	@ScriptName=Player\r
    Guest = FF_WS_guest #%(T_46_META_WS_E_PLAYER)\r
	@ApiLevel=4\r
	@ScriptName=Store\r
    Minshop = FF_WS_MinShop #%(T_46_META_WS_E_STORE)\r
	@ApiLevel=4\r
	@ScriptName=Exit\r
    Quit = FF_WS_Quit #%(T_46_META_WS_E_EXIT)\r
	@ApiLevel=4\r
	@ScriptName=Warning\r
    Warnning = FF_WS_Report_Room_icon #%(T_46_META_WS_E_WARNING)\r
	@ApiLevel=4\r
	@ScriptName=Text\r
    Text = FF_WS_Reservation #%(T_46_META_WS_E_TEXT)\r
	@ApiLevel=4\r
	@ScriptName=CountDown\r
    Clock = FF_WS_timelimite #%(T_46_META_WS_E_COUNTDOWN)\r
	@ApiLevel=4\r
	@ScriptName=Bell\r
    Pet = FF_icon_Pet #%(T_46_META_WS_E_BELL)\r
	@ApiLevel=4\r
	@ScriptName=PetTabBG\r
    PetTabBG = T_12_O_PET_TITLE #%(T_46_META_WS_E_PETTABBG)\r
	@ApiLevel=4\r
	@ScriptName=Boom\r
    BOMBBD = FF_UI_Bomb_BD #%(T_46_META_WS_E_BOOM)\r
	@ApiLevel=4\r
	@ScriptName=Repair\r
    Debug = FF_UI_Common_Debug #%(T_46_META_WS_E_REPAIR)\r
	@ApiLevel=4\r
	@ScriptName=Smiley\r
    Emoji = Icon_Chat_Emoji #%(T_46_META_WS_E_SMILEY)\r
	@ApiLevel=4\r
	@ScriptName=LoudSpeaker\r
    Speaker = Icon_Chat_Speaker #%(T_46_META_WS_E_LOUDSPEAKER)\r
	@ApiLevel=4\r
	@ScriptName=CircleBack\r
    Unlimited = Icon_PlayCard_unlimited #%(T_46_META_WS_E_CIRCLEBACK)\r
	@ApiLevel=4\r
	@ScriptName=Crown\r
    CROWN = UI_Customize_official_icon #%(T_46_META_WS_E_CROWN)\r
	@ApiLevel=4\r
	@ScriptName=Duel\r
    BATTLE = UI_Icon_battle #%(T_46_META_WS_E_DUEL)\r
	@ApiLevel=4\r
	@ScriptName=Guild\r
    Guild = UI_icon_Guild #%(T_46_META_WS_E_GUILD)\r
	@ApiLevel=4\r
	@ScriptName=HeartBeat\r
    HeartbHud = UI_icon_HP #%(T_46_META_WS_E_HEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=Music\r
    Music = UI_Icon_Music #%(T_46_META_WS_E_MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=Vehicle\r
    Vehicle = UI_Icon_Vehicle #%(T_46_META_WS_E_VEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=MeleeWeapons\r
    MELEEWEAPONS = Icon_HUD_Changuo #%(T_46_META_WS_E_MELEEWEAPONS)\r
	@ApiLevel=4\r
	@ScriptName=Pistol\r
    PISTOL = Icon_HUD_DE #%(T_46_META_WS_E_PISTOL)\r
	@ApiLevel=4\r
	@ScriptName=Rifle\r
    RIFLE = Icon_HUD_M4A1 #%(T_46_META_WS_E_RIFLE)\r
	@ApiLevel=4\r
	@ScriptName=Sniper\r
    SNIPER = Icon_HUD_M24 #%(T_46_META_WS_E_SNIPER)\r
	@ApiLevel=4\r
	@ScriptName=Shotgun\r
    SHOTGUN = Icon_HUD_M1887 #%(T_46_META_WS_E_SHOTGUN)\r
	@ApiLevel=4\r
	@ScriptName=MachineGun\r
    SUBMACHINE = Icon_HUD_MP5 #%(T_46_META_WS_E_MACHINEGUN)\r
	@ApiLevel=4\r
	@ScriptName=HealPistol\r
    TREATMENTGUN = Icon_HUD_TREATMENTGUN #%(T_46_META_WS_E_HEALPISTOL)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPiercing\r
    KillA = FF_UI_FirstBlood_icon_kill01 #%(T_46_META_WS_E_ARMORPIERCING)\r
	@ApiLevel=4\r
	@ScriptName=Headshoot\r
    HEADSHOOT = FF_UI_FirstBlood_icon_kill02 #%(T_46_META_WS_E_HEADSHOOT)\r
	@ApiLevel=4\r
	@ScriptName=ArmorSpecialist\r
    Awakening = ui_icon_skill_Andrew_Awakening #%(T_46_META_WS_E_ARMORSPECIALIST)\r
	@ApiLevel=4\r
	@ScriptName=WallBrawl\r
    Crazygirl = ui_icon_skill_Crazygirl #%(T_46_META_WS_E_WALLBRAWL)\r
	@ApiLevel=4\r
	@ScriptName=TracingSteps\r
    Detective = ui_icon_skill_Detective #%(T_46_META_WS_E_TRACINGSTEPS)\r
	@ApiLevel=4\r
	@ScriptName=DropBeat\r
    Djmale = ui_icon_skill_Djmale #%(T_46_META_WS_E_DROPBEAT)\r
	@ApiLevel=4\r
	@ScriptName=ThrillBattle\r
    MadeManA = ui_icon_skill_MadeManA #%(T_46_META_WS_E_THRILLBATTLE)\r
	@ApiLevel=4\r
	@ScriptName=Camouflage\r
    Monkeygod = ui_icon_skill_monkeygod #%(T_46_META_WS_E_CAMOUFLAGE)\r
	@ApiLevel=4\r
	@ScriptName=NuttyMovement\r
    Singersb = ui_icon_skill_Singersb_link #%(T_46_META_WS_E_NUTTYMOVEMENT)\r
	@ApiLevel=4\r
	@ScriptName=HatTrick\r
    SoccerStar = ui_icon_skill_SoccerStar #%(T_46_META_WS_E_HATTRICK)\r
	@ApiLevel=4\r
	@ScriptName=RiptideRhythm\r
    Superstar = ui_icon_skill_Superstar #%(T_46_META_WS_E_RIPTIDERHYTHM)\r
	@ApiLevel=4\r
	@ScriptName=SensesShockwave\r
    TRACKER = ui_icon_skill_ #%(T_46_META_WS_E_SENSESSHOCKWAVE)\r
}\r
\r
@Accept AudioID\r
@ApiLevel=4\r
@ScriptName=SoundEffectType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum AudioType : AudioID = 31 { #%(T_46_META_WS_C_SOUNDEFFECTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Explosion\r
    SoundGrenadeExplosion = SOUND_UAV_EXPLODE #%(T_46_META_WS_E_EXPLOSION)\r
	@ApiLevel=4\r
	@ScriptName=Gunfire\r
    SoundGun = SOUND_MP5_FIRE #%(T_46_META_WS_E_GUNFIRE)\r
	@ApiLevel=4\r
	@ScriptName=CountDownDiDi\r
    SoundCountDownDD = SOUND_INGAME_WAITINGCOUNTDOWN #%(T_46_META_WS_E_COUNTDOWNDIDI)\r
	@ApiLevel=4\r
	@ScriptName=UITap\r
    SoundClick = SOUND_UI_CLICK_COMMON_DEFAULT #%(T_46_META_WS_E_UITAP)\r
	@ApiLevel=4\r
	@ScriptName=InjuredFemale\r
    SOUNDFEMALEA = SOUND_FEMALE_INJURED_SERIOUS01 #%(T_46_META_WS_E_INJUREDFEMALE)\r
	@ApiLevel=4\r
	@ScriptName=InjuredMale\r
    SOUNDMALEA = SOUND_MALE_INJURED_SERIOUS01 #%(T_46_META_WS_E_INJUREDMALE)\r
	@ApiLevel=3\r
	@ScriptName=CoinGenerator\r
    SOUNDTOKENPICKUP = SOUND_UI_TOKENPICKUP #%(T_36_JH_WS_CREATEGOLD)\r
	@ApiLevel=4\r
	@ScriptName=FinishingPoint\r
    SOUNDUIENDPOINT = SOUND_SFX_Rushingpets_UI_Checkpoint #%(T_46_META_WS_E_FINISHINGPOINT)\r
	@ApiLevel=4\r
	@ScriptName=Triggers\r
    SOUNDTRIGGER = SOUND_TELEPORTDOOR_STARTUSE #%(T_46_META_WS_E_TRIGGERS)\r
	@ApiLevel=4\r
	@ScriptName=RankDown\r
    RANKDOWN = SOUND_PUMPKINSNATCH_RANKDOWN #%(T_46_META_WS_E_RANKDOWN)\r
	@ApiLevel=4\r
	@ScriptName=SuccessfulHit\r
    LIGHTATTACK = SFX_REAPER_LIGHTATTACK #%(T_46_META_WS_E_SUCCESSFULHIT)\r
	@ApiLevel=4\r
	@ScriptName=LevelUpDiscarded\r
    RANKUP = SOUND_PUMPKINSNATCH_RANKUP #%(T_46_META_WS_E_LEVELUPDISCARDED)\r
	@ApiLevel=4\r
	@ScriptName=GentleTap\r
    PRESS = SOUND_USE_MESSAGEBOX #%(T_46_META_WS_E_GENTLETAP)\r
	@ApiLevel=4\r
	@ScriptName=StepTrigger\r
    BOXOPEN = SOUND_VEHICLE_AIRSHIP_BOX_OPEN #%(T_46_META_WS_E_STEPTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=RepairEquip\r
    ARMORTOOL = SOUND_USE_ARMORTOOL #%(T_46_META_WS_E_REPAIREQUIP)\r
	@ApiLevel=4\r
	@ScriptName=HeartBeat\r
    HEARTBEAT = SOUND_PACEMAKER_HEARTBEAT #%(T_46_META_WS_E_HEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=Mistake\r
    DROP = SOUND_SFX_Rushingpets_Pets_Drop #%(T_46_META_WS_E_MISTAKE)\r
	@ApiLevel=4\r
	@ScriptName=Reminder\r
    MESSAGEBOX = SOUND_SHRINK_MESSAGEBOX #%(T_46_META_WS_E_REMINDER)\r
	@ApiLevel=4\r
	@ScriptName=Football\r
    FOOTBALL = SOUND_FOOTBALL_BOUNCE #%(T_46_META_WS_E_FOOTBALL)\r
	@ApiLevel=4\r
	@ScriptName=Cheer\r
    CHEER = SFX_TORTOISE_CHEER #%(T_46_META_WS_E_CHEER)\r
	@ApiLevel=4\r
	@ScriptName=BombIndication\r
    BOMBSTART = SOUND_BOMB_TIME_start #%(T_46_META_WS_E_BOMBINDICATION)\r
	@ApiLevel=4\r
	@ScriptName=PriorExplosion\r
    BOMBEND = SOUND_BOMB_TIME_END #%(T_46_META_WS_E_PRIOREXPLOSION)\r
	@ApiLevel=3\r
	@ScriptName=CharacterAppears\r
    HUNTERSHOW = SOUND_INFECTION_HUNTERROAR #%(T_37_WZY_WS_BOMBEND)\r
	@ApiLevel=3\r
	@ScriptName=EndBGM\r
    FINALBGM = SOUND_BGM_MODE_INFECTION_FINALPHASE #%(T_37_WZY_WS_BOMBEND)\r
	@ApiLevel=3\r
	@ScriptName=SupplyBox\r
    BOMREFRESH = SOUND_AIR_DROP_PLANE_NORMAL  #%(T_37_WZY_WS_BOMBEND)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
    EVENTSTART = SOUND_TELEPORTDOOR_EVENTSTART #%(T_46_META_WS_E_ACCELERATION)\r
	@ApiLevel=4\r
	@ScriptName=DisappearNotification\r
    DISABLE = SOUND_TELEPORTDOOR_DISABLE #%(T_46_META_WS_E_DISAPPEARNOTIFICATION)\r
	@ApiLevel=4\r
	@ScriptName=VisualEffects\r
    LOOP = SOUND_TELEPORTDOOR_LOOP #%(T_46_META_WS_E_VISUALEFFECTS)\r
	@ApiLevel=4\r
	@ScriptName=InsectChirping\r
    INSECTCRY = SOUND_AMBIENCE_INSECTCRY #%(T_46_META_WS_E_INSECTCHIRPING)\r
	@ApiLevel=4\r
	@ScriptName=HitBlunt\r
    HIT = SOUND_ICEWALL_HIT #%(T_46_META_WS_E_HITBLUNT)\r
	@ApiLevel=4\r
	@ScriptName=Reaction\r
    TACTICS = SOUND_ING_CHAT_TACTICS #%(T_46_META_WS_E_REACTION)\r
	@ApiLevel=4\r
	@ScriptName=SurpriseFind\r
    Butterfly = SOUND_GUNSHOW_AWM_Butterfly #%(T_46_META_WS_E_SURPRISEFIND)\r
	@ApiLevel=4\r
	@ScriptName=Apparition\r
    MAXLEVEL = SOUND_HYPE_MAX_LEVEL #%(T_46_META_WS_E_APPARITION)\r
	@ApiLevel=4\r
	@ScriptName=PhaseStart\r
    SHOOTINGGAMEEND = SOUND_UI_SHOOTINGGAME_END #%(T_46_META_WS_E_PHASESTART)\r
	@ApiLevel=4\r
	@ScriptName=Monsters\r
    ZOMBIE = SOUND_ZOMBIE_FURY #%(T_46_META_WS_E_ZOMBIES)\r
	@ApiLevel=4\r
	@ScriptName=Horror\r
    GHOST = SOUND_EMOTE_GHOST_MOVE #%(T_46_META_WS_E_HORROR)\r
	@ApiLevel=4\r
	@ScriptName=Transformation\r
    MORPH = SOUND_UI_NOTICE_PEEKABOO_TRANSFORM #%(T_46_META_WS_E_TRANSFORMATION)\r
	@ApiLevel=4\r
	@ScriptName=PoundingHeart\r
    HEARTBEAT_FAST = SOUND_UI_NOTICE_PEEKABOO_HEARTBEAT_FAST #%(T_46_META_WS_E_POUNDINGHEART)\r
	@ApiLevel=4\r
	@ScriptName=MediumHeartbeat\r
    HEARTBEAT_MEDIUM = SOUND_UI_NOTICE_PEEKABOO_HEARTBEAT_MEDIUM #%(T_46_META_WS_E_MEDIUMHEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=SlowHeartbeat\r
    HEARTBEAT_SLOW = SOUND_UI_NOTICE_PEEKABOO_HEARTBEAT_SLOW #%(T_46_META_WS_E_SLOWHEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=RushTime\r
    FEVERTIME = SOUND_UI_NOTICE_PEEKABOO_FEVERTIME #%(T_46_META_WS_E_RUSHTIME)\r
	@ApiLevel=4\r
	@ScriptName=Tap\r
    CLICK = SOUND_UI_CLICK_COMMON_TINY #%(T_46_META_WS_E_TAP)\r
	@ApiLevel=4\r
	@ScriptName=SkillRecover\r
    ACTIVESKILLREADY = SOUND_ACTIVESKILLREADY #%(T_46_META_WS_E_SKILLRECOVER)\r
	@ApiLevel=4\r
	@ScriptName=JoinGame\r
    PVE_JOIN = SOUND_PVE_JOIN #%(T_46_META_WS_E_JOINGAME)\r
	@ApiLevel=4\r
	@ScriptName=MechanicalDeviceEcho\r
    SFX_Generator_Loop = SOUND_UI_Generator #%(T_46_META_WS_E_MECHANICALDEVICEECHO)\r
	@ApiLevel=4\r
	@ScriptName=Mosquito\r
    SFX_Mosquito_GhillieSuit = SOUND_BUSH_CAMOUFLAGE_MOSQUITO #%(T_46_META_WS_E_MOSQUITO)\r
	@ApiLevel=4\r
	@ScriptName=SharpMechanical\r
    SFX_MovieOpening_Type = SOUND_GAMEOPENING_TYPEWRITER #%(T_46_META_WS_E_SHARPMECHANICAL)\r
	@ApiLevel=4\r
	@ScriptName=Mechanical\r
    SFX_UI_Motion_Common_ProgressLong = SOUND_UI_MOTION_COMMON_PROGRESSLONG #%(T_46_META_WS_E_MECHANICAL)\r
	@ApiLevel=4\r
	@ScriptName=GearSwitchedOn\r
    Weapon_OnGround_Cannon_Turn_a = SOUND_CANNON_TURN #%(T_46_META_WS_E_GEARSWITCHEDON)\r
	@ApiLevel=4\r
	@ScriptName=Charge\r
    SFX_Charge_EjectCannon1 = SOUND_CATAPULT_CHARGE #%(T_46_META_WS_E_CHARGE)\r
	@ApiLevel=4\r
	@ScriptName=Step\r
    SFX_TankZombie_Walk01 = SOUND_ZombieTank_Walk01 #%(T_46_META_WS_E_STEP)\r
	@ApiLevel=4\r
	@ScriptName=MissionComplete\r
    SFX_UI_Bomb_Success = SOUND_BOMB_SUCCESS #%(T_46_META_WS_E_MISSIONCOMPLETE)\r
	@ApiLevel=4\r
	@ScriptName=DangerVibrating\r
    SFX_UI_EnterFail = SOUND_SFX_UI_EnterFail #%(T_46_META_WS_E_DANGERVIBRATING)\r
	@ApiLevel=4\r
	@ScriptName=DangerAlarm\r
    SFX_AMB_Alarm_Shrink = SOUND_ALARM_SHRINK_NORMAL #%(T_46_META_WS_E_DANGERALARM)\r
	@ApiLevel=4\r
	@ScriptName=CountdownWithinGame\r
    SFX_Ingame_WaitingCountDown = SOUND_UI_WAITING_COUNT_DOWN #%(T_46_META_WS_E_COUNTDOWNWITHINGAME)\r
	@ApiLevel=4\r
	@ScriptName=TipsSound\r
    SFX_Tips_Announce = SOUND_TIPS_ANNOUNCE #%(T_46_META_WS_E_TIPSSOUND)\r
	@ApiLevel=4\r
	@ScriptName=CrowCaw\r
    Ambient_Bird = SOUND_AMBIENCE_BIRD #%(T_46_META_WS_E_CROWCAW)\r
	@ApiLevel=4\r
	@ScriptName=TeleportWrong\r
    SFX_Item_Beaconing_Disapper = SOUND_ITEM_BEACONING_DISAPPER #%(T_46_META_WS_E_TELEPORTWRONG)\r
	@ApiLevel=4\r
	@ScriptName=TeleportCorrect\r
    SFX_M60_FoxMiko = SOUND_PREVIEW_M60_FOXMIKO #%(T_46_META_WS_E_TELEPORTCORRECT)\r
	@ApiLevel=4\r
	@ScriptName=Teleport\r
    SFX_Fist_Meteorite_Whoosh = SOUND_FIST_METEORITE_WHOOSH #%(T_46_META_WS_E_TELEPORT)\r
	@ApiLevel=4\r
	@ScriptName=ElectricShock\r
    SFX_Fist_Rampage4_Whoosh = SOUND_FIST_RAMPAGE4_WHOOSH #%(T_46_META_WS_E_ELECTRICSHOCK)\r
	@ApiLevel=4\r
	@ScriptName=FallingStar\r
    FallingStar = SOUND_METEOR #%(T_46_META_WS_E_FALLINGSTAR)\r
	@ApiLevel=4\r
	@ScriptName=ElectronicBGM\r
    SFX_Pet_BGM = SOUND_BGM_PET #%(T_46_META_WS_E_ELECTRONICBGM)\r
	@ApiLevel=4\r
	@ScriptName=CasualGameBGM\r
    GAMEOVER = SOUND_GAMEOVER #%(T_46_META_WS_E_CASUALGAMEBGM)\r
	@ApiLevel=4\r
	@ScriptName=OpeningBox\r
    MysteryBox_Open = SOUND_MYSTERY_BOX_PURCHASE #%(T_46_META_WS_E_OPENINGBOX)\r
	@ApiLevel=4\r
	@ScriptName=LevelUp\r
    SFX_FourSymbols_General_Levelup = SOUND_UI_FS_LEVELUP_DEFAULT #%(T_46_META_WS_E_LEVELUP)\r
	@ApiLevel=4\r
	@ScriptName=LevelMaxed\r
    SFX_FourSymbols_General_Levelfull = SOUND_UI_FS_LEVELUP_FULL #%(T_46_META_WS_E_LEVELMAXED)\r
	@ApiLevel=4\r
	@ScriptName=TappingButton\r
    SFX_PetStar_Skill_ButtonUI_01 = SOUND_PETSTAR_SKILL_BUTTONUI_01 #%(T_46_META_WS_E_TAPPINGBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=CountdownDengDeng\r
    SFX_Rushingpets_UI_Countdown = SOUND_SFX_Rushingpets_UI_Countdown #%(T_46_META_WS_E_COUNTDOWNDENGDENG)\r
	@ApiLevel=4\r
	@ScriptName=Whistle\r
    SFX_Rushingpets_UI_Defeat = SOUND_SFX_Rushingpets_UI_Defeat #%(T_46_META_WS_E_WHISTLE)\r
	@ApiLevel=4\r
	@ScriptName=UIFinish\r
    SFX_Rushingpets_UI_Finish = SOUND_SFX_Rushingpets_UI_Finish #%(T_46_META_WS_E_UIFINISH)\r
	@ApiLevel=4\r
	@ScriptName=Forward\r
    SFX_Rushingpets_UI_Go = SOUND_SFX_Rushingpets_UI_Go #%(T_46_META_WS_E_FORWARD)\r
	@ApiLevel=4\r
	@ScriptName=Booyah\r
    SFX_Rushingpets_UI_Victory = SOUND_SFX_Rushingpets_UI_Victory #%(T_46_META_WS_E_BOOYAH)\r
	@ApiLevel=4\r
	@ScriptName=Checkpoint\r
    SFX_Training_Racer_Checkpoint = SOUND_TRAINING_RACER_CHECKPOINT #%(T_46_META_WS_E_CHECKPOINT)\r
	@ApiLevel=4\r
	@ScriptName=CountdownMechanical\r
    SFX_UI_Training_CountDown0 = SOUND_UI_TRAINING_COUNTDOWN #%(T_46_META_WS_E_COUNTDOWNMECHANICAL)\r
	@ApiLevel=4\r
	@ScriptName=GameStart\r
    SFX_UI_Training_GameStart = SOUND_UI_SHOOTINGGAME_START #%(T_46_META_WS_E_GAMESTART)\r
	@ApiLevel=4\r
	@ScriptName=ObtainedManyCoins\r
    SFX_UI_Coin_Get_Large = SOUND_UI_NOTICE_COMMON_COINS_ADD_03 #%(T_46_META_WS_E_OBTAINEDMANYCOINS)\r
	@ApiLevel=4\r
	@ScriptName=ObtainedCoins\r
    SFX_UI_Coin_Get_Mid = SOUND_UI_NOTICE_COMMON_COINS_ADD_02 #%(T_46_META_WS_E_OBTAINEDCOINS)\r
	@ApiLevel=4\r
	@ScriptName=ObtainedSomeCoins\r
    SFX_UI_Coin_Get_Small = SOUND_UI_NOTICE_COMMON_COINS_ADD_01 #%(T_46_META_WS_E_OBTAINEDSOMECOINS)\r
	@ApiLevel=4\r
	@ScriptName=JoinedGameDull\r
    SFX_GuildWar_Join = SOUND_SFX_GUILDWAR_JOIN #%(T_46_META_WS_E_JOINEDGAMEDULL)\r
	@ApiLevel=4\r
	@ScriptName=OpeningGuildSupply\r
    SFX_UI_Guildwelfare_redpocket = SOUND_SFX_UI_GUILDWELFARE_REDPOCKET #%(T_46_META_WS_E_OPENINGGUILDSUPPLY)\r
	@ApiLevel=4\r
	@ScriptName=Horn\r
    SFX_UI_Horn = SOUND_UI_HORN #%(T_46_META_WS_E_HORN)\r
	@ApiLevel=4\r
	@ScriptName=EliminatedBoss\r
    SFX_UI_KillLeader = SOUND_UI_KILLLEADER #%(T_46_META_WS_E_ELIMINATEDBOSS)\r
	@ApiLevel=4\r
	@ScriptName=OpeningWarChest\r
    SFX_Warehouse_Save = SOUND_UI_Warehouse_SAVE #%(T_46_META_WS_E_OPENINGWARCHEST)\r
	@ApiLevel=4\r
	@ScriptName=SpecialFiringSound\r
    SFX_Weapon_WS_Fire = SOUND_WEAPON_WS_FIRE #%(T_46_META_WS_E_SPECIALFIRINGSOUND)\r
	@ApiLevel=4\r
	@ScriptName=BulletHitting\r
    SFX_Weapon_WS_Hit = SOUND_WEAPON_WS_HIT #%(T_46_META_WS_E_BULLETHITTING)\r
	@ApiLevel=4\r
	@ScriptName=Movement\r
    SFX_WS_Footstep = SOUND_WS_FOOTSTEP #%(T_46_META_WS_E_MOVEMENT)\r
	@ApiLevel=4\r
	@ScriptName=TappingDisabledButton\r
    SFX_UI_Skill_Unavailable = SOUND_UI_SKILL_UNAVAILABLE #%(T_46_META_WS_E_TAPPINGDISABLEDBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=SkillChargingComplete\r
    SFX_UI_Skill_Available = SOUND_ACTIVESKILLREADY #%(T_46_META_WS_E_SKILLCHARGINGCOMPLETE)\r
	@ApiLevel=4\r
	@ScriptName=LaserSkill\r
    SFX_WS_Skill_Meteorite = SOUND_WS_SKILL_METEORITE #%(T_46_META_WS_E_LASERSKILL)\r
	@ApiLevel=4\r
	@ScriptName=GetItem\r
    SFX_WS_Item_Get = SOUND_WS_ITEM_GET #%(T_46_META_WS_E_GETITEM)\r
	@ApiLevel=4\r
	@ScriptName=Countdown\r
    SFX_WS_CountDown = SOUND_WS_COUNTDOWN #%(T_46_META_WS_E_COUNTDOWN)\r
	@ApiLevel=4\r
	@ScriptName=GameOver\r
    SFX_WS_ResultBanner = SOUND_WS_RESULTBANNER #%(T_46_META_WS_E_GAMEOVER)\r
	@ApiLevel=4\r
	@ScriptName=EliminationNotification\r
    SFX_WS_Kill = SOUND_WS_KILL #%(T_46_META_WS_E_ELIMINATIONNOTIFICATION)\r
	@ApiLevel=4\r
	@ScriptName=Boom\r
    SFX_WS_Kill_Enemy = SOUND_WS_KILL_ENEMY #%(T_46_META_WS_E_BOOM)\r
	@ApiLevel=4\r
	@ScriptName=ExplosivePaintSkill\r
    SFX_WS_Skill_Bomb = SOUND_WS_SKILL_BOMB #%(T_46_META_WS_E_EXPLOSIVEPAINTSKILL)\r
	@ApiLevel=4\r
	@ScriptName=PaintShieldSkill\r
    SFX_WS_Skill_BloodPool = SOUND_WS_SKILL_BLOODPOOL #%(T_46_META_WS_E_PAINTSHIELDSKILL)\r
	@ApiLevel=4\r
	@ScriptName=TUNG\r
    SFX_WS_SOUND_TUNG_VOICE_ITEM_01_EN = SOUND_TUNG_VOICE_ITEM_01_EN #%(T_49_YU_QCITEM_ALL_11)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SortType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum SortType : Int = 33 { #%(T_46_META_WS_C_SORTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=AscIgnoreZero\r
    AscIgnoreZero = 0 #%(T_46_META_WS_E_ASCIGNOREZERO)\r
	@ApiLevel=4\r
	@ScriptName=Desc\r
    Desc = 1 #%(T_46_META_WS_E_DESC)\r
	@ApiLevel=4\r
	@ScriptName=Asc\r
    Asc = 2 #%(T_46_META_WS_E_ASC)\r
}\r
\r
@Accept ItemID\r
@ApiLevel=4\r
@ScriptName=ItemIDType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum ItemGoodsIDType : ItemID = 34 { #%(T_46_META_WS_C_ITEMIDTYPE)\r
	@ApiLevel=4\r
	@ScriptName=DefaultFist\r
    DefaultFIST = 1 #%(T_46_META_WS_E_DEFAULTFIST)\r
	@ApiLevel=4\r
	@ScriptName=Kar98K\r
    KAR98K = 21 #%(T_46_META_WS_E_KAR98K)\r
	@ApiLevel=4\r
	@ScriptName=CrossBow\r
    CROSSBOW = 22 #%(T_46_META_WS_E_CROSSBOW)\r
	@ApiLevel=4\r
	@ScriptName=FootballShield\r
    FootballShield = 6402 #%(T_46_META_WS_E_FOOTBALLSHIELD)\r
	@ApiLevel=4\r
	@ScriptName=FootballIce\r
    FootballIce = 6403 #%(T_46_META_WS_E_FOOTBALLICE)\r
	@ApiLevel=4\r
	@ScriptName=Bizon\r
    Bizon = 150 #%(T_46_META_WS_E_BIZON)\r
	@ApiLevel=4\r
	@ScriptName=VSK94\r
    VSK94 = 197 #%(T_46_META_WS_E_VSK94)\r
	@ApiLevel=4\r
	@ScriptName=M4A1\r
    M4A1 = 2 #%(T_46_META_WS_E_M4A1)\r
	@ApiLevel=4\r
	@ScriptName=USP\r
    USP = 3 #%(T_46_META_WS_E_USP)\r
	@ApiLevel=4\r
	@ScriptName=AWM\r
    AWM = 4 #%(T_46_META_WS_E_AWM)\r
	@ApiLevel=4\r
	@ScriptName=AWM2\r
    AWM2 = 172 #%(T_46_META_WS_E_AWM2)\r
	@ApiLevel=4\r
	@ScriptName=M1014\r
    M1014 = 5 #%(T_46_META_WS_E_M1014)\r
	@ApiLevel=4\r
	@ScriptName=M10142\r
    M10142 = 163 #%(T_46_META_WS_E_M10142)\r
	@ApiLevel=4\r
	@ScriptName=FGL24\r
    FGL24 = 196 #%(T_46_META_WS_E_FGL24)\r
	@ApiLevel=4\r
	@ScriptName=AK\r
    AK = 6 #%(T_46_META_WS_E_AK)\r
	@ApiLevel=4\r
	@ScriptName=AK2\r
    AK2 = 154 #%(T_46_META_WS_E_AK2)\r
	@ApiLevel=4\r
	@ScriptName=UMP\r
    UMP = 7 #%(T_46_META_WS_E_UMP)\r
	@ApiLevel=4\r
	@ScriptName=UMP2\r
    UMP2 = 169 #%(T_46_META_WS_E_UMP2)\r
	@ApiLevel=4\r
	@ScriptName=MP5\r
    MP5 = 8 #%(T_46_META_WS_E_MP5)\r
	@ApiLevel=4\r
	@ScriptName=EAGLE\r
    EAGLE = 9 #%(T_46_META_WS_E_EAGLE)\r
	@ApiLevel=4\r
	@ScriptName=G18\r
    G18 = 10 #%(T_46_META_WS_E_G18)\r
	@ApiLevel=4\r
	@ScriptName=M14\r
    M14 = 11 #%(T_46_META_WS_E_M14)\r
	@ApiLevel=4\r
	@ScriptName=SCAR\r
    SCAR = 12 #%(T_46_META_WS_E_SCAR)\r
	@ApiLevel=4\r
	@ScriptName=SCAR2\r
    SCAR2 = 156 #%(T_46_META_WS_E_SCAR2)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_SCAR_I\r
    GOLD_SCAR_I = 178 #%(T_46_META_WS_E_GOLD_SCAR_I)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_SCAR_II\r
    GOLD_SCAR_II = 179 #%(T_46_META_WS_E_GOLD_SCAR_II)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_SCAR_III\r
    GOLD_SCAR_III = 180 #%(T_46_META_WS_E_GOLD_SCAR_III)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_M1014_I\r
    GOLD_M1014_I = 184 #%(T_46_META_WS_E_GOLD_M1014_I)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_M1014_II\r
    GOLD_M1014_II = 185 #%(T_46_META_WS_E_GOLD_M1014_II)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_M1014_III\r
    GOLD_M1014_III = 186 #%(T_46_META_WS_E_GOLD_M1014_III)\r
	@ApiLevel=4\r
	@ScriptName=HeatGun\r
    HEATGUN = 39 #%(T_46_META_WS_E_HEATGUN)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_HEATGUN_I\r
    GOLD_HEATGUN_I = 66 #%(T_46_META_WS_E_GOLD_HEATGUN_I)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_HEATGUN_II\r
    GOLD_HEATGUN_II = 132 #%(T_46_META_WS_E_GOLD_HEATGUN_II)\r
	@ApiLevel=4\r
	@ScriptName=GOLD_HEATGUN_III\r
    GOLD_HEATGUN_III = 133 #%(T_46_META_WS_E_GOLD_HEATGUN_III)\r
	@ApiLevel=4\r
	@ScriptName=PLASMA_X\r
    PLASMA_X = 199 #%(T_46_META_WS_E_PLASMA_X)\r
	@ApiLevel=4\r
	@ScriptName=HealingPistol_X\r
    HealingPistol_X = 21001 #%(T_46_META_WS_E_HEALINGPISTOL_X)\r
	@ApiLevel=4\r
	@ScriptName=Healinggun_Sniper\r
    Healinggun_Sniper = 78 #%(T_46_META_WS_E_HEALINGGUN_SNIPER)\r
	@ApiLevel=4\r
	@ScriptName=HealPistol\r
    TREATMENTGUN = 93 #%(T_46_META_WS_E_HEALPISTOL)\r
	@ApiLevel=4\r
	@ScriptName=VSS\r
    VSS = 13 #%(T_46_META_WS_E_VSS)\r
	@ApiLevel=4\r
	@ScriptName=GROZA\r
    GROZA = 14 #%(T_46_META_WS_E_GROZA)\r
	@ApiLevel=4\r
	@ScriptName=GROZA2\r
    GROZA2 = 153 #%(T_46_META_WS_E_GROZA2)\r
	@ApiLevel=4\r
	@ScriptName=MP40\r
    MP40 = 15 #%(T_46_META_WS_E_MP40)\r
	@ApiLevel=4\r
	@ScriptName=MP402\r
    MP402 = 164 #%(T_46_META_WS_E_MP402)\r
	@ApiLevel=4\r
	@ScriptName=Pot\r
    CHANGUO = 16 #%(T_46_META_WS_E_POT)\r
	@ApiLevel=4\r
	@ScriptName=Machete\r
    MACHETE = 17 #%(T_46_META_WS_E_MACHETE)\r
	@ApiLevel=4\r
	@ScriptName=SKS\r
    SKS = 18 #%(T_46_META_WS_E_SKS)\r
	@ApiLevel=4\r
	@ScriptName=M249\r
    M249 = 19 #%(T_46_META_WS_E_M249)\r
	@ApiLevel=4\r
	@ScriptName=M2492\r
    M2492 = 71 #%(T_46_META_WS_E_M2492)\r
	@ApiLevel=4\r
	@ScriptName=M1873\r
    M1873 = 20 #%(T_46_META_WS_E_M1873)\r
	@ApiLevel=4\r
	@ScriptName=M79\r
    M79 = 23 #%(T_46_META_WS_E_M79)\r
	@ApiLevel=4\r
	@ScriptName=FAMAS\r
    FAMAS = 24 #%(T_46_META_WS_E_FAMAS)\r
	@ApiLevel=4\r
	@ScriptName=M500\r
    M500 = 25 #%(T_46_META_WS_E_M500)\r
	@ApiLevel=4\r
	@ScriptName=SVD\r
    SVD = 26 #%(T_46_META_WS_E_SVD)\r
	@ApiLevel=4\r
	@ScriptName=SVD2\r
    SVD2 = 170 #%(T_46_META_WS_E_SVD2)\r
	@ApiLevel=4\r
	@ScriptName=AC80\r
    AC80 = 89 #%(T_46_META_WS_E_AC80)\r
	@ApiLevel=4\r
	@ScriptName=BaseballPole\r
    BASEBALLPOLE = 27 #%(T_46_META_WS_E_BASEBALLPOLE)\r
	@ApiLevel=4\r
	@ScriptName=XM8\r
    XM8 = 28 #%(T_46_META_WS_E_XM8)\r
	@ApiLevel=4\r
	@ScriptName=XM82\r
    XM82 = 159 #%(T_46_META_WS_E_XM82)\r
	@ApiLevel=4\r
	@ScriptName=SPAS12\r
    SPAS12 = 29 #%(T_46_META_WS_E_SPAS12)\r
	@ApiLevel=4\r
	@ScriptName=SPAS122\r
    SPAS122 = 162 #%(T_46_META_WS_E_SPAS122)\r
	@ApiLevel=4\r
	@ScriptName=M60\r
    M60 = 30 #%(T_46_META_WS_E_M60)\r
	@ApiLevel=4\r
	@ScriptName=MGL140\r
    MGL140 = 31 #%(T_46_META_WS_E_MGL140)\r
	@ApiLevel=4\r
	@ScriptName=P90\r
    P90 = 32 #%(T_46_META_WS_E_P90)\r
	@ApiLevel=4\r
	@ScriptName=P902\r
    P902 = 166 #%(T_46_META_WS_E_P902)\r
	@ApiLevel=4\r
	@ScriptName=AN94\r
    AN94 = 33 #%(T_46_META_WS_E_AN94)\r
	@ApiLevel=4\r
	@ScriptName=Katana\r
    KATANA = 34 #%(T_46_META_WS_E_KATANA)\r
	@ApiLevel=4\r
	@ScriptName=CG15\r
    CG15 = 35 #%(T_46_META_WS_E_CG15)\r
	@ApiLevel=4\r
	@ScriptName=RG550\r
    RG550 = 36 #%(T_46_META_WS_E_RG550)\r
	@ApiLevel=4\r
	@ScriptName=Gatling\r
    GATLING = 37 #%(T_46_META_WS_E_GATLING)\r
	@ApiLevel=4\r
	@ScriptName=HookGun\r
    GRAPPLINGHOOKGUN = 38 #%(T_46_META_WS_E_HOOKGUN)\r
	@ApiLevel=3\r
	@ScriptName=NewHookGun\r
    NEWGRAPPLINGHOOKGUN = 19001 #%(T_40_XYL_WS_NEWHOOKGUN)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingKnife\r
    THROWINGKNIFE = 40 #%(T_46_META_WS_E_THROWINGKNIFE)\r
	@ApiLevel=4\r
	@ScriptName=M1887\r
    M1887 = 41 #%(T_46_META_WS_E_M1887)\r
	@ApiLevel=4\r
	@ScriptName=M1887X\r
    M1887X = 119 #%(T_46_META_WS_E_M1887X)\r
	@ApiLevel=4\r
	@ScriptName=M18872\r
    M18872 = 161 #%(T_46_META_WS_E_M18872)\r
	@ApiLevel=4\r
	@ScriptName=THOMPSON\r
    THOMPSON = 43 #%(T_46_META_WS_E_THOMPSON)\r
	@ApiLevel=4\r
	@ScriptName=THOMPSON2\r
    THOMPSON2 = 168 #%(T_46_META_WS_E_THOMPSON2)\r
	@ApiLevel=4\r
	@ScriptName=BLT\r
    BLT = 45 #%(T_46_META_WS_E_BLT)\r
	@ApiLevel=4\r
	@ScriptName=BLT2\r
    BLT2 = 173 #%(T_46_META_WS_E_BLT2)\r
	@ApiLevel=4\r
	@ScriptName=AUG\r
    AUG = 46 #%(T_46_META_WS_E_AUG)\r
	@ApiLevel=4\r
	@ScriptName=PARAFAL\r
    PARAFAL = 47 #%(T_46_META_WS_E_PARAFAL)\r
	@ApiLevel=4\r
	@ScriptName=PARAFAL2\r
    PARAFAL2 = 158 #%(T_46_META_WS_E_PARAFAL2)\r
	@ApiLevel=4\r
	@ScriptName=M21A5\r
    M21A5 = 48 #%(T_46_META_WS_E_M21A5)\r
	@ApiLevel=4\r
	@ScriptName=VECTOR\r
    VECTOR = 49 #%(T_46_META_WS_E_VECTOR)\r
	@ApiLevel=4\r
	@ScriptName=MAG7\r
    MAG7 = 50 #%(T_46_META_WS_E_MAG7)\r
	@ApiLevel=4\r
	@ScriptName=MAG72\r
    MAG72 = 160 #%(T_46_META_WS_E_MAG72)\r
	@ApiLevel=4\r
	@ScriptName=Sickle\r
    SICKLE = 51 #%(T_46_META_WS_E_SICKLE)\r
	@ApiLevel=4\r
	@ScriptName=BigHeadHammer\r
    BigHeadHammer = 52 #%(T_46_META_WS_E_BIGHEADHAMMER)\r
	@ApiLevel=4\r
	@ScriptName=Knife\r
    Knife = 53 #%(T_46_META_WS_E_KNIFE)\r
	@ApiLevel=4\r
	@ScriptName=Kord\r
    Kord = 54 #%(T_46_META_WS_E_KORD)\r
	@ApiLevel=4\r
	@ScriptName=M1917\r
    M1917 = 55 #%(T_46_META_WS_E_M1917)\r
	@ApiLevel=4\r
	@ScriptName=USP_2\r
    USP-2 = 56 #%(T_46_META_WS_E_USP_2)\r
	@ApiLevel=4\r
	@ScriptName=AR15\r
    AR15 = 57 #%(T_46_META_WS_E_AR15)\r
	@ApiLevel=4\r
	@ScriptName=UZI\r
    UZI = 58 #%(T_46_META_WS_E_UZI)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_I\r
    GoldMP5_1 = 60 #%(T_46_META_WS_E_GOLDMP5_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_I\r
    GoldM60_1 = 61 #%(T_46_META_WS_E_GOLDM60_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldVSS_I\r
    GoldVSS_1 = 62 #%(T_46_META_WS_E_GOLDVSS_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_I\r
    GoldM14_1 = 63 #%(T_46_META_WS_E_GOLDM14_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_I\r
    GoldKar98K_1 = 64 #%(T_46_META_WS_E_GOLDKAR98K_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldAWM\r
    GoldAWM = 65 #%(T_46_META_WS_E_GOLDAWM)\r
	@ApiLevel=4\r
	@ScriptName=GoldFamas_I\r
    GoldFamas-1 = 67 #%(T_46_META_WS_E_GOLDFAMAS_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldGroza\r
    GoldGroza = 70 #%(T_46_META_WS_E_GOLDGROZA)\r
	@ApiLevel=4\r
	@ScriptName=GoldSVD\r
    GoldSVD = 72 #%(T_46_META_WS_E_GOLDSVD)\r
	@ApiLevel=4\r
	@ScriptName=G36\r
    G36 = 73 #%(T_46_META_WS_E_G36)\r
	@ApiLevel=4\r
	@ScriptName=M24\r
    M24 = 75 #%(T_46_META_WS_E_M24)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_I\r
    GoldM4A1_1 = 80 #%(T_46_META_WS_E_GOLDM4A1_I)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_II\r
    GoldM4A1_2 = 81 #%(T_46_META_WS_E_GOLDM4A1_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_III\r
    GoldM4A1_3 = 82 #%(T_46_META_WS_E_GOLDM4A1_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM4A1_III_ForInfection\r
    GoldM4A1_3_2 = 155 #%(T_46_META_WS_E_GOLDM4A1_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=ChargeBuster\r
    ChargeBuster = 86 #%(T_46_META_WS_E_CHARGEBUSTER)\r
	@ApiLevel=4\r
	@ScriptName=MAC10\r
    MAC10 = 88 #%(T_46_META_WS_E_MAC10)\r
	@ApiLevel=4\r
	@ScriptName=HandCannon\r
    HandCannon = 95 #%(T_46_META_WS_E_HANDCANNON)\r
	@ApiLevel=4\r
	@ScriptName=IceGun\r
    IceGun = 97 #%(T_46_META_WS_E_ICEGUN)\r
	@ApiLevel=4\r
	@ScriptName=ShieldGun\r
    ShieldGun = 99 #%(T_46_META_WS_E_SHIELDGUN)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_II\r
    GoldMP5_2 = 120 #%(T_46_META_WS_E_GOLDMP5_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_III\r
    GoldMP5_3 = 121 #%(T_46_META_WS_E_GOLDMP5_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldMP5_III_ForInfection\r
    GoldMP5_3_2 = 165 #%(T_46_META_WS_E_GOLDMP5_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_II\r
    GoldM60_2 = 122 #%(T_46_META_WS_E_GOLDM60_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_III\r
    GoldM60_3 = 123 #%(T_46_META_WS_E_GOLDM60_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM60_III_ForInfection\r
    GoldM60_3_2 = 167 #%(T_46_META_WS_E_GOLDM60_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldVSS_II\r
    GoldVSS_2 = 124 #%(T_46_META_WS_E_GOLDVSS_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldVSS_III\r
    GoldVSS_3 = 125 #%(T_46_META_WS_E_GOLDVSS_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_II\r
    GoldM14_2 = 126 #%(T_46_META_WS_E_GOLDM14_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_III\r
    GoldM14_3 = 127 #%(T_46_META_WS_E_GOLDM14_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldM14_III_ForInfection\r
    GoldM14_3_2 = 157 #%(T_46_META_WS_E_GOLDM14_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_II\r
    GoldKar98K_2 = 128 #%(T_46_META_WS_E_GOLDKAR98K_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_III\r
    GoldKar98K_3 = 129 #%(T_46_META_WS_E_GOLDKAR98K_III)\r
	@ApiLevel=4\r
	@ScriptName=GoldKar98K_III_ForInfection\r
    GoldKar98K_3_2 = 175 #%(T_46_META_WS_E_GOLDKAR98K_III_FORINFECTION)\r
	@ApiLevel=4\r
	@ScriptName=GoldFamas_II\r
    GoldFamas-2 = 130 #%(T_46_META_WS_E_GOLDFAMAS_II)\r
	@ApiLevel=4\r
	@ScriptName=GoldFamas_III\r
    GoldFamas-3 = 131 #%(T_46_META_WS_E_GOLDFAMAS_III)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
    Grenade = 601 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Flashbang\r
    FlashGrenade = 602 #%(T_46_META_WS_E_FLASHBANG)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
    SmokeGrenade = 603 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
    FlashFreeze = 608 #%(T_46_META_WS_E_FLASHFREEZE)\r
	@ApiLevel=4\r
	@ScriptName=Vest1\r
    Vest1 = 301 #%(T_46_META_WS_E_VEST1)\r
	@ApiLevel=4\r
	@ScriptName=Vest2\r
    Vest2 = 302 #%(T_46_META_WS_E_VEST2)\r
	@ApiLevel=4\r
	@ScriptName=Vest3\r
    Vest3 = 303 #%(T_46_META_WS_E_VEST3)\r
	@ApiLevel=4\r
	@ScriptName=Helmet1\r
    Helmet1 = 304 #%(T_46_META_WS_E_HELMET1)\r
	@ApiLevel=4\r
	@ScriptName=Helmet2\r
    Helmet2 = 305 #%(T_46_META_WS_E_HELMET2)\r
	@ApiLevel=4\r
	@ScriptName=Helmet3\r
    Helmet3 = 306 #%(T_46_META_WS_E_HELMET3)\r
	@ApiLevel=4\r
	@ScriptName=Vest4\r
    Vest4 = 309 #%(T_46_META_WS_E_VEST4)\r
	@ApiLevel=4\r
	@ScriptName=Bag1\r
    Bag1 = 401 #%(T_46_META_WS_E_BAG1)\r
	@ApiLevel=4\r
	@ScriptName=Bag2\r
    Bag2 = 402 #%(T_46_META_WS_E_BAG2)\r
	@ApiLevel=4\r
	@ScriptName=Bag3\r
    Bag3 = 403 #%(T_46_META_WS_E_BAG3)\r
	@ApiLevel=4\r
	@ScriptName=Muzzle1\r
    Muzzle1 = 501 #%(T_46_META_WS_E_MUZZLE1)\r
	@ApiLevel=4\r
	@ScriptName=Muzzle2\r
    Muzzle2 = 502 #%(T_46_META_WS_E_MUZZLE2)\r
	@ApiLevel=4\r
	@ScriptName=Muzzle3\r
    Muzzle3 = 503 #%(T_46_META_WS_E_MUZZLE3)\r
	@ApiLevel=4\r
	@ScriptName=Silencer\r
    Silencer = 504 #%(T_46_META_WS_E_SILENCER)\r
	@ApiLevel=4\r
	@ScriptName=SMGMuzzle\r
    SMGMuzzle = 505 #%(T_46_META_WS_E_SMGMUZZLE)\r
	@ApiLevel=4\r
	@ScriptName=ShotgunMuzzle\r
    ShotgunMuzzle = 506 #%(T_46_META_WS_E_SHOTGUNMUZZLE)\r
	@ApiLevel=4\r
	@ScriptName=Magazine1\r
    Magezine1 = 511 #%(T_46_META_WS_E_MAGEZINE1)\r
	@ApiLevel=4\r
	@ScriptName=Magazine2\r
    Magezine2 = 512 #%(T_46_META_WS_E_MAGEZINE2)\r
	@ApiLevel=4\r
	@ScriptName=Magazine3\r
    Magezine3 = 513 #%(T_46_META_WS_E_MAGEZINE3)\r
	@ApiLevel=4\r
	@ScriptName=DoubleMagazine\r
    DoubleMagezine = 516 #%(T_46_META_WS_E_DOUBLEMAGEZINE)\r
	@ApiLevel=4\r
	@ScriptName=ARMagazine\r
    ARMagazine = 517 #%(T_46_META_WS_E_ARMAGAZINE)\r
	@ApiLevel=4\r
	@ScriptName=Foregrip1\r
    Foregrip1 = 521 #%(T_46_META_WS_E_FOREGRIP1)\r
	@ApiLevel=4\r
	@ScriptName=Foregrip2\r
    Foregrip2 = 522 #%(T_46_META_WS_E_FOREGRIP2)\r
	@ApiLevel=4\r
	@ScriptName=Foregrip3\r
    Foregrip3 = 523 #%(T_46_META_WS_E_FOREGRIP3)\r
	@ApiLevel=4\r
	@ScriptName=Bipod\r
    Bipod = 524 #%(T_46_META_WS_E_BIPOD)\r
	@ApiLevel=4\r
	@ScriptName=FOREGRIP_MR\r
    FOREGRIP_MR = 525 #%(T_46_META_WS_E_FOREGRIP_MR)\r
	@ApiLevel=4\r
	@ScriptName=STOCK_S\r
    STOCK_S = 544 #%(T_46_META_WS_E_STOCK_S)\r
	@ApiLevel=4\r
	@ScriptName=STOCK_SR\r
    STOCK_SR = 545 #%(T_46_META_WS_E_STOCK_SR)\r
	@ApiLevel=4\r
	@ScriptName=ThermalScope\r
    ThermalScope = 537 #%(T_46_META_WS_E_THERMALSCOPE)\r
	@ApiLevel=4\r
	@ScriptName=Stock1\r
    Stock1 = 541 #%(T_46_META_WS_E_STOCK1)\r
	@ApiLevel=4\r
	@ScriptName=Stock2\r
    Stock2 = 542 #%(T_46_META_WS_E_STOCK2)\r
	@ApiLevel=4\r
	@ScriptName=Stock3\r
    Stock3 = 543 #%(T_46_META_WS_E_STOCK3)\r
	@ApiLevel=4\r
	@ScriptName=Attachment1ForCompatibility\r
    Attachment1 = 5601 #%(T_46_META_WS_E_ATTACHMENT1FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment4ForCompatibility\r
    Attachment4 = 5604 #%(T_46_META_WS_E_ATTACHMENT4FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment5ForCompatibility\r
    Attachment5 = 5605 #%(T_46_META_WS_E_ATTACHMENT5FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment6ForCompatibility\r
    Attachment6 = 5606 #%(T_46_META_WS_E_ATTACHMENT6FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Attachment8ForCompatibility\r
    Attachment8 = 5607 #%(T_46_META_WS_E_ATTACHMENT8FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=Inhaler\r
    Inhaler = 213 #%(T_46_META_WS_E_INHALER)\r
	@ApiLevel=4\r
	@ScriptName=Cardiotonic\r
    Cardiac = 108 #%(T_46_META_WS_E_CARDIOTONIC)\r
	@ApiLevel=4\r
	@ScriptName=MedKit\r
    Fak = 102 #%(T_46_META_WS_E_MEDKIT)\r
	@ApiLevel=4\r
	@ScriptName=RepairKit\r
    ArmorRepair = 106 #%(T_46_META_WS_E_REPAIRKIT)\r
	@ApiLevel=4\r
	@ScriptName=MiniHandle\r
    MiniHandle = 2102 #%(T_46_META_WS_E_MINIHANDLE)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom1\r
    Mushroom1 = 701 #%(T_46_META_WS_E_MUSHROOM1)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom2\r
    Mushroom2 = 702 #%(T_46_META_WS_E_MUSHROOM2)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom3\r
    Mushroom3 = 703 #%(T_46_META_WS_E_MUSHROOM3)\r
	@ApiLevel=4\r
	@ScriptName=Mushroom4\r
    Mushroom4 = 707 #%(T_46_META_WS_E_MUSHROOM4)\r
	@ApiLevel=4\r
	@ScriptName=UAVLite\r
    UAVLite = 1006 #%(T_46_META_WS_E_UAVLITE)\r
	@ApiLevel=4\r
	@ScriptName=GlooWall\r
    GlooWall = 1201 #%(T_46_META_WS_E_GLOOWALL)\r
	@ApiLevel=4\r
	@ScriptName=Landmine\r
    Landmine = 1401 #%(T_46_META_WS_E_LANDMINE)\r
	@ApiLevel=4\r
	@ScriptName=Flyshoe\r
    Flyshoe = 1601 #%(T_46_META_WS_E_FLYSHOE)\r
	@ApiLevel=4\r
	@ScriptName=DoubleJumpShoe\r
    DoublejumpShoe = 1602 #%(T_46_META_WS_E_DOUBLEJUMPSHOE)\r
	@ApiLevel=4\r
	@ScriptName=Foldwings\r
    Foldwings = 2003 #%(T_46_META_WS_E_FOLDWINGS)\r
	@ApiLevel=4\r
	@ScriptName=Dummy\r
    Dummy = 2401 #%(T_46_META_WS_E_DUMMY)\r
	@ApiLevel=4\r
	@ScriptName=ElectricSurfboard\r
    ElectricSurfboard = 2501 #%(T_46_META_WS_E_ELECTRICSURFBOARD)\r
	@ApiLevel=4\r
	@ScriptName=BombPliers\r
    BombPliers = 2801 #%(T_46_META_WS_E_BOMBPLIERS)\r
	@ApiLevel=4\r
	@ScriptName=Replacer\r
    Replacer = 3008 #%(T_46_META_WS_E_REPLACER)\r
	@ApiLevel=4\r
	@ScriptName=ARAmmo\r
    ARAMMO = 201 #%(T_46_META_WS_E_ARAMMO)\r
	@ApiLevel=4\r
	@ScriptName=HGAmmo\r
    HGAMMO = 202 #%(T_46_META_WS_E_HGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SNAmmo\r
    SNAMMO = 203 #%(T_46_META_WS_E_SNAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SGAmmo\r
    SGAMMO = 204 #%(TXT_ITEM_SGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SMGAmmo\r
    SMGAMMO = 205 #%(T_46_META_WS_E_SMGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=BOWAmmo\r
    BOWAMMO = 206 #%(T_46_META_WS_E_BOWAMMO)\r
	@ApiLevel=4\r
	@ScriptName=LauncherAMMO\r
    LANUNCHERAMMO = 207 #%(T_46_META_WS_E_LANUNCHERAMMO)\r
	@ApiLevel=4\r
	@ScriptName=FlameGun\r
    FLAMETHROWER = 214 #%(T_46_META_WS_E_FLAMEGUN)\r
	@ApiLevel=4\r
	@ScriptName=ThowingKnife2ForCompatibility\r
    THROWINGKNIFE2 = 152 #%(T_46_META_WS_E_THOWINGKNIFE2FORCOMPATIBILITY)\r
	@ApiLevel=4\r
	@ScriptName=HookGunAMMO\r
    GRAPPLINGHOOKAMMO = 209 #%(T_46_META_WS_E_HOOKGUNAMMO)\r
	@ApiLevel=4\r
	@ScriptName=FootballGun\r
    FOOTBALLGUN = 177 #%(T_46_META_WS_E_FOOTBALLGUN)\r
	@ApiLevel=4\r
	@ScriptName=Fist\r
    FIST = 17001 #%(T_46_META_WS_E_FIST)\r
	@ApiLevel=4\r
	@ScriptName=HideAndSeekFlamethrower\r
    FLAMETHROWERDMM = 17002 #%(T_46_META_WS_E_HIDEANDSEEKFLAMETHROWER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    MonkeygodCard = 5611 #%(T_12_R_SKILL_NAME_MONKEYGOD)\r
	@ApiLevel=4\r
	@ScriptName=\r
    MadeManACard = 5612 #%(T_33_C_SKILL_NAME_MADEMANA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    DjmaleCard = 5613 #%(T_18_C_SKILL_NAME_DJMALE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    GraffitistCard = 5614 #%(T_20_C_SKILL_NAME_GRAFFITIST)\r
	@ApiLevel=4\r
	@ScriptName=\r
    DetectiveCard = 5615 #%(T_22_C_SKILL_NAME_DETECTIVE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    ProfessorCard = 5616 #%(T_24_C_SKILL_NAME_PROFESSOR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    BountyHunterCard = 5617 #%(T_25_C_SKILL_NAME_BOUNTYHUNTER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SuperstarCard = 5618 #%(T_26_C_SKILL_NAME_SUPERSTAR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    XtremeCard = 5619 #%(T_27_C_SKILL_NAME_XTREME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    MusicBroCard = 5620 #%(T_29_C_SKILL_NAME_MUSICBRO_WHITE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    KentaCard = 5621 #%(T_42_WH_ITEM_SKILLCARD)\r
	@ApiLevel=4\r
	@ScriptName=\r
    TRACKERCard = 5622 #%(T_34_C_SKILL_NAME_TRACKER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    CrazygirlCard = 5623 #%(T_35_JL_SKILL_NAME_CRAZYGIRL)\r
	@ApiLevel=4\r
	@ScriptName=\r
    RunSpeedUpCard = 5624 #%(T_32_C_SKILL_NAME_YAKUZA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SantinoCard = 5625 #%(T_38_BQ_SKILL_NAME_DUMMY1)\r
	@ApiLevel=4\r
	@ScriptName=\r
    VillainCard = 5626 #%(T_39_BQ_SKILL_NAME_VILLAIN)\r
	@ApiLevel=4\r
	@ScriptName=\r
    HealUAV = 92103 #%(T_42_WH_ITEM_HEALUAV)\r
	@ApiLevel=4\r
	@ScriptName=\r
    NewLoadoutTBonfire = 1001 #%(TXT_OB8_HQW_NEWLOADOUT_BONFIRE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradIgnis = 91017 #%(T_41_WT_SKILL_NAME_FIREBOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradKoda = 91055 #%(T_47_B_SKILL_NAME_AURORABOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradCamouflage = 91037 #%(T_12_R_SKILL_NAME_MONKEYGOD)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradThrillOfBattle = 91038 #%(T_33_C_SKILL_NAME_MADEMANA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradDropTheBeat = 91039 #%(T_18_C_SKILL_NAME_DJMALE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradPaintedRefuge = 91040 #%(T_20_C_SKILL_NAME_GRAFFITIST)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradTracingSteps = 91041 #%(T_22_C_SKILL_NAME_DETECTIVE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradMasterOfAll = 91042 #%(T_24_C_SKILL_NAME_PROFESSOR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradTimeTurner = 91043 #%(T_25_C_SKILL_NAME_BOUNTYHUNTER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradRiptideRhythm = 91044 #%(T_26_C_SKILL_NAME_SUPERSTAR)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradXtremeEncounter = 91045 #%(T_27_C_SKILL_NAME_XTREME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradHealingHeartbeat = 91046 #%(T_29_C_SKILL_NAME_MUSICBRO_WHITE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradSwordsmansWrath = 91047 #%(T_33_C_SKILL_NAME_KENTA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradSensesShockwave = 91048 #%(T_34_C_SKILL_NAME_TRACKER)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradWallBrawl = 91049 #%(T_35_JL_SKILL_NAME_CRAZYGIRL)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradRebelRush = 91050 #%(T_32_C_SKILL_NAME_YAKUZA)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradStuntDouble = 91051 #%(T_38_BQ_SKILL_NAME_DUMMY1)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradCrimsonCrush = 91052 #%(T_39_BQ_SKILL_NAME_VILLAIN)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradFlameMirage = 91053 #%(T_39_BQ_SKILL_NAME_VILLAIN)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradSpiderTrap = 91054 #%(T_42_B_SKILL_NAME_GEEK)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradAuroraVision = 91057 #%(T_47_B_SKILL_NAME_AURORABOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradElectroTherapy = 91060 #%(T_44_B_SKILL_NAME_ELECTRICGIRL)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SkillCradValiantDash = 91063 #%(T_48_WT_SKILL_NAME_CITYHEROBOY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    GrenadeDragon = 624 #%(T_44_QL_GRENADE_DRAGON)\r
	@ApiLevel=4\r
	@ScriptName=\r
    GrenadeJumpPad = 622 #%(T_37_QL_JUMPPAD_NAME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    SupplkyBox = 1015 #%(T_43_WH_ITEM_SUPPLYBOX_NAME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    GrenadeMinisentry = 93003 #%(T_16_Q_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=\r
    JumpShoesX = 1605 #%(T_44_QL_JUMPSHOESX)\r
	@ApiLevel=4\r
	@ScriptName=\r
    VehicledropRandom = 92200 #%(T_45_ZD_VEHICLEDROP_R_NAME)\r
	@ApiLevel=4\r
	@ScriptName=\r
    VehicledropRandomPORTALSPERSONAL = 91200 #%(T_42_RW_PORTALSPERSONAL_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
    Shuriken_Heavy = 21003 #%(T_47_WT_W_NB_GP_SRK_HEAVY_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
    Shuriken_Light = 21004 #%(T_47_WT_W_NB_GP_SRK_LIGHT_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
    Kunai_Explode = 10050 #%(T_47_WT_W_NB_GP_KA_EXPLODE_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
    Kunai_Thunder = 10051 #%(T_47_WT_W_NB_GP_KA_THUNDER_NAME)\r
	@ApiLevel=3\r
	@ScriptName=\r
    Kunai_Wind = 10052 #%(T_47_WT_W_NB_GP_KA_WIND_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpecialItemIDType\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum SpecialItemGoodsIDType : ItemID = 308 { #%(T_46_META_WS_C_SPECIALITEMIDTYPE)\r
	@ApiLevel=4\r
	@ScriptName=IceWallMaker\r
    IceWallMaker = 1299 #%(T_46_META_WS_E_ICEWALLMAKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITimerInfo\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CountdownHud : InternalHud = 1010 { #%(T_46_META_WS_C_UITIMERINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1010000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    Duration : Int = -1010001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
    BaseTime : Int = -1010002 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=UpdateType\r
    UpdateType : Int = -1010003 #%(T_46_META_WS_P_UPDATETYPE)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, -16, 0)\r
	@ScriptName=Offset\r
    Offset : Vector3 = -1010004 #%(T_46_META_WS_P_OFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIOpeningBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type OpeningBannerHud : InternalHud = 1011 { #%(T_46_META_WS_C_UIOPENINGBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1011000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=10\r
	@ScriptName=IconName_Deprecated\r
    IconSpriteName : String = -1011001 #IconSpriteName\r
	@ApiLevel=4\r
	@ScriptName=ThemeColor\r
    ThemeColor : Color = -1011002 #%(T_46_META_WS_P_THEMECOLOR)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1011003 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Title\r
    TitleText : String = -1011004 #%(T_46_META_WS_P_TITLE)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    DescText : String = -1011005 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    Icon : SpriteID = -1011006 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=MaxProgress\r
    MaxProgress : Int = -1011007 #%(T_46_META_WS_P_MAXPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=CurrentProgress\r
    CurProgress : Int = -1011008 #%(T_46_META_WS_P_CURRENTPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=ProgressIcon\r
    ProgressIcon : SpriteID = -1011009 #%(T_46_META_WS_P_PROGRESSICON)\r
	@ApiLevel=4\r
	@ScriptName=ProgressIconName\r
    ProgressIconSpriteName : String = -1011010 #%(T_46_META_WS_P_PROGRESSICONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPersonaChat\r
@ModuleID=43\r
@ModuleLib=LLM\r
type LLMChatHud : InternalHud = 416 { #%(T_47_XXJ_WS_LLMCHATHUD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Visible\r
    IsVisible : Bool = -416000 #%(T_47_XXJ_WS_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
    BindPersona : PersonaID = -416001 #%(T_46_META_WS_A_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector2 = -416002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowSystemReply\r
    ShowSystemReply : Bool = -416004 #%(T_47_XXJ_WS_SHOWSYSTEMREPLY)\r
	@ApiLevel=4\r
	@Default=Persona\r
	@ScriptName=PersonaNickName\r
    PersonaNickName : String = -416005 #%(T_47_XXJ_WS_PERSONANICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=PersonaAvatar\r
    PersonaAvatar : SpriteID = -416006 #%(T_47_XXJ_WS_PERSONAAVATAR)\r
	@ApiLevel=4\r
	@ScriptName=UserNickName\r
    UserNickName : String = -416007 #%(T_47_XXJ_WS_USERNICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=UserAvatar\r
    UserAvatar : SpriteID = -416008 #%(T_47_XXJ_WS_USERAVATAR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundStartBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamRoundStartBannerHud : InternalHud = 1012 { #%(T_46_META_WS_C_UIROUNDSTARTBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1012000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1012001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumKey\r
    RoundNumLocKey : String = -1012002 #%(T_46_META_WS_P_ROUNDNUMKEY)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumLocKeyParams\r
    RoundNumLocKey_Params : ListT_Int = -1012003 #%(T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    DescText : String = -1012004 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=LeftColor\r
    LeftColor : Color = -1012005 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightColor\r
    RightColor : Color = -1012006 #%(T_46_META_WS_P_RIGHTCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISimpleRoundStartBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type NormalRoundStartBannerHud : InternalHud = 1013 { #%(T_46_META_WS_C_UISIMPLEROUNDSTARTBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1013000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1013001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumKey\r
    RoundNumLocKey : String = -1013002 #%(T_46_META_WS_P_ROUNDNUMKEY)\r
	@ApiLevel=4\r
	@ScriptName=RoundNumLocKeyParams\r
    RoundNumLocKey_Params : ListT_Int = -1013003 #%(T_46_META_WS_P_ROUNDNUMLOCKEYPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    DescText : String = -1013004 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=ThemeColor\r
    ThemeColor : Color = -1013005 #%(T_46_META_WS_P_THEMECOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISimpleRoundScoreBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TeamRoundScoreBannerHud : InternalHud = 1014 { #%(T_46_META_WS_C_UISIMPLEROUNDSCOREBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1014000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1014001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=FirstScoreTitle\r
    FirstScoreTitleLocKey : String = -1014002 #%(T_46_META_WS_P_FIRSTSCORETITLE)\r
	@ApiLevel=4\r
	@ScriptName=FirstScoreValue\r
    FirstScoreValueLocKey : String = -1014003 #%(T_46_META_WS_P_FIRSTSCOREVALUE)\r
	@ApiLevel=4\r
	@ScriptName=FirstScoreParams\r
    FirstScoreValueLocKey_Params : ListT_Int = -1014004 #%(T_46_META_WS_P_FIRSTSCOREPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=SecondScoreTitle\r
    SecondScoreTitleLocKey : String = -1014005 #%(T_46_META_WS_P_SECONDSCORETITLE)\r
	@ApiLevel=4\r
	@ScriptName=SecondScoreValue\r
    SecondScoreValueLocKey : String = -1014006 #%(T_46_META_WS_P_SECONDSCOREVALUE)\r
	@ApiLevel=4\r
	@ScriptName=SecondScoreValueParams\r
    SecondScoreValueLocKey_Params : ListT_Int = -1014007 #%(T_46_META_WS_P_SECONDSCOREVALUEPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICheckPointIndicator\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CheckPointMgrHud : InternalHud = 1015 { #%(T_46_META_WS_C_UICHECKPOINTINDICATOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1015000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamResultPanel\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundResultShowTimeHud : InternalHud = 1016 { #%(T_46_META_WS_C_UITWOTEAMRESULTPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1016000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTimeType\r
    ShowTimeType : Int = -1016001 #%(T_46_META_WS_P_SHOWTIMETYPE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTwoTeamScore\r
    ShowTwoTeamScore : Bool = -1016002 #%(T_46_META_WS_P_SHOWTWOTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -1016003 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -1016004 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=PhaseEndTime\r
    PhaseEndTime : Int = -1016005 #%(T_46_META_WS_P_PHASEENDTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIVersusBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamFactionHud : InternalHud = 1017 { #%(T_46_META_WS_C_UIVERSUSBANNER)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1017000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
    LeftTeamName : String = -1017001 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftDescription\r
    LeftTeamDesc : String = -1017002 #%(T_46_META_WS_P_LEFTDESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
    RightTeamName : String = -1017003 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightDescription\r
    RightTeamDesc : String = -1017004 #%(T_46_META_WS_P_RIGHTDESCRIPTION)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1017005 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamRoundScoreBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamRoundScoreBannerHud : InternalHud = 1018 { #%(T_46_META_WS_C_UITWOTEAMROUNDSCOREBANNER)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1018000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=RoundNum\r
    RoundNum : Int = -1018001 #%(T_46_META_WS_P_ROUNDNUM)\r
	@ApiLevel=10\r
	@ScriptName=LeftTeamIndex_Deprecated\r
    LeftTeamIndex : Int = -1018002 #LeftTeamIndex\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
    LeftTeamName : String = -1018003 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -1018004 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
    RightTeamName : String = -1018005 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -1018006 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1018007 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWinOrLoseBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ResultBannerHud : InternalHud = 1019 { #%(T_46_META_WS_C_UIWINORLOSEBANNER)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1019000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Result\r
    Result : Int = -1019001 #%(T_46_META_WS_P_RESULT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1019002 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundNumber\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundNumHud : InternalHud = 1020 { #%(T_46_META_WS_C_UIROUNDNUMBER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1020000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1020001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TextKey\r
    TextKey : String = -1020002 #%(T_46_META_WS_P_TEXTKEY)\r
	@ApiLevel=4\r
	@ScriptName=TextKeyParams\r
    TextKey_Params : ListT_Int = -1020003 #%(T_46_META_WS_P_TEXTKEYPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=ThemeColor\r
    ThemeColor : Color = -1020004 #%(T_46_META_WS_P_THEMECOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPhaseTimer\r
@ModuleID=31\r
@ModuleLib=Hud\r
type PhaseCountDownHud : InternalHud = 1021 { #%(T_46_META_WS_C_UIPHASETIMER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1021000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
    BaseTimeS : Int = -1021001 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    DurationTimeS : Int = -1021002 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -1021003 #%(T_46_META_WS_P_OFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMatchSubtitle\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MatchInfoSubTitleHud : InternalHud = 1022 { #%(T_46_META_WS_C_UIMATCHSUBTITLE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1022000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1022001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TextKey\r
    TextKey : String = -1022002 #%(T_46_META_WS_P_TEXTKEY)\r
	@ApiLevel=4\r
	@ScriptName=TextKeyParams\r
    TextKey_Params : ListT_Int = -1022003 #%(T_46_META_WS_P_TEXTKEYPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamInfo\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchInfoHud : InternalHud = 1023 { #%(T_46_META_WS_C_UITWOTEAMINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1023000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTeamScore\r
    ShowTeamScore : Bool = -1023001 #%(T_46_META_WS_P_SHOWTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -1023002 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -1023003 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=ShowTeammateState\r
    ShowTeammateState : Bool = -1023004 #%(T_46_META_WS_P_SHOWTEAMMATESTATE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateStates\r
    LeftTeammateStateArray : ListT_Int = -1023005 #%(T_46_META_WS_P_LEFTTEAMMATESTATES)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateStates\r
    RightTeammateStateArray : ListT_Int = -1023006 #%(T_46_META_WS_P_RIGHTTEAMMATESTATES)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateFlagCount\r
    LeftTeammateFlagCount : Int = -1023007 #%(T_46_META_WS_P_LEFTTEAMMATEFLAGCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateFlagCount\r
    RightTeammateFlagCount : Int = -1023008 #%(T_46_META_WS_P_RIGHTTEAMMATEFLAGCOUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITeamMatchInfo\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TeamMatchInfoHud : InternalHud = 1024 { #%(T_46_META_WS_C_UITEAMMATCHINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1024000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1024001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    OffsetPosition : Vector3 = -1024002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=Rank\r
    Rank : Int = -1024003 #%(T_46_META_WS_P_RANK)\r
	@ApiLevel=4\r
	@ScriptName=TeamColor\r
    TeamColor : Color = -1024004 #%(T_46_META_WS_P_TEAMCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=IconName\r
    IconSpriteName : String = -1024005 #%(T_46_META_WS_P_ICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=ShowFrame\r
    ShowFrame : Bool = -1024006 #%(T_46_META_WS_P_SHOWFRAME)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTextKey\r
    ScoreTextKey : String = -1024007 #%(T_46_META_WS_P_SCORETEXTKEY)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTextKeyParams\r
    ScoreTextKey_Params : ListT_Int = -1024008 #%(T_46_META_WS_P_SCORETEXTKEYPARAMS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UITwoTeamLeaderboard\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamLeaderboardHud : InternalHud = 1025 { #%(T_46_META_WS_C_UITWOTEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1025000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=10\r
	@ScriptName=LeftTeamIndex\r
    LeftTeamIndex : Int = -1025001 #%(T_46_META_WS_P_LEFTTEAMINDEX)\r
	@ApiLevel=10\r
	@ScriptName=RightTeamIndex\r
    RightTeamIndex : Int = -1025002 #%(T_46_META_WS_P_RIGHTTEAMINDEX)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -1025003 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -1025004 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=PlayerScoreTypes\r
    PlayerScoreTypes : ListT_Int = -1025005 #%(T_46_META_WS_P_PLAYERSCORETYPES)\r
	@ApiLevel=4\r
	@ScriptName=LeftPlayers\r
    LeftPlayerArray : ListT_Player = -1025006 #%(T_46_META_WS_P_LEFTPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=RightPlayers\r
    RightPlayerArray : ListT_Player = -1025007 #%(T_46_META_WS_P_RIGHTPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamLeaderboardV2\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamLeaderboardHudV2 : InternalHud = 437 { #%(T_46_META_WS_C_UITWOTEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -437000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -437001 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -437002 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftPlayers\r
    LeftPlayerArray : ListT_Player = -437003 #%(T_46_META_WS_P_LEFTPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=RightPlayers\r
    RightPlayerArray : ListT_Player = -437004 #%(T_46_META_WS_P_RIGHTPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTypeNames\r
    ScoreTypeNames : ListT_String = -437005 #%(T_48_META_TYP_437_I5)\r
	@ApiLevel=4\r
	@ScriptName=LeftScoreContent\r
    LeftScoreContent : ListT_ListT_Object = -437006 #%(T_48_META_TYP_437_I6)\r
	@ApiLevel=4\r
	@ScriptName=RightScoreContent\r
    RightScoreContent : ListT_ListT_Object = -437007 #%(T_48_META_TYP_437_I7)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UIMultipleTeamLeaderboard\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MoreTeamLeaderboardHud : InternalHud = 1026 { #%(T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1026000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=TeamIndexs\r
    TeamIndexs : ListT_Int = -1026001 #%(T_46_META_WS_P_TEAMINDEXS)\r
	@ApiLevel=4\r
	@ScriptName=TeamRanks\r
    TeamRanks : ListT_Int = -1026002 #%(T_46_META_WS_P_TEAMRANKS)\r
	@ApiLevel=4\r
	@ScriptName=TeamScores\r
    TeamScores : ListT_Int = -1026003 #%(T_46_META_WS_P_TEAMSCORES)\r
	@ApiLevel=4\r
	@ScriptName=TeamColors\r
    TeamColors : ListT_Color = -1026004 #%(T_46_META_WS_P_TEAMCOLORS)\r
	@ApiLevel=4\r
	@ScriptName=PlayerScoreTypes\r
    PlayerScoreTypes : ListT_Int = -1026005 #%(T_46_META_WS_P_PLAYERSCORETYPES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMultipleTeamLeaderboardV2\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MoreTeamLeaderboardHudV2 : InternalHud = 438 { #%(T_46_META_WS_C_UIMULTIPLETEAMLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -438000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
    Players : ListT_ListT_Player = -438001 #%(T_48_META_TYP_438_I1)\r
	@ApiLevel=4\r
	@ScriptName=Ranks\r
    Ranks : ListT_Int = -438002 #%(T_48_META_TYP_438_I2)\r
	@ApiLevel=4\r
	@ScriptName=TotalScores\r
    TotalScores : ListT_Int = -438003 #%(T_48_META_TYP_438_I3)\r
	@ApiLevel=4\r
	@ScriptName=ScoreTypeNames\r
    ScoreTypeNames : ListT_String = -438004 #%(T_48_META_TYP_438_I4)\r
	@ApiLevel=4\r
	@ScriptName=Colors\r
    Colors : ListT_Color = -438005 #%(T_48_META_TYP_438_I5)\r
	@ApiLevel=4\r
	@ScriptName=Scores\r
    Scores : ListT_ListT_Object = -438006 #%(T_48_META_TYP_438_I6)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UISimpleVersusBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type FactionInfoHud : InternalHud = 1028 { #%(T_46_META_WS_C_UISIMPLEVERSUSBANNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1028000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateAliveNum\r
    LeftTeammateAliveCount : Int = -1028001 #%(T_46_META_WS_P_LEFTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateAliveNum\r
    RightTeammateAliveCount : Int = -1028002 #%(T_46_META_WS_P_RIGHTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=LeftBackgroundColor\r
    LeftBgColor : Color = -1028003 #%(T_46_META_WS_P_LEFTBACKGROUNDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightBackgroundColor\r
    RightBgColor : Color = -1028004 #%(T_46_META_WS_P_RIGHTBACKGROUNDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LeftIconName\r
    LeftIconSpriteName : String = -1028005 #%(T_46_META_WS_P_LEFTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightIconName\r
    RightIconSpriteName : String = -1028006 #%(T_46_META_WS_P_RIGHTICONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIIconNotification\r
@ModuleID=31\r
@ModuleLib=Hud\r
type IconNotificationHud : InternalHud = 1029 { #%(T_46_META_WS_C_UIICONNOTIFICATION)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1029000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=IconName\r
    IconSpriteName : String = -1029001 #%(T_46_META_WS_P_ICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundIconName\r
    BgIconSpriteName : String = -1029002 #%(T_46_META_WS_P_BACKGROUNDICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    Description : String = -1029003 #%(T_46_META_WS_P_DESCRIPTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamBriefInfo\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchInfoSimpleHud : InternalHud = 1030 { #%(T_46_META_WS_C_UITWOTEAMBRIEFINFO)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1030000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -1030001 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -1030002 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeammateAliveNum\r
    LeftTeammateAliveCount : Int = -1030003 #%(T_46_META_WS_P_LEFTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=RightTeammateAliveNum\r
    RightTeammateAliveCount : Int = -1030004 #%(T_46_META_WS_P_RIGHTTEAMMATEALIVENUM)\r
	@ApiLevel=4\r
	@ScriptName=LeftIconName\r
    LeftIconSpriteName : String = -1030005 #%(T_46_META_WS_P_LEFTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightIconName\r
    RightIconSpriteName : String = -1030006 #%(T_46_META_WS_P_RIGHTICONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamBriefInfoV2\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchInfoSimpleHudV2 : InternalHud = 442 { #%(T_46_META_WS_C_UITWOTEAMBRIEFINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -442000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LeftScore\r
    LeftScore : Int = -442001 #%(T_48_META_TYP_442_I1)\r
	@ApiLevel=4\r
	@ScriptName=RightScore\r
    RightScore : Int = -442002 #%(T_48_META_TYP_442_I2)\r
	@ApiLevel=4\r
	@ScriptName=LeftAliveNum\r
    LeftAliveCount : Int = -442003 #%(T_48_META_TYP_442_I3)\r
	@ApiLevel=4\r
	@ScriptName=RightAliveNum\r
    RightAliveCount : Int = -442004 #%(T_48_META_TYP_442_I4)\r
	@ApiLevel=4\r
	@ScriptName=LeftDeadNum\r
    LeftDeadCount : Int = -442005 #%(T_48_META_TYP_442_I5)\r
	@ApiLevel=4\r
	@ScriptName=RightDeadNum\r
    RightDeadCount : Int = -442006 #%(T_48_META_TYP_442_I6)\r
	@ApiLevel=4\r
	@ScriptName=LeftAliveIcon\r
    LeftAliveIcon : SpriteID = -442007 #%(T_48_META_TYP_442_I7)\r
	@ApiLevel=4\r
	@ScriptName=RightAliveIcon\r
    RightAliveIcon : SpriteID = -442008 #%(T_48_META_TYP_442_I8)\r
	@ApiLevel=4\r
	@ScriptName=LeftDeadIcon\r
    LeftDeadIcon : SpriteID = -442009 #%(T_48_META_TYP_442_I9)\r
	@ApiLevel=4\r
	@ScriptName=RightDeadIcon\r
    RightDeadIcon : SpriteID = -442010 #%(T_48_META_TYP_442_I10)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICountdownReminder\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CountdownReminderHud : InternalHud = 1031 { #%(T_46_META_WS_C_UICOUNTDOWNREMINDER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1031000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    DurationTimeS : Int = -1031001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    Description : String = -1031002 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
    CountDownBaseTimeS : Int = -1031003 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=DescriptionParams\r
    DescriptionParams : ListT_String = -1031004 #%(T_46_META_WS_P_DESCRIPTIONPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITweenTip\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TweenTipsHud : InternalHud = 1032 { #%(T_46_META_WS_C_UITWEENTIP)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1032000 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TipsType\r
    EventTipsType : Int = -1032001 #%(T_46_META_WS_P_TIPSTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    Description : String = -1032002 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=Params\r
    Params : ListT_Int = -1032003 #%(T_46_META_WS_P_PARAMS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1032004 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundTransition\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundTransitionHud : InternalHud = 1033 { #%(T_46_META_WS_C_UIROUNDTRANSITION)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1033000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=TransitionStage\r
    TransitionStage : Int = -1033001 #%(T_46_META_WS_P_TRANSITIONSTAGE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : Int = -1033002 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : Int = -1033003 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
    LeftTeamName : String = -1033004 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
    RightTeamName : String = -1033005 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftIconName\r
    LeftIconSpriteName : String = -1033006 #%(T_46_META_WS_P_LEFTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightIconName\r
    RightIconSpriteName : String = -1033007 #%(T_46_META_WS_P_RIGHTICONNAME)\r
	@ApiLevel=4\r
	@ScriptName=ResultType\r
    ResultType : Int = -1033008 #%(T_46_META_WS_P_RESULTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=WinText\r
    WinLoc : String = -1033009 #%(T_46_META_WS_P_WINTEXT)\r
	@ApiLevel=4\r
	@ScriptName=LoseText\r
    LoseLoc : String = -1033010 #%(T_46_META_WS_P_LOSETEXT)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncomeTitle\r
    RoundIncomeTitle : String = -1033011 #%(T_46_META_WS_P_ROUNDINCOMETITLE)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncome\r
    RoundIncome : Int = -1033012 #%(T_46_META_WS_P_ROUNDINCOME)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncomeDetailTitles\r
    RoundIncomeDetailTitleList : ListT_String = -1033013 #%(T_46_META_WS_P_ROUNDINCOMEDETAILTITLES)\r
	@ApiLevel=4\r
	@ScriptName=RoundIncomeDetailNums\r
    RoundIncomeDetailList : ListT_Int = -1033014 #%(T_46_META_WS_P_ROUNDINCOMEDETAILNUMS)\r
	@ApiLevel=4\r
	@ScriptName=MVP\r
    MVP : String = -1033015 #%(T_46_META_WS_P_MVP)\r
	@ApiLevel=4\r
	@ScriptName=NextRoundIndex\r
    NextRoundIndex : Int = -1033016 #%(T_46_META_WS_P_NEXTROUNDINDEX)\r
	@ApiLevel=4\r
	@ScriptName=IsMatchPoint\r
    IsMatchPoint : Bool = -1033017 #%(T_46_META_WS_P_ISMATCHPOINT)\r
	@ApiLevel=4\r
	@ScriptName=IsLastRound\r
    IsLastRound : Bool = -1033018 #%(T_46_META_WS_P_ISLASTROUND)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=UISoloLeaderboard\r
@ModuleID=31\r
@ModuleLib=Hud\r
type SingleLeaderboardHud : InternalHud = 1034 { #%(T_46_META_WS_C_UISOLOLEADERBOARD)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1034000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
    Players : ListT_Player = -1034001 #%(T_46_META_WS_P_PLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=PlayerRanks\r
    PlayerRanks : ListT_Int = -1034002 #%(T_46_META_WS_P_PLAYERRANKS)\r
	@ApiLevel=4\r
	@ScriptName=PlayerScoreTypes\r
    PlayerScoreTypes : ListT_Int = -1034003 #%(T_46_META_WS_P_PLAYERSCORETYPES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UILeaderboardButton\r
@ModuleID=31\r
@ModuleLib=Hud\r
type LeaderboardButtonHud : InternalHud = 1035 { #%(T_46_META_WS_C_UILEADERBOARDBUTTON)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1035000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMonsterLevel\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ZombieLevelHud : InternalHud = 1036 { #%(T_46_META_WS_C_UIMONSTERLEVEL)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1036000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=TotalLevel\r
    TotalLevel : Int = -1036001 #%(T_46_META_WS_P_TOTALLEVEL)\r
	@ApiLevel=4\r
	@ScriptName=Level\r
    Level : Int = -1036002 #%(T_46_META_WS_P_LEVEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIAddScore\r
@ModuleID=31\r
@ModuleLib=Hud\r
type AddScoreVFXHud : InternalHud = 1037 { #%(T_46_META_WS_C_UIADDSCORE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1037000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Score\r
    ScoreNum : Int = -1037001 #%(T_46_META_WS_P_SCORE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMonster\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ZombieVFXHud : InternalHud = 1038 { #%(T_46_META_WS_C_UIMONSTERUI)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1038000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICountdownHint\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TimeTweenTipsHud : InternalHud = 1039 { #%(T_46_META_WS_C_UICOUNTDOWNHINT)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1039000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1039001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Description\r
    Description : String = -1039002 #%(T_46_META_WS_P_DESCRIPTION)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
    CountDownBaseTimeS : Int = -1039003 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    DurationTimeS : Int = -1039004 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICardSelectionPanel\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ChooseCardHud : InternalHud = 1040 { #%(T_46_META_WS_C_UICARDSELECTIONPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1040000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1040001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=CountDownKey\r
    CountDownKey : String = -1040002 #%(T_46_META_WS_P_COUNTDOWNKEY)\r
	@ApiLevel=4\r
	@ScriptName=CountDownTime\r
    CountDownTimeS : Int = -1040003 #%(T_46_META_WS_P_COUNTDOWNTIME)\r
	@ApiLevel=4\r
	@ScriptName=DescriptionKey\r
    DescriptionKey : String = -1040004 #%(T_46_META_WS_P_DESCRIPTIONKEY)\r
	@ApiLevel=4\r
	@ScriptName=DescriptionParams\r
    DescriptionParams : List = -1040005 #%(T_46_META_WS_P_DESCRIPTIONPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=ItemBackgrounds\r
    ItemBGSprites : ListT_String = -1040006 #%(T_46_META_WS_P_ITEMBACKGROUNDS)\r
	@ApiLevel=4\r
	@ScriptName=ItemBackgroundColors\r
    ItemBGColors : ListT_Color = -1040007 #%(T_46_META_WS_P_ITEMBACKGROUNDCOLORS)\r
	@ApiLevel=4\r
	@ScriptName=ItemIcons\r
    ItemIconSprites : ListT_String = -1040008 #%(T_46_META_WS_P_ITEMICONS)\r
	@ApiLevel=4\r
	@ScriptName=ItemNames\r
    ItemNames : ListT_String = -1040009 #%(T_46_META_WS_P_ITEMNAMES)\r
	@ApiLevel=4\r
	@ScriptName=ItemDescriptions\r
    ItemDescs : ListT_String = -1040010 #%(T_46_META_WS_P_ITEMDESCRIPTIONS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=SelectedIndex\r
    SelectItemIndex : Int = -1040011 #%(T_46_META_WS_P_SELECTEDINDEX)\r
	@ApiLevel=4\r
	@ScriptName=ButtonNames\r
    ButtonNames : ListT_String = -1040012 #%(T_46_META_WS_P_BUTTONNAMES)\r
	@ApiLevel=4\r
	@ScriptName=ButtonColors\r
    ButtonColors : ListT_Color = -1040013 #%(T_46_META_WS_P_BUTTONCOLORS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIIdentityNotification\r
@ModuleID=31\r
@ModuleLib=Hud\r
type IdentityNotifyHud : InternalHud = 1041 { #%(T_46_META_WS_C_UIIDENTITYNOTIFICATION)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1041000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1041001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
    Position : Vector3 = -1041002 #%(T_46_META_WS_P_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    IconSprite : String = -1041003 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=Label\r
    Label : String = -1041004 #%(T_46_META_WS_P_LABEL)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundColor\r
    BGColor : Color = -1041005 #%(T_46_META_WS_P_BACKGROUNDCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICountDown5\r
@ModuleID=31\r
@ModuleLib=Hud\r
type FiveSecondCountDownHud : InternalHud = 1042 { #%(T_46_META_WS_C_UICOUNTDOWN5)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1042000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    LocalPosition : Vector3 = -1042001 #%(T_46_META_WS_P_LOCALPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITitleBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TitleBannerHud : InternalHud = 1043 { #%(T_46_META_WS_C_UITITLEBANNER)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1043000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -1043001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    LocalPosition : Vector3 = -1043002 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=FontSize\r
    FontSize : Int = -1043003 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=FontColor\r
    Color : Int = -1043004 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=LabelKey\r
    LabelKey : String = -1043005 #%(T_46_META_WS_P_LABELKEY)\r
	@ApiLevel=4\r
	@ScriptName=LabelParams\r
    LabelParams : List = -1043006 #%(T_46_META_WS_P_LABELPARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIBuiltInSwitch\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CommonHudSwitchHud : InternalHud = 1044 { #%(T_46_META_WS_C_UIBUILTINSWITCH)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1044000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowCrouch\r
    CrouchSwitch : Bool = -1044001 #%(T_46_META_WS_P_SHOWCROUCH)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowProne\r
    CreepSwitch : Bool = -1044002 #%(T_46_META_WS_P_SHOWPRONE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowJump\r
    JumpSwitch : Bool = -1044003 #%(T_46_META_WS_P_SHOWJUMP)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowFire\r
    FireSwitch : Bool = -1044004 #%(T_46_META_WS_P_SHOWFIRE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowMovingJoystick\r
    MovingJoystickSwitch : Bool = -1044005 #%(T_46_META_WS_P_SHOWMOVINGJOYSTICK)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowTeammatesInfo\r
    TeammatesInfoSwitch : Bool = -1044006 #%(T_46_META_WS_P_SHOWTEAMMATESINFO)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowAttackGrenade\r
    AttackGrenadeSwitch : Bool = -1044007 #%(T_46_META_WS_P_SHOWATTACKGRENADE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowDefenceGrenade\r
    DefenceGrenadeSwitch : Bool = -1044008 #%(T_46_META_WS_P_SHOWDEFENCEGRENADE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowSprint\r
    SpeedupSwitch : Bool = -1044009 #%(T_46_META_WS_P_SHOWSPRINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISkillButton\r
@ModuleID=31\r
@ModuleLib=Hud\r
type SkillButtonHud : InternalHud = 1045 { #%(T_46_META_WS_C_UISKILLBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -1045000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
    Name : String = -1045001 #Name\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    IconSprite : String = -1045002 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=IconColor\r
    IconColor : Color = -1045003 #%(T_46_META_WS_P_ICONCOLOR)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=Size\r
    Size : Int = -1045004 #%(T_46_META_WS_P_SIZE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    LocalPosition : Vector3 = -1045005 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Count\r
    Count : Int = -1045006 #%(T_46_META_WS_P_COUNT)\r
	@ApiLevel=4\r
	@ScriptName=BaseTime\r
    CDStartTime : Int = -1045007 #%(T_46_META_WS_P_BASETIME)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    CDDurationTime : Int = -1045008 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=IsGrey\r
    Grey : Bool = -1045009 #%(T_46_META_WS_P_ISGREY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIHeartbeat\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HeartbeatHud : InternalHud = 82 { #%(T_46_META_WS_C_UIHEARTBEAT)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -82000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    IconSprite : String = -82001 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=IconColor\r
    IconColor : Color = -82002 #%(T_46_META_WS_P_ICONCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    LocalPosition : Vector3 = -82003 #%(T_46_META_WS_P_LOCALPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIProgressBar\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ProgressbarHud : InternalHud = 120 { #%(T_46_META_WS_C_UIPROGRESSBAR)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -120000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -120001 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -120002 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Length\r
    HUDLength : Int = -120003 #%(T_46_META_WS_P_LENGTH)\r
	@ApiLevel=4\r
	@ScriptName=CurrentValue\r
    CurrentValue : Float = -120004 #%(T_46_META_WS_P_CURRENTVALUE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -120005 #%(T_46_META_WS_P_OFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIHealthBar\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HPbarHud : InternalHud = 126 { #%(T_46_META_WS_C_UIHEALTHBAR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -126000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Name\r
    ObjectName : String = -126001 #%(T_46_META_WS_P_NAME)\r
	@ApiLevel=4\r
	@ScriptName=CurrentValue\r
    CurrentValue : Int = -126002 #%(T_46_META_WS_P_CURRENTVALUE)\r
	@ApiLevel=4\r
	@ScriptName=MaxValue\r
    MaxValue : Int = -126003 #%(T_46_META_WS_P_MAXVALUE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -126004 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=387\r
	@ScriptName=Length\r
    Length : Int = -126005 #%(T_46_META_WS_P_LENGTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIVFXHeartbeat\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HeartbeatEffectHud : InternalHud = 254 { #%(T_46_META_WS_C_UIHEARTBEAT)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -254000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=PlaySpeed\r
    PlaySpeed : Float = -254001 #%(T_46_META_WS_P_PLAYSPEED)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -254002 #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentIcon_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentIcon : Entity = 35 { #%(T_34_WT_WS_ICONENTITY_PARAM1)\r
	@ApiLevel=4\r
	@ScriptName=IconResID\r
    IconType : SpriteID = -35000 #%(T_34_WT_WS_ICONENTITY_PARAM2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -35001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ScaleDiscarded\r
    Scale : Float = -35002 #%(T_34_WT_WS_ICONENTITY_PARAM4)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -35003 #%(T_34_WT_WS_ICONENTITY_PARAM5)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -35004 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsIgnoreDepth\r
    IgnoreDepth : Bool = -35005 #%(T_34_WT_WS_ICONENTITY_PARAM7)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAlwaysInScreen\r
    AlwaysInScreen : Bool = -35006 #%(T_34_WT_WS_ICONENTITY_PARAM8)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
    IsBillboard : Bool = -35007 #%(T_36_WZY_WS_FACECAMERA)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
    Rotator : Vector3 = -35008 #%(T_36_WZY_WS_EULERANGLE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
    ScaleVector : Vector3 = -35009 #%(T_36_WZY_WS_3DZOOM)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentText_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentText : Entity = 36 { #%(T_34_WT_WS_TXTENTITY_PARAM1)\r
	@ApiLevel=4\r
	@ScriptName=TextKey\r
    TextKey : String = -36000 #%(T_34_WT_WS_TXTENTITY_PARAM2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -36001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ScaleDiscarded\r
    Scale : Float = -36002 #%(T_34_WT_WS_ICONENTITY_PARAM4)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -36003 #%(T_34_WT_WS_ICONENTITY_PARAM5)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -36004 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@ScriptName=IsIgnoreDepth\r
    IgnoreDepth : Bool = -36005 #%(T_34_WT_WS_ICONENTITY_PARAM7)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
    IsBillboard : Bool = -36006 #%(T_36_WZY_WS_FACECAMERA)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
    Rotator : Vector3 = -36007 #%(T_36_WZY_WS_EULERANGLE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
    ScaleVector : Vector3 = -36008 #%(T_36_WZY_WS_3DZOOM)\r
	@ApiLevel=4\r
	@Default=16\r
	@ScriptName=FontSize\r
    FontSize : Int = -36009 #%(T_40_WZY_WS_PRESENTTXT_FONTSIZE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentEffect_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentEffect : Entity = 37 { #%(T_34_WT_WS_VFXENTITY_PARAM1)\r
	@ApiLevel=4\r
	@ScriptName=EffectResID\r
    EffectType : EffectType = -37000 #%(T_34_WT_WS_ICONENTITY_PARAM2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -37001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ScaleDiscarded\r
    Scale : Float = -37002 #%(T_34_WT_WS_ICONENTITY_PARAM4)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -37003 #%(T_34_WT_WS_ICONENTITY_PARAM5)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -37004 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
    Rotator : Vector3 = -37005 #%(T_36_WZY_WS_EULERANGLE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
    ScaleVector : Vector3 = -37006 #%(T_36_WZY_WS_3DZOOM)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=PlaySpeed\r
    PlaySpeed : Int = -37007 #%(T_38_WZY_WS_PLAYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=PresentEffectTextureType\r
    PresentEffectTexType : TextureID = -37008 #%(T_38_WZY_WS_PARTICALMAP)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseAlpha\r
    DiffuseAlpha : Int = -37009 #%(T_39_WZY_WS_DIFFUSEALPHA)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=VFXReplaceTextPresent\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type ReplaceTexPresentEffect : Entity = 167 { #%(T_46_META_WS_C_VFXREPLACETEXTPRESENT)\r
	@ApiLevel=4\r
	@ScriptName=VFXTextureType\r
    VFXTexture : TextureID = -167000 #%(T_46_META_WS_P_VFXTEXTURETYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentEffectTextureType_Deprecated\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum PresentEffectTexType : TextureID = 168 { #%(T_46_META_WS_C_PRESENTEFFECTTEXTURETYPE_DEPRECATED)\r
	@ApiLevel=4\r
	@ScriptName=Lightning\r
    Lightning = VFX_2X2_Lightning003_BJ #%(T_46_META_WS_E_LIGHTNING)\r
	@ApiLevel=4\r
	@ScriptName=Air\r
    Air = VFX_Air_A #%(T_46_META_WS_E_AIR)\r
	@ApiLevel=4\r
	@ScriptName=Bubble\r
    Bubble = VFX_Bubble001 #%(T_46_META_WS_E_BUBBLE)\r
	@ApiLevel=4\r
	@ScriptName=Circle\r
    Circle = WS_VFX_Circle002_A #%(T_46_META_WS_E_CIRCLE)\r
	@ApiLevel=4\r
	@ScriptName=Darkness\r
    Darkness = VFX_Darkness_Trail001_BJ #%(T_46_META_WS_E_DARKNESS)\r
	@ApiLevel=4\r
	@ScriptName=Feather\r
    Feather = WS_VFX_Feather006_A #%(T_46_META_WS_E_FEATHER)\r
	@ApiLevel=4\r
	@ScriptName=Fire\r
    Fire = WS_VFX_Fire001_A #%(T_46_META_WS_E_FIRE)\r
	@ApiLevel=4\r
	@ScriptName=Flower\r
    Flower = WS_VFX_Flower001_A #%(T_46_META_WS_E_FLOWER)\r
	@ApiLevel=4\r
	@ScriptName=Ghost\r
    Ghost = VFX_Ghost001 #%(T_46_META_WS_E_GHOST)\r
	@ApiLevel=4\r
	@ScriptName=Gunfire\r
    Gunfire = VFX_Gunfire001 #%(T_46_META_WS_E_GUNFIRE)\r
	@ApiLevel=4\r
	@ScriptName=Line\r
    Line = VFX_Line001 #%(T_46_META_WS_E_LINE)\r
	@ApiLevel=4\r
	@ScriptName=Liquid\r
    Liquid = WS_VFX_Liquid011 #%(T_46_META_WS_E_LIQUID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidget\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudWidget : Entity = 13 { #%(T_46_META_WS_C_UIWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=IsVisible\r
    ActiveSelf : Bool = -13000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=AnchorPosition\r
    AnchorPosition : Vector3 = -13001 #%(T_46_META_WS_P_ANCHORPOSITION)\r
	@ApiLevel=10\r
	@ScriptName=Width\r
    Width : Int = -13002 #%(T_46_META_WS_P_WIDTH)\r
	@ApiLevel=10\r
	@ScriptName=Height\r
    Height : Int = -13003 #%(T_46_META_WS_P_HEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Angle\r
    Angle : Float = -13004 #%(T_46_META_WS_P_ANGLE)\r
	@ApiLevel=10\r
	@ScriptName=HostHudID_Deprecated\r
    get HostHudEntityID : String = -13005 #HostHudEntityID\r
	@ApiLevel=3\r
	@ScriptName=FileID\r
    get FileID : Int = -13006 #%(T_46_META_WS_P_FILEID)\r
	@ApiLevel=4\r
	@ScriptName=ParentUI\r
    get HostHudEntity : CustomHud = -13007 #%(T_46_META_WS_P_PARENTUI)\r
	@ApiLevel=4\r
	@ScriptName=AnchorMin\r
    AnchorMin : Vector2 = -13008 #%(T_46_META_WS_P_ANCHORMIN)\r
	@ApiLevel=4\r
	@ScriptName=AnchorMax\r
    AnchorMax : Vector2 = -13009 #%(T_46_META_WS_P_ANCHORMAX)\r
	@ApiLevel=4\r
	@ScriptName=SizeDelta\r
    SizeDelta : Vector2 = -13010 #%(T_46_META_WS_P_SIZEDELTA)\r
	@ApiLevel=4\r
	@ScriptName=Pivot\r
    Pivot : Vector2 = -13011 #%(T_46_META_WS_P_PIVOT)\r
	@ApiLevel=3\r
	@ScriptName=Depth\r
    get Depth : Int = -13012 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=10\r
	@ScriptName=ParentWidgetFileID_Deprecated\r
    get ParentWidgetFileID : Int = -13013 #ParentWidgetFileID\r
	@ApiLevel=4\r
	@ScriptName=ChildIndex\r
    get ChildIndex : Int = -13014 #%(T_46_META_WS_P_CHILDINDEX)\r
	@ApiLevel=3\r
	@ScriptName=ParentWidgetEntityID\r
    get ParentEntityID : String = -13015 #%(T_46_META_WS_P_PARENTWIDGETENTITYID)\r
	@ApiLevel=3\r
    get UniqueID : String = -13016 #UniqueID\r
	@ApiLevel=4\r
	@ScriptName=Priority\r
    Priority : Int = -13017 #%(T_46_META_WS_P_PRIORITY)\r
	@ApiLevel=4\r
	@ScriptName=ActualPosition\r
    ActualPosition : Vector3 = -13018 #%(T_46_META_WS_P_ACTUALPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=Size\r
    Size : Vector2 = -13019 #%(T_52_META_TYP_13_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomUIOrWidget\r
@ModuleID=16\r
@ModuleLib=Hud\r
alias HudWidgetOrCustomHud : Object&(HudWidget|CustomHud) = 391 #%(T_46_META_WS_C_CUSTOMUIORWIDGET)\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetEmpty\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudEmptyWidget : HudWidget = 38 { #%(T_46_META_WS_C_UIWIDGETEMPTY)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -38000 #%(T_46_META_WS_P_ALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetImage\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudImageWidget : HudWidget = 39 { #%(T_46_META_WS_C_UIWIDGETIMAGE)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
    Color : Color = -39000 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=SpriteName\r
    SpriteName : SpriteID = -39001 #%(T_46_META_WS_P_SPRITENAME)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -39002 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=Flip\r
    SpriteFlip : Int = -39003 #%(T_46_META_WS_P_FLIP)\r
	@ApiLevel=4\r
	@ScriptName=Fill\r
    SpriteType : FillType = -39004 #%(T_46_META_WS_P_FILL)\r
	@ApiLevel=4\r
	@ScriptName=CenterInvisible\r
    CenterInvisible : Bool = -39005 #%(T_46_META_WS_P_CENTERINVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
    FillDir : FillDir = -39006 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=FillAmount\r
    FillAmount : Float = -39007 #%(T_46_META_WS_P_FILLAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=InvertFill\r
    InvertFill : Bool = -39008 #%(T_46_META_WS_P_INVERTFILL)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
    Gradient : Int = -39009 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@ScriptName=GradientTop\r
    GradientTop : Color = -39010 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@ScriptName=GradientBottom\r
    GradientBottom : Color = -39011 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=TopAlpha\r
    GradientTopAlpha : Float = -39012 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=BottomAlpha\r
    GradientBottomAlpha : Float = -39013 #%(T_46_META_WS_P_BOTTOMALPHA)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsApplyAnimation\r
    IsApplyAnimation : Bool = -39014 #%(T_54_META_TYP_39_I14)\r
	@ApiLevel=4\r
	@ScriptName=AtlasID\r
    AtlasID : AtlasID = -39015 #%(T_54_META_TYP_39_I15)\r
	@ApiLevel=4\r
	@Default=30\r
	@ScriptName=FrameRate\r
    FrameRate : Int = -39016 #%(T_54_META_TYP_39_I16)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=Loop\r
    Loop : Bool = -39017 #%(T_46_META_WS_E_LOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetLabel\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudLabelWidget : HudWidget = 40 { #%(T_46_META_WS_C_UIWIDGETLABEL)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
    Color : Color = -40000 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Content\r
    Text : String = -40001 #%(T_46_META_WS_P_CONTENT)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -40002 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=10\r
	@ScriptName=LocKey\r
    LocKey : String = -40003 #%(T_46_META_WS_P_LOCKEY)\r
	@ApiLevel=4\r
	@ScriptName=FontSize\r
    FontSize : Int = -40004 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentHorizontal\r
    Alignment : Int = -40005 #%(T_46_META_WS_P_ALIGNMENTHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentVertical\r
    AlignmentVertical : Int = -40006 #%(T_46_META_WS_P_ALIGNMENTVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=IsBold\r
    IsBold : Bool = -40007 #%(T_46_META_WS_P_ISBOLD)\r
	@ApiLevel=4\r
	@ScriptName=IsItalic\r
    IsItalic : Bool = -40008 #%(T_46_META_WS_P_ISITALIC)\r
	@ApiLevel=4\r
	@ScriptName=IsUnderline\r
    IsUnderline : Bool = -40009 #%(T_46_META_WS_P_ISUNDERLINE)\r
	@ApiLevel=4\r
	@ScriptName=LineSpacing\r
    LineSpacing : Float = -40010 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@ScriptName=Overflow\r
    Overflow : Int = -40011 #%(T_46_META_WS_P_OVERFLOW)\r
	@ApiLevel=4\r
	@ScriptName=Font\r
    FontType : FontType = -40012 #%(T_46_META_WS_P_FONT)\r
	@ApiLevel=4\r
	@ScriptName=IsApplyShadow\r
    IsApplyShadow : Bool = -40013 #%(T_46_META_WS_P_ISAPPLYSHADOW)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ShadowColor\r
    ShadowColor : Color = -40014 #%(T_46_META_WS_P_SHADOWCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=ShadowOffset\r
    ShadowOffset : Vector2 = -40015 #%(T_46_META_WS_P_SHADOWOFFSET)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ShadowAlpha\r
    ShadowAlpha : Float = -40016 #%(T_54_META_TYP_40_I16)\r
	@ApiLevel=4\r
	@ScriptName=IsApplyOutline\r
    IsApplyOutline : Bool = -40017 #%(T_54_META_TYP_40_I17)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=OutlineColor\r
    OutlineColor : Color = -40018 #%(T_54_META_TYP_40_I18)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=OutlineAlpha\r
    OutlineAlpha : Float = -40019 #%(T_54_META_TYP_40_I19)\r
	@ApiLevel=4\r
	@ScriptName=OutlineOffset\r
    OutlineOffset : Float = -40020 #%(T_54_META_TYP_40_I20)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
    Gradient : Int = -40021 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=GradientTop\r
    GradientTop : Color = -40022 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=GradientBottom\r
    GradientBottom : Color = -40023 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=TopAlpha\r
    GradientTopAlpha : Float = -40024 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=BottomAlpha\r
    GradientBottomAlpha : Float = -40025 #%(T_46_META_WS_P_BOTTOMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetButton\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudButtonWidget : HudWidget = 41 { #%(T_46_META_WS_C_UIWIDGETBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=SpriteResource\r
    SpriteName : SpriteID = -41000 #%(T_46_META_WS_P_SPRITERESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
    Color : Color = -41001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -41002 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=3\r
	@ScriptName=DisableColor\r
    DisableColor : Color = -41003 #%(T_46_META_WS_P_DISABLECOLOR)\r
	@ApiLevel=4\r
	@ScriptName=PressedColor\r
    PressedColor : Color = -41004 #%(T_46_META_WS_P_PRESSEDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=FillType\r
    SpriteType : FillType = -41005 #%(T_46_META_WS_P_FILLTYPE)\r
	@ApiLevel=3\r
	@ScriptName=IsFEButton\r
    get IsFEButton : Bool = -41006 #%(T_46_META_WS_P_ISFEBUTTON)\r
	@ApiLevel=10\r
	@ScriptName=PressedSprite\r
    PressedSprite : SpriteID = -41007 #%(T_46_META_WS_P_PRESSEDSPRITE)\r
	@ApiLevel=10\r
	@Default=-1\r
	@ScriptName=PressedSpriteType\r
    PressedSpriteType : FillType = -41008 #%(T_46_META_WS_P_PRESSEDSPRITETYPE)\r
	@ApiLevel=4\r
	@ScriptName=FlipType\r
    FlipType : Int = -41009 #%(T_46_META_WS_P_FLIPTYPE)\r
	@ApiLevel=4\r
	@ScriptName=CenterInvisible\r
    CenterInvisible : Bool = -41010 #%(T_46_META_WS_P_CENTERINVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
    FillDir : FillDir = -41011 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=FillAmount\r
    FillAmount : Float = -41012 #%(T_46_META_WS_P_FILLAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=InvertFill\r
    InvertFill : Bool = -41013 #%(T_46_META_WS_P_INVERTFILL)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
    Gradient : Int = -41014 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@ScriptName=GradientTop\r
    GradientTop : Color = -41015 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@ScriptName=GradientBottom\r
    GradientBottom : Color = -41016 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=TopAlpha\r
    GradientTopAlpha : Float = -41017 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=BottomAlpha\r
    GradientBottomAlpha : Float = -41018 #%(T_46_META_WS_P_BOTTOMALPHA)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
    DisableCollider : Bool = -41019 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetInputLabel\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudInputWidget : HudWidget = 42 { #%(T_46_META_WS_C_UIWIDGETINPUTLABLE)\r
	@ApiLevel=4\r
	@ScriptName=DefaultText\r
    DefaultText : String = -42000 #%(T_46_META_WS_P_DEFAULTTEXT)\r
	@ApiLevel=4\r
	@ScriptName=ActiveText\r
    ActiveText : String = -42001 #%(T_46_META_WS_P_ACTIVETEXT)\r
	@ApiLevel=4\r
	@ScriptName=FontSize\r
    FontSize : Int = -42002 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentHorizontal\r
    Alignment : Int = -42003 #%(T_46_META_WS_P_ALIGNMENTHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentVertical\r
    AlignmentVertical : Int = -42004 #%(T_46_META_WS_P_ALIGNMENTVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=IsBold\r
    IsBold : Bool = -42005 #%(T_46_META_WS_P_ISBOLD)\r
	@ApiLevel=4\r
	@ScriptName=IsItalic\r
    IsItalic : Bool = -42006 #%(T_46_META_WS_P_ISITALIC)\r
	@ApiLevel=4\r
	@ScriptName=IsUnderline\r
    IsUnderline : Bool = -42007 #%(T_46_META_WS_P_ISUNDERLINE)\r
	@ApiLevel=4\r
	@ScriptName=LineSpacing\r
    LineSpacing : Float = -42008 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@ScriptName=WordWrap\r
    WordWrap : Int = -42009 #%(T_46_META_WS_P_WORDWRAP)\r
	@ApiLevel=4\r
	@ScriptName=MaxLength\r
    MaxLength : Int = -42010 #%(T_46_META_WS_P_MAXLENGTH)\r
	@ApiLevel=10\r
	@ScriptName=TransitionType\r
    get TransitionType : Int = -42011 #%(T_46_META_WS_P_TRANSITIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LabelColor\r
    LabelColor : Color = -42012 #%(T_46_META_WS_P_LABELCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=NormalColor\r
    NormalColor : Color = -42013 #%(T_46_META_WS_P_NORMALCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=PressedColor\r
    PressedColor : Color = -42014 #%(T_46_META_WS_P_PRESSEDCOLOR)\r
	@ApiLevel=10\r
	@ScriptName=DisableColor\r
    DisableColor : Color = -42015 #%(T_46_META_WS_P_DISABLECOLOR)\r
	@ApiLevel=10\r
	@ScriptName=LocKey\r
    LocKey : String = -42016 #%(T_46_META_WS_P_LOCKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetLayout\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudLayout : HudWidget = 294 { #%(T_46_META_WS_C_UIWIDGETLAYOUT)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -294000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=LayoutType\r
    LayoutType : Int = -294001 #%(T_46_META_WS_P_LAYOUTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ContentOrigin\r
    ContentOrigin : Int = -294002 #%(T_46_META_WS_P_CONTENTORIGIN)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
    FillDirection : Int = -294003 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CellSize\r
    CellSize : Vector2 = -294004 #%(T_46_META_WS_P_CELLSIZE)\r
	@ApiLevel=4\r
	@ScriptName=CellSpace\r
    Space : Vector2 = -294005 #%(T_46_META_WS_P_CELLSPACE)\r
	@ApiLevel=4\r
	@ScriptName=Constraint\r
    Constraint : Int = -294006 #%(T_46_META_WS_P_CONSTRAINT)\r
	@ApiLevel=4\r
	@ScriptName=ConstraintCount\r
    ConstraintCount : Int = -294007 #%(T_46_META_WS_P_CONSTRAINTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=VerticalOffset\r
    OffsetUpDown : Vector2 = -294008 #%(T_46_META_WS_P_VERTICALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalOffset\r
    OffsetLeftRight : Vector2 = -294009 #%(T_46_META_WS_P_HORIZONTALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=SortType\r
    SortType : LayoutSortType = -294010 #%(T_46_META_WS_P_SORTTYPE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IgnoreInactive\r
    IgnoreInactive : Bool = -294011 #%(T_54_META_TYP_294_I11)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetTexture\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudTexture : HudWidget = 316 { #%(T_46_META_WS_C_UIWIDGETTEXTURE)\r
	@ApiLevel=4\r
	@ScriptName=TextureResource\r
    TextureName : TextureID = -316000 #%(T_46_META_WS_P_TEXTURERESOURCE)\r
	@ApiLevel=3\r
	@ScriptName=ShaderName\r
    get ShaderName : String = -316001 #%(T_46_META_WS_P_SHADERNAME)\r
	@ApiLevel=4\r
	@ScriptName=UVOffset\r
    UVRectXY : Vector2 = -316002 #%(T_46_META_WS_P_UVOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=UVSize\r
    UVRectWH : Vector2 = -316003 #%(T_46_META_WS_P_UVSIZE)\r
	@ApiLevel=4\r
	@ScriptName=FillType\r
    FillType : FillType = -316004 #%(T_46_META_WS_P_FILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=BorderLR\r
    BorderLR : Vector2 = -316005 #%(T_46_META_WS_P_BORDERLR)\r
	@ApiLevel=4\r
	@ScriptName=BorderTB\r
    BorderTB : Vector2 = -316006 #%(T_46_META_WS_P_BORDERTB)\r
	@ApiLevel=4\r
	@ScriptName=CenterInvisible\r
    CenterInvisible : Bool = -316007 #%(T_46_META_WS_P_CENTERINVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
    FillDir : FillDir = -316008 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=FillAmount\r
    FillAmount : Float = -316009 #%(T_46_META_WS_P_FILLAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=InvertFill\r
    InvertFill : Bool = -316010 #%(T_46_META_WS_P_INVERTFILL)\r
	@ApiLevel=4\r
	@ScriptName=FlipType\r
    Flip : Int = -316011 #%(T_46_META_WS_P_FLIPTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
    Color : Color = -316012 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
    Gradient : Int = -316013 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@ScriptName=GradientTop\r
    GradientTop : Color = -316014 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@ScriptName=GradientBottom\r
    GradientBottom : Color = -316015 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -316016 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=TopAlpha\r
    GradientTopAlpha : Float = -316017 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@ScriptName=BottomAlpha\r
    GradientBottomAlpha : Float = -316018 #%(T_46_META_WS_P_BOTTOMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetProfile\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudProfileInfo : HudWidget = 323 { #%(T_46_META_WS_C_UIWIDGETPROFILE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
    Scale : Vector3 = -323000 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=AccountID\r
    AccountID : UUID = -323001 #%(T_46_META_WS_P_ACCOUNTID)\r
	@ApiLevel=3\r
	@ScriptName=ProfileInfo\r
    get ProfileInfo : ProfileInfo = -323002 #%(T_46_META_WS_P_PROFILEINFO)\r
	@ApiLevel=4\r
	@ScriptName=Style\r
    get ShowType : Int = -323003 #%(T_46_META_WS_P_STYLE)\r
	@ApiLevel=4\r
	@ScriptName=ShowRank\r
    get ShowRank : Int = -323004 #%(T_46_META_WS_P_SHOWRANK)\r
	@ApiLevel=4\r
	@ScriptName=ShowPin\r
    get ShowPin : Bool = -323005 #%(T_46_META_WS_P_SHOWPIN)\r
	@ApiLevel=4\r
	@ScriptName=ShowName\r
    get ShowName : Bool = -323006 #%(T_46_META_WS_P_SHOWNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetToggle\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudToggle : HudWidget = 352 { #%(T_46_META_WS_C_UIWIDGETTOGGLE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=Alpha\r
    Alpha : Float = -352000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=UnselectedSprite\r
    UnSelectedSprite : SpriteID = -352001 #%(T_46_META_WS_P_UNSELECTEDSPRITE)\r
	@ApiLevel=4\r
	@ScriptName=UnselectedType\r
    UnSelectedType : FillType = -352002 #%(T_46_META_WS_P_UNSELECTEDTYPE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=UnselectedColor\r
    UnSelectedColor : Color = -352003 #%(T_46_META_WS_P_UNSELECTEDCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=SelectedSprite\r
    SelectedSprite : SpriteID = -352004 #%(T_46_META_WS_P_SELECTEDSPRITE)\r
	@ApiLevel=4\r
	@ScriptName=SelectedType\r
    SelectedType : FillType = -352005 #%(T_46_META_WS_P_SELECTEDTYPE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SelectedColor\r
    SelectedColor : Color = -352006 #%(T_46_META_WS_P_SELECTEDCOLOR)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
    DisableCollider : Bool = -352007 #%(T_48_META_TYP_41_I19)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Value\r
    Value : Bool = -352008 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetTouchPad\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudTouchPad : HudWidget = 387 { #%(T_46_META_WS_C_UIWIDGETTOUCHPAD)\r
	@ApiLevel=4\r
	@Default=0.2\r
	@ScriptName=Alpha\r
    Alpha : Float = -387000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=AllowPressedOutside\r
    AllowPressedOutside : Bool = -387001 #%(T_46_META_WS_P_ALLOWPRESSEDOUTSIDE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
    DisableCollider : Bool = -387002 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetJoystick\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudJoystick : HudWidget = 389 { #%(T_46_META_WS_C_UIWIDGETJOYSTICK)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundOffset\r
    Offset : Vector2 = -389000 #%(T_46_META_WS_P_BACKGROUNDOFFSET)\r
	@ApiLevel=4\r
	@Default=UI_move_bg\r
	@ScriptName=BackgroundSprite\r
    BackGroundImage : SpriteID = -389001 #%(T_46_META_WS_P_BACKGROUNDSPRITE)\r
	@ApiLevel=4\r
	@Default=91\r
	@ScriptName=BackgroundRadius\r
    BackGroundRadius : Int = -389002 #%(T_46_META_WS_P_BACKGROUNDRADIUS)\r
	@ApiLevel=4\r
	@Default=UI_move_bt\r
	@ScriptName=JoystickImage\r
    JoystickCapImage : SpriteID = -389003 #%(T_46_META_WS_P_JOYSTICKIMAGE)\r
	@ApiLevel=4\r
	@Default=27\r
	@ScriptName=JoystickRadius\r
    JoystickCapRadius : Int = -389004 #%(T_46_META_WS_P_JOYSTICKRADIUS)\r
	@ApiLevel=4\r
	@Default=58\r
	@ScriptName=JoystickDragRadius\r
    JoystickCapDragRadius : Int = -389005 #%(T_46_META_WS_P_JOYSTICKDRAGRADIUS)\r
	@ApiLevel=4\r
	@Default=UI_move_bt01\r
	@ScriptName=ArrowSprite\r
    ArrowImage : SpriteID = -389006 #%(T_46_META_WS_P_ARROWSPRITE)\r
	@ApiLevel=4\r
	@Default=&math.Vector2(70, 24)\r
	@ScriptName=ArrowSize\r
    ArrowSize : Vector2 = -389007 #%(T_46_META_WS_P_ARROWSIZE)\r
	@ApiLevel=4\r
	@Default=98\r
	@ScriptName=ArrowOffset\r
    ArrowOffset : Int = -389008 #%(T_46_META_WS_P_ARROWOFFSET)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ActivatedAlpha\r
    ActivatedAlpha : Float = -389009 #%(T_46_META_WS_P_ACTIVATEDALPHA)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=InactivatedAlpha\r
    InactivatedAlpha : Float = -389010 #%(T_46_META_WS_P_INACTIVATEDALPHA)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
    DisableCollider : Bool = -389011 #%(T_48_META_TYP_41_I19)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPanel\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudPanel : HudWidget = 265 { #%(T_46_META_WS_C_UIPANEL)\r
	@ApiLevel=4\r
	@ScriptName=Alpha\r
    Alpha : Float = -265000 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundFill\r
    BgFill : Bool = -265001 #%(T_46_META_WS_P_BACKGROUNDFILL)\r
	@ApiLevel=3\r
	@ScriptName=BackgroundName\r
    BgName : SpriteID = -265002 #%(T_46_META_WS_P_BACKGROUNDNAME)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundColor\r
    BgColor : Color = -265003 #%(T_46_META_WS_P_BACKGROUNDCOLOR)\r
	@ApiLevel=10\r
	@ScriptName=BackgroundSizeDelta\r
    get BgSizeDelta : Vector2 = -265004 #%(T_46_META_WS_P_BACKGROUNDSIZEDELTA)\r
	@ApiLevel=4\r
	@ScriptName=BackgroundAlpha\r
    BgAlpha : Float = -265005 #%(T_46_META_WS_P_BACKGROUNDALPHA)\r
	@ApiLevel=4\r
	@ScriptName=ClippingType\r
    ClippingType : Int = -265006 #%(T_46_META_WS_P_CLIPPINGTYPE)\r
	@ApiLevel=4\r
	@ScriptName=MaskName\r
    MaskName : String = -265007 #%(T_46_META_WS_P_MASKNAME)\r
	@ApiLevel=4\r
	@ScriptName=Softness\r
    Softness : Vector2 = -265008 #%(T_46_META_WS_P_SOFTNESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIPanelEmpty\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudEmptyPanel : HudPanel = 271 { #%(T_46_META_WS_C_UIPANELEMPTY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Grid\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudGrid : HudPanel = 266 { #%(T_46_META_WS_C_GRID)\r
	@ApiLevel=4\r
	@ScriptName=LayoutType\r
    LayoutType : Int = -266000 #%(T_46_META_WS_P_LAYOUTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ContentOrigin\r
    ContentOrigin : Int = -266001 #%(T_46_META_WS_P_CONTENTORIGIN)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
    FillDirection : Int = -266002 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CellSize\r
    CellSize : Vector2 = -266003 #%(T_46_META_WS_P_CELLSIZE)\r
	@ApiLevel=4\r
	@ScriptName=CellSpace\r
    Space : Vector2 = -266004 #%(T_46_META_WS_P_CELLSPACE)\r
	@ApiLevel=4\r
	@ScriptName=Constraint\r
    Constraint : Int = -266005 #%(T_46_META_WS_P_CONSTRAINT)\r
	@ApiLevel=4\r
	@ScriptName=ConstraintCount\r
    ConstraintCount : Int = -266006 #%(T_46_META_WS_P_CONSTRAINTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=VerticalOffset\r
    OffsetUpDown : Vector2 = -266007 #%(T_46_META_WS_P_VERTICALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalOffset\r
    OffsetLeftRight : Vector2 = -266008 #%(T_46_META_WS_P_HORIZONTALOFFSET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIScrollPanel\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudScrollView : HudPanel = 267 { #%(T_46_META_WS_C_UISCROLLPANEL)\r
	@ApiLevel=4\r
	@ScriptName=ContentOrigin\r
    ContentOrigin : Int = -267000 #%(T_46_META_WS_P_CONTENTORIGIN)\r
	@ApiLevel=4\r
	@ScriptName=ScrollDirection\r
    ScrollDirection : Int = -267001 #%(T_46_META_WS_P_SCROLLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CustomXY\r
    CustomXY : Vector2 = -267002 #%(T_46_META_WS_P_CUSTOMXY)\r
	@ApiLevel=4\r
	@ScriptName=ScrollEffect\r
    DragEffect : Int = -267003 #%(T_46_META_WS_P_SCROLLEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=ScrollWheelSpeed\r
    ScrollWheelFactor : Float = -267004 #%(T_46_META_WS_P_SCROLLWHEELSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScrollContinuity\r
    MomentumAmount : Float = -267005 #%(T_46_META_WS_P_SCROLLCONTINUITY)\r
	@ApiLevel=4\r
	@ScriptName=RestrictWithinPanel\r
    RestrictWithinPanel : Bool = -267006 #%(T_46_META_WS_P_RESTRICTWITHINPANEL)\r
	@ApiLevel=4\r
	@ScriptName=SmoothScrollStart\r
    SmoothDragStart : Bool = -267007 #%(T_46_META_WS_P_SMOOTHSCROLLSTART)\r
	@ApiLevel=4\r
	@ScriptName=CancelDragIfFits\r
    CancelDragIfFits : Bool = -267008 #%(T_46_META_WS_P_CANCELDRAGIFFITS)\r
	@ApiLevel=4\r
	@ScriptName=VerticalBar\r
    VerticalBar : Int = -267009 #%(T_46_META_WS_P_VERTICALBAR)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalBar\r
    HorizontalBar : Int = -267010 #%(T_46_META_WS_P_HORIZONTALBAR)\r
	@ApiLevel=3\r
    ShowPosition : Vector2 = -267011 #ShowPosition\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=DisableCollider\r
    DisableCollider : Bool = -267012 #%(T_48_META_TYP_41_I19)\r
	@ApiLevel=4\r
	@ScriptName=VerticalScrollAmount\r
    VerticalScrollAmount : Float = -267013 #%(T_52_META_TYP_267_I13)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalScrollAmount\r
    HorizontalScrollAmount : Float = -267014 #%(T_52_META_TYP_267_I14)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=HudTransform_Deprecated\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudTransform : Entity = 299 { #%(T_46_META_WS_C_HUDTRANSFORM_DEPRECATED)\r
	@ApiLevel=4\r
	@ScriptName=Active\r
    ActiveSelf : Bool = -299000 #%(T_46_META_WS_P_ACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=AnchorPosition\r
    AnchorPosition : Vector3 = -299001 #%(T_46_META_WS_P_ANCHORPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=Angle\r
    Angle : Float = -299002 #%(T_46_META_WS_P_ANGLE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
    Scale : Vector3 = -299003 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=3\r
	@ScriptName=FileID\r
    get FileID : Int = -299004 #%(T_46_META_WS_P_FILEID)\r
	@ApiLevel=4\r
	@ScriptName=ParentUI\r
    get HostHudEntity : CustomHud = -299005 #%(T_46_META_WS_P_PARENTUI)\r
	@ApiLevel=3\r
	@ScriptName=Depth\r
    get Depth : Int = -299006 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=3\r
	@ScriptName=ParentWidgetFileID\r
    get ParentWidgetFileID : Int = -299007 #%(T_46_META_WS_P_PARENTWIDGETFILEID)\r
	@ApiLevel=4\r
	@ScriptName=ChildIndex\r
    get ChildIndex : Int = -299008 #%(T_46_META_WS_P_CHILDINDEX)\r
	@ApiLevel=3\r
	@ScriptName=ParentID\r
    get ParentEntityID : String = -299009 #%(T_46_META_WS_P_PARENTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIWidgetContainer\r
@ModuleID=16\r
@ModuleLib=Hud\r
type Hud3DContainer : HudWidget = 300 { #%(T_46_META_WS_C_UIWIDGETCONTAINER)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
    ResourceID : String = -300000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
    Scale : Vector3 = -300001 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=Rotation\r
    Rotation : Vector3 = -300002 #%(T_46_META_WS_P_ROTATION)\r
	@ApiLevel=4\r
	@ScriptName=CreatedEntity\r
    get PrefabEntity : Entity = -300003 #%(T_46_META_WS_P_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Turret\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type UGCMinisentry : LevelObject&FightingEntity&ResetableEntity&Collider = 2507 { #%(T_46_META_WS_C_TURRET)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TeamSeq\r
    TeamID : Int = -2507000 #%(T_46_META_WS_P_TEAMSEQ)\r
	@ApiLevel=4\r
	@Default=200\r
	@ScriptName=HP\r
    HP : Int = -2507001 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@Default=200\r
	@ScriptName=MaxHP\r
    MaxHP : Int = -2507002 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Damage\r
    Attack : Int = -2507003 #%(T_46_META_WS_P_DAMAGE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=AttackInterval\r
    AttackInterval : Float = -2507004 #%(T_46_META_WS_P_ATTACKINTERVAL)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=AttackRange\r
    AttackRange : MinisentryAttackRangeType = -2507005 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@Default=0.01\r
	@ScriptName=Defense\r
    Defense : Float = -2507006 #%(T_46_META_WS_P_DEFENSE)\r
	@ApiLevel=3\r
	@ScriptName=Target\r
    get Target : Int = -2507007 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=3\r
	@ScriptName=RotationAngle\r
    get Rot_Angles : Int = -2507008 #%(T_46_META_WS_P_ROTATIONANGLE)\r
	@ApiLevel=3\r
	@ScriptName=Status\r
    get Status : Int = -2507009 #%(T_46_META_WS_P_STATUS)\r
	@ApiLevel=3\r
	@ScriptName=ObjectID\r
    get ObjectID : Int = -2507010 #%(T_46_META_WS_P_OBJECTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpawnPosition\r
@ModuleID=10\r
@ModuleLib=LevelObject\r
type SpawnPos : LevelObject = 2500 { #%(T_46_META_WS_C_SPAWNPOSITION)\r
	@ApiLevel=10\r
	@ScriptName=AvailablePosition_Deprecated\r
    get AvailablePos : DirectedPoint = -2500000 #AvailablePos\r
	@ApiLevel=4\r
	@ScriptName=IsDefaultSpawnPoint\r
    get IsDefault : Bool = -2500001 #%(T_46_META_WS_P_ISDEFAULTSPAWNPOINT)\r
	@ApiLevel=10\r
	@ScriptName=DynamicCollider_Deprecated\r
    get DynamicCollider : LevelObject = -2500002 #DynamicCollider\r
	@ApiLevel=4\r
	@ScriptName=IsOccupied\r
    get IsOccupied : Bool = -2500003 #%(T_46_META_WS_P_ISOCCUPIED)\r
	@ApiLevel=4\r
	@ScriptName=AvailablePoint\r
    get AvailablePosVec3 : Vector3 = -2500004 #%(T_46_META_WS_P_AVAILABLEPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomizeTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CustomizeTrigger : LevelObject&Collider = 2501 { #%(T_46_META_WS_C_CUSTOMIZETRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DeathOrInvincibilityTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type KillOrGodZoneTrigger : CustomizeTrigger = 2502 { #%(T_46_META_WS_C_DEATHORINVINCIBILITYTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=IsDeathTrigger\r
    IsKillZone : Bool = -2502000 #%(T_46_META_WS_P_ISDEATHTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=IsShow\r
    ShowOrHide : Bool = -2502001 #%(T_46_META_WS_P_IS SHOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CheckPointTrigger\r
@ModuleID=13\r
@ModuleLib=CheckPoint\r
type CheckPointTrigger : CustomizeTrigger = 2503 { #%(T_46_META_WS_C_CHECKPOINTTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CheckpointID\r
    get ID : Int = -2503000 #%(T_46_META_WS_P_CHECKPOINTID)\r
	@ApiLevel=10\r
	@ScriptName=DirectPosition_Deprecated\r
    get DirectPos : DirectedPoint = -2503001 #DirectPos\r
	@ApiLevel=4\r
	@ScriptName=PointPosition\r
    get DirectPosVec3 : Vector3 = -2503002 #%(T_46_META_WS_P_POINTPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EndPointTrigger\r
@ModuleID=13\r
@ModuleLib=CheckPoint\r
type EndPointTrigger : CustomizeTrigger = 2504 { #%(T_46_META_WS_C_ENDPOINTTRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DynamicFence\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DynamicCollider : LevelObject = 2505 { #%(T_46_META_WS_C_DYNAMICFENCE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SupplyBoxTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type SupplyBoxTrigger : CustomizeTrigger = 2506 { #%(T_46_META_WS_C_SUPPLYBOXTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=Model\r
    Model : Int = -2506000 #%(T_46_META_WS_P_MODEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterSpawn\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BotGenerator : LevelObject&SpawnableEntity&ResetableEntity = 2508 { #%(T_46_META_WS_C_MONSTERSPAWN)\r
	@ApiLevel=4\r
	@ScriptName=CountPerWave\r
    CountEachBatch : Int = -2508000 #%(T_46_META_WS_P_COUNTPERWAVE)\r
	@ApiLevel=4\r
	@ScriptName=WaveCount\r
    BatchCount : Int = -2508001 #%(T_46_META_WS_P_WAVECOUNT)\r
	@ApiLevel=4\r
	@ScriptName=IsContinuous\r
    IsContinuous : Bool = -2508002 #%(T_46_META_WS_P_ISCONTINUOUS)\r
	@ApiLevel=4\r
	@ScriptName=CurrentWave\r
    CurBatch : Int = -2508003 #%(T_46_META_WS_P_CURRENTWAVE)\r
	@ApiLevel=10\r
	@ScriptName=WaveInterval_Deprecated\r
    BatchInterval : Int = -2508004 #BatchInterval\r
	@ApiLevel=4\r
	@ScriptName=Type\r
    AIType : AIType = -2508005 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@ScriptName=EnableDropOnDeath\r
    EnableDeadDrop : Bool = -2508006 #%(T_46_META_WS_P_ENABLEDROPONDEATH)\r
	@ApiLevel=4\r
	@ScriptName=StartSpawnTime\r
    StartGenTime : Float = -2508007 #%(T_46_META_WS_P_STARTSPAWNTIME)\r
	@ApiLevel=4\r
	@ScriptName=WaveInterval\r
    BatchIntervalFloat : Float = -2508008 #%(T_46_META_WS_P_WAVEINTERVAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpawnBox\r
@ModuleID=10\r
@ModuleLib=LevelObject\r
type SpawnBox : SpawnPos = 2510 { #%(T_46_META_WS_C_SPAWNBOX)\r
	@ApiLevel=4\r
	@ScriptName=SpawnPointCount\r
    get SpawnPointCount : Int = -2510000 #%(T_46_META_WS_P_SPAWNPOINTCOUNT)\r
	@ApiLevel=10\r
	@ScriptName=TeamIndex_Deprecated\r
    get TeamIndex : Int = -2510001 #TeamIndex\r
	@ApiLevel=4\r
	@ScriptName=TeamSeq\r
    get TeamSeq : Int = -2510002 #%(T_46_META_WS_P_TEAMSEQ)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsMovementLocked\r
    IsMovementLocked : Bool = -2510003 #%(T_51_ZCS_SPAWNPOINT_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentEffectGenerator_Deprecated\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type PresentEffectGenerator : LevelObject&PresentEffect = 169 { #%(T_46_META_WS_C_PRESENTEFFECTGENERATOR_DEPRECATED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EffectContainer\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type EffectEntityGenerator : ItemContainerGenerator = 251 { #%(T_46_META_WS_C_EFFECTCONTAINER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Player\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Player : List = 43 { #%(T_46_META_WS_C_LISTT_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Team\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Team : List = 44 { #%(T_46_META_WS_C_LISTT_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Entity\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Entity : List = 50 { #%(T_46_META_WS_C_LISTT_ENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterType\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum AIType : AssetConfigID = 51 { #%(T_46_META_WS_C_MONSTERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Regular\r
    UGCAI = 18 #%(T_46_META_WS_E_NORMAL)\r
	@ApiLevel=4\r
	@ScriptName=WoodCutZombie\r
    ZombieWoodCut = 4 #%(T_46_META_WS_E_WOODCUTZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowZombie\r
    ZombieThrow = 5 #%(T_46_META_WS_E_THROWZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosiveZombie\r
    ZombieExplosive = 6 #%(T_46_META_WS_E_EXPLOSIVEZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=TyrantZombie\r
    ZombieTyrant = 8 #%(T_46_META_WS_E_TYRANTZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowRedZombie\r
    ZombieThrowRed = 9 #%(T_46_META_WS_E_THROWREDZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=MrV\r
    ZombieMrV = 10 #%(T_46_META_WS_E_MRV)\r
	@ApiLevel=4\r
	@ScriptName=TankZombie\r
    ZombieTank = 11 #%(T_46_META_WS_E_TANKZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=DrillZombie\r
    ZombieDrill = 12 #%(T_46_META_WS_E_DRILLZOMBIE)\r
	@ApiLevel=4\r
	@ScriptName=Samurai\r
    ZombieSamurai = 13 #%(T_46_META_WS_E_SAMURAI)\r
	@ApiLevel=4\r
	@ScriptName=FlyBombBee\r
    FlyBombBee = 21 #%(T_46_META_WS_E_FLYBOMBBEE)\r
	@ApiLevel=3\r
	@ScriptName=ZombieDragon\r
    ZombieDragon = 23 #%(T_44_PD_PVE_DRAGON_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaveCountType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum BatchCountType : Int = 140 { #%(T_46_META_WS_C_WAVECOUNTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Wave1\r
    Batch1 = 1 #%(T_46_META_WS_E_WAVE1)\r
	@ApiLevel=4\r
	@ScriptName=Wave2\r
    Batch2 = 2 #%(T_46_META_WS_E_WAVE2)\r
	@ApiLevel=4\r
	@ScriptName=Wave3\r
    Batch3 = 3 #%(T_46_META_WS_E_WAVE3)\r
	@ApiLevel=4\r
	@ScriptName=Continuous\r
    BatchContinuous = 255 #%(T_46_META_WS_E_CONTINUOUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaveIntervalType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum BatchIntervalType : Int = 121 { #%(T_46_META_WS_C_WAVEINTERVALTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Interval3Seconds\r
    Interval3Seconds = 3 #%(T_46_META_WS_E_INTERVAL3SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval5Seconds\r
    Interval5Seconds = 5 #%(T_46_META_WS_E_INTERVAL5SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval10Seconds\r
    Interval10Seconds = 10 #%(T_46_META_WS_E_INTERVAL10SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval15Seconds\r
    Interval15Seconds = 15 #%(T_46_META_WS_E_INTERVAL15SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval30Seconds\r
    Interval30Seconds = 30 #%(T_46_META_WS_E_INTERVAL30SECONDS)\r
	@ApiLevel=4\r
	@ScriptName=Interval9999Seconds\r
    Interval9999Seconds = 9999 #%(T_46_META_WS_E_INTERVAL9999SECONDS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuffType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum BuffType : Int = 81 { #%(T_46_META_WS_C_BUFFTYPE)\r
	@ApiLevel=4\r
	@ScriptName=RandomBuff\r
    BuffTypeRandom = 0 #%(T_46_META_WS_E_RANDOMBUFF)\r
	@ApiLevel=4\r
	@ScriptName=HPBuff\r
    BuffTypeHP = 1 #%(T_46_META_WS_E_HPBUFF)\r
	@ApiLevel=4\r
	@ScriptName=BulletBuff\r
    BuffTypeAmmo = 2 #%(T_46_META_WS_E_BULLETBUFF)\r
	@ApiLevel=4\r
	@ScriptName=ArmorBuff\r
    BuffTypeArmor = 3 #%(T_46_META_WS_E_ARMORBUFF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundDrumType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum DrumMusicElementType : Int = 117 { #%(T_46_META_WS_C_SOUNDDRUMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Claps\r
    Claps = 1 #%(T_46_META_WS_E_CLAPS)\r
	@ApiLevel=4\r
	@ScriptName=Hihats\r
    Hihats = 2 #%(T_46_META_WS_E_HIHATS)\r
	@ApiLevel=4\r
	@ScriptName=Kick\r
    Kick = 3 #%(T_46_META_WS_E_KICK)\r
	@ApiLevel=4\r
	@ScriptName=OpenHihats\r
    OpenHihats = 4 #%(T_46_META_WS_E_OPENHIHATS)\r
	@ApiLevel=4\r
	@ScriptName=Rides\r
    Rides = 5 #%(T_46_META_WS_E_RIDES)\r
	@ApiLevel=4\r
	@ScriptName=Snares\r
    Snares = 6 #%(T_46_META_WS_E_SNARES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundLead1Type\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum Lead1MusicElementType : Int = 143 { #%(T_46_META_WS_C_SOUNDLEAD1TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Lead1C2\r
    Lead1C2 = 7 #%(T_46_META_WS_E_LEAD1C2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1C2Sharp\r
    Lead1C2Sharp = 8 #%(T_46_META_WS_E_LEAD1C2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1D2\r
    Lead1D2 = 9 #%(T_46_META_WS_E_LEAD1D2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1D2Sharp\r
    Lead1D2Sharp = 10 #%(T_46_META_WS_E_LEAD1D2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1E2\r
    Lead1E2 = 11 #%(T_46_META_WS_E_LEAD1E2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1F2\r
    Lead1F2 = 12 #%(T_46_META_WS_E_LEAD1F2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1F2Sharp\r
    Lead1F2Sharp = 13 #%(T_46_META_WS_E_LEAD1F2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1G2\r
    Lead1G2 = 14 #%(T_46_META_WS_E_LEAD1G2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1G2Sharp\r
    Lead1G2Sharp = 15 #%(T_46_META_WS_E_LEAD1G2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1A2\r
    Lead1A2 = 16 #%(T_46_META_WS_E_LEAD1A2)\r
	@ApiLevel=4\r
	@ScriptName=Lead1A2Sharp\r
    Lead1A2Sharp = 17 #%(T_46_META_WS_E_LEAD1A2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead1B2\r
    Lead1B2 = 18 #%(T_46_META_WS_E_LEAD1B2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundLead2Type\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum Lead2MusicElementType : Int = 144 { #%(T_46_META_WS_C_SOUNDLEAD2TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Lead2C2\r
    Lead2C2 = 19 #%(T_46_META_WS_E_LEAD2C2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2C2Sharp\r
    Lead2C2Sharp = 20 #%(T_46_META_WS_E_LEAD2C2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2D2\r
    Lead2D2 = 21 #%(T_46_META_WS_E_LEAD2D2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2D2Sharp\r
    Lead2D2Sharp = 22 #%(T_46_META_WS_E_LEAD2D2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2E2\r
    Lead2E2 = 23 #%(T_46_META_WS_E_LEAD2E2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2F2\r
    Lead2F2 = 24 #%(T_46_META_WS_E_LEAD2F2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2F2Sharp\r
    Lead2F2Sharp = 25 #%(T_46_META_WS_E_LEAD2F2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2G2\r
    Lead2G2 = 26 #%(T_46_META_WS_E_LEAD2G2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2G2Sharp\r
    Lead2G2Sharp = 27 #%(T_46_META_WS_E_LEAD2G2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2A2\r
    Lead2A2 = 28 #%(T_46_META_WS_E_LEAD2A2)\r
	@ApiLevel=4\r
	@ScriptName=Lead2A2Sharp\r
    Lead2A2Sharp = 29 #%(T_46_META_WS_E_LEAD2A2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead2B2\r
    Lead2B2 = 30 #%(T_46_META_WS_E_LEAD2B2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundLead3Type\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum Lead3MusicElementType : Int = 145 { #%(T_46_META_WS_C_SOUNDLEAD3TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Lead3C2\r
    Lead3C2 = 31 #%(T_46_META_WS_E_LEAD3C2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3C2Sharp\r
    Lead3C2Sharp = 32 #%(T_46_META_WS_E_LEAD3C2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3D2\r
    Lead3D2 = 33 #%(T_46_META_WS_E_LEAD3D2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3D2Sharp\r
    Lead3D2Sharp = 34 #%(T_46_META_WS_E_LEAD3D2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3E2\r
    Lead3E2 = 35 #%(T_46_META_WS_E_LEAD3E2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3F2\r
    Lead3F2 = 36 #%(T_46_META_WS_E_LEAD3F2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3F2Sharp\r
    Lead3F2Sharp = 37 #%(T_46_META_WS_E_LEAD3F2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3G2\r
    Lead3G2 = 38 #%(T_46_META_WS_E_LEAD3G2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3G2Sharp\r
    Lead3G2Sharp = 39 #%(T_46_META_WS_E_LEAD3G2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3A2\r
    Lead3A2 = 40 #%(T_46_META_WS_E_LEAD3A2)\r
	@ApiLevel=4\r
	@ScriptName=Lead3A2Sharp\r
    Lead3A2Sharp = 41 #%(T_46_META_WS_E_LEAD3A2SHARP)\r
	@ApiLevel=4\r
	@ScriptName=Lead3B2\r
    Lead3B2 = 42 #%(T_46_META_WS_E_LEAD3B2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundPianoType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum PianoMusicElementType : Int = 146 { #%(T_46_META_WS_C_SOUNDPIANOTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PianoC3\r
    PianoC3 = 43 #%(T_46_META_WS_E_PIANOC3)\r
	@ApiLevel=4\r
	@ScriptName=PianoC3Sharp\r
    PianoC3Sharp = 44 #%(T_46_META_WS_E_PIANOC3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoD3\r
    PianoD3 = 45 #%(T_46_META_WS_E_PIANOD3)\r
	@ApiLevel=4\r
	@ScriptName=PianoD3Sharp\r
    PianoD3Sharp = 46 #%(T_46_META_WS_E_PIANOD3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoE3\r
    PianoE3 = 47 #%(T_46_META_WS_E_PIANOE3)\r
	@ApiLevel=4\r
	@ScriptName=PianoF3\r
    PianoF3 = 48 #%(T_46_META_WS_E_PIANOF3)\r
	@ApiLevel=4\r
	@ScriptName=PianoF3Sharp\r
    PianoF3Sharp = 49 #%(T_46_META_WS_E_PIANOF3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoG3\r
    PianoG3 = 50 #%(T_46_META_WS_E_PIANOG3)\r
	@ApiLevel=4\r
	@ScriptName=PianoG3Sharp\r
    PianoG3Sharp = 51 #%(T_46_META_WS_E_PIANOG3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoA3\r
    PianoA3 = 52 #%(T_46_META_WS_E_PIANOA3)\r
	@ApiLevel=4\r
	@ScriptName=PianoA3Sharp\r
    PianoA3Sharp = 53 #%(T_46_META_WS_E_PIANOA3SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoB3\r
    PianoB3 = 54 #%(T_46_META_WS_E_PIANOB3)\r
	@ApiLevel=4\r
	@ScriptName=PianoC4\r
    PianoC4 = 55 #%(T_46_META_WS_E_PIANOC4)\r
	@ApiLevel=4\r
	@ScriptName=PianoC4Sharp\r
    PianoC4Sharp = 56 #%(T_46_META_WS_E_PIANOC4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoD4\r
    PianoD4 = 57 #%(T_46_META_WS_E_PIANOD4)\r
	@ApiLevel=4\r
	@ScriptName=PianoD4Sharp\r
    PianoD4Sharp = 58 #%(T_46_META_WS_E_PIANOD4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoE4\r
    PianoE4 = 59 #%(T_46_META_WS_E_PIANOE4)\r
	@ApiLevel=4\r
	@ScriptName=PianoF4\r
    PianoF4 = 60 #%(T_46_META_WS_E_PIANOF4)\r
	@ApiLevel=4\r
	@ScriptName=PianoF4Sharp\r
    PianoF4Sharp = 61 #%(T_46_META_WS_E_PIANOF4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoG4\r
    PianoG4 = 62 #%(T_46_META_WS_E_PIANOG4)\r
	@ApiLevel=4\r
	@ScriptName=PianoG4Sharp\r
    PianoG4Sharp = 63 #%(T_46_META_WS_E_PIANOG4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoA4\r
    PianoA4 = 64 #%(T_46_META_WS_E_PIANOA4)\r
	@ApiLevel=4\r
	@ScriptName=PianoA4Sharp\r
    PianoA4Sharp = 65 #%(T_46_META_WS_E_PIANOA4SHARP)\r
	@ApiLevel=4\r
	@ScriptName=PianoB4\r
    PianoB4 = 66 #%(T_46_META_WS_E_PIANOB4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniSentryAttackRangeType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum MinisentryAttackRangeType : Int = 124 { #%(T_46_META_WS_C_MINISENTRYATTACKRANGETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Near\r
    Near = 0 #%(T_46_META_WS_E_NEAR)\r
	@ApiLevel=4\r
	@ScriptName=Middle\r
    Middle = 1 #%(T_46_META_WS_E_MIDDLE)\r
	@ApiLevel=4\r
	@ScriptName=Far\r
    Far = 2 #%(T_46_META_WS_E_FAR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Playable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Playable : Entity = 197 { #%(T_46_META_WS_C_PLAYABLE)\r
	@ApiLevel=4\r
	@ScriptName=IsPlaying\r
    get Playing : Bool = -197000 #%(T_46_META_WS_P_PLAYINGSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=Flag\r
    get Flag : Int = -197001 #%(FLAG)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAutoPlaying\r
    AutoPlay : Bool = -197002 #%(T_46_META_WS_P_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Loopable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Loopable : Entity = 332 { #%(T_46_META_WS_C_LOOPABLE)\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
    IsLoop : AnimationOverrideLoopType = -332000 #%(T_46_META_WS_P_ISLOOP)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentSound_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PresentSound : Playable = 52 { #%(T_40_XXJ_WS_SOUNDNTITY_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=SoundResID\r
    SoundType : AudioType = -52000 #%(T_34_M_WS_SOUND)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -52001 #%(T_34_WT_WS_ICONENTITY_PARAM6)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=PlayTime\r
    PlayTime : Int = -52002 #%(T_38_WZY_WS_CYCLES)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsLoop\r
    IsLoop : Bool = -52003 #%(T_38_WZY_WS_WHECYCLE)\r
	@ApiLevel=4\r
	@Default=50\r
	@ScriptName=Volume\r
    Volume : Int = -52004 #%(T_38_WZY_WS_VOLUME)\r
	@ApiLevel=4\r
	@Default=30\r
	@ScriptName=PlayDistance\r
    PlayDistance : Float = -52005 #%(T_38_WZY_WS_TRANDIST)\r
	@ApiLevel=4\r
	@ScriptName=Position\r
    Position : Vector3 = -52006 #%(T_34_WT_WS_ENTITY13_PARAM2)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Is3D\r
    Is3D : Bool = -52007 #%(T_40_XXJ_WS_IS3D)\r
	@ApiLevel=10\r
	@Default=0\r
	@ScriptName=IsPlaying\r
    State : Int = -52008 #%(T_46_META_WS_P_ISPLAYING)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ListT_PresentSound_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_PresentSound : List = 229 { #%(T_39_WZY_WS_SOUNDENTL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PresentSoundOrPresentSoundList_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PresentSoundOrListPresentSound : Object&(PresentSound|ListT_PresentSound) = 230 #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
\r
@ApiLevel=4\r
@ScriptName=DummyLevelObject\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DummyLevelObject : LevelObject&Collider = 53 { #%(T_46_META_WS_C_DUMMYLEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestructibleLevelObject\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DestructibleLevelObject : LevelObject&Collider = 54 { #%(T_46_META_WS_C_DESTRUCTIBLELEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GeneralSpawnPoint\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type NoTeamIndexSpawnPoint : SpawnPos = 55 { #%(T_46_META_WS_C_GENERALSPAWNPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vehicle\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Vehicle : LevelObject&ResetableEntity&BuffableEntity&FightingEntity = 56 { #%(T_46_META_WS_C_VEHICLE)\r
	@ApiLevel=10\r
	@ScriptName=EngineTorque\r
    EngineTorque : Float = -56000 #%(T_46_META_WS_P_ENGINETORQUE)\r
	@ApiLevel=10\r
	@ScriptName=BrakeTorque\r
    BrakeTorque : Float = -56001 #%(T_46_META_WS_P_BRAKETORQUE)\r
	@ApiLevel=10\r
	@ScriptName=HighSpeedSteerAngle\r
    get HighSpeedSteerAngle : Float = -56002 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLE)\r
	@ApiLevel=10\r
	@ScriptName=HighSpeedSteerAngleAtSpeed\r
    get HighSpeedSteerAngleAtspeed : Float = -56003 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED)\r
	@ApiLevel=10\r
	@ScriptName=MaxSpeed\r
    MaxSpeed : Float = -56004 #%(T_46_META_WS_P_MAXSPEED)\r
	@ApiLevel=10\r
	@ScriptName=IdleBrakeInput\r
    get IdleBrakeInput : Float = -56005 #%(T_46_META_WS_P_IDLEBRAKEINPUT)\r
	@ApiLevel=10\r
	@ScriptName=CrashMessFactor\r
    CrashMessFactor : Float = -56006 #%(T_46_META_WS_P_CRASHMESSFACTOR)\r
	@ApiLevel=10\r
	@ScriptName=CrashMaxSpeed\r
    CrashMaxSpeed : Float = -56007 #%(T_46_META_WS_P_CRASHMAXSPEED)\r
	@ApiLevel=10\r
	@ScriptName=CrashMinDamage\r
    CrashMinDamage : Float = -56008 #%(T_46_META_WS_P_CRASHMINDAMAGE)\r
	@ApiLevel=10\r
	@ScriptName=CrashMaxDamage\r
    CrashMaxDamage : Float = -56009 #%(T_46_META_WS_P_CRASHMAXDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDelay\r
    ExplodeDelay : Float = -56010 #%(T_46_META_WS_P_EXPLODEDELAY)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeRange\r
    ExplodeRange : Float = -56011 #%(T_46_META_WS_P_EXPLODERANGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamage\r
    ExplodeDamage : Int = -56012 #%(T_46_META_WS_P_EXPLODEDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=BurnTime\r
    BurnTime : Float = -56013 #%(T_46_META_WS_P_BURNTIME)\r
	@ApiLevel=4\r
	@ScriptName=BurnDamage\r
    BurnDamage : Int = -56014 #%(T_46_META_WS_P_BURNDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=BurningDamageInterval\r
    BurnInterval : Float = -56015 #%(T_46_META_WS_P_BURNINGDAMAGEINTERVAL)\r
	@ApiLevel=10\r
	@ScriptName=HP\r
    HP : Int = -56016 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@ScriptName=Driver\r
    get Driver : Player = -56017 #%(T_46_META_WS_P_DRIVER)\r
	@ApiLevel=4\r
	@ScriptName=Passengers\r
    get Passengers : ListT_Player = -56018 #%(T_46_META_WS_P_PASSENGERS)\r
	@ApiLevel=4\r
	@ScriptName=VehicleSkinID\r
    VehicleSkinID : VehicleSkinID = -56019 #%(T_46_META_WS_P_VEHICLESKINID)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
    OverloadByPlayerSkin : Bool = -56020 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=MaxHP\r
    MaxHP : Int = -56021 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=CurrentHP\r
    CurrentHP : Int = -56022 #%(T_46_META_WS_P_HP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Car\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Car : Vehicle = 412 { #%(T_46_META_WS_C_CAR)\r
	@ApiLevel=4\r
	@ScriptName=EngineHorsepower\r
    EngineTorque : Float = -56000 #%(T_46_META_WS_P_ENGINEHORSEPOWER)\r
	@ApiLevel=4\r
	@ScriptName=BrakeHorsepower\r
    BrakeTorque : Float = -56001 #%(T_46_META_WS_P_BRAKEHORSEPOWER)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngle\r
    get HighSpeedSteerAngle : Float = -56002 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLE)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngleAtSpeed\r
    get HighSpeedSteerAngleAtspeed : Float = -56003 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED)\r
	@ApiLevel=4\r
	@ScriptName=MaxSpeed\r
    MaxSpeed : Float = -56004 #%(T_46_META_WS_P_MAXSPEED)\r
	@ApiLevel=4\r
	@ScriptName=IdleBrakeInput\r
    get IdleBrakeInput : Float = -56005 #%(T_46_META_WS_P_IDLEBRAKEINPUT)\r
	@ApiLevel=4\r
	@ScriptName=CrashMessFactor\r
    CrashMessFactor : Float = -56006 #%(T_46_META_WS_P_CRASHMESSFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=CrashMaxSpeed\r
    CrashMaxSpeed : Float = -56007 #%(T_46_META_WS_P_CRASHMAXSPEED)\r
	@ApiLevel=4\r
	@ScriptName=CrashMinDamage\r
    CrashMinDamage : Float = -56008 #%(T_46_META_WS_P_CRASHMINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=CrashMaxDamage\r
    CrashMaxDamage : Float = -56009 #%(T_46_META_WS_P_CRASHMAXDAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Portal\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type TeleportDoor : LevelObject&Collider = 57 { #%(T_46_META_WS_C_PORTAL)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAutoTeleport\r
    IsAutoTeleport : Bool = -57000 #%(T_46_META_WS_P_ISAUTOTELEPORT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuffGenerator\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BuffGen : LevelObject = 58 { #%(T_46_META_WS_C_BUFFGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=BuffType\r
    BuffGenType : BuffType = -58000 #%(T_46_META_WS_P_BUFFTYPE)\r
	@ApiLevel=4\r
	@ScriptName=RefreshTime\r
    BuffGenTime : Int = -58001 #%(T_46_META_WS_P_REFRESHTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MovePlatform\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MoveObject : LevelObject&Collider = 59 { #%(T_46_META_WS_C_MOVEPLATFORM)\r
	@ApiLevel=4\r
	@ScriptName=MotionType\r
    MotionType : MoveObjectMotionType = -59000 #%(T_46_META_WS_P_MOTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=MotionValueX\r
    MotionValueX : Int = -59001 #%(T_46_META_WS_P_MOTIONVALUEX)\r
	@ApiLevel=4\r
	@ScriptName=MotionValueY\r
    MotionValueY : Int = -59002 #%(T_46_META_WS_P_MOTIONVALUEY)\r
	@ApiLevel=4\r
	@ScriptName=MotionValueZ\r
    MotionValueZ : Int = -59003 #%(T_46_META_WS_P_MOTIONVALUEZ)\r
	@ApiLevel=4\r
	@ScriptName=MovementDuration\r
    MotionTime : Int = -59004 #%(T_46_META_WS_P_MOVEMENTDURATION)\r
	@ApiLevel=4\r
	@ScriptName=StopDuration\r
    StayTime : Int = -59005 #%(T_46_META_WS_P_STOPDURATION)\r
	@ApiLevel=4\r
	@ScriptName=DisableReciprocating\r
    IsReset : Bool = -59006 #%(T_46_META_WS_P_DISABLERECIPROCATING)\r
	@ApiLevel=3\r
    ExtraBaseInfoInstanceId : Int = -59007 #ExtraBaseInfoInstanceId\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootWeapon\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBox : LevelObject&SpawnableEntity&ResetableEntity = 60 { #%(T_46_META_WS_C_LOOTWEAPON)\r
	@ApiLevel=4\r
	@Default=1000\r
	@ScriptName=WeaponType\r
    LootWeapon : LootWeaponType = -60000 #%(T_46_META_WS_P_WEAPONTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootIAmmo\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxAmmo : LevelObject&SpawnableEntity&ResetableEntity = 135 { #%(T_46_META_WS_C_LOOTIAMMO)\r
	@ApiLevel=4\r
	@Default=1014\r
	@ScriptName=AmmoType\r
    LootArmor : LootAmmoType = -135000 #%(T_46_META_WS_P_AMMOTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootConsumable\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxConsumableItem : LevelObject&SpawnableEntity&ResetableEntity = 136 { #%(T_46_META_WS_C_LOOTCONSUMABLE)\r
	@ApiLevel=4\r
	@Default=1024\r
	@ScriptName=ConsumableType\r
    LootConsumableItem : LootConsumableItemType = -136000 #%(T_46_META_WS_P_CONSUMABLETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootThrowable\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxProjectile : LevelObject&SpawnableEntity&ResetableEntity = 137 { #%(T_46_META_WS_C_LOOTTHROWABLE)\r
	@ApiLevel=4\r
	@Default=1029\r
	@ScriptName=ThrowableType\r
    LootProjectile : LootProjectileType = -137000 #%(T_46_META_WS_P_THROWABLETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootScope\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxSight : LevelObject&SpawnableEntity&ResetableEntity = 138 { #%(T_46_META_WS_C_LOOTSCOPE)\r
	@ApiLevel=4\r
	@Default=1036\r
	@ScriptName=ScopeType\r
    LootSight : LootSightType = -138000 #%(T_46_META_WS_P_SCOPETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootArmor\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LootItemBoxArmor : LevelObject&SpawnableEntity&ResetableEntity = 139 { #%(T_46_META_WS_C_LOOTARMOR)\r
	@ApiLevel=4\r
	@Default=1018\r
	@ScriptName=ArmorType\r
    LootArmor : LootArmorType = -139000 #%(T_46_META_WS_P_ARMORTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VendingMachine\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type VendingMachine : CustomizeTrigger = 61 { #%(T_46_META_WS_C_VENDINGMACHINE)\r
	@ApiLevel=4\r
	@ScriptName=Shop\r
    BindShop : Shop = -61000 #%(T_46_META_WS_P_SHOP)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TriggerRange\r
    TriggerRadius : Float = -61001 #%(T_46_META_WS_P_TRIGGERRANGE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ModelVisibility\r
    ModelShow : Bool = -61002 #%(T_46_META_WS_P_MODELVISIBILITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Dice\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BigToyBall : LevelObject&Collider = 62 { #%(T_46_META_WS_C_DICE)\r
	@ApiLevel=4\r
	@ScriptName=VelocityXZ\r
    VelocityXZ : Int = -62000 #%(T_46_META_WS_P_VELOCITYXZ)\r
	@ApiLevel=4\r
	@ScriptName=VelocityY\r
    VelocityY : Int = -62001 #%(T_46_META_WS_P_VELOCITYY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BouncingTire\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BounceTire : LevelObject&Collider = 63 { #%(T_46_META_WS_C_BOUNCINGTIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Keyboard\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MusicElement : LevelObject&Collider = 64 { #%(T_46_META_WS_C_KEYBOARD)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
    get MusicElementType : PianoMusicElementType = -64000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicScalable\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BasicScalableItem : LevelObject&Appearance&Collider = 65 { #%(T_46_META_WS_C_BASICSCALABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomPath\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomPath : LevelObject = 66 { #%(T_46_META_WS_C_CUSTOMPATH)\r
	@ApiLevel=4\r
	@ScriptName=InstanceID\r
    get InstanceID : Int = -66000 #%(T_46_META_WS_P_INSTANCEID)\r
	@ApiLevel=4\r
	@ScriptName=Points\r
    get Points : ListT_Vector3 = -66001 #%(T_46_META_WS_P_POINTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PathPoint\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomPathPoint : LevelObject = 67 { #%(T_46_META_WS_C_PATHPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Monster\r
@ModuleID=10008\r
@ModuleLib=AI\r
type AI : FightingEntity&InstanceEntity&Transform&ItemContainerGenerator&Visibility = 68 { #%(T_46_META_WS_C_MONSTER)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
    HP : Int = -68000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@ScriptName=HPMax\r
    HPMAX : Int = -68001 #%(T_46_META_WS_P_HPMAX)\r
	@ApiLevel=4\r
	@ScriptName=HostTeam\r
    get HostTeamEntity : Team = -68002 #%(T_46_META_WS_P_HOSTTEAM)\r
	@ApiLevel=10\r
	@ScriptName=SpawnPosition_Deprecated\r
    SpawnPos : DirectedPoint = -68003 #%(T_38_WZY_WS_SPAWNPOS)\r
	@ApiLevel=4\r
	@ScriptName=AttackDamage\r
    AttackDamage : Int = -68004 #%(T_46_META_WS_P_ATTACKDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=AttackInterval\r
    AttackInterval : Int = -68005 #%(T_46_META_WS_P_ATTACKINTERVAL)\r
	@ApiLevel=4\r
	@ScriptName=AttackRange\r
    AttackRange : Float = -68006 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@ScriptName=WanderRange\r
    WanderRange : Float = -68007 #%(T_46_META_WS_P_WANDERRANGE)\r
	@ApiLevel=4\r
	@ScriptName=DetectRange\r
    DetectRange : Float = -68008 #%(T_46_META_WS_P_DETECTRANGE)\r
	@ApiLevel=4\r
	@ScriptName=RunSpeed\r
    RunSpeed : Float = -68009 #%(T_46_META_WS_P_RUNSPEED)\r
	@ApiLevel=4\r
	@ScriptName=IsDeadDrop\r
    EnableDeadDrop : Bool = -68010 #%(T_46_META_WS_P_ISDEADDROP)\r
	@ApiLevel=4\r
	@ScriptName=IsInvincible\r
    IsGod : Bool = -68011 #%(T_46_META_WS_P_ISINVINCIBLE)\r
	@ApiLevel=4\r
	@ScriptName=DamageTakenPercent\r
    InjuredScale : Float = -68012 #%(T_46_META_WS_P_DAMAGETAKENPERCENT)\r
	@ApiLevel=4\r
	@ScriptName=MonsterType\r
    get AIType : AIType = -68013 #%(T_46_META_WS_P_MONSTERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=IsAutoChaseEnemy\r
    get CanChaseEnemy : Bool = -68014 #%(T_46_META_WS_P_ISAUTOCHASEENEMY)\r
	@ApiLevel=4\r
	@ScriptName=ActionType\r
    get ActionType : Int = -68015 #%(T_46_META_WS_P_ACTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PathID\r
    get PathID : Int = -68016 #%(T_46_META_WS_P_PATHID)\r
	@ApiLevel=4\r
	@ScriptName=ChaseTarget\r
    ChaseTarget : FightingEntity = -68017 #%(T_46_META_WS_P_CHASETARGET)\r
	@ApiLevel=4\r
	@ScriptName=AttackTarget\r
    get AttackTarget : FightingEntity = -68018 #%(T_46_META_WS_P_ATTACKTARGET)\r
	@ApiLevel=4\r
	@ScriptName=SpawnPosition\r
    SpawnPosVec3 : Vector3 = -68019 #%(T_46_META_WS_P_SPAWNPOSITION)\r
	@ApiLevel=3\r
	@ScriptName=TeamIndex\r
    get TeamIndex : Int = -68020 #%(T_41_XXJ_WS_TEAMINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShopItem\r
@ModuleID=19\r
@ModuleLib=Economy\r
type ShopItem : Entity = 71 { #%(T_46_META_WS_C_SHOPITEM)\r
	@ApiLevel=3\r
	@ScriptName=ID\r
    ID : Int = -71000 #%(T_46_META_WS_P_ID)\r
	@ApiLevel=4\r
	@ScriptName=Price\r
    Price : Int = -71001 #%(T_46_META_WS_P_PRICE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=MoneyType\r
    MoneyType : MoneyType = -71002 #%(T_46_META_WS_P_MONEYTYPE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PurchaseLimit\r
    TotalPurchaseLimit : Int = -71003 #%(T_46_META_WS_P_PURCHASELIMIT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=RemainQuantity\r
    CurTotalPurchaseLimit : Int = -71004 #%(T_46_META_WS_P_REMAINQUANTITY)\r
	@ApiLevel=4\r
	@ScriptName=Name\r
    Name : String = -71005 #%(T_46_META_WS_P_NAME)\r
	@ApiLevel=3\r
	@ScriptName=Desc\r
    Desc : String = -71006 #%(T_46_META_WS_P_DESC)\r
	@ApiLevel=3\r
	@ScriptName=ItemIDs\r
    ItemGoodsIDList : ListT_ItemGoodsIDType = -71007 #%(T_46_META_WS_P_ITEMIDS)\r
	@ApiLevel=3\r
	@ScriptName=ItemCounts\r
    ItemGoodsCntList : ListT_Int = -71008 #%(T_46_META_WS_P_ITEMCOUNTS)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    IconType : SpriteID = -71009 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsPurchasable\r
    CanPurchas : Bool = -71010 #%(T_46_META_WS_P_ISPURCHASABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShopShelf\r
@ModuleID=19\r
@ModuleLib=Economy\r
type ShopShelf : Entity = 72 { #%(T_46_META_WS_C_SHOPSHELF)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
    Name : String = -72000 #Name\r
	@ApiLevel=4\r
	@ScriptName=ShopItems\r
    ShopItemList : ListT_ShopItem = -72001 #%(T_46_META_WS_P_SHOPITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Shop\r
@ModuleID=19\r
@ModuleLib=Economy\r
type Shop : Entity = 73 { #%(T_46_META_WS_C_SHOP)\r
	@ApiLevel=10\r
	@ScriptName=Name_Deprecated\r
    Name : String = -73000 #Name\r
	@ApiLevel=4\r
	@ScriptName=Shelves\r
    ShopShelfList : ListT_ShopShelf = -73001 #%(T_46_META_WS_P_SHELFS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=InventoryType\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum InventoryType : Int = 74 { #%(T_46_META_WS_C_INVENTORYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Weapon\r
    Weapon = 0 #%(T_24_V_TRAINING_BOX_WEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
    Helmet = 2 #%(T_46_META_WS_E_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
    Vest = 4 #%(T_46_META_WS_E_VEST)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
    Grenade = 8 #%(T_46_META_WS_E_GRENADE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolType\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum PatrolType : Int = 75 { #%(T_46_META_WS_C_PATROLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=OneWay\r
    OneWay = 1 #%(T_46_META_WS_E_ONEWAY)\r
	@ApiLevel=4\r
	@ScriptName=BackAndForth\r
    BackAndForth = 2 #%(T_46_META_WS_E_BACKANDFORTH)\r
	@ApiLevel=4\r
	@ScriptName=Cyclic\r
    Cylic = 3 #%(T_46_META_WS_E_CYLIC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolStyleType\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum PatrolStyleType : Int = 76 { #%(T_46_META_WS_C_PATROLSTYLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=JustPatrol\r
    JustPatrol = 1 #%(T_46_META_WS_E_JUSTPATROL)\r
	@ApiLevel=4\r
	@ScriptName=PatrolWhileAttack\r
    Attack = 2 #%(T_46_META_WS_E_PATROLWHILEATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FireType\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum FireType : Int = 401 { #%(T_46_META_WS_C_FIRETYPE)\r
	@ApiLevel=4\r
	@ScriptName=None\r
    None = -1 #%(T_46_META_WS_E_NONE)\r
	@ApiLevel=4\r
	@ScriptName=Auto\r
    Auto = 0 #%(T_46_META_WS_E_AUTO)\r
	@ApiLevel=4\r
	@ScriptName=Single\r
    Single = 1 #%(T_46_META_WS_E_SINGLE)\r
	@ApiLevel=4\r
	@ScriptName=Triple\r
    Triple = 2 #%(T_46_META_WS_E_TRIPLE)\r
	@ApiLevel=4\r
	@ScriptName=Double\r
    Double = 3 #%(T_46_META_WS_E_DOUBLE)\r
	@ApiLevel=4\r
	@ScriptName=Dump\r
    Dump = 4 #%(T_46_META_WS_E_DUMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Weapon\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Weapon : FormulableEntity&BuffableEntity = 79 { #%(T_46_META_WS_C_WEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Damage\r
    Damage : Int = -79000 #%(T_46_META_WS_P_DAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=AttackRange\r
    Range : Float = -79001 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@ScriptName=AttackInterval\r
    FireInterval : Float = -79002 #%(T_32_YS_WEAPON_TAG_3)\r
	@ApiLevel=4\r
	@ScriptName=AmmoMagSize\r
    AmmoClipSize : Int = -79003 #%(T_46_META_WS_P_AMMOMAGSIZE)\r
	@ApiLevel=4\r
	@ScriptName=InitialMagCount\r
    InitialClipCount : Int = -79004 #%(T_46_META_WS_P_INITIALMAGCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPenetration\r
    BiteArmor : Float = -79005 #%(T_46_META_WS_P_ARMORPENETRATION)\r
	@ApiLevel=4\r
	@ScriptName=FullDamageDistance\r
    FullDamageDistance : Float = -79006 #%(T_46_META_WS_P_FULLDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=MinDamageDistance\r
    MinDamageDistance : Float = -79007 #%(T_46_META_WS_P_MINDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=MinDamage\r
    MinDamage : Int = -79008 #%(T_46_META_WS_P_MINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ScatterThreshold\r
    ScatterNum : Float = -79009 #%(T_46_META_WS_P_SCATTERTHRESHOLD)\r
	@ApiLevel=4\r
	@ScriptName=MaxScatterRatio\r
    ScatterMax : Float = -79010 #%(T_46_META_WS_P_MAXSCATTERRATIO)\r
	@ApiLevel=4\r
	@ScriptName=ItemID\r
    get ItemID : ItemGoodsIDType = -79011 #%(T_46_META_WS_P_ITEMID)\r
	@ApiLevel=4\r
	@ScriptName=FiringInterval\r
    RepeatFireInterval : Float = -79012 #%(T_36_WZY_GUNPRO_PARAM12)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
    get Owner : Player = -79013 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsConsumeAmmo\r
    CostAmmo : Bool = -79014 #%(T_46_META_WS_P_ISCONSUMEAMMO)\r
	@ApiLevel=4\r
	@ScriptName=DoubleGunType\r
    CombineType : WeaponCombineType = -79015 #%(T_46_META_WS_P_DOUBLEGUNTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPenetrationFactor\r
    Armordestroy : Float = -79016 #%(T_46_META_WS_P_ARMORPENETRATIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=PlayerSpeedFactor\r
    PlayerSpeedFactor : Float = -79017 #%(T_46_META_WS_P_PLAYERSPEEDFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=BodyDamageFactor\r
    DamageRatioBody : Float = -79018 #%(T_46_META_WS_P_BODYDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=HeadDamageFactor\r
    DamageRatioHead : Float = -79019 #%(T_46_META_WS_P_HEADDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=LimbDamageFactor\r
    DamageLimbBody : Float = -79020 #%(T_46_META_WS_P_LIMBDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=OtherDamageFactor\r
    ExtraDamageRate : Float = -79021 #%(T_46_META_WS_P_OTHERDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=VisibleOnBack\r
    VisibleOnBack : Bool = -79022 #%(T_46_META_WS_P_VISIBLEONBACK)\r
	@ApiLevel=4\r
	@ScriptName=KnockdownDamageBonus\r
    KnockDownDamage : Int = -79023 #%(T_46_META_WS_P_KNOCKDOWNDAMAGEBONUS)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=AmmoPerShot\r
    OnceAmmo : Int = -79024 #%(T_46_META_WS_P_AMMOPERSHOT)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ReloadSpeedFactor\r
    ReloadSpeed : Float = -79025 #%(T_46_META_WS_P_RELOADSPEEDFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=CurrentAmmo\r
    AmmoInClip : Int = -79026 #%(T_46_META_WS_P_CURRENTAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SkinID\r
    WeaponSkinID : WeaponSkinID = -79027 #%(T_46_META_WS_P_SKINID)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
    OverloadByPlayerWeaponSkin : Bool = -79028 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableSkinAttributes\r
    EnableWeaponSkinProp : Bool = -79029 #%(T_46_META_WS_P_ENABLESKINATTRIBUTES)\r
	@ApiLevel=4\r
	@ScriptName=ScatterIncreaseSpeed\r
    ScatterSpeed : Float = -79030 #%(T_46_META_WS_P_SCATTERINCREASESPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScatterRecoverSpeed\r
    ScatterRecoverSpeed : Float = -79031 #%(T_46_META_WS_P_SCATTERRECOVERSPEED)\r
	@ApiLevel=4\r
	@ScriptName=PlayerSpeedFactorWhileFiring\r
    PlayerSpeedFactorFiring : Float = -79032 #%(T_46_META_WS_P_PLAYERSPEEDFACTORWHILEFIRING)\r
	@ApiLevel=4\r
	@ScriptName=ScatterMultiplierWhileMoving\r
    ScatterMove : Float = -79033 #%(T_46_META_WS_P_SCATTERMULTIPLIERWHILEMOVING)\r
	@ApiLevel=4\r
	@ScriptName=WeaponType\r
    get OriginWeaponType : WeaponType = -79034 #%(T_46_META_WS_P_WEAPONTYPE)\r
	@ApiLevel=4\r
    get AmmoType : AmmoType = -79035 #%(T_46_META_WS_P_AMMOTYPE)\r
	@ApiLevel=4\r
    FireType : FireType = -79036 #%(T_46_META_WS_P_FIRETYPE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsSingleShot\r
    IsSingleShot : Bool = -79037 #%(T_46_META_WS_P_ISSINGLESHOT)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsSilence\r
    IsSilence : Bool = -79038 #%(T_46_META_WS_P_ISSILENCE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=SpeedWhileAiming\r
    SpeedWhileAiming : Float = -79039 #%(T_46_META_WS_P_SPEEDWHILEAIMING)\r
	@ApiLevel=4\r
	@ScriptName=SwitchWeaponTime\r
    SwitchWeaponTime : Float = -79040 #%(T_52_META_TYP_79_I40)\r
	@ApiLevel=4\r
	@ScriptName=PreSwitchWeaponTime\r
    PreSwitchWeaponTime : Float = -79041 #%(T_52_META_TYP_79_I41)\r
	@ApiLevel=4\r
	@ScriptName=PostSwitchWeaponTime\r
    PostSwitchWeaponTime : Float = -79042 #%(T_52_META_TYP_79_I42)\r
	@ApiLevel=4\r
	@ScriptName=ScopeTransitionTime\r
    ScopeTransitionTime : Float = -79043 #%(T_52_META_TYP_79_I43)\r
	@ApiLevel=3\r
	@Default=false\r
    EnableAppearanceOverride : Bool = -79044 #%(T_55_META_TYP_79_I44)\r
	@ApiLevel=3\r
    DisplayName : StringOrLocString = -79045 #%(T_55_META_TYP_79_I45)\r
	@ApiLevel=3\r
    FirstPersonModel : PrefabID = -79046 #%(T_55_META_TYP_79_I46)\r
	@ApiLevel=3\r
    ThirdPersonModel : PrefabID = -79047 #%(T_55_META_TYP_79_I47)\r
	@ApiLevel=3\r
    BackModel : PrefabID = -79048 #%(T_55_META_TYP_79_I48)\r
	@ApiLevel=3\r
    PickupModel : PrefabID = -79049 #%(T_55_META_TYP_79_I49)\r
	@ApiLevel=3\r
    BackpackIcon : SpriteID = -79050 #%(T_55_META_TYP_79_I50)\r
	@ApiLevel=3\r
    SlotIcon : SpriteID = -79051 #%(T_55_META_TYP_79_I51)\r
	@ApiLevel=3\r
    KillIcon : SpriteID = -79052 #%(T_55_META_TYP_79_I52)\r
	@ApiLevel=3\r
    FireAudioID : AudioID = -79053 #%(T_55_META_TYP_79_I53)\r
	@ApiLevel=3\r
    ClipInAudioID : AudioID = -79054 #%(T_55_META_TYP_79_I54)\r
	@ApiLevel=3\r
    ClipOutAudioID : AudioID = -79055 #%(T_55_META_TYP_79_I55)\r
	@ApiLevel=3\r
    ChangeWeaponAudioID : AudioID = -79056 #%(T_55_META_TYP_79_I56)\r
	@ApiLevel=3\r
	@ScriptName=BulletTrailMaterial\r
    GunTraceMaterial : MaterialID = -79057 #%(T_55_META_TYP_79_I57)\r
	@ApiLevel=3\r
    FireEffect : PrefabID = -79058 #%(T_55_META_TYP_79_I58)\r
	@ApiLevel=3\r
    HitEffect : PrefabID = -79059 #%(T_55_META_TYP_79_I59)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WeaponGenerator\r
@ModuleID=10016\r
@ModuleLib=Combat\r
type WeaponGenerator : ItemContainerGenerator&Weapon&Transform&InstanceEntity = 176 { #%(T_46_META_WS_C_WEAPONGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=WeaponType\r
    get WeaponType : Int = -176000 #%(T_46_META_WS_P_WEAPONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=WeaponSubType\r
    get WeaponSubType : Int = -176001 #%(T_46_META_WS_P_WEAPONSUBTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ItemContainer\r
@ModuleID=10014\r
@ModuleLib=Items\r
type ItemGenerator : ItemContainerGenerator&Transform&InstanceEntity = 187 { #%(T_46_META_WS_C_ITEMCONTAINER)\r
	@ApiLevel=4\r
	@ScriptName=ItemID\r
    get ItemID : Int = -187000 #%(T_46_META_WS_P_ITEMID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRequestPurchaseType\r
@ModuleID=19\r
@ModuleLib=Economy\r
enum RequestPurchaseType : Int = 363 { #%(T_46_META_WS_C_UIREQUESTPURCHASETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Disabled\r
    Forbiden = 1 #%(T_46_META_WS_E_DISABLED)\r
	@ApiLevel=4\r
	@ScriptName=Team\r
    Team = 2 #%(T_46_META_WS_E_TEAM)\r
	@ApiLevel=10\r
	@ScriptName=Faction\r
    Faction = 3 #%(T_46_META_WS_E_FACTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIStore\r
@ModuleID=19\r
@ModuleLib=Economy\r
type UGCShopHud : InternalHud = 80 { #%(T_46_META_WS_C_UISTORE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -80000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=DisableManualClosing\r
    CloseForbiden : Bool = -80001 #%(T_46_META_WS_P_DISABLEMANUALCLOSING)\r
	@ApiLevel=4\r
	@ScriptName=Store\r
    BindShopEntity : Shop = -80002 #%(T_46_META_WS_P_STORE)\r
	@ApiLevel=10\r
	@ScriptName=Money\r
    BindMoneyEntity : Money = -80003 #%(T_46_META_WS_P_MONEY)\r
	@ApiLevel=3\r
	@ScriptName=MoneyList\r
    BindMoneyEntityList : ListT_Money = -80004 #%(T_46_META_WS_P_MONEYLIST)\r
	@ApiLevel=3\r
	@ScriptName=WalletID\r
    get BindWalletEntityID : String = -80005 #%(T_46_META_WS_P_WALLETID)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=RequestType\r
    get RequestType : RequestPurchaseType = -80006 #%(T_46_META_WS_P_REQUESTTYPE)\r
	@ApiLevel=3\r
	@ScriptName=RequestedItemList\r
    get AskedList : ListT_Object = -80007 #%(T_46_META_WS_P_REQUESTEDITEMLIST)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=UIInternalPurchaseStore\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
type UIInternalPurchaseHud : InternalHud = 469 { #%(T_53_SD_COMMIAP_DEFAULTSHOPNAME)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -469000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UIInteractionButton\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ActionHud : InternalHud = 83 { #%(T_46_META_WS_C_UIINTERACTIONBUTTON)\r
	@ApiLevel=3\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -83000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=TriggerPlayerID\r
    EntityID : Entity = -83001 #%(T_46_META_WS_P_TRIGGERPLAYERID)\r
	@ApiLevel=3\r
	@ScriptName=Params\r
    Params : ListT_Object = -83002 #%(T_46_META_WS_P_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PropertyFormulaFactorType\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
enum FormulaFactorType : Int = 86 { #%(T_46_META_WS_C_PROPERTYFORMULAFACTORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=MinValue\r
    MinValue = 1 #%(T_46_META_WS_E_MINVALUE)\r
	@ApiLevel=4\r
	@ScriptName=MaxValue\r
    MaxValue = 2 #%(T_46_META_WS_E_MAXVALUE)\r
	@ApiLevel=4\r
	@ScriptName=BaseCoefficient\r
    BaseMultiplier = 3 #%(T_46_META_WS_E_BASECOEFFICIENT)\r
	@ApiLevel=4\r
	@ScriptName=PreAccumulator\r
    BeforeAccumulator = 4 #%(T_46_META_WS_E_PREACCUMULATOR)\r
	@ApiLevel=4\r
	@ScriptName=Multiplier\r
    Multiplier = 5 #%(T_46_META_WS_E_MULTIPLIER)\r
	@ApiLevel=4\r
	@ScriptName=MultiplyAccumulate\r
    SumMultiplier = 6 #%(T_46_META_WS_E_MULTIPLYACCUMULATE)\r
	@ApiLevel=4\r
	@ScriptName=PostAccumulator\r
    AfterAccumulator = 7 #%(T_46_META_WS_E_POSTACCUMULATOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DualWieldWeaponType\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum WeaponCombineType : Int = 154 { #%(T_46_META_WS_C_DUALWIELDWEAPONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=NoDualWielding\r
    NoCombine = 0 #%(T_46_META_WS_E_NODUALWIELDING)\r
	@ApiLevel=4\r
	@ScriptName=CombineSelf\r
    CombineSelf = 1 #%(T_46_META_WS_E_COMBINESELF)\r
	@ApiLevel=4\r
	@ScriptName=CombineAll\r
    CombineAll = 2 #%(T_46_META_WS_E_COMBINEALL)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum WeaponType : Int = 345 { #%(T_46_META_WS_C_WEAPONTYPE)\r
	@ApiLevel=4\r
    Rifle = 0 #%(T_46_META_WS_E_RIFLE)\r
	@ApiLevel=4\r
    Sniper = 1 #%(T_46_META_WS_E_SNIPER)\r
	@ApiLevel=4\r
    Pistol = 2 #%(T_46_META_WS_E_PISTOL)\r
	@ApiLevel=4\r
    Melee = 3 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
    Shotgun = 4 #%(T_46_META_WS_E_SHOTGUN)\r
	@ApiLevel=4\r
    SubMachineGun = 6 #%(T_46_META_WS_E_SUBMACHINEGUN)\r
	@ApiLevel=4\r
    SpecialGun = 7 #%(T_46_META_WS_E_SPECIALGUN)\r
	@ApiLevel=4\r
    CrossBow = 8 #%(T_46_META_WS_E_CROSSBOW)\r
	@ApiLevel=4\r
    CG15 = 12 #%(T_46_META_WS_E_CG15)\r
	@ApiLevel=4\r
    GrapplingHookGun = 15 #%(T_46_META_WS_E_GRAPPLINGHOOKGUN)\r
	@ApiLevel=4\r
    HandCannon = 16 #%(T_46_META_WS_E_HANDCANNON)\r
	@ApiLevel=4\r
    ThrowingKnife = 18 #%(T_46_META_WS_E_THROWINGKNIFE)\r
	@ApiLevel=4\r
    IceGun = 19 #%(T_46_META_WS_E_ICEGUN)\r
	@ApiLevel=4\r
    FlameThrower = 21 #%(T_46_META_WS_E_FLAMETHROWER)\r
	@ApiLevel=4\r
    Dagger = 22 #%(T_46_META_WS_E_DAGGER)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum AmmoType : Int = 346 { #%(T_46_META_WS_C_AMMOTYPE)\r
	@ApiLevel=4\r
    RifleAmmo = 201 #%(T_46_META_WS_E_RIFLEAMMO)\r
	@ApiLevel=4\r
    PistolAmmo = 202 #%(T_46_META_WS_E_PISTOLAMMO)\r
	@ApiLevel=4\r
    SniperAmmo = 203 #%(T_46_META_WS_E_SNIPERAMMO)\r
	@ApiLevel=4\r
    ShotgunAmmo = 204 #%(T_46_META_WS_E_SHOTGUNAMMO)\r
	@ApiLevel=4\r
    SubMachineGunAmmo = 205 #%(T_46_META_WS_E_SUBMACHINEGUNAMMO)\r
	@ApiLevel=4\r
    BowAmmo = 206 #%(T_46_META_WS_E_BOWAMMO)\r
	@ApiLevel=4\r
    M79Ammo = 207 #%(T_46_META_WS_E_M79AMMO)\r
	@ApiLevel=4\r
    Hook = 209 #%(T_46_META_WS_E_HOOK)\r
	@ApiLevel=4\r
    M79Ammo_Exclusive = 219 #%(T_46_META_WS_E_M79AMMO_EXCLUSIVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MovePlatformType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum MoveObjectMotionType : Int = 127 { #%(T_46_META_WS_C_MOVEPLATFORMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Move\r
    Translate = 0 #%(T_46_META_WS_E_MOVE)\r
	@ApiLevel=4\r
	@ScriptName=Rotate\r
    Rotate = 1 #%(T_46_META_WS_E_ROTATE)\r
	@ApiLevel=4\r
	@ScriptName=Scale\r
    Scale = 2 #%(T_46_META_WS_E_SCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootAmmoType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootAmmoType : Int = 129 { #%(T_46_META_WS_C_LOOTAMMOTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
    LootAmmoRandom = 1014 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=ARAmmo\r
    ARAmmo = 1008 #%(T_46_META_WS_E_ARAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SMGAmmo\r
    SMGAmmo = 1009 #%(T_46_META_WS_E_SMGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SNAmmo\r
    SNAmmo = 1010 #%(T_46_META_WS_E_SNAMMO)\r
	@ApiLevel=4\r
	@ScriptName=HGAmmo\r
    HGAmmo = 1011 #%(T_46_META_WS_E_HGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=SGAmmo\r
    SGAmmo = 1012 #%(TXT_ITEM_SGAMMO)\r
	@ApiLevel=4\r
	@ScriptName=BOWAmmo\r
    BOWAmmo = 1013 #%(T_46_META_WS_E_BOWAMMO)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootConsumableType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootConsumableItemType : Int = 130 { #%(T_46_META_WS_C_LOOTCONSUMABLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
    LootCORandom = 1024 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=MedKit\r
    FAK = 1019 #%(T_46_META_WS_E_MEDKIT)\r
	@ApiLevel=4\r
	@ScriptName=RepairKit\r
    ArmorPrepair = 1020 #%(T_46_META_WS_E_REPAIRKIT)\r
	@ApiLevel=4\r
	@ScriptName=Horizaline\r
    Cardiac = 1021 #%(T_46_META_WS_E_HORIZALINE)\r
	@ApiLevel=4\r
	@ScriptName=Inhaler\r
    Inhaler = 1022 #%(T_46_META_WS_E_INHALER)\r
	@ApiLevel=4\r
	@ScriptName=GlooWall\r
    Glooshield = 1023 #%(T_46_META_WS_E_GLOOWALL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootArmorType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootArmorType : Int = 131 { #%(T_46_META_WS_C_LOOTARMORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
    LootArRandom = 1018 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=ArmorLv1\r
    ArmorLv1 = 1015 #%(T_46_META_WS_E_ARMORLV1)\r
	@ApiLevel=4\r
	@ScriptName=ArmorLv2\r
    ArmorLv2 = 1016 #%(T_46_META_WS_E_ARMORLV2)\r
	@ApiLevel=4\r
	@ScriptName=ArmorLv3\r
    ArmorLv3 = 1017 #%(T_46_META_WS_E_ARMORLV3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootThrowableType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootProjectileType : Int = 132 { #%(T_46_META_WS_C_LOOTTHROWABLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
    LootJaRandom = 1029 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
    Grenade = 1025 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashGrenade\r
    Flash = 1026 #%(TXT_ITEM_FLASH)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
    SmokeGrenade = 1027 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
    IceGrenade = 1028 #%(T_46_META_WS_E_FLASHFREEZE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootScopeType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootSightType : Int = 133 { #%(T_46_META_WS_C_LOOTSCOPETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Random\r
    LootSightRandom = 1036 #%(T_46_META_WS_E_RANDOM)\r
	@ApiLevel=4\r
	@ScriptName=Scope2x\r
    Sight2 = 1032 #%(T_46_META_WS_E_SCOPE2X)\r
	@ApiLevel=4\r
	@ScriptName=Scope4x\r
    Sight4 = 1033 #%(T_46_META_WS_E_SCOPE4X)\r
	@ApiLevel=4\r
	@ScriptName=ThermalScope\r
    HeatSight = 1035 #%(T_46_META_WS_E_THERMALSCOPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootWeaponType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum LootWeaponType : Int = 134 { #%(T_46_META_WS_C_LOOTWEAPONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LootWeaponRandom\r
    LootSightRandom = 1000 #%(T_46_META_WS_E_LOOTWEAPONRANDOM)\r
	@ApiLevel=4\r
	@ScriptName=AR\r
    AR = 1001 #%(T_46_META_WS_E_AR)\r
	@ApiLevel=4\r
	@ScriptName=SMG\r
    SMG = 1002 #%(T_46_META_WS_E_SMG)\r
	@ApiLevel=4\r
	@ScriptName=SR\r
    SR = 1003 #%(T_46_META_WS_E_SR)\r
	@ApiLevel=4\r
	@ScriptName=Pistol\r
    Pistol = 1004 #%(T_46_META_WS_E_PISTOL)\r
	@ApiLevel=4\r
	@ScriptName=SG\r
    SG = 1005 #%(T_46_META_WS_E_SG)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
    Melee = 1006 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=CrossBow\r
    CrossBow = 1007 #%(T_46_META_WS_E_CROSSBOW)\r
	@ApiLevel=4\r
	@ScriptName=FootballShooter\r
    FootGun = 1041 #%(T_46_META_WS_E_FOOTBALLSHOOTER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MoneyType\r
@ModuleID=20\r
@ModuleLib=Economy\r
enum MoneyType : Int = 88 { #%(T_46_META_WS_C_MONEYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Basic\r
    Basic = 1 #%(T_46_META_WS_E_BASIC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Money\r
@ModuleID=20\r
@ModuleLib=Economy\r
type Money : Entity = 89 { #%(T_46_META_WS_C_MONEY)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Type\r
    Type : MoneyType = -89000 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Count\r
    Count : BigFloat = -89001 #%(T_46_META_WS_P_COUNT)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    MoneyIcon : SpriteID = -89002 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=IconColor\r
    MoneyIconColor : Color = -89003 #%(T_46_META_WS_P_ICONCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Wallet\r
@ModuleID=20\r
@ModuleLib=Economy\r
type Wallet : Entity = 90 { #%(T_46_META_WS_C_WALLET)\r
	@ApiLevel=4\r
	@ScriptName=Moneys\r
    Content : ListT_Money = -90000 #%(T_46_META_WS_P_MONEYS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UnitSpawn\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EntityGenerator : LevelObject&SpawnableEntity&ResetableEntity = 2509 { #%(T_46_META_WS_C_UNITSPAWN)\r
	@ApiLevel=4\r
	@ScriptName=SpawnCountPerWave\r
    CountEachBatch : Int = -2509000 #%(T_46_META_WS_P_SPAWNCOUNTPERWAVE)\r
	@ApiLevel=4\r
	@ScriptName=WaveCount\r
    BatchCount : Int = -2509001 #%(T_46_META_WS_P_WAVECOUNT)\r
	@ApiLevel=4\r
	@ScriptName=CurrentWave\r
    CurBatch : Int = -2509002 #%(T_46_META_WS_P_CURRENTWAVE)\r
	@ApiLevel=10\r
	@ScriptName=WaveInterval_Deprecated\r
    BatchInterval : Int = -2509003 #%(T_33_LO_WS_ZBPARA_INTERVAL)\r
	@ApiLevel=4\r
	@ScriptName=TemplateEntity\r
    LogicEntity : Entity = -2509004 #%(T_46_META_WS_P_TEMPLATEENTITY)\r
	@ApiLevel=4\r
	@ScriptName=StartSpawnTime\r
    StartGenTime : Float = -2509005 #%(T_46_META_WS_P_STARTSPAWNTIME)\r
	@ApiLevel=4\r
	@ScriptName=IsContinuous\r
    IsContinuous : Bool = -2509006 #%(T_46_META_WS_P_ISCONTINUOUS)\r
	@ApiLevel=4\r
	@ScriptName=WaveInterval\r
    BatchIntervalFloat : Float = -2509007 #%(T_46_META_WS_P_WAVEINTERVAL)\r
	@ApiLevel=3\r
	@ScriptName=TemplatePrefabID\r
    TemplatePrefabID : PrefabID = -2509008 #%(T_41_XXJ_WS_TEMPLATEPREFABID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DynamicCreateLevelObjectType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum DynamicCreateItemID : LevelObjectID = 92 { #%(T_46_META_WS_C_DYNAMICCREATELEVELOBJECTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=SquareBox\r
    Item1 = 1 #%(T_46_META_WS_E_SQUAREBOX)\r
	@ApiLevel=4\r
	@ScriptName=LongBox\r
    Item2 = 2 #%(T_46_META_WS_E_LONGBOX)\r
	@ApiLevel=4\r
	@ScriptName=Shrub\r
    Item3 = 3 #%(T_46_META_WS_E_SHRUB)\r
	@ApiLevel=4\r
	@ScriptName=Haystack\r
    Item4 = 4 #%(T_46_META_WS_E_HAYSTACK)\r
	@ApiLevel=4\r
	@ScriptName=WreckedCar\r
    Item5 = 5 #%(T_46_META_WS_E_WRECKEDCAR)\r
	@ApiLevel=4\r
	@ScriptName=WreckedBus\r
    Item6 = 6 #%(T_46_META_WS_E_WRECKEDBUS)\r
	@ApiLevel=4\r
	@ScriptName=ContainerA\r
    Item7 = 7 #%(T_46_META_WS_E_CONTAINERA)\r
	@ApiLevel=4\r
	@ScriptName=ContainerB\r
    Item8 = 8 #%(T_46_META_WS_E_CONTAINERB)\r
	@ApiLevel=4\r
	@ScriptName=ContainerC\r
    Item9 = 9 #%(T_46_META_WS_E_CONTAINERC)\r
	@ApiLevel=4\r
	@ScriptName=Hut\r
    Item10 = 10 #%(T_46_META_WS_E_HUT)\r
	@ApiLevel=4\r
	@ScriptName=GuardTower\r
    Item11 = 11 #%(T_46_META_WS_E_GUARDTOWER)\r
	@ApiLevel=4\r
	@ScriptName=Outpost\r
    Item12 = 12 #%(T_46_META_WS_E_OUTPOST)\r
	@ApiLevel=4\r
	@ScriptName=HouseB\r
    Item14 = 14 #%(T_46_META_WS_E_HOUSEB)\r
	@ApiLevel=4\r
	@ScriptName=SandStructure\r
    Item16 = 16 #%(T_46_META_WS_E_SANDSTRUCTURE)\r
	@ApiLevel=4\r
	@ScriptName=Fountain\r
    Item17 = 17 #%(T_46_META_WS_E_FOUNTAIN)\r
	@ApiLevel=4\r
	@ScriptName=CherryBlossom\r
    Item18 = 18 #%(T_46_META_WS_E_CHERRYBLOSSOM)\r
	@ApiLevel=4\r
	@ScriptName=HouseA\r
    Item19 = 19 #%(T_46_META_WS_E_HOUSEA)\r
	@ApiLevel=4\r
	@ScriptName=HouseC\r
    Item20 = 20 #%(T_46_META_WS_E_HOUSEC)\r
	@ApiLevel=4\r
	@ScriptName=BananaTree\r
    Item21 = 21 #%(T_46_META_WS_E_BANANATREE)\r
	@ApiLevel=4\r
	@ScriptName=ToiletBowl\r
    Item22 = 22 #%(T_46_META_WS_E_TOILETBOWL)\r
	@ApiLevel=4\r
	@ScriptName=Fence\r
    Item23 = 23 #%(T_46_META_WS_E_FENCE)\r
	@ApiLevel=4\r
	@ScriptName=BreakableContainer\r
    DestructibleContainer = 24 #%(T_46_META_WS_E_BREAKABLECONTAINER)\r
	@ApiLevel=4\r
	@ScriptName=BreakableFence\r
    DestructibleFence = 25 #%(T_46_META_WS_E_BREAKABLEFENCE)\r
	@ApiLevel=4\r
	@ScriptName=BounceTire\r
    BounceTire = 28 #%(T_46_META_WS_E_BOUNCETIRE)\r
	@ApiLevel=4\r
	@ScriptName=Bumpercar\r
    Item32 = 32 #%(T_46_META_WS_E_BUMPERCAR)\r
	@ApiLevel=4\r
	@ScriptName=AmphibianCar\r
    Item33 = 33 #%(T_46_META_WS_E_AMPHIBIANCAR)\r
	@ApiLevel=4\r
	@ScriptName=Jeep\r
    Item34 = 34 #%(T_46_META_WS_E_JEEP)\r
	@ApiLevel=4\r
	@ScriptName=Trashcan\r
    Item35 = 35 #%(T_46_META_WS_E_TRASHCAN)\r
	@ApiLevel=4\r
	@ScriptName=MedicalTent\r
    Item37 = 37 #%(T_46_META_WS_E_MEDICALTENT)\r
	@ApiLevel=4\r
	@ScriptName=Garage\r
    Item38 = 38 #%(T_46_META_WS_E_GARAGE)\r
	@ApiLevel=4\r
	@ScriptName=PaintedWalls\r
    Item39 = 39 #%(T_46_META_WS_E_PAINTEDWALLS)\r
	@ApiLevel=4\r
	@ScriptName=Torii\r
    Item40 = 40 #%(T_46_META_WS_E_TORII)\r
	@ApiLevel=4\r
	@ScriptName=IronPlatform\r
    Item41 = 41 #%(T_46_META_WS_E_IRONPLATFORM)\r
	@ApiLevel=4\r
	@ScriptName=SiteHut\r
    Item42 = 42 #%(T_46_META_WS_E_SITEHUT)\r
	@ApiLevel=4\r
	@ScriptName=Trailer\r
    Item43 = 43 #%(T_46_META_WS_E_TRAILER)\r
	@ApiLevel=4\r
	@ScriptName=WallA\r
    Item44 = 44 #%(T_46_META_WS_E_WALLA)\r
	@ApiLevel=4\r
	@ScriptName=PianoKey1\r
    Item51 = 51 #%(T_46_META_WS_E_PIANOKEY1)\r
	@ApiLevel=4\r
	@ScriptName=PianoKey2\r
    Item52 = 52 #%(T_46_META_WS_E_PIANOKEY2)\r
	@ApiLevel=4\r
	@ScriptName=DrumKey1\r
    Item53 = 53 #%(T_46_META_WS_E_DRUMKEY1)\r
	@ApiLevel=4\r
	@ScriptName=DrumKey2\r
    Item54 = 54 #%(T_46_META_WS_E_DRUMKEY2)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyA1\r
    Item55 = 55 #%(T_46_META_WS_E_COMBOKEYA1)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyA2\r
    Item56 = 56 #%(T_46_META_WS_E_COMBOKEYA2)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyB1\r
    Item57 = 57 #%(T_46_META_WS_E_COMBOKEYB1)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyB2\r
    Item58 = 58 #%(T_46_META_WS_E_COMBOKEYB2)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyC1\r
    Item59 = 59 #%(T_46_META_WS_E_COMBOKEYC1)\r
	@ApiLevel=4\r
	@ScriptName=ComboKeyC2\r
    Item60 = 60 #%(T_46_META_WS_E_COMBOKEYC2)\r
	@ApiLevel=4\r
	@ScriptName=BuffGenerator\r
    Item61 = 61 #%(T_46_META_WS_E_BUFFGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=Fan\r
    Item62 = 62 #%(T_46_META_WS_E_FAN)\r
	@ApiLevel=4\r
	@ScriptName=FlyPan\r
    Item63 = 63 #%(T_46_META_WS_E_FLYPAN)\r
	@ApiLevel=4\r
	@ScriptName=Cube\r
    Item64 = 64 #%(T_46_META_WS_E_CUBE)\r
	@ApiLevel=4\r
	@ScriptName=Ring\r
    Item65 = 65 #%(T_46_META_WS_E_RING)\r
	@ApiLevel=4\r
	@ScriptName=Hammer\r
    Item66 = 66 #%(T_46_META_WS_E_HAMMER)\r
	@ApiLevel=4\r
	@ScriptName=Board\r
    Item67 = 67 #%(T_46_META_WS_E_BOARD)\r
	@ApiLevel=4\r
	@ScriptName=ShootingTarget\r
    Item68 = 68 #%(T_46_META_WS_E_SHOOTINGTARGET)\r
	@ApiLevel=4\r
	@ScriptName=FlexWall\r
    Item69 = 69 #%(T_46_META_WS_E_FLEXWALL)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBox\r
    Item70 = 70 #%(T_46_META_WS_E_LOOTITEMBOX)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxAmmo\r
    Item71 = 71 #%(T_46_META_WS_E_LOOTITEMBOXAMMO)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxConsumableItem\r
    Item72 = 72 #%(T_46_META_WS_E_LOOTITEMBOXCONSUMABLEITEM)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxProjectile\r
    Item73 = 73 #%(T_46_META_WS_E_LOOTITEMBOXPROJECTILE)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxSight\r
    Item74 = 74 #%(T_46_META_WS_E_LOOTITEMBOXSIGHT)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxArmor\r
    Item75 = 75 #%(T_46_META_WS_E_LOOTITEMBOXARMOR)\r
	@ApiLevel=4\r
	@ScriptName=IPipe\r
    Item76 = 76 #%(T_46_META_WS_E_IPIPE)\r
	@ApiLevel=4\r
	@ScriptName=TPipe\r
    Item77 = 77 #%(T_46_META_WS_E_TPIPE)\r
	@ApiLevel=4\r
	@ScriptName=PipeIntersection\r
    Item78 = 78 #%(T_46_META_WS_E_PIPEINTERSECTION)\r
	@ApiLevel=4\r
	@ScriptName=PipeCorner\r
    Item79 = 79 #%(T_46_META_WS_E_PIPECORNER)\r
	@ApiLevel=4\r
	@ScriptName=MushShade\r
    Item80 = 80 #%(T_46_META_WS_E_MUSHSHADE)\r
	@ApiLevel=4\r
	@ScriptName=Hanger\r
    Item81 = 81 #%(T_46_META_WS_E_HANGER)\r
	@ApiLevel=4\r
	@ScriptName=WoodenPlank\r
    Item82 = 82 #%(T_46_META_WS_E_WOODENPLANK)\r
	@ApiLevel=4\r
	@ScriptName=LatticeScreen\r
    Item83 = 83 #%(T_46_META_WS_E_LATTICESCREEN)\r
	@ApiLevel=4\r
	@ScriptName=Pillar\r
    Item84 = 84 #%(T_46_META_WS_E_PILLAR)\r
	@ApiLevel=4\r
	@ScriptName=Cactus\r
    Item85 = 85 #%(T_46_META_WS_E_CACTUS)\r
	@ApiLevel=4\r
	@ScriptName=LeaflessTree\r
    Item86 = 86 #%(T_46_META_WS_E_LEAFLESSTREE)\r
	@ApiLevel=4\r
	@ScriptName=StoneLantern\r
    Item87 = 87 #%(T_46_META_WS_E_STONELANTERN)\r
	@ApiLevel=4\r
	@ScriptName=Streetlamp\r
    Item88 = 88 #%(T_46_META_WS_E_STREETLAMP)\r
	@ApiLevel=4\r
	@ScriptName=SolarPanel\r
    Item89 = 89 #%(T_46_META_WS_E_SOLARPANEL)\r
	@ApiLevel=4\r
	@ScriptName=AirConditionerA\r
    Item90 = 90 #%(T_46_META_WS_E_AIRCONDITIONERA)\r
	@ApiLevel=4\r
	@ScriptName=Block\r
    Item91 = 91 #%(T_46_META_WS_E_BLOCK)\r
	@ApiLevel=4\r
	@ScriptName=Slope\r
    Item92 = 92 #%(T_46_META_WS_E_SLOPE)\r
	@ApiLevel=4\r
	@ScriptName=FoodTruck\r
    Item95 = 95 #%(T_46_META_WS_E_FOODTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=StatusTrigger\r
    Item96 = 96 #%(T_46_META_WS_E_STATUSTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CheckPoint\r
    Item97 = 97 #%(T_46_META_WS_E_CHECKPOINT)\r
	@ApiLevel=4\r
	@ScriptName=FinishingPoint\r
    Item98 = 98 #%(T_46_META_WS_E_FINISHINGPOINT)\r
	@ApiLevel=4\r
	@ScriptName=GiantDice\r
    Item99 = 99 #%(T_46_META_WS_E_GIANTDICE)\r
	@ApiLevel=4\r
	@ScriptName=Bench\r
    Item100 = 100 #%(T_46_META_WS_E_BENCH)\r
	@ApiLevel=4\r
	@ScriptName=BusStop\r
    Item101 = 101 #%(T_46_META_WS_E_BUSSTOP)\r
	@ApiLevel=4\r
	@ScriptName=DogHouse\r
    Item102 = 102 #%(T_46_META_WS_E_DOGHOUSE)\r
	@ApiLevel=4\r
	@ScriptName=AdBoard\r
    Item103 = 103 #%(T_46_META_WS_E_ADBOARD)\r
	@ApiLevel=4\r
	@ScriptName=RefineryTank\r
    Item104 = 104 #%(T_46_META_WS_E_REFINERYTANK)\r
	@ApiLevel=4\r
	@ScriptName=GraffitiWall\r
    Item105 = 105 #%(T_46_META_WS_E_GRAFFITIWALL)\r
	@ApiLevel=4\r
	@ScriptName=Stable\r
    Item106 = 106 #%(T_46_META_WS_E_STABLE)\r
	@ApiLevel=4\r
	@ScriptName=StoneBridge\r
    Item107 = 107 #%(T_46_META_WS_E_STONEBRIDGE)\r
	@ApiLevel=4\r
	@ScriptName=SunShade\r
    Item108 = 108 #%(T_46_META_WS_E_SUNSHADE)\r
	@ApiLevel=4\r
	@ScriptName=FinishLineArch\r
    Item109 = 109 #%(T_46_META_WS_E_FINISHLINEARCH)\r
	@ApiLevel=4\r
	@ScriptName=Tower\r
    Item110 = 110 #%(T_46_META_WS_E_TOWER)\r
	@ApiLevel=4\r
	@ScriptName=MonsterSpawn\r
    Item111 = 111 #%(T_46_META_WS_E_MONSTERSPAWN)\r
	@ApiLevel=4\r
	@ScriptName=Marker\r
    Item113 = 113 #%(T_46_META_WS_E_MARKER)\r
	@ApiLevel=4\r
	@ScriptName=MiniSentry\r
    Item114 = 114 #%(T_46_META_WS_E_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=CustomTrigger\r
    CustomTrigger = 117 #%(T_46_META_WS_E_CUSTOMTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=DoubleDoor\r
    Item118 = 118 #%(T_46_META_WS_E_DOUBLEDOOR)\r
	@ApiLevel=4\r
	@ScriptName=Roadblock\r
    Item119 = 119 #%(T_46_META_WS_E_ROADBLOCK)\r
	@ApiLevel=4\r
	@ScriptName=Stairs\r
    Item120 = 120 #%(T_46_META_WS_E_STAIRS)\r
	@ApiLevel=4\r
	@ScriptName=LandingB\r
    Item121 = 121 #%(T_46_META_WS_E_LANDINGB)\r
	@ApiLevel=4\r
	@ScriptName=LandingA\r
    Item122 = 122 #%(T_46_META_WS_E_LANDINGA)\r
	@ApiLevel=4\r
	@ScriptName=PhoneBooth\r
    Item123 = 123 #%(T_46_META_WS_E_PHONEBOOTH)\r
	@ApiLevel=4\r
	@ScriptName=BISGraffitiWall\r
    Item124 = 124 #%(T_46_META_WS_E_BISGRAFFITIWALL)\r
	@ApiLevel=4\r
	@ScriptName=GraffitiFlowerbed\r
    Item125 = 125 #%(T_46_META_WS_E_GRAFFITIFLOWERBED)\r
	@ApiLevel=4\r
	@ScriptName=VendingMachine\r
    VendingMachine = 126 #%(T_46_META_WS_E_VENDINGMACHINE)\r
	@ApiLevel=4\r
	@ScriptName=Monster\r
    Item127 = 127 #%(T_46_META_WS_E_MONSTER)\r
	@ApiLevel=4\r
	@ScriptName=UnitGenerator\r
    Item128 = 128 #%(T_46_META_WS_E_UNITGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=SuperCar\r
    Item129 = 129 #%(T_46_META_WS_E_SUPERCAR)\r
	@ApiLevel=4\r
	@ScriptName=TuTuCar\r
    Item130 = 130 #%(T_46_META_WS_E_TUTUCAR)\r
	@ApiLevel=4\r
	@ScriptName=BreakableBox\r
    DestructibleBox = 131 #%(T_46_META_WS_E_BREAKABLEBOX)\r
	@ApiLevel=4\r
	@ScriptName=PickUpTruck\r
    Item132 = 132 #%(T_46_META_WS_E_PICKUPTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=Motobike\r
    Item133 = 133 #%(T_46_META_WS_E_MOTOBIKE)\r
	@ApiLevel=4\r
	@ScriptName=MonsterTruck\r
    Item134 = 134 #%(T_46_META_WS_E_MONSTERTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=CoinGenerator\r
    CoinGenerator = 135 #%(T_46_META_WS_E_COINGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=LandingC\r
    Item136 = 136 #%(T_46_META_WS_E_LANDINGC)\r
	@ApiLevel=4\r
	@ScriptName=DirectionSign\r
    Item137 = 137 #%(T_46_META_WS_E_DIRECTIONSIGN)\r
	@ApiLevel=4\r
	@ScriptName=IronFence\r
    Item138 = 138 #%(T_46_META_WS_E_IRONFENCE)\r
	@ApiLevel=4\r
	@ScriptName=JerseyMachine\r
    Wardrobe = 139 #%(T_46_META_WS_E_JERSEYMACHINE)\r
	@ApiLevel=4\r
	@ScriptName=Football\r
    Item140 = 140 #%(T_46_META_WS_E_FOOTBALL)\r
	@ApiLevel=4\r
	@ScriptName=ConcretePillar\r
    Item141 = 141 #%(T_46_META_WS_E_CONCRETEPILLAR)\r
	@ApiLevel=4\r
	@ScriptName=LootItemBoxSoccer\r
    Item184 = 184 #%(T_46_META_WS_E_LOOTITEMBOXSOCCER)\r
	@ApiLevel=4\r
	@ScriptName=JerryCan\r
    Item187 = 187 #%(T_46_META_WS_E_JERRYCAN)\r
	@ApiLevel=4\r
	@ScriptName=AbnormalGravZone\r
    Item188 = 188 #%(T_46_META_WS_E_ABNORMALGRAVZONE)\r
	@ApiLevel=4\r
	@ScriptName=WeaponGenerator\r
    Item189 = 189 #%(T_46_META_WS_E_WEAPONGENERATOR)\r
	@ApiLevel=4\r
	@ScriptName=IronFenceB\r
    Item191 = 191 #%(T_46_META_WS_E_IRONFENCEB)\r
	@ApiLevel=4\r
	@ScriptName=BrickHouseA\r
    Item192 = 192 #%(T_46_META_WS_E_BRICKHOUSEA)\r
	@ApiLevel=4\r
	@ScriptName=DamagedTruck\r
    Item193 = 193 #%(T_46_META_WS_E_DAMAGEDTRUCK)\r
	@ApiLevel=4\r
	@ScriptName=BasicSphere\r
    Item176 = 209 #%(T_46_META_WS_E_BASICSPHERE)\r
	@ApiLevel=4\r
	@ScriptName=BasicCone\r
    Item211 = 211 #%(T_46_META_WS_E_BASICCONE)\r
	@ApiLevel=4\r
	@ScriptName=BasicCylinder\r
    Item212 = 212 #%(T_46_META_WS_E_BASICCYLINDER)\r
	@ApiLevel=4\r
	@ScriptName=Itementity\r
    Item213 = 213 #%(T_46_META_WS_E_ITEMENTITY)\r
	@ApiLevel=4\r
	@ScriptName=CustomWaterZone\r
    Item215 = 215 #%(T_46_META_WS_E_CUSTOMWATERZONE)\r
	@ApiLevel=4\r
	@ScriptName=Arrow\r
    Item218 = 218 #%(T_46_META_WS_E_ARROW)\r
	@ApiLevel=4\r
	@ScriptName=ColorBlock\r
    Item220 = 220 #%(T_46_META_WS_E_COLORBLOCK)\r
	@ApiLevel=3\r
	@ScriptName=ColorOilBarrel\r
    Item221 = 221 #%(T_46_META_WS_E_COLOROILBARREL)\r
	@ApiLevel=4\r
	@ScriptName=TextObject\r
    Item115 = 222 #%(T_46_META_WS_E_TEXTOBJECT)\r
	@ApiLevel=4\r
	@ScriptName=IconObject\r
    Item116 = 223 #%(T_46_META_WS_E_ICONOBJECT)\r
	@ApiLevel=4\r
	@ScriptName=BlueDoll\r
    Item225 = 225 #%(T_46_META_WS_E_BLUEDOLL)\r
	@ApiLevel=4\r
	@ScriptName=CapsuleTrigger\r
    Item237 = 237 #%(T_46_META_WS_E_CAPSULETRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=SphereTrigger\r
    Item238 = 238 #%(T_46_META_WS_E_SPHERETRIGGER)\r
	@ApiLevel=3\r
	@ScriptName=ReflectiveCube\r
    Item239 = 239 #%(T_46_META_WS_E_REFLECTIVECUBE)\r
	@ApiLevel=3\r
	@ScriptName=BumperCarFactory\r
    Item240 = 240 #%(T_46_META_WS_E_BUMPERCARFACTORY)\r
	@ApiLevel=3\r
	@ScriptName=PlaidAmusementParkCube\r
    Item241 = 241 #%(T_46_META_WS_E_PLAIDAMUSEMENTPARKCUBE)\r
	@ApiLevel=3\r
	@ScriptName=Billboard\r
    Item253 = 253 #%(T_46_META_WS_E_BILLBOARD)\r
	@ApiLevel=3\r
	@ScriptName=Podium\r
    Item254 = 254 #%(T_46_META_WS_E_PODIUM)\r
	@ApiLevel=3\r
	@ScriptName=GiantLollipop\r
    Item255 = 255 #%(T_46_META_WS_E_GIANTLOLLIPOP)\r
	@ApiLevel=3\r
	@ScriptName=FoodTruckB\r
    Item256 = 256 #%(T_46_META_WS_E_FOODTRUCKB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PropertyModifyType\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
enum PropertyModifyType : Int = 94 { #%(T_46_META_WS_C_PROPERTYMODIFYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Add\r
    Add = 1 #%(T_46_META_WS_E_ADD)\r
	@ApiLevel=4\r
	@ScriptName=Multiply\r
    Mul = 2 #%(T_46_META_WS_E_MULTIPLY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CoinGenerator\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CoinGenerator : CustomizeTrigger = 95 { #%(T_46_META_WS_C_COINGENERATOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=MoneyType\r
    MoneyType : MoneyType = -95000 #%(T_46_META_WS_P_MONEYTYPE)\r
	@ApiLevel=4\r
	@Default=500\r
	@ScriptName=Count\r
    Count : Float = -95001 #%(T_46_META_WS_P_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WalletHud\r
@ModuleID=20\r
@ModuleLib=Economy\r
type WalletHud : InternalHud = 96 { #%(T_46_META_WS_C_WALLETHUD)\r
	@ApiLevel=4\r
	@ScriptName=BoundWallet\r
    BindMoneyEntity : Money = -96000 #%(T_46_META_WS_P_BOUNDWALLET)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(-32, -15, 0)\r
	@ScriptName=Offset\r
    Offset : Vector3 = -96001 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=Scale\r
    Scale : Vector3 = -96002 #%(T_46_META_WS_P_SCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITextTip\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TextTipsHud : InternalHud = 158 { #%(T_46_META_WS_C_UITEXTTIP)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -158000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -158001 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@Default=9\r
	@ScriptName=AnchorType\r
    EUIAnchor : Int = -158002 #%(T_46_META_WS_P_ANCHORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    LocalPosition : Vector3 = -158003 #%(T_46_META_WS_P_LOCALPOSITION)\r
	@ApiLevel=4\r
	@Default=24\r
	@ScriptName=FontSize\r
    FontSize : Int = -158004 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=FontColor\r
    Color : Color = -158005 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=LabelKey\r
    LabelKey : String = -158006 #%(T_46_META_WS_P_LABELKEY)\r
	@ApiLevel=4\r
	@ScriptName=LabelParams\r
    LabelParams : List = -158007 #%(T_46_META_WS_P_LABELPARAMS)\r
	@ApiLevel=4\r
	@ScriptName=TweenerEnabled\r
    TweenerEnabled : Bool = -158008 #%(T_46_META_WS_P_TWEENERENABLED)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    Duration : Float = -158009 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITwoTeamScorePanel\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TwoTeamMatchResultHud : InternalHud = 190 { #%(T_46_META_WS_C_UITWOTEAMSCOREPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -190000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=Result\r
    Result : MatchResultType = -190001 #%(T_46_META_WS_P_RESULT)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamName\r
    LeftTeamName : String = -190002 #%(T_46_META_WS_P_LEFTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamName\r
    RightTeamName : String = -190003 #%(T_46_META_WS_P_RIGHTTEAMNAME)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeam\r
    LeftTeam : Entity = -190004 #%(T_46_META_WS_P_LEFTTEAM)\r
	@ApiLevel=4\r
	@ScriptName=RightTeam\r
    RightTeam : Entity = -190005 #%(T_46_META_WS_P_RIGHTTEAM)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
    PlayerList : ListT_Player = -190006 #%(T_46_META_WS_P_PLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=LeftTeamScore\r
    LeftTeamScore : String = -190007 #%(T_46_META_WS_P_LEFTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=RightTeamScore\r
    RightTeamScore : String = -190008 #%(T_46_META_WS_P_RIGHTTEAMSCORE)\r
	@ApiLevel=4\r
	@ScriptName=Titles\r
    TitleList : ListT_LocString = -190009 #%(T_46_META_WS_P_TITLES)\r
	@ApiLevel=4\r
	@ScriptName=Scores1\r
    ScoreList1 : ListT_Object = -190010 #%(T_46_META_WS_P_SCORES1)\r
	@ApiLevel=4\r
	@ScriptName=Scores2\r
    ScoreList2 : ListT_Object = -190011 #%(T_46_META_WS_P_SCORES2)\r
	@ApiLevel=4\r
	@ScriptName=Scores3\r
    ScoreList3 : ListT_Object = -190012 #%(T_46_META_WS_P_SCORES3)\r
	@ApiLevel=4\r
	@ScriptName=WinMVPs\r
    WinMVPList : ListT_Player = -190013 #%(T_46_META_WS_P_WINMVPS)\r
	@ApiLevel=4\r
	@ScriptName=LoseMVPs\r
    LoseMVPList : ListT_Player = -190014 #%(T_46_META_WS_P_LOSEMVPS)\r
	@ApiLevel=10\r
	@Default=true\r
	@ScriptName=ShowMatchDetail\r
    ShowMatchDetail : Bool = -190015 #%(T_46_META_WS_P_SHOWMATCHDETAIL)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowMapEvaluate\r
    ShowMapEvaluate : Bool = -190016 #%(T_46_META_WS_P_SHOWMAPEVALUATE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowGift\r
    ShowGift : Bool = -190017 #%(T_46_META_WS_P_SHOWGIFT)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowReport\r
    ShowReport : Bool = -190018 #%(T_46_META_WS_P_SHOWREPORT)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=ShowReplay\r
    ShowReplay : Bool = -190019 #%(T_46_META_WS_P_SHOWREPLAY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowShare\r
    ShowShare : Bool = -190020 #%(T_46_META_WS_P_SHOWSHARE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLobby\r
    ShowLobby : Bool = -190021 #%(T_46_META_WS_P_SHOWLOBBY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLike\r
    ShowLike : Bool = -190022 #%(T_46_META_WS_P_SHOWLIKE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowAddFriend\r
    ShowFriend : Bool = -190023 #%(T_46_META_WS_P_SHOWADDFRIEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIMultiTeamResultPanel\r
@ModuleID=31\r
@ModuleLib=Hud\r
type MultiTeamMatchResultHud : InternalHud = 193 { #%(T_46_META_WS_C_UIMULTITEAMRESULTPANEL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -193000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@ScriptName=MatchTitleLeft\r
    MatchTitle1 : String = -193001 #%(T_46_META_WS_P_MATCHTITLELEFT)\r
	@ApiLevel=4\r
	@ScriptName=MatchTitleRight\r
    MatchTitle2 : String = -193002 #%(T_46_META_WS_P_MATCHTITLERIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Result\r
    Result : MatchResultType = -193003 #%(T_46_META_WS_P_RESULT)\r
	@ApiLevel=4\r
	@ScriptName=TeamRank\r
    TeamRank : ListT_Entity = -193004 #%(T_46_META_WS_P_TEAMRANK)\r
	@ApiLevel=4\r
	@ScriptName=PlayerRank\r
    PlayerRank : ListT_Player = -193005 #%(T_46_META_WS_P_PLAYERRANK)\r
	@ApiLevel=4\r
	@ScriptName=TeamRankDisplay\r
    TeamRank4Display : ListT_String = -193006 #%(T_46_META_WS_P_TEAMRANKDISPLAY)\r
	@ApiLevel=4\r
	@ScriptName=MainScoreTitle\r
    MainScoreTitle : String = -193007 #%(T_46_META_WS_P_MAINSCORETITLE)\r
	@ApiLevel=4\r
	@ScriptName=MainScoreList\r
    MainScoreList : ListT_Int = -193008 #%(T_46_META_WS_P_MAINSCORELIST)\r
	@ApiLevel=4\r
	@ScriptName=TitleList\r
    TitleList : ListT_LocString = -193009 #%(T_46_META_WS_P_TITLELIST)\r
	@ApiLevel=4\r
	@ScriptName=Scores1\r
    ScoreList1 : ListT_Object = -193010 #%(T_46_META_WS_P_SCORES1)\r
	@ApiLevel=4\r
	@ScriptName=Scores2\r
    ScoreList2 : ListT_Object = -193011 #%(T_46_META_WS_P_SCORES2)\r
	@ApiLevel=4\r
	@ScriptName=Scores3\r
    ScoreList3 : ListT_Object = -193012 #%(T_46_META_WS_P_SCORES3)\r
	@ApiLevel=4\r
	@ScriptName=Scores4\r
    ScoreList4 : ListT_Object = -193013 #%(T_46_META_WS_P_SCORES4)\r
	@ApiLevel=4\r
	@ScriptName=Scores5\r
    ScoreList5 : ListT_Object = -193014 #%(T_46_META_WS_P_SCORES5)\r
	@ApiLevel=4\r
	@ScriptName=WinMVPs\r
    WinMVPList : ListT_Player = -193015 #%(T_46_META_WS_P_WINMVPS)\r
	@ApiLevel=4\r
	@ScriptName=LoseMVPs\r
    LoseMVPList : ListT_Player = -193016 #%(T_46_META_WS_P_LOSEMVPS)\r
	@ApiLevel=10\r
	@Default=true\r
	@ScriptName=ShowMatchDetail\r
    ShowMatchDetail : Bool = -193017 #%(T_46_META_WS_P_SHOWMATCHDETAIL)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ShowMapEvaluate\r
    ShowMapEvaluate : Bool = -193018 #%(T_46_META_WS_P_SHOWMAPEVALUATE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowGift\r
    ShowGift : Bool = -193019 #%(T_46_META_WS_P_SHOWGIFT)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowReport\r
    ShowReport : Bool = -193020 #%(T_46_META_WS_P_SHOWREPORT)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=ShowReplay\r
    ShowReplay : Bool = -193021 #%(T_46_META_WS_P_SHOWREPLAY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowShare\r
    ShowShare : Bool = -193022 #%(T_46_META_WS_P_SHOWSHARE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLobby\r
    ShowLobby : Bool = -193023 #%(T_46_META_WS_P_SHOWLOBBY)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowLike\r
    ShowLike : Bool = -193024 #%(T_46_META_WS_P_SHOWLIKE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=ShowAddFriend\r
    ShowFriend : Bool = -193025 #%(T_46_META_WS_P_SHOWADDFRIEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Football\r
@ModuleID=10006\r
@ModuleLib=Football\r
type Football : LevelObject = 99 { #%(T_46_META_WS_C_FOOTBALL)\r
	@ApiLevel=4\r
	@ScriptName=Radius\r
    Radius : Float = -99000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@ScriptName=RollingFrictionCoeff\r
    RollingFrictionCoeff : Float = -99001 #%(T_46_META_WS_P_ROLLINGFRICTIONCOEFF)\r
	@ApiLevel=4\r
	@ScriptName=RollingFrictionCoeffRushing\r
    RollingFrictionCoeff_Rushing : Float = -99002 #%(T_46_META_WS_P_ROLLINGFRICTIONCOEFFRUSHING)\r
	@ApiLevel=4\r
	@ScriptName=ShootAngleMin\r
    ShootAngleMin : Int = -99003 #%(T_46_META_WS_P_SHOOTANGLEMIN)\r
	@ApiLevel=4\r
	@ScriptName=HighShootAngleMin\r
    HighShootAngleMin : Int = -99004 #%(T_46_META_WS_P_HIGHSHOOTANGLEMIN)\r
	@ApiLevel=4\r
	@ScriptName=ResetTime\r
    HideTime : Int = -99005 #%(T_46_META_WS_P_RESETTIME)\r
	@ApiLevel=4\r
	@ScriptName=ShootAngleMax\r
    ShootAngleMax : Int = -99006 #%(T_46_META_WS_P_SHOOTANGLEMAX)\r
	@ApiLevel=4\r
	@ScriptName=ResetPosition\r
    InitPos : Vector3 = -99007 #%(T_46_META_WS_P_RESETPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JerseyMachine\r
@ModuleID=10006\r
@ModuleLib=Football\r
type Wardrobe : CustomizeTrigger = 100 { #%(T_46_META_WS_C_JERSEYMACHINE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TriggerRadius\r
    TriggerRadius : Float = -100000 #%(T_46_META_WS_P_TRIGGERRADIUS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=ModelVisible\r
    ModelShow : Bool = -100001 #%(T_46_META_WS_P_MODELVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphObject\r
@ModuleID=22\r
@ModuleLib=Morph\r
type MorphObject : LevelObject&Appearance = 101 { #%(T_46_META_WS_C_MORPHOBJECT)\r
	@ApiLevel=3\r
	@ScriptName=Player\r
    Player : Player = -101000 #%(T_46_META_WS_P_PLAYER)\r
	@ApiLevel=3\r
	@ScriptName=TargetItemID\r
    get TargetItemID : LevelObjectID = -101001 #%(T_46_META_WS_P_TARGETITEMID)\r
	@ApiLevel=3\r
	@Default=math.Vector3_Z()\r
	@ScriptName=TargetRotation\r
    get TargetRotation : Vector3 = -101002 #%(T_46_META_WS_P_TARGETROTATION)\r
	@ApiLevel=3\r
	@Default=math.Vector3_1()\r
	@ScriptName=TargetScale\r
    get TargetScale : Vector3 = -101003 #%(T_46_META_WS_P_TARGETSCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationState\r
@ModuleID=35\r
@ModuleLib=Animation\r
type AnimationState : Entity = 295 { #%(T_46_META_WS_C_ANIMATIONSTATE)\r
	@ApiLevel=10\r
	@ScriptName=Name\r
    get Name : String = -295000 #Name\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
    IsLoop : Bool = -295001 #%(T_46_META_WS_P_ISLOOP)\r
	@ApiLevel=4\r
	@ScriptName=PlaySpeed\r
    Speed : Float = -295002 #%(T_46_META_WS_P_PLAYSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationClip\r
@ModuleID=35\r
@ModuleLib=Animation\r
type AnimationClip : Entity = 296 { #%(T_46_META_WS_C_ANIMATIONCLIP)\r
	@ApiLevel=10\r
	@ScriptName=Name\r
    get Name : String = -296000 #Name\r
	@ApiLevel=4\r
	@ScriptName=ClipLength\r
    get Length : Float = -296001 #%(T_46_META_WS_P_CLIPLENGTH)\r
	@ApiLevel=4\r
	@ScriptName=PlaySpeed\r
    Speed : Float = -296002 #%(T_46_META_WS_P_PLAYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
    IsLoop : Bool = -296003 #%(T_46_META_WS_P_ISLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationController\r
@ModuleID=35\r
@ModuleLib=Animation\r
type AnimationController : Entity = 297 { #%(T_46_META_WS_C_ANIMATIONCONTROLLER)\r
	@ApiLevel=4\r
	@ScriptName=AttachTarget\r
    get AttachTarget : Entity = -297000 #%(T_46_META_WS_P_ATTACHTARGET)\r
	@ApiLevel=10\r
	@ScriptName=CurrentState\r
    get CurrentState : AnimationState = -297001 #%(T_46_META_WS_P_CURRENTSTATE)\r
	@ApiLevel=10\r
	@ScriptName=CurrentClip\r
    get CurrentClip : AnimationClip = -297002 #%(T_46_META_WS_P_CURRENTCLIP)\r
	@ApiLevel=10\r
	@ScriptName=CurrentClipProgress\r
    get CurrentClipProgress : Float = -297003 #%(T_46_META_WS_P_CURRENTCLIPPROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
    get ResUUID : String = -297004 #%(T_46_META_WS_P_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LoopType\r
@ModuleID=35\r
@ModuleLib=Animation\r
enum AnimationOverrideLoopType : Int = 298 { #%(T_46_META_WS_C_LOOPTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
    DontChange = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=Loop\r
    Loop = 1 #%(T_46_META_WS_E_LOOP)\r
	@ApiLevel=4\r
	@ScriptName=Once\r
    Once = 2 #%(T_46_META_WS_E_ONCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerReviveSourceType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerReviveSourceType : Int = 102 { #%(T_46_META_WS_C_PLAYERREVIVESOURCETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Death\r
    Death = 1 #%(T_46_META_WS_E_DEATH)\r
	@ApiLevel=4\r
	@ScriptName=KnockDown\r
    KnockDown = 2 #%(T_46_META_WS_E_KNOCKDOWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EquipmentType\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum EquipSlotType : Int = 103 { #%(T_46_META_WS_C_EQUIPMENTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponA\r
    PrimaryWeapon1 = 0 #%(T_46_META_WS_E_PRIMARYWEAPONA)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponB\r
    PrimaryWeapon2 = 1 #%(T_46_META_WS_E_PRIMARYWEAPONB)\r
	@ApiLevel=4\r
	@ScriptName=SecondaryWeapon\r
    SecondaryWeapon = 2 #%(T_46_META_WS_E_SECONDARYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
    ExplosiveWeapon = 3 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
    MeleeWeapon = 4 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=HeavyWeapon\r
    HeavyWeapon = 5 #%(T_46_META_WS_E_HEAVYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
    Helmet = 6 #%(T_46_META_WS_E_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
    Vest = 8 #%(T_46_META_WS_E_VEST)\r
	@ApiLevel=4\r
	@ScriptName=Flash\r
    FlashBomb = 16 #%(T_46_META_WS_E_FLASH)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
    SmokeGrenade = 23 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
    FrozenGrenade = 30 #%(T_46_META_WS_E_FLASHFREEZE)\r
	@ApiLevel=4\r
	@ScriptName=GlooWall\r
    BuildingIceWall = 13 #%(T_46_META_WS_E_GLOOWALL)\r
	@ApiLevel=4\r
	@ScriptName=Landmine\r
    Landmine = 14 #%(T_46_META_WS_E_LANDMINE)\r
	@ApiLevel=4\r
	@ScriptName=MiniSentry\r
    MiniSentry = 17 #%(T_46_META_WS_E_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=Dummy\r
    Dummy = 21 #%(T_46_META_WS_E_DUMMY)\r
	@ApiLevel=4\r
	@ScriptName=PersonalUAV\r
    PersonalUAV = 28 #%(T_46_META_WS_E_PERSONALUAV)\r
	@ApiLevel=4\r
	@ScriptName=FunctionalItems\r
    Camouflage = 12 #%(T_46_META_WS_E_FUNCTIONALITEMS)\r
	@ApiLevel=4\r
	@ScriptName=SnowBall\r
    SnowBall = 31 #%(T_52_META_TYP_103_I17)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EquipmentSlotType\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum EquipmentSlot : Int = 302 { #%(T_46_META_WS_C_EQUIPMENTSLOTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponA\r
    PrimaryWeapon1 = 0 #%(T_46_META_WS_E_PRIMARYWEAPONA)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponB\r
    PrimaryWeapon2 = 1 #%(T_46_META_WS_E_PRIMARYWEAPONB)\r
	@ApiLevel=4\r
	@ScriptName=SecondaryWeapon\r
    SecondaryWeapon = 2 #%(T_46_META_WS_E_SECONDARYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
    MeleeWeapon = 4 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=Helmet\r
    Helmet = 6 #%(T_46_META_WS_E_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Bag\r
    Bag = 7 #%(T_46_META_WS_E_BAG)\r
	@ApiLevel=4\r
	@ScriptName=Vest\r
    Vest = 8 #%(T_46_META_WS_E_VEST)\r
	@ApiLevel=4\r
	@ScriptName=FunctionalItems\r
    Camouflage = 12 #%(T_46_META_WS_E_FUNCTIONALITEMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JerseyStyle\r
@ModuleID=10006\r
@ModuleLib=Football\r
enum CustomizeClothesType : Int = 104 { #%(T_46_META_WS_C_JERSEY STYLE)\r
	@ApiLevel=4\r
	@ScriptName=StyleA\r
    Style1 = 1 #%(T_46_META_WS_E_STYLEA)\r
	@ApiLevel=4\r
	@ScriptName=StyleB\r
    Style2 = 2 #%(T_46_META_WS_E_STYLEB)\r
	@ApiLevel=4\r
	@ScriptName=StyleC\r
    Style3 = 3 #%(T_46_META_WS_E_STYLEC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FootballGoal\r
@ModuleID=10006\r
@ModuleLib=Football\r
type FootballGoal : LevelObject = 105 { #%(T_37_XYL_SOCCERGOAL)\r
	@ApiLevel=10\r
	@ScriptName=Team_Deprecated\r
    get Team : Int = -105000 #%(TXT_ROOM_LOBBY_ID)\r
	@ApiLevel=4\r
	@ScriptName=TeamSeq\r
    get TeamSeq : Int = -105001 #%(T_46_META_WS_P_TEAMSEQ)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AimAssistType\r
@ModuleID=10016\r
@ModuleLib=Combat\r
enum AimAssistType : Int = 106 { #%(T_46_META_WS_C_AIMASSISTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=Enable\r
    Enable = 1 #%(T_46_META_WS_E_ENABLE)\r
	@ApiLevel=4\r
	@ScriptName=Disable\r
    Disable = 2 #%(T_46_META_WS_E_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ChatChannel\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
type ChatChannel : Entity = 109 { #%(T_46_META_WS_C_CHATCHANNEL)\r
	@ApiLevel=3\r
	@ScriptName=ChannelID\r
    get ChannelID : String = -109000 #%(T_46_META_WS_P_CHANNELID)\r
	@ApiLevel=3\r
	@ScriptName=PlayerList\r
    Players : ListT_Player = -109001 #%(T_46_META_WS_P_PLAYERLIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ChatChannelType\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
enum FreeChatChannel : Int = 110 { #%(T_46_META_WS_C_CHATCHANNELTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ChannelA\r
    Channel_1 = 0 #%(T_46_META_WS_E_CHANNELA)\r
	@ApiLevel=4\r
	@ScriptName=ChannelB\r
    Channel_2 = 1 #%(T_46_META_WS_E_CHANNELB)\r
	@ApiLevel=4\r
	@ScriptName=ChannelC\r
    Channel_3 = 2 #%(T_46_META_WS_E_CHANNELC)\r
	@ApiLevel=4\r
	@ScriptName=ChannelD\r
    Channel_4 = 3 #%(T_46_META_WS_E_CHANNELD)\r
	@ApiLevel=4\r
	@ScriptName=ChannelE\r
    Channel_5 = 4 #%(T_46_META_WS_E_CHANNELE)\r
	@ApiLevel=4\r
	@ScriptName=ChannelF\r
    Channel_6 = 5 #%(T_46_META_WS_E_CHANNELF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerBehaviorType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerBehaviorType : Int = 111 { #%(T_46_META_WS_C_PLAYERBEHAVIORTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Move\r
    Movement = 1 #%(T_46_META_WS_E_MOVE)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
    Sprint = 2 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@ScriptName=Attack\r
    Attack = 3 #%(T_46_META_WS_E_ATTACK)\r
	@ApiLevel=4\r
	@ScriptName=Jump\r
    Jump = 4 #%(T_46_META_WS_E_JUMP)\r
	@ApiLevel=4\r
	@ScriptName=VaultOver\r
    Climb = 5 #%(T_46_META_WS_E_VAULTOVER)\r
	@ApiLevel=4\r
	@ScriptName=Drive\r
    Drive = 6 #%(T_46_META_WS_E_DRIVE)\r
	@ApiLevel=4\r
	@ScriptName=EnterVehicle\r
    GetOnDrive = 7 #%(T_46_META_WS_E_ENTERVEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=ExitVehicle\r
    GetOffDrive = 8 #%(T_46_META_WS_E_EXITVEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=DriveVehicle\r
    OpeVehicle = 9 #%(T_46_META_WS_E_DIRVEVEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerBehaviorStatusType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerBehaviorStatus : Int = 112 { #%(T_46_META_WS_C_PLAYERBEHAVIORSTATUSTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Enable\r
    Enable = 0 #%(T_46_META_WS_E_ENABLE)\r
	@ApiLevel=4\r
	@ScriptName=Disable\r
    Disable = 1 #%(T_46_META_WS_E_DISABLE)\r
	@ApiLevel=4\r
	@ScriptName=Invisible\r
    Invisible = 2 #%(T_46_META_WS_E_INVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DrumMusic\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type DrumMusicElement : LevelObject&Collider = 113 { #%(T_46_META_WS_C_DRUMMUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
    get MusicElementType : DrumMusicElementType = -113000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lead1Music\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Lead1MusicElement : LevelObject&Collider = 114 { #%(T_46_META_WS_C_LEAD1MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
    get MusicElementType : Lead1MusicElementType = -114000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lead2Music\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Lead2MusicElement : LevelObject&Collider = 115 { #%(T_46_META_WS_C_LEAD2MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
    get MusicElementType : Lead2MusicElementType = -115000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lead3Music\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Lead3MusicElement : LevelObject&Collider = 116 { #%(T_46_META_WS_C_LEAD3MUSIC)\r
	@ApiLevel=4\r
	@ScriptName=MusicElementType\r
    get MusicElementType : Lead3MusicElementType = -116000 #%(T_46_META_WS_P_MUSICELEMENTTYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Faction\r
@ModuleID=25\r
@ModuleLib=Hostility\r
type Faction : Entity = 118 { #%(T_46_META_WS_C_FACTION)\r
	@ApiLevel=4\r
	@ScriptName=IsAced\r
    get IsACE : Bool = -118000 #%(T_46_META_WS_P_ISACED)\r
	@ApiLevel=4\r
	@ScriptName=AllPlayers\r
    get AllPlayers : ListT_Player = -118001 #%(T_46_META_WS_P_ALLPLAYERS)\r
	@ApiLevel=4\r
	@ScriptName=FriendFactions\r
    get FriendlyFactions : ListT_Faction = -118002 #%(T_46_META_WS_P_FRIENDFACTIONS)\r
	@ApiLevel=4\r
	@ScriptName=AttackableFactions\r
    get HostileFactions : ListT_Faction = -118003 #%(T_46_META_WS_P_ATTACKABLEFACTIONS)\r
	@ApiLevel=4\r
	@ScriptName=IsShowHudName\r
    IsShowHudName : Bool = -118004 #%(T_46_META_WS_P_ISSHOWHUDNAME)\r
	@ApiLevel=4\r
	@ScriptName=IsShowMapInfo\r
    IsShowMapInfo : Bool = -118005 #%(T_46_META_WS_P_ISSHOWMAPINFO)\r
	@ApiLevel=4\r
	@ScriptName=IsShowTag\r
    IsShowTag : Bool = -118006 #%(T_46_META_WS_P_ISSHOWTAG)\r
	@ApiLevel=4\r
	@ScriptName=IsShowScan\r
    IsShowScan : Bool = -118007 #%(T_46_META_WS_P_ISSHOWSCAN)\r
	@ApiLevel=4\r
	@ScriptName=AllMembers\r
    get AllMembers : ListT_Entity = -118008 #%(T_46_META_WS_P_ALLMEMBERS)\r
	@ApiLevel=4\r
	@ScriptName=IsShowQuickMessage\r
    IsShowQuickMessage : Bool = -118009 #%(T_46_META_WS_P_ISSHOWQUICKMESSAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AttackableType\r
@ModuleID=26\r
@ModuleLib=Hostility\r
enum AttackableOption : Int = 119 { #%(T_46_META_WS_C_ATTACKABLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=TRUE\r
    Yes = 1 #%(T_46_META_WS_E_TRUE)\r
	@ApiLevel=4\r
	@ScriptName=FALSE\r
    No = 2 #%(T_46_META_WS_E_FALSE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
    Default = 3 #%(T_46_META_WS_E_DEFAULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphableObject\r
@ModuleID=22\r
@ModuleLib=Morph\r
enum MorphableObject : Int = 128 { #%(T_46_META_WS_C_MORPHABLEOBJECT)\r
	@ApiLevel=4\r
	@ScriptName=Bushes\r
    PeekabooBushCover = 210 #%(T_46_META_WS_E_BUSHES)\r
	@ApiLevel=4\r
	@ScriptName=Pumpkin\r
    Pumpkin = 158 #%(T_46_META_WS_E_PUMPKIN)\r
	@ApiLevel=4\r
	@ScriptName=Scarecrow\r
    JackStraw = 159 #%(T_46_META_WS_E_SCARECROW)\r
	@ApiLevel=4\r
	@ScriptName=Cabinet\r
    Cabinet = 160 #%(T_46_META_WS_E_CABINET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootSoccerType\r
@ModuleID=10006\r
@ModuleLib=Football\r
enum LootSoccerType : Int = 141 { #%(T_46_META_WS_C_LOOTSOCCERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LootSoccerRandom\r
    LootSoccerRandom = 1040 #%(T_46_META_WS_E_LOOTSOCCERRANDOM)\r
	@ApiLevel=4\r
	@ScriptName=LootSoccerShield\r
    LootSoccerShield = 1038 #%(T_46_META_WS_E_LOOTSOCCERSHIELD)\r
	@ApiLevel=4\r
	@ScriptName=LootSoccerIce\r
    LootSoccerIce = 1039 #%(T_46_META_WS_E_LOOTSOCCERICE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LootItemBoxSoccer\r
@ModuleID=10006\r
@ModuleLib=Football\r
type LootItemBoxSoccer : LevelObject&SpawnableEntity&ResetableEntity = 142 { #%(T_46_META_WS_C_LOOTITEMBOXSOCCER)\r
	@ApiLevel=4\r
	@Default=1040\r
	@ScriptName=LootSoccer\r
    LootSoccer : LootSoccerType = -142000 #%(T_46_META_WS_P_LOOTSOCCER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraType\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraType : AssetConfigID = 147 { #%(T_46_META_WS_C_CAMERATYPE)\r
	@ApiLevel=4\r
	@ScriptName=ThirdPersonClassic\r
    Classic = 1 #%(T_46_META_WS_E_THIRDPERSONCLASSIC)\r
	@ApiLevel=4\r
	@ScriptName=ThirdPerson\r
    ThirdPerson = 2 #%(T_46_META_WS_E_THIRDPERSON)\r
	@ApiLevel=4\r
	@ScriptName=FirstPersonClassic\r
    FirstPerson = 3 #%(T_46_META_WS_E_FIRSTPERSONCLASSIC)\r
	@ApiLevel=4\r
	@ScriptName=TopDown\r
    LookDown = 4 #%(T_46_META_WS_E_TOPDOWN)\r
	@ApiLevel=4\r
	@ScriptName=SideScrolling\r
    TwoDimension = 5 #%(T_46_META_WS_E_SIDESCROLLING)\r
	@ApiLevel=4\r
	@ScriptName=Custom\r
    Performance = 6 #%(T_46_META_WS_E_CUSTOM)\r
	@ApiLevel=4\r
	@ScriptName=ThirdPersonLock\r
    ThirdPersonLock = 7 #%(T_46_META_WS_E_THIRDPERSONLOCK)\r
	@ApiLevel=4\r
	@ScriptName=Free\r
    Free = 8 #%(T_46_META_WS_E_FREE)\r
	@ApiLevel=4\r
	@ScriptName=FirstPersonAdvanced\r
    FirstPersonModel = 9 #%(T_46_META_WS_E_FIRSTPERSON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraBlockMode\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraBlockMode : Int = 177 { #%(T_46_META_WS_C_CAMERABLOCKMODE)\r
	@ApiLevel=4\r
	@ScriptName=Stable\r
    Stable = 0 #%(T_39_XXJ_WS_STABLE)\r
	@ApiLevel=4\r
	@ScriptName=Zoom\r
    Zoom = 1 #%(T_46_META_WS_E_ZOOM)\r
	@ApiLevel=4\r
	@ScriptName=Transparent\r
    Invisicam = 2 #%(T_46_META_WS_E_TRANSPARENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraProjectionMode\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraProjectionMode : Int = 178 { #%(T_46_META_WS_C_CAMERAPROJECTIONMODE)\r
	@ApiLevel=4\r
	@ScriptName=Perspective\r
    Perspective = 0 #%(T_46_META_WS_E_PERSPECTIVE)\r
	@ApiLevel=4\r
	@ScriptName=Orthogonal\r
    Orthogonal = 1 #%(T_46_META_WS_E_ORTHOGONAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Camera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
type CameraConfig : Entity = 148 { #%(T_46_META_WS_C_CAMERA)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=CameraType\r
    CameraType : CameraType = -148000 #%(T_46_META_WS_P_CAMERATYPE)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=FOV\r
    Fov : Float = -148001 #%(T_46_META_WS_P_FOV)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -148002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=3\r
	@ScriptName=FocusPoint\r
    Offset2 : Vector3 = -148003 #%(T_39_XXJ_WS_OFFSET2)\r
	@ApiLevel=4\r
	@ScriptName=Pitch\r
    Pitch : Float = -148004 #%(T_46_META_WS_P_PITCH)\r
	@ApiLevel=4\r
	@ScriptName=Yaw\r
    Yaw : Float = -148005 #%(T_46_META_WS_P_YAW)\r
	@ApiLevel=10\r
	@ScriptName=Distance_Deprecated\r
    Distance : Float = -148006 #%(T_39_XXJ_WS_CAMERADISTANCE)\r
	@ApiLevel=3\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -148007 #%(T_39_XXJ_WS_FOLLOWTARGET)\r
	@ApiLevel=3\r
	@ScriptName=FocusTarget\r
    FocusTarget : Entity = -148008 #%(T_39_XXJ_WS_FOCUSTARGET)\r
	@ApiLevel=4\r
	@ScriptName=Owner\r
    get UseEntities : ListT_Player = -148009 #%(T_46_META_WS_P_OWNER)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=CameraTransitionType\r
    get CameraTransitionType : CameraTransitionType = -148010 #%(T_39_XXJ_WS_TRANSITIONTYPE)\r
	@ApiLevel=3\r
	@ScriptName=CameraTransitionTime\r
    CameraTransitionTime : Float = -148011 #%(T_39_XXJ_WS_TRANSITIONTIME)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=CameraBlockMode\r
    CameraBlockMode : CameraBlockMode = -148012 #%(T_46_META_WS_P_CAMERABLOCKMODE)\r
	@ApiLevel=4\r
	@ScriptName=CameraProjectionMode\r
    CameraProjectionMode : CameraProjectionMode = -148013 #%(T_46_META_WS_P_CAMERAPROJECTIONMODE)\r
	@ApiLevel=3\r
	@Default=2\r
	@ScriptName=FollowCoordinateType\r
    FollowCoordinateType : CoordinateType = -148014 #FollowCoordinateType\r
	@ApiLevel=3\r
	@Default=2\r
	@ScriptName=FocusCoordinateType\r
    FocusCoordinateType : CoordinateType = -148015 #FocusCoordinateType\r
	@ApiLevel=3\r
	@Default=65535\r
	@ScriptName=CullingMask\r
    CullingMask : Int = -148016 #%(T_40_XXJ_WS_CULLINGMASK_NAMEKEY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=ViewingAngleRestriction\r
    ViewingAngleRestriction : CameraViewingAngleRestrictionType = -148017 #%(T_46_META_WS_P_VIEWINGANGLERESTRICTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Oildrum\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Oildrum : LevelObject&Collider = 150 { #%(T_46_META_WS_C_OILDRUM)\r
	@ApiLevel=4\r
	@ScriptName=Durability\r
    Durability : Int = -150000 #%(T_46_META_WS_P_DURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=DamageRadius\r
    Radius : Float = -150001 #%(T_46_META_WS_P_DAMAGERADIUS)\r
	@ApiLevel=4\r
	@ScriptName=DamageFactor\r
    DamageFac : Float = -150002 #%(T_46_META_WS_P_DAMAGEFACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LowGravity\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type LowGravity : CustomizeTrigger = 152 { #%(T_46_META_WS_C_LOWGRAVITY)\r
	@ApiLevel=4\r
	@ScriptName=JumpHeight\r
    JumpHeight : Float = -152000 #%(T_46_META_WS_P_JUMPHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=CustomGravity\r
    CustomGravity : Float = -152001 #%(T_46_META_WS_P_CUSTOMGRAVITY)\r
	@ApiLevel=4\r
	@ScriptName=IsShow\r
    get ShowOrHide : Bool = -152002 #%(T_46_META_WS_P_ISSHOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ItemBase\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type InventoryBase : Entity = 198 { #%(T_46_META_WS_C_ITEMBASE)\r
	@ApiLevel=4\r
	@ScriptName=ItemID\r
    get ItemID : ItemGoodsIDType = -198000 #%(T_46_META_WS_P_ITEMID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Helmet\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Helmet : InventoryBase&FormulableEntity = 155 { #%(T_46_META_WS_C_HELMET)\r
	@ApiLevel=4\r
	@ScriptName=Level\r
    get Level : Int = -155000 #%(T_46_META_WS_P_LEVEL)\r
	@ApiLevel=4\r
	@ScriptName=MaxDurability\r
    DurabilityMax : Int = -155001 #%(T_46_META_WS_P_MAXDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=CurrentDurability\r
    Durability : Int = -155002 #%(T_46_META_WS_P_CURRENTDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=DamageReductionFactor\r
    DamageReductionFactor : Int = -155003 #%(T_46_META_WS_P_DAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamageReductionFactor\r
    DamageReductionFactorExplode : Int = -155004 #%(T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDamaged\r
    CostDurability : Bool = -155005 #%(T_46_META_WS_P_CANCOSTDURABILITY)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDestroyed\r
    CanDestroy : Bool = -155006 #%(T_46_META_WS_P_CANDESTROY)\r
	@ApiLevel=10\r
	@ScriptName=Owner_Deprecated\r
    get Owner : Player = -155007 #%(T_38_WZY_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vest\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Vest : InventoryBase&FormulableEntity = 156 { #%(T_46_META_WS_C_VEST)\r
	@ApiLevel=4\r
	@ScriptName=Level\r
    get Level : Int = -156000 #%(T_46_META_WS_P_LEVEL)\r
	@ApiLevel=4\r
	@ScriptName=MaxDurability\r
    DurabilityMax : Int = -156001 #%(T_46_META_WS_P_MAXDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=CurrentDurability\r
    Durability : Int = -156002 #%(T_46_META_WS_P_CURRENTDURABILITY)\r
	@ApiLevel=4\r
	@ScriptName=DamageReductionFactor\r
    DamageReductionFactor : Int = -156003 #%(T_46_META_WS_P_DAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamageReductionFactor\r
    DamageReductionFactorExplode : Int = -156004 #%(T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDamaged\r
    CostDurability : Bool = -156005 #%(T_46_META_WS_P_CANDAMAGED)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=CanDestroyed\r
    CanDestroy : Bool = -156006 #%(T_46_META_WS_P_CANDESTROYED)\r
	@ApiLevel=10\r
	@ScriptName=Owner_Deprecated\r
    get Owner : Player = -156007 #%(T_38_WZY_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraTransitionType\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraTransitionType : Int = 157 { #%(T_46_META_WS_C_CAMERATRANSITIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Default\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=Smooth\r
    Smooth = 1 #%(T_46_META_WS_E_SMOOTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Mushroom\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Mushroom : InventoryBase = 171 { #%(T_46_META_WS_C_MUSHROOM)\r
	@ApiLevel=4\r
	@ScriptName=Energy\r
    Energy : Int = -171000 #%(T_46_META_WS_P_ENERGY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Ammo\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Ammo : InventoryBase = 172 { #%(T_46_META_WS_C_AMMO)\r
	@ApiLevel=4\r
	@ScriptName=Count\r
    Count : Int = -172000 #%(T_46_META_WS_P_COUNT)\r
	@ApiLevel=4\r
    get AmmoType : AmmoType = -172001 #%(T_46_META_WS_P_AMMOTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Backpack\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Bag : InventoryBase = 173 { #%(T_46_META_WS_C_BACKPACK)\r
	@ApiLevel=4\r
	@ScriptName=ExtraBagCapacity\r
    ExtraBagCapacity : Int = -173000 #%(T_46_META_WS_P_EXTRABAGCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=OverloadByPlayerConfiguration\r
    PrioritizePlayerSkin : Bool = -173001 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
    SkinID : BagSkinID = -173002 #%(T_46_META_WS_P_SKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Grenade\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Grenade : InventoryBase&FormulableEntity = 174 { #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=10\r
	@ScriptName=Owner_Deprecated\r
    get Owner : Player = -174000 #%(T_38_WZY_WS_OWNER)\r
	@ApiLevel=4\r
	@ScriptName=MinDamage\r
    MinDamage : Int = -174001 #%(T_46_META_WS_P_MINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=MaxDamage\r
    MaxDamage : Int = -174002 #%(T_46_META_WS_P_MAXDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionRange\r
    Range : Float = -174003 #%(T_46_META_WS_P_EXPLOSIONRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingSpeed\r
    ThrowSpeed : Float = -174004 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionTime\r
    ExplosionTime : Float = -174005 #%(T_46_META_WS_P_EXPLOSIONTIME)\r
	@ApiLevel=4\r
	@ScriptName=SelfDamageFactor\r
    RatioSelf : Float = -174006 #%(T_46_META_WS_P_SELFDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=TeammateDamageFactor\r
    RatioTeammate : Float = -174007 #%(T_46_META_WS_P_TEAMMATEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=VehicleDamageFactor\r
    RatioVehicle : Float = -174008 #%(T_46_META_WS_P_VEHICLEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
    AssetConfigID : WeaponSkinID = -174009 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
    OverloadByPlayerWeaponSkin : Bool = -174010 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeFrozen\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeFrozen : InventoryBase&Grenade = 175 { #%(T_46_META_WS_C_GRENADEFROZEN)\r
	@ApiLevel=4\r
	@ScriptName=Radius\r
    ZoneRadius : Float = -175000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@ScriptName=FrozenAreaDuration\r
    ZoneDuration : Float = -175001 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicSphere\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BasicSphereItem : LevelObject&Appearance&Collider = 179 { #%(T_46_META_WS_C_BASICSPHERE)\r
	@ApiLevel=10\r
	@Default=1\r
	@ScriptName=Radius\r
    Radius : Float = -179000 #%(T_46_META_WS_P_RADIUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BasicCylinder\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BasicCylinderItem : LevelObject&Appearance&Collider = 188 { #%(T_46_META_WS_C_BASICCYLINDER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeFlashbang\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeFlash : InventoryBase&FormulableEntity = 191 { #%(T_46_META_WS_C_GRENADEFLASHBANG)\r
	@ApiLevel=4\r
	@ScriptName=CenterRange\r
    CentralRange : Float = -191000 #%(T_46_META_WS_P_CENTERRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionRange\r
    Range : Float = -191001 #%(T_46_META_WS_P_EXPLOSIONRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingSpeed\r
    ThrowSpeed : Float = -191002 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionDelay\r
    ExplosionTime : Float = -191003 #%(T_46_META_WS_P_EXPLOSIONDELAY)\r
	@ApiLevel=4\r
	@ScriptName=CentralFlashTime\r
    CenterFlashTime : Float = -191004 #%(T_46_META_WS_P_CENTRALFLASHTIME)\r
	@ApiLevel=4\r
	@ScriptName=EdgeFlashTime\r
    EdgeFlashTime : Float = -191005 #%(T_46_META_WS_P_EDGEFLASHTIME)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=FlashbangHitEffectSwitch\r
    HitEffectSwitch : Bool = -191006 #%(T_46_META_WS_P_FLASHBANGHITEFFECTSWITCH)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
    AssetConfigID : WeaponSkinID = -191007 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
    OverloadByPlayerWeaponSkin : Bool = -191008 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeSmoke\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeSmoke : InventoryBase&FormulableEntity = 192 { #%(T_46_META_WS_C_GRENADESMOKE)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionRange\r
    Range : Float = -192000 #%(T_46_META_WS_P_EXPLOSIONRANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowingSpeed\r
    ThrowSpeed : Float = -192001 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionDelay\r
    ExplosionTime : Float = -192002 #%(T_46_META_WS_P_EXPLOSIONDELAY)\r
	@ApiLevel=4\r
	@ScriptName=EffectDuration\r
    EffectTime : Float = -192003 #%(T_46_META_WS_P_EFFECTDURATION)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
    AssetConfigID : WeaponSkinID = -192004 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
    OverloadByPlayerWeaponSkin : Bool = -192005 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Landmine\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Landmine : InventoryBase&FormulableEntity = 194 { #%(T_46_META_WS_C_LANDMINE)\r
	@ApiLevel=4\r
	@ScriptName=StartTime\r
    StartTime : Float = -194000 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@ScriptName=TriggerRadius\r
    TriggerRadius : Float = -194001 #%(T_46_META_WS_P_TRIGGERRADIUS)\r
	@ApiLevel=4\r
	@ScriptName=TriggerTime\r
    TriggerTime : Float = -194002 #%(T_46_META_WS_P_TRIGGERTIME)\r
	@ApiLevel=4\r
	@ScriptName=CanTriggeredbySelf\r
    CanSelfTrigger : Bool = -194003 #%(T_46_META_WS_P_CANTRIGGEREDBY SELF)\r
	@ApiLevel=4\r
	@ScriptName=CanTriggeredbyTeam\r
    CanTeamTrigger : Bool = -194004 #%(T_46_META_WS_P_CANTRIGGEREDBY TEAM)\r
	@ApiLevel=4\r
	@ScriptName=CanTriggeredbyVehicle\r
    CanVehicleTrigger : Bool = -194005 #%(T_46_META_WS_P_CANTRIGGEREDBY VEHICLE)\r
	@ApiLevel=4\r
	@ScriptName=LifeTime\r
    LifeTime : Float = -194006 #%(T_46_META_WS_P_LIFETIME)\r
	@ApiLevel=4\r
	@ScriptName=IsAttackable\r
    CanBeAttacked : Bool = -194007 #%(T_46_META_WS_P_ISATTACKABLE)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
    MaxHP : Int = -194008 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=SelfDamageFactor\r
    RatioSelf : Float = -194009 #%(T_46_META_WS_P_SELFDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=TeammateDamageFactor\r
    RatioTeammate : Float = -194010 #%(T_46_META_WS_P_TEAMMATEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=VehicleDamageFactor\r
    RatioVehicle : Float = -194011 #%(T_46_META_WS_P_VEHICLEDAMAGEFACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TweenStyle\r
@ModuleID=29\r
@ModuleLib=Playable\r
enum TweenStyle : Int = 195 { #%(T_46_META_WS_C_TWEENSTYLE)\r
	@ApiLevel=4\r
	@ScriptName=Once\r
    Once = 1 #%(T_46_META_WS_E_ONCE)\r
	@ApiLevel=4\r
	@ScriptName=Loop\r
    Loop = 2 #%(T_46_META_WS_E_LOOP)\r
	@ApiLevel=4\r
	@ScriptName=PingPong\r
    PingPong = 3 #%(T_46_META_WS_E_PINGPONG)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=TweenCurve_Deprecated\r
@ModuleID=29\r
@ModuleLib=Playable\r
type TweenCurve : Entity = 196 { #%(T_46_META_WS_C_TWEENCURVE_DEPRECATED)\r
	@ApiLevel=4\r
	@ScriptName=ControlPoints\r
    get ControlPoints : ListT_Float = -196000 #%(T_46_META_WS_P_CONTROLPOINTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Tween\r
@ModuleID=29\r
@ModuleLib=Playable\r
type Tween : Playable = 203 { #%(T_46_META_WS_C_TWEEN)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
    TargetEntity : Entity = -203000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=PropID\r
    PropID : Property = -203001 #%(T_46_META_WS_P_PROPID)\r
	@ApiLevel=10\r
	@ScriptName=SrcVal\r
    SrcVal : ListT_Float = -203002 #%(T_46_META_WS_P_SRCVAL)\r
	@ApiLevel=10\r
	@ScriptName=DestVal\r
    DestVal : ListT_Float = -203003 #%(T_46_META_WS_P_DESTVAL)\r
	@ApiLevel=4\r
	@ScriptName=TweenStyle\r
    Style : TweenStyle = -203004 #%(T_46_META_WS_P_TWEENSTYLE)\r
	@ApiLevel=10\r
	@ScriptName=Curve_Deprecated\r
    Curve : TweenCurve = -203005 #Curve\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    Duration : Float = -203006 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=IsReverse\r
    Reverse : Bool = -203007 #%(T_46_META_WS_P_ISREVERSE)\r
	@ApiLevel=4\r
	@ScriptName=ControlPoints\r
    ControlPoints : BezierCurve = -203008 #%(T_46_META_WS_P_CONTROLPOINTS)\r
	@ApiLevel=11\r
	@ScriptName=ForceSyncToClient\r
    get ForceSyncValue : ListT_Float = -203009 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
	@ApiLevel=3\r
    get StartTickCount : Int = -203010 #StartTickCount\r
	@ApiLevel=4\r
	@ScriptName=StartValue\r
    StartValue : Object = -203011 #%(T_46_META_WS_P_STARTVALUE)\r
	@ApiLevel=4\r
	@ScriptName=EndValue\r
    EndValue : Object = -203012 #%(T_46_META_WS_P_ENDVALUE)\r
	@ApiLevel=4\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -203013 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JetShoes\r
@ModuleID=10014\r
@ModuleLib=Items\r
type JetPack : InventoryBase&FormulableEntity = 199 { #%(T_46_META_WS_C_JETSHOES)\r
	@ApiLevel=4\r
	@ScriptName=MaxEP\r
    MaxEnergy : Int = -199000 #%(T_46_META_WS_P_MAXEP)\r
	@ApiLevel=4\r
	@ScriptName=EnergyCost\r
    BaseEnergyCost : Float = -199001 #%(T_46_META_WS_P_ENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=UpEnergyCost\r
    UpChangeEnergyCost : Float = -199002 #%(T_46_META_WS_P_UPENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=SprintEnergyCost\r
    DashEnergyCost : Float = -199003 #%(T_46_META_WS_P_SPRINTENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=RushEnergyCost\r
    RushEnergyCost : Float = -199004 #%(T_46_META_WS_P_RUSHENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=BaseHorizontalSpeed\r
    BaseHSpeed : Float = -199005 #%(T_46_META_WS_P_BASEHORIZONTALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=SprintHorizontalSpeed\r
    DashHSpeed : Float = -199006 #%(T_46_META_WS_P_SPRINTHORIZONTALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=BaseVerticalSpeed\r
    BaseVSpeed : Float = -199007 #%(T_46_META_WS_P_BASEVERTICALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=RushVerticalSpeed\r
    RushVSpeed : Float = -199008 #%(T_46_META_WS_P_RUSHVERTICALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=RushDistance\r
    DistanceToReady : Float = -199009 #%(T_46_META_WS_P_RUSHDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=FallingDamageRatio\r
    FallingDamageScale : Float = -199010 #%(T_46_META_WS_P_FALLINGDAMAGERATIO)\r
	@ApiLevel=4\r
	@ScriptName=CurrentEnergy\r
    CurEnergy : Float = -199011 #%(T_46_META_WS_P_CURRENTENERGY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaterZone\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type WaterZone : CustomizeTrigger = 201 { #%(T_46_META_WS_C_WATERZONE)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=DecelerationPercent\r
    DecelerationRatio : Int = -201000 #%(T_46_META_WS_P_DECELERATIONPERCENT)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=JailBreakArea\r
@ModuleID=10009\r
@ModuleLib=Other\r
type JailBreakArea : CustomizeTrigger = 200 { #%(T_40_XXJ_WS_JAILBREAKAREA_NAMEKEY)\r
	@ApiLevel=3\r
	@ScriptName=Area\r
    get JailBreakAreaID : Int = -200000 #JailBreakAreaID\r
	@ApiLevel=3\r
	@ScriptName=Game\r
    get JailBreakGameID : Int = -200001 #%(T_46_META_WS_A_GAMEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomLevelObject\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomLevelObject : LevelObject = 186 { #%(T_46_META_WS_C_CUSTOMLEVELOBJECT)\r
	@ApiLevel=11\r
	@ScriptName=ColliderID\r
    ColliderID : ColliderID = -186000 #%(T_46_META_WS_P_COLLIDERID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NPC\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type NPC : CustomLevelObject = 413 { #%(T_46_META_WS_C_NPC)\r
	@ApiLevel=3\r
	@ScriptName=TransformClothInfo\r
    get TransformClothInfo : TransformClothInfo = -413000 #TransformClothInfo\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DoubleJumpShoes\r
@ModuleID=10014\r
@ModuleLib=Items\r
type DoubleJumpShoes : InventoryBase&FormulableEntity = 204 { #%(T_46_META_WS_C_DOUBLEJUMPSHOES)\r
	@ApiLevel=4\r
	@ScriptName=MaxJumpHeight\r
    MaxJumpHeight : Float = -204000 #%(T_46_META_WS_P_MAXJUMPHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=FallingDamageRatio\r
    DamageReduce : Float = -204001 #%(T_46_META_WS_P_FALLINGDAMAGERATIO)\r
	@ApiLevel=4\r
	@ScriptName=EnergyRecovery\r
    EnergyRecovery : Int = -204002 #%(T_46_META_WS_P_ENERGYRECOVERY)\r
	@ApiLevel=4\r
	@ScriptName=EnergyCost\r
    JumpConsume : Int = -204003 #%(T_46_META_WS_P_ENERGYCOST)\r
	@ApiLevel=4\r
	@ScriptName=MaxEnergy\r
    MaxEnergy : Int = -204004 #%(T_46_META_WS_P_MAXENERGY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FoldWing\r
@ModuleID=10014\r
@ModuleLib=Items\r
type FoldWing : InventoryBase&FormulableEntity = 205 { #%(T_46_META_WS_C_FOLDWING)\r
	@ApiLevel=4\r
	@ScriptName=MinFlyHeight\r
    MinFlyHeight : Float = -205000 #%(T_46_META_WS_P_MINFLYHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=MinEndHeight\r
    MinEndHeight : Float = -205001 #%(T_46_META_WS_P_MINENDHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=FlySpeedHorizontal\r
    FlySpeedHorizontal : Float = -205002 #%(T_46_META_WS_P_FLYSPEEDHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=FlySpeedVertical\r
    FlySpeedVertical : Float = -205003 #%(T_46_META_WS_P_FLYSPEEDVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=FallSpeed\r
    FallSpeed : Float = -205004 #%(T_46_META_WS_P_FALLSPEED)\r
	@ApiLevel=4\r
	@ScriptName=TurnSpeed\r
    TurnSpeed : Float = -205005 #%(T_46_META_WS_P_TURNSPEED)\r
	@ApiLevel=4\r
	@ScriptName=FlyMaxHeight\r
    FlyMaxHeight : Float = -205006 #%(T_46_META_WS_P_FLYMAXHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=OverheightFallSpeed\r
    OverheightFallSpeed : Float = -205007 #%(T_46_META_WS_P_OVERHEIGHTFALLSPEED)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
    AcceleratedSpeed : Float = -205008 #%(T_46_META_WS_P_ACCELERATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Skateboard\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Skateboard : InventoryBase&FormulableEntity = 206 { #%(T_46_META_WS_C_SKATEBOARD)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
    Speed : Float = -206000 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=Accelerate\r
    Accelerate : Float = -206001 #%(T_46_META_WS_P_ACCELERATE)\r
	@ApiLevel=4\r
	@ScriptName=BoostSpeed\r
    BoostSpeed : Float = -206002 #%(T_46_META_WS_P_BOOSTSPEED)\r
	@ApiLevel=4\r
	@ScriptName=BoostDuration\r
    BoostDuration : Float = -206003 #%(T_46_META_WS_P_BOOSTDURATION)\r
	@ApiLevel=4\r
	@ScriptName=BoostCD\r
    BoostCooldown : Float = -206004 #%(T_46_META_WS_P_BOOSTCD)\r
	@ApiLevel=4\r
	@ScriptName=JumpHeight\r
    JumpHeight : Float = -206005 #%(T_46_META_WS_P_JUMPHEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=JumpCD\r
    HBJumpCD : Float = -206006 #%(T_46_META_WS_P_JUMPCD)\r
	@ApiLevel=4\r
	@ScriptName=GetOnBoostCD\r
    HBBoostInitial : Float = -206007 #%(T_46_META_WS_P_GETONBOOSTCD)\r
	@ApiLevel=4\r
	@ScriptName=GetOnBoostCDSwitch\r
    HBBoostCDSwitch : Bool = -206008 #%(T_46_META_WS_P_GETONBOOSTCDSWITCH)\r
	@ApiLevel=4\r
	@ScriptName=GetOnSkateboardCD\r
    HoverboardCDMs : Float = -206009 #%(T_46_META_WS_P_GETONSKATEBOARDCD)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngle\r
    HighSpeedSteerAngle : Float = -206010 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLE)\r
	@ApiLevel=4\r
	@ScriptName=HighSpeedSteerAngleAtSpeed\r
    HighSpeedSteerAngleAtSpeed : Float = -206011 #%(T_46_META_WS_P_HIGHSPEEDSTEERANGLEATSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ZipLine\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type StropShelf : LevelObject&Collider = 207 { #%(T_46_META_WS_C_ZIPLINE)\r
	@ApiLevel=4\r
	@Default=12\r
	@ScriptName=Speed\r
    Speed : Float = -207000 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=StartPosition\r
    get StartPosition : String = -207001 #%(T_46_META_WS_P_STARTPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EndPosition\r
    get EndPosition : String = -207002 #%(T_46_META_WS_P_ENDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=StropID\r
    get StropID : Int = -207003 #%(T_46_META_WS_P_STROPID)\r
	@ApiLevel=4\r
	@ScriptName=GroupID\r
    get GroupID : Int = -207004 #%(T_46_META_WS_P_GROUPID)\r
	@ApiLevel=4\r
	@ScriptName=IsEnd\r
    get IsEnd : Bool = -207005 #%(T_46_META_WS_P_ISEND)\r
	@ApiLevel=4\r
	@ScriptName=StartPositionVec3\r
    get StartPositionVec3 : Vector3 = -207006 #%(T_46_META_WS_P_STARTPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EndPositionVec3\r
    get EndPositionVec3 : Vector3 = -207007 #%(T_46_META_WS_P_ENDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_Playable\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_Playable : List = 208 { #%(T_46_META_WS_C_LISTT_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayableOrPlayables\r
@ModuleID=29\r
@ModuleLib=Playable\r
alias PlayableOrListPlayable : Object&(Playable|ListT_Playable) = 209 #%(T_46_META_WS_C_PLAYABLEORPLAYABLES)\r
\r
@ApiLevel=4\r
@ScriptName=Trajectory\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableTrajectory : Playable&Loopable = 210 { #%(T_46_META_WS_C_TRAJECTORY)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
    TargetEntity : Entity = -210000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=InitialSpeed\r
    get InitialVelocity : Vector3 = -210001 #%(T_46_META_WS_P_INITIALSPEED)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
    get Acceleration : Vector3 = -210002 #%(T_46_META_WS_P_ACCELERATION)\r
	@ApiLevel=4\r
	@ScriptName=MaxDisplacement\r
    get MaxDisplacement : Float = -210003 #%(T_46_META_WS_P_MAXDISPLACEMENT)\r
	@ApiLevel=3\r
	@ScriptName=InitialWorldPosition\r
    get InitialWorldPos : Vector3 = -210004 #%(T_46_META_WS_P_INITIALWORLDPOSITION)\r
	@ApiLevel=11\r
	@ScriptName=ForceSyncToClient\r
    get ForceSyncValue : Vector3 = -210005 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
	@ApiLevel=3\r
    get StartTickCount : Int = -210006 #StartTickCount\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SelfRelative\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableSelfRelative : Playable = 330 { #%(T_46_META_WS_C_SELFRELATIVE)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
    TargetEntity : Entity = -330000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=PropID\r
    PropID : Property = -330001 #%(T_46_META_WS_P_PROPID)\r
	@ApiLevel=10\r
	@ScriptName=Delta\r
    Delta : ListT_Float = -330002 #%(T_46_META_WS_P_DELTA)\r
	@ApiLevel=4\r
	@ScriptName=TweenStyle\r
    Style : TweenStyle = -330003 #%(T_46_META_WS_P_TWEENSTYLE)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    Duration : Float = -330004 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=ControlPoints\r
    ControlPoints : BezierCurve = -330005 #%(T_46_META_WS_P_CONTROLPOINTS)\r
	@ApiLevel=11\r
	@ScriptName=ForceSyncToClient\r
    get ForceSyncValue : ListT_Float = -330006 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
	@ApiLevel=3\r
    get StartTickCount : Int = -330007 #StartTickCount\r
	@ApiLevel=4\r
	@ScriptName=DeltaValue\r
    DeltaValue : Object = -330008 #%(T_46_META_WS_P_DELTAVALUE)\r
	@ApiLevel=4\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -330009 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FrameSelfRelative\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableRelativeFrame : Playable = 347 { #%(T_46_META_WS_C_FRAMESELFRELATIVE)\r
	@ApiLevel=4\r
    TargetEntity : Entity = -347000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
    PropID : Property = -347001 #%(T_46_META_WS_P_PROPID)\r
	@ApiLevel=10\r
    Delta : ListT_Float = -347002 #Delta\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Type\r
    Switch : Bool = -347003 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=11\r
    get ForceSyncValue : ListT_Float = -347004 #ForceSyncValue\r
	@ApiLevel=3\r
    get StartTickCount : Int = -347005 #StartTickCount\r
	@ApiLevel=4\r
    DeltaValue : Object = -347006 #%(T_46_META_WS_P_DELTAVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CoordinateSystemType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum CoordinateType : Int = 211 { #%(T_46_META_WS_C_COORDINATESYSTEMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=LocalPosition\r
    Local = 1 #%(T_46_META_WS_E_LOCALPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=WorldPosition\r
    World = 2 #%(T_46_META_WS_E_WORLDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Follow\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayablePosFollow : Playable = 212 { #%(T_46_META_WS_C_FOLLOW)\r
	@ApiLevel=4\r
	@ScriptName=Self\r
    SelfEntity : Entity = -212000 #%(T_46_META_WS_P_SELF)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    TargetEntity : Entity = -212001 #%(T_46_META_WS_A_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    get Offset : Vector3 = -212002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=CoordinateSystem\r
    get CoordinateType : CoordinateType = -212003 #%(T_46_META_WS_P_COORDINATESYSTEM)\r
	@ApiLevel=11\r
	@ScriptName=ForceSyncToClient\r
    get ForceSyncValue : Vector3 = -212004 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LookAt\r
@ModuleID=29\r
@ModuleLib=Playable\r
type PlayableLookAt : Playable = 213 { #%(T_46_META_WS_C_LOOKAT)\r
	@ApiLevel=4\r
	@ScriptName=Self\r
    SelfEntity : Entity = -213000 #%(T_46_META_WS_P_SELF)\r
	@ApiLevel=4\r
	@ScriptName=LookAtTarget\r
    TargetEntity : Entity = -213001 #%(T_46_META_WS_A_LOOKATTARGET)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    get Offset : Vector3 = -213002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=CoordinateSystem\r
    get CoordinateType : CoordinateType = -213003 #%(T_46_META_WS_P_COORDINATESYSTEM)\r
	@ApiLevel=3\r
	@ScriptName=ForceSyncToClient\r
    get ForceSyncValue : Vector3 = -213004 #%(T_46_META_WS_P_FORCESYNCTOCLIENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GameResultType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum MatchResultType : Int = 215 { #%(T_46_META_WS_C_GAMERESULTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Win\r
    Win = 1 #%(T_46_META_WS_E_WIN)\r
	@ApiLevel=4\r
	@ScriptName=Lose\r
    Lose = 2 #%(T_46_META_WS_E_LOSE)\r
	@ApiLevel=4\r
	@ScriptName=Booyah\r
    Booyah = 3 #%(T_44_L_HIGHLIGHT_BOOYAH)\r
	@ApiLevel=4\r
	@ScriptName=Draw\r
    Draw = 4 #%(T_46_META_WS_E_DRAW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PointLight\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type PointLight : LevelObject = 218 { #%(T_46_META_WS_C_POINTLIGHT)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=Intensity\r
    Intensity : Float = -218000 #%(T_46_META_WS_P_INTENSITY)\r
	@ApiLevel=4\r
	@Default=3\r
	@ScriptName=Range\r
    Range : Float = -218001 #%(T_46_META_WS_P_RANGE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -218002 #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type SpotLight : LevelObject = 426 { #%(T_47_XXJ_WS_SPOTLIGHT)\r
	@ApiLevel=4\r
	@Default=1\r
    Intensity : Float = -426000 #%(T_46_META_WS_P_INTENSITY)\r
	@ApiLevel=4\r
	@Default=1\r
    Range : Float = -426001 #%(T_46_META_WS_P_RANGE)\r
	@ApiLevel=4\r
	@Default=30\r
    SpotAngle : Float = -426002 #%(T_47_XXJ_WS_SPOTANGLE)\r
	@ApiLevel=4\r
	@Default=-1\r
    Color : Color = -426003 #%(T_44_XXJ_WS_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Motobike\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MotobikeVehicle : Car = 219 { #%(T_46_META_WS_C_MOTOBIKE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TukTuk\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type TutuVehicle : Car = 220 { #%(T_46_META_WS_C_TUKTUK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Amphibian\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type BumperVehicle : Car = 221 { #%(T_46_META_WS_C_AMPHIBIAN)\r
	@ApiLevel=4\r
	@ScriptName=GearShiftingDelay\r
    GearShiftingDelay : Float = -221000 #%(T_46_META_WS_P_GEARSHIFTINGDELAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SportsCar\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CarVehicle : Car = 222 { #%(T_46_META_WS_C_SPORTSCAR)\r
	@ApiLevel=4\r
	@ScriptName=GearShiftingDelay\r
    GearShiftingDelay : Float = -222000 #%(T_46_META_WS_P_GEARSHIFTINGDELAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniSentry\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MiniSentry : InventoryBase&FormulableEntity = 225 { #%(T_46_META_WS_C_MINISENTRY)\r
	@ApiLevel=4\r
	@ScriptName=Damage\r
    Damage : Int = -225000 #%(T_46_META_WS_P_DAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=DamageInterval\r
    Interval : Float = -225001 #%(T_46_META_WS_P_IDAMAGE NTERVAL)\r
	@ApiLevel=4\r
	@ScriptName=Accuracy\r
    HitChance : Float = -225002 #%(T_46_META_WS_P_ACCURACY)\r
	@ApiLevel=4\r
	@ScriptName=DamageRange\r
    Range : Float = -225003 #%(T_46_META_WS_P_DAMAGE RANGE)\r
	@ApiLevel=4\r
	@ScriptName=AngularSpeed\r
    AngleSpeed : Float = -225004 #%(T_46_META_WS_P_ANGULARSPEED)\r
	@ApiLevel=4\r
	@ScriptName=AngleUp\r
    AngleUp : Float = -225005 #%(T_46_META_WS_P_ANGLEUP)\r
	@ApiLevel=4\r
	@ScriptName=AngleDown\r
    AngleDown : Float = -225006 #%(T_46_META_WS_P_ANGLEDOWN)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
    HpMax : Int = -225007 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=LifeTime\r
    LifeTime : Int = -225008 #%(T_46_META_WS_P_LIFETIME)\r
	@ApiLevel=4\r
	@ScriptName=MaxTurretCount\r
    MaxCount : Int = -225009 #%(T_46_META_WS_P_MAXTURRETCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=FireAngleLimit\r
    FireAngle : Float = -225010 #%(T_46_META_WS_P_FIREANGLELIMIT)\r
	@ApiLevel=4\r
	@ScriptName=DefenseRate\r
    Defense : Float = -225011 #%(T_46_META_WS_P_DEFENSERATE)\r
	@ApiLevel=4\r
	@ScriptName=ArmorPenetration\r
    BiteArmor : Float = -225012 #%(T_46_META_WS_P_ARMORPENETRATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniSentryCreated\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type MiniSentryObj : LevelObject&MiniSentry&FightingEntity = 226 { #%(T_46_META_WS_C_MINISENTRYCREATED)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
    Hp : Int = -226000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableAttack\r
    OpenAttack : Bool = -226001 #%(T_46_META_WS_P_ENABLEATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ActionType\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum ActionType : Int = 400 { #%(T_46_META_WS_C_ACTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Active\r
    Active = 0 #%(T_46_META_WS_E_ACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=Passive\r
    Passive = 1 #%(T_46_META_WS_E_PASSIVE)\r
	@ApiLevel=4\r
	@ScriptName=NoAttack\r
    NoAttack = 2 #%(T_46_META_WS_E_NOATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WidgetType\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum HudWidgetType : Int = 227 { #%(T_46_META_WS_C_WIDGETTYPE)\r
	@ApiLevel=4\r
	@ScriptName=SimpleWidget\r
    HudEmpty = 0 #%(T_46_META_WS_E_SIMPLEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ImageWidget\r
    HudImage = 1 #%(T_46_META_WS_E_IMAGEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=LabelWidget\r
    HudLabel = 2 #%(T_46_META_WS_E_LABELWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ButtonWidget\r
    HudButton = 3 #%(T_46_META_WS_E_BUTTONWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=InputLabelWidget\r
    HudInput = 4 #%(T_46_META_WS_E_INPUTLABLEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=Panel\r
    HudPanel = 5 #%(T_46_META_WS_E_PANEL)\r
	@ApiLevel=4\r
	@ScriptName=ScrollPanel\r
    HudScrollView = 6 #%(T_46_META_WS_E_SCROLLPANEL)\r
	@ApiLevel=4\r
	@ScriptName=Grid\r
    HudGrid = 7 #%(T_46_META_WS_E_GRID)\r
	@ApiLevel=4\r
	@ScriptName=LayoutWidget\r
    HudLayout = 8 #%(T_46_META_WS_E_LAYOUTWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ContainerWidget\r
    Hud3DContainer = 9 #%(T_46_META_WS_E_CONTAINERWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=TextureWidget\r
    HudTexture = 10 #%(T_46_META_WS_E_TEXTUREWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ProfileWidget\r
    HudProfileInfo = 11 #%(T_46_META_WS_E_PROFILEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=ToggleWidget\r
    HudToggle = 12 #%(T_46_META_WS_E_TOGGLEWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=TouchPadWidget\r
    HudTouchPad = 13 #%(T_46_META_WS_E_TOUCHPADWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=JoystickWidget\r
    HudJoystick = 14 #%(T_46_META_WS_E_JOYSTICKWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=SocialButtonWidget\r
    HUDSocialButtonWidget = 15 #%(T_46_META_WS_E_SOCIALBUTTONWIDGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FillType\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum FillType : Int = 319 { #%(T_46_META_WS_C_FILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Simple\r
    Simple = 0 #%(T_46_META_WS_E_SIMPLE)\r
	@ApiLevel=4\r
	@ScriptName=Sliced\r
    Sliced = 1 #%(T_46_META_WS_E_SLICED)\r
	@ApiLevel=4\r
	@ScriptName=Tiled\r
    Tiled = 2 #%(T_46_META_WS_E_TILED)\r
	@ApiLevel=4\r
	@ScriptName=Filled\r
    Filled = 3 #%(T_46_META_WS_E_FILLED)\r
	@ApiLevel=4\r
	@ScriptName=Fit\r
    Fit = 5 #%(T_46_META_WS_E_FIT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FillDirectionType\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum FillDir : Int = 320 { #%(T_46_META_WS_C_FILLDIRECTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Horizontal\r
    Horizontal = 0 #%(T_46_META_WS_E_HORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=Vertical\r
    Vertical = 1 #%(T_46_META_WS_E_VERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=Radial90\r
    Radial90 = 2 #%(T_46_META_WS_E_RADIAL90)\r
	@ApiLevel=4\r
	@ScriptName=Radial180\r
    Radial180 = 3 #%(T_46_META_WS_E_RADIAL180)\r
	@ApiLevel=4\r
	@ScriptName=Radial360\r
    Radial360 = 4 #%(T_46_META_WS_E_RADIAL360)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LayoutSortType\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum LayoutSortType : Int = 405 { #%(T_46_META_WS_C_LAYOUTSORTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ByHierarchy\r
    SortByHierarchy = 0 #%(T_46_META_WS_E_BYHIERARCHY)\r
	@ApiLevel=4\r
	@ScriptName=SortByPriorityHighToLow\r
    SortByPriorityHighToLow = 1 #%(T_46_META_WS_E_SORTBYPRIORITYHIGHTOLOW)\r
	@ApiLevel=4\r
	@ScriptName=SortByPriorityLowToHigh\r
    SortByPriorityLowToHigh = 2 #%(T_46_META_WS_E_SORTBYPRIORITYLOWTOHIGH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FontType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum FontType : String = 333 { #%(T_46_META_WS_C_FONTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=FZLanTingHei\r
    T_40_WZY_WS_FONT_FF_CN_T = FONT_FF_CN_T #%(T_46_META_WS_E_FZLANTINGHEI)\r
	@ApiLevel=4\r
	@ScriptName=SimplifiedArabic\r
    T_40_WZY_WS_FONT_SIMPBDO = FONT_SIMPBDO #%(T_46_META_WS_E_SIMPLIFIEDARABIC)\r
	@ApiLevel=4\r
	@ScriptName=NotoNastaliqUrdu\r
    T_40_WZY_WS_FONT_NOTOSANS = FONT_NOTOSANS #%(T_46_META_WS_E_NOTONASTALIQURDU)\r
	@ApiLevel=4\r
	@ScriptName=GFFLatin\r
    T_40_WZY_WS_UIFONT_LATIN_BOLD = UIFONT_LATIN_BOLD #%(T_46_META_WS_E_GFFLATIN)\r
	@ApiLevel=4\r
	@ScriptName=AgencyFB\r
    T_40_WZY_WS_UIFONT_LATIN = UIFONT_LATIN #%(T_46_META_WS_E_AGENCYFB)\r
	@ApiLevel=4\r
	@ScriptName=Supermarket\r
    T_40_WZY_WS_FONT_SUPERMARKET = FONT_SUPERMARKET #%(T_46_META_WS_E_SUPERMARKET)\r
	@ApiLevel=4\r
	@ScriptName=HindSiliguri\r
    T_40_WZY_WS_FONT_HINDSILIGURI = FONT_HINDSILIGURI #%(T_46_META_WS_E_HINDSILIGURI)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OverflowType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum FondOverFlowMod : Int = 451 { #%(T_50_META_TYP_451)\r
	@ApiLevel=4\r
    Shrink = 0 #%(T_50_HJ_OVERFLOW_SHRINKCONTENT)\r
	@ApiLevel=4\r
    Clamp = 1 #%(T_50_HJ_OVERFLOW_RESIZEHEIGHT)\r
	@ApiLevel=4\r
    ResizeFreely = 2 #%(T_50_HJ_OVERFLOW_RESIZEFREELY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScrollDirection\r
@ModuleID=16\r
@ModuleLib=Hud\r
enum ScrollDirection : Int = 491 { #%(T_55_META_TYP_491)\r
	@ApiLevel=4\r
	@ScriptName=Vertical\r
    Vertical = 0 #%(T_55_META_TYP_491_I0)\r
	@ApiLevel=4\r
	@ScriptName=Horizontal\r
    Horizontal = 1 #%(T_55_META_TYP_491_I1)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=MonsterAttackTargetType\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum AIAttackTargetType : Int = 375 { #%(T_40_XXJ_WS_MONSTERATTACKTARGETTYPE_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Player\r
    Player = 0 #Player\r
	@ApiLevel=4\r
	@ScriptName=FightingEntity\r
    FightingEntity = 1 #FightingEntity\r
}\r
\r
@ApiLevel=11\r
@ScriptName=MiniSentryAttackTargetType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum MiniSentryAttackTargetType : Int = 376 { #MiniSentryAttackTargetType\r
	@ApiLevel=4\r
	@ScriptName=Player\r
    Player = 0 #%(T_46_META_WS_E_PLAYER)\r
	@ApiLevel=4\r
	@ScriptName=FightingEntity\r
    FightingEntity = 1 #%(T_46_META_WS_E_FIGHTINGENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RaycastLayerType\r
@ModuleID=33\r
@ModuleLib=Physics\r
enum RayCastLayerType : Int = 228 { #%(T_46_META_WS_C_RAYCASTLAYERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Static\r
    Static = 0 #%(T_46_META_WS_E_STATIC)\r
	@ApiLevel=4\r
	@ScriptName=Charactor\r
    Charactor = 1 #%(T_46_META_WS_E_CHARACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RepairKit\r
@ModuleID=10014\r
@ModuleLib=Items\r
type RepairArmorKit : InventoryBase&FormulableEntity = 231 { #%(T_46_META_WS_C_REPAIRKIT)\r
	@ApiLevel=4\r
	@ScriptName=DurabilityRecovery\r
    Health : Int = -231000 #%(T_46_META_WS_P_DURABILITYRECOVERY)\r
	@ApiLevel=4\r
	@ScriptName=EffectiveTimeInterval\r
    PreTime : Float = -231001 #%(T_46_META_WS_P_EFFECTIVETIMEINTERVAL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PlayerBonesType_Deprecated\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerBonesType : Int = 232 { #%(T_40_XXJ_WS_SKELETON)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
    Head = 1 #%(T_41_XXJ_WS_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Body\r
    Body = 2 #%(T_41_XXJ_WS_BODY)\r
	@ApiLevel=4\r
	@ScriptName=Limb\r
    Limb = 3 #%(T_41_XXJ_WS_LIMB)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UIProgressCircle\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ProgressCircleHud : InternalHud = 233 { #%(T_46_META_WS_C_UIPROGRESSCIRCLE)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -233000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=3\r
	@Default=5\r
	@ScriptName=Duration\r
    DurationTimeS : Int = -233001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=3\r
	@Default=0\r
	@ScriptName=EndTimeS\r
    EndTimeS : Int = -233002 #%(T_46_META_WS_P_ENDTIMES)\r
	@ApiLevel=3\r
	@Default=math.Vector3_1()\r
	@ScriptName=Offset\r
    Offset : Vector3 = -233003 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=3\r
	@Default=UI_icon_FirstAidKit\r
	@ScriptName=Icon\r
    Icon : String = -233004 #%(T_46_META_WS_P_ICON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LandmineCreated\r
@ModuleID=10014\r
@ModuleLib=Items\r
type LandmineObj : InventoryBase&FormulableEntity = 234 { #%(T_46_META_WS_C_LANDMINECREATED)\r
	@ApiLevel=4\r
	@ScriptName=TriggerTime\r
    TriggerTime : Float = -234000 #%(T_46_META_WS_P_TRIGGERTIME)\r
	@ApiLevel=4\r
	@ScriptName=CanSelfTrigger\r
    CanSelfTrigger : Bool = -234001 #%(T_46_META_WS_P_CANSELFTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CanTeamTrigger\r
    CanTeamTrigger : Bool = -234002 #%(T_46_META_WS_P_CANTEAMTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=CanVehicleTrigger\r
    CanVehicleTrigger : Bool = -234003 #%(T_46_META_WS_P_CANVEHICLETRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    LifeTime : Float = -234004 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=IsAttackable\r
    CanBeAttacked : Bool = -234005 #%(T_46_META_WS_P_ISATTACKABLE)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
    MaxHP : Int = -234006 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=SelfDamageFactor\r
    RatioSelf : Float = -234007 #%(T_46_META_WS_P_SELFDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=TeammateDamageFactor\r
    RatioTeammate : Float = -234008 #%(T_46_META_WS_P_TEAMMATEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=VehicleDamageFactor\r
    RatioVehicle : Float = -234009 #%(T_46_META_WS_P_VEHICLEDAMAGEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
    Hp : Int = -234010 #%(T_46_META_WS_P_HP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IceWall\r
@ModuleID=10014\r
@ModuleLib=Items\r
type IceWall : InventoryBase&FormulableEntity = 235 { #%(T_46_META_WS_C_ICEWALL)\r
	@ApiLevel=4\r
	@ScriptName=MaxHP\r
    MaxHP : Int = -235000 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    LifeTime : Float = -235001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@ScriptName=MaxCount\r
    MaxCount : Int = -235002 #%(T_46_META_WS_P_MAXCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=Skin\r
    AssetConfigID : WeaponSkinID = -235003 #%(T_46_META_WS_P_SKIN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=OverloadByPlayerConfiguration\r
    OverloadByPlayerWeaponSkin : Bool = -235004 #%(T_46_META_WS_P_OVERLOADBYPLAYERCONFIGURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IceWallCreated\r
@ModuleID=10014\r
@ModuleLib=Items\r
type IceWallObj : InventoryBase&FormulableEntity = 236 { #%(T_46_META_WS_C_ICEWALLCREATED)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    LifeTime : Float = -236000 #%(T_46_META_WS_P_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HookGun\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrapplingHookGun : Weapon = 237 { #%(T_46_META_WS_C_HOOKGUN)\r
	@ApiLevel=4\r
	@ScriptName=ThrowSpeed\r
    ThrowSpeed : Float = -237000 #%(T_46_META_WS_P_THROWSPEED)\r
	@ApiLevel=4\r
	@ScriptName=PlayerTractionSpeed\r
    TowSpeed : Float = -237001 #%(T_46_META_WS_P_PLAYERTRACTIONSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayGun\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type SprayGunComponent : Weapon = 238 { #%(T_46_META_WS_C_SPRAYGUN)\r
	@ApiLevel=4\r
	@ScriptName=SprayColor\r
    SprayColor : SprayColor = -238000 #%(T_46_META_WS_P_SPRAYCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayRifle\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type SprayRifle : SprayGunComponent = 239 { #%(T_46_META_WS_C_SPRAYRIFLE)\r
	@ApiLevel=4\r
	@Default=20\r
	@ScriptName=InitialSpeed\r
    InitialSpeed : Float = -239000 #%(T_46_META_WS_P_INITIALSPEED)\r
	@ApiLevel=4\r
	@Default=&math.Vector3(0, -9.8, 0)\r
	@ScriptName=Acceleration\r
    Acceleration : Vector3 = -239001 #%(T_46_META_WS_P_ACCELERATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwingGun\r
@ModuleID=10014\r
@ModuleLib=Items\r
type SwingGun : Weapon = 241 { #%(T_46_META_WS_C_SWINGGUN)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=TowSpeed\r
    TowSpeed : Float = -241000 #%(T_46_META_WS_P_TOWSPEED)\r
	@ApiLevel=4\r
	@Default=3\r
	@ScriptName=SwingingSpeed\r
    SwingSpeed : Float = -241001 #%(T_46_META_WS_P_SWINGINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=EnableTraction\r
    OpenTow : Bool = -241002 #%(T_46_META_WS_P_ENABLETRACTION)\r
	@ApiLevel=4\r
	@ScriptName=EnableSwinging\r
    OpenSwing : Bool = -241003 #%(T_46_META_WS_P_ENABLESWINGING)\r
	@ApiLevel=4\r
	@ScriptName=AnchorObject\r
    TargetObject : LevelObject = -241004 #%(T_46_META_WS_P_ANCHOROBJECT)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=SwingExitAcceleration\r
    LeaveAcceleration : Float = -241005 #%(T_46_META_WS_P_SWINGEXITACCELERATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIScoreBar\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ScoreBarHud : InternalHud = 242 { #%(T_46_META_WS_C_UISCOREBAR)\r
	@ApiLevel=4\r
	@ScriptName=LeftColor\r
    LeftColor : Color = -242000 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightColor\r
    RightColor : Color = -242001 #%(T_46_META_WS_P_RIGHTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LeftEffectActive\r
    LeftEffectActive : Bool = -242002 #%(T_46_META_WS_P_LEFTEFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=RightEffectActive\r
    RightEffectActive : Bool = -242003 #%(T_46_META_WS_P_RIGHTEFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=CentralLineActive\r
    CentralLineActive : Bool = -242004 #%(T_46_META_WS_P_CENTRALLINEACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=Value\r
    Value : Float = -242005 #%(T_46_META_WS_P_VALUE)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
    Speed : Float = -242006 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
    NormalizedPosition : Vector3 = -242007 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=CentralLinePosition\r
    CentralLinePos : Float = -242008 #%(T_46_META_WS_P_CENTRALLINEPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OutfitSlotType\r
@ModuleID=10017\r
@ModuleLib=Collection\r
enum WardrobeType : Int = 243 { #%(T_46_META_WS_C_OUTFITSLOTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Top\r
    Chest = 3 #%(T_40_XXJ_WS_CUSTOMCLOTHCHESTID_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Bottom\r
    Legs = 4 #%(T_40_XXJ_WS_CUSTOMCLOTHLEGSID_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Shoes\r
    Feet = 5 #%(T_40_XXJ_WS_CUSTOMCLOTHFEETID_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Mask\r
    Face = 8 #%(T_40_XXJ_WS_CUSTOMCLOTHHEADADDITIVEID_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
    Hair = 11 #%(T_40_XXJ_WS_CUSTOMCLOTHHAIRID_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Onesie\r
    Set = 12 #%(T_40_XXJ_WS_CUSTOMCLOTHSETID_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=Facepaint\r
    HeadAdditive = 14 #%(T_40_XXJ_WS_CUSTOMCLOTHMAKEUP_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Text\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TextEntity : LevelObject = 244 { #%(T_46_META_WS_C_TEXT)\r
	@ApiLevel=4\r
	@Default=Text\r
	@ScriptName=Content\r
    TextKey : String = -244000 #%(T_46_META_WS_P_CONTENT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -244001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -244002 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@ScriptName=IsIgnoreDepth\r
    IgnoreDepth : Bool = -244003 #%(T_46_META_WS_P_ISIGNOREDEPTH)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
    IsBillboard : Bool = -244004 #%(T_36_WZY_WS_FACECAMERA)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAlwaysInScreen\r
    AlwaysInScreen : Bool = -244005 #%(T_46_META_WS_P_ISALWAYSINSCREEN)\r
	@ApiLevel=4\r
	@Default=16\r
	@ScriptName=FontStyle\r
    FontStyle : Int = -244006 #%(T_46_META_WS_P_FONTSTYLE)\r
	@ApiLevel=4\r
	@Default=UIFONT_LATIN\r
	@ScriptName=FontType\r
    FontType : FontType = -244007 #%(T_46_META_WS_P_FONTTYPE)\r
	@ApiLevel=4\r
	@Default=48\r
	@ScriptName=FontSize\r
    FontSize : Int = -244008 #%(T_46_META_WS_P_FONTSIZE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -244009 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=VisiblePlayers\r
    VisiblePlayers : ListT_Player = -244010 #%(T_46_META_WS_P_VISIBLEPLAYERS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Depth\r
    Depth : Int = -244011 #%(T_46_META_WS_P_DEPTH)\r
	@ApiLevel=4\r
	@Default=100\r
    Width : Int = -244012 #%(T_46_META_WS_A_WIDTH)\r
	@ApiLevel=4\r
	@Default=100\r
    Height : Int = -244013 #%(T_46_META_WS_A_HEIGHT)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=OverflowType\r
    FondOverFlowMod : FondOverFlowMod = -244014 #%(T_50_META_TYP_451)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentHorizontal\r
    Alignment : Int = -244015 #%(T_46_META_WS_P_ALIGNMENTHORIZONTAL)\r
	@ApiLevel=4\r
	@ScriptName=AlignmentVertical\r
    AlignmentVertical : Int = -244016 #%(T_46_META_WS_P_ALIGNMENTVERTICAL)\r
	@ApiLevel=4\r
	@ScriptName=LineSpacing\r
    LineSpacing : Float = -244017 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@ScriptName=IsApplyShadow\r
    IsApplyShadow : Bool = -244018 #%(T_46_META_WS_P_ISAPPLYSHADOW)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ShadowColor\r
    ShadowColor : Color = -244019 #%(T_46_META_WS_P_SHADOWCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=ShadowOffset\r
    ShadowOffset : Vector2 = -244020 #%(T_46_META_WS_P_SHADOWOFFSET)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=ShadowAlpha\r
    ShadowAlpha : Float = -244021 #%(T_54_META_TYP_40_I16)\r
	@ApiLevel=4\r
	@ScriptName=IsApplyOutline\r
    IsApplyOutline : Bool = -244022 #%(T_54_META_TYP_40_I17)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=OutlineColor\r
    OutlineColor : Color = -244023 #%(T_54_META_TYP_40_I18)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=OutlineAlpha\r
    OutlineAlpha : Float = -244024 #%(T_54_META_TYP_40_I19)\r
	@ApiLevel=4\r
	@ScriptName=OutlineOffset\r
    OutlineOffset : Float = -244025 #%(T_54_META_TYP_40_I20)\r
	@ApiLevel=4\r
	@ScriptName=Gradient\r
    Gradient : Int = -244026 #%(T_46_META_WS_P_GRADIENT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=GradientTop\r
    GradientTop : Color = -244027 #%(T_46_META_WS_P_GRADIENTTOP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=GradientBottom\r
    GradientBottom : Color = -244028 #%(T_46_META_WS_P_GRADIENTBOTTOM)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=TopAlpha\r
    GradientTopAlpha : Float = -244029 #%(T_46_META_WS_P_TOPALPHA)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=BottomAlpha\r
    GradientBottomAlpha : Float = -244030 #%(T_46_META_WS_P_BOTTOMALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Icon\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type IconEntity : LevelObject = 245 { #%(T_46_META_WS_C_ICON)\r
	@ApiLevel=4\r
	@Default=T_34_M_WS_ICON_SQUARE\r
	@ScriptName=Resource\r
    IconType : SpriteID = -245000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -245001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -245002 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsIgnoreDepth\r
    IgnoreDepth : Bool = -245003 #%(T_46_META_WS_P_ISIGNOREDEPTH)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=IsAlwaysInScreen\r
    AlwaysInScreen : Bool = -245004 #%(T_46_META_WS_P_ISALWAYSINSCREEN)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsBillboard\r
    IsBillboard : Bool = -245005 #%(T_36_WZY_WS_FACECAMERA)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=RenderType\r
    RenderType : Int = -245006 #%(T_46_META_WS_P_RENDERTYPE)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Width\r
    Width : Int = -245007 #%(T_46_META_WS_P_WIDTH)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=Height\r
    Height : Int = -245008 #%(T_46_META_WS_P_HEIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -245009 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=VisiblePlayers\r
    VisiblePlayers : ListT_Player = -245010 #%(T_46_META_WS_P_VISIBLEPLAYERS)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Depth\r
    Depth : Int = -245011 #%(T_46_META_WS_P_DEPTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayColor\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
enum SprayColor : Int = 246 { #%(T_46_META_WS_C_SPRAYCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=Orange\r
    Orange = 1 #%(T_46_META_WS_E_ORANGE)\r
	@ApiLevel=4\r
	@ScriptName=Purple\r
    Purple = 2 #%(T_46_META_WS_E_PURPLE)\r
	@ApiLevel=4\r
	@ScriptName=Red\r
    Red = 3 #%(T_46_META_WS_E_RED)\r
	@ApiLevel=4\r
	@ScriptName=Green\r
    Green = 4 #%(T_46_META_WS_E_GREEN)\r
	@ApiLevel=4\r
	@ScriptName=Blue\r
    Blue = 5 #%(T_46_META_WS_E_BLUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DefaultUIType\r
@ModuleID=10010\r
@ModuleLib=Player\r
enum PlayerHudSwitchType : Int = 247 { #%(T_40_XXJ_WS_PLAYERUISWITCHTYPE_NAMEKEY)\r
	@ApiLevel=4\r
	@ScriptName=MovingJoystick\r
    MovementHUD = 1 #%(T_46_META_WS_E_MOVINGJOYSTICK)\r
	@ApiLevel=4\r
	@ScriptName=Sprint\r
    SprintHUD = 2 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@ScriptName=Attack\r
    AttackHUD = 3 #%(T_46_META_WS_E_ATTACK)\r
	@ApiLevel=4\r
	@ScriptName=Jump\r
    JumpHUD = 4 #%(T_46_META_WS_E_JUMP)\r
	@ApiLevel=4\r
	@ScriptName=KillingTips\r
    KillingTipsHUD = 5 #%(T_46_META_WS_E_KILLINGTIPS)\r
	@ApiLevel=4\r
	@ScriptName=WeaponSlot\r
    WeaponHUD = 6 #%(T_46_META_WS_E_WEAPONSLOT)\r
	@ApiLevel=4\r
	@ScriptName=MiniMap\r
    MinMapHUD = 7 #%(T_46_META_WS_E_MINIMAP)\r
	@ApiLevel=4\r
	@ScriptName=Bag\r
    BagHUD = 8 #%(T_46_META_WS_E_BAG)\r
	@ApiLevel=4\r
	@ScriptName=MedicalProps\r
    MedicalPropsHUD = 9 #%(T_46_META_WS_E_MEDICALPROPS)\r
	@ApiLevel=4\r
	@ScriptName=Crouch\r
    CrouchHUD = 10 #%(T_46_META_WS_E_CROUCH)\r
	@ApiLevel=4\r
	@ScriptName=Prone\r
    CreepHUD = 11 #%(T_46_META_WS_E_PRONE)\r
	@ApiLevel=4\r
	@ScriptName=TeammatesInfo\r
    TeammatesInfoHUD = 12 #%(T_46_META_WS_E_TEAMMATESINFO)\r
	@ApiLevel=4\r
	@ScriptName=AttackGrenade\r
    AttackGrenadeHUD = 13 #%(T_46_META_WS_E_ATTACKGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=DefenceGrenade\r
    DefenceGrenadeHUD = 14 #%(T_46_META_WS_E_DEFENCEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Emote\r
    EmotionHUD = 15 #%(T_46_META_WS_E_EMOTE)\r
	@ApiLevel=4\r
	@ScriptName=QuickChat\r
    QuickChatBtnHUD = 16 #%(T_46_META_WS_E_QUICKCHAT)\r
	@ApiLevel=4\r
	@ScriptName=Pickups\r
    PickupListHUD = 17 #%(T_46_META_WS_E_PICKUPS)\r
	@ApiLevel=4\r
	@ScriptName=QuickChatShow\r
    QuickChatShowHUD = 18 #%(T_46_META_WS_E_QUICKCHATSHOW)\r
	@ApiLevel=4\r
	@ScriptName=HP\r
    HPItemHUD = 19 #%(T_46_META_WS_E_HP)\r
	@ApiLevel=4\r
	@ScriptName=EP\r
    EPItemHUD = 20 #%(T_46_META_WS_E_EP)\r
	@ApiLevel=4\r
	@ScriptName=Armor\r
    ArmorHUD = 21 #%(T_46_META_WS_E_ARMOR)\r
	@ApiLevel=4\r
	@ScriptName=Reload\r
    ReloadBtnHUD = 22 #%(T_46_META_WS_E_RELOAD)\r
	@ApiLevel=4\r
	@ScriptName=SweapWeaponQuick\r
    SweapWeaponQuickBtnHUD = 23 #%(T_46_META_WS_E_SWEAPWEAPONQUICK)\r
	@ApiLevel=4\r
	@ScriptName=Speaker\r
    SpeakerBtnHUD = 24 #%(T_46_META_WS_E_SPEAKER)\r
	@ApiLevel=4\r
	@ScriptName=MicroPhone\r
    MicroPhoneBtnHUD = 25 #%(T_46_META_WS_E_MICROPHONE)\r
	@ApiLevel=4\r
	@ScriptName=Mark\r
    MarkBtnHUD = 26 #%(T_46_META_WS_E_MARK)\r
	@ApiLevel=10\r
	@ScriptName=Settings\r
    SettingsBtnHUD = 27 #%(T_46_META_WS_E_SETTINGS)\r
	@ApiLevel=4\r
	@ScriptName=Signal\r
    SignalIcoHUD = 28 #%(T_46_META_WS_E_SIGNAL)\r
	@ApiLevel=4\r
	@ScriptName=ActiveSkill\r
    ActiveSkillBtnHUD = 29 #%(T_46_META_WS_E_ACTIVESKILL)\r
	@ApiLevel=4\r
	@ScriptName=Crosshairs\r
    CrosshairsHUD = 30 #%(T_46_META_WS_E_CROSSHAIRS)\r
	@ApiLevel=4\r
	@ScriptName=PassiveSkill\r
    PassiveSkillHUD = 31 #%(T_46_META_WS_E_PASSIVESKILL)\r
	@ApiLevel=4\r
	@ScriptName=FPPInspectionHUD\r
    FPPInspectionHUD = 32 #%(T_52_META_TYP_247_I31)\r
	@ApiLevel=4\r
	@ScriptName=RequestHelp\r
    HelpUpHud = 33 #%(T_51_META_TYP_247_I31)\r
	@ApiLevel=4\r
	@ScriptName=HelpUpOthers\r
    RescureHud = 34 #%(T_51_META_TYP_247_I32)\r
	@ApiLevel=4\r
	@ScriptName=Attack2HUD\r
    Attack2Hud = 35 #%(T_51_META_TYP_247_I33)\r
	@ApiLevel=4\r
	@ScriptName=CombineWeaponHUD\r
    CombineWeaponHud = 36 #%(T_51_META_TYP_247_I34)\r
	@ApiLevel=4\r
	@ScriptName=SwimmingSurfHUD\r
    SwimmingSurfHud = 37 #%(T_51_META_TYP_247_I35)\r
	@ApiLevel=4\r
	@ScriptName=ActionHud\r
    ActionHud = 38 #%(T_52_META_TYP_247_I37)\r
	@ApiLevel=4\r
    TakePhotoHud = 39 #%(T_52_META_TYP_247_I38)\r
	@ApiLevel=4\r
	@ScriptName=PullThePin\r
    PullThePin = 40 #%(T_54_META_TYP_247_I39)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UIBuiltInUISwitchController\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CommonHudSwitchController : Entity = 248 { #%(T_46_META_WS_C_UIBUILTINUISWITCHCONTROLLER)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Crouch\r
    Crouch : CommonHudSwitchValue = -248000 #%(T_46_META_WS_E_CROUCH)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Prone\r
    Creep : CommonHudSwitchValue = -248001 #%(T_46_META_WS_E_PRONE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Jump\r
    Jump : CommonHudSwitchValue = -248002 #%(T_46_META_WS_E_JUMP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Fire\r
    Fire : CommonHudSwitchValue = -248003 #%(T_46_META_WS_E_ATTACK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MovingJoystick\r
    MovingJoystick : CommonHudSwitchValue = -248004 #%(T_46_META_WS_E_MOVINGJOYSTICK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=TeammatesInfo\r
    TeammatesInfo : CommonHudSwitchValue = -248005 #%(T_46_META_WS_E_TEAMMATESINFO)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=AttackGrenade\r
    AttackGrenade : CommonHudSwitchValue = -248006 #%(T_46_META_WS_E_ATTACKGRENADE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=DefenceGrenade\r
    DefenceGrenade : CommonHudSwitchValue = -248007 #%(T_46_META_WS_E_DEFENCEGRENADE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Sprint\r
    Speedup : CommonHudSwitchValue = -248008 #%(T_46_META_WS_E_SPRINT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=KillingTips\r
    KillingTips : CommonHudSwitchValue = -248009 #%(T_46_META_WS_E_KILLINGTIPS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=WeaponSlot\r
    WeaponHUD : CommonHudSwitchValue = -248010 #%(T_46_META_WS_E_WEAPONSLOT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MiniMap\r
    MinMapHUD : CommonHudSwitchValue = -248011 #%(T_46_META_WS_E_MINIMAP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Bag\r
    BagHUD : CommonHudSwitchValue = -248012 #%(T_46_META_WS_E_BAG)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MedicalProps\r
    MedicalPropsHUD : CommonHudSwitchValue = -248013 #%(T_46_META_WS_E_MEDICALPROPS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Emote\r
    EmotionHUD : CommonHudSwitchValue = -248014 #%(T_46_META_WS_E_EMOTE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=QuickChat\r
    QuickChatHUD : CommonHudSwitchValue = -248015 #%(T_46_META_WS_E_QUICKCHAT)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Pickups\r
    PickupListHUD : CommonHudSwitchValue = -248016 #%(T_46_META_WS_E_PICKUPS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=QuickChatShow\r
    QuickChatShowHUD : CommonHudSwitchValue = -248017 #%(T_46_META_WS_E_QUICKCHATSHOW)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=HP\r
    HPItemHUD : CommonHudSwitchValue = -248018 #%(T_46_META_WS_E_HP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=EP\r
    EPItemHUD : CommonHudSwitchValue = -248019 #%(T_46_META_WS_E_EP)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Armor\r
    ArmorHUD : CommonHudSwitchValue = -248020 #%(T_46_META_WS_E_ARMOR)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Reload\r
    ReloadBtnHUD : CommonHudSwitchValue = -248021 #%(T_46_META_WS_E_RELOAD)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SweapWeaponQuick\r
    SweapWeaponQuickBtnHUD : CommonHudSwitchValue = -248022 #%(T_46_META_WS_E_SWEAPWEAPONQUICK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Speaker\r
    SpeakerBtnHUD : CommonHudSwitchValue = -248023 #%(T_46_META_WS_E_SPEAKER)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=MicroPhone\r
    MicroPhoneBtnHUD : CommonHudSwitchValue = -248024 #%(T_46_META_WS_E_MICROPHONE)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Mark\r
    MarkBtnHUD : CommonHudSwitchValue = -248025 #%(T_46_META_WS_E_MARK)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Settings\r
    SettingsBtnHUD : CommonHudSwitchValue = -248026 #%(T_46_META_WS_E_SETTINGS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SignalIcon\r
    SignalIcoHUD : CommonHudSwitchValue = -248027 #%(T_46_META_WS_E_SIGNAL)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ActiveSkill\r
    ActiveSkillBtnHUD : CommonHudSwitchValue = -248028 #%(T_46_META_WS_E_ACTIVESKILL)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Crosshairs\r
    CrosshairsHUD : CommonHudSwitchValue = -248029 #%(T_46_META_WS_E_CROSSHAIRS)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PassiveSkill\r
    PassiveSkillHUD : CommonHudSwitchValue = -248030 #%(T_46_META_WS_E_PASSIVESKILL)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=FPPInspection\r
    FPPInspectionHUD : CommonHudSwitchValue = -248031 #%(T_45_HJ_CAMERA_INSPECTOR)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=RequestHelp\r
    HelpUpHud : CommonHudSwitchValue = -248032 #%(T_51_META_TYP_247_I31)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=HelpUpOthers\r
    RescureHud : CommonHudSwitchValue = -248033 #%(T_51_META_TYP_247_I32)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Attack2\r
    Attack2Hud : CommonHudSwitchValue = -248034 #%(T_51_META_TYP_247_I33)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=CombineWeapon\r
    CombineWeaponHud : CommonHudSwitchValue = -248035 #%(T_51_META_TYP_247_I34)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=SwimmingSurf\r
    SwimmingSurfHud : CommonHudSwitchValue = -248036 #%(T_51_META_TYP_247_I35)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ActionHud\r
    ActionHud : CommonHudSwitchValue = -248037 #%(T_52_META_TYP_247_I37)\r
	@ApiLevel=4\r
	@Default=-1\r
    TakePhotoHud : CommonHudSwitchValue = -248038 #%(T_52_META_TYP_247_I38)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PullThePin\r
    PullThePin : CommonHudSwitchValue = -248039 #PullThePin\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchEquipSlot\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum SwitchWeaponEquipSlot : Int = 249 { #%(T_46_META_WS_C_SWITCHEQUIPSLOT)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponA\r
    PrimaryWeapon1 = 0 #%(T_46_META_WS_E_PRIMARYWEAPONA)\r
	@ApiLevel=4\r
	@ScriptName=PrimaryWeaponB\r
    PrimaryWeapon2 = 1 #%(T_46_META_WS_E_PRIMARYWEAPONB)\r
	@ApiLevel=4\r
	@ScriptName=SecondaryWeapon\r
    SecondaryWeapon = 2 #%(T_46_META_WS_E_SECONDARYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Grenade\r
    ExplosiveWeapon = 3 #%(T_46_META_WS_E_GRENADE)\r
	@ApiLevel=4\r
	@ScriptName=Melee\r
    MeleeWeapon = 4 #%(T_46_META_WS_E_MELEE)\r
	@ApiLevel=4\r
	@ScriptName=HeavyWeapon\r
    HeavyWeapon = 5 #%(T_46_META_WS_E_HEAVYWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=Flashbang\r
    FlashBomb = 16 #%(T_46_META_WS_E_FLASHBANG)\r
	@ApiLevel=4\r
	@ScriptName=SmokeGrenade\r
    SmokeGrenade = 23 #%(T_46_META_WS_E_SMOKEGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=FlashFreeze\r
    FrozenGrenade = 30 #%(T_46_META_WS_E_FLASHFREEZE)\r
	@ApiLevel=4\r
	@ScriptName=DummyGrenade\r
    Dummy = 21 #%(T_46_META_WS_E_DUMMYGRENADE)\r
	@ApiLevel=4\r
	@ScriptName=PersonalUAV\r
    PersonalUAV = 28 #%(T_46_META_WS_E_PERSONALUAV)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Effect\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type EffectEntity : Playable&Loopable&LevelObject = 250 { #%(T_46_META_WS_C_EFFECT)\r
	@ApiLevel=4\r
	@ScriptName=EffectResID\r
    EffectType : EffectType = -250000 #%(T_46_META_WS_P_EFFECTRESID)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=Color\r
    Color : Color = -250001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=PlaySpeed\r
    PlaySpeed : Int = -250002 #%(T_46_META_WS_P_PLAYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=VFXTextureType\r
    PresentEffectTexType : TextureID = -250003 #%(T_46_META_WS_P_VFXTEXTURETYPE)\r
	@ApiLevel=4\r
	@ScriptName=DiffuseAlpha\r
    DiffuseAlpha : Int = -250004 #%(T_46_META_WS_P_DIFFUSEALPHA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Particles\r
@Addable=["CustomLevelObject"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Particles : Playable&Loopable = 417 { #%(T_48_META_TYP_417)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
    ResUUID : ParticlesID = -417000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -417001 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ApiTarget=1\r
    RendererOnly : Bool = -417002 #%(T_55_META_TYP_417_I2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SprayResultUI\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type SprayResultHud : InternalHud = 252 { #%(T_46_META_WS_C_SPRAYRESULTUI)\r
	@ApiLevel=4\r
	@ScriptName=LeftColor\r
    LeftColor : Color = -252000 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=LeftIcon\r
    LeftIcon : SpriteID = -252001 #%(T_46_META_WS_P_LEFTICON)\r
	@ApiLevel=4\r
	@ScriptName=LeftText\r
    LeftText : String = -252002 #%(T_46_META_WS_P_LEFTTEXT)\r
	@ApiLevel=4\r
	@ScriptName=LeftScoreText\r
    LeftScoreText : String = -252003 #%(T_46_META_WS_P_LEFTSCORETEXT)\r
	@ApiLevel=4\r
	@ScriptName=RightColor\r
    RightColor : Color = -252004 #%(T_46_META_WS_P_RIGHTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=RightIcon\r
    RightIcon : SpriteID = -252005 #%(T_46_META_WS_P_RIGHTICON)\r
	@ApiLevel=4\r
	@ScriptName=RightText\r
    RightText : String = -252006 #%(T_46_META_WS_P_RIGHTTEXT)\r
	@ApiLevel=4\r
	@ScriptName=RightScoreText\r
    RightScoreText : String = -252007 #%(T_46_META_WS_P_RIGHTSCORETEXT)\r
	@ApiLevel=4\r
	@ScriptName=Progress\r
    Progress : Float = -252008 #%(T_46_META_WS_P_PROGRESS)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -252009 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UITipButton\r
@ModuleID=31\r
@ModuleLib=Hud\r
type HintButtonHud : InternalHud = 253 { #%(T_46_META_WS_C_UITIPBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    Icon : SpriteID = -253000 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=Text\r
    Text : String = -253001 #%(T_46_META_WS_P_TEXT)\r
	@ApiLevel=4\r
	@ScriptName=EffectActive\r
    EffectActive : Bool = -253002 #%(T_46_META_WS_P_EFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
    NormalizedPosition : Vector3 = -253003 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -253004 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampLocString\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type TimestampLocString : String = 255 { #%(T_46_META_WS_C_TIMESTAMPLOCSTRING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampLocStringMs\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@NotNull=True\r
type TimestampMsLocString : String = 450 { #%(T_49_META_TYP_450)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampFormatStyleType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum TimestampFormatStyle : Int = 258 { #%(T_46_META_WS_C_TIMESTAMPFORMATSTYLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=DateTime\r
    DateTime = 1 #%(T_46_META_WS_E_DATETIME)\r
	@ApiLevel=4\r
	@ScriptName=ShortTime\r
    ShortTime = 2 #%(T_46_META_WS_E_SHORTTIME)\r
	@ApiLevel=4\r
	@ScriptName=ShortDateTime\r
    ShortDateTime = 3 #%(T_46_META_WS_E_SHORTDATETIME)\r
	@ApiLevel=4\r
	@ScriptName=ShortDate\r
    ShortDate = 4 #%(T_46_META_WS_E_SHORTDATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISimpleTip\r
@ModuleID=31\r
@ModuleLib=Hud\r
type TipHud : InternalHud = 259 { #%(T_46_META_WS_C_UISIMPLETIP)\r
	@ApiLevel=4\r
	@ScriptName=Background\r
    Background : SpriteID = -259000 #%(T_46_META_WS_P_BACKGROUND)\r
	@ApiLevel=4\r
	@ScriptName=Text\r
    Text : String = -259001 #%(T_46_META_WS_P_TEXT)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
    NormalizedPosition : Vector3 = -259002 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=EnableLocalization\r
    LocSwitch : Bool = -259003 #%(T_46_META_WS_P_ENABLELOCALIZATION)\r
	@ApiLevel=4\r
	@ScriptName=TextColor\r
    TextColor : Color = -259004 #%(T_46_META_WS_P_TEXTCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIProgressSkillButton\r
@ModuleID=31\r
@ModuleLib=Hud\r
type ProgressSkillButtonHud : InternalHud = 260 { #%(T_46_META_WS_C_UIPROGRESSSKILLBUTTON)\r
	@ApiLevel=4\r
	@ScriptName=Icon\r
    Icon : SpriteID = -260000 #%(T_46_META_WS_P_ICON)\r
	@ApiLevel=4\r
	@ScriptName=Color\r
    Color : Color = -260001 #%(T_44_XXJ_WS_COLOR)\r
	@ApiLevel=4\r
	@ScriptName=Value\r
    Value : Float = -260002 #%(T_46_META_WS_P_VALUE)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
    Speed : Float = -260003 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=EffectActive\r
    EffectActive : Bool = -260004 #%(T_46_META_WS_P_EFFECTACTIVE)\r
	@ApiLevel=4\r
	@ScriptName=NormalizedPosition\r
    NormalizedPosition : Vector3 = -260005 #%(T_46_META_WS_P_NORMALIZEDPOSITION)\r
	@ApiLevel=4\r
	@ScriptName=InitialValue\r
    InitialValue : Float = -260006 #%(T_46_META_WS_P_INITIALVALUE)\r
	@ApiLevel=4\r
	@ScriptName=EffectColor\r
    EffectColor : Color = -260007 #%(T_46_META_WS_P_EFFECTCOLOR)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Scale\r
    Scale : Float = -260008 #%(T_46_META_WS_P_SCALE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ThreeStatusSwitch\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum CommonHudSwitchValue : Int = 268 { #%(T_42_XXJ_WS_THREESTATESWITCH)\r
	@ApiLevel=3\r
	@ScriptName=OriginalLogic\r
    Original = -1 #%(T_40_XXJ_WS_ORIGINAL)\r
	@ApiLevel=4\r
	@ScriptName=Close\r
    Close = 0 #%(T_46_META_WS_E_CLOSE)\r
	@ApiLevel=4\r
	@ScriptName=Show\r
    Show = 1 #%(T_46_META_WS_E_SHOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniMap\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
type MiniMap : Entity = 273 { #%(T_46_META_WS_C_MINIMAP)\r
	@ApiLevel=4\r
	@ScriptName=Center\r
    Center : Vector3 = -273000 #%(T_46_META_WS_P_CENTER)\r
	@ApiLevel=4\r
	@Default=100\r
	@ScriptName=MapSize\r
    MapSize : Int = -273001 #%(T_46_META_WS_P_MAPSIZE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=EnableDepthMap\r
    UseDepthMap : Bool = -273002 #%(T_46_META_WS_P_ENABLEDEPTHMAP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MiniMapIcon\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
type MiniMapIcon : Entity = 274 { #%(T_46_META_WS_C_MINIMAPICON)\r
	@ApiLevel=4\r
	@ScriptName=IconResource\r
    IconPath : SpriteID = -274000 #%(T_46_META_WS_P_ICONRESOURCE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=Scale\r
    Scale : Float = -274001 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
	@ScriptName=Offset\r
    Offset : Vector3 = -274002 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@ScriptName=FollowTarget\r
    FollowTarget : Entity = -274003 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
    Depth : Int = -274004 #%(T_46_META_WS_P_DEPTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MinimapPixelRenderer\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
type MiniMapBit : Entity = 278 { #%(T_46_META_WS_C_MINIMAPPIXELRENDERER)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
    Target : Entity = -278000 #%(T_43_YU_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkeletonPart\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SkeletonPart : Entity = 275 { #%(T_46_META_WS_C_SKELETONPART)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
	@ScriptName=BoneScale\r
    BoneScale : Vector3 = -275000 #%(T_46_META_WS_P_BONESCALE)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=BonePosition\r
	@ApiTarget=1\r
    get BonePosition : Vector3 = -275001 #%(T_46_META_WS_P_BONEPOSITION)\r
	@ApiLevel=4\r
	@Default=math.Vector3_0()\r
	@ScriptName=BoneRotation\r
	@ApiTarget=1\r
    get BoneRotation : Vector3 = -275002 #%(T_52_META_TYP_275_I2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkeletonPartController\r
@ModuleID=38\r
@ModuleLib=Avatar\r
type SkeletonPartController : Entity = 447 { #%(T_49_META_TYP_447)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SkeletonPartLookAtController\r
@ModuleID=38\r
@ModuleLib=Avatar\r
type SkeletonPartLookAtController : SkeletonPartController = 448 { #%(T_49_META_TYP_448)\r
	@ApiLevel=4\r
	@ScriptName=ControlledTarget\r
    ControlBone : SkeletonPart = -448000 #%(T_49_META_TYP_448_I0)\r
	@ApiLevel=4\r
	@ScriptName=LookAtTarget\r
	@ApiTarget=1\r
    LookAt : Transform = -448001 #%(T_49_META_TYP_448_I1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Skeleton\r
@ModuleID=10010\r
@ModuleLib=Player\r
type Skeleton : Entity = 276 { #%(T_46_META_WS_C_SKELETON)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
    get Head : SkeletonPart = -276000 #%(T_46_META_WS_P_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=LeftArm\r
    get LeftArm : SkeletonPart = -276001 #%(T_46_META_WS_P_LEFTARM)\r
	@ApiLevel=4\r
	@ScriptName=LeftHand\r
    get LeftHand : SkeletonPart = -276002 #%(T_46_META_WS_P_LEFTHAND)\r
	@ApiLevel=4\r
	@ScriptName=RightArm\r
    get RightArm : SkeletonPart = -276003 #%(T_46_META_WS_P_RIGHTARM)\r
	@ApiLevel=4\r
	@ScriptName=RightHand\r
    get RightHand : SkeletonPart = -276004 #%(T_46_META_WS_P_RIGHTHAND)\r
	@ApiLevel=4\r
	@ScriptName=Body\r
    get Body : SkeletonPart = -276005 #%(T_46_META_WS_P_BODY)\r
	@ApiLevel=4\r
	@ScriptName=LeftLeg\r
    get LeftLeg : SkeletonPart = -276006 #%(T_46_META_WS_P_LEFTLEG)\r
	@ApiLevel=4\r
	@ScriptName=LeftFoot\r
    get LeftFoot : SkeletonPart = -276007 #%(T_46_META_WS_P_LEFTFOOT)\r
	@ApiLevel=4\r
	@ScriptName=RightLeg\r
    get RightLeg : SkeletonPart = -276008 #%(T_46_META_WS_P_RIGHTLEG)\r
	@ApiLevel=4\r
	@ScriptName=RightFoot\r
    get RightFoot : SkeletonPart = -276009 #%(T_46_META_WS_P_RIGHTFOOT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraRaycastUI\r
@ModuleID=10007\r
@ModuleLib=Camera\r
type CameraRayCastHud : InternalHud = 277 { #%(T_46_META_WS_C_CAMERARAYCASTUI)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -277000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=Distance\r
    Distant : Float = -277001 #%(T_46_META_WS_P_DISTANCE)\r
	@ApiLevel=4\r
	@Default=4\r
	@ScriptName=LayerType\r
    LayerType : Int = -277002 #%(T_46_META_WS_P_LAYERTYPE)\r
	@ApiLevel=4\r
	@ScriptName=CenterOffset\r
    CenterOffset : Vector2 = -277003 #%(T_46_META_WS_P_CENTEROFFSET)\r
	@ApiLevel=4\r
	@ScriptName=SpriteResource\r
    IconSpriteName : SpriteID = -277004 #%(T_46_META_WS_P_SPRITERESOURCE)\r
	@ApiLevel=4\r
	@Default=&math.Vector2(100, 100)\r
	@ScriptName=ClickSize\r
    ClickSize : Vector2 = -277005 #%(T_46_META_WS_P_CLICKSIZE)\r
	@ApiLevel=4\r
	@ScriptName=ShowHitPointEffect\r
    ShowHitPointEffect : Bool = -277006 #%(T_46_META_WS_P_SHOWHITPOINTEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=HitPointEffect\r
    HitPointEffect : Entity = -277007 #%(T_46_META_WS_P_HITPOINTEFFECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColorDrum\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
type ColorDrum : Oildrum = 279 { #%(T_46_META_WS_C_COLORDRUM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SphereTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type SphereTrigger : CustomizeTrigger = 280 { #%(T_46_META_WS_C_SPHERETRIGGER)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=Radius\r
    Radius : Float = -280000 #%(T_46_META_WS_P_RADIUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CapsuleTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type CapsuleTrigger : CustomizeTrigger = 281 { #%(T_46_META_WS_C_CAPSULETRIGGER)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=Radius\r
    Radius : Float = -281000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=Height\r
    Height : Float = -281001 #%(T_46_META_WS_P_HEIGHT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTree\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTree : Entity = 290 { #%(T_46_META_WS_C_BEVTREE)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=TickInterval\r
    TickInterval : Int = -290000 #%(T_46_META_WS_P_TICKINTERVAL)\r
	@ApiLevel=3\r
	@Default=false\r
	@ScriptName=IsDebug\r
    Debug : Bool = -290001 #%(T_46_META_WS_P_ISDEBUG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeNodeType\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
enum BTCustomNodeType : Int = 291 { #%(T_46_META_WS_C_BEVTREENODETYPE)\r
	@ApiLevel=4\r
	@ScriptName=ConditionNode\r
    Condition = 1 #%(T_46_META_WS_E_CONDITIONNODE)\r
	@ApiLevel=4\r
	@ScriptName=ActionNode\r
    Action = 2 #%(T_46_META_WS_E_ACTIONNODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeCustomNode\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
type BehaviourTreeNode : Entity = 292 { #%(T_46_META_WS_C_BEVTREECUSTOMNODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterSkillType\r
@ModuleID=10008\r
@ModuleLib=AI\r
enum AISkillType : Int = 301 { #%(T_41_XXJ_WS_MONSTERSKILLTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowAttack\r
    ThrowAttack = 1 #%(T_46_META_WS_E_THROWATTACK)\r
	@ApiLevel=4\r
	@ScriptName=Explode\r
    Explode = 2 #%(T_46_META_WS_E_EXPLODE)\r
	@ApiLevel=4\r
	@ScriptName=DashAttack\r
    DashAttack = 3 #%(T_46_META_WS_E_DASHATTACK)\r
	@ApiLevel=4\r
	@ScriptName=ShockWave\r
    ShockWave = 4 #%(T_46_META_WS_E_SHOCKWAVE)\r
	@ApiLevel=4\r
	@ScriptName=WindAttack\r
    WindAttack = 6 #%(T_46_META_WS_E_WINDATTACK)\r
	@ApiLevel=4\r
	@ScriptName=JumpAttack\r
    JumpAttack = 13 #%(T_46_META_WS_E_JUMPATTACK)\r
	@ApiLevel=4\r
	@ScriptName=ShieldUp\r
    ShieldUp = 22 #%(T_46_META_WS_E_SHIELDUP)\r
	@ApiLevel=4\r
	@ScriptName=ShieldBroken\r
    ShieldBroken = 23 #%(T_46_META_WS_E_SHIELDBROKEN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BevTreeNodeStatus\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
enum BTreeNodeState : Int = 305 { #%(T_46_META_WS_C_BEVTREENODESTATUS)\r
	@ApiLevel=4\r
	@ScriptName=Finish\r
    Finish = 1 #%(T_46_META_WS_E_FINISH)\r
	@ApiLevel=4\r
	@ScriptName=Running\r
    Running = 2 #%(T_46_META_WS_E_RUNNING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IceWallMaker\r
@ModuleID=10014\r
@ModuleLib=Items\r
type IceWallMaker : Entity = 307 { #%(T_46_META_WS_C_ICEWALLMAKER)\r
	@ApiLevel=4\r
	@ScriptName=ExpPerDamage\r
    ExpPerDamage : Float = -307000 #%(T_46_META_WS_P_EXPPERDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=ExpPerMoveMile\r
    ExpPerMoveMile : Float = -307001 #%(T_46_META_WS_P_EXPPERMOVEMILE)\r
	@ApiLevel=4\r
	@ScriptName=ExpPerSecond\r
    ExpPerSecond : Float = -307002 #%(T_46_META_WS_P_EXPPERSECOND)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ChipExp\r
    ExpChip : Float = -307003 #%(T_46_META_WS_P_CHIPEXP)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ChargeMax\r
    ChargeMax : Float = -307004 #%(T_46_META_WS_P_CHARGEMAX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeWeapon\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeWeapon : Weapon = 311 { #%(T_46_META_WS_C_GRENADEWEAPON)\r
	@ApiLevel=4\r
	@ScriptName=MinDamage\r
    GrenadeMinDamage : Int = -311000 #%(T_46_META_WS_P_MINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=MaxDamage\r
    GrenadeMaxDamage : Int = -311001 #%(T_46_META_WS_P_MAXDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=Range\r
    GrenadeRange : Float = -311002 #%(T_46_META_WS_P_EXPLODERANGE)\r
	@ApiLevel=4\r
	@ScriptName=ThrowSpeed\r
    GrenadeThrowSpeed : Float = -311003 #%(T_46_META_WS_P_THROWINGSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ExplosionTime\r
    GrenadeExplosionTime : Float = -311004 #%(T_46_META_WS_P_EXPLOSIONTIME)\r
	@ApiLevel=4\r
	@ScriptName=RatioSelfFactor\r
    GrenadeRatioSelf : Float = -311005 #%(T_46_META_WS_P_RATIOSELFFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=RatioTeammateFactor\r
    GrenadeRatioTeammate : Float = -311006 #%(T_46_META_WS_P_RATIOTEAMMATEFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=RatioVehicleFactor\r
    GrenadeRatioVehicle : Float = -311007 #%(T_46_META_WS_P_RATIOVEHICLEFACTOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeLauncher\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeLauncher : GrenadeWeapon = 309 { #%(T_46_META_WS_C_GRENADELAUNCHER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CrossBow\r
@ModuleID=10014\r
@ModuleLib=Items\r
type CrossBow : GrenadeWeapon = 310 { #%(T_46_META_WS_C_CROSSBOW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HandCannon\r
@ModuleID=10014\r
@ModuleLib=Items\r
type HandCannon : GrenadeWeapon = 312 { #%(T_46_META_WS_C_HANDCANNON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GrenadeDeIceWall\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeDeIceWall : InventoryBase&Grenade = 313 { #%(T_46_META_WS_C_GRENADEDEICEWALL)\r
	@ApiLevel=4\r
	@ScriptName=Radius\r
    ZoneRadius : Float = -313000 #%(T_46_META_WS_P_RADIUS)\r
	@ApiLevel=4\r
	@ScriptName=Duration\r
    ZoneDuration : Float = -313001 #%(T_46_META_WS_P_DURATION)\r
	@ApiLevel=4\r
	@Default=230\r
	@ScriptName=ZoneDamage\r
    ZoneDamage : Int = -313002 #%(T_46_META_WS_P_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Attachment\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Attachment : InventoryBase&FormulableEntity = 318 { #%(T_46_META_WS_C_ATTACHMENT)\r
	@ApiLevel=4\r
	@ScriptName=AttackRange\r
    Range : Float = -318000 #%(T_46_META_WS_P_ATTACKRANGE)\r
	@ApiLevel=4\r
	@ScriptName=FullDamageDistance\r
    FullDamageDistance : Float = -318001 #%(T_46_META_WS_P_FULLDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=MinDamageDistance\r
    MinDamageDistance : Float = -318002 #%(T_46_META_WS_P_MINDAMAGEDISTANCE)\r
	@ApiLevel=4\r
	@ScriptName=AmmoClipSize\r
    AmmoClipSize : Int = -318003 #%(T_46_META_WS_P_AMMOCLIPSIZE)\r
	@ApiLevel=4\r
	@ScriptName=AttackInterval\r
    FireInterval : Float = -318004 #%(T_32_YS_WEAPON_TAG_3)\r
	@ApiLevel=4\r
	@ScriptName=ReloadSpeed\r
    ReloadSpeed : Float = -318005 #%(T_46_META_WS_P_RELOADSPEED)\r
	@ApiLevel=4\r
	@ScriptName=FastAutoReloadSpeed\r
    FastAutoReloadSpeed : Float = -318006 #%(T_46_META_WS_P_FASTAUTORELOADSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScatterSpeed\r
    ScatterSpeed : Float = -318007 #%(T_46_META_WS_P_SCATTERSPEED)\r
	@ApiLevel=4\r
	@ScriptName=ScatterSpeedCrouchProne\r
    ScatterSpeedCrouchCreep : Float = -318008 #%(T_46_META_WS_P_SCATTERSPEEDCROUCHPRONE)\r
	@ApiLevel=4\r
	@ScriptName=ScatterMax\r
    ScatterMax : Float = -318009 #%(T_46_META_WS_P_SCATTERMAX)\r
	@ApiLevel=4\r
	@ScriptName=PlayerAimingSpeedFactor\r
    PlayerSpeedFactorAiming : Float = -318010 #%(T_46_META_WS_P_PLAYERAIMINGSPEEDFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=SightAmplifyRatio\r
    SightAmplifyRatio : Int = -318011 #%(T_46_META_WS_P_SIGHTAMPLIFYRATIO)\r
	@ApiLevel=4\r
	@ScriptName=SightFOVAmplifyRatio\r
    SightFOVAmplifyRatio : Float = -318012 #%(T_46_META_WS_P_SIGHTFOVAMPLIFYRATIO)\r
	@ApiLevel=4\r
	@ScriptName=SightUIActionRatio\r
    SightUiActionRatio : Float = -318013 #%(T_46_META_WS_P_SIGHTUIACTIONRATIO)\r
	@ApiLevel=4\r
	@ScriptName=SightUIActionExpand\r
    SightUiActionExpand : Float = -318014 #%(T_46_META_WS_P_SIGHTUIACTIONEXPAND)\r
	@ApiLevel=4\r
	@ScriptName=SightUIActionRecovery\r
    SightUiActionRecovery : Float = -318015 #%(T_46_META_WS_P_SIGHTUIACTIONRECOVERY)\r
	@ApiLevel=4\r
	@ScriptName=SightShootMinDamage\r
    SightShootMinDamage : Int = -318016 #%(T_46_META_WS_P_SIGHTSHOOTMINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssist\r
    SightAimAssist : Bool = -318017 #%(T_46_META_WS_P_SIGHTAIMASSIST)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistSnapRange\r
    SightAimAssistSnapRange : Float = -318018 #%(T_46_META_WS_P_SIGHTAIMASSISTSNAPRANGE)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistFalloff\r
    SightAimAssistDistFalloff : Float = -318019 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTFALLOFF)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistpriority\r
    SightAimAssistDistpriority : Bool = -318020 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIORITY)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistprioMin\r
    SightAimAssistDistprioMin : Float = -318021 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMIN)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistprioMax\r
    SightAimAssistDistprioMax : Float = -318022 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOMAX)\r
	@ApiLevel=4\r
	@ScriptName=SightAimAssistDistprioCoef\r
    SightAimAssistDistprioCoef : Float = -318023 #%(T_46_META_WS_P_SIGHTAIMASSISTDISTPRIOCOEF)\r
	@ApiLevel=4\r
	@ScriptName=SightRotSensitiveness\r
    SightRotSensitiveness : Float = -318024 #%(T_46_META_WS_P_SIGHTROTSENSITIVENESS)\r
	@ApiLevel=4\r
	@ScriptName=ShrinkSpeed\r
    ShrinkSpeed : Float = -318025 #%(T_46_META_WS_P_SHRINKSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DamagedBodyPartType\r
@ModuleID=10016\r
@ModuleLib=Combat\r
enum HitBodyPart : Int = 322 { #%(T_46_META_WS_C_DAMAGEDBODYPARTTYPE)\r
	@ApiLevel=4\r
	@ScriptName=None\r
    None = 0 #%(T_46_META_WS_E_NONE)\r
	@ApiLevel=4\r
	@ScriptName=Head\r
    Head = 1 #%(T_46_META_WS_E_HEAD)\r
	@ApiLevel=4\r
	@ScriptName=Body\r
    Body = 2 #%(T_46_META_WS_E_BODY)\r
	@ApiLevel=4\r
	@ScriptName=Limb\r
    Limb = 3 #%(T_46_META_WS_E_LIMB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SeatType\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
enum SeatType : Int = 329 { #%(T_46_META_WS_C_SEATTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Driver\r
    Driver = 0 #%(T_46_META_WS_E_DRIVER)\r
	@ApiLevel=4\r
	@ScriptName=PassengerA\r
    Passenger1 = 1 #%(T_46_META_WS_E_PASSENGERA)\r
	@ApiLevel=4\r
	@ScriptName=PassengerB\r
    Passenger2 = 2 #%(T_46_META_WS_E_PASSENGERB)\r
	@ApiLevel=4\r
	@ScriptName=PassengerC\r
    Passenger3 = 3 #%(T_46_META_WS_E_PASSENGERC)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VehicleIDType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum VehicleID : Int = 350 { #%(T_46_META_WS_C_VEHICLEIDTYPE)\r
	@ApiLevel=4\r
    SportsCar = 118 #%(T_46_META_WS_E_SPORTSCAR)\r
	@ApiLevel=4\r
    Motorbike = 117 #%(T_46_META_WS_E_MOTORBIKE)\r
	@ApiLevel=4\r
    Jeep = 113 #%(T_46_META_WS_E_JEEP)\r
	@ApiLevel=4\r
	@ScriptName=SUV\r
    Suv = 112 #%(T_46_META_WS_E_SUV)\r
	@ApiLevel=4\r
    MonsterTruck = 116 #%(T_46_META_WS_E_MONSTERTRUCK)\r
	@ApiLevel=4\r
    TukTuk = 114 #%(T_46_META_WS_E_TUKTUK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundEffect\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type SoundEntity : Transform&Playable&Loopable = 335 { #%(T_46_META_WS_C_SOUNDEFFECT)\r
	@ApiLevel=4\r
	@ScriptName=Resource\r
    SoundType : AudioID = -335000 #%(T_46_META_WS_P_RESOURCE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=RepeatTimes\r
    RepeatTimes : Int = -335001 #%(T_46_META_WS_P_REPEATTIMES)\r
	@ApiLevel=4\r
	@Default=50\r
	@ScriptName=Volume\r
    Volume : Int = -335002 #%(T_46_META_WS_P_VOLUME)\r
	@ApiLevel=4\r
	@Default=30\r
	@ScriptName=MaxDistance\r
    MaxDistance : Float = -335003 #%(T_46_META_WS_P_MAXDISTANCE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=MinDistance\r
    MinDistance : Float = -335004 #%(T_46_META_WS_P_MINDISTANCE)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=Is3D\r
    Is3D : Bool = -335005 #%(T_46_META_WS_P_IS3D)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Priority\r
    Priority : Int = -335006 #%(T_46_META_WS_P_PRIORITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=StartTime\r
    StartTime : Float = -335007 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=3\r
	@Default=2\r
	@ScriptName=IsPlaying\r
    get State : Int = -335008 #%(T_46_META_WS_P_ISPLAYING)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=ElapsedTime\r
    get PlayedTime : Int = -335009 #%(T_49_META_TYP_335_I9)\r
	@ApiLevel=4\r
    Speed : Float = -335010 #%(T_46_META_WS_P_SPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_SoundEffect\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_SoundEntity : List = 336 { #%(T_46_META_WS_C_LISTT_SOUNDEFFECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SoundEffectOrSoundEffectList\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias SoundEntityOrListSoundEntity : Object&(SoundEntity|ListT_SoundEntity) = 337 #%(T_46_META_WS_C_SOUNDEFFECTORSOUNDEFFECTLIST)\r
\r
@ApiLevel=3\r
@ScriptName=PlayerBehavior\r
@ModuleID=10010\r
@ModuleLib=Player\r
type PlayerBehavior : Entity = 338 { #%(T_42_XXJ_WS_PLAYERBEHAVIOR)\r
	@ApiLevel=3\r
	@ScriptName=MovementStatus\r
    get MovementStatus : PlayerBehaviorStatus = -338000 #%(T_42_XXJ_WS_MOVEMENTSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=SprintStatus\r
    get SprintStatus : PlayerBehaviorStatus = -338001 #%(T_42_XXJ_WS_SPRINTSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=AttackStatus\r
    get AttackStatus : PlayerBehaviorStatus = -338002 #%(T_42_XXJ_WS_ATTACKSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=JumpStatus\r
    get JumpStatus : PlayerBehaviorStatus = -338003 #%(T_42_XXJ_WS_JUMPSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=ClimbStatus\r
    get ClimbStatus : PlayerBehaviorStatus = -338004 #%(T_42_XXJ_WS_CLIMBSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=GetOnAsDriverStatus\r
    get GetOnAsDriverStatus : PlayerBehaviorStatus = -338005 #%(T_42_XXJ_WS_GETONASDRIVERSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=GetOnAsPassengerStatus\r
    get GetOnAsPassengerStatus : PlayerBehaviorStatus = -338006 #%(T_42_XXJ_WS_GETONASPASSENGERSTATUS)\r
	@ApiLevel=3\r
	@ScriptName=GetOffVehicleStatus\r
    get GetOffVehicleStatus : PlayerBehaviorStatus = -338007 #%(T_42_XXJ_WS_GETOFFVEHICLESTATUS)\r
	@ApiLevel=3\r
	@ScriptName=DrivingStatus\r
    get DrivingStatus : PlayerBehaviorStatus = -338008 #%(T_42_XXJ_WS_DRIVINGSTATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EquipmentAttachment\r
@ModuleID=10010\r
@ModuleLib=Player\r
type EquipmentAttachment : InventoryBase&FormulableEntity = 339 { #%(T_46_META_WS_C_EQUIPMENTATTACHMENT)\r
	@ApiLevel=4\r
	@ScriptName=DamageRatioLimb\r
    DamageRatioLimb : Float = -339000 #%(T_46_META_WS_P_DAMAGERATIOLIMB)\r
	@ApiLevel=4\r
	@ScriptName=DamageRatioHead\r
    DamageRatioHead : Float = -339001 #%(T_46_META_WS_P_DAMAGERATIOHEAD)\r
	@ApiLevel=4\r
	@ScriptName=MaxDurabilityRatio\r
    MaxDurabilityRatio : Float = -339002 #%(T_46_META_WS_P_MAXDURABILITYRATIO)\r
	@ApiLevel=4\r
	@ScriptName=ExtraHPRatio\r
    ExtraHpRatio : Float = -339003 #%(T_46_META_WS_P_EXTRAHPRATIO)\r
	@ApiLevel=4\r
	@ScriptName=ExplodeDamageReductionFactor\r
    DamageReductionFactorExplode : Int = -339004 #%(T_46_META_WS_P_EXPLODEDAMAGEREDUCTIONFACTOR)\r
	@ApiLevel=4\r
	@ScriptName=ExtraBackpackCapacity\r
    ExtraBagCapacity : Int = -339005 #%(T_46_META_WS_P_EXTRABACKPACKCAPACITY)\r
	@ApiLevel=4\r
	@ScriptName=ReplacementPriority\r
    ReplacementPriority : Int = -339006 #%(T_46_META_WS_P_REPLACEMENTPRIORITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BotDifficultyType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum BotDifficulty : Int = 340 { #%(T_46_META_WS_C_BOTDIFFICULTYTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Easy\r
    Easy = 0 #%(T_46_META_WS_E_EASY)\r
	@ApiLevel=4\r
	@ScriptName=Simple\r
    Simple = 1 #%(T_46_META_WS_E_SIMPLE)\r
	@ApiLevel=4\r
	@ScriptName=Normal\r
    Normal = 2 #%(T_46_META_WS_E_NORMAL)\r
	@ApiLevel=4\r
	@ScriptName=Moderate\r
    Moderate = 3 #%(T_46_META_WS_E_MODERATE)\r
	@ApiLevel=4\r
	@ScriptName=Hard\r
    Hard = 4 #%(T_46_META_WS_E_HARD)\r
	@ApiLevel=4\r
	@ScriptName=Hell\r
    Hell = 5 #%(T_46_META_WS_E_HELL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IntegerMapTemplate\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MapT_Int_Int : Map = 341 { #%(T_46_META_WS_C_INTEGERMAPTEMPLATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Timer\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Clock : LevelObject = 342 { #%(T_46_META_WS_C_TIMER)\r
	@ApiLevel=4\r
	@ScriptName=StartEvent\r
    get StartEventID : EventID = -342000 #%(T_46_META_WS_P_STARTEVENT)\r
	@ApiLevel=4\r
	@ScriptName=StopEvent\r
    get StopEventID : EventID = -342001 #%(T_46_META_WS_P_STOPEVENT)\r
	@ApiLevel=4\r
	@ScriptName=PauseEvent\r
    get PauseEventID : EventID = -342002 #%(T_46_META_WS_P_PAUSEEVENT)\r
	@ApiLevel=4\r
    StartTime : Int = -342003 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
    LoopCount : Int = -342004 #%(T_46_META_WS_P_LOOPCOUNT)\r
	@ApiLevel=4\r
    get Events : MapT_Int_EventID = -342005 #%(T_46_META_WS_P_EVENTS)\r
	@ApiLevel=4\r
    IsCountdown : Bool = -342006 #%(T_46_META_WS_P_ISCOUNTDOWN)\r
	@ApiLevel=4\r
	@ScriptName=Status\r
    get State : Int = -342007 #%(T_46_META_WS_P_STATUS)\r
	@ApiLevel=4\r
	@ScriptName=CountdownEndTime\r
    get EndTimeS : Int = -342008 #%(T_46_META_WS_P_COUNTDOWNENDTIME)\r
	@ApiLevel=4\r
	@ScriptName=CountdownTime\r
    get DurationTimeS : Int = -342009 #%(T_46_META_WS_P_COUNTDOWNTIME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
type ThrowingKnife : Weapon = 343 { #%(T_42_SJ_WS_KNIFEITEMPICK)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
type ThrowingKnifeBR : ThrowingKnife = 344 { #%(T_42_SJ_WS_KNIFEITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MedKit\r
@ModuleID=10014\r
@ModuleLib=Items\r
type FirstAidKit : InventoryBase&FormulableEntity = 353 { #%(T_46_META_WS_C_MEDKIT)\r
	@ApiLevel=4\r
	@ScriptName=HPRecoveryAmount\r
    Health : Int = -353000 #%(T_46_META_WS_P_HPRECOVERYAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=HPRecoverySpeed\r
    Duration : Int = -353001 #%(T_46_META_WS_P_HPRECOVERYSPEED)\r
	@ApiLevel=4\r
	@ScriptName=TimeRequired\r
    Pretime : Int = -353002 #%(T_46_META_WS_P_TIMEREQUIRED)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Inhaler : FirstAidKit = 354 { #%(T_46_META_WS_C_INHALER)\r
	@ApiLevel=4\r
	@ScriptName=EPRecoveryAmount\r
    Energy : Int = -354000 #%(T_46_META_WS_P_EPRECOVERYAMOUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Horizaline\r
@ModuleID=10014\r
@ModuleLib=Items\r
type Pacemaker : InventoryBase&FormulableEntity = 355 { #%(T_46_META_WS_C_HORIZALINE)\r
	@ApiLevel=4\r
	@ScriptName=HPRecoveryAmount\r
    Health : Int = -355000 #%(T_46_META_WS_P_HPRECOVERYAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=EPRecoveryAmount\r
    Energy : Int = -355001 #%(T_46_META_WS_P_EPRECOVERYAMOUNT)\r
	@ApiLevel=4\r
	@ScriptName=TimeRequired\r
    Pretime : Int = -355002 #%(T_46_META_WS_P_TIMEREQUIRED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Airdrop\r
@ModuleID=40\r
@ModuleLib=AirDrop\r
type AirDrop : Transform&ResetableEntity = 356 { #%(T_46_META_WS_C_AIRDROP)\r
	@ApiLevel=4\r
	@ScriptName=DropItems\r
    DropItems : MapT_Int_Int = -356000 #%(T_46_META_WS_P_DROPITEMS)\r
	@ApiLevel=4\r
	@ScriptName=StartDropTime\r
    StartDropTime : Int = -356001 #%(T_46_META_WS_P_STARTDROPTIME)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=AirDropState\r
    get AirDropState : Int = -356002 #%(T_46_META_WS_P_AIRDROPSTATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LaunchPad\r
@ModuleID=10014\r
@ModuleLib=Items\r
type HandCatapult : InventoryBase&FormulableEntity = 360 { #%(T_46_META_WS_C_LAUNCHPAD)\r
	@ApiLevel=4\r
	@Default=-160\r
	@ScriptName=LeftFiringArcAngle\r
    HorizontalMinAngle : Float = -360000 #%(T_46_META_WS_P_LEFTFIRINGARCANGLE)\r
	@ApiLevel=4\r
	@Default=160\r
	@ScriptName=RightFiringArcAngle\r
    HorizontalMaxAngle : Float = -360001 #%(T_46_META_WS_P_RIGHTFIRINGARCANGLE)\r
	@ApiLevel=4\r
	@Default=-45\r
	@ScriptName=MinElevationAngle\r
    VerticalMinAngle : Float = -360002 #%(T_46_META_WS_P_MINELEVATIONANGLE)\r
	@ApiLevel=4\r
	@Default=-7\r
	@ScriptName=MaxDepressionAngle\r
    VerticalMaxAngle : Float = -360003 #%(T_46_META_WS_P_MAXDEPRESSIONANGLE)\r
	@ApiLevel=4\r
	@Default=35.0\r
	@ScriptName=MuzzleVelocity\r
    Speed : Float = -360004 #%(T_46_META_WS_P_MUZZLEVELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LaunchPadLevelObject\r
@ModuleID=10014\r
@ModuleLib=Items\r
type HandCatapultLevelObj : HandCatapult = 361 { #%(T_46_META_WS_C_LAUNCH PAD LEVEL OBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SocialIslandSnowball\r
@ModuleID=10014\r
@ModuleLib=Items\r
type GrenadeSnowball : Grenade = 362 { #%(T_46_META_WS_C_SOCIALISLANDSNOWBALL)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=FreezeDuration\r
    FreezingTime : Float = -362000 #%(T_46_META_WS_P_FREEZEDURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AnimationTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type AnimationTrigger : CustomizeTrigger = 364 { #%(T_46_META_WS_C_ANIMATIONTRIGGER)\r
	@ApiLevel=4\r
	@ScriptName=IsCenterPos\r
    IsCenterPos : Bool = -364000 #%(T_46_META_WS_P_ISCENTERPOS)\r
	@ApiLevel=4\r
	@ScriptName=IsLoop\r
    Loop : Bool = -364001 #%(T_46_META_WS_P_ISLOOP)\r
	@ApiLevel=4\r
	@ScriptName=AnimationClip\r
    Clip : AnimationClipID = -364002 #%(T_46_META_WS_P_ANIMATIONCLIP)\r
	@ApiLevel=4\r
	@ScriptName=IsAutoPlay\r
    IsAutoPlay : Bool = -364003 #%(T_46_META_WS_P_ISAUTOPLAY)\r
	@ApiLevel=4\r
	@ScriptName=UseCustomResource\r
    IsCustomEmote : Bool = -364004 #%(T_46_META_WS_P_USECUSTOMRESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIAniTriggerHud\r
@ModuleID=31\r
@ModuleLib=Hud\r
type UGCAniTriggerHud : InternalHud = 365 { #%(T_46_META_WS_C_UIANITRIGGERHUD)\r
	@ApiLevel=3\r
	@Default=true\r
	@ScriptName=IsVisible\r
    get OpenState : Bool = -365000 #%(T_46_META_WS_P_ISVISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UICompass\r
@ModuleID=31\r
@ModuleLib=Hud\r
type DirectionRulerHud : InternalHud = 367 { #%(T_46_META_WS_C_UICOMPASS)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=IsVisible\r
    OpenState : Bool = -367000 #%(T_46_META_WS_P_ISVISIBLE)\r
	@ApiLevel=4\r
	@Default=false\r
    ShowTag : Bool = -367001 #%(T_46_META_WS_P_SHOWTAG)\r
	@ApiLevel=4\r
    TargetIcons : MapT_Entity_IconType = -367002 #%(T_46_META_WS_P_TARGETICONS)\r
	@ApiLevel=4\r
    TargetIconColors : MapT_Entity_Color = -367003 #%(T_46_META_WS_P_TARGETICONCOLORS)\r
	@ApiLevel=4\r
    StaticIcons : MapT_Int_IconType = -367004 #%(T_46_META_WS_P_STATICICONS)\r
	@ApiLevel=4\r
    StaticIconColors : MapT_Int_Color = -367005 #%(T_46_META_WS_P_STATICICONCOLORS)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=AlwaysShowMark\r
    IconIsAlwaysShown : Bool = -367006 #%(T_46_META_WS_P_ALWAYSSHOWMARK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundInfoBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type RoundInfoHud : InternalHud = 370 { #%(T_46_META_WS_C_UIROUNDINFOBANNER)\r
	@ApiLevel=4\r
    Title : String = -370000 #%(T_46_META_WS_P_TITLE)\r
	@ApiLevel=4\r
    SubTitle : String = -370001 #%(T_46_META_WS_P_SUBTITLE)\r
	@ApiLevel=4\r
    BackgroundColor1 : Color = -370002 #%(T_46_META_WS_P_BACKGROUNDCOLOR1)\r
	@ApiLevel=4\r
    BackgroundColor2 : Color = -370003 #%(T_46_META_WS_P_BACKGROUNDCOLOR2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIRoundResultBanner\r
@ModuleID=31\r
@ModuleLib=Hud\r
type CSRoundResultHud : InternalHud = 371 { #%(T_46_META_WS_C_UIROUNDRESULTBANNER)\r
	@ApiLevel=4\r
    LeftColor : Color = -371000 #%(T_46_META_WS_P_LEFTCOLOR)\r
	@ApiLevel=4\r
    RightColor : Color = -371001 #%(T_46_META_WS_P_RIGHTCOLOR)\r
	@ApiLevel=4\r
    LeftScore : String = -371002 #%(T_46_META_WS_P_LEFTSCORE)\r
	@ApiLevel=4\r
    RightScore : String = -371003 #%(T_46_META_WS_P_RIGHTSCORE)\r
	@ApiLevel=4\r
    LeftScoreAfter : String = -371004 #%(T_46_META_WS_P_LEFTSCOREAFTER)\r
	@ApiLevel=4\r
    RightScoreAfter : String = -371005 #%(T_46_META_WS_P_RIGHTSCOREAFTER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIFollowHeadlthBar\r
@ModuleID=31\r
@ModuleLib=Hud\r
type PlayerHeadHud : InternalHud = 374 { #%(T_46_META_WS_C_UIFOLLOWHEADLTHBAR)\r
	@ApiLevel=4\r
	@Default=-362274305\r
    MainColor : Color = -374000 #%(T_46_META_WS_P_MAINCOLOR)\r
	@ApiLevel=4\r
	@Default=-4756993\r
    LoseHpColor : Color = -374001 #%(T_46_META_WS_P_LOSEHPCOLOR)\r
	@ApiLevel=4\r
	@Default=-1526765057\r
    GainHpColor : Color = -374002 #%(T_46_META_WS_P_GAINHPCOLOR)\r
	@ApiLevel=4\r
	@Default=255\r
	@ScriptName=BackgroundColor\r
    BackGrColor : Color = -374003 #%(T_46_META_WS_P_BACKGROUNDCOLOR)\r
	@ApiLevel=4\r
	@Default=1\r
    Alpha : Float = -374004 #%(T_46_META_WS_P_ALPHA)\r
	@ApiLevel=4\r
	@Default=math.Vector3_1()\r
    Scale : Vector3 = -374005 #%(T_46_META_WS_P_SCALE)\r
	@ApiLevel=4\r
    PlayerName : String = -374006 #%(T_46_META_WS_P_PLAYERNAME)\r
	@ApiLevel=4\r
	@Default=1\r
    Level : Int = -374007 #%(T_46_META_WS_P_LEVEL)\r
	@ApiLevel=4\r
	@Default=164\r
    Width : Int = -374008 #%(T_46_META_WS_P_WIDTH)\r
	@ApiLevel=4\r
    FollowTarget : Entity = -374009 #%(T_46_META_WS_P_FOLLOWTARGET)\r
	@ApiLevel=4\r
    Offset : Vector3 = -374010 #%(T_46_META_WS_P_OFFSET)\r
	@ApiLevel=4\r
	@Default=0\r
    LineSpacing : Int = -374011 #%(T_46_META_WS_P_LINESPACING)\r
	@ApiLevel=4\r
	@Default=100\r
    TotalHp : Int = -374012 #%(T_46_META_WS_P_TOTALHP)\r
	@ApiLevel=4\r
	@Default=100\r
    CurrentHp : Int = -374013 #%(T_46_META_WS_P_CURRENTHP)\r
	@ApiLevel=4\r
	@Default=false\r
    IsOpenTween : Bool = -374014 #%(T_46_META_WS_P_ISOPENTWEEN)\r
	@ApiLevel=4\r
	@Default=false\r
    IsLocalPos : Bool = -374015 #%(T_46_META_WS_P_ISLOCALPOS)\r
	@ApiLevel=4\r
	@ScriptName=VisiblePlayers\r
    VisiblePlayers : ListT_Player = -374016 #%(T_46_META_WS_P_VISIBLEPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrVehicle\r
@ModuleID=10010\r
@ModuleLib=Player\r
alias PlayerOrVehicle : Entity&(Player|Vehicle) = 377 #%(T_46_META_WS_C_PLAYERORVEHICLE)\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrNPC\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PlayerOrNPC : Entity&(Player|NPC) = 429 #%(T_47_XXJ_WS_PLAYERORNPC)\r
\r
@ApiLevel=4\r
@ScriptName=ListT_ItemGoodsIDType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_ItemGoodsIDType : List = 384 { #%(T_46_META_WS_C_LISTT_ITEMGOODSIDTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SafeZone\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
type EradicateZone : LevelObject&ResetableEntity = 392 { #%(T_46_META_WS_C_SAFEZONE)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=StartTime\r
    StartTime : Int = -392000 #%(T_46_META_WS_P_STARTTIME)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=ShrinkDuration\r
    ShrinkTime : Int = -392001 #%(T_46_META_WS_P_SHRINKDURATION)\r
	@ApiLevel=10\r
	@Default=5\r
	@ScriptName=DamageInterval\r
    DamageTimeSpan : Float = -392002 #%(T_46_META_WS_P_DAMAGEINTERVAL)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=DamageValue\r
    DamageValue : Int = -392003 #%(T_46_META_WS_P_DAMAGEVALUE)\r
	@ApiLevel=4\r
	@ScriptName=Players\r
    Players : ListT_Player = -392004 #%(T_46_META_WS_P_PLAYERS)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=EndTime\r
    CloseTime : Int = -392005 #%(T_46_META_WS_P_ENDTIME)\r
	@ApiLevel=4\r
	@ScriptName=GroupID\r
    get GroupID : Int = -392006 #%(T_46_META_WS_P_GROUPID)\r
	@ApiLevel=4\r
	@ScriptName=StartRadius\r
    StartRadius : Float = -392007 #%(T_46_META_WS_P_STARTRADIUS)\r
	@ApiLevel=4\r
	@ScriptName=IsEnd\r
    get IsEnd : Bool = -392008 #%(T_46_META_WS_P_ISEND)\r
	@ApiLevel=4\r
	@ScriptName=Status\r
    get State : Int = -392009 #%(T_46_META_WS_P_STATUS)\r
	@ApiLevel=4\r
	@ScriptName=ShrinkEndTime\r
    get ShrinkEndTime : Int = -392010 #%(T_46_META_WS_P_SHRINKENDTIME)\r
	@ApiLevel=10\r
	@Default=-1\r
	@ScriptName=EffectColor\r
    EffectColor : Color = -392011 #%(T_46_META_WS_P_EFFECTCOLOR)\r
	@ApiLevel=4\r
	@ScriptName=EndRadius\r
    EndRadius : Float = -392012 #%(T_46_META_WS_P_ENDRADIUS)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=ShrinkStartTime\r
    StartShrinkTime : Int = -392013 #%(T_46_META_WS_P_SHRINKSTARTTIME)\r
	@ApiLevel=4\r
	@Default=5\r
    DamageTimeInterval : Int = -392014 #%(T_46_META_WS_P_DAMAGEINTERVAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Hierarchical\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias Mountable : Entity&(Player|Transform|SkeletonPart) = 390 #%(T_46_META_WS_C_HIERARCHICAL)\r
\r
@ApiLevel=4\r
@ScriptName=NaturalConstantType\r
@ModuleID=10003\r
@ModuleLib=Math\r
enum NaturalConst : Float = 394 { #%(T_46_META_WS_C_NATURALCONSTANTTYPE)\r
	@ApiLevel=4\r
    Pi = 3.14159265 #%(T_46_META_WS_E_PI)\r
	@ApiLevel=4\r
    E = 2.71828183 #%(T_46_META_WS_E_E)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MidGameExitConfig\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type MidGameExitConfig : Entity = 396 { #%(T_46_META_WS_C_MIDGAMEEXITCONFIG)\r
	@ApiLevel=4\r
	@ScriptName=Title\r
    get Title : String = -396000 #%(T_46_META_WS_P_TITLE)\r
	@ApiLevel=4\r
	@ScriptName=Content\r
    get Content : String = -396001 #%(T_46_META_WS_P_CONTENT)\r
	@ApiLevel=4\r
	@ScriptName=Options\r
    get Options : ListT_String = -396002 #%(T_46_META_WS_P_OPTIONS)\r
	@ApiLevel=4\r
	@ScriptName=ShowBackground\r
    get ShowBackground : Bool = -396003 #%(T_46_META_WS_P_SHOWBACKGROUND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColliderCollection\r
@Addable=["CustomLevelObject"]\r
@Conflict=["PhysicalCCT"]\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type ColliderShape : Component = 397 { #%(T_46_META_WS_C_COLLIDERCOLLECTION)\r
	@ApiLevel=3\r
    ColliderID : ColliderID = -186000 #ColliderID\r
}\r
\r
@ApiLevel=4\r
@ScriptName=VaultTrigger\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type VaultTrigger : CustomizeTrigger = 406 { #%(T_46_META_WS_C_VAULTTRIGGER)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=VaultDistance\r
    VaultDistance : Float = -406000 #%(T_46_META_WS_P_VAULTDISTANCE)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=VaultHeight\r
    VaultHeight : Float = -406001 #%(T_46_META_WS_P_VAULTHEIGHT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Persona\r
@Addable=["CustomLevelObject"]\r
@ModuleID=43\r
@ModuleLib=LLM\r
type Persona : Component = 415 { #%(T_46_META_WS_C_PERSONA)\r
	@ApiLevel=4\r
	@ScriptName=PersonaID\r
    PersonaID : PersonaID = -415000 #%(T_46_META_WS_P_PERSONAID)\r
	@ApiLevel=4\r
	@Default=Hi\r
	@ScriptName=NickName\r
    PersonaNickName : String = -415001 #%(T_46_META_WS_P_NICKNAME)\r
	@ApiLevel=4\r
	@ScriptName=Avatar\r
    PersonaAvatar : SpriteID = -415002 #%(T_46_META_WS_P_AVATAR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StringOrLocString\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias StringOrLocString : Object&(String|LocString) = 398 #%(T_46_META_WS_C_STRINGORLOCSTRING)\r
\r
@ApiLevel=4\r
@ScriptName=UISocialButtonType\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
enum SocialButtonType : Int = 403 { #%(T_45_XXJ_WS_UISOCIALBUTTONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=AddFriend\r
    AddFriend = 0 #%(T_46_META_WS_E_ADDFRIEND)\r
	@ApiLevel=4\r
	@ScriptName=Report\r
    Report = 1 #%(T_46_META_WS_E_REPORT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISocialButtonStyleType\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
enum SocialButtonStyleType : Int = 404 { #%(T_45_XXJ_WS_UISOCIALBUTTONSTYLETYPE)\r
	@ApiLevel=4\r
	@ScriptName=Bright\r
    Light = 0 #%(T_46_META_WS_E_BRIGHT)\r
	@ApiLevel=4\r
	@ScriptName=Dark\r
    Dark = 1 #%(T_46_META_WS_E_DARK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UISocialButtonWidget\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
type HUDSocialButtonWidget : HudWidget = 402 { #%(T_46_META_WS_C_UISOCIALBUTTONWIDGET)\r
	@ApiLevel=4\r
	@ScriptName=Target\r
    Player : Player = -402000 #%(T_46_META_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=FunctionType\r
    FunctionType : SocialButtonType = -402001 #%(T_46_META_WS_P_FUNCTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=ButtonStyle\r
    ButtonStyle : SocialButtonStyleType = -402002 #%(T_46_META_WS_P_BUTTONSTYLE)\r
	@ApiLevel=4\r
	@Default=1.0\r
	@ScriptName=Alpha\r
    Alpha : Float = -402003 #%(T_46_META_WS_P_ALPHA)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum PlatformType : Int = 407 { #%(T_46_META_WS_C_PLATFORMTYPE)\r
	@ApiLevel=4\r
	@ScriptName=Local\r
    Local = 0 #%(T_46_META_WS_E_LOCAL)\r
	@ApiLevel=4\r
	@ScriptName=Client\r
    Client = 1 #%(T_46_META_WS_E_CLIENT)\r
	@ApiLevel=4\r
	@ScriptName=Server\r
    Server = 2 #%(T_46_META_WS_E_SERVER)\r
	@ApiLevel=4\r
	@ScriptName=Both\r
    Both = 3 #%(T_46_META_WS_E_BOTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BaseDataAlias\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias BaseData : Object&(Bool|Int|Int64|Float|String|Vector2|Vector3|Quaternion|Color) = 408 #%(T_46_META_WS_C_BASEDATAALIAS)\r
\r
@ApiLevel=4\r
@ScriptName=StatusCode\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum ErrorCode : Int = 409 { #%(T_46_META_WS_A_STATUSCODE)\r
	@ApiLevel=4\r
	@ScriptName=NoError\r
    None = 0 #%(T_46_META_WS_E_NOERROR)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageTimeout\r
    DB_Timeout = 1 #%(T_46_META_WS_E_DATASTORAGETIMEOUT)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageLimitExceeded\r
    DB_Overlimit = 2 #%(T_46_META_WS_E_DATASTORAGELIMITEXCEEDED)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageParameterError\r
    DB_ParamError = 3 #%(T_46_META_WS_E_DATASTORAGEPARAMETERERROR)\r
	@ApiLevel=4\r
	@ScriptName=Failed_InvalidAllIDsOnCreate\r
    Failed_InvalidAllIDsOnCreate = 4 #%(T_47_XXJ_WS_FAILED_INVALIDALLIDSONCREATE)\r
	@ApiLevel=4\r
	@ScriptName=CommonError\r
    Common_Error = 5 #%(T_47_XXJ_WS_COMMON_ERROR)\r
	@ApiLevel=4\r
	@ScriptName=PremiumClosed\r
    Premium_Closed = 6 #%(T_47_XXJ_WS_PREMIUM_CLOSED)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_NotSupported\r
    ChangeTeamFailed_NotSupported = 7 #%(T_48_META_TYP_409_I7)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_AlreadyInTeam\r
    ChangeTeamFailed_AlreadyInTeam = 8 #%(T_48_META_TYP_409_I8)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_InvalidTarget\r
    ChangeTeamFailed_InvalidTarget = 9 #%(T_48_META_TYP_409_I9)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_InvalidTeam\r
    ChangeTeamFailed_InvalidTeam = 10 #%(T_48_META_TYP_409_I10)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_Dead\r
    ChangeTeamFailed_Dead = 11 #%(T_48_META_TYP_409_I11)\r
	@ApiLevel=4\r
	@ScriptName=ChangeTeamFailed_InVehicle\r
    ChangeTeamFailed_InVehicle = 12 #%(T_48_META_TYP_409_I12)\r
	@ApiLevel=4\r
	@ScriptName=LLM_OK\r
    LLM_OK = 101 #%(T_49_META_TYP_409_I13)\r
	@ApiLevel=4\r
	@ScriptName=LLM_FAILED\r
    LLM_FAILED = 102 #%(T_49_META_TYP_409_I14)\r
	@ApiLevel=4\r
	@ScriptName=LLM_TIMEOUT\r
    LLM_TIMEOUT = 103 #%(T_49_META_TYP_409_I15)\r
	@ApiLevel=4\r
	@ScriptName=LLM_INVALID_PERSONA\r
    LLM_INVALID_PERSONA = 104 #%(T_49_META_TYP_409_I16)\r
	@ApiLevel=4\r
	@ScriptName=LLM_TOKEN_LIMIT\r
    LLM_TOKEN_LIMIT = 105 #%(T_49_META_TYP_409_I17)\r
	@ApiLevel=4\r
	@ScriptName=LLM_VIOLATION\r
    LLM_VIOLATION = 106 #%(T_49_META_TYP_409_I18)\r
	@ApiLevel=4\r
	@ScriptName=LLM_FREQUENT_REQUEST\r
    LLM_FREQUENT_REQUEST = 107 #%(T_49_META_TYP_409_I19)\r
	@ApiLevel=4\r
	@ScriptName=IO_CREATE_FILE_FAILED\r
    IO_CREATE_FILE_FAILED = 108 #%(T_50_META_TYP_409_I20)\r
	@ApiLevel=4\r
	@ScriptName=IO_INVALID_FILE_NAME\r
    IO_INVALID_FILE_NAME = 109 #%(T_50_META_TYP_409_I21)\r
	@ApiLevel=4\r
	@ScriptName=PARAM_ERROR\r
    PARAM_ERROR = 110 #%(T_51_META_TYP_409_I22)\r
	@ApiLevel=4\r
	@ScriptName=INGAME_MATCHING_OUTOFRANGE\r
    INGAME_MATCHING_OUTOFRANGE = 1001 #%(T_52_META_TYP_409_I23)\r
	@ApiLevel=4\r
	@ScriptName=INGAME_MATCHING_TIMEOUT\r
    INGAME_MATCHING_TIMEOUT = 1002 #%(T_52_META_TYP_409_I24)\r
	@ApiLevel=4\r
	@ScriptName=INGAME_MATCHING_FAIL\r
    INGAME_MATCHING_FAIL = 1003 #%(T_52_META_TYP_409_I25)\r
	@ApiLevel=4\r
	@ScriptName=INGAME_MATCHING_CANCEL\r
    INGAME_MATCHING_CANCEL = 1004 #%(T_52_META_TYP_409_I26)\r
	@ApiLevel=4\r
	@ScriptName=INGAME_MATCHING_DOWNLOAD_CANCEL\r
    INGAME_MATCHING_DOWBLOAD_CANCEL = 1005 #%(T_55_META_TYP_409_I27)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageValueSizeOverLimit\r
    DataStorageValueSizeOverLimit = 14 #%(T_52_META_TYP_409_I27)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageWorkshopCodeAccessDenied\r
    DataStorageWorkshopCodeAccessDenied = 15 #%(T_52_META_TYP_409_I28)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageValueObsolete\r
    DataStorageValueObsolete = 16 #%(T_52_META_TYP_409_I29)\r
	@ApiLevel=4\r
	@ScriptName=DataStorageInvalidSheetName\r
    DataStorageInvalidSheetName = 17 #%(T_52_META_TYP_409_I30)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceNotFound\r
    MapResourceNotFound = 1012 #%(T_55_META_TYP_409_I32)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceTargetUnavailable\r
    MapResourceTargetUnavailable = 1006 #%(T_55_META_TYP_409_I33)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceAccessDenied\r
    MapResourceAccessDenied = 1007 #%(T_55_META_TYP_409_I34)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceBusy\r
    MapResourceBusy = 1008 #%(T_55_META_TYP_409_I35)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceDownloadFailed\r
    MapResourceDownloadFailed = 1009 #%(T_55_META_TYP_409_I36)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceVerifyFailed\r
    MapResourceVerifyFailed = 1010 #%(T_55_META_TYP_409_I37)\r
	@ApiLevel=4\r
	@ScriptName=MapResourceNetworkRestricted\r
    MapResourceNetworkRestricted = 1011 #%(T_55_META_TYP_409_I38)\r
	@ApiLevel=4\r
	@ScriptName=WardrobeResourceDownloadUnknown\r
    WardrobeResourceDownloadUnknown = 1013 #%(T_55_META_TYP_409_I39)\r
	@ApiLevel=4\r
	@ScriptName=WardrobeResourceReadyForDownload\r
    WardrobeResourceReadyForDownload = 1014 #%(T_55_META_TYP_409_I40)\r
	@ApiLevel=4\r
	@ScriptName=WardrobeResourceDownloading\r
    WardrobeResourceDownloading = 1015 #%(T_55_META_TYP_409_I41)\r
	@ApiLevel=4\r
	@ScriptName=WardrobeResourceDownloadPending\r
    WardrobeResourceDownloadPending = 1016 #%(T_55_META_TYP_409_I42)\r
	@ApiLevel=4\r
	@ScriptName=WardrobeResourceDownloadPaused\r
    WardrobeResourceDownloadPaused = 1017 #%(T_55_META_TYP_409_I43)\r
	@ApiLevel=4\r
	@ScriptName=WardrobeResourceDownloadFinished\r
    WardrobeResourceDownloadFinished = 1018 #%(T_55_META_TYP_409_I44)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrTransform\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PlayerOrTransform : Entity&(Player|Transform) = 410 #%(T_46_META_WS_C_PLAYERORTRANSFORM)\r
\r
@ApiLevel=4\r
@ScriptName=Skyblaster\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Helicopter : Vehicle = 411 { #%(T_46_META_WS_C_SKYBLASTER)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=ForwardSpeed\r
    ForwardSpeed : Float = -411000 #%(T_46_META_WS_P_FORWARDSPEED)\r
	@ApiLevel=4\r
	@Default=600\r
	@ScriptName=BackwardSpeed\r
    BackwardSpeed : Float = -411001 #%(T_46_META_WS_P_BACKWARDSPEED)\r
	@ApiLevel=4\r
	@Default=700\r
	@ScriptName=UpSpeed\r
    UpSpeed : Float = -411002 #%(T_46_META_WS_P_UPSPEED)\r
	@ApiLevel=4\r
	@Default=800\r
	@ScriptName=DownSpeed\r
    DownSpeed : Float = -411003 #%(T_46_META_WS_P_DOWNSPEED)\r
	@ApiLevel=4\r
	@ScriptName=MissileMinDamage\r
    GrenadeMinDamage : Int = -411004 #%(T_46_META_WS_P_MISSILEMINDAMAGE)\r
	@ApiLevel=4\r
	@ScriptName=MissileMaxDamage\r
    GrenadeMaxDamage : Int = -411005 #%(T_46_META_WS_P_MISSILEMAXDAMAGE)\r
	@ApiLevel=4\r
	@Default=true\r
	@ScriptName=MissileRange\r
    GrenadeRange : Float = -411006 #%(T_46_META_WS_P_MISSILERANGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CameraViewingAngleRestrictionType\r
@ModuleID=10007\r
@ModuleLib=Camera\r
enum CameraViewingAngleRestrictionType : Int = 414 { #%(T_46_META_WS_C_CAMERAVIEWINGANGLERESTRICTIONTYPE)\r
	@ApiLevel=4\r
	@ScriptName=\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
	@ScriptName=\r
    WideRange = 1 #%(T_46_META_WS_E_WIDERANGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ComplexNPC\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
alias ComplexNPC : NPC&Collider&ColliderShape&LevelObject&CustomLevelObject&AvatarAble&AnimationControllerAble = 427 #%(T_47_XXJ_WS_CLNPC)\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
enum PremiumState : Int = 418 { #%(T_46_XXJ_WS_PREMIUMSTATUS)\r
	@ApiLevel=4\r
    Expire = 0 #%(T_46_XXJ_WS_EXPIRE)\r
	@ApiLevel=4\r
    Become = 1 #%(T_46_XXJ_WS_BECOME)\r
	@ApiLevel=4\r
    Renewal = 2 #%(T_46_XXJ_WS_RENEWAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Random\r
@ModuleID=10003\r
@ModuleLib=Math\r
type Random : Object = 430 { #%(T_47_XXJ_WS_RANDOM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomCurvePathWayPoint\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomCurvePathWayPoint : CustomLevelObject = 432 { #%(T_48_META_TYP_432)\r
	@ApiLevel=4\r
	@ScriptName=Roll\r
    get Roll : Float = -432000 #%(T_48_META_TYP_432_I0)\r
	@ApiLevel=4\r
	@ScriptName=Tangent\r
    get Tangent : Vector3 = -432001 #%(T_48_META_TYP_432_I1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum CustomCurvePathType : Int = 433 { #%(T_48_META_TYP_433)\r
	@ApiLevel=4\r
    Linear = 0 #%(T_48_META_TYP_433_I0)\r
	@ApiLevel=4\r
    Smooth = 1 #%(T_48_META_TYP_433_I1)\r
	@ApiLevel=4\r
    Custom = 2 #%(T_48_META_TYP_433_I2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_UUID\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_UUID : List = 435 { #%(T_48_META_API_1098_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_ErrorCode\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_ErrorCode : List = 436 { #%(T_48_META_API_1098_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Group\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Group : CustomLevelObject = 439 { #%(T_48_META_TYP_439)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomCurvePath\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CustomCurvePath : Group = 434 { #%(T_48_META_TYP_434)\r
	@ApiLevel=4\r
	@ScriptName=PathType\r
    get PathType : CustomCurvePathType = -434000 #%(T_46_META_WS_P_TYPE)\r
	@ApiLevel=4\r
	@ScriptName=Length\r
    get Length : Float = -434001 #%(T_46_META_WS_LENGTH)\r
	@ApiLevel=4\r
	@ScriptName=ClosedLoop\r
    get ClosedLoop : Bool = -434002 #%(T_48_META_TYP_434_I2)\r
	@ApiLevel=3\r
	@ScriptName=WayPoints\r
    get WayPoints : ListT_ListT_Float = -434003 #%(T_48_META_TYP_434_I3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Performance\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TimeLine : Playable = 440 { #%(T_49_XXJ_WS_PERFORMANCE)\r
	@ApiLevel=4\r
	@Default=0\r
    get ElapsedTime : Int = -440000 #%(T_49_META_TYP_335_I9)\r
	@ApiLevel=4\r
    get Resource : TimeLineID = -440001 #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type TimeLineID : AssetID = 441 { #%(T_49_META_TYP_441)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AlongPathMotion\r
@ModuleID=29\r
@ModuleLib=Playable\r
type AlongPathMotion : Playable = 431 { #%(T_48_META_TYP_431)\r
	@ApiLevel=4\r
	@ScriptName=TargetEntity\r
    get TargetEntity : Entity = -431000 #%(T_43_YU_WS_TARGET)\r
	@ApiLevel=4\r
	@ScriptName=Path\r
    Path : CustomCurvePath = -431001 #%(T_48_META_TYP_431_I1)\r
	@ApiLevel=4\r
	@ScriptName=TweenStyle\r
    Style : TweenStyle = -431002 #%(T_46_META_WS_P_TWEENSTYLE)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
    Speed : Float = -431003 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
	@ScriptName=TangentFacing\r
    TangentFacing : Bool = -431004 #%(T_48_META_API_93_P4)\r
	@ApiLevel=4\r
	@ApiTarget=1\r
    get ElapsedPercentage : Float = -431005 #%(T_47_XXJ_WS_ELAPSEDPERCENTAGE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum LanguageType : Int = 444 { #%(T_48_META_TYP_444)\r
	@ApiLevel=4\r
    English = 1 #%(T_48_META_TYP_444_I0)\r
	@ApiLevel=4\r
    Chinese_Simplified = 2 #%(T_48_META_TYP_444_I1)\r
	@ApiLevel=4\r
    Chinese_Traditional = 3 #%(T_48_META_TYP_444_I2)\r
	@ApiLevel=4\r
    Thai = 4 #%(T_48_META_TYP_444_I3)\r
	@ApiLevel=4\r
    Vietnamese = 5 #%(T_48_META_TYP_444_I4)\r
	@ApiLevel=4\r
    Indonesian = 6 #%(T_48_META_TYP_444_I5)\r
	@ApiLevel=4\r
    Portuguese = 7 #%(T_48_META_TYP_444_I6)\r
	@ApiLevel=4\r
    Spanish = 8 #%(T_48_META_TYP_444_I7)\r
	@ApiLevel=4\r
    Russian = 9 #%(T_48_META_TYP_444_I8)\r
	@ApiLevel=4\r
    Korean = 10 #%(T_48_META_TYP_444_I9)\r
	@ApiLevel=4\r
    French = 11 #%(T_48_META_TYP_444_I10)\r
	@ApiLevel=4\r
    German = 12 #%(T_48_META_TYP_444_I11)\r
	@ApiLevel=4\r
    Turkish = 13 #%(T_48_META_TYP_444_I12)\r
	@ApiLevel=4\r
    Hindi = 14 #%(T_48_META_TYP_444_I13)\r
	@ApiLevel=4\r
    Japanese = 15 #%(T_48_META_TYP_444_I14)\r
	@ApiLevel=4\r
    Romanian = 16 #%(T_48_META_TYP_444_I15)\r
	@ApiLevel=4\r
    Arabic = 17 #%(T_48_META_TYP_444_I16)\r
	@ApiLevel=4\r
    Burmese = 18 #%(T_48_META_TYP_444_I17)\r
	@ApiLevel=4\r
    Urdu = 19 #%(T_48_META_TYP_444_I18)\r
	@ApiLevel=4\r
    Bengali = 20 #%(T_48_META_TYP_444_I19)\r
	@ApiLevel=4\r
    Malay = 21 #%(T_50_YS_SETTING_LANG_MALAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayableControllerAttachable\r
@Addable=["LevelObject"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type PlayableControllerAttachable : Entity = 446 { #%(T_49_META_TYP_446)\r
	@ApiLevel=4\r
	@ScriptName=PlayableController\r
    PlayableController : PlayableControllerResID = -446000 #%(T_49_META_TYP_446_I0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CustomCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
type BasicCamera : Transform = 449 { #%(T_49_META_TYP_449)\r
	@ApiLevel=4\r
	@ScriptName=CameraProjectionMode\r
    CameraProjectionMode : CameraProjectionMode = -449000 #%(T_46_META_WS_P_CAMERAPROJECTIONMODE)\r
	@ApiLevel=4\r
	@Default=60\r
	@ScriptName=FOV\r
    Fov : Float = -449001 #%(T_46_META_WS_P_FOV)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=OrthographicSize\r
    OrthographicSize : Float = -449002 #%(T_49_META_TYP_449_I2)\r
	@ApiLevel=3\r
	@Default=65535\r
	@ScriptName=CullingMask\r
    CullingMask : Int = -449003 #%(T_40_XXJ_WS_CULLINGMASK_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RenderQualityType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum ERenderQuality : Int = 453 { #%(T_50_META_TYP_453)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias MaterialProperty : Object&(Int|Float|Vector2|Vector3|Color|TextureID) = 454 #%(T_51_META_TYP_454)\r
\r
@ApiLevel=4\r
@ScriptName=EntityFlag\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum EntityFlag : Int = 455 { #%(T_51_META_TYP_455)\r
	@ApiLevel=4\r
    Default = 0 #%(T_46_META_WS_E_DEFAULT)\r
	@ApiLevel=4\r
    Static = 1 #%(T_51_META_TYP_455_I1)\r
	@ApiLevel=4\r
    Locally = 2 #%(T_51_META_TYP_455_I2)\r
	@ApiLevel=4\r
    RenderOnly = 4 #%(T_51_META_TYP_455_I3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=33\r
@ModuleLib=Physics\r
alias ComplexRigidbody : Collider&ColliderShape&CustomLevelObject = 456 #%(T_51_META_TYP_COMPLEXRIGIDBODY)\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type LineRenderEntity : Entity = 457 { #%(T_52_META_TYP_457)\r
	@ApiLevel=4\r
	@ScriptName=Points\r
	@ApiTarget=1\r
    Points : ListT_Vector3 = -457000 #%(T_52_META_TYP_457_I0)\r
	@ApiLevel=4\r
	@ScriptName=Material\r
	@ApiTarget=1\r
    CustomMaterial : MaterialID = -457001 #%(T_52_META_TYP_457_I1)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Width\r
	@ApiTarget=1\r
    Width : Float = -457002 #%(T_46_META_WS_P_WIDTH)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ProjectileTrajectory : Entity = 458 { #%(T_52_META_TYP_458)\r
	@ApiLevel=4\r
	@ScriptName=StartPoint\r
	@ApiTarget=1\r
    StartPoint : Vector3 = -458000 #%(T_52_META_TYP_458_I0)\r
	@ApiLevel=4\r
	@ScriptName=InitialSpeed\r
	@ApiTarget=1\r
    InitialVelocity : Vector3 = -458001 #%(T_46_META_WS_P_INITIALSPEED)\r
	@ApiLevel=4\r
	@Default=-9.8\r
	@ScriptName=Gravity\r
	@ApiTarget=1\r
    CustomGravity : Float = -458002 #%(T_46_META_WS_P_GRAVITY)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=DragCoefficient\r
	@ApiTarget=1\r
    DragCoefficient : Float = -458003 #%(T_52_META_TYP_458_I3)\r
	@ApiLevel=4\r
	@ScriptName=Acceleration\r
	@ApiTarget=1\r
    Acceleration : Vector3 = -458004 #%(T_46_META_WS_A_ACCELERATION)\r
	@ApiLevel=4\r
	@Default=1000\r
	@ScriptName=DurationTimeMS\r
	@ApiTarget=1\r
    DurationTimeMS : Int = -458005 #%(T_52_META_TYP_458_I4)\r
	@ApiLevel=4\r
	@ScriptName=LayerMask\r
    LayerMask : ListT_Int = -458006 #%(T_46_META_WS_A_LAYERMASK)\r
	@ApiLevel=4\r
	@ScriptName=Material\r
	@ApiTarget=1\r
    CustomMaterial : MaterialID = -458007 #%(T_52_META_TYP_458_I6)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Width\r
	@ApiTarget=1\r
    Width : Float = -458008 #%(T_46_META_WS_P_WIDTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TrainingBot\r
@ModuleID=10018\r
@ModuleLib=Offline\r
type TrainingPlayer : FightingEntity = 459 { #%(T_52_META_TYP_459)\r
	@ApiLevel=4\r
    HP : Int = -459000 #%(T_46_META_WS_P_HP)\r
	@ApiLevel=4\r
    HPMax : Int = -459001 #%(T_46_META_WS_P_MAXHP)\r
	@ApiLevel=4\r
    HelmetLevel : Int = -459002 #%(T_52_META_TYP_459_I2)\r
	@ApiLevel=4\r
    VestLevel : Int = -459003 #%(T_52_META_TYP_459_I3)\r
	@ApiLevel=4\r
    get MoveMode : TrainingTargetType = -459004 #%(T_52_META_API_162_P2)\r
	@ApiLevel=4\r
	@ScriptName=IsOnlyHeadshot\r
    OnlyHeadshot : Bool = -459005 #%(T_52_META_TYP_459_I5)\r
	@ApiLevel=4\r
    get Position : Vector3 = -459006 #%(T_46_META_WS_A_POSITION)\r
	@ApiLevel=4\r
	@ScriptName=Speed\r
    MoveSpeed : Float = -459007 #%(T_46_META_WS_P_SPEED)\r
	@ApiLevel=4\r
    get InitDirection : Vector3 = -459008 #%(T_52_META_API_162_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TrianingBotMoveModeType\r
@ModuleID=10018\r
@ModuleLib=Offline\r
enum TrainingTargetType : Int = 460 { #%(T_52_META_TYP_460)\r
    Stand = 0 #%(T_43_YU_WS_EPHYSXPOSE_STANDING)\r
    Walk = 1 #%(T_47_XXJ_WS_WALK)\r
    Run = 2 #%(T_47_XXJ_WS_RUN)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum DebugCommandType : Int = 464 { #%(T_52_META_TYP_464)\r
	@ApiLevel=4\r
	@ScriptName=Invulnerable\r
    Invulnerable = 1 #%(T_52_META_TYP_464_I0)\r
	@ApiLevel=4\r
	@ScriptName=RestoreHP\r
    RestoreHP = 2 #%(T_52_META_TYP_464_I1)\r
	@ApiLevel=4\r
	@ScriptName=Suicide\r
    Suicide = 3 #%(T_52_META_TYP_464_I2)\r
	@ApiLevel=4\r
	@ScriptName=TeleportToSpawnPoint\r
    TeleportToSpawnPoint = 4 #%(T_52_META_TYP_464_I3)\r
	@ApiLevel=4\r
	@ScriptName=AddBot\r
    AddBot = 5 #%(T_52_META_TYP_464_I4)\r
	@ApiLevel=4\r
	@ScriptName=ChangeViewport\r
    ChangeViewport = 6 #%(T_52_META_TYP_464_I5)\r
	@ApiLevel=4\r
	@ScriptName=EndCurrentPhase\r
    EndCurrentPhase = 7 #%(T_52_META_TYP_464_I6)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Spectator\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type Observer : Entity = 462 { #%(T_52_META_TYP_462)\r
	@ApiLevel=4\r
	@ScriptName=CustomCamera\r
    CustomCamera : BasicCamera = -462000 #%(T_49_META_TYP_449)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayerOrSpectator\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias PlayerOrObserver : Entity&(Player|Observer) = 463 #%(T_52_META_TYP_463)\r
\r
@ApiLevel=4\r
@ScriptName=CombineMesh\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type CombineMesh : CustomLevelObject&BatchCombineRender = 465 { #%(T_52_META_TYP_465)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
alias AnimationControllerAbleOrPlayer : Entity&(AnimationControllerAble|Player) = 470 #%(T_53_META_TYP_470)\r
\r
@ApiLevel=4\r
@ScriptName=Horse\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
type Horse : Car = 471 { #%(T_53_META_TYP_471)\r
	@ApiLevel=4\r
	@Default=0\r
    Model : Int = -471000 #%(T_53_META_TYP_471_I0)\r
	@ApiLevel=4\r
	@Default=1\r
    WalkMaxSpeedScale : Float = -471001 #%(T_53_META_TYP_471_I1)\r
	@ApiLevel=4\r
	@Default=1\r
    InWaterMaxSpeedScale : Float = -471002 #%(T_53_META_TYP_471_I2)\r
	@ApiLevel=4\r
	@Default=1\r
    get HorseJumpHeight : Float = -471003 #%(T_53_META_TYP_471_I3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ListT_BaseData : List = 472 { #%(T_53_META_GT_WS_LISTBASEDATA)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum UseEndReason : Int = 473 { #%(T_53_META_TYP_473)\r
	@ApiLevel=4\r
    Completed = 0 #%(T_53_META_TYP_473_I0)\r
	@ApiLevel=4\r
    Canceled = 1 #%(T_53_META_TYP_473_I1)\r
	@ApiLevel=4\r
    Interrupted = 2 #%(T_53_META_TYP_473_I2)\r
	@ApiLevel=4\r
    OutOfResource = 3 #%(T_53_META_TYP_473_I3)\r
	@ApiLevel=4\r
    InvalidState = 4 #%(T_53_META_TYP_473_I4)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum UnEquipReason : Int = 474 { #%(T_53_META_TYP_474)\r
	@ApiLevel=4\r
    Dropped = 0 #%(T_53_META_TYP_474_I0)\r
	@ApiLevel=4\r
    Consumed = 1 #%(T_53_META_TYP_474_I1)\r
	@ApiLevel=4\r
    Destroyed = 2 #%(T_53_META_TYP_474_I2)\r
	@ApiLevel=4\r
    Death = 3 #%(T_53_META_TYP_474_I3)\r
}\r
\r
@ApiLevel=3\r
@Addable=["LevelObject","CustomLevelObject","DummyLevelObject","CustomHud","SoundEntity"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type ProfilerEntity : Component = 475 { #ProfilerEntity\r
	@ApiLevel=3\r
	@ScriptName=SourceID\r
    SourceID : String = -475000 #SourceID\r
	@ApiLevel=3\r
	@ScriptName=CodeID\r
    CodeID : String = -475001 #CodeID\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
enum ResidualItemsType : Int = 477 { #%(T_54_META_TYP_477)\r
	@ApiLevel=4\r
    All = 0 #%(T_54_META_TYP_477_I0)\r
	@ApiLevel=4\r
    Landmine = 1 #%(T_54_META_TYP_477_I1)\r
	@ApiLevel=4\r
    MiniSentry = 2 #%(T_54_META_TYP_477_I2)\r
	@ApiLevel=4\r
    IceWall = 3 #%(T_54_META_TYP_477_I3)\r
	@ApiLevel=4\r
    TrowingKnife = 4 #%(T_54_META_TYP_477_I4)\r
	@ApiLevel=4\r
    Deadbox = 5 #%(T_54_META_TYP_477_I5)\r
	@ApiLevel=4\r
    Loot = 6 #%(T_54_META_TYP_477_I6)\r
	@ApiLevel=4\r
    Portal = 7 #%(T_54_META_TYP_477_I7)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PetSkillID\r
@ModuleID=10010\r
@ModuleLib=Player\r
type PetSkillID : AssetConfigID = 478 { #%(T_54_META_EVT_3135_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FilterType\r
@ModuleID=10012\r
@ModuleLib=Scene\r
enum FilterType : Int = 479 { #%(T_54_XYL_PHOTOFILTER_TYPE)\r
	@ApiLevel=4\r
    NormalFilter = 0 #%(T_54_XYL_PHOTOFILTER_TYPE_NONE)\r
	@ApiLevel=4\r
    Comic = 1 #%(T_54_XYL_PHOTOFILTER_TYPE_COMIC)\r
	@ApiLevel=4\r
    Drawing = 2 #%(T_54_XYL_PHOTOFILTER_TYPE_DRAWING)\r
	@ApiLevel=4\r
    Pixel = 3 #%(T_54_XYL_PHOTOFILTER_TYPE_PIXEL)\r
	@ApiLevel=4\r
    RGBSplit = 4 #%(T_54_XYL_PHOTOFILTER_TYPE_RGBSPLIT)\r
	@ApiLevel=4\r
    GoldenAge = 5 #%(T_54_XYL_PHOTOFILTER_TYPE_GOLDENAGE)\r
	@ApiLevel=4\r
    Cyberpunk = 6 #%(T_54_XYL_PHOTOFILTER_TYPE_CYBERPUNK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BaseFilter\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type BaseFilter : Entity = 480 { #%(T_54_XYL_PHOTOFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Type\r
    Type : FilterType = -480000 #%(T_46_META_WS_A_TYPE)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Brightness\r
    Brightness : Float = -480001 #%(T_55_META_TYP_480_I1)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Saturation\r
    Saturation : Float = -480002 #%(T_55_META_TYP_480_I2)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Contrast\r
    Contrast : Float = -480003 #%(T_55_META_TYP_480_I3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ComicFilterStyle\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type ComicFilterStyle : BaseFilter = 481 { #%(T_55_ZJH_COMICFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=0.332\r
	@ScriptName=Threshold\r
    Threshold : Float = -481000 #%(T_55_META_TYP_481_I0)\r
	@ApiLevel=4\r
	@Default=0.015\r
	@ScriptName=Range\r
    Range : Float = -481001 #%(T_46_META_WS_A_RANGE)\r
	@ApiLevel=4\r
	@Default=10\r
	@ScriptName=FlashSpeed\r
    FlashSpeed : Float = -481002 #%(T_55_META_TYP_481_I2)\r
	@ApiLevel=4\r
	@Default=2\r
	@ScriptName=LineIntensity\r
    LineIntensity : Float = -481003 #%(T_55_META_TYP_481_I3)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=LineSize\r
    LineSize : Float = -481004 #%(T_55_META_TYP_481_I4)\r
	@ApiLevel=4\r
	@Default=0.0006\r
	@ScriptName=PencilSize\r
    PencilSize : Float = -481005 #%(T_55_META_TYP_482_I0)\r
	@ApiLevel=4\r
	@Default=0.3\r
	@ScriptName=PencilCorrection\r
    PencilCorrection : Float = -481006 #%(T_55_META_TYP_482_I1)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PencilColor\r
    PencilColor : Color = -481007 #%(T_55_META_TYP_482_I2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DrawingFilterStyle\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type DrawingFilterStyle : BaseFilter = 482 { #%(T_55_ZJH_DRAWINGFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=0.0006\r
	@ScriptName=PencilSize\r
    PencilSize : Float = -482000 #%(T_55_META_TYP_482_I0)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=PencilCorrection\r
    PencilCorrection : Float = -482001 #%(T_55_META_TYP_482_I1)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PencilColor\r
    PencilColor : Color = -482002 #%(T_55_META_TYP_482_I2)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=PaperColor\r
    PaperColor : Color = -482003 #%(T_55_META_TYP_482_I3)\r
	@ApiLevel=4\r
	@Default=0.5\r
	@ScriptName=CornerLose\r
    CornerLose : Float = -482004 #%(T_55_META_TYP_482_I4)\r
	@ApiLevel=4\r
	@ScriptName=PaperTexture\r
    PaperTex : TextureID = -482005 #%(T_55_META_TYP_482_I5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PixelFilterStyle\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type PixelFilterStyle : BaseFilter = 483 { #%(T_55_ZJH_PIXELFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=200\r
	@ScriptName=Pixelisation\r
    Pixelisation : Float = -483000 #%(T_55_META_TYP_483_I0)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=ColorOffset\r
    ColorOffset : Color = -483001 #%(T_55_META_TYP_483_I1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RGBSplitFilterStyle\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type RGBSplitFilterStyle : BaseFilter = 484 { #%(T_55_ZJH_RGBSPLITFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=0.005\r
	@ScriptName=SplitOffset\r
    SplitOffset : Float = -484000 #%(T_55_META_TYP_484_I0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GoldenAgeFilterStyle\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type GoldenAgeFilterStyle : BaseFilter = 485 { #%(T_55_ZJH_GOLDENAGEFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=Intensity\r
    Intensity : Float = -485000 #%(T_55_META_TYP_485_I0)\r
	@ApiLevel=4\r
	@Default=0\r
	@ScriptName=Warmth\r
    Warmth : Float = -485001 #%(T_55_META_TYP_485_I1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CyberpunkFilterStyle\r
@ModuleID=10012\r
@ModuleLib=Scene\r
type CyberpunkFilterStyle : BaseFilter = 486 { #%(T_55_ZJH_CYBERPUNKFILTER_ENTITY_NAME)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=EdgeIntensity\r
    EdgeIntensity : Float = -486000 #%(T_55_META_TYP_486_I0)\r
	@ApiLevel=4\r
	@Default=0.0013\r
	@ScriptName=EdgeSize\r
    EdgeSize : Float = -486001 #%(T_55_META_TYP_486_I1)\r
	@ApiLevel=4\r
	@Default=0.15\r
	@ScriptName=EdgeSensitivity\r
    EdgeSensitivity : Float = -486002 #%(T_55_META_TYP_486_I2)\r
	@ApiLevel=4\r
	@Default=3\r
	@ScriptName=GlitchInterval\r
    GlitchInterval : Float = -486003 #%(T_55_META_TYP_486_I3)\r
	@ApiLevel=4\r
	@Default=0.1\r
	@ScriptName=GlitchDuration\r
    GlitchDuration : Float = -486004 #%(T_55_META_TYP_486_I4)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=EdgeColor1\r
    EdgeColor1 : Color = -486005 #%(T_55_META_TYP_486_I5)\r
	@ApiLevel=4\r
	@Default=-1\r
	@ScriptName=EdgeColor2\r
    EdgeColor2 : Color = -486006 #%(T_55_META_TYP_486_I6)\r
	@ApiLevel=4\r
	@ScriptName=EdgeNoiseTex\r
    EdgeNoiseTex : TextureID = -486007 #%(T_55_META_TYP_486_I7)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MapResourceDownloadStatus\r
@ModuleID=49\r
@ModuleLib=MapResource\r
enum MapResourceDownloadState : Int = 487 { #%(FE_55_Q_WS_ENUM_MAPRESOURCE_DOWNLOAD_STATE)\r
	@ApiLevel=4\r
    NotDownloaded = 0 #%(FE_55_Q_WS_ENUM_MAPRESOURCE_NOT_DOWNLOADED)\r
	@ApiLevel=4\r
    Downloading = 1 #%(FE_55_Q_WS_ENUM_MAPRESOURCE_DOWNLOADING)\r
	@ApiLevel=4\r
    Success = 2 #%(FE_55_Q_WS_ENUM_MAPRESOURCE_SUCCESS)\r
	@ApiLevel=4\r
    Failed = 3 #%(FE_55_Q_WS_ENUM_MAPRESOURCE_FAILED)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum DistanceSourceType : Int = 488 { #%(T_55_META_TYP_488)\r
	@ApiLevel=4\r
	@ScriptName=PlayerCamera\r
    PlayerCamera = 0 #%(T_55_META_TYP_488_I0)\r
	@ApiLevel=4\r
	@ScriptName=PlayerCharacter\r
    PlayerCharacter = 1 #%(T_55_META_TYP_488_I1)\r
	@ApiLevel=4\r
	@ScriptName=CustomEntity\r
    CustomEntity = 2 #%(T_55_META_TYP_488_I2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
enum DistanceSpaceType : Int = 489 { #%(T_55_META_TYP_489)\r
	@ApiLevel=4\r
	@ScriptName=World3D\r
    World3D = 0 #%(T_55_META_TYP_489_I0)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalXZ\r
    HorizontalXZ = 1 #%(T_55_META_TYP_489_I1)\r
	@ApiLevel=4\r
	@ScriptName=ScreenSpace\r
    ScreenSpace = 2 #%(T_55_META_TYP_489_I2)\r
}\r
\r
@ApiLevel=4\r
@Addable=["TextEntity","IconEntity","CustomHud"]\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
type DistanceVisibility : Entity = 490 { #%(T_55_META_TYP_490)\r
	@ApiLevel=4\r
    DistanceSource : DistanceSourceType = -490000 #%(T_55_META_TYP_490_I0)\r
	@ApiLevel=4\r
    CustomSourceEntity : Entity = -490001 #%(T_55_META_TYP_490_I1)\r
	@ApiLevel=4\r
    DistanceSpace : DistanceSpaceType = -490002 #%(T_55_META_TYP_490_I2)\r
	@ApiLevel=4\r
    FadeStartDistance : Float = -490003 #%(T_55_META_TYP_490_I3)\r
	@ApiLevel=4\r
    FadeEndDistance : Float = -490004 #%(T_55_META_TYP_490_I4)\r
	@ApiLevel=4\r
    FadeCurve : BezierCurve = -490005 #%(T_55_META_TYP_490_I5)\r
	@ApiLevel=4\r
    HideThreshold : Float = -490006 #%(T_55_META_TYP_490_I6)\r
	@ApiLevel=4\r
    ScaleCurve : BezierCurve = -490007 #%(T_55_META_TYP_490_I7)\r
	@ApiLevel=4\r
    ScreenSizeClamp : Bool = -490008 #%(T_55_META_TYP_490_I8)\r
	@ApiLevel=4\r
    MinScreenSize : Vector2 = -490009 #%(T_55_META_TYP_490_I9)\r
	@ApiLevel=4\r
    MaxScreenSize : Vector2 = -490010 #%(T_55_META_TYP_490_I10)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_AnimationClipID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type ListT_AnimationClipID : List = 492 { #%(T_55_META_TYP_492)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_OutfitID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type ListT_ClothID : List = 493 { #%(T_55_META_TYP_493)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_VehicleSkinID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type ListT_VehicleSkinID : List = 494 { #%(T_55_META_TYP_494)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_WeaponSkinID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type ListT_WeaponSkinID : List = 495 { #%(T_55_META_TYP_495)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ListT_BackpackSkinID\r
@ModuleID=10017\r
@ModuleLib=Collection\r
type ListT_BagSkinID : List = 496 { #%(T_55_META_TYP_496)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UIEasyList\r
@ModuleID=16\r
@ModuleLib=Hud\r
type HudEasyList : HudScrollView = 498 { #%(T_55_META_TYP_498)\r
	@ApiLevel=4\r
	@ScriptName=FillDirection\r
    FillDirection : Int = -498000 #%(T_46_META_WS_P_FILLDIRECTION)\r
	@ApiLevel=4\r
	@ScriptName=CellSize\r
    CellSize : Vector2 = -498001 #%(T_46_META_WS_P_CELLSIZE)\r
	@ApiLevel=4\r
	@ScriptName=CellSpace\r
    Space : Vector2 = -498002 #%(T_46_META_WS_P_CELLSPACE)\r
	@ApiLevel=4\r
	@ScriptName=Constraint\r
    Constraint : Int = -498003 #%(T_46_META_WS_P_CONSTRAINT)\r
	@ApiLevel=4\r
	@ScriptName=ConstraintCount\r
    ConstraintCount : Int = -498004 #%(T_46_META_WS_P_CONSTRAINTCOUNT)\r
	@ApiLevel=4\r
	@ScriptName=VerticalOffset\r
    OffsetUpDown : Vector2 = -498005 #%(T_46_META_WS_P_VERTICALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=HorizontalOffset\r
    OffsetLeftRight : Vector2 = -498006 #%(T_46_META_WS_P_HORIZONTALOFFSET)\r
	@ApiLevel=4\r
	@ScriptName=CellPrefab\r
    CellPrefab : PrefabID = -498007 #%(T_55_META_TYP_498_I7)\r
	@ApiLevel=4\r
	@Default=1\r
	@ScriptName=ExtraCacheLineCount\r
    ExtraCacheLineCount : Int = -498008 #%(T_55_META_TYP_498_I8)\r
	@ApiLevel=4\r
	@Default=false\r
	@ScriptName=AllowMultipleSelections\r
    AllowMultipleSelections : Bool = -498009 #%(T_55_META_TYP_498_I9)\r
	@ApiLevel=4\r
	@ScriptName=DataList\r
    DataList : ListT_Object = -498010 #%(T_55_META_TYP_498_I10)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
enum AdditionalWardrobeOutfitSortType : Int = 499 { #%(T_55_META_TYP_499)\r
	@ApiLevel=4\r
	@ScriptName=Prepend\r
    Clothe = 0 #%(T_55_META_TYP_499_I0)\r
	@ApiLevel=4\r
	@ScriptName=Append\r
    Back = 1 #%(T_55_META_TYP_499_I1)\r
	@ApiLevel=4\r
    Default = 2 #%(T_46_META_WS_E_DEFAULT)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
type UIWidgetEasyCell : HudWidget = 500 { #%(T_55_META_TYP_500)\r
	@ApiLevel=4\r
    TriggerButton : HudButtonWidget = -500000 #%(T_55_META_TYP_500_I0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnGameStart\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnMatchStart = 1 { #%(T_46_META_WS_ONGAMESTART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnGameEnd\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnMatchEnd = 3 { #%(T_46_META_WS_ONGAMEEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnRoundStart\r
@ModuleID=2\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnRoundStart = 4 { #%(T_46_META_WS_ONROUNDSTART)\r
	@ScriptName=RoundIndex\r
    RoundIndex : Int #%(T_46_META_WS_ROUNDINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquipArmor\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnWear = 3019 { #%(T_46_META_WS_ONEQUIPARMOR)\r
	@ScriptName=EquipmentID\r
    EquipType : Int #%(T_46_META_WS_EQUIPMENTID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquipWeapon\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnWield = 3020 { #%(T_46_META_WS_ONEQUIPWEAPON)\r
	@ScriptName=Weapon\r
    WeaponEntity : Weapon #%(T_46_META_WS_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAccessEquipment\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnPlayerEquip = 3113 { #%(T_46_META_WS_ONACCESSEQUIPMENT)\r
	@ScriptName=Item\r
    ItemEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSwitchHandHeld\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnPlayerHandHeld = 3114 { #%(T_46_META_WS_ONSWITCHHANDHELD)\r
	@ScriptName=Item\r
    ItemEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnRoundEnd\r
@ModuleID=2\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnRoundEnd = 5 { #%(T_46_META_WS_ONROUNDEND)\r
	@ScriptName=RoundIndex\r
    RoundIndex : Int #%(T_46_META_WS_ROUNDINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPhaseStart\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnPhaseStart = 7 { #%(T_46_META_WS_ONPHASESTART)\r
	@ScriptName=Phase\r
    Phase : Phase #%(T_46_META_WS_PHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPhaseEnd\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@Owner = Global\r
event OnPhaseEnd = 8 { #%(T_46_META_WS_ONPHASEEND)\r
	@ScriptName=Phase\r
    Phase : Phase #%(T_46_META_WS_PHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerQuit\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnUserQuit = 11 { #%(T_46_META_WS_ONPLAYERQUIT)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnPlayerScoreChange\r
@ApiTarget=2\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnPlayerRoundScoreChange = 1000 { #%(T_46_META_WS_ONPLAYERSCORECHANGE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ScoreType\r
    ScoreType : ScoreType #%(T_46_META_WS_SCORETYPE)\r
	@ScriptName=Score\r
    Score : Int #%(T_46_META_WS_SCORE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnScoreChange\r
@ApiTarget=2\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@Owner = ScoreableEntity\r
event OnRoundScoreChange = 3023 { #%(T_46_META_WS_ONSCORECHANGE)\r
	@ScriptName=ScoreType\r
    ScoreType : ScoreType #%(T_46_META_WS_SCORETYPE)\r
	@ScriptName=Score\r
    Score : Int #%(T_46_META_WS_SCORE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnTeamScoreChange\r
@ApiTarget=2\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnTeamRoundScoreChange = 1001 { #%(T_46_META_WS_ONTEAMSCORECHANGE)\r
	@ScriptName=Team\r
    Team : Team #%(T_46_META_WS_TEAM)\r
	@ScriptName=ScoreType\r
    ScoreType : ScoreType #%(T_46_META_WS_SCORETYPE)\r
	@ScriptName=Score\r
    Score : Int #%(T_46_META_WS_SCORE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnPlayerRankChange\r
@ApiTarget=2\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnPlayerRoundRankChange = 1002 { #%(T_46_META_WS_ONPLAYERRANKCHANGE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Rank\r
    Rank : Int #%(T_46_META_WS_RANK)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnRankChanged\r
@ApiTarget=2\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@Owner = RankableEntity\r
event OnRoundRankChange = 3024 { #%(T_46_META_WS_ONRANKCHANGED)\r
	@ScriptName=Rank\r
    Rank : Int #%(T_46_META_WS_RANK)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnTeamRoundRankChange\r
@ApiTarget=2\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@Owner = Global\r
event OnTeamRoundRankChange = 1003 { #%(T_46_META_WS_ONTEAMROUNDRANKCHANGE)\r
	@ScriptName=Team\r
    Team : Team #%(T_46_META_WS_TEAM)\r
	@ScriptName=Rank\r
    Rank : Int #%(T_46_META_WS_RANK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerBeEliminated\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerDead = 2002 { #%(T_46_META_WS_ONPLAYERBEELIMINATED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerAssist\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerAssist = 2003 { #%(T_46_META_WS_ONPLAYERASSIST)\r
	@ScriptName=AssistPlayer\r
    AssistPlayer : Player #%(T_46_META_WS_ASSISTPLAYER)\r
	@ScriptName=EliminatedPlayer\r
    BeKilledPlayer : Player #%(T_46_META_WS_ELIMINATEDPLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAssist\r
@ApiTarget=2\r
@ModuleID=27\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnAssist = 3025 { #%(T_46_META_WS_ONASSIST)\r
	@ScriptName=EliminatedEntity\r
    BeKilledPlayer : FightingEntity #%(T_46_META_WS_ELIMINATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerDealDamage\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerDamage = 2004 { #%(T_46_META_WS_ONPLAYERDEALDAMAGE)\r
	@ScriptName=Attacker\r
    Player : Player #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=Target\r
    BeDamagedPlayer : Player #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamageType\r
    DamageType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Value\r
    Value : Int #%(T_46_META_WS_VALUE)\r
	@ScriptName=DamagedBodyPart\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=OnEntityEnterTrigger_Deprecated\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnEnterTrigger = 3037 { #%(T_35_WZY_WS_ENTERTRIGGER_NAME)\r
	@ScriptName=Trigger\r
    TargetEntity : Entity #%(T_46_META_WS_TRIGGER)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=OnEntityLeaveTrigger_Deprecated\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnLeaveTrigger = 3038 { #%(T_35_WZY_WS_QUITTRIGGER_NAME)\r
	@ScriptName=Trigger\r
    TargetEntity : Entity #%(T_46_META_WS_TRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEliminate\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerKill = 2005 { #%(T_46_META_WS_ONPLAYERELIMINATE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=eliminatedPlayer\r
    BeKilledPlayer : Player #%(T_46_META_WS_ELIMINATEDPLAYER)\r
	@ScriptName=DamageType\r
    DamageType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerJoin\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnPlayerAdd = 2006 { #%(T_46_META_WS_ONPLAYERJOIN)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerRevived\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnPlayerRevive = 2007 { #%(T_46_META_WS_ONPLAYERREVIVED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=RevivalSource\r
    PlayerReviveSourceType : PlayerReviveSourceType #%(T_46_META_WS_REVIVALSOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerBeKnockedDown\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnPlayerKnockedDown = 2008 { #%(T_46_META_WS_ONPLAYERBEKNOCKEDDOWN)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Attacker\r
    Damager : Player #%(T_46_META_WS_ATTACKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeamRemove\r
@ApiTarget=2\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@Owner = Global\r
event OnRemoveTeam = 2100 { #%(T_46_META_WS_ONTEAMREMOVE)\r
	@ScriptName=Team\r
    Team : Team #%(T_46_META_WS_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeamAdd\r
@ApiTarget=2\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@Owner = Global\r
event OnAddTeam = 2101 { #%(T_46_META_WS_ONTEAMADD)\r
	@ScriptName=Team\r
    Team : Team #%(T_46_META_WS_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeamAce\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Global\r
event OnTeamACE = 2102 { #%(T_46_META_WS_ONTEAMACE)\r
	@ScriptName=Team\r
    Team : Team #%(T_46_META_WS_TEAM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnACE\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Team\r
event OnACE = 3018 { #%(T_46_META_WS_ONACE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAwake\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnAwake = 3000 { #%(T_46_META_WS_ONAWAKE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDestroy\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnDestroy = 3001 { #%(T_46_META_WS_ONDESTROY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEnable\r
@ApiTarget=0\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnEnable = 3007 { #%(T_46_META_WS_ONENABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDisable\r
@ApiTarget=0\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnDisable = 3008 { #%(T_46_META_WS_ONDISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEliminated\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnDamaged = 3011 { #%(T_46_META_WS_ONELIMINATED)\r
	@ScriptName=Attacker\r
    AttackerEntity : Entity #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=DamageType\r
    AttackedType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=DamagedBodyPart\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTakeDamage\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnAttacked = 3012 { #%(T_46_META_WS_ONTAKEDAMAGE)\r
	@ScriptName=Attacker\r
    AttackerEntity : Entity #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=DamageType\r
    AttackedType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
    Value : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPreTakeDamage\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnBeforeAttacked = 10 { #%(T_46_META_WS_ONPRETAKEDAMAGE)\r
	@ScriptName=Attacker\r
    AttackerEntity : Entity #%(T_46_META_WS_ATTACKER)\r
	@ScriptName=DamageType\r
    AttackedType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
    Value : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPreDealDamage\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnBeforeHurt = 13 { #%(T_46_META_WS_ONPREDEALDAMAGE)\r
	@ScriptName=Target\r
    AttackTarget : FightingEntity #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamageType\r
    DamageType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
    DamageValue : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
    DamagePart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDealDamage\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnHurt = 3013 { #%(T_46_META_WS_ONDEALDAMAGE)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamageType\r
    HurtType : DamageType #%(T_46_META_WS_DAMAGETYPE)\r
	@ScriptName=Damage\r
    Value : Int #%(T_46_META_WS_DAMAGE)\r
	@ScriptName=DamagedBodyPart\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEliminate\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = FightingEntity\r
event OnKill = 3014 { #%(T_46_META_WS_ONELIMINATE)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
	@ScriptName=DamagedBodyPart\r
    HitBodyPart : HitBodyPart #%(T_46_META_WS_DAMAGEDBODYPART)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = CustomizeTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = KillOrGodZoneTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = CheckPointTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerEnter\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = EndPointTrigger\r
event OnPlayerEnter = 3002 { #%(T_46_META_WS_ONPLAYERENTER)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerLeave\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = CustomizeTrigger\r
event OnPlayerLeave = 3003 { #%(T_46_META_WS_ONPLAYERLEAVE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerLeave\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = KillOrGodZoneTrigger\r
event OnPlayerLeave = 3003 { #%(T_46_META_WS_ONPLAYERLEAVE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = LeaderboardButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = TwoTeamLeaderboardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = MoreTeamLeaderboardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = SingleLeaderboardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ActionHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = UGCShopHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ChooseCardHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = SkillButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ProgressCircleHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = HintButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ProgressSkillButtonHud\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = TwoTeamLeaderboardHudV2\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBuiltInButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = MoreTeamLeaderboardHudV2\r
event OnInternalHUDClick = 3005 { #%(T_46_META_WS_ONBUILTINBUTTONTAPPED)\r
	@ScriptName=ButtonName\r
    ButtonName : String #%(T_46_META_WS_BUTTONNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerPurchaseProduct\r
@ApiTarget=2\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@Owner = Player\r
event OnPlayerPurchaseProduct = 34 { #%(T_53_META_EVT_34)\r
	@ScriptName=ProductCode\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
	@ScriptName=PurchaseStatus\r
    PurchaseStatus : PurchaseStatus #%(T_53_META_EVT_34_P1)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=OnBuiltInCloseButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = TwoTeamLeaderboardHudV2\r
event OnInternalHUDClose = 15 { #OnInternalHUDClose\r
}\r
\r
@ApiLevel=3\r
@ScriptName=OnBuiltInCloseButtonTapped\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = MoreTeamLeaderboardHudV2\r
event OnInternalHUDClose = 15 { #OnInternalHUDClose\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerEnter\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = CustomizeTrigger\r
event OnTriggerEnter = 3009 { #%(T_46_META_WS_ONENTITYENTER)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerEnter\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnTriggerEnter = 3009 { #%(T_46_META_WS_ONENTITYENTER)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerLeave\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = CustomizeTrigger\r
event OnTriggerLeave = 3010 { #%(T_46_META_WS_ONENTITYEXIT)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTriggerLeave\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnTriggerLeave = 3010 { #%(T_46_META_WS_ONENTITYEXIT)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCollisionEnter\r
@ApiTarget=0\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnCollisionEnter = 6 { #%(T_46_META_WS_ONCOLLISIONENTER)\r
	@ScriptName=CollidedEntity\r
    OtherEntity : Entity #%(T_46_META_WS_COLLIDEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCollisionExit\r
@ApiTarget=0\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Collider\r
event OnCollisionExit = 9 { #%(T_46_META_WS_ONCOLLISIONEXIT)\r
	@ScriptName=CollidedEntity\r
    OtherEntity : Entity #%(T_46_META_WS_COLLIDEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCharacterControllerHit\r
@ApiTarget=0\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = PhysicalCCT\r
event OnControllerColliderHit = 12 { #%(T_46_META_WS_ONCHARACTERCONTROLLERHIT)\r
	@ScriptName=CollidedEntity\r
    OtherEntity : Entity #%(T_46_META_WS_COLLIDEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTapped\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnClick = 3004 { #%(T_46_META_WS_ONTAPPED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnBeKnockedDown_Deprecated\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Player\r
event OnKnockedDown = 3017 { #%(T_46_META_WS_ONBEKNOCKEDDOWN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnKnockedDown\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Player\r
event OnKnockedDownV2 = 3129 { #%(T_46_META_WS_ONBEKNOCKEDDOWN)\r
	@ScriptName=Attacker\r
    Attaker : FightingEntity #%(T_46_META_WS_ATTACKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUseConsumable\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnUseItem = 3021 { #%(T_46_META_WS_ONUSECONSUMABLE)\r
	@ScriptName=ConsumableID\r
    ItemType : ItemGoodsIDType #%(T_46_META_WS_CONSUMABLEID)\r
	@ScriptName=Item\r
    TargetEntity : Entity #%(T_46_META_WS_ITEM)\r
	@ScriptName=SpawnedItem\r
    NewEntity : Entity #%(T_46_META_WS_SPAWNEDITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAccessItem\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnObtainItem = 3022 { #%(T_46_META_WS_ONACCESSITEM)\r
	@ScriptName=ItemID\r
    ItemType : ItemGoodsIDType #%(T_46_META_WS_ITEMID)\r
	@ScriptName=Item\r
    TargetEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnEnteringVehicle_Deprecated\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnEnteringVehicle = 3026 { #%(T_36_WZY_WS_PLAGETONVEH_NAME)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    Vehicle : Vehicle #%(T_36_WZY_WS_VEHENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEnterVehicle\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnEnteringVehicle_V2 = 3065 { #%(T_46_META_WS_ONENTERVEHICLE)\r
	@ScriptName=Vehicle\r
    Vehicle : Vehicle #%(T_46_META_WS_VEHICLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnLeavingVehicle_Deprecated\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnLeavingVehicle = 3027 { #%(T_36_WZY_WS_PLAGETOFFVEH_NAME)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    Vehicle : Vehicle #%(T_36_WZY_WS_VEHENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLeaveVehicle\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnLeavingVehicle_V2 = 3066 { #%(T_46_META_WS_ONLEAVEVEHICLE)\r
	@ScriptName=Vehicle\r
    Vehicle : Vehicle #%(T_46_META_WS_VEHICLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnDrivingVehicle_Deprecated\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnDrivingVehicle = 3028 { #%(T_36_WZY_WS_PLADRIVEH_NAME)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    Vehicle : Vehicle #%(T_36_WZY_WS_VEHENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDriveVehicle\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnDrivingVehicle_V2 = 3067 { #%(T_46_META_WS_ONDRIVEVEHICLE)\r
	@ScriptName=Vehicle\r
    Vehicle : Vehicle #%(T_46_META_WS_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEntered\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnBeEnterVehicle = 3029 { #%(T_46_META_WS_ONENTERED)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLeft\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnBeLeaveVehicle = 3030 { #%(T_46_META_WS_ONLEFT)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDriven\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnBeDriveVehicle = 3031 { #%(T_46_META_WS_ONDRIVED)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnTeleporting_Deprecated\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnTeleporting = 3032 { #%(T_36_WZY_WS_PLATP_NAME)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    TeleportDoor : TeleportDoor #%(T_36_WZY_WS_PORTALENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsePortal\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnTeleporting_V2 = 3068 { #%(T_46_META_WS_ONUSEPORTAL)\r
	@ScriptName=Portal\r
    TeleportDoor : TeleportDoor #%(T_46_META_WS_PORTAL)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnSpringing_Deprecated\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnSpringing = 3033 { #%(T_36_WZY_WS_PLAKNOFLY_NAME)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    BounceTire : BounceTire #%(T_36_WZY_WS_OBJENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBouncedByTire\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnSpringing_V2 = 3069 { #%(T_46_META_WS_ONBOUNCEDBYTIRE)\r
	@ScriptName=Tire\r
    BounceTire : BounceTire #%(T_46_META_WS_TIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTeleportEntity\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = TeleportDoor\r
event OnBeTeleport = 3034 { #%(T_46_META_WS_ONTELEPORTENTITY)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBounceEntity\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = BounceTire\r
event OnBeSpring = 3035 { #%(T_46_META_WS_ONBOUNCEENTITY)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHitFlyEntity\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = MoveObject\r
event OnHitFlying = 3036 { #%(T_46_META_WS_ONHITFLYENTITY)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
	@ScriptName=Mechanism\r
    MoveObject : MoveObject #%(T_46_META_WS_MECHANISM)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnBeHitFly_Deprecated\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnBeHitFly = 3040 { #%(T_36_WZY_WS_PLACOLLIDE_NAME)\r
    TargetEntity : Entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    MoveObject : MoveObject #%(T_36_WZY_WS_OBJENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHitFly\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Player\r
event OnBeHitFly_V2 = 3070 { #%(T_46_META_WS_ONHITFLY)\r
	@ScriptName=Mechanism\r
    MoveObject : MoveObject #%(T_46_META_WS_MECHANISM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnRevived\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnRevived = 3015 { #%(T_46_META_WS_ONREVIVED)\r
	@ScriptName=RevivalSource\r
    PlayerReviveSourceType : PlayerReviveSourceType #%(T_46_META_WS_REVIVALSOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSpawn\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = SpawnableEntity\r
event OnSpawn = 3016 { #%(T_46_META_WS_ONSPAWN)\r
	@ScriptName=Spawnables\r
    Entities : ListT_InstanceEntity #%(T_46_META_WS_SPAWNABLES)\r
	@ScriptName=Waves\r
    BatchCount : Int #%(T_46_META_WS_WAVES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAccessWeapon\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnObtainWeapon = 3039 { #%(T_46_META_WS_ONACCESSWEAPON)\r
	@ScriptName=Weapon\r
    WeaponEntity : Weapon #%(T_46_META_WS_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSceneLoad\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@Owner = Global\r
event OnSceneLoaded = 30 { #%(T_46_META_WS_ONSCENELOAD)\r
	@ScriptName=SceneName\r
    SceneName : String #%(T_46_META_WS_SCENENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerSwitchScene\r
@ApiTarget=0\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@Owner = Player\r
event OnSwitchPlayerArea = 32 { #%(T_46_META_WS_ONPLAYERSWITCHSCENE)\r
	@ScriptName=SceneName\r
    SceneName : String #%(T_46_META_WS_SCENENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSceneSwitch\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@Owner = Global\r
event OnSceneSwitchSuccessed = 31 { #%(T_46_META_WS_ONSCENESWITCH)\r
	@ScriptName=SceneName\r
    SceneName : String #%(T_46_META_WS_SCENENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLevelObjectBeMorphed\r
@ApiTarget=2\r
@ModuleID=22\r
@ModuleLib=Morph\r
@Owner = LevelObject\r
event OnLevelObjectToBeMorphed = 3045 { #%(T_46_META_WS_ONLEVELOBJECTBEMORPHED)\r
	@ScriptName=MorphObject\r
    MorphObject : MorphObject #%(T_46_META_WS_MORPHOBJECT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnClipEnd\r
@ModuleID=35\r
@ModuleLib=Animation\r
@Owner = AnimationController\r
event OnAnimationClipEnd = 3200 { #%(T_46_META_WS_ONCLIPEND)\r
	@ScriptName=ClipName\r
    ClipName : String #%(T_46_META_WS_CLIPNAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnStateEnd\r
@ModuleID=35\r
@ModuleLib=Animation\r
@Owner = AnimationController\r
event OnAnimationStateEnd = 3201 { #%(T_46_META_WS_ONSTATEEND)\r
	@ScriptName=StateName\r
    StateName : String #%(T_46_META_WS_STATENAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerRevivedInSpawnPos\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = SpawnPos\r
event OnPlayerReviveInSpawnPos = 3046 { #%(T_46_META_WS_ONPLAYERREVIVEDINSPAWNPOS)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDropWeapon\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnDropWeapon = 3047 { #%(T_46_META_WS_ONDROPWEAPON)\r
	@ScriptName=Weapon\r
    WeaponEntity : Weapon #%(T_46_META_WS_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDropConsumable\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnDropItem = 3048 { #%(T_46_META_WS_ONDROPCONSUMABLE)\r
	@ScriptName=ConsumableID\r
    ItemType : ItemGoodsIDType #%(T_46_META_WS_CONSUMABLEID)\r
	@ScriptName=Item\r
    ItemEntity : Entity #%(T_46_META_WS_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnShotByFootballShooter\r
@ApiTarget=2\r
@ModuleID=10006\r
@ModuleLib=Football\r
@Owner = Football\r
event OnShootByGun = 3049 { #%(T_46_META_WS_ONSHOTBYFOOTBALLSHOOTER)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Velocity\r
    Velocity : Vector3 #%(T_46_META_WS_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFootBallCollided\r
@ModuleID=10006\r
@ModuleLib=Football\r
@Owner = Football\r
event OnHitEntity = 3050 { #%(T_46_META_WS_ONFOOTBALLCOLLIDED)\r
	@ScriptName=Target\r
    TargetEntity : LevelObject #%(T_46_META_WS_TARGET)\r
	@ScriptName=Velocity\r
    Velocity : Vector3 #%(T_46_META_WS_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAiming\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnPlayerAimEntity = 3041 { #%(T_46_META_WS_ONAIMING)\r
	@ScriptName=Target\r
    TargetEntity : AimableEntity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAimed\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = AimableEntity\r
event OnEntityAimedByPlayer = 3042 { #%(T_46_META_WS_ONAIMED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnBulletHit\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnWeaponHitEntity = 3043 { #%(T_46_META_WS_ONBULLETHIT)\r
	@ScriptName=Target\r
    TargetEntity : AimableEntity #%(T_46_META_WS_TARGET)\r
	@ScriptName=HitPosition\r
    HitPosition : Vector3 #%(T_46_META_WS_HITPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponBeEquiped\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnWeaponBeEquiped = 3061 { #%(T_46_META_WS_ONWEAPONBEEQUIPED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponEliminate\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Weapon\r
event OnWeaponKillEntity = 3062 { #%(T_46_META_WS_ONWEAPONELIMINATE)\r
	@ScriptName=Target\r
    FightingEntity : FightingEntity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponDealDamage\r
@ApiTarget=2\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@Owner = Weapon\r
event OnWeaponTakeDamage = 3063 { #%(T_46_META_WS_ONWEAPONDEALDAMAGE)\r
	@ScriptName=Target\r
    FightingEntity : FightingEntity #%(T_46_META_WS_TARGET)\r
	@ScriptName=Damage\r
    Damage : Int #%(T_46_META_WS_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReload\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnWeaponReload = 3064 { #%(T_46_META_WS_ONRELOAD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHitByBullet\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = AimableEntity\r
event OnEntityHittedByWeapon = 3044 { #%(T_46_META_WS_ONHITBYBULLET)\r
	@ScriptName=Weapon\r
    Weapon : Weapon #%(T_46_META_WS_WEAPON)\r
	@ScriptName=HitPosition\r
    HitPosition : Vector3 #%(T_46_META_WS_HITPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUpdate\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnUpdate = 2 { #%(T_46_META_WS_ONUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoinChatChannelSuccessfully\r
@ApiTarget=2\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@Owner = Player\r
event OnJoinChatChannelSuccess = 3051 { #%(T_46_META_WS_ONJOINCHATCHANNELSUCCESSFULLY)\r
	@ScriptName=ChatChannel\r
    ChatChannel : ChatChannel #%(T_46_META_WS_CHATCHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerJoinChatChannelFailure\r
@ApiTarget=2\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@Owner = Player\r
event OnJoinChatChannelFailure = 3052 { #%(T_46_META_WS_ONPLAYERJOINCHATCHANNELFAILURE)\r
	@ScriptName=ChatChannel\r
    ChatChannel : ChatChannel #%(T_46_META_WS_CHATCHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLeaveChatChannel\r
@ApiTarget=2\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@Owner = Player\r
event OnLeaveChatChannel = 3053 { #%(T_46_META_WS_ONLEAVECHATCHANNEL)\r
	@ScriptName=ChatChannel\r
    ChatChannel : ChatChannel #%(T_46_META_WS_CHATCHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnGoal\r
@ApiTarget=2\r
@ModuleID=10006\r
@ModuleLib=Football\r
@Owner = Football\r
event OnGoal = 3054 { #%(T_46_META_WS_ONGOAL)\r
	@ScriptName=FootballGoal\r
    FootballGoal : FootballGoal #%(T_46_META_WS_FOOTBALLGOAL)\r
	@ScriptName=Scorer\r
    LastPlayer : Player #%(T_46_META_WS_SCORER)\r
	@ScriptName=AssistPlayer\r
    PrevPlayer : Player #%(T_46_META_WS_ASSISTPLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDisconnect\r
@ApiTarget=2\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnPlayerDisconnect = 2009 { #%(T_46_META_WS_ONDISCONNECT)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReconnect\r
@ApiTarget=2\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnPlayerReconnect = 2010 { #%(T_46_META_WS_ONRECONNECT)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnStartFire\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerFire = 3055 { #%(T_46_META_WS_ONSTARTFIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJump\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerJump = 3056 { #%(T_46_META_WS_ONJUMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJumpStop\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerJumpStop = 3122 { #%(T_46_META_WS_ONJUMPSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFall\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerFall = 3123 { #%(T_46_META_WS_ONFALL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFallStop\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerFallStop = 3124 { #%(T_46_META_WS_ONFALLSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCrouch\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerCrouch = 3057 { #%(T_46_META_WS_ONCROUCH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCreep\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerCreep = 3058 { #%(T_46_META_WS_ONCREEP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSprint\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerSprint = 3059 { #%(T_46_META_WS_ONSPRINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPurchase\r
@ApiTarget=2\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnShopPurchase = 3060 { #%(T_46_META_WS_ONPURCHASE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ShopItem\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPrePurchase\r
@ApiTarget=2\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnBeforeShopPurchase = 3090 { #%(T_46_META_WS_ONPREPURCHASE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ShopItem\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerPurchaseRequest\r
@ApiTarget=2\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnShopRequestPurchase = 3115 { #%(T_46_META_WS_ONPLAYERPURCHASEREQUEST)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=ShopItem\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerRequestForPurchaseFulfilled\r
@ApiTarget=2\r
@ModuleID=19\r
@ModuleLib=Economy\r
@Owner = Shop\r
event OnShopRequestFilled = 3116 { #%(T_46_META_WS_ONPLAYERREQUESTFORPURCHASEFULFILLED)\r
	@ScriptName=HelpPlayer\r
    HelpPlayer : Player #%(T_46_META_WS_HELPPLAYER)\r
	@ScriptName=HelpedPlayer\r
    HelpedPlayer : Player #%(T_46_META_WS_HELPEDPLAYER)\r
	@ScriptName=ShopItem\r
    ShopItem : ShopItem #%(T_46_META_WS_SHOPITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPressed\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnPress = 3071 { #%(T_46_META_WS_ONPRESSED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnReleased\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnRelease = 3072 { #%(T_46_META_WS_ONRELEASED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDoubleTapped\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudButtonWidget\r
event OnDoubleClick = 3073 { #%(T_46_META_WS_ONDOUBLETAPPED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTextChange\r
@ApiTarget=2\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudInputWidget\r
event OnSyncInputText = 3077 { #%(T_46_META_WS_ONTEXTCHANGE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Text\r
    Text : String #%(T_46_META_WS_TEXT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnToggle\r
@ApiTarget=0\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudToggle\r
event OnToggleChange = 3204 { #%(T_46_META_WS_ONTOGGLE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Status\r
    State : Bool #%(T_46_META_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTouchDown\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnTouchDown = 3260 { #%(T_46_META_WS_ONTOUCHDOWN)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Position\r
    TouchDownPosition : Vector2 #%(T_46_META_WS_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnTouchUp\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnTouchUp = 3261 { #%(T_46_META_WS_ONTOUCHUP)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Position\r
    TouchUpPosition : Vector2 #%(T_46_META_WS_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDragStart\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnDragStart = 3262 { #%(T_46_META_WS_ONDRAGSTART)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=StartPosition\r
    DragStartPosition : Vector2 #%(T_46_META_WS_STARTPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDrag\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnDrag = 3263 { #%(T_46_META_WS_ONDRAG)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=StartPosition\r
    DragStartPosition : Vector2 #%(T_46_META_WS_STARTPOSITION)\r
	@ScriptName=Delta\r
    Delta : Vector2 #%(T_46_META_WS_DELTA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDragEnd\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudTouchPad\r
event OnDragEnd = 3264 { #%(T_46_META_WS_ONDRAGEND)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=EndPosition\r
    DragEndPosition : Vector2 #%(T_46_META_WS_ENDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoyStickPressed\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudJoystick\r
event OnPressed = 3265 { #%(T_46_META_WS_ONJOYSTICKPRESSED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoyStickReleased\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudJoystick\r
event OnReleased = 3266 { #%(T_46_META_WS_ONJOYSTICKRELEASED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJoyStickMove\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudJoystick\r
event OnMove = 3267 { #%(T_46_META_WS_ONJOYSTICKMOVE)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=Delta\r
    Output : Vector2 #%(T_46_META_WS_DELTA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakAreaBegin\r
@ApiTarget=2\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakAreaBegin = 3074 { #%(T_46_META_WS_ONJAILBREAKAREABEGIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakAreaEnd\r
@ApiTarget=2\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakAreaEnd = 3075 { #%(T_46_META_WS_ONJAILBREAKAREAEND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakPlayerJoin\r
@ApiTarget=2\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakPlayerJoin = 3082 { #%(T_46_META_WS_ONJAILBREAKPLAYERJOIN)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnJailBreakPlayerQuit\r
@ApiTarget=2\r
@ModuleID=10009\r
@ModuleLib=Other\r
@Owner = JailBreakArea\r
event OnJailBreakPlayerQuit = 3083 { #%(T_46_META_WS_ONJAILBREAKPLAYERQUIT)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnStart\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableBegin = 3078 { #%(T_46_META_WS_ONSTART)\r
	@ScriptName=Playable\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEnd\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableEnd = 3079 { #%(T_46_META_WS_ONEND)\r
	@ScriptName=Playable\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnResume\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableResume = 3080 { #%(T_46_META_WS_ONRESUME)\r
	@ScriptName=Playable\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPause\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayablePause = 3081 { #%(T_46_META_WS_ONPAUSE)\r
	@ScriptName=Playable\r
    Playable : Playable #%(T_46_META_WS_C_PLAYABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEachLoop\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Playable\r
event OnPlayableEachLoop = 14 { #%(T_46_META_WS_ONEACHLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEachLoop\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Owner = Loopable\r
event OnPlayableEachLoop = 14 { #%(T_46_META_WS_ONEACHLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCountdownFinished\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = ProgressCircleHud\r
event OnCountdownFinished = 3084 { #%(T_46_META_WS_ONCOUNTDOWNFINISHED)\r
	@ScriptName=Owner\r
    TargetEntity : Entity #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPickedUp\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = InventoryBase\r
event OnPickup = 3085 { #%(T_46_META_WS_ONPICKEDUP)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnDropped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = InventoryBase\r
event OnDrop = 3086 { #%(T_46_META_WS_ONDROPPED)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Helmet\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Bag\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Vest\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = JetPack\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = DoubleJumpShoes\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FoldWing\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnEquiped\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Skateboard\r
event OnEquip = 3087 { #%(T_46_META_WS_ONEQUIPED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLandmineActive\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = LandmineObj\r
event OnLandmineObjStart = 3088 { #%(T_46_META_WS_ONLANDMINEACTIVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLandmineTrigger\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = LandmineObj\r
event OnLandmineObjTrigger = 3089 { #%(T_46_META_WS_ONLANDMINETRIGGER)\r
	@ScriptName=Target\r
    TargetEntity : Entity #%(T_46_META_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = MiniSentry\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Mushroom\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = RepairArmorKit\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = JetPack\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = DoubleJumpShoes\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FoldWing\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsed\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Skateboard\r
event OnUse = 3091 { #%(T_46_META_WS_ONUSED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnHookGunFire\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = GrapplingHookGun\r
event OnFires = 3092 { #%(T_46_META_WS_ONHOOKGUNFIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnThrowableExplode\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Player\r
event OnThrowHit = 3093 { #%(T_46_META_WS_ONTHROWABLEEXPLODE)\r
	@ScriptName=HitPosition\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSprayed\r
@ApiTarget=2\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@Owner = LevelObject\r
event OnSprayedByWeapon = 3094 { #%(T_46_META_WS_ONSPRAYED)\r
	@ScriptName=Weapon\r
    Weapon : Weapon #%(T_46_META_WS_WEAPON)\r
	@ScriptName=HitPosition\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
	@ScriptName=HitNormal\r
    Normal : Vector3 #%(T_46_META_WS_HITNORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSpray\r
@ApiTarget=2\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@Owner = LevelObject\r
event OnSprayEntity = 3095 { #%(T_46_META_WS_ONSPRAY)\r
	@ScriptName=HitObject\r
    HitObject : LevelObject #%(T_46_META_WS_HITOBJECT)\r
	@ScriptName=HitPosition\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
	@ScriptName=HitNormal\r
    Normal : Vector3 #%(T_46_META_WS_HITNORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnExplode\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Oildrum\r
event OnOildrumExplode = 3096 { #%(T_46_META_WS_ONEXPLODE)\r
	@ScriptName=Maker\r
    Player : Player #%(T_46_META_WS_MAKER)\r
	@ScriptName=DamagedPlayers\r
    BeDamagedPlayers : ListT_Player #%(T_46_META_WS_DAMAGEDPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnExplode\r
@ApiTarget=2\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Owner = Vehicle\r
event OnOildrumExplode = 3096 { #%(T_46_META_WS_ONEXPLODE)\r
	@ScriptName=Maker\r
    Player : Player #%(T_46_META_WS_MAKER)\r
	@ScriptName=DamagedPlayers\r
    BeDamagedPlayers : ListT_Player #%(T_46_META_WS_DAMAGEDPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWeaponStopFiring\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnStopFire = 3097 { #%(T_46_META_WS_ONWEAPONSTOPFIRING)\r
	@ScriptName=CurrentAmmoCount\r
    AmmoInClip : Int #%(T_46_META_WS_CURRENTAMMOCOUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnChase\r
@ApiTarget=2\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStartChase = 3098 { #%(T_46_META_WS_ONCHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnChaseStop\r
@ApiTarget=2\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStopChase = 3099 { #%(T_46_META_WS_ONCHASESTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAttack\r
@ApiTarget=2\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStartAttack = 3100 { #%(T_46_META_WS_ONATTACK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnAttackStop\r
@ApiTarget=2\r
@ModuleID=10008\r
@ModuleLib=AI\r
@Owner = AI\r
event OnAIStopAttack = 3101 { #%(T_46_META_WS_ONATTACKSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCameraRaycast\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = Global\r
event OnClientCameraRayCast = 3102 { #%(T_46_META_WS_ONCAMERARAYCAST)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
	@ScriptName=IsHit\r
    IsHit : Bool #%(T_46_META_WS_ISHIT)\r
	@ScriptName=HitPosition\r
    HitPos : Vector3 #%(T_46_META_WS_HITPOSITION)\r
	@ScriptName=CameraDirection\r
    CameraDir : Vector3 #%(T_46_META_WS_CAMERADIRECTION)\r
	@ScriptName=CameraPosition\r
    CameraPos : Vector3 #%(T_46_META_WS_CAMERAPOSITION)\r
	@ScriptName=HitEntity\r
    HitEntity : Entity #%(T_46_META_WS_HITENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnUIShow\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = UGCShopHud\r
event OnShow = 3103 { #%(T_46_META_WS_ONUISHOW)\r
	@ScriptName=Player\r
    TriggerPlayer : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnUIHide\r
@ApiTarget=2\r
@ModuleID=31\r
@ModuleLib=Hud\r
@Owner = UGCShopHud\r
event OnHide = 3104 { #%(T_46_META_WS_ONUIHIDE)\r
	@ScriptName=Player\r
    TriggerPlayer : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnNodeEnter\r
@ApiTarget=2\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@Owner = BehaviourTreeNode\r
event OnNodeEnter = 3105 { #%(T_46_META_WS_ONNODEENTER)\r
	@ScriptName=NodeName\r
    NodeName : String #%(T_46_META_WS_NODENAME)\r
	@ScriptName=Owner\r
    Owner : BehaviourTreeAttachable #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnNodeExit\r
@ApiTarget=2\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@Owner = BehaviourTreeNode\r
event OnNodeExit = 3106 { #%(T_46_META_WS_ONNODEEXIT)\r
	@ScriptName=NodeName\r
    NodeName : String #%(T_46_META_WS_NODENAME)\r
	@ScriptName=Owner\r
    Owner : BehaviourTreeAttachable #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnNodeEnterForClient\r
@ApiTarget=1\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@Owner = BehaviourTreeNode\r
event OnNodeEnterForClient = 3133 { #%(T_46_META_WS_ONNODEENTER)\r
	@ScriptName=NodeName\r
    NodeName : String #%(T_46_META_WS_NODENAME)\r
	@ScriptName=Owner\r
    Owner : BehaviourTreeAttachableForClient #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnNodeExitForClient\r
@ApiTarget=1\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@Owner = BehaviourTreeNode\r
event OnNodeExitForClient = 3134 { #%(T_46_META_WS_ONNODEEXIT)\r
	@ScriptName=NodeName\r
    NodeName : String #%(T_46_META_WS_NODENAME)\r
	@ScriptName=Owner\r
    Owner : BehaviourTreeAttachableForClient #%(T_46_META_WS_OWNER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnWakeUp\r
@ApiTarget=2\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Rigidbody\r
event OnWakeup = 3107 { #%(T_46_META_WS_ONWAKEUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSleep\r
@ApiTarget=2\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Owner = Rigidbody\r
event OnSleep = 3108 { #%(T_46_META_WS_ONSLEEP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnMove\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerMove = 3109 { #%(T_46_META_WS_ONMOVE)\r
	@ScriptName=Pose\r
    PhysxPose : PlayerPhysXPoseType #%(T_46_META_WS_POSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnIdle\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerIdle = 3110 { #%(T_46_META_WS_ONIDLE)\r
	@ScriptName=Pose\r
    PhysxPose : PlayerPhysXPoseType #%(T_46_META_WS_POSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUsePetSkill\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnUsePetSkill = 3135 { #%(T_54_META_EVT_3135)\r
	@ScriptName=PetID\r
    PetID : Int #%(T_54_META_EVT_3135_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUseAvatarSkill\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerUseSkill = 3111 { #%(T_46_META_WS_ONUSEAVATARSKILL)\r
	@ScriptName=Skill\r
    skill : PlayerSkillID #%(T_46_META_WS_SKILL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnStandUP\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerStand = 3268 { #%(T_46_META_WS_ONSTANDUP)\r
	@ScriptName=PrePose\r
    PrePhysxPose : PlayerPhysXPoseType #%(T_46_META_WS_PREPOSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFire\r
@ApiTarget=1\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Weapon\r
event OnFiringEachBullet = 3269 { #%(T_46_META_WS_ONFIRE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSurfing\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerSwimSurfing = 3006 { #%(T_46_META_WS_ONSURFING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSurfingStop\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerStopSwimSurfing = 3076 { #%(T_46_META_WS_ONSURFINGSTOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSprintStop\r
@ApiTarget=0\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerStopDash = 3112 { #%(T_46_META_WS_ONSPRINTSTOP)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=41\r
@ModuleLib=Time\r
@Owner = Entity\r
event OnFixedUpdate = 3117 { #%(T_46_META_WS_ONFIXEDUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=41\r
@ModuleLib=Time\r
@Owner = Global\r
event OnGamePause = 3118 { #%(T_46_META_WS_ONGAMEPAUSE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=41\r
@ModuleLib=Time\r
@Owner = Global\r
event OnGameResume = 3119 { #%(T_46_META_WS_ONGAMERESUME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnFriendsUpdate\r
@ApiTarget=1\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@Owner = Player\r
event OnFriendRelationChange = 3120 { #%(T_46_META_WS_ONFRIENDSUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceivePersonaCreateRoomResult = 19 { #%(T_50_META_EVT_19)\r
    ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
    RoomID : String #%(T_50_META_EVT_19_P1)\r
}\r
\r
@ApiLevel=10\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveContentFromPersona = 3121 { #%(T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA)\r
	@ScriptName=Content\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
	@ScriptName=Sender\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
    ChatID : String #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveContentFromPersonaV2 = 16 { #%(T_47_XXJ_WS_ONRECEIVECONTENTFROMPERSONA)\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
    RequestID : Int64 #%(T_49_META_API_1089_P2)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=OnReceiveActionFromPersona_Deprecated\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveActionFromPersona = 3125 { #%(T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA)\r
	@ScriptName=Action\r
    Action : String #%(T_47_XXJ_WS_ACTION)\r
	@ScriptName=Sender\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
    ChatID : String #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveActionIDFromPersona = 3270 { #%(T_47_XXJ_WS_ONRECEIVEACTIONFROMPERSONA)\r
	@ScriptName=Action\r
    Action : String #%(T_47_XXJ_WS_ACTION)\r
	@ScriptName=Sender\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveFinishFromPersona = 3132 { #%(T_47_XXJ_WS_ONRECEIVEFINISHFROMPERSONA)\r
	@ScriptName=Sender\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=ErrorCode\r
    ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
	@ScriptName=RequestID\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=10\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveStatusFromPersona = 3130 { #%(T_47_XXJ_WS_ONRECEIVESTATUSFROMPERSONA)\r
	@ScriptName=Sender\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=ErrorCode\r
    ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
	@ScriptName=RequestID\r
    ChatID : String #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnPlayerSendMessageByUIPersonaChat\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnHudSendMessageToPersona = 3131 { #%(T_47_XXJ_WS_ONHUDSENDMESSAGETOPERSONA)\r
	@ScriptName=Content\r
    Text : String #%(T_47_XXJ_WS_CONTENT)\r
	@ScriptName=Sender\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ScriptName=RequestID\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=OnReceiveVoiceResponseFromPersona\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnReceiveVoiceFromPersona = 23 { #%(T_51_META_EVT_23)\r
	@ApiLevel=3\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ApiLevel=3\r
    RequestID : Int64 #%(T_49_META_API_1089_P2)\r
	@ApiLevel=3\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
}\r
\r
@ApiLevel=3\r
@ApiTarget=1\r
@ModuleID=43\r
@ModuleLib=LLM\r
@Owner = Global\r
event OnPlayVoiceFinishFromPersona = 24 { #%(T_51_META_EVT_24)\r
	@ApiLevel=3\r
	@ScriptName=\r
    Sender : PersonaID #%(T_47_XXJ_WS_SENDER)\r
	@ApiLevel=3\r
	@ScriptName=\r
    ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
	@ApiLevel=3\r
	@ScriptName=\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=42\r
@ModuleLib=Premium\r
@Owner = Player\r
event OnPremiumChange = 3126 { #%(T_47_XXJ_WS_ONPREMIUMCHANGE)\r
    State : PremiumState #%(T_46_XXJ_WS_PREMIUMSTATUS)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=42\r
@ModuleLib=Premium\r
@Owner = Player\r
event OnPlayerEnterPremiumCenter = 3127 { #%(T_46_XXJ_WS_ONPLAYERENTERPREMIUMCENTER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=42\r
@ModuleLib=Premium\r
@Owner = Player\r
event OnPlayerLeavePremiumCenter = 3128 { #%(T_46_XXJ_WS_ONPLAYERLEAVEPREMIUMCENTER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@Owner = Entity\r
event OnChangeTeam = 3140 { #%(T_48_META_EVT_3140)\r
	@ScriptName=FormerTeam\r
    FormalTeam : Team #%(T_48_META_EVT_3140_P0)\r
	@ScriptName=CurrentTeam\r
    CurrentTeam : Team #%(T_48_META_EVT_3140_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnPlotStart = 3141 { #%(T_48_META_EVT_3141)\r
	@ScriptName=PlotID\r
    PlotID : String #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OnPlotEnd = 3142 { #%(T_48_META_EVT_3142)\r
	@ScriptName=PlotID\r
    PlotID : String #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Player\r
event OntriggerPlotOption = 3143 { #%(T_48_META_EVT_3143)\r
	@ScriptName=PlotID\r
    PlotID : String #%(T_48_META_EVT_3141_P1)\r
	@ScriptName=OptionID\r
    OptionID : Int #%(T_48_META_EVT_3143_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnScreenTouchBegin\r
@ApiTarget=1\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@Owner = Global\r
event OnScreenTouchBegan = 17 { #%(T_50_META_EVT_17)\r
    TouchIndex : Int #%(T_50_META_EVT_17_P0)\r
    Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnScreenTouchEnd\r
@ApiTarget=1\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@Owner = Global\r
event OnScreenTouchEnded = 18 { #%(T_50_META_EVT_18)\r
    TouchIndex : Int #%(T_50_META_EVT_18_P0)\r
    Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnUserQuitOrUserMatchEnd\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Global\r
event OnUserQuitOrUserMacthEnd = 20 { #%(T_50_META_EVT_20)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnCustomPropertyChange = 21 { #%(T_51_META_EVT_21)\r
    PropertyIndex : Property #%(T_51_META_EVT_21_P0)\r
    PropertyValue : Object #%(T_51_META_API_157_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnCustomPlayerStateChanged = 22 { #%(T_51_META_EVT_22)\r
    CustomPlayerState : Int #%(T_51_META_EVT_22_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerSpeakStart = 25 { #%(T_52_META_EVT_25)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerSpeakEnd = 26 { #%(T_52_META_EVT_26)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnLateUpdate = 27 { #%(T_52_META_EVT_27)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnReceiveDebugCommand = 28 { #%(T_52_META_EVT_28)\r
	@ApiLevel=4\r
    CommandType : DebugCommandType #%(T_52_META_EVT_28_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSpectatorJoin\r
@ApiTarget=0\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnObserverJoin = 29 { #%(T_52_ONOBSERVERJOIN)\r
	@ApiLevel=4\r
	@ScriptName=Spectator\r
    Observer : Observer #%(T_52_ONOBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnSpectatorQuit\r
@ApiTarget=0\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnObserverQuit = 33 { #%(T_52_ONOBSERVERQUIT)\r
	@ApiLevel=4\r
	@ScriptName=Spectator\r
    Observer : Observer #%(T_52_ONOBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerBeginTakePhoto = 3271 { #%(T_52_META_EVT_3271)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10010\r
@ModuleLib=Player\r
@Owner = Player\r
event OnPlayerEndTakePhoto = 3272 { #%(T_52_META_EVT_3272)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Global\r
event OnPlayerOutOfSync = 3274 { #%(T_53_META_EVT_3274)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    IsOutOfSync : Bool #%(T_53_META_EVT_3274_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCustomFightingEntityHitted\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FightingEntity\r
event OnCustomFightingEntityHitted = 3275 { #%(T_53_META_EVT_3275)\r
	@ScriptName=Player\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
	@ScriptName=ItemID\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEMID)\r
	@ScriptName=Damage\r
    Damage : Int #%(T_53_META_EVT_3275_P2)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = MiniSentry\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Mushroom\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = RepairArmorKit\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = JetPack\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = DoubleJumpShoes\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FoldWing\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=2\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Skateboard\r
event OnUseEnd = 3276 { #%(T_53_META_EVT_3276)\r
    EndReason : UseEndReason #%(T_53_META_EVT_3276_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Helmet\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Bag\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Vest\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = JetPack\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = DoubleJumpShoes\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = FoldWing\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=0\r
@ModuleID=10014\r
@ModuleLib=Items\r
@Owner = Skateboard\r
event OnUnEquipped = 3277 { #%(T_53_META_EVT_3277)\r
    Reason : UnEquipReason #%(T_53_META_EVT_3277_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=49\r
@ModuleLib=MapResource\r
@Owner = Global\r
event OnMapResourceDownloadStateChanged = 35 { #%(FE_55_Q_WS_EVENT_MAPRESOURCE_DOWNLOAD_STATE_CHANGED)\r
	@ScriptName=MapCode\r
    MapCode : String #%(T_46_META_WS_A_MAPCODE)\r
	@ScriptName=DownloadStatus\r
    State : MapResourceDownloadState #%(T_55_META_API_191_P1)\r
	@ScriptName=ErrorCode\r
    ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnLateVisualTick\r
@ApiTarget=1\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnLateVisualTick = 36 { #%(T_55_META_EVT_36)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudWidget\r
event OnCellBind = 37 { #%(T_55_META_EVT_37)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
    DataContent : Object #%(T_55_META_EVT_37_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnCellTap\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudEasyList\r
event OnCellClick = 38 { #%(T_55_META_EVT_38)\r
    Cell : HudWidget #%(T_55_META_EVT_38_P0)\r
    CellIndex : Int #%(T_55_META_EVT_38_P1)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudEasyList\r
event OnCellSelect = 39 { #%(T_55_META_EVT_39)\r
    Cell : HudWidget #%(T_55_META_EVT_38_P0)\r
    CellIndex : Int #%(T_55_META_EVT_38_P1)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudEasyList\r
event OnCellUnselect = 40 { #%(T_55_META_EVT_40)\r
    Cell : HudWidget #%(T_55_META_EVT_38_P0)\r
    CellIndex : Int #%(T_55_META_EVT_38_P1)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudEasyList\r
event OnCellCancelSelect = 41 { #%(T_55_META_EVT_41)\r
    Cell : HudWidget #%(T_55_META_EVT_38_P0)\r
    CellIndex : Int #%(T_55_META_EVT_38_P1)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Owner = HudEasyList\r
event OnVisibleDataRangeChanged = 42 { #%(T_55_META_EVT_42)\r
    FirstDataIndex : Int #%(T_55_META_EVT_42_P0)\r
    LastDataIndex : Int #%(T_55_META_EVT_42_P1)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@Owner = Player\r
event OnInGameWardrobeClosed = 3280 { #%(T_55_META_EVT_3280)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@Owner = Player\r
event OnPlayerConfirmOutfitWardrobe = 3281 { #%(T_55_META_EVT_3281)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@Owner = Player\r
event OnTapWardrobeItem = 3282 { #%(T_55_META_EVT_3282)\r
    Outfits : ListT_ClothID #%(T_55_META_API_215_P0)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@Owner = Player\r
event OnReceiveWardrobeResourceDownloadResult = 3283 { #%(T_55_META_EVT_3283)\r
    Outfits : ListT_ClothID #%(T_55_META_API_215_P0)\r
	@ScriptName=StatusCode\r
    ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=50\r
@ModuleLib=RoomSocial\r
@Owner = Player\r
event OnReceivedChatMessage = 3284 { #%(T_55_META_EVT_3284)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=50\r
@ModuleLib=RoomSocial\r
@Owner = Player\r
event OnChatHudOpen = 3285 { #%(T_55_META_EVT_3285)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=50\r
@ModuleLib=RoomSocial\r
@Owner = Player\r
event OnChatHudClose = 3286 { #%(T_55_META_EVT_3286)\r
}\r
\r
@ApiLevel=4\r
@ApiTarget=1\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Owner = Entity\r
event OnLogicTick = 43 { #%(T_55_META_EVT_43)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnMouseWheelScroll\r
@ApiTarget=1\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@Owner = Global\r
event OnMouseWheelScroll = 3136 { #OnMouseWheelScroll\r
    Scroll : Float #Scroll\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllPlayers\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1_R_D)\r
variable AllPlayers : ListT_Player = 1 { #%(T_46_META_WS_GETALLPLAYERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllTeams\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2_R_D)\r
variable AllTeams : ListT_Team = 2 { #%(T_46_META_WS_GETALLTEAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchPhase\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@ApiTarget=0\r
action SetFSMNextPhase = 3 { #%(T_46_META_WS_SWITCHPHASE)\r
    PhaseIndex : Int #%(T_46_META_WS_A_PHASEINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAllPlayersMoveStatus\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SetMatchCanMove = 4 { #%(T_46_META_WS_SETALLPLAYERSMOVESTATUS)\r
    MoveEnable : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveLevelObject_Deprecated\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=2\r
action RemoveLevelObject = 5 { #%(T_34_WT_WS_ENTITY14_NAME)\r
    LevelObjectEntity : LevelObject #%(T_34_WT_WS_ENTITY13_PARAM4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateLevelObject\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
action CreateLevelObject = 6 { #%(T_46_META_WS_CREATELEVELOBJECT)\r
    out EntityVarName : LevelObject #%(T_46_META_WS_A_CREATEDENTITY)\r
    SpawnPostion : Vector3 #%(T_46_META_WS_A_POSTION)\r
    ItemID : Int #%(T_46_META_WS_A_LEVELOBJECT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnableSafeZone\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
@ApiTarget=2\r
action OpenSafeZone = 8 { #%(T_46_META_WS_ENABLESAFEZONE)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    WaitShrinkTime : Float #%(T_46_META_WS_A_WAITTIME)\r
    ShrinkDuration : Float #%(T_46_META_WS_A_DURATION)\r
    Damage : Float #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnableMovingSafeZone\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
@ApiTarget=2\r
action MoveSafeZone = 3109 { #%(T_46_META_WS_ENABLEMOVINGSAFEZONE)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    TargetPos : Vector3 #%(T_46_META_WS_A_TARGETPOSITION)\r
    InitRadius : Float #%(T_46_META_WS_A_INITRADIUS)\r
    FinalRadius : Float #%(T_46_META_WS_A_FINALRADIUS)\r
    ShrinkDuration : Float #%(T_46_META_WS_A_DURATION)\r
    Damage : Float #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddItem\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action AddItemToCharacter = 3200 { #%(T_46_META_WS_ADDITEM)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
    ItemCount : Int #%(T_46_META_WS_A_COUNT)\r
    out EntityList : ListT_Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSpecialItemStatus\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action ToggleSpecialItemState = 23 { #%(T_46_META_WS_SETSPECIALITEMSTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemID : SpecialItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
    State : Bool #%(T_46_META_WS_A_STATUS)\r
    out IceWallMaker : IceWallMaker #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetTokenCount\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action GetPlayerTokenNum = 3500 { #%(T_46_META_WS_GETTOKENCOUNT)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
    out Count : Int #%(T_46_META_WS_A_COUNT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CompleteCustomMission\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action CustomMissionComplete = 47 { #%(T_46_META_WS_COMPLETECUSTOMMISSION)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    MissionID : Int #%(T_46_META_WS_A_MISSIONID)\r
    MissionProgress : Int #%(T_46_META_WS_A_MISSIONPROGRESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetTokenCountToday\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action GetPlayerTokenCountToday = 32 { #%(T_46_META_WS_GETTOKENCOUNTTODAY)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
    out Count : Int #%(T_46_META_WS_A_COUNT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddToken\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action AddTokenToPlayer = 3501 { #%(T_46_META_WS_ADDTOKEN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CostToken\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action PlayerRemoveToken = 3502 { #%(T_46_META_WS_COSTTOKEN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
    Count : Int #%(T_46_META_WS_A_TOKENCOUNT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateTokenInScene\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
action AddTokenAtPosition = 3503 { #%(T_46_META_WS_CREATETOKENINSCENE)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    TokenID : Int #%(T_46_META_WS_A_TOKENID)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DisableSafeZone\r
@ModuleID=9\r
@ModuleLib=SafeZone\r
@ApiTarget=2\r
action CloseSafeZone = 9 { #%(T_46_META_WS_DISABLESAFEZONE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FilterLevelObjects\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@Return = %(T_48_META_API_10_R_D)\r
variable AllLevelObjs : ListT_LevelObject = 10 { #%(T_46_META_WS_FILTERLEVELOBJECTS)\r
    FilterLevelObjType : LevelObjType #%(T_46_META_WS_A_FILTERTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EndCurrentPhase\r
@ModuleID=1\r
@ModuleLib=Workflow\r
@ApiTarget=0\r
action EndCurrentPhase = 11 { #%(T_46_META_WS_ENDCURRENTPHASE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LogInfo\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PrintString = 12 { #%(T_46_META_WS_LOGINFO)\r
    Context : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=3\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action Assert = 3121 { #%(T_46_META_WS_ASSERT)\r
    Assert : Bool #%(T_46_META_WS_A_ASSERTIONEXPRESSION)\r
    Tips : String #%(T_46_META_WS_A_TIPS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Format\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@ApiTarget=0\r
@Return = %(T_48_META_API_13_R_D)\r
variable FormatString : String = 13 { #%(T_46_META_WS_FORMAT)\r
    FormatString : String #%(T_46_META_WS_A_CONTENT)\r
    ParamsArray : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ClearResidualLevelObjects\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action ClearAllLevelObjsResidual = 14 { #%(T_46_META_WS_CLEARRESIDUALLEVELOBJECTS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlIf = 1001 { #%(T_34_WZ_WS_LOGIC5_NAME)\r
    Conditions : ListT_Condition #%(T_34_WZ_WS_LOGIC5_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlForIndex = 1002 { #%(T_34_WZ_WS_LOGIC6_NAME)\r
    ElementIndexName : String #%(T_34_LY_WS_INDEX)\r
    LoopStart : Int #%(T_34_WZ_WS_LOGIC6_PARAM2_NAME)\r
    LoopEnd : Int #%(T_34_WZ_WS_LOGIC6_PARAM3_NAME)\r
    LoopStep : Int #%(T_34_WZ_WS_LOGIC6_PARAM4_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ProcessCtlForRange_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action ProcessCtlForRange = 1003 { #%(T_34_WZ_WS_LOGIC7_NAME)\r
    out ElementName : Object #%(T_34_WZ_WS_LOGIC7_PARAM1_NAME)\r
    out ElementIndexName : Int #%(T_34_LY_WS_INDEX)\r
    LoopRange : List #%(T_34_WZ_WS_LOGIC7_PARAM3_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlForLoopRange = 1020 { #%(T_40_XXJ_WS_PROCESSCTLFORLOOPRANGE_NAMEKEY)\r
    out KeyName : Object #%(T_40_XXJ_WS_KEY_NAMEKEY)\r
    out ValueName : Object #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
    LoopRange : ListOrMap #%(T_43_YU_WS_MODULE_MAP)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlBreak = 1004 { #%(T_34_WZ_WS_LOGIC9_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlContinue = 1005 { #%(T_34_WZ_WS_LOGIC10_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlReturn = 1006 { #%(T_34_WZ_WS_LOGIC11_NAME)\r
    ReturnValue : Object #%(T_34_WZ_WS_LOGIC11_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ProcessCtlWhile = 1007 { #%(T_34_WZ_WS_LOGIC8_NAME)\r
    Condition : Condition #%(T_34_WZ_WS_LOGIC8_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaitForNextFrame\r
@Async\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action WaitForNextFrame = 1008 { #%(T_46_META_WS_WAITFORNEXTFRAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WaitForMillisecond\r
@Async\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action WaitForSeconds = 1009 { #%(T_46_META_WS_WAITFORMILESECOND)\r
    WaitSeconds : Int #%(T_46_META_WS_P_PHASEDURATION)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action EventCallback = 1010 { #%(T_48_META_API_1010)\r
    EventParamNames : ListT_String #%(T_48_META_API_1010_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CodeBlock = 1011 { #%(T_48_META_API_1011)\r
    ParamNames : ListT_String #%(T_48_META_API_1011_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeCustomAPIWithSerial = 1012 { #%(T_48_META_API_1012)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
    GraphID : String #%(T_48_META_API_1012_P1)\r
    FuncID : String #%(T_48_META_API_1012_P2)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeCustomAPIWithParallel = 1013 { #%(T_48_META_API_1013)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
    GraphID : String #%(T_48_META_API_1013_P1)\r
    FuncID : String #%(T_48_META_API_1013_P2)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeSelfCustomAPIWithSerial = 1014 { #%(T_48_META_API_1014)\r
    FuncID : String #%(T_48_META_API_1014_P0)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeSelfCustomAPIWithParallel = 1015 { #%(T_48_META_API_1015)\r
    FuncID : String #%(T_48_META_API_1015_P0)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Length\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1050_R_D)\r
variable ListLength : Int = 1050 { #%(T_46_META_WS_LENGTH)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1051_R_D)\r
variable ListGetElement : Object = 1051 { #%(T_34_LY_WS_GET)\r
    ListValue : List #%(T_34_M_WS_ARRAY)\r
    Index : Int #%(T_34_LY_WS_INDEX)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1602_R_D)\r
variable MapGetValue : Object = 1602 { #%(T_34_LY_WS_GET)\r
    MapValue : Map #%(T_46_META_WS_C_MAP)\r
    Key : Object #%(T_40_XXJ_WS_KEY_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ContainKey\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1607_R_D)\r
variable MapContainKey : Bool = 1607 { #%(T_46_META_WS_CONTAINKEY)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
    Key : Object #%(T_46_META_WS_A_KEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllKeys\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1608_R_D)\r
variable MapGetAllKeys : ListT_Object = 1608 { #%(T_46_META_WS_GETALLKEYS)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListSetElement = 1052 { #%(T_34_LY_WS_SET)\r
    ListValue : List #%(T_34_M_WS_ARRAY)\r
    Index : Int #%(T_34_LY_WS_INDEX)\r
    ElementValue : Object #%(T_34_WT_WS_ENTITY2_PARAM4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetElement\r
@ModuleID=10002\r
@ModuleLib=Map\r
action MapSetValue = 1603 { #%(T_34_LY_WS_SET)\r
    MapValue : Map #%(T_46_META_WS_C_MAP)\r
    Key : Object #%(T_40_XXJ_WS_KEY_NAMEKEY)\r
    Value : Object #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Append\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListAppend = 1053 { #%(T_46_META_WS_APPEND)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Remove\r
@ModuleID=10002\r
@ModuleLib=Map\r
action MapRemoveValue = 1604 { #%(T_46_META_WS_DELETE)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
    Key : Object #%(T_46_META_WS_A_KEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clear\r
@ModuleID=10002\r
@ModuleLib=Map\r
action MapClear = 1605 { #%(T_46_META_WS_CLEAR)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Length\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1606_R_D)\r
variable MapGetLength : Int = 1606 { #%(T_46_META_WS_LENGTH)\r
    MapValue : Map #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveAt\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListRemoveAt = 1054 { #%(T_46_META_WS_DELETEAT)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1060_R_D)\r
variable Compare : Bool = 1060 { #%(T_34_WZ_WS_LOGIC2_NAME)\r
    LeftValue : Object #%(T_34_WZ_WS_LOGIC2_PARAM1_NAME)\r
    CompareType : Int #%(T_34_WZ_WS_LOGIC2_PARAM2_NAME)\r
    RightValue : Object #%(T_34_WZ_WS_LOGIC2_PARAM3_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideSphere\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1532_R_D)\r
variable IsEntityInsideSphere : Bool = 1532 { #%(T_46_META_WS_ISINSIDESPHERE)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideCylinder\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1533_R_D)\r
variable IsEntityInsideCylinder : Bool = 1533 { #%(T_46_META_WS_ISINSIDECYLINDER)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideBox\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1534_R_D)\r
variable IsEntityInsideBox : Bool = 1534 { #%(T_46_META_WS_ISINSIDEBOX)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Length : Float #%(T_46_META_WS_A_LENGTH)\r
    Width : Float #%(T_46_META_WS_A_WIDTH)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsInsideSector\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_1535_R_D)\r
variable IsEntityInsideSector : Bool = 1535 { #%(T_46_META_WS_ISINSIDESECTOR)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CenterPos : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    CutRadius : Float #%(T_46_META_WS_A_CUTRADIUS)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
    Angle : Float #%(T_46_META_WS_A_ANGLE)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_ROTATION)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1061_R_D)\r
variable Arithmetic : Number = 1061 { #%(T_36_WZY_WS_ARITHMETIC_NAME)\r
    LeftValue : Number #%(T_42_XXJ_WS_LEFTVALUE)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
    RightValue : Number #%(T_42_XXJ_WS_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RandomInt\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1062_R_D)\r
variable RandomInt : Int = 1062 { #%(T_46_META_WS_RANDOMINT)\r
    MinValue : Int #%(T_46_META_WS_A_MIN)\r
    MaxValue : Int #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RandomFloat\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1063_R_D)\r
variable RandomFloat : Float = 1063 { #%(T_46_META_WS_RANDOMFLOAT)\r
    MinValue : Float #%(T_46_META_WS_A_MIN)\r
    MaxValue : Float #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1065_R_D)\r
variable Not : Bool = 1065 { #%(T_34_WZ_WS_LOGIC3_NAME)\r
    Value : Bool #%(T_34_WT_WS_ENTITY2_PARAM4)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Abs\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1066_R_D)\r
variable Abs : Number = 1066 { #%(T_46_META_WS_ABS)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sqrt\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1067_R_D)\r
variable Sqrt : Float = 1067 { #%(T_46_META_WS_SQRT)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Negate\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1068_R_D)\r
variable Negate : Number = 1068 { #%(T_46_META_WS_NEGATE)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Connect\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1069_R_D)\r
variable StrConcat : String = 1069 { #%(T_46_META_WS_CONNECT)\r
    LeftStr : Object #%(T_46_META_WS_A_LEFT)\r
    RightStr : Object #%(T_46_META_WS_A_RIGHT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Length\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1070_R_D)\r
variable StrLen : Int = 1070 { #%(T_46_META_WS_LENGTH)\r
    Str : String #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Floor\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1071_R_D)\r
variable Floor : Int = 1071 { #%(T_46_META_WS_FLOOR)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Ceil\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1072_R_D)\r
variable Ceil : Int = 1072 { #%(T_46_META_WS_CEIL)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Round\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1073_R_D)\r
variable Round : Int = 1073 { #%(T_46_META_WS_ROUND)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetX\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1500_R_D)\r
variable VectorGetX : Float = 1500 { #%(T_34_LY_WS_GVX)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetY\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1501_R_D)\r
variable VectorGetY : Float = 1501 { #%(T_34_LY_WS_GVY)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetZ\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1502_R_D)\r
variable VectorGetZ : Float = 1502 { #%(T_34_LY_WS_GVZ)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetX\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action VectorSetX = 1503 { #%(T_34_LY_WS_SVX)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetY\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action VectorSetY = 1504 { #%(T_34_LY_WS_SVY)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetZ\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action VectorSetZ = 1505 { #%(T_34_LY_WS_SVZ)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
    Z : Float #%(T_48_META_API_1505_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Add\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1506_R_D)\r
variable VectorAdd : Vector3 = 1506 { #%(T_34_LY_WS_VADD)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sub\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1507_R_D)\r
variable VectorSub : Vector3 = 1507 { #%(T_34_LY_WS_VSUB)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Mul\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1508_R_D)\r
variable VectorMul : Vector3 = 1508 { #%(T_34_LY_WS_VMUL)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUE)\r
    Scale : Float #%(T_40_XXJ_WS_SCALE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Dot\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1509_R_D)\r
variable VectorDot : Float = 1509 { #%(T_46_META_WS_DOT)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Cross\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1510_R_D)\r
variable VectorCross : Vector3 = 1510 { #%(T_46_META_WS_CROSS)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Normalize\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1511_R_D)\r
variable VectorNormalize : Vector3 = 1511 { #%(T_46_META_WS_NORMALIZE)\r
    Vector : Vector3 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Magnitude\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1512_R_D)\r
variable VectorSize : Float = 1512 { #%(T_46_META_WS_MAGNITUDE)\r
    Vector : Vector3 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Distance\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1513_R_D)\r
variable VectorDistance : Float = 1513 { #%(T_46_META_WS_DISTANCE)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Angle\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1514_R_D)\r
variable VectorAngel : Float = 1514 { #%(T_46_META_WS_ANGEL)\r
    VectorLeft : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    VectorRight : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Projection\r
@ModuleID=10003\r
@ModuleLib=Math\r
variable Vector3Projection : Vector3 = 98 { #%(T_49_META_API_98)\r
    ValueA : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    ValueB : Vector3 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2GetX\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3240_R_D)\r
variable Vector2GetX : Float = 3240 { #%(T_43_YU_WS_VECTOR2GETX)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2GetY\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3241_R_D)\r
variable Vector2GetY : Float = 3241 { #%(T_43_YU_WS_VECTOR2GETY)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetX\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action Vector2SetX = 3242 { #%(T_43_YU_WS_VECTOR2SETX)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetY\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
action Vector2SetY = 3243 { #%(T_43_YU_WS_VECTOR2SETY)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Add\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3244_R_D)\r
variable Vector2Add : Vector2 = 3244 { #%(T_43_YU_WS_VECTOR2ADD)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Sub\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3245_R_D)\r
variable Vector2Sub : Vector2 = 3245 { #%(T_43_YU_WS_VECTOR2SUB)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Scale\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3246_R_D)\r
variable Vector2Scale : Vector2 = 3246 { #%(T_43_YU_WS_VECTOR2SCALE)\r
    Vector2Left : Vector2 #%(T_38_M_WS_VECTOR2)\r
    Scale : Float #%(T_40_XXJ_WS_SCALE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Dot\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3247_R_D)\r
variable Vector2Dot : Float = 3247 { #%(T_46_META_WS_VECTOR2DOT)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Distance\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3248_R_D)\r
variable Vector2Distance : Float = 3248 { #%(T_46_META_WS_VECTOR2DISTANCE)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Angle\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3249_R_D)\r
variable Vector2Angle : Float = 3249 { #%(T_46_META_WS_VECTOR2ANGLE)\r
    Vector2Left : Vector2 #%(T_46_META_WS_A_VALUEA)\r
    Vector2Right : Vector2 #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Normalize\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3250_R_D)\r
variable Vector2Normalize : Vector2 = 3250 { #%(T_46_META_WS_VECTOR2NORMALIZE)\r
    Vector2 : Vector2 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Magnitude\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3251_R_D)\r
variable Vector2Magnitude : Float = 3251 { #%(T_46_META_WS_VECTOR2MAGNITUDE)\r
    Vector2 : Vector2 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2Reflect\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3252_R_D)\r
variable Vector2Reflect : Vector2 = 3252 { #%(T_46_META_WS_VECTOR2REFLECT)\r
    Direction : Vector2 #%(T_46_META_WS_A_DIRECTION)\r
    Normal : Vector2 #%(T_46_META_WS_A_NORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector3Reflect\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3253_R_D)\r
variable Vector3Reflect : Vector3 = 3253 { #%(T_46_META_WS_VECTOR3REFLECT)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector3ToVector2\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_3254_R_D)\r
variable Vector3ToVector2 : Vector2 = 3254 { #%(T_46_META_WS_VECTOR3TOVECTOR2)\r
    Vector3 : Vector3 #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2ToVector3\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_3255_R_D)\r
variable Vector2ToVector3 : Vector3 = 3255 { #%(T_46_META_WS_VECTOR2TOVECTOR3)\r
    Vector2 : Vector2 #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NewVector2\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_3256_R_D)\r
variable NewVector2 : Vector2 = 3256 { #%(T_43_YU_WS_NEWVECTOR2)\r
    X : Float #%(T_43_YU_WS_X)\r
    Y : Float #%(T_43_YU_WS_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NewVector3\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1515_R_D)\r
variable NewVector : Vector3 = 1515 { #%(T_38_WZY_WS_GETVEC_NAME)\r
    X : Float #%(T_43_YU_WS_X)\r
    Y : Float #%(T_43_YU_WS_Y)\r
    Z : Float #%(T_45_XXJ_WS_Z)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=NewDirectPoint_Deprecated\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1516_R_D)\r
variable NewDirectPoint : DirectedPoint = 1516 { #%(T_36_WZY_WS_SETDIRPOINT_NAME)\r
    Position : Vector3 #%(T_34_WT_WS_ENTITY13_PARAM2)\r
    Forward : Vector3 #%(T_36_WZY_WS_SETDIRPOINT_PARAM2_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DirectPointGetPos_Deprecated\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1517_R_D)\r
variable DirectPointGetPos : Vector3 = 1517 { #%(T_36_WZY_WS_GETPOS_NAME)\r
    DirectPoint : DirectedPoint #%(T_36_WZY_WS_DIRPOINT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DirectPointGetForward_Deprecated\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1518_R_D)\r
variable DirectPointGetForward : Vector3 = 1518 { #%(T_36_WZY_WS_GETFOR_NAME)\r
    DirectPoint : DirectedPoint #%(T_36_WZY_WS_DIRPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=New\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1519_R_D)\r
variable NewList : List = 1519 { #%(T_46_META_WS_NEW)\r
    Length : Int #%(T_46_META_WS_A_LENGTH)\r
    Capicity : Int #%(T_46_META_WS_A_CAPICITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=New\r
@ModuleID=10002\r
@ModuleLib=Map\r
@Return = %(T_48_META_API_1601_R_D)\r
variable NewMap : Map = 1601 { #%(T_46_META_WS_NEW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sin\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1525_R_D)\r
variable Sin : Float = 1525 { #%(T_46_META_WS_SIN)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Cos\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1526_R_D)\r
variable Cos : Float = 1526 { #%(T_46_META_WS_COS)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Tan\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1527_R_D)\r
variable Tan : Float = 1527 { #%(T_46_META_WS_TAN)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ColorGet\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1528_R_D)\r
variable ColorGet : Color = 1528 { #%(T_46_META_WS_COLORGET)\r
    R : Int #%(T_46_META_WS_A_R)\r
    G : Int #%(T_46_META_WS_A_G)\r
    B : Int #%(T_46_META_WS_A_B)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ASin\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1529_R_D)\r
variable Asin : Float = 1529 { #%(T_46_META_WS_ASIN)\r
    Degree : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ACos\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1530_R_D)\r
variable Acos : Float = 1530 { #%(T_46_META_WS_ACOS)\r
    Degree : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Value\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1531_R_D)\r
variable Atan : Float = 1531 { #%(T_46_META_WS_A_VALUE)\r
    Degree : Float #%(T_46_META_WS_A_DEGREE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_1064_R_D)\r
variable IsNil : Bool = 1064 { #%(T_34_WZ_WS_LOGIC4_NAME)\r
    TargetObj : Object #%(T_34_WZ_WS_LOGIC4_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetServerTimestamp\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1598_R_D)\r
variable GetServerTime : Int = 1598 { #%(T_46_META_WS_GETSERVERTIMESTAMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetServerRegion\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1599_R_D)\r
variable GetServerRegion : String = 1599 { #%(T_46_META_WS_GETSERVERREGION)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetReplicationData = 2000 { #%(T_34_WT_WS_ENTITY2_NAME)\r
    TargetEntity : entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    PropertyIndex : Property #%(T_34_WT_WS_ENTITY2_PARAM3)\r
    PropertyValue : Object #%(T_34_WT_WS_ENTITY2_PARAM4)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2001_R_D)\r
variable GetReplicationData : Object = 2001 { #%(T_34_WT_WS_ENTITY4_NAME)\r
    TargetEntity : entity #%(T_34_WT_WS_ENTITY2_PARAM1)\r
    PropertyIndex : Property #%(T_34_WT_WS_ENTITY2_PARAM3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetGraphProperty = 2002 { #%(T_48_META_API_2002)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
    GraphID : String #%(T_48_META_API_2002_P1)\r
    PropertyID : String #%(T_48_META_API_2002_P2)\r
    PropertyValue : Object #%(T_48_META_API_2002_P3)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2003_R_D)\r
variable GetGraphProperty : Object = 2003 { #%(T_48_META_API_2003)\r
    TargetEntity : entity #%(T_40_XXJ_WS_TARGETENTITY_NAMEKEY)\r
    GraphID : String #%(T_48_META_API_2003_P1)\r
    PropertyID : String #%(T_48_META_API_2003_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetSelfGraphProperty = 2013 { #%(T_48_META_API_2013)\r
    PropertyID : String #%(T_48_META_API_2013_P0)\r
    PropertyValue : Object #%(T_48_META_API_2013_P1)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2014_R_D)\r
variable GetSelfGraphProperty : Object = 2014 { #%(T_48_META_API_2014)\r
    PropertyID : String #%(T_48_META_API_2014_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DefLocalVar = 2004 { #%(T_36_M_WS_TEMPVAR)\r
    VarName : String #%(T_34_M_WS_VARNAME)\r
    VarValue : Object #%(T_34_WT_WS_ENTITY2_PARAM4)\r
    VarType : Type #%(T_40_XXJ_WS_VARTYPE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetLocalVar = 2005 { #%(T_36_M_WS_SETTEMPVAR)\r
    VarName : String #%(T_34_M_WS_VARNAME)\r
    VarValue : Object #%(T_48_META_API_2005_P1)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_2006_R_D)\r
variable GetLocalVar : Object = 2006 { #%(T_48_META_API_2006)\r
    VarName : String #%(T_48_META_API_2006_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeGlobalCustomAPIWithSerial = 2009 { #%(T_48_META_API_2009)\r
    GraphID : String #%(T_48_META_API_2009_P0)\r
    FuncID : String #%(T_48_META_API_2009_P1)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action FindAndInvokeGlobalCustomAPIWithParallel = 2010 { #%(T_48_META_API_2010)\r
    GraphID : String #%(T_48_META_API_2010_P0)\r
    FuncID : String #%(T_48_META_API_2010_P1)\r
    ParamsArray : List #%(T_42_XXJ_WS_PARAMSARRAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddHP\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action PlayerAddHP = 3201 { #%(T_46_META_WS_ADDHP)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    DeltaHP : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyItem\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action PlayerRemoveItem = 3205 { #%(T_46_META_WS_DESTROYITEM)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetItemCount\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3206_R_D)\r
variable GetPlayerBagItemCount : Int = 3206 { #%(T_46_META_WS_GETITEMCOUNT)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBuiltInUI\r
@ModuleID=31\r
@ModuleLib=Hud\r
@ApiTarget=2\r
action CreateInternalHud = 9000 { #%(T_46_META_WS_CREATEBUILTINUI)\r
    out EntityVarName : InternalHud #%(T_46_META_WS_A_CREATEDENTITY)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
    HudType : InternalHudType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBuiltInUIClient\r
@ModuleID=31\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action CreateInternalHudClient = 73 { #%(T_46_META_WS_CREATEBUILTINUICLIENT)\r
    out EntityVarName : InternalHud #%(T_46_META_WS_A_CREATEDENTITY)\r
    HudType : InternalHudType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyBuiltInUI\r
@ModuleID=31\r
@ModuleLib=Hud\r
action RemoveInternalHud = 9001 { #%(T_46_META_WS_DESTROYBUILTINUI)\r
    HudEntity : InternalHud #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateIconEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateIconEntity = 9002 { #%(T_34_WT_WS_ENTITY6_NAME)\r
    out EntityVarName : PresentIcon #%(T_34_WT_WS_ICONENTITY_PARAM1)\r
    OwnerPlayer : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    IconType : IconType #%(T_34_WT_WS_ENTITY6_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveIconEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveIconEntity = 9003 { #%(T_34_WT_WS_ENTITY10_NAME)\r
    TargetEntity : PresentIcon #%(T_34_WT_WS_ICONENTITY_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateTextEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateTextEntity = 9004 { #%(T_34_WT_WS_ENTITY8_NAME)\r
    out EntityVarName : PresentText #%(T_34_WT_WS_TXTENTITY_PARAM1)\r
    OwnerPlayer : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    Text : Object #%(T_34_WT_WS_ENTITY8_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveTextEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveTextEntity = 9005 { #%(T_34_WT_WS_ENTITY11_NAME)\r
    TargetEntity : PresentText #%(T_34_WT_WS_TXTENTITY_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateEffectEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateEffectEntity = 9006 { #%(T_34_SP_WS_BLOCK10_NAME)\r
    out EntityVarName : PresentEffect #%(T_34_WT_WS_VFXENTITY_PARAM1)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
    EffectType : EffectType #%(T_34_M_WS_VFX)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateEffect_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CreateEffectEntityNew = 9023 { #%(T_34_SP_WS_BLOCK10_NAME)\r
    out EntityVarName : EffectEntity #%(T_34_WT_WS_VFXENTITY_PARAM1)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
    EffectType : EffectType #%(T_34_M_WS_VFX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSkybox\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action SetSkyboxEnv = 103 { #%(T_46_META_WS_SETSKYBOX)\r
    SkyboxEnv : SkyboxEnvBaseType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveEffectEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveEffectEntity = 9007 { #%(T_34_SP_WS_BLOCK12_NAME)\r
    TargetEntity : PresentEffect #%(T_34_SP_WS_BLOCK12_PARAM1_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveEffectEntityNew_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveEffectEntityNew = 9024 { #%(T_34_SP_WS_BLOCK12_NAME)\r
    TargetEntity : EffectEntity #%(T_34_SP_WS_BLOCK12_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUI_Deprecated\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=2\r
action CreateCustomHud = 9008 { #%(T_46_META_WS_CREATECUSTOMUI)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_OWNER)\r
    HudID : CustomHudID #%(T_46_META_WS_A_UIID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUI\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=2\r
action CreateCustomHudV2 = 114 { #%(T_46_META_WS_CREATECUSTOMUI)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
    @optional\r
    OwnerPlayer : PlayerOrObserver #%(T_46_META_WS_A_OWNER)\r
    HudAssetID : CustomHudAssetID #%(T_50_META_API_114_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUIClient_Deprecated\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action CreateCustomHudClient = 74 { #%(T_46_META_WS_CREATECUSTOMUICLIENT)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
    HudID : CustomHudID #%(T_46_META_WS_A_UIID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUIClient\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action CreateCustomHudClientV2 = 115 { #%(T_46_META_WS_CREATECUSTOMUICLIENT)\r
    out EntityVarName : CustomHud #%(T_46_META_WS_A_CREATEDENTITY)\r
    HudAssetID : CustomHudAssetID #%(T_50_META_API_114_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyCustomUI\r
@ModuleID=16\r
@ModuleLib=Hud\r
action RemoveCustomHud = 9009 { #%(T_46_META_WS_DELETECUSTOMUI)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWidgetFromCustomUI\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Return = %(T_48_META_API_9010_R_D)\r
variable GetWidgetFromCustomHud : HudWidget = 9010 { #%(T_46_META_WS_GETWIDGETFROMCUSTOMUI)\r
    @optional\r
    OwnerPlayer : PlayerOrObserver #%(T_46_META_WS_A_OWNER)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_TARGET)\r
    WidgetID : CustomHudWidgetID #%(T_46_META_WS_A_WIDGETID)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateSoundEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CreateSoundEntity = 9011 { #%(T_34_SP_WS_BLOCK14_NAME)\r
    out EntityVarName : PresentSound #%(T_38_WZY_WS_SOUNDENT)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
    SoundType : AudioType #%(T_34_SP_WS_BLOCK13_PARAM2_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PauseSoundEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action PauseSoundEntity = 9014 { #%(T_39_WZY_WS_PAUSESOUND_NAME)\r
    TargetEntity : PresentSoundOrListPresentSound #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ResumeSoundEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action ResumeSoundEntity = 9015 { #%(T_39_WZY_WS_PLAYSOUND_NAME)\r
    TargetEntity : PresentSoundOrListPresentSound #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
    IsReplay : Bool #%(T_39_WZY_WS_WEAREPLAY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveSoundEntity_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveSoundEntity = 9012 { #RemoveSoundEntity\r
    TargetEntity : PresentSound #%(T_40_XXJ_WS_SOUNDNTITY_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayEmote\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=0\r
action NotifyPlayEmote = 9503 { #%(T_46_META_WS_PLAYEMOTE)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    EmoteType : AnimationClipID #%(T_46_META_WS_A_EMOTE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PauseEmote\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=0\r
action NotifyPauseAnimation = 9504 { #%(T_46_META_WS_PAUSEEMOTE)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    IsPause : Bool #%(T_46_META_WS_A_ISPAUSE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NotifyPlayEffect\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyPlayEffect = 9500 { #%(T_46_META_WS_NOTIFYPLAYEFFECT)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ResPath : EffectType #%(T_46_META_WS_A_RESOURCE)\r
    Color : Color #%(T_46_META_WS_A_COLOR)\r
    Scale : Float #%(T_46_META_WS_A_SCALE)\r
    BindEntity : entity #%(T_46_META_WS_A_FOLLOWTARGET)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=NotifyPlaySound\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyPlaySound = 9501 { #%(T_46_META_WS_NOTIFYPLAYSOUND)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    AudioType : AudioType #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NotifyShowTips\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action NotifyShowTips = 9502 { #%(T_46_META_WS_NOTIFYSHOWTIPS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Text : Object #%(T_46_META_WS_A_CONTENT)\r
    Color : Color #%(T_46_META_WS_A_COLOR)\r
    Duration : Int #%(T_46_META_WS_P_PHASEDURATION)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10000_R_D)\r
variable ThisEntity : Entity = 10000 { #%(T_47_XXJ_WS_THISENTITY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10001_R_D)\r
variable FindEntityByID : Entity = 10001 { #%(T_48_META_API_10001)\r
    EntityID : String #%(T_48_META_API_10001_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10002_R_D)\r
variable GetGlobalEntity : Global = 10002 { #%(T_37_WZY_WS_GETGAMEENT_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=TeleportPlayer_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action TeleportPlayer = 10003 { #%(T_34_WT_WS_ENTITY25_NAME)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    Pos : DirectedPoint #%(T_34_WT_WS_ENTITY13_PARAM2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action BindCustomPlayer = 144 { #%(T_50_META_API_144)\r
    CustomPlayer : Entity #%(T_50_META_API_144_P0)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action UnbindCustomPlayer = 145 { #%(T_50_META_API_145)\r
    BindedPlayer : Player #%(T_50_META_API_145_P0)\r
    out IsSuccess : Bool #IsSuccess\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetCustomPlayerState = 147 { #%(T_50_META_API_147)\r
    CustomPlayer : Entity #%(T_50_META_API_147_P0)\r
    State : Int #%(T_50_META_API_147_P1)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action GetCustomPlayerState = 148 { #%(T_50_META_API_148)\r
    CustomPlayer : Entity #%(T_50_META_API_148_P0)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
    out State : Int #%(T_50_META_API_148_P1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeammateNearPos_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10004_R_D)\r
variable GetTeammateNearPos : DirectedPoint = 10004 { #%(T_35_M_WS_GETTEAMMATEPOS)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetOwner\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10005_R_D)\r
variable GetEntityOwner : Player = 10005 { #%(T_46_META_WS_GETOWNER)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Teleport\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action TeleportPlayerPositionAndForward = 10056 { #%(T_46_META_WS_TELEPORT)\r
    Player : PlayerOrVehicle #%(T_46_META_WS_A_TARGET)\r
    Pos : Vector3 #%(T_46_META_WS_A_POSITION)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetPositionNearTeammate\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10057_R_D)\r
variable GetTeammateNearPosVec3 : Vector3 = 10057 { #%(T_46_META_WS_GETPOSITIONNEARTEAMMATE)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetRandomSpawnPos_Deprecated\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3002_R_D)\r
variable GetRandomSpawnPos : DirectedPoint = 3002 { #%(T_34_WT_WS_ENTITY18_NAME)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerScore_Deprecated\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3003_R_D)\r
variable GetPlayerScoreByType : Int = 3003 { #%(T_34_WT_WS_ENTITY19_NAME)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetPlayerScore_Deprecated\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
action SetPlayerScoreByType = 3004 { #%(T_38_WZY_WS_SETROUNDSCORE)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
    ScoreValue : Int #%(T_34_WT_WS_ENTITY20_PARAM3)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamScore_Deprecated\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3005_R_D)\r
variable GetTeamScoreByType : Int = 3005 { #%(T_34_WT_WS_ENTITY21_NAME)\r
    Team : Team #%(T_34_WT_WS_ENTITY21_PARAM1)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetTeamScore_Deprecated\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
action SetTeamScoreByType = 3006 { #%(T_34_WT_WS_ENTITY22_NAME)\r
    Team : Team #%(T_34_WT_WS_ENTITY21_PARAM1)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
    ScoreValue : Int #%(T_34_WT_WS_ENTITY20_PARAM3)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerRoundScore_Deprecated\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3007_R_D)\r
variable GetPlayerRoundScoreByType : Int = 3007 { #%(T_34_WT_WS_ENTITY23_NAME)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    RoundIndex : Int #%(T_34_WT_WS_ENTITY23_PARAM2)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamRoundScore_Deprecated\r
@ModuleID=5\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3008_R_D)\r
variable GetTeamRoundScoreByType : Int = 3008 { #%(T_34_WT_WS_ENTITY24_NAME)\r
    Team : Team #%(T_34_WT_WS_ENTITY21_PARAM1)\r
    RoundIndex : Int #%(T_34_WT_WS_ENTITY23_PARAM2)\r
    ScoreType : ScoreType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerRank_Deprecated\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3009_R_D)\r
variable GetPlayerRank : Int = 3009 { #%(T_40_XXJ_WS_GETPLAYERRANK)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamRank_Deprecated\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3011_R_D)\r
variable GetTeamRank : Int = 3011 { #%(T_40_XXJ_WS_GETTEAMRANK)\r
    Team : Team #Team\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetPlayerRoundRank_Deprecated\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3013_R_D)\r
variable GetPlayerRoundRank : Int = 3013 { #%(T_40_XXJ_WS_GETPLAYERROUNDRANK)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    RoundIndex : Int #%(T_34_T_WS_BLOCK3_PARAM1_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetTeamRoundRank_Deprecated\r
@ModuleID=7\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3014_R_D)\r
variable GetTeamRoundRank : Int = 3014 { #%(T_40_XXJ_WS_GETTEAMROUNDRANK)\r
    Team : Team #Team\r
    RoundIndex : Int #%(T_34_T_WS_BLOCK3_PARAM1_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetRandomSpawnPosition\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3041_R_D)\r
variable GetRandomSpawnPosVec3 : Vector3 = 3041 { #%(T_46_META_WS_GETRANDOMSPAWNPOSITION)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CheckTriggerByOrder\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3207_R_D)\r
variable PlayerCheckCanTriggerLevelObjectByOrder : Bool = 3207 { #%(T_46_META_WS_CHECKTRIGGERBYORDER)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    LevelObject : LevelObject #%(T_46_META_WS_A_TRIGGER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=InfectionZombieGrowUp\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action InfectionZombieGrowUp = 3208 { #%(T_46_META_WS_INFECTIONZOMBIEGROWUP)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DealDamage\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@ApiTarget=2\r
action EntityTakeDamage = 10008 { #%(T_46_META_WS_DEALDAMAGE)\r
    DamageTaker : FightingEntity #%(T_46_META_WS_A_TARGET)\r
    DamageMaker : FightingEntity #%(T_46_META_WS_A_ATTACKER)\r
    DamageType : DamageType #%(T_46_META_WS_A_TYPE)\r
    DamageValue : Int #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Revive\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action RevivePlayer = 10009 { #%(T_46_META_WS_REVIVE)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddItemInScene\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action AddPickUpAtPosition = 10010 { #%(T_46_META_WS_ADDITEMINSCENE)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    ItemIds : IntOrListInt #%(T_46_META_WS_A_ITEMS)\r
    ItemCounts : IntOrListInt #%(T_46_META_WS_A_COUNTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Contain\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1520_R_D)\r
variable ListContains : Bool = 1520 { #%(T_46_META_WS_CONTAIN)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AppendRange\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListAppendRange = 1521 { #%(T_46_META_WS_APPENDRANGE)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    ContentList : List #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Remove\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListRemove = 1522 { #%(T_46_META_WS_DELETE)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IndexOf\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1523_R_D)\r
variable ListIndexOf : Int = 1523 { #%(T_46_META_WS_INDEXOF)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LastIndexOf\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1524_R_D)\r
variable ListLastIndexOf : Int = 1524 { #%(T_46_META_WS_LASTINDEXOF)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetInvincibility\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetGodState = 10006 { #%(T_46_META_WS_SETINVINCIBILITY)\r
    TargetEntity : Player #%(T_46_META_WS_A_TARGET)\r
    Duration : Int #%(T_46_META_WS_A_DURATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clone\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CloneEntity = 10007 { #%(T_46_META_WS_CLONE)\r
    out EntityVarName : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
    EntityToClone : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnableDefaultBTree\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action EnableDefaultAI = 3209 { #%(T_46_META_WS_ENABLEDEFAULTBTREE)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
    AIEnable : Bool #%(T_46_META_WS_A_ENABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PursuitTarget\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action AIAttackEntity = 3210 { #%(T_46_META_WS_PURSUITTARGET)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
    TargetEntity : FightingEntity #%(T_46_META_WS_A_PURSUITTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AttackTarget\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action AIRealAttackEntity = 3226 { #%(T_46_META_WS_ATTACKTARGET)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
    TargetEntity : FightingEntity #%(T_46_META_WS_A_ATTACKTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchWeapon\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action SwitchWeaponBySlot = 3227 { #%(T_46_META_WS_SWITCHWEAPON)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Slot : SwitchWeaponEquipSlot #%(T_46_META_WS_A_SLOT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DestroyEquipment_Deprecated\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DestroyEquipment = 3211 { #%(T_36_WZY_WS_DESTITEM_NAME)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    ItemType : InventoryType #%(T_34_WT_WS_ENTITY13_PARAM1)\r
    SlotType : EquipSlotType #%(T_13_R_PVE_WEAPON_SLOT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyEquipment\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DestroyEquipmentBySlot = 3218 { #%(T_46_META_WS_DESTROYEQUIPMENT)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    SlotType : EquipSlotType #%(T_46_META_WS_A_SLOT)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolTo\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action PatrolTo = 10011 { #%(T_46_META_WS_PATROLTO)\r
    TargetEntity : AI #%(T_46_META_WS_A_TARGET)\r
    Target : Vector3 #%(T_46_META_WS_A_POSITION)\r
    ComeBack : Bool #%(T_46_META_WS_A_COMEBACK)\r
    Style : PatrolStyleType #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PatrolAlong\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action PatrolAlong = 10012 { #%(T_46_META_WS_PATROLALONG)\r
    TargetEntity : AI #%(T_46_META_WS_A_TARGET)\r
    Points : ListT_Vector3 #%(T_46_META_WS_A_POSITIONS)\r
    PatrolType : PatrolType #%(T_46_META_WS_A_COMEBACK)\r
    Style : PatrolStyleType #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SpawnNextWave\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RefreshSpawnableEntity = 10013 { #%(T_46_META_WS_SPAWNNEXTWAVE)\r
    TargetEntity : SpawnableEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetType\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1016_R_D)\r
variable GetType : Type = 1016 { #%(T_46_META_WS_GETTYPE)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TypeIs\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1017_R_D)\r
variable TypeIs : Bool = 1017 { #%(T_46_META_WS_TYPEIS)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
    CompareType : Type #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsSubTypeOf\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1018_R_D)\r
variable IsSubClassOf : Bool = 1018 { #%(T_46_META_WS_ISSUBTYPEOF)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
    CompareType : Type #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_34_R_D)\r
variable HasComponent : Bool = 34 { #%(T_46_META_WS_HASCOMPONENT)\r
    @optional\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    TypeID : Type #%(T_46_META_WS_A_COMPONENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DispatchEvent\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEvent = 1019 { #%(T_46_META_WS_DISPATCHEVENT)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddFormulaPropertyFactor\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ModifyPropertyFactor = 10014 { #%(T_46_META_WS_ADDFORMULAPROPERTYFACTOR)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTYID)\r
    FactorType : FormulaFactorType #%(T_46_META_WS_A_FACTORTYPE)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=11\r
@ScriptName=ClearPropertyFactor_Deprecated\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ClearPropertyFactor = 10015 { #%(T_38_WZY_WS_CLEARPRO)\r
    TargetEntity : FormulableEntity #%(T_34_M_WS_ENTITY)\r
    PropertyID : Property #%(T_36_WZY_WS_FORMUFACT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearFormulaPropertyFactor\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ClearAllPropertyFactor = 10016 { #%(T_46_META_WS_CLEARFORMULAPROPERTYFACTOR)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFormulaPropertyRelative\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ModifyFormulaProperty = 10017 { #%(T_46_META_WS_SETFORMULAPROPERTYRELATIVE)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTY)\r
    ModifyType : PropertyModifyType #%(T_46_META_WS_A_MODIFYTYPE)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFormulaPropertyAbsolute\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action SetFormulaProperty = 10018 { #%(T_46_META_WS_SETFORMULAPROPERTYABSOLUTE)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTY)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFormulaPropertyFactor\r
@ModuleID=18\r
@ModuleLib=PropertyFormula\r
@ApiTarget=2\r
action ClearSingleFormulaProperty = 10019 { #%(T_46_META_WS_REMOVEFORMULAPROPERTYFACTOR)\r
    TargetEntity : FormulableEntity #%(T_46_META_WS_A_TARGET)\r
    PropertyID : Property #%(T_46_META_WS_A_PROPERTY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWallet\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action TryGetWalletIDByEntity = 3015 { #%(T_46_META_WS_GETWALLET)\r
    OwnerEntity : entity #%(T_46_META_WS_A_TARGET)\r
    out IsExistVarName : Bool #%(T_46_META_WS_A_ISEXIST)\r
    out WalletVarName : Wallet #%(T_46_META_WS_A_WALLET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateWallet\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action NewWalletForEntity = 3016 { #%(T_46_META_WS_CREATEWALLET)\r
    @optional\r
    OwnerUser : Player #%(T_46_META_WS_A_OWNER)\r
    OwnerEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    out WalletVarName : Wallet #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddMoney\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action IncreaseMoneyForWallet = 3017 { #%(T_46_META_WS_ADDMONEY)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
    Count : Float #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CostMoney\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action DecreaseMoneyForWallet = 3018 { #%(T_46_META_WS_COSTMONEY)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
    Count : Float #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TransferMoney\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action TransferMoneyForWallet = 3019 { #%(T_46_META_WS_TRANSFERMONEY)\r
    @optional\r
    OutWalletEntity : Wallet #%(T_46_META_WS_A_OUTWALLET)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
    Count : Float #%(T_46_META_WS_A_COUNT)\r
    @optional\r
    InWalletEntity : Wallet #%(T_46_META_WS_A_INWALLET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMoneyCount\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3020_R_D)\r
variable GetMoneyCountByWallet : Float = 3020 { #%(T_46_META_WS_GETMONEYCOUNT)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMoney\r
@ModuleID=20\r
@ModuleLib=Economy\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3021_R_D)\r
variable GetMoneyEntityByWallet : Money = 3021 { #%(T_46_META_WS_GETMONEY)\r
    @optional\r
    WalletEntity : Wallet #%(T_46_META_WS_A_TARGET)\r
    MoneyType : MoneyType #%(T_46_META_WS_A_MONEYTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllShops\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3022_R_D)\r
variable GetAllShops : ListT_Shop = 3022 { #%(T_46_META_WS_GETALLSHOPS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChatChannel\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3027_R_D)\r
variable GetFreeChatChannel : ChatChannel = 3027 { #%(T_46_META_WS_GETCHATCHANNEL)\r
    FreeChatChannel : FreeChatChannel #%(T_46_META_WS_A_INDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentChatChannel\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3028_R_D)\r
variable GetChatChannel : ChatChannel = 3028 { #%(T_46_META_WS_GETCURRENTCHATCHANNEL)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JoinChatChannel\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action JoinChatChannel = 3029 { #%(T_46_META_WS_JOINCHATCHANNEL)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_A_CHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitChatChannel\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action LeaveChatChannel = 3030 { #%(T_46_META_WS_QUITCHATCHANNEL)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsChatChannelEmpty\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
variable IsChatChannelEmpty : Bool = 3031 { #%(T_46_META_WS_ISCHATCHANNELEMPTY)\r
    ChatChannel : ChatChannel #%(T_46_META_WS_A_CHANNEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBehaviorStatus\r
@ModuleID=10010\r
@ModuleLib=Player\r
action SetPlayerBehaviorStatus = 3032 { #%(T_46_META_WS_SETBEHAVIORSTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    PlayerBehaviorType : PlayerBehaviorType #%(T_46_META_WS_A_TYPE)\r
    PlayerBehaviorStatus : PlayerBehaviorStatus #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ToString\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_7_R_D)\r
variable ToString : String = 7 { #%(T_46_META_WS_TOSTRING)\r
    TargetValue : Object #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NumToString\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@Return = %(T_48_META_API_1549_R_D)\r
variable NumToString : String = 1549 { #%(T_46_META_WS_NUMTOSTRING)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
    Format : String #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LoadScene\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=0\r
action LoadScene = 100 { #%(T_46_META_WS_LOADSCENE)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SwitchArea\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action SwitchPlayerArea = 104 { #%(T_46_META_WS_SWITCHAREA)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    EulerAngles : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UnloadScene\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=0\r
action UnloadScene = 101 { #%(T_46_META_WS_UNLOADSCENE)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchScene\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=0\r
action SwitchScene = 102 { #%(T_46_META_WS_SWITCHSCENE)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMapID\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
@Return = %(T_48_META_API_49_R_D)\r
variable GetMapID : Int = 49 { #%(T_46_META_WS_GETMAPID)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clear\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListClear = 1055 { #%(T_46_META_WS_CLEAR)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Reverse\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListReverse = 1056 { #%(T_46_META_WS_REVERSE)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clone\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1057_R_D)\r
variable ListClone : List = 1057 { #%(T_46_META_WS_CLONE)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Insert\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListInsert = 1058 { #%(T_46_META_WS_INSERT)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
    ElementValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Shuffle\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListShuffle = 1059 { #%(T_46_META_WS_SHUFFLE)\r
    ListValue : List #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsEqual\r
@ModuleID=10001\r
@ModuleLib=List\r
@Return = %(T_48_META_API_1077_R_D)\r
variable ListIsEqual : Bool = 1077 { #%(T_46_META_WS_ISEQUAL)\r
    LeftValue : List #%(T_46_META_WS_A_LEFTVALUE)\r
    RightValue : List #%(T_46_META_WS_A_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Replace\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1074_R_D)\r
variable StrReplace : String = 1074 { #%(T_46_META_WS_REPLACE)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
    OldValue : String #%(T_46_META_WS_A_OLDVALUE)\r
    NewValue : String #%(T_46_META_WS_A_NEWVALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Find\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1075_R_D)\r
variable StrFind : Int = 1075 { #%(T_46_META_WS_FIND)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
    FindValue : String #%(T_46_META_WS_A_FINDVALUE)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTINDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sub\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1076_R_D)\r
variable StrSub : String = 1076 { #%(T_46_META_WS_SUB)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTINDEX)\r
    Length : Int #%(T_46_META_WS_A_LENGTH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Split\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1078_R_D)\r
variable SplitString : ListT_String = 1078 { #%(T_46_META_WS_SPLIT)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
    SepStr : String #%(T_46_META_WS_A_SEPSTR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FindAt\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1079_R_D)\r
variable StringFindAt : String = 1079 { #%(T_46_META_WS_FINDAT)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
    IndexList : ListT_Int #%(T_46_META_WS_A_INDEXS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ToUpper\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1080_R_D)\r
variable StringUpper : String = 1080 { #%(T_46_META_WS_TOUPPER)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ToLower\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1081_R_D)\r
variable StringLower : String = 1081 { #%(T_46_META_WS_TOLOWER)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Strip\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1082_R_D)\r
variable StringStrip : String = 1082 { #%(T_46_META_WS_STRIP)\r
    SrcValue : String #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Join\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@Return = %(T_48_META_API_1083_R_D)\r
variable StringJoin : String = 1083 { #%(T_46_META_WS_JOIN)\r
    StrElems : ListT_String #%(T_46_META_WS_A_TARGET)\r
    SepStr : String #%(T_46_META_WS_A_SEP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FilterEntity\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_10020_R_D)\r
variable FilterEntities : ListT_Entity = 10020 { #%(T_46_META_WS_FILTERENTITY)\r
    Has : TypeOrListType #%(T_46_META_WS_A_MUST)\r
    Not : TypeOrListType #%(T_46_META_WS_A_NOT)\r
    Any : TypeOrListType #%(T_46_META_WS_A_ANY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetJersey\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action ChangeCustomizeClothes = 3212 { #%(T_46_META_WS_SETJERSEY)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ClothesType : CustomizeClothesType #%(T_46_META_WS_A_JERSEYTYPE)\r
    MainColor1 : Color #%(T_46_META_WS_A_MAINCOLOR1)\r
    MainColor2 : Color #%(T_46_META_WS_A_MAINCOLOR2)\r
    OtherColor : Color #%(T_46_META_WS_A_OTHERCOLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetJersey\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action ClearCustomizeClothes = 3213 { #%(T_46_META_WS_RESETJERSEY)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddFootballVelocity\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action AddVelocity = 10021 { #%(T_46_META_WS_ADDFOOTBALLVELOCITY)\r
    Football : Football #%(T_46_META_WS_A_FOOTBALL)\r
    Velocity : Vector3 #%(T_46_META_WS_A_VELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPlayerVoiceStatus\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action MutePlayerVoice = 3214 { #%(T_46_META_WS_SETPLAYERVOICESTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    MuteVoice : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPlayerQuickMessageStatus\r
@ModuleID=24\r
@ModuleLib=ChatChannel\r
@ApiTarget=2\r
action MutePlayerQuickChat = 3215 { #%(T_46_META_WS_SETPLAYERQUICKMESSAGESTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    MuteQuickChat : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphTo\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action MorphTargetLevelObject = 3023 { #%(T_46_META_WS_MORPHTO)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    LevelObject : LevelObject #%(T_46_META_WS_A_TARGET)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayAnimation\r
@ModuleID=35\r
@ModuleLib=Animation\r
action PlayAnimationByController = 3100 { #%(T_46_META_WS_PLAYANIMATION)\r
    AnimationControllerAble : AnimationControllerAble #%(T_46_META_WS_A_TARGET)\r
    StateName : String #%(T_46_META_WS_A_STATE)\r
    PlaySpeed : Float #%(T_46_META_WS_A_PLAYSPEED)\r
    OverrideLoopMode : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBodyPartWeight\r
@ModuleID=35\r
@ModuleLib=Animation\r
action SetBodyPartTrackWeight = 3300 { #%(T_48_META_API_3300)\r
    AnimationControllerAble : AnimationControllerAble #%(T_46_META_WS_TARGET)\r
    TrackName : String #%(T_48_META_API_3300_P1)\r
    Weight : Float #%(T_48_META_API_3300_P2)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=StopAnimation_Deprecated\r
@ModuleID=35\r
@ModuleLib=Animation\r
action StopAnimationByController = 3316 { #%(T_48_META_API_3316)\r
    AnimationControllerAble : AnimationControllerAble #%(T_46_META_WS_A_TARGET)\r
    StateName : String #%(T_46_META_WS_A_STATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StopAnimationV2\r
@ModuleID=35\r
@ModuleLib=Animation\r
action StopAnimationByControllerV2 = 3320 { #%(T_55_META_API_3320)\r
    AnimationControllerAble : AnimationControllerAble #%(T_45_XXJ_WS_TARGET)\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayPlayerdataAnimationByController\r
@ModuleID=35\r
@ModuleLib=Animation\r
action PlayPlayerdataAnimationByController = 3325 { #PlayPlayerdataAnimationByController\r
    Player : Player #Player\r
    StateName : String #StateName\r
    PlaySpeed : Float #PlaySpeed\r
    OverrideLoopMode : AnimationOverrideLoopType #OverrideLoopMode\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StopPlayerdataAnimationByController\r
@ModuleID=35\r
@ModuleLib=Animation\r
action StopPlayerdataAnimationByController = 3326 { #StopPlayerdataAnimationByController\r
    Player : Player #Player\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PausePlayerdataAnimationByController\r
@ModuleID=35\r
@ModuleLib=Animation\r
action PausePlayerdataAnimationByController = 3327 { #PausePlayerdataAnimationByController\r
    Player : Player #Player\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResumePlayerdataAnimationByController\r
@ModuleID=35\r
@ModuleLib=Animation\r
action ResumePlayerdataAnimationByController = 3328 { #ResumePlayerdataAnimationByController\r
    Player : Player #Player\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetPlayerdataAnimationController\r
@ModuleID=35\r
@ModuleLib=Animation\r
action ResetPlayerdataAnimationController = 3329 { #ResetPlayerdataAnimationController\r
    Player : Player #Player\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PauseAnimation\r
@ModuleID=35\r
@ModuleLib=Animation\r
action PauseAnimationByController = 3317 { #%(T_55_META_API_3317)\r
    AnimationControllerAble : AnimationControllerAble #%(T_45_XXJ_WS_TARGET)\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResumeAnimation\r
@ModuleID=35\r
@ModuleLib=Animation\r
action ResumeAnimationByController = 3318 { #%(T_55_META_API_3318)\r
    AnimationControllerAble : AnimationControllerAble #%(T_45_XXJ_WS_TARGET)\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetAnimation\r
@ModuleID=35\r
@ModuleLib=Animation\r
action ResetAnimationByController = 3319 { #%(T_55_META_API_3319)\r
    AnimationControllerAble : AnimationControllerAble #%(T_45_XXJ_WS_TARGET)\r
    BodyIndexes : ListT_Int #BodyIndexes\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayCharacterAnimationClip\r
@ModuleID=10010\r
@ModuleLib=Player\r
action PlayCharacterAnimationClip = 3101 { #%(T_46_META_WS_PLAYCHARACTERANIMATIONCLIP)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ClipID : AnimationClipID #%(T_46_META_WS_A_RESOURCE)\r
    IsLooping : Bool #%(T_46_META_WS_A_ISLOOP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PlayCharacterAnimationClipOverride\r
@ModuleID=10010\r
@ModuleLib=Player\r
action PlayCharacterAnimationClipOverride = 3315 { #%(T_48_META_API_3315)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ClipID : AnimationClipID #%(T_46_META_WS_A_RESOURCE)\r
    IsLooping : Bool #%(T_46_META_WS_A_ISLOOP)\r
    OverrideGamePlayControl : Bool #%(T_48_META_API_3315_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StopCharacterAnimationClip\r
@ModuleID=10010\r
@ModuleLib=Player\r
action StopCharacterAnimationClip = 3321 { #%(T_55_META_API_3321)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PauseCharacterAnimationClip\r
@ModuleID=10010\r
@ModuleLib=Player\r
action PauseCharacterAnimationClip = 3322 { #%(T_55_META_API_3322)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResumeCharacterAnimationClip\r
@ModuleID=10010\r
@ModuleLib=Player\r
action ResumeCharacterAnimationClip = 3323 { #%(T_55_META_API_3323)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetCharacterAnimationClip\r
@ModuleID=10010\r
@ModuleLib=Player\r
action ResetCharacterAnimationClip = 3324 { #%(T_55_META_API_3324)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCharacter\r
@ModuleID=10010\r
@ModuleLib=Player\r
action SwitchPresetCharacterType = 3102 { #%(T_46_META_WS_SETCHARACTER)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    DataID : PlayerDataID #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchAppearanceGroup\r
@ModuleID=38\r
@ModuleLib=Avatar\r
action ChangeAvatarPart = 3110 { #%(T_46_META_WS_SWITCHAPPEARANCEGROUP)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    PartName : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShowAppearanceGroup\r
@ModuleID=38\r
@ModuleLib=Avatar\r
action EnableAvatarPart = 3111 { #%(T_46_META_WS_SHOWAPPEARANCEGROUP)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    PartName : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HideAppearanceGroup\r
@ModuleID=38\r
@ModuleLib=Avatar\r
action DisableAvatarPart = 3112 { #%(T_46_META_WS_HIDEAPPEARANCEGROUP)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    PartName : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EndMorph\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action RestoreMorphTarget = 3024 { #%(T_46_META_WS_ENDMORPH)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CopyToMorph\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action CopyTargetLevelObject = 3025 { #%(T_46_META_WS_COPYTOMORPH)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    LevelObject : LevelObject #%(T_46_META_WS_A_TARGET)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMorph\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3026_R_D)\r
variable GetMorphObjectByPlayer : MorphObject = 3026 { #%(T_46_META_WS_GETMORPH)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWidgetByPath\r
@ModuleID=16\r
@ModuleLib=Hud\r
@Return = %(T_48_META_API_9013_R_D)\r
variable GetWidgetFromCustomHudByString : HudWidget = 9013 { #%(T_46_META_WS_GETWIDGETBYPATH)\r
    @optional\r
    OwnerPlayer : PlayerOrObserver #%(T_46_META_WS_A_OWNER)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_TARGET)\r
    WidgetPathOrName : String #%(T_46_META_WS_A_PATH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddScript\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action AddScript = 6000 { #%(T_46_META_WS_ADDSCRIPT)\r
    @optional\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    ScriptID : GraphID #%(T_46_META_WS_A_SCRIPT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveScript\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action RemoveScript = 6001 { #%(T_46_META_WS_REMOVESCRIPT)\r
    @optional\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    ScriptID : GraphID #%(T_46_META_WS_A_SCRIPT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HasScript\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_6002_R_D)\r
variable ExistScript : Bool = 6002 { #%(T_46_META_WS_HASSCRIPT)\r
    @optional\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    ScriptID : GraphID #%(T_46_META_WS_A_SCRIPT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPickupStatus\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DisablePickupItem = 3216 { #%(T_46_META_WS_SETPICKUPSTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Disable : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetDropStatus\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DisableDropItem = 3217 { #%(T_46_META_WS_SETDROPSTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Disable : Bool #%(T_46_META_WS_A_DISABLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateFaction\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action CreateFaction = 3301 { #%(T_46_META_WS_CREATEFACTION)\r
    out EntityVarName : Faction #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=JoinFaction\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action JoinFaction = 3302 { #%(T_46_META_WS_JOINFACTION)\r
    Entity : Entity #%(T_46_META_WS_A_TARGET)\r
    FactionEntity : Faction #%(T_46_META_WS_A_FACTION)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetAttackableFactions\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3303_R_D)\r
variable GetAttackableFactions : ListT_Faction = 3303 { #%(T_46_META_WS_GETATTACKABLEFACTIONS)\r
    FactionEntity : Faction #%(T_46_META_WS_A_ATTACKER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetAttackableFaction\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetAttackableFaction = 3304 { #%(T_46_META_WS_SETATTACKABLEFACTION)\r
    FactionSelf : Faction #%(T_46_META_WS_A_ATTACKER)\r
    FactionTarget : Faction #%(T_46_META_WS_A_TARGET)\r
    Attackable : Bool #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetAttackablePlayer_Deprecated\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetAttackablePlayer = 3305 { #%(T_37_WZY_WS_SETPLAHOST_NAME)\r
    PlayerSelf : Player #%(T_46_META_WS_A_ATTACKER)\r
    PlayerTarget : Player #%(T_46_META_WS_A_TARGET)\r
    Option : AttackableOption #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAttackableTeam\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetAttackableTeam = 3306 { #%(T_46_META_WS_SETATTACKABLETEAM)\r
    TeamSelf : Team #%(T_46_META_WS_A_ATTACKER)\r
    TeamTarget : Team #%(T_46_META_WS_A_TARGET)\r
    Option : Bool #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetAttackablePlayer_Deprecated\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3307_R_D)\r
variable GetAttackablePlayer : ListT_Player = 3307 { #%(T_37_WZY_WS_GETHOSTPLA_NAME)\r
    PlayerSelf : Player #%(T_46_META_WS_A_ATTACKER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=QuitFaction\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action QuitFaction = 3308 { #%(T_46_META_WS_QUITFACTION)\r
    Entity : Entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetFaction\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3309_R_D)\r
variable GetFaction : Faction = 3309 { #%(T_46_META_WS_GETFACTION)\r
    Entity : Entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=IsAttackAble\r
@ModuleID=25\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3310_R_D)\r
variable IsActualAttackAble : Bool = 3310 { #%(T_46_META_WS_ISATTACKABLE)\r
    Attacker : Entity #%(T_46_META_WS_A_ATTACKER)\r
    Attackee : Entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAttackableEntity\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action SetActualAttackAbleEntity = 3311 { #%(T_46_META_WS_SETATTACKABLEENTITY)\r
    EntitySelf : Entity #%(T_46_META_WS_A_ATTACKER)\r
    EntityTarget : Entity #%(T_46_META_WS_A_TARGET)\r
    Option : AttackableOption #%(T_46_META_WS_A_ATTACKABLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAttackableEntity\r
@ModuleID=26\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3312_R_D)\r
variable GetActualAttackAbleEntity : ListT_Entity = 3312 { #%(T_46_META_WS_GETATTACKABLEENTITY)\r
    EntitySelf : Entity #%(T_46_META_WS_A_ATTACKER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MorphToByItemID\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action MorphTargetLevelObjectByItemID = 3033 { #%(T_46_META_WS_MORPHTOBYITEMID)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    MorphableItemID : MorphableObject #%(T_46_META_WS_A_TARGET)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Destroy\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action RemoveEntity = 10022 { #%(T_46_META_WS_DESTROY)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddTag\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action AddTag = 10023 { #%(T_46_META_WS_ADDTAG)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CustomTag : String #%(T_46_META_WS_A_CUSTOMTAG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveTag\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action RemoveTag = 10024 { #%(T_46_META_WS_DELETETAG)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CustomTag : String #%(T_46_META_WS_A_CUSTOMTAG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HasTag\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10025_R_D)\r
variable HasTag : Bool = 10025 { #%(T_46_META_WS_HASTAG)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CustomTag : String #%(T_46_META_WS_A_CUSTOMTAG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMorph\r
@ModuleID=22\r
@ModuleLib=Morph\r
@ApiTarget=2\r
action CopyMorphObjectBySelf = 3034 { #%(T_46_META_WS_CREATEMORPH)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    out EntityVarName : MorphObject #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFootballPosition\r
@ModuleID=10006\r
@ModuleLib=Football\r
@ApiTarget=2\r
action SetFootballPosition = 10026 { #%(T_46_META_WS_SETFOOTBALLPOSITION)\r
    Football : Football #%(T_46_META_WS_A_FOOTBALL)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    KeepVelocity : Bool #%(T_46_META_WS_A_KEEPVELOCITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateShop\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action CreateShop = 3035 { #%(T_46_META_WS_CREATESHOP)\r
    out EntityVarName : Shop #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateShopShelf\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action CreateShopShelf = 3036 { #%(T_46_META_WS_CREATESHOPSHELF)\r
    out EntityVarName : ShopShelf #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateShopItem\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action CreateShopItem = 3037 { #%(T_46_META_WS_CREATESHOPITEM)\r
    out EntityVarName : ShopItem #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddItemToShopItem\r
@ModuleID=19\r
@ModuleLib=Economy\r
@ApiTarget=2\r
action AddItemToShopItem = 3038 { #%(T_46_META_WS_ADDITEMTOSHOPITEM)\r
    ShopItem : ShopItem #%(T_46_META_WS_A_SHOPITEM)\r
    ItemGoodsID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
    ItemCnt : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@Return = %(T_48_META_API_10027_R_D)\r
variable GetCurrentCamera : CameraConfig = 10027 { #%(T_46_META_WS_GETCURRENTCAMERA)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action SwitchCamera = 10028 { #%(T_46_META_WS_SWITCHCAMERA)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
    CameraTransitionType : CameraTransitionType #%(T_46_META_WS_A_TRANSITIONTYPE)\r
    TransitionTime : Float #%(T_46_META_WS_A_TRANSITIONTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action CreateCamera = 10029 { #%(T_46_META_WS_CREATECAMERA)\r
    CameraType : CameraType #%(T_46_META_WS_A_TYPE)\r
    out EntityVarName : CameraConfig #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=Eliminate\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@ApiTarget=2\r
action KillFightingEntity = 10030 { #%(T_46_META_WS_ELIMINATE)\r
    TargetEntity : FightingEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearBackpack\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action ClearInventory = 3219 { #%(T_46_META_WS_CLEARBACKPACK)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetActive\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action SetActive = 10031 { #%(T_46_META_WS_SETACTIVE)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    Active : Bool #%(T_46_META_WS_A_ACTIVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCameraFollow\r
@ModuleID=10007\r
@ModuleLib=Camera\r
action SetFollowEntity = 10032 { #%(T_46_META_WS_SETCAMERAFOLLOW)\r
    TargetEntity : Entity #%(T_46_META_WS_A_CAMERA)\r
    FollowEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCameraFocus\r
@ModuleID=10007\r
@ModuleLib=Camera\r
action SetWatchEntity = 10033 { #%(T_46_META_WS_SETCAMERAFOCUS)\r
    TargetEntity : Entity #%(T_46_META_WS_A_CAMERA)\r
    WatchEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DyeAtPosition\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingPosition = 10047 { #%(T_46_META_WS_DYEATPOSITION)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetDyedStatus\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10048_R_D)\r
variable GetDyeingState : Int = 10048 { #%(T_46_META_WS_GETDYEDSTATUS)\r
    Origion : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    Dir : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetDyedCount\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10049_R_D)\r
variable GetDyeingCount : Int = 10049 { #%(T_46_META_WS_GETDYEDCOUNT)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DyeAtPlane\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingPlane = 10050 { #%(T_46_META_WS_DYEATPLANE)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    DyeingRange : Float #%(T_46_META_WS_A_RANGE)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
    out ResultValue : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DyeAtArea\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingArea = 10051 { #%(T_46_META_WS_DYEATAREA)\r
    Normal : Vector3 #%(T_46_META_WS_A_NORMAL)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    DyeingRange : Float #%(T_46_META_WS_A_RANGE)\r
    Color : Int #%(T_46_META_WS_A_COLOR)\r
    FixedDyeingRange : Float #%(T_46_META_WS_A_FIXEDRANGE)\r
    RandomRatio : Float #%(T_46_META_WS_A_RANDOMRATIO)\r
    RandomDecay : Float #%(T_46_META_WS_A_RANDOMDECAY)\r
    out ResultValue : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetDyeing\r
@ModuleID=32\r
@ModuleLib=Dyeing\r
@ApiTarget=2\r
action DyeingReset = 10058 { #%(T_46_META_WS_RESETDYEING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetForward\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action PlayerSetForward = 3220 { #%(T_46_META_WS_SETFORWARD)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSkills\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerSkills = 3202 { #%(T_46_META_WS_SETSKILLS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    PlayerSkills : ListT_PlayerSkillID #%(T_46_META_WS_A_SKILLS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSkills\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3203_R_D)\r
variable GetPlayerSkills : ListT_PlayerSkillID = 3203 { #%(T_46_META_WS_GETSKILLS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetBuffs\r
@ModuleID=10011\r
@ModuleLib=Buff\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3236_R_D)\r
variable GetInternalBuffs : ListT_InternalBuffType = 3236 { #%(T_46_META_WS_GETBUFFS)\r
    TargetEntity : BuffableEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddBuff\r
@ModuleID=10011\r
@ModuleLib=Buff\r
@ApiTarget=2\r
action AddInternalBuff = 3234 { #%(T_46_META_WS_ADDBUFF)\r
    TargetEntity : BuffableEntity #%(T_46_META_WS_A_TARGET)\r
    BuffID : InternalBuffType #%(T_46_META_WS_A_BUFF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveBuff\r
@ModuleID=10011\r
@ModuleLib=Buff\r
@ApiTarget=2\r
action RemoveInternalBuff = 3235 { #%(T_46_META_WS_REMOVEBUFF)\r
    TargetEntity : BuffableEntity #%(T_46_META_WS_A_TARGET)\r
    BuffID : InternalBuffType #%(T_46_META_WS_A_BUFF)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetConsumables\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action GetPlayerItems = 3237 { #%(T_46_META_WS_GETCONSUMABLES)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    out ItemList : ListT_ItemGoodsIDType #%(T_46_META_WS_A_RESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddAttachments\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action AddAttachmentsToPlayer = 3238 { #%(T_46_META_WS_ADDATTACHMENTS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    WeaponEquipSlot : SwitchWeaponEquipSlot #%(T_46_META_WS_A_SLOT)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
    out Attachment : Entity #%(T_46_META_WS_A_ATTACHMENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetEquipments\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action GetPlayerEquipments = 3239 { #%(T_46_META_WS_GETEQUIPMENTS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Slot : EquipmentSlot #%(T_46_META_WS_A_SLOT)\r
    out EquipEntity : Entity #%(T_46_META_WS_A_EQUIPMENTS)\r
    out AttachmentList : ListT_Attachment #%(T_46_META_WS_A_ATTACHMENTS)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=AddGameEventLog_Deprecated\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=2\r
action CustomMatchEventLog = 15 { #%(T_44_YU_WS_ADDGAMEEVENTLOGMAP)\r
    Keys : List #%(T_46_META_WS_A_KEYS)\r
    Values : List #%(T_46_META_WS_A_VALUES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddGameEventLog\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=2\r
action AddGameEventLogMap = 3257 { #%(T_46_META_WS_ADDGAMEEVENTLOG)\r
    Dictionary : Map #%(T_46_META_WS_A_LOG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSV\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4000_R_D)\r
variable ReadCSVDataAll : ListT_ListT_Object = 4000 { #%(T_46_META_WS_READCSV)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRow\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4001_R_D)\r
variable ReadCSVDataRow : ListT_Object = 4001 { #%(T_46_META_WS_READCSVROW)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVColumn\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4002_R_D)\r
variable ReadCSVDataCol : ListT_Object = 4002 { #%(T_46_META_WS_READCSVCOLUMN)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCell\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4003_R_D)\r
variable ReadCSVDataCell : Object = 4003 { #%(T_46_META_WS_READCSVCELL)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCellByName\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4004_R_D)\r
variable ReadCSVDataCellByRowAndColName : Object = 4004 { #%(T_46_META_WS_READCSVCELLBYNAME)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
    ColName : String #%(T_46_META_WS_A_COLUMNNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVFromServer\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4005_R_D)\r
variable ReadCSVDataAllOverMode : ListT_ListT_Object = 4005 { #%(T_46_META_WS_READCSVFROMSERVER)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRowFromServer\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4006_R_D)\r
variable ReadCSVDataRowOverMode : ListT_Object = 4006 { #%(T_46_META_WS_READCSVROWFROMSERVER)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVColumnFromServer\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4007_R_D)\r
variable ReadCSVDataColOverMode : ListT_Object = 4007 { #%(T_46_META_WS_READCSVCOLUMNFROMSERVER)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCellFromServer\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
@Return = %(T_48_META_API_4008_R_D)\r
variable ReadCSVDataCellOverMode : Object = 4008 { #%(T_46_META_WS_READCSVCELLFROMSERVER)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
    Col : Int #%(T_46_META_WS_A_COLUMN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRowByKey\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4009_R_D)\r
variable ReadCSVDataRowByKey : ListT_Object = 4009 { #%(T_46_META_WS_READCSVROWBYKEY)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
    Col : Int #%(T_46_META_WS_A_KEYCOLUMN)\r
    TargetValue : Object #%(T_46_META_WS_A_KEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CSVColumnNameToInt\r
@ModuleID=10019\r
@ModuleLib=CSVData\r
@ApiTarget=0\r
@Return = %(T_48_META_API_4010_R_D)\r
variable ReadCSVDataColIntByName : Int = 4010 { #%(T_46_META_WS_CSVCOLUMNNAMETOINT)\r
    UUIDCSV : CsvID #%(T_46_META_WS_A_SHEETNAME)\r
    ColName : String #%(T_46_META_WS_A_COLUMNNAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=AddUserEventLog_Deprecated\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
action CustomUserEventLog = 16 { #%(T_44_YU_WS_ADDUSEREVENTLOGMAP)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    Keys : List #%(T_46_META_WS_A_KEYS)\r
    Values : List #%(T_46_META_WS_A_VALUES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddUserEventLog\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=2\r
action AddUserEventLogMap = 3258 { #%(T_46_META_WS_ADDUSEREVENTLOG)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Dictionary : Map #%(T_46_META_WS_A_LOG)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateTween_Deprecated\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
action CreateTween = 10034 { #%(T_39_WZY_WS_CRETWEEN_NAME)\r
    TargetEntity : Entity #%(T_34_M_WS_ENTITY)\r
    PropID : Property #%(T_34_M_WS_ATT)\r
    SrcVal : Object #%(T_34_WZ_WS_LOGIC6_PARAM2_NAME)\r
    DestVal : Object #%(T_39_WZY_WS_TARGETVAL)\r
    Style : TweenStyle #%(T_39_WZY_WS_TWEENSTYLE)\r
    Curve : TweenCurve #%(T_39_WZY_WS_CURVE)\r
    Duration : Float #%(TXT_OB7_ZJS_HISTORY_TIME)\r
    out EntityVarName : Tween #%(T_39_WZY_WS_TWEENENT)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreateSelfRelative = 31 { #%(T_46_META_WS_CREATESELFRELATIVE)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    PropID : Property #%(T_46_META_WS_A_PROPERTY)\r
    Delta : Object #%(T_46_META_WS_A_DELTA)\r
    ControlPoints : BezierCurve #%(T_46_META_WS_A_CURVE)\r
    Style : TweenStyle #%(T_46_META_WS_A_STYLE)\r
    Duration : Float #%(T_46_META_WS_P_PHASEDURATION)\r
    out EntityVarName : PlayableSelfRelative #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateFrameSelfRelative\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreateSelfRelativeFrame = 50 { #%(T_46_META_WS_CREATEFRAMESELFRELATIVE)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    PropID : Property #%(T_46_META_WS_A_PROPERTY)\r
    Delta : Object #%(T_46_META_WS_A_DELTA)\r
    IsSwitch : Bool #%(T_46_META_WS_A_TYPE)\r
    out EntityVarName : PlayableRelativeFrame #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateTween\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreateTweenV2 = 29 { #%(T_46_META_WS_CREATETWEEN)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    PropID : Property #%(T_46_META_WS_A_PROPERTY)\r
    SrcVal : Object #%(T_46_META_WS_A_SRCVAL)\r
    DestVal : Object #%(T_46_META_WS_A_DESTVAL)\r
    Style : TweenStyle #%(T_46_META_WS_A_STYLE)\r
    ControlPoints : BezierCurve #%(T_46_META_WS_A_CURVE)\r
    Duration : Float #%(T_46_META_WS_P_PHASEDURATION)\r
    out EntityVarName : Tween #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetWidgetParent\r
@ModuleID=16\r
@ModuleLib=Hud\r
action SetHudWidgetParent = 61 { #%(T_46_META_WS_SETWIDGETPARENT)\r
    Parent : HudWidgetOrCustomHud #%(T_46_META_WS_A_PARENT)\r
    Child : HudWidget #%(T_46_META_WS_A_CHILD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetParent\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SetParent = 10035 { #%(T_46_META_WS_SETPARENT)\r
    Parent : Transform #%(T_46_META_WS_A_PARENT)\r
    Child : Transform #%(T_46_META_WS_A_CHILD)\r
    WorldPositionStays : Bool #%(T_46_META_WS_A_WORLDPOSITIONSTAYS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChildren\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10052_R_D)\r
variable GetChildren : ListT_Entity = 10052 { #%(T_46_META_WS_GETCHILDREN)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChildByIndex\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10053_R_D)\r
variable GetChildByIndex : Entity = 10053 { #%(T_46_META_WS_GETCHILDBYINDEX)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetChildByName\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_83_R_D)\r
variable GetChildByName : Entity = 83 { #%(T_46_META_WS_GETCHILDBYNAME)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
    EntityName : String #%(T_46_META_WS_A_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetParent\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_10054_R_D)\r
variable GetParent : Entity = 10054 { #%(T_46_META_WS_GETPARENT)\r
    Child : Entity #%(T_46_META_WS_A_CHILD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearAllChildren\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ClearAllChildren = 10055 { #%(T_46_META_WS_CLEARALLCHILDREN)\r
    Parent : Entity #%(T_46_META_WS_A_PARENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GiveJailBreakReward\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action GiveJailBreakReward = 3039 { #%(T_46_META_WS_GIVEJAILBREAKREWARD)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
    RealCoin : Bool #%(T_46_META_WS_A_REALCOIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UpdateJailBreakMission\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action UpdateJailBreakMission = 3040 { #%(T_46_META_WS_UPDATEJAILBREAKMISSION)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    MissionID : Int #%(T_46_META_WS_A_MISSIONID)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitJailBreakMiniGame\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action QuitJailBreakMiniGame = 3042 { #%(T_46_META_WS_QUITJAILBREAKMINIGAME)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    GameID : Int #%(T_46_META_WS_A_GAMEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GiveJailBreakItem\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
action GiveJailBreakItem = 3043 { #%(T_46_META_WS_GIVEJAILBREAKITEM)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemType : Int #%(T_46_META_WS_A_ITEMTYPE)\r
    ItemID : Int #%(T_46_META_WS_A_ITEMID)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadFromDatabase_Deprecate\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetValue = 5000 { #%(T_40_XXJ_WS_DB)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
    AccountId : UUID #%(T_40_XXJ_WS_UUID_NAMEKEY)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
    out Result : Object #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteToDatabase_Deprecate\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBSheetValue = 5001 { #%(T_40_XXJ_WS_DBWRITE)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
    AccountId : UUID #%(T_40_XXJ_WS_UUID_NAMEKEY)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
    Value : Object #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DeleteFromDatabase_Deprecate\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBSheetValue = 5002 { #%(T_46_META_WS_DELETEFROMDATABASE)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadLeadboardFromDatabase_Deprecate\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValue = 5003 { #%(T_40_XXJ_WS_READLEADERBOARD)\r
    LeaderboardName : String #%(T_40_XXJ_WS_LEADERBOARDNAME)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
    out Result : List #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteLeadboardToDatabase_Deprecate\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardValue = 5004 { #%(T_40_XXJ_WS_WRITELEADERBOARD)\r
    LeaderboardName : String #%(T_40_XXJ_WS_LEADERBOARDNAME)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
    Value : Int #%(T_40_XXJ_WS_VALUE_NAMEKEY)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DeleteFromLeadboardDatabaseByKey_Deprecate\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByKey = 5005 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYKEY)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DeleteFromLeadboardDatabaseByRank_Deprecate\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByOrder = 5006 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATABASEBYRANK)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Order : Int #%(T_46_META_WS_A_RANK)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadLeadboardFromDatabaseByRank_Deprecate\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValuesByRange = 5007 { #%(T_40_XXJ_WS_READLEADERBOARD2)\r
    LeaderboardName : String #%(T_40_XXJ_WS_LEADERBOARDNAME)\r
    StartIndex : Int #%(T_40_XXJ_WS_ORDER1)\r
    EndIndex : Int #%(T_40_XXJ_WS_ORDER2)\r
    out Result : List #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ReadAccumulatedValueFromDatabase_Deprecate\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBAccumulatedData = 5008 { #%(T_41_XXJ_WS_READDBACCUMULATEDDATA)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
    out Result : Int #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteAccumulatedValueToDatabase_Deprecate\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBAccumulatedDataOffset = 5009 { #%(T_41_XXJ_WS_WRITEDBACCUMULATEDDATAOFFSET)\r
    SheetName : String #%(T_40_XXJ_WS_DBTABLENAME)\r
    Key : String #%(T_40_XXJ_WS_DBKEY_NAMEKEY)\r
    ArithmeticType : Int #%(T_36_WZY_WS_OPERMETHOD_NAME)\r
    Offset : Int #%(T_41_XXJ_WS_OFFSET)\r
    WorkshopCode : String #%(T_42_XXJ_WS_WORKSHOPCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetProductCount\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=2\r
action GetProductCount = 173 { #%(T_53_META_API_173)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
    out Count : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ConsumeProduct\r
@Async\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=2\r
action ConsumeProduct = 175 { #%(T_53_META_API_175)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
    out ConsumeStatus : ConsumeStatus #%(T_53_META_API_175_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CheckProductStatus\r
@Async\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=2\r
action CheckProductStatus = 219 { #%(T_55_META_API_219)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
    out ProductStatus : ProductStatus #%(T_55_META_API_219_P1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=NewTweenCurve_Deprecated\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
@Return = %(T_48_META_API_10036_R_D)\r
variable NewTweenCurve : TweenCurve = 10036 { #%(T_39_WZY_WS_TWEENCURVE_NAME)\r
    ControlPoints : ListT_Float #%(T_36_WZY_WS_FLOATLIST)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCurve\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Return = %(T_48_META_API_48_R_D)\r
variable NewTweenCurveV2 : BezierCurve = 48 { #%(T_46_META_WS_CREATECURVE)\r
    ControlPoints : ListT_Float #%(T_46_META_WS_A_CURVE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Play\r
@ModuleID=29\r
@ModuleLib=Playable\r
action PlayPlayable = 10037 { #%(T_46_META_WS_PLAY)\r
    PlayableEntities : PlayableOrListPlayable #%(T_46_META_WS_A_TARGET)\r
    Reset : Bool #%(T_46_META_WS_A_RESET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Reset\r
@ModuleID=29\r
@ModuleLib=Playable\r
action ResetPlayable = 51 { #%(T_46_META_WS_RESET)\r
    PlayableEntities : PlayableOrListPlayable #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Pause\r
@ModuleID=29\r
@ModuleLib=Playable\r
action PausePlayable = 10038 { #%(T_46_META_WS_PAUSE)\r
    PlayableEntities : PlayableOrListPlayable #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateTrajectory\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreatePlayableTrajectory = 10039 { #%(T_46_META_WS_CREATETRAJECTORY)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    InitialVelocity : Vector3 #%(T_46_META_WS_A_INITIALVELOCITY)\r
    Acceleration : Vector3 #%(T_46_META_WS_A_ACCELERATION)\r
    MaxDisplacement : Float #%(T_46_META_WS_A_MAXDISPLACEMENT)\r
    out EntityVarName : PlayableTrajectory #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateFollow\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreatePlayablePosFollow = 10040 { #%(T_46_META_WS_CREATEFOLLOW)\r
    HostEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    TargetEntity : Entity #%(T_46_META_WS_A_FOLLOWTARGET)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
    out EntityVarName : PlayablePosFollow #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateLookAt\r
@ModuleID=29\r
@ModuleLib=Playable\r
action CreatePlayableLookAt = 10041 { #%(T_46_META_WS_CREATELOOKAT)\r
    HostEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    TargetEntity : Entity #%(T_46_META_WS_A_LOOKATTARGET)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
    CoordinateType : CoordinateType #%(T_46_META_WS_A_COORDINATESYSTEM)\r
    out EntityVarName : PlayableLookAt #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetMatchResult_Deprecate\r
@ModuleID=15\r
@ModuleLib=GameResult\r
@ApiTarget=2\r
action SetMatchResult = 10042 { #%(T_39_WZY_WS_LOADRESULT_NAME)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    Result : MatchResultType #%(T_34_M_WS_RESULTS)\r
    Rank : Int #%(TXT_PLAYER_RANK)\r
    ScoreName : ListT_String #%(T_39_WZY_WS_SCORENAME)\r
    ScoreValue : ListT_String #%(T_34_WT_WS_ENTITY20_PARAM3)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=QuitGame\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action KickOutPlayer = 10060 { #%(T_46_META_WS_QUITGAME)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    IsShowMatchResult : Bool #%(T_46_META_WS_A_SHOWMATCHRESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPropertySmoothly\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SetReplicationDataSmoothly = 10043 { #%(T_46_META_WS_SETPROPERTYSMOOTHLY)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    PropertyIndex : Property #%(T_46_META_WS_A_PROPERTY)\r
    PropertyValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomUIWidget\r
@ModuleID=16\r
@ModuleLib=Hud\r
action CreateCustomHudWidget = 9016 { #%(T_46_META_WS_CREATECUSTOMUIWIDGET)\r
    out EntityVarName : HudWidget #%(T_46_META_WS_A_CREATEDENTITY)\r
    WidgetType : HudWidgetType #%(T_46_META_WS_A_WIDGETTYPE)\r
    HudEntity : CustomHud #%(T_46_META_WS_A_UI)\r
    @optional\r
    ParentWidget : HudWidget #%(T_46_META_WS_A_PARENTWIDGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SingleRaycast\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SingleRaycast = 10044 { #%(T_46_META_WS_SINGLERAYCAST)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntity : Entity #%(T_52_META_API_174_P8)\r
    out HitPosition : Vector3 #%(T_52_META_API_174_P9)\r
    out HitDistance : Float #%(T_52_META_API_174_P10)\r
    out HitNormal : Vector3 #%(T_52_META_API_174_P11)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MultiRaycast\r
@ModuleID=33\r
@ModuleLib=Physics\r
action MultiRaycast = 10045 { #%(T_46_META_WS_MULTIRAYCAST)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntities : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
    out HitPoints : ListT_Vector3 #%(T_46_META_WS_A_HITPOINTS)\r
    out HitDistances : ListT_Float #%(T_46_META_WS_A_HITDISTANCES)\r
    out HitNormals : ListT_Vector3 #%(T_46_META_WS_A_HITNORMALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BoxCast\r
@ModuleID=33\r
@ModuleLib=Physics\r
action BoxCast = 17 { #%(T_46_META_WS_BOXCAST)\r
    HalfExtents : Vector3 #%(T_46_META_WS_A_HALFEXTENTS)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SphereCast\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SphereCast = 18 { #%(T_46_META_WS_SPHERECAST)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CapsuleCast\r
@ModuleID=33\r
@ModuleLib=Physics\r
action CapsuleCast = 19 { #%(T_46_META_WS_CAPSULECAST)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BoxOverlap\r
@ModuleID=33\r
@ModuleLib=Physics\r
action BoxOverlap = 20 { #%(T_46_META_WS_BOXOVERLAP)\r
    HalfExtents : Vector3 #%(T_46_META_WS_A_HALFEXTENTS)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SphereOverlap\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SphereOverlap = 21 { #%(T_46_META_WS_SPHEREOVERLAP)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CapsuleOverlap\r
@ModuleID=33\r
@ModuleLib=Physics\r
action CapsuleOverlap = 22 { #%(T_46_META_WS_CAPSULEOVERLAP)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
    Position : Vector3 #%(T_46_META_WS_A_CENTER)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntitysName : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddForce\r
@ModuleID=33\r
@ModuleLib=Physics\r
action AddForce = 24 { #%(T_46_META_WS_ADDFORCE)\r
    PhysicalObject : PhysicalObject #%(T_46_META_WS_A_TARGET)\r
    Force : Vector3 #%(T_46_META_WS_A_FORCE)\r
    ForceMode : ForceType #%(T_46_META_WS_A_FORCEMODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddForceAtPosition\r
@ModuleID=33\r
@ModuleLib=Physics\r
action AddForceAtPosition = 25 { #%(T_46_META_WS_ADDFORCEATPOSITION)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
    Force : Vector3 #%(T_46_META_WS_A_FORCE)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    ForceMode : ForceType #%(T_46_META_WS_A_FORCEMODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddTorque\r
@ModuleID=33\r
@ModuleLib=Physics\r
action AddTorque = 26 { #%(T_46_META_WS_ADDTORQUE)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
    Torque : Vector3 #%(T_46_META_WS_A_TORQUE)\r
    ForceMode : ForceType #%(T_46_META_WS_A_FORCEMODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MoveCCT\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=0\r
action CCTMoveV2 = 89 { #%(T_44_XXJ_WS_CCTMOVE)\r
    Target : PhysicalCCT #%(T_44_XXJ_WS_TARGET)\r
    Movement : Vector3 #%(T_44_XXJ_WS_MOVEMENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=MoveCCT_Deprecated\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=2\r
action CCTMove = 62 { #%(T_46_META_WS_MOVECCT)\r
    Target : PhysicalCCT #%(T_46_META_WS_A_TARGET)\r
    Movement : Vector3 #%(T_46_META_WS_A_DISPLACEMENT)\r
    out IsTopColliding : Bool #%(T_46_META_WS_A_ISTOPCOLLIDING)\r
    out IsSideColliding : Bool #%(T_46_META_WS_A_ISSIDECOLLIDING)\r
    out IsBottomColliding : Bool #%(T_46_META_WS_A_ISBOTTOMCOLLIDING)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TeleportCCT\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=0\r
action CCTTeleport = 82 { #%(T_46_META_WS_TELEPORTCCT)\r
    Target : PhysicalCCT #%(T_46_META_WS_A_TARGET)\r
    TargetPosition : Vector3 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCCTForward\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=0\r
action SetCCTForward = 180 { #%(T_54_META_API_180)\r
    Target : PhysicalCCT #%(T_46_META_WS_A_TARGET)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MovePosition\r
@ModuleID=33\r
@ModuleLib=Physics\r
action MovePosition = 27 { #%(T_46_META_WS_MOVEPOSITION)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MoveRotation\r
@ModuleID=33\r
@ModuleLib=Physics\r
action MoveRotation = 28 { #%(T_46_META_WS_MOVEROTATION)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
    Rotation : Quaternion #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Sleep\r
@ModuleID=33\r
@ModuleLib=Physics\r
action Sleep = 36 { #%(T_46_META_WS_SLEEP)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Wakeup\r
@ModuleID=33\r
@ModuleLib=Physics\r
action Wakeup = 37 { #%(T_46_META_WS_WAKEUP)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=IsSleeping\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_38_R_D)\r
variable IsSleeping : Bool = 38 { #%(T_46_META_WS_ISSLEEPING)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetSleepThreshold\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SetSleepThreshold = 39 { #%(T_46_META_WS_SETSLEEPTHRESHOLD)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
    Threshold : Float #%(T_46_META_WS_A_THRESHOLD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSleepThreshold\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_40_R_D)\r
variable GetSleepThreshold : Float = 40 { #%(T_46_META_WS_GETSLEEPTHRESHOLD)\r
    RigidbodyObject : Rigidbody #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetGlobalSleepThreshold\r
@ModuleID=33\r
@ModuleLib=Physics\r
action SetGlobalSleepThreshold = 41 { #%(T_46_META_WS_SETGLOBALSLEEPTHRESHOLD)\r
    Threshold : Float #%(T_46_META_WS_A_THRESHOLD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetGlobalSleepThreshold\r
@ModuleID=33\r
@ModuleLib=Physics\r
@Return = %(T_48_META_API_42_R_D)\r
variable GetGlobalSleepThreshold : Float = 42 { #%(T_46_META_WS_GETGLOBALSLEEPTHRESHOLD)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=SetPlayerBonesScale_Deprecated\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerBonesScale = 3221 { #%(T_40_XXJ_WS_BONESCALE_NAMEKEY)\r
    Player : Player #%(T_34_WT_WS_ENTITY7_PARAM1)\r
    PlayerBonesType : PlayerBonesType #%(T_40_XXJ_WS_SKELETON)\r
    Scale : Vector3 #%(T_40_XXJ_WS_SCALE_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateFromPrefab\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CreateEntityFromPrefab = 10046 { #%(T_46_META_WS_CREATEFROMPREFAB)\r
    out EntityVarName : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
    TargetPrefabID : PrefabID #%(T_46_META_WS_A_PREFAB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=InstantiatePrefab\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action InstantiatePrefab = 96 { #%(T_48_META_API_96)\r
    out EntityVarName : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
    TargetPrefabID : PrefabID #%(T_46_META_WS_A_PREFAB)\r
    Async : Bool #%(T_48_META_API_96_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMonster\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action CreateZombie = 76 { #%(T_46_META_WS_CREATEMONSTER)\r
    out Zombie : AI #%(T_46_META_WS_A_TARGET)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    AIType : AIType #%(T_46_META_WS_A_TYPE)\r
    TeamIndex : Int #%(T_46_META_WS_A_TEAMSEQ)\r
    ChaseEnemy : Bool #%(T_46_META_WS_A_CHASEENEMY)\r
    ActionType : ActionType #%(T_46_META_WS_A_ACTIONTYPE)\r
    Path : CustomPath #%(T_46_META_WS_A_PATH)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetPlayerCanQuitMidway\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetPlayerCanFreeQuit = 90 { #%(T_47_XXJ_WS_SETPLAYERCANQUITMIDWAY)\r
    PlayerEntity : Player #%(T_46_META_WS_A_TARGET)\r
    CanFreeQuit : Bool #%(T_48_META_API_90_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HitFly\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action HitFlyPlayer = 3222 { #%(T_46_META_WS_HITFLY)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Dir : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    FlyTime : Float #%(T_46_META_WS_A_DURATION)\r
    VelocityY : Float #%(T_46_META_WS_A_VELOCITYY)\r
    VelcityXZ : Float #%(T_46_META_WS_A_VELOCITYXZ)\r
    ChangeFwd : Bool #%(T_46_META_WS_A_CHANGEROTATION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetOutfit\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3223_R_D)\r
variable GetPlayerClothIDByWardrobeType : ClothID = 3223 { #%(T_46_META_WS_GETOUTFIT)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    WardrobeType : WardrobeType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetOutfit\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetPlayerClothID = 3224 { #%(T_46_META_WS_SETOUTFIT)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    ClothID : ClothID #%(T_46_META_WS_A_OUTFIT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetOutfit\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ReSetPlayerClothes = 3225 { #%(T_46_META_WS_RESETOUTFIT)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetWeaponSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3228_R_D)\r
variable GetPlayerWeaponSkinIDByWeaponID : WeaponSkinID = 3228 { #%(T_46_META_WS_GETWEAPONSKIN)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    WeaponID : ItemGoodsIDType #%(T_46_META_WS_A_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetWeaponSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetPlayerWeaponSkinID = 3229 { #%(T_46_META_WS_SETWEAPONSKIN)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    WeaponSkinID : WeaponSkinID #%(T_46_META_WS_A_WEAPONSKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetWeaponSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ReSetPlayerWeaponSkinByWeaponID = 3230 { #%(T_46_META_WS_RESETWEAPONSKIN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    WeaponID : ItemGoodsIDType #%(T_46_META_WS_A_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBundle\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetPlayerClothIDs = 3231 { #%(T_46_META_WS_SETBUNDLE)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Clothes : ListT_ClothID #%(T_46_META_WS_A_OUTFITS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveOutfit\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemovePlayerClothIDByWardrobeType = 3232 { #%(T_46_META_WS_REMOVEOUTFIT)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    WardrobeType : WardrobeType #%(T_46_META_WS_A_TYPE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveWeaponSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemovePlayerWeaponSkinByWeaponID = 3233 { #%(T_46_META_WS_REMOVEWEAPONSKIN)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    WeaponID : ItemGoodsIDType #%(T_46_META_WS_A_WEAPON)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Max\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1536_R_D)\r
variable Max : Number = 1536 { #%(T_46_META_WS_MAX)\r
    Value1 : Number #%(T_46_META_WS_A_VALUEA)\r
    Value2 : Number #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Max\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListFindMax = 1537 { #%(T_46_META_WS_MAX)\r
    Value : List #%(T_46_META_WS_A_TARGET)\r
    out Result : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
    out ResultValue : Number #%(T_46_META_WS_A_RESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Min\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1538_R_D)\r
variable Min : Number = 1538 { #%(T_46_META_WS_MIN)\r
    Value1 : Number #%(T_46_META_WS_A_VALUEA)\r
    Value2 : Number #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Min\r
@ModuleID=10001\r
@ModuleLib=List\r
action ListFindMin = 1539 { #%(T_46_META_WS_MIN)\r
    Value : List #%(T_46_META_WS_A_TARGET)\r
    out Result : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
    out ResultValue : Number #%(T_46_META_WS_A_RESULT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Lerp\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1540_R_D)\r
variable Lerp : Float = 1540 { #%(T_46_META_WS_LERP)\r
    ValueA : Float #%(T_46_META_WS_A_VALUEA)\r
    ValueB : Float #%(T_46_META_WS_A_VALUEB)\r
    ValueT : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Clamp\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1541_R_D)\r
variable Clamp : Number = 1541 { #%(T_46_META_WS_CLAMP)\r
    Value : Number #%(T_46_META_WS_A_VALUE)\r
    Min : Number #%(T_46_META_WS_A_MIN)\r
    Max : Number #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuaternionToEulerAngle\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_43_R_D)\r
variable QuaternionToEulerAngle : Vector3 = 43 { #Math/%(T_46_META_WS_QUATERNIONTOEULERANGLE)\r
    Value : Quaternion #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EulerAngleToQuaternion\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_44_R_D)\r
variable EulerAngleToQuaternion : Quaternion = 44 { #Math/%(T_46_META_WS_EULERANGLETOQUATERNION)\r
    Value : Vector3 #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AxisAngleToQuaternion\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_45_R_D)\r
variable AxisAngleToQuaternion : Quaternion = 45 { #Math/%(T_46_META_WS_AXISANGLETOQUATERNION)\r
    Axis : Vector3 #%(T_46_META_WS_A_AXIS)\r
    Angle : Float #%(T_46_META_WS_A_ANGLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuaternionToAxisAngle\r
@ModuleID=10003\r
@ModuleLib=Math\r
action QuaternionToAxisAngle = 46 { #Math/%(T_46_META_WS_QUATERNIONTOAXISANGLE)\r
    Value : Quaternion #%(T_46_META_WS_A_VALUE)\r
    out Axis : Vector3 #%(T_46_META_WS_A_AXIS)\r
    out Angle : Float #%(T_46_META_WS_A_ANGLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MultiplyQuaternion\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_52_R_D)\r
variable MultiplyQuaternion : Quaternion = 52 { #Math/%(T_46_META_WS_MULTIPLYQUATERNION)\r
    Left : Quaternion #%(T_46_META_WS_A_VALUEA)\r
    Right : Quaternion #%(T_46_META_WS_A_VALUEB)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LookRotation\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_53_R_D)\r
variable LookRotation : Quaternion = 53 { #Math/%(T_46_META_WS_LOOKROTATION)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
    Upward : Vector3 #%(T_46_META_WS_A_UPWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SlerpQuaternion\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_54_R_D)\r
variable SlerpQuaternion : Quaternion = 54 { #Math/%(T_46_META_WS_SLERPQUATERNION)\r
    A : Quaternion #%(T_46_META_WS_A_VALUEA)\r
    B : Quaternion #%(T_46_META_WS_A_VALUEB)\r
    Ratio : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LerpVector3\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_54_R_D)\r
variable LerpVector3 : Vector3 = 108 { #Math/%(T_49_META_API_108)\r
    A : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    B : Vector3 #%(T_46_META_WS_A_VALUEB)\r
    Ratio : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SlerpVector3\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_54_R_D)\r
variable SlerpVector3 : Vector3 = 111 { #Math/%(T_49_META_API_111)\r
    A : Vector3 #%(T_46_META_WS_A_VALUEA)\r
    B : Vector3 #%(T_46_META_WS_A_VALUEB)\r
    Ratio : Float #%(T_46_META_WS_A_VALUET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetColorChannel\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ColorGetChannel = 1542 { #%(T_46_META_WS_GETCOLORCHANNEL)\r
    Value : Color #%(T_46_META_WS_A_COLOR)\r
    out ColorR : Int #%(T_46_META_WS_A_R)\r
    out ColorG : Int #%(T_46_META_WS_A_G)\r
    out ColorB : Int #%(T_46_META_WS_A_B)\r
    out ColorA : Int #%(T_46_META_WS_A_A)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StringToInt\r
@ModuleID=10005\r
@ModuleLib=Convert\r
action String2Int = 1700 { #%(T_46_META_WS_STRINGTOINT)\r
    Value : String #%(T_46_META_WS_A_TARGET)\r
    out IntValue : Int #%(T_46_META_WS_A_RESULT)\r
    out Ok : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=StringToFloat\r
@ModuleID=10005\r
@ModuleLib=Convert\r
action String2Float = 1701 { #%(T_46_META_WS_STRINGTOFLOAT)\r
    Value : String #%(T_46_META_WS_A_TARGET)\r
    out FloatValue : Float #%(T_46_META_WS_A_RESULT)\r
    out Ok : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenTouchRay\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action CameraTouchRay = 63 { #%(T_46_META_WS_SCREENTOUCHRAY)\r
    Position : Vector2 #%(T_46_META_WS_A_TOUCHPOINT)\r
    out WorldPosition : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    out RayDirection : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WorldToScreenPoint\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action WorldToScreenPoint = 68 { #%(T_46_META_WS_WORLDTOSCREENPOINT)\r
    WorldPosition : Vector3 #%(T_46_META_WS_A_WORLDPOSITION)\r
    out InScreen : Bool #%(T_46_META_WS_A_ISMAPPEDINSCREEN)\r
    out InScreenPosition : Vector2 #%(T_46_META_WS_A_MAPPEDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenToWorldPoint\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action ScreenToWorldPoint = 69 { #%(T_46_META_WS_SCREENTOWORLDPOINT)\r
    ScreenPosition : Vector2 #%(T_46_META_WS_A_SCREENPOSITION)\r
    Depth : Float #%(T_46_META_WS_A_DEPTH)\r
    out WorldPosition : Vector3 #%(T_46_META_WS_A_WORLDPOSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenSingleRaycast\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action CameraSingleRaycast = 70 { #%(T_46_META_WS_SCREENSINGLERAYCAST)\r
    StartPosition : Vector2 #%(T_46_META_WS_A_STARTPOSITION)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
    LayerMask : ListT_Int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntity : Entity #%(T_52_META_API_174_P8)\r
    out HitPosition : Vector3 #%(T_52_META_API_174_P9)\r
    out HitDistance : Float #%(T_52_META_API_174_P10)\r
    out HitNormal : Vector3 #%(T_52_META_API_174_P11)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ScreenMultiRaycast\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action CameraMultiRaycast = 71 { #%(T_46_META_WS_SCREENMULTIRAYCAST)\r
    StartPosition : Vector2 #%(T_46_META_WS_A_STARTPOSITION)\r
    Distance : Float #%(T_46_META_WS_A_DISTANCE)\r
    LayerMask : ListT_Int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntities : ListT_Entity #%(T_46_META_WS_A_HITENTITIES)\r
    out HitPoints : ListT_Vector3 #%(T_46_META_WS_A_HITPOINTS)\r
    out HitDistances : ListT_Float #%(T_46_META_WS_A_HITDISTANCES)\r
    out HitNormals : ListT_Vector3 #%(T_46_META_WS_A_HITNORMALS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCullingMask\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action SetCameraCullingMask = 9017 { #%(T_46_META_WS_SETCULLINGMASK)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
    CullingMask : ListT_Int #%(T_46_META_WS_A_CULLINGMASK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCullingMask\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
@Return = %(T_48_META_API_9018_R_D)\r
variable GetCameraCullingMask : ListT_Int = 9018 { #%(T_46_META_WS_GETCULLINGMASK)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCullingMaskLayer\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action AddOrRemoveCameraCullingMask = 9019 { #%(T_46_META_WS_SETCULLINGMASKLAYER)\r
    Camera : CameraConfig #%(T_46_META_WS_A_CAMERA)\r
    VisibilityLayer : Int #%(T_46_META_WS_A_LAYER)\r
    IsInCullingMask : Bool #%(T_46_META_WS_A_VISIBLE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=GetSceneSkybox\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=2\r
@Return = %(T_48_META_API_105_R_D)\r
variable GetSceneSkybox : SkyboxEnv = 105 { #%(T_46_META_WS_GETSCENESKYBOX)\r
    SceneGUID : String #%(T_46_META_WS_A_SCENEID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetDefaultUIStatus\r
@ModuleID=10010\r
@ModuleLib=Player\r
action SetPlayerHubSwitch = 9020 { #%(T_46_META_WS_SETDEFAULTUISTATUS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    PlayerHudSwitchType : PlayerHudSwitchType #%(T_46_META_WS_A_TYPE)\r
    SwitchValue : CommonHudSwitchValue #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetDefaultUIInfo\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action GetDefaultUIPosition = 151 { #%(T_50_META_API_151)\r
    Target : PlayerHudSwitchType #%(T_46_META_WS_A_TARGET)\r
    out Enable : Bool #%(T_46_META_WS_E_ENABLE)\r
    out Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
    out Size : Vector2 #%(T_50_META_API_151_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampToLocalString\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@Return = %(T_48_META_API_9021_R_D)\r
variable CreateTimestampLocString : TimestampLocString = 9021 { #%(T_46_META_WS_TIMESTAMPTO LOCALSTRING)\r
    Timestamp : Int #%(T_46_META_WS_A_TIMESTAMP)\r
    Style : TimestampFormatStyle #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalTimestampMs\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
variable GetLocalTimestampMs : Int64 = 99 { #%(T_49_META_API_99)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetServerTimestampMs\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
variable GetServerTimestampMs : Int64 = 106 { #%(T_49_META_API_106)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=TimestampToLocalStringMs\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
variable TimestampMsToLocalString : TimestampMsLocString = 107 { #%(T_49_META_API_107)\r
    TimestampMs : Int64 #%(T_49_META_API_107_P0)\r
    Style : TimestampFormatStyle #%(T_46_META_WS_A_STYLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMiniMapIcon\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
action CreateMapIconEntity = 9022 { #%(T_46_META_WS_CREATEMINIMAPICON)\r
    out EntityVarName : MiniMapIcon #%(T_46_META_WS_A_CREATEDENTITY)\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
    IconType : IconType #%(T_46_META_WS_A_RESOURCE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateMiniMapPixel\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
action CreateMapBitEntity = 9025 { #%(T_46_META_WS_CREATEMINIMAPPIXEL)\r
    out EntityVarName : MiniMapBit #%(T_46_META_WS_A_CREATEDENTITY)\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
    TargetEntity : Entity #%(T_46_META_WS_A_BOUNDTARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetMiniMap\r
@ModuleID=34\r
@ModuleLib=MiniMap\r
@Return = %(T_48_META_API_9026_R_D)\r
variable GetPlayerMiniMap : MiniMap = 9026 { #%(T_46_META_WS_GETMINIMAP)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=MonsterUseSkill\r
@ModuleID=10008\r
@ModuleLib=AI\r
@ApiTarget=2\r
action AICastSkill = 3504 { #%(T_46_META_WS_MONSTERUSESKILL)\r
    AITarget : AI #%(T_46_META_WS_A_TARGET)\r
    SkillType : AISkillType #%(T_46_META_WS_A_SKILL)\r
    TargetEntity : Player #%(T_46_META_WS_A_SKILLTARGET)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=FindPath\r
@Async\r
@ModuleID=37\r
@ModuleLib=Scene\r
@ApiTarget=2\r
action FindStraightPath = 3505 { #%(T_46_META_WS_FINDPATH)\r
    StartPos : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    TargetPos : Vector3 #%(T_46_META_WS_A_ENDPOSITION)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
    out Path : ListT_Vector3 #%(T_46_META_WS_A_PATHPOINTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBlackboardValue\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@ApiTarget=0\r
action SetBlackBoard = 3506 { #%(T_46_META_WS_SETBLACKBOARDVALUE)\r
    BTree : BehaviourTree #%(T_46_META_WS_A_BTREE)\r
    BBKey : String #%(T_46_META_WS_A_KEY)\r
    BBValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetBlackboardValue\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@ApiTarget=0\r
action GetBlackBoard = 3507 { #%(T_46_META_WS_GETBLACKBOARDVALUE)\r
    BTree : BehaviourTree #%(T_46_META_WS_A_BTREE)\r
    BBKey : String #%(T_46_META_WS_A_KEY)\r
    out BBValue : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetNodeVariable\r
@ModuleID=36\r
@ModuleLib=BehaviourTree\r
@ApiTarget=0\r
action GetBTreeNodeParam = 3508 { #%(T_46_META_WS_GETNODEVARIABLE)\r
    Node : BehaviourTreeNode #%(T_46_META_WS_A_NODE)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Value : Object #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetVehicleSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_3509_R_D)\r
variable GetVehicleSkin : VehicleSkinID = 3509 { #%(T_46_META_WS_GETVEHICLESKIN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    VehicleID : VehicleID #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetVehicleSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetVehicleSkin = 3510 { #%(T_46_META_WS_SETVEHICLESKIN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    VehicleSkinID : VehicleSkinID #%(T_46_META_WS_A_VEHICLESKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveVehicleSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemoveVehicleSkin = 3511 { #%(T_46_META_WS_REMOVEVEHICLESKIN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    VehicleID : VehicleID #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetVehicleSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ResetVehicleSkin = 3512 { #%(T_46_META_WS_RESETVEHICLESKIN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    VehicleID : VehicleID #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EnterVehicle\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=2\r
action GetInTheVehicle = 30 { #%(T_46_META_WS_ENTERVEHICLE)\r
    Player : Player #%(T_46_META_WS_A_PLAYER)\r
    Vehicle : Vehicle #%(T_46_META_WS_A_VEHICLE)\r
    Seat : SeatType #%(T_46_META_WS_A_SEAT)\r
    out IsSuccess : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ProfanityFilter\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_33_R_D)\r
variable DirtyWordFilter : String = 33 { #%(T_46_META_WS_PROFANITYFILTER)\r
    Text : String #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RequestMatchMaking\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action RequestMatchMaking = 10061 { #%(T_46_META_WS_REQUESTMATCHMAKING)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    ShowMessageWhenCancel : Bool #%(T_46_META_WS_A_SHOWMESSAGEWHENCANCEL)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RequestGroupMatchMaking\r
@Async\r
@ModuleID=10020\r
@ModuleLib=Player\r
@ApiTarget=2\r
action RequestGroupMatchMaking = 10074 { #%(T_51_SD_WS_REQUES_GROUP_MATCHMAKING)\r
    Members : ListT_Player #%(T_51_META_WS_MEMBERLIST)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateLineRenderEntity\r
@Async\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action CreateLineRenderEntity = 10075 { #%(T_52_META_API_10075)\r
    out EntityVarName : LineRenderEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
    Points : ListT_Vector3 #%(T_52_META_WS_POINTLIST)\r
    Material : MaterialID #%(T_52_META_TYP_458_I6)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateProjectileTrajectory\r
@Async\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action CreateProjectileTrajectory = 10076 { #%(T_52_META_API_10076)\r
    out EntityVarName : ProjectileTrajectory #%(T_46_META_WS_A_CREATEDENTITY)\r
    StartPosition : Vector3 #%(T_46_META_WS_A_STARTPOSITION)\r
    InitialVelocity : Vector3 #%(T_52_META_API_10076_P2)\r
    Material : MaterialID #%(T_52_META_TYP_458_I6)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=CreateSound_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action CreateSoundEntityV2 = 10059 { #%(T_42_XXJ_WS_CREATESOUND)\r
    out EntityVarName : SoundEntity #%(T_38_WZY_WS_SOUNDENT)\r
    OwnerPlayer : Player #%(T_34_SP_WS_BLOCK6_PARAM2_NAME)\r
    SoundType : AudioType #%(T_34_SP_WS_BLOCK13_PARAM2_NAME)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=PauseSound_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PauseSoundEntityV2 = 10062 { #%(T_39_WZY_WS_PAUSESOUND_NAME)\r
    TargetEntity : SoundEntityOrListSoundEntity #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=ResumeSound_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action ResumeSoundEntityV2 = 10063 { #%(T_39_WZY_WS_PLAYSOUND_NAME)\r
    TargetEntity : SoundEntityOrListSoundEntity #%(T_39_WZY_WS_SOUNDENTLORSENT)\r
    IsReplay : Bool #%(T_39_WZY_WS_WEAREPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetFallingDamage\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SetPlayerFallingDamage = 9027 { #StdLibrary/%(T_46_META_WS_SETFALLINGDAMAGE)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    HeightList : ListT_Float #%(T_46_META_WS_A_HEIGHTSEGMENTS)\r
    DamageList : ListT_int #%(T_46_META_WS_A_DAMAGESEGMENTS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateBot\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action AddBot = 35 { #StdLibrary/%(T_46_META_WS_CREATEBOT)\r
    Difficulty : BotDifficulty #%(T_46_META_WS_A_DIFFICULTY)\r
    TeamSeq : Int #%(T_46_META_WS_A_TEAMSEQ)\r
    out BotVarName : Player #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyBot\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action DeleteBot = 1021 { #StdLibrary/%(T_46_META_WS_DESTROYBOT)\r
    Bot : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1543_R_D)\r
variable Exponentiation : Number = 1543 { #%(T_46_META_WS_EXPONENTIATION)\r
    LeftValue : Number #%(T_46_META_WS_A_BASE)\r
    RightValue : Number #%(T_46_META_WS_A_EXPONENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Logarithm\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1544_R_D)\r
variable Log : Number = 1544 { #%(T_46_META_WS_LOGARITHM)\r
    Base : Number #%(T_46_META_WS_A_BASE)\r
    RealNumber : Number #%(T_46_META_WS_A_REALNUMBER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DirectionToEulerAngle\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1545_R_D)\r
variable Vector3ToEulerAngles : Vector3 = 1545 { #%(T_46_META_WS_DIRECTIONTOEULERANGLE)\r
    Vector : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ExitVehicle\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action GetOutTheVehicle = 1022 { #%(T_46_META_WS_EXITVEHICLE)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DropItem\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action DropItemEntity = 3001 { #%(T_46_META_WS_DROPITEM)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Item : InventoryBase #%(T_46_META_WS_A_ITEM)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateAirDrop\r
@ModuleID=40\r
@ModuleLib=AirDrop\r
@ApiTarget=2\r
action CreateAirDropEntity = 10064 { #%(T_46_META_WS_CREATEAIRDROP)\r
    out EntityVarName : AirDrop #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateDamageNum\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action CreateUGCDamageNum = 1023 { #%(T_46_META_WS_CREATEDAMAGENUM)\r
    Value : String #%(T_46_META_WS_A_CONTENT)\r
    FontSize : Int #%(T_46_META_WS_A_FONTSIZE)\r
    FontColor : Color #%(T_46_META_WS_A_FONTCOLOR)\r
    TimeOfStay : Int #%(T_46_META_WS_P_PHASEDURATION)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
    Offset : Vector3 #%(T_46_META_WS_A_OFFSET)\r
    RandomRange : Vector2 #%(T_46_META_WS_A_RANDOMRANGE)\r
    DoTween : Bool #%(T_46_META_WS_A_DOTWEEN)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DispatchEventWithPlatform_Deprecated\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEventV2 = 1024 { #%(T_46_META_WS_DISPATCHEVENTWITHPLATFORM)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
    TargetEntity : entity #%(T_46_META_WS_A_TARGET)\r
    CrossPlatform : Bool #%(T_46_META_WS_A_CROSSPLATFORM)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCustomMissionProgress\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1025_R_D)\r
variable GetCustomMissionProgress : Int = 1025 { #%(T_46_META_WS_GETCUSTOMMISSIONPROGRESS)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    MissionID : Int #%(T_46_META_WS_A_MISSIONID)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetFriends\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=1\r
variable GetFriends : ListT_UUID = 150 { #%(T_50_META_API_150)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LogWarning\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PrintWarning = 57 { #%(T_46_META_WS_LOGWARNING)\r
    Context : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=LogError\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action PrintError = 58 { #%(T_46_META_WS_LOGERROR)\r
    Context : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SampleOnCurve\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Return = %(T_48_META_API_59_R_D)\r
variable CurveEvaluate : Float = 59 { #%(T_46_META_WS_SAMPLEONCURVE)\r
    Curve : BezierCurve #%(T_46_META_WS_A_CURVE)\r
    Time : Float #%(T_46_META_WS_A_SAMPLEPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetResultFromCurve\r
@ModuleID=29\r
@ModuleLib=Playable\r
@Return = %(T_48_META_API_60_R_D)\r
variable GetResultFromCurve : Object = 60 { #%(T_46_META_WS_GETRESULTFROMCURVE)\r
    PropType : Type #%(T_46_META_WS_A_VALUETYPE)\r
    SrcValue : Object #%(T_46_META_WS_A_SRCVALUE)\r
    DestVal : Object #%(T_46_META_WS_A_DESTVAL)\r
    Curve : BezierCurve #%(T_46_META_WS_A_CURVE)\r
    Time : Float #%(T_46_META_WS_A_SAMPLEPOINT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UploadGameResult\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action UploadMatchResult = 64 { #%(T_46_META_WS_UPLOADGAMERESULT)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    Result : MatchResultType #%(T_46_META_WS_A_RESULT)\r
    ScoreName : ListT_String #%(T_46_META_WS_A_SCORENAME)\r
    ScoreValue : ListT_String #%(T_46_META_WS_A_SCORE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateSound\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
action CreateSoundEntityV3 = 65 { #%(T_46_META_WS_CREATESOUND)\r
    out EntityVarName : SoundEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
    SoundType : AudioType #%(T_46_META_WS_A_RESOURCE)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateSoundClient\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=1\r
action CreateSoundEntityClient = 67 { #%(T_46_META_WS_CREATESOUNDCLIENT)\r
    out EntityVarName : SoundEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
    SoundType : AudioType #%(T_46_META_WS_A_RESOURCE)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateEffect\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=2\r
action CreateEffectEntityV2 = 66 { #%(T_46_META_WS_CREATEEFFECT)\r
    out EntityVarName : EffectEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
    @optional\r
    OwnerPlayer : Player #%(T_46_META_WS_A_TARGET)\r
    EffectType : EffectType #%(T_46_META_WS_A_RESOURCE)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateEffectClient\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=1\r
action CreateEffectEntityClient = 72 { #%(T_46_META_WS_CREATEEFFECTCLIENT)\r
    out EntityVarName : EffectEntity #%(T_46_META_WS_A_CREATEDENTITY)\r
    EffectType : EffectType #%(T_46_META_WS_A_RESOURCE)\r
    LoopType : AnimationOverrideLoopType #%(T_46_META_WS_A_LOOPTYPE)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetBackpackSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
@Return = %(T_48_META_API_1026_R_D)\r
variable GetBagSkinID : BagSkinID = 1026 { #%(T_46_META_WS_GETBACKPACKSKIN)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetBackpackSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action SetBagSkinID = 1027 { #%(T_46_META_WS_SETBACKPACKSKIN)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
    SkinID : BagSkinID #%(T_46_META_WS_A_SKIN)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetBackpackSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action ResetBagSkinID = 1028 { #%(T_46_META_WS_RESETBACKPACKSKIN)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveBackpackSkin\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=2\r
action RemoveBagSkinID = 1029 { #%(T_46_META_WS_REMOVEBACKPACKSKIN)\r
    Player : PlayerOrNPC #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetSkeletonPartByName\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1030_R_D)\r
variable GetMountPoint : SkeletonPart = 1030 { #%(T_46_META_WS_GETSKELETONPARTBYNAME)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
    Name : String #%(T_46_META_WS_A_NAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateSkeletonPartLookAtController\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
action CreateSkeletonPartLookAtController = 97 { #%(T_49_META_API_97)\r
    out EntityVarName : SkeletonPartLookAtController #%(T_46_META_WS_A_CREATEDENTITY)\r
    ControlBone : SkeletonPart #%(T_49_META_TYP_448_I0)\r
    LookAt : Transform #%(T_49_META_TYP_448_I1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetParentClient\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetParentClient = 1031 { #%(T_46_META_WS_SETPARENTCLIENT)\r
    Parent : Mountable #%(T_46_META_WS_A_PARENT)\r
    Child : Transform #%(T_46_META_WS_A_CHILD)\r
    WorldPositionStays : Bool #%(T_46_META_WS_A_WORLDPOSITIONSTAYS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=NotifyPlayIconAnimation\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action NotifyIconAnimation = 1032 { #%(T_46_META_WS_NOTIFYPLAYICONANIMATION)\r
    Icon : SpriteID #%(T_46_META_WS_A_RESOURCE)\r
    Color : Color #%(T_46_META_WS_A_COLOR)\r
    Scale : Vector2 #%(T_46_META_WS_A_SCALE)\r
    StartPosition : Vector2 #%(T_46_META_WS_A_STARTAREACENTER)\r
    StartRange : Vector2 #%(T_46_META_WS_A_STARTAREARANGE)\r
    EndPosition : Vector2 #%(T_46_META_WS_A_ENDAREACENTER)\r
    EndRange : Vector2 #%(T_46_META_WS_A_ENDAREARANGE)\r
    Speed : Float #%(T_46_META_WS_A_PLAYSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ATan2\r
@ModuleID=10003\r
@ModuleLib=Math\r
@Return = %(T_48_META_API_1033_R_D)\r
variable Atan2 : Float = 1033 { #%(T_46_META_WS_ATAN2)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action AddComponent = 1034 { #%(T_46_META_WS_ADDCOMPONENT)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    TypeID : Type #%(T_46_META_WS_A_COMPONENT)\r
    out IsSuc : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action RemoveComponent = 1035 { #%(T_46_META_WS_REMOVECOMPONENT)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    TypeID : Type #%(T_46_META_WS_A_COMPONENT)\r
    out IsSuc : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ApplyQuitMidwayUIConfig\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action ApplyQuitMidwayHudConfig = 1036 { #%(T_46_META_WS_APPLYQUITMIDWAYUICONFIG)\r
    Title : StringOrLocString #%(T_46_META_WS_A_TITLE)\r
    Content : StringOrLocString #%(T_46_META_WS_A_CONTENT)\r
    Options : ListT_StringOrLocString #%(T_46_META_WS_A_OPTIONS)\r
    ShowBackground : Bool #%(T_46_META_WS_A_SHOWBACKGROUND)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalPlayer\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
@Return = %(T_48_META_API_75_R_D)\r
variable LocalPlayer : Player = 75 { #%(T_46_META_WS_GETLOCALPLAYER)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10012\r
@ModuleLib=Scene\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1037_R_D)\r
variable GetLoadedScenes : ListT_String = 1037 { #%(T_46_META_WS_GETLOADEDSCENES)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1038_R_D)\r
variable GetLocalAimDirection : Vector3 = 1038 { #%(T_46_META_WS_GETLOCALAIMDIRECTION)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=41\r
@ModuleLib=Time\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1039_R_D)\r
variable GetLocalTimestamp : Int = 1039 { #%(T_46_META_WS_GETLOCALTIMESTAMP)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetXClient\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_77_R_D)\r
variable VectorSetXClient : Vector3 = 77 { #%(T_34_LY_WS_SVX)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetYClient\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_78_R_D)\r
variable VectorSetYClient : Vector3 = 78 { #%(T_34_LY_WS_SVY)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetZClient\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_79_R_D)\r
variable VectorSetZClient : Vector3 = 79 { #%(T_34_LY_WS_SVZ)\r
    Vector : Vector3 #%(T_48_META_API_1500_P0)\r
    Z : Float #%(T_48_META_API_1505_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetXClient\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_80_R_D)\r
variable Vector2SetXClient : Vector2 = 80 { #%(T_43_YU_WS_VECTOR2SETX)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
    X : Float #%(T_46_META_WS_A_X)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=Vector2SetYClient\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=1\r
@Return = %(T_48_META_API_81_R_D)\r
variable Vector2SetYClient : Vector2 = 81 { #%(T_43_YU_WS_VECTOR2SETY)\r
    Vector2 : Vector2 #%(T_38_M_WS_VECTOR2)\r
    Y : Float #%(T_46_META_WS_A_Y)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=PauseFixedUpdate\r
@ModuleID=41\r
@ModuleLib=Time\r
@ApiTarget=0\r
action PauseGame = 1040 { #%(T_46_META_WS_PAUSEFIXEDUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResumeFixedUpdate\r
@ModuleID=41\r
@ModuleLib=Time\r
@ApiTarget=0\r
action ResumeGame = 1041 { #%(T_46_META_WS_RESUMEFIXEDUPDATE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10013\r
@ModuleLib=FF_Platform\r
@ApiTarget=1\r
@Return = %(T_48_META_API_1042_R_D)\r
variable IsFriend : Bool = 1042 { #%(T_46_META_WS_ISFRIEND)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=DispatchEventWithPlatform\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEventV3 = 1043 { #%(T_46_META_WS_SENDEVENT)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    TargetSide : PlatformType #%(T_46_META_WS_A_PLATFORM)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DispatchEventToEntity\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action DispatchCustomEventV4 = 153 { #%(T_50_META_API_153)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    TargetSide : PlatformType #%(T_46_META_WS_A_PLATFORM)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BroadcastCustomEvent\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
action BroadcastCustomEvent = 152 { #%(T_50_META_API_152)\r
    EventID : EventID #%(T_46_META_WS_A_EVENTID)\r
    TargetSide : PlatformType #%(T_46_META_WS_A_PLATFORM)\r
    Params : List #%(T_46_META_WS_A_PARAMS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action StartParachute = 1044 { #%(T_46_META_WS_STARTPARACHUTE)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
    ForceToParachuteHeight : Float #%(T_46_META_WS_A_FORCEDPARACHUTEHEIGHT)\r
    SurfingMaxSpeed : Vector2 #%(T_46_META_WS_A_SURFINGMAXSPEED)\r
    DivingMaxSpeed : Vector2 #%(T_46_META_WS_A_DIVINGMAXSPEED)\r
    ParachutingMaxSpeed : Vector2 #%(T_46_META_WS_A_PARACHUTINGMAXSPEED)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromDataStore\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetValue_V2 = 1045 { #%(T_46_META_WS_READFROMDATASTORE)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromDataStoreSteady\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetValueNoCache = 1199 { #%(T_52_META_API_1199)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromDataStoreBatch\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action BatchReadDBSheetValue = 1098 { #%(T_48_META_API_1098)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountIds : ListT_UUID #%(T_48_META_API_1098_P1)\r
    Keys : ListT_String #%(T_48_META_API_1098_P2)\r
    out Result : ListT_Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCodes : ListT_ErrorCode #%(T_48_META_API_1098_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLeaderboard\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValue_V2 = 1046 { #%(T_46_META_WS_READFROMLEADBOARDDATASTORE)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLeaderboardByRank\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardValuesByRange_V2 = 1047 { #%(T_46_META_WS_READFROMLEADBOARDDATASTOREBYRANK)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTRANK)\r
    EndIndex : Int #%(T_46_META_WS_A_ENDRANK)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromAccumulation\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBAccumulatedData_V2 = 1048 { #%(T_46_META_WS_READFROMACCUMULATEDDATASTORE)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Result : Int #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteToDataStore\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBSheetValue_V2 = 1049 { #%(T_46_META_WS_WRITETODATASTORE)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : Object #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToDataStoreV2\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBSheetValueAsync = 1211 { #%(T_52_META_API_1211)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : Object #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=UpdateToDataStore\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBSheetValueBlocking = 1210 { #%(T_52_META_API_1210)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : Object #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteToLeaderboardDataStore\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardValue_V2 = 1084 { #%(T_46_META_WS_WRITETOLEADBOARDDATASTORE)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToLeaderboard\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardValueAsync = 1122 { #%(T_52_META_API_1122)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=WriteToAccumulatedDataStore\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBAccumulatedDataOffset_V2 = 1085 { #%(T_46_META_WS_WRITETOACCUMULATEDDATASTORE)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    ArithmeticType : Int #%(T_46_META_WS_A_OPERATIOMETHOD)\r
    Offset : Int #%(T_46_META_WS_A_OFFSET)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToAccumulationOffset\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBAccumulatedDataOffsetAsync = 1123 { #%(T_52_META_API_1123)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    ArithmeticType : Int #%(T_46_META_WS_A_OPERATIOMETHOD)\r
    Offset : Int #%(T_46_META_WS_A_OFFSET)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddAOISpecialFollow\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action AddSpecialFollow = 84 { #%(T_46_META_WS_ADDAOISPECIALFOLLOW)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    Observer : Player #%(T_46_META_WS_A_OBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveAOISpecialFollow\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action RemoveSpecialFollow = 85 { #%(T_46_META_WS_REMOVEAOISPECIALFOLLOW)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    Observer : Player #%(T_46_META_WS_A_OBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ClearAOISpecialFollow\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action CleanSpecialFollow = 86 { #%(T_46_META_WS_CLEARAOISPECIALFOLLOW)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HasAOISpecialFollow\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_48_META_API_87_R_D)\r
variable HasSpecialFollow : Bool = 87 { #%(T_46_META_WS_HASAOISPECIALFOLLOW)\r
    Target : entity #%(T_46_META_WS_A_TARGET)\r
    Observer : Player #%(T_46_META_WS_A_OBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EulerAngleToVector3\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1546_R_D)\r
variable EularAngleToVector3 : Vector3 = 1546 { #%(T_46_XXJ_WS_EULARANGLETOVECTOR3)\r
    Value : Vector3 #%(T_46_XXJ_WS_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1547_R_D)\r
variable IntToFloat : Float = 1547 { #%(T_46_XXJ_WS_INTTOFLOAT)\r
    Value : Int #%(T_46_XXJ_WS_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1548_R_D)\r
variable RotateVector : Vector3 = 1548 { #%(T_46_XXJ_WS_ROTATEVECTOR)\r
    Value : Vector3 #%(T_46_XXJ_WS_VALUE)\r
    Delta : Quaternion #%(T_46_XXJ_WS_DELTA)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchAOIProxyObserver\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action SwitchUserProxyObserver = 88 { #%(T_46_META_WS_SWITCHAOIPROXYOBSERVER)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    ProxyObserver : PlayerOrTransform #%(T_46_XXJ_WS_PROXYOBSERVER)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveFromDataStore\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBSheetValue_V2 = 1086 { #%(T_46_META_WS_DELETEFROMDATASTORE)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromDataStoreV2\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBSheetValueAsync = 171 { #%(T_52_META_API_171)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveFromLeaderboardDataStoreByKey\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByKey_V2 = 1087 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYKEY)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromLeaderboard\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByKeyAsync = 1125 { #%(T_52_META_API_1125)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=RemoveFromLeaderboardDataStoreByRank\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByOrder_V2 = 1088 { #%(T_46_META_WS_DELETEFROMLEADBOARDDATASTOREBYRANK)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Order : Int #%(T_46_META_WS_A_RANK)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromLeaderboardByRank\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action DeleteDBLeaderboardValueByOrderAsync = 1126 { #%(T_52_META_API_1126)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Order : Int #%(T_46_META_WS_A_RANK)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UserMessageToPersona = 1089 { #%(T_47_XXJ_WS_USERMESSAGETOPERSONA)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SystemMessageToPersona = 1090 { #%(T_47_XXJ_WS_SYSTEMMESSAGETOPERSONA)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
    ShouldReply : Bool #%(T_47_XXJ_WS_SHOULDREPLY)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=UserMessageToPersonaVoiceResponse\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UserMessageToPersonaVoice = 1114 { #%(T_51_META_API_1114)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Content : String #%(T_46_META_WS_A_CONTENT)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=SystemMessageToPersonaVoiceResponse\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SystemMessageToPersonaVoice = 1115 { #%(T_51_META_API_1115)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Content : String #%(T_46_META_WS_A_CONTENT)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=3\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action PlayStoredVoiceFromPersona = 1116 { #%(T_51_META_API_1116)\r
    ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action ClearMemory = 1091 { #%(T_47_XXJ_WS_CLEARMEMORY)\r
    out ErrorCode : ErrorCode #%(T_47_XXJ_WS_ERRORCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=2\r
action IsPremium = 1096 { #%(T_46_XXJ_WS_ISPREMIUM)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
    out Result : Bool #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=2\r
action OpenPremiumCenter = 1097 { #%(T_46_XXJ_WS_OPENPREMIUMCENTER)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=1\r
action OpenPremiumCenter_Client = 1092 { #%(T_46_XXJ_WS_OPENPREMIUMCENTER)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=2\r
action GetPremiumExpireDate = 1093 { #%(T_46_XXJ_WS_GETPREMIUMEXPIREDATE)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
    out Result : Int64 #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=1\r
action IsPremium_Client = 1094 { #%(T_46_XXJ_WS_ISPREMIUM)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
    out Result : Bool #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=42\r
@ModuleLib=Premium\r
@ApiTarget=1\r
action GetPremiumExpireDate_Client = 1095 { #%(T_46_XXJ_WS_GETPREMIUMEXPIREDATE)\r
    out Result : Int64 #%(T_40_XXJ_WS_RESULT_NAMEKEY)\r
    out Status : ErrorCode #%(T_46_XXJ_WS_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=2\r
action OpenPremiumStore = 176 { #%(T_53_SD_COMMIAP_OPENSTOREHUD)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=1\r
action OpenPremiumStore_Client = 177 { #%(T_53_SD_COMMIAP_OPENSTOREHUD)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=BuyPremiumProduct_Deprecate\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=2\r
action BuyPremiumCommodity = 178 { #%(T_53_META_API_178)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
}\r
\r
@ApiLevel=10\r
@ScriptName=BuyPremiumProduct_Client_Deprecate\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=1\r
action BuyPremiumCommodity_Client = 179 { #%(T_53_SD_COMMIAP_OPENSTOREHUD)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuyPremiumProduct\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=2\r
action BuyPremiumCommodityV2 = 1121 { #%(T_53_META_API_178)\r
    Player : Player #%(T_45_XXJ_WS_PLAYER)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=BuyPremiumProduct_Client\r
@ModuleID=48\r
@ModuleLib=CommerceIAP\r
@ApiTarget=1\r
action BuyPremiumCommodity_ClientV2 = 1127 { #%(T_53_META_API_178)\r
    ItemCode : String #%(T_53_META_API_173_P1)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SetPersonaObserver = 1099 { #%(T_47_XXJ_WS_SETPERSONAOBSERVER)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Observers : ListT_PersonaID #%(T_47_XXJ_WS_OBSERVERS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UserMessageToPersonaStream = 1100 { #%(T_47_XXJ_WS_USERMESSAGETOPERSONASTREAM)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action SystemMessageToPersonaStream = 1101 { #%(T_47_XXJ_WS_SYSTEMMESSAGETOPERSONASTREAM)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Content : String #%(T_47_XXJ_WS_CONTENT)\r
    ShouldReply : Bool #%(T_47_XXJ_WS_SHOULDREPLY)\r
    out ChatID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action UpdateContextToPersona = 109 { #%(T_49_META_API_109)\r
    Target : PersonaID #%(T_46_META_WS_A_TARGET)\r
    Context : String #%(T_49_META_API_109_P1)\r
    out RequestID : Int64 #%(T_49_META_API_1089_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action FeedbackToPersonaContent = 110 { #%(T_49_META_API_110)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
    IsLiked : Bool #%(T_49_META_API_110_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=43\r
@ModuleLib=LLM\r
@ApiTarget=1\r
action RollbackPersonaMemory = 112 { #%(T_49_META_API_112)\r
    ResponseID : String #%(T_49_META_EVT_16_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JoinTeam\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action JoinTeam = 91 { #%(T_47_XXJ_WS_JOINTEAM)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
    TargetTeam : Team #%(T_47_XXJ_WS_TARGETTEAM)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=JoinNewTeam\r
@ModuleID=14\r
@ModuleLib=Hostility\r
@ApiTarget=2\r
action JoinNewTeam = 92 { #%(T_47_XXJ_WS_JOINNEWTEAM)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
    out NewTeam : Team #%(T_47_XXJ_WS_NEWTEAM)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1103_R_D)\r
variable CreateRandomSeed : Random = 1103 { #%(T_47_XXJ_WS_CREATERANDOMSEED)\r
    Seed : Int #%(T_47_XXJ_WS_SEED)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
@Return = %(T_48_META_API_1104_R_D)\r
variable Next : Int = 1104 { #%(T_47_XXJ_WS_NEXT)\r
    Value : Random #%(T_46_META_WS_A_VALUE)\r
    Min : Int #%(T_46_META_WS_A_MIN)\r
    Max : Int #%(T_46_META_WS_A_MAX)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyStartPlot = 1105 { #%(T_48_META_API_1105)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    PlotID : PlotID #%(T_48_META_EVT_3141_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreatePerformance\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=1\r
action CreateTimeLine = 1106 { #%(T_50_META_API_1106)\r
    ResID : TimeLineID #%(T_46_META_WS_A_RESOURCE)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
    out EntityVarName : TimeLine #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateAlongPathMotion\r
@ModuleID=29\r
@ModuleLib=Playable\r
@ApiTarget=0\r
action CreateAlongPathMotion = 93 { #%(T_48_META_API_93)\r
    TargetEntity : Entity #%(T_46_META_WS_A_TARGET)\r
    Path : CustomCurvePath #%(T_48_META_API_93_P1)\r
    Style : TweenStyle #%(T_46_META_WS_A_STYLE)\r
    Speed : Float #%(T_46_META_WS_P_SPEED)\r
    TangentFacing : Bool #%(T_48_META_API_93_P4)\r
    out EntityVarName : AlongPathMotion #%(T_46_META_WS_A_CREATEDENTITY)\r
    AutoPlay : Bool #%(T_46_META_WS_A_AUTOPLAY)\r
}\r
\r
@ApiLevel=3\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action SetLocalVarByIndex = 94 { #SetLocalVarByIndex\r
    Index : Int #%(T_48_META_API_94_P0)\r
    VarValue : Object #%(T_48_META_API_94_P1)\r
    ArithmeticType : Int #%(T_48_META_API_94_P2)\r
    VarName : String #%(T_48_META_API_94_P3)\r
}\r
\r
@ApiLevel=3\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
@Return = %(T_48_META_API_2006_R_D)\r
variable GetLocalVarByIndex : Object = 95 { #%(T_48_META_API_95)\r
    Index : Int #%(T_48_META_API_95_P0)\r
    VarName : String #%(T_48_META_API_95_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalLanguage\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
variable GetLocalLanguage : LanguageType = 1108 { #%(T_48_META_API_1108)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLocalPlayerPosition\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action SetLocalPlayerPositon = 1109 { #%(T_49_META_API_1109)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLocalPlayerForward\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action SetLocalPlayerForward = 1110 { #%(T_49_META_API_1110)\r
    Forward : Vector3 #%(T_46_META_WS_A_FORWARD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchCustomCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
action SwitchNewCamera = 10065 { #%(T_49_META_API_10065)\r
    Player : PlayerOrObserver #%(T_46_META_WS_TARGET)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_CAMERA)\r
    CameraTransitionType : CameraTransitionType #%(T_46_META_WS_A_TRANSITIONTYPE)\r
    TransitionTime : Float #%(T_46_META_WS_A_TRANSITIONTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchCustomCameraClient\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action SwitchNewCameraForClinet = 10066 { #%(T_49_META_API_10065)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_CAMERA)\r
    CameraTransitionType : CameraTransitionType #%(T_46_META_WS_A_TRANSITIONTYPE)\r
    TransitionTime : Float #%(T_46_META_WS_A_TRANSITIONTIME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentNewCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=2\r
variable GetCurrentNewCamera : BasicCamera = 10067 { #%(T_49_META_API_10067)\r
    Player : PlayerOrObserver #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCurrentCustomCameraClient\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
variable GetCurrentNewCameraForClinet : BasicCamera = 10068 { #%(T_49_META_API_10067)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CreateCustomCamera\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
action CreateBasicCamera = 10069 { #%(T_49_META_API_10069)\r
    out EntityVarName : BasicCamera #%(T_46_META_WS_A_CREATEDENTITY)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCustomCameraCullingMask\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
action SetCustomCameraCullingMask = 10070 { #%(T_49_META_API_10070)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_TARGET)\r
    CullingMask : ListT_Int #%(T_46_META_WS_A_CULLINGMASK)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetCustomCameraCullingMask\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
@Return = %(T_48_META_API_9018_R_D)\r
variable GetCustomCameraCullingMask : ListT_Int = 10071 { #%(T_49_META_API_10071)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetCustomCameraCullingMaskLayer\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=0\r
action AddOrRemoveCustomCameraCullingMask = 10072 { #%(T_49_META_API_10072)\r
    BasicCamera : BasicCamera #%(T_46_META_WS_A_TARGET)\r
    VisibilityLayer : Int #%(T_46_META_WS_A_LAYER)\r
    IsInCullingMask : Bool #%(T_46_META_WS_A_VISIBLE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=\r
@ModuleID=10007\r
@ModuleLib=Camera\r
@ApiTarget=1\r
action PlayCustomCameraShake = 1128 { #%(T_55_META_API_1128)\r
    AxisOffset : Vector3 #%(T_55_META_API_1128_P0)\r
    Amplitude : Float #%(T_55_META_API_1128_P1)\r
    Frequency : Float #%(T_55_META_API_1128_P2)\r
    FadeIn : Int #%(T_55_META_API_1128_P3)\r
    FadeOut : Int #%(T_55_META_API_1128_P4)\r
    DurationMs : Int #%(T_55_META_API_1128_P5)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action CaptureScreenshot = 10073 { #%(T_49_META_API_10073)\r
    FileName : String #%(T_50_META_API_10073_P0)\r
    out Status : ErrorCode #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=10\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action PlayOneShotSound = 113 { #%(T_49_META_API_113)\r
    Resource : AudioID #%(T_46_META_WS_A_RESOURCE)\r
    Volume : Float #%(T_49_META_API_113_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLevelObjectHighLight\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action SetLevelObjHighLight = 116 { #%(T_50_META_API_116)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
    Status : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=3\r
@ScriptName=SetLevelObjectOutlineEffect\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetLevelObjOutlineEffect = 146 { #%(T_51_TYC_API_OUTLINE)\r
    Target : Entity #%(T_51_TYC_API_OUTLINE_TARGET)\r
    Width : Float #%(T_51_TYC_API_OUTLINE_WIDTH)\r
    Color : Color #%(T_51_TYC_API_OUTLINE_COLOR)\r
    Alpha : Float #%(T_51_TYC_API_OUTLINE_ALPHA)\r
    NoBlock : Bool #%(T_51_TYC_API_OUTLINE_TOPMOST)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable BitwiseCommon : Int = 117 { #%(T_50_META_API_117)\r
    Left : Int #%(T_46_META_WS_A_LEFTVALUE)\r
    Right : Int #%(T_46_META_WS_A_RIGHTVALUE)\r
    Operation : Int #%(T_46_META_WS_A_OPERATIOMETHOD)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable BitwiseNot : Int = 118 { #%(T_50_META_API_118)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
variable BitwiseListToInt : Int = 119 { #%(T_50_META_API_119)\r
    BitArray : ListT_Int #%(T_50_META_API_119_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10005\r
@ModuleLib=Convert\r
@ApiTarget=0\r
variable BitwiseIntToList : ListT_Int = 120 { #%(T_50_META_API_120)\r
    Value : Int #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionAngle : Float = 121 { #%(T_50_META_API_121)\r
    Left : Quaternion #%(T_46_META_WS_A_LEFTVALUE)\r
    Right : Quaternion #%(T_46_META_WS_A_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionDot : Float = 122 { #%(T_50_META_API_122)\r
    Left : Quaternion #%(T_46_META_WS_A_LEFTVALUE)\r
    Right : Quaternion #%(T_46_META_WS_A_RIGHTVALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionInverse : Quaternion = 123 { #%(T_50_META_API_123)\r
    Value : Quaternion #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionFromToRotation : Quaternion = 124 { #%(T_50_META_API_124)\r
    From : Vector3 #%(T_50_META_API_125_P0)\r
    To : Vector3 #%(T_50_META_API_125_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10003\r
@ModuleLib=Math\r
@ApiTarget=0\r
variable QuaternionRotateTowards : Quaternion = 125 { #%(T_50_META_API_125)\r
    From : Quaternion #%(T_50_META_API_125_P0)\r
    To : Quaternion #%(T_50_META_API_125_P1)\r
    MaxDegreesDelta : Float #%(T_50_META_API_125_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeOrientation : Quaternion = 126 { #%(T_50_META_API_126)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeGravity : Vector3 = 127 { #%(T_50_META_API_127)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeRotationRate : Vector3 = 128 { #%(T_50_META_API_128)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetGyroscopeRotationUnbiased : Vector3 = 129 { #%(T_50_META_API_129)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetGyroscopeUserAcceleration\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetUserAcceleration : Vector3 = 130 { #%(T_50_META_API_130)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
action GetTouchInfo = 131 { #%(T_50_META_API_131)\r
    Index : Int #%(T_46_META_WS_A_INDEX)\r
    out Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
    out DeltaPosition : Vector2 #%(T_50_META_API_131_P2)\r
    out DeltaTime : Float #%(T_50_META_API_131_P3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetScreenTouchCount : Int = 132 { #%(T_50_META_API_132)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
action VibrateDevice = 133 { #%(T_50_META_API_133)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action NotifyPlaySoundV2 = 134 { #%(T_46_META_WS_NOTIFYPLAYSOUND)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
    Resource : AudioID #%(T_46_META_WS_A_RESOURCE)\r
    Speed : Float #%(T_46_META_WS_P_SPEED)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action PlayOneShotSoundV2 = 135 { #%(T_49_META_API_113)\r
    Resource : AudioID #%(T_46_META_WS_A_RESOURCE)\r
    Speed : Float #%(T_46_META_WS_P_SPEED)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10004\r
@ModuleLib=Strings\r
@ApiTarget=0\r
variable FormatStr : String = 136 { #%(T_50_META_API_136)\r
    Content : String #%(T_46_META_WS_A_CONTENT)\r
    ParamsArray : ListT_Object #%(T_50_META_API_136_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action PasteComponent = 137 { #%(T_50_META_API_137)\r
    Source : Entity #%(T_50_META_API_137_P0)\r
    Target : Entity #%(T_46_META_WS_A_TARGET)\r
    ComponentType : Type #%(T_50_META_API_137_P2)\r
    out IsSuc : Bool #%(T_50_META_API_137_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReviveAtNextFrame\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action ReviveOnNextFrame = 138 { #%(T_50_META_API_138)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=EliminateAtNextFrame\r
@ModuleID=10016\r
@ModuleLib=Combat\r
@ApiTarget=2\r
action EliminateOnNextFrame = 139 { #%(T_50_META_API_139)\r
    Target : FightingEntity #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitGameAtNextFrame\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action QuitFameOnNextFrame = 140 { #%(T_50_META_API_140)\r
    Target : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
action GetMicrophoneVolume = 141 { #%(T_50_META_API_141)\r
    out Volume : Float #%(T_50_META_API_141_P0)\r
    out Status : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromDataStoreByColumn\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetColumnValue = 1102 { #%(T_50_META_API_1102)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    ColumnIndex : Int #%(T_50_META_API_1102_P3)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromDataStoreByColumnSteady\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBSheetColumnValueNoCache = 1200 { #%(T_52_META_API_1200)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    ColumnIndex : Int #%(T_50_META_API_1102_P3)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLeaderboardAssociation\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardAssociationValue = 1111 { #%(T_50_META_API_1111)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1111_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLeaderboardAssociationByRank\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action ReadDBLeaderboardAssociationValuesByRange = 1112 { #%(T_50_META_API_1112)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    StartIndex : Int #%(T_46_META_WS_A_STARTRANK)\r
    EndIndex : Int #%(T_46_META_WS_A_ENDRANK)\r
    out Result : List #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1112_P6)\r
}\r
\r
@ApiLevel=10\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardAssociationValue = 1113 { #%(T_50_META_API_1113)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : List #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1113_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToLeaderboardAssociation\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=2\r
action WriteDBLeaderboardAssociationValueAsync = 1124 { #%(T_52_META_API_1124)\r
    LeaderboardName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : List #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
    out AssociationErrorCode : ErrorCode #%(T_50_META_API_1113_P5)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLocalDataStore\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=1\r
action ReadLocalDBSheetValue = 1117 { #%(T_52_META_API_1117)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=WriteToLocalDataStore\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=1\r
action WriteLocalDBSheetValue = 1118 { #%(T_52_META_API_1118)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    Value : Object #%(T_46_META_WS_A_VALUE)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=RemoveFromLocalDataStore\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=1\r
action DeleteLocalDBSheetValue = 1119 { #%(T_52_META_API_1119)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadFromLocalDataStoreByColumn\r
@Async\r
@ModuleID=30\r
@ModuleLib=Database\r
@ApiTarget=1\r
action ReadLocalDBSheetColumnValue = 1120 { #%(T_52_META_API_1120)\r
    SheetName : String #%(T_46_META_WS_A_SHEETNAME)\r
    AccountId : UUID #%(T_46_META_WS_A_ACCOUNTID)\r
    Key : String #%(T_46_META_WS_A_KEY)\r
    ColumnIndex : Int #%(T_50_META_API_1102_P3)\r
    out Result : Object #%(T_46_META_WS_A_RESULT)\r
    WorkshopCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetRenderQuality : ERenderQuality = 142 { #%(T_50_META_API_142)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=1\r
variable GetRenderResolution : Vector2 = 143 { #%(T_50_META_API_143)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=47\r
@ModuleLib=InputSystem\r
@ApiTarget=0\r
action SetDistanceVolumes = 149 { #%(T_50_META_API_149)\r
    DistanceList : ListT_Float #%(T_50_META_API_149_P0)\r
    VolumeList : ListT_Int #%(T_50_META_API_149_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable GetTypeName : String = 154 { #%(T_51_META_API_154)\r
    Variable : Object #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action GetBoundingBox = 155 { #%(T_51_META_API_155)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
    out Center : Vector3 #%(T_46_META_WS_A_CENTER)\r
    out Size : Vector3 #%(T_51_META_API_155_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
action CreateEntity = 156 { #%(T_51_META_API_156)\r
    out CreatedEntity : Entity #%(T_46_META_WS_A_CREATEDENTITY)\r
    TypeID : Type #%(T_46_META_WS_C_TYPE)\r
    Owner : Player #%(T_46_META_WS_A_OWNER)\r
    Attribute : EntityFlag #%(T_51_META_API_156_P3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action SetMaterialProperty = 157 { #%(T_51_META_API_157)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
    PropertyName : String #%(T_51_META_API_157_P1)\r
    PropertyValue : MaterialProperty #%(T_51_META_API_157_P2)\r
    out Success : Bool #%(T_51_META_API_157_P3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=21\r
@ModuleLib=LevelObject\r
@ApiTarget=1\r
action ClearMaterialProperty = 158 { #%(T_51_META_API_158)\r
    Target : LevelObject #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
variable GetClientRegion : String = 159 { #%(T_52_META_API_159)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DealDamage\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action TakeDamage = 160 { #%(T_46_META_WS_DEALDAMAGE)\r
    DamageTaker : FightingEntity #%(T_46_META_WS_A_TARGET)\r
    DamageMaker : FightingEntity #%(T_46_META_WS_A_ATTACKER)\r
    DamageType : DamageType #%(T_46_META_WS_A_TYPE)\r
    DamageValue : Int #%(T_46_META_WS_A_DAMAGE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action Revive = 161 { #%(T_46_META_WS_REVIVE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action CreateTrainingBot = 162 { #%(T_52_META_API_162)\r
    out EntityVarName : TrainingPlayer #%(T_46_META_WS_A_CREATEDENTITY)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    MoveMode : TrainingTargetType #%(T_52_META_API_162_P2)\r
    InitDirection : Vector3 #%(T_52_META_API_162_P3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action ExitVehicle = 163 { #%(T_52_META_API_163)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action EnterVehicle = 164 { #%(T_52_META_API_164)\r
    Vehicle : Vehicle #%(T_46_META_WS_A_VEHICLE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action SetInvincibility = 165 { #%(T_52_META_API_165)\r
    Duration : Int #%(T_49_XXJ_WS_DURATIONS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action SwitchWeapon = 166 { #%(T_52_META_API_166)\r
    Slot : SwitchWeaponEquipSlot #%(T_46_META_WS_A_SLOT)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action AddItem = 167 { #%(T_52_META_API_167)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEMID)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
    out EntityList : ListT_Entity #%(T_52_META_API_167_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAllSpectators\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
@Return = %(T_52_GETALLOBSERVERS_R_D)\r
variable AllObservers : ListT_Observer = 168 { #%(T_52_GETALLOBSERVERS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetLocalSpectator\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
@Return = %(T_52_GETLOCALOBSERVER_R_D)\r
variable LocalObserver : Observer = 169 { #%(T_52_GETLOCALOBSERVER)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=QuitGameClient\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action QuitGameClient = 170 { #%(T_52_META_API_170)\r
    NeedConfirm : Bool #%(T_52_META_API_170_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=OnlineLog\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=2\r
action OnlineLog = 172 { #%(T_52_META_API_172)\r
    Content : Object #%(T_46_META_WS_A_CONTENT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SingleCapsuleCast\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=0\r
action SingleCapsuleCast = 174 { #%(T_52_META_API_174)\r
    Radius : Float #%(T_46_META_WS_A_RADIUS)\r
    Height : Float #%(T_46_META_WS_A_HEIGHT)\r
    Position : Vector3 #%(T_46_META_WS_A_POSITION)\r
    Rotation : Vector3 #%(T_46_META_WS_A_ROTATION)\r
    Direction : Vector3 #%(T_46_META_WS_A_DIRECTION)\r
    MaxDistance : Float #%(T_46_META_WS_A_MAXDISTANCE)\r
    LayerMask : ListT_int #%(T_46_META_WS_A_LAYERMASK)\r
    IncludeTrigger : Bool #%(T_46_META_WS_A_INCLUDETRIGGER)\r
    out HitEntity : Entity #%(T_52_META_API_174_P8)\r
    out HitPosition : Vector3 #%(T_52_META_API_174_P9)\r
    out HitDistance : Float #%(T_52_META_API_174_P10)\r
    out HitNormal : Vector3 #%(T_52_META_API_174_P11)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=DestroyItem\r
@ModuleID=10018\r
@ModuleLib=Offline\r
@ApiTarget=1\r
action DestroyItem = 10078 { #%(T_46_META_WS_DESTROYITEM)\r
    ItemID : ItemGoodsIDType #%(T_46_META_WS_A_ITEM)\r
    Count : Int #%(T_46_META_WS_A_COUNT)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddUserEventLogForClient\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=1\r
action AddUserEventLogMapForClient = 10079 { #%(T_46_META_WS_ADDUSEREVENTLOG)\r
    Dictionary : Map #%(T_46_META_WS_A_LOG)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddGameEventLogForClient\r
@ModuleID=17\r
@ModuleLib=StatisticalReport\r
@ApiTarget=1\r
action AddGameEventLogMapForClient = 10080 { #%(T_46_META_WS_ADDGAMEEVENTLOG)\r
    Dictionary : Map #%(T_46_META_WS_A_LOG)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10014\r
@ModuleLib=Items\r
@ApiTarget=2\r
action RemoveResidualItems = 181 { #%(T_54_META_API_181)\r
    ResidualItemsType : ResidualItemsType #%(T_54_META_API_181_P0)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetLocalPlayerMoveStatus\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=1\r
action SetLocalPlayerMoveStatus = 182 { #%(T_54_META_API_182)\r
    Status : Bool #%(T_46_META_WS_A_STATUS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetPetSkill\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
variable GetPetSkill : Int = 183 { #%(T_54_META_API_183)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetPetSkill\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action ResetPetSkill = 184 { #%(T_54_META_API_184)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SwitchPetSkill\r
@ModuleID=10010\r
@ModuleLib=Player\r
@ApiTarget=2\r
action SwitchPetSkill = 185 { #%(T_54_META_API_185)\r
    Player : Player #%(T_46_META_WS_A_TARGET)\r
    @optional\r
    PetSkillID : PetSkillID #%(T_54_META_API_185_P1)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetAppearanceMaterialOverride\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
action SetAppearanceMaterial = 186 { #%(T_54_META_API_186)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    AppearanceGroup : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
    AppearancePart : String #%(T_54_META_API_189_P2)\r
    MaterialSlot : Int #%(T_54_META_API_189_P3)\r
    Material : MaterialID #%(T_54_META_API_189_P4)\r
    out Success : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetAppearanceMaterial\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
action ResetAppearanceMaterial = 187 { #%(T_54_META_API_187)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    AppearanceGroup : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
    AppearancePart : String #%(T_54_META_API_189_P2)\r
    MaterialSlot : Int #%(T_54_META_API_189_P3)\r
    out Success : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetAppearanceMaterialGroup\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
action ResetAppearanceMaterialGroup = 188 { #%(T_54_META_API_188)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    AppearanceGroup : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
    out Success : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=GetAppearanceMaterialOverride\r
@ModuleID=38\r
@ModuleLib=Avatar\r
@ApiTarget=1\r
action GetAppearanceMaterial = 189 { #%(T_54_META_API_189)\r
    AvatarAbleEntity : AvatarAble #%(T_46_META_WS_A_TARGET)\r
    AppearanceGroup : String #%(T_46_META_WS_A_APPEARANCEGROUP)\r
    AppearancePart : String #%(T_54_META_API_189_P2)\r
    MaterialSlot : Int #%(T_54_META_API_189_P3)\r
    out Material : MaterialID #%(T_54_META_API_189_P4)\r
    out Success : Bool #%(T_46_META_WS_A_ISSUCCESS)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=49\r
@ModuleLib=MapResource\r
@ApiTarget=1\r
action DownloadMapResource = 190 { #%(T_55_META_API_190)\r
    MapCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@Async\r
@ModuleID=49\r
@ModuleLib=MapResource\r
@ApiTarget=1\r
action CheckMapResourceDownloaded = 191 { #%(T_55_META_API_191)\r
    MapCode : String #%(T_46_META_WS_A_MAPCODE)\r
    out State : MapResourceDownloadState #%(T_55_META_API_191_P1)\r
    out Progress : Int #%(T_55_META_API_191_P2)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
variable CheckUIHit : Bool = 192 { #%(T_55_META_API_192)\r
    Position : Vector2 #%(T_46_META_WS_A_POSITION)\r
    IncludeNonColliderUI : Bool #IncludeNonColliderUI\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=0\r
variable StringToBigFloat : BigFloat = 193 { #%(T_55_META_API_193)\r
    Value : String #%(T_46_META_WS_A_VALUE)\r
    AllowScientificNotation : Bool #%(T_55_META_API_193_P1)\r
    AllowSeparators : Bool #%(T_55_META_API_193_P2)\r
    AllowSuffix : Bool #%(T_55_META_API_193_P3)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=SetScrollAmount\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action SetScrollAmount = 194 { #%(T_55_META_API_194)\r
    HudScrollView : HudScrollView #%(T_45_XXJ_WS_TARGET)\r
    ScrollDirection : ScrollDirection #%(T_55_META_TYP_491)\r
    Value : Float #%(T_46_META_WS_A_VALUE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ResetScrollViewPosition\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action ResetScrollViewPosition = 195 { #%(T_55_META_API_195)\r
    HudScrollView : HudScrollView #%(T_55_META_API_195_P0)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
variable GetLocalOwnedEmotes : ListT_AnimationClipID = 196 { #%(T_55_META_API_196)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
variable GetLocalOwnedOutfit : ListT_ClothID = 197 { #%(T_55_META_API_197)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
variable GetLocalOwnedVehicleSkin : ListT_VehicleSkinID = 198 { #%(T_55_META_API_198)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
variable GetLocalOwnedWeaponSkin : ListT_WeaponSkinID = 199 { #%(T_55_META_API_199)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
variable GetLocalOwnedBackpackSkin : ListT_BagSkinID = 200 { #%(T_55_META_API_200)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVCellByNameFromServer\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
variable ReadCSVCellByNameFromServer : Object = 201 { #%(T_55_META_API_201)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Row : Int #%(T_46_META_WS_A_ROW)\r
    ColName : String #%(T_46_META_WS_A_COLUMNNAME)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ReadCSVRowByKeyFromServer\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
variable ReadCSVRowByKeyFromServer : ListT_Object = 202 { #%(T_55_META_API_202)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
    Col : Int #%(T_55_META_API_202_P1)\r
    TargetValue : Object #%(T_55_META_API_202_P2)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=CSVColumnNameToInt\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=2\r
variable CSVColumnNameToInt : Int = 203 { #%(T_55_META_API_203)\r
    CSVName : String #%(T_46_META_WS_A_SHEETNAME)\r
    ColName : String #%(T_46_META_WS_A_COLUMNNAME)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action Refresh = 204 { #%(T_55_META_API_204)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
    ResetScroll : Bool #%(T_55_META_API_204_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
variable GetCell : HudWidget = 205 { #%(T_55_META_API_205)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action ScrollToDataIndex = 206 { #%(T_55_META_API_206)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
    Offset : Float #%(T_46_META_WS_A_OFFSET)\r
    Restrict : Bool #%(T_55_META_API_206_P3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action SelectData = 207 { #%(T_55_META_API_207)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
    ScrollToItem : Bool #%(T_55_META_API_207_P2)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action UnselectData = 208 { #%(T_55_META_API_208)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
action ClearSelection = 209 { #%(T_55_META_API_209)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
variable GetSelectedDataIndexs : ListT_Int = 210 { #%(T_55_META_API_210)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
variable GetVisibleDataRange : Vector2 = 211 { #%(T_55_META_API_211)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=1\r
variable IsDataVisible : Bool = 212 { #%(T_55_META_API_212)\r
    EasyList : HudEasyList #%(T_45_XXJ_WS_TARGET)\r
    DataIndex : Int #%(T_55_META_API_205_P1)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
action OpenInGameWardrobe = 213 { #%(T_55_META_API_213)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
action CloseInGameWardrobe = 214 { #%(T_55_META_API_214)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
action ModifyAdditionalWardrobeOutfit = 215 { #%(T_55_META_API_215)\r
    Outfits : ListT_ClothID #%(T_55_META_API_215_P0)\r
    SortType : AdditionalWardrobeOutfitSortType #%(T_55_META_API_215_P1)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10017\r
@ModuleLib=Collection\r
@ApiTarget=1\r
action CheckWardrobeResourceDownloadStatus = 216 { #%(T_55_META_API_216)\r
    Outfits : ListT_ClothID #%(T_55_META_API_215_P0)\r
    out ErrorCode : ErrorCode #%(T_46_META_WS_A_STATUSCODE)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=ShowChatHud\r
@ModuleID=50\r
@ModuleLib=RoomSocial\r
@ApiTarget=1\r
action CreateChatHud = 218 { #%(T_55_META_API_SHOWCHATHUD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=HideChatHud\r
@ModuleID=50\r
@ModuleLib=RoomSocial\r
@ApiTarget=1\r
action CloseChatHud = 221 { #%(T_55_META_API_CLOSECHATHUD)\r
}\r
\r
@ApiLevel=4\r
@ScriptName=AddMovementEffect\r
@ModuleID=33\r
@ModuleLib=Physics\r
@ApiTarget=1\r
variable AddMovementEffect : Int = 217 { #%(T_55_META_API_217)\r
    TargetEntity : Entity #%(T_55_META_API_217_P0)\r
    Velocity : Vector3 #%(T_46_META_WS_A_VELOCITY)\r
    Acceleration : Vector3 #%(T_46_META_WS_A_ACCELERATION)\r
    Duration : Float #%(T_55_META_API_217_P3)\r
    Damping : Float #%(T_55_META_API_217_P4)\r
    BlendMode : Int #%(T_55_META_API_217_P5)\r
    Flags : Int #%(T_55_META_API_217_P6)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=16\r
@ModuleLib=Hud\r
@ApiTarget=0\r
action CreateUIWidgetFromPrefab = 220 { #%(T_55_META_API_220)\r
    out EntityVarName : HudWidget #%(T_55_META_API_220_P0)\r
    TargetPrefabID : PrefabID #%(T_55_META_API_220_P1)\r
    HudEntity : CustomHud #%(T_55_META_API_220_P2)\r
    @optional\r
    ParentWidget : HudWidget #%(T_55_META_API_220_P3)\r
}\r
\r
@ApiLevel=4\r
@ModuleID=10009\r
@ModuleLib=Other\r
@ApiTarget=1\r
@Return = %(T_55_META_API_GETTOTALMEMORY_P1_D)\r
variable GetTotalMemory : Int = 222 { #%(T_55_META_API_GETTOTALMEMORY)\r
}\r
\r
@ApiLevel=4\r
@Async\r
@ModuleID=10000\r
@ModuleLib=StdLibrary\r
@ApiTarget=1\r
action GetCameraPixelColor = 223 { #GetCameraPixelColor\r
    ScreenPosition : Vector2 #ScreenPosition\r
    out Color : Color #Color\r
}\r
\r
//Some removed APIs\r
@Return = number of elements\r
variable ArrayLength : int = 1050 { #obsolete/array length\r
     ArrayValue: List #array\r
}\r
\r
action SetArrayElementByIndex = 1052 { # outdated/modified array element\r
     ArrayValue: List #array\r
     Index: int #index\r
     ElementValue: any #element value\r
}\r
\r
@Return = result array\r
variable DeleteElementFromArray : List = 1054 { # Obsolete/delete array elements\r
     ArrayValue: List #array\r
     Index: int #index\r
}\r
`, oR = `id,comment,exports,category,order,weblink,tips,name,type,ref,is_linkable,ff_manual,ff_custom,fe_custom,param_order,param_info,dev_only,api_target,syntax_tooltip,ResourceLevel,Division,SearchKey,UtilizationFactor\r
"图元id\r
（不可重复）\r
（不可删除）",图元注释,"-1 不导出\r
1 仅在FF导出\r
2 仅在FE导出\r
\r
留空或0全部导出","分类 (支持多级分类)，\r
event\r
game/xxx\r
等\r
参考UGCBlockSubTypeConfig表",排序-数字越大越靠前,图元帮助连接(configid),"如果设置的话会覆盖meta中的描述key\r
对于手工导出的图元则必须指定","名字\r
（不可重复）\r
（改变可导致数据损坏，一旦上线后不可变）\r
（程序填写）","导出方式1-event|2-action|3-data|4-enum\r
（程序填写）","参考api\r
（程序填写）","该图元下是否能连接其他图元\r
（程序填写）","是否采用手工导出\r
（程序填写）","ff 特殊功能或图元\r
（程序填写）","fe 特殊功能或图元\r
'-' 表示fe程序原因不导出\r
（程序填写）","参数顺序\r
参数序号根据meta定义从1开始\r
竖线代表换行\r
分号代表参数分隔\r
如果是0则表示隐藏所有参数","参数信息及默认值\r
参数序号根据meta定义从1开始\r
格式为-参数序号:slot表现类型=默认值\r
默认是slot类型\r
带有Enum_表示这个枚举采用嵌入图元的方式",是否在正式版隐藏  0-不变 1-FF（仅在非线上环境显示） 2-FE（无功能） 3-Both,控制该行 API 从属于哪个端。会覆盖元数据 ApiTarget 字段。 2. 服务器 1. 客户端 0. 服务器+客户端（默认）,脚本化相关。用于悬浮显示关键字或语法糖在FCG脚本中的使用方法。,"资源权限等级\r
public（或不填）：公开资源\r
internal：仅白名单可用资源",用于配置从属分类，格式：从属大分类_从属小分类,用于搜索中对特写图元的名称匹配，另，对非特写图元，将在搜索时覆盖其label作为匹配内容,用于搜索中图元的使用率影响权重分\r
1,游戏开始时,,event/1,,docs/event-1-1/,,OnMatchStart,1,OnMatchStart,TRUE,,,,,,,,,,event,,0.04\r
2,游戏结束时,,event/1,,docs/event-1-2/,,OnMatchEnd,1,OnMatchEnd,TRUE,,,,,,3,,,,event,,0\r
3,回合开始时,,event/1,,docs/event-18-3/,,OnRoundStart,1,OnRoundStart,TRUE,,,,,,,,,,event,,0.057\r
4,回合结束时,,event/1,,docs/event-18-4/,,OnRoundEnd,1,OnRoundEnd,TRUE,,,,,,,,,,event,,0.003\r
5,阶段开始时,,event/1,,docs/event-18-5/,,OnPhaseStart,1,OnPhaseStart,TRUE,,,,,,,,,,event,,0.002\r
6,阶段结束时,,event/1,,docs/event-18-6/,,OnPhaseEnd,1,OnPhaseEnd,TRUE,,,,,,,,,,event,,0.001\r
7,玩家退出时,,event/1,,docs/event-11-7/,,OnUserQuit,1,OnUserQuit,TRUE,,,,,,,,,,event,,0.01\r
8,【废弃】玩家积分改变时,,event/2,,docs/event-19-8/,,OnPlayerRoundScoreChange,1,OnPlayerRoundScoreChange,TRUE,,,,,,1,,,,event,,0\r
9,【废弃】队伍积分改变时,,event/2,,docs/event-19-9/,,OnTeamRoundScoreChange,1,OnTeamRoundScoreChange,TRUE,,,,,,1,,,,event,,0\r
10,玩家死亡时,,event/1,,docs/event-16-10/,,OnPlayerDead,1,OnPlayerDead,TRUE,,,,,,,,,,event,,0.001\r
11,玩家助攻时,,event/1,,docs/event-16-11/,,OnPlayerAssist,1,OnPlayerAssist,TRUE,,,,,,,,,,event,,0.001\r
12,玩家造成伤害时,,event/1,,docs/event-16-12/,,OnPlayerDamage,1,OnPlayerDamage,TRUE,,,,,,,,,,event,,0.001\r
13,玩家击杀时,,event/1,,docs/event-16-13/,,OnPlayerKill,1,OnPlayerKill,TRUE,,,,,,,,,,event,,0.003\r
14,玩家加入游戏时,,event/1,,docs/event-11-14/,,OnPlayerAdd,1,OnPlayerAdd,TRUE,,,,,,,,,,event,,0.027\r
15,玩家复活时,,event/1,,docs/event-11-15/,,OnPlayerRevive,1,OnPlayerRevive,TRUE,,,,,,,,,,event,,0.002\r
16,当移除队伍时,,event/1,,docs/event-29-16/,,OnRemoveTeam,1,OnRemoveTeam,TRUE,,,,,,3,,,,event,,0\r
17,当添加队伍时,,event/1,,docs/event-29-17/,,OnAddTeam,1,OnAddTeam,TRUE,,,,,,3,,,,event,,0\r
18,当队伍被团灭时,,event/1,,docs/event-16-18/,,OnTeamACE,1,OnTeamACE,TRUE,,,,,,,,,,event,,0.003\r
10013,If,,logic,,,,If,2,,TRUE,TRUE,,if,,,,,,,condition,T_49_SD_SEARCHKEY_IF,0.05\r
10014,IfElse,,logic,,,,IfElse,2,,TRUE,TRUE,,ifelse,,,,,,,condition,T_49_SD_SEARCHKEY_IFELSE,0.015\r
21,ForEach,,logic,,,T_34_WZ_WS_LOGIC7_NAMEDESC,ForEach,2,,TRUE,TRUE,P2=P3.T0,loop_foreach,,,,,"for index , value in range",,condition,T_49_SD_SEARCHKEY_FOREACH,0.011\r
22,For,,logic,,,T_34_WZ_WS_LOGIC6_NAMEDESC,For,2,,TRUE,TRUE,,loop_forindex,,,,,"for i = begin, max, step",,condition,T_49_SD_SEARCHKEY_FOR,0.011\r
23,While,,logic,,,T_34_WZ_WS_LOGIC8_NAMEDESC,While,2,,TRUE,TRUE,,loop_while,,,,,while,,condition,T_49_SD_SEARCHKEY_WHILE,0.007\r
24,打断-退出循环,,logic,,docs/api-1-24/,,ProcessCtlBreak,2,ProcessCtlBreak,,,,loop_break,,,,,break,,condition,T_49_SD_SEARCHKEY_BREAK,0.001\r
25,跳转到下一次循环,,logic,,docs/api-1-25/,,ProcessCtlContinue,2,ProcessCtlContinue,,,,loop_continue,,,,,continue,,condition,T_49_SD_SEARCHKEY_CONTINUE,0.001\r
26,返回,,function,,docs/api-1-26/,T_34_WZ_WS_LOGIC11_NAMEDESC,ProcessCtlReturnVoid,2,ProcessCtlReturn,,,,function_return,0,,,,,,function,T_49_SD_SEARCHKEY_RETURN,0.001\r
27,切换游戏阶段,,game/6,,docs/api-18-27/,,SetFSMNextPhase,2,SetFSMNextPhase,TRUE,,,,,FE_1:PhaseIndex,,,,,module/18,,0.001\r
28,打开毒圈,,game/1,3190970,docs/api-20-28/,,OpenSafeZone,2,OpenSafeZone,TRUE,,,,1;2|3;4;5,,,,,,module/39,,0.001\r
29,关闭毒圈,,game/1,3190960,docs/api-20-29/,,CloseSafeZone,2,CloseSafeZone,TRUE,,,,,,,,,,module/39,,0.001\r
30,等待秒,,entity/1,,docs/api-1-30/,,WaitForSeconds,2,WaitForSeconds,TRUE,,,,,,,,,,action/1,,0.066\r
31,等待下一帧,,entity/1,,docs/api-1-31/,,WaitForNextFrame,2,WaitForNextFrame,TRUE,,,,,,,,,,action/1,,0.002\r
32,创建内置HUD,,entity/4,2490990,docs/api-22-32/,,CreateInternalHud,2,CreateInternalHud,TRUE,,P3=P2.EnumToType,P1=P3.InternalHudType,,3:InternalHudType;FE_3:InternalHudType,,,,,action/22,,0.008\r
33,【废弃】移除内置HUD,,entity/4,2490980,docs/api-22-33/,,RemoveInternalHud,2,RemoveInternalHud,TRUE,,,,,,3,,,,action/22,,0.001\r
34,创建自定义HUD,1,entity/4,2490970,docs/api-22-34/,,CreateCustomHud,2,CreateCustomHud,TRUE,TRUE,,,,3:Enum_CustomHud;FE_3:CustomHudID,,,,,action/22,,0.028\r
35,【废弃】移除自定义HUD,,entity/4,2490960,docs/api-22-35/,,RemoveCustomHud,2,RemoveCustomHud,TRUE,,,,,,3,,,,action/22,,0\r
36,【废弃】创建特效,,entity/1,,docs/api-1-36/,,CreateEffectEntityPlayer,2,CreateEffectEntity,TRUE,,,,,3:EffectType;1:PresentEffect,3,,,,action/1,,0.001\r
37,【废弃】创建特效-全体,,entity/1,,docs/api-1-37/,,CreateEffectEntity,2,CreateEffectEntity,TRUE,,,,1;3,3:EffectType;1:PresentEffect,3,,,,action/1,,0.001\r
38,【废弃】移除特效,,entity/1,,docs/api-1-38/,,RemoveEffectEntity,2,RemoveEffectEntity,TRUE,,,,,,3,,,,action/1,,0.001\r
39,【废弃】创建文本,,entity/1,,docs/api-1-39/,,CreateTextEntityPlayer,2,CreateTextEntity,TRUE,,,,,1:PresentText,3,,,,action/1,,0.001\r
40,【废弃】创建文本-全体,,entity/1,,docs/api-1-40/,,CreateTextEntity,2,CreateTextEntity,TRUE,,,,1;3,1:PresentText,3,,,,action/1,,0.001\r
41,【废弃】移除文本,,entity/1,,docs/api-1-41/,,RemoveTextEntity,2,RemoveTextEntity,TRUE,,,,,,3,,,,action/1,,0.001\r
42,【废弃】创建图标,,entity/1,,docs/api-1-42/,,CreateIconEntityPlayer,2,CreateIconEntity,TRUE,,,,,3:IconType;1:PresentIcon,3,,,,action/1,,0.001\r
43,【废弃】创建图标-全体,,entity/1,,docs/api-1-43/,,CreateIconEntity,2,CreateIconEntity,TRUE,,,,1;3,3:IconType;1:PresentIcon,3,,,,action/1,,0.001\r
44,【废弃】移除图标,,entity/1,,docs/api-1-44/,,RemoveIconEntity,2,RemoveIconEntity,TRUE,,,,,,3,,,,action/1,,0.001\r
45,设置玩家是否可以移动,,game/2,,docs/api-1-45/,,SetMatchCanMove,2,SetMatchCanMove,TRUE,,,,,,,,,,action/1,,0.001\r
46,修改元素-数组,,data/3,4390970,docs/api-2-46/,,SetArrayElementByIndex,2,ListSetElement,TRUE,,P3=P1.T0,P3=P1.T0,,,,,ListName[Index] = Value,,data/2,T_49_SD_SEARCHKEY_LISTSET,0.001\r
47,添加元素-数组,,data/3,4390990,docs/api-2-47/,,ListAppend,2,ListAppend,TRUE,,P2=P1.T0,P2=P1.T0,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTAPPEND,0.013\r
48,删除元素-数组,,data/3,4390980,docs/api-2-48/,,ListRemove,2,ListRemove,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTDELETE,0.009\r
49,创建物件,,entity/9,,docs/api-26-49/,,CreateLevelObject,2,CreateLevelObject,TRUE,,,P1=LevelObject P3.ItemIDToType,,3:DynamicCreateItemID,,,,,action/26,,0.013\r
50,【废弃】删除物件,,entity/9,,docs/api-26-50/,,RemoveLevelObject,2,RemoveLevelObject,TRUE,,,,,1:EntityGetter,3,,,,action/26,,0\r
51,打印日志,,entity/1,2190960,docs/api-1-51/,,PrintString,2,PrintString,TRUE,,,,,,2,,,,action/1,,0.039\r
52,给玩家添加道具,,entity/3,,docs/api-15-52/,,AddItemToCharacter,2,AddItemToCharacter,TRUE,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,action/15,,0.045\r
53,播放音效,,entity/6,,docs/api-1-53/,,NotifyPlaySound,2,NotifyPlaySound,TRUE,,,,,2:AudioType;FE_2:AudioID,,,,,action/1,,0.003\r
54,ConstFloatOrInt,,data/1,4190990,,T_34_LY_WS_VAL_DESC,ConstFloatOrInt,3,,,TRUE,,-,,,,,,,data/10000,Number,0.096\r
55,ConstString,,data/1,4190980,,T_48_JH_WS_STRINGDESC,ConstString,3,,,TRUE,,input_text,,,,,,,data/10000,T_49_SD_SEARCHKEY_TEXT,0.058\r
56,ConstVector3,,data/1,4190970,docs/api-4-56/,T_34_LY_WS_VEC_DESC,ConstVector3,3,NewVector,,TRUE,,,,,,,"Vector3{x,y,z}",,data/10000,Vector3,0.054\r
57,ConstBool,,data/1,4190960,,T_36_WZY_WS_LOGOPER,ConstBool,3,,,TRUE,,logic_boolean,,,,,,,data/10000,T_49_SD_SEARCHKEY_BOOL,0.065\r
10033,FE constPI,2,data/1,,,,ConstPI,,,,,,input_pi,,,,,NaturalConst.Pi,,data/10000,T_49_SD_SEARCHKEY_PI,0\r
10034,FE constE,2,data/1,,,,ConstE,,,,,,input_e,,,,,NaturalConst.E,,data/10000,T_49_SD_SEARCHKEY_E,0\r
58,ColorGetter,,data/1,4190950,,T_34_LY_WS_COL_DESC,ColorGetter,3,,,TRUE,,input_color,,,,,#RRGGBB,,data/10000,T_49_SD_SEARCHKEY_COLOR,0.014\r
59,EntityGetter,,data/1,4190940,,EntityGetter,EntityGetter,3,,,TRUE,,EntityGetter,,,,,,,data/10000,T_49_SD_SEARCHKEY_ENTITY,0.015\r
60,Arithmetic,,data/2,4290990,,T_36_WZY_WS_ARITHMETIC_NAMEDESC,Arithmetic,3,,,TRUE,,math_arithmetic,,,,,,,data/4,T_49_SD_SEARCHKEY_MATH,0.047\r
61,Comparer,,data/1,4180992,,T_34_WZ_WS_LOGIC2_NAMEDESC,Comparer,3,,,TRUE,,logic_compare,,,,,,,data/4,T_49_SD_SEARCHKEY_COMPARER,0.053\r
62,LogicalOperation,,data/1,4180991,,T_36_WZY_WS_LOGOPER,LogicalOperation,3,,,TRUE,,logic_operation,,,,,&& ||,,data/4,T_49_SD_SEARCHKEY_LOGICAL,0.002\r
63,脚本所在对象,,entity/1,,docs/api-1-63/,,ThisEntity,3,ThisEntity,,,,this_entity,,,,,thisEntity,,action/1,T_49_SD_SEARCHKEY_THISENTITY,0.085\r
64,所有玩家,,entity/1,2190950,docs/api-1-64/,,AllPlayers,3,AllPlayers,,,,,,,,,,,action/1,,0.017\r
65,所有队伍,,entity/1,2190940,docs/api-1-65/,,AllTeams,3,AllTeams,,,,,,,,,,,action/1,,0.003\r
66,数组长度,,data/3,4390950,docs/api-2-66/,,ArrayLength,3,ListLength,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTLENGTH,0.009\r
67,获取元素-数组,,data/3,4390960,docs/api-2-67/,,ArrayElementByIndex,3,ListGetElement,,,R=P1.T0,R=P1.T0,,,,,ListName[Index],,data/2,T_49_SD_SEARCHKEY_LISTGET,0.023\r
68,随机整数,,data/2,4290960,docs/api-4-68/,,RandomInt,3,RandomInt,,,,,,,,,,,data/4,,0.003\r
69,随机小数,,data/2,4290950,docs/api-4-69/,,RandomFloat,3,RandomFloat,,,,,,,,,,,data/4,,0.009\r
70,非空,,data/1,4180990,docs/api-1-70/,,IsNil,3,IsNil,,,,,,,,,if(value==nil),,action/1,,0.001\r
71,绝对值,,data/2,4290940,docs/api-4-71/,,Abs,3,Abs,,,,R=0 P1 ?number,,1:ConstFloatOrInt,,,,,data/4,,0\r
72,非,,data/1,4180980,docs/api-1-72/,,Not,3,Not,,,,,,,,,!,,action/1,,0.01\r
73,平方根,,data/2,4290930,docs/api-4-73/,,Sqrt,3,Sqrt,,,,,,,,,,,data/4,,0\r
74,负值,,data/2,4290920,docs/api-4-74/,,Negate,3,Negate,,,,R=0 P1 ?number,,1:ConstFloatOrInt,,,,,data/4,,0\r
75,字符串链接,,data/6,4690990,docs/api-5-75/,,StrConcat,3,StrConcat,,TRUE,,str_concat,,,,,,,data/5,T_49_SD_SEARCHKEY_CONCANT,0.012\r
76,字符串长度,,data/6,4690980,docs/api-5-76/,,StrLen,3,StrLen,,,,,,,,,,,data/5,,0.001\r
77,伤害类型,,data/8,,docs/enum/,,DamageType,4,DamageType,,,,,,,,,,,data/10001,,0.006\r
78,积分类型,,data/8,,docs/enum/,,ScoreType,4,ScoreType,,,,,,1:ScoreType=1,,,,,data/10001,,0.001\r
79,内置HUD类型,,data/8,,docs/enum/,,InternalHudType,4,InternalHudType,,,,InternalHudType,,,,,,,data/10001,T_49_SD_SEARCHKEY_INTERNALHUD,0.007\r
80,,1,data/5,4590990,docs/api-4-80/,,VectorGetX,3,VectorGetX,,,,,,,,,Vector3.X,,data/4,,0.009\r
81,,1,data/5,4590960,docs/api-4-81/,,VectorSetX,2,VectorSetX,TRUE,,,,,,,2,Vector3.X = value,,data/4,,0\r
82,,1,data/5,4590950,docs/api-4-82/,,VectorSetY,2,VectorSetY,TRUE,,,,,,,2,Vector3.Y = value,,data/4,,0.009\r
83,,1,data/5,4590940,docs/api-4-83/,,VectorSetZ,2,VectorSetZ,TRUE,,,,,,,2,Vector3.Z = value,,data/4,,0\r
84,,1,data/2,4280990,docs/api-4-84/,,VectorAdd,3,VectorAdd,,,,,,,,,"Vector3{x,y,z}+Vector3{a,b,c}",,data/4,,0.011\r
85,,1,data/2,4280980,docs/api-4-85/,,VectorSub,3,VectorSub,,,,,,,,,"Vector3{x,y,z}-Vector3{a,b,c}",,data/4,,0.009\r
86,,1,data/2,4280970,docs/api-4-86/,,VectorMul,3,VectorMul,,,,,,,,,"Vector3{x,y,z} * value",,data/4,,0\r
87,,1,data/2,4280960,docs/api-4-87/,,VectorDot,3,VectorDot,,,,,,,,,,,data/4,,0\r
88,,1,data/2,4280950,docs/api-4-88/,,VectorCross,3,VectorCross,,,,,,,,,,,data/4,,0\r
89,,,data/2,4280940,docs/api-4-89/,,VectorNormalize,3,VectorNormalize,,,,,,,,,,,data/4,,0\r
90,,,data/2,4280930,docs/api-4-90/,,VectorSize,3,VectorSize,,,,,,,,,,,data/4,,0\r
91,,1,data/2,4280920,docs/api-4-91/,,VectorDistance,3,VectorDistance,,,,,,,,,,,data/4,,0\r
92,,1,data/2,4280910,docs/api-4-92/,,VectorAngel,3,VectorAngel,,,,,,,,,,,data/4,,0\r
93,设置实体属性,,entity/1,2190990,,T_34_WT_WS_ENTITY2_NAMEDESC,SetEntityProperty,2,,TRUE,TRUE,,property_set,,,,,EntityName<{0}>.{1} = Value,,action/1,T_49_SD_SEARCHKEY_SETVALUE,0.081\r
94,获取实体属性,,entity/1,2190980,,T_34_WT_WS_ENTITY4_NAMEDESC,GetEntityProperty,3,,,TRUE,,property_get,,,,,EntityName<{0}>.{1},,action/1,T_49_SD_SEARCHKEY_GETVALUE,0.053\r
95,获得游戏实体,,entity/1,2190970,docs/api-1-95/,,GetGlobalEntity,3,GetGlobalEntity,,,,,,,,,globalEntity,,action/1,,0.003\r
96,图片类型,,data/8,,docs/enum/,,IconType,4,IconType,,,,SpriteID,,,,,,,data/10001,T_49_SD_SEARCHKEY_IMGENUM,0.003\r
97,特效类型,,data/8,,docs/enum/,,EffectType,4,EffectType,,,,EffectID,,,,,,,data/10001,T_49_SD_SEARCHKEY_EFFECTENUM,0.001\r
98,类型指定图元,,entity/1,,,T_34_WT_WS_ENTITY3_NAMEDESC,As,3,,,TRUE,R=P2,as_type,,,,,,,action/1,T_49_SD_SEARCHKEY_AS,0.017\r
99,声音类型,,data/8,,docs/enum/,,AudioType,4,AudioType,,,,AudioID,,,,,,,data/10001,T_49_SD_SEARCHKEY_AUDIOENUM,0.004\r
100,,,data/8,,docs/enum/,,SortType,4,SortType,,,,,,,1,,,,data/10001,,0.001\r
101,结束当前阶段,,game/6,,docs/api-18-101/,,EndCurrentPhase,2,EndCurrentPhase,TRUE,,,,,,,,,,module/18,,0.003\r
102,获取控件,,entity/4,2490950,docs/api-22-102/,T_34_M_WS_GETCONTROL2,GetWidgetFromCustomHud,3,GetWidgetFromCustomHud,,TRUE,,R=P3.T0,,,,,,,action/22,,0.017\r
103,【废弃】随机出生点,,game/2,,docs/api-11-103/,,GetRandomSpawnPos,3,GetRandomSpawnPos,,,,,,,3,,,,module/11,,0\r
104,【废弃】获取玩家积分,,entity/10,,docs/api-19-104/,,GetPlayerScoreByType,3,GetPlayerScoreByType,,,,,,2:ScoreType=10,,,,,action/19,,0\r
105,【废弃】设置玩家积分,,entity/10,,docs/api-19-105/,,SetPlayerScoreByType,2,SetPlayerScoreByType,TRUE,,,,,2:ScoreType=10,,,,,action/19,,0\r
106,【废弃】获取队伍积分,,entity/10,,docs/api-19-106/,,GetTeamScoreByType,3,GetTeamScoreByType,,,,,,2:ScoreType=10,,,,,action/19,,0\r
107,【废弃】设置队伍积分,,entity/10,,docs/api-19-107/,,SetTeamScoreByType,2,SetTeamScoreByType,TRUE,,,,,2:ScoreType=10,,,,,action/19,,0\r
108,【废弃】获取玩家回合积分,,entity/10,,docs/api-19-108/,,GetPlayerRoundScoreByType,3,GetPlayerRoundScoreByType,,,,,,,1,,,,action/19,,0\r
109,【废弃】获取队伍回合积分,,entity/10,,docs/api-19-109/,,GetTeamRoundScoreByType,3,GetTeamRoundScoreByType,,,,,,,1,,,,action/19,,0\r
110,【废弃】获取玩家排名,,entity/10,,docs/api-19-110/,,GetPlayerRank,3,GetPlayerRank,,,,,,,1,,,,action/19,,0\r
112,【废弃】获取队伍排名,,entity/10,,docs/api-19-112/,,GetTeamRank,3,GetTeamRank,,,,,,,1,,,,action/19,,0\r
114,【废弃】获取玩家指定回合排名,,entity/10,,docs/api-19-114/,,GetPlayerRoundRank,3,GetPlayerRoundRank,,,,,,,1,,,,action/19,,0.001\r
115,【废弃】获取队伍指定回合排名,,entity/10,,docs/api-19-115/,,GetTeamRoundRank,3,GetTeamRoundRank,,,,,,,1,,,,action/19,,0.001\r
116,检测顺序触发,,entity/9,,docs/api-26-116/,,PlayerCheckCanTriggerLevelObjectByOrder,3,PlayerCheckCanTriggerLevelObjectByOrder,,,,,,,1,,,,action/26,,0\r
117,【废弃】传送,,entity/1,,docs/api-1-117/,,TeleportPlayer,2,TeleportPlayer,TRUE,,,,,,3,,,,action/1,,0.001\r
118,造成伤害,,entity/5,,docs/api-16-118/,,EntityTakeSystemDamage,2,EntityTakeDamage,TRUE,,,,1;3;4,3:DamageType,,,,,action/16,,0.004\r
119,玩家造成伤害,,entity/5,,docs/api-16-119/,,EntityTakeDamage,2,EntityTakeDamage,TRUE,,,,,3:DamageType,,,,,action/16,,0.001\r
120,【废弃】获得队友附近的位置,,entity/1,,docs/api-1-120/,,GetTeammateNearPos,3,GetTeammateNearPos,,,,,,,3,,,,action/1,,0.001\r
121,获得实体的绑定玩家,,game/2,3290960,docs/api-1-121/,,GetEntityOwner,3,GetEntityOwner,,,,,,,,,,,action/1,,0.007\r
122,加血,,game/2,3290980,docs/api-11-122/,,PlayerAddHP,2,PlayerAddHP,TRUE,,,,,,,,,,module/11,,0.004\r
123,复活,,game/2,3290990,docs/api-11-123/,,RevivePlayer,2,RevivePlayer,TRUE,,,,,,,,,,module/11,,0.015\r
124,所有物件,,entity/9,,docs/api-26-124/,,AllLevelObjs,3,AllLevelObjs,,,R=P1 ListT >,R=P1.EnumToType ListT >,,1:Enum_LevelObjType=LevelObject,,,,,action/26,,0.001\r
125,GetLocalVar,,variable,,,,GetLocalVar,3,,,TRUE,,-,,,,,,,variable,GetLocalVar,0.072\r
126,SetLocalVar,,variable,,,,SetLocalVar,2,,TRUE,TRUE,,-,,,,,,,variable,SetLocalVar,0.01\r
127,GetSelfGraphProperty,,variable,,,,GetSelfGraphProperty,3,,,TRUE,,-,,,,,,,variable,GetSelfGraphProperty,0.051\r
128,SetSelfGraphProperty,,variable,,,,SetSelfGraphProperty,2,,TRUE,TRUE,,-,,,,,,,variable,SetSelfGraphProperty,0.05\r
129,GetGlobalGraphProperty,,variable,,,,GetGlobalGraphProperty,3,,,TRUE,,-,,,,,,,variable,GetGlobalGraphProperty,0\r
130,SetGlobalGraphProperty,,variable,,,,SetGlobalGraphProperty,2,,TRUE,TRUE,,-,,,,,,,variable,SetGlobalGraphProperty,0\r
131,DefFuncWithoutReturn,,function,,,,DefFuncWithoutReturn,2,,,TRUE,,function_definition_noreturn,,,,,,,function,T_49_SD_SEARCHKEY_ACTION,0.05\r
132,DefFuncWithReturn,,function,,,,DefFuncWithReturn,2,,,TRUE,,function_definition,,,,,,,function,T_49_SD_SEARCHKEY_FUNCTION,0.01\r
133,CallActionFunc,,function,,,,CallActionFunc,2,,TRUE,TRUE,,-,,,,,,,function,CallActionFunc,0.048\r
134,CallDataFunc,,function,,,,CallDataFunc,3,,,TRUE,,-,,,,,,,function,CallDataFunc,0.009\r
135,OnClickHudButton,,event/2,,docs/event-22-135/,T_35_M_WS_BUTTONCLICKDESC,OnClickHudButton,1,OnClick,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONCLICK,0.018\r
136,返回值 （FE=返回）,,function,,docs/api-1-136/,T_34_WZ_WS_LOGIC11_NAMEDESC,ProcessCtlReturn,2,ProcessCtlReturn,,,,-,,,,,,,action/1,,0.002\r
137,道具ID类型,,data/8,,docs/enum/,,ItemGoodsIDType,4,ItemGoodsIDType,,,,ItemID,,,,,,,data/10001,T_49_SD_SEARCHKEY_ITEMENUM,0.046\r
138,私有-创建事件,,event/2,1290990,docs/event-1-138/,,OnAwake,1,OnAwake,TRUE,,,,,,,,,,event,,0.081\r
139,私有-击杀事件,,event/2,,docs/event-16-139/,,OnKill,1,OnKill,TRUE,,,,,,,,,,event,,0.038\r
140,私有-死亡事件,,event/2,,docs/event-16-140/,,OnDamaged,1,OnDamaged,TRUE,,,,,,,,,,event,,0.046\r
141,私有-受伤事件,,event/2,,docs/event-16-141/,,OnAttacked,1,OnAttacked,TRUE,,,,,,,,,,event,,0.001\r
142,私有-造成伤害事件,,event/2,,docs/event-16-142/,,OnHurt,1,OnHurt,TRUE,,,,,,,,,,event,,0.001\r
143,私有-进入触发器事件,,event/2,,docs/event-33-143/,,OnTriggerEnter,1,OnTriggerEnter,TRUE,,,,,,,,,,event,,0.003\r
144,私有-退出触发器事件,,event/2,,docs/event-33-144/,,OnTriggerLeave,1,OnTriggerLeave,TRUE,,,,,,,,,,event,,0.001\r
145,按钮点击时,,event/2,,docs/event-22-145/,,OnClick,1,OnClick,TRUE,,,,,,,,,,event,,0\r
146,创建道具,,entity/3,,docs/api-15-146/,,AddPickUpAtPosition,2,AddPickUpAtPosition,TRUE,,,P2=ItemID|ListT_ItemID;P3=Int ListT_Int P2.IsList ?,,2:ItemGoodsIDType;FE_2:ItemID;3:ConstFloatOrInt;FE_3:Int,,,,,action/15,,0\r
147,删除道具,,entity/3,,docs/api-15-147/,,PlayerRemoveItem,2,PlayerRemoveItem,TRUE,,,,,,,,,,action/15,,0.036\r
148,,1,data/5,4590980,docs/api-4-148/,,VectorGetY,3,VectorGetY,,,,,,,,,Vector3.Y,,data/4,,0.009\r
149,,1,data/5,4590970,docs/api-4-149/,,VectorGetZ,3,VectorGetZ,,,,,,,,,Vector3.Z,,data/4,,0.009\r
150,触发私有-玩家进入事件,,event/2,,docs/event-26-150/,,OnPlayerEnter,1,OnPlayerEnter,TRUE,,,,,,,,,,event,,0.004\r
151,触发私有-玩家退出事件,,event/2,,docs/event-26-151/,,OnPlayerLeave,1,OnPlayerLeave,TRUE,,,,,,,,,,event,,0.001\r
152,移除列表元素,,data/3,4390940,docs/api-2-152/,,ListRemoveAt,2,ListRemoveAt,TRUE,,,,,,,,,,data/2,,0\r
153,临时变量定义,,variable,,,,DefLocalVar,2,,TRUE,TRUE,P1=P2;P3=P2,localvar_def,,,,,,,variable,T_49_SD_SEARCHKEY_LOCALVAR,0.048\r
154,向上取���,,data/2,4260990,docs/api-4-154/,,Ceil,3,Ceil,,,,,,,,,,,data/4,,0\r
155,向下取整,,data/2,4260980,docs/api-4-155/,,Floor,3,Floor,,,,,,,,,,,data/4,,0.009\r
156,四舍五入取整,,data/2,4260970,docs/api-4-156/,,Round,3,Round,,,,,,,,,,,data/4,,0\r
157,正弦函数,,data/2,4260960,docs/api-4-157/,,Sin,3,Sin,,,,,,,,,,,data/4,,0.009\r
158,余弦函数,,data/2,4260950,docs/api-4-158/,,Cos,3,Cos,,,,,,,,,,,data/4,,0.009\r
159,正切函数,,data/2,4260940,docs/api-4-159/,,Tan,3,Tan,,,,,,,,,,,data/4,,0\r
160,飘字,,entity/4,,docs/api-1-160/,,NotifyShowTips,2,NotifyShowTips,TRUE,,,,,3:ColorGetter,,,,,action/1,,0.002\r
161,【废弃】私有-实体进入载具,,event/2,,docs/event-26-161/,,OnEnteringVehicle,1,OnEnteringVehicle,TRUE,,,,,,3,,,,event,,0\r
162,【废弃】私有-实体离开载具,,event/2,,docs/event-26-162/,,OnLeavingVehicle,1,OnLeavingVehicle,TRUE,,,,,,3,,,,event,,0\r
163,【废弃】私有-实体驾驶载具,,event/2,,docs/event-26-163/,,OnDrivingVehicle,1,OnDrivingVehicle,TRUE,,,,,,3,,,,event,,0\r
164,私有-载具被实体进入,,event/2,,docs/event-26-164/,,OnBeEnterVehicle,1,OnBeEnterVehicle,TRUE,,,,,,,,,,event,,0\r
165,私有-载具被实体离开,,event/2,,docs/event-26-165/,,OnBeLeaveVehicle,1,OnBeLeaveVehicle,TRUE,,,,,,,,,,event,,0\r
166,私有-载具被实体驾驶,,event/2,,docs/event-26-166/,,OnBeDriveVehicle,1,OnBeDriveVehicle,TRUE,,,,,,,,,,event,,0\r
10001,输入int,2,data/1,,,,ConstInt,,,,,,input_int,,,,,,,data/10000,T_49_SD_SEARCHKEY_INT,0\r
10002,输入float,2,data/1,,,,ConstFloat,,,,,,input_float,,,,,,,data/10000,T_49_SD_SEARCHKEY_FLOAT,0\r
10003,定义LocalVar,-1,variable,,,,DefLocalVarFE,,,,,,localvar_def,,,,,,,variable,LocalVar,0\r
10006,NewList,2,data/3,4390991,docs/api-2-10006/,,NewList,3,NewList,,,,R=ListT_any,,,,,,,data/2,T_49_SD_SEARCHKEY_NEWLIST,0\r
167,【废弃】私有-实体使用传送门,,event/2,,docs/event-26-167/,,OnTeleporting,1,OnTeleporting,TRUE,,,,,,3,,,,event,,0\r
168,私有-实体被物件产生弹跳,,event/2,,docs/event-26-168/,,OnBeSpring,1,OnBeSpring,TRUE,,,,,,,,,,event,,0\r
169,私有-传送门被实体使用传送,,event/2,,docs/event-26-169/,,OnBeTeleport,1,OnBeTeleport,TRUE,,,,,,,,,,event,,0\r
170,【废弃】私有-物件对实体产生弹跳行为,,event/2,,docs/event-26-170/,,OnSpringing,1,OnSpringing,TRUE,,,,,,3,,,,event,,0\r
171,是否包含指定元素,,data/3,4390930,docs/api-2-171/,,ListContains,3,ListContains,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCONTAIN,0\r
172,追加多条元素,,data/3,4390920,docs/api-2-172/,,ListAppendRange,2,ListAppendRange,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTAPPENDRANGE,0\r
173,获取元素最先出现位置,,data/3,4390910,docs/api-2-173/,,ListIndexOf,3,ListIndexOf,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTINDEXOF,0\r
174,获取元素最后出现位置,,data/3,4390900,docs/api-2-174/,,ListLastIndexOf,3,ListLastIndexOf,,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTLASTINDEXOF,0\r
175,生成器生成单位时,,event/2,,docs/event-1-175/,,OnSpawn,1,OnSpawn,TRUE,,,,,,,,,,event,,0\r
176,刷新下一波,,entity/9,,docs/api-1-176/,,RefreshSpawnableEntity,2,RefreshSpawnableEntity,TRUE,,,,,,,,,,action/1,,0\r
177,【废弃】构造方向点,,data/2,,docs/api-4-177/,,NewDirectPoint,3,NewDirectPoint,,,,,,,3,,,,data/4,,0.001\r
178,【废弃】取方向点位置,,data/2,,docs/api-4-178/,,DirectPointGetPos,3,DirectPointGetPos,,,,,,,3,,,,data/4,,0.001\r
179,【废弃】取方向点朝向,,data/2,,docs/api-4-179/,,DirectPointGetForward,3,DirectPointGetForward,,,,,,,3,,,,data/4,,0\r
180,修改属性因子,2,entity/10,,docs/api-24-180/,,ModifyPropertyFactor,2,ModifyPropertyFactor,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,1,,,,action/24,,0.001\r
181,【废弃】清除单个属性因子,2,entity/10,,docs/api-24-181/,,ClearPropertyFactor,2,ClearPropertyFactor,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,3,,,,action/24,,0.001\r
182,清除所有属性因子,,entity/10,,docs/api-24-182/,T_36_WZY_WS_REMMODEDPRO_NAMEDESC1,ClearAllPropertyFactor,2,ClearAllPropertyFactor,TRUE,TRUE,,,,,,,,,action/24,,0\r
183,属性因子类型,,data/8,,docs/enum/,,FormulaFactorType,4,FormulaFactorType,,,,,,,1,,,,data/10001,,0.001\r
184,当换武器时,,event/2,,docs/event-15-184/,,OnWield,1,OnWield,TRUE,,,,,,,,,,event,,0.009\r
185,可动态创建物件ID,,data/8,,docs/enum/,,DynamicCreateItemID,4,DynamicCreateItemID,,,,DynamicCreateItemID,,,,,,,data/10001,T_49_SD_SEARCHKEY_DYNAMICITEMENUM,0.013\r
186,修改属性,1,entity/10,,docs/api-24-186/,T_36_WZY_WS_MODGUNPRO_NAMEDESC,ModifyFormulaProperty,2,ModifyFormulaProperty,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,,,,,action/24,,0\r
187,设置属性,1,entity/10,,docs/api-24-187/,T_36_WZY_WS_SETGUNPRO_NAMEDESC,SetFormulaProperty,2,SetFormulaProperty,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,,,,,action/24,,0\r
188,清空单个属性,1,entity/10,,docs/api-24-188/,T_36_WZY_WS_REMMODEDPRO_NAMEDESC2,ClearSingleFormulaProperty,2,ClearSingleFormulaProperty,TRUE,TRUE,,P2=P1 PropertyT >,,FE_2:FormulaProperty,,,,,action/24,,0\r
189,属性修改方式,,data/8,,docs/enum/,,PropertyModifyType,4,PropertyModifyType,,,,,,,,,,,data/10001,,0.001\r
190,【废弃】实体被机关击飞,,event/2,,docs/event-26-190/,,OnBeHitFly,1,OnBeHitFly,TRUE,,,,,,3,,,,event,,0\r
191,启用默认AI,,entity/7,,docs/api-9-191/,,EnableDefaultAI,2,EnableDefaultAI,TRUE,,,,,,,,,,action/9,,0\r
192,AI追击实体,,entity/7,,docs/api-9-192/,,AIAttackEntity,2,AIAttackEntity,TRUE,,,,,,,,,,action/9,,0\r
193,巡逻至,,entity/7,,docs/api-9-193/,,PatrolTo,2,PatrolTo,TRUE,,,,,4:PatrolStyleType,,,,,action/9,,0\r
194,巡逻,,entity/7,,docs/api-9-194/,,PatrolAlong,2,PatrolAlong,TRUE,,,,,3:PatrolType;4:PatrolStyleType,,,,,action/9,,0\r
195,获取变量类型,,entity/1,,docs/api-1-195/,,GetType,3,GetType,,,,,,,,,,,action/1,,0.001\r
196,是否类型一致,,entity/1,,docs/api-1-196/,,TypeIs,3,TypeIs,,,,,,,,,,,action/1,,0.001\r
197,是否类型一致或继承,,entity/1,,docs/api-1-197/,,IsSubClassOf,3,IsSubClassOf,,,,,,,,,,,action/1,,0\r
198,值转字符串,,data/7,4790990,docs/api-6-198/,,ToString,3,ToString,,,,,,,,,,,data/6,,0.002\r
199,【废弃】摧毁玩家物品,,entity/3,,docs/api-15-199/,,DestroyEquipment,2,DestroyEquipment,TRUE,,,,,2:InventoryType;3:EquipSlotType,3,,,,action/15,,0\r
200,当穿装备时,,event/2,,docs/event-15-200/,,OnWear,1,OnWear,TRUE,,,,,,,,,,event,,0\r
201,【废弃】当玩家被击倒,,event/2,,docs/event-16-201/,,OnKnockedDown,1,OnKnockedDown,TRUE,,,,,,,,,,event,,0\r
202,当使用物品,,event/2,,docs/event-15-202/,,OnUseItem,1,OnUseItem,TRUE,,,,,,,,,,event,,0.002\r
203,尝试获取钱包,,game/7,,docs/api-25-203/,,TryGetWalletIDByEntity,2,TryGetWalletIDByEntity,TRUE,,,,,,,,,,module/25,,0.002\r
204,创建主钱包,,game/7,,docs/api-25-204/,,NewWalletForEntity,2,NewWalletForEntity,TRUE,,,,,,,,,,module/25,,0\r
205,钱包增加货币,,game/7,,docs/api-25-205/,,IncreaseMoneyForWallet,2,IncreaseMoneyForWallet,TRUE,,,,,2:MoneyType,,,,,module/25,,0.002\r
206,钱包消耗货币,,game/7,,docs/api-25-206/,,DecreaseMoneyForWallet,2,DecreaseMoneyForWallet,TRUE,,,,,2:MoneyType,,,,,module/25,,0\r
207,钱包交易货币,,game/7,,docs/api-25-207/,,TransferMoneyForWallet,2,TransferMoneyForWallet,TRUE,,,,,2:MoneyType,,,,,module/25,,0\r
208,获取货币数量,,game/7,,docs/api-25-208/,,GetMoneyCountByWallet,3,GetMoneyCountByWallet,,,,,,2:MoneyType,,,,,module/25,,0\r
209,通过RGB获取颜色值,,data/1,4180970,docs/api-1-209/,,ColorGet,3,ColorGet,,,,,,,,,,,action/1,,0.001\r
210,私有-实体进入触发器事件,,event/2,,docs/event-1-210/,,OnEnterTrigger,1,OnEnterTrigger,TRUE,,,,,,,,,,event,,0\r
211,私有-实体退出触发器事件,,event/2,,docs/event-1-211/,,OnLeaveTrigger,1,OnLeaveTrigger,TRUE,,,,,,,,,,event,,0\r
212,获取货币实体,,game/7,,docs/api-25-212/,,GetMoneyEntityByWallet,3,GetMoneyEntityByWallet,,,,,,2:MoneyType,,,,,module/25,,0.001\r
213,当获得物品,,event/2,,docs/event-15-213/,,OnObtainItem,1,OnObtainItem,TRUE,,,,,,,,,,event,,0.004\r
214,当获得武器,,event/2,,docs/event-15-214/,,OnObtainWeapon,1,OnObtainWeapon,TRUE,,,,,,,,,,event,,0.002\r
215,私有-机关把实体击飞,,event/2,,docs/event-26-215/,,OnHitFlying,1,OnHitFlying,TRUE,,,,,,,,,,event,,0\r
216,私有-队伍团灭时,,event/2,,docs/event-16-216/,,OnACE,1,OnACE,TRUE,,,,,,,,,,event,,0.001\r
217,【废弃】私有-积分改变时,,event/2,,docs/event-19-217/,,OnRoundScoreChange,1,OnRoundScoreChange,TRUE,,,,,,,,,,event,,0\r
218,私有-复活时,,event/2,,docs/event-11-218/,,OnRevived,1,OnRevived,TRUE,,,,,,,,,,event,,0.037\r
219,物品类型,,data/8,,docs/enum/,,InventoryType,4,InventoryType,,,,,,,,,,,data/10001,,0.001\r
220,类型枚举,,data/8,,docs/enum/,,TypeEnum,4,TypeEnum,,,,,,,,,,,data/10001,,0.002\r
221,克隆物件,,entity/9,,docs/api-1-221/,,CloneEntity,2,CloneEntity,TRUE,,P2=P1,P1=P2,,2:EntityGetter;FE_2:Component,,,,,action/1,,0.002\r
222,获取所有商店,,game/7,,docs/api-25-222/,,GetAllShops,3,GetAllShops,,,,,,,,,,,module/25,,0.006\r
223,巡逻风格,,data/8,,docs/enum/,,PatrolStyleType,4,PatrolStyleType,,,,,,,,,,,data/10001,,0\r
224,巡逻方式,,data/8,,docs/enum/,,PatrolType,4,PatrolType,,,,,,,,,,,data/10001,,0\r
225,EmptyList,,data/1,4190969,docs/api--225/,T_36_M_WS_EMPTYLISTDESC,EmptyList,3,EmptyList,,TRUE,,-,,,,,,,data/2,,0.01\r
226,货币类型,,data/8,,docs/enum/,,MoneyType,4,MoneyType,,,,,,,,,,,data/10001,,0.003\r
227,列表清空,,data/3,4380990,docs/api-2-227/,,ListClear,2,ListClear,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCLEAR,0.009\r
228,列表返转,,data/3,4380980,docs/api-2-228/,,ListReverse,2,ListReverse,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTREVERSE,0\r
229,列表克隆,,data/3,4380970,docs/api-2-229/,,ListClone,3,ListClone,,,,R=P1,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCLONE,0.001\r
230,列表插入,,data/3,4380960,docs/api-2-230/,,ListInsert,2,ListInsert,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTINSERT,0.001\r
231,字符串替换,,data/6,4690970,docs/api-5-231/,,StrReplace,3,StrReplace,,,,,,,,,,,data/5,,0.001\r
232,字符串查找,,data/6,4690960,docs/api-5-232/,,StrFind,3,StrFind,,,,,,,,,,,data/5,,0\r
233,字符串截取,,data/6,4690950,docs/api-5-233/,,StrSub,3,StrSub,,,,,,,,,,,data/5,,0\r
234,列表打乱,,data/3,4380950,docs/api-2-234/,,ListShuffle,2,ListShuffle,TRUE,,,,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTSHUFFLE,0.001\r
10007,获得全局实体,-1,entity/1,2190930,docs/api-1-10007/,,GetGlobalEntityFE,3,GetGlobalEntity,,,,,,,,,,,action/1,,0\r
10008,列表初始化,2,data/3,4390993,docs/api--10008/,,ListInit,3,ListInit,,,,list_create,,,,,,,data/2,T_49_SD_SEARCHKEY_LISTCREATE,0\r
240,天空盒基础类型,,data/8,,docs/enum/,,SkyboxEnvBaseType,4,SkyboxEnvBaseType,,,,,,,,,,,data/10001,,0.002\r
241,设置天空盒,,entity/2,,docs/api-13-241/,,SetSkyboxEnv,2,SetSkyboxEnv,TRUE,,,,1,1:SkyboxEnvBaseType,,,,,action/13,,0.002\r
301,场景加载成功,2,event/1,,docs/event-13-301/,,OnSceneLoaded,1,OnSceneLoaded,TRUE,,,,,,,,,,event,,0\r
302,场景切换成功,2,event/1,,docs/event-13-302/,,OnSceneSwitchSuccessed,1,OnSceneSwitchSuccessed,TRUE,,,,,,,,,,event,,0\r
303,加载场景,2,entity/2,,docs/api-13-303/,,LoadScene,2,LoadScene,TRUE,,,,1,FE_1:SceneID,,,,,action/13,,0\r
304,卸载场景,2,entity/2,,docs/api-13-304/,,UnloadScene,2,UnloadScene,TRUE,,,,1,FE_1:SceneID,,,,,action/13,,0\r
305,切换场景,2,entity/2,,docs/api-13-305/,,SwitchScene,2,SwitchScene,TRUE,,,,1,FE_1:SceneID,,,,,action/13,,0\r
306,玩家复活来源类型,,data/8,,docs/enum/,,PlayerReviveSourceType,4,PlayerReviveSourceType,,,,,,,,,,,data/10001,,0\r
307,丢弃武器实体时,,event/2,,docs/event-15-307/,,OnDropWeapon,1,OnDropWeapon,TRUE,,,,,,,,,,event,,0.001\r
308,装备槽位类型,,data/8,,docs/enum/,,EquipSlotType,4,EquipSlotType,,,,,,,,,,,data/10001,,0.001\r
309,丢弃道具时,,event/2,,docs/event-15-309/,,OnDropItem,1,OnDropItem,TRUE,,,,,,,,,,event,,0.001\r
310,瞄准辅助类型,,data/8,,docs/enum/,,AimAssistType,4,AimAssistType,,,,,,,,,,,data/10001,,0\r
311,控制玩家语音聊天,,entity/10,,docs/api-28-311/,,MutePlayerVoice,2,MutePlayerVoice,TRUE,,,,,,,,,,action/28,,0.001\r
312,控制玩家快捷聊天,,entity/10,,docs/api-28-312/,,MutePlayerQuickChat,2,MutePlayerQuickChat,TRUE,,,,,,,,,,action/28,,0\r
313,实体筛选器,,entity/1,,docs/api-1-313/,,FilterEntities,3,FilterEntities,,,,,,,,,,,action/1,,0.001\r
314,空闲语音频道,,data/8,,docs/enum/,,FreeChatChannel,4,FreeChatChannel,,,,,,,1,,,,data/10001,,0.009\r
315,获取控件,,entity/4,2490940,docs/api-22-315/,T_34_M_WS_GETCONTROL2,GetWidgetFromCustomHudByString,3,GetWidgetFromCustomHudByString,,,,,,,,,,,action/22,,0.002\r
316,是否禁止拾取物品,,entity/3,,docs/api-15-316/,,DisablePickupItem,2,DisablePickupItem,TRUE,,,,,,,,,,action/15,,0.001\r
317,是否禁止丢弃物品,,entity/3,,docs/api-15-317/,,DisableDropItem,2,DisableDropItem,TRUE,,,,,,,,,,action/15,,0.001\r
318,创建阵营,,game/3,,docs/api-29-318/,,CreateFaction,2,CreateFaction,TRUE,,,,,,,,,,module/29,,0.001\r
319,加入阵营,,game/3,,docs/api-29-319/,,JoinFaction,2,JoinFaction,TRUE,,,,,,,,,,module/29,,0.001\r
320,获得可攻击阵营,,game/3,,docs/api-29-320/,,GetAttackableFactions,3,GetAttackableFactions,,,,,,,,,,,module/29,,0\r
321,设置可攻击阵营,,game/3,,docs/api-29-321/,,SetAttackableFaction,2,SetAttackableFaction,TRUE,,,,,,,,,,module/29,,0.001\r
322,设置可攻击玩家,,game/3,,docs/api-29-322/,,SetAttackablePlayer,2,SetAttackablePlayer,TRUE,,,,,3:AttackableOption,,,,,module/29,,0\r
323,设置可攻击队伍,,game/3,,docs/api-29-323/,,SetAttackableTeam,2,SetAttackableTeam,TRUE,,,,,,,,,,module/29,,0\r
324,获得可攻击玩家,,game/3,,docs/api-29-324/,,GetAttackablePlayer,3,GetAttackablePlayer,,,,,,,,,,,module/29,,0\r
325,足球和实体碰撞,,event/2,,docs/event-7-325/,,OnHitEntity,1,OnHitEntity,TRUE,,,,,,,,,,event,,0\r
326,被足球枪击中,,event/2,,docs/event-7-326/,,OnShootByGun,1,OnShootByGun,TRUE,,,,,,,,,,event,,0\r
327,瞄准实体时,,event/2,,docs/event-15-327/,,OnPlayerAimEntity,1,OnPlayerAimEntity,TRUE,,,,,,,,,,event,,0\r
328,实体被瞄准时,,event/2,,docs/event-15-328/,,OnEntityAimedByPlayer,1,OnEntityAimedByPlayer,TRUE,,,,,,,,,,event,,0\r
329,武器击中实体,,event/2,,docs/event-15-329/,,OnWeaponHitEntity,1,OnWeaponHitEntity,TRUE,,,,,,,,,,event,,0\r
330,实体被武器击中,,event/2,,docs/event-15-330/,,OnEntityHittedByWeapon,1,OnEntityHittedByWeapon,TRUE,,,,,,,,,,event,,0\r
331,进球时,,event/2,,docs/event-7-331/,,OnGoal,1,OnGoal,TRUE,,,,,,,,,,event,,0\r
332,琴键音乐组件类型,,data/8,,docs/enum/,,PianoMusicElementType,4,PianoMusicElementType,,,,,,,1,,,,data/10001,,0.001\r
333,Null,,data/1,4190930,docs/api--333/,T_36_JH_WS_NULL,Null,3,Null,,TRUE,,input_null,,,,,nil,,data/10000,T_49_SD_SEARCHKEY_NULL,0.007\r
334,取消伪装,,game/12,,docs/api-27-334/,,RestoreMorphTarget,2,RestoreMorphTarget,TRUE,,,,,,,,,,module/27,,0.001\r
335,变身,,game/12,,docs/api-27-335/,,MorphTargetLevelObject,2,MorphTargetLevelObject,TRUE,,,,,,,,,,module/27,,0.001\r
336,获取伪装实体,,game/12,,docs/api-27-336/,,GetMorphObjectByPlayer,3,GetMorphObjectByPlayer,,,,,,,,,,,module/27,,0.001\r
337,获取空频道,,entity/10,,docs/api-28-337/,,GetFreeChatChannel,3,GetFreeChatChannel,,,,,,1:FreeChatChannel,,,,,action/28,,0.009\r
338,获取当前频道,,entity/10,,docs/api-28-338/,,GetChatChannel,3,GetChatChannel,,,,,,,,,,,action/28,,0.001\r
339,玩家加入频道,,entity/10,,docs/api-28-339/,,JoinChatChannel,2,JoinChatChannel,TRUE,,,,,,,,,,action/28,,0.009\r
340,玩家退出频道,,entity/10,,docs/api-28-340/,,LeaveChatChannel,2,LeaveChatChannel,TRUE,,,,,,,,,,action/28,,0.001\r
341,玩家行为类型,,data/8,,docs/enum/,,PlayerBehaviorType,4,PlayerBehaviorType,,,,,,,1,,,,data/10001,,0.001\r
342,玩家行为状态,,data/8,,docs/enum/,,PlayerBehaviorStatus,4,PlayerBehaviorStatus,,,,,,,,,,,data/10001,,0.001\r
343,设置行为状态,,game/2,,docs/api-11-343/,,SetPlayerBehaviorStatus,2,SetPlayerBehaviorStatus,TRUE,,,,,2:PlayerBehaviorType;3:PlayerBehaviorStatus,,,,,module/11,,0.001\r
344,足球增加速度,,game/12,,docs/api-7-344/,,AddVelocity,2,AddVelocity,TRUE,,,,,,,,,,module/7,,0\r
345,球衣样式,,data/8,,docs/enum/,,CustomizeClothesType,4,CustomizeClothesType,,,,,,,1,,,,data/10001,,0.001\r
346,更换球衣,,game/12,,docs/api-7-346/,,ChangeCustomizeClothes,2,ChangeCustomizeClothes,TRUE,,,,,2:CustomizeClothesType,,,,,module/7,,0.001\r
347,恢复默认衣饰,,game/12,,docs/api-7-347/,,ClearCustomizeClothes,2,ClearCustomizeClothes,TRUE,,,,,,,,,,module/7,,0\r
348,Buff类型,,data/8,,docs/enum/,,BuffType,4,BuffType,,,,,,,,,,,data/10001,,0\r
349,移除实体,1,entity/1,,docs/api-1-349/,,RemoveEntity,2,RemoveEntity,TRUE,,,,,,2,,,,action/1,,0.033\r
350,添加Tag,,entity/1,,docs/api-1-350/,,AddTag,2,AddTag,TRUE,,,,,FE_2:InputTag,,,,,action/1,,0.001\r
351,删除Tag,,entity/1,,docs/api-1-351/,,RemoveTag,2,RemoveTag,TRUE,,,,,FE_2:InputTag,,,,,action/1,,0.001\r
352,包含Tag,,entity/1,,docs/api-1-352/,,HasTag,3,HasTag,TRUE,,,,,FE_2:InputTag,,,,,action/1,,0.001\r
353,敌意状态,,data/8,,docs/enum/,,AttackableOption,4,AttackableOption,,,,,,,1,,,,data/10001,,0.001\r
354,删除实体,,entity/1,,docs/api-1-354/,,DeleteEntity,2,RemoveEntity,TRUE,,,,,,,,,,action/1,,0.014\r
355,鼓点音乐组件类型,,data/8,,docs/enum/,,DrumMusicElementType,4,DrumMusicElementType,,,,,,,1,,,,data/10001,,0.001\r
356,Lead1音乐组件类型,,data/8,,docs/enum/,,Lead1MusicElementType,4,Lead1MusicElementType,,,,,,,1,,,,data/10001,,0.001\r
357,Lead2音乐组件类型,,data/8,,docs/enum/,,Lead2MusicElementType,4,Lead2MusicElementType,,,,,,,1,,,,data/10001,,0\r
358,Lead3音乐组件类型,,data/8,,docs/enum/,,Lead3MusicElementType,4,Lead3MusicElementType,,,,,,,1,,,,data/10001,,0\r
359,退出阵营,,game/3,,docs/api-29-359/,,QuitFaction,2,QuitFaction,TRUE,,,,,,1,,,,module/29,,0\r
360,足球设置位置,,game/12,,docs/api-7-360/,,SetFootballPosition,2,SetFootballPosition,TRUE,,,,,,,,,,module/7,,0\r
361,Loot点武器类型,,data/8,,docs/enum/,,LootWeaponType,4,LootWeaponType,,,,,,,,,,,data/10001,,0\r
362,反正弦函数,,data/2,4260930,docs/api-4-362/,,Asin,3,Asin,,,,,,,,,,,data/4,,0\r
363,反正余弦函数,,data/2,4260920,docs/api-4-363/,,Acos,3,Acos,,,,,,,,,,,data/4,,0\r
364,反正切函数,,data/2,4260910,docs/api-4-364/,,Atan,3,Atan,,,,,,,,,,,data/4,,0\r
365,玩家断线时,,event/1,,docs/event-11-365/,,OnPlayerDisconnect,1,OnPlayerDisconnect,TRUE,,,,,,,,,,event,,0\r
366,玩家断线重连时,,event/1,,docs/event-11-366/,,OnPlayerReconnect,1,OnPlayerReconnect,TRUE,,,,,,,,,,event,,0\r
367,创建商店,,game/7,,docs/api-25-367/,,CreateShop,2,CreateShop,TRUE,,,,,,,,,,module/25,,0.002\r
368,创建商店货架,,game/7,,docs/api-25-368/,,CreateShopShelf,2,CreateShopShelf,TRUE,,,,,,,,,,module/25,,0.001\r
369,创建商品,,game/7,,docs/api-25-369/,,CreateShopItem,2,CreateShopItem,TRUE,,,,,,,,,,module/25,,0.001\r
370,添加物品到商品,,game/7,,docs/api-25-370/,,AddItemToShopItem,2,AddItemToShopItem,TRUE,,,,,,,,,,module/25,,0.001\r
371,游戏更新时,,event/2,1290980,docs/event-1-371/,,OnUpdate,1,OnUpdate,TRUE,,,,,,,,,,event,,0.008\r
372,杀死可战斗实体,,entity/5,,docs/api-16-372/,,KillFightingEntity,2,KillFightingEntity,TRUE,,,,,,,,,,action/16,,0.005\r
373,【废弃】创建音效,,entity/6,,docs/api-1-373/,,CreateSoundEntity,2,CreateSoundEntity,TRUE,,,,,3:AudioType,3,,,,action/1,,0.001\r
374,购买商品时,,event/2,,docs/event-25-374/,,OnShopPurchase,1,OnShopPurchase,TRUE,,,,,,,,,,event,,0\r
375,贴图类型枚举,,data/8,,docs/enum/,,TextureType,4,TextureType,TRUE,,,TextureID,,,,,,,data/10001,T_49_SD_SEARCHKEY_TEXTUREID,0\r
376,武器被装备,,event/2,,docs/event-15-376/,,OnWeaponBeEquiped,1,OnWeaponBeEquiped,TRUE,,,,,,,,,,event,,0\r
377,击杀单位,,event/2,,docs/event-16-377/,,OnWeaponKillEntity,1,OnWeaponKillEntity,TRUE,,,,,,,,,,event,,0\r
378,造成伤害,,event/2,,docs/event-16-378/,,OnWeaponTakeDamage,1,OnWeaponTakeDamage,TRUE,,,,,,,,,,event,,0\r
379,更换子弹,,event/2,,docs/event-15-379/,,OnWeaponReload,1,OnWeaponReload,TRUE,,,,,,,,,,event,,0\r
380,物件分身,,game/12,,docs/api-27-380/,,CopyTargetLevelObject,2,CopyTargetLevelObject,TRUE,,,,,,,,,,module/27,,0\r
381,开火时,,event/2,,docs/event-11-381/,,OnPlayerFire,1,OnPlayerFire,TRUE,,,,,,,,,,event,,0.001\r
382,蹲下时,,event/2,,docs/event-11-382/,,OnPlayerCrouch,1,OnPlayerCrouch,TRUE,,,,,,,,,,event,,0.001\r
383,趴下时,,event/2,,docs/event-11-383/,,OnPlayerCreep,1,OnPlayerCreep,TRUE,,,,,,,,,,event,,0.001\r
384,跳起时,,event/2,,docs/event-11-384/,,OnPlayerJump,1,OnPlayerJump,TRUE,,,,,,,,,,event,,0.001\r
385,加速时,,event/2,,docs/event-11-385/,,OnPlayerSprint,1,OnPlayerSprint,TRUE,,,,,,,,,,event,,0.001\r
386,武器每次发射,,event/2,,docs/event-15-386/,,OnFiringEachBullet,1,OnFiringEachBullet,TRUE,,,,,,,,,,event,,0\r
387,获取当前相机,,game/5,,docs/api-8-387/,,GetCurrentCamera,3,GetCurrentCamera,,,,,,,1,,,,module/8,,0.001\r
388,切换相机,,game/5,,docs/api-8-388/,,SwitchCamera,2,SwitchCamera,TRUE,,,,,3:CameraTransitionType,1,,,,module/8,,0.001\r
389,创建相机,,game/5,,docs/api-8-389/,,CreateCamera,2,CreateCamera,TRUE,,,,,1:CameraType,1,,,,module/8,,0.001\r
390,球型范围判定,,game/4,,docs/api-33-390/,,IsEntityInsideSphere,3,IsEntityInsideSphere,,,,,,,,,,,module/33,,0\r
391,圆柱范围判定,,game/4,,docs/api-33-391/,,IsEntityInsideCylinder,3,IsEntityInsideCylinder,,,,,,,,,,,module/33,,0.001\r
392,方型范围判定,,game/4,,docs/api-33-392/,,IsEntityInsideBox,3,IsEntityInsideBox,,,,,,,,,,,module/33,,0\r
393,扇形范围判定,,game/4,,docs/api-33-393/,,IsEntityInsideSector,3,IsEntityInsideSector,,,,,,,,,,,module/33,,0\r
394,僵尸类型,,data/8,,docs/enum/,,AIType,4,AIType,,,,,,,,,,,data/10001,,0.001\r
395,Emote类型,,data/8,,docs/enum/,,EmoteType,4,EmoteType,EmoteType,,,,,,1,,,,data/10001,,0.004\r
396,播放Emote,,game/10,,docs/api-17-396/,,NotifyPlayEmote,2,NotifyPlayEmote,TRUE,,,,,2:EmoteType,,0,,,module/17,,0.004\r
397,暂停动作,,game/10,,docs/api-17-397/,,NotifyPauseAnimation,2,NotifyPauseAnimation,TRUE,,,,,,,0,,,module/17,,0.002\r
398,清除背包,,entity/3,,docs/api-15-398/,,ClearInventory,2,ClearInventory,TRUE,,,,,,,,,,action/15,,0.002\r
399,获取玩家背包里某个道具的数量,,entity/3,,docs/api-15-399/,,GetPlayerBagItemCount,3,GetPlayerBagItemCount,,,,,,,,,,,action/15,,0.035\r
400,摧毁玩家物品,,entity/3,,docs/api-15-400/,,DestroyEquipmentBySlot,2,DestroyEquipmentBySlot,TRUE,,,,,2:EquipSlotType,,,,,action/15,,0\r
401,设置实体跟随,,game/5,,docs/api-8-401/,,SetFollowEntity,2,SetFollowEntity,TRUE,,,,,4:CoordinateType,1,,,,module/8,,0.001\r
402,设置实体朝向,,game/5,,docs/api-8-402/,,SetWatchEntity,2,SetWatchEntity,TRUE,,,,,4:CoordinateType,1,,,,module/8,,0.001\r
403,ConstructVector3,,data/5,4590991,docs/api-4-403/,,NewVector3,3,NewVector,,,,-,,,,,"Vector3{x,y,z}",,data/4,,0.045\r
10009,FE 动态枚举 PhaseIndex,2,data/8,,docs/enum/,,PhaseIndex,4,PhaseIndex,,,,,,,,,,,data/10001,,0\r
404,相机类型,,data/8,,docs/enum/,,CameraType,4,CameraType,,,,,,,1,,,,data/10001,,0.001\r
405,清理地图物件残留,,entity/3,,docs/api-15-405/,,ClearAllLevelObjsResidual,2,ClearAllLevelObjsResidual,TRUE,,,,,,,,,,action/15,,0.004\r
406,特效贴图枚举,,data/8,,docs/enum/,,PresentEffectTexType,4,PresentEffectTexType,TRUE,,,PresentEffectTexType,,,,,,,data/10001,T_49_SD_SEARCHKEY_PREEFFECT,0\r
407,玩家进入载具,,event/2,,docs/event-26-407/,,OnEnteringVehicle_V2,1,OnEnteringVehicle_V2,TRUE,,,,,,,,,,event,,0.001\r
408,玩家离开载具,,event/2,,docs/event-26-408/,,OnLeavingVehicle_V2,1,OnLeavingVehicle_V2,TRUE,,,,,,,,,,event,,0\r
409,玩家驾驶载具,,event/2,,docs/event-26-409/,,OnDrivingVehicle_V2,1,OnDrivingVehicle_V2,TRUE,,,,,,,,,,event,,0\r
410,玩家传送,,event/2,,docs/event-26-410/,,OnTeleporting_V2,1,OnTeleporting_V2,TRUE,,,,,,,,,,event,,0\r
411,玩家发生弹跳行为,,event/2,,docs/event-26-411/,,OnSpringing_V2,1,OnSpringing_V2,TRUE,,,,,,,,,,event,,0\r
412,玩家被机关击飞,,event/2,,docs/event-26-412/,,OnBeHitFly_V2,1,OnBeHitFly_V2,TRUE,,,,,,,,,,event,,0\r
413,设置活动状态,,entity/1,,docs/api-1-413/,,SetActive,2,SetActive,TRUE,,,,,,,,,,action/1,,0.003\r
414,相机切换类型,,data/8,,docs/enum/,,CameraTransitionType,4,CameraTransitionType,,,,,,,1,,,,data/10001,,0.001\r
10010,FE Localize Key,2,data/1,,,,LocalizeKey,3,,,,,input_localization_key,,,,,"LocString{""Key"",{""param1"", ""param2"", ""param3""}}",,data/10000,T_49_SD_SEARCHKEY_LOCALKEY,0\r
10011,FE KeyEnum,-1,data/1,,,,KeyEnum,3,,,,,key_enum,,,,,,,data/10000,KeyEnum,0\r
415,设置玩家朝向,,game/2,,docs/api-11-415/,,PlayerSetForward,2,PlayerSetForward,TRUE,,,,,,,,,,module/11,,0.001\r
416,Loot点子弹类型,,data/8,,docs/enum/,,LootAmmoType,4,LootAmmoType,,,,,,,,,,,data/10001,,0\r
417,Loot点消耗品类型,,data/8,,docs/enum/,,LootConsumableItemType,4,LootConsumableItemType,,,,,,,,,,,data/10001,,0\r
418,Loot点护甲类型,,data/8,,docs/enum/,,LootArmorType,4,LootArmorType,,,,,,,,,,,data/10001,,0\r
419,Loot点投掷物类型,,data/8,,docs/enum/,,LootProjectileType,4,LootProjectileType,,,,,,,,,,,data/10001,,0\r
420,Loot点倍镜类型,,data/8,,docs/enum/,,LootSightType,4,LootSightType,,,,,,,,,,,data/10001,,0\r
421,物件移动方式,,data/8,,docs/enum/,,MoveObjectMotionType,4,MoveObjectMotionType,,,,,,,,,,,data/10001,,0\r
423,OnPressHudButton,,event/2,,docs/event-22-423/,T_39_M_WS_BUTTON_PRESSDESC,OnPressHudButton,1,OnPress,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONPRESS,0.008\r
424,按钮按下时,,event/2,,docs/event-22-424/,,OnPress,1,OnPress,TRUE,,,,,,,,,,event,,0\r
425,OnReleaseHudButton,,event/2,,docs/event-22-425/,T_39_M_WS_BUTTON_RELEASEDESC,OnReleaseHudButton,1,OnRelease,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONRELEASE,0.001\r
426,按钮抬起时,,event/2,,docs/event-22-426/,,OnRelease,1,OnRelease,TRUE,,,,,,,,,,event,,0\r
427,OnDoubleClickHudButton,,event/2,,docs/event-22-427/,T_39_M_WS_BUTTON_DOUBLECLICKDESC,OnDoubleClickHudButton,1,OnDoubleClick,,TRUE,,button_event,,,,,,,event,T_49_SD_SEARCHKEY_BUTTONDOUBLECLICK,0.003\r
428,按钮双击时,,event/2,,docs/event-22-428/,,OnDoubleClick,1,OnDoubleClick,TRUE,,,,,,,,,,event,,0\r
429,【废弃】Tween动画图元,,entity/6,,docs/api-30-429/,,CreateTween,2,CreateTween,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType,1;2;3;4|5;6;7;8,FE_2:TweenProperty;FE_6:input_bezier,3,,,,action/30,,0.001\r
430,【废弃】NewTweenCurve,,entity/6,,docs/api-30-430/,,NewTweenCurve,3,NewTweenCurve,,TRUE,,input_bezier,,,3,,,,action/30,T_49_SD_SEARCHKEY_BEZIER,0.001\r
431,JailBreakAreaBegin,2,event/2,,docs/event-10-431/,,OnJailBreakAreaBegin,1,OnJailBreakAreaBegin,TRUE,,,,,,,,,,event,,0\r
432,JailBreakAreaEnd,2,event/2,,docs/event-10-432/,,OnJailBreakAreaEnd,1,OnJailBreakAreaEnd,TRUE,,,,,,,,,,event,,0\r
433,GiveJailBreakReward,2,game/12,,docs/api-10-433/,,GiveJailBreakReward,2,GiveJailBreakReward,TRUE,,,,,1:Player;2:Int;3:Bool,,,,,module/10,,0\r
435,设置父子关系,,entity/1,,docs/api-1-435/,,SetParent,2,SetParent,TRUE,,,,,,,,,,action/1,,0.001\r
436,读取CSV全表数据,2,data/9,,docs/api-43-436/,,ReadCSVDataAll,3,ReadCSVDataAll,,,,,,FE_1:SelectCSV,,,,,data/43,,0\r
437,读取CSV表某一行数据,2,data/9,,docs/api-43-437/,,ReadCSVDataRow,3,ReadCSVDataRow,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0\r
438,读取CSV表某一列数据,2,data/9,,docs/api-43-438/,,ReadCSVDataCol,3,ReadCSVDataCol,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0\r
439,读取CSV表某单元数据,2,data/9,,docs/api-43-439/,,ReadCSVDataCell,3,ReadCSVDataCell,,,,,,FE_1:SelectCSV;2:Int=1;3:Int=1,,,,,data/43,,0\r
440,TweenStyle,,data/8,,docs/enum/,,TweenStyle,4,TweenStyle,,,,,,,,,,,data/10001,,0.001\r
441,PlayPlayable,,entity/6,,docs/api-30-441/,,PlayPlayable,2,PlayPlayable,TRUE,,,,,,,,,,action/30,,0.001\r
442,PausePlayable,,entity/6,,docs/api-30-442/,,PausePlayable,2,PausePlayable,TRUE,,,,,,,,,,action/30,,0.001\r
443,CreatePlayableTrajectory,,entity/6,,docs/api-30-443/,,CreatePlayableTrajectory,2,CreatePlayableTrajectory,TRUE,,,,5;1;2|3;4;6,,,,,,action/30,,0.001\r
444,CreatePlayablePosFollow,,entity/6,,docs/api-30-444/,,CreatePlayablePosFollow,2,CreatePlayablePosFollow,TRUE,,,,5;1;2|3;4;6,4:CoordinateType,,,,,action/30,,0.001\r
445,CreatePlayableLookAt,,entity/6,,docs/api-30-445/,,CreatePlayableLookAt,2,CreatePlayableLookAt,TRUE,,,,5;1;2|3;4;6,4:CoordinateType,,,,,action/30,,0.001\r
446,OnPlayableBegin,,event/2,,docs/event-30-446/,,OnPlayableBegin,1,OnPlayableBegin,TRUE,,,,,,,,,,event,,0\r
447,OnPlayableEnd,,event/2,,docs/event-30-447/,,OnPlayableEnd,1,OnPlayableEnd,TRUE,,,,,,,,,,event,,0\r
448,OnPlayableResume,,event/2,,docs/event-30-448/,,OnPlayableResume,1,OnPlayableResume,TRUE,,,,,,,,,,event,,0\r
449,OnPlayablePause,,event/2,,docs/event-30-449/,,OnPlayablePause,1,OnPlayablePause,TRUE,,,,,,,,,,event,,0\r
450,比赛结果,,data/8,,docs/enum/,,MatchResultType,4,MatchResultType,,,,,,,,,,,data/10001,,0.001\r
451,【废弃】设置比赛结果,,entity/10,,docs/api-19-451/,,SetMatchResult,2,SetMatchResult,TRUE,,,,,2:MatchResultType,,,,,action/19,,0\r
452,CoordinateType,,data/8,,docs/enum/,,CoordinateType,4,CoordinateType,,,,,,,,,,,data/10001,,0.001\r
453,防御塔攻击范围类型,,data/8,,docs/enum/,,MinisentryAttackRangeType,4,MinisentryAttackRangeType,,,,,,,,,,,data/10001,,0.001\r
454,Loot点足球类型,,data/8,,docs/enum/,,LootSoccerType,4,LootSoccerType,,,,,,,,,,,data/10001,,0\r
455,接收玩家自定义的事件,2,event/3,,docs/event--455/,,OnCustomEvent,1,OnCustomEvent,TRUE,TRUE,,,,,,,,,event,,0\r
456,发出玩家自定义的事件,2,event/3,,docs/api-1-456/,,DispatchCustomEvent,2,DispatchCustomEvent,TRUE,TRUE,,,,,,,,,event,,0\r
457,JailBreakPlayerJoin,2,event/2,,docs/event-10-457/,,OnJailBreakPlayerJoin,1,OnJailBreakPlayerJoin,TRUE,,,,,,,,,,event,,0\r
458,JailBreakPlayerQuit,2,event/2,,docs/event-10-458/,,OnJailBreakPlayerQuit,1,OnJailBreakPlayerQuit,TRUE,,,,,,,,,,event,,0\r
459,UpdateJailBreakMission,2,game/12,,docs/api-10-459/,,UpdateJailBreakMission,2,UpdateJailBreakMission,TRUE,,,,,1:Int;2:Int,,,,,module/10,,0\r
460,【废弃】暂停音效,,entity/6,,docs/api-1-460/,,PauseSoundEntity,2,PauseSoundEntity,TRUE,,,,,,3,,,,action/1,,0.001\r
461,【废弃】继续播放音效,,entity/6,,docs/api-1-461/,,ResumeSoundEntity,2,ResumeSoundEntity,TRUE,,,,,,3,,,,action/1,,0.001\r
462,相机投影类型,,data/8,,docs/enum/,,CameraProjectionMode,4,CameraProjectionMode,,,,,,,1,,,,data/10001,,0.001\r
463,【废弃】读取数据库值,2,game/12,,docs/api-31-463/,,ReadDBSheetValue,2,ReadDBSheetValue,TRUE,,,P4=P1.SheetType,1;2;3;4,FE_1:DataSheet,3,,,,module/31,,0\r
464,【废弃】写入数据库值,2,game/12,,docs/api-31-464/,,WriteDBSheetValue,2,WriteDBSheetValue,TRUE,,,P4=P1.SheetType,1;2;3;4,FE_1:DataSheet,3,,,,module/31,,0\r
465,【废弃】删除数据库记录,2,game/12,,docs/api-31-465/,,DeleteDBSheetValue,2,DeleteDBSheetValue,TRUE,,,,1;2;3,FE_1:DataSheet,3,,,,module/31,,0\r
466,【废弃】读取数据库排行榜值,2,game/12,,docs/api-31-466/,,ReadDBLeaderboardValue,2,ReadDBLeaderboardValue,TRUE,,,,1;2;3,FE_1:RankSheet,3,,,,module/31,,0\r
467,【废弃】写入数据库排行榜值,2,game/12,,docs/api-31-467/,,WriteDBLeaderboardValue,2,WriteDBLeaderboardValue,TRUE,,,,1;2;3,FE_1:RankSheet,3,,,,module/31,,0\r
468,【废弃】根据Key删除数据库排行榜值,2,game/12,,docs/api-31-468/,,DeleteDBLeaderboardValueByKey,2,DeleteDBLeaderboardValueByKey,TRUE,,,,1;2,FE_1:RankSheet,3,,,,module/31,,0\r
469,【废弃】根据名次删除数据库排行榜值,2,game/12,,docs/api-31-469/,,DeleteDBLeaderboardValueByOrder,2,DeleteDBLeaderboardValueByOrder,TRUE,,,,1;2,FE_1:RankSheet,3,,,,module/31,,0\r
470,【废弃】根据名次范围读取数据库排行榜值,2,game/12,,docs/api-31-470/,,ReadDBLeaderboardValuesByRange,2,ReadDBLeaderboardValuesByRange,TRUE,,,,1;2;3;4,FE_1:RankSheet,3,,,,module/31,,0\r
471,添加脚本,,entity/1,,docs/api-1-471/,,AddScript,2,AddScript,TRUE,,,,,FE_2:ScriptID,1,,,,action/1,,0.001\r
472,移除脚本,,entity/1,,docs/api-1-472/,,RemoveScript,2,RemoveScript,TRUE,,,,,FE_2:ScriptID,1,,,,action/1,,0.001\r
473,是否存在脚本,,entity/1,,docs/api-1-473/,,ExistScript,3,ExistScript,,,,,,FE_2:ScriptID,1,,,,action/1,,0.001\r
474,相机遮蔽类型,,data/8,,docs/enum/,,CameraBlockMode,4,CameraBlockMode,,,,,,,1,,,,data/10001,,0.001\r
475,SetReplicationDataSmoothly,,entity/1,,docs/api-1-475/,,SetReplicationDataSmoothly,2,SetReplicationDataSmoothly,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType,,FE_2:TweenProperty,,,,,action/1,,0.003\r
476,人物技能枚举,,data/8,,,T_49_META_TYPE_385_D,PlayerSkillType,4,,,TRUE,,PlayerSkillID,,,,,,,data/10001,T_49_SD_SEARCHKEY_PLAYERSKILLENUM,0\r
477,获取人物技能列表,,game/2,,docs/api-11-477/,,GetPlayerSkills,3,GetPlayerSkills,,,,,,,,,,,module/11,,0.002\r
478,设置人物技能列表,,game/2,,docs/api-11-478/,,SetPlayerSkills,2,SetPlayerSkills,TRUE,,,,,,,,,,module/11,,0.003\r
479,创建自定义UI控件,,entity/4,2490930,docs/api-22-479/,,CreateCustomHudWidget,2,CreateCustomHudWidget,TRUE,,,P1=HudWidget P2.WidgetType,,2:Enum_HudWidgetType,,,,,action/22,,0.001\r
480,单返回射线检测,,game/4,,docs/api-33-480/,,SingleRaycast,2,SingleRaycast,TRUE,,,,1;2;3;4|5;6;7;8;9,,,,,,module/33,,0\r
481,多返回射线检测,,game/4,,docs/api-33-481/,,MultiRaycast,2,MultiRaycast,TRUE,,,,1;2;3;4|5;6;7;8;9,,,,,,module/33,,0\r
482,【废弃】玩家骨骼枚举,,data/8,,docs/enum/,,PlayerBonesType,4,PlayerBonesType,,,,,,,3,,,,data/10001,,0.001\r
483,【废弃】设置玩家骨骼大小缩放,,game/2,,docs/api-11-483/,,SetPlayerBonesScale,2,SetPlayerBonesScale,TRUE,,,,,,3,,,,module/11,,0.001\r
484,圆形进度条倒计时结束,,event/1,,docs/event-22-484/,,OnCountdownFinished,1,OnCountdownFinished,TRUE,,,,,,1,,,,event,,0\r
485,读取CSV表某单元数据通过行数和列名,2,data/9,,docs/api-43-485/,,ReadCSVDataCellByRowAndColName,3,ReadCSVDataCellByRowAndColName,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0\r
486,从Prefab创建实体,2,entity/1,,docs/api-1-486/,,CreateEntityFromPrefab,2,CreateEntityFromPrefab,TRUE,,P2=P1,P1=P2.T0,,2:PrefabGetter,,,,,action/1,,0\r
487,私有-当拾取时,,event/2,,docs/event-15-487/,,OnPickup,1,OnPickup,TRUE,,,,,,,,,,event,,0\r
488,私有-当丢下时,,event/2,,docs/event-15-488/,,OnDrop,1,OnDrop,TRUE,,,,,,,,,,event,,0\r
489,私有-当装备时,,event/2,,docs/event-15-489/,,OnEquip,1,OnEquip,TRUE,,,,,,,,,,event,,0\r
490,私有-当地雷启动时,,event/2,,docs/event-15-490/,,OnLandmineObjStart,1,OnLandmineObjStart,TRUE,,,,,,,,,,event,,0\r
491,私有-当地雷触发时,,event/2,,docs/event-15-491/,,OnLandmineObjTrigger,1,OnLandmineObjTrigger,TRUE,,,,,,,,,,event,,0\r
492,私有-当使用时,,event/2,,docs/event-15-492/,,OnUse,1,OnUse,TRUE,,,,,,,,,,event,,0\r
493,私有-当爆炸时,,event/2,,docs/event-15-493/,,OnThrowHit,1,OnThrowHit,TRUE,,,,,,,,,,event,,0\r
494,玩家【击飞】效果,,game/2,,docs/api-11-494/,,HitFlyPlayer,2,HitFlyPlayer,TRUE,,,,,,,,,,module/11,,0.001\r
495,列表内容是否相同,,data/3,4380940,docs/api-2-495/,,ListIsEqual,3,ListIsEqual,,,,,,,,,,,data/2,,0\r
496,私有-当钩锁枪发射时,,event/2,,docs/event-15-496/,,OnFires,1,OnFires,,,,,,,,,,,event,,0\r
497,获取服务器时间戳,,game/1,3190940,docs/api-1-497/,,GetServerTime,3,GetServerTime,,,,,,,,,,,module/39,,0.001\r
498,获取服务器区域,,entity/1,,docs/api-1-498/,,GetServerRegion,3,GetServerRegion,,,,,,,,,,,action/1,,0\r
499,喷射击中时,,event/2,,docs/event-32-499/,,OnSprayedByWeapon,1,OnSprayedByWeapon,,,,,,,1,,,,event,,0\r
500,染色,,game/12,,docs/api-32-500/,,DyeingPosition,2,DyeingPosition,TRUE,,,,,,1,,,,module/32,,0.001\r
501,查询token数量,2,game/12,,docs/api-14-501/,,GetPlayerTokenNum,2,GetPlayerTokenNum,TRUE,,,,,,,,,,module/14,,0\r
502,增加玩家token,2,game/12,,docs/api-14-502/,,AddTokenToPlayer,2,AddTokenToPlayer,TRUE,,,,,,,,,,module/14,,0\r
503,消耗玩家token,2,game/12,,docs/api-14-503/,,PlayerRemoveToken,2,PlayerRemoveToken,TRUE,,,,,,,,,,module/14,,0\r
504,位置生成token,2,game/12,,docs/api-14-504/,,AddTokenAtPosition,2,AddTokenAtPosition,TRUE,,,,,,,,,,module/14,,0\r
505,返回最大数值,,data/2,4270990,docs/api-4-505/,,Max,3,Max,,,,R=0 P1 P2 ?number,,,,,,,data/4,,0.001\r
506,返回列表最大数值,,data/3,4380930,docs/api-2-506/,,ListFindMax,2,ListFindMax,TRUE,,,,,,,,,,data/2,,0.001\r
507,返回最小数值,,data/2,4270980,docs/api-4-507/,,Min,3,Min,,,,R=0 P1 P2 ?number,,,,,,,data/4,,0.001\r
508,返回列表最小数值,,data/3,4380920,docs/api-2-508/,,ListFindMin,2,ListFindMin,TRUE,,,,,,,,,,data/2,,0.001\r
509,返回插值,,data/2,4270970,docs/api-4-509/,,Lerp,3,Lerp,,,,,,,,,,,data/4,,0.001\r
510,返回限制数值,,data/2,4270960,docs/api-4-510/,,Clamp,3,Clamp,,,,R=0 P1 P2 P3 ?number,,,,,,,data/4,,0.001\r
511,取得颜色(RGBA)值通道,,data/1,4180960,docs/api-1-511/,,ColorGetChannel,2,ColorGetChannel,TRUE,,,,,,1,,,,action/1,,0.001\r
512,获取玩家服装ID,,game/10,,docs/api-17-512/,,GetPlayerClothIDByWardrobeType,3,GetPlayerClothIDByWardrobeType,,,,,,,,,,,module/17,,0.001\r
513,设置玩家服装ID,,game/10,,docs/api-17-513/,,SetPlayerClothID,2,SetPlayerClothID,TRUE,,,,,2:ClothType;FE_2:ClothID,,,,,module/17,,0.004\r
514,恢复玩家默认服装,,game/10,,docs/api-17-514/,,ReSetPlayerClothes,2,ReSetPlayerClothes,TRUE,,,,,,,,,,module/17,,0.001\r
515,根据位置获取染色状态,,game/12,,docs/api-32-515/,,GetDyeingState,3,GetDyeingState,TRUE,,,,,,1,,,,module/32,,0.001\r
516,统计染色数量图元,,game/12,,docs/api-32-516/,,GetDyeingCount,3,GetDyeingCount,TRUE,,,,,,1,,,,module/32,,0.001\r
517,对平面染色,,game/12,,docs/api-32-517/,,DyeingPlane,2,DyeingPlane,TRUE,,,,,,1,,,,module/32,,0.001\r
518,对区域染色,,game/12,,docs/api-32-518/,,DyeingArea,2,DyeingArea,TRUE,,,,,,1,,,,module/32,,0.001\r
519,切换玩家区域,,entity/2,,docs/api-13-519/,,SwitchPlayerArea,2,SwitchPlayerArea,TRUE,,,,1;2;3;4,FE_2:SceneID,1,,,,action/13,,0.001\r
520,玩家切换区域成功,,event/2,,docs/event-13-520/,,OnSwitchPlayerArea,1,OnSwitchPlayerArea,TRUE,,,,,,1,,,,event,,0\r
521,私有-停止开火时,,event/2,,docs/event-15-521/,,OnStopFire,1,OnStopFire,TRUE,,,,,,,,,,event,,0\r
522,玩家服装部件枚举,,data/8,,docs/enum/,,WardrobeType,4,WardrobeType,,,,,,,,,,,data/10001,,0.001\r
523,设置相机CullingMask,,game/5,,docs/api-8-523/,,SetCameraCullingMask,2,SetCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.001\r
524,设置相机CullingMask对某层是否可见,,game/5,,docs/api-8-524/,,AddOrRemoveCameraCullingMask,2,AddOrRemoveCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.001\r
525,染色颜色类型,,data/8,,docs/enum/,,SprayColor,4,SprayColor,,,,,,,1,,,,data/10001,,0.001\r
526,当AI开始追击时,,event/2,,docs/event-9-526/,,OnAIStartChase,1,OnAIStartChase,TRUE,,,,,,1,,,,event,,0\r
527,当AI停止追击时,,event/2,,docs/event-9-527/,,OnAIStopChase,1,OnAIStopChase,TRUE,,,,,,1,,,,event,,0\r
528,设置玩家界面显示开关,,game/2,,docs/api-11-528/,,SetPlayerHubSwitch,2,SetPlayerHubSwitch,TRUE,,,,,2:PlayerHudSwitchType;3:CommonHudSwitchValue,,,,,module/11,,0.001\r
529,玩家界面显示开关类型,,data/8,,docs/enum/,,PlayerHudSwitchType,4,PlayerHudSwitchType,,,,,,,,,,,data/10001,,0.001\r
530,获取相机CullingMask,,game/5,,docs/api-8-530/,,GetCameraCullingMask,3,GetCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0.001\r
531,获取场景对应的天空盒,,entity/2,,docs/api-13-531/,,GetSceneSkybox,3,GetSceneSkybox,,,,,,FE_1:SceneID,1,,,,action/13,,0.001\r
532,字符串转整形,,data/7,4790970,docs/api-6-532/,,String2Int,2,String2Int,TRUE,,,,,,,,,,data/6,,0.001\r
533,字符串转浮点数,,data/7,4790960,docs/api-6-533/,,String2Float,2,String2Float,TRUE,,,,,,,,,,data/6,,0.001\r
534,切换玩家武器,,entity/3,,docs/api-15-534/,,SwitchWeaponBySlot,2,SwitchWeaponBySlot,TRUE,,,,,,,,,,action/15,,0.001\r
535,切换武器槽位类型,,data/8,,docs/enum/,,SwitchWeaponEquipSlot,4,SwitchWeaponEquipSlot,,,,,,,,,,,data/10001,,0.001\r
536,获取玩家枪皮,,game/10,,docs/api-17-536/,,GetPlayerWeaponSkinIDByWeaponID,3,GetPlayerWeaponSkinIDByWeaponID,,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,module/17,,0.001\r
537,设定玩家枪皮,,game/10,,docs/api-17-537/,,SetPlayerWeaponSkinID,2,SetPlayerWeaponSkinID,TRUE,,,,,2:WeaponSkinType;FE_2: WeaponSkinID,,,,,module/17,,0.003\r
538,恢复玩家默认枪皮,,game/10,,docs/api-17-538/,,ReSetPlayerWeaponSkinByWeaponID,2,ReSetPlayerWeaponSkinByWeaponID,TRUE,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,module/17,,0\r
539,删除所有子节点,,entity/1,,docs/api-1-539/,,ClearAllChildren,2,ClearAllChildren,TRUE,,,,,,,,,,action/1,,0.001\r
540,通过ID获取子节点,,entity/1,,docs/api-1-540/,,GetChildByIndex,3,GetChildByIndex,,,,,,,,,,,action/1,,0.001\r
541,获取所有子节点,,entity/1,,docs/api-1-541/,,GetChildren,3,GetChildren,,,,,,,,,,,action/1,,0.001\r
542,获取父节点,,entity/1,,docs/api-1-542/,,GetParent,3,GetParent,,,,,,,,,,,action/1,,0.001\r
543,【已废弃】创建特效全体新,,entity/6,,docs/api-1-543/,,CreateEffectEntityNew,2,CreateEffectEntityNew,TRUE,,,,1;3,3:EffectType;FE_3:EffectID;1:EffectEntity,1,,,,action/1,,0\r
545,【已废弃】创建特效玩家新,,entity/6,,docs/api-1-545/,,CreateEffectEntityPlayerNew,2,CreateEffectEntityNew,TRUE,,,,,3:EffectType;FE_3:EffectID;1:EffectEntity,1,,,,action/1,,0.001\r
547,创建时间戳本地化字符串,,data/7,4790860,docs/api-1-547/,,CreateTimestampLocString,3,CreateTimestampLocString,,,,,,2:TimestampFormatStyle,1,,,,data/6,,0.001\r
548,时间戳格式化显示样式,,data/8,,docs/enum/,,TimestampFormatStyle,4,TimestampFormatStyle,,,,,,,1,,,,data/10001,,0.001\r
549,创建字典,,data/4,,docs/api-3-549/,,NewMap,3,NewMap,,,,map_dictionary,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPCREATE,0.001\r
550,按key获取字典值,,data/4,,docs/api-3-550/,,MapGetValue,3,MapGetValue,,,,R=P1.T1,,,1,,MapName[Key],,data/3,T_49_SD_SEARCHKEY_MAPGET,0.001\r
551,修改字典值,,data/4,,docs/api-3-551/,,MapSetValue,2,MapSetValue,TRUE,,,,,,1,,MapName[Key] = Value,,data/3,T_49_SD_SEARCHKEY_MAPSET,0.001\r
552,移除字典值,,data/4,,docs/api-3-552/,,MapRemoveValue,2,MapRemoveValue,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPREMOVE,0.001\r
553,清除字典,,data/4,,docs/api-3-553/,,MapClear,2,MapClear,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPCLEAR,0.001\r
554,获得Map长度,,data/4,,docs/api-3-554/,,MapGetLength,3,MapGetLength,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPLENGTH,0.001\r
555,通用HUD开关值,,data/8,,docs/enum/,,CommonHudSwitchValue,4,CommonHudSwitchValue,,,,,,,,,,,data/10001,,0.001\r
556,性别枚举,,data/8,,docs/enum/,,GenderType,4,GenderType,,,,,,,,,,,data/10001,,0.001\r
557,油桶爆炸时,,event/2,,docs/event-26-557/,,OnOildrumExplode,1,OnOildrumExplode,TRUE,,,,,,,,,,event,,0\r
558,创建小地图图标,,game/8,,docs/api-34-558/,,CreateMapIconEntity,2,CreateMapIconEntity,TRUE,,,,,3:IconType;1:MiniMapIcon,,,,,module/34,,0.001\r
559,OnInternalHUDClick,,event/2,,docs/event-22-559/,,OnInternalHUDClick,1,OnInternalHUDClick,TRUE,,,,,,1,,,,event,,0\r
560,客户端相机射线检测时,,event/1,,docs/event-22-560/,,OnClientCameraRayCast,1,OnClientCameraRayCast,TRUE,,,,,,,,,,event,,0\r
561,创建小地图像素,,game/8,,docs/api-34-561/,,CreateMapBitEntity,2,CreateMapBitEntity,TRUE,,,,,,,,,,module/34,,0.001\r
562,当发生碰撞时,,event/2,,docs/event-33-562/,,OnCollisionEnter,1,OnCollisionEnter,TRUE,,,,,,,,,,event,,0\r
563,当碰撞结束时,,event/2,,docs/event-33-563/,,OnCollisionExit,1,OnCollisionExit,TRUE,,,,,,,,,,event,,0\r
564,盒体扫描检测,,game/4,,docs/api-33-564/,,BoxCast,2,BoxCast,TRUE,,,,1;2;3|4;5;6;7;8,,,,,,module/33,,0.001\r
565,球体扫描检测,,game/4,,docs/api-33-565/,,SphereCast,2,SphereCast,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/33,,0\r
566,胶囊体扫描检测,,game/4,,docs/api-33-566/,,CapsuleCast,2,CapsuleCast,TRUE,,,,1;2;3;4;5|6;7;8;9,,,,,,module/33,,0.001\r
567,盒体重叠检测,,game/4,,docs/api-33-567/,,BoxOverlap,2,BoxOverlap,TRUE,,,,1;2;3|4;5;6,,,,,,module/33,,0.001\r
568,球体重叠检测,,game/4,,docs/api-33-568/,,SphereOverlap,2,SphereOverlap,TRUE,,,,1;2;3|4;5,,,,,,module/33,,0\r
569,胶囊体重叠检测,,game/4,,docs/api-33-569/,,CapsuleOverlap,2,CapsuleOverlap,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/33,,0.001\r
570,AI攻击实体,,entity/7,,docs/api-9-570/,,AIRealAttackEntity,2,AIRealAttackEntity,TRUE,,,,,,1,,,,action/9,,0.001\r
571,当AI开始攻击时,,event/2,,docs/event-9-571/,,OnAIStartAttack,1,OnAIStartAttack,TRUE,,,,,,1,,,,event,,0\r
572,当AI停止攻击时,,event/2,,docs/event-9-572/,,OnAIStopAttack,1,OnAIStopAttack,TRUE,,,,,,1,,,,event,,0\r
573,获得玩家小地图,,game/8,,docs/api-34-573/,,GetPlayerMiniMap,3,GetPlayerMiniMap,TRUE,,,,,,1,,,,module/34,,0.001\r
574,批量修改玩家服饰,,game/10,,docs/api-17-574/,,SetPlayerClothIDs,2,SetPlayerClothIDs,TRUE,,,,,,1,,,,module/17,,0.001\r
575,去除玩家服装,,game/10,,docs/api-17-575/,,RemovePlayerClothIDByWardrobeType,2,RemovePlayerClothIDByWardrobeType,TRUE,,,,,,,,,,module/17,,0.001\r
576,去除玩家枪皮,,game/10,,docs/api-17-576/,,RemovePlayerWeaponSkinByWeaponID,2,RemovePlayerWeaponSkinByWeaponID,TRUE,,,,,2:ItemGoodsIDType;FE_2:ItemID,,,,,module/17,,0.001\r
8000,是否循环重载,0,data/8,,docs/enum/,,AnimationOverrideLoopType,4,AnimationOverrideLoopType,,,,,,,,,,,data/10001,,0.002\r
8001,播放动画,0,game/9,,docs/api-35-8001/,,PlayAnimationByController,2,PlayAnimationByController,TRUE,,,,,FE_4:AnimationOverrideLoopType;4:AnimationOverrideLoopType;2:AnimStateName;3:ConstFloatOrInt=1,,,,,action/35,,0.001\r
8002,动画片段播放结束,0,event/1,,docs/event-35-8002/,,OnAnimationClipEnd,1,OnAnimationClipEnd,TRUE,,,,,,,,,,event,,0\r
8003,动画状态播放结束,0,event/1,,docs/event-35-8003/,,OnAnimationStateEnd,1,OnAnimationStateEnd,TRUE,,,,,,,,,,event,,0\r
8004,进入行为树节点,2,event/1,,docs/event-36-8004/,,OnNodeEnter,1,OnNodeEnter,TRUE,,,,,,,,,,event,,0\r
8005,退出行为树节点,2,event/1,,docs/event-36-8005/,,OnNodeExit,1,OnNodeExit,TRUE,,,,,,,,,,event,,0\r
8006,设置动画身体部位的权重,0,game/9,,docs/api-35-8006/,,SetBodyPartTrackWeight,2,SetBodyPartTrackWeight,TRUE,,,,,,,,,,action/35,,0\r
8010,Avatar换装,2,entity/10,,docs/api-37-8010/,,ChangeAvatarPart,2,ChangeAvatarPart,TRUE,,,,,,,,,,action/37,,0\r
8011,启用Avatar部件,2,entity/10,,docs/api-37-8011/,,EnableAvatarPart,2,EnableAvatarPart,TRUE,,,,,,,,,,action/37,,0\r
8012,关闭Avatar部件,2,entity/10,,docs/api-37-8012/,,DisableAvatarPart,2,DisableAvatarPart,TRUE,,,,,,,,,,action/37,,0\r
8013,切换自定角色,2,game/2,,docs/api-11-8013/,,SwitchPresetCharacterType,2,SwitchPresetCharacterType,TRUE,,,,,,,,,,module/11,,0\r
8014,播放自定表情,2,game/2,,docs/api-11-8014/,,PlayCharacterAnimationClip,2,PlayCharacterAnimationClip,TRUE,,,,,,,,,,module/11,,0\r
8015,播放自定表情高级,2,game/2,,docs/api-11-8015/,,PlayCharacterAnimationClipOverride,2,PlayCharacterAnimationClipOverride,TRUE,,,,,,,,,,module/11,,0\r
8016,【废弃】停止动画,0,game/9,,docs/api-35-8016/,,StopAnimationByController,2,StopAnimationByController,TRUE,,,,,FE_2:AnimationState,,,,,action/35,,0\r
8027,停止自定表情,2,game/2,,docs/api-11-8027/,,StopCharacterAnimationClip,2,StopCharacterAnimationClip,TRUE,,,,,,,,,,module/11,,0\r
8028,暂停自定表情,2,game/2,,docs/api-11-8028/,,PauseCharacterAnimationClip,2,PauseCharacterAnimationClip,TRUE,,,,,,,,,,module/11,,0\r
8029,恢复自定表情,2,game/2,,docs/api-11-8029/,,ResumeCharacterAnimationClip,2,ResumeCharacterAnimationClip,TRUE,,,,,,,,,,module/11,,0\r
8030,重置自定表情,2,game/2,,docs/api-11-8030/,,ResetCharacterAnimationClip,2,ResetCharacterAnimationClip,TRUE,,,,,,,,,,module/11,,0\r
8031,暂停动画,2,game/9,,docs/api-35-8031/,,PauseAnimationByController,2,PauseAnimationByController,TRUE,,,,,,,,,,action/35,,0\r
8032,恢复动画,2,game/9,,docs/api-35-8032/,,ResumeAnimationByController,2,ResumeAnimationByController,TRUE,,,,,,,,,,action/35,,0\r
8033,重置动画,2,game/9,,docs/api-35-8033/,,ResetAnimationByController,2,ResetAnimationByController,TRUE,,,,,,,,,,action/35,,0\r
8034,停止动画V2,2,game/9,,docs/api-35-8034/,,StopAnimationByControllerV2,2,StopAnimationByControllerV2,TRUE,,,,,,,,,,action/35,,0\r
8017,创建骨骼注视控制器,2,game/9,,docs/api-37-8017/,,CreateSkeletonPartLookAtController,2,CreateSkeletonPartLookAtController,TRUE,,,,,,,,,,action/35,,0\r
10015,FE 可见层级枚举 VisibilityLayer,2,data/8,,docs/enum/,,VisibilityLayer,4,VisibilityLayer,,,,,,,1,,,,data/10001,,0\r
10016,FE 枪皮类型枚举,2,data/8,,docs/enum/,,WeaponSkinID,4,WeaponSkinID,,,,WeaponSkinID,,,1,,,,data/10001,T_49_SD_SEARCHKEY_WEAPONSKINENUM,0\r
10017,FE 服装类型枚举,2,data/8,,docs/enum/,,ClothID,4,ClothID,,,,ClothID,,,1,,,,data/10001,T_49_SD_SEARCHKEY_CLOTHENUM,0\r
10018,FE 添加注释,2,entity/1,2190920,,,Comment,,,,,,input_comments,,,1,,//comment,,action/1,T_49_SD_SEARCHKEY_COMMENT,0\r
10019,FE 选择Prefab,2,data/1,,,,PrefabGetter,,,,,,PrefabGetter,,,1,,,,data/10000,T_49_SD_SEARCHKEY_PREFAB,0\r
10020,FE 选择ECA 脚本,2,data/1,,,,ScriptID,,,,,,ScriptID,,,1,,,,data/10000,T_49_SD_SEARCHKEY_SCRIPTID,0\r
10032,FE 选择行为树,2,data/1,,,,BTreeID,,,,,,BTreeID,,,,,,,data/10000,T_49_SD_SEARCHKEY_BTREEID,0\r
10021,FE 物理层级枚举 PhysicalLayer,2,data/8,,docs/enum/,,PhysicalLayer,4,PhysicalLayer,,,,,,,1,,,,data/10001,,0\r
10022,FE 裸资源收集,2,data/1,,,,RawResource,3,,,,,RawResource,,,,,,,data/10000,T_49_SD_SEARCHKEY_RAWID,0\r
10023,AI技能枚举,,data/8,,docs/enum/,,AISkillType,4,AISkillType,,,,,,,1,,,,data/10001,,0.001\r
10024,行为树节点状态,2,data/8,,docs/enum/,,BTreeNodeState,4,BTreeNodeState,,,,,,,,,,,data/10001,,0\r
10025,FE 动画状态枚举 AnimationControllerStates,-1,data/8,,docs/enum/,,AnimationControllerStates,4,AnimationControllerStates,,,,,,,1,,,,data/10001,,0\r
577,字典是否存在key,,data/4,,docs/api-3-577/,,MapContainKey,3,MapContainKey,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPCONTAIN,0.001\r
578,获取随机出生点可用位置,,game/2,,docs/api-11-578/,,GetRandomSpawnPosVec3,3,GetRandomSpawnPosVec3,,,,,,,,,,,module/11,,0.001\r
579,传送玩家,,game/2,3290970,docs/api-11-579/,,TeleportPlayerPositionAndForward,2,TeleportPlayerPositionAndForward,TRUE,,,,,,,,,,module/11,,0.014\r
580,获取队友附近位置,,game/3,,docs/api-29-580/,,GetTeammateNearPosVec3,3,GetTeammateNearPosVec3,,,,,,,,,,,module/29,,0.001\r
582,实体销毁时,,event/2,1290970,docs/event-1-582/,,OnDestroy,1,OnDestroy,TRUE,,,,,,,,,,event,,0.002\r
583,清除染色,,game/12,,docs/api-32-583/,,DyeingReset,2,DyeingReset,TRUE,,,,,,1,,,,module/32,,0.001\r
584,私有-当界面被打开时,,event/2,,docs/event-22-584/,,OnShow,1,OnShow,TRUE,,,,,,,,,,event,,0\r
585,私有-当界面被关闭时,,event/2,,docs/event-22-585/,,OnHide,1,OnHide,TRUE,,,,,,,,,,event,,0\r
586,踢出玩家,,game/2,3290950,docs/api-11-586/,,KickOutPlayer,2,KickOutPlayer,TRUE,,,,,,,,,,module/11,,0.003\r
588,buf枚举,2,data/8,,docs/enum/,,InternalBuffType,4,InternalBuffType,,,,,,,,,,,data/10001,,0\r
589,获取玩家buff列表,2,game/12,,docs/api-12-589/,,GetInternalBuffs,3,GetInternalBuffs,,,,,,,,,,,module/12,,0\r
590,添加玩家buff,2,game/12,,docs/api-12-590/,,AddInternalBuff,2,AddInternalBuff,TRUE,,,,,,,,,,module/12,,0\r
591,移除玩家buff,2,game/12,,docs/api-12-591/,,RemoveInternalBuff,2,RemoveInternalBuff,TRUE,,,,,,,,,,module/12,,0\r
592,AI使用技能,,entity/7,,docs/api-9-592/,,AICastSkill,2,AICastSkill,TRUE,,,,,2:AISkillType,1,,,,action/9,,0.001\r
593,寻路,,entity/2,,docs/api-13-593/,,FindStraightPath,2,FindStraightPath,TRUE,,,,,,,,,,action/13,,0\r
594,行为树设置黑板值,,entity/8,,docs/api-36-594/,,SetBlackBoard,2,SetBlackBoard,TRUE,,,,,,,,,,action/36,,0\r
595,行为树获取黑板值,,entity/8,,docs/api-36-595/,,GetBlackBoard,2,GetBlackBoard,TRUE,,,,,,,,,,action/36,,0\r
596,获取节点参数,,entity/8,,docs/api-36-596/,,GetBTreeNodeParam,2,GetBTreeNodeParam,TRUE,,,,,,,,,,action/36,,0\r
597,开启特殊装置,,entity/3,,docs/api-15-597/,,ToggleSpecialItemState,2,ToggleSpecialItemState,TRUE,,,,,2:SpecialItemGoodsIDType,,,,,action/15,,0\r
598,特殊道具ID类型,,data/8,,docs/enum/,,SpecialItemGoodsIDType,4,SpecialItemGoodsIDType,,,,SpecialItemGoodsIDType,,,,,,,data/10001,T_49_SD_SEARCHKEY_SPECIALITEMENUM,0.001\r
599,QuitJailBreakMiniGame,2,game/12,,docs/api-10-599/,,QuitJailBreakMiniGame,2,QuitJailBreakMiniGame,TRUE,,,,,1:Player;2:Int,,,,,module/10,,0\r
600,GiveJailBreakItem,2,game/12,,docs/api-10-600/,,GiveJailBreakItem,2,GiveJailBreakItem,TRUE,,,,,1:Player;2:Int;3:Int,,,,,module/10,,0\r
601,装备栏槽位枚举,,data/8,,docs/enum/,,EquipmentSlot,4,EquipmentSlot,,,,,,,,,,,data/10001,,0.001\r
602,获取背包道具栏中物品,,entity/3,,docs/api-15-602/,,GetPlayerItems,2,GetPlayerItems,TRUE,,,,,,,,,,action/15,,0.001\r
603,【废弃】读取累计数据,2,game/12,,docs/api-31-603/,,ReadDBAccumulatedData,2,ReadDBAccumulatedData,TRUE,,,ReadStatisticalSheetV2,1;2;3,,3,,,,module/31,,0\r
604,【废弃】写入累计数据偏移值,2,game/12,,docs/api-31-604/,,WriteDBAccumulatedDataOffset,2,WriteDBAccumulatedDataOffset,TRUE,,,WriteStatisticalSheetV2,1;2;3;4,,3,,,,module/31,,0\r
605,为玩家发放武器配件,,entity/3,,docs/api-15-605/,,AddAttachmentsToPlayer,2,AddAttachmentsToPlayer,TRUE,,,,,2:SwitchWeaponEquipSlot;3:ItemGoodsIDType;FE_3:EquipItemID_Attachment,,,,,action/15,,0\r
606,击中部位枚举,,data/8,,docs/enum/,,HitBodyPart,4,HitBodyPart,,,,,,,,,,,data/10001,,0\r
607,获取背包装备栏中物品,,entity/3,,docs/api-15-607/,,GetPlayerEquipments,2,GetPlayerEquipments,TRUE,,,,,2:EquipmentSlot,,,,,action/15,,0\r
608,读取CSV全表数据,2,game/12,,docs/api-10-608/,,ReadCSVDataAllOverMode,3,ReadCSVDataAllOverMode,,,,,,,,,,,module/10,,0\r
609,读取CSV表某一行数据,2,game/12,,docs/api-10-609/,,ReadCSVDataRowOverMode,3,ReadCSVDataRowOverMode,,,,,,2:Int=1,,,,,module/10,,0\r
610,读取CSV表某一列数据,2,game/12,,docs/api-10-610/,,ReadCSVDataColOverMode,3,ReadCSVDataColOverMode,,,,,,2:Int=1,,,,,module/10,,0\r
611,读取CSV表某单元数据,2,game/12,,docs/api-10-611/,,ReadCSVDataCellOverMode,3,ReadCSVDataCellOverMode,,,,,,2:Int=1;3:Int=1,,,,,module/10,,0\r
612,文本输入事件,,event/1,,docs/event-22-612/,,OnSyncInputText,1,OnSyncInputText,TRUE,,,,,,1,,,,event,,0\r
613,施加线性力,,game/4,,docs/api-33-613/,,AddForce,2,AddForce,TRUE,,,,,3:ForceType,1,,,,module/33,,0.001\r
614,施力于某位置,,game/4,,docs/api-33-614/,,AddForceAtPosition,2,AddForceAtPosition,TRUE,,,,,4:ForceType,1,,,,module/33,,0.001\r
615,施加力矩,,game/4,,docs/api-33-615/,,AddTorque,2,AddTorque,TRUE,,,,,3:ForceType,1,,,,module/33,,0.001\r
616,移动刚体,,game/4,,docs/api-33-616/,,MovePosition,2,MovePosition,TRUE,,,,,,1,,,,module/33,,0.001\r
617,旋转刚体,,game/4,,docs/api-33-617/,,MoveRotation,2,MoveRotation,TRUE,,,,,,1,,,,module/33,,0.001\r
10026,FE pick CustomHud ID,2,data/1,,,,CustomHudID,,,,,,CustomHudID,,,,,,,data/10000,T_49_SD_SEARCHKEY_CUSTOMHUD,0\r
10027,FE pick CustomHudWidget ID,2,data/1,,,,CustomHudWidgetID,,,,,,CustomHudWidgetID,,,,,,,data/10000,T_49_SD_SEARCHKEY_CUSTOMHUDWIDGET,0\r
618,私有-受到伤害前事件,,event/2,,docs/event-16-618/,,OnBeforeAttacked,1,OnBeforeAttacked,TRUE,,,,,,,,,,event,,0\r
10028,FE pick Attachment ID,2,data/1,,,,EquipItemID_Attachment,,,,,,EquipItemID_Attachment,,,,,,,data/10000,T_49_SD_SEARCHKEY_ATTACHMENTENUM,0\r
10029,FE pick Object3D ID,2,data/1,,,,Object3DResourceID,,,,,,Object3DResourceID,,,,,,,data/10000,T_49_SD_SEARCHKEY_RESOURCEENUM,0\r
619,UI控件填充方向枚举,,data/8,,docs/enum/,,FillDir,4,FillDir,,,,,,,,,,,data/10001,,0.001\r
620,UI控件填充类型枚举,,data/8,,docs/enum/,,FillType,4,FillType,,,,,,,,,,,data/10001,,0.001\r
621,Tween动画图元V2,,entity/6,,docs/api-30-621/,,CreateTweenV2,2,CreateTweenV2,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType;P4=P2.PropertyType,8;1;2;3|4;5;6;7;9,FE_2:TweenProperty;FE_6:input_bezier,1,,,,action/30,,0\r
622,强制玩家上车,,entity/9,,docs/api-26-622/,,GetInTheVehicle,2,GetInTheVehicle,TRUE,,,,,3:SeatType,,,,,action/26,,0.001\r
623,载具座位枚举,,data/8,,docs/enum/,,SeatType,4,SeatType,,,,,,,,,,,data/10001,,0.001\r
624,相对自身运动动画图元,,entity/6,,docs/api-30-624/,,CreateSelfRelative,2,CreateSelfRelative,TRUE,TRUE,,P2=P1 PropertyT >;P3=P2.PropertyType,7;1;2;3|4;5;6;8,FE_2:TweenProperty;FE_4:input_bezier,1,,,,action/30,,0\r
625,字体枚举,,data/8,,docs/enum/,,FontType,4,FontType,,,,,,,,,,,data/10001,,0.001\r
626,脏字过滤,,entity/1,,docs/api-1-626/,,DirtyWordFilter,3,DirtyWordFilter,,,,,,,,,,,action/1,,0.001\r
627,获取玩家车皮,,game/10,,docs/api-17-627/,,GetVehicleSkin,3,GetVehicleSkin,,,,,,,,,,,module/17,,0.001\r
628,设置玩家车皮,,game/10,,docs/api-17-628/,,SetVehicleSkin,2,SetVehicleSkin,TRUE,,,,,2:VehicleSkinType;FE_2:VehicleSkinID,,,,,module/17,,0.001\r
629,去除玩家车皮,,game/10,,docs/api-17-629/,,RemoveVehicleSkin,2,RemoveVehicleSkin,TRUE,,,,,,,,,,module/17,,0.001\r
630,恢复玩家默认车皮,,game/10,,docs/api-17-630/,,ResetVehicleSkin,2,ResetVehicleSkin,TRUE,,,,,,,,,,module/17,,0.001\r
631,请求匹配,2,game/2,,docs/api-11-631/,,RequestMatchMaking,2,RequestMatchMaking,TRUE,,,,,,,,,,module/11,,0\r
632,创建音效(new),,entity/6,,docs/api-1-632/,,CreateSoundEntityV2,2,CreateSoundEntityV2,TRUE,,,,,3:AudioType;FE_3:AudioID,,,,,action/1,,0.001\r
633,暂停音效(new),,entity/6,,docs/api-1-633/,,PauseSoundEntityV2,2,PauseSoundEntityV2,TRUE,,,,,,1,,,,action/1,,0.001\r
634,继续播放音效(new),,entity/6,,docs/api-1-634/,,ResumeSoundEntityV2,2,ResumeSoundEntityV2,TRUE,,,,,,1,,,,action/1,,0.001\r
635,设置玩家坠落伤害,,game/2,,docs/api-11-635/,,SetPlayerFallingDamage,2,SetPlayerFallingDamage,TRUE,,,,,,,,,,module/11,,0.001\r
636,查询当天token数量限制,2,game/12,,docs/api-14-636/,,GetPlayerTokenCountToday,2,GetPlayerTokenCountToday,TRUE,,,,,,,,,,module/14,,0\r
637,休眠刚体,,game/4,,docs/api-33-637/,,Sleep,2,Sleep,TRUE,,,,,,1,,,,module/33,,0.001\r
638,唤醒刚体,,game/4,,docs/api-33-638/,,Wakeup,2,Wakeup,TRUE,,,,,,1,,,,module/33,,0.001\r
639,刚体是否处于休眠,,game/4,,docs/api-33-639/,,IsSleeping,3,IsSleeping,,,,,,,1,,,,module/33,,0.001\r
640,设置刚体休眠阈值,,game/4,,docs/api-33-640/,,SetSleepThreshold,2,SetSleepThreshold,TRUE,,,,,,1,,,,module/33,,0.001\r
641,获取刚体休眠阈值,,game/4,,docs/api-33-641/,,GetSleepThreshold,3,GetSleepThreshold,,,,,,,1,,,,module/33,,0.001\r
642,设置全局刚体休眠阈值,,game/4,,docs/api-33-642/,,SetGlobalSleepThreshold,2,SetGlobalSleepThreshold,TRUE,,,,,,1,,,,module/33,,0.001\r
643,获取全局刚体休眠阈值,,game/4,,docs/api-33-643/,,GetGlobalSleepThreshold,3,GetGlobalSleepThreshold,,,,,,,1,,,,module/33,,0.001\r
644,四元数转欧拉角,,data/7,4790900,docs/api-4-644/,,QuaternionToEulerAngle,3,QuaternionToEulerAngle,TRUE,,,,,,1,,,,data/4,,0.001\r
645,欧拉角转四元数,,data/7,4790890,docs/api-4-645/,,EulerAngleToQuaternion,3,EulerAngleToQuaternion,TRUE,,,,,,1,,,,data/4,,0.001\r
646,轴角转四元数,,data/7,4790880,docs/api-4-646/,,AxisAngleToQuaternion,3,AxisAngleToQuaternion,TRUE,,,,,,1,,,,data/4,,0.001\r
647,四元数转轴角,,data/7,4790870,docs/api-4-647/,,QuaternionToAxisAngle,2,QuaternionToAxisAngle,TRUE,,,,,,1,,,,data/4,,0.001\r
648,添加Bot,,entity/1,,docs/api-1-648/,,AddBot,2,AddBot,TRUE,,,,,,,,,,action/1,,0.001\r
649,删除Bot,,entity/1,,docs/api-1-649/,,DeleteBot,2,DeleteBot,TRUE,,,,,,,,,,action/1,,0\r
650,幂运算,,data/2,4270950,docs/api-4-650/,,Exponentiation,3,Exponentiation,,,,,,,,,,,data/4,,0\r
651,对数,,data/2,4270940,docs/api-4-651/,,Log,3,Log,,,,,,,,,,,data/4,,0\r
652,方向向量转欧拉角,,data/7,4790910,docs/api-4-652/,,Vector3ToEulerAngles,3,Vector3ToEulerAngles,,,,,,,,,,,data/4,,0\r
653,获取字典所有key,,data/4,,docs/api-3-653/,,MapGetAllKeys,3,MapGetAllKeys,,,,,,,1,,,,data/3,T_49_SD_SEARCHKEY_MAPALLKEYS,0.001\r
654,切割字符串,,data/6,4680990,docs/api-5-654/,,SplitString,3,SplitString,,,,,,,,,,,data/5,,0\r
655,访问字符串中的值,,data/6,4690940,docs/api-5-655/,,StringFindAt,3,StringFindAt,,,,,,,,,,,data/5,,0\r
656,字符串转换大写,,data/6,4670990,docs/api-5-656/,,StringUpper,3,StringUpper,,,,,,,,,,,data/5,,0\r
657,字符串转换小写,,data/6,4670980,docs/api-5-657/,,StringLower,3,StringLower,,,,,,,,,,,data/5,,0\r
658,移除两侧空白字符,,data/6,4670970,docs/api-5-658/,,StringStrip,3,StringStrip,,,,,,,,,,,data/5,,0\r
659,链接字符串,,data/6,4680980,docs/api-5-659/,,StringJoin,3,StringJoin,,,,,,,,,,,data/5,,0.001\r
660,相对自身运动动画图元,,entity/6,,docs/api-30-660/,,CreateSelfRelativeFrame,2,CreateSelfRelativeFrame,TRUE,,,P2=P1 PropertyT >;P3=P2.PropertyType,5;1;2|3;4;6,FE_2:TweenProperty,1,,,,action/30,,0.001\r
661,【废弃】按战场码读取数据库值,2,game/12,,docs/api-31-661/,,ReadDBSheetValueByWorkshopCode,2,ReadDBSheetValue,TRUE,,,,,,3,,,,module/31,,0\r
662,【废弃】按战场码写入数据库值,2,game/12,,docs/api-31-662/,,WriteDBSheetValueByWorkshopCode,2,WriteDBSheetValue,TRUE,,,,,,3,,,,module/31,,0\r
663,【废弃】按战场码删除数据库记录,2,game/12,,docs/api-31-663/,,DeleteDBSheetValueByWorkshopCode,2,DeleteDBSheetValue,TRUE,,,,,,3,,,,module/31,,0\r
664,【废弃】按战场码读取数据库排行榜值,2,game/12,,docs/api-31-664/,,ReadDBLeaderboardValueByWorkshopCode,2,ReadDBLeaderboardValue,TRUE,,,,,,3,,,,module/31,,0\r
665,【废弃】按战场码写入数据库排行榜值,2,game/12,,docs/api-31-665/,,WriteDBLeaderboardValueByWorkshopCode,2,WriteDBLeaderboardValue,TRUE,,,,,,3,,,,module/31,,0\r
666,【废弃】按战场码和Key删除数据库排行榜值,2,game/12,,docs/api-31-666/,,DeleteDBLeaderboardValueByKeyAndWorkshopCode,2,DeleteDBLeaderboardValueByKey,TRUE,,,,,,3,,,,module/31,,0\r
667,【废弃】按战场码和名次删除数据库排行榜值,2,game/12,,docs/api-31-667/,,DeleteDBLeaderboardValueByOrderAndWorkshopCode,2,DeleteDBLeaderboardValueByOrder,TRUE,,,,,,3,,,,module/31,,0\r
668,【废弃】按战场码和名次范围读取数据库排行榜值,2,game/12,,docs/api-31-668/,,ReadDBLeaderboardValuesByRangeAndWorkshopCode,2,ReadDBLeaderboardValuesByRange,TRUE,,,,,,3,,,,module/31,,0\r
669,【废弃】按战场码读取累计数据,2,game/12,,docs/api-31-669/,,ReadDBAccumulatedDataByWorkshopCode,2,ReadDBAccumulatedData,TRUE,,,,,,3,,,,module/31,,0\r
670,【废弃】按战场码写入累计数据偏移值,2,game/12,,docs/api-31-670/,,WriteDBAccumulatedDataOffsetByWorkshopCode,2,WriteDBAccumulatedDataOffset,TRUE,,,WriteStatisticalSheetCrossMap,,,3,,,,module/31,,0\r
671,四元数相乘,,data/2,4250990,docs/api-4-671/,,MultiplyQuaternion,3,MultiplyQuaternion,TRUE,,,,,,1,,,,data/4,,0.001\r
672,获取目标方向的旋转,,data/2,4250980,docs/api-4-672/,,LookRotation,3,LookRotation,TRUE,,,,,,1,,,,data/4,,0.001\r
673,四元数球形插值,,data/2,4250970,docs/api-4-673/,,SlerpQuaternion,3,SlerpQuaternion,TRUE,,,,,,1,,,,data/4,,0.001\r
674,设置完成大活动任务,,game/12,,docs/api-14-674/,,CustomMissionComplete,2,CustomMissionComplete,TRUE,,,,,,1,,,,module/14,,0.001\r
675,强制玩家下车,,game/2,,docs/api-11-675/,,GetOutTheVehicle,2,GetOutTheVehicle,TRUE,,,,,,,,,,module/11,,0.001\r
676,【废弃】自定义比赛埋点日志,2,game/12,,docs/api-23-676/,,CustomMatchEventLog,2,CustomMatchEventLog,TRUE,,,,,,3,,,,module/23,,0\r
677,【废弃】自定义用户埋点日志,2,game/12,,docs/api-23-677/,,CustomUserEventLog,2,CustomUserEventLog,TRUE,,,,,,3,,,,module/23,,0\r
678,获取场景地图ID,2,entity/2,,docs/api-13-678/,,GetMapID,3,GetMapID,,,,,,FE_1:SceneID,,,,,action/13,,0\r
679,当手持时,,event/2,,docs/event-15-679/,,OnPlayerHandHeld,1,OnPlayerHandHeld,TRUE,,,,,,,,,,event,,0\r
680,当装备进装备栏时,,event/2,,docs/event-15-680/,,OnPlayerEquip,1,OnPlayerEquip,TRUE,,,,,,,,,,event,,0\r
681,格式化字符串,,data/6,4670960,docs/api-5-681/,,FormatString,3,FormatString,,,,,,,,,,,data/5,,0.001\r
682,丢弃道具,,entity/3,,docs/api-15-682/,,DropItemEntity,2,DropItemEntity,TRUE,,,,,,,,,,action/15,,0.001\r
10030,FE 车辆皮肤枚举,2,data/8,,docs/enum/,,VehicleSkinID,4,VehicleSkinID,,,,VehicleSkinID,,,1,,,,data/10001,T_49_SD_SEARCHKEY_VEHICLEENUM,0\r
683,Toggle控件状态改变时,2,event/1,,docs/event-22-683/,,OnToggleChange,1,OnToggleChange,TRUE,,,,,,,,,,event,,0\r
684,创建空投箱,,entity/9,,docs/api-41-684/,,CreateAirDropEntity,2,CreateAirDropEntity,TRUE,,,,,,,,,,action/26,,0.001\r
10031,FE 三维向量运算,2,data/2,,,,Vector3Operation,3,,,,,Vector3Operation,,,,,,,data/4,T_49_SD_SEARCHKEY_V3VOPERATION,0\r
10035,FE 获取三维向量分量,2,data/5,,,,Vector3Getter,3,,,,,Vector3Getter,,,,,,,data/4,T_49_SD_SEARCHKEY_V3VGET,0\r
10036,FE 设置三维向量分量,2,data/5,,,,Vector3Setter,2,,,,,Vector3Setter,,,,2,,,data/4,T_49_SD_SEARCHKEY_V3VSET,0\r
685,移动毒圈,,game/1,3190950,docs/api-20-685/,,MoveSafeZone,2,MoveSafeZone,TRUE,,,,1;2|3;4;5;6,,,,,,module/39,,0.001\r
686,,1,data/5,4580990,docs/api-4-686/,,Vector2GetX,3,Vector2GetX,,,,,,,,,Vector2.X,,data/4,,0.009\r
687,,1,data/5,4580980,docs/api-4-687/,,Vector2GetY,3,Vector2GetY,,,,,,,,,Vector2.Y,,data/4,,0.009\r
688,,1,data/5,4580970,docs/api-4-688/,,Vector2SetX,2,Vector2SetX,TRUE,,,,,,,2,Vector2.X = value,,data/4,,0\r
689,,1,data/5,4580960,docs/api-4-689/,,Vector2SetY,2,Vector2SetY,TRUE,,,,,,,2,Vector2.Y = value,,data/4,,0\r
690,,1,data/2,4275990,docs/api-4-690/,,Vector2Add,3,Vector2Add,,,,,,,,,"Vector2{x,y} + Vector2{a,b}",,data/4,,0.009\r
691,,1,data/2,4275980,docs/api-4-691/,,Vector2Sub,3,Vector2Sub,,,,,,,,,"Vector2{x,y} - Vector2{a,b}",,data/4,,0.009\r
692,,1,data/2,4275970,docs/api-4-692/,,Vector2Scale,3,Vector2Scale,,,,,,,,,"Vector2{x,y} * value",,data/4,,0.009\r
693,,1,data/2,4275960,docs/api-4-693/,,Vector2Dot,3,Vector2Dot,,,,,,,,,,,data/4,,0.009\r
694,,1,data/2,4275950,docs/api-4-694/,,Vector2Distance,3,Vector2Distance,,,,,,,,,,,data/4,,0\r
695,,1,data/2,4275940,docs/api-4-695/,,Vector2Angle,3,Vector2Angle,,,,,,,,,,,data/4,,0\r
696,,,data/2,4275930,docs/api-4-696/,,Vector2Normalize,3,Vector2Normalize,,,,,,,,,,,data/4,,0\r
697,,,data/2,4275920,docs/api-4-697/,,Vector2Magnitude,3,Vector2Magnitude,,,,,,,,,,,data/4,,0\r
698,,,data/2,4275910,docs/api-4-698/,,Vector2Reflect,3,Vector2Reflect,,,,,,,,,,,data/4,,0\r
699,,,data/2,4275900,docs/api-4-699/,,Vector3Reflect,3,Vector3Reflect,,,,,,,,,,,data/4,,0\r
700,,,data/7,4790940,docs/api-6-700/,,Vector3ToVector2,3,Vector3ToVector2,,,,,,,,,,,data/6,,0\r
701,,,data/7,4790930,docs/api-6-701/,,Vector2ToVector3,3,Vector2ToVector3,,,,,,,,,,,data/6,,0\r
702,,,data/5,4580991,docs/api-4-702/,,NewVector2,3,NewVector2,,,,,,,,,"Vector2{x,y}",,data/4,,0.01\r
703,创建伤害跳字,,entity/4,,docs/api-1-703/,,CreateUGCDamageNum,2,CreateUGCDamageNum,TRUE,,,,,,,,,,action/1,,0\r
704,自定义比赛埋点日志,2,game/12,,docs/api-23-704/,,AddGameEventLogMap,2,AddGameEventLogMap,TRUE,,,,,,,,,,module/23,,0\r
705,自定义用户埋点日志,2,game/12,,docs/api-23-705/,,AddUserEventLogMap,2,AddUserEventLogMap,TRUE,,,,,,,,,,module/23,,0\r
10037,FE 二维向量运算,2,data/2,,,,Vector2Operation,3,,,,,Vector2Operation,,,,,,,data/4,T_49_SD_SEARCHKEY_V2VOPERATION,0\r
10038,FE 获取二维向量分量,2,data/5,,,,Vector2Getter,3,,,,,Vector2Getter,,,,,,,data/4,T_49_SD_SEARCHKEY_V2VGET,0\r
10039,FE 设置二维向量分量,2,data/5,,,,Vector2Setter,2,,,,,Vector2Setter,,,,2,,,data/4,T_49_SD_SEARCHKEY_V2VSET,0\r
706,请求购买类型,,data/8,,docs/enum/,,RequestPurchaseType,4,RequestPurchaseType,,,,,,,1,,,,data/10001,,0.001\r
707,开始移动时,,event/2,,docs/event-11-707/,,OnPlayerMove,1,OnPlayerMove,TRUE,,,,,,,,,,event,,0.001\r
708,进入待机时,,event/2,,docs/event-11-708/,,OnPlayerIdle,1,OnPlayerIdle,TRUE,,,,,,,,,,event,,0.001\r
709,玩家姿态枚举,,data/8,,docs/enum/,,PlayerPhysXPoseType,4,PlayerPhysXPoseType,,,,,,,,,,,data/10001,,0\r
710,当使用技能时,2,event/2,,docs/event-11-710/,,OnPlayerUseSkill,1,OnPlayerUseSkill,TRUE,,,,,,1,,,,event,,0\r
711,查询自定义任务进度,2,game/12,,docs/api-14-711/,,GetCustomMissionProgress,3,GetCustomMissionProgress,,,,,,,1,,,,module/14,,0\r
10040,FE 选择PlayerDataID,2,data/1,,,,PlayerDataID,3,,,,,PlayerDataID,,,,,,,data/10000,T_49_SD_SEARCHKEY_PLAYERDATAID,0\r
10041,FE 选择AnimationClipID,2,data/1,,,,AnimationClipID,3,,,,,AnimationClipID,,,,,,,data/10000,T_49_SD_SEARCHKEY_ANICLIPID,0\r
10042,FE 选择CSV文件,2,data/1,,,,SelectCSV,3,,,,,SelectCSV,,,,,,,data/10000,T_49_SD_SEARCHKEY_GETCSV,0\r
712,购买商品前,,event/2,,docs/event-25-712/,,OnBeforeShopPurchase,1,OnBeforeShopPurchase,TRUE,,,,,,,,,,event,,0\r
713,当角色控制器触碰实体时,,event/2,,docs/event-33-713/,,OnControllerColliderHit,1,OnControllerColliderHit,TRUE,,,,,,1,,,,event,,0\r
714,打印警告信息,1,entity/1,,docs/api-1-714/,,PrintWarning,2,PrintWarning,TRUE,,,,,,,,,,action/1,,0.001\r
715,打印错误信息,1,entity/1,,docs/api-1-715/,,PrintError,2,PrintError,TRUE,,,,,,,,,,action/1,,0.001\r
716,Curve采样,,entity/6,,docs/api-30-716/,,CurveEvaluate,3,CurveEvaluate,TRUE,,,,,FE_1:input_bezier,,,,,action/30,,0.001\r
717,TouchPad控件按下时,2,event/1,,docs/event-22-717/,,OnTouchDown,1,OnTouchDown,TRUE,,,,,,,,,,event,,0\r
718,TouchPad控件抬起时,2,event/1,,docs/event-22-718/,,OnTouchUp,1,OnTouchUp,TRUE,,,,,,,,,,event,,0\r
719,TouchPad控件开始滑动时,2,event/1,,docs/event-22-719/,,OnDragStart,1,OnDragStart,TRUE,,,,,,,,,,event,,0\r
720,TouchPad控件滑动时,2,event/1,,docs/event-22-720/,,OnDrag,1,OnDrag,TRUE,,,,,,,,,,event,,0\r
721,TouchPad控件滑动结束时,2,event/1,,docs/event-22-721/,,OnDragEnd,1,OnDragEnd,TRUE,,,,,,,,,,event,,0\r
723,Joystick控件按下时,2,event/1,,docs/event-22-723/,,OnPressed,1,OnPressed,TRUE,,,,,,,,,,event,,0\r
724,Joystick控件释放时,2,event/1,,docs/event-22-724/,,OnReleased,1,OnReleased,TRUE,,,,,,,,,,event,,0\r
725,Joystick控件移动时,2,event/1,,docs/event-22-725/,,OnMove,1,OnMove,TRUE,,,,,,,,,,event,,0\r
726,背包皮肤ID,2,game/10,,docs/api--726/,,BagSkinID,3,BagSkinID,,,,BagSkinID,,,,,,,data/10000,T_49_SD_SEARCHKEY_BAGSKINID,0\r
727,设置玩家背包皮肤ID,,game/10,,docs/api-17-727/,,SetBagSkinID,2,SetBagSkinID,TRUE,,,,,2:BagSkinType;FE_2:BagSkinID,,,,,module/17,,0\r
728,获取玩家背包皮肤ID,,game/10,,docs/api-17-728/,,GetBagSkinID,3,GetBagSkinID,,,,,,,,,,,module/17,,0\r
729,重置玩家背包皮肤ID,,game/10,,docs/api-17-729/,,ResetBagSkinID,2,ResetBagSkinID,TRUE,,,,,,,,,,module/17,,0\r
730,移除玩家背包皮肤ID,,game/10,,docs/api-17-730/,,RemoveBagSkinID,2,RemoveBagSkinID,TRUE,,,,,,,,,,module/17,,0\r
731,通过Curve获取运算值,,entity/6,,docs/api-30-731/,,GetResultFromCurve,3,GetResultFromCurve,,,,P2=P1.EnumToType;P3=P1.EnumToType;R=P1.EnumToType,,FE_4:input_bezier,,,,,action/30,,0\r
10043,FE 区分日志类型的打印,2,entity/1,,,,PrintInfo,2,,,,,PrintInfo,,,,,,,action/1,T_49_SD_SEARCHKEY_LOGINFO,0\r
10044,FE 设置客户端父子关系,,entity/1,,docs/api-1-10044/,,SetParentClient,2,SetParentClient,TRUE,,,,,,,,,,action/1,,0\r
10045,FE 获取挂载点,2,entity/10,,docs/api-37-10045/,,GetMountPoint,3,GetMountPoint,TRUE,,,,,,,,,,action/37,,0\r
732,站起时,,event/2,,docs/event-11-732/,,OnPlayerStand,1,OnPlayerStand,TRUE,,,,,,,,,,event,,0\r
733,Hud设置父子关系,,entity/4,2490920,docs/api-22-733/,,SetHudWidgetParent,2,SetHudWidgetParent,TRUE,,,,,,,,,,action/22,,0.001\r
734,根据相机和触点得到射线,,game/5,,docs/api-8-734/,,CameraTouchRay,2,CameraTouchRay,TRUE,,,,,,,,,,module/8,,0\r
735,播放icon动画效果,,entity/4,,docs/api-1-735/,,NotifyIconAnimation,2,NotifyIconAnimation,TRUE,,,,1;2;3;4|5;6;7;8,,,,,,action/1,,0\r
736,【废弃】移动角色控制器,,game/4,,docs/api-33-736/,,CCTMove,2,CCTMove,TRUE,,,,,,,,,,module/33,,0\r
737,上传自定义结算信息,,entity/10,,docs/api-1-737/,,UploadMatchResult,2,UploadMatchResult,TRUE,,,,,,,,,,action/19,,0\r
738,世界坐标转换成屏幕坐标,,game/5,,docs/api-8-738/,,WorldToScreenPoint,2,WorldToScreenPoint,TRUE,,,,,,,,,,module/8,,0\r
739,屏幕坐标转换成世界坐标,,game/5,,docs/api-8-739/,,ScreenToWorldPoint,2,ScreenToWorldPoint,TRUE,,,,,,,,,,module/8,,0\r
740,屏幕触控单反回射线检测,,game/5,,docs/api-8-740/,,CameraSingleRaycast,2,CameraSingleRaycast,TRUE,,,,,,,,,,module/8,,0\r
741,屏幕触控多反回射线检测,,game/5,,docs/api-8-741/,,CameraMultiRaycast,2,CameraMultiRaycast,TRUE,,,,,,,,,,module/8,,0\r
742,创建音效,,entity/6,,docs/api-30-742/,,CreateSoundEntityV3,2,CreateSoundEntityV3,TRUE,,,,1;2;3|4;5,,,,,,action/30,,0.001\r
743,创建特效,,entity/6,,docs/api-30-743/,,CreateEffectEntityV2,2,CreateEffectEntityV2,TRUE,,,,1;2;3|4;5,,,,,,action/30,,0\r
10046,FE 选择场景,2,data/1,,docs/api--10046/,,SceneID,3,SceneID,TRUE,,,SceneID,,,,,,,data/10000,T_49_SD_SEARCHKEY_SCENEENUM,0\r
744,反正切函数(坐标),,data/2,4260900,docs/api-4-744/,,Atan2,3,Atan2,,,,,,,,,,,data/4,,0\r
745,读取CSV表某一行数据通过列数和内容,2,data/9,,docs/api-43-745/,,ReadCSVDataRowByKey,3,ReadCSVDataRowByKey,,,,,,FE_1:SelectCSV;2:Int=1,,,,,data/43,,0\r
746,获得实体所属阵营,,game/3,,docs/api-29-746/,,GetFaction,3,GetFaction,,,,,,,,,,,module/29,,0\r
747,实体A是否可以攻击实体B,,game/3,,docs/api-29-747/,,IsActualAttackAble,3,IsActualAttackAble,,,,,,,,,,,module/29,,0\r
748,设置可攻击实体,,game/3,,docs/api-29-748/,,SetActualAttackAbleEntity,2,SetActualAttackAbleEntity,TRUE,,,,,3:AttackableOption,,,,,module/29,,0\r
749,获得可攻击实体列表,,game/3,,docs/api-29-749/,,GetActualAttackAbleEntity,3,GetActualAttackAbleEntity,,,,,,,,,,,module/29,,0\r
10047,访问资产注册属性,2,data/1,,,,FEAssetsRegister,,,,,,PickRegisteredAsset,,,,,,,data/10000,T_49_SD_SEARCHKEY_GETREGISTERED,0\r
10048,技能枚举,2,data/8,,,,PlayerSkillID,4,,,,,PlayerSkillID,,,,,,,data/10001,T_49_SD_SEARCHKEY_PLAYERSKILLENUM,0\r
750,通过列名读取CSV表某一列数,2,data/9,,docs/api-43-750/,,ReadCSVDataColIntByName,3,ReadCSVDataColIntByName,,,,,,FE_1:SelectCSV,,,,,data/43,,0\r
751,实体是否存在组件,,entity/1,,docs/api-1-751/,,HasComponent,3,HasComponent,,,,,,FE_2:ComponentID,,,,,action/1,,0\r
752,向实体添加组件,2,entity/1,,docs/api-1-752/,,AddComponent,2,AddComponent,TRUE,,,,,FE_2:ComponentID,,,,,action/1,,0\r
753,从实体删除组件,2,entity/1,,docs/api-1-753/,,RemoveComponent,2,RemoveComponent,TRUE,,,,,FE_2:ComponentID,,,,,action/1,,0\r
754,重置运动实体,,entity/6,2690990,docs/api-30-754/,,ResetPlayable,2,ResetPlayable,TRUE,,,,,,,,,,action/30,,0\r
755,应用中退界面配置,2,entity/4,,docs/api-1-755/,,ApplyQuitMidwayHudConfig,2,ApplyQuitMidwayHudConfig,TRUE,,,,,,,,,,action/1,,0\r
756,创建客户端自定义HUD,1,entity/4,2490910,docs/api-22-756/,,CreateCustomHudClient,2,CreateCustomHudClient,TRUE,TRUE,,,,2:Enum_CustomHud;FE_2:CustomHudID,,,,,action/22,,0\r
757,创建客户端特效,,entity/6,,docs/api-30-757/,,CreateEffectEntityClient,2,CreateEffectEntityClient,TRUE,,,,,,,,,,action/30,,0\r
758,创建客户端内置HUD,,entity/4,2490900,docs/api-22-758/,,CreateInternalHudClient,2,CreateInternalHudClient,TRUE,,P2=P1.EnumToType,P1=P2.InternalHudType,,2:InternalHudType;FE_2:InternalHudType,1,,,,action/22,,0\r
759,创建客户端音效,,entity/6,,docs/api-30-759/,,CreateSoundEntityClient,2,CreateSoundEntityClient,TRUE,,,,,,,,,,action/30,,0\r
760,当前玩家,2,entity/1,,docs/api-1-760/,,LocalPlayer,3,LocalPlayer,,,,,,,,,,,action/1,,0\r
10049,组件ID,2,data/1,,,,ComponentID,2,,TRUE,,,ComponentID,,,,,,,data/10000,T_49_SD_SEARCHKEY_COMPONENTENUM,0\r
10050,类型ID,2,data/1,,,,TypeID,2,,TRUE,,,Type,,,,,,,data/10000,T_49_SD_SEARCHKEY_TYPEENUM,0\r
761,击倒状态枚举,,data/8,,docs/enum/,,KnockDownStateType,4,KnockDownStateType,,,,,,,,,,,data/10001,,0.045\r
762,当使用水上滑板时,,event/2,,docs/event-11-762/,,OnPlayerSwimSurfing,1,OnPlayerSwimSurfing,TRUE,,,,,,,,,,event,,0\r
763,当结束使用水上滑板时,,event/2,,docs/event-11-763/,,OnPlayerStopSwimSurfing,1,OnPlayerStopSwimSurfing,TRUE,,,,,,,,,,event,,0\r
764,当结束冲刺时,,event/2,,docs/event-11-764/,,OnPlayerStopDash,1,OnPlayerStopDash,TRUE,,,,,,,,,,event,,0\r
765,AI攻击模式枚举,,data/8,,docs/enum/,,ActionType,4,ActionType,,,,,,,,,,,data/10001,,0\r
766,创建僵尸,,entity/7,,docs/api-9-766/,,CreateZombie,2,CreateZombie,TRUE,,,,1;2;3;4|5;6;7,3:AIType;6:ActionType,,,,,action/9,,0\r
767,开火类型,,data/8,,docs/enum/,,FireType,4,FireType,,,,,,,,,,,data/10001,,0\r
768,造成伤害前,,event/2,,docs/event-16-768/,,OnBeforeHurt,1,OnBeforeHurt,TRUE,,,,,,,,,,event,,0\r
769,获取本地的瞄准方向,,game/2,,docs/api-11-769/,,GetLocalAimDirection,3,GetLocalAimDirection,,,,,,,,,,,module/11,,0\r
770,获取本地时间戳,,game/1,3190930,docs/api-44-770/,,GetLocalTimestamp,3,GetLocalTimestamp,,,,,,,,,,,module/39,,0\r
771,,1,data/5,4590961,docs/api-4-771/,,VectorSetXClient,3,VectorSetXClient,,,,,,,,1,Vector3.X = value,,data/4,,0\r
772,,1,data/5,4590951,docs/api-4-772/,,VectorSetYClient,3,VectorSetYClient,,,,,,,,1,Vector3.Y = value,,data/4,,0\r
773,,1,data/5,4590941,docs/api-4-773/,,VectorSetZClient,3,VectorSetZClient,,,,,,,,1,Vector3.Z = value,,data/4,,0\r
774,,1,data/5,4580971,docs/api-4-774/,,Vector2SetXClient,3,Vector2SetXClient,,,,,,,,1,Vector2.X = value,,data/4,,0\r
775,,1,data/5,4580961,docs/api-4-775/,,Vector2SetYClient,3,Vector2SetYClient,,,,,,,,1,Vector2.Y = value,,data/4,,0\r
776,固定帧更新时,,event/1,,docs/event-44-776/,,OnFixedUpdate,1,OnFixedUpdate,TRUE,,,,,,,,,,event,,0\r
777,游戏暂停时,,event/1,,docs/event-44-777/,,OnGamePause,1,OnGamePause,TRUE,,,,,,,,,,event,,0\r
778,游戏恢复时,,event/1,,docs/event-44-778/,,OnGameResume,1,OnGameResume,TRUE,,,,,,,,,,event,,0.001\r
779,暂停游戏,,game/1,3190990,docs/api-44-779/,,PauseGame,2,PauseGame,TRUE,,,,,,,,,,module/39,,0\r
780,判断好友关系,2,game/12,,docs/api-22-780/,,IsFriend,3,IsFriend,,,,,,,,1,,,module/14,,0\r
781,当好友关系更新时,2,event/3,,docs/event-22-781/,,OnFriendRelationChange,1,OnFriendRelationChange,,,,,,,,1,,,event,,0\r
782,Layout控件排序方式枚举,,data/8,,docs/enum/,,LayoutSortType,4,LayoutSortType,,,,,,,,,,,data/10001,,0\r
783,恢复游戏,,game/1,3190980,docs/api-44-783/,,ResumeGame,2,ResumeGame,TRUE,,,,,,,,,,module/39,,0\r
784,强制移动角色控制器,2,game/4,,docs/api-33-784/,,CCTTeleport,2,CCTTeleport,TRUE,,,,,,,,,,module/33,,0\r
785,开启跳伞,,entity/9,,docs/api-11-785/,,StartParachute,2,StartParachute,TRUE,,,,,,,,,,action/26,,0.001\r
786,通过ID获取子节点,,entity/1,,docs/api-1-786/,,GetChildByName,3,GetChildByName,,,,,,,,,,,action/1,,0\r
10056,FE 设置二维向量分量,2,data/5,,,,Vector2xySetter,3,,,,,Vector2xySetter,,,,1,,,data/4,T_49_SD_SEARCHKEY_V2VCREATE,0\r
10057,FE 设置三维向量分量,2,data/5,,,,Vector3xyzSetter,3,,,,,Vector3xyzSetter,,,,1,,,data/4,T_49_SD_SEARCHKEY_V3VCREATE,0\r
787,OnPlayableEachLoop,,event/2,,docs/event-30-787/,,OnPlayableEachLoop,1,OnPlayableEachLoop,TRUE,,,,,,,,,,event,,0\r
788,打印断言功能,2,entity/1,,docs/api-1-788/,,Assert,2,Assert,TRUE,,,,,,,,,,action/1,,0\r
789,当实体可用时,,event/2,1290960,docs/event-1-789/,,OnEnable,1,OnEnable,TRUE,,,,,,,,,,event,,0.003\r
790,当实体不可用时,,event/2,1290650,docs/event-1-790/,,OnDisable,1,OnDisable,TRUE,,,,,,,,,,event,,0.001\r
791,读取数据库值,2,game/12,988,docs/api-31-791/,,ReadDBSheetValue_V2,2,ReadDBSheetValue_V2,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0\r
1006,读取数据库值，无缓存,2,game/12,986,,,ReadDBSheetValueNoCache,2,ReadDBSheetValueNoCache,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0\r
792,写入数据库值,2,game/12,,docs/api-31-792/,,WriteDBSheetValue_V2,2,WriteDBSheetValue_V2,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0\r
793,写入数据库值，阻塞直到写入完成,2,game/12,983,,,WriteDBSheetValueBlocking,2,WriteDBSheetValueBlocking,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0\r
1017,写入数据库值，带跨战场码读写权限校验,2,game/12,984,,,WriteDBSheetValueAsync,2,WriteDBSheetValueAsync,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0\r
794,读取数据库排行榜值,2,game/12,999,docs/api-31-794/,,ReadDBLeaderboardValue_V2,2,ReadDBLeaderboardValue_V2,TRUE,,,,1;2;3;5,FE_1:RankSheet,,,,,module/31,,0\r
795,写入数据库排行榜值,2,game/12,,docs/api-31-795/,,WriteDBLeaderboardValue_V2,2,WriteDBLeaderboardValue_V2,TRUE,,,,1;2;3;5,FE_1:RankSheet,,,,,module/31,,0\r
1013,写入数据库排行榜值，带跨战场码读写权限校验,2,game/12,997,,,WriteDBLeaderboardValueAsync,2,WriteDBLeaderboardValueAsync,TRUE,,,,1;2;3;5,FE_1:RankSheet,,,,,module/31,,0\r
798,根据名次范围读取数据库排行榜值,2,game/12,998,docs/api-31-798/,,ReadDBLeaderboardValuesByRange_V2,2,ReadDBLeaderboardValuesByRange_V2,TRUE,,,,1;2;3;4;6,FE_1:RankSheet,,,,,module/31,,0\r
799,读取累计数据,2,game/12,991,docs/api-31-799/,,ReadDBAccumulatedData_V2,2,ReadDBAccumulatedData_V2,TRUE,,,ReadStatisticalSheet_ERR,1;2;3;5,FE_1:StatisticalSheet,,,,,module/31,T_49_SD_SEARCHKEY_READSTATIS,0\r
800,【废弃】写入累计数据偏移值,2,game/12,,docs/api-31-800/,,WriteDBAccumulatedDataOffset_V2,2,WriteDBAccumulatedDataOffset_V2,TRUE,,,WriteStatisticalSheet_ERR,,,,,,,module/31,T_49_SD_SEARCHKEY_WRITESTATIS,0\r
1015,写入累计数据偏移值，带跨战场码读写权限校验,2,game/12,990,,,WriteDBAccumulatedDataOffsetAsync,2,WriteDBAccumulatedDataOffsetAsync,TRUE,,,WriteStatisticalSheet_ERR_V2,1;2;3;4;6,FE_1:StatisticalSheet;FE_3:StatisticSheetOperation,,,,,module/31,T_49_SD_SEARCHKEY_WRITESTATIS,0\r
801,按战场码读取数据库值,2,game/12,,docs/api-31-801/,,ReadDBSheetValueByWorkshopCode_V2,2,ReadDBSheetValue_V2,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
999,按战场码读取数据库值，无缓存,2,game/12,,,,ReadDBSheetValueByWorkshopCodeNoCache,2,ReadDBSheetValueNoCache,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
802,按战场码写入数据库值,2,game/12,,docs/api-31-802/,,WriteDBSheetValueByWorkshopCode_V2,2,WriteDBSheetValue_V2,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
803,按战场码写入数据库值，阻塞直到写入完成,2,game/12,,,,WriteDBSheetValueByWorkshopCodeBlocking,2,WriteDBSheetValueBlocking,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
1010,按战场码写入数据库值，带跨战场码读写权限校验,2,game/12,,,,WriteDBSheetValueByWorkshopCodeAsync,2,WriteDBSheetValueAsync,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
804,按战场码读取数据库排行榜值,2,game/12,,docs/api-31-804/,,ReadDBLeaderboardValueByWorkshopCode_V2,2,ReadDBLeaderboardValue_V2,TRUE,,,,,,,,,,module/31,,0\r
805,按战场码写入数据库排行榜值,2,game/12,,docs/api-31-805/,,WriteDBLeaderboardValueByWorkshopCode_V2,2,WriteDBLeaderboardValue_V2,TRUE,,,,,,,,,,module/31,,0\r
1014,按战场码写入数据库排行榜值，带跨战场码读写权限校验,2,game/12,,,,WriteDBLeaderboardValueByWorkshopCodeAsync,2,WriteDBLeaderboardValueAsync,TRUE,,,,,,,,,,module/31,,0\r
808,按战场码和名次范围读取数据库排行榜值,2,game/12,,docs/api-31-808/,,ReadDBLeaderboardValuesByRangeAndWorkshopCode_V2,2,ReadDBLeaderboardValuesByRange_V2,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
809,按战场码读取累计数据,2,game/12,,docs/api-31-809/,,ReadDBAccumulatedDataByWorkshopCode_V2,2,ReadDBAccumulatedData_V2,TRUE,,,,,,,,,,module/31,,0\r
810,【废弃】按战场码写入累计数据偏移值,2,game/12,,docs/api-31-810/,,WriteDBAccumulatedDataOffsetByWorkshopCode_V2,2,WriteDBAccumulatedDataOffset_V2,TRUE,,,WriteStatisticalSheetCross_ERR,,,,,,,module/31,T_49_SD_SEARCHKEY_WRITESTATISCROSS,0\r
1016,按战场码写入累计数据偏移值，带跨战场码读写权限校验,2,game/12,,,,WriteDBAccumulatedDataOffsetByWorkshopCodeAsync,2,WriteDBAccumulatedDataOffsetAsync,TRUE,,,WriteStatisticalSheetCross_ERR_V2,1;2;3;4|5;6,FE_3:StatisticSheetOperation,,,,,module/31,T_49_SD_SEARCHKEY_WRITESTATISCROSS,0\r
811,错误码枚举,,data/8,,docs/enum/,,ErrorCode,4,ErrorCode,,,,,,,,,,,data/10001,,0\r
821,检查特别关注,2,game/2,,docs/api-1-821/,,HasSpecialFollow,3,HasSpecialFollow,,,,,,,3,,,,action/1,,0\r
822,添加特别关注,2,game/2,,docs/api-1-822/,,AddSpecialFollow,2,AddSpecialFollow,TRUE,,,,,,3,,,,action/1,,0\r
823,移除特别关注,2,game/2,,docs/api-1-823/,,RemoveSpecialFollow,2,RemoveSpecialFollow,TRUE,,,,,,3,,,,action/1,,0\r
824,清空特别关注,2,game/2,,docs/api-1-824/,,CleanSpecialFollow,2,CleanSpecialFollow,TRUE,,,,,,3,,,,action/1,,0\r
825,欧拉角转方向向量,,data/7,4790920,docs/api-6-825/,,EularAngleToVector3,3,EularAngleToVector3,,,,,,,,,,,data/6,,0\r
826,整型转浮点,,data/7,4790950,docs/api-6-826/,,IntToFloat,3,IntToFloat,,,,,,,,,,,data/6,,0\r
827,根据四元数旋转向量,,data/2,4275890,docs/api-4-827/,,RotateVector,3,RotateVector,,,,,,,,,,,data/4,,0\r
828,跳跃结束时,,event/2,,docs/event-11-828/,,OnPlayerJumpStop,1,OnPlayerJumpStop,TRUE,,,,,,,,,,event,,0\r
829,坠落开始时,,event/2,,docs/event-11-829/,,OnPlayerFall,1,OnPlayerFall,TRUE,,,,,,,,,,event,,0\r
830,坠落结束时,,event/2,,docs/event-11-830/,,OnPlayerFallStop,1,OnPlayerFallStop,TRUE,,,,,,,,,,event,,0\r
831,切换玩家观察者,2,game/2,,docs/api-1-831/,,SwitchUserProxyObserver,2,SwitchUserProxyObserver,TRUE,,,,,,3,,,,action/1,,0\r
832,镜头转动角度限制类型,,data/8,,docs/enum/,,CameraViewingAngleRestrictionType,4,CameraViewingAngleRestrictionType,,,,,,,,,,,data/10001,,0\r
10058,NumToString,2,data/7,4790980,,,NumToString,3,,,,,num_to_string,,,,,,,data/6,T_49_SD_SEARCHKEY_NUMTOSTRING,0\r
812,删除数据库记录,2,game/12,,docs/api-31-812/,,DeleteDBSheetValue_V2,2,DeleteDBSheetValue_V2,TRUE,,,,1;2;3;5,FE_1:DataSheet,,,,,module/31,,0\r
1011,删除数据库记录，带跨战场码读写权限校验,2,game/12,982,,,DeleteDBSheetValueAsync,2,DeleteDBSheetValueAsync,TRUE,,,,1;2;3;5,FE_1:DataSheet,,,,,module/31,,0\r
813,根据Key删除数据库排行榜值,2,game/12,,docs/api-31-813/,,DeleteDBLeaderboardValueByKey_V2,2,DeleteDBLeaderboardValueByKey_V2,TRUE,,,,1;2;4,FE_1:RankSheet,,,,,module/31,,0\r
1020,根据Key删除数据库排行榜值，带跨战场码读写权限校验,2,game/12,996,,,DeleteDBLeaderboardValueByKeyAsync,2,DeleteDBLeaderboardValueByKeyAsync,TRUE,,,,1;2;4,FE_1:RankSheet,,,,,module/31,,0\r
814,根据名次删除数据库排行榜值,2,game/12,,docs/api-31-814/,,DeleteDBLeaderboardValueByOrder_V2,2,DeleteDBLeaderboardValueByOrder_V2,TRUE,,,,1;2;4,FE_1:RankSheet,,,,,module/31,,0\r
1024,根据名次删除数据库排行榜值，带跨战场码读写权限校验,2,game/12,995,,,DeleteDBLeaderboardValueByOrderAsync,2,DeleteDBLeaderboardValueByOrderAsync,TRUE,,,,1;2;4,FE_1:RankSheet,,,,,module/31,,0\r
815,按战场码删除数据库记录,2,game/12,,docs/api-31-815/,,DeleteDBSheetValueByWorkshopCode_V2,2,DeleteDBSheetValue_V2,TRUE,,,,,,,,,,module/31,,0\r
1012,按战场码删除数据库记录，带跨战场码读写权限校验,2,game/12,,,,DeleteDBSheetValueByWorkshopCodeAsync,2,DeleteDBSheetValueAsync,TRUE,,,,,,,,,,module/31,,0\r
816,按战场码和Key删除数据库排行榜值,2,game/12,,docs/api-31-816/,,DeleteDBLeaderboardValueByKeyAndWorkshopCode_V2,2,DeleteDBLeaderboardValueByKey_V2,TRUE,,,,,,,,,,module/31,,0\r
1021,按战场码和Key删除数据库排行榜值，带跨战场码读写权限校验,2,game/12,,,,DeleteDBLeaderboardValueByKeyAndWorkshopCodeAsync,2,DeleteDBLeaderboardValueByKeyAsync,TRUE,,,,,,,,,,module/31,,0\r
817,按战场码和名次删除数据库排行榜值,2,game/12,,docs/api-31-817/,,DeleteDBLeaderboardValueByOrderAndWorkshopCode_V2,2,DeleteDBLeaderboardValueByOrder_V2,TRUE,,,,,,,,,,module/31,,0\r
1029,按战场码和名次删除数据库排行榜值，带跨战场码读写权限校验,2,game/12,,,,DeleteDBLeaderboardValueByOrderAndWorkshopCodeAsync,2,DeleteDBLeaderboardValueByOrderAsync,TRUE,,,,,,,,,,module/31,,0\r
818,移动角色控制器,2,game/4,,docs/api-33-818/,,CCTMoveV2,2,CCTMoveV2,TRUE,,,,,,,,,,module/33,,0\r
820,UserMessageToPersona,2,game/12,,docs/api-46-820/,,UserMessageToPersona,2,UserMessageToPersona,TRUE,,,,,,,,,,module/46,,0\r
833,SystemMessageToPersona,2,game/12,,docs/api-46-833/,,SystemMessageToPersona,2,SystemMessageToPersona,TRUE,,,,,,,,,,module/46,,0\r
834,ClearMemory,2,game/12,,docs/api-46-834/,,ClearMemory,2,ClearMemory,TRUE,,,,,,,,,,module/46,,0\r
835,OnReceiveContentFromPersona,2,event/1,,docs/event-46-835/,,OnReceiveContentFromPersona,1,OnReceiveContentFromPersona,TRUE,,,,,,,,,,event,,0\r
836,OnReceiveActionFromPersona,2,event/1,,docs/event-46-836/,,OnReceiveActionFromPersona,1,OnReceiveActionFromPersona,TRUE,,,,,,,,,,event,,0\r
851,判断玩家是否是会员（服务端）,,game/12,,docs/api-45-851/,,IsPremium,2,IsPremium,TRUE,,,,,,3,2,,,module/45,,0\r
852,唤起会员中心（服务端）,,game/12,,docs/api-45-852/,,OpenPremiumCenter,2,OpenPremiumCenter,TRUE,,,,,,3,2,,,module/45,,0\r
853,唤起会员中心（客户端）,,game/12,,docs/api-45-853/,,OpenPremiumCenter_Client,2,OpenPremiumCenter_Client,TRUE,,,,,,3,1,,,module/45,,0\r
854,获取会员到期时间戳（服务端）,,game/12,,docs/api-45-854/,,GetPremiumExpireDate,2,GetPremiumExpireDate,TRUE,,,,,,3,2,,,module/45,,0\r
855,会员信息改变时,,event/1,,docs/event-45-855/,,OnPremiumChange,1,OnPremiumChange,TRUE,,,,,,3,,,,event,,0\r
856,进入会员中心时,,event/1,,docs/event-45-856/,,OnPlayerEnterPremiumCenter,1,OnPlayerEnterPremiumCenter,TRUE,,,,,,3,,,,event,,0\r
857,离开会员中心时,,event/1,,docs/event-45-857/,,OnPlayerLeavePremiumCenter,1,OnPlayerLeavePremiumCenter,TRUE,,,,,,3,,,,event,,0\r
858,会员状态枚举,,data/8,,docs/enum/,,PremiumState,4,PremiumState,,,,,,,3,,,,data/5,,0\r
859,判断玩家是否是会员（客户端）,,game/12,,docs/api-45-859/,,IsPremium_Client,2,IsPremium_Client,TRUE,,,,,,3,1,,,module/45,,0\r
860,获取会员到期时间戳（客户端）,,game/12,,docs/api-45-860/,,GetPremiumExpireDate_Client,2,GetPremiumExpireDate_Client,TRUE,,,,,,3,1,,,module/45,,0\r
861,枪械皮肤类型枚举,1,data/8,,docs/enum/,,WeaponSkinType,4,WeaponSkinType,,,,,,,,,,,data/10001,,0.002\r
862,载具皮肤类型枚举,1,data/8,,docs/enum/,,VehicleSkinType,4,VehicleSkinType,,,,,,,,,,,data/10001,,0\r
863,皮肤类型枚举,1,data/8,,docs/enum/,,ClothType,4,ClothType,,,,,,,,,,,data/10001,,0.003\r
864,背包皮肤类型枚举,1,data/8,,docs/enum/,,BagSkinType,4,BagSkinType,,,,,,,,,,,data/10001,,0\r
865,SetPersonaObserver,2,game/12,,docs/api-46-865/,,SetPersonaObserver,2,SetPersonaObserver,TRUE,,,,,,,,,,module/46,,0\r
866,UpdateUserNickName,2,game/12,,docs/api--866/,,UpdateUserNickName,2,UpdateUserNickName,TRUE,,,,,,,,,,module/46,,0\r
867,UserMessageToPersonaStream,2,game/12,,docs/api-46-867/,,UserMessageToPersonaStream,2,UserMessageToPersonaStream,TRUE,,,,,,,,,,module/46,,0\r
868,SystemMessageToPersonaStream,2,game/12,,docs/api-46-868/,,SystemMessageToPersonaStream,2,SystemMessageToPersonaStream,TRUE,,,,,,,,,,module/46,,0\r
869,设置玩家可自由退出,,game/2,,docs/api-1-869/,,SetPlayerCanFreeQuit,2,SetPlayerCanFreeQuit,TRUE,,,,,,,,,,action/1,,0.001\r
870,添加注释,1,entity/1,,,T_50_XXJ_WS_CONTENT_D,AddComment,2,,TRUE,TRUE,,,,,,,,,action/1,AddComment,0.004\r
10059,FE 选择粒子参数文件,2,data/1,,docs/api--10059/,,ParticlesID,3,ParticlesID,,,,ParticlesID,,,,,,,data/10000,T_49_SD_SEARCHKEY_PARTICLESENUM,0\r
871,设置 Global property,2,game/1,,docs/api-1-871/,,SetReplicationData,2,SetReplicationData,TRUE,,,globalvar_set,,,,,globalEntity<{0}>.{1} = Value,,module/39,T_49_SD_SEARCHKEY_GLOBALVARSET,0\r
872,获取 Global property,2,game/1,,docs/api-1-872/,,GetReplicationData,3,GetReplicationData,TRUE,,,globalvar_get,,,,,globalEntity<{0}>.{1},,module/39,T_49_SD_SEARCHKEY_GLOBALVARGET,0\r
10060,FE 商店枚举,2,data/8,,docs/enum/,,ShopType,4,ShopType,,,,,,,,,,,data/10001,,0\r
10061,FE Persona枚举,-1,data/8,,docs/enum/,,PersonaType,4,PersonaType,,,,,,,,,,,data/10001,,0\r
873,创建随机种子,,data/4,,docs/api-4-873/,,CreateRandomSeed,3,CreateRandomSeed,,,,,,,,,,,data/4,,0\r
874,获取下一个随机数,,data/4,,docs/api-4-874/,,Next,3,Next,,,,,,,,,,,data/3,,0\r
875,加入队伍,,game/3,,docs/api-29-875/,,JoinTeam,2,JoinTeam,TRUE,,,,,,,,,,module/29,,0\r
876,加入新队伍,,game/3,,docs/api-29-876/,,JoinNewTeam,2,JoinNewTeam,TRUE,,,,,,,,,,module/29,,0\r
877,OnReceiveFinishFromPersona,2,event/1,,docs/event-46-877/,,OnReceiveFinishFromPersona,1,OnReceiveFinishFromPersona,TRUE,,,,,,,,,,event,,0\r
878,OnReceiveStatusFromPersona,2,event/1,,docs/event-46-878/,,OnReceiveStatusFromPersona,1,OnReceiveStatusFromPersona,TRUE,,,,,,,,,,event,,0\r
879,当玩家被击倒V2,,event/2,,docs/event-16-879/,,OnKnockedDownV2,1,OnKnockedDownV2,TRUE,,,,,,,,,,event,,0.002\r
10062,FE 选择PersonaID,2,data/1,,,,PersonaID,3,,,,,PersonaID,,,,,,internal,data/10000,T_49_SD_SEARCHKEY_PERSONA,0\r
880,OnHudSendMessageToPersona,2,event/1,,docs/event-46-880/,,OnHudSendMessageToPersona,1,OnHudSendMessageToPersona,TRUE,,,,,,,,,,event,,0\r
881,雾效枚举,,data/8,,docs/enum/,,FogModeType,4,FogModeType,,,,,,,,,,,data/10001,,0\r
819,批量读取数据库值,2,game/12,989,docs/api-31-819/,,BatchReadDBSheetValue,2,BatchReadDBSheetValue,TRUE,,,,1;2;3;4;6,FE_1:DataSheet,,,,,module/31,,0\r
837,按战场码批量读取数据值,2,game/12,,docs/api-31-837/,,BatchReadDBSheetValueByWorkshopCode,2,BatchReadDBSheetValue,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
882,开始播放剧情,1,game/11,,docs/api-1-882/,,NotifyStartPlot,2,NotifyStartPlot,TRUE,,,,,,,,,,action/1,,0\r
883,当实体切换队伍时,,event/2,,docs/event-29-883/,,OnChangeTeam,1,OnChangeTeam,TRUE,,,,,,,,,,event,,0.001\r
884,CreateTimeLine,,game/11,,docs/api-30-884/,,CreateTimeLine,2,CreateTimeLine,TRUE,,,,,1:Enum_TimeLineID;FE_1:PerformanceID,,,,,module/47,,0\r
885,SetTimeLineTrackActor,,game/11,,docs/api-30-885/,,SetTimeLineTrackActor,2,SetTimeLineTrackActor,TRUE,,,,,,3,,,,module/47,,0\r
886,FE 选择PerformanceID,2,game/11,,,,PerformanceID,3,,,,,PerformanceID,,,,,,,data/10000,T_49_SD_SEARCHKEY_TIMELINE,0\r
887,沿路径移动,,entity/6,,docs/api-30-887/,,CreateAlongPathMotion,2,CreateAlongPathMotion,TRUE,,,,,,,,,,action/30,,0\r
888,CF 选择PlotID,1,game/11,31190990,,,PlotID,4,,,TRUE,,,,,,,,,data/10000,PlotID,0\r
889,获取客户端语言,,entity/1,,docs/api-1-889/,,GetLocalLanguage,3,GetLocalLanguage,,,,,,,,1,,,action/1,,0\r
890,剧情对话开始播放,1,event/2,,docs/event-1-890/,,OnPlotStart,1,OnPlotStart,TRUE,,,,,,,,,,event,,0\r
891,剧情对话结束,1,event/2,,docs/event-1-891/,,OnPlotEnd,1,OnPlotEnd,TRUE,,,,,,,,,,event,,0\r
892,剧情对话选项被触发,1,event/2,,docs/event-1-892/,,OntriggerPlotOption,1,OntriggerPlotOption,TRUE,,,,,,,,,,event,,0\r
893,实例化prefab,2,entity/1,,docs/api-1-893/,,InstantiatePrefab,2,InstantiatePrefab,TRUE,,P2=P1,P1=P2.T0,,2:PrefabGetter,,,,,action/1,,0\r
894,设置本地玩家位置,,game/2,,docs/api-11-894/,,SetLocalPlayerPositon,2,SetLocalPlayerPositon,TRUE,,,,,,,,,,module/11,,0\r
895,设置本地玩家朝向,,game/2,,docs/api-11-895/,,SetLocalPlayerForward,2,SetLocalPlayerForward,TRUE,,,,,,,,,,module/11,,0\r
896,向量投影,,data/2,4280900,docs/api-4-896/,,Vector3Projection,3,Vector3Projection,,,,,,,,,,,data/4,,0\r
897,获取当前相机,,game/5,,docs/api-8-897/,,GetCurrentNewCamera,3,GetCurrentNewCamera,,,,,,,,,,,module/8,,0\r
898,获取当前相机(clinet),,game/5,,docs/api-8-898/,,GetCurrentNewCameraForClinet,3,GetCurrentNewCameraForClinet,,,,,,,,,,,module/8,,0\r
899,切换相机,,game/5,,docs/api-8-899/,,SwitchNewCamera,2,SwitchNewCamera,TRUE,,,,,3:CameraTransitionType,,,,,module/8,,0\r
900,切换相机(clinet),,game/5,,docs/api-8-900/,,SwitchNewCameraForClinet,2,SwitchNewCameraForClinet,TRUE,,,,,,,,,,module/8,,0\r
901,创建相机,,game/5,,docs/api-8-901/,,CreateBasicCamera,2,CreateBasicCamera,TRUE,,,,,,,,,,module/8,,0\r
902,获取本地时间戳(Ms),,game/1,,docs/api-1-902/,,GetLocalTimestampMs,3,GetLocalTimestampMs,,,,,,,,,,,module/39,,0\r
903,获取服务器时间戳(Ms),,game/1,,docs/api-1-903/,,GetServerTimestampMs,3,GetServerTimestampMs,,,,,,,,,,,module/39,,0\r
904,时间戳(Ms)本地化字符串,,data/7,4790850,docs/api-1-904/,,TimestampMsToLocalString,3,TimestampMsToLocalString,,,,,,2:TimestampFormatStyle,,,,,data/6,,0\r
905,Persona更新上下文,2,game/12,,docs/api-46-905/,,UpdateContextToPersona,2,UpdateContextToPersona,TRUE,,,,,,,,,,module/46,,0\r
906,Persona点赞点踩,2,game/12,,docs/api-46-906/,,FeedbackToPersonaContent,2,FeedbackToPersonaContent,TRUE,,,,,,,,,,module/46,,0\r
907,Persona记忆回滚,2,game/12,,docs/api-46-907/,,RollbackPersonaMemory,2,RollbackPersonaMemory,TRUE,,,,,,,,,,module/46,,0\r
908,收到Persona回复,2,event/1,,docs/event-46-908/,,OnReceiveContentFromPersonaV2,1,OnReceiveContentFromPersonaV2,TRUE,,,,,,,,,,event,,0\r
909,刚体约束枚举,,data/8,,docs/enum/,,RigidbodyConstrainType,4,RigidbodyConstrainType,,,,,,,,,,,data/10001,,0\r
910,三维向量线性插值,,data/2,4280890,docs/api-4-910/,,LerpVector3,3,LerpVector3,TRUE,,,,,,,,,,data/4,,0\r
911,三维向量球形插值,,data/2,4280880,docs/api-4-911/,,SlerpVector3,3,SlerpVector3,TRUE,,,,,,,,,,data/4,,0\r
912,设置Basic相机CullingMask,,game/5,,docs/api-8-912/,,SetCustomCameraCullingMask,2,SetCustomCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0\r
913,设置Basic相机CullingMask对某层是否可见,,game/5,,docs/api-8-913/,,AddOrRemoveCustomCameraCullingMask,2,AddOrRemoveCustomCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0\r
914,获取Basic相机CullingMask,,game/5,,docs/api-8-914/,,GetCustomCameraCullingMask,3,GetCustomCameraCullingMask,TRUE,,,,,,1,,,,module/8,,0\r
915,截图,,entity/1,,docs/api-1-915/,,CaptureScreenshot,2,CaptureScreenshot,TRUE,,,,,,,,,internal,action/1,,0\r
916,BezierGetter,,data/1,4190920,,T_48_META_API_48_D,BezierGetter,3,,,TRUE,,input_bezier,,,,,,,data/10000,T_49_SD_SEARCHKEY_BEZIER,0\r
917,播放一次性音效,2,entity/6,,docs/api-1-917/,,PlayOneShotSound,2,PlayOneShotSound,TRUE,,,,,,,1,,,action/30,,0\r
918,文字溢出时处理方式枚举,,data/8,,docs/enum/,,FondOverFlowMod,4,FondOverFlowMod,,,,,,,1,,,,data/10001,,0\r
919,通过UIAsset创建自定义HUD,2,entity/4,2490890,docs/api-22-919/,,CreateCustomHudV2,2,CreateCustomHudV2,TRUE,TRUE,,,,,,,,,action/22,,0\r
920,通过UIAsset创建客户端自定义HUD,2,entity/4,2490880,docs/api-22-920/,,CreateCustomHudClientV2,2,CreateCustomHudClientV2,TRUE,TRUE,,,,,,,,,action/22,,0\r
10063,Tuple Get,2,data/3,,,,TupleGet,3,,,,,tuple_get,,,,,,,data/2,T_50_HJ_SEARCHKEY_TUPLEGET,0\r
10064,Tuple Set,2,data/3,,,,TupleSet,2,,,,,tuple_set,,,,,,,data/2,T_50_HJ_SEARCHKEY_TUPLESET,0\r
10065,Tuple Create,2,data/3,,,,TupleCreate,3,,,,,tuple_create,,,,,,,data/2,T_50_HJ_SEARCHKEY_TUPLECREATE,0\r
921,渲染质量枚举,,data/8,,docs/enum/,,ERenderQuality,4,ERenderQuality,,,,,,,,,,,data/10001,,0\r
922,设置关卡物件高亮,,entity/9,,docs/api-26-922/,,SetLevelObjHighLight,2,SetLevelObjHighLight,TRUE,,,,,,,,,,action/1,,0\r
923,按位通用运算,-1,data/2,4240990,docs/api-1-923/,,BitwiseCommon,3,BitwiseCommon,,,,,,,,,,,data/4,,0\r
924,按位取反,-1,data/2,4240980,docs/api-1-924/,,BitwiseNot,3,BitwiseNot,,,,,,,,,,,data/4,,0\r
925,按位数组转整数,,data/7,4790840,docs/api-6-925/,,BitwiseListToInt,3,BitwiseListToInt,,,,,,,,,,,data/6,,0\r
926,整数转按位数组,,data/7,4790830,docs/api-6-926/,,BitwiseIntToList,3,BitwiseIntToList,,,,,,,,,,,data/6,,0\r
927,四元数夹角,,data/2,4250960,docs/api-4-927/,,QuaternionAngle,3,QuaternionAngle,,,,,,,,,,,data/4,,0\r
928,四元数点积,,data/2,4250950,docs/api-4-928/,,QuaternionDot,3,QuaternionDot,,,,,,,,,,,data/4,,0\r
929,四元数求逆,,data/2,4250940,docs/api-4-929/,,QuaternionInverse,3,QuaternionInverse,,,,,,,,,,,data/4,,0\r
930,四元数FromTo旋转,,data/2,4250930,docs/api-4-930/,,QuaternionFromToRotation,3,QuaternionFromToRotation,,,,,,,,,,,data/4,,0\r
931,四元数朝向插值,,data/2,4250920,docs/api-4-931/,,QuaternionRotateTowards,3,QuaternionRotateTowards,,,,,,,,,,,data/4,,0\r
932,获取陀螺仪朝向,,game/12,,docs/api-40-932/,,GetGyroscopeOrientation,3,GetGyroscopeOrientation,,,,,,,,,,,module/40,,0\r
933,获取陀螺仪重力,,game/12,,docs/api-40-933/,,GetGyroscopeGravity,3,GetGyroscopeGravity,,,,,,,,,,,module/40,,0\r
934,获取陀螺仪旋转速率,,game/12,,docs/api-40-934/,,GetGyroscopeRotationRate,3,GetGyroscopeRotationRate,,,,,,,,,,,module/40,,0\r
935,获取陀螺仪无偏旋转速率,,game/12,,docs/api-40-935/,,GetGyroscopeRotationUnbiased,3,GetGyroscopeRotationUnbiased,,,,,,,,,,,module/40,,0\r
936,获取用户加速度,,game/12,,docs/api-40-936/,,GetUserAcceleration,3,GetUserAcceleration,,,,,,,,,,,module/40,,0\r
937,获取触摸信息,,game/12,,docs/api-40-937/,,GetTouchInfo,2,GetTouchInfo,TRUE,,,,,,,,,,module/40,,0\r
938,获取屏幕触摸点数量,,game/12,,docs/api-40-938/,,GetScreenTouchCount,3,GetScreenTouchCount,,,,,,,,,,,module/40,,0\r
939,设备震动,,game/12,,docs/api-40-939/,,VibrateDevice,2,VibrateDevice,TRUE,,,,,,,,,,module/40,,0\r
940,获取渲染质量,,game/12,,docs/api-40-940/,,GetRenderQuality,3,GetRenderQuality,,,,,,,,,,,module/40,,0\r
941,获取渲染分辨率,,game/12,,docs/api-40-941/,,GetRenderResolution,3,GetRenderResolution,,,,,,,,,,,module/40,,0\r
942,服务端播放音效V2,,entity/6,,docs/api-1-942/,,NotifyPlaySoundV2,2,NotifyPlaySoundV2,TRUE,,,,,3:ConstFloatOrInt=1,,,,,action/1,,0\r
943,客户端播放一次性音效V2,,entity/6,,docs/api-1-943/,,PlayOneShotSoundV2,2,PlayOneShotSoundV2,TRUE,,,,,,,,,,action/1,,0\r
944,字符串格式化,,data/6,4670950,docs/api-5-944/,,FormatStr,3,FormatStr,,,,,,,,,,,data/5,,0\r
945,异步复活玩家,,game/2,,docs/api-11-945/,,ReviveOnNextFrame,2,ReviveOnNextFrame,TRUE,,,,,,,,,,module/11,,0\r
946,异步淘汰战斗实体,,game/3,,docs/api-16-946/,,EliminateOnNextFrame,2,EliminateOnNextFrame,TRUE,,,,,,,,,,module/29,,0\r
947,异步踢出玩家,,game/2,,docs/api-11-947/,,QuitFameOnNextFrame,2,QuitFameOnNextFrame,TRUE,,,,,,,,,,module/11,,0\r
948,获取麦克风音量,,game/12,,docs/api-40-948/,,GetMicrophoneVolume,2,GetMicrophoneVolume,TRUE,,,,,,,,,,module/40,,0\r
949,屏幕触摸开始事件,,event/1,,docs/event-40-949/,,OnScreenTouchBegan,1,OnScreenTouchBegan,TRUE,,,,,,,,,,event,,0\r
950,屏幕触摸结束事件,,event/1,,docs/event-40-950/,,OnScreenTouchEnded,1,OnScreenTouchEnded,TRUE,,,,,,,,,,event,,0\r
951,粘贴组件,2,entity/1,,docs/api-1-951/,,PasteComponent,2,PasteComponent,TRUE,,,,,,,,,,action/1,,0\r
952,读取数据库某列值,2,game/12,987,docs/api-31-952/,,ReadDBSheetColumnValue,2,ReadDBSheetColumnValue,TRUE,,,P4=P1.SheetType TupleIndexT >;P5=P4.PropertyType,1;2;3;4|5;7,FE_1:MulticolSheet;FE_4:SheetColumn,,,,,module/31,,0\r
997,读取数据库某列值，无缓存,2,game/12,985,,,ReadDBSheetColumnValueNoCache,2,ReadDBSheetColumnValueNoCache,TRUE,,,P4=P1.SheetType TupleIndexT >;P5=P4.PropertyType,1;2;3;4|5;7,FE_1:MulticolSheet;FE_4:SheetColumn,,,,,module/31,,0\r
953,按战场码读取数据库某列值,2,game/12,,docs/api-31-953/,,ReadDBSheetColumnValueByWorkshopCode,2,ReadDBSheetColumnValue,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/31,,0\r
998,按战场码读取数据库某列值，无缓存,2,game/12,,,,ReadDBSheetColumnValueByWorkshopCodeNoCache,2,ReadDBSheetColumnValueNoCache,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/31,,0\r
954,读取数据库中排行榜关联表值,2,game/12,994,docs/api-31-954/,,ReadDBLeaderboardAssociationValue,2,ReadDBLeaderboardAssociationValue,TRUE,,,P3=P1.SheetType,1;2;3;5;6,FE_1:RankSheet,,,,,module/31,,0\r
955,按战场码读取数据库中排行榜关联表值,2,game/12,,docs/api-31-955/,,ReadDBLeaderboardAssociationValueByWorkshopCode,2,ReadDBLeaderboardAssociationValue,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
956,根据名次区间读取数据库中排行榜表及关联表值,2,game/12,993,docs/api-31-956/,,ReadDBLeaderboardAssociationValuesByRange,2,ReadDBLeaderboardAssociationValuesByRange,TRUE,,,,1;2;3;4|6;7,FE_1:RankSheet,,,,,module/31,,0\r
957,按战场码根据名次区间读取数据库中排行榜表及关联表值,2,game/12,,docs/api-31-957/,,ReadDBLeaderboardAssociationValuesByRangeByWorkshop,2,ReadDBLeaderboardAssociationValuesByRange,TRUE,,,,1;2;3;4|5;6;7,,,,,,module/31,,0\r
958,写入数据库中排行榜表和关联表值,2,game/12,,docs/api-31-958/,,WriteDBLeaderboardAssociationValue,2,WriteDBLeaderboardAssociationValue,TRUE,,,P3=P1.SheetValueType,1;2;3;5;6,FE_1:RankSheet,,,,,module/31,,0\r
1022,写入数据库中排行榜表和关联表值，带跨战场码读写权限校验,2,game/12,992,,,WriteDBLeaderboardAssociationValueAsync,2,WriteDBLeaderboardAssociationValueAsync,TRUE,,,P3=P1.SheetValueType,1;2;3;5;6,FE_1:RankSheet,,,,,module/31,,0\r
959,绑定CustomPlayer,2,game/2,,docs/api-1-959/,,BindCustomPlayer,2,BindCustomPlayer,TRUE,,,,,,,,,,action/1,,0\r
960,解绑CustomPlayer,2,game/2,,docs/api-1-960/,,UnbindCustomPlayer,2,UnbindCustomPlayer,TRUE,,,,,,,,,,action/1,,0\r
961,设置CustomPlayer状态,2,game/2,,docs/api-1-961/,,SetCustomPlayerState,2,SetCustomPlayerState,TRUE,,,,,,,,,,action/1,,0\r
962,获取CustomPlayer状态,2,game/2,,docs/api-1-962/,,GetCustomPlayerState,2,GetCustomPlayerState,TRUE,,,,,,,,,,action/1,,0\r
963,收到persona创房结果,2,event/1,,docs/event-46-963/,,OnReceivePersonaCreateRoomResult,1,OnReceivePersonaCreateRoomResult,TRUE,,,,,,,,,,event,,0\r
964,收到Persona触发Action,2,event/1,,docs/event-46-964/,,OnReceiveActionIDFromPersona,1,OnReceiveActionIDFromPersona,TRUE,,,,,,,,,,event,,0\r
965,按战场码写入数据库中排行榜表和关联表值,2,game/12,,docs/api-31-965/,,WriteDBLeaderboardAssociationValueByWorkshopCode,2,WriteDBLeaderboardAssociationValue,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
1023,按战场码写入数据库中排行榜表和关联表值，带跨战场码读写权限校验,2,game/12,,,,WriteDBLeaderboardAssociationValueByWorkshopCodeAsync,2,WriteDBLeaderboardAssociationValueAsync,TRUE,,,,1;2;3;4|5;6,,,,,,module/31,,0\r
966,设置玩家之间距离语音音量,,game/12,,docs/api-40-966/,,SetDistanceVolumes,2,SetDistanceVolumes,TRUE,,,,,,,,,,module/40,,0\r
967,获取好友ID,,game/12,,docs/api-14-967/,,GetFriends,3,GetFriends,,,,,,,,,,,module/14,,0\r
968,用户自定义事件,1,event/3,,docs/event--968/,,UserCustomEvent,1,UserCustomEvent,,TRUE,,,,,,,,,,,0\r
969,触发用户自定义事件,1,event/3,,docs/api--969/,,DispatchUserCustomEvent,2,DispatchUserCustomEvent,,TRUE,,,,,,,,,,,0\r
970,获取默认界面位置,,game/2,,docs/api-11-970/,,GetDefaultUIPosition,2,GetDefaultUIPosition,TRUE,,,,,,,,,,module/11,,0\r
972,玩家退出或玩家比赛结束时,,event/1,,docs/event-11-972/,,OnUserQuitOrUserMacthEnd,1,OnUserQuitOrUserMacthEnd,TRUE,,,,,,,,,,event,,0\r
973,PlayerStateType,,data/8,,docs/enum/,,PlayerStateType,4,PlayerStateType,,,,,,,,,,,data/10001,,0\r
10066,FE 动画状态,2,data/1,,,,AnimationState,3,,,,,AnimationState,,,,,,,data/10000,AnimationState,0\r
974,设置实体描边,,entity/1,,docs/api-1-974/,,SetLevelObjOutlineEffect,2,SetLevelObjOutlineEffect,TRUE,,,,,,3,,,internal,action/1,,0\r
975,CF 阶段索引PhaseIndex,1,data/8,,,,DynamicPhaseIndex,4,,,TRUE,,,,,,,,,data/10000,DynamicPhaseIndex,0\r
977,实体属性,2,data/8,,docs/enum/,,EntityFlag,4,EntityFlag,,,,,,,,,,,data/10000,,0\r
978,获取类型名称,,entity/1,,docs/api-1-978/,,GetTypeName,3,GetTypeName,TRUE,,,,,,,,,,action/1,,0\r
979,获取包围盒,,game/5,,docs/api-26-979/,,GetBoundingBox,2,GetBoundingBox,TRUE,,,,,,,,,,action/1,,0\r
980,设置材质属性,,game/5,,docs/api-26-980/,,SetMaterialProperty,2,SetMaterialProperty,TRUE,,,,,,,,,,action/1,,0\r
981,清除材质属性,,game/5,,docs/api-26-981/,,ClearMaterialProperty,2,ClearMaterialProperty,TRUE,,,,,,,,,,action/1,,0\r
982,自定义属性改变时,2,event,,docs/event-1-982/,,OnCustomPropertyChange,1,OnCustomPropertyChange,TRUE,,,,,,,,,,event,,0\r
983,CustomPlayer状态改变时,2,event/1,,docs/event-1-983/,,OnCustomPlayerStateChanged,1,OnCustomPlayerStateChanged,TRUE,,,,,,,,,,event,,0\r
984,获取属性id,,entity/1,,,,GetPropertyId,3,,,TRUE,,get_property_id,,,,,,,action/1,GetPropertyId,0\r
985,向persona发送用户消息要求有语音回复,2,game/12,,docs/api-46-985/,,UserMessageToPersonaVoice,2,UserMessageToPersonaVoice,TRUE,,,,,,,,,,module/46,,0\r
986,向persona发送系统消息要求有语音回复,2,game/12,,docs/api-46-986/,,SystemMessageToPersonaVoice,2,SystemMessageToPersonaVoice,TRUE,,,,,,,,,,module/46,,0\r
987,播放缓存的已生成语音,2,game/12,,docs/api-46-987/,,PlayStoredVoiceFromPersona,2,PlayStoredVoiceFromPersona,TRUE,,,,,,,,,,module/46,,0\r
988,当接收到persona的语音回复,2,event/1,,docs/event-46-988/,,OnReceiveVoiceFromPersona,1,OnReceiveVoiceFromPersona,TRUE,,,,,,,,,,event,,0\r
989,OnPlayVoiceFinishFromPersona,2,event/1,,docs/event-46-989/,,OnPlayVoiceFinishFromPersona,1,OnPlayVoiceFinishFromPersona,TRUE,,,,,,,,,,event,,0\r
10100,玩家开始说话时,2,event/1,,,,OnPlayerSpeakStart,1,OnPlayerSpeakStart,TRUE,,,,,,,,,,event,,0\r
10101,玩家停止说话时,2,event/1,,,,OnPlayerSpeakEnd,1,OnPlayerSpeakEnd,TRUE,,,,,,,,,,event,,0\r
10067,广播自定义事件,-1,event/3,,docs/api-1-10067/,广播自定义事件到指定平台,BroadcastCustomEvent,2,BroadcastCustomEvent,,,,,,,,,,,,BroadcastCustomEvent,0\r
990,获取客户端区域,0,game/1,,docs/api-1-990/,,GetClientRegion,2,GetClientRegion,TRUE,,,,,,,1,,,action/1,,0\r
991,施力类型,,data/8,,docs/enum/,,ForceType,4,ForceType,,,,,,,,,,,data/10001,,0\r
992,请求组队匹配,2,game/1,,,,RequestGroupMatchMaking,2,RequestGroupMatchMaking,TRUE,,,,,,,,,internal,module/11,,0\r
993,创建线渲染器实体,2,entity/1,,,,CreateLineRenderEntity,2,CreateLineRenderEntity,TRUE,,,,,,,,,,action/1,,0\r
994,创建抛物轨迹,2,entity/1,,,,CreateProjectileTrajectory,2,CreateProjectileTrajectory,TRUE,,,,,,,,,,action/1,,0\r
10068,造成伤害,2,game/1,,,,TakeDamage,2,TakeDamage,TRUE,,,,,,,1,,,module/48,,0\r
10069,复活,2,game/1,,,,Revive,2,Revive,TRUE,,,,,,,1,,,module/48,,0\r
10070,创建训练靶,2,game/1,,,,CreateTrainingBot,2,CreateTrainingBot,TRUE,,,,,,,1,,,module/48,,0\r
10071,训练靶移动类型枚举,2,data/8,,,,TrainingTargetType,4,TrainingTargetType,,,,,,,,1,,,data/10001,,0\r
995,读取本地数据库表值,2,game/12,981,,,ReadLocalDBSheetValue,2,ReadLocalDBSheetValue,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheetClient,,1,,,module/31,,0\r
996,按战场码读取本地数据库表值,2,game/12,,,,ReadLocalDBSheetValueByWorkshopCode,2,ReadLocalDBSheetValue,TRUE,,,P4=P1.SheetType,,FE_1:DataSheetClient,,1,,,module/31,,0\r
1000,写入本地数据库值,2,game/12,979,,,WriteLocalDBSheetValue,2,WriteLocalDBSheetValue,TRUE,,,P4=P1.SheetType,1;2;3;4;6,FE_1:DataSheetClient,,1,,,module/31,,0\r
1001,按战场码写入本地数据库值,2,game/12,,,,WriteLocalDBSheetValueByWorkshopCode,2,WriteLocalDBSheetValue,TRUE,,,P4=P1.SheetType,,FE_1:DataSheetClient,,1,,,module/31,,0\r
1002,删除本地数据库记录,2,game/12,978,,,DeleteLocalDBSheetValue,2,DeleteLocalDBSheetValue,TRUE,,,,1;2;3;5,FE_1:DataSheetClient,,1,,,module/31,,0\r
1003,按战场码删除本地数据库记录,2,game/12,,,,DeleteLocalDBSheetValueByWorkshopCode,2,DeleteLocalDBSheetValue,TRUE,,,,,FE_1:DataSheetClient,,1,,,module/31,,0\r
1004,读取本地数据库某列值,2,game/12,980,,,ReadLocalDBSheetColumnValue,2,ReadLocalDBSheetColumnValue,TRUE,,,P4=P1.SheetType TupleIndexT >;P5=P4.PropertyType,1;2;3;4|5;7,FE_1:MulticolSheetClient;FE_4:SheetColumn,,1,,,module/31,,0\r
1005,按战场码读取本地数据库某列值,2,game/12,,,,ReadLocalDBSheetColumnValueByWorkshopCode,2,ReadLocalDBSheetColumnValue,TRUE,,,P4=P1.SheetType TupleIndexT >;P5=P4.PropertyType,,FE_1:MulticolSheetClient;FE_4:SheetColumn,,1,,,module/31,,0\r
10072,退出载具,2,game/12,,,,ExitVehicle,2,ExitVehicle,TRUE,,,,,,,1,,,module/48,,0\r
10073,进入载具,2,game/12,,,,EnterVehicle,2,EnterVehicle,TRUE,,,,,,,1,,,module/48,,0\r
10074,设置无敌状态,2,game/12,,,,SetInvincibility,2,SetInvincibility,TRUE,,,,,,,1,,,module/48,,0\r
10075,切换武器,2,game/12,,,,SwitchWeapon,2,SwitchWeapon,TRUE,,,,,,,1,,,module/48,,0\r
10076,添加物品(客户端),2,game/12,,,,AddItem,2,AddItem,TRUE,,,,,,,1,,,module/48,,0\r
10102,观战者加入游戏时,0,event/1,,,,OnObserverJoin,1,OnObserverJoin,TRUE,,,,,,,0,,,event,,0\r
10103,观战者退出游戏时,0,event/1,,,,OnObserverQuit,1,OnObserverQuit,TRUE,,,,,,,0,,,event,,0\r
10104,所有观战者,0,entity/1,,,,AllObservers,3,AllObservers,,,,,,,,2,,,action/1,,0\r
10105,当前观战者,2,entity/1,,,,LocalObserver,3,LocalObserver,,,,,,,,1,,,action/1,,0\r
10106,LateUpdate回调,0,event/1,,,,OnLateUpdate,1,OnLateUpdate,TRUE,,,,,,,1,,,event,,0\r
10107,退出游戏,2,game/12,,,,QuitGameClient,2,QuitGameClient,TRUE,0,,,1,,,,,,action/1,,0\r
1007,进入行为树节点,2,event/1,,,,OnNodeEnterForClient,1,OnNodeEnterForClient,TRUE,,,,,,,1,,,event,,0\r
1008,退出行为树节点,2,event/1,,,,OnNodeExitForClient,1,OnNodeExitForClient,TRUE,,,,,,,1,,,event,,0\r
10108,调试指令类型,,data/8,,,,DebugCommandType,4,DebugCommandType,,,,,,,,,,,data/10001,,0\r
10109,接收到调试指令,,event/1,,,,OnReceiveDebugCommand,1,OnReceiveDebugCommand,TRUE,,,,,,,,,,event/1,,0\r
1009,玩家开始拍照时(截图前),,event/2,,,,OnPlayerBeginTakePhoto,1,OnPlayerBeginTakePhoto,TRUE,,,,,,,,,,event,,0\r
1018,当结束拍照后(截图后),,event/2,,,,OnPlayerEndTakePhoto,1,OnPlayerEndTakePhoto,TRUE,,,,,,,,,,event,,0\r
10110,单返回胶囊体检测,0,game/4,,,,SingleCapsuleCast,2,SingleCapsuleCast,TRUE,,,,1;2;3;4;5;6;7;8|9;10;11;12,,,,,,module/33,,0\r
10111,删除物品(客户端),2,game/12,,,,DestroyItem,2,DestroyItem,TRUE,,,,,,,1,,,module/48,,0\r
10079,自定义客户端用户埋点日志,2,game/12,,,,AddUserEventLogMapForClient,2,AddUserEventLogMapForClient,TRUE,,,,,,,,,,module/23,,0\r
10080,自定义客户端比赛埋点日志,2,game/12,,,,AddGameEventLogMapForClient,2,AddGameEventLogMapForClient,TRUE,,,,,,,,,,module/23,,0\r
1019,玩家购买商品事件,,event/2,,,,OnPlayerPurchaseProduct,1,OnPlayerPurchaseProduct,TRUE,,,,,,,,,,event,,0\r
1025,查询玩家官方仓库中某商品的数量,2,game/12,,,,GetProductCount,2,GetProductCount,TRUE,,,,,,,,,,module/49,,0\r
1026,消耗玩家官方仓库中某数量的商品,2,game/12,,,,ConsumeProduct,2,ConsumeProduct,TRUE,,,,,,,,,,module/49,,0\r
10112,玩家同步状态变化,,event/2,,,,OnPlayerOutOfSync,1,OnPlayerOutOfSync,TRUE,,,,,,,2,,,event,,\r
1027,动画状态枚举,1,data/8,,,T_48_META_EVT_3201_P0_D,AnimStateName,4,,,TRUE,,,,,,,,,data/10001,T_41_XXJ_WS_ANIMATIONCLIP,0\r
1028,自定义战斗实体被击中,,event/2,,,,OnCustomFightingEntityHitted,1,OnCustomFightingEntityHitted,TRUE,,,,,,,,,,event,,0\r
1033,唤起内购商店界面（GS）,2,game/12,,,,OpenPremiumStore,2,OpenPremiumStore,TRUE,,,,,,,,,,module/49,,0\r
1030,唤起内购商店界面（Client）,2,game/12,,,,OpenPremiumStore_Client,2,OpenPremiumStore_Client,TRUE,,,,,,,,,,module/49,,0\r
1031,【废弃】快速唤起购买商品界面（GS）,2,game/12,,,,BuyPremiumCommodity,2,BuyPremiumCommodity,TRUE,,,,,,,,,,module/49,,0\r
1032,【废弃】快速唤起购买商品界面（Client）,2,game/12,,,,BuyPremiumCommodity_Client,2,BuyPremiumCommodity_Client,TRUE,,,,,,,,,,module/49,,0\r
1034,内购购买状态枚举,,data/8,,docs/enum/,,PurchaseStatus,4,PurchaseStatus,,,,,,,,,,,data/5,,0\r
1035,消耗商品状态枚举,,data/8,,docs/enum/,,ConsumeStatus,4,ConsumeStatus,,,,,,,,,,,data/5,,0\r
1036,私有-当使用结束时,,event/2,,,,OnUseEnd,1,OnUseEnd,TRUE,,,,,,,,,,event,,\r
1037,私有-当卸下装备时,,event/2,,,,OnUnEquipped,1,OnUnEquipped,TRUE,,,,,,,,,,event,,\r
1038,使用结束原因枚举,,data/8,,,,UseEndReason,4,UseEndReason,,,,,,,,,,,data/10001,,\r
1039,卸装原因枚举,,data/8,,,,UnEquipReason,4,UnEquipReason,,,,,,,,,,,data/10001,,\r
1040,设置角色控制器朝向,2,game/4,,docs/api-33-1040/,,SetCCTForward,2,SetCCTForward,TRUE,,,,,,,,,,module/33,,0\r
10113,数据存储服务端图元整合,2,game/12,1000,,,DataStorageIntegrate,2,,,,,DataStorageIntegrate,,,,2,,,module/31,FE_53A_HZY_SEARCHKEY_DATASTORAGE,0\r
1041,残留物类型,,data/8,,docs/enum/,,ResidualItemsType,4,ResidualItemsType,,,,,,,,,,,data/10001,,0\r
1042,移除残留物,,entity/3,,docs/api-15-10114/,,RemoveResidualItems,2,RemoveResidualItems,TRUE,,,,,2:ResidualItemsType;FE_2:Type,,,,,action/15,,0\r
1043,获取宠物技能,,game/2,,docs/api-11-10116/,,GetPetSkill,3,GetPetSkill,,,,,,,,,,,module/11,,0\r
1044,重置宠物技能,,game/2,,docs/api-11-10117/,,ResetPetSkill,2,ResetPetSkill,TRUE,,,,,,,,,,module/11,,0\r
1045,切换宠物技能,,game/2,,docs/api-11-10118/,,SwitchPetSkill,2,SwitchPetSkill,TRUE,,,,,2:PetSkillID;FE_2:PetSkillID,,,,,module/11,,0\r
1046,宠物技能类型,,data/8,,,T_54_META_TYP_478_D,PetSkillID,4,,,TRUE,,PetSkillID,,,,,,,data/10001,T_54_META_EVT_3135_P0,0\r
1047,当使用宠物技能时,0,event/2,,docs/event-11-10120/,,OnUsePetSkill,1,OnUsePetSkill,TRUE,,,,,,1,,,,event,,0\r
1048,设置本地玩家移动状态,,game/2,,docs/api-11-10115/,,SetLocalPlayerMoveStatus,2,SetLocalPlayerMoveStatus,TRUE,,,,,,,,,,action/1,,0\r
1049,设置外观组材质,2,entity/10,,,,SetAppearanceMaterial,2,SetAppearanceMaterial,True,,,,,,,1,,,action/37,,\r
1050,重置外观组材质,2,entity/10,,,,ResetAppearanceMaterial,2,ResetAppearanceMaterial,True,,,,,,,1,,,action/37,,\r
1051,重置外观组所有材质,2,entity/10,,,,ResetAppearanceMaterialGroup,2,ResetAppearanceMaterialGroup,True,,,,,,,1,,,action/37,,\r
1052,获取外观组材质,2,entity/10,,,,GetAppearanceMaterial,2,GetAppearanceMaterial,True,,,,,,,1,,,action/37,,\r
1053,快速唤起购买商品界面（GS）,2,game/12,,,,BuyPremiumCommodityV2,2,BuyPremiumCommodityV2,TRUE,,,,,FE_3:Int=1,,,,,module/49,,0\r
1054,快速唤起购买商品界面（Client）,2,game/12,,,,BuyPremiumCommodity_ClientV2,2,BuyPremiumCommodity_ClientV2,TRUE,,,,,FE_2:Int=1,,,,,module/49,,0\r
1055,后处理滤镜类型,,data/8,,docs/enum/,,FilterType,4,FilterType,,,,,,,,,,,data/10001,,0.002\r
8018,地图资源下载状态,2,data/8,,docs/enum/,,MapResourceDownloadState,4,MapResourceDownloadState,,,,,,,,,,,data/10001,,0\r
8019,地图资源下载状态变化,2,event/2,,,,OnMapResourceDownloadStateChanged,1,OnMapResourceDownloadStateChanged,TRUE,,,,,,,1,,,event,,0\r
8020,下载地图资源,2,game/12,,,,DownloadMapResource,2,DownloadMapResource,TRUE,,,,,,,1,,,module/51,,0\r
8021,检查地图资源下载状态,2,game/12,,,,CheckMapResourceDownloaded,2,CheckMapResourceDownloaded,TRUE,,,,,,,1,,,module/51,,0\r
8022,图集ID,,data/8,,,,AtlasID,4,,,TRUE,,AtlasID,,,,,,,data/10001,T_54_META_TYP_39_I15,0\r
10114,LateVisualTick回调,0,event/1,,,,OnLateVisualTick,1,OnLateVisualTick,TRUE,,,,,,,1,,,event,,0\r
10115,OnPressedHudJoystick,,event/2,,docs/event-22-10115/,,OnPressedHudJoystick,1,OnPressed,,TRUE,,joystick_event,,,,,,,event,,0\r
10116,OnReleasedHudJoystick,,event/2,,docs/event-22-10116/,,OnReleasedHudJoystick,1,OnReleased,,TRUE,,joystick_event,,,,,,,event,,0\r
10117,OnMoveHudJoystick,,event/2,,docs/event-22-10117/,,OnMoveHudJoystick,1,OnMove,,TRUE,,joystick_event,,,,,,,event,,0\r
8023,距离来源类型,2,data/8,,,,DistanceSourceType,4,DistanceSourceType,,,,,,,,,,,data/10001,,\r
8024,距离空间类型,2,data/8,,,,DistanceSpaceType,4,DistanceSpaceType,,,,,,,,,,,data/10001,,\r
8025,检测UI命中,,entity/4,,,,CheckUIHit,3,CheckUIHit,,,,,,,,,,,action/22,,\r
8026,字符串转大数,,data/7,,,,StringToBigFloat,3,StringToBigFloat,,,,,,,,,,,data/6,,\r
1056,滚动方向枚举,,data/8,,,,ScrollDirection,4,ScrollDirection,,,,,,,,,,,data/10001,,\r
1057,设置滚动视图滚动量,,entity/4,,,,SetScrollAmount,2,SetScrollAmount,TRUE,,,,,2:Enum_ScrollDirection,,1,,,action/22,,\r
1058,重置滚动视图位置,,entity/4,,,,ResetScrollViewPosition,2,ResetScrollViewPosition,TRUE,,,,,,,1,,,action/22,,\r
8035,获取本地玩家已拥有 Emote,2,game/10,,,,GetLocalOwnedEmotes,3,GetLocalOwnedEmotes,,,,,,,,,,,module/17,GetLocalOwnedEmotes,\r
8036,获取本地玩家已拥有 Outfit,2,game/10,,,,GetLocalOwnedOutfit,3,GetLocalOwnedOutfit,,,,,,,,,,,module/17,GetLocalOwnedOutfit,\r
8037,获取本地玩家已拥有 VehicleSkin,2,game/10,,,,GetLocalOwnedVehicleSkin,3,GetLocalOwnedVehicleSkin,,,,,,,,,,,module/17,GetLocalOwnedVehicleSkin,\r
8038,获取本地玩家已拥有 WeaponSkin,2,game/10,,,,GetLocalOwnedWeaponSkin,3,GetLocalOwnedWeaponSkin,,,,,,,,,,,module/17,GetLocalOwnedWeaponSkin,\r
8039,获取本地玩家已拥有 BackpackSkin,2,game/10,,,,GetLocalOwnedBackpackSkin,3,GetLocalOwnedBackpackSkin,,,,,,,,,,,module/17,GetLocalOwnedBackpackSkin,\r
8040,读取CSV表某单元数据通过行数和列名（服务器）,,game/12,,,,ReadCSVCellByNameFromServer,3,ReadCSVCellByNameFromServer,,,,,,2:Int=1,,,,,module/10,ReadCSVCellByNameFromServer,\r
8041,读取CSV表某一行数据通过列数和内容（服务器）,,game/12,,,,ReadCSVRowByKeyFromServer,3,ReadCSVRowByKeyFromServer,,,,,,2:Int=1,,,,,module/10,ReadCSVRowByKeyFromServer,\r
8042,通过列名读取CSV表某一列数（服务器）,,game/12,,,,CSVColumnNameToInt,3,CSVColumnNameToInt,,,,,,,,,,,module/10,CSVColumnNameToInt,\r
8043,EasyList 格子绑定数据时,2,event/2,,,,OnCellBind,1,OnCellBind,,,,,,,,,,,event/22,OnCellBind,\r
8044,EasyList 点击有效格子时,2,event/2,,,,OnCellClick,1,OnCellClick,,,,,,,,,,,event/22,OnCellClick,\r
8045,EasyList 格子被选中时,2,event/2,,,,OnCellSelect,1,OnCellSelect,,,,,,,,,,,event/22,OnCellSelect,\r
8046,EasyList 格子取消选中时,2,event/2,,,,OnCellUnselect,1,OnCellUnselect,,,,,,,,,,,event/22,OnCellUnselect,\r
8047,EasyList 再次点击已选中格子并取消选择时,2,event/2,,,,OnCellCancelSelect,1,OnCellCancelSelect,,,,,,,,,,,event/22,OnCellCancelSelect,\r
8048,EasyList 可见数据范围变化时,2,event/2,,,,OnVisibleDataRangeChanged,1,OnVisibleDataRangeChanged,,,,,,,,,,,event/22,OnVisibleDataRangeChanged,\r
8049,刷新 EasyList 网格,2,entity/4,,,,Refresh,2,Refresh,,,,,,2:Bool=true,,,,,action/22,Refresh,\r
8050,获取 EasyList 可见格子,2,entity/4,,,,GetCell,3,GetCell,,,,,,,,,,,action/22,GetCell,\r
8051,滚动到 EasyList 指定数据下标,2,entity/4,,,,ScrollToDataIndex,2,ScrollToDataIndex,,,,,,3:Float=0;4:Bool=true,,,,,action/22,ScrollToDataIndex,\r
8052,选中 EasyList 指定数据下标,2,entity/4,,,,SelectData,2,SelectData,,,,,,3:Bool=true,,,,,action/22,SelectData,\r
8053,取消选中 EasyList 指定数据下标,2,entity/4,,,,UnselectData,2,UnselectData,,,,,,,,,,,action/22,UnselectData,\r
8054,清空 EasyList 选中状态,2,entity/4,,,,ClearSelection,2,ClearSelection,,,,,,,,,,,action/22,ClearSelection,\r
8055,获取 EasyList 已选数据下标,2,entity/4,,,,GetSelectedDataIndexs,3,GetSelectedDataIndexs,,,,,,,,,,,action/22,GetSelectedDataIndexs,\r
8056,获取 EasyList 可见数据范围,2,entity/4,,,,GetVisibleDataRange,3,GetVisibleDataRange,,,,,,,,,,,action/22,GetVisibleDataRange,\r
8057,判断 EasyList 数据下标是否可见,2,entity/4,,,,IsDataVisible,3,IsDataVisible,,,,,,,,,,,action/22,IsDataVisible,\r
8058,打开衣橱,,game/12,,,,OpenInGameWardrobe,2,OpenInGameWardrobe,TRUE,,,,,,,1,,,module/17,,0\r
8059,关闭衣橱,,game/12,,,,CloseInGameWardrobe,2,CloseInGameWardrobe,TRUE,,,,,,,1,,,module/17,,0\r
8060,附加局内衣橱展示内容,,game/12,,,,ModifyAdditionalWardrobeOutfit,2,ModifyAdditionalWardrobeOutfit,TRUE,,,,,,,1,,,module/17,,0\r
8061,修改附加衣柜服装排序方式枚举,,data/8,,docs/enum/,,AdditionalWardrobeOutfitSortType,4,AdditionalWardrobeOutfitSortType,,,,,,,,,,,data/10001,,0\r
8062,玩家或系统关闭衣橱时触发,,event/2,,docs/event-11-8062/,,OnInGameWardrobeClosed,1,OnInGameWardrobeClosed,TRUE,,,,,,,,,,event,,0.001\r
8063,玩家在换衣间点击确认换装时触发,,event/2,,docs/event-11-8063/,,OnPlayerConfirmOutfitWardrobe,1,OnPlayerConfirmOutfitWardrobe,TRUE,,,,,,,,,,event,,0.001\r
8064,玩家点击时装条目时触发,,event/2,,docs/event-11-8064/,,OnTapWardrobeItem,1,OnTapWardrobeItem,TRUE,,,,,,,,,,event,,0.001\r
8065,时装资源下载完成或失败时触发,,event/2,,docs/event-11-8065/,,OnReceiveWardrobeResourceDownloadResult,1,OnReceiveWardrobeResourceDownloadResult,TRUE,,,,,,,,,,event,,0.001\r
8066,查询指定时装资源下载状态,,game/12,,,,CheckWardrobeResourceDownloadStatus,2,CheckWardrobeResourceDownloadStatus,TRUE,,,,,,,1,,,module/17,,0\r
8067,打开聊天框,,game/12,,,,CreateChatHud,2,CreateChatHud,TRUE,,,,,,,1,,,module/50,,0\r
8072,关闭聊天框,,game/12,,,,CloseChatHud,2,CloseChatHud,TRUE,,,,,,,1,,,module/50,,0\r
8068,收到聊天消息事件,,event/2,,docs/event-11-8068/,,OnReceivedChatMessage,1,OnReceivedChatMessage,TRUE,,,,,,,,,,event,,0.001\r
8069,聊天窗口打开事件,,event/2,,docs/event-11-8069/,,OnChatHudOpen,1,OnChatHudOpen,TRUE,,,,,,,,,,event,,0.001\r
8070,聊天窗口打开事件,,event/2,,docs/event-11-8070/,,OnChatHudClose,1,OnChatHudClose,TRUE,,,,,,,,,,event,,0.001\r
1059,设置相机抖动,,game/5,,,,PlayCustomCameraShake,2,PlayCustomCameraShake,TRUE,,,,,,1,,,,module/8,,0\r
1060,商品状态枚举,,data/8,,docs/enum/,,ProductStatus,4,ProductStatus,,,,,,,,,,,data/5,,0\r
1061,查询商品状态,2,game/12,,,,CheckProductStatus,2,CheckProductStatus,TRUE,,,,,,,,,,module/49,,0\r
8071,通过 UI 预制体创建客户端 UI 控件树,2,entity/4,,,,CreateUIWidgetFromPrefab,2,CreateUIWidgetFromPrefab,,,,,,,,,,,action/22,CreateUIWidgetFromPrefab,\r
8073,播放PlayerData动画,2,game/9,,docs/api-35-8073/,,PlayPlayerdataAnimationByController,2,PlayPlayerdataAnimationByController,TRUE,,,,,,,,,,action/35,,0.001\r
8074,停止PlayerData动画,2,game/9,,docs/api-35-8074/,,StopPlayerdataAnimationByController,2,StopPlayerdataAnimationByController,TRUE,,,,,,,,,,action/35,,0\r
8075,暂停PlayerData动画,2,game/9,,docs/api-35-8075/,,PausePlayerdataAnimationByController,2,PausePlayerdataAnimationByController,TRUE,,,,,,,,,,action/35,,0\r
8076,恢复PlayerData动画,2,game/9,,docs/api-35-8076/,,ResumePlayerdataAnimationByController,2,ResumePlayerdataAnimationByController,TRUE,,,,,,,,,,action/35,,0\r
8077,重置PlayerData动画控制器,2,game/9,,docs/api-35-8077/,,ResetPlayerdataAnimationController,2,ResetPlayerdataAnimationController,TRUE,,,,,,,,,,action/35,,0\r
10118,获取总内存(MB),,game/12,,,,GetTotalMemory,3,GetTotalMemory,,,,,,,,,,,module/10,,\r
8078,鼠标滚轮事件,,event/1,,,,OnMouseWheelScroll,1,OnMouseWheelScroll,TRUE,,,,,,,,,,event,,0\r
8079,获取当前玩家控制相机在指定屏幕坐标下的渲染颜色,,game/12,,,,GetCameraPixelColor,2,GetCameraPixelColor,True,,,,,,,1,,,module/10,GetCameraPixelColor,\r
8080,频道是否为空,,entity/10,,,,IsChatChannelEmpty,3,IsChatChannelEmpty,,,,,,,,,,,action/28,,0`, pI = 44, Nh = 13, lS = 10, yh = 34, lR = /""/g;
class sR {
  CsvToJson(l, r = {
    hasDescription: !0
  }) {
    let o = [0], c = this.parseLine(l, o), T = [];
    for (r.hasDescription && this.parseLine(l, o); o[0] < l.length; ) {
      let d = this.parseLine(l, o), h = d[0];
      d.length == c.length && h[0] != ";" && T.push(this.BuildJsonResult(c, d, r ? r.plainText : void 0));
    }
    return T;
  }
  CsvToListArray(l) {
    let r = [], o = [0], c = this.parseLine(l, o);
    for (r.push(c); o[0] < l.length; ) {
      let T = this.parseLine(l, o);
      T.length == c.length && r.push(T);
    }
    return r;
  }
  // parse one line, and update the current index
  parseLine(l, r) {
    let o = [];
    do {
      if (o.push(this.parseCell(l, r)), this.checkNewLineOrFileEnd(l, r))
        break;
      r[0]++;
    } while (!0);
    return o;
  }
  checkNewLineOrFileEnd(l, r) {
    let o = r[0], c = l.charCodeAt(o);
    return o >= l.length ? !0 : c == Nh ? (o++, l.charCodeAt(o) == lS && o++, r[0] = o, !0) : c == lS ? (o++, r[0] = o, !0) : !1;
  }
  parseCell(l, r) {
    let o = r[0];
    if (l.charCodeAt(o) == yh)
      return r[0] = o + 1, this.parseCellComplex(l, r);
    let c = o, T, d = null;
    for (; T = l.charCodeAt(o); ) {
      if (T == pI) {
        d = l.substring(c, o);
        break;
      } else if (T == lS || T == Nh) {
        d = l.substring(c, o);
        break;
      }
      o++;
    }
    return T || (d = l.substring(c, o)), r[0] = o, d;
  }
  parseCellComplex(l, r) {
    let o = r[0], c = o, T, d = null;
    for (; T = l.charCodeAt(o); ) {
      if (T == yh) {
        if (o++, l.charCodeAt(o) == yh) {
          o++;
          continue;
        }
        d = l.substring(c, o - 1), d = d.replace(lR, '"');
        break;
      }
      o++;
    }
    for (; (T = l.charCodeAt(o)) && T != pI; ) {
      if (T == lS || T == Nh)
        break;
      o++;
    }
    return r[0] = o, d;
  }
  BuildJsonResult(l, r, o = !1) {
    let c = {};
    for (let T = 0; T < l.length; T++) {
      let d = l[T], h;
      o ? h = r[T] : h = this.GetValueFormatByType(r[T]), c[d] = h;
    }
    return c;
  }
  GetValueFormatByType(l) {
    if (l === void 0 || l === "")
      return "";
    let r = Number(l);
    return isNaN(r) ? l.localeCompare("true", void 0, { sensitivity: "accent" }) == 0 ? !0 : l.localeCompare("false", void 0, { sensitivity: "accent" }) == 0 ? !1 : l : r;
  }
}
const aR = new sR();
let dI = {
  "": "any",
  Boolean: "bool",
  Number: "number",
  String: "string",
  Colour: "Color"
};
class _R extends N.ConnectionChecker {
  constructor() {
    super(...arguments);
    C(this, "isDragging");
  }
  canConnectWithReason(r, o, c, T) {
    let d = this.isDragging;
    this.isDragging = c;
    let h = super.canConnectWithReason(r, o, c, T);
    return this.isDragging = d, h;
  }
  doTypeChecks(r, o) {
    if (r.type == N.ConnectionType.NEXT_STATEMENT || r.type == N.ConnectionType.PREVIOUS_STATEMENT)
      return super.doTypeChecks(r, o);
    let c = r.isSuperior(), T = c ? o.getSourceBlock() : r.getSourceBlock();
    if ("ReversedDetermineType" in T && T.ReversedDetermineType(), this.isDragging = T.workspace.isDragging(), this.isDragging)
      return !0;
    let d = c ? r.getCheck() : o.getCheck(), h = c ? o.getCheck() : r.getCheck();
    if (d == null || h == null)
      return T.setWarningText(null, "TYPE"), !0;
    let y = ce.CurrentDescriptionFile, b = "", U = "";
    for (let Z of h) {
      let le = y.GetVarType(Z);
      le && (U += le.Label + " ");
    }
    for (let Z of d) {
      Z = dI[Z] || Z;
      let le = y.GetVarType(Z);
      le != null && (b += le.Label + " ");
      for (let ue of h)
        if (ue = dI[ue] || ue, Z == ue || le != null && Vn.CheckIsAssignable(le, ue, y))
          return T.setWarningText(null, "TYPE"), !0;
    }
    return (r.targetConnection == o || r.targetConnection == null) && T.setWarningText(ye(re.Warning_TypeAssign, [b, U]), "TYPE"), !0;
  }
}
let Qu = null;
async function cR(i, l, r, o) {
  let c = null;
  if (typeof i == "string" ? c = document.querySelector(i) : c = i, !c)
    throw new Error("fe-blockly-web: invalid container");
  c.setAttribute("theme-style", "dark-theme"), await TR(r), uR();
  const T = {
    theme: o ? "craftlandTheme" : "customTheme",
    renderer: "eca_renderer",
    rendererOverrides: {
      IsCraftland: o
    },
    sounds: !1,
    scrollbars: !0,
    move: {
      drag: !1
    },
    zoom: {
      minScale: 0.1,
      maxScale: 10
    },
    plugins: {
      [N.registry.Type.CONNECTION_CHECKER.toString()]: _R
    }
  }, d = N.inject(c, T);
  if (!d)
    throw new Error("fe-blockly-web: fail to create workspace");
  return d.IsCraftland = o, N.serialization.blocks.append(l, d), ER(d, c), window.addEventListener("resize", OM.bind(null, d)), d;
}
let EI = !1, sS = null, fh = null;
function uR() {
  if (EI)
    return;
  EI = !0, dR();
  let i = nR();
  J.graphElementMap = /* @__PURE__ */ new Map();
  const l = aR.CsvToJson(oR);
  for (let r = 0; r < l.length; ++r) {
    let o = l[r], c = o.Division;
    if (!c)
      continue;
    let T = c == null ? void 0 : c.indexOf("/");
    T >= 0 && (c = c.substring(0, T)), o.block_style = c + "_blocks", c = o.category, T = c == null ? void 0 : c.indexOf("/"), T >= 0 && (c = c.substring(0, T)), o.block_style_cl = c + "_blocks";
    let d = o.id;
    if (!d)
      continue;
    J.graphElementMap.set(d, o);
    let h = o.exports;
    if (h == 1 || h == -1)
      continue;
    let y = o.name, b = o.fe_custom;
    if (!y || y === "-" || b == "-")
      continue;
    const U = ce.CurrentDescriptionFile;
    let Z = null;
    o.ref && (Z = U.actions.get_Item(o.ref), Z == null && (Z = U.variables.get_Item(o.ref)), Z == null && (Z = U.varTypes.get_Item(o.ref)), Z && pR(o, Z.Items.Count, i));
    let le;
    b && (le = i.get(b), le && (le.block_style = o.block_style));
  }
}
async function TR(i = fI.English) {
  return sS && (await sS, ce.CurrentDescriptionFile && fh == i) ? ce.CurrentDescriptionFile : (sS = (async () => {
    if (Qu == null && (Qu = new kg(), $g(Qu)), Qu.hasLang(i) || await Qu.init(i), ce.CurrentDescriptionFile && fh == i)
      return ce.CurrentDescriptionFile;
    fh = i, Qu.SetLanguage(i), Bg();
    const l = new ce();
    l.SetLocalizeProxy(
      Nm({
        Localize: function(h) {
          return ye(h);
        }
      })
    ), l.SetJsonProxy(
      Nm({
        Parse(h) {
          return JSON.parse(h);
        },
        Serialize(h) {
          return JSON.stringify(h);
        }
      })
    ), l.Load(iR);
    let r = new xt("generic", "PropertyT", "Property");
    r.Attributes = new it(), r.Attributes.Add(new Ri("@Accept", "Property", "")), r.Items = new it(), r.Items.Add(new Ri("", "T0", "Component")), l.DefineType("PropertyT", r);
    let o = new xt("generic", "$PrefabT", "PrefabID");
    o.m_Label = ye("FE_39_ZQ_PREFAB_PREFAB"), o.Items = new it(), o.Items.Add(new Ri("", "T0", "Component")), l.DefineType("$PrefabT", o);
    let c = new xt("generic", "$HudWidgetIDT", "CustomHudWidgetID"), T = l.GetVarType("CustomHudWidgetID");
    c.m_Label = (T == null ? void 0 : T.Label) ?? "HudWidgetID", c.Items = new it(), c.Items.Add(new Ri("", "T0", "HudWidget")), l.DefineType("$HudWidgetIDT", c);
    let d = new xt("generic", "$InternalHudTypeT", "InternalHudType");
    return d.m_Label = ye("T_36_WZY_WS_HUDTYPE"), d.Items = new it(), d.Items.Add(new Ri("", "T0", "Component")), l.DefineType("$InternalHudTypeT", d), ce.CurrentDescriptionFile = l, l;
  })(), sS);
}
function pR(i, l, r, o) {
  const T = /^([\w\d_]+)(?:\s*:\s*([\w\d_]+))?(?:\s*=\s*([\w\d_]+))?\s*$/;
  i.ParsedParamInfo = {};
  let d = i.param_info;
  if (d) {
    let y = d.split(";");
    for (let b of y) {
      let U = b.match(T);
      if (U != null) {
        let Z = U[1], le = U[2], ue = U[3];
        Z.startsWith("FE_") ? Z = Z.replace("FE_", "P") : Z = "P" + Z;
        let be = !1, Ke;
        le && (le.startsWith("Enum_") ? (be = !0, le = le.substring(5)) : le.startsWith("Shadow_") ? (be = !0, le = le.substring(7), Ke = r.get(le)) : (Ke = r.get(le), Ke && (be = !0))), i.ParsedParamInfo[Z] = {
          inputType: le,
          defaultValue: ue,
          bShadow: be,
          block: Ke
        };
      }
    }
  }
  if (i.param_order === 0)
    return i.ParsedParamOrder = [];
  let h = i.param_order;
  if (typeof h == "number")
    return [h];
  {
    if (h.trim() == "") {
      let b = [];
      for (let U = 1; U <= l; ++U)
        b.push(U);
      return i.ParsedParamOrder = b;
    }
    let y = h.replace(/\|/g, ";-1;").split(";");
    return i.ParsedParamOrder = y.map((b) => Number(b));
  }
}
function dR() {
  const i = N.BlockSvg.prototype.initSvg;
  N.BlockSvg.prototype.initSvg = function() {
    i.apply(this), this.setMovable(!1), this.setEditable(!1), this.setDeletable(!1);
  };
  const { dom: l } = N.utils;
  l.getFastTextWidth = function(o, c, T, d) {
    return l.getFastTextWidthWithSizeString(
      o,
      c + "px",
      // FE
      T,
      d
    );
  }, N.Field.prototype.updateSize_ = function(o) {
    var b;
    const c = this.getConstants(), T = o !== void 0 ? o : this.borderRect_ ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
    let d = T * 2, h = c.FIELD_TEXT_HEIGHT, y = 0;
    if (this.textElement_ && (y = l.getFastTextWidth(
      this.textElement_,
      c.FIELD_TEXT_FONTSIZE,
      c.FIELD_TEXT_FONTWEIGHT,
      c.FIELD_TEXT_FONTFAMILY
    ), d += y), this.borderRect_) {
      const U = (b = this.getSourceBlock()) != null && b.isShadow() ? c.FIELD_IN_SHADOW_BORDER_RECT_HEIGHT : c.FIELD_BORDER_RECT_HEIGHT;
      h = Math.max(h, U);
    }
    this.size_.height = h, this.size_.width = d, this.positionTextElement_(T, y), this.positionBorderRect_();
  }, N.Gesture.prototype.handleWsStart = function(o, c) {
    return !1;
  }, N.WorkspaceSvg.prototype.getGesture = function() {
    return null;
  }, N.FieldDropdown.prototype.renderSelectedText = function() {
    var Z, le, ue;
    const o = this.getTextContent();
    o && (o.nodeValue = this.getDisplayText_());
    const c = this.getTextElement();
    l.addClass(c, "blocklyDropdownText"), c.setAttribute("text-anchor", "start");
    const T = !!this.borderRect_, d = Math.max(
      T ? this.getConstants().FIELD_DROPDOWN_BORDER_RECT_HEIGHT : 0,
      this.getConstants().FIELD_TEXT_HEIGHT
    ), h = l.getFastTextWidth(
      this.getTextElement(),
      this.getConstants().FIELD_TEXT_FONTSIZE,
      this.getConstants().FIELD_TEXT_FONTWEIGHT,
      this.getConstants().FIELD_TEXT_FONTFAMILY
    ), y = T ? this.getConstants().FIELD_BORDER_RECT_X_PADDING : 0;
    let b = 0;
    if (this.svgArrow && (b = this.positionSVGArrow(
      h + y,
      d / 2 - this.getConstants().FIELD_DROPDOWN_SVG_ARROW_SIZE / 2
    )), this.size_.width = h + b + y * 2, this.size_.height = d, this.positionTextElement_(y, h), (Z = this.getSourceBlock()) != null && Z.isInFlyout)
      return;
    const U = this.textElement_;
    if (U) {
      const be = this.selectedOption;
      (le = be == null ? void 0 : be[3]) != null && le.style ? U.setAttribute("style", (ue = be == null ? void 0 : be[3]) == null ? void 0 : ue.style) : U.setAttribute("style", "");
    }
  }, N.blockRendering.RenderInfo.prototype.shouldStartNewRow_ = function(o, c) {
    return o.type == N.inputTypes.DUMMY && o.name.startsWith("NEW_LINE_") ? !0 : c ? o instanceof N.inputs.StatementInput || c instanceof N.inputs.StatementInput ? !0 : o instanceof N.inputs.ValueInput || o instanceof N.inputs.DummyInput ? !this.isInline : !1 : !1;
  };
  const r = N.WorkspaceSvg.prototype.dispose;
  N.WorkspaceSvg.prototype.dispose = function() {
    window.removeEventListener("resize", OM.bind(null, this)), r.apply(this);
  }, N.WorkspaceSvg.prototype.zoomToFit = function() {
    if (!this.isMovable()) {
      console.warn(
        "Tried to move a non-movable workspace. This could result in blocks becoming inaccessible."
      );
      return;
    }
    const o = this.getMetrics();
    let c = o.viewWidth, T = o.viewHeight;
    const d = this.getBlocksBoundingBox();
    let h = d.right - d.left, y = d.bottom - d.top;
    if (!h)
      return;
    const b = this.flyout;
    b && (this.horizontalLayout ? (T += b.getHeight(), y += b.getHeight() / this.scale) : (c += b.getWidth(), h += b.getWidth() / this.scale));
    const U = c / h, Z = T / y;
    N.Events.disable();
    try {
      this.setScale(Math.min(U, Z)), this.scrollCenter();
    } finally {
      N.Events.enable();
    }
    this.maybeFireViewportChangeEvent();
  }, N.Field.prototype.updateEditable = function() {
    const o = this.fieldGroup_, c = this.getSourceBlock();
    !this.EDITABLE || !o || !c || (this.enabled_ && this.EDITABLE ? (l.addClass(o, "blocklyEditableText"), l.removeClass(o, "blocklyNonEditableText")) : (l.addClass(o, "blocklyNonEditableText"), l.removeClass(o, "blocklyEditableText")), this.enabled_ && c.isEditable() ? (l.addClass(o, "blocklyCurrentEditableText"), l.removeClass(o, "blocklyCuurentNonEditableText"), o.style.cursor = this.CURSOR) : (l.addClass(o, "blocklyCurrentEditableText"), l.removeClass(o, "blocklyCuurentNonEditableText"), o.style.cursor = ""));
  }, N.Input.prototype.conditionAppendField = function(o, c, T) {
    return o && this.appendField(c, T), this;
  };
}
function ER(i, l) {
  const o = i.getCanvas().getBBox();
  let { width: c, height: T } = o;
  const d = 12, h = (c / d).toFixed(2), y = (T / d).toFixed(2);
  l.setAttribute("style", `width: ${h}rem; height: ${y}rem`), setTimeout(() => {
    N.svgResize(i);
  }, 0), setTimeout(() => {
    i.zoomToFit();
  }, 60);
}
function OM(i) {
  setTimeout(() => {
    i.zoomToFit();
  }, 0);
}
async function mR(i, l, r, o = !1) {
  let c = l;
  if (typeof l == "string")
    try {
      if (c = JSON.parse(l), typeof c != "object")
        throw new Error("fe-blockly-web: invalid state");
    } catch (d) {
      console.error(d);
      return;
    }
  let T = null;
  try {
    T = await cR(i, c, r, o);
  } catch (d) {
    console.error(d);
  }
  return T;
}
export {
  mR as loadBlocklyState
};
